import "./mirai.c2367a7b.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a21"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a21"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aXLS2", function(module, exports) {
"use strict";

});

parcelRegister("1NWL6", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("8FlDu", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("1rFi6", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("iDdZD", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("bDA0X", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("oBon1", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});


var $iqelV = parcelRequire("iqelV");
/**
    * @license
    * Copyright 2023 Google LLC. All Rights Reserved.
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    * =============================================================================
    */ var $670e4c2ab08b8e48$exports = {};
(function() {
    'use strict';
    var x;
    function aa(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ca(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var y = ca(this);
    function z(a, b) {
        if (b) a: {
            var c = y;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && ba(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    z("Symbol", function(a) {
        function b(g) {
            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
            return new c(d + (g || "") + "_" + e++, g);
        }
        function c(g, f) {
            this.h = g;
            ba(this, "description", {
                configurable: !0,
                writable: !0,
                value: f
            });
        }
        if (a) return a;
        c.prototype.toString = function() {
            return this.h;
        };
        var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
        return b;
    });
    z("Symbol.iterator", function(a) {
        if (a) return a;
        a = Symbol("Symbol.iterator");
        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
            var d = y[b[c]];
            "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                configurable: !0,
                writable: !0,
                value: function() {
                    return da(aa(this));
                }
            });
        }
        return a;
    });
    function da(a) {
        a = {
            next: a
        };
        a[Symbol.iterator] = function() {
            return this;
        };
        return a;
    }
    function A(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: aa(a)
        };
    }
    function ea(a) {
        if (!(a instanceof Array)) {
            a = A(a);
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            a = c;
        }
        return a;
    }
    var fa = "function" == typeof Object.assign ? Object.assign : function(a, b) {
        for(var c = 1; c < arguments.length; c++){
            var d = arguments[c];
            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
        }
        return a;
    };
    z("Object.assign", function(a) {
        return a || fa;
    });
    var ha = "function" == typeof Object.create ? Object.create : function(a) {
        function b() {}
        b.prototype = a;
        return new b;
    }, ia;
    if ("function" == typeof Object.setPrototypeOf) ia = Object.setPrototypeOf;
    else {
        var ja;
        a: {
            var ka = {
                a: !0
            }, la = {};
            try {
                la.__proto__ = ka;
                ja = la.a;
                break a;
            } catch (a) {}
            ja = !1;
        }
        ia = ja ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
    }
    var ma = ia;
    function na(a, b) {
        a.prototype = ha(b.prototype);
        a.prototype.constructor = a;
        if (ma) ma(a, b);
        else for(var c in b)if ("prototype" != c) {
            if (Object.defineProperties) {
                var d = Object.getOwnPropertyDescriptor(b, c);
                d && Object.defineProperty(a, c, d);
            } else a[c] = b[c];
        }
        a.za = b.prototype;
    }
    function oa() {
        this.m = !1;
        this.j = null;
        this.i = void 0;
        this.h = 1;
        this.v = this.s = 0;
        this.l = null;
    }
    function pa(a) {
        if (a.m) throw new TypeError("Generator is already running");
        a.m = !0;
    }
    oa.prototype.u = function(a) {
        this.i = a;
    };
    function qa(a, b) {
        a.l = {
            ma: b,
            na: !0
        };
        a.h = a.s || a.v;
    }
    oa.prototype.return = function(a) {
        this.l = {
            return: a
        };
        this.h = this.v;
    };
    function D(a, b, c) {
        a.h = c;
        return {
            value: b
        };
    }
    function ra(a) {
        this.h = new oa;
        this.i = a;
    }
    function sa(a, b) {
        pa(a.h);
        var c = a.h.j;
        if (c) return ta(a, "return" in c ? c["return"] : function(d) {
            return {
                value: d,
                done: !0
            };
        }, b, a.h.return);
        a.h.return(b);
        return ua(a);
    }
    function ta(a, b, c, d) {
        try {
            var e = b.call(a.h.j, c);
            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
            if (!e.done) return a.h.m = !1, e;
            var g = e.value;
        } catch (f) {
            return a.h.j = null, qa(a.h, f), ua(a);
        }
        a.h.j = null;
        d.call(a.h, g);
        return ua(a);
    }
    function ua(a) {
        for(; a.h.h;)try {
            var b = a.i(a.h);
            if (b) return a.h.m = !1, {
                value: b.value,
                done: !1
            };
        } catch (c) {
            a.h.i = void 0, qa(a.h, c);
        }
        a.h.m = !1;
        if (a.h.l) {
            b = a.h.l;
            a.h.l = null;
            if (b.na) throw b.ma;
            return {
                value: b.return,
                done: !0
            };
        }
        return {
            value: void 0,
            done: !0
        };
    }
    function va(a) {
        this.next = function(b) {
            pa(a.h);
            a.h.j ? b = ta(a, a.h.j.next, b, a.h.u) : (a.h.u(b), b = ua(a));
            return b;
        };
        this.throw = function(b) {
            pa(a.h);
            a.h.j ? b = ta(a, a.h.j["throw"], b, a.h.u) : (qa(a.h, b), b = ua(a));
            return b;
        };
        this.return = function(b) {
            return sa(a, b);
        };
        this[Symbol.iterator] = function() {
            return this;
        };
    }
    function wa(a) {
        function b(d) {
            return a.next(d);
        }
        function c(d) {
            return a.throw(d);
        }
        return new Promise(function(d, e) {
            function g(f) {
                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
            }
            g(a.next());
        });
    }
    function E(a) {
        return wa(new va(new ra(a)));
    }
    z("Promise", function(a) {
        function b(f) {
            this.i = 0;
            this.j = void 0;
            this.h = [];
            this.u = !1;
            var h = this.l();
            try {
                f(h.resolve, h.reject);
            } catch (k) {
                h.reject(k);
            }
        }
        function c() {
            this.h = null;
        }
        function d(f) {
            return f instanceof b ? f : new b(function(h) {
                h(f);
            });
        }
        if (a) return a;
        c.prototype.i = function(f) {
            if (null == this.h) {
                this.h = [];
                var h = this;
                this.j(function() {
                    h.m();
                });
            }
            this.h.push(f);
        };
        var e = y.setTimeout;
        c.prototype.j = function(f) {
            e(f, 0);
        };
        c.prototype.m = function() {
            for(; this.h && this.h.length;){
                var f = this.h;
                this.h = [];
                for(var h = 0; h < f.length; ++h){
                    var k = f[h];
                    f[h] = null;
                    try {
                        k();
                    } catch (l) {
                        this.l(l);
                    }
                }
            }
            this.h = null;
        };
        c.prototype.l = function(f) {
            this.j(function() {
                throw f;
            });
        };
        b.prototype.l = function() {
            function f(l) {
                return function(m) {
                    k || (k = !0, l.call(h, m));
                };
            }
            var h = this, k = !1;
            return {
                resolve: f(this.I),
                reject: f(this.m)
            };
        };
        b.prototype.I = function(f) {
            if (f === this) this.m(new TypeError("A Promise cannot resolve to itself"));
            else if (f instanceof b) this.L(f);
            else {
                a: switch(typeof f){
                    case "object":
                        var h = null != f;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.F(f) : this.s(f);
            }
        };
        b.prototype.F = function(f) {
            var h = void 0;
            try {
                h = f.then;
            } catch (k) {
                this.m(k);
                return;
            }
            "function" == typeof h ? this.M(h, f) : this.s(f);
        };
        b.prototype.m = function(f) {
            this.v(2, f);
        };
        b.prototype.s = function(f) {
            this.v(1, f);
        };
        b.prototype.v = function(f, h) {
            if (0 != this.i) throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.i);
            this.i = f;
            this.j = h;
            2 === this.i && this.K();
            this.H();
        };
        b.prototype.K = function() {
            var f = this;
            e(function() {
                if (f.D()) {
                    var h = y.console;
                    "undefined" !== typeof h && h.error(f.j);
                }
            }, 1);
        };
        b.prototype.D = function() {
            if (this.u) return !1;
            var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
            if ("undefined" === typeof k) return !0;
            "function" === typeof f ? f = new f("unhandledrejection", {
                cancelable: !0
            }) : "function" === typeof h ? f = new h("unhandledrejection", {
                cancelable: !0
            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", !1, !0, f));
            f.promise = this;
            f.reason = this.j;
            return k(f);
        };
        b.prototype.H = function() {
            if (null != this.h) {
                for(var f = 0; f < this.h.length; ++f)g.i(this.h[f]);
                this.h = null;
            }
        };
        var g = new c;
        b.prototype.L = function(f) {
            var h = this.l();
            f.T(h.resolve, h.reject);
        };
        b.prototype.M = function(f, h) {
            var k = this.l();
            try {
                f.call(h, k.resolve, k.reject);
            } catch (l) {
                k.reject(l);
            }
        };
        b.prototype.then = function(f, h) {
            function k(p, n) {
                return "function" == typeof p ? function(q) {
                    try {
                        l(p(q));
                    } catch (t) {
                        m(t);
                    }
                } : n;
            }
            var l, m, r = new b(function(p, n) {
                l = p;
                m = n;
            });
            this.T(k(f, l), k(h, m));
            return r;
        };
        b.prototype.catch = function(f) {
            return this.then(void 0, f);
        };
        b.prototype.T = function(f, h) {
            function k() {
                switch(l.i){
                    case 1:
                        f(l.j);
                        break;
                    case 2:
                        h(l.j);
                        break;
                    default:
                        throw Error("Unexpected state: " + l.i);
                }
            }
            var l = this;
            null == this.h ? g.i(k) : this.h.push(k);
            this.u = !0;
        };
        b.resolve = d;
        b.reject = function(f) {
            return new b(function(h, k) {
                k(f);
            });
        };
        b.race = function(f) {
            return new b(function(h, k) {
                for(var l = A(f), m = l.next(); !m.done; m = l.next())d(m.value).T(h, k);
            });
        };
        b.all = function(f) {
            var h = A(f), k = h.next();
            return k.done ? d([]) : new b(function(l, m) {
                function r(q) {
                    return function(t) {
                        p[q] = t;
                        n--;
                        0 == n && l(p);
                    };
                }
                var p = [], n = 0;
                do p.push(void 0), n++, d(k.value).T(r(p.length - 1), m), k = h.next();
                while (!k.done);
            });
        };
        return b;
    });
    function xa(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var g = c++;
                    return {
                        value: b(g, a[g]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    z("Array.prototype.keys", function(a) {
        return a ? a : function() {
            return xa(this, function(b) {
                return b;
            });
        };
    });
    z("Array.prototype.fill", function(a) {
        return a ? a : function(b, c, d) {
            var e = this.length || 0;
            0 > c && (c = Math.max(0, e + c));
            if (null == d || d > e) d = e;
            d = Number(d);
            0 > d && (d = Math.max(0, e + d));
            for(c = Number(c || 0); c < d; c++)this[c] = b;
            return this;
        };
    });
    function F(a) {
        return a ? a : Array.prototype.fill;
    }
    z("Int8Array.prototype.fill", F);
    z("Uint8Array.prototype.fill", F);
    z("Uint8ClampedArray.prototype.fill", F);
    z("Int16Array.prototype.fill", F);
    z("Uint16Array.prototype.fill", F);
    z("Int32Array.prototype.fill", F);
    z("Uint32Array.prototype.fill", F);
    z("Float32Array.prototype.fill", F);
    z("Float64Array.prototype.fill", F);
    z("Object.is", function(a) {
        return a ? a : function(b, c) {
            return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
        };
    });
    z("Array.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            var d = this;
            d instanceof String && (d = String(d));
            var e = d.length;
            c = c || 0;
            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                var g = d[c];
                if (g === b || Object.is(g, b)) return !0;
            }
            return !1;
        };
    });
    z("String.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            if (null == this) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
            return -1 !== this.indexOf(b, c || 0);
        };
    });
    var ya = this || self;
    function G(a, b) {
        a = a.split(".");
        var c = ya;
        a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
        for(var d; a.length && (d = a.shift());)a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
    }
    function Aa(a) {
        var b;
        a: {
            if (b = ya.navigator) {
                if (b = b.userAgent) break a;
            }
            b = "";
        }
        return -1 != b.indexOf(a);
    }
    var Ba = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)g in e && (d[g] = b.call(void 0, e[g], g, a));
        return d;
    };
    var Ca = {}, Da = null;
    function Ea(a) {
        var b = a.length, c = 3 * b / 4;
        c % 3 ? c = Math.floor(c) : -1 != "=.".indexOf(a[b - 1]) && (c = -1 != "=.".indexOf(a[b - 2]) ? c - 2 : c - 1);
        var d = new Uint8Array(c), e = 0;
        Fa(a, function(g) {
            d[e++] = g;
        });
        return e !== c ? d.subarray(0, e) : d;
    }
    function Fa(a, b) {
        function c(k) {
            for(; d < a.length;){
                var l = a.charAt(d++), m = Da[l];
                if (null != m) return m;
                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
            }
            return k;
        }
        Ga();
        for(var d = 0;;){
            var e = c(-1), g = c(0), f = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | g >> 4);
            64 != f && (b(g << 4 & 240 | f >> 2), 64 != h && b(f << 6 & 192 | h));
        }
    }
    function Ga() {
        if (!Da) {
            Da = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++){
                var d = a.concat(b[c].split(""));
                Ca[c] = d;
                for(var e = 0; e < d.length; e++){
                    var g = d[e];
                    void 0 === Da[g] && (Da[g] = e);
                }
            }
        }
    }
    var Ha = "undefined" !== typeof Uint8Array, Ia = !(Aa("Trident") || Aa("MSIE")) && "function" === typeof ya.btoa;
    function Ja(a) {
        if (!Ia) {
            var b;
            void 0 === b && (b = 0);
            Ga();
            b = Ca[b];
            for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
                f = b[(f & 3) << 4 | h >> 4];
                h = b[(h & 15) << 2 | k >> 6];
                k = b[k & 63];
                c[g++] = l + f + h + k;
            }
            l = 0;
            k = d;
            switch(a.length - e){
                case 2:
                    l = a[e + 1], k = b[(l & 15) << 2] || d;
                case 1:
                    a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
            }
            return c.join("");
        }
        for(b = ""; 10240 < a.length;)b += String.fromCharCode.apply(null, a.subarray(0, 10240)), a = a.subarray(10240);
        b += String.fromCharCode.apply(null, a);
        return btoa(b);
    }
    var Ka = RegExp("[-_.]", "g");
    function La(a) {
        switch(a){
            case "-":
                return "+";
            case "_":
                return "/";
            case ".":
                return "=";
            default:
                return "";
        }
    }
    function Ma(a) {
        if (!Ia) return Ea(a);
        Ka.test(a) && (a = a.replace(Ka, La));
        a = atob(a);
        for(var b = new Uint8Array(a.length), c = 0; c < a.length; c++)b[c] = a.charCodeAt(c);
        return b;
    }
    var Na;
    function Oa() {
        return Na || (Na = new Uint8Array(0));
    }
    var Pa = {};
    var Qa = "function" === typeof Uint8Array.prototype.slice, H = 0, K = 0;
    function Ra(a) {
        var b = 0 > a;
        a = Math.abs(a);
        var c = a >>> 0;
        a = Math.floor((a - c) / 4294967296);
        b && (c = A(Sa(c, a)), b = c.next().value, a = c.next().value, c = b);
        H = c >>> 0;
        K = a >>> 0;
    }
    var Ta = "function" === typeof BigInt;
    function Sa(a, b) {
        b = ~b;
        a ? a = ~a + 1 : b += 1;
        return [
            a,
            b
        ];
    }
    function Ua(a, b) {
        this.i = a >>> 0;
        this.h = b >>> 0;
    }
    function Va(a) {
        if (!a) return Wa || (Wa = new Ua(0, 0));
        if (!/^-?\d+$/.test(a)) return null;
        if (16 > a.length) Ra(Number(a));
        else if (Ta) a = BigInt(a), H = Number(a & BigInt(4294967295)) >>> 0, K = Number(a >> BigInt(32) & BigInt(4294967295));
        else {
            var b = +("-" === a[0]);
            K = H = 0;
            for(var c = a.length, d = b, e = (c - b) % 6 + b; e <= c; d = e, e += 6)d = Number(a.slice(d, e)), K *= 1E6, H = 1E6 * H + d, 4294967296 <= H && (K += H / 4294967296 | 0, H %= 4294967296);
            b && (b = A(Sa(H, K)), a = b.next().value, b = b.next().value, H = a, K = b);
        }
        return new Ua(H, K);
    }
    var Wa;
    function Xa(a, b) {
        return Error("Invalid wire type: " + a + " (at position " + b + ")");
    }
    function Ya() {
        return Error("Failed to read varint, encoding is invalid.");
    }
    function Za(a, b) {
        return Error("Tried to read past the end of the data " + b + " > " + a);
    }
    function L() {
        throw Error("Invalid UTF8");
    }
    function $a(a, b) {
        b = String.fromCharCode.apply(null, b);
        return null == a ? b : a + b;
    }
    var ab = void 0, bb, cb = "undefined" !== typeof TextDecoder, db, eb = "undefined" !== typeof TextEncoder;
    var fb;
    function gb(a) {
        if (a !== Pa) throw Error("illegal external caller");
    }
    function hb(a, b) {
        gb(b);
        this.V = a;
        if (null != a && 0 === a.length) throw Error("ByteString should be constructed with non-empty values");
    }
    function ib() {
        return fb || (fb = new hb(null, Pa));
    }
    function jb(a) {
        gb(Pa);
        var b = a.V;
        b = null == b || Ha && null != b && b instanceof Uint8Array ? b : "string" === typeof b ? Ma(b) : null;
        return null == b ? b : a.V = b;
    }
    function kb(a) {
        if ("string" === typeof a) return {
            buffer: Ma(a),
            C: !1
        };
        if (Array.isArray(a)) return {
            buffer: new Uint8Array(a),
            C: !1
        };
        if (a.constructor === Uint8Array) return {
            buffer: a,
            C: !1
        };
        if (a.constructor === ArrayBuffer) return {
            buffer: new Uint8Array(a),
            C: !1
        };
        if (a.constructor === hb) return {
            buffer: jb(a) || Oa(),
            C: !0
        };
        if (a instanceof Uint8Array) return {
            buffer: new Uint8Array(a.buffer, a.byteOffset, a.byteLength),
            C: !1
        };
        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers");
    }
    function lb(a, b) {
        this.i = null;
        this.m = !1;
        this.h = this.j = this.l = 0;
        mb(this, a, b);
    }
    function mb(a, b, c) {
        c = void 0 === c ? {} : c;
        a.S = void 0 === c.S ? !1 : c.S;
        b && (b = kb(b), a.i = b.buffer, a.m = b.C, a.l = 0, a.j = a.i.length, a.h = a.l);
    }
    lb.prototype.reset = function() {
        this.h = this.l;
    };
    function M(a, b) {
        a.h = b;
        if (b > a.j) throw Za(a.j, b);
    }
    function nb(a) {
        var b = a.i, c = a.h, d = b[c++], e = d & 127;
        if (d & 128 && (d = b[c++], e |= (d & 127) << 7, d & 128 && (d = b[c++], e |= (d & 127) << 14, d & 128 && (d = b[c++], e |= (d & 127) << 21, d & 128 && (d = b[c++], e |= d << 28, d & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128))))) throw Ya();
        M(a, c);
        return e;
    }
    function ob(a, b) {
        if (0 > b) throw Error("Tried to read a negative byte length: " + b);
        var c = a.h, d = c + b;
        if (d > a.j) throw Za(b, a.j - c);
        a.h = d;
        return c;
    }
    var pb = [];
    function qb() {
        this.h = [];
    }
    qb.prototype.length = function() {
        return this.h.length;
    };
    qb.prototype.end = function() {
        var a = this.h;
        this.h = [];
        return a;
    };
    function rb(a, b, c) {
        for(; 0 < c || 127 < b;)a.h.push(b & 127 | 128), b = (b >>> 7 | c << 25) >>> 0, c >>>= 7;
        a.h.push(b);
    }
    function N(a, b) {
        for(; 127 < b;)a.h.push(b & 127 | 128), b >>>= 7;
        a.h.push(b);
    }
    function sb(a, b) {
        if (pb.length) {
            var c = pb.pop();
            mb(c, a, b);
            a = c;
        } else a = new lb(a, b);
        this.h = a;
        this.j = this.h.h;
        this.i = this.l = -1;
        this.setOptions(b);
    }
    sb.prototype.setOptions = function(a) {
        a = void 0 === a ? {} : a;
        this.ca = void 0 === a.ca ? !1 : a.ca;
    };
    sb.prototype.reset = function() {
        this.h.reset();
        this.j = this.h.h;
        this.i = this.l = -1;
    };
    function tb(a) {
        var b = a.h;
        if (b.h == b.j) return !1;
        a.j = a.h.h;
        var c = nb(a.h) >>> 0;
        b = c >>> 3;
        c &= 7;
        if (!(0 <= c && 5 >= c)) throw Xa(c, a.j);
        if (1 > b) throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
        a.l = b;
        a.i = c;
        return !0;
    }
    function ub(a) {
        switch(a.i){
            case 0:
                if (0 != a.i) ub(a);
                else a: {
                    a = a.h;
                    for(var b = a.h, c = b + 10, d = a.i; b < c;)if (0 === (d[b++] & 128)) {
                        M(a, b);
                        break a;
                    }
                    throw Ya();
                }
                break;
            case 1:
                a = a.h;
                M(a, a.h + 8);
                break;
            case 2:
                2 != a.i ? ub(a) : (b = nb(a.h) >>> 0, a = a.h, M(a, a.h + b));
                break;
            case 5:
                a = a.h;
                M(a, a.h + 4);
                break;
            case 3:
                b = a.l;
                do {
                    if (!tb(a)) throw Error("Unmatched start-group tag: stream EOF");
                    if (4 == a.i) {
                        if (a.l != b) throw Error("Unmatched end-group tag");
                        break;
                    }
                    ub(a);
                }while (1);
                break;
            default:
                throw Xa(a.i, a.j);
        }
    }
    var vb = [];
    function wb() {
        this.j = [];
        this.i = 0;
        this.h = new qb;
    }
    function O(a, b) {
        0 !== b.length && (a.j.push(b), a.i += b.length);
    }
    function xb(a, b) {
        if (b = b.R) {
            O(a, a.h.end());
            for(var c = 0; c < b.length; c++)O(a, jb(b[c]) || Oa());
        }
    }
    var P = "function" === typeof Symbol && "symbol" === typeof Symbol() ? Symbol() : void 0;
    function Q(a, b) {
        if (P) return a[P] |= b;
        if (void 0 !== a.A) return a.A |= b;
        Object.defineProperties(a, {
            A: {
                value: b,
                configurable: !0,
                writable: !0,
                enumerable: !1
            }
        });
        return b;
    }
    function yb(a, b) {
        P ? a[P] && (a[P] &= ~b) : void 0 !== a.A && (a.A &= ~b);
    }
    function R(a) {
        var b;
        P ? b = a[P] : b = a.A;
        return null == b ? 0 : b;
    }
    function S(a, b) {
        P ? a[P] = b : void 0 !== a.A ? a.A = b : Object.defineProperties(a, {
            A: {
                value: b,
                configurable: !0,
                writable: !0,
                enumerable: !1
            }
        });
    }
    function zb(a) {
        Q(a, 1);
        return a;
    }
    function Ab(a, b) {
        S(b, (a | 0) & -51);
    }
    function Bb(a, b) {
        S(b, (a | 18) & -41);
    }
    var Cb = {};
    function Db(a) {
        return null !== a && "object" === typeof a && !Array.isArray(a) && a.constructor === Object;
    }
    var Eb, Fb = [];
    S(Fb, 23);
    Eb = Object.freeze(Fb);
    function Gb(a) {
        if (R(a.o) & 2) throw Error("Cannot mutate an immutable Message");
    }
    function Hb(a) {
        var b = a.length;
        (b = b ? a[b - 1] : void 0) && Db(b) ? b.g = 1 : (b = {}, a.push((b.g = 1, b)));
    }
    function Ib(a) {
        var b = a.i + a.G;
        return a.B || (a.B = a.o[b] = {});
    }
    function T(a, b) {
        return -1 === b ? null : b >= a.i ? a.B ? a.B[b] : void 0 : a.o[b + a.G];
    }
    function V(a, b, c, d) {
        Gb(a);
        Jb(a, b, c, d);
    }
    function Jb(a, b, c, d) {
        a.j && (a.j = void 0);
        b >= a.i || d ? Ib(a)[b] = c : (a.o[b + a.G] = c, (a = a.B) && b in a && delete a[b]);
    }
    function Kb(a, b, c, d) {
        var e = T(a, b);
        Array.isArray(e) || (e = Eb);
        var g = R(e);
        g & 1 || zb(e);
        if (d) g & 2 || Q(e, 2), c & 1 || Object.freeze(e);
        else {
            d = !(c & 2);
            var f = g & 2;
            c & 1 || !f ? d && g & 16 && !f && yb(e, 16) : (e = zb(Array.prototype.slice.call(e)), Jb(a, b, e));
        }
        return e;
    }
    function Lb(a, b) {
        var c = T(a, b);
        var d = null == c ? c : "number" === typeof c || "NaN" === c || "Infinity" === c || "-Infinity" === c ? Number(c) : void 0;
        null != d && d !== c && Jb(a, b, d);
        return d;
    }
    function Mb(a, b, c, d, e) {
        a.h || (a.h = {});
        var g = a.h[c], f = Kb(a, c, 3, e);
        if (!g) {
            var h = f;
            g = [];
            var k = !!(R(a.o) & 16);
            f = !!(R(h) & 2);
            var l = h;
            !e && f && (h = Array.prototype.slice.call(h));
            for(var m = f, r = 0; r < h.length; r++){
                var p = h[r];
                var n = b, q = !1;
                q = void 0 === q ? !1 : q;
                p = Array.isArray(p) ? new n(p) : q ? new n : void 0;
                if (void 0 !== p) {
                    n = p.o;
                    var t = q = R(n);
                    f && (t |= 2);
                    k && (t |= 16);
                    t != q && S(n, t);
                    n = t;
                    m = m || !!(2 & n);
                    g.push(p);
                }
            }
            a.h[c] = g;
            k = R(h);
            b = k | 33;
            b = m ? b & -9 : b | 8;
            k != b && (m = h, Object.isFrozen(m) && (m = Array.prototype.slice.call(m)), S(m, b), h = m);
            l !== h && Jb(a, c, h);
            (e || d && f) && Q(g, 2);
            d && Object.freeze(g);
            return g;
        }
        e || (e = Object.isFrozen(g), d && !e ? Object.freeze(g) : !d && e && (g = Array.prototype.slice.call(g), a.h[c] = g));
        return g;
    }
    function Nb(a, b, c) {
        var d = !!(R(a.o) & 2);
        b = Mb(a, b, c, d, d);
        a = Kb(a, c, 3, d);
        if (!(d || R(a) & 8)) {
            for(d = 0; d < b.length; d++){
                c = b[d];
                if (R(c.o) & 2) {
                    var e = Ob(c, !1);
                    e.j = c;
                } else e = c;
                c !== e && (b[d] = e, a[d] = e.o);
            }
            Q(a, 8);
        }
        return b;
    }
    function W(a, b, c) {
        if (null != c && "number" !== typeof c) throw Error("Value of float/double field must be a number|null|undefined, found " + typeof c + ": " + c);
        V(a, b, c);
    }
    function Pb(a, b, c, d, e) {
        Gb(a);
        var g = Mb(a, c, b, !1, !1);
        c = null != d ? d : new c;
        a = Kb(a, b, 2, !1);
        void 0 != e ? (g.splice(e, 0, c), a.splice(e, 0, c.o)) : (g.push(c), a.push(c.o));
        c.C() && yb(a, 8);
        return c;
    }
    function Qb(a, b) {
        return null == a ? b : a;
    }
    function X(a, b, c) {
        c = void 0 === c ? 0 : c;
        return Qb(Lb(a, b), c);
    }
    var Rb;
    function Sb(a) {
        switch(typeof a){
            case "number":
                return isFinite(a) ? a : String(a);
            case "object":
                if (a) {
                    if (Array.isArray(a)) {
                        if (0 !== (R(a) & 128)) return a = Array.prototype.slice.call(a), Hb(a), a;
                    } else {
                        if (Ha && null != a && a instanceof Uint8Array) return Ja(a);
                        if (a instanceof hb) {
                            var b = a.V;
                            return null == b ? "" : "string" === typeof b ? b : a.V = Ja(b);
                        }
                    }
                }
        }
        return a;
    }
    function Tb(a, b, c, d) {
        if (null != a) {
            if (Array.isArray(a)) a = Ub(a, b, c, void 0 !== d);
            else if (Db(a)) {
                var e = {}, g;
                for(g in a)e[g] = Tb(a[g], b, c, d);
                a = e;
            } else a = b(a, d);
            return a;
        }
    }
    function Ub(a, b, c, d) {
        var e = R(a);
        d = d ? !!(e & 16) : void 0;
        a = Array.prototype.slice.call(a);
        for(var g = 0; g < a.length; g++)a[g] = Tb(a[g], b, c, d);
        c(e, a);
        return a;
    }
    function Vb(a) {
        return a.ja === Cb ? a.toJSON() : Sb(a);
    }
    function Wb(a, b) {
        a & 128 && Hb(b);
    }
    function Xb(a, b, c) {
        c = void 0 === c ? Bb : c;
        if (null != a) {
            if (Ha && a instanceof Uint8Array) return a.length ? new hb(new Uint8Array(a), Pa) : ib();
            if (Array.isArray(a)) {
                var d = R(a);
                if (d & 2) return a;
                if (b && !(d & 32) && (d & 16 || 0 === d)) return S(a, d | 2), a;
                a = Ub(a, Xb, d & 4 ? Bb : c, !0);
                b = R(a);
                b & 4 && b & 2 && Object.freeze(a);
                return a;
            }
            return a.ja === Cb ? Yb(a) : a;
        }
    }
    function Zb(a, b, c, d, e, g, f) {
        if (a = a.h && a.h[c]) {
            d = R(a);
            d & 2 ? d = a : (g = Ba(a, Yb), Bb(d, g), Object.freeze(g), d = g);
            Gb(b);
            f = null == d ? Eb : zb([]);
            if (null != d) {
                g = !!d.length;
                for(a = 0; a < d.length; a++){
                    var h = d[a];
                    g = g && !(R(h.o) & 2);
                    f[a] = h.o;
                }
                g = (g ? 8 : 0) | 1;
                a = R(f);
                (a & g) !== g && (Object.isFrozen(f) && (f = Array.prototype.slice.call(f)), S(f, a | g));
                b.h || (b.h = {});
                b.h[c] = d;
            } else b.h && (b.h[c] = void 0);
            Jb(b, c, f, e);
        } else V(b, c, Xb(d, g, f), e);
    }
    function Yb(a) {
        if (R(a.o) & 2) return a;
        a = Ob(a, !0);
        Q(a.o, 2);
        return a;
    }
    function Ob(a, b) {
        var c = a.o, d = [];
        Q(d, 16);
        var e = a.constructor.h;
        e && d.push(e);
        e = a.B;
        if (e) {
            d.length = c.length;
            d.fill(void 0, d.length, c.length);
            var g = {};
            d[d.length - 1] = g;
        }
        0 !== (R(c) & 128) && Hb(d);
        b = b || a.C() ? Bb : Ab;
        g = a.constructor;
        Rb = d;
        d = new g(d);
        Rb = void 0;
        a.R && (d.R = a.R.slice());
        g = !!(R(c) & 16);
        for(var f = e ? c.length - 1 : c.length, h = 0; h < f; h++)Zb(a, d, h - a.G, c[h], !1, g, b);
        if (e) for(var k in e)Zb(a, d, +k, e[k], !0, g, b);
        return d;
    }
    function Y(a, b, c) {
        null == a && (a = Rb);
        Rb = void 0;
        var d = this.constructor.i || 0, e = 0 < d, g = this.constructor.h, f = !1;
        if (null == a) {
            a = g ? [
                g
            ] : [];
            var h = 48;
            var k = !0;
            e && (d = 0, h |= 128);
            S(a, h);
        } else {
            if (!Array.isArray(a)) throw Error();
            if (g && g !== a[0]) throw Error();
            var l = h = Q(a, 0);
            if (k = 0 !== (16 & l)) (f = 0 !== (32 & l)) || (l |= 32);
            if (e) {
                if (128 & l) d = 0;
                else if (0 < a.length) {
                    var m = a[a.length - 1];
                    if (Db(m) && "g" in m) {
                        d = 0;
                        l |= 128;
                        delete m.g;
                        var r = !0, p;
                        for(p in m){
                            r = !1;
                            break;
                        }
                        r && a.pop();
                    }
                }
            } else if (128 & l) throw Error();
            h !== l && S(a, l);
        }
        this.G = (g ? 0 : -1) - d;
        this.h = void 0;
        this.o = a;
        a: {
            g = this.o.length;
            d = g - 1;
            if (g && (g = this.o[d], Db(g))) {
                this.B = g;
                this.i = d - this.G;
                break a;
            }
            void 0 !== b && -1 < b ? (this.i = Math.max(b, d + 1 - this.G), this.B = void 0) : this.i = Number.MAX_VALUE;
        }
        if (!e && this.B && "g" in this.B) throw Error('Unexpected "g" flag in sparse object of message that is not a group type.');
        if (c) {
            b = k && !f && !0;
            e = this.i;
            var n;
            for(k = 0; k < c.length; k++)f = c[k], f < e ? (f += this.G, (d = a[f]) ? $b(d, b) : a[f] = Eb) : (n || (n = Ib(this)), (d = n[f]) ? $b(d, b) : n[f] = Eb);
        }
    }
    Y.prototype.toJSON = function() {
        return Ub(this.o, Vb, Wb);
    };
    Y.prototype.C = function() {
        return !!(R(this.o) & 2);
    };
    function $b(a, b) {
        if (Array.isArray(a)) {
            var c = R(a), d = 1;
            !b || c & 2 || (d |= 16);
            (c & d) !== d && S(a, c | d);
        }
    }
    Y.prototype.ja = Cb;
    Y.prototype.toString = function() {
        return this.o.toString();
    };
    function ac(a, b, c) {
        if (c) {
            var d = {}, e;
            for(e in c){
                var g = c[e], f = g.ra;
                f || (d.J = g.xa || g.oa.W, g.ia ? (d.aa = bc(g.ia), f = function(h) {
                    return function(k, l, m) {
                        return h.J(k, l, m, h.aa);
                    };
                }(d)) : g.ka ? (d.Z = cc(g.da.P, g.ka), f = function(h) {
                    return function(k, l, m) {
                        return h.J(k, l, m, h.Z);
                    };
                }(d)) : f = d.J, g.ra = f);
                f(b, a, g.da);
                d = {
                    J: d.J,
                    aa: d.aa,
                    Z: d.Z
                };
            }
        }
        xb(b, a);
    }
    var dc = Symbol();
    function ec(a, b, c) {
        return a[dc] || (a[dc] = function(d, e) {
            return b(d, e, c);
        });
    }
    function fc(a) {
        var b = a[dc];
        if (!b) {
            var c = gc(a);
            b = function(d, e) {
                return hc(d, e, c);
            };
            a[dc] = b;
        }
        return b;
    }
    function ic(a) {
        var b = a.ia;
        if (b) return fc(b);
        if (b = a.wa) return ec(a.da.P, b, a.ka);
    }
    function jc(a) {
        var b = ic(a), c = a.da, d = a.oa.U;
        return b ? function(e, g) {
            return d(e, g, c, b);
        } : function(e, g) {
            return d(e, g, c);
        };
    }
    function kc(a, b) {
        var c = a[b];
        "function" == typeof c && 0 === c.length && (c = c(), a[b] = c);
        return Array.isArray(c) && (lc in c || mc in c || 0 < c.length && "function" == typeof c[0]) ? c : void 0;
    }
    function nc(a, b, c, d, e, g) {
        b.P = a[0];
        var f = 1;
        if (a.length > f && "number" !== typeof a[f]) {
            var h = a[f++];
            c(b, h);
        }
        for(; f < a.length;){
            c = a[f++];
            for(var k = f + 1; k < a.length && "number" !== typeof a[k];)k++;
            h = a[f++];
            k -= f;
            switch(k){
                case 0:
                    d(b, c, h);
                    break;
                case 1:
                    (k = kc(a, f)) ? (f++, e(b, c, h, k)) : d(b, c, h, a[f++]);
                    break;
                case 2:
                    k = f++;
                    k = kc(a, k);
                    e(b, c, h, k, a[f++]);
                    break;
                case 3:
                    g(b, c, h, a[f++], a[f++], a[f++]);
                    break;
                case 4:
                    g(b, c, h, a[f++], a[f++], a[f++], a[f++]);
                    break;
                default:
                    throw Error("unexpected number of binary field arguments: " + k);
            }
        }
        return b;
    }
    var oc = Symbol();
    function bc(a) {
        var b = a[oc];
        if (!b) {
            var c = pc(a);
            b = function(d, e) {
                return qc(d, e, c);
            };
            a[oc] = b;
        }
        return b;
    }
    function cc(a, b) {
        var c = a[oc];
        c || (c = function(d, e) {
            return ac(d, e, b);
        }, a[oc] = c);
        return c;
    }
    var mc = Symbol();
    function rc(a, b) {
        a.push(b);
    }
    function sc(a, b, c) {
        a.push(b, c.W);
    }
    function tc(a, b, c, d) {
        var e = bc(d), g = pc(d).P, f = c.W;
        a.push(b, function(h, k, l) {
            return f(h, k, l, g, e);
        });
    }
    function uc(a, b, c, d, e, g) {
        var f = cc(d, g), h = c.W;
        a.push(b, function(k, l, m) {
            return h(k, l, m, d, f);
        });
    }
    function pc(a) {
        var b = a[mc];
        if (b) return b;
        b = nc(a, a[mc] = [], rc, sc, tc, uc);
        lc in a && mc in a && (a.length = 0);
        return b;
    }
    var lc = Symbol();
    function vc(a, b) {
        a[0] = b;
    }
    function wc(a, b, c, d) {
        var e = c.U;
        a[b] = d ? function(g, f, h) {
            return e(g, f, h, d);
        } : e;
    }
    function xc(a, b, c, d, e) {
        var g = c.U, f = fc(d), h = gc(d).P;
        a[b] = function(k, l, m) {
            return g(k, l, m, h, f, e);
        };
    }
    function yc(a, b, c, d, e, g, f) {
        var h = c.U, k = ec(d, e, g);
        a[b] = function(l, m, r) {
            return h(l, m, r, d, k, f);
        };
    }
    function gc(a) {
        var b = a[lc];
        if (b) return b;
        b = nc(a, a[lc] = {}, vc, wc, xc, yc);
        lc in a && mc in a && (a.length = 0);
        return b;
    }
    function hc(a, b, c) {
        for(; tb(b) && 4 != b.i;){
            var d = b.l, e = c[d];
            if (!e) {
                var g = c[0];
                g && (g = g[d]) && (e = c[d] = jc(g));
            }
            if (!e || !e(b, a, d)) {
                e = b;
                d = a;
                g = e.j;
                ub(e);
                var f = e;
                if (!f.ca) {
                    e = f.h.h - g;
                    f.h.h = g;
                    f = f.h;
                    if (0 == e) e = ib();
                    else {
                        g = ob(f, e);
                        if (f.S && f.m) e = f.i.subarray(g, g + e);
                        else {
                            f = f.i;
                            var h = g;
                            e = g + e;
                            e = h === e ? Oa() : Qa ? f.slice(h, e) : new Uint8Array(f.subarray(h, e));
                        }
                        e = 0 == e.length ? ib() : new hb(e, Pa);
                    }
                    (g = d.R) ? g.push(e) : d.R = [
                        e
                    ];
                }
            }
        }
        return a;
    }
    function qc(a, b, c) {
        for(var d = c.length, e = 1 == d % 2, g = e ? 1 : 0; g < d; g += 2)(0, c[g + 1])(b, a, c[g]);
        ac(a, b, e ? c[0] : void 0);
    }
    function zc(a, b) {
        return {
            U: a,
            W: b
        };
    }
    var Z = zc(function(a, b, c) {
        if (5 !== a.i) return !1;
        a = a.h;
        var d = a.i, e = a.h, g = d[e];
        var f = d[e + 1];
        var h = d[e + 2];
        d = d[e + 3];
        M(a, a.h + 4);
        f = (g << 0 | f << 8 | h << 16 | d << 24) >>> 0;
        a = 2 * (f >> 31) + 1;
        g = f >>> 23 & 255;
        f &= 8388607;
        V(b, c, 255 == g ? f ? NaN : Infinity * a : 0 == g ? a * Math.pow(2, -149) * f : a * Math.pow(2, g - 150) * (f + Math.pow(2, 23)));
        return !0;
    }, function(a, b, c) {
        b = Lb(b, c);
        if (null != b) {
            N(a.h, 8 * c + 5);
            a = a.h;
            var d = +b;
            0 === d ? 0 < 1 / d ? H = K = 0 : (K = 0, H = 2147483648) : isNaN(d) ? (K = 0, H = 2147483647) : (d = (c = 0 > d ? -2147483648 : 0) ? -d : d, 3.4028234663852886E38 < d ? (K = 0, H = (c | 2139095040) >>> 0) : 1.1754943508222875E-38 > d ? (d = Math.round(d / Math.pow(2, -149)), K = 0, H = (c | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, K = 0, H = (c | b + 127 << 23 | d & 8388607) >>> 0));
            c = H;
            a.h.push(c >>> 0 & 255);
            a.h.push(c >>> 8 & 255);
            a.h.push(c >>> 16 & 255);
            a.h.push(c >>> 24 & 255);
        }
    }), Ac = zc(function(a, b, c) {
        if (0 !== a.i) return !1;
        var d = a.h, e = 0, g = a = 0, f = d.i, h = d.h;
        do {
            var k = f[h++];
            e |= (k & 127) << g;
            g += 7;
        }while (32 > g && k & 128);
        32 < g && (a |= (k & 127) >> 4);
        for(g = 3; 32 > g && k & 128; g += 7)k = f[h++], a |= (k & 127) << g;
        M(d, h);
        if (128 > k) {
            d = e >>> 0;
            k = a >>> 0;
            if (a = k & 2147483648) d = ~d + 1 >>> 0, k = ~k >>> 0, 0 == d && (k = k + 1 >>> 0);
            d = 4294967296 * k + (d >>> 0);
        } else throw Ya();
        V(b, c, a ? -d : d);
        return !0;
    }, function(a, b, c) {
        b = T(b, c);
        null != b && ("string" === typeof b && Va(b), null != b && (N(a.h, 8 * c), "number" === typeof b ? (a = a.h, Ra(b), rb(a, H, K)) : (c = Va(b), rb(a.h, c.i, c.h))));
    }), Bc = zc(function(a, b, c) {
        if (0 !== a.i) return !1;
        V(b, c, nb(a.h));
        return !0;
    }, function(a, b, c) {
        b = T(b, c);
        if (null != b && null != b) {
            if (N(a.h, 8 * c), a = a.h, c = b, 0 <= c) N(a, c);
            else {
                for(b = 0; 9 > b; b++)a.h.push(c & 127 | 128), c >>= 7;
                a.h.push(1);
            }
        }
    }), Cc = zc(function(a, b, c) {
        if (2 !== a.i) return !1;
        var d = nb(a.h) >>> 0;
        a = a.h;
        var e = ob(a, d);
        a = a.i;
        if (cb) {
            var g = a, f;
            (f = bb) || (f = bb = new TextDecoder("utf-8", {
                fatal: !0
            }));
            a = e + d;
            g = 0 === e && a === g.length ? g : g.subarray(e, a);
            try {
                var h = f.decode(g);
            } catch (r) {
                if (void 0 === ab) {
                    try {
                        f.decode(new Uint8Array([
                            128
                        ]));
                    } catch (p) {}
                    try {
                        f.decode(new Uint8Array([
                            97
                        ])), ab = !0;
                    } catch (p) {
                        ab = !1;
                    }
                }
                !ab && (bb = void 0);
                throw r;
            }
        } else {
            h = e;
            d = h + d;
            e = [];
            for(var k = null, l, m; h < d;)l = a[h++], 128 > l ? e.push(l) : 224 > l ? h >= d ? L() : (m = a[h++], 194 > l || 128 !== (m & 192) ? (h--, L()) : e.push((l & 31) << 6 | m & 63)) : 240 > l ? h >= d - 1 ? L() : (m = a[h++], 128 !== (m & 192) || 224 === l && 160 > m || 237 === l && 160 <= m || 128 !== ((g = a[h++]) & 192) ? (h--, L()) : e.push((l & 15) << 12 | (m & 63) << 6 | g & 63)) : 244 >= l ? h >= d - 2 ? L() : (m = a[h++], 128 !== (m & 192) || 0 !== (l << 28) + (m - 144) >> 30 || 128 !== ((g = a[h++]) & 192) || 128 !== ((f = a[h++]) & 192) ? (h--, L()) : (l = (l & 7) << 18 | (m & 63) << 12 | (g & 63) << 6 | f & 63, l -= 65536, e.push((l >> 10 & 1023) + 55296, (l & 1023) + 56320))) : L(), 8192 <= e.length && (k = $a(k, e), e.length = 0);
            h = $a(k, e);
        }
        V(b, c, h);
        return !0;
    }, function(a, b, c) {
        b = T(b, c);
        if (null != b) {
            var d = !1;
            d = void 0 === d ? !1 : d;
            if (eb) {
                if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b)) throw Error("Found an unpaired surrogate");
                b = (db || (db = new TextEncoder)).encode(b);
            } else {
                for(var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++){
                    var h = b.charCodeAt(f);
                    if (128 > h) g[e++] = h;
                    else {
                        if (2048 > h) g[e++] = h >> 6 | 192;
                        else {
                            if (55296 <= h && 57343 >= h) {
                                if (56319 >= h && f < b.length) {
                                    var k = b.charCodeAt(++f);
                                    if (56320 <= k && 57343 >= k) {
                                        h = 1024 * (h - 55296) + k - 56320 + 65536;
                                        g[e++] = h >> 18 | 240;
                                        g[e++] = h >> 12 & 63 | 128;
                                        g[e++] = h >> 6 & 63 | 128;
                                        g[e++] = h & 63 | 128;
                                        continue;
                                    } else f--;
                                }
                                if (d) throw Error("Found an unpaired surrogate");
                                h = 65533;
                            }
                            g[e++] = h >> 12 | 224;
                            g[e++] = h >> 6 & 63 | 128;
                        }
                        g[e++] = h & 63 | 128;
                    }
                }
                b = e === g.length ? g : g.subarray(0, e);
            }
            N(a.h, 8 * c + 2);
            N(a.h, b.length);
            O(a, a.h.end());
            O(a, b);
        }
    }), Dc = zc(function(a, b, c, d, e) {
        if (2 !== a.i) return !1;
        b = Pb(b, c, d);
        c = a.h.j;
        d = nb(a.h) >>> 0;
        var g = a.h.h + d, f = g - c;
        0 >= f && (a.h.j = g, e(b, a, void 0, void 0, void 0), f = g - a.h.h);
        if (f) throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
        a.h.h = g;
        a.h.j = c;
        return !0;
    }, function(a, b, c, d, e) {
        b = Nb(b, d, c);
        if (null != b) for(d = 0; d < b.length; d++){
            var g = a;
            N(g.h, 8 * c + 2);
            var f = g.h.end();
            O(g, f);
            f.push(g.i);
            g = f;
            e(b[d], a);
            f = a;
            var h = g.pop();
            for(h = f.i + f.h.length() - h; 127 < h;)g.push(h & 127 | 128), h >>>= 7, f.i++;
            g.push(h);
            f.i++;
        }
    });
    function Ec(a) {
        return function(b, c) {
            a: {
                if (vb.length) {
                    var d = vb.pop();
                    d.setOptions(c);
                    mb(d.h, b, c);
                    b = d;
                } else b = new sb(b, c);
                try {
                    var e = gc(a);
                    var g = hc(new e.P, b, e);
                    break a;
                } finally{
                    e = b.h, e.i = null, e.m = !1, e.l = 0, e.j = 0, e.h = 0, e.S = !1, b.l = -1, b.i = -1, 100 > vb.length && vb.push(b);
                }
                g = void 0;
            }
            return g;
        };
    }
    function Fc(a) {
        return function() {
            var b = new wb;
            qc(this, b, pc(a));
            O(b, b.h.end());
            for(var c = new Uint8Array(b.i), d = b.j, e = d.length, g = 0, f = 0; f < e; f++){
                var h = d[f];
                c.set(h, g);
                g += h.length;
            }
            b.j = [
                c
            ];
            return c;
        };
    }
    function Gc(a) {
        Y.call(this, a);
    }
    na(Gc, Y);
    var Hc = [
        Gc,
        1,
        Bc,
        2,
        Z,
        3,
        Cc,
        4,
        Cc
    ];
    Gc.prototype.l = Fc(Hc);
    function Ic(a) {
        Y.call(this, a, -1, Jc);
    }
    na(Ic, Y);
    Ic.prototype.addClassification = function(a, b) {
        Pb(this, 1, Gc, a, b);
        return this;
    };
    var Jc = [
        1
    ], Kc = Ec([
        Ic,
        1,
        Dc,
        Hc
    ]);
    function Lc(a) {
        Y.call(this, a);
    }
    na(Lc, Y);
    var Mc = [
        Lc,
        1,
        Z,
        2,
        Z,
        3,
        Z,
        4,
        Z,
        5,
        Z
    ];
    Lc.prototype.l = Fc(Mc);
    function Nc(a) {
        Y.call(this, a, -1, Oc);
    }
    na(Nc, Y);
    var Oc = [
        1
    ], Pc = Ec([
        Nc,
        1,
        Dc,
        Mc
    ]);
    function Qc(a) {
        Y.call(this, a);
    }
    na(Qc, Y);
    var Rc = [
        Qc,
        1,
        Z,
        2,
        Z,
        3,
        Z,
        4,
        Z,
        5,
        Z,
        6,
        Ac
    ], Sc = Ec(Rc);
    Qc.prototype.l = Fc(Rc);
    function Tc(a, b, c) {
        c = a.createShader(0 === c ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
        a.shaderSource(c, b);
        a.compileShader(c);
        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
        return c;
    }
    function Uc(a) {
        return Nb(a, Gc, 1).map(function(b) {
            var c = T(b, 1);
            return {
                index: null == c ? 0 : c,
                qa: X(b, 2),
                label: null != T(b, 3) ? Qb(T(b, 3), "") : void 0,
                displayName: null != T(b, 4) ? Qb(T(b, 4), "") : void 0
            };
        });
    }
    function Vc(a) {
        return {
            x: X(a, 1),
            y: X(a, 2),
            z: X(a, 3),
            visibility: null != Lb(a, 4) ? X(a, 4) : void 0
        };
    }
    function Wc(a) {
        return Nb(Pc(a), Lc, 1).map(Vc);
    }
    function Xc(a, b) {
        this.i = a;
        this.h = b;
        this.m = 0;
    }
    function Yc(a, b, c) {
        Zc(a, b);
        if ("function" === typeof a.h.canvas.transferToImageBitmap) return Promise.resolve(a.h.canvas.transferToImageBitmap());
        if (c) return Promise.resolve(a.h.canvas);
        if ("function" === typeof createImageBitmap) return createImageBitmap(a.h.canvas);
        void 0 === a.j && (a.j = document.createElement("canvas"));
        return new Promise(function(d) {
            a.j.height = a.h.canvas.height;
            a.j.width = a.h.canvas.width;
            a.j.getContext("2d", {}).drawImage(a.h.canvas, 0, 0, a.h.canvas.width, a.h.canvas.height);
            d(a.j);
        });
    }
    function Zc(a, b) {
        var c = a.h;
        if (void 0 === a.s) {
            var d = Tc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Tc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
            c.attachShader(g, d);
            c.attachShader(g, e);
            c.linkProgram(g);
            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
            d = a.s = g;
            c.useProgram(d);
            e = c.getUniformLocation(d, "sampler0");
            a.l = {
                O: c.getAttribLocation(d, "aVertex"),
                N: c.getAttribLocation(d, "aTex"),
                ya: e
            };
            a.v = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, a.v);
            c.enableVertexAttribArray(a.l.O);
            c.vertexAttribPointer(a.l.O, 2, c.FLOAT, !1, 0, 0);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                -1,
                -1,
                -1,
                1,
                1,
                1,
                1,
                -1
            ]), c.STATIC_DRAW);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            a.u = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, a.u);
            c.enableVertexAttribArray(a.l.N);
            c.vertexAttribPointer(a.l.N, 2, c.FLOAT, !1, 0, 0);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                0,
                1,
                0,
                0,
                1,
                0,
                1,
                1
            ]), c.STATIC_DRAW);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.uniform1i(e, 0);
        }
        d = a.l;
        c.useProgram(a.s);
        c.canvas.width = b.width;
        c.canvas.height = b.height;
        c.viewport(0, 0, b.width, b.height);
        c.activeTexture(c.TEXTURE0);
        a.i.bindTexture2d(b.glName);
        c.enableVertexAttribArray(d.O);
        c.bindBuffer(c.ARRAY_BUFFER, a.v);
        c.vertexAttribPointer(d.O, 2, c.FLOAT, !1, 0, 0);
        c.enableVertexAttribArray(d.N);
        c.bindBuffer(c.ARRAY_BUFFER, a.u);
        c.vertexAttribPointer(d.N, 2, c.FLOAT, !1, 0, 0);
        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
        c.clearColor(0, 0, 0, 0);
        c.clear(c.COLOR_BUFFER_BIT);
        c.colorMask(!0, !0, !0, !0);
        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
        c.disableVertexAttribArray(d.O);
        c.disableVertexAttribArray(d.N);
        c.bindBuffer(c.ARRAY_BUFFER, null);
        a.i.bindTexture2d(0);
    }
    function $c(a) {
        this.h = a;
    }
    var ad = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        2,
        1,
        0,
        10,
        9,
        1,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    function bd(a, b) {
        return b + a;
    }
    function cd(a, b) {
        window[a] = b;
    }
    function dd(a) {
        var b = document.createElement("script");
        b.setAttribute("src", a);
        b.setAttribute("crossorigin", "anonymous");
        return new Promise(function(c) {
            b.addEventListener("load", function() {
                c();
            }, !1);
            b.addEventListener("error", function() {
                c();
            }, !1);
            document.body.appendChild(b);
        });
    }
    function ed() {
        return E(function(a) {
            switch(a.h){
                case 1:
                    return a.s = 2, D(a, WebAssembly.instantiate(ad), 4);
                case 4:
                    a.h = 3;
                    a.s = 0;
                    break;
                case 2:
                    return a.s = 0, a.l = null, a.return(!1);
                case 3:
                    return a.return(!0);
            }
        });
    }
    function fd(a) {
        this.h = a;
        this.listeners = {};
        this.l = {};
        this.L = {};
        this.s = {};
        this.v = {};
        this.M = this.u = this.ga = !0;
        this.I = Promise.resolve();
        this.fa = "";
        this.D = {};
        this.locateFile = a && a.locateFile || bd;
        if ("object" === typeof window) var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
        else if ("undefined" !== typeof location) b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
        else throw Error("solutions can only be loaded on a web page or in a web worker");
        this.ha = b;
        if (a.options) {
            b = A(Object.keys(a.options));
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = a.options[c].default;
                void 0 !== d && (this.l[c] = "function" === typeof d ? d() : d);
            }
        }
    }
    x = fd.prototype;
    x.close = function() {
        this.j && this.j.delete();
        return Promise.resolve();
    };
    function gd(a) {
        var b, c, d, e, g, f, h, k, l, m, r;
        return E(function(p) {
            switch(p.h){
                case 1:
                    if (!a.ga) return p.return();
                    b = void 0 === a.h.files ? [] : "function" === typeof a.h.files ? a.h.files(a.l) : a.h.files;
                    return D(p, ed(), 2);
                case 2:
                    c = p.i;
                    if ("object" === typeof window) return cd("createMediapipeSolutionsWasm", {
                        locateFile: a.locateFile
                    }), cd("createMediapipeSolutionsPackedAssets", {
                        locateFile: a.locateFile
                    }), f = b.filter(function(n) {
                        return void 0 !== n.data;
                    }), h = b.filter(function(n) {
                        return void 0 === n.data;
                    }), k = Promise.all(f.map(function(n) {
                        var q = hd(a, n.url);
                        if (void 0 !== n.path) {
                            var t = n.path;
                            q = q.then(function(w) {
                                a.overrideFile(t, w);
                                return Promise.resolve(w);
                            });
                        }
                        return q;
                    })), l = Promise.all(h.map(function(n) {
                        return void 0 === n.simd || n.simd && c || !n.simd && !c ? dd(a.locateFile(n.url, a.ha)) : Promise.resolve();
                    })).then(function() {
                        var n, q, t;
                        return E(function(w) {
                            if (1 == w.h) return n = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, D(w, n(q), 2);
                            t.i = w.i;
                            w.h = 0;
                        });
                    }), m = function() {
                        return E(function(n) {
                            a.h.graph && a.h.graph.url ? n = D(n, hd(a, a.h.graph.url), 0) : (n.h = 0, n = void 0);
                            return n;
                        });
                    }(), D(p, Promise.all([
                        l,
                        k,
                        m
                    ]), 7);
                    if ("function" !== typeof importScripts) throw Error("solutions can only be loaded on a web page or in a web worker");
                    d = b.filter(function(n) {
                        return void 0 === n.simd || n.simd && c || !n.simd && !c;
                    }).map(function(n) {
                        return a.locateFile(n.url, a.ha);
                    });
                    importScripts.apply(null, ea(d));
                    e = a;
                    return D(p, createMediapipeSolutionsWasm(Module), 6);
                case 6:
                    e.i = p.i;
                    a.m = new OffscreenCanvas(1, 1);
                    a.i.canvas = a.m;
                    g = a.i.GL.createContext(a.m, {
                        antialias: !1,
                        alpha: !1,
                        va: "undefined" !== typeof WebGL2RenderingContext ? 2 : 1
                    });
                    a.i.GL.makeContextCurrent(g);
                    p.h = 4;
                    break;
                case 7:
                    a.m = document.createElement("canvas");
                    r = a.m.getContext("webgl2", {});
                    if (!r && (r = a.m.getContext("webgl", {}), !r)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                    a.K = r;
                    a.i.canvas = a.m;
                    a.i.createContext(a.m, !0, !0, {});
                case 4:
                    a.j = new a.i.SolutionWasm, a.ga = !1, p.h = 0;
            }
        });
    }
    function id(a) {
        var b, c, d, e, g, f, h, k;
        return E(function(l) {
            if (1 == l.h) {
                if (a.h.graph && a.h.graph.url && a.fa === a.h.graph.url) return l.return();
                a.u = !0;
                if (!a.h.graph || !a.h.graph.url) {
                    l.h = 2;
                    return;
                }
                a.fa = a.h.graph.url;
                return D(l, hd(a, a.h.graph.url), 3);
            }
            2 != l.h && (b = l.i, a.j.loadGraph(b));
            c = A(Object.keys(a.D));
            for(d = c.next(); !d.done; d = c.next())e = d.value, a.j.overrideFile(e, a.D[e]);
            a.D = {};
            if (a.h.listeners) for(g = A(a.h.listeners), f = g.next(); !f.done; f = g.next())h = f.value, jd(a, h);
            k = a.l;
            a.l = {};
            a.setOptions(k);
            l.h = 0;
        });
    }
    x.reset = function() {
        var a = this;
        return E(function(b) {
            a.j && (a.j.reset(), a.s = {}, a.v = {});
            b.h = 0;
        });
    };
    x.setOptions = function(a, b) {
        var c = this;
        if (b = b || this.h.options) {
            for(var d = [], e = [], g = {}, f = A(Object.keys(a)), h = f.next(); !h.done; g = {
                X: g.X,
                Y: g.Y
            }, h = f.next())if (h = h.value, !(h in this.l && this.l[h] === a[h])) {
                this.l[h] = a[h];
                var k = b[h];
                void 0 !== k && (k.onChange && (g.X = k.onChange, g.Y = a[h], d.push(function(l) {
                    return function() {
                        var m;
                        return E(function(r) {
                            if (1 == r.h) return D(r, l.X(l.Y), 2);
                            m = r.i;
                            !0 === m && (c.u = !0);
                            r.h = 0;
                        });
                    };
                }(g))), k.graphOptionXref && (h = Object.assign({}, {
                    calculatorName: "",
                    calculatorIndex: 0
                }, k.graphOptionXref, {
                    valueNumber: 1 === k.type ? a[h] : 0,
                    valueBoolean: 0 === k.type ? a[h] : !1,
                    valueString: 2 === k.type ? a[h] : ""
                }), e.push(h)));
            }
            if (0 !== d.length || 0 !== e.length) this.u = !0, this.H = (void 0 === this.H ? [] : this.H).concat(e), this.F = (void 0 === this.F ? [] : this.F).concat(d);
        }
    };
    function kd(a) {
        var b, c, d, e, g, f, h;
        return E(function(k) {
            switch(k.h){
                case 1:
                    if (!a.u) return k.return();
                    if (!a.F) {
                        k.h = 2;
                        break;
                    }
                    b = A(a.F);
                    c = b.next();
                case 3:
                    if (c.done) {
                        k.h = 5;
                        break;
                    }
                    d = c.value;
                    return D(k, d(), 4);
                case 4:
                    c = b.next();
                    k.h = 3;
                    break;
                case 5:
                    a.F = void 0;
                case 2:
                    if (a.H) {
                        e = new a.i.GraphOptionChangeRequestList;
                        g = A(a.H);
                        for(f = g.next(); !f.done; f = g.next())h = f.value, e.push_back(h);
                        a.j.changeOptions(e);
                        e.delete();
                        a.H = void 0;
                    }
                    a.u = !1;
                    k.h = 0;
            }
        });
    }
    x.initialize = function() {
        var a = this;
        return E(function(b) {
            return 1 == b.h ? D(b, gd(a), 2) : 3 != b.h ? D(b, id(a), 3) : D(b, kd(a), 0);
        });
    };
    function hd(a, b) {
        var c, d;
        return E(function(e) {
            if (b in a.L) return e.return(a.L[b]);
            c = a.locateFile(b, "");
            d = fetch(c).then(function(g) {
                return g.arrayBuffer();
            });
            a.L[b] = d;
            return e.return(d);
        });
    }
    x.overrideFile = function(a, b) {
        this.j ? this.j.overrideFile(a, b) : this.D[a] = b;
    };
    x.clearOverriddenFiles = function() {
        this.D = {};
        this.j && this.j.clearOverriddenFiles();
    };
    x.send = function(a, b) {
        var c = this, d, e, g, f, h, k, l, m, r;
        return E(function(p) {
            switch(p.h){
                case 1:
                    if (!c.h.inputs) return p.return();
                    d = 1E3 * (void 0 === b || null === b ? performance.now() : b);
                    return D(p, c.I, 2);
                case 2:
                    return D(p, c.initialize(), 3);
                case 3:
                    e = new c.i.PacketDataList;
                    g = A(Object.keys(a));
                    for(f = g.next(); !f.done; f = g.next())if (h = f.value, k = c.h.inputs[h]) {
                        a: {
                            var n = a[h];
                            switch(k.type){
                                case "video":
                                    var q = c.s[k.stream];
                                    q || (q = new Xc(c.i, c.K), c.s[k.stream] = q);
                                    0 === q.m && (q.m = q.i.createTexture());
                                    if ("undefined" !== typeof HTMLVideoElement && n instanceof HTMLVideoElement) {
                                        var t = n.videoWidth;
                                        var w = n.videoHeight;
                                    } else "undefined" !== typeof HTMLImageElement && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                                    w = {
                                        glName: q.m,
                                        width: t,
                                        height: w
                                    };
                                    t = q.h;
                                    t.canvas.width = w.width;
                                    t.canvas.height = w.height;
                                    t.activeTexture(t.TEXTURE0);
                                    q.i.bindTexture2d(q.m);
                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                                    q.i.bindTexture2d(0);
                                    q = w;
                                    break a;
                                case "detections":
                                    q = c.s[k.stream];
                                    q || (q = new $c(c.i), c.s[k.stream] = q);
                                    q.data || (q.data = new q.h.DetectionListData);
                                    q.data.reset(n.length);
                                    for(w = 0; w < n.length; ++w){
                                        t = n[w];
                                        var v = q.data, B = v.setBoundingBox, J = w;
                                        var I = t.la;
                                        var u = new Qc;
                                        W(u, 1, I.sa);
                                        W(u, 2, I.ta);
                                        W(u, 3, I.height);
                                        W(u, 4, I.width);
                                        W(u, 5, I.rotation);
                                        V(u, 6, I.pa);
                                        I = u.l();
                                        B.call(v, J, I);
                                        if (t.ea) for(v = 0; v < t.ea.length; ++v){
                                            u = t.ea[v];
                                            B = q.data;
                                            J = B.addNormalizedLandmark;
                                            I = w;
                                            u = Object.assign({}, u, {
                                                visibility: u.visibility ? u.visibility : 0
                                            });
                                            var C = new Lc;
                                            W(C, 1, u.x);
                                            W(C, 2, u.y);
                                            W(C, 3, u.z);
                                            u.visibility && W(C, 4, u.visibility);
                                            u = C.l();
                                            J.call(B, I, u);
                                        }
                                        if (t.ba) for(v = 0; v < t.ba.length; ++v)B = q.data, J = B.addClassification, I = w, u = t.ba[v], C = new Gc, W(C, 2, u.qa), u.index && V(C, 1, u.index), u.label && V(C, 3, u.label), u.displayName && V(C, 4, u.displayName), u = C.l(), J.call(B, I, u);
                                    }
                                    q = q.data;
                                    break a;
                                default:
                                    q = {};
                            }
                        }
                        l = q;
                        m = k.stream;
                        switch(k.type){
                            case "video":
                                e.pushTexture2d(Object.assign({}, l, {
                                    stream: m,
                                    timestamp: d
                                }));
                                break;
                            case "detections":
                                r = l;
                                r.stream = m;
                                r.timestamp = d;
                                e.pushDetectionList(r);
                                break;
                            default:
                                throw Error("Unknown input config type: '" + k.type + "'");
                        }
                    }
                    c.j.send(e);
                    return D(p, c.I, 4);
                case 4:
                    e.delete(), p.h = 0;
            }
        });
    };
    function ld(a, b, c) {
        var d, e, g, f, h, k, l, m, r, p, n, q, t, w;
        return E(function(v) {
            switch(v.h){
                case 1:
                    if (!c) return v.return(b);
                    d = {};
                    e = 0;
                    g = A(Object.keys(c));
                    for(f = g.next(); !f.done; f = g.next())h = f.value, k = c[h], "string" !== typeof k && "texture" === k.type && void 0 !== b[k.stream] && ++e;
                    1 < e && (a.M = !1);
                    l = A(Object.keys(c));
                    f = l.next();
                case 2:
                    if (f.done) {
                        v.h = 4;
                        break;
                    }
                    m = f.value;
                    r = c[m];
                    if ("string" === typeof r) return t = d, w = m, D(v, md(a, m, b[r]), 14);
                    p = b[r.stream];
                    if ("detection_list" === r.type) {
                        if (p) {
                            var B = p.getRectList();
                            for(var J = p.getLandmarksList(), I = p.getClassificationsList(), u = [], C = 0; C < B.size(); ++C){
                                var U = Sc(B.get(C)), pd = X(U, 1), qd = X(U, 2), rd = X(U, 3), sd = X(U, 4), td = X(U, 5, 0), za = void 0;
                                za = void 0 === za ? 0 : za;
                                U = {
                                    la: {
                                        sa: pd,
                                        ta: qd,
                                        height: rd,
                                        width: sd,
                                        rotation: td,
                                        pa: Qb(T(U, 6), za)
                                    },
                                    ea: Wc(J.get(C)),
                                    ba: Uc(Kc(I.get(C)))
                                };
                                u.push(U);
                            }
                            B = u;
                        } else B = [];
                        d[m] = B;
                        v.h = 7;
                        break;
                    }
                    if ("proto_list" === r.type) {
                        if (p) {
                            B = Array(p.size());
                            for(J = 0; J < p.size(); J++)B[J] = p.get(J);
                            p.delete();
                        } else B = [];
                        d[m] = B;
                        v.h = 7;
                        break;
                    }
                    if (void 0 === p) {
                        v.h = 3;
                        break;
                    }
                    if ("float_list" === r.type) {
                        d[m] = p;
                        v.h = 7;
                        break;
                    }
                    if ("proto" === r.type) {
                        d[m] = p;
                        v.h = 7;
                        break;
                    }
                    if ("texture" !== r.type) throw Error("Unknown output config type: '" + r.type + "'");
                    n = a.v[m];
                    n || (n = new Xc(a.i, a.K), a.v[m] = n);
                    return D(v, Yc(n, p, a.M), 13);
                case 13:
                    q = v.i, d[m] = q;
                case 7:
                    r.transform && d[m] && (d[m] = r.transform(d[m]));
                    v.h = 3;
                    break;
                case 14:
                    t[w] = v.i;
                case 3:
                    f = l.next();
                    v.h = 2;
                    break;
                case 4:
                    return v.return(d);
            }
        });
    }
    function md(a, b, c) {
        var d;
        return E(function(e) {
            return "number" === typeof c || c instanceof Uint8Array || c instanceof a.i.Uint8BlobList ? e.return(c) : c instanceof a.i.Texture2dDataOut ? (d = a.v[b], d || (d = new Xc(a.i, a.K), a.v[b] = d), e.return(Yc(d, c, a.M))) : e.return(void 0);
        });
    }
    function jd(a, b) {
        for(var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.i.StringList, g = A(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
        g = a.i.PacketListener.implement({
            onResults: function(h) {
                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = h.get(l);
                var m = a.listeners[c];
                m && (a.I = ld(a, k, b.outs).then(function(r) {
                    r = m(r);
                    for(var p = 0; p < b.wants.length; ++p){
                        var n = k[d[p]];
                        "object" === typeof n && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
                    }
                    r && (a.I = r);
                }));
            }
        });
        a.j.attachMultiListener(e, g);
        e.delete();
    }
    x.onResults = function(a, b) {
        this.listeners[b || "$"] = a;
    };
    G("Solution", fd);
    G("OptionType", {
        BOOL: 0,
        NUMBER: 1,
        ua: 2,
        0: "BOOL",
        1: "NUMBER",
        2: "STRING"
    });
    function nd(a) {
        void 0 === a && (a = 0);
        switch(a){
            case 1:
                return "pose_landmark_full.tflite";
            case 2:
                return "pose_landmark_heavy.tflite";
            default:
                return "pose_landmark_lite.tflite";
        }
    }
    function od(a) {
        var b = this;
        a = a || {};
        this.h = new fd({
            locateFile: a.locateFile,
            files: function(c) {
                return [
                    {
                        url: "pose_solution_packed_assets_loader.js"
                    },
                    {
                        simd: !1,
                        url: "pose_solution_wasm_bin.js"
                    },
                    {
                        simd: !0,
                        url: "pose_solution_simd_wasm_bin.js"
                    },
                    {
                        data: !0,
                        url: nd(c.modelComplexity)
                    }
                ];
            },
            graph: {
                url: "pose_web.binarypb"
            },
            listeners: [
                {
                    wants: [
                        "pose_landmarks",
                        "world_landmarks",
                        "segmentation_mask",
                        "image_transformed"
                    ],
                    outs: {
                        image: {
                            type: "texture",
                            stream: "image_transformed"
                        },
                        poseLandmarks: {
                            type: "proto",
                            stream: "pose_landmarks",
                            transform: Wc
                        },
                        poseWorldLandmarks: {
                            type: "proto",
                            stream: "world_landmarks",
                            transform: Wc
                        },
                        segmentationMask: {
                            type: "texture",
                            stream: "segmentation_mask"
                        }
                    }
                }
            ],
            inputs: {
                image: {
                    type: "video",
                    stream: "input_frames_gpu"
                }
            },
            options: {
                useCpuInference: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "InferenceCalculator",
                        fieldName: "use_cpu_inference"
                    },
                    default: "object" !== typeof window || void 0 === window.navigator ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                },
                selfieMode: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "GlScalerCalculator",
                        calculatorIndex: 1,
                        fieldName: "flip_horizontal"
                    }
                },
                modelComplexity: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorModelComplexity",
                        fieldName: "int_value"
                    },
                    onChange: function(c) {
                        var d, e, g;
                        return E(function(f) {
                            if (1 == f.h) return d = nd(c), e = "third_party/mediapipe/modules/pose_landmark/" + d, D(f, hd(b.h, d), 2);
                            g = f.i;
                            b.h.overrideFile(e, g);
                            return f.return(!0);
                        });
                    }
                },
                smoothLandmarks: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks",
                        fieldName: "bool_value"
                    }
                },
                enableSegmentation: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorEnableSegmentation",
                        fieldName: "bool_value"
                    }
                },
                smoothSegmentation: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation",
                        fieldName: "bool_value"
                    }
                },
                minDetectionConfidence: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "TensorsToDetectionsCalculator",
                        calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
                        fieldName: "min_score_thresh"
                    }
                },
                minTrackingConfidence: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "ThresholdingCalculator",
                        calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator",
                        fieldName: "threshold"
                    }
                }
            }
        });
    }
    x = od.prototype;
    x.reset = function() {
        this.h.reset();
    };
    x.close = function() {
        this.h.close();
        return Promise.resolve();
    };
    x.onResults = function(a) {
        this.h.onResults(a);
    };
    x.initialize = function() {
        var a = this;
        return E(function(b) {
            return D(b, a.h.initialize(), 0);
        });
    };
    x.send = function(a, b) {
        var c = this;
        return E(function(d) {
            return D(d, c.h.send(a, b), 0);
        });
    };
    x.setOptions = function(a) {
        this.h.setOptions(a);
    };
    G("Pose", od);
    G("POSE_CONNECTIONS", [
        [
            0,
            1
        ],
        [
            1,
            2
        ],
        [
            2,
            3
        ],
        [
            3,
            7
        ],
        [
            0,
            4
        ],
        [
            4,
            5
        ],
        [
            5,
            6
        ],
        [
            6,
            8
        ],
        [
            9,
            10
        ],
        [
            11,
            12
        ],
        [
            11,
            13
        ],
        [
            13,
            15
        ],
        [
            15,
            17
        ],
        [
            15,
            19
        ],
        [
            15,
            21
        ],
        [
            17,
            19
        ],
        [
            12,
            14
        ],
        [
            14,
            16
        ],
        [
            16,
            18
        ],
        [
            16,
            20
        ],
        [
            16,
            22
        ],
        [
            18,
            20
        ],
        [
            11,
            23
        ],
        [
            12,
            24
        ],
        [
            23,
            24
        ],
        [
            23,
            25
        ],
        [
            24,
            26
        ],
        [
            25,
            27
        ],
        [
            26,
            28
        ],
        [
            27,
            29
        ],
        [
            28,
            30
        ],
        [
            29,
            31
        ],
        [
            30,
            32
        ],
        [
            27,
            31
        ],
        [
            28,
            32
        ]
    ]);
    G("POSE_LANDMARKS", {
        NOSE: 0,
        LEFT_EYE_INNER: 1,
        LEFT_EYE: 2,
        LEFT_EYE_OUTER: 3,
        RIGHT_EYE_INNER: 4,
        RIGHT_EYE: 5,
        RIGHT_EYE_OUTER: 6,
        LEFT_EAR: 7,
        RIGHT_EAR: 8,
        LEFT_RIGHT: 9,
        RIGHT_LEFT: 10,
        LEFT_SHOULDER: 11,
        RIGHT_SHOULDER: 12,
        LEFT_ELBOW: 13,
        RIGHT_ELBOW: 14,
        LEFT_WRIST: 15,
        RIGHT_WRIST: 16,
        LEFT_PINKY: 17,
        RIGHT_PINKY: 18,
        LEFT_INDEX: 19,
        RIGHT_INDEX: 20,
        LEFT_THUMB: 21,
        RIGHT_THUMB: 22,
        LEFT_HIP: 23,
        RIGHT_HIP: 24,
        LEFT_KNEE: 25,
        RIGHT_KNEE: 26,
        LEFT_ANKLE: 27,
        RIGHT_ANKLE: 28,
        LEFT_HEEL: 29,
        RIGHT_HEEL: 30,
        LEFT_FOOT_INDEX: 31,
        RIGHT_FOOT_INDEX: 32
    });
    G("POSE_LANDMARKS_LEFT", {
        LEFT_EYE_INNER: 1,
        LEFT_EYE: 2,
        LEFT_EYE_OUTER: 3,
        LEFT_EAR: 7,
        LEFT_RIGHT: 9,
        LEFT_SHOULDER: 11,
        LEFT_ELBOW: 13,
        LEFT_WRIST: 15,
        LEFT_PINKY: 17,
        LEFT_INDEX: 19,
        LEFT_THUMB: 21,
        LEFT_HIP: 23,
        LEFT_KNEE: 25,
        LEFT_ANKLE: 27,
        LEFT_HEEL: 29,
        LEFT_FOOT_INDEX: 31
    });
    G("POSE_LANDMARKS_RIGHT", {
        RIGHT_EYE_INNER: 4,
        RIGHT_EYE: 5,
        RIGHT_EYE_OUTER: 6,
        RIGHT_EAR: 8,
        RIGHT_LEFT: 10,
        RIGHT_SHOULDER: 12,
        RIGHT_ELBOW: 14,
        RIGHT_WRIST: 16,
        RIGHT_PINKY: 18,
        RIGHT_INDEX: 20,
        RIGHT_THUMB: 22,
        RIGHT_HIP: 24,
        RIGHT_KNEE: 26,
        RIGHT_ANKLE: 28,
        RIGHT_HEEL: 30,
        RIGHT_FOOT_INDEX: 32
    });
    G("POSE_LANDMARKS_NEUTRAL", {
        NOSE: 0
    });
    G("VERSION", "0.5.1675469404");
}).call($670e4c2ab08b8e48$exports);


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code.
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code for tfjs-core
// Set up Engine and ENV
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $0f11f47888a734c2$export$76e53a66c52b6d4d = 1e-7;
const $0f11f47888a734c2$export$49716d145771e6a2 = 1e-4;
class $0f11f47888a734c2$export$e95767ffe2e60cec {
    constructor(backend, dataMover){
        this.backend = backend;
        this.dataMover = dataMover;
        this.data = new WeakMap();
        this.dataIdsCount = 0;
    }
    get(dataId) {
        if (!this.data.has(dataId)) this.dataMover.moveData(this.backend, dataId);
        return this.data.get(dataId);
    }
    set(dataId, value) {
        this.dataIdsCount++;
        this.data.set(dataId, value);
    }
    has(dataId) {
        return this.data.has(dataId);
    }
    delete(dataId) {
        this.dataIdsCount--;
        return this.data.delete(dataId);
    }
    numDataIds() {
        return this.dataIdsCount;
    }
}
class $0f11f47888a734c2$export$543916c62202b50a {
    refCount(dataId) {
        return $0f11f47888a734c2$var$notYetImplemented('refCount');
    }
    incRef(dataId) {
        return $0f11f47888a734c2$var$notYetImplemented('incRef');
    }
    timerAvailable() {
        return true;
    }
    time(f) {
        return $0f11f47888a734c2$var$notYetImplemented('time');
    }
    read(dataId) {
        return $0f11f47888a734c2$var$notYetImplemented('read');
    }
    readSync(dataId) {
        return $0f11f47888a734c2$var$notYetImplemented('readSync');
    }
    readToGPU(dataId, options) {
        return $0f11f47888a734c2$var$notYetImplemented('readToGPU');
    }
    numDataIds() {
        return $0f11f47888a734c2$var$notYetImplemented('numDataIds');
    }
    disposeData(dataId, force) {
        return $0f11f47888a734c2$var$notYetImplemented('disposeData');
    }
    write(values, shape, dtype) {
        return $0f11f47888a734c2$var$notYetImplemented('write');
    }
    move(dataId, values, shape, dtype, refCount) {
        return $0f11f47888a734c2$var$notYetImplemented('move');
    }
    createTensorFromGPUData(values, shape, dtype) {
        return $0f11f47888a734c2$var$notYetImplemented('createTensorFromGPUData');
    }
    memory() {
        return $0f11f47888a734c2$var$notYetImplemented('memory');
    }
    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */ floatPrecision() {
        return $0f11f47888a734c2$var$notYetImplemented('floatPrecision');
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $0f11f47888a734c2$export$76e53a66c52b6d4d : $0f11f47888a734c2$export$49716d145771e6a2;
    }
    dispose() {
        return $0f11f47888a734c2$var$notYetImplemented('dispose');
    }
}
function $0f11f47888a734c2$var$notYetImplemented(kernelName) {
    throw new Error(`'${kernelName}' not yet implemented or not found in the registry. ` + `This kernel may not be supported by the tfjs backend you have chosen`);
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $9e4a6174e3538e7d$exports = {};

$parcel$export($9e4a6174e3538e7d$exports, "shuffle", () => $9e4a6174e3538e7d$export$448332262467e042);
$parcel$export($9e4a6174e3538e7d$exports, "swap", () => $9e4a6174e3538e7d$export$b0e76d9850c64156);
$parcel$export($9e4a6174e3538e7d$exports, "shuffleCombo", () => $9e4a6174e3538e7d$export$ae1498b5fd31a179);
$parcel$export($9e4a6174e3538e7d$exports, "clamp", () => $9e4a6174e3538e7d$export$7d15b64cf5a3a4c4);
$parcel$export($9e4a6174e3538e7d$exports, "nearestLargerEven", () => $9e4a6174e3538e7d$export$ece2fd7300c99d1f);
$parcel$export($9e4a6174e3538e7d$exports, "sum", () => $9e4a6174e3538e7d$export$8a63f25cc62965f1);
$parcel$export($9e4a6174e3538e7d$exports, "randUniform", () => $9e4a6174e3538e7d$export$1c2519d52242937);
$parcel$export($9e4a6174e3538e7d$exports, "distSquared", () => $9e4a6174e3538e7d$export$499eb56409f6cbc2);
$parcel$export($9e4a6174e3538e7d$exports, "assert", () => $9e4a6174e3538e7d$export$a7a9523472993e97);
$parcel$export($9e4a6174e3538e7d$exports, "assertShapesMatch", () => $9e4a6174e3538e7d$export$e08b27e7f37e2782);
$parcel$export($9e4a6174e3538e7d$exports, "arraysEqual", () => $9e4a6174e3538e7d$export$234180f8206db11b);
$parcel$export($9e4a6174e3538e7d$exports, "assertNonNull", () => $9e4a6174e3538e7d$export$44a06cc2759dd036);
$parcel$export($9e4a6174e3538e7d$exports, "sizeFromShape", () => $9e4a6174e3538e7d$export$b4c3214a70a0e73f);
$parcel$export($9e4a6174e3538e7d$exports, "isScalarShape", () => $9e4a6174e3538e7d$export$d58b8d1ec2129064);
$parcel$export($9e4a6174e3538e7d$exports, "arraysEqualWithNull", () => $9e4a6174e3538e7d$export$9efb31c074e61de7);
$parcel$export($9e4a6174e3538e7d$exports, "isInt", () => $9e4a6174e3538e7d$export$357fc28f6427af8b);
$parcel$export($9e4a6174e3538e7d$exports, "tanh", () => $9e4a6174e3538e7d$export$7128670e45beef9a);
$parcel$export($9e4a6174e3538e7d$exports, "sizeToSquarishShape", () => $9e4a6174e3538e7d$export$55bdc5631791c247);
$parcel$export($9e4a6174e3538e7d$exports, "createShuffledIndices", () => $9e4a6174e3538e7d$export$49070d702e17365);
$parcel$export($9e4a6174e3538e7d$exports, "rightPad", () => $9e4a6174e3538e7d$export$390245bab32fb60f);
$parcel$export($9e4a6174e3538e7d$exports, "repeatedTry", () => $9e4a6174e3538e7d$export$aa345f93372ddb7b);
$parcel$export($9e4a6174e3538e7d$exports, "inferFromImplicitShape", () => $9e4a6174e3538e7d$export$e9459a51c182ffc2);
$parcel$export($9e4a6174e3538e7d$exports, "parseAxisParam", () => $9e4a6174e3538e7d$export$72b84eb9fe1f482);
$parcel$export($9e4a6174e3538e7d$exports, "squeezeShape", () => $9e4a6174e3538e7d$export$3106ace2a3b5396d);
$parcel$export($9e4a6174e3538e7d$exports, "getTypedArrayFromDType", () => $9e4a6174e3538e7d$export$3b783bdb77632623);
$parcel$export($9e4a6174e3538e7d$exports, "getArrayFromDType", () => $9e4a6174e3538e7d$export$24f13f6206df8f7c);
$parcel$export($9e4a6174e3538e7d$exports, "checkConversionForErrors", () => $9e4a6174e3538e7d$export$579cf7b8ff0a87a3);
$parcel$export($9e4a6174e3538e7d$exports, "isValidDtype", () => $9e4a6174e3538e7d$export$a6a3df2178ac9529);
$parcel$export($9e4a6174e3538e7d$exports, "hasEncodingLoss", () => $9e4a6174e3538e7d$export$9130d84b35fa7b98);
$parcel$export($9e4a6174e3538e7d$exports, "bytesPerElement", () => $9e4a6174e3538e7d$export$3f355ce86503b89f);
$parcel$export($9e4a6174e3538e7d$exports, "bytesFromStringArray", () => $9e4a6174e3538e7d$export$c474902e1102282d);
$parcel$export($9e4a6174e3538e7d$exports, "isString", () => $9e4a6174e3538e7d$export$844ec244b1367d54);
$parcel$export($9e4a6174e3538e7d$exports, "isBoolean", () => $9e4a6174e3538e7d$export$f9ce7b637dfbe238);
$parcel$export($9e4a6174e3538e7d$exports, "isNumber", () => $9e4a6174e3538e7d$export$7e4aa119212bc614);
$parcel$export($9e4a6174e3538e7d$exports, "inferDtype", () => $9e4a6174e3538e7d$export$2005775d905d2dc2);
$parcel$export($9e4a6174e3538e7d$exports, "isFunction", () => $9e4a6174e3538e7d$export$f6e2535fb5126e54);
$parcel$export($9e4a6174e3538e7d$exports, "nearestDivisor", () => $9e4a6174e3538e7d$export$c0ff3276320ddb5e);
$parcel$export($9e4a6174e3538e7d$exports, "computeStrides", () => $9e4a6174e3538e7d$export$6ad0292cf4d50f79);
$parcel$export($9e4a6174e3538e7d$exports, "toNestedArray", () => $9e4a6174e3538e7d$export$3983c25181aa68cc);
$parcel$export($9e4a6174e3538e7d$exports, "convertBackendValuesAndArrayBuffer", () => $9e4a6174e3538e7d$export$568d15cfc23dac5d);
$parcel$export($9e4a6174e3538e7d$exports, "makeOnesTypedArray", () => $9e4a6174e3538e7d$export$b915f681a907ae99);
$parcel$export($9e4a6174e3538e7d$exports, "makeZerosTypedArray", () => $9e4a6174e3538e7d$export$edbc8aedac4e036f);
$parcel$export($9e4a6174e3538e7d$exports, "makeZerosNestedTypedArray", () => $9e4a6174e3538e7d$export$eef638260c005c74);
$parcel$export($9e4a6174e3538e7d$exports, "assertNonNegativeIntegerDimensions", () => $9e4a6174e3538e7d$export$3d8b7619bac22cf5);
$parcel$export($9e4a6174e3538e7d$exports, "locToIndex", () => $9e4a6174e3538e7d$export$a14b009c502dc3b4);
$parcel$export($9e4a6174e3538e7d$exports, "indexToLoc", () => $9e4a6174e3538e7d$export$2d1ada4c755a8699);
$parcel$export($9e4a6174e3538e7d$exports, "isPromise", () => $9e4a6174e3538e7d$export$4369c812aac99591);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Shuffles the array in-place using Fisher-Yates algorithm.
 *
 * ```js
 * const a = [1, 2, 3, 4, 5];
 * tf.util.shuffle(a);
 * console.log(a);
 * ```
 *
 * @param array The array to shuffle in-place.
 *
 * @doc {heading: 'Util', namespace: 'util'}
 */ // tslint:disable-next-line:no-any
function $9e4a6174e3538e7d$export$448332262467e042(array) {
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element with it
        $9e4a6174e3538e7d$export$b0e76d9850c64156(array, counter, index);
    }
}
function $9e4a6174e3538e7d$export$ae1498b5fd31a179(// tslint:disable-next-line:no-any
array, // tslint:disable-next-line:no-any
array2) {
    if (array.length !== array2.length) throw new Error(`Array sizes must match to be shuffled together ` + `First array length was ${array.length}` + `Second array length was ${array2.length}`);
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element of each array with it
        $9e4a6174e3538e7d$export$b0e76d9850c64156(array, counter, index);
        $9e4a6174e3538e7d$export$b0e76d9850c64156(array2, counter, index);
    }
}
function $9e4a6174e3538e7d$export$7d15b64cf5a3a4c4(min, x, max) {
    return Math.max(min, Math.min(x, max));
}
function $9e4a6174e3538e7d$export$ece2fd7300c99d1f(val) {
    return val % 2 === 0 ? val : val + 1;
}
function $9e4a6174e3538e7d$export$b0e76d9850c64156(object, left, right) {
    const temp = object[left];
    object[left] = object[right];
    object[right] = temp;
}
function $9e4a6174e3538e7d$export$8a63f25cc62965f1(arr) {
    let sum = 0;
    for(let i = 0; i < arr.length; i++)sum += arr[i];
    return sum;
}
function $9e4a6174e3538e7d$export$1c2519d52242937(a, b) {
    const r = Math.random();
    return b * r + (1 - r) * a;
}
function $9e4a6174e3538e7d$export$499eb56409f6cbc2(a, b) {
    let result = 0;
    for(let i = 0; i < a.length; i++){
        const diff = Number(a[i]) - Number(b[i]);
        result += diff * diff;
    }
    return result;
}
function $9e4a6174e3538e7d$export$a7a9523472993e97(expr, msg) {
    if (!expr) throw new Error(typeof msg === 'string' ? msg : msg());
}
function $9e4a6174e3538e7d$export$e08b27e7f37e2782(shapeA, shapeB, errorMessagePrefix = '') {
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$234180f8206db11b(shapeA, shapeB), ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
}
function $9e4a6174e3538e7d$export$44a06cc2759dd036(a) {
    $9e4a6174e3538e7d$export$a7a9523472993e97(a != null, ()=>`The input to the tensor constructor must be a non-null value.`);
}
function $9e4a6174e3538e7d$export$b4c3214a70a0e73f(shape) {
    if (shape.length === 0) // Scalar.
    return 1;
    let size = shape[0];
    for(let i = 1; i < shape.length; i++)size *= shape[i];
    return size;
}
function $9e4a6174e3538e7d$export$d58b8d1ec2129064(shape) {
    return shape.length === 0;
}
function $9e4a6174e3538e7d$export$9efb31c074e61de7(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== null && n2[i] !== null && n1[i] !== n2[i]) return false;
    }
    return true;
}
function $9e4a6174e3538e7d$export$234180f8206db11b(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== n2[i]) return false;
    }
    return true;
}
function $9e4a6174e3538e7d$export$357fc28f6427af8b(a) {
    return a % 1 === 0;
}
function $9e4a6174e3538e7d$export$7128670e45beef9a(x) {
    // tslint:disable-next-line:no-any
    if (Math.tanh != null) // tslint:disable-next-line:no-any
    return Math.tanh(x);
    if (x === Infinity) return 1;
    else if (x === -Infinity) return -1;
    else {
        const e2x = Math.exp(2 * x);
        return (e2x - 1) / (e2x + 1);
    }
}
function $9e4a6174e3538e7d$export$55bdc5631791c247(size) {
    const width = Math.ceil(Math.sqrt(size));
    return [
        width,
        Math.ceil(size / width)
    ];
}
function $9e4a6174e3538e7d$export$49070d702e17365(n) {
    const shuffledIndices = new Uint32Array(n);
    for(let i = 0; i < n; ++i)shuffledIndices[i] = i;
    $9e4a6174e3538e7d$export$448332262467e042(shuffledIndices);
    return shuffledIndices;
}
function $9e4a6174e3538e7d$export$390245bab32fb60f(a, size) {
    if (size <= a.length) return a;
    return a + ' '.repeat(size - a.length);
}
function $9e4a6174e3538e7d$export$aa345f93372ddb7b(checkFn, delayFn = (counter)=>0, maxCounter, scheduleFn) {
    return new Promise((resolve, reject)=>{
        let tryCount = 0;
        const tryFn = ()=>{
            if (checkFn()) {
                resolve();
                return;
            }
            tryCount++;
            const nextBackoff = delayFn(tryCount);
            if (maxCounter != null && tryCount >= maxCounter) {
                reject();
                return;
            }
            if (scheduleFn != null) scheduleFn(tryFn, nextBackoff);
            else // google3 does not allow assigning another variable to setTimeout.
            // Don't refactor this so scheduleFn has a default value of setTimeout.
            setTimeout(tryFn, nextBackoff);
        };
        tryFn();
    });
}
function $9e4a6174e3538e7d$export$e9459a51c182ffc2(shape, size) {
    let shapeProd = 1;
    let implicitIdx = -1;
    for(let i = 0; i < shape.length; ++i){
        if (shape[i] >= 0) shapeProd *= shape[i];
        else if (shape[i] === -1) {
            if (implicitIdx !== -1) throw Error(`Shapes can only have 1 implicit size. ` + `Found -1 at dim ${implicitIdx} and dim ${i}`);
            implicitIdx = i;
        } else if (shape[i] < 0) throw Error(`Shapes can not be < 0. Found ${shape[i]} at dim ${i}`);
    }
    if (implicitIdx === -1) {
        if (size > 0 && size !== shapeProd) throw Error(`Size(${size}) must match the product of shape ${shape}`);
        return shape;
    }
    if (shapeProd === 0) throw Error(`Cannot infer the missing size in [${shape}] when ` + `there are 0 elements`);
    if (size % shapeProd !== 0) throw Error(`The implicit shape can't be a fractional number. ` + `Got ${size} / ${shapeProd}`);
    const newShape = shape.slice();
    newShape[implicitIdx] = size / shapeProd;
    return newShape;
}
function $9e4a6174e3538e7d$export$72b84eb9fe1f482(axis, shape) {
    const rank = shape.length;
    // Normalize input
    axis = axis == null ? shape.map((s, i)=>i) : [].concat(axis);
    // Check for valid range
    $9e4a6174e3538e7d$export$a7a9523472993e97(axis.every((ax)=>ax >= -rank && ax < rank), ()=>`All values in axis param must be in range [-${rank}, ${rank}) but ` + `got axis ${axis}`);
    // Check for only integers
    $9e4a6174e3538e7d$export$a7a9523472993e97(axis.every((ax)=>$9e4a6174e3538e7d$export$357fc28f6427af8b(ax)), ()=>`All values in axis param must be integers but ` + `got axis ${axis}`);
    // Handle negative axis.
    return axis.map((a)=>a < 0 ? rank + a : a);
}
function $9e4a6174e3538e7d$export$3106ace2a3b5396d(shape, axis) {
    const newShape = [];
    const keptDims = [];
    const isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
    const axes = axis == null || isEmptyArray ? null : $9e4a6174e3538e7d$export$72b84eb9fe1f482(axis, shape).sort();
    let j = 0;
    for(let i = 0; i < shape.length; ++i){
        if (axes != null) {
            if (axes[j] === i && shape[i] !== 1) throw new Error(`Can't squeeze axis ${i} since its dim '${shape[i]}' is not 1`);
            if ((axes[j] == null || axes[j] > i) && shape[i] === 1) {
                newShape.push(shape[i]);
                keptDims.push(i);
            }
            if (axes[j] <= i) j++;
        }
        if (shape[i] !== 1) {
            newShape.push(shape[i]);
            keptDims.push(i);
        }
    }
    return {
        newShape: newShape,
        keptDims: keptDims
    };
}
function $9e4a6174e3538e7d$export$3b783bdb77632623(dtype, size) {
    return $9e4a6174e3538e7d$export$24f13f6206df8f7c(dtype, size);
}
function $9e4a6174e3538e7d$export$24f13f6206df8f7c(dtype, size) {
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else if (dtype === 'string') values = new Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    return values;
}
function $9e4a6174e3538e7d$export$579cf7b8ff0a87a3(vals, dtype) {
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) throw Error(`A tensor of type ${dtype} being uploaded contains ${num}.`);
    }
}
function $9e4a6174e3538e7d$export$a6a3df2178ac9529(dtype) {
    return dtype === 'bool' || dtype === 'complex64' || dtype === 'float32' || dtype === 'int32' || dtype === 'string';
}
function $9e4a6174e3538e7d$export$9130d84b35fa7b98(oldType, newType) {
    if (newType === 'complex64') return false;
    if (newType === 'float32' && oldType !== 'complex64') return false;
    if (newType === 'int32' && oldType !== 'float32' && oldType !== 'complex64') return false;
    if (newType === 'bool' && oldType === 'bool') return false;
    return true;
}
function $9e4a6174e3538e7d$export$3f355ce86503b89f(dtype) {
    if (dtype === 'float32' || dtype === 'int32') return 4;
    else if (dtype === 'complex64') return 8;
    else if (dtype === 'bool') return 1;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $9e4a6174e3538e7d$export$c474902e1102282d(arr) {
    if (arr == null) return 0;
    let bytes = 0;
    arr.forEach((x)=>bytes += x.length);
    return bytes;
}
function $9e4a6174e3538e7d$export$844ec244b1367d54(value) {
    return typeof value === 'string' || value instanceof String;
}
function $9e4a6174e3538e7d$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $9e4a6174e3538e7d$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $9e4a6174e3538e7d$export$2005775d905d2dc2(values) {
    if (Array.isArray(values)) return $9e4a6174e3538e7d$export$2005775d905d2dc2(values[0]);
    if (values instanceof Float32Array) return 'float32';
    else if (values instanceof Int32Array || values instanceof Uint8Array || values instanceof Uint8ClampedArray) return 'int32';
    else if ($9e4a6174e3538e7d$export$7e4aa119212bc614(values)) return 'float32';
    else if ($9e4a6174e3538e7d$export$844ec244b1367d54(values)) return 'string';
    else if ($9e4a6174e3538e7d$export$f9ce7b637dfbe238(values)) return 'bool';
    return 'float32';
}
function $9e4a6174e3538e7d$export$f6e2535fb5126e54(f) {
    return !!(f && f.constructor && f.call && f.apply);
}
function $9e4a6174e3538e7d$export$c0ff3276320ddb5e(size, start) {
    for(let i = start; i < size; ++i){
        if (size % i === 0) return i;
    }
    return size;
}
function $9e4a6174e3538e7d$export$6ad0292cf4d50f79(shape) {
    const rank = shape.length;
    if (rank < 2) return [];
    // Last dimension has implicit stride of 1, thus having D-1 (instead of D)
    // strides.
    const strides = new Array(rank - 1);
    strides[rank - 2] = shape[rank - 1];
    for(let i = rank - 3; i >= 0; --i)strides[i] = strides[i + 1] * shape[i + 1];
    return strides;
}
function $9e4a6174e3538e7d$var$createNestedArray(offset, shape, a, isComplex = false) {
    const ret = new Array();
    if (shape.length === 1) {
        const d = shape[0] * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = a[offset + i];
    } else {
        const d = shape[0];
        const rest = shape.slice(1);
        const len = rest.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = $9e4a6174e3538e7d$var$createNestedArray(offset + i * len, rest, a, isComplex);
    }
    return ret;
}
function $9e4a6174e3538e7d$export$3983c25181aa68cc(shape, a, isComplex = false) {
    if (shape.length === 0) // Scalar type should return a single number.
    return a[0];
    const size = shape.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
    if (size === 0) // A tensor with shape zero should be turned into empty list.
    return [];
    if (size !== a.length) throw new Error(`[${shape}] does not match the input size ${a.length}${isComplex ? ' for a complex tensor' : ''}.`);
    return $9e4a6174e3538e7d$var$createNestedArray(0, shape, a, isComplex);
}
function $9e4a6174e3538e7d$export$568d15cfc23dac5d(data, dtype) {
    // If is type Uint8Array[], return it directly.
    if (Array.isArray(data)) return data;
    if (dtype === 'float32') return data instanceof Float32Array ? data : new Float32Array(data);
    else if (dtype === 'int32') return data instanceof Int32Array ? data : new Int32Array(data);
    else if (dtype === 'bool' || dtype === 'string') return Uint8Array.from(new Int32Array(data));
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $9e4a6174e3538e7d$export$b915f681a907ae99(size, dtype) {
    const array = $9e4a6174e3538e7d$export$edbc8aedac4e036f(size, dtype);
    for(let i = 0; i < array.length; i++)array[i] = 1;
    return array;
}
function $9e4a6174e3538e7d$export$edbc8aedac4e036f(size, dtype) {
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(size);
    else if (dtype === 'int32') return new Int32Array(size);
    else if (dtype === 'bool') return new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
}
function $9e4a6174e3538e7d$export$eef638260c005c74(shape, dtype) {
    const size = shape.reduce((prev, curr)=>prev * curr, 1);
    if (dtype == null || dtype === 'float32') return $9e4a6174e3538e7d$export$3983c25181aa68cc(shape, new Float32Array(size));
    else if (dtype === 'int32') return $9e4a6174e3538e7d$export$3983c25181aa68cc(shape, new Int32Array(size));
    else if (dtype === 'bool') return $9e4a6174e3538e7d$export$3983c25181aa68cc(shape, new Uint8Array(size));
    else throw new Error(`Unknown data type ${dtype}`);
}
function $9e4a6174e3538e7d$export$3d8b7619bac22cf5(shape) {
    shape.forEach((dimSize)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(Number.isInteger(dimSize) && dimSize >= 0, ()=>`Tensor must have a shape comprised of positive integers but got ` + `shape [${shape}].`);
    });
}
function $9e4a6174e3538e7d$export$a14b009c502dc3b4(locs, rank, strides) {
    if (rank === 0) return 0;
    else if (rank === 1) return locs[0];
    let index = locs[locs.length - 1];
    for(let i = 0; i < locs.length - 1; ++i)index += strides[i] * locs[i];
    return index;
}
function $9e4a6174e3538e7d$export$2d1ada4c755a8699(index, rank, strides) {
    if (rank === 0) return [];
    else if (rank === 1) return [
        index
    ];
    const locs = new Array(rank);
    for(let i = 0; i < locs.length - 1; ++i){
        locs[i] = Math.floor(index / strides[i]);
        index -= locs[i] * strides[i];
    }
    locs[locs.length - 1] = index;
    return locs;
}
function $9e4a6174e3538e7d$export$4369c812aac99591(object) {
    //  We chose to not use 'obj instanceOf Promise' for two reasons:
    //  1. It only reliably works for es6 Promise, not other Promise
    //  implementations.
    //  2. It doesn't work with framework that uses zone.js. zone.js monkey
    //  patch the async calls, so it is possible the obj (patched) is
    //  comparing to a pre-patched Promise.
    return object && object.then && typeof object.then === 'function';
}


// Expects flags from URL in the format ?tfjsflags=FLAG1:1,FLAG2:true.
const $339e95daf833709b$var$TENSORFLOWJS_FLAGS_PREFIX = 'tfjsflags';
class $339e95daf833709b$export$7dc6752a22ab011a {
    // tslint:disable-next-line: no-any
    constructor(global){
        this.global = global;
        this.flags = {};
        this.flagRegistry = {};
        this.urlFlags = {};
        // Jasmine spies on this in 'environment_test.ts'
        this.getQueryParams = $339e95daf833709b$export$e2de15bbd9edf9c6;
        this.populateURLFlags();
    }
    setPlatform(platformName, platform) {
        if (this.platform != null) {
            if (!($339e95daf833709b$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $339e95daf833709b$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Platform ${this.platformName} has already been set. ` + `Overwriting the platform with ${platformName}.`);
        }
        this.platformName = platformName;
        this.platform = platform;
    }
    registerFlag(flagName, evaluationFn, setHook) {
        this.flagRegistry[flagName] = {
            evaluationFn: evaluationFn,
            setHook: setHook
        };
        // Override the flag value from the URL. This has to happen here because
        // the environment is initialized before flags get registered.
        if (this.urlFlags[flagName] != null) {
            const flagValue = this.urlFlags[flagName];
            if (!($339e95daf833709b$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $339e95daf833709b$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Setting feature override from URL ${flagName}: ${flagValue}.`);
            this.set(flagName, flagValue);
        }
    }
    async getAsync(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        this.flags[flagName] = await this.evaluateFlag(flagName);
        return this.flags[flagName];
    }
    get(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        const flagValue = this.evaluateFlag(flagName);
        if ((0, $9e4a6174e3538e7d$export$4369c812aac99591)(flagValue)) throw new Error(`Flag ${flagName} cannot be synchronously evaluated. ` + `Please use getAsync() instead.`);
        this.flags[flagName] = flagValue;
        return this.flags[flagName];
    }
    getNumber(flagName) {
        return this.get(flagName);
    }
    getBool(flagName) {
        return this.get(flagName);
    }
    getString(flagName) {
        return this.get(flagName);
    }
    getFlags() {
        return this.flags;
    }
    // For backwards compatibility.
    get features() {
        return this.flags;
    }
    set(flagName, value) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot set flag ${flagName} as it has not been registered.`);
        this.flags[flagName] = value;
        if (this.flagRegistry[flagName].setHook != null) this.flagRegistry[flagName].setHook(value);
    }
    evaluateFlag(flagName) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot evaluate flag '${flagName}': no evaluation function found.`);
        return this.flagRegistry[flagName].evaluationFn();
    }
    setFlags(flags) {
        this.flags = Object.assign({}, flags);
    }
    reset() {
        this.flags = {};
        this.urlFlags = {};
        this.populateURLFlags();
    }
    populateURLFlags() {
        if (typeof this.global === 'undefined' || typeof this.global.location === 'undefined' || typeof this.global.location.search === 'undefined') return;
        const urlParams = this.getQueryParams(this.global.location.search);
        if ($339e95daf833709b$var$TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
            const keyValues = urlParams[$339e95daf833709b$var$TENSORFLOWJS_FLAGS_PREFIX].split(',');
            keyValues.forEach((keyValue)=>{
                const [key, value] = keyValue.split(':');
                this.urlFlags[key] = $339e95daf833709b$var$parseValue(key, value);
            });
        }
    }
}
function $339e95daf833709b$export$e2de15bbd9edf9c6(queryString) {
    const params = {};
    queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (s, ...t)=>{
        $339e95daf833709b$var$decodeParam(params, t[0], t[1]);
        return t.join('=');
    });
    return params;
}
function $339e95daf833709b$var$decodeParam(params, name, value) {
    params[decodeURIComponent(name)] = decodeURIComponent(value || '');
}
function $339e95daf833709b$var$parseValue(flagName, value) {
    const lowerCaseValue = value.toLowerCase();
    if (lowerCaseValue === 'true' || lowerCaseValue === 'false') return lowerCaseValue === 'true';
    else if (`${+lowerCaseValue}` === lowerCaseValue) return +lowerCaseValue;
    else return value;
}
function $339e95daf833709b$export$a7b6bc01c63cdfc3() {
    return $339e95daf833709b$export$83401e34d5e11bf4;
}
let $339e95daf833709b$export$83401e34d5e11bf4 = null;
function $339e95daf833709b$export$3ef32a49eeda04cc(environment) {
    $339e95daf833709b$export$83401e34d5e11bf4 = environment;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Note that the identifier globalNameSpace is scoped to this module, but will
// always resolve to the same global object regardless of how the module is
// resolved.
// tslint:disable-next-line:no-any
var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


let $edf795347656fd15$var$globalNameSpace;
function $edf795347656fd15$export$5054b240ae6849b7() {
    if ($edf795347656fd15$var$globalNameSpace == null) {
        // tslint:disable-next-line:no-any
        let ns;
        if (typeof window !== 'undefined') ns = window;
        else if (typeof $parcel$global !== 'undefined') ns = $parcel$global;
        else if (typeof $371a3837fd81d701$exports !== 'undefined') ns = $371a3837fd81d701$exports;
        else if (typeof self !== 'undefined') ns = self;
        else throw new Error('Could not find a global object');
        $edf795347656fd15$var$globalNameSpace = ns;
    }
    return $edf795347656fd15$var$globalNameSpace;
}
// tslint:disable-next-line:no-any
function $edf795347656fd15$var$getGlobalMap() {
    const ns = $edf795347656fd15$export$5054b240ae6849b7();
    if (ns._tfGlobals == null) ns._tfGlobals = new Map();
    return ns._tfGlobals;
}
function $edf795347656fd15$export$a4e55266d2135a7f(key, init) {
    const globalMap = $edf795347656fd15$var$getGlobalMap();
    if (globalMap.has(key)) return globalMap.get(key);
    else {
        const singleton = init();
        globalMap.set(key, singleton);
        return globalMap.get(key);
    }
}


const $507890e4aa8e1463$export$b73c596ee8758a66 = 'Abs';
const $507890e4aa8e1463$export$3b952c9980dac550 = 'Acos';
const $507890e4aa8e1463$export$987da490b7c2e7dd = 'Acosh';
const $507890e4aa8e1463$export$d0265b2c425512d6 = 'Add';
const $507890e4aa8e1463$export$eef235ad06d3226a = 'AddN';
const $507890e4aa8e1463$export$5dceb1ab650a1776 = 'All';
const $507890e4aa8e1463$export$b24b633b1364b94b = 'Any';
const $507890e4aa8e1463$export$17612294a1503e1c = 'ArgMax';
const $507890e4aa8e1463$export$baabd09270cbbd94 = 'ArgMin';
const $507890e4aa8e1463$export$664c8ca7e7e5c126 = 'Asin';
const $507890e4aa8e1463$export$847c88940cb7dcb5 = 'Asinh';
const $507890e4aa8e1463$export$bac667d46ac043ae = 'Atan';
const $507890e4aa8e1463$export$98981a86fa2b1366 = 'Atanh';
const $507890e4aa8e1463$export$3bf4c619ce589f4b = 'Atan2';
const $507890e4aa8e1463$export$37f2cc7be1add88c = 'AvgPool';
const $507890e4aa8e1463$export$9873fd6046cd6951 = 'AvgPoolGrad';
const $507890e4aa8e1463$export$390ecb697af103f6 = 'AvgPool3D';
const $507890e4aa8e1463$export$7163112adf28c062 = 'AvgPool3DGrad';
const $507890e4aa8e1463$export$9a3bf60b23f63c8 = 'BatchMatMul';
const $507890e4aa8e1463$export$e2743f47f61cca1f = 'BatchToSpaceND';
const $507890e4aa8e1463$export$45dfbbff595c32aa = 'Bincount';
const $507890e4aa8e1463$export$a9e259e32a62221f = 'BitwiseAnd';
const $507890e4aa8e1463$export$ea5eeb875a7c4dd1 = 'BroadcastTo';
const $507890e4aa8e1463$export$32877b1d6d497805 = 'BroadcastArgs';
const $507890e4aa8e1463$export$107ecfb3d1ccbd77 = 'Cast';
const $507890e4aa8e1463$export$d4a1bccfd52ebd3 = 'Ceil';
const $507890e4aa8e1463$export$611c0e357ac37f7d = 'ClipByValue';
const $507890e4aa8e1463$export$50ceb3fb9926e63e = 'Complex';
const $507890e4aa8e1463$export$32902e58f1b48f4b = 'ComplexAbs';
const $507890e4aa8e1463$export$936bbfc007425eea = 'Concat';
const $507890e4aa8e1463$export$57742e605d475795 = 'Conv2D';
const $507890e4aa8e1463$export$32a8943c0f1ca5a7 = 'Conv2DBackpropFilter';
const $507890e4aa8e1463$export$e26961e8ed0eb404 = 'Conv2DBackpropInput';
const $507890e4aa8e1463$export$9d3874201dd21933 = 'Conv3D';
const $507890e4aa8e1463$export$dd2885efe6043eee = 'Conv3DBackpropFilterV2';
const $507890e4aa8e1463$export$a54f552d6d7d521f = 'Conv3DBackpropInputV2';
const $507890e4aa8e1463$export$ddfd0a983d257666 = 'Cos';
const $507890e4aa8e1463$export$5e311a1c57b0d27c = 'Cosh';
const $507890e4aa8e1463$export$e581acc6014c47a = 'Cumprod';
const $507890e4aa8e1463$export$706617d894ad63da = 'Cumsum';
const $507890e4aa8e1463$export$50bc9557793c2e04 = 'CropAndResize';
const $507890e4aa8e1463$export$5bab6834954299c5 = 'DenseBincount';
const $507890e4aa8e1463$export$fb0ee52d0cd6f233 = 'DepthToSpace';
const $507890e4aa8e1463$export$7c0fc590ff9e156f = 'DepthwiseConv2dNative';
const $507890e4aa8e1463$export$c99f139e0d4d1833 = 'DepthwiseConv2dNativeBackpropFilter';
const $507890e4aa8e1463$export$8649ca3b17033a24 = 'DepthwiseConv2dNativeBackpropInput';
const $507890e4aa8e1463$export$ca73a25315ddeb7f = 'Diag';
const $507890e4aa8e1463$export$dbbb7830c6497701 = 'Dilation2D';
const $507890e4aa8e1463$export$5dd675a6b0f37e17 = 'Dilation2DBackpropInput';
const $507890e4aa8e1463$export$91add972be69d592 = 'Dilation2DBackpropFilter';
const $507890e4aa8e1463$export$dca20402ebea5ece = 'Draw';
const $507890e4aa8e1463$export$b9880b86e1014bb8 = 'RealDiv';
const $507890e4aa8e1463$export$2541d8be32f3c641 = 'Einsum';
const $507890e4aa8e1463$export$64636e173424d83d = 'Elu';
const $507890e4aa8e1463$export$9906be4699a73c53 = 'EluGrad';
const $507890e4aa8e1463$export$c2ee2551ce71f1d0 = 'Erf';
const $507890e4aa8e1463$export$8dcf9f58ce5cdfc = 'Equal';
const $507890e4aa8e1463$export$f908be7a96fb3363 = 'Exp';
const $507890e4aa8e1463$export$2391750b1d901146 = 'ExpandDims';
const $507890e4aa8e1463$export$261f26143a1ff3 = 'Expm1';
const $507890e4aa8e1463$export$677347237c014ba = 'FFT';
const $507890e4aa8e1463$export$ffffe40bfa0649a3 = 'Fill';
const $507890e4aa8e1463$export$34e7296fc8558df5 = 'FlipLeftRight';
const $507890e4aa8e1463$export$4880b0ae5643c62b = 'Floor';
const $507890e4aa8e1463$export$d79b5692ede26c2f = 'FloorDiv';
const $507890e4aa8e1463$export$3821a0416660aaa2 = 'FusedBatchNorm';
const $507890e4aa8e1463$export$ccd988942e5c0181 = 'GatherV2';
const $507890e4aa8e1463$export$4ef6e37a23721703 = 'GatherNd';
const $507890e4aa8e1463$export$d0a25eac5ee3f515 = 'Greater';
const $507890e4aa8e1463$export$3b7d21bc9aee0851 = 'GreaterEqual';
const $507890e4aa8e1463$export$544bf02140fa9a77 = 'Identity';
const $507890e4aa8e1463$export$21c6f576ae8100e8 = 'IFFT';
const $507890e4aa8e1463$export$303b4473993a24f = 'Imag';
const $507890e4aa8e1463$export$b9fcc0946d7d485e = 'IsFinite';
const $507890e4aa8e1463$export$74b5a3bc735b152 = 'IsInf';
const $507890e4aa8e1463$export$9912dc4fc649dbec = 'IsNan';
const $507890e4aa8e1463$export$f0c7162bb7af1a2d = 'LeakyRelu';
const $507890e4aa8e1463$export$728c50f1c88ac779 = 'Less';
const $507890e4aa8e1463$export$84afd0d8f7fb8c5d = 'LessEqual';
const $507890e4aa8e1463$export$34f0ab8eba543ee6 = 'LinSpace';
const $507890e4aa8e1463$export$ce30dbb46644d06c = 'Log';
const $507890e4aa8e1463$export$70f05bf9ddcfca68 = 'Log1p';
const $507890e4aa8e1463$export$8a27ff10dff4d6e5 = 'LogicalAnd';
const $507890e4aa8e1463$export$4393bee5596c68c2 = 'LogicalNot';
const $507890e4aa8e1463$export$c49f9f5ffc6f678c = 'LogicalOr';
const $507890e4aa8e1463$export$656629b293485eff = 'LogicalXor';
const $507890e4aa8e1463$export$85b5bcbd60848a10 = 'LogSoftmax';
const $507890e4aa8e1463$export$9ec35fe80d53e931 = 'LowerBound';
const $507890e4aa8e1463$export$eb2f713fc3e1ca9a = 'LRN';
const $507890e4aa8e1463$export$73ba43cd0ce95b10 = 'LRNGrad';
const $507890e4aa8e1463$export$b4571177c51d555b = 'MatrixBandPart';
const $507890e4aa8e1463$export$d36c09e5d02927e7 = 'Max';
const $507890e4aa8e1463$export$d8d02ac92d161004 = 'Maximum';
const $507890e4aa8e1463$export$39ea33024ddd5cf = 'MaxPool';
const $507890e4aa8e1463$export$f0f010b1d1db8a46 = 'MaxPoolGrad';
const $507890e4aa8e1463$export$88fdc64af890fc53 = 'MaxPool3D';
const $507890e4aa8e1463$export$52be2c00371a1350 = 'MaxPool3DGrad';
const $507890e4aa8e1463$export$deac4b7497b4047f = 'MaxPoolWithArgmax';
const $507890e4aa8e1463$export$1c2d59c4b681fbd8 = 'Mean';
const $507890e4aa8e1463$export$dfed19fabc75a31d = 'Min';
const $507890e4aa8e1463$export$23cb308301e89d6b = 'Minimum';
const $507890e4aa8e1463$export$f4c0e95fd7fd31e5 = 'MirrorPad';
const $507890e4aa8e1463$export$e4835a5e3f3674d5 = 'Mod';
const $507890e4aa8e1463$export$ee0a8cfb693e0e3f = 'Multinomial';
const $507890e4aa8e1463$export$f14f83b3b531d498 = 'Multiply';
const $507890e4aa8e1463$export$c07c549000872073 = 'Neg';
const $507890e4aa8e1463$export$385ebe9945cae0c5 = 'NotEqual';
const $507890e4aa8e1463$export$5e11788439c2f04 = 'NonMaxSuppressionV3';
const $507890e4aa8e1463$export$7df908154366fe7f = 'NonMaxSuppressionV4';
const $507890e4aa8e1463$export$cb45d3fcefce2ef0 = 'NonMaxSuppressionV5';
const $507890e4aa8e1463$export$a2962e735c809d91 = 'OnesLike';
const $507890e4aa8e1463$export$18982b43ba8c02e9 = 'OneHot';
const $507890e4aa8e1463$export$c26f40b29201e5b7 = 'Pack';
const $507890e4aa8e1463$export$5d47ba206577f0f2 = 'PadV2';
const $507890e4aa8e1463$export$14963ee5c8637e11 = 'Pool';
const $507890e4aa8e1463$export$ce28d653ec559ee = 'Pow';
const $507890e4aa8e1463$export$a42f35f308fc2fa3 = 'Prelu';
const $507890e4aa8e1463$export$b8a16d526a791fb0 = 'Prod';
const $507890e4aa8e1463$export$ffee9c5b4fce08a1 = 'RaggedGather';
const $507890e4aa8e1463$export$9d0615a9a6d213d2 = 'RaggedRange';
const $507890e4aa8e1463$export$616d73a9ab7617c7 = 'RaggedTensorToTensor';
const $507890e4aa8e1463$export$9a58ef0d7ad3278c = 'Range';
const $507890e4aa8e1463$export$f41305719b94e675 = 'Real';
const $507890e4aa8e1463$export$c6e4a23ed5e0415b = 'Reciprocal';
const $507890e4aa8e1463$export$9a6ff968bf961432 = 'Relu';
const $507890e4aa8e1463$export$755ddd847e5abe03 = 'Reshape';
const $507890e4aa8e1463$export$6c8d8ec26192bb18 = 'ResizeNearestNeighbor';
const $507890e4aa8e1463$export$b84ac31c55aa023b = 'ResizeNearestNeighborGrad';
const $507890e4aa8e1463$export$24f2f15d869e0fd = 'ResizeBilinear';
const $507890e4aa8e1463$export$2d3cf759f1538c13 = 'ResizeBilinearGrad';
const $507890e4aa8e1463$export$3be9e924f629054e = 'Relu6';
const $507890e4aa8e1463$export$53c81f36b32e1bba = 'Reverse';
const $507890e4aa8e1463$export$c5ed3eef16c0612f = 'Round';
const $507890e4aa8e1463$export$7cc53aa09f5f3a2d = 'Rsqrt';
const $507890e4aa8e1463$export$28eef6f0168af686 = 'ScatterNd';
const $507890e4aa8e1463$export$20050a140fd1de77 = 'TensorScatterUpdate';
const $507890e4aa8e1463$export$9a1405490b09867e = 'SearchSorted';
const $507890e4aa8e1463$export$ef9b1a59e592288f = 'Select';
const $507890e4aa8e1463$export$6760d858e6f2594a = 'Selu';
const $507890e4aa8e1463$export$b3f2e2de3a8baa1e = 'Slice';
const $507890e4aa8e1463$export$75be1b631f7687 = 'Sin';
const $507890e4aa8e1463$export$b8c187376329d79b = 'Sinh';
const $507890e4aa8e1463$export$1db683ad541682f6 = 'Sign';
const $507890e4aa8e1463$export$fde18c826dda6b1b = 'Sigmoid';
const $507890e4aa8e1463$export$c5af433747f1fd0a = 'Softplus';
const $507890e4aa8e1463$export$21ab404ab9d512a6 = 'Sqrt';
const $507890e4aa8e1463$export$534760f50726d5 = 'Sum';
const $507890e4aa8e1463$export$f63ac5409312707c = 'SpaceToBatchND';
const $507890e4aa8e1463$export$8dffabb4071f05aa = 'SplitV';
const $507890e4aa8e1463$export$350a526055d3ca6e = 'Softmax';
const $507890e4aa8e1463$export$8f1933853a5c8cca = 'SparseFillEmptyRows';
const $507890e4aa8e1463$export$f08f0dca44fa542 = 'SparseReshape';
const $507890e4aa8e1463$export$610b077aecc2447b = 'SparseSegmentMean';
const $507890e4aa8e1463$export$68351c28d7116b56 = 'SparseSegmentSum';
const $507890e4aa8e1463$export$2c426709a9332421 = 'SparseToDense';
const $507890e4aa8e1463$export$2f922d20d66089c6 = 'SquaredDifference';
const $507890e4aa8e1463$export$b09fb900337259de = 'Square';
const $507890e4aa8e1463$export$2fbaa77553edaeff = 'StaticRegexReplace';
const $507890e4aa8e1463$export$60c7f9ac271417a9 = 'StridedSlice';
const $507890e4aa8e1463$export$11a7f4af7d96ad41 = 'StringNGrams';
const $507890e4aa8e1463$export$7e266f7223b9d396 = 'StringSplit';
const $507890e4aa8e1463$export$a5639899909bc8ae = 'StringToHashBucketFast';
const $507890e4aa8e1463$export$d7a01e11500dfb6f = 'Sub';
const $507890e4aa8e1463$export$115b2d5263ba5985 = 'Tan';
const $507890e4aa8e1463$export$893b6e865e352c83 = 'Tanh';
const $507890e4aa8e1463$export$235cb65c20ad2b7 = 'Tile';
const $507890e4aa8e1463$export$c593cd1ea0d02ebd = 'TopK';
const $507890e4aa8e1463$export$563a914cafbdc389 = 'Transform';
const $507890e4aa8e1463$export$7e714455f9a1f8f7 = 'Transpose';
const $507890e4aa8e1463$export$8e3adf126971a183 = 'Unique';
const $507890e4aa8e1463$export$441ad6bfc5db8ab4 = 'Unpack';
const $507890e4aa8e1463$export$af810663cded5fe2 = 'UnsortedSegmentSum';
const $507890e4aa8e1463$export$7dc194c8da2f9058 = 'UpperBound';
const $507890e4aa8e1463$export$430969a37eda1e88 = 'ZerosLike';
const $507890e4aa8e1463$export$fd55ce593607084a = 'Step';
const $507890e4aa8e1463$export$d0eb4e7054966c48 = 'FromPixels';
const $507890e4aa8e1463$export$c5a44649815d1c3 = 'RotateWithOffset';
const $507890e4aa8e1463$export$8d1af0f7c2a4da9e = '_FusedMatMul';
const $507890e4aa8e1463$export$86f8a8e3a8f2a8f2 = 'FusedConv2D';
const $507890e4aa8e1463$export$5a249e8f498c02c1 = 'FusedDepthwiseConv2D';


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

var $720e4308e1a7c928$exports = {};

$parcel$export($720e4308e1a7c928$exports, "warn", () => $720e4308e1a7c928$export$c106dd0671a0fc2d);
$parcel$export($720e4308e1a7c928$exports, "log", () => $720e4308e1a7c928$export$bef1f36f5486a6a3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $720e4308e1a7c928$export$c106dd0671a0fc2d(...msg) {
    if (!((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_TEST') || (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('PROD'))) console.warn(...msg);
}
function $720e4308e1a7c928$export$bef1f36f5486a6a3(...msg) {
    if (!((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_TEST') || (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('PROD'))) console.log(...msg);
}


const $071cf1fd9dc2117e$var$kernelRegistry = (0, $edf795347656fd15$export$a4e55266d2135a7f)('kernelRegistry', ()=>new Map());
const $071cf1fd9dc2117e$var$gradRegistry = (0, $edf795347656fd15$export$a4e55266d2135a7f)('gradRegistry', ()=>new Map());
function $071cf1fd9dc2117e$export$1b85808c967cc434(kernelName, backendName) {
    const key = $071cf1fd9dc2117e$var$makeKey(kernelName, backendName);
    return $071cf1fd9dc2117e$var$kernelRegistry.get(key);
}
function $071cf1fd9dc2117e$export$e14995d3ec1747ee(kernelName) {
    return $071cf1fd9dc2117e$var$gradRegistry.get(kernelName);
}
function $071cf1fd9dc2117e$export$e4b8d76e176eaecc(backendName) {
    const it = $071cf1fd9dc2117e$var$kernelRegistry.entries();
    const result = [];
    while(true){
        const { done: done, value: value } = it.next();
        if (done) break;
        const [key, config] = value;
        const [backend] = key.split('_');
        if (backend === backendName) result.push(config);
    }
    return result;
}
function $071cf1fd9dc2117e$export$f3f7c443f3a606e6(config) {
    const { kernelName: kernelName, backendName: backendName } = config;
    const key = $071cf1fd9dc2117e$var$makeKey(kernelName, backendName);
    if ($071cf1fd9dc2117e$var$kernelRegistry.has(key)) $720e4308e1a7c928$export$c106dd0671a0fc2d(`The kernel '${kernelName}' for backend ` + `'${backendName}' is already registered`);
    $071cf1fd9dc2117e$var$kernelRegistry.set(key, config);
}
function $071cf1fd9dc2117e$export$de9396b872fdfcc3(config) {
    const { kernelName: kernelName } = config;
    if ($071cf1fd9dc2117e$var$gradRegistry.has(kernelName)) // TODO (yassogba) after 3.0 assess whether we need to keep this gated
    // to debug mode.
    {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) $720e4308e1a7c928$export$c106dd0671a0fc2d(`Overriding the gradient for '${kernelName}'`);
    }
    $071cf1fd9dc2117e$var$gradRegistry.set(kernelName, config);
}
function $071cf1fd9dc2117e$export$1c3fb41896379a12(kernelName, backendName) {
    const key = $071cf1fd9dc2117e$var$makeKey(kernelName, backendName);
    if (!$071cf1fd9dc2117e$var$kernelRegistry.has(key)) throw new Error(`The kernel '${kernelName}' for backend ` + `'${backendName}' is not registered`);
    $071cf1fd9dc2117e$var$kernelRegistry.delete(key);
}
function $071cf1fd9dc2117e$export$41b3e24402efeb81(kernelName) {
    if (!$071cf1fd9dc2117e$var$gradRegistry.has(kernelName)) throw new Error(`The gradient '${kernelName}' for backend is not registered`);
    $071cf1fd9dc2117e$var$gradRegistry.delete(kernelName);
}
function $071cf1fd9dc2117e$export$fb249e95c44186e6(registeredBackendName, newBackendName) {
    const kernels = $071cf1fd9dc2117e$export$e4b8d76e176eaecc(registeredBackendName);
    kernels.forEach((kernelConfig)=>{
        const newKernelConfig = Object.assign({}, kernelConfig, {
            backendName: newBackendName
        });
        $071cf1fd9dc2117e$export$f3f7c443f3a606e6(newKernelConfig);
    });
}
function $071cf1fd9dc2117e$var$makeKey(kernelName, backendName) {
    return `${backendName}_${kernelName}`;
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $0775da5e684c8c0d$exports = {};

$parcel$export($0775da5e684c8c0d$exports, "createScalarValue", () => $0775da5e684c8c0d$export$cd3f28d8002ec2a2);
$parcel$export($0775da5e684c8c0d$exports, "encodeString", () => $0775da5e684c8c0d$export$8146d2e653b87d6a);
$parcel$export($0775da5e684c8c0d$exports, "toTypedArray", () => $0775da5e684c8c0d$export$965adc581230795c);
$parcel$export($0775da5e684c8c0d$exports, "flatten", () => $0775da5e684c8c0d$export$bffa455ba8c619a6);
$parcel$export($0775da5e684c8c0d$exports, "now", () => $0775da5e684c8c0d$export$461939dd4422153);
$parcel$export($0775da5e684c8c0d$exports, "fetch", () => $0775da5e684c8c0d$export$e7aa7bc5c1b3cfb3);
$parcel$export($0775da5e684c8c0d$exports, "decodeString", () => $0775da5e684c8c0d$export$a0fb664af7d0cc44);
$parcel$export($0775da5e684c8c0d$exports, "isTypedArray", () => $0775da5e684c8c0d$export$b119cc7e1840e59c);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $60e26135cef47b6f$export$632e6430b2d784cd(a) {
    return a instanceof Float32Array || a instanceof Int32Array || a instanceof Uint8Array || a instanceof Uint8ClampedArray;
}



var $1807475b7392bfc6$exports = {};

$parcel$export($1807475b7392bfc6$exports, "hexToLong", () => $1807475b7392bfc6$export$20e49d17901a85a5);
$parcel$export($1807475b7392bfc6$exports, "fingerPrint64", () => $1807475b7392bfc6$export$919ee948dc019032);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for allowing cjs module to be included in bundle created by
// rollup.
var $035a06a8b28ed0fd$exports = {};
$035a06a8b28ed0fd$exports = $035a06a8b28ed0fd$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $035a06a8b28ed0fd$var$wasm = null;
try {
    $035a06a8b28ed0fd$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $035a06a8b28ed0fd$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $035a06a8b28ed0fd$var$Long.prototype.__isLong__;
Object.defineProperty($035a06a8b28ed0fd$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $035a06a8b28ed0fd$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$Long.isLong = $035a06a8b28ed0fd$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $035a06a8b28ed0fd$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $035a06a8b28ed0fd$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $035a06a8b28ed0fd$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $035a06a8b28ed0fd$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $035a06a8b28ed0fd$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $035a06a8b28ed0fd$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $035a06a8b28ed0fd$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $035a06a8b28ed0fd$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromInt = $035a06a8b28ed0fd$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $035a06a8b28ed0fd$var$UZERO : $035a06a8b28ed0fd$var$ZERO;
    if (unsigned) {
        if (value < 0) return $035a06a8b28ed0fd$var$UZERO;
        if (value >= $035a06a8b28ed0fd$var$TWO_PWR_64_DBL) return $035a06a8b28ed0fd$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$035a06a8b28ed0fd$var$TWO_PWR_63_DBL) return $035a06a8b28ed0fd$var$MIN_VALUE;
        if (value + 1 >= $035a06a8b28ed0fd$var$TWO_PWR_63_DBL) return $035a06a8b28ed0fd$var$MAX_VALUE;
    }
    if (value < 0) return $035a06a8b28ed0fd$var$fromNumber(-value, unsigned).neg();
    return $035a06a8b28ed0fd$var$fromBits(value % $035a06a8b28ed0fd$var$TWO_PWR_32_DBL | 0, value / $035a06a8b28ed0fd$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromNumber = $035a06a8b28ed0fd$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromBits(lowBits, highBits, unsigned) {
    return new $035a06a8b28ed0fd$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBits = $035a06a8b28ed0fd$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $035a06a8b28ed0fd$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $035a06a8b28ed0fd$var$ZERO;
    if (typeof unsigned === 'number') // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
    else if (p === 0) return $035a06a8b28ed0fd$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $035a06a8b28ed0fd$var$fromNumber($035a06a8b28ed0fd$var$pow_dbl(radix, 8));
    var result = $035a06a8b28ed0fd$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $035a06a8b28ed0fd$var$fromNumber($035a06a8b28ed0fd$var$pow_dbl(radix, size));
            result = result.mul(power).add($035a06a8b28ed0fd$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($035a06a8b28ed0fd$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromString = $035a06a8b28ed0fd$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromValue(val, unsigned) {
    if (typeof val === 'number') return $035a06a8b28ed0fd$var$fromNumber(val, unsigned);
    if (typeof val === 'string') return $035a06a8b28ed0fd$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $035a06a8b28ed0fd$var$fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$Long.fromValue = $035a06a8b28ed0fd$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_32_DBL = $035a06a8b28ed0fd$var$TWO_PWR_16_DBL * $035a06a8b28ed0fd$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_64_DBL = $035a06a8b28ed0fd$var$TWO_PWR_32_DBL * $035a06a8b28ed0fd$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_63_DBL = $035a06a8b28ed0fd$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_24 = $035a06a8b28ed0fd$var$fromInt($035a06a8b28ed0fd$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$ZERO = $035a06a8b28ed0fd$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.ZERO = $035a06a8b28ed0fd$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$UZERO = $035a06a8b28ed0fd$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.UZERO = $035a06a8b28ed0fd$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$ONE = $035a06a8b28ed0fd$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.ONE = $035a06a8b28ed0fd$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$UONE = $035a06a8b28ed0fd$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.UONE = $035a06a8b28ed0fd$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$NEG_ONE = $035a06a8b28ed0fd$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.NEG_ONE = $035a06a8b28ed0fd$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$MAX_VALUE = $035a06a8b28ed0fd$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.MAX_VALUE = $035a06a8b28ed0fd$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$MAX_UNSIGNED_VALUE = $035a06a8b28ed0fd$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.MAX_UNSIGNED_VALUE = $035a06a8b28ed0fd$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$MIN_VALUE = $035a06a8b28ed0fd$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.MIN_VALUE = $035a06a8b28ed0fd$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $035a06a8b28ed0fd$var$LongPrototype = $035a06a8b28ed0fd$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $035a06a8b28ed0fd$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $035a06a8b28ed0fd$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $035a06a8b28ed0fd$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $035a06a8b28ed0fd$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $035a06a8b28ed0fd$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';
    if (this.isNegative()) {
        if (this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $035a06a8b28ed0fd$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return '-' + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $035a06a8b28ed0fd$var$fromNumber($035a06a8b28ed0fd$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = '';
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $035a06a8b28ed0fd$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($035a06a8b28ed0fd$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.eqz = $035a06a8b28ed0fd$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.equals = function equals(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.eq = $035a06a8b28ed0fd$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.neq = $035a06a8b28ed0fd$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.ne = $035a06a8b28ed0fd$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lt = $035a06a8b28ed0fd$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lte = $035a06a8b28ed0fd$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.le = $035a06a8b28ed0fd$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.gt = $035a06a8b28ed0fd$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.gte = $035a06a8b28ed0fd$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.ge = $035a06a8b28ed0fd$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $035a06a8b28ed0fd$var$LongPrototype.compare = function compare(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $035a06a8b28ed0fd$var$LongPrototype.comp = $035a06a8b28ed0fd$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $035a06a8b28ed0fd$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return $035a06a8b28ed0fd$var$MIN_VALUE;
    return this.not().add($035a06a8b28ed0fd$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $035a06a8b28ed0fd$var$LongPrototype.neg = $035a06a8b28ed0fd$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $035a06a8b28ed0fd$var$LongPrototype.add = function add(addend) {
    if (!$035a06a8b28ed0fd$var$isLong(addend)) addend = $035a06a8b28ed0fd$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $035a06a8b28ed0fd$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $035a06a8b28ed0fd$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$035a06a8b28ed0fd$var$isLong(subtrahend)) subtrahend = $035a06a8b28ed0fd$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $035a06a8b28ed0fd$var$LongPrototype.sub = $035a06a8b28ed0fd$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $035a06a8b28ed0fd$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $035a06a8b28ed0fd$var$ZERO;
    if (!$035a06a8b28ed0fd$var$isLong(multiplier)) multiplier = $035a06a8b28ed0fd$var$fromValue(multiplier);
    // use wasm support if present
    if ($035a06a8b28ed0fd$var$wasm) {
        var low = $035a06a8b28ed0fd$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $035a06a8b28ed0fd$var$fromBits(low, $035a06a8b28ed0fd$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $035a06a8b28ed0fd$var$ZERO;
    if (this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return multiplier.isOdd() ? $035a06a8b28ed0fd$var$MIN_VALUE : $035a06a8b28ed0fd$var$ZERO;
    if (multiplier.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return this.isOdd() ? $035a06a8b28ed0fd$var$MIN_VALUE : $035a06a8b28ed0fd$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($035a06a8b28ed0fd$var$TWO_PWR_24) && multiplier.lt($035a06a8b28ed0fd$var$TWO_PWR_24)) return $035a06a8b28ed0fd$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $035a06a8b28ed0fd$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $035a06a8b28ed0fd$var$LongPrototype.mul = $035a06a8b28ed0fd$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $035a06a8b28ed0fd$var$LongPrototype.divide = function divide(divisor) {
    if (!$035a06a8b28ed0fd$var$isLong(divisor)) divisor = $035a06a8b28ed0fd$var$fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero');
    // use wasm support if present
    if ($035a06a8b28ed0fd$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $035a06a8b28ed0fd$var$wasm.div_u : $035a06a8b28ed0fd$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $035a06a8b28ed0fd$var$fromBits(low, $035a06a8b28ed0fd$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $035a06a8b28ed0fd$var$UZERO : $035a06a8b28ed0fd$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) {
            if (divisor.eq($035a06a8b28ed0fd$var$ONE) || divisor.eq($035a06a8b28ed0fd$var$NEG_ONE)) return $035a06a8b28ed0fd$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return $035a06a8b28ed0fd$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($035a06a8b28ed0fd$var$ZERO)) return divisor.isNegative() ? $035a06a8b28ed0fd$var$ONE : $035a06a8b28ed0fd$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return this.unsigned ? $035a06a8b28ed0fd$var$UZERO : $035a06a8b28ed0fd$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $035a06a8b28ed0fd$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $035a06a8b28ed0fd$var$UZERO;
        if (divisor.gt(this.shru(1))) return $035a06a8b28ed0fd$var$UONE;
        res = $035a06a8b28ed0fd$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $035a06a8b28ed0fd$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $035a06a8b28ed0fd$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $035a06a8b28ed0fd$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $035a06a8b28ed0fd$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $035a06a8b28ed0fd$var$LongPrototype.div = $035a06a8b28ed0fd$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $035a06a8b28ed0fd$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$035a06a8b28ed0fd$var$isLong(divisor)) divisor = $035a06a8b28ed0fd$var$fromValue(divisor);
    // use wasm support if present
    if ($035a06a8b28ed0fd$var$wasm) {
        var low = (this.unsigned ? $035a06a8b28ed0fd$var$wasm.rem_u : $035a06a8b28ed0fd$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $035a06a8b28ed0fd$var$fromBits(low, $035a06a8b28ed0fd$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $035a06a8b28ed0fd$var$LongPrototype.mod = $035a06a8b28ed0fd$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $035a06a8b28ed0fd$var$LongPrototype.rem = $035a06a8b28ed0fd$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.not = function not() {
    return $035a06a8b28ed0fd$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.and = function and(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    return $035a06a8b28ed0fd$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.or = function or(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    return $035a06a8b28ed0fd$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.xor = function xor(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    return $035a06a8b28ed0fd$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($035a06a8b28ed0fd$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $035a06a8b28ed0fd$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $035a06a8b28ed0fd$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shl = $035a06a8b28ed0fd$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($035a06a8b28ed0fd$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $035a06a8b28ed0fd$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $035a06a8b28ed0fd$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shr = $035a06a8b28ed0fd$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($035a06a8b28ed0fd$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $035a06a8b28ed0fd$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $035a06a8b28ed0fd$var$fromBits(high, 0, this.unsigned);
        else return $035a06a8b28ed0fd$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shru = $035a06a8b28ed0fd$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shr_u = $035a06a8b28ed0fd$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $035a06a8b28ed0fd$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $035a06a8b28ed0fd$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $035a06a8b28ed0fd$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $035a06a8b28ed0fd$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $035a06a8b28ed0fd$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $035a06a8b28ed0fd$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $035a06a8b28ed0fd$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $035a06a8b28ed0fd$var$Long.fromBytesLE(bytes, unsigned) : $035a06a8b28ed0fd$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $035a06a8b28ed0fd$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $035a06a8b28ed0fd$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};


// tslint:disable-next-line
const $1807475b7392bfc6$var$Long = // tslint:disable-next-line
$035a06a8b28ed0fd$exports.default || $035a06a8b28ed0fd$exports;
function $1807475b7392bfc6$export$20e49d17901a85a5(hex) {
    return $1807475b7392bfc6$var$Long.fromString(hex, true, 16);
}
// Some primes between 2^63 and 2^64 for various uses.
// Hex 0xc3a5c85c97cb3127
const $1807475b7392bfc6$var$k0 = $1807475b7392bfc6$export$20e49d17901a85a5('c3a5c85c97cb3127');
// Hex 0xb492b66fbe98f273
const $1807475b7392bfc6$var$k1 = $1807475b7392bfc6$export$20e49d17901a85a5('b492b66fbe98f273');
// Hex 0x9ae16a3b2f90404f
const $1807475b7392bfc6$var$k2 = $1807475b7392bfc6$export$20e49d17901a85a5('9ae16a3b2f90404f');
function $1807475b7392bfc6$var$shiftMix(val) {
    return val.xor(val.shru(47));
}
function $1807475b7392bfc6$var$fetch(s, offset, numBytes) {
    const bytes = s.slice(offset, offset + numBytes);
    return $1807475b7392bfc6$var$Long.fromBytes(Array.from(bytes), true, true);
}
function $1807475b7392bfc6$var$fetch64(s, offset) {
    return $1807475b7392bfc6$var$fetch(s, offset, 8);
}
function $1807475b7392bfc6$var$fetch32(s, offset) {
    return $1807475b7392bfc6$var$fetch(s, offset, 4);
}
function $1807475b7392bfc6$var$rotate64(val, shift) {
    // Avoid shifting by 64: doing so yields an undefined result.
    return shift === 0 ? val : val.shru(shift).or(val.shl(64 - shift));
}
function $1807475b7392bfc6$var$hashLen16(u, v, mul = $1807475b7392bfc6$export$20e49d17901a85a5('9ddfea08eb382d69')) {
    // Murmur-inspired hashing.
    let a = u.xor(v).mul(mul);
    a = a.xor(a.shru(47));
    let b = v.xor(a).mul(mul);
    b = b.xor(b.shru(47));
    b = b.mul(mul);
    return b;
}
// Return a 16-byte hash for 48 bytes.  Quick and dirty.
// Callers do best to use "random-looking" values for a and b.
function $1807475b7392bfc6$var$weakHashLen32WithSeeds(w, x, y, z, a, b) {
    a = a.add(w);
    b = $1807475b7392bfc6$var$rotate64(b.add(a).add(z), 21);
    const c = a;
    a = a.add(x);
    a = a.add(y);
    b = b.add($1807475b7392bfc6$var$rotate64(a, 44));
    return [
        a.add(z),
        b.add(c)
    ];
}
function $1807475b7392bfc6$var$weakHashLen32WithSeedsStr(s, offset, a, b) {
    return $1807475b7392bfc6$var$weakHashLen32WithSeeds($1807475b7392bfc6$var$fetch64(s, offset), $1807475b7392bfc6$var$fetch64(s, offset + 8), $1807475b7392bfc6$var$fetch64(s, offset + 16), $1807475b7392bfc6$var$fetch64(s, offset + 24), a, b);
}
function $1807475b7392bfc6$var$hashLen0to16(s, len = s.length) {
    if (len >= 8) {
        const mul = $1807475b7392bfc6$var$k2.add(len * 2);
        const a = $1807475b7392bfc6$var$fetch64(s, 0).add($1807475b7392bfc6$var$k2);
        const b = $1807475b7392bfc6$var$fetch64(s, len - 8);
        const c = $1807475b7392bfc6$var$rotate64(b, 37).mul(mul).add(a);
        const d = $1807475b7392bfc6$var$rotate64(a, 25).add(b).mul(mul);
        return $1807475b7392bfc6$var$hashLen16(c, d, mul);
    }
    if (len >= 4) {
        const mul = $1807475b7392bfc6$var$k2.add(len * 2);
        const a = $1807475b7392bfc6$var$fetch32(s, 0);
        return $1807475b7392bfc6$var$hashLen16(a.shl(3).add(len), $1807475b7392bfc6$var$fetch32(s, len - 4), mul);
    }
    if (len > 0) {
        const a = s[0];
        const b = s[len >> 1];
        const c = s[len - 1];
        const y = a + (b << 8);
        const z = len + (c << 2);
        return $1807475b7392bfc6$var$shiftMix($1807475b7392bfc6$var$k2.mul(y).xor($1807475b7392bfc6$var$k0.mul(z))).mul($1807475b7392bfc6$var$k2);
    }
    return $1807475b7392bfc6$var$k2;
}
function $1807475b7392bfc6$var$hashLen17to32(s, len = s.length) {
    const mul = $1807475b7392bfc6$var$k2.add(len * 2);
    const a = $1807475b7392bfc6$var$fetch64(s, 0).mul($1807475b7392bfc6$var$k1);
    const b = $1807475b7392bfc6$var$fetch64(s, 8);
    const c = $1807475b7392bfc6$var$fetch64(s, len - 8).mul(mul);
    const d = $1807475b7392bfc6$var$fetch64(s, len - 16).mul($1807475b7392bfc6$var$k2);
    return $1807475b7392bfc6$var$hashLen16($1807475b7392bfc6$var$rotate64(a.add(b), 43).add($1807475b7392bfc6$var$rotate64(c, 30)).add(d), a.add($1807475b7392bfc6$var$rotate64(b.add($1807475b7392bfc6$var$k2), 18)).add(c), mul);
}
function $1807475b7392bfc6$var$hashLen33to64(s, len = s.length) {
    const mul = $1807475b7392bfc6$var$k2.add(len * 2);
    const a = $1807475b7392bfc6$var$fetch64(s, 0).mul($1807475b7392bfc6$var$k2);
    const b = $1807475b7392bfc6$var$fetch64(s, 8);
    const c = $1807475b7392bfc6$var$fetch64(s, len - 8).mul(mul);
    const d = $1807475b7392bfc6$var$fetch64(s, len - 16).mul($1807475b7392bfc6$var$k2);
    const y = $1807475b7392bfc6$var$rotate64(a.add(b), 43).add($1807475b7392bfc6$var$rotate64(c, 30)).add(d);
    const z = $1807475b7392bfc6$var$hashLen16(y, a.add($1807475b7392bfc6$var$rotate64(b.add($1807475b7392bfc6$var$k2), 18)).add(c), mul);
    const e = $1807475b7392bfc6$var$fetch64(s, 16).mul(mul);
    const f = $1807475b7392bfc6$var$fetch64(s, 24);
    const g = y.add($1807475b7392bfc6$var$fetch64(s, len - 32)).mul(mul);
    const h = z.add($1807475b7392bfc6$var$fetch64(s, len - 24)).mul(mul);
    return $1807475b7392bfc6$var$hashLen16($1807475b7392bfc6$var$rotate64(e.add(f), 43).add($1807475b7392bfc6$var$rotate64(g, 30)).add(h), e.add($1807475b7392bfc6$var$rotate64(f.add(a), 18)).add(g), mul);
}
function $1807475b7392bfc6$export$919ee948dc019032(s, len = s.length) {
    const seed = $1807475b7392bfc6$var$Long.fromNumber(81, true);
    if (len <= 32) {
        if (len <= 16) return $1807475b7392bfc6$var$hashLen0to16(s, len);
        else return $1807475b7392bfc6$var$hashLen17to32(s, len);
    } else if (len <= 64) return $1807475b7392bfc6$var$hashLen33to64(s, len);
    // For strings over 64 bytes we loop.  Internal state consists of
    // 56 bytes: v, w, x, y, and z.
    let x = seed;
    let y = seed.mul($1807475b7392bfc6$var$k1).add(113);
    let z = $1807475b7392bfc6$var$shiftMix(y.mul($1807475b7392bfc6$var$k2).add(113)).mul($1807475b7392bfc6$var$k2);
    let v = [
        $1807475b7392bfc6$var$Long.UZERO,
        $1807475b7392bfc6$var$Long.UZERO
    ];
    let w = [
        $1807475b7392bfc6$var$Long.UZERO,
        $1807475b7392bfc6$var$Long.UZERO
    ];
    x = x.mul($1807475b7392bfc6$var$k2).add($1807475b7392bfc6$var$fetch64(s, 0));
    let offset = 0;
    // Set end so that after the loop we have 1 to 64 bytes left to process.
    const end = (len - 1 >> 6) * 64;
    const last64 = end + (len - 1 & 63) - 63;
    do {
        x = $1807475b7392bfc6$var$rotate64(x.add(y).add(v[0]).add($1807475b7392bfc6$var$fetch64(s, offset + 8)), 37).mul($1807475b7392bfc6$var$k1);
        y = $1807475b7392bfc6$var$rotate64(y.add(v[1]).add($1807475b7392bfc6$var$fetch64(s, offset + 48)), 42).mul($1807475b7392bfc6$var$k1);
        x = x.xor(w[1]);
        y = y.add(v[0]).add($1807475b7392bfc6$var$fetch64(s, offset + 40));
        z = $1807475b7392bfc6$var$rotate64(z.add(w[0]), 33).mul($1807475b7392bfc6$var$k1);
        v = $1807475b7392bfc6$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul($1807475b7392bfc6$var$k1), x.add(w[0]));
        w = $1807475b7392bfc6$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($1807475b7392bfc6$var$fetch64(s, offset + 16)));
        [z, x] = [
            x,
            z
        ];
        offset += 64;
    }while (offset !== end);
    const mul = $1807475b7392bfc6$var$k1.add(z.and(0xff).shl(1));
    // Point to the last 64 bytes of input.
    offset = last64;
    w[0] = w[0].add(len - 1 & 63);
    v[0] = v[0].add(w[0]);
    w[0] = w[0].add(v[0]);
    x = $1807475b7392bfc6$var$rotate64(x.add(y).add(v[0]).add($1807475b7392bfc6$var$fetch64(s, offset + 8)), 37).mul(mul);
    y = $1807475b7392bfc6$var$rotate64(y.add(v[1]).add($1807475b7392bfc6$var$fetch64(s, offset + 48)), 42).mul(mul);
    x = x.xor(w[1].mul(9));
    y = y.add(v[0].mul(9).add($1807475b7392bfc6$var$fetch64(s, offset + 40)));
    z = $1807475b7392bfc6$var$rotate64(z.add(w[0]), 33).mul(mul);
    v = $1807475b7392bfc6$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul(mul), x.add(w[0]));
    w = $1807475b7392bfc6$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($1807475b7392bfc6$var$fetch64(s, offset + 16)));
    [z, x] = [
        x,
        z
    ];
    return $1807475b7392bfc6$var$hashLen16($1807475b7392bfc6$var$hashLen16(v[0], w[0], mul).add($1807475b7392bfc6$var$shiftMix(y).mul($1807475b7392bfc6$var$k0)).add(z), $1807475b7392bfc6$var$hashLen16(v[1], w[1], mul).add(x), mul);
}


function $0775da5e684c8c0d$export$cd3f28d8002ec2a2(value, dtype) {
    if (dtype === 'string') return $0775da5e684c8c0d$export$8146d2e653b87d6a(value);
    return $0775da5e684c8c0d$export$965adc581230795c([
        value
    ], dtype);
}
function $0775da5e684c8c0d$var$noConversionNeeded(a, dtype) {
    return a instanceof Float32Array && dtype === 'float32' || a instanceof Int32Array && dtype === 'int32' || a instanceof Uint8Array && dtype === 'bool';
}
function $0775da5e684c8c0d$export$965adc581230795c(a, dtype) {
    if (dtype === 'string') throw new Error('Cannot convert a string[] to a TypedArray');
    if (Array.isArray(a)) a = $0775da5e684c8c0d$export$bffa455ba8c619a6(a);
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) $9e4a6174e3538e7d$export$579cf7b8ff0a87a3(a, dtype);
    if ($0775da5e684c8c0d$var$noConversionNeeded(a, dtype)) return a;
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(a);
    else if (dtype === 'int32') return new Int32Array(a);
    else if (dtype === 'bool') {
        const bool = new Uint8Array(a.length);
        for(let i = 0; i < bool.length; ++i)if (Math.round(a[i]) !== 0) bool[i] = 1;
        return bool;
    } else throw new Error(`Unknown data type ${dtype}`);
}
function $0775da5e684c8c0d$export$461939dd4422153() {
    return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.now();
}
function $0775da5e684c8c0d$export$e7aa7bc5c1b3cfb3(path, requestInits) {
    return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.fetch(path, requestInits);
}
function $0775da5e684c8c0d$export$8146d2e653b87d6a(s, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.encode(s, encoding);
}
function $0775da5e684c8c0d$export$a0fb664af7d0cc44(bytes, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.decode(bytes, encoding);
}
function $0775da5e684c8c0d$export$b119cc7e1840e59c(a) {
    // TODO(mattsoulanille): Remove this fallback in 5.0.0
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.isTypedArray != null) return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.isTypedArray(a);
    else return (0, $60e26135cef47b6f$export$632e6430b2d784cd)(a);
}
function $0775da5e684c8c0d$export$bffa455ba8c619a6(arr, result = [], skipTypedArray = false) {
    if (result == null) result = [];
    if (typeof arr === 'boolean' || typeof arr === 'number' || typeof arr === 'string' || $9e4a6174e3538e7d$export$4369c812aac99591(arr) || arr == null || $0775da5e684c8c0d$export$b119cc7e1840e59c(arr) && skipTypedArray) result.push(arr);
    else if (Array.isArray(arr) || $0775da5e684c8c0d$export$b119cc7e1840e59c(arr)) for(let i = 0; i < arr.length; ++i)$0775da5e684c8c0d$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    else {
        let maxIndex = -1;
        for (const key of Object.keys(arr))// 0 or positive integer.
        if (/^([1-9]+[0-9]*|0)$/.test(key)) maxIndex = Math.max(maxIndex, Number(key));
        for(let i = 0; i <= maxIndex; i++)// tslint:disable-next-line: no-unnecessary-type-assertion
        $0775da5e684c8c0d$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    }
    return result;
}
$parcel$exportWildcard($0775da5e684c8c0d$exports, $9e4a6174e3538e7d$exports);
$parcel$exportWildcard($0775da5e684c8c0d$exports, $1807475b7392bfc6$exports);


class $453aebb21735a356$export$e2c29f18771995cb {
    constructor(backendTimer, logger){
        this.backendTimer = backendTimer;
        this.logger = logger;
        if (logger == null) this.logger = new $453aebb21735a356$export$efa9a398d6368992();
    }
    profileKernel(kernelName, inputs, f) {
        let outputs;
        const holdResultWrapperFn = ()=>{
            outputs = f();
        };
        let timer;
        const start = $0775da5e684c8c0d$export$461939dd4422153();
        if (this.backendTimer.timerAvailable()) timer = this.backendTimer.time(holdResultWrapperFn);
        else {
            holdResultWrapperFn();
            for (const output of outputs)output.dataSync();
            timer = Promise.resolve({
                kernelMs: $0775da5e684c8c0d$export$461939dd4422153() - start
            });
        }
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('CHECK_COMPUTATION_FOR_ERRORS')) for(let i = 0; i < outputs.length; i++){
            const output = outputs[i];
            // Dangling promise here because we don't want to propagate up
            // asynchronicity.
            output.data().then((tensorVals)=>{
                $453aebb21735a356$export$7f6e9a47e989eedc(tensorVals, output.dtype, kernelName);
            });
        }
        const kernelProfile = {
            kernelName: kernelName,
            outputs: outputs,
            inputs: inputs,
            timeMs: timer.then((timing)=>timing.kernelMs),
            extraInfo: timer.then((timing)=>timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : '')
        };
        return kernelProfile;
    }
    logKernelProfile(kernelProfile) {
        const { kernelName: kernelName, outputs: outputs, timeMs: timeMs, inputs: inputs, extraInfo: extraInfo } = kernelProfile;
        outputs.forEach((result)=>{
            Promise.all([
                result.data(),
                timeMs,
                extraInfo
            ]).then((valueContainer)=>{
                this.logger.logKernelProfile(kernelName, result, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
            });
        });
    }
}
function $453aebb21735a356$export$7f6e9a47e989eedc(vals, dtype, kernelName) {
    if (dtype !== 'float32') // Only floating point computations will generate NaN values
    return false;
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) {
            // Throwing custom exception so behavior is testable.
            console.warn(`Found ${num} in the result of '${kernelName}'`);
            return true;
        }
    }
    return false;
}
class $453aebb21735a356$export$efa9a398d6368992 {
    logKernelProfile(name, result, vals, timeMs, inputs, extraInfo) {
        const time = typeof timeMs === 'number' ? $9e4a6174e3538e7d$export$390245bab32fb60f(`${timeMs}ms`, 9) : timeMs['error'];
        const paddedName = $9e4a6174e3538e7d$export$390245bab32fb60f(name, 25);
        const rank = result.rank;
        const size = result.size;
        const shape = $9e4a6174e3538e7d$export$390245bab32fb60f(result.shape.toString(), 14);
        let inputShapesDescription = '';
        for(const name in inputs){
            const input = inputs[name];
            if (input != null) {
                // The input might be a non-tensor (e.g HTMLImageElement), in which case
                // we claim the output shape as input shape.
                const inputShape = input.shape || result.shape;
                const inputRank = inputShape.length;
                inputShapesDescription += `${name}: ${inputRank}D ${inputRank > 0 ? inputShape : ''} `;
            }
        }
        console.log(`%c${paddedName}\t%c${time}\t%c${rank}D ${shape}\t%c${size}\t%c${inputShapesDescription}\t%c${extraInfo}`, 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $e785710de6d72a0b$export$13eebbb952f0db02(tape, xs, y) {
    // Forward pass to compute all the nodes and Tensors that are transitively a
    // function of x.
    const tensorsFromX = {};
    const nodesFromX = {};
    for(let i = 0; i < xs.length; i++)tensorsFromX[xs[i].id] = true;
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        const nodeInputs = node.inputs;
        for(const inputName in nodeInputs){
            const input = nodeInputs[inputName];
            let anyInputFromX = false;
            for(let j = 0; j < xs.length; j++)if (tensorsFromX[input.id]) {
                node.outputs.forEach((output)=>tensorsFromX[output.id] = true);
                anyInputFromX = true;
                nodesFromX[node.id] = true;
                break;
            }
            if (anyInputFromX) break;
        }
    }
    // Backward pass to find all of the nodes and Tensors that lead to y.
    const tensorsLeadToY = {};
    tensorsLeadToY[y.id] = true;
    const nodesToY = {};
    for(let i = tape.length - 1; i >= 0; i--){
        const node = tape[i];
        const nodeInputs = node.inputs;
        // If any of the outputs lead to y, mark all of the inputs as leading to y.
        for(let j = 0; j < node.outputs.length; j++)if (tensorsLeadToY[node.outputs[j].id]) {
            for(const inputName in nodeInputs){
                tensorsLeadToY[nodeInputs[inputName].id] = true;
                nodesToY[node.id] = true;
            }
            break;
        }
    }
    // Return the paths that come from x and lead to y.
    const filteredTape = [];
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        if (nodesFromX[node.id] && nodesToY[node.id]) {
            // Prune the inputs from the node that aren't a function of x.
            const prunedInputs = {};
            for(const inputName in node.inputs){
                const nodeInput = node.inputs[inputName];
                if (tensorsFromX[nodeInput.id]) prunedInputs[inputName] = nodeInput;
            }
            // Copy the node and overwrite inputsAndArgs to the pruned version.
            const prunedNode = Object.assign({}, node);
            prunedNode.inputs = prunedInputs;
            prunedNode.outputs = node.outputs;
            filteredTape.push(prunedNode);
        }
    }
    return filteredTape;
}
function $e785710de6d72a0b$export$2992958ba0a8790d(tensorAccumulatedGradientMap, filteredTape, tidy, add) {
    // Walk the tape backward and keep a map of Tensor to its gradient.
    for(let i = filteredTape.length - 1; i >= 0; i--){
        const node = filteredTape[i];
        const dys = [];
        node.outputs.forEach((o)=>{
            const gradTensor = tensorAccumulatedGradientMap[o.id];
            if (gradTensor != null) dys.push(gradTensor);
            else // This particular output is not in the back-propagation subgraph, so it
            // does not affect the final output, thus we put null for its dy.
            dys.push(null);
        });
        if (node.gradient == null) throw new Error(`Cannot compute gradient: gradient function not found ` + `for ${node.kernelName}.`);
        // Backprop dy through this node and accumulate gradients over the inputs.
        const inputGradients = node.gradient(dys);
        for(const inputName in node.inputs){
            if (!(inputName in inputGradients)) throw new Error(`Cannot backprop through input ${inputName}. ` + `Available gradients found: ${Object.keys(inputGradients)}.`);
            // Call the gradient function.
            const dx = tidy(()=>inputGradients[inputName]());
            if (dx.dtype !== 'float32') throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `${inputName} must have 'float32' dtype, but has '${dx.dtype}'`);
            const x = node.inputs[inputName];
            if (!$9e4a6174e3538e7d$export$234180f8206db11b(dx.shape, x.shape)) throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `'${inputName}' has shape '${dx.shape}', which does not match ` + `the shape of the input '${x.shape}'`);
            if (tensorAccumulatedGradientMap[x.id] == null) tensorAccumulatedGradientMap[x.id] = dx;
            else {
                const curGradient = tensorAccumulatedGradientMap[x.id];
                tensorAccumulatedGradientMap[x.id] = add(curGradient, dx);
                curGradient.dispose();
            }
        }
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="@webgpu/types/dist" />

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
// Maximum number of values before we decide to show ellipsis.
const $4ee90eed3b92dbb8$var$FORMAT_LIMIT_NUM_VALS = 20;
// Number of first and last values to show when displaying a, b,...,y, z.
const $4ee90eed3b92dbb8$var$FORMAT_NUM_FIRST_LAST_VALS = 3;
// Number of significant digits to show.
const $4ee90eed3b92dbb8$var$FORMAT_NUM_SIG_DIGITS = 7;
function $4ee90eed3b92dbb8$export$7febe2c78b16daa7(vals, shape, dtype, verbose) {
    const strides = (0, $9e4a6174e3538e7d$export$6ad0292cf4d50f79)(shape);
    const padPerCol = $4ee90eed3b92dbb8$var$computeMaxSizePerColumn(vals, shape, dtype, strides);
    const rank = shape.length;
    const valsLines = $4ee90eed3b92dbb8$var$subTensorToString(vals, shape, dtype, strides, padPerCol);
    const lines = [
        'Tensor'
    ];
    if (verbose) {
        lines.push(`  dtype: ${dtype}`);
        lines.push(`  rank: ${rank}`);
        lines.push(`  shape: [${shape}]`);
        lines.push(`  values:`);
    }
    lines.push(valsLines.map((l)=>'    ' + l).join('\n'));
    return lines.join('\n');
}
function $4ee90eed3b92dbb8$var$computeMaxSizePerColumn(vals, shape, dtype, strides) {
    const n = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape);
    const numCols = strides[strides.length - 1];
    const padPerCol = new Array(numCols).fill(0);
    const rank = shape.length;
    const valuesOrTuples = dtype === 'complex64' ? $4ee90eed3b92dbb8$var$createComplexTuples(vals) : vals;
    if (rank > 1) for(let row = 0; row < n / numCols; row++){
        const offset = row * numCols;
        for(let j = 0; j < numCols; j++)padPerCol[j] = Math.max(padPerCol[j], $4ee90eed3b92dbb8$var$valToString(valuesOrTuples[offset + j], 0, dtype).length);
    }
    return padPerCol;
}
function $4ee90eed3b92dbb8$var$valToString(val, pad, dtype) {
    let valStr;
    if (Array.isArray(val)) valStr = `${parseFloat(val[0].toFixed($4ee90eed3b92dbb8$var$FORMAT_NUM_SIG_DIGITS))} + ` + `${parseFloat(val[1].toFixed($4ee90eed3b92dbb8$var$FORMAT_NUM_SIG_DIGITS))}j`;
    else if ((0, $9e4a6174e3538e7d$export$844ec244b1367d54)(val)) valStr = `'${val}'`;
    else if (dtype === 'bool') valStr = $4ee90eed3b92dbb8$var$boolNumToString(val);
    else valStr = parseFloat(val.toFixed($4ee90eed3b92dbb8$var$FORMAT_NUM_SIG_DIGITS)).toString();
    return (0, $9e4a6174e3538e7d$export$390245bab32fb60f)(valStr, pad);
}
function $4ee90eed3b92dbb8$var$boolNumToString(v) {
    return v === 0 ? 'false' : 'true';
}
function $4ee90eed3b92dbb8$var$subTensorToString(vals, shape, dtype, strides, padPerCol, isLast = true) {
    const storagePerElement = dtype === 'complex64' ? 2 : 1;
    const size = shape[0];
    const rank = shape.length;
    if (rank === 0) {
        if (dtype === 'complex64') {
            const complexTuple = $4ee90eed3b92dbb8$var$createComplexTuples(vals);
            return [
                $4ee90eed3b92dbb8$var$valToString(complexTuple[0], 0, dtype)
            ];
        }
        if (dtype === 'bool') return [
            $4ee90eed3b92dbb8$var$boolNumToString(vals[0])
        ];
        return [
            vals[0].toString()
        ];
    }
    if (rank === 1) {
        if (size > $4ee90eed3b92dbb8$var$FORMAT_LIMIT_NUM_VALS) {
            const firstValsSize = $4ee90eed3b92dbb8$var$FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
            let firstVals = Array.from(vals.slice(0, firstValsSize));
            let lastVals = Array.from(vals.slice((size - $4ee90eed3b92dbb8$var$FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
            if (dtype === 'complex64') {
                firstVals = $4ee90eed3b92dbb8$var$createComplexTuples(firstVals);
                lastVals = $4ee90eed3b92dbb8$var$createComplexTuples(lastVals);
            }
            return [
                '[' + firstVals.map((x, i)=>$4ee90eed3b92dbb8$var$valToString(x, padPerCol[i], dtype)).join(', ') + ', ..., ' + lastVals.map((x, i)=>$4ee90eed3b92dbb8$var$valToString(x, padPerCol[size - $4ee90eed3b92dbb8$var$FORMAT_NUM_FIRST_LAST_VALS + i], dtype)).join(', ') + ']'
            ];
        }
        const displayVals = dtype === 'complex64' ? $4ee90eed3b92dbb8$var$createComplexTuples(vals) : Array.from(vals);
        return [
            '[' + displayVals.map((x, i)=>$4ee90eed3b92dbb8$var$valToString(x, padPerCol[i], dtype)).join(', ') + ']'
        ];
    }
    // The array is rank 2 or more.
    const subshape = shape.slice(1);
    const substrides = strides.slice(1);
    const stride = strides[0] * storagePerElement;
    const lines = [];
    if (size > $4ee90eed3b92dbb8$var$FORMAT_LIMIT_NUM_VALS) {
        for(let i = 0; i < $4ee90eed3b92dbb8$var$FORMAT_NUM_FIRST_LAST_VALS; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$4ee90eed3b92dbb8$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false));
        }
        lines.push('...');
        for(let i = size - $4ee90eed3b92dbb8$var$FORMAT_NUM_FIRST_LAST_VALS; i < size; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$4ee90eed3b92dbb8$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
        }
    } else for(let i = 0; i < size; i++){
        const start = i * stride;
        const end = start + stride;
        lines.push(...$4ee90eed3b92dbb8$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
    }
    const sep = rank === 2 ? ',' : '';
    lines[0] = '[' + (size > 0 ? lines[0] + sep : '');
    for(let i = 1; i < lines.length - 1; i++)lines[i] = ' ' + lines[i] + sep;
    let newLineSep = ',\n';
    for(let i = 2; i < rank; i++)newLineSep += '\n';
    lines[lines.length - 1] = ' ' + lines[lines.length - 1] + ']' + (isLast ? '' : newLineSep);
    return lines;
}
function $4ee90eed3b92dbb8$var$createComplexTuples(vals) {
    const complexTuples = [];
    for(let i = 0; i < vals.length; i += 2)complexTuples.push([
        vals[i],
        vals[i + 1]
    ]);
    return complexTuples;
}



class $4b7222b1b59444b8$export$350df26cd52e08e1 {
    constructor(shape, dtype, values){
        this.dtype = dtype;
        this.shape = shape.slice();
        this.size = $9e4a6174e3538e7d$export$b4c3214a70a0e73f(shape);
        if (values != null) {
            const n = values.length;
            $9e4a6174e3538e7d$export$a7a9523472993e97(n === this.size, ()=>`Length of values '${n}' does not match the size ` + `inferred by the shape '${this.size}'.`);
        }
        if (dtype === 'complex64') throw new Error(`complex64 dtype TensorBuffers are not supported. Please create ` + `a TensorBuffer for the real and imaginary parts separately and ` + `call tf.complex(real, imag).`);
        this.values = values || $9e4a6174e3538e7d$export$24f13f6206df8f7c(dtype, this.size);
        this.strides = (0, $9e4a6174e3538e7d$export$6ad0292cf4d50f79)(shape);
    }
    /**
     * Sets a value in the buffer at a given location.
     *
     * @param value The value to set.
     * @param locs  The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ set(value, ...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        $9e4a6174e3538e7d$export$a7a9523472993e97(locs.length === this.rank, ()=>`The number of provided coordinates (${locs.length}) must ` + `match the rank (${this.rank})`);
        const index = this.locToIndex(locs);
        this.values[index] = value;
    }
    /**
     * Returns the value in the buffer at the provided location.
     *
     * @param locs The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ get(...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        let i = 0;
        for (const loc of locs){
            if (loc < 0 || loc >= this.shape[i]) {
                const msg = `Requested out of range element at ${locs}. ` + `  Buffer shape=${this.shape}`;
                throw new Error(msg);
            }
            i++;
        }
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return this.values[index];
    }
    locToIndex(locs) {
        if (this.rank === 0) return 0;
        else if (this.rank === 1) return locs[0];
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return index;
    }
    indexToLoc(index) {
        if (this.rank === 0) return [];
        else if (this.rank === 1) return [
            index
        ];
        const locs = new Array(this.shape.length);
        for(let i = 0; i < locs.length - 1; ++i){
            locs[i] = Math.floor(index / this.strides[i]);
            index -= locs[i] * this.strides[i];
        }
        locs[locs.length - 1] = index;
        return locs;
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Creates an immutable `tf.Tensor` object from the buffer.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ toTensor() {
        return $4b7222b1b59444b8$var$trackerFn().makeTensor(this.values, this.shape, this.dtype);
    }
}
// For tracking tensor creation and disposal.
let $4b7222b1b59444b8$var$trackerFn = null;
// Used by chaining methods to call into ops.
let $4b7222b1b59444b8$var$opHandler = null;
// Used to warn about deprecated methods.
let $4b7222b1b59444b8$var$deprecationWarningFn = null;
function $4b7222b1b59444b8$export$b1e34d2f0ffbbd85(fn) {
    $4b7222b1b59444b8$var$trackerFn = fn;
}
function $4b7222b1b59444b8$export$1efe8d8b4884ad31(handler) {
    $4b7222b1b59444b8$var$opHandler = handler;
}
function $4b7222b1b59444b8$export$ca605c1d8919649f(fn) {
    $4b7222b1b59444b8$var$deprecationWarningFn = fn;
}
class $4b7222b1b59444b8$export$7b6b8d90402f8814 {
    constructor(shape, dtype, dataId, id){
        /** Whether this tensor has been globally kept. */ this.kept = false;
        this.isDisposedInternal = false;
        this.shape = shape.slice();
        this.dtype = dtype || 'float32';
        this.size = $9e4a6174e3538e7d$export$b4c3214a70a0e73f(shape);
        this.strides = (0, $9e4a6174e3538e7d$export$6ad0292cf4d50f79)(shape);
        this.dataId = dataId;
        this.id = id;
        this.rankType = this.rank < 5 ? this.rank.toString() : 'higher';
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async buffer() {
        const vals = await this.data();
        return $4b7222b1b59444b8$var$opHandler.buffer(this.shape, this.dtype, vals);
    }
    /**
     * Returns a `tf.TensorBuffer` that holds the underlying data.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ bufferSync() {
        return $4b7222b1b59444b8$var$opHandler.buffer(this.shape, this.dtype, this.dataSync());
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * asynchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async array() {
        const vals = await this.data();
        return (0, $9e4a6174e3538e7d$export$3983c25181aa68cc)(this.shape, vals, this.dtype === 'complex64');
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * synchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ arraySync() {
        return (0, $9e4a6174e3538e7d$export$3983c25181aa68cc)(this.shape, this.dataSync(), this.dtype === 'complex64');
    }
    /**
     * Asynchronously downloads the values from the `tf.Tensor`. Returns a
     * promise of `TypedArray` that resolves when the computation has finished.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async data() {
        this.throwIfDisposed();
        const data = $4b7222b1b59444b8$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') {
            const bytes = await data;
            try {
                return bytes.map((b)=>$0775da5e684c8c0d$export$a0fb664af7d0cc44(b));
            } catch (_a) {
                throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
            }
        }
        return data;
    }
    /**
     * Copy the tensor's data to a new GPU resource. Comparing to the `dataSync()`
     * and `data()`, this method prevents data from being downloaded to CPU.
     *
     * For WebGL backend, the data will be stored on a densely packed texture.
     * This means that the texture will use the RGBA channels to store value.
     *
     * For WebGPU backend, the data will be stored on a buffer. There is no
     * parameter, so can not use a user-defined size to create the buffer.
     *
     * @param options:
     *     For WebGL,
     *         - customTexShape: Optional. If set, will use the user defined
     *     texture shape to create the texture.
     *
     * @returns For WebGL backend, a GPUData contains the new texture and
     *     its information.
     *     {
     *        tensorRef: The tensor that is associated with this texture,
     *        texture: WebGLTexture,
     *        texShape: [number, number] // [height, width]
     *     }
     *
     *     For WebGPU backend, a GPUData contains the new buffer.
     *     {
     *        tensorRef: The tensor that is associated with this buffer,
     *        buffer: GPUBuffer,
     *     }
     *
     *     Remember to dispose the GPUData after it is used by
     *     `res.tensorRef.dispose()`.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataToGPU(options) {
        this.throwIfDisposed();
        return $4b7222b1b59444b8$var$trackerFn().readToGPU(this.dataId, options);
    }
    /**
     * Synchronously downloads the values from the `tf.Tensor`. This blocks the
     * UI thread until the values are ready, which can cause performance issues.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataSync() {
        this.throwIfDisposed();
        const data = $4b7222b1b59444b8$var$trackerFn().readSync(this.dataId);
        if (this.dtype === 'string') try {
            return data.map((b)=>$0775da5e684c8c0d$export$a0fb664af7d0cc44(b));
        } catch (_a) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return data;
    }
    /** Returns the underlying bytes of the tensor's data. */ async bytes() {
        this.throwIfDisposed();
        const data = await $4b7222b1b59444b8$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') return data;
        else return new Uint8Array(data.buffer);
    }
    /**
     * Disposes `tf.Tensor` from memory.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dispose() {
        if (this.isDisposed) return;
        if (this.kerasMask) this.kerasMask.dispose();
        $4b7222b1b59444b8$var$trackerFn().disposeTensor(this);
        this.isDisposedInternal = true;
    }
    get isDisposed() {
        return this.isDisposedInternal;
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error(`Tensor is disposed.`);
    }
    /**
     * Prints the `tf.Tensor`. See `tf.print` for details.
     *
     * @param verbose Whether to print verbose information about the tensor,
     *    including dtype and size.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ print(verbose = false) {
        return $4b7222b1b59444b8$var$opHandler.print(this, verbose);
    }
    /**
     * Returns a copy of the tensor. See `tf.clone` for details.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ clone() {
        this.throwIfDisposed();
        return $4b7222b1b59444b8$var$opHandler.clone(this);
    }
    /**
     * Returns a human-readable description of the tensor. Useful for logging.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ toString(verbose = false) {
        const vals = this.dataSync();
        return (0, $4ee90eed3b92dbb8$export$7febe2c78b16daa7)(vals, this.shape, this.dtype, verbose);
    }
    cast(dtype) {
        this.throwIfDisposed();
        return $4b7222b1b59444b8$var$opHandler.cast(this, dtype);
    }
    variable(trainable = true, name, dtype) {
        this.throwIfDisposed();
        return $4b7222b1b59444b8$var$trackerFn().makeVariable(this, trainable, name, dtype);
    }
}
Object.defineProperty($4b7222b1b59444b8$export$7b6b8d90402f8814, Symbol.hasInstance, {
    value: (instance)=>{
        // Implementation note: we should use properties of the object that will be
        // defined before the constructor body has finished executing (methods).
        // This is because when this code is transpiled by babel, babel will call
        // classCallCheck before the constructor body is run.
        // See https://github.com/tensorflow/tfjs/issues/3384 for backstory.
        return !!instance && instance.data != null && instance.dataSync != null && instance.throwIfDisposed != null;
    }
});
function $4b7222b1b59444b8$export$3cbd87e9d6a9b7ac() {
    // Use getGlobal so that we can augment the Tensor class across package
    // boundaries because the node resolution alg may result in different modules
    // being returned for this file depending on the path they are loaded from.
    return (0, $edf795347656fd15$export$a4e55266d2135a7f)('Tensor', ()=>{
        return $4b7222b1b59444b8$export$7b6b8d90402f8814;
    });
}
// Global side effect. Cache global reference to Tensor class
$4b7222b1b59444b8$export$3cbd87e9d6a9b7ac();
class $4b7222b1b59444b8$export$c867a5c9595a1350 extends $4b7222b1b59444b8$export$7b6b8d90402f8814 {
    constructor(initialValue, trainable, name, tensorId){
        super(initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId);
        this.trainable = trainable;
        this.name = name;
    }
    /**
     * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
     * the same shape and dtype as the old `tf.Tensor`.
     *
     * @param newValue New tensor to be assigned to this variable.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ assign(newValue) {
        if (newValue.dtype !== this.dtype) throw new Error(`dtype of the new value (${newValue.dtype}) and ` + `previous value (${this.dtype}) must match`);
        if (!$9e4a6174e3538e7d$export$234180f8206db11b(newValue.shape, this.shape)) throw new Error(`shape of the new value (${newValue.shape}) and ` + `previous value (${this.shape}) must match`);
        $4b7222b1b59444b8$var$trackerFn().disposeTensor(this);
        this.dataId = newValue.dataId;
        $4b7222b1b59444b8$var$trackerFn().incRef(this, null);
    }
    dispose() {
        $4b7222b1b59444b8$var$trackerFn().disposeVariable(this);
        this.isDisposedInternal = true;
    }
}
Object.defineProperty($4b7222b1b59444b8$export$c867a5c9595a1350, Symbol.hasInstance, {
    value: (instance)=>{
        return instance instanceof $4b7222b1b59444b8$export$7b6b8d90402f8814 && instance.assign != null && instance.assign instanceof Function;
    }
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $4ccb7c1368387e67$export$c36edca8f8f0427a;
(function(Rank) {
    Rank["R0"] = "R0";
    Rank["R1"] = "R1";
    Rank["R2"] = "R2";
    Rank["R3"] = "R3";
    Rank["R4"] = "R4";
    Rank["R5"] = "R5";
    Rank["R6"] = "R6";
})($4ccb7c1368387e67$export$c36edca8f8f0427a || ($4ccb7c1368387e67$export$c36edca8f8f0427a = {}));
// Looks for upcasting types. Used, for example, in operations with mixed dtype
// inputs.
var $4ccb7c1368387e67$var$UpcastInt32AndMap;
(function(UpcastInt32AndMap) {
    UpcastInt32AndMap["float32"] = "float32";
    UpcastInt32AndMap["int32"] = "int32";
    UpcastInt32AndMap["bool"] = "int32";
    UpcastInt32AndMap["complex64"] = "complex64";
})($4ccb7c1368387e67$var$UpcastInt32AndMap || ($4ccb7c1368387e67$var$UpcastInt32AndMap = {}));
var $4ccb7c1368387e67$var$UpcastBoolAndMap;
(function(UpcastBoolAndMap) {
    UpcastBoolAndMap["float32"] = "float32";
    UpcastBoolAndMap["int32"] = "int32";
    UpcastBoolAndMap["bool"] = "bool";
    UpcastBoolAndMap["complex64"] = "complex64";
})($4ccb7c1368387e67$var$UpcastBoolAndMap || ($4ccb7c1368387e67$var$UpcastBoolAndMap = {}));
var $4ccb7c1368387e67$var$UpcastFloat32AndMap;
(function(UpcastFloat32AndMap) {
    UpcastFloat32AndMap["float32"] = "float32";
    UpcastFloat32AndMap["int32"] = "float32";
    UpcastFloat32AndMap["bool"] = "float32";
    UpcastFloat32AndMap["complex64"] = "complex64";
})($4ccb7c1368387e67$var$UpcastFloat32AndMap || ($4ccb7c1368387e67$var$UpcastFloat32AndMap = {}));
var $4ccb7c1368387e67$var$UpcastComplex64AndMap;
(function(UpcastComplex64AndMap) {
    UpcastComplex64AndMap["float32"] = "complex64";
    UpcastComplex64AndMap["int32"] = "complex64";
    UpcastComplex64AndMap["bool"] = "complex64";
    UpcastComplex64AndMap["complex64"] = "complex64";
})($4ccb7c1368387e67$var$UpcastComplex64AndMap || ($4ccb7c1368387e67$var$UpcastComplex64AndMap = {}));
const $4ccb7c1368387e67$var$upcastTypeMap = {
    'float32': $4ccb7c1368387e67$var$UpcastFloat32AndMap,
    'int32': $4ccb7c1368387e67$var$UpcastInt32AndMap,
    'bool': $4ccb7c1368387e67$var$UpcastBoolAndMap,
    'complex64': $4ccb7c1368387e67$var$UpcastComplex64AndMap
};
function $4ccb7c1368387e67$export$7bcca02d1a156bdf(typeA, typeB) {
    if (typeA === 'string' || typeB === 'string') {
        if (typeA === 'string' && typeB === 'string') return 'string';
        throw new Error(`Can not upcast ${typeA} with ${typeB}`);
    }
    return $4ccb7c1368387e67$var$upcastTypeMap[typeA][typeB];
}
function $4ccb7c1368387e67$export$3479b4fbed3c0d8d(type) {
    return $4ccb7c1368387e67$export$7bcca02d1a156bdf(type, 'int32');
}
function $4ccb7c1368387e67$export$12371c78da2a116a(values) {
    return values != null && typeof values === 'object' && 'texture' in values && values.texture instanceof WebGLTexture;
}
function $4ccb7c1368387e67$export$db4071ca636ae03b(values) {
    return typeof GPUBuffer !== 'undefined' && values != null && typeof values === 'object' && 'buffer' in values && values.buffer instanceof GPUBuffer;
}



function $186e2a8efb04b468$export$8b0e24c749a224d7(a, b) {
    if (a.dtype === b.dtype) return [
        a,
        b
    ];
    const dtype = (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(a.dtype, b.dtype);
    return [
        a.cast(dtype),
        b.cast(dtype)
    ];
}
function $186e2a8efb04b468$export$8a66522456343d17(a, b) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(a.dtype === b.dtype, ()=>`The dtypes of the first(${a.dtype}) and` + ` second(${b.dtype}) input must match`);
}
function $186e2a8efb04b468$export$537d2ee9de90a490(tensor, tensorList) {
    return tensorList.some((x)=>x.id === tensor.id);
}
function $186e2a8efb04b468$export$888c106d343989f5(result) {
    const list = [];
    const seen = new Set();
    $186e2a8efb04b468$var$walkTensorContainer(result, list, seen);
    return list;
}
function $186e2a8efb04b468$var$walkTensorContainer(container, list, seen) {
    if (container == null) return;
    if (container instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)) {
        list.push(container);
        return;
    }
    if (!$186e2a8efb04b468$var$isIterable(container)) return;
    // Iteration over keys works also for arrays.
    const iterable = container;
    for(const k in iterable){
        const val = iterable[k];
        if (!seen.has(val)) {
            seen.add(val);
            $186e2a8efb04b468$var$walkTensorContainer(val, list, seen);
        }
    }
}
// tslint:disable-next-line:no-any
function $186e2a8efb04b468$var$isIterable(obj) {
    return Array.isArray(obj) || typeof obj === 'object';
}



function $6a645535e157b279$var$isRegisteredKernelInvocation(kernelInvocation) {
    return kernelInvocation.kernelName != null;
}
class $6a645535e157b279$var$EngineState {
    constructor(){
        // Public since optimizers will use it.
        this.registeredVariables = {};
        this.nextTapeNodeId = 0;
        this.numBytes = 0;
        this.numTensors = 0;
        this.numStringTensors = 0;
        this.numDataBuffers = 0;
        // Number of nested tf.grad() statements when computing higher-order
        // gradients. E.g. `1` for first-order gradients and `2` for second-order
        // gradients. Used to track if the tape should be removed after a backprop.
        this.gradientDepth = 0;
        // Number of nested kernel calls. When kernel depth is greater than 1, we turn
        // off the tape.
        this.kernelDepth = 0;
        this.scopeStack = [];
        /**
         * Keeps track of the number of data moves during a kernel execution. We
         * maintain a stack since kernels can call other kernels, recursively.
         */ this.numDataMovesStack = [];
        this.nextScopeId = 0;
        this.tensorInfo = new WeakMap();
        this.profiling = false;
        this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null,
            get kernelNames () {
                return Array.from(new Set(this.kernels.map((k)=>k.name)));
            }
        };
    }
    dispose() {
        for(const variableName in this.registeredVariables)this.registeredVariables[variableName].dispose();
    }
}
class $6a645535e157b279$export$2c3b404bf3a77a1f {
    constructor(ENV){
        this.ENV = ENV;
        this.registry = {};
        this.registryFactory = {};
        this.pendingBackendInitId = 0;
        this.state = new $6a645535e157b279$var$EngineState();
    }
    async ready() {
        if (this.pendingBackendInit != null) return this.pendingBackendInit.then(()=>{});
        if (this.backendInstance != null) return;
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const success = await this.initializeBackend(backendName).success;
            if (success) {
                await this.setBackend(backendName);
                return;
            }
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    get backend() {
        if (this.pendingBackendInit != null) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make ` + `sure to await tf.ready() or await tf.setBackend() before calling ` + `other methods`);
        if (this.backendInstance == null) {
            const { name: name, asyncInit: asyncInit } = this.initializeBackendsAndReturnBest();
            if (asyncInit) throw new Error(`The highest priority backend '${name}' has not yet been ` + `initialized. Make sure to await tf.ready() or ` + `await tf.setBackend() before calling other methods`);
            this.setBackend(name);
        }
        return this.backendInstance;
    }
    backendNames() {
        return Object.keys(this.registryFactory);
    }
    findBackend(backendName) {
        if (!(backendName in this.registry)) {
            // If the backend hasn't been initialized but we have a registry entry for
            // it, initialize it and return it.
            if (backendName in this.registryFactory) {
                const { asyncInit: asyncInit } = this.initializeBackend(backendName);
                if (asyncInit) // Backend is not ready yet.
                return null;
            } else return null;
        }
        return this.registry[backendName];
    }
    findBackendFactory(backendName) {
        if (!(backendName in this.registryFactory)) return null;
        return this.registryFactory[backendName].factory;
    }
    registerBackend(backendName, factory, priority = 1) {
        if (backendName in this.registryFactory) {
            $720e4308e1a7c928$export$c106dd0671a0fc2d(`${backendName} backend was already registered. ` + `Reusing existing backend factory.`);
            return false;
        }
        this.registryFactory[backendName] = {
            factory: factory,
            priority: priority
        };
        return true;
    }
    async setBackend(backendName) {
        if (this.registryFactory[backendName] == null) throw new Error(`Backend name '${backendName}' not found in registry`);
        this.backendName = backendName;
        if (this.registry[backendName] == null) {
            this.backendInstance = null;
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            const result = asyncInit ? await success : success;
            if (!result) return false;
        }
        this.backendInstance = this.registry[backendName];
        this.setupRegisteredKernels();
        // Reset the profiler.
        this.profiler = new (0, $453aebb21735a356$export$e2c29f18771995cb)(this.backendInstance);
        return true;
    }
    setupRegisteredKernels() {
        const kernels = (0, $071cf1fd9dc2117e$export$e4b8d76e176eaecc)(this.backendName);
        kernels.forEach((kernel)=>{
            if (kernel.setupFunc != null) kernel.setupFunc(this.backendInstance);
        });
    }
    disposeRegisteredKernels(backendName) {
        const kernels = (0, $071cf1fd9dc2117e$export$e4b8d76e176eaecc)(backendName);
        kernels.forEach((kernel)=>{
            if (kernel.disposeFunc != null) kernel.disposeFunc(this.registry[backendName]);
        });
    }
    /**
     * Initializes a backend by looking up the backend name in the factory
     * registry and calling the factory method. Returns a boolean representing
     * whether the initialization of the backend succeeded. Throws an error if
     * there is no backend in the factory registry.
     */ initializeBackend(backendName) {
        const registryFactoryEntry = this.registryFactory[backendName];
        if (registryFactoryEntry == null) throw new Error(`Cannot initialize backend ${backendName}, no registration found.`);
        try {
            const backend = registryFactoryEntry.factory();
            /* Test if the factory returns a promise.
            Done in a more liberal way than
            previous 'Promise.resolve(backend)===backend'
            as we needed to account for custom Promise
            implementations (e.g. Angular) */ if (backend && !(backend instanceof (0, $0f11f47888a734c2$export$543916c62202b50a)) && typeof backend.then === 'function') {
                const promiseId = ++this.pendingBackendInitId;
                const success = backend.then((backendInstance)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.registry[backendName] = backendInstance;
                    this.pendingBackendInit = null;
                    return true;
                }).catch((err)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.pendingBackendInit = null;
                    $720e4308e1a7c928$export$c106dd0671a0fc2d(`Initialization of backend ${backendName} failed`);
                    $720e4308e1a7c928$export$c106dd0671a0fc2d(err.stack || err.message);
                    return false;
                });
                this.pendingBackendInit = success;
                return {
                    success: success,
                    asyncInit: true
                };
            } else {
                this.registry[backendName] = backend;
                return {
                    success: true,
                    asyncInit: false
                };
            }
        } catch (err) {
            $720e4308e1a7c928$export$c106dd0671a0fc2d(`Initialization of backend ${backendName} failed`);
            $720e4308e1a7c928$export$c106dd0671a0fc2d(err.stack || err.message);
            return {
                success: false,
                asyncInit: false
            };
        }
    }
    removeBackend(backendName) {
        if (!(backendName in this.registryFactory)) throw new Error(`${backendName} backend not found in registry`);
        if (this.backendName === backendName && this.pendingBackendInit != null) // There is a pending promise of the backend we want to remove. Make it
        // obsolete.
        this.pendingBackendInitId++;
        if (backendName in this.registry) {
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        delete this.registryFactory[backendName];
        // Unset the backend if it is active.
        if (this.backendName === backendName) {
            this.pendingBackendInit = null;
            this.backendName = null;
            this.backendInstance = null;
        }
    }
    getSortedBackends() {
        if (Object.keys(this.registryFactory).length === 0) throw new Error('No backend found in registry.');
        return Object.keys(this.registryFactory).sort((a, b)=>{
            // Highest priority comes first.
            return this.registryFactory[b].priority - this.registryFactory[a].priority;
        });
    }
    initializeBackendsAndReturnBest() {
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            if (asyncInit || success) return {
                name: backendName,
                asyncInit: asyncInit
            };
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    moveData(backend, dataId) {
        const info = this.state.tensorInfo.get(dataId);
        const srcBackend = info.backend;
        const values = this.readSync(dataId);
        const refCount = srcBackend.refCount(dataId);
        // Delete the tensor from the old backend and move it to the new
        // backend.
        srcBackend.disposeData(dataId, true);
        info.backend = backend;
        backend.move(dataId, values, info.shape, info.dtype, refCount);
        if (this.shouldCheckForMemLeaks()) // Track the number of moves during a kernel execution to correctly
        // detect memory leaks.
        this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
    tidy(nameOrFn, fn) {
        let name = null;
        if (fn == null) {
            // Called with only 1 argument.
            if (typeof nameOrFn !== 'function') throw new Error('Please provide a function to tidy()');
            fn = nameOrFn;
        } else {
            // Called with 2 arguments.
            if (typeof nameOrFn !== 'string' && !(nameOrFn instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if (typeof fn !== 'function') throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            name = nameOrFn;
        // TODO(nsthorat,smilkov): Do operation logging and performance
        // profiling.
        }
        let result;
        return this.scopedRun(()=>this.startScope(name), ()=>this.endScope(result), ()=>{
            result = fn();
            if (result instanceof Promise) console.error('Cannot return a Promise inside of tidy.');
            return result;
        });
    }
    scopedRun(start, end, f) {
        start();
        try {
            const res = f();
            end();
            return res;
        } catch (ex) {
            end();
            throw ex;
        }
    }
    nextTensorId() {
        return $6a645535e157b279$export$2c3b404bf3a77a1f.nextTensorId++;
    }
    nextVariableId() {
        return $6a645535e157b279$export$2c3b404bf3a77a1f.nextVariableId++;
    }
    /**
     * This method is called instead of the public-facing tensor.clone() when
     * saving a tensor for backwards pass. It makes sure to add the clone
     * operation to the tape regardless of being called inside a kernel
     * execution.
     */ clone(x) {
        const y = $6a645535e157b279$export$33b63313cc511a3b.runKernel((0, $507890e4aa8e1463$export$544bf02140fa9a77), {
            x: x
        });
        const inputs = {
            x: x
        };
        const grad = (dy)=>({
                x: ()=>{
                    const dtype = 'float32';
                    const gradInputs = {
                        x: dy
                    };
                    const attrs = {
                        dtype: dtype
                    };
                    return $6a645535e157b279$export$33b63313cc511a3b.runKernel((0, $507890e4aa8e1463$export$107ecfb3d1ccbd77), gradInputs, // tslint:disable-next-line: no-unnecessary-type-assertion
                    attrs);
                }
            });
        const saved = [];
        this.addTapeNode(this.state.activeScope.name, inputs, [
            y
        ], grad, saved, {});
        return y;
    }
    /**
     * Execute a kernel with the given name and return the output tensor.
     *
     * @param kernelName The name of the kernel to execute.
     * @param inputs A map of input names to tensors.
     * @param attrs A map of attribute names to their values. An attribute is a
     *     primitive (non-tensor) input to the kernel.
     * @param inputsToSave A list of tensors, inputs to save for the backprop
     *     computation.
     * @param outputsToSave A list of booleans, specifying which output to save
     *     for the backprop computation. These are booleans since the output
     * tensors are not visible to the user.
     */ runKernel(kernelName, inputs, attrs) {
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        const hasKernel = (0, $071cf1fd9dc2117e$export$1b85808c967cc434)(kernelName, this.backendName) != null;
        if (!hasKernel) throw new Error(`Kernel '${kernelName}' not registered for backend '${this.backendName}'`);
        return this.runKernelFunc({
            kernelName: kernelName,
            inputs: inputs,
            attrs: attrs
        });
    }
    shouldCheckForMemLeaks() {
        return this.ENV.getBool('IS_TEST');
    }
    checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos) {
        const numDataIdsAfter = this.backend.numDataIds();
        // Count the number of data ids associated with the result of the kernel.
        let numOutputDataIds = 0;
        outInfos.forEach((info)=>{
            // Complex numbers allocate 3 data ids, one for 'real', one for
            // 'imaginary', and one for the container that holds the former two.
            numOutputDataIds += info.dtype === 'complex64' ? 3 : 1;
        });
        // Account for the number of moves during kernel execution. A "data move"
        // can happen in the middle of a kernel execution, placing a new (key,value)
        // pair in the data storage. Since data moves have net zero effect (we
        // always remove the data from the old backend), we have to cancel them out
        // when detecting memory leaks.
        const numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
        const dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
        if (dataIdsLeaked > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak ` + `(${dataIdsLeaked} data ids) after running '${kernelName}'`);
    }
    /**
     * Internal helper method to execute a kernel Func
     *
     * Use `runKernel` to execute kernels from outside of engine.
     */ runKernelFunc(kernelParams) {
        let outputs;
        let saved = [];
        const isTapeOn = this.isTapeOn();
        const startingBytecount = this.state.numBytes;
        const startingNumTensors = this.state.numTensors;
        if (this.shouldCheckForMemLeaks()) this.state.numDataMovesStack.push(0);
        let kernelFunc;
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        let out;
        const kernelOrScopeName = $6a645535e157b279$var$isRegisteredKernelInvocation(kernelParams) ? kernelParams.kernelName : this.state.activeScope != null ? this.state.activeScope.name : '';
        // Create the kernelFunc from either a registered kernel OR passed in
        // forward/backward functions (used by custom grad). In this context a
        // kernelFunc wraps a kernel implementation with some bookkeeping.
        if ($6a645535e157b279$var$isRegisteredKernelInvocation(kernelParams)) {
            const { kernelName: kernelName, inputs: inputs, attrs: attrs } = kernelParams;
            if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
            // can be deferred until an op/ kernel is run).
            // The below getter has side effects that will try to initialize the
            // backend and set properties like this.backendName
            // tslint:disable-next-line: no-unused-expression
            this.backend;
            const kernel = (0, $071cf1fd9dc2117e$export$1b85808c967cc434)(kernelName, this.backendName);
            $9e4a6174e3538e7d$export$a7a9523472993e97(kernel != null, ()=>`Cannot find registered kernel '${kernelName}' for backend '${this.backendName}'`);
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = kernel.kernelFunc({
                    inputs: inputs,
                    attrs: attrs,
                    backend: this.backend
                });
                const outInfos = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
                const outTensors = outInfos.map((outInfo)=>{
                    // todo (yassogba) remove this option (Tensor) when node backend
                    // methods have been modularized and they all return tensorInfo.
                    // TensorInfos do not have a rank attribute.
                    if (outInfo.rank != null) return outInfo;
                    return this.makeTensorFromTensorInfo(outInfo);
                });
                // Save any required inputs and outputs.
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since there would be no backprop for these tensors
                // (which would otherwise dispose them).
                if (isTapeOn) {
                    const tensorsToSave = this.getTensorsForGradient(kernelName, inputs, outTensors);
                    saved = this.saveTensorsForBackwardMode(tensorsToSave);
                }
                return outTensors;
            };
        } else {
            const { forwardFunc: forwardFunc } = kernelParams;
            // Running a customGrad op.
            const saveFunc = (tensors)=>{
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since we would never run backprop, which disposes
                // the kept tensors.
                if (!isTapeOn) return;
                saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
            };
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = this.tidy(()=>forwardFunc(this.backend, saveFunc));
                const outs = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) // Scope name is used to print a more helpful error message if needed.
                this.checkKernelForMemLeak(kernelOrScopeName, numDataIdsBefore, outs);
                return outs;
            };
        }
        //
        // Run the kernelFunc. Optionally profiling it.
        //
        const { inputs: inputs, attrs: attrs } = kernelParams;
        const backwardsFunc = $6a645535e157b279$var$isRegisteredKernelInvocation(kernelParams) ? null : kernelParams.backwardsFunc;
        let kernelProfile;
        this.scopedRun(// Stop recording to a tape when running a kernel.
        ()=>this.state.kernelDepth++, ()=>this.state.kernelDepth--, ()=>{
            if (!this.ENV.getBool('DEBUG') && !this.state.profiling) outputs = kernelFunc();
            else {
                kernelProfile = this.profiler.profileKernel(kernelOrScopeName, inputs, ()=>kernelFunc());
                if (this.ENV.getBool('DEBUG')) this.profiler.logKernelProfile(kernelProfile);
                outputs = kernelProfile.outputs;
            }
        });
        if (isTapeOn) this.addTapeNode(kernelOrScopeName, inputs, outputs, backwardsFunc, saved, attrs);
        if (this.state.profiling) this.state.activeProfile.kernels.push({
            name: kernelOrScopeName,
            bytesAdded: this.state.numBytes - startingBytecount,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - startingNumTensors,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(inputs).map((key)=>inputs[key] != null ? inputs[key].shape : null),
            outputShapes: outputs.map((item)=>item.shape),
            kernelTimeMs: kernelProfile.timeMs,
            extraInfo: kernelProfile.extraInfo
        });
        return Array.isArray(out) ? outputs : outputs[0];
    }
    /**
     * Saves tensors used in forward mode for use in backward mode.
     *
     * @param tensors the list of tensors to save.
     */ saveTensorsForBackwardMode(tensors) {
        const saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
        return saved;
    }
    /**
     * Returns a list of tensors to save for a given gradient calculation.
     *
     * @param kernelName name of kernel to look up gradient for.
     * @param inputs a map of input tensors.
     * @param outputs an array of output tensors from forward mode of kernel.
     */ getTensorsForGradient(kernelName, inputs, outputs) {
        const gradConfig = (0, $071cf1fd9dc2117e$export$e14995d3ec1747ee)(kernelName);
        if (gradConfig != null) {
            const inputsToSave = gradConfig.inputsToSave || [];
            const outputsToSave = gradConfig.outputsToSave || [];
            // If saveAllInputs is true, all inputs will be saved. Otherwise, inputs
            // specified in inputsToSave will be saved.
            let inputTensorsToSave;
            if (gradConfig.saveAllInputs) {
                $9e4a6174e3538e7d$export$a7a9523472993e97(Array.isArray(inputs), ()=>'saveAllInputs is true, expected inputs to be an array.');
                inputTensorsToSave = Object.keys(inputs).map((key)=>inputs[key]);
            } else inputTensorsToSave = inputsToSave.map((inputName)=>inputs[inputName]);
            const outputTensorsToSave = outputs.filter((_, i)=>outputsToSave[i]);
            return inputTensorsToSave.concat(outputTensorsToSave);
        }
        // We return an empty list rather than throw an error because the kernel we
        // are looking up may not actually be relevant to backproping through the
        // overall function
        //
        // See 'does not error if irrelevant (pruned) ops are missing grads' test
        // in gradients_test.ts for an example.
        return [];
    }
    /**
     * Internal method used by public APIs for tensor creation. Makes a new
     * tensor with the provided shape, dtype and values. It always
     * creates a new data id and writes the values to the underlying backend.
     */ makeTensor(values, shape, dtype, backend) {
        if (values == null) throw new Error('Values passed to engine.makeTensor() are null');
        dtype = dtype || 'float32';
        backend = backend || this.backend;
        let backendVals = values;
        if (dtype === 'string' && $9e4a6174e3538e7d$export$844ec244b1367d54(values[0])) backendVals = values.map((d)=>$0775da5e684c8c0d$export$8146d2e653b87d6a(d));
        const dataId = backend.write(backendVals, shape, dtype);
        const t = new (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        // Count bytes for string tensors.
        if (dtype === 'string') {
            const info = this.state.tensorInfo.get(dataId);
            const newBytes = (0, $9e4a6174e3538e7d$export$c474902e1102282d)(backendVals);
            this.state.numBytes += newBytes - info.bytes;
            info.bytes = newBytes;
        }
        return t;
    }
    /**
     * Internal method used by backends. Makes a new tensor
     * that is a wrapper around an existing data id. It doesn't create
     * a new data id, only increments the ref count used in memory tracking.
     * @deprecated
     */ makeTensorFromDataId(dataId, shape, dtype, backend) {
        dtype = dtype || 'float32';
        const tensorInfo = {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
        return this.makeTensorFromTensorInfo(tensorInfo, backend);
    }
    /**
     * Internal method used by backends. Makes a new tensor that is a wrapper
     * around an existing data id in TensorInfo. It doesn't create a new data id,
     * only increments the ref count used in memory tracking.
     */ makeTensorFromTensorInfo(tensorInfo, backend) {
        const { dataId: dataId, shape: shape, dtype: dtype } = tensorInfo;
        const t = new (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        return t;
    }
    makeVariable(initialValue, trainable = true, name, dtype) {
        name = name || this.nextVariableId().toString();
        if (dtype != null && dtype !== initialValue.dtype) initialValue = initialValue.cast(dtype);
        const v = new (0, $4b7222b1b59444b8$export$c867a5c9595a1350)(initialValue, trainable, name, this.nextTensorId());
        if (this.state.registeredVariables[v.name] != null) throw new Error(`Variable with name ${v.name} was already registered`);
        this.state.registeredVariables[v.name] = v;
        this.incRef(v, this.backend);
        return v;
    }
    trackTensor(a, backend) {
        this.state.numTensors++;
        if (a.dtype === 'string') this.state.numStringTensors++;
        // Bytes for complex numbers are counted by their components. Bytes for
        // string tensors are counted when writing values.
        let bytes = 0;
        if (a.dtype !== 'complex64' && a.dtype !== 'string') bytes = a.size * $9e4a6174e3538e7d$export$3f355ce86503b89f(a.dtype);
        this.state.numBytes += bytes;
        if (!this.state.tensorInfo.has(a.dataId)) {
            this.state.numDataBuffers++;
            this.state.tensorInfo.set(a.dataId, {
                backend: backend || this.backend,
                dtype: a.dtype,
                shape: a.shape,
                bytes: bytes
            });
        }
        if (!(a instanceof (0, $4b7222b1b59444b8$export$c867a5c9595a1350))) this.track(a);
    }
    // Track the tensor by dataId and increase the refCount for the dataId in the
    // backend.
    // TODO(pyu10055): This is currently used by makeVariable method, to increase
    // refCount on the backend for the dataId. It can potentially be replaced with
    // Identity op indead of calling backend directly.
    incRef(a, backend) {
        this.trackTensor(a, backend);
        this.backend.incRef(a.dataId);
    }
    removeDataId(dataId, backend) {
        if (this.state.tensorInfo.has(dataId) && this.state.tensorInfo.get(dataId).backend === backend) {
            this.state.tensorInfo.delete(dataId);
            this.state.numDataBuffers--;
        }
    }
    disposeTensor(a) {
        if (!this.state.tensorInfo.has(a.dataId)) return;
        const info = this.state.tensorInfo.get(a.dataId);
        this.state.numTensors--;
        if (a.dtype === 'string') {
            this.state.numStringTensors--;
            this.state.numBytes -= info.bytes;
        }
        // Don't count bytes for complex numbers as they are counted by their
        // components.
        if (a.dtype !== 'complex64' && a.dtype !== 'string') {
            const bytes = a.size * $9e4a6174e3538e7d$export$3f355ce86503b89f(a.dtype);
            this.state.numBytes -= bytes;
        }
        // Remove the reference to dataId if backend dispose the data successfully
        if (info.backend.disposeData(a.dataId)) this.removeDataId(a.dataId, info.backend);
    // TODO(nsthorat): Construct an error and save the stack trace for
    // debugging when in debug mode. Creating a stack trace is too expensive
    // to do unconditionally.
    }
    disposeVariables() {
        for(const varName in this.state.registeredVariables){
            const v = this.state.registeredVariables[varName];
            this.disposeVariable(v);
        }
    }
    disposeVariable(v) {
        this.disposeTensor(v);
        if (this.state.registeredVariables[v.name] != null) delete this.state.registeredVariables[v.name];
    }
    memory() {
        const info = this.backend.memory();
        info.numTensors = this.state.numTensors;
        info.numDataBuffers = this.state.numDataBuffers;
        info.numBytes = this.state.numBytes;
        if (this.state.numStringTensors > 0) {
            info.unreliable = true;
            if (info.reasons == null) info.reasons = [];
            info.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)");
        }
        return info;
    }
    async profile(query) {
        this.state.profiling = true;
        const startBytes = this.state.numBytes;
        const startNumTensors = this.state.numTensors;
        this.state.activeProfile.kernels = [];
        this.state.activeProfile.result = await query();
        this.state.profiling = false;
        this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((d)=>d.totalBytesSnapshot));
        this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
        this.state.activeProfile.newTensors = this.state.numTensors - startNumTensors;
        for (const kernel of this.state.activeProfile.kernels){
            kernel.kernelTimeMs = await kernel.kernelTimeMs;
            kernel.extraInfo = await kernel.extraInfo;
        }
        return this.state.activeProfile;
    }
    isTapeOn() {
        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
    }
    addTapeNode(kernelName, inputs, outputs, gradientsFunc, saved, attrs) {
        const tapeNode = {
            id: this.state.nextTapeNodeId++,
            kernelName: kernelName,
            inputs: inputs,
            outputs: outputs,
            saved: saved
        };
        const gradConfig = (0, $071cf1fd9dc2117e$export$e14995d3ec1747ee)(kernelName);
        if (gradConfig != null) gradientsFunc = gradConfig.gradFunc;
        if (gradientsFunc != null) tapeNode.gradient = (dys)=>{
            // TODO(smilkov): To optimize back-prop, pass dys that are not used in
            // the backprop graph to the user as null instead of zeros
            dys = dys.map((dy, i)=>{
                if (dy == null) {
                    const output = outputs[i];
                    const vals = $9e4a6174e3538e7d$export$edbc8aedac4e036f(output.size, output.dtype);
                    return this.makeTensor(vals, output.shape, output.dtype);
                }
                return dy;
            });
            // Grad functions of ops with single outputs expect a dy, while ops
            // with multiple outputs expect dys (array of dy).
            return gradientsFunc(dys.length > 1 ? dys : dys[0], saved, attrs);
        };
        this.state.activeTape.push(tapeNode);
    }
    keep(result) {
        result.kept = true;
        return result;
    }
    startTape() {
        if (this.state.gradientDepth === 0) this.state.activeTape = [];
        this.state.gradientDepth++;
    }
    endTape() {
        this.state.gradientDepth--;
    }
    /**
     * Start a scope. Use this with endScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ startScope(name) {
        const scopeInfo = {
            track: [],
            name: 'unnamed scope',
            id: this.state.nextScopeId++
        };
        if (name) scopeInfo.name = name;
        this.state.scopeStack.push(scopeInfo);
        this.state.activeScope = scopeInfo;
    }
    /**
     * End a scope. Use this with startScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ endScope(result) {
        const tensorsToTrackInParent = (0, $186e2a8efb04b468$export$888c106d343989f5)(result);
        const tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map((t)=>t.id));
        // Dispose the arrays tracked in this scope.
        for(let i = 0; i < this.state.activeScope.track.length; i++){
            const tensor = this.state.activeScope.track[i];
            if (!tensor.kept && !tensorsToTrackInParentSet.has(tensor.id)) tensor.dispose();
        }
        const oldScope = this.state.scopeStack.pop();
        this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1];
        // Track the current result in the parent scope.
        tensorsToTrackInParent.forEach((tensor)=>{
            // Only track the tensor if was allocated in the inner scope and is not
            // globally kept.
            if (!tensor.kept && tensor.scopeId === oldScope.id) this.track(tensor);
        });
    }
    /**
     * Returns gradients of `f` with respect to each of the `xs`. The gradients
     * returned are of the same length as `xs`, but some might be null if `f`
     * was not a function of that `x`. It also takes optional dy to multiply the
     * gradient, which defaults to `1`.
     */ gradients(f, xs, dy, allowNoGradients = false) {
        $9e4a6174e3538e7d$export$a7a9523472993e97(xs.length > 0, ()=>'gradients() received an empty list of xs.');
        if (dy != null && dy.dtype !== 'float32') throw new Error(`dy must have 'float32' dtype, but has '${dy.dtype}'`);
        const y = this.scopedRun(()=>this.startTape(), ()=>this.endTape(), ()=>this.tidy('forward', f));
        $9e4a6174e3538e7d$export$a7a9523472993e97(y instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814), ()=>'The result y returned by f() must be a tensor.');
        // Filter out the nodes that don't connect x => y.
        const filteredTape = (0, $e785710de6d72a0b$export$13eebbb952f0db02)(this.state.activeTape, xs, y);
        if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy('backward', ()=>{
            const accumulatedGradientMap = {};
            accumulatedGradientMap[y.id] = dy == null ? $6a645535e157b279$var$ones(y.shape) : dy;
            // Backprop gradients through the filtered nodes.
            (0, $e785710de6d72a0b$export$2992958ba0a8790d)(accumulatedGradientMap, filteredTape, // Pass the tidy function to avoid circular dep with `tape.ts`.
            (f)=>this.tidy(f), // Pass an add function to avoide a circular dep with `tape.ts`.
            $6a645535e157b279$export$e16d8520af44a096);
            const grads = xs.map((x)=>accumulatedGradientMap[x.id]);
            if (this.state.gradientDepth === 0) {
                // This means that we are not computing higher-order gradients
                // and can clean up the tape.
                this.state.activeTape.forEach((node)=>{
                    for (const tensor of node.saved)tensor.dispose();
                });
                this.state.activeTape = null;
            }
            return {
                value: y,
                grads: grads
            };
        });
    }
    customGrad(f) {
        $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(f), ()=>'The f passed in customGrad(f) must be a function.');
        return (...inputs)=>{
            $9e4a6174e3538e7d$export$a7a9523472993e97(inputs.every((t)=>t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)), ()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors");
            let res;
            const inputMap = {};
            inputs.forEach((input, i)=>{
                inputMap[i] = input;
            });
            const forwardFunc = (_, save)=>{
                res = f(...[
                    ...inputs,
                    save
                ]);
                $9e4a6174e3538e7d$export$a7a9523472993e97(res.value instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814), ()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor");
                $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(res.gradFunc), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.");
                return res.value;
            };
            const backwardsFunc = (dy, saved)=>{
                const gradRes = res.gradFunc(dy, saved);
                const grads = Array.isArray(gradRes) ? gradRes : [
                    gradRes
                ];
                $9e4a6174e3538e7d$export$a7a9523472993e97(grads.length === inputs.length, ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).");
                $9e4a6174e3538e7d$export$a7a9523472993e97(grads.every((t)=>t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
                const gradMap = {};
                grads.forEach((grad, i)=>{
                    gradMap[i] = ()=>grad;
                });
                return gradMap;
            };
            return this.runKernelFunc({
                forwardFunc: forwardFunc,
                backwardsFunc: backwardsFunc,
                inputs: inputMap
            });
        };
    }
    readSync(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readSync(dataId);
    }
    read(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.read(dataId);
    }
    readToGPU(dataId, options) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readToGPU(dataId, options);
    }
    async time(query) {
        const start = (0, $0775da5e684c8c0d$export$461939dd4422153)();
        const timingInfo = await this.backend.time(query);
        timingInfo.wallMs = (0, $0775da5e684c8c0d$export$461939dd4422153)() - start;
        return timingInfo;
    }
    /**
     * Tracks a Tensor in the current scope to be automatically cleaned up
     * when the current scope ends, and returns the value.
     *
     * @param result The Tensor to track in the current scope.
     */ track(result) {
        if (this.state.activeScope != null) {
            result.scopeId = this.state.activeScope.id;
            this.state.activeScope.track.push(result);
        }
        return result;
    }
    get registeredVariables() {
        return this.state.registeredVariables;
    }
    /**
     * Resets the engine state. Removes all backends but does not remove
     * registered backend factories.
     */ reset() {
        // Make any pending promise obsolete.
        this.pendingBackendInitId++;
        this.state.dispose();
        this.ENV.reset();
        this.state = new $6a645535e157b279$var$EngineState();
        for(const backendName in this.registry){
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        this.backendName = null;
        this.backendInstance = null;
        this.pendingBackendInit = null;
    }
}
$6a645535e157b279$export$2c3b404bf3a77a1f.nextTensorId = 0;
$6a645535e157b279$export$2c3b404bf3a77a1f.nextVariableId = 0;
function $6a645535e157b279$var$ones(shape) {
    const values = (0, $9e4a6174e3538e7d$export$b915f681a907ae99)((0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape), 'float32');
    return $6a645535e157b279$export$33b63313cc511a3b.makeTensor(values, shape, 'float32');
}
function $6a645535e157b279$export$ca8737f6c8c212b8() {
    const ns = (0, $edf795347656fd15$export$5054b240ae6849b7)();
    if (ns._tfengine == null) {
        const environment = new (0, $339e95daf833709b$export$7dc6752a22ab011a)(ns);
        ns._tfengine = new $6a645535e157b279$export$2c3b404bf3a77a1f(environment);
    }
    (0, $339e95daf833709b$export$3ef32a49eeda04cc)(ns._tfengine.ENV);
    // Tell the current tensor interface that the global engine is responsible
    // for tracking.
    (0, $4b7222b1b59444b8$export$b1e34d2f0ffbbd85)(()=>ns._tfengine);
    return ns._tfengine;
}
const $6a645535e157b279$export$33b63313cc511a3b = $6a645535e157b279$export$ca8737f6c8c212b8();
function $6a645535e157b279$export$e16d8520af44a096(a, b) {
    // We duplicate Add here to avoid a circular dependency with add.ts.
    const inputs = {
        a: a,
        b: b
    };
    return $6a645535e157b279$export$33b63313cc511a3b.runKernel((0, $507890e4aa8e1463$export$d0265b2c425512d6), inputs);
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $0479127e9813c50e$exports = {};

$parcel$export($0479127e9813c50e$exports, "mockIsMobile", () => $0479127e9813c50e$export$f55f7bd5cb259cb2);
$parcel$export($0479127e9813c50e$exports, "isMobile", () => $0479127e9813c50e$export$d0a8044dce8ff2fc);
$parcel$export($0479127e9813c50e$exports, "isBrowser", () => $0479127e9813c50e$export$4e09c449d6c407f7);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line:no-any
function $0479127e9813c50e$var$_isNavigatorDefined() {
    return typeof navigator !== 'undefined' && navigator != null;
}
let $0479127e9813c50e$var$isMobileMockValue;
function $0479127e9813c50e$export$f55f7bd5cb259cb2(value) {
    $0479127e9813c50e$var$isMobileMockValue = value;
}
function $0479127e9813c50e$export$d0a8044dce8ff2fc(nav) {
    if ($0479127e9813c50e$var$isMobileMockValue !== undefined) return $0479127e9813c50e$var$isMobileMockValue;
    if (nav || $0479127e9813c50e$var$_isNavigatorDefined()) {
        if (!nav) nav = navigator;
        if (nav.product === 'ReactNative') return true;
        const a = nav.userAgent || nav.vendor || // tslint:disable-next-line:no-any
        (typeof window !== 'undefined' ? window.opera : '');
        // Use `navigator.userAgentData.mobile` as fallback.
        if (!a) {
            // tslint:disable-next-line:no-any
            const navAny = nav;
            return navAny.userAgentData && navAny.userAgentData.mobile;
        }
        // tslint:disable-next-line:max-line-length
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || // tslint:disable-next-line:max-line-length
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
    }
    return false;
}
function $0479127e9813c50e$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' && window.document != null || //@ts-ignore
    typeof WorkerGlobalScope !== 'undefined';
}



const $d4c303731399160a$var$ENV = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)();
/**
 * This file contains environment-related flag registrations.
 */ /** Whether to enable debug mode. */ $d4c303731399160a$var$ENV.registerFlag('DEBUG', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
});
/** Whether we are in a browser (as versus, say, node.js) environment. */ $d4c303731399160a$var$ENV.registerFlag('IS_BROWSER', ()=>$0479127e9813c50e$export$4e09c449d6c407f7());
/** Whether we are in a browser (as versus, say, node.js) environment. */ $d4c303731399160a$var$ENV.registerFlag('IS_NODE', ()=>false);
/** Whether this browser is Chrome. */ $d4c303731399160a$var$ENV.registerFlag('IS_CHROME', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
/** Whether this browser is Safari. */ $d4c303731399160a$var$ENV.registerFlag('IS_SAFARI', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor));
/**
 * True when the environment is "production" where we disable safety checks
 * to gain performance.
 */ $d4c303731399160a$var$ENV.registerFlag('PROD', ()=>false);
/**
 * Whether to do sanity checks when inferring a shape from user-provided
 * values, used when creating a new tensor.
 */ $d4c303731399160a$var$ENV.registerFlag('TENSORLIKE_CHECK_SHAPE_CONSISTENCY', ()=>$d4c303731399160a$var$ENV.getBool('DEBUG'));
/** Whether deprecation warnings are enabled. */ $d4c303731399160a$var$ENV.registerFlag('DEPRECATION_WARNINGS_ENABLED', ()=>true);
/** True if running unit tests. */ $d4c303731399160a$var$ENV.registerFlag('IS_TEST', ()=>false);
/** Whether to check computation result for errors. */ $d4c303731399160a$var$ENV.registerFlag('CHECK_COMPUTATION_FOR_ERRORS', ()=>$d4c303731399160a$var$ENV.getBool('DEBUG'));
/** Whether the backend needs to wrap input to imageBitmap. */ $d4c303731399160a$var$ENV.registerFlag('WRAP_TO_IMAGEBITMAP', ()=>false);
/** Whether to enable canvas2d willReadFrequently for GPU backends */ $d4c303731399160a$var$ENV.registerFlag('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU', ()=>false);
/** Whether to use setTimeoutCustom */ $d4c303731399160a$var$ENV.registerFlag('USE_SETTIMEOUTCUSTOM', ()=>false);


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





function $539f0ce07f2139cd$export$467a8ad638b9ad20(val, dtype) {
    let firstElem = val;
    if ((0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(val)) return dtype === 'string' ? [] : [
        val.length
    ];
    if ((0, $4ccb7c1368387e67$export$12371c78da2a116a)(val)) {
        const usedChannels = val.channels || 'RGBA';
        return [
            val.height,
            val.width * usedChannels.length
        ];
    } else if ((0, $4ccb7c1368387e67$export$db4071ca636ae03b)(val)) return [
        val.buffer.size / (dtype == null ? 4 : (0, $9e4a6174e3538e7d$export$3f355ce86503b89f)(dtype))
    ];
    if (!Array.isArray(val)) return []; // Scalar.
    const shape = [];
    while(Array.isArray(firstElem) || (0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(firstElem) && dtype !== 'string'){
        shape.push(firstElem.length);
        firstElem = firstElem[0];
    }
    if (Array.isArray(val) && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('TENSORLIKE_CHECK_SHAPE_CONSISTENCY')) $539f0ce07f2139cd$var$deepAssertShapeConsistency(val, shape, []);
    return shape;
}
function $539f0ce07f2139cd$var$deepAssertShapeConsistency(val, shape, indices) {
    indices = indices || [];
    if (!Array.isArray(val) && !(0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(val)) {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(shape.length === 0, ()=>`Element arr[${indices.join('][')}] is a primitive, ` + `but should be an array/TypedArray of ${shape[0]} elements`);
        return;
    }
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(shape.length > 0, ()=>`Element arr[${indices.join('][')}] should be a primitive, ` + `but is an array of ${val.length} elements`);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(val.length === shape[0], ()=>`Element arr[${indices.join('][')}] should have ${shape[0]} ` + `elements, but has ${val.length} elements`);
    const subShape = shape.slice(1);
    for(let i = 0; i < val.length; ++i)$539f0ce07f2139cd$var$deepAssertShapeConsistency(val[i], subShape, indices.concat(i));
}
function $539f0ce07f2139cd$var$assertDtype(expectedDtype, actualDType, argName, functionName) {
    if (expectedDtype === 'string_or_numeric') return;
    if (expectedDtype == null) throw new Error(`Expected dtype cannot be null.`);
    if (expectedDtype !== 'numeric' && expectedDtype !== actualDType || expectedDtype === 'numeric' && actualDType === 'string') throw new Error(`Argument '${argName}' passed to '${functionName}' must ` + `be ${expectedDtype} tensor, but got ${actualDType} tensor`);
}
function $539f0ce07f2139cd$export$ede379c4c939d71a(x, argName, functionName, parseAsDtype = 'numeric') {
    if (x instanceof (0, $4b7222b1b59444b8$export$3cbd87e9d6a9b7ac)()) {
        $539f0ce07f2139cd$var$assertDtype(parseAsDtype, x.dtype, argName, functionName);
        return x;
    }
    let inferredDtype = (0, $9e4a6174e3538e7d$export$2005775d905d2dc2)(x);
    // If the user expects a bool/int/float, use that info to update the
    // inferredDtype when it is not a string.
    if (inferredDtype !== 'string' && [
        'bool',
        'int32',
        'float32'
    ].indexOf(parseAsDtype) >= 0) inferredDtype = parseAsDtype;
    $539f0ce07f2139cd$var$assertDtype(parseAsDtype, inferredDtype, argName, functionName);
    if (x == null || !(0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(x) && !Array.isArray(x) && typeof x !== 'number' && typeof x !== 'boolean' && typeof x !== 'string') {
        const type = x == null ? 'null' : x.constructor.name;
        throw new Error(`Argument '${argName}' passed to '${functionName}' must be a ` + `Tensor or TensorLike, but got '${type}'`);
    }
    const inferredShape = $539f0ce07f2139cd$export$467a8ad638b9ad20(x, inferredDtype);
    if (!(0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(x) && !Array.isArray(x)) x = [
        x
    ];
    const skipTypedArray = true;
    const values = inferredDtype !== 'string' ? (0, $0775da5e684c8c0d$export$965adc581230795c)(x, inferredDtype) : (0, $0775da5e684c8c0d$export$bffa455ba8c619a6)(x, [], skipTypedArray);
    return (0, $6a645535e157b279$export$33b63313cc511a3b).makeTensor(values, inferredShape, inferredDtype);
}
function $539f0ce07f2139cd$export$758e66616b4d410b(arg, argName, functionName, parseAsDtype = 'numeric') {
    if (!Array.isArray(arg)) throw new Error(`Argument ${argName} passed to ${functionName} must be a ` + '`Tensor[]` or `TensorLike[]`');
    const tensors = arg;
    return tensors.map((t, i)=>$539f0ce07f2139cd$export$ede379c4c939d71a(t, `${argName}[${i}]`, functionName, parseAsDtype));
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $90f933163f6ac994$export$93114f1494faf9bb = '__op';
function $90f933163f6ac994$export$f59964a629598e2(f) {
    const keys = Object.keys(f);
    if (keys.length !== 1) throw new Error(`Please provide an object with a single key ` + `(operation name) mapping to a function. Got an object with ` + `${keys.length} keys.`);
    let opName = keys[0];
    const fn = f[opName];
    // Strip the underscore from the end of the function name.
    if (opName.endsWith('_')) opName = opName.substring(0, opName.length - 1);
    // add an __op suffix to distinguish ops from kernels in tf.profile
    opName = opName + $90f933163f6ac994$export$93114f1494faf9bb;
    // tslint:disable-next-line:no-any
    const f2 = (...args)=>{
        (0, $6a645535e157b279$export$33b63313cc511a3b).startScope(opName);
        try {
            const result = fn(...args);
            if ((0, $9e4a6174e3538e7d$export$4369c812aac99591)(result)) console.error('Cannot return a Promise inside of tidy.');
            (0, $6a645535e157b279$export$33b63313cc511a3b).endScope(result);
            return result;
        } catch (ex) {
            (0, $6a645535e157b279$export$33b63313cc511a3b).endScope(null);
            throw ex;
        }
    };
    Object.defineProperty(f2, 'name', {
        value: opName,
        configurable: true
    });
    // tslint:disable-next-line:no-any
    return f2;
}


/**
 * Converts two real numbers to a complex number.
 *
 * Given a tensor `real` representing the real part of a complex number, and a
 * tensor `imag` representing the imaginary part of a complex number, this
 * operation returns complex numbers elementwise of the form [r0, i0, r1, i1],
 * where r represents the real part and i represents the imag part.
 *
 * The input tensors real and imag must have the same shape.
 *
 * ```js
 * const real = tf.tensor1d([2.25, 3.25]);
 * const imag = tf.tensor1d([4.75, 5.75]);
 * const complex = tf.complex(real, imag);
 *
 * complex.print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $974747594bfdbaee$var$complex_(real, imag) {
    const $real = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(real, 'real', 'complex');
    const $imag = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(imag, 'imag', 'complex');
    $9e4a6174e3538e7d$export$e08b27e7f37e2782($real.shape, $imag.shape, `real and imag shapes, ${$real.shape} and ${$imag.shape}, ` + `must match in call to tf.complex().`);
    const inputs = {
        real: $real,
        imag: $imag
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$50ceb3fb9926e63e), inputs);
}
const $974747594bfdbaee$export$83a0e34f1302825b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    complex_: $974747594bfdbaee$var$complex_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $0d6d4026377c0979$export$f41686c891d7ebce(values, shape, inferredShape, dtype) {
    if (dtype == null) dtype = (0, $9e4a6174e3538e7d$export$2005775d905d2dc2)(values);
    else if (dtype === 'complex64') throw new Error(`Cannot construct a complex64 tensor directly. ` + `Please use tf.complex(real, imag).`);
    if ((0, $4ccb7c1368387e67$export$db4071ca636ae03b)(values) || (0, $4ccb7c1368387e67$export$12371c78da2a116a)(values)) {
        if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Creating tensor from GPU data only supports ` + `'float32'|'int32' dtype, while the dtype is ${dtype}.`);
        return (0, $6a645535e157b279$export$33b63313cc511a3b).backend.createTensorFromGPUData(values, shape || inferredShape, dtype);
    }
    if (!(0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(values) && !Array.isArray(values) && typeof values !== 'number' && typeof values !== 'boolean' && typeof values !== 'string') throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    // Verify that the shape matches the inferred shape.
    if (shape != null) {
        (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
        const providedSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape);
        const inferredSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(inferredShape);
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(providedSize === inferredSize, ()=>`Based on the provided shape, [${shape}], the tensor should have ` + `${providedSize} values but has ${inferredSize}`);
        for(let i = 0; i < inferredShape.length; ++i){
            const inferred = inferredShape[i];
            const flatDimsDontMatch = i === inferredShape.length - 1 ? inferred !== (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape.slice(i)) : true;
            (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(inferredShape[i] === shape[i] || !flatDimsDontMatch, ()=>`Error creating a new Tensor. Inferred shape ` + `(${inferredShape}) does not match the provided ` + `shape (${shape}). `);
        }
    }
    if (!(0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(values) && !Array.isArray(values)) values = [
        values
    ];
    shape = shape || inferredShape;
    values = dtype !== 'string' ? (0, $0775da5e684c8c0d$export$965adc581230795c)(values, dtype) : (0, $0775da5e684c8c0d$export$bffa455ba8c619a6)(values, [], true);
    return (0, $6a645535e157b279$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}


function $141b1f68c03d4acb$export$65df3ad1ad888abb(values, shape, dtype) {
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /* Type definitions for exporting and importing of models. */ /**
 * A map from Tensor dtype to number of bytes per element of the Tensor.
 */ const $aa89193df21f6c84$export$8103dee73e5eaa46 = {
    'float32': 4,
    'float16': 2,
    'int32': 4,
    'uint16': 2,
    'uint8': 1,
    'bool': 1,
    'complex64': 8
};



class $dfd620ba1104fd6f$export$fd7a5551e5344016 {
    /**
     * Concatenate a number of ArrayBuffers into one.
     *
     * @param buffers An array of ArrayBuffers to concatenate, or a single
     *     ArrayBuffer.
     * @returns Result of concatenating `buffers` in order.
     */ static join(buffers) {
        return new $dfd620ba1104fd6f$export$fd7a5551e5344016(buffers).slice();
    }
    constructor(buffers){
        this.shards = [];
        this.previousShardIndex = 0;
        if (buffers == null) return;
        // Normalize the `buffers` input to be `ArrayBuffer[]`.
        if (!(buffers instanceof Array)) buffers = [
            buffers
        ];
        buffers = buffers.map((bufferOrTypedArray)=>{
            if ($0775da5e684c8c0d$export$b119cc7e1840e59c(bufferOrTypedArray)) return bufferOrTypedArray.buffer;
            return bufferOrTypedArray;
        });
        // Skip setting up shards if there are no buffers.
        if (buffers.length === 0) return;
        this.bufferUniformSize = buffers[0].byteLength;
        let start = 0;
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            // Check that all buffers except the last one have the same length.
            if (i !== buffers.length - 1 && buffer.byteLength !== this.bufferUniformSize) // Unset the buffer uniform size, since the buffer sizes are not
            // uniform.
            this.bufferUniformSize = undefined;
            // Create the shards, including their start and end points.
            const end = start + buffer.byteLength;
            this.shards.push({
                buffer: buffer,
                start: start,
                end: end
            });
            start = end;
        }
        // Set the byteLength
        if (this.shards.length === 0) this.byteLength = 0;
        this.byteLength = this.shards[this.shards.length - 1].end;
    }
    slice(start = 0, end = this.byteLength) {
        // If there are no shards, then the CompositeArrayBuffer was initialized
        // with no data.
        if (this.shards.length === 0) return new ArrayBuffer(0);
        // NaN is treated as zero for slicing. This matches ArrayBuffer's behavior.
        start = isNaN(Number(start)) ? 0 : start;
        end = isNaN(Number(end)) ? 0 : end;
        // Fix the bounds to within the array.
        start = Math.max(0, start);
        end = Math.min(this.byteLength, end);
        if (end <= start) return new ArrayBuffer(0);
        const startShardIndex = this.findShardForByte(start);
        if (startShardIndex === -1) // This should not happen since the start and end indices are always
        // within 0 and the composite array's length.
        throw new Error(`Could not find start shard for byte ${start}`);
        const size = end - start;
        const outputBuffer = new ArrayBuffer(size);
        const outputArray = new Uint8Array(outputBuffer);
        let sliced = 0;
        for(let i = startShardIndex; i < this.shards.length; i++){
            const shard = this.shards[i];
            const globalStart = start + sliced;
            const localStart = globalStart - shard.start;
            const outputStart = sliced;
            const globalEnd = Math.min(end, shard.end);
            const localEnd = globalEnd - shard.start;
            const outputSlice = new Uint8Array(shard.buffer, localStart, localEnd - localStart);
            outputArray.set(outputSlice, outputStart);
            sliced += outputSlice.length;
            if (end < shard.end) break;
        }
        return outputBuffer;
    }
    /**
     * Get the index of the shard that contains the byte at `byteIndex`.
     */ findShardForByte(byteIndex) {
        if (this.shards.length === 0 || byteIndex < 0 || byteIndex >= this.byteLength) return -1;
        // If the buffers have a uniform size, compute the shard directly.
        if (this.bufferUniformSize != null) {
            this.previousShardIndex = Math.floor(byteIndex / this.bufferUniformSize);
            return this.previousShardIndex;
        }
        // If the buffers don't have a uniform size, we need to search for the
        // shard. That means we need a function to check where the byteIndex lies
        // relative to a given shard.
        function check(shard) {
            if (byteIndex < shard.start) return -1;
            if (byteIndex >= shard.end) return 1;
            return 0;
        }
        // For efficiency, try the previous shard first.
        if (check(this.shards[this.previousShardIndex]) === 0) return this.previousShardIndex;
        // Otherwise, use a generic search function.
        // This should almost never end up being used in practice since the weight
        // entries should always be in order.
        const index = $dfd620ba1104fd6f$export$d76128d007d19019(this.shards, check);
        if (index === -1) return -1;
        this.previousShardIndex = index;
        return this.previousShardIndex;
    }
}
function $dfd620ba1104fd6f$export$d76128d007d19019(sortedArray, compare) {
    // Binary search
    let min = 0;
    let max = sortedArray.length;
    while(min <= max){
        const middle = Math.floor((max - min) / 2) + min;
        const side = compare(sortedArray[middle]);
        if (side === 0) return middle;
        else if (side < 0) max = middle;
        else min = middle + 1;
    }
    return -1;
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $8a461ef06e070cc9$export$1e73b1267274f27e() {
    (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set('PROD', true);
}
function $8a461ef06e070cc9$export$ef8a131e8a882a3a() {
    (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set('DEBUG', true);
}
function $8a461ef06e070cc9$export$cb100329fdb11914() {
    (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set('DEPRECATION_WARNINGS_ENABLED', false);
    console.warn(`TensorFlow.js deprecation warnings have been disabled.`);
}
function $8a461ef06e070cc9$export$e46eea6a629d2da5(msg) {
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEPRECATION_WARNINGS_ENABLED')) console.warn(msg + ' You can disable deprecation warnings with ' + 'tf.disableDeprecationWarnings().');
}
(0, $4b7222b1b59444b8$export$ca605c1d8919649f)($8a461ef06e070cc9$export$e46eea6a629d2da5);
function $8a461ef06e070cc9$export$f22ce7a2fa538c48() {
    (0, $6a645535e157b279$export$33b63313cc511a3b).disposeVariables();
}
function $8a461ef06e070cc9$export$d3c662a6136faebb() {
    return 0, $6a645535e157b279$export$33b63313cc511a3b;
}
function $8a461ef06e070cc9$export$827b61424e8f52d2() {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).memory();
}
function $8a461ef06e070cc9$export$4882ae973e0491e(f) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).profile(f);
}
function $8a461ef06e070cc9$export$b841c6a213a653eb(nameOrFn, fn) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).tidy(nameOrFn, fn);
}
function $8a461ef06e070cc9$export$fcfbbcec2cb820d5(container) {
    const tensors = (0, $186e2a8efb04b468$export$888c106d343989f5)(container);
    tensors.forEach((tensor)=>tensor.dispose());
}
function $8a461ef06e070cc9$export$fae3166c418e0471(result) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).keep(result);
}
function $8a461ef06e070cc9$export$2da9be4cfdb689b1(f) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).time(f);
}
function $8a461ef06e070cc9$export$7953970fabc9c2(backendName) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).setBackend(backendName);
}
function $8a461ef06e070cc9$export$28ee1007e174a2a6() {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).ready();
}
function $8a461ef06e070cc9$export$b098501f764cdf30() {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).backendName;
}
function $8a461ef06e070cc9$export$c299110fbe92c80c(name) {
    (0, $6a645535e157b279$export$33b63313cc511a3b).removeBackend(name);
}
function $8a461ef06e070cc9$export$f94fbc07ea8e852e(name) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).findBackend(name);
}
function $8a461ef06e070cc9$export$e4a6d214466a2c7b(name) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).findBackendFactory(name);
}
function $8a461ef06e070cc9$export$1ac8c3a90eff05d(name, factory, priority = 1) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).registerBackend(name, factory, priority);
}
function $8a461ef06e070cc9$export$32a253b6f8b50fb4() {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).backend;
}
function $8a461ef06e070cc9$export$5f05d56a0f2349cc(platformName, platform) {
    (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().setPlatform(platformName, platform);
}




var $cbQCu = parcelRequire("cbQCu");
var $6b95449a1ec560d1$require$Buffer = $cbQCu.Buffer;
/** Number of bytes reserved for the length of the string. (32bit integer). */ const $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH = 4;
async function $6b95449a1ec560d1$export$6c50c12dbd6168b(tensors, group) {
    // TODO(adarob, cais): Support quantization.
    const specs = [];
    const dataPromises = [];
    const names = Array.isArray(tensors) ? tensors.map((tensor)=>tensor.name) : Object.keys(tensors);
    for(let i = 0; i < names.length; ++i){
        const name = names[i];
        const t = Array.isArray(tensors) ? tensors[i].tensor : tensors[name];
        if (t.dtype !== 'float32' && t.dtype !== 'int32' && t.dtype !== 'bool' && t.dtype !== 'string' && t.dtype !== 'complex64') throw new Error(`Unsupported dtype in weight '${name}': ${t.dtype}`);
        const spec = {
            name: name,
            shape: t.shape,
            dtype: t.dtype
        };
        if (t.dtype === 'string') {
            const utf8bytes = new Promise(async (resolve)=>{
                const vals = await t.bytes();
                const totalNumBytes = vals.reduce((p, c)=>p + c.length, 0) + $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH * vals.length;
                const bytes = new Uint8Array(totalNumBytes);
                let offset = 0;
                for(let i = 0; i < vals.length; i++){
                    const val = vals[i];
                    const bytesOfLength = new Uint8Array(new Uint32Array([
                        val.length
                    ]).buffer);
                    bytes.set(bytesOfLength, offset);
                    offset += $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH;
                    bytes.set(val, offset);
                    offset += val.length;
                }
                resolve(bytes);
            });
            dataPromises.push(utf8bytes);
        } else dataPromises.push(t.data());
        if (group != null) spec.group = group;
        specs.push(spec);
    }
    const tensorValues = await Promise.all(dataPromises);
    return {
        data: $6b95449a1ec560d1$export$b9f790e5e2031778(tensorValues),
        specs: specs
    };
}
function $6b95449a1ec560d1$export$7a14c2428d4f4a2e(weightData, specs) {
    // TODO(adarob, cais): Support quantization.
    const compositeBuffer = new (0, $dfd620ba1104fd6f$export$fd7a5551e5344016)(weightData);
    const out = {};
    let offset = 0;
    for (const spec of specs){
        const byteLength = $6b95449a1ec560d1$var$getWeightBytelength(spec, (start, end)=>{
            return compositeBuffer.slice(offset + start, offset + end);
        });
        out[spec.name] = $6b95449a1ec560d1$var$decodeWeight(spec, compositeBuffer.slice(offset, offset + byteLength));
        offset += byteLength;
    }
    return out;
}
function $6b95449a1ec560d1$var$getWeightBytelength(spec, slice) {
    const size = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(slice(byteLength, byteLength + $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[spec.dtype];
    return size * bytesPerValue;
}
async function $6b95449a1ec560d1$var$getWeightBytelengthAsync(spec, slice) {
    const size = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(await slice(byteLength, byteLength + $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[spec.dtype];
    return size * bytesPerValue;
}
function $6b95449a1ec560d1$var$decodeWeight(spec, byteBuffer) {
    const name = spec.name;
    const dtype = spec.dtype;
    const shape = spec.shape;
    const size = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape);
    let values;
    let offset = 0;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
            if (!('min' in quantization && 'scale' in quantization)) throw new Error(`Weight ${spec.name} with quantization ${quantization.dtype} ` + `doesn't have corresponding metadata min and scale.`);
        } else if (quantization.dtype === 'float16') {
            if (dtype !== 'float32') throw new Error(`Weight ${spec.name} is quantized with ${quantization.dtype} ` + `which only supports weights of type float32 not ${dtype}.`);
        } else throw new Error(`Weight ${spec.name} has unknown ` + `quantization dtype ${quantization.dtype}. ` + `Supported quantization dtypes are: ` + `'uint8', 'uint16', and 'float16'.`);
        const quantizationSizeFactor = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[quantization.dtype];
        const quantizedArray = quantization.dtype === 'uint8' ? new Uint8Array(byteBuffer) : new Uint16Array(byteBuffer);
        if (dtype === 'float32') {
            if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
                values = new Float32Array(quantizedArray.length);
                for(let i = 0; i < quantizedArray.length; i++){
                    const v = quantizedArray[i];
                    values[i] = v * quantization.scale + quantization.min;
                }
            } else if (quantization.dtype === 'float16') {
                // TODO: This is inefficient. Make getFloat16Decoder efficient.
                const float16Decode = $6b95449a1ec560d1$export$6f94974d2b5810f7();
                values = float16Decode(quantizedArray);
            } else throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type float32.`);
        } else if (dtype === 'int32') {
            if (quantization.dtype !== 'uint8' && quantization.dtype !== 'uint16') throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type int32.`);
            values = new Int32Array(quantizedArray.length);
            for(let i = 0; i < quantizedArray.length; i++){
                const v = quantizedArray[i];
                values[i] = Math.round(v * quantization.scale + quantization.min);
            }
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * quantizationSizeFactor;
    } else if (dtype === 'string') {
        const size = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(spec.shape);
        values = [];
        for(let i = 0; i < size; i++){
            const byteLength = new Uint32Array(byteBuffer.slice(offset, offset + $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH))[0];
            offset += $6b95449a1ec560d1$var$NUM_BYTES_STRING_LENGTH;
            const bytes = new Uint8Array(byteBuffer.slice(offset, offset + byteLength));
            values.push(bytes);
            offset += byteLength;
        }
    } else {
        const dtypeFactor = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[dtype];
        if (dtype === 'float32') values = new Float32Array(byteBuffer);
        else if (dtype === 'int32') values = new Int32Array(byteBuffer);
        else if (dtype === 'bool') values = new Uint8Array(byteBuffer);
        else if (dtype === 'complex64') {
            values = new Float32Array(byteBuffer);
            const real = new Float32Array(values.length / 2);
            const image = new Float32Array(values.length / 2);
            for(let i = 0; i < real.length; i++){
                real[i] = values[i * 2];
                image[i] = values[i * 2 + 1];
            }
            const realTensor = (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)(real, shape, 'float32');
            const imageTensor = (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)(image, shape, 'float32');
            const complexTensor = (0, $974747594bfdbaee$export$83a0e34f1302825b)(realTensor, imageTensor);
            realTensor.dispose();
            imageTensor.dispose();
            return complexTensor;
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * dtypeFactor;
    }
    return (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)(values, shape, dtype);
}
async function $6b95449a1ec560d1$var$readToLength(reader, initialData, length) {
    let data = new Uint8Array(initialData);
    while(data.byteLength < length){
        const { done: done, value: value } = await reader.read();
        if (done && value == null) {
            const missing = length - data.byteLength;
            throw new Error(`Reader is done but ${missing} bytes are still expected`);
        }
        // TODO: Don't create a new array every loop.
        const newData = new Uint8Array(data.length + value.byteLength);
        newData.set(data, 0);
        newData.set(new Uint8Array(value), data.length);
        data = newData;
    }
    return data.buffer;
}
async function $6b95449a1ec560d1$export$6c19531ae9ba1204(weightStream, specs) {
    const tensors = {};
    const reader = weightStream.getReader();
    let data = new ArrayBuffer(0);
    for (const spec of specs){
        const byteLength = await $6b95449a1ec560d1$var$getWeightBytelengthAsync(spec, async (start, end)=>{
            data = await $6b95449a1ec560d1$var$readToLength(reader, data, end);
            return data.slice(start, end);
        });
        data = await $6b95449a1ec560d1$var$readToLength(reader, data, byteLength);
        // Slice the tensor out
        const tensorData = data.slice(0, byteLength);
        data = data.slice(byteLength);
        const weightTensor = $6b95449a1ec560d1$var$decodeWeight(spec, tensorData);
        tensors[spec.name] = weightTensor;
        // TODO(mattsoulanille): Better way to call uploadToGPU.
        // TODO(mattsoulanille): Make this work for webgl too.
        if ((0, $8a461ef06e070cc9$export$b098501f764cdf30)() === 'webgpu') {
            const b = (0, $8a461ef06e070cc9$export$32a253b6f8b50fb4)();
            if ('uploadToGPU' in b && (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(weightTensor.shape) >= (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD')) b.uploadToGPU(weightTensor.dataId);
        }
    }
    return tensors;
}
function $6b95449a1ec560d1$export$b9f790e5e2031778(xs) {
    // TODO(adarob, cais): Support quantization.
    if (xs === null) throw new Error(`Invalid input value: ${JSON.stringify(xs)}`);
    let totalByteLength = 0;
    // `normalizedXs` is here for this reason: a `TypedArray`'s `buffer'
    // can have a different byte length from that of the `TypedArray` itself,
    // for example, when the `TypedArray` is created from an offset in an
    // `ArrayBuffer`. `normliazedXs` holds `TypedArray`s whose `buffer`s match
    // the `TypedArray` in byte length. If an element of `xs` does not show
    // this property, a new `TypedArray` that satisfy this property will be
    // constructed and pushed into `normalizedXs`.
    const normalizedXs = [];
    xs.forEach((x)=>{
        totalByteLength += x.byteLength;
        // tslint:disable:no-any
        normalizedXs.push(x.byteLength === x.buffer.byteLength ? x : new x.constructor(x));
        if (!(x instanceof Float32Array || x instanceof Int32Array || x instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${x.constructor.name}`);
    // tslint:enable:no-any
    });
    const y = new Uint8Array(totalByteLength);
    let offset = 0;
    normalizedXs.forEach((x)=>{
        y.set(new Uint8Array(x.buffer), offset);
        offset += x.byteLength;
    });
    return y.buffer;
}
// Use Buffer on Node.js instead of Blob/atob/btoa
const $6b95449a1ec560d1$var$useNodeBuffer = typeof $6b95449a1ec560d1$require$Buffer !== 'undefined' && (typeof Blob === 'undefined' || typeof atob === 'undefined' || typeof btoa === 'undefined');
function $6b95449a1ec560d1$export$42600be9c932993b(str) {
    if ($6b95449a1ec560d1$var$useNodeBuffer) return $6b95449a1ec560d1$require$Buffer.byteLength(str, 'utf8');
    return new Blob([
        str
    ]).size;
}
function $6b95449a1ec560d1$export$28e753ea3e93cabf(buffer) {
    if ($6b95449a1ec560d1$var$useNodeBuffer) return $6b95449a1ec560d1$require$Buffer.from(buffer).toString('base64');
    const buf = new Uint8Array(buffer);
    let s = '';
    for(let i = 0, l = buf.length; i < l; i++)s += String.fromCharCode(buf[i]);
    return btoa(s);
}
function $6b95449a1ec560d1$export$aa941b9d243f1be4(str) {
    if ($6b95449a1ec560d1$var$useNodeBuffer) {
        const buf = $6b95449a1ec560d1$require$Buffer.from(str, 'base64');
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
    const s = atob(str);
    const buffer = new Uint8Array(s.length);
    for(let i = 0; i < s.length; ++i)buffer.set([
        s.charCodeAt(i)
    ], i);
    return buffer.buffer;
}
function $6b95449a1ec560d1$export$9a3e9c78eb778da8(buffers) {
    return (0, $dfd620ba1104fd6f$export$fd7a5551e5344016).join(buffers);
}
function $6b95449a1ec560d1$export$9bf319d8f74f51d1(path) {
    const SEPARATOR = '/';
    path = path.trim();
    while(path.endsWith(SEPARATOR))path = path.slice(0, path.length - 1);
    const items = path.split(SEPARATOR);
    return items[items.length - 1];
}
function $6b95449a1ec560d1$export$a725daa2cfaa7bd5(artifacts, manifest) {
    const result = {
        modelTopology: artifacts.modelTopology,
        format: artifacts.format,
        generatedBy: artifacts.generatedBy,
        convertedBy: artifacts.convertedBy,
        weightsManifest: manifest
    };
    if (artifacts.signature != null) result.signature = artifacts.signature;
    if (artifacts.userDefinedMetadata != null) result.userDefinedMetadata = artifacts.userDefinedMetadata;
    if (artifacts.modelInitializer != null) result.modelInitializer = artifacts.modelInitializer;
    if (artifacts.initializerSignature != null) result.initializerSignature = artifacts.initializerSignature;
    if (artifacts.trainingConfig != null) result.trainingConfig = artifacts.trainingConfig;
    return result;
}
function $6b95449a1ec560d1$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData) {
    const modelArtifacts = {
        modelTopology: modelJSON.modelTopology,
        format: modelJSON.format,
        generatedBy: modelJSON.generatedBy,
        convertedBy: modelJSON.convertedBy
    };
    if (modelJSON.trainingConfig != null) modelArtifacts.trainingConfig = modelJSON.trainingConfig;
    if (modelJSON.weightsManifest != null) {
        if (!weightSpecs) throw new Error('modelJSON has weightsManifest but weightSpecs is null');
        if (!weightData) throw new Error('modelJSON has weightsManifest but weightData is null');
        modelArtifacts.weightSpecs = weightSpecs;
        modelArtifacts.weightData = weightData;
    }
    if (modelJSON.signature != null) modelArtifacts.signature = modelJSON.signature;
    if (modelJSON.userDefinedMetadata != null) modelArtifacts.userDefinedMetadata = modelJSON.userDefinedMetadata;
    if (modelJSON.modelInitializer != null) modelArtifacts.modelInitializer = modelJSON.modelInitializer;
    if (modelJSON.initializerSignature != null) modelArtifacts.initializerSignature = modelJSON.initializerSignature;
    return modelArtifacts;
}
async function $6b95449a1ec560d1$export$b867c14eedd5b8a2(modelJSON, loadWeights) {
    let weightSpecs;
    let weightData;
    if (modelJSON.weightsManifest != null) [weightSpecs, weightData] = await loadWeights(modelJSON.weightsManifest);
    return $6b95449a1ec560d1$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData);
}
function $6b95449a1ec560d1$export$ece8b449d7d29272(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error('Expected JSON model topology, received ArrayBuffer.');
    return {
        dateSaved: new Date(),
        modelTopologyType: 'JSON',
        modelTopologyBytes: modelArtifacts.modelTopology == null ? 0 : $6b95449a1ec560d1$export$42600be9c932993b(JSON.stringify(modelArtifacts.modelTopology)),
        weightSpecsBytes: modelArtifacts.weightSpecs == null ? 0 : $6b95449a1ec560d1$export$42600be9c932993b(JSON.stringify(modelArtifacts.weightSpecs)),
        weightDataBytes: modelArtifacts.weightData == null ? 0 : new (0, $dfd620ba1104fd6f$export$fd7a5551e5344016)(modelArtifacts.weightData).byteLength
    };
}
function $6b95449a1ec560d1$export$9f3fe06e8e8def44(weightsManifest) {
    const weightSpecs = [];
    for (const entry of weightsManifest)weightSpecs.push(...entry.weights);
    return weightSpecs;
}
/**
 * Computes mantisa table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 2048 mantissa lookup values.
 */ function $6b95449a1ec560d1$var$computeFloat16MantisaTable() {
    const convertMantissa = (i)=>{
        let m = i << 13;
        let e = 0;
        while((m & 0x00800000) === 0){
            e -= 0x00800000;
            m <<= 1;
        }
        m &= -8388609;
        e += 0x38800000;
        return m | e;
    };
    const mantisaTable = new Uint32Array(2048);
    mantisaTable[0] = 0;
    for(let i = 1; i < 1024; i++)mantisaTable[i] = convertMantissa(i);
    for(let i = 1024; i < 2048; i++)mantisaTable[i] = 0x38000000 + (i - 1024 << 13);
    return mantisaTable;
}
/**
 * Computes exponent table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 64 exponent lookup values.
 */ function $6b95449a1ec560d1$var$computeFloat16ExponentTable() {
    const exponentTable = new Uint32Array(64);
    exponentTable[0] = 0;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 31; i++)exponentTable[i] = i << 23;
    for(let i = 33; i < 63; i++)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    return exponentTable;
}
/**
 * Computes offset table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 6d offset values.
 */ function $6b95449a1ec560d1$var$computeFloat16OffsetTable() {
    const offsetTable = new Uint32Array(64);
    for(let i = 0; i < 64; i++)offsetTable[i] = 1024;
    offsetTable[0] = offsetTable[32] = 0;
    return offsetTable;
}
function $6b95449a1ec560d1$export$6f94974d2b5810f7() {
    // Algorithm is based off of
    // http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
    // Cache lookup tables
    const mantisaTable = $6b95449a1ec560d1$var$computeFloat16MantisaTable();
    const exponentTable = $6b95449a1ec560d1$var$computeFloat16ExponentTable();
    const offsetTable = $6b95449a1ec560d1$var$computeFloat16OffsetTable();
    return (quantizedArray)=>{
        const buffer = new ArrayBuffer(4 * quantizedArray.length);
        const bufferUint32View = new Uint32Array(buffer);
        for(let index = 0; index < quantizedArray.length; index++){
            const float16Bits = quantizedArray[index];
            const float32Bits = mantisaTable[offsetTable[float16Bits >> 10] + (float16Bits & 0x3ff)] + exponentTable[float16Bits >> 10];
            bufferUint32View[index] = float32Bits;
        }
        return new Float32Array(buffer);
    };
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $cd899f472e2dfa40$export$512275d398c0bdcd {
    constructor(){
        this.saveRouters = [];
        this.loadRouters = [];
    }
    static getInstance() {
        if ($cd899f472e2dfa40$export$512275d398c0bdcd.instance == null) $cd899f472e2dfa40$export$512275d398c0bdcd.instance = new $cd899f472e2dfa40$export$512275d398c0bdcd();
        return $cd899f472e2dfa40$export$512275d398c0bdcd.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerSaveRouter(saveRouter) {
        $cd899f472e2dfa40$export$512275d398c0bdcd.getInstance().saveRouters.push(saveRouter);
    }
    /**
     * Register a load-handler router.
     *
     * @param loadRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `load` method defined or `null`.
     */ static registerLoadRouter(loadRouter) {
        $cd899f472e2dfa40$export$512275d398c0bdcd.getInstance().loadRouters.push(loadRouter);
    }
    /**
     * Look up IOHandler for saving, given a URL-like string.
     *
     * @param url
     * @returns If only one match is found, an instance of IOHandler with the
     * `save` method defined. If no match is found, `null`.
     * @throws Error, if more than one match is found.
     */ static getSaveHandlers(url) {
        return $cd899f472e2dfa40$export$512275d398c0bdcd.getHandlers(url, 'save');
    }
    /**
     * Look up IOHandler for loading, given a URL-like string.
     *
     * @param url
     * @param loadOptions Optional, custom load options.
     * @returns All valid handlers for `url`, given the currently registered
     *   handler routers.
     */ static getLoadHandlers(url, loadOptions) {
        return $cd899f472e2dfa40$export$512275d398c0bdcd.getHandlers(url, 'load', loadOptions);
    }
    static getHandlers(url, handlerType, loadOptions) {
        const validHandlers = [];
        const routers = handlerType === 'load' ? $cd899f472e2dfa40$export$512275d398c0bdcd.getInstance().loadRouters : $cd899f472e2dfa40$export$512275d398c0bdcd.getInstance().saveRouters;
        routers.forEach((router)=>{
            const handler = router(url, loadOptions);
            if (handler !== null) validHandlers.push(handler);
        });
        return validHandlers;
    }
}
const $cd899f472e2dfa40$export$94da4683f36f634e = (loudRouter)=>$cd899f472e2dfa40$export$512275d398c0bdcd.registerSaveRouter(loudRouter);
const $cd899f472e2dfa40$export$8bf64df3d1fb9866 = (loudRouter)=>$cd899f472e2dfa40$export$512275d398c0bdcd.registerLoadRouter(loudRouter);
const $cd899f472e2dfa40$export$88af18fd9ddb62ff = (url)=>$cd899f472e2dfa40$export$512275d398c0bdcd.getSaveHandlers(url);
const $cd899f472e2dfa40$export$90c6c4d24103fa9a = (url, loadOptions)=>$cd899f472e2dfa40$export$512275d398c0bdcd.getLoadHandlers(url, loadOptions);



const $4227d40eaa9125a1$var$DATABASE_NAME = 'tensorflowjs';
const $4227d40eaa9125a1$var$DATABASE_VERSION = 1;
// Model data and ModelArtifactsInfo (metadata) are stored in two separate
// stores for efficient access of the list of stored models and their metadata.
// 1. The object store for model data: topology, weights and weight manifests.
const $4227d40eaa9125a1$var$MODEL_STORE_NAME = 'models_store';
// 2. The object store for ModelArtifactsInfo, including meta-information such
//    as the type of topology (JSON vs binary), byte size of the topology, byte
//    size of the weights, etc.
const $4227d40eaa9125a1$var$INFO_STORE_NAME = 'model_info_store';
async function $4227d40eaa9125a1$export$24b6df48b2529372() {
    const idbFactory = $4227d40eaa9125a1$var$getIndexedDBFactory();
    return new Promise((resolve, reject)=>{
        const deleteRequest = idbFactory.deleteDatabase($4227d40eaa9125a1$var$DATABASE_NAME);
        deleteRequest.onsuccess = ()=>resolve();
        deleteRequest.onerror = (error)=>reject(error);
    });
}
function $4227d40eaa9125a1$var$getIndexedDBFactory() {
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) // TODO(cais): Add more info about what IOHandler subtypes are available.
    //   Maybe point to a doc page on the web and/or automatically determine
    //   the available IOHandlers and print them in the error message.
    throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    // tslint:disable-next-line:no-any
    const theWindow = typeof window === 'undefined' ? self : window;
    const factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;
    if (factory == null) throw new Error('The current browser does not appear to support IndexedDB.');
    return factory;
}
function $4227d40eaa9125a1$var$setUpDatabase(openRequest) {
    const db = openRequest.result;
    db.createObjectStore($4227d40eaa9125a1$var$MODEL_STORE_NAME, {
        keyPath: 'modelPath'
    });
    db.createObjectStore($4227d40eaa9125a1$var$INFO_STORE_NAME, {
        keyPath: 'modelPath'
    });
}
/**
 * IOHandler subclass: Browser IndexedDB.
 *
 * See the doc string of `browserIndexedDB` for more details.
 */ class $4227d40eaa9125a1$export$2c670ce804876090 {
    constructor(modelPath){
        this.indexedDB = $4227d40eaa9125a1$var$getIndexedDBFactory();
        if (modelPath == null || !modelPath) throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
    }
    async save(modelArtifacts) {
        // TODO(cais): Support saving GraphDef models.
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, modelArtifacts);
    }
    async load() {
        return this.databaseAction(this.modelPath);
    }
    /**
     * Perform database action to put model artifacts into or read model artifacts
     * from IndexedDB object store.
     *
     * Whether the action is put or get depends on whether `modelArtifacts` is
     * specified. If it is specified, the action will be put; otherwise the action
     * will be get.
     *
     * @param modelPath A unique string path for the model.
     * @param modelArtifacts If specified, it will be the model artifacts to be
     *   stored in IndexedDB.
     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
     *   of `ModelArtifacts`, if the action is get.
     */ databaseAction(modelPath, modelArtifacts) {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($4227d40eaa9125a1$var$DATABASE_NAME, $4227d40eaa9125a1$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$4227d40eaa9125a1$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                if (modelArtifacts == null) {
                    // Read model out from object store.
                    const modelTx = db.transaction($4227d40eaa9125a1$var$MODEL_STORE_NAME, 'readonly');
                    const modelStore = modelTx.objectStore($4227d40eaa9125a1$var$MODEL_STORE_NAME);
                    const getRequest = modelStore.get(this.modelPath);
                    getRequest.onsuccess = ()=>{
                        if (getRequest.result == null) {
                            db.close();
                            return reject(new Error(`Cannot find model with path '${this.modelPath}' ` + `in IndexedDB.`));
                        } else resolve(getRequest.result.modelArtifacts);
                    };
                    getRequest.onerror = (error)=>{
                        db.close();
                        return reject(getRequest.error);
                    };
                    modelTx.oncomplete = ()=>db.close();
                } else {
                    // Put model into object store.
                    // Concatenate all the model weights into a single ArrayBuffer. Large
                    // models (~1GB) have problems saving if they are not concatenated.
                    // TODO(mattSoulanille): Save large models to multiple indexeddb
                    // records.
                    modelArtifacts.weightData = (0, $dfd620ba1104fd6f$export$fd7a5551e5344016).join(modelArtifacts.weightData);
                    const modelArtifactsInfo = (0, $6b95449a1ec560d1$export$ece8b449d7d29272)(modelArtifacts);
                    // First, put ModelArtifactsInfo into info store.
                    const infoTx = db.transaction($4227d40eaa9125a1$var$INFO_STORE_NAME, 'readwrite');
                    let infoStore = infoTx.objectStore($4227d40eaa9125a1$var$INFO_STORE_NAME);
                    let putInfoRequest;
                    try {
                        putInfoRequest = infoStore.put({
                            modelPath: this.modelPath,
                            modelArtifactsInfo: modelArtifactsInfo
                        });
                    } catch (error) {
                        return reject(error);
                    }
                    let modelTx;
                    putInfoRequest.onsuccess = ()=>{
                        // Second, put model data into model store.
                        modelTx = db.transaction($4227d40eaa9125a1$var$MODEL_STORE_NAME, 'readwrite');
                        const modelStore = modelTx.objectStore($4227d40eaa9125a1$var$MODEL_STORE_NAME);
                        let putModelRequest;
                        try {
                            putModelRequest = modelStore.put({
                                modelPath: this.modelPath,
                                modelArtifacts: modelArtifacts,
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        } catch (error) {
                            // Sometimes, the serialized value is too large to store.
                            return reject(error);
                        }
                        putModelRequest.onsuccess = ()=>resolve({
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        putModelRequest.onerror = (error)=>{
                            // If the put-model request fails, roll back the info entry as
                            // well.
                            infoStore = infoTx.objectStore($4227d40eaa9125a1$var$INFO_STORE_NAME);
                            const deleteInfoRequest = infoStore.delete(this.modelPath);
                            deleteInfoRequest.onsuccess = ()=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                            deleteInfoRequest.onerror = (error)=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                        };
                    };
                    putInfoRequest.onerror = (error)=>{
                        db.close();
                        return reject(putInfoRequest.error);
                    };
                    infoTx.oncomplete = ()=>{
                        if (modelTx == null) db.close();
                        else modelTx.oncomplete = ()=>db.close();
                    };
                }
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}
$4227d40eaa9125a1$export$2c670ce804876090.URL_SCHEME = 'indexeddb://';
const $4227d40eaa9125a1$export$7375c81acb8edf6e = (url)=>{
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($4227d40eaa9125a1$export$2c670ce804876090.URL_SCHEME)) return $4227d40eaa9125a1$export$a4d8901e5a950049(url.slice($4227d40eaa9125a1$export$2c670ce804876090.URL_SCHEME.length));
        else return null;
    }
};
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerSaveRouter($4227d40eaa9125a1$export$7375c81acb8edf6e);
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerLoadRouter($4227d40eaa9125a1$export$7375c81acb8edf6e);
function $4227d40eaa9125a1$export$a4d8901e5a950049(modelPath) {
    return new $4227d40eaa9125a1$export$2c670ce804876090(modelPath);
}
function $4227d40eaa9125a1$var$maybeStripScheme(key) {
    return key.startsWith($4227d40eaa9125a1$export$2c670ce804876090.URL_SCHEME) ? key.slice($4227d40eaa9125a1$export$2c670ce804876090.URL_SCHEME.length) : key;
}
class $4227d40eaa9125a1$export$4b0775e2ff88802 {
    constructor(){
        this.indexedDB = $4227d40eaa9125a1$var$getIndexedDBFactory();
    }
    async listModels() {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($4227d40eaa9125a1$var$DATABASE_NAME, $4227d40eaa9125a1$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$4227d40eaa9125a1$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const tx = db.transaction($4227d40eaa9125a1$var$INFO_STORE_NAME, 'readonly');
                const store = tx.objectStore($4227d40eaa9125a1$var$INFO_STORE_NAME);
                // tslint:disable:max-line-length
                // Need to cast `store` as `any` here because TypeScript's DOM
                // library does not have the `getAll()` method even though the
                // method is supported in the latest version of most mainstream
                // browsers:
                // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
                // tslint:enable:max-line-length
                // tslint:disable-next-line:no-any
                const getAllInfoRequest = store.getAll();
                getAllInfoRequest.onsuccess = ()=>{
                    const out = {};
                    for (const item of getAllInfoRequest.result)out[item.modelPath] = item.modelArtifactsInfo;
                    resolve(out);
                };
                getAllInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getAllInfoRequest.error);
                };
                tx.oncomplete = ()=>db.close();
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
    async removeModel(path) {
        path = $4227d40eaa9125a1$var$maybeStripScheme(path);
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($4227d40eaa9125a1$var$DATABASE_NAME, $4227d40eaa9125a1$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$4227d40eaa9125a1$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const infoTx = db.transaction($4227d40eaa9125a1$var$INFO_STORE_NAME, 'readwrite');
                const infoStore = infoTx.objectStore($4227d40eaa9125a1$var$INFO_STORE_NAME);
                const getInfoRequest = infoStore.get(path);
                let modelTx;
                getInfoRequest.onsuccess = ()=>{
                    if (getInfoRequest.result == null) {
                        db.close();
                        return reject(new Error(`Cannot find model with path '${path}' ` + `in IndexedDB.`));
                    } else {
                        // First, delete the entry in the info store.
                        const deleteInfoRequest = infoStore.delete(path);
                        const deleteModelData = ()=>{
                            // Second, delete the entry in the model store.
                            modelTx = db.transaction($4227d40eaa9125a1$var$MODEL_STORE_NAME, 'readwrite');
                            const modelStore = modelTx.objectStore($4227d40eaa9125a1$var$MODEL_STORE_NAME);
                            const deleteModelRequest = modelStore.delete(path);
                            deleteModelRequest.onsuccess = ()=>resolve(getInfoRequest.result.modelArtifactsInfo);
                            deleteModelRequest.onerror = (error)=>reject(getInfoRequest.error);
                        };
                        // Proceed with deleting model data regardless of whether deletion
                        // of info data succeeds or not.
                        deleteInfoRequest.onsuccess = deleteModelData;
                        deleteInfoRequest.onerror = (error)=>{
                            deleteModelData();
                            db.close();
                            return reject(getInfoRequest.error);
                        };
                    }
                };
                getInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getInfoRequest.error);
                };
                infoTx.oncomplete = ()=>{
                    if (modelTx == null) db.close();
                    else modelTx.oncomplete = ()=>db.close();
                };
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





const $841d0937d70403fd$var$PATH_SEPARATOR = '/';
const $841d0937d70403fd$var$PATH_PREFIX = 'tensorflowjs_models';
const $841d0937d70403fd$var$INFO_SUFFIX = 'info';
const $841d0937d70403fd$var$MODEL_TOPOLOGY_SUFFIX = 'model_topology';
const $841d0937d70403fd$var$WEIGHT_SPECS_SUFFIX = 'weight_specs';
const $841d0937d70403fd$var$WEIGHT_DATA_SUFFIX = 'weight_data';
const $841d0937d70403fd$var$MODEL_METADATA_SUFFIX = 'model_metadata';
function $841d0937d70403fd$export$af2a48c9611db360() {
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') throw new Error("purgeLocalStorageModels() cannot proceed because local storage is unavailable in the current environment.");
    const LS = window.localStorage;
    const purgedModelPaths = [];
    for(let i = 0; i < LS.length; ++i){
        const key = LS.key(i);
        const prefix = $841d0937d70403fd$var$PATH_PREFIX + $841d0937d70403fd$var$PATH_SEPARATOR;
        if (key.startsWith(prefix) && key.length > prefix.length) {
            LS.removeItem(key);
            const modelName = $841d0937d70403fd$var$getModelPathFromKey(key);
            if (purgedModelPaths.indexOf(modelName) === -1) purgedModelPaths.push(modelName);
        }
    }
    return purgedModelPaths;
}
function $841d0937d70403fd$var$getModelKeys(path) {
    return {
        info: [
            $841d0937d70403fd$var$PATH_PREFIX,
            path,
            $841d0937d70403fd$var$INFO_SUFFIX
        ].join($841d0937d70403fd$var$PATH_SEPARATOR),
        topology: [
            $841d0937d70403fd$var$PATH_PREFIX,
            path,
            $841d0937d70403fd$var$MODEL_TOPOLOGY_SUFFIX
        ].join($841d0937d70403fd$var$PATH_SEPARATOR),
        weightSpecs: [
            $841d0937d70403fd$var$PATH_PREFIX,
            path,
            $841d0937d70403fd$var$WEIGHT_SPECS_SUFFIX
        ].join($841d0937d70403fd$var$PATH_SEPARATOR),
        weightData: [
            $841d0937d70403fd$var$PATH_PREFIX,
            path,
            $841d0937d70403fd$var$WEIGHT_DATA_SUFFIX
        ].join($841d0937d70403fd$var$PATH_SEPARATOR),
        modelMetadata: [
            $841d0937d70403fd$var$PATH_PREFIX,
            path,
            $841d0937d70403fd$var$MODEL_METADATA_SUFFIX
        ].join($841d0937d70403fd$var$PATH_SEPARATOR)
    };
}
function $841d0937d70403fd$var$removeItems(keys) {
    for (const key of Object.values(keys))window.localStorage.removeItem(key);
}
/**
 * Get model path from a local-storage key.
 *
 * E.g., 'tensorflowjs_models/my/model/1/info' --> 'my/model/1'
 *
 * @param key
 */ function $841d0937d70403fd$var$getModelPathFromKey(key) {
    const items = key.split($841d0937d70403fd$var$PATH_SEPARATOR);
    if (items.length < 3) throw new Error(`Invalid key format: ${key}`);
    return items.slice(1, items.length - 1).join($841d0937d70403fd$var$PATH_SEPARATOR);
}
function $841d0937d70403fd$var$maybeStripScheme(key) {
    return key.startsWith($841d0937d70403fd$export$8984a84f7aef20de.URL_SCHEME) ? key.slice($841d0937d70403fd$export$8984a84f7aef20de.URL_SCHEME.length) : key;
}
/**
 * IOHandler subclass: Browser Local Storage.
 *
 * See the doc string to `browserLocalStorage` for more details.
 */ class $841d0937d70403fd$export$8984a84f7aef20de {
    constructor(modelPath){
        if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') // TODO(cais): Add more info about what IOHandler subtypes are
        // available.
        //   Maybe point to a doc page on the web and/or automatically determine
        //   the available IOHandlers and print them in the error message.
        throw new Error('The current environment does not support local storage.');
        this.LS = window.localStorage;
        if (modelPath == null || !modelPath) throw new Error('For local storage, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
        this.keys = $841d0937d70403fd$var$getModelKeys(this.modelPath);
    }
    /**
     * Save model artifacts to browser local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @param modelArtifacts The model artifacts to be stored.
     * @returns An instance of SaveResult.
     */ async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        else {
            const topology = JSON.stringify(modelArtifacts.modelTopology);
            const weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
            const modelArtifactsInfo = (0, $6b95449a1ec560d1$export$ece8b449d7d29272)(modelArtifacts);
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $dfd620ba1104fd6f$export$fd7a5551e5344016).join(modelArtifacts.weightData);
            try {
                this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
                this.LS.setItem(this.keys.topology, topology);
                this.LS.setItem(this.keys.weightSpecs, weightSpecs);
                this.LS.setItem(this.keys.weightData, (0, $6b95449a1ec560d1$export$28e753ea3e93cabf)(weightBuffer));
                // Note that JSON.stringify doesn't write out keys that have undefined
                // values, so for some keys, we set undefined instead of a null-ish
                // value.
                const metadata = {
                    format: modelArtifacts.format,
                    generatedBy: modelArtifacts.generatedBy,
                    convertedBy: modelArtifacts.convertedBy,
                    signature: modelArtifacts.signature != null ? modelArtifacts.signature : undefined,
                    userDefinedMetadata: modelArtifacts.userDefinedMetadata != null ? modelArtifacts.userDefinedMetadata : undefined,
                    modelInitializer: modelArtifacts.modelInitializer != null ? modelArtifacts.modelInitializer : undefined,
                    initializerSignature: modelArtifacts.initializerSignature != null ? modelArtifacts.initializerSignature : undefined,
                    trainingConfig: modelArtifacts.trainingConfig != null ? modelArtifacts.trainingConfig : undefined
                };
                this.LS.setItem(this.keys.modelMetadata, JSON.stringify(metadata));
                return {
                    modelArtifactsInfo: modelArtifactsInfo
                };
            } catch (err) {
                // If saving failed, clean up all items saved so far.
                $841d0937d70403fd$var$removeItems(this.keys);
                throw new Error(`Failed to save model '${this.modelPath}' to local storage: ` + `size quota being exceeded is a possible cause of this failure: ` + `modelTopologyBytes=${modelArtifactsInfo.modelTopologyBytes}, ` + `weightSpecsBytes=${modelArtifactsInfo.weightSpecsBytes}, ` + `weightDataBytes=${modelArtifactsInfo.weightDataBytes}.`);
            }
        }
    }
    /**
     * Load a model from local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @returns The loaded model (if loading succeeds).
     */ async load() {
        const info = JSON.parse(this.LS.getItem(this.keys.info));
        if (info == null) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if (info.modelTopologyType !== 'JSON') throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const out = {};
        // Load topology.
        const topology = JSON.parse(this.LS.getItem(this.keys.topology));
        if (topology == null) throw new Error(`In local storage, the topology of model '${this.modelPath}' ` + `is missing.`);
        out.modelTopology = topology;
        // Load weight specs.
        const weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (weightSpecs == null) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' ` + `are missing.`);
        out.weightSpecs = weightSpecs;
        // Load meta-data fields.
        const metadataString = this.LS.getItem(this.keys.modelMetadata);
        if (metadataString != null) {
            const metadata = JSON.parse(metadataString);
            out.format = metadata.format;
            out.generatedBy = metadata.generatedBy;
            out.convertedBy = metadata.convertedBy;
            if (metadata.signature != null) out.signature = metadata.signature;
            if (metadata.userDefinedMetadata != null) out.userDefinedMetadata = metadata.userDefinedMetadata;
            if (metadata.modelInitializer != null) out.modelInitializer = metadata.modelInitializer;
            if (metadata.initializerSignature != null) out.initializerSignature = metadata.initializerSignature;
            if (metadata.trainingConfig != null) out.trainingConfig = metadata.trainingConfig;
        }
        // Load weight data.
        const weightDataBase64 = this.LS.getItem(this.keys.weightData);
        if (weightDataBase64 == null) throw new Error(`In local storage, the binary weight values of model ` + `'${this.modelPath}' are missing.`);
        out.weightData = (0, $6b95449a1ec560d1$export$aa941b9d243f1be4)(weightDataBase64);
        return out;
    }
}
$841d0937d70403fd$export$8984a84f7aef20de.URL_SCHEME = 'localstorage://';
const $841d0937d70403fd$export$64ff64fd6b1180ae = (url)=>{
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($841d0937d70403fd$export$8984a84f7aef20de.URL_SCHEME)) return $841d0937d70403fd$export$96d8dd89e6c22307(url.slice($841d0937d70403fd$export$8984a84f7aef20de.URL_SCHEME.length));
        else return null;
    }
};
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerSaveRouter($841d0937d70403fd$export$64ff64fd6b1180ae);
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerLoadRouter($841d0937d70403fd$export$64ff64fd6b1180ae);
function $841d0937d70403fd$export$96d8dd89e6c22307(modelPath) {
    return new $841d0937d70403fd$export$8984a84f7aef20de(modelPath);
}
class $841d0937d70403fd$export$bb7e7fb445a616f4 {
    constructor(){
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER'), ()=>'Current environment is not a web browser');
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(typeof window === 'undefined' || typeof window.localStorage !== 'undefined', ()=>'Current browser does not appear to support localStorage');
        this.LS = window.localStorage;
    }
    async listModels() {
        const out = {};
        const prefix = $841d0937d70403fd$var$PATH_PREFIX + $841d0937d70403fd$var$PATH_SEPARATOR;
        const suffix = $841d0937d70403fd$var$PATH_SEPARATOR + $841d0937d70403fd$var$INFO_SUFFIX;
        for(let i = 0; i < this.LS.length; ++i){
            const key = this.LS.key(i);
            if (key.startsWith(prefix) && key.endsWith(suffix)) {
                const modelPath = $841d0937d70403fd$var$getModelPathFromKey(key);
                out[modelPath] = JSON.parse(this.LS.getItem(key));
            }
        }
        return out;
    }
    async removeModel(path) {
        path = $841d0937d70403fd$var$maybeStripScheme(path);
        const keys = $841d0937d70403fd$var$getModelKeys(path);
        if (this.LS.getItem(keys.info) == null) throw new Error(`Cannot find model at path '${path}'`);
        const info = JSON.parse(this.LS.getItem(keys.info));
        $841d0937d70403fd$var$removeItems(keys);
        return info;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Classes and functions for model management across multiple storage mediums.
 *
 * Supported client actions:
 * - Listing models on all registered storage mediums.
 * - Remove model by URL from any registered storage mediums, by using URL
 *   string.
 * - Moving or copying model from one path to another in the same medium or from
 *   one medium to another, by using URL strings.
 */ 

const $1b50d059503ab55e$var$URL_SCHEME_SUFFIX = '://';
class $1b50d059503ab55e$export$ccf7f72dec8f0028 {
    constructor(){
        this.managers = {};
    }
    static getInstance() {
        if ($1b50d059503ab55e$export$ccf7f72dec8f0028.instance == null) $1b50d059503ab55e$export$ccf7f72dec8f0028.instance = new $1b50d059503ab55e$export$ccf7f72dec8f0028();
        return $1b50d059503ab55e$export$ccf7f72dec8f0028.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerManager(scheme, manager) {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(scheme != null, ()=>'scheme must not be undefined or null.');
        if (scheme.endsWith($1b50d059503ab55e$var$URL_SCHEME_SUFFIX)) scheme = scheme.slice(0, scheme.indexOf($1b50d059503ab55e$var$URL_SCHEME_SUFFIX));
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(scheme.length > 0, ()=>'scheme must not be an empty string.');
        const registry = $1b50d059503ab55e$export$ccf7f72dec8f0028.getInstance();
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(registry.managers[scheme] == null, ()=>`A model store manager is already registered for scheme '${scheme}'.`);
        registry.managers[scheme] = manager;
    }
    static getManager(scheme) {
        const manager = $1b50d059503ab55e$export$ccf7f72dec8f0028.getInstance().managers[scheme];
        if (manager == null) throw new Error(`Cannot find model manager for scheme '${scheme}'`);
        return manager;
    }
    static getSchemes() {
        return Object.keys($1b50d059503ab55e$export$ccf7f72dec8f0028.getInstance().managers);
    }
}
/**
 * Helper method for parsing a URL string into a scheme and a path.
 *
 * @param url E.g., 'localstorage://my-model'
 * @returns A dictionary with two fields: scheme and path.
 *   Scheme: e.g., 'localstorage' in the example above.
 *   Path: e.g., 'my-model' in the example above.
 */ function $1b50d059503ab55e$var$parseURL(url) {
    if (url.indexOf($1b50d059503ab55e$var$URL_SCHEME_SUFFIX) === -1) throw new Error(`The url string provided does not contain a scheme. ` + `Supported schemes are: ` + `${$1b50d059503ab55e$export$ccf7f72dec8f0028.getSchemes().join(',')}`);
    return {
        scheme: url.split($1b50d059503ab55e$var$URL_SCHEME_SUFFIX)[0],
        path: url.split($1b50d059503ab55e$var$URL_SCHEME_SUFFIX)[1]
    };
}
async function $1b50d059503ab55e$var$cloneModelInternal(sourceURL, destURL, deleteSource = false) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(sourceURL !== destURL, ()=>`Old path and new path are the same: '${sourceURL}'`);
    const loadHandlers = (0, $cd899f472e2dfa40$export$512275d398c0bdcd).getLoadHandlers(sourceURL);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(loadHandlers.length > 0, ()=>`Copying failed because no load handler is found for source URL ${sourceURL}.`);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(loadHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `load handlers for source URL ${sourceURL}.`);
    const loadHandler = loadHandlers[0];
    const saveHandlers = (0, $cd899f472e2dfa40$export$512275d398c0bdcd).getSaveHandlers(destURL);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(saveHandlers.length > 0, ()=>`Copying failed because no save handler is found for destination ` + `URL ${destURL}.`);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(saveHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `save handlers for destination URL ${destURL}.`);
    const saveHandler = saveHandlers[0];
    const sourceScheme = $1b50d059503ab55e$var$parseURL(sourceURL).scheme;
    const sourcePath = $1b50d059503ab55e$var$parseURL(sourceURL).path;
    const sameMedium = sourceScheme === $1b50d059503ab55e$var$parseURL(sourceURL).scheme;
    const modelArtifacts = await loadHandler.load();
    // If moving within the same storage medium, remove the old model as soon as
    // the loading is done. Without doing this, it is possible that the combined
    // size of the two models will cause the cloning to fail.
    if (deleteSource && sameMedium) await $1b50d059503ab55e$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    const saveResult = await saveHandler.save(modelArtifacts);
    // If moving between mediums, the deletion is done after the save succeeds.
    // This guards against the case in which saving to the destination medium
    // fails.
    if (deleteSource && !sameMedium) await $1b50d059503ab55e$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    return saveResult.modelArtifactsInfo;
}
/**
 * List all models stored in registered storage mediums.
 *
 * For a web browser environment, the registered mediums are Local Storage and
 * IndexedDB.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @returns A `Promise` of a dictionary mapping URLs of existing models to
 * their model artifacts info. URLs include medium-specific schemes, e.g.,
 *   'indexeddb://my/model/1'. Model artifacts info include type of the
 * model's topology, byte sizes of the topology, weights, etc.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $1b50d059503ab55e$export$8d63af86d795ece4() {
    const schemes = $1b50d059503ab55e$export$ccf7f72dec8f0028.getSchemes();
    const out = {};
    for (const scheme of schemes){
        const schemeOut = await $1b50d059503ab55e$export$ccf7f72dec8f0028.getManager(scheme).listModels();
        for(const path in schemeOut){
            const url = scheme + $1b50d059503ab55e$var$URL_SCHEME_SUFFIX + path;
            out[url] = schemeOut[path];
        }
    }
    return out;
}
/**
 * Remove a model specified by URL from a registered storage medium.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @param url A URL to a stored model, with a scheme prefix, e.g.,
 *   'localstorage://my-model-1', 'indexeddb://my/model/2'.
 * @returns ModelArtifactsInfo of the deleted model (if and only if deletion
 *   is successful).
 * @throws Error if deletion fails, e.g., if no model exists at `path`.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $1b50d059503ab55e$export$e71037184d1ad0fd(url) {
    const schemeAndPath = $1b50d059503ab55e$var$parseURL(url);
    const manager = $1b50d059503ab55e$export$ccf7f72dec8f0028.getManager(schemeAndPath.scheme);
    return manager.removeModel(schemeAndPath.path);
}
/**
 * Copy a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Copying within a storage medium, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Copying between two storage mediums, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Copy the model, from Local Storage to IndexedDB.
 * await tf.io.copyModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove both models.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of copying.
 * @param destURL Destination URL of copying.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if copying fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $1b50d059503ab55e$export$b5971478866000ed(sourceURL, destURL) {
    const deleteSource = false;
    return $1b50d059503ab55e$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}
/**
 * Move a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Moving within a storage medium, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Moving between two storage mediums, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Move the model, from Local Storage to IndexedDB.
 * await tf.io.moveModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove the moved model.
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of moving.
 * @param destURL Destination URL of moving.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if moving fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $1b50d059503ab55e$export$598f168272f4fec2(sourceURL, destURL) {
    const deleteSource = true;
    return $1b50d059503ab55e$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}



class $130334147e52168a$export$c812b315576f1552 {
    constructor(){
        // For setTimeoutCustom
        this.messageName = 'setTimeoutCustom';
        this.functionRefs = [];
        this.handledMessageCount = 0;
        this.hasEventListener = false;
    }
    fetch(path, init) {
        return fetch(path, init);
    }
    now() {
        return performance.now();
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Browser's encoder only supports utf-8, but got ${encoding}`);
        if (this.textEncoder == null) this.textEncoder = new TextEncoder();
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        return new TextDecoder(encoding).decode(bytes);
    }
    // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
    setTimeoutCustom(functionRef, delay) {
        if (typeof window === 'undefined' || !(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('USE_SETTIMEOUTCUSTOM')) {
            setTimeout(functionRef, delay);
            return;
        }
        this.functionRefs.push(functionRef);
        setTimeout(()=>{
            window.postMessage({
                name: this.messageName,
                index: this.functionRefs.length - 1
            }, '*');
        }, delay);
        if (!this.hasEventListener) {
            this.hasEventListener = true;
            window.addEventListener('message', (event)=>{
                if (event.source === window && event.data.name === this.messageName) {
                    event.stopPropagation();
                    const functionRef = this.functionRefs[event.data.index];
                    functionRef();
                    this.handledMessageCount++;
                    if (this.handledMessageCount === this.functionRefs.length) {
                        this.functionRefs = [];
                        this.handledMessageCount = 0;
                    }
                }
            }, true);
        }
    }
    isTypedArray(a) {
        return (0, $60e26135cef47b6f$export$632e6430b2d784cd)(a);
    }
}
if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('IS_BROWSER')) {
    (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().setPlatform('browser', new $130334147e52168a$export$c812b315576f1552());
    // Register LocalStorage IOHandler
    try {
        (0, $1b50d059503ab55e$export$ccf7f72dec8f0028).registerManager((0, $841d0937d70403fd$export$8984a84f7aef20de).URL_SCHEME, new (0, $841d0937d70403fd$export$bb7e7fb445a616f4)());
    } catch (err) {}
    // Register IndexedDB IOHandler
    try {
        (0, $1b50d059503ab55e$export$ccf7f72dec8f0028).registerManager((0, $4227d40eaa9125a1$export$2c670ce804876090).URL_SCHEME, new (0, $4227d40eaa9125a1$export$4b0775e2ff88802)());
    } catch (err) {}
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $2624a6b300b6f041$export$fc0623918121e18f = {
    // tslint:disable-next-line:no-require-imports
    importFetch: ()=>(parcelRequire("aXLS2"))
};
let $2624a6b300b6f041$var$systemFetch;
function $2624a6b300b6f041$export$ab67f817cc7ff6dc() {
    $2624a6b300b6f041$var$systemFetch = null;
}
function $2624a6b300b6f041$export$fec6b32271d1a551(fetchFn) {
    $2624a6b300b6f041$var$systemFetch = fetchFn;
}
function $2624a6b300b6f041$export$f53da9ce5ba19de0() {
    return $2624a6b300b6f041$var$systemFetch;
}

class $2624a6b300b6f041$export$7befb6c3de272049 {
    constructor(){
        // tslint:disable-next-line:no-require-imports
        this.util = (parcelRequire("aXLS2"));
        // According to the spec, the built-in encoder can do only UTF-8 encoding.
        // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder/TextEncoder
        this.textEncoder = new this.util.TextEncoder();
    }
    fetch(path, requestInits) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().global.fetch != null) return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().global.fetch(path, requestInits);
        if ($2624a6b300b6f041$var$systemFetch == null) $2624a6b300b6f041$var$systemFetch = $2624a6b300b6f041$export$fc0623918121e18f.importFetch();
        return $2624a6b300b6f041$var$systemFetch(path, requestInits);
    }
    now() {
        const time = $371a3837fd81d701$exports.hrtime();
        return time[0] * 1000 + time[1] / 1000000;
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Node built-in encoder only supports utf-8, but got ${encoding}`);
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        if (bytes.length === 0) return '';
        return new this.util.TextDecoder(encoding).decode(bytes);
    }
    isTypedArray(a) {
        return this.util.types.isFloat32Array(a) || this.util.types.isInt32Array(a) || this.util.types.isUint8Array(a) || this.util.types.isUint8ClampedArray(a);
    }
}
if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('IS_NODE') && !(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('IS_BROWSER')) (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().setPlatform('node', new $2624a6b300b6f041$export$7befb6c3de272049());


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a(shape, dtype = 'float32', values) {
    dtype = dtype || 'float32';
    $9e4a6174e3538e7d$export$3d8b7619bac22cf5(shape);
    return new (0, $4b7222b1b59444b8$export$350df26cd52e08e1)(shape, dtype, values);
}


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Casts a `tf.Tensor` to a new dtype.
 *
 * ```js
 * const x = tf.tensor1d([1.5, 2.5, 3]);
 * tf.cast(x, 'int32').print();
 * ```
 * @param x The input tensor to be casted.
 * @param dtype The dtype to cast the input tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $262a02e810d931f1$var$cast_(x, dtype) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'cast');
    // Sanity checks.
    if (!$9e4a6174e3538e7d$export$a6a3df2178ac9529(dtype)) throw new Error(`Failed to cast to unknown dtype ${dtype}`);
    if (dtype === 'string' && $x.dtype !== 'string' || dtype !== 'string' && $x.dtype === 'string') throw new Error('Only strings can be casted to strings');
    const inputs = {
        x: $x
    };
    const attrs = {
        dtype: dtype
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$107ecfb3d1ccbd77), inputs, attrs);
}
const $262a02e810d931f1$export$f2db7d5238e1d23f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cast_: $262a02e810d931f1$var$cast_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a new tensor with the same values and shape as the specified
 * tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 *
 * x.clone().print();
 * ```
 *
 * @param x The tensor to clone.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $765aa12b24d3e86a$var$clone_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'clone', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    // Note this op is called tf.identity in python. Hence the kernel name used
    // here.
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$544bf02140fa9a77), inputs);
}
const $765aa12b24d3e86a$export$9cd59f9826255e47 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    clone_: $765aa12b24d3e86a$var$clone_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Prints information about the `tf.Tensor` including its data.
 *
 * ```js
 * const verbose = true;
 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print(verbose);
 * ```
 * @param x The tensor to be printed.
 * @param verbose Whether to print verbose information about the ` Tensor`,
 * including dtype and size.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $25c41199dcd2e1a0$export$c2d084dc44961371(x, verbose = false) {
    console.log(x.toString(verbose));
}



(0, $6a645535e157b279$export$ca8737f6c8c212b8)();
const $a50081f2c453ee1d$var$opHandler = {
    buffer: $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a,
    cast: $262a02e810d931f1$export$f2db7d5238e1d23f,
    clone: $765aa12b24d3e86a$export$9cd59f9826255e47,
    print: $25c41199dcd2e1a0$export$c2d084dc44961371
};
(0, $4b7222b1b59444b8$export$1efe8d8b4884ad31)($a50081f2c453ee1d$var$opHandler);


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Adds two `tf.Tensor`s element-wise, A + B. Supports broadcasting.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 *
 * ```js
 * // Broadcast add a with b.
 * const a = tf.scalar(5);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 * @param a The first `tf.Tensor` to add.
 * @param b The second `tf.Tensor` to add. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $8efd352f234ac278$var$add_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'add');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'add');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d0265b2c425512d6), inputs);
}
const $8efd352f234ac278$export$e16d8520af44a096 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    add_: $8efd352f234ac278$var$add_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 * The result is rounded with floor function.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.floorDiv(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.floorDiv(b).print();  // or tf.floorDiv(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $a4de2f9f568ab684$var$floorDiv_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'floorDiv');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'floorDiv');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d79b5692ede26c2f), inputs);
}
const $a4de2f9f568ab684$export$112397bc52715a8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    floorDiv_: $a4de2f9f568ab684$var$floorDiv_
});



/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $3321ac17b3d0dfc7$var$div_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'div');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'div');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    if ($a.dtype === 'int32' && $b.dtype === 'int32') return (0, $a4de2f9f568ab684$export$112397bc52715a8)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b9880b86e1014bb8), inputs, attrs);
}
const $3321ac17b3d0dfc7$export$159d9494db57879b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    div_: $3321ac17b3d0dfc7$var$div_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Multiplies two `tf.Tensor`s element-wise, A * B. Supports broadcasting.
 *
 * We also expose `tf.mulStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([2, 3, 4, 5]);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 *
 * ```js
 * // Broadcast mul a with b.
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.scalar(5);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 * @param a The first tensor to multiply.
 * @param b The second tensor to multiply. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $582b63c19659e1cf$var$mul_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'mul');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'mul');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f14f83b3b531d498), inputs);
}
const $582b63c19659e1cf$export$6e3a27864ab166fe = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    mul_: $582b63c19659e1cf$var$mul_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes square root of the input `tf.Tensor` element-wise: `y = sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.sqrt().print();  // or tf.sqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $829be0ea336e2128$var$sqrt_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'sqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$21ab404ab9d512a6), inputs);
}
const $829be0ea336e2128$export$eba8049fb5020b81 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sqrt_: $829be0ea336e2128$var$sqrt_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Computes square of `x` element-wise: `x ^ 2`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.sqrt(2), -1]);
 *
 * x.square().print();  // or tf.square(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7c706d812ea019b4$var$square_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'square');
    const attrs = {};
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel('Square', {
        x: $x
    }, attrs);
}
const $7c706d812ea019b4$export$dd4f28cef696bc7d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    square_: $7c706d812ea019b4$var$square_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with all elements set to 0 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.zerosLike(x).print();
 * ```
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $a5cb5e205b190f05$var$zerosLike_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'zerosLike');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$430969a37eda1e88), inputs);
}
const $a5cb5e205b190f05$export$cb1f824e7733584d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    zerosLike_: $a5cb5e205b190f05$var$zerosLike_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Provided `f(x)`, returns another function `g(x, dy?)`, which gives the
 * gradient of `f(x)` with respect to `x`.
 *
 * If `dy` is provided, the gradient of `f(x).mul(dy).sum()` with respect to
 * `x` is computed instead. `f(x)` must take a single tensor `x` and return a
 * single tensor `y`. If `f()` takes multiple inputs, use `tf.grads` instead.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.grad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * g(x).print();
 * ```
 *
 * ```js
 * // f(x) = x ^ 3
 * const f = x => x.pow(tf.scalar(3, 'int32'));
 * // f'(x) = 3x ^ 2
 * const g = tf.grad(f);
 * // f''(x) = 6x
 * const gg = tf.grad(g);
 *
 * const x = tf.tensor1d([2, 3]);
 * gg(x).print();
 * ```
 *
 * @param f The function f(x), to compute gradient for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $d54cf47ed1e7fb8d$export$c24429b22bb73814(f) {
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(f), ()=>'The f passed in grad(f) must be a function');
    return (x, dy)=>{
        // x can be of any dtype, thus null as the last argument.
        const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'tf.grad', 'string_or_numeric');
        const $dy = dy != null ? (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(dy, 'dy', 'tf.grad') : null;
        return (0, $6a645535e157b279$export$33b63313cc511a3b).tidy(()=>{
            const { value: value, grads: grads } = (0, $6a645535e157b279$export$33b63313cc511a3b).gradients(()=>f($x), [
                $x
            ], $dy);
            if ($dy != null) $9e4a6174e3538e7d$export$e08b27e7f37e2782(value.shape, $dy.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)");
            $d54cf47ed1e7fb8d$var$checkGrads(grads);
            return grads[0];
        });
    };
}
/**
 * Provided `f(x1, x2,...)`, returns another function `g([x1, x2,...], dy?)`,
 * which gives an array of gradients of `f()` with respect to each input
 * [`x1`,`x2`,...].
 *
 * If `dy` is passed when calling `g()`, the gradient of
 * `f(x1,...).mul(dy).sum()` with respect to each input is computed instead.
 * The provided `f` must take one or more tensors and return a single tensor
 * `y`. If `f()` takes a single input, we recommend using `tf.grad` instead.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df / da = b, df / db = a
 * const g = tf.grads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const [da, db] = g([a, b]);
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @param f The function `f(x1, x2,...)` to compute gradients for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $d54cf47ed1e7fb8d$export$3f3749f5340c73f2(f) {
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(f), ()=>'The f passed in grads(f) must be a function');
    return (args, dy)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(Array.isArray(args), ()=>"The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s");
        // args can be of any dtype, thus null as the last argument.
        const $args = (0, $539f0ce07f2139cd$export$758e66616b4d410b)(args, 'args', 'tf.grads', 'string_or_numeric');
        const $dy = dy != null ? (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(dy, 'dy', 'tf.grads') : null;
        return (0, $6a645535e157b279$export$33b63313cc511a3b).tidy(()=>{
            const { value: value, grads: grads } = (0, $6a645535e157b279$export$33b63313cc511a3b).gradients(()=>f(...$args), $args, $dy);
            if ($dy != null) $9e4a6174e3538e7d$export$e08b27e7f37e2782(value.shape, $dy.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
            $d54cf47ed1e7fb8d$var$checkGrads(grads);
            return grads;
        });
    };
}
/**
 * Like `tf.grad`, but also returns the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grad: The gradient of `f(x)` w.r.t. `x` (result of `tf.grad`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.valueAndGrad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * const {value, grad} = g(x);
 *
 * console.log('value');
 * value.print();
 * console.log('grad');
 * grad.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $d54cf47ed1e7fb8d$export$9fbe39d4dcb3921e(f) {
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(f), ()=>'The f passed in valueAndGrad(f) must be a function');
    return (x, dy)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(x instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814), ()=>'The x passed in valueAndGrad(f)(x) must be a tensor');
        $9e4a6174e3538e7d$export$a7a9523472993e97(dy == null || dy instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814), ()=>'The dy passed in valueAndGrad(f)(x, dy) must be a tensor');
        const { grads: grads, value: value } = (0, $6a645535e157b279$export$33b63313cc511a3b).gradients(()=>f(x), [
            x
        ], dy);
        $d54cf47ed1e7fb8d$var$checkGrads(grads);
        return {
            grad: grads[0],
            value: value
        };
    };
}
/**
 * Like `tf.grads`, but returns also the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grads: The gradients of `f()` w.r.t. each input (result of `tf.grads`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df/da = b, df/db = a
 * const g = tf.valueAndGrads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const {value, grads} = g([a, b]);
 *
 * const [da, db] = grads;
 *
 * console.log('value');
 * value.print();
 *
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $d54cf47ed1e7fb8d$export$c03281a254ef3cf0(f) {
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(f), ()=>'The f passed in valueAndGrads(f) must be a function');
    return (args, dy)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(Array.isArray(args) && args.every((arg)=>arg instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)), ()=>"The args passed in valueAndGrads(f)(args) must be array of tensors");
        $9e4a6174e3538e7d$export$a7a9523472993e97(dy == null || dy instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814), ()=>'The dy passed in valueAndGrads(f)(args, dy) must be a tensor');
        const res = (0, $6a645535e157b279$export$33b63313cc511a3b).gradients(()=>f(...args), args, dy);
        if (dy != null) $9e4a6174e3538e7d$export$e08b27e7f37e2782(res.value.shape, dy.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
        $d54cf47ed1e7fb8d$var$checkGrads(res.grads);
        return res;
    };
}
/**
 * Computes and returns the gradient of f(x) with respect to the list of
 * trainable variables provided by `varList`. If no list is provided, it
 * defaults to all trainable variables.
 *
 * ```js
 * const a = tf.variable(tf.tensor1d([3, 4]));
 * const b = tf.variable(tf.tensor1d([5, 6]));
 * const x = tf.tensor1d([1, 2]);
 *
 * // f(a, b) = a * x ^ 2 + b * x
 * const f = () => a.mul(x.square()).add(b.mul(x)).sum();
 * // df/da = x ^ 2, df/db = x
 * const {value, grads} = tf.variableGrads(f);
 *
 * Object.keys(grads).forEach(varName => grads[varName].print());
 * ```
 *
 * @param f The function to execute. f() should return a scalar.
 * @param varList The list of variables to compute the gradients with respect
 *     to. Defaults to all trainable variables.
 * @returns An object with the following keys and values:
 *   - `value`: The value of the function `f`.
 *   - `grads`: A map from the names of the variables to the gradients.
 *     If the `varList` argument is provided explicitly and contains a subset of
 *     non-trainable variables, this map in the return value will contain keys
 *     that map the names of the non-trainable variables to `null`.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $d54cf47ed1e7fb8d$export$c756d9ed08b9677f(f, varList) {
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$f6e2535fb5126e54(f), ()=>'The f passed in variableGrads(f) must be a function');
    $9e4a6174e3538e7d$export$a7a9523472993e97(varList == null || Array.isArray(varList) && varList.every((v)=>v instanceof (0, $4b7222b1b59444b8$export$c867a5c9595a1350)), ()=>"The varList passed in variableGrads(f, varList) must be an array of variables");
    const specifiedVarList = varList != null;
    if (!specifiedVarList) {
        // Get all of the trainable variables.
        varList = [];
        for(const varName in (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables)varList.push((0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[varName]);
    }
    const specifiedNonTrainable = specifiedVarList ? varList.filter((variable)=>!variable.trainable) : null;
    // Prune non-trainable variables.
    const originalVarCount = varList.length;
    varList = varList.filter((variable)=>variable.trainable);
    $9e4a6174e3538e7d$export$a7a9523472993e97(varList.length > 0, ()=>`variableGrads() expects at least one of the input variables to ` + `be trainable, but none of the ${originalVarCount} variables is ` + `trainable.`);
    const allowNoGradients = true;
    const { value: value, grads: grads } = (0, $6a645535e157b279$export$33b63313cc511a3b).gradients(f, varList, null, allowNoGradients);
    $9e4a6174e3538e7d$export$a7a9523472993e97(grads.some((g)=>g != null), ()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().");
    $9e4a6174e3538e7d$export$a7a9523472993e97(value.rank === 0, ()=>`The f passed in variableGrads(f) must return a scalar, but it ` + `returned a rank-${value.rank} tensor`);
    const namedGrads = {};
    varList.forEach((v, i)=>{
        if (grads[i] != null) namedGrads[v.name] = grads[i];
    });
    if (specifiedNonTrainable != null) // If varList is explicitly provided and contains non-trainable values,
    // add them to the returned gradients with `null` values.
    specifiedNonTrainable.forEach((v)=>namedGrads[v.name] = null);
    return {
        value: value,
        grads: namedGrads
    };
}
/**
 * Overrides the gradient computation of a function `f`.
 *
 * Takes a function
 * `f(...inputs, save) => {value: Tensor, gradFunc: (dy, saved) => Tensor[]}`
 * and returns another function `g(...inputs)` which takes the same inputs as
 * `f`. When called, `g` returns `f().value`. In backward mode, custom gradients
 * with respect to each input of `f` are computed using `f().gradFunc`.
 *
 * The `save` function passed to `f` should be used for saving tensors needed
 * in the gradient. And the `saved` passed to the `gradFunc` is a
 * `NamedTensorMap`, which contains those saved tensors.
 *
 * ```js
 * const customOp = tf.customGrad((x, save) => {
 *   // Save x to make sure it's available later for the gradient.
 *   save([x]);
 *   // Override gradient of our custom x ^ 2 op to be dy * abs(x);
 *   return {
 *     value: x.square(),
 *     // Note `saved.x` which points to the `x` we saved earlier.
 *     gradFunc: (dy, saved) => [dy.mul(saved[0].abs())]
 *   };
 * });
 *
 * const x = tf.tensor1d([-1, -2, 3]);
 * const dx = tf.grad(x => customOp(x));
 *
 * console.log(`f(x):`);
 * customOp(x).print();
 * console.log(`f'(x):`);
 * dx(x).print();
 * ```
 *
 * @param f The function to evaluate in forward mode, which should return
 *     `{value: Tensor, gradFunc: (dy, saved) => Tensor[]}`, where `gradFunc`
 *     returns the custom gradients of `f` with respect to its inputs.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5(f) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).customGrad(f);
}
function $d54cf47ed1e7fb8d$var$checkGrads(grads) {
    const numNullGradients = grads.filter((g)=>g == null).length;
    if (numNullGradients > 0) throw new Error(`Cannot compute gradient of y=f(x) with respect to x. Make sure that
    the f you passed encloses all operations that lead from x to y.`);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46(value, dtype) {
    if (((0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(value) && dtype !== 'string' || Array.isArray(value)) && dtype !== 'complex64') throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if (dtype === 'string' && (0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(value) && !(value instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    const shape = [];
    const inferredShape = [];
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(value, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * Maps to mapping between the custom object and its name.
 *
 * After registering a custom class, these two maps will add key-value pairs
 * for the class object and the registered name.
 *
 * Therefore we can get the relative registered name by calling
 * getRegisteredName() function.
 *
 * For example:
 * GLOBAL_CUSTOM_OBJECT: {key=registeredName: value=corresponding
 * CustomObjectClass}
 *
 * GLOBAL_CUSTOM_NAMES: {key=CustomObjectClass: value=corresponding
 * registeredName}
 *
 */ const $40c153fc1adf46b0$var$GLOBAL_CUSTOM_OBJECT = new Map();
const $40c153fc1adf46b0$var$GLOBAL_CUSTOM_NAMES = new Map();
class $40c153fc1adf46b0$export$64782a6a7800f48c {
    /**
     * Return the class name for this class to use in serialization contexts.
     *
     * Generally speaking this will be the same thing that constructor.name
     * would have returned.  However, the class name needs to be robust
     * against minification for serialization/deserialization to work properly.
     *
     * There's also places such as initializers.VarianceScaling, where
     * implementation details between different languages led to different
     * class hierarchies and a non-leaf node is used for serialization purposes.
     */ getClassName() {
        return this.constructor.className;
    }
    /**
     * Creates an instance of T from a ConfigDict.
     *
     * This works for most descendants of serializable.  A few need to
     * provide special handling.
     * @param cls A Constructor for the class to instantiate.
     * @param config The Configuration for the object.
     */ /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
class $40c153fc1adf46b0$export$3a868b20f0f2f6c0 {
    constructor(){
        this.classNameMap = {};
    }
    /**
     * Returns the singleton instance of the map.
     */ static getMap() {
        if ($40c153fc1adf46b0$export$3a868b20f0f2f6c0.instance == null) $40c153fc1adf46b0$export$3a868b20f0f2f6c0.instance = new $40c153fc1adf46b0$export$3a868b20f0f2f6c0();
        return $40c153fc1adf46b0$export$3a868b20f0f2f6c0.instance;
    }
    /**
     * Registers the class as serializable.
     */ static register(cls) {
        $40c153fc1adf46b0$export$3a868b20f0f2f6c0.getMap().classNameMap[cls.className] = [
            cls,
            cls.fromConfig
        ];
    }
}
function $40c153fc1adf46b0$export$a3f7d716dc76cb2e(cls, pkg, name) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(cls.className != null, ()=>`Class being registered does not have the static className ` + `property defined.`);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(typeof cls.className === 'string', ()=>`className is required to be a string, but got type ` + typeof cls.className);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(cls.className.length > 0, ()=>`Class being registered has an empty-string as its className, ` + `which is disallowed.`);
    if (typeof pkg === 'undefined') pkg = 'Custom';
    if (typeof name === 'undefined') name = cls.className;
    const className = name;
    const registerName = pkg + '>' + className;
    $40c153fc1adf46b0$export$3a868b20f0f2f6c0.register(cls);
    $40c153fc1adf46b0$var$GLOBAL_CUSTOM_OBJECT.set(registerName, cls);
    $40c153fc1adf46b0$var$GLOBAL_CUSTOM_NAMES.set(cls, registerName);
    return cls;
}
function $40c153fc1adf46b0$export$33f51542dd5bdf78(cls) {
    if ($40c153fc1adf46b0$var$GLOBAL_CUSTOM_NAMES.has(cls)) return $40c153fc1adf46b0$var$GLOBAL_CUSTOM_NAMES.get(cls);
    else return cls.className;
}


class $48d5dd7cc40870d2$export$69ae9293516e70f0 extends (0, $40c153fc1adf46b0$export$64782a6a7800f48c) {
    /**
     * Executes `f()` and minimizes the scalar output of `f()` by computing
     * gradients of y with respect to the list of trainable variables provided by
     * `varList`. If no list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to minimize.
     * @param returnCost Whether to return the scalar cost value produced by
     * executing `f()`.
     * @param varList An optional list of variables to update. If specified, only
     * the trainable variables in varList will be updated by minimize. Defaults to
     * all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ minimize(f, returnCost = false, varList) {
        const { value: value, grads: grads } = this.computeGradients(f, varList);
        if (varList != null) {
            const gradArray = varList.map((v)=>({
                    name: v.name,
                    tensor: grads[v.name]
                }));
            this.applyGradients(gradArray);
        } else this.applyGradients(grads);
        // Dispose gradients.
        (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(grads);
        if (returnCost) return value;
        else {
            value.dispose();
            return null;
        }
    }
    /**
     * The number of iterations that this optimizer instance has been invoked for.
     */ get iterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return this.iterations_;
    }
    incrementIterations() {
        this.iterations_ = this.iterations + 1;
    }
    /**
     * Executes f() and computes the gradient of the scalar output of f() with
     * respect to the list of trainable variables provided by `varList`. If no
     * list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to use for computing
     * gradients with respect to variables.
     * @param varList An optional list of variables to compute gradients with
     * respect to. If specified, only the trainable variables in varList will have
     * gradients computed with respect to. Defaults to all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ computeGradients(f, varList) {
        return (0, $d54cf47ed1e7fb8d$export$c756d9ed08b9677f)(f, varList);
    }
    /**
     * Dispose the variables (if any) owned by this optimizer instance.
     */ dispose() {
        if (this.iterations_ != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.iterations_);
    }
    async saveIterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return {
            name: 'iter',
            // TODO(cais): Use 'int64' type when available.
            tensor: (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(this.iterations_, 'int32')
        };
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for this optimizer yet.');
    }
    async setWeights(weightValues) {
        throw new Error(`setWeights() is not implemented for this optimizer class ` + `${this.getClassName()}`);
    }
    /**
     * Extract the first element of the weight values and set it
     * as the iterations counter variable of this instance of optimizer.
     *
     * @param weightValues
     * @returns Weight values with the first element consumed and excluded.
     */ async extractIterations(weightValues) {
        this.iterations_ = (await weightValues[0].tensor.data())[0];
        return weightValues.slice(1);
    }
}
Object.defineProperty($48d5dd7cc40870d2$export$69ae9293516e70f0, Symbol.hasInstance, {
    value: (instance)=>{
        return instance.minimize != null && instance.computeGradients != null && instance.applyGradients != null;
    }
});


class $44319e42f1f8891c$export$d80a766c536c9aaf extends (0, $48d5dd7cc40870d2$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adadelta';
    }
    constructor(learningRate, rho, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.rho = rho;
        this.epsilon = epsilon;
        this.accumulatedGrads = [];
        this.accumulatedUpdates = [];
        if (epsilon == null) this.epsilon = (0, $6a645535e157b279$export$33b63313cc511a3b).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedGrads[i] == null) this.accumulatedGrads[i] = {
                originalName: `${name}/accum_grad`,
                variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
            };
            if (this.accumulatedUpdates[i] == null) this.accumulatedUpdates[i] = {
                originalName: `${name}/accum_var`,
                variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            const accumulatedUpdate = this.accumulatedUpdates[i].variable;
            (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                const newAccumulatedGrad = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedGrad, this.rho), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(gradient), 1 - this.rho));
                const updates = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $8efd352f234ac278$export$e16d8520af44a096)(accumulatedUpdate, this.epsilon)), (0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $8efd352f234ac278$export$e16d8520af44a096)(accumulatedGrad, this.epsilon))), gradient);
                const newAccumulatedUpdate = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedUpdate, this.rho), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(updates), 1 - this.rho));
                accumulatedGrad.assign(newAccumulatedGrad);
                accumulatedUpdate.assign(newAccumulatedUpdate);
                const newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(updates, -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedUpdates != null) {
            (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedGrads.map((v)=>v.variable));
            (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedUpdates.map((v)=>v.variable));
        }
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedGrads,
            ...this.accumulatedUpdates
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedGrads = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedUpdates = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'rho': this.rho,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['rho'], config['epsilon']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` filled with a scalar value.
 *
 * ```js
 * tf.fill([2, 2], 4).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param value The scalar value to fill the tensor with.
 * @param dtype The type of an element in the resulting tensor. Defaults to
 *     'float32' if the given param value is a number, otherwise 'string'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $a1afd8d5a9faad9a$export$9563e054e6f787fb(shape, value, dtype) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    dtype = dtype || (0, $9e4a6174e3538e7d$export$2005775d905d2dc2)(value);
    const attrs = {
        shape: shape,
        value: value,
        dtype: dtype
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ffffe40bfa0649a3), {}, attrs);
}






class $5d7ea0bb3b70b6ad$export$fa35e48f6f1caa57 extends (0, $48d5dd7cc40870d2$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adagrad';
    }
    constructor(learningRate, initialAccumulatorValue = 0.1){
        super();
        this.learningRate = learningRate;
        this.initialAccumulatorValue = initialAccumulatorValue;
        this.accumulatedGrads = [];
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
            if (this.accumulatedGrads[i] == null) {
                const trainable = false;
                this.accumulatedGrads[i] = {
                    originalName: `${name}/accumulator`,
                    variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a1afd8d5a9faad9a$export$9563e054e6f787fb)(value.shape, this.initialAccumulatorValue).variable(trainable))
                };
            }
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                const newAccumulatedGrad = (0, $8efd352f234ac278$export$e16d8520af44a096)(accumulatedGrad, (0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(gradient));
                accumulatedGrad.assign(newAccumulatedGrad);
                const newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(gradient, (0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $8efd352f234ac278$export$e16d8520af44a096)(newAccumulatedGrad, (0, $6a645535e157b279$export$33b63313cc511a3b).backend.epsilon()))), -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedGrads != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedGrads.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulatedGrads.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulatedGrads = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'initialAccumulatorValue': this.initialAccumulatorValue
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['initialAccumulatorValue']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the power of one `tf.Tensor` to another. Supports broadcasting.
 *
 * Given a `tf.Tensor` x and a `tf.Tensor` y, this operation computes x^y for
 * corresponding elements in x and y. The result's dtype will be the upcasted
 * type of the `base` and `exp` dtypes.
 *
 * ```js
 * const a = tf.tensor([[2, 3], [4, 5]])
 * const b = tf.tensor([[1, 2], [3, 0]]).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 *
 * ```js
 * const a = tf.tensor([[1, 2], [3, 4]])
 * const b = tf.tensor(2).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 * We also expose `powStrict` which has the same signature as this op and
 * asserts that `base` and `exp` are the same shape (does not broadcast).
 *
 * @param base The base `tf.Tensor` to pow element-wise.
 * @param exp The exponent `tf.Tensor` to pow element-wise.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $dfeb0ec8a84c566a$var$pow_(base, exp) {
    let $base = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(base, 'base', 'pow');
    let $exp = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(exp, 'exp', 'pow');
    [$base, $exp] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($base, $exp);
    const inputs = {
        a: $base,
        b: $exp
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ce28d653ec559ee), inputs);
}
const $dfeb0ec8a84c566a$export$9c297f60e22e3389 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pow_: $dfeb0ec8a84c566a$var$pow_
});





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Subtracts two `tf.Tensor`s element-wise, A - B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 *
 * ```js
 * // Broadcast subtract a with b.
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.scalar(5);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 * @param a The first `tf.Tensor` to subtract from.
 * @param b The second `tf.Tensor` to be subtracted. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $6b10a09db634e9ba$var$sub_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'sub');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'sub');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d7a01e11500dfb6f), inputs);
}
const $6b10a09db634e9ba$export$f93b5905241a7cca = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sub_: $6b10a09db634e9ba$var$sub_
});




class $9c0f711b74ba380e$export$de1938eb5fee8ee2 extends (0, $48d5dd7cc40870d2$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adam';
    }
    constructor(learningRate, beta1, beta2, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.accumulatedFirstMoment = [];
        this.accumulatedSecondMoment = [];
        (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            // accB* will be updated by batch.
            this.accBeta1 = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(beta1).variable();
            this.accBeta2 = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(beta2).variable();
        });
        if (epsilon == null) this.epsilon = (0, $6a645535e157b279$export$33b63313cc511a3b).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const oneMinusAccBeta1 = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(1, this.accBeta1);
            const oneMinusAccBeta2 = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(1, this.accBeta2);
            varNames.forEach((name, i)=>{
                const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
                };
                if (this.accumulatedSecondMoment[i] == null) this.accumulatedSecondMoment[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const secondMoment = this.accumulatedSecondMoment[i].variable;
                const newFirstMoment = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(firstMoment, this.beta1), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(gradient, 1 - this.beta1));
                const newSecondMoment = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(secondMoment, this.beta2), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(gradient), 1 - this.beta2));
                const biasCorrectedFirstMoment = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(newFirstMoment, oneMinusAccBeta1);
                const biasCorrectedSecondMoment = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(newSecondMoment, oneMinusAccBeta2);
                firstMoment.assign(newFirstMoment);
                secondMoment.assign(newSecondMoment);
                const newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(biasCorrectedFirstMoment, (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $829be0ea336e2128$export$eba8049fb5020b81)(biasCorrectedSecondMoment), this.epsilon)), -this.learningRate), value);
                value.assign(newValue);
            });
            this.accBeta1.assign((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.accBeta1, this.beta1));
            this.accBeta2.assign((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.accBeta2, this.beta2));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.accBeta2.dispose();
        if (this.accumulatedFirstMoment != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedSecondMoment != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedSecondMoment.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedFirstMoment,
            ...this.accumulatedSecondMoment
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            this.accBeta1.assign((0, $dfeb0ec8a84c566a$export$9c297f60e22e3389)(this.beta1, this.iterations_ + 1));
            this.accBeta2.assign((0, $dfeb0ec8a84c566a$export$9c297f60e22e3389)(this.beta2, this.iterations_ + 1));
        });
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes absolute value element-wise: `abs(x)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.abs().print();  // or tf.abs(x)
 * ```
 * @param x The input `tf.Tensor`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ac4659b792ae4bef$var$abs_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'abs');
    if ($x.dtype === 'complex64') {
        const inputs = {
            x: $x
        };
        return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$32902e58f1b48f4b), inputs);
    } else {
        const inputs = {
            x: $x
        };
        return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b73c596ee8758a66), inputs);
    }
}
const $ac4659b792ae4bef$export$2335f513bbd82c6d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    abs_: $ac4659b792ae4bef$var$abs_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



var $5ede3b6f723b9f5a$exports = {};

$parcel$export($5ede3b6f723b9f5a$exports, "getBroadcastDims", () => $5ede3b6f723b9f5a$export$fc823784344690e0);
$parcel$export($5ede3b6f723b9f5a$exports, "getReductionAxes", () => $5ede3b6f723b9f5a$export$9f11ec258a9b2804);
$parcel$export($5ede3b6f723b9f5a$exports, "assertAndGetBroadcastShape", () => $5ede3b6f723b9f5a$export$a3e2a38a57ec8318);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Returns the dimensions in the input shape that are broadcasted to
 * produce the provided output shape.
 *
 * The returned dimensions are 0-indexed and sorted. An example:
 * inShape = [4, 1, 3]
 * outShape = [5, 4, 3, 3]
 * result = [1]. Dimension 1 (2nd dimension of input) gets broadcasted 1 => 3.
 */ function $5ede3b6f723b9f5a$export$fc823784344690e0(inShape, outShape) {
    const inRank = inShape.length;
    const dims = [];
    for(let i = 0; i < inRank; i++){
        const dim = inRank - 1 - i;
        const a = inShape[dim] || 1;
        const b = outShape[outShape.length - 1 - i] || 1;
        if (b > 1 && a === 1) dims.unshift(dim);
    }
    return dims;
}
function $5ede3b6f723b9f5a$export$9f11ec258a9b2804(inShape, outShape) {
    const result = [];
    for(let i = 0; i < outShape.length; i++){
        const inDim = inShape[inShape.length - i - 1];
        const outAxis = outShape.length - i - 1;
        const outDim = outShape[outAxis];
        if (inDim == null || inDim === 1 && outDim > 1) result.unshift(outAxis);
    }
    return result;
}
function $5ede3b6f723b9f5a$export$a3e2a38a57ec8318(shapeA, shapeB) {
    const l = Math.max(shapeA.length, shapeB.length);
    const result = new Array(l);
    for(let i = 0; i < l; i++){
        let a = shapeA[shapeA.length - i - 1];
        if (a == null) a = 1;
        let b = shapeB[shapeB.length - i - 1];
        if (b == null) b = 1;
        if (a === 1) result[l - i - 1] = b;
        else if (b === 1) result[l - i - 1] = a;
        else if (a !== b) {
            const errMsg = `Operands could not be broadcast together with shapes ` + `${shapeA} and ${shapeB}.`;
            throw Error(errMsg);
        } else result[l - i - 1] = a;
    }
    return result;
}




/**
 * Returns the max of a and b (`a > b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `tf.maximumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * ```js
 * // Broadcast maximum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $23b950e6abbae120$var$maximum_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'maximum');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'maximum');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($a, 'int32');
        $b = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($b, 'int32');
    }
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d8d02ac92d161004), inputs);
}
const $23b950e6abbae120$export$b25e0be55f42c9a = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    maximum_: $23b950e6abbae120$var$maximum_
});







class $ffde8d09e756940c$export$69957d0bff775eb6 extends (0, $48d5dd7cc40870d2$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adamax';
    }
    constructor(learningRate, beta1, beta2, epsilon = null, decay = 0.0){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.decay = decay;
        this.accumulatedFirstMoment = [];
        this.accumulatedWeightedInfNorm = [];
        (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            this.iteration = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0).variable();
            this.accBeta1 = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(beta1).variable();
        });
        if (epsilon == null) this.epsilon = (0, $6a645535e157b279$export$33b63313cc511a3b).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const oneMinusAccBeta1 = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(1, this.accBeta1);
            const lr = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(-this.learningRate, (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.iteration, this.decay), 1));
            variableNames.forEach((name, i)=>{
                const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable)
                };
                if (this.accumulatedWeightedInfNorm[i] == null) this.accumulatedWeightedInfNorm[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable)
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const weightedInfNorm = this.accumulatedWeightedInfNorm[i].variable;
                const newFirstMoment = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(firstMoment, this.beta1), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(gradient, 1 - this.beta1));
                const ut0 = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(weightedInfNorm, this.beta2);
                const ut1 = (0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(gradient);
                const newWeightedInfNorm = (0, $23b950e6abbae120$export$b25e0be55f42c9a)(ut0, ut1);
                firstMoment.assign(newFirstMoment);
                weightedInfNorm.assign(newWeightedInfNorm);
                const newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(lr, oneMinusAccBeta1), (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(newFirstMoment, (0, $8efd352f234ac278$export$e16d8520af44a096)(newWeightedInfNorm, this.epsilon))), value);
                value.assign(newValue);
            });
            this.iteration.assign((0, $8efd352f234ac278$export$e16d8520af44a096)(this.iteration, 1));
            this.accBeta1.assign((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.accBeta1, this.beta1));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.iteration.dispose();
        if (this.accumulatedFirstMoment != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedWeightedInfNorm != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedWeightedInfNorm.map((v)=>v.variable));
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for Adamax yet.');
    }
    async setWeights(weightValues) {
        throw new Error('setWeights() is not implemented for Adamax yet.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon,
            'decay': this.decay
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon'], config['decay']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





class $ee2a64408d6bfb28$export$97318dd520e1bd4f extends (0, $48d5dd7cc40870d2$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'SGD';
    }
    constructor(learningRate){
        super();
        this.learningRate = learningRate;
        this.setLearningRate(learningRate);
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        varNames.forEach((name, i)=>{
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
            (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                const newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.c, gradient), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    /**
     * Sets the learning rate of the optimizer.
     */ setLearningRate(learningRate) {
        this.learningRate = learningRate;
        if (this.c != null) this.c.dispose();
        this.c = (0, $8a461ef06e070cc9$export$fae3166c418e0471)((0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(-learningRate));
    }
    dispose() {
        this.c.dispose();
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ];
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        if (weightValues.length !== 0) throw new Error('SGD optimizer does not have settable weights.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate']);
    }
}


class $94a990cdc33b294a$export$1db7ecf1f8312c6 extends (0, $ee2a64408d6bfb28$export$97318dd520e1bd4f) {
    /** @nocollapse */ // Name matters for Python compatibility.
    static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Momentum';
    }
    constructor(learningRate, momentum, useNesterov = false){
        super(learningRate);
        this.learningRate = learningRate;
        this.momentum = momentum;
        this.useNesterov = useNesterov;
        this.accumulations = [];
        this.m = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(this.momentum);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
            if (this.accumulations[i] == null) {
                const trainable = false;
                this.accumulations[i] = {
                    originalName: `${name}/momentum`,
                    variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
                };
            }
            const accumulation = this.accumulations[i].variable;
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                let newValue;
                const newAccumulation = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.m, accumulation), gradient);
                if (this.useNesterov) newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.c, (0, $8efd352f234ac278$export$e16d8520af44a096)(gradient, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(newAccumulation, this.m))), value);
                else newValue = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(this.c, newAccumulation), value);
                accumulation.assign(newAccumulation);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        this.m.dispose();
        if (this.accumulations != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulations.map((v)=>v.variable));
    }
    /**
     * Sets the momentum of the optimizer.
     *
     * @param momentum
     */ setMomentum(momentum) {
        this.momentum = momentum;
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulations.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulations = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'momentum': this.momentum,
            'useNesterov': this.useNesterov
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['momentum'], config['useNesterov']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









class $df93e2fa71f7d3a5$export$6e668138ce08e3bf extends (0, $48d5dd7cc40870d2$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'RMSProp';
    }
    constructor(learningRate, decay = 0.9, momentum = 0.0, epsilon = null, centered = false){
        super();
        this.learningRate = learningRate;
        this.decay = decay;
        this.momentum = momentum;
        this.epsilon = epsilon;
        this.accumulatedMeanSquares = [];
        this.accumulatedMoments = [];
        this.accumulatedMeanGrads = [];
        this.centered = centered;
        if (epsilon == null) this.epsilon = (0, $6a645535e157b279$export$33b63313cc511a3b).backend.epsilon();
        if (learningRate == null) throw new Error(`learningRate for RMSPropOptimizer must be defined.`);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $6a645535e157b279$export$33b63313cc511a3b).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedMeanSquares[i] == null) this.accumulatedMeanSquares[i] = {
                originalName: `${name}/rms`,
                variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
            };
            if (this.accumulatedMoments[i] == null) this.accumulatedMoments[i] = {
                originalName: `${name}/momentum`,
                variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
            };
            if (this.accumulatedMeanGrads[i] == null && this.centered) this.accumulatedMeanGrads[i] = {
                originalName: `${name}/mg`,
                variable: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>(0, $a5cb5e205b190f05$export$cb1f824e7733584d)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedMeanSquare = this.accumulatedMeanSquares[i].variable;
            const accumulatedMoments = this.accumulatedMoments[i].variable;
            (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                const newAccumulatedMeanSquare = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedMeanSquare, this.decay), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(gradient), 1 - this.decay));
                if (this.centered) {
                    const accumulatedMeanGrad = this.accumulatedMeanGrads[i].variable;
                    // Centered gradient
                    const newAccumulatedMeanGrad = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedMeanGrad, this.decay), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(gradient, 1 - this.decay));
                    const gradContribution = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(gradient, this.learningRate), (0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)(newAccumulatedMeanSquare, (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(newAccumulatedMeanGrad), this.epsilon))));
                    const newAccumulatedMoments = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedMoments, this.momentum), gradContribution);
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(value, newAccumulatedMoments);
                    value.assign(newValue);
                } else {
                    // Plain gradient
                    const newAccumulatedMeanSquare = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedMeanSquare, this.decay), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(gradient), 1 - this.decay));
                    const newAccumulatedMoments = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(accumulatedMoments, this.momentum), (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(gradient, this.learningRate), (0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $8efd352f234ac278$export$e16d8520af44a096)(newAccumulatedMeanSquare, this.epsilon))));
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(value, newAccumulatedMoments);
                    value.assign(newValue);
                }
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedMeanSquares != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedMeanSquares.map((v)=>v.variable));
        if (this.accumulatedMeanGrads != null && this.centered) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedMeanGrads.map((v)=>v.variable));
        if (this.accumulatedMoments != null) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.accumulatedMoments.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedMeanSquares,
            ...this.accumulatedMoments
        ];
        if (this.centered) variables.push(...this.accumulatedMeanGrads);
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
        const trainable = false;
        this.accumulatedMeanSquares = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedMoments = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        if (this.centered) this.accumulatedMeanGrads = weightValues.slice(variableCount * 2, variableCount * 3).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'decay': this.decay,
            'momentum': this.momentum,
            'epsilon': this.epsilon,
            'centered': this.centered
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['decay'], config['momentum'], config['epsilon'], config['centered']);
    }
}




const $4556f4d353a40dfb$var$OPTIMIZERS = [
    (0, $44319e42f1f8891c$export$d80a766c536c9aaf),
    (0, $5d7ea0bb3b70b6ad$export$fa35e48f6f1caa57),
    (0, $9c0f711b74ba380e$export$de1938eb5fee8ee2),
    (0, $ffde8d09e756940c$export$69957d0bff775eb6),
    (0, $94a990cdc33b294a$export$1db7ecf1f8312c6),
    (0, $df93e2fa71f7d3a5$export$6e668138ce08e3bf),
    (0, $ee2a64408d6bfb28$export$97318dd520e1bd4f)
];
function $4556f4d353a40dfb$export$9a85654c75805c9a() {
    for (const optimizer of $4556f4d353a40dfb$var$OPTIMIZERS)(0, $40c153fc1adf46b0$export$a3f7d716dc76cb2e)(optimizer);
}


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the indices of the maximum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMax().print();  // or tf.argMax(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMax(axis).print();  // or tf.argMax(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $3cfdfd16cd19c85f$var$argMax_(x, axis = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'argMax');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$17612294a1503e1c), inputs, attrs);
}
const $3cfdfd16cd19c85f$export$7980a683c1b852b4 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    argMax_: $3cfdfd16cd19c85f$var$argMax_
});

var $f35e0c1a651337db$exports = {};

$parcel$export($f35e0c1a651337db$exports, "fromUint8ToStringArray", () => $f35e0c1a651337db$export$debaff328bdca650);
$parcel$export($f35e0c1a651337db$exports, "fromStringArrayToUint8", () => $f35e0c1a651337db$export$ce1f4ec5bdd0ab9a);
$parcel$export($f35e0c1a651337db$exports, "slice_util", () => $f147fd057118a602$exports);
$parcel$export($f35e0c1a651337db$exports, "upcastType", () => $4ccb7c1368387e67$export$7bcca02d1a156bdf);
$parcel$export($f35e0c1a651337db$exports, "segment_util", () => $1ce909f7dd4e3bbe$exports);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fab93e7418eff1cc$exports = {};

$parcel$export($fab93e7418eff1cc$exports, "axesAreInnerMostDims", () => $fab93e7418eff1cc$export$fcf762ecdaba1fc1);
$parcel$export($fab93e7418eff1cc$exports, "combineLocations", () => $fab93e7418eff1cc$export$6cfee5a53150f612);
$parcel$export($fab93e7418eff1cc$exports, "computeOutAndReduceShapes", () => $fab93e7418eff1cc$export$68ecd7df33283881);
$parcel$export($fab93e7418eff1cc$exports, "expandShapeToKeepDim", () => $fab93e7418eff1cc$export$e35db9afe008d7e3);
$parcel$export($fab93e7418eff1cc$exports, "assertAxesAreInnerMostDims", () => $fab93e7418eff1cc$export$f83b6b93f3b44c9c);
$parcel$export($fab93e7418eff1cc$exports, "getAxesPermutation", () => $fab93e7418eff1cc$export$d2a6288eef79b310);
$parcel$export($fab93e7418eff1cc$exports, "getUndoAxesPermutation", () => $fab93e7418eff1cc$export$2975b40e45f30ba8);
$parcel$export($fab93e7418eff1cc$exports, "getInnerMostAxes", () => $fab93e7418eff1cc$export$b62922ed36931ab6);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $fab93e7418eff1cc$export$fcf762ecdaba1fc1(axes, rank) {
    for(let i = 0; i < axes.length; ++i){
        if (axes[axes.length - i - 1] !== rank - 1 - i) return false;
    }
    return true;
}
function $fab93e7418eff1cc$export$6cfee5a53150f612(outputLoc, reduceLoc, axes) {
    const rank = outputLoc.length + reduceLoc.length;
    const loc = [];
    let outIdx = 0;
    let reduceIdx = 0;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) loc.push(outputLoc[outIdx++]);
    else loc.push(reduceLoc[reduceIdx++]);
    return loc;
}
function $fab93e7418eff1cc$export$68ecd7df33283881(aShape, axes) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) outShape.push(aShape[dim]);
    const reduceShape = axes.map((dim)=>aShape[dim]);
    return [
        outShape,
        reduceShape
    ];
}
function $fab93e7418eff1cc$export$e35db9afe008d7e3(shape, axes) {
    const reduceSubShape = axes.map((x)=>1);
    return $fab93e7418eff1cc$export$6cfee5a53150f612(shape, reduceSubShape, axes);
}
function $fab93e7418eff1cc$export$f83b6b93f3b44c9c(msg, axes, rank) {
    $9e4a6174e3538e7d$export$a7a9523472993e97($fab93e7418eff1cc$export$fcf762ecdaba1fc1(axes, rank), ()=>`${msg} supports only inner-most axes for now. ` + `Got axes ${axes} and rank-${rank} input.`);
}
function $fab93e7418eff1cc$export$d2a6288eef79b310(axes, rank) {
    if ($fab93e7418eff1cc$export$fcf762ecdaba1fc1(axes, rank)) return null;
    const result = [];
    for(let i = 0; i < rank; ++i)if (axes.indexOf(i) === -1) result.push(i);
    axes.forEach((axis)=>result.push(axis));
    return result;
}
function $fab93e7418eff1cc$export$2975b40e45f30ba8(axes) {
    return axes.map((axis, i)=>[
            i,
            axis
        ]).sort((a, b)=>a[1] - b[1]).map((x)=>x[0]);
}
function $fab93e7418eff1cc$export$b62922ed36931ab6(numAxes, rank) {
    const res = [];
    for(let i = rank - numAxes; i < rank; ++i)res.push(i);
    return res;
}



var $5be849e9fa3ddc21$exports = {};

$parcel$export($5be849e9fa3ddc21$exports, "assertParamsConsistent", () => $5be849e9fa3ddc21$export$ce1cccab5e7518dd);
$parcel$export($5be849e9fa3ddc21$exports, "computeOutShape", () => $5be849e9fa3ddc21$export$22fa6b3b1305508e);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $5be849e9fa3ddc21$export$ce1cccab5e7518dd(shapes, axis) {
    const rank = shapes[0].length;
    shapes.forEach((shape, i)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(shape.length === rank, ()=>`Error in concat${rank}D: rank of tensors[${i}] must be the same ` + `as the rank of the rest (${rank})`);
    });
    $9e4a6174e3538e7d$export$a7a9523472993e97(axis >= 0 && axis < rank, ()=>`Error in concat${rank}D: axis must be between 0 and ${rank - 1}.`);
    const firstShape = shapes[0];
    shapes.forEach((shape, i)=>{
        for(let r = 0; r < rank; r++)$9e4a6174e3538e7d$export$a7a9523472993e97(r === axis || shape[r] === firstShape[r], ()=>`Error in concat${rank}D: Shape of tensors[${i}] (${shape}) ` + `does not match the shape of the rest (${firstShape}) ` + `along the non-concatenated axis ${i}.`);
    });
}
function $5be849e9fa3ddc21$export$22fa6b3b1305508e(shapes, axis) {
    const outputShape = shapes[0].slice();
    for(let i = 1; i < shapes.length; i++)outputShape[axis] += shapes[i][axis];
    return outputShape;
}


var $f9c374363849dff2$exports = {};

$parcel$export($f9c374363849dff2$exports, "computeDilation2DInfo", () => $f9c374363849dff2$export$24e8a5cb688b9852);
$parcel$export($f9c374363849dff2$exports, "convertConv2DDataFormat", () => $f9c374363849dff2$export$1641c6bb3eb9a5b4);
$parcel$export($f9c374363849dff2$exports, "computeConv2DInfo", () => $f9c374363849dff2$export$fdd37387e0a3c672);
$parcel$export($f9c374363849dff2$exports, "computePool2DInfo", () => $f9c374363849dff2$export$67e321f77840205c);
$parcel$export($f9c374363849dff2$exports, "computePool3DInfo", () => $f9c374363849dff2$export$1382473b2833755b);
$parcel$export($f9c374363849dff2$exports, "computeConv3DInfo", () => $f9c374363849dff2$export$e4819ceef3994d7b);
$parcel$export($f9c374363849dff2$exports, "computeDefaultPad", () => $f9c374363849dff2$export$670354fdcb16da70);
$parcel$export($f9c374363849dff2$exports, "tupleValuesAreOne", () => $f9c374363849dff2$export$f16174446c2d5b2a);
$parcel$export($f9c374363849dff2$exports, "eitherStridesOrDilationsAreOne", () => $f9c374363849dff2$export$1e13dbff91e2f5ca);
$parcel$export($f9c374363849dff2$exports, "stridesOrDilationsArePositive", () => $f9c374363849dff2$export$6f24ba18d950c7e3);
$parcel$export($f9c374363849dff2$exports, "checkPadOnDimRoundingMode", () => $f9c374363849dff2$export$1b3400c26a44af8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $f9c374363849dff2$export$24e8a5cb688b9852(inputShape, filterShape, strides, pad, dataFormat = 'NHWC', dilations) {
    // `computerConv2DInfo` require filterShape to be in the dimension of:
    // `[filterHeight, filterWidth, depth, outDepth]`, dilation2d doesn't have
    // outDepth, it should have the same depth as the input.
    // Input shape: [batch, height, width, inChannels]
    const inputChannels = inputShape[3];
    const $filterShape = [
        ...filterShape,
        inputChannels
    ];
    const $dataFormat = $f9c374363849dff2$export$1641c6bb3eb9a5b4(dataFormat);
    return $f9c374363849dff2$export$fdd37387e0a3c672(inputShape, $filterShape, strides, dilations, pad, null, null, $dataFormat);
}
function $f9c374363849dff2$export$67e321f77840205c(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'channelsLast') {
    const [filterHeight, filterWidth] = $f9c374363849dff2$var$parseTupleParam(filterSize);
    let filterShape;
    if (dataFormat === 'channelsLast') filterShape = [
        filterHeight,
        filterWidth,
        inShape[3],
        inShape[3]
    ];
    else if (dataFormat === 'channelsFirst') filterShape = [
        filterHeight,
        filterWidth,
        inShape[1],
        inShape[1]
    ];
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $f9c374363849dff2$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, false, dataFormat);
}
function $f9c374363849dff2$export$1382473b2833755b(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'NDHWC') {
    const [filterDepth, filterHeight, filterWidth] = $f9c374363849dff2$var$parse3TupleParam(filterSize);
    let filterShape;
    let $dataFormat;
    if (dataFormat === 'NDHWC') {
        $dataFormat = 'channelsLast';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[4],
            inShape[4]
        ];
    } else if (dataFormat === 'NCDHW') {
        $dataFormat = 'channelsFirst';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[1],
            inShape[1]
        ];
    } else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $f9c374363849dff2$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, false, $dataFormat, roundingMode);
}
function $f9c374363849dff2$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, depthwise = false, dataFormat = 'channelsLast') {
    let [batchSize, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideHeight, strideWidth] = $f9c374363849dff2$var$parseTupleParam(strides);
    const [dilationHeight, dilationWidth] = $f9c374363849dff2$var$parseTupleParam(dilations);
    const effectiveFilterHeight = $f9c374363849dff2$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $f9c374363849dff2$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outHeight: outHeight, outWidth: outWidth } = $f9c374363849dff2$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode, dataFormat);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $f9c374363849dff2$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, depthwise = false, dataFormat = 'channelsLast', roundingMode) {
    let [batchSize, inDepth, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inDepth, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inDepth, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterDepth, filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideDepth, strideHeight, strideWidth] = $f9c374363849dff2$var$parse3TupleParam(strides);
    const [dilationDepth, dilationHeight, dilationWidth] = $f9c374363849dff2$var$parse3TupleParam(dilations);
    const effectiveFilterDepth = $f9c374363849dff2$var$getEffectiveFilterSize(filterDepth, dilationDepth);
    const effectiveFilterHeight = $f9c374363849dff2$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $f9c374363849dff2$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth } = $f9c374363849dff2$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outDepth,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outDepth,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inDepth: inDepth,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideDepth: strideDepth,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterDepth: filterDepth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterDepth: effectiveFilterDepth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationDepth: dilationDepth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $f9c374363849dff2$var$computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $f9c374363849dff2$export$670354fdcb16da70(inShape, fieldSize, stride);
    const inputRows = inShape[0];
    const inputCols = inShape[1];
    const outputRows = $f9c374363849dff2$var$round((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputCols = $f9c374363849dff2$var$round((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    return [
        outputRows,
        outputCols
    ];
}
function $f9c374363849dff2$var$computeOutputShape4D(inShape, filterShape, outChannels, strides, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $f9c374363849dff2$export$670354fdcb16da70(inShape, filterShape[0], strides[0]);
    const outShape = [
        0,
        0,
        0,
        outChannels
    ];
    for(let index = 0; index < 3; index++)if (inShape[index] + 2 * zeroPad >= filterShape[index]) outShape[index] = $f9c374363849dff2$var$round((inShape[index] - filterShape[index] + 2 * zeroPad) / strides[index] + 1, roundingMode);
    return outShape;
}
function $f9c374363849dff2$export$670354fdcb16da70(inputShape, fieldSize, stride, dilation = 1) {
    const effectiveFieldSize = $f9c374363849dff2$var$getEffectiveFilterSize(fieldSize, dilation);
    return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
}
function $f9c374363849dff2$var$parseTupleParam(param) {
    if (typeof param === 'number') return [
        param,
        param,
        param
    ];
    if (param.length === 2) return [
        param[0],
        param[1],
        1
    ];
    return param;
}
function $f9c374363849dff2$var$parse3TupleParam(param) {
    return typeof param === 'number' ? [
        param,
        param,
        param
    ] : param;
}
/* See https://www.tensorflow.org/api_docs/python/tf/nn/atrous_conv2d
 * Atrous convolution is equivalent to standard convolution with upsampled
 * filters with effective_filter_height =
 * filter_height + (filter_height - 1) * (dilation - 1)
 * and effective_filter_width =
 * filter_width + (filter_width - 1) * (dilation - 1),
 * produced by inserting dilation - 1 zeros along consecutive elements across
 * the filters' spatial dimensions.
 * When there is a dilation, this converts a filter dimension to the
 * effective filter dimension, so it can be used in a standard convolution.
 */ function $f9c374363849dff2$var$getEffectiveFilterSize(filterSize, dilation) {
    if (dilation <= 1) return filterSize;
    return filterSize + (filterSize - 1) * (dilation - 1);
}
function $f9c374363849dff2$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode, dataFormat) {
    let padInfo;
    let outHeight;
    let outWidth;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            type: padType
        };
        const outShape = $f9c374363849dff2$var$computeOutputShape2D([
            inHeight,
            inWidth
        ], filterHeight, strideHeight, pad, roundingMode);
        outHeight = outShape[0];
        outWidth = outShape[1];
    } else if (pad === 'same') {
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
        const padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: 'SAME'
        };
    } else if (pad === 'valid') {
        padInfo = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            type: 'VALID'
        };
        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
    } else if (typeof pad === 'object') {
        const top = dataFormat === 'channelsLast' ? pad[1][0] : pad[2][0];
        const bottom = dataFormat === 'channelsLast' ? pad[1][1] : pad[2][1];
        const left = dataFormat === 'channelsLast' ? pad[2][0] : pad[3][0];
        const right = dataFormat === 'channelsLast' ? pad[2][1] : pad[3][1];
        const padType = top === 0 && bottom === 0 && left === 0 && right === 0 ? 'VALID' : 'EXPLICIT';
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: padType
        };
        outHeight = $f9c374363849dff2$var$round((inHeight - filterHeight + top + bottom) / strideHeight + 1, roundingMode);
        outWidth = $f9c374363849dff2$var$round((inWidth - filterWidth + left + right) / strideWidth + 1, roundingMode);
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
function $f9c374363849dff2$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
    let padInfo;
    let outDepth;
    let outHeight;
    let outWidth;
    if (pad === 'valid') pad = 0;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            front: pad,
            back: pad,
            type: padType
        };
        const outShape = $f9c374363849dff2$var$computeOutputShape4D([
            inDepth,
            inHeight,
            inWidth,
            1
        ], [
            filterDepth,
            filterHeight,
            filterWidth
        ], 1, [
            strideDepth,
            strideHeight,
            strideWidth
        ], pad, roundingMode);
        outDepth = outShape[0];
        outHeight = outShape[1];
        outWidth = outShape[2];
    } else if (pad === 'same') {
        outDepth = Math.ceil(inDepth / strideDepth);
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
        const padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
        const padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
        const front = Math.floor(padAlongDepth / 2);
        const back = padAlongDepth - front;
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            front: front,
            back: back,
            type: 'SAME'
        };
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
/**
 * Rounds a value depending on the rounding mode
 * @param value
 * @param roundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $f9c374363849dff2$var$round(value, roundingMode) {
    if (!roundingMode) return Math.trunc(value);
    switch(roundingMode){
        case 'round':
            // used for Caffe Conv
            return Math.round(value);
        case 'ceil':
            // used for Caffe Pool
            return Math.ceil(value);
        case 'floor':
            return Math.floor(value);
        default:
            throw new Error(`Unknown roundingMode ${roundingMode}`);
    }
}
function $f9c374363849dff2$export$f16174446c2d5b2a(param) {
    const [dimA, dimB, dimC] = $f9c374363849dff2$var$parseTupleParam(param);
    return dimA === 1 && dimB === 1 && dimC === 1;
}
function $f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations) {
    return $f9c374363849dff2$export$f16174446c2d5b2a(strides) || $f9c374363849dff2$export$f16174446c2d5b2a(dilations);
}
function $f9c374363849dff2$export$6f24ba18d950c7e3(values) {
    return $f9c374363849dff2$var$parseTupleParam(values).every((value)=>value > 0);
}
function $f9c374363849dff2$export$1641c6bb3eb9a5b4(dataFormat) {
    if (dataFormat === 'NHWC') return 'channelsLast';
    else if (dataFormat === 'NCHW') return 'channelsFirst';
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
}
function $f9c374363849dff2$export$1b3400c26a44af8(opDesc, pad, dimRoundingMode) {
    if (dimRoundingMode != null) {
        if (typeof pad === 'string') throw Error(`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'number') $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$357fc28f6427af8b(pad), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'object') pad.forEach((p)=>{
            p.forEach((v)=>{
                $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$357fc28f6427af8b(v), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${v}.`);
            });
        });
        else throw Error(`Error in ${opDesc}: Unknown padding parameter: ${pad}`);
    }
}


var $c561cfa6a1183f44$exports = {};

$parcel$export($c561cfa6a1183f44$exports, "getFusedDyActivation", () => $c561cfa6a1183f44$export$a1905aed55f51aef);
$parcel$export($c561cfa6a1183f44$exports, "getFusedBiasGradient", () => $c561cfa6a1183f44$export$1a797e236ae09d1f);
$parcel$export($c561cfa6a1183f44$exports, "applyActivation", () => $c561cfa6a1183f44$export$a0f250a2ba84196);
$parcel$export($c561cfa6a1183f44$exports, "shouldFuse", () => $c561cfa6a1183f44$export$4904add493b957ab);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes exponential linear element-wise: `x > 0 ? x : (e ^ x) - 1`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 1, -3, 2]);
 *
 * x.elu().print();  // or tf.elu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5bdd6bdcdfee63f8$var$elu_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'elu', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$64636e173424d83d), inputs);
}
const $5bdd6bdcdfee63f8$export$796b583dd79d8524 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    elu_: $5bdd6bdcdfee63f8$var$elu_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes leaky rectified linear element-wise.
 *
 * See
 * [http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf](
 *     http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf)
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.leakyRelu(0.1).print();  // or tf.leakyRelu(x, 0.1)
 * ```
 * @param x The input tensor.
 * @param alpha The scaling factor for negative values, defaults to 0.2.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0c93893b76e462ad$var$leakyRelu_(x, alpha = 0.2) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'leakyRelu');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f0c7162bb7af1a2d), inputs, attrs);
}
const $0c93893b76e462ad$export$23a860e40a2c6b61 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    leakyRelu_: $0c93893b76e462ad$var$leakyRelu_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes leaky rectified linear element-wise with parametric alphas.
 *
 * `x < 0 ? alpha * x : f(x) = x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 * const alpha = tf.scalar(0.1);
 *
 * x.prelu(alpha).print();  // or tf.prelu(x, alpha)
 * ```
 * @param x The input tensor.
 * @param alpha Scaling factor for negative values.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $69a5169271dc480f$var$prelu_(x, alpha) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'prelu');
    const $alpha = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(alpha, 'alpha', 'prelu');
    const inputs = {
        x: $x,
        alpha: $alpha
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$a42f35f308fc2fa3), inputs);
}
const $69a5169271dc480f$export$5882f235222e6729 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    prelu_: $69a5169271dc480f$var$prelu_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes rectified linear element-wise: `max(x, 0)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.relu().print();  // or tf.relu(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6c8b0dbda17f9033$var$relu_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'relu');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9a6ff968bf961432), inputs);
}
const $6c8b0dbda17f9033$export$16d1e4612cc0139f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    relu_: $6c8b0dbda17f9033$var$relu_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes rectified linear 6 element-wise: `min(max(x, 0), 6)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 8]);
 *
 * x.relu6().print();  // or tf.relu6(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9412c844ada93d82$var$relu6_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'relu6');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$3be9e924f629054e), inputs);
}
const $9412c844ada93d82$export$4a62bcb95e9c44c4 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    relu6_: $9412c844ada93d82$var$relu6_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reshapes a `tf.Tensor` to a given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * If one component of shape is the special value -1, the size of that
 * dimension is computed so that the total size remains constant. In
 * particular, a shape of [-1] flattens into 1-D. At most one component of
 * shape can be -1.
 *
 * If shape is 1-D or higher, then the operation returns a tensor with shape
 * shape filled with the values of tensor. In this case, the number of
 * elements implied by shape must be the same as the number of elements in
 * tensor.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.reshape([2, 2]).print();
 * ```
 *
 * @param x The input tensor to be reshaped.
 * @param shape An array of integers defining the output tensor shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $6e2ae4fe7bb01bb0$var$reshape_(x, shape) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reshape', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        shape: shape
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$755ddd847e5abe03), inputs, attrs);
}
const $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reshape_: $6e2ae4fe7bb01bb0$var$reshape_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes sigmoid element-wise, `1 / (1 + exp(-x))`
 *
 * ```js
 * const x = tf.tensor1d([0, -1, 2, -3]);
 *
 * x.sigmoid().print();  // or tf.sigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $4e7e1888b524d401$var$sigmoid_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'sigmoid', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$fde18c826dda6b1b), inputs);
}
const $4e7e1888b524d401$export$3b295495ca3cad7c = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sigmoid_: $4e7e1888b524d401$var$sigmoid_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes step of the input `tf.Tensor` element-wise: `x > 0 ? 1 : alpha`
 *
 * ```js
 * const x = tf.tensor1d([0, 2, -1, -3]);
 *
 * x.step(.5).print();  // or tf.step(x, .5)
 * ```
 * @param x The input tensor.
 * @param alpha The gradient when input is negative. Defaults to 0.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9412dac12debc677$var$step_(x, alpha = 0.0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'step');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$fd55ce593607084a), inputs, attrs);
}
const $9412dac12debc677$export$35d34bc0ed591a92 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    step_: $9412dac12debc677$var$step_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the sum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If axes has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.sum().print();  // or tf.sum(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.sum(axis).print();  // or tf.sum(x, axis)
 * ```
 *
 * @param x The input tensor to compute the sum over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $140b816be4851e95$var$sum_(x, axis = null, keepDims = false) {
    let $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'sum');
    if ($x.dtype === 'bool') $x = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$534760f50726d5), inputs, attrs);
}
const $140b816be4851e95$export$8a63f25cc62965f1 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sum_: $140b816be4851e95$var$sum_
});


function $c561cfa6a1183f44$export$a1905aed55f51aef(dy, y, activation) {
    if (activation == null || activation === 'linear') return dy;
    if (activation === 'relu') return (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(dy, (0, $9412dac12debc677$export$35d34bc0ed591a92)(y));
    throw new Error(`Cannot compute gradient for fused activation ${activation}.`);
}
function $c561cfa6a1183f44$export$1a797e236ae09d1f(bias, dyActivation) {
    let res = dyActivation;
    const reduceAxes = $5ede3b6f723b9f5a$export$9f11ec258a9b2804(bias.shape, dyActivation.shape);
    if (reduceAxes.length > 0) res = (0, $140b816be4851e95$export$8a63f25cc62965f1)(res, reduceAxes);
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, bias.shape);
}
function $c561cfa6a1183f44$export$a0f250a2ba84196(x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return x;
    else if (activation === 'relu') return (0, $6c8b0dbda17f9033$export$16d1e4612cc0139f)(x);
    else if (activation === 'elu') return (0, $5bdd6bdcdfee63f8$export$796b583dd79d8524)(x);
    else if (activation === 'relu6') return (0, $9412c844ada93d82$export$4a62bcb95e9c44c4)(x);
    else if (activation === 'prelu') return (0, $69a5169271dc480f$export$5882f235222e6729)(x, preluActivationWeights);
    else if (activation === 'leakyrelu') return (0, $0c93893b76e462ad$export$23a860e40a2c6b61)(x, leakyreluAlpha);
    else if (activation === 'sigmoid') return (0, $4e7e1888b524d401$export$3b295495ca3cad7c)(x);
    throw new Error(`Unknown fused activation ${activation}.`);
}
const $c561cfa6a1183f44$export$4904add493b957ab = (gradientDepth, activation)=>{
    const gradientMode = gradientDepth > 0;
    return !gradientMode || activation === 'linear';
};


var $2ca7341467f87d13$exports = {};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

var $2164e21a23ca882e$exports = {};

$parcel$export($2164e21a23ca882e$exports, "RowPartitionType", () => $2164e21a23ca882e$export$c56fa138ccffd243);
$parcel$export($2164e21a23ca882e$exports, "combineRaggedTensorToTensorShapes", () => $2164e21a23ca882e$export$ab67507eda6e05cb);
$parcel$export($2164e21a23ca882e$exports, "getRowPartitionTypesHelper", () => $2164e21a23ca882e$export$b8324e259bdd3daf);
$parcel$export($2164e21a23ca882e$exports, "getRaggedRank", () => $2164e21a23ca882e$export$1cdd548e021d4109);
$parcel$export($2164e21a23ca882e$exports, "validateDefaultValueShape", () => $2164e21a23ca882e$export$4170394182a906f5);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $2164e21a23ca882e$export$c56fa138ccffd243;
(function(RowPartitionType) {
    RowPartitionType[RowPartitionType["FIRST_DIM_SIZE"] = 0] = "FIRST_DIM_SIZE";
    RowPartitionType[RowPartitionType["VALUE_ROWIDS"] = 1] = "VALUE_ROWIDS";
    RowPartitionType[RowPartitionType["ROW_LENGTHS"] = 2] = "ROW_LENGTHS";
    RowPartitionType[RowPartitionType["ROW_SPLITS"] = 3] = "ROW_SPLITS";
    RowPartitionType[RowPartitionType["ROW_LIMITS"] = 4] = "ROW_LIMITS";
    RowPartitionType[RowPartitionType["ROW_STARTS"] = 5] = "ROW_STARTS";
})($2164e21a23ca882e$export$c56fa138ccffd243 || ($2164e21a23ca882e$export$c56fa138ccffd243 = {}));
function $2164e21a23ca882e$export$ab67507eda6e05cb(raggedRank, shape, valueShape) {
    // Test for consistency of valueShape and shape specified.
    // If shape is unspecified and valueShape is specified, then copy
    // over the size from the valueShape dimension.
    let outputShape = new Array();
    if (valueShape == null && shape == null) return outputShape;
    if (shape == null) // Here, value_shape must be of known size.
    while(outputShape.length < raggedRank + valueShape.length)outputShape.push(-1);
    else outputShape = shape.slice();
    if (valueShape == null) return outputShape;
    // At this point, valueShape and output_shape have known ranks.
    if (raggedRank + valueShape.length !== outputShape.length) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.rank = ${raggedRank + valueShape.length}, but shape.rank = ${outputShape.length}`);
    for(let i = 1; i < valueShape.length; ++i){
        const valueDim = valueShape[i];
        const outputShapeDimIndex = outputShape[outputShape.length - valueShape.length + i];
        const outputShapeDim = outputShape[outputShapeDimIndex];
        if (valueDim >= 0) {
            if (outputShapeDim >= 0) {
                if (outputShapeDim !== valueDim) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.shape[${i + raggedRank}] = ${valueDim} but shape[${i + raggedRank}] = ${outputShapeDim}`);
            } else outputShape[outputShapeDimIndex] = valueDim;
        }
    }
    return outputShape;
}
function $2164e21a23ca882e$export$b8324e259bdd3daf(rowPartitionTypeStrings) {
    const stringToType = {
        'FIRST_DIM_SIZE': $2164e21a23ca882e$export$c56fa138ccffd243.FIRST_DIM_SIZE,
        'VALUE_ROWIDS': $2164e21a23ca882e$export$c56fa138ccffd243.VALUE_ROWIDS,
        'ROW_LENGTHS': $2164e21a23ca882e$export$c56fa138ccffd243.ROW_LENGTHS,
        'ROW_SPLITS': $2164e21a23ca882e$export$c56fa138ccffd243.ROW_SPLITS,
        'ROW_LIMITS': $2164e21a23ca882e$export$c56fa138ccffd243.ROW_LIMITS,
        'ROW_STARTS': $2164e21a23ca882e$export$c56fa138ccffd243.ROW_STARTS
    };
    const result = [];
    for (const typeStr of rowPartitionTypeStrings){
        if (typeStr in stringToType) result.push(stringToType[typeStr]);
        else break;
    }
    return result;
}
function $2164e21a23ca882e$export$1cdd548e021d4109(rowPartitionTypes) {
    if (rowPartitionTypes.length === 0) return 0;
    if (rowPartitionTypes[0] === $2164e21a23ca882e$export$c56fa138ccffd243.FIRST_DIM_SIZE) return rowPartitionTypes.length - 1;
    return rowPartitionTypes.length;
}
function $2164e21a23ca882e$export$4170394182a906f5(defaultValueShape, valueShape) {
    if (defaultValueShape == null || valueShape == null) return;
    const defaultNDims = defaultValueShape.length;
    const valuesNDims = valueShape.length;
    if (defaultNDims >= valuesNDims) throw new Error(`defaultValue.shape=${defaultValueShape} and ragged tensor flatValues.shape=${valueShape}, are incompatible: defaultValue.rank = ${defaultNDims} must be less than ragged tensor input flatValues.rank = ${valuesNDims})`);
    for(let i = 0; i < Math.min(defaultNDims, valuesNDims - 1); ++i){
        const defaultDim = defaultValueShape[i];
        const valueDim = valueShape[i + 1];
        if (defaultDim >= 0 && valueDim >= 0 && defaultDim !== 1 && defaultDim !== valueDim) throw new Error(`defaultValue.shape=${defaultValueShape}, and ragged tensor input flatValues.shape=${valueShape} are incompatible: defaultValue.shape[${i - defaultValueShape.length}] = ${defaultDim} but ragged tensor input.flatValues.shape[${i - defaultValueShape.length}] = ${valueDim}`);
    }
}


var $1582b44fb207af36$exports = {};

$parcel$export($1582b44fb207af36$exports, "PARALLELIZE_THRESHOLD", () => $1582b44fb207af36$export$ee3544492fe530f6);
$parcel$export($1582b44fb207af36$exports, "computeOptimalWindowSize", () => $1582b44fb207af36$export$ee795473f4c8fb04);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inputs of size above this threshold will be parallelized by calling multiple
 * shader programs.
 */ 
const $1582b44fb207af36$export$ee3544492fe530f6 = 30;
function $1582b44fb207af36$export$ee795473f4c8fb04(inSize) {
    if (inSize <= $1582b44fb207af36$export$ee3544492fe530f6) return inSize;
    return (0, $9e4a6174e3538e7d$export$c0ff3276320ddb5e)(inSize, Math.floor(Math.sqrt(inSize)));
}


var $f147fd057118a602$exports = {};

$parcel$export($f147fd057118a602$exports, "assertParamsValid", () => $f147fd057118a602$export$1da6c8ba17e84239);
$parcel$export($f147fd057118a602$exports, "maskToAxes", () => $f147fd057118a602$export$ce8be3e704107015);
$parcel$export($f147fd057118a602$exports, "computeOutShape", () => $f147fd057118a602$export$22fa6b3b1305508e);
$parcel$export($f147fd057118a602$exports, "stridesWithElidedDims", () => $f147fd057118a602$export$7f5fa1173bdb6e15);
$parcel$export($f147fd057118a602$exports, "getNormalizedAxes", () => $f147fd057118a602$export$895fe9252fb79d1);
$parcel$export($f147fd057118a602$exports, "startIndicesWithElidedDims", () => $f147fd057118a602$export$a9f0de12634a4ce3);
$parcel$export($f147fd057118a602$exports, "stopIndicesWithElidedDims", () => $f147fd057118a602$export$19a416bd7e87244f);
$parcel$export($f147fd057118a602$exports, "startForAxis", () => $f147fd057118a602$export$643aca61b9318da8);
$parcel$export($f147fd057118a602$exports, "stopForAxis", () => $f147fd057118a602$export$612a961a199ffe65);
$parcel$export($f147fd057118a602$exports, "stridesForAxis", () => $f147fd057118a602$export$9e3fd91f45c1f07f);
$parcel$export($f147fd057118a602$exports, "isSliceContinous", () => $f147fd057118a602$export$9dc11bd6855e72c6);
$parcel$export($f147fd057118a602$exports, "computeFlatOffset", () => $f147fd057118a602$export$b01553f5da8f819c);
$parcel$export($f147fd057118a602$exports, "parseSliceParams", () => $f147fd057118a602$export$8448a0604fef5d62);
$parcel$export($f147fd057118a602$exports, "sliceInfo", () => $f147fd057118a602$export$54d224865abb6767);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $f147fd057118a602$var$NEW_AXIS = -2;
const $f147fd057118a602$var$SHRINK_AXIS = -1;
function $f147fd057118a602$export$1da6c8ba17e84239(input, begin, size) {
    const inputRank = input.shape.length;
    $9e4a6174e3538e7d$export$a7a9523472993e97(inputRank === begin.length, ()=>`Error in slice${inputRank}D: Length of begin ${begin} must ` + `match the rank of the array (${inputRank}).`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(inputRank === size.length, ()=>`Error in slice${inputRank}D: Length of size ${size} must ` + `match the rank of the array (${inputRank}).`);
    for(let i = 0; i < inputRank; ++i)$9e4a6174e3538e7d$export$a7a9523472993e97(begin[i] + size[i] <= input.shape[i], ()=>`Error in slice${inputRank}D: begin[${i}] + size[${i}] ` + `(${begin[i] + size[i]}) would overflow input.shape[${i}] (${input.shape[i]})`);
}
function $f147fd057118a602$export$ce8be3e704107015(mask) {
    const axes = [];
    let axis = 0;
    while(mask > 0){
        if (mask & 1) axes.push(axis);
        mask /= 2;
        axis++;
    }
    return axes;
}
function $f147fd057118a602$export$22fa6b3b1305508e(begin, end, strides) {
    const size = [];
    for(let axis = 0; axis < begin.length; axis++)size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
    return size;
}
function $f147fd057118a602$export$7f5fa1173bdb6e15(strides, ellipsisInsertionIndex, numElidedAxes, inputShape) {
    const newStrides = [
        ...strides
    ];
    for(let i = newStrides.length; i < inputShape.length; i++)newStrides.push(1);
    for(let i = 0; i < numElidedAxes; i++)if (i === 0) newStrides[ellipsisInsertionIndex] = 1;
    else {
        newStrides.splice(ellipsisInsertionIndex, 0 /* num elements to delete */ , 1 /* element to add */ );
        newStrides.pop();
    }
    return newStrides;
}
function $f147fd057118a602$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, normalizedAxis) {
    if (normalizedAxis <= ellipsisInsertionIndex) return normalizedAxis;
    return normalizedAxis - (numElidedAxes - 1);
}
function $f147fd057118a602$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex) {
    const elidedAxes = [];
    for(let i = 0; i < numElidedAxes; i++)elidedAxes.push(ellipsisInsertionIndex + i);
    return elidedAxes;
}
function $f147fd057118a602$export$895fe9252fb79d1(inputShape, ellipsisAxes, numInterpolatedAxes, begin, end, strides, beginMask, endMask, ellipsisMask) {
    const inputRank = inputShape.length;
    let normalizedBegin = new Array(inputRank), normalizedEnd = new Array(inputRank), normalizedStrides = new Array(inputRank);
    if (ellipsisAxes.length && numInterpolatedAxes > 0) {
        const fullIndex = ellipsisAxes[0];
        // The ellipsis applies to the masked index as well as any dimensions
        // that are interpolated.
        const numElidedAxes = numInterpolatedAxes + 1;
        normalizedBegin = $f147fd057118a602$export$a9f0de12634a4ce3(beginMask, fullIndex, numElidedAxes, begin, inputShape);
        normalizedEnd = $f147fd057118a602$export$19a416bd7e87244f(endMask, fullIndex, numElidedAxes, end, inputShape);
        normalizedStrides = $f147fd057118a602$export$7f5fa1173bdb6e15(strides, fullIndex, numElidedAxes, inputShape);
    } else for(let axis = 0; axis < inputRank; axis++){
        normalizedBegin[axis] = $f147fd057118a602$export$643aca61b9318da8(beginMask, begin, strides, inputShape, axis, ellipsisMask);
        normalizedEnd[axis] = $f147fd057118a602$export$612a961a199ffe65(endMask, end, strides, inputShape, axis, ellipsisMask);
        normalizedStrides[axis] = $f147fd057118a602$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask);
    }
    return {
        begin: normalizedBegin,
        end: normalizedEnd,
        strides: normalizedStrides
    };
}
function $f147fd057118a602$export$a9f0de12634a4ce3(beginMask, ellipsisInsertionIndex, numElidedAxes, originalBegin, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $f147fd057118a602$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = 0;
    else {
        const originalAxis = $f147fd057118a602$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalBegin[originalAxis];
        if (beginMask & 1 << originalAxis) originalValue = 0;
        newIndices[axis] = originalValue;
    }
    return newIndices;
}
function $f147fd057118a602$export$19a416bd7e87244f(endMask, ellipsisInsertionIndex, numElidedAxes, originalEnd, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $f147fd057118a602$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = Number.MAX_SAFE_INTEGER;
    else {
        const originalAxis = $f147fd057118a602$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalEnd[originalAxis];
        if (endMask & 1 << originalAxis) originalValue = Number.MAX_SAFE_INTEGER;
        newIndices[axis] = originalValue;
    }
    for(let i = 0; i < newIndices.length; i++){
        // Handle negative indices
        const axisSize = inputShape[i];
        if (newIndices[i] < 0) newIndices[i] += axisSize;
        newIndices[i] = $9e4a6174e3538e7d$export$7d15b64cf5a3a4c4(0, newIndices[i], inputShape[i]);
    }
    return newIndices;
}
function $f147fd057118a602$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask) {
    let stride = strides[axis];
    if (ellipsisMask & 1 << axis || stride == null) stride = 1;
    return stride;
}
function $f147fd057118a602$export$643aca61b9318da8(beginMask, startIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let start = startIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or the begin index is not set
    // for the axis.
    if (beginMask & 1 << axis || ellipsisMask & 1 << axis || start == null) {
        if (stride > 0) // Forward iteration - use the first element. These values will get
        // clamped below (Note: We could have set them to 0 and axis_size-1, but
        // use lowest() and max() to maintain symmetry with StopForAxis())
        start = Number.MIN_SAFE_INTEGER;
        else // Backward iteration - use the last element.
        start = Number.MAX_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (start < 0) start += axisSize;
    // Clamping
    start = $9e4a6174e3538e7d$export$7d15b64cf5a3a4c4(0, start, axisSize - 1);
    return start;
}
function $f147fd057118a602$export$612a961a199ffe65(endMask, stopIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let stop = stopIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or if the stop index is not
    // set for this axis.
    if (endMask & 1 << axis || ellipsisMask & 1 << axis || stop == null) {
        if (stride > 0) // Forward iteration - use the last element. These values will get
        // clamped below
        stop = Number.MAX_SAFE_INTEGER;
        else // Backward iteration - use the first element.
        stop = Number.MIN_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (stop < 0) stop += axisSize;
    // Clamping
    // Because the end index points one past the last element, we need slightly
    // different clamping ranges depending on the direction.
    if (stride > 0) // Forward iteration
    stop = $9e4a6174e3538e7d$export$7d15b64cf5a3a4c4(0, stop, axisSize);
    else // Backward iteration
    stop = $9e4a6174e3538e7d$export$7d15b64cf5a3a4c4(-1, stop, axisSize - 1);
    return stop;
}
function $f147fd057118a602$export$9dc11bd6855e72c6(shape, begin, size) {
    // Index of the first axis that has size > 1.
    let firstNonOneAxis = size.length;
    for(let i = 0; i < size.length; i++)if (size[i] > 1) {
        firstNonOneAxis = i;
        break;
    }
    for(let i = firstNonOneAxis + 1; i < size.length; i++){
        if (begin[i] > 0 || size[i] !== shape[i]) return false;
    }
    return true;
}
function $f147fd057118a602$export$b01553f5da8f819c(begin, strides) {
    let flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
    for(let i = 0; i < begin.length - 1; i++)flatOffset += begin[i] * strides[i];
    return flatOffset;
}
function $f147fd057118a602$export$8448a0604fef5d62(x, begin, size) {
    // The following logic allows for more ergonomic calls.
    let begin_;
    const xRank = x.shape.length;
    if (typeof begin === 'number') begin_ = [
        begin,
        ...new Array(xRank - 1).fill(0)
    ];
    else if (begin.length < xRank) begin_ = begin.concat(new Array(xRank - begin.length).fill(0));
    else begin_ = begin.slice();
    begin_.forEach((d)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(d !== -1, ()=>'slice() does not support negative begin indexing.');
    });
    let size_;
    if (size == null) size_ = new Array(xRank).fill(-1);
    else if (typeof size === 'number') size_ = [
        size,
        ...new Array(xRank - 1).fill(-1)
    ];
    else if (size.length < xRank) size_ = size.concat(new Array(xRank - size.length).fill(-1));
    else size_ = size;
    size_ = size_.map((d, i)=>{
        if (d >= 0) return d;
        else {
            $9e4a6174e3538e7d$export$a7a9523472993e97(d === -1, ()=>`Negative size values should be exactly -1 but got ` + `${d} for the slice() size at index ${i}.`);
            return x.shape[i] - begin_[i];
        }
    });
    return [
        begin_,
        size_
    ];
}
function $f147fd057118a602$export$54d224865abb6767(xShape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    let stridesNonNull;
    if (strides == null) {
        stridesNonNull = new Array(begin.length);
        stridesNonNull.fill(1);
    } else stridesNonNull = strides;
    // Only one non-zero bit is allowed in ellipsisMask, which means ellipsisMask
    // is a power of 2. Use bit compares to ensure ellipsisMask is 0 or a power
    // of 2. When i is a power of 2, i & (i - 1) is always 0.
    // Also ref:
    // https://stackoverflow.com/questions/600293/how-to-check-if-a-number-is-a-power-of-2
    if (ellipsisMask != null && (ellipsisMask & ellipsisMask - 1) !== 0) throw new Error('Multiple ellipses in slice is not allowed.');
    // Step 1: Account for ellipsis and new axis.
    // Check for ellipsis and count how many non-newaxis there are after.
    let ellipsisSeen = false;
    const sparseSpec = {
        dims: stridesNonNull.length,
        numAddAxisAfterEllipsis: 0,
        begin: begin.slice(),
        end: end.slice(),
        strides: stridesNonNull.slice(),
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    for(let i = 0; i < sparseSpec.dims; i++){
        if (ellipsisSeen && (1 << i & newAxisMask) !== 0) sparseSpec.numAddAxisAfterEllipsis++;
        if (1 << i & ellipsisMask) ellipsisSeen = true;
    }
    // If no ellipsis insert one at the end.
    if (!ellipsisSeen) {
        sparseSpec.ellipsisMask |= 1 << sparseSpec.dims;
        sparseSpec.dims++; // this effects loop iteration below
    }
    // Step 2: Make a sparse spec into a full index spec.
    //
    // The sparse spec deos not correspond to the number of dimensions.
    // Make a dense spec that cooresponds to the number of dimensions.
    //
    // For example suppose foo[...,3:] on foo.shape = [2, 2, 3] then we need to
    // produce the missing beginMask for the first two dimensions i.e. from
    // beginMaskSpec = 0, endMaskSpec = 2, we achieve beginMask = 6 (110),
    // endMask = 7 (111).
    const denseSpec = {
        dims: xShape.length,
        beginMask: 0,
        endMask: 0,
        beginValid: false,
        endValid: false
    };
    $f147fd057118a602$var$buildDenseSpec(sparseSpec, denseSpec);
    // Step 3: Make implicit ranges (non-zero beginMasks and endMasks) explicit
    // and bounds check.
    let isIdentity = true;
    let sliceDim0 = true;
    let isSimpleSlice = true;
    const processingShape = [];
    const finalShape = [];
    for(let i = 0; i < xShape.length; ++i){
        if (denseSpec.strides[i] === 0) throw Error(`strides[${i}] must be non-zero`);
        const shrinkI = !!(denseSpec.shrinkAxisMask & 1 << i);
        const dimI = xShape[i];
        if (dimI === -1) {
            processingShape.push(shrinkI ? 1 : -1);
            continue;
        }
        const masks = [
            denseSpec.beginMask & 1 << i,
            denseSpec.endMask & 1 << i
        ];
        const validRange = [
            denseSpec.strides[i] > 0 ? 0 : -1,
            denseSpec.strides[i] > 0 ? dimI : dimI - 1
        ];
        if (shrinkI && denseSpec.strides[i] <= 0) throw Error('only stride 1 allowed on non-range indexing.');
        isSimpleSlice = isSimpleSlice && denseSpec.strides[i] === 1;
        const beginAndEndMasked = !!(denseSpec.beginMask & 1 << i && denseSpec.endMask & 1 << i);
        if (denseSpec.beginValid && denseSpec.endValid) {
            if (shrinkI) {
                // If we are shrinking, the end index is now possibly incorrect. In
                // particular foo[-1] produces sparseBegin = -1, sparseEnd = 0.
                // and canonical puts these to n-1 and 0, which implies a degenerate
                // interval. Fortunately, it is now safe to re-create end as begin + 1.
                const xFwd = denseSpec.begin[i] < 0 ? dimI + denseSpec.begin[i] : denseSpec.begin[i];
                denseSpec.begin[i] = xFwd;
                denseSpec.end[i] = denseSpec.begin[i] + 1;
                if (xFwd < 0 || xFwd >= dimI) throw Error(`slice index ${denseSpec.begin[i]} of dimension ${i} out of bounds.`);
            } else {
                denseSpec.begin[i] = $f147fd057118a602$var$canonical(denseSpec.begin[i], 0, denseSpec.strides[i], dimI, masks, validRange);
                denseSpec.end[i] = $f147fd057118a602$var$canonical(denseSpec.end[i], 1, denseSpec.strides[i], dimI, masks, validRange);
            }
            // Update optimization values
            const takeAllInDimension = denseSpec.strides[i] === 1 && denseSpec.begin[i] === 0 && denseSpec.end[i] === dimI;
            isIdentity = isIdentity && takeAllInDimension;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || takeAllInDimension);
        } else {
            isIdentity = isIdentity && denseSpec.strides[i] === 1 && beginAndEndMasked;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || beginAndEndMasked);
        }
        // Compute the processing shape (the intermediate Eigen will produce)
        let intervalLength;
        let knownInterval = false;
        if (denseSpec.beginValid && denseSpec.endValid) {
            intervalLength = denseSpec.end[i] - denseSpec.begin[i];
            knownInterval = true;
        } else if (shrinkI) {
            // The dimension is still known as 1 for the processingShape, but will be
            // discarded for the final shape.
            intervalLength = 1;
            knownInterval = true;
        } else if (beginAndEndMasked) // Even if we don't have values for begin or end, we do know that this
        // dimension covers the whole interval. If we have shape information for
        // this dimension, that tells us the interval length.
        {
            if (dimI >= 0) {
                if (denseSpec.strides[i] < 0) intervalLength = -dimI;
                else intervalLength = dimI;
                knownInterval = true;
            }
        }
        if (knownInterval) {
            let sizeI;
            // Hold zero if the interval is degenerate, otherwise account for
            // remainder
            if (intervalLength === 0 || intervalLength < 0 !== denseSpec.strides[i] < 0) sizeI = 0;
            else sizeI = Math.trunc(intervalLength / denseSpec.strides[i]) + (intervalLength % denseSpec.strides[i] !== 0 ? 1 : 0);
            processingShape.push(sizeI);
        } else processingShape.push(-1);
    }
    // Step 4: Compute the final shape
    //
    // newAxis will increase dimension by 1 (with a one-size dimension)
    // slices like foo[3, ...] will reduce dimension by 1.
    // This cannot be done earlier, because it depends on Step 3.
    for(let denseDim = 0; denseDim < denseSpec.finalShapeGatherIndices.length; ++denseDim){
        const gatherIndex = denseSpec.finalShapeGatherIndices[denseDim];
        if (gatherIndex >= 0) finalShape.push(processingShape[gatherIndex]);
        else if (gatherIndex === $f147fd057118a602$var$NEW_AXIS) finalShape.push(1);
    }
    const finalShapeSparse = finalShape.filter((dim, i)=>denseSpec.finalShapeGatherIndices[i] !== $f147fd057118a602$var$NEW_AXIS);
    return {
        finalShapeSparse: finalShapeSparse,
        finalShape: finalShape,
        isIdentity: isIdentity,
        sliceDim0: sliceDim0,
        isSimpleSlice: isSimpleSlice,
        begin: denseSpec.begin,
        end: denseSpec.end,
        strides: denseSpec.strides
    };
}
function $f147fd057118a602$var$buildDenseSpec(sparse, dense) {
    dense.beginMask = 0;
    dense.endMask = 0;
    dense.shrinkAxisMask = 0;
    let fullIndex = 0;
    dense.beginValid = sparse.begin != null;
    dense.endValid = sparse.end != null;
    dense.begin = new Array(dense.dims);
    dense.end = new Array(dense.dims);
    dense.strides = new Array(dense.dims);
    dense.finalShapeGatherIndices = [];
    dense.finalShapeGatherIndicesSparse = [];
    dense.inputShapeGatherIndicesSparse = new Array(dense.dims);
    for(let i = 0; i < sparse.dims; i++){
        if (1 << i & sparse.ellipsisMask) {
            // Only the bit that has ellipsis will fall in this condition.
            // Expand the ellipsis into the appropriate indices
            // Note: this only works because we guaranteed one ellipsis.
            const nextIndex = Math.min(dense.dims - (sparse.dims - i) + 1 + sparse.numAddAxisAfterEllipsis, dense.dims);
            for(; fullIndex < nextIndex; fullIndex++){
                // newAxis aren't real axis so you have to skip.
                dense.begin[fullIndex] = 0;
                dense.end[fullIndex] = 0;
                dense.strides[fullIndex] = 1;
                dense.beginMask |= 1 << fullIndex;
                dense.endMask |= 1 << fullIndex;
                dense.finalShapeGatherIndices.push(fullIndex);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            }
        } else if (1 << i & sparse.newAxisMask) {
            // Only the bit that has newAxis will fall in this condition.
            dense.finalShapeGatherIndices.push($f147fd057118a602$var$NEW_AXIS);
            dense.finalShapeGatherIndicesSparse.push(-1);
        } else {
            if (fullIndex === dense.begin.length) throw Error(`Index out of range using input dim ${fullIndex}; input ` + `has only ${dense.dims} dims, ${dense.begin.length}.`);
            // Gather slicing spec into appropriate index.
            if (sparse.begin != null) dense.begin[fullIndex] = sparse.begin[i];
            if (sparse.end != null) dense.end[fullIndex] = sparse.end[i];
            dense.strides[fullIndex] = sparse.strides[i];
            if (sparse.beginMask & 1 << i) dense.beginMask |= 1 << fullIndex;
            if (sparse.endMask & 1 << i) dense.endMask |= 1 << fullIndex;
            // If shrink, record where to get the dimensionality from (i.e. newAxis)
            // creates a fake 1 size dimension. Also remember shrink axis (now in
            // dense form) so we can ignore dense.end below.
            if (sparse.shrinkAxisMask & 1 << i) {
                dense.finalShapeGatherIndices.push($f147fd057118a602$var$SHRINK_AXIS);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.shrinkAxisMask |= 1 << fullIndex;
            } else {
                dense.finalShapeGatherIndices.push(fullIndex);
                // Remember that where in the sparse shape the dense dim comes from.
                dense.finalShapeGatherIndicesSparse.push(i);
            }
            dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            fullIndex++;
        }
    }
}
function $f147fd057118a602$var$canonical(x, c, strideI, dimI, masks, validRange) {
    if (masks[c]) return strideI > 0 ? validRange[c] : validRange[c + 1 & 1];
    else {
        const xFwd = x < 0 ? dimI + x : x; // make negative indices positive
        return xFwd < validRange[0] ? validRange[0] : xFwd > validRange[1] ? validRange[1] : xFwd;
    }
}



var $0f2b3b4de1fbd15d$exports = {};

$parcel$export($0f2b3b4de1fbd15d$exports, "getImageCenter", () => $0f2b3b4de1fbd15d$export$3c8762d0dab347aa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Returns the image center in pixels.
function $0f2b3b4de1fbd15d$export$3c8762d0dab347aa(center, imageHeight, imageWidth) {
    const centerX = imageWidth * (typeof center === 'number' ? center : center[0]);
    const centerY = imageHeight * (typeof center === 'number' ? center : center[1]);
    return [
        centerX,
        centerY
    ];
}


var $b7dc8cc8406bb92b$exports = {};

$parcel$export($b7dc8cc8406bb92b$exports, "getReshaped", () => $b7dc8cc8406bb92b$export$4a6fd6a82dc667e2);
$parcel$export($b7dc8cc8406bb92b$exports, "getPermuted", () => $b7dc8cc8406bb92b$export$4def7dccf4cfc2e9);
$parcel$export($b7dc8cc8406bb92b$exports, "getReshapedPermuted", () => $b7dc8cc8406bb92b$export$2435a8b57f99e080);
$parcel$export($b7dc8cc8406bb92b$exports, "getSliceBeginCoords", () => $b7dc8cc8406bb92b$export$b9a01540baa98f86);
$parcel$export($b7dc8cc8406bb92b$exports, "getSliceSize", () => $b7dc8cc8406bb92b$export$2457416ec9e0c8d3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Gets the new shape of the input Tensor after it's been reshaped
 * to:
 * [blockShape[0], ..., blockShape[M-1], batch / prod(blockShape),
 * inputShape[1], ..., inputShape[N-1]]
 *
 * See step 1: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
 */ function $b7dc8cc8406bb92b$export$4a6fd6a82dc667e2(inputShape, blockShape, prod, batchToSpace = true) {
    let reshaped = [];
    if (batchToSpace) {
        reshaped = reshaped.concat(blockShape.slice(0));
        reshaped.push(inputShape[0] / prod);
        reshaped = reshaped.concat(inputShape.slice(1));
    } else {
        reshaped = reshaped.concat(inputShape[0]);
        const spatialLength = blockShape.length;
        for(let i = 0; i < spatialLength; ++i)reshaped = reshaped.concat([
            inputShape[i + 1] / blockShape[i],
            blockShape[i]
        ]);
        reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
    }
    return reshaped;
}
function $b7dc8cc8406bb92b$export$4def7dccf4cfc2e9(reshapedRank, blockShapeRank, batchToSpace = true) {
    const permuted = [];
    if (batchToSpace) {
        permuted.push(blockShapeRank);
        for(let i = blockShapeRank + 1; i < reshapedRank; ++i)if (i <= 2 * blockShapeRank) {
            permuted.push(i);
            permuted.push(i - (blockShapeRank + 1));
        } else permuted.push(i);
    } else {
        const permutedBeforeBatch = [];
        const permutedAfterBatch = [];
        for(let i = 1; i < reshapedRank; ++i)if (i >= blockShapeRank * 2 + 1 || i % 2 === 1) permutedAfterBatch.push(i);
        else permutedBeforeBatch.push(i);
        permuted.push(...permutedBeforeBatch);
        permuted.push(0);
        permuted.push(...permutedAfterBatch);
    }
    return permuted;
}
function $b7dc8cc8406bb92b$export$2435a8b57f99e080(inputShape, blockShape, prod, batchToSpace = true) {
    const reshapedPermuted = [];
    if (batchToSpace) reshapedPermuted.push(inputShape[0] / prod);
    else reshapedPermuted.push(inputShape[0] * prod);
    for(let i = 1; i < inputShape.length; ++i)if (i <= blockShape.length) {
        if (batchToSpace) reshapedPermuted.push(blockShape[i - 1] * inputShape[i]);
        else reshapedPermuted.push(inputShape[i] / blockShape[i - 1]);
    } else reshapedPermuted.push(inputShape[i]);
    return reshapedPermuted;
}
function $b7dc8cc8406bb92b$export$b9a01540baa98f86(crops, blockShape) {
    const sliceBeginCoords = [
        0
    ];
    for(let i = 0; i < blockShape; ++i)sliceBeginCoords.push(crops[i][0]);
    return sliceBeginCoords;
}
function $b7dc8cc8406bb92b$export$2457416ec9e0c8d3(uncroppedShape, crops, blockShape) {
    const sliceSize = uncroppedShape.slice(0, 1);
    for(let i = 0; i < blockShape; ++i)sliceSize.push(uncroppedShape[i + 1] - crops[i][0] - crops[i][1]);
    return sliceSize;
}


var $49ed19fada82bbf9$exports = {};

$parcel$export($49ed19fada82bbf9$exports, "prepareAndValidate", () => $49ed19fada82bbf9$export$6bb34ea9be10068f);

function $49ed19fada82bbf9$export$6bb34ea9be10068f(tensor, indices) {
    const tensorRank = tensor.shape.length;
    const indicesRank = indices.shape.length;
    if (tensorRank < 1) throw new Error('tf.gatherND() expects the input to be rank 1 or higher,' + ` but the rank was ${tensorRank}.`);
    if (indicesRank < 1) throw new Error('tf.gatherND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indicesRank}.`);
    if (indices.dtype !== 'int32') throw new Error('tf.gatherND() expects the indices to be int32 type,' + ` but the dtype was ${indices.dtype}.`);
    if (indices.shape[indicesRank - 1] > tensorRank) throw new Error('index innermost dimension length must be <= tensor rank; saw: ' + `${indices.shape[indicesRank - 1]} vs. ${tensorRank}`);
    if ((0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(tensor.shape) === 0) throw new Error('Requested more than 0 entries, but input is empty.' + ` Input shape: ${tensor.shape}.`);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    // The result shape is
    //   indices.shape[:-1] + params.shape[indices.shape[-1]:]
    let nResult = 1;
    for(let i = 0; i < indicesShape.length - 1; ++i)nResult *= indicesShape[i];
    const inputShape = tensor.shape;
    const resultShape = indicesShape.slice();
    resultShape.pop();
    let sliceSize = 1;
    for(let i = sliceRank; i < tensorRank; ++i){
        sliceSize *= inputShape[i];
        resultShape.push(inputShape[i]);
    }
    const strides = [
        ...(0, $9e4a6174e3538e7d$export$6ad0292cf4d50f79)(tensor.shape).map((stride)=>stride / sliceSize),
        1
    ].slice(0, sliceRank);
    return [
        resultShape,
        nResult,
        sliceSize,
        strides
    ];
}


var $8abc84d2fff8230c$exports = {};

$parcel$export($8abc84d2fff8230c$exports, "validateUpdateShape", () => $8abc84d2fff8230c$export$9d843bc97e7022ed);
$parcel$export($8abc84d2fff8230c$exports, "validateInput", () => $8abc84d2fff8230c$export$4d09d4ac8ba225dd);
$parcel$export($8abc84d2fff8230c$exports, "calculateShapes", () => $8abc84d2fff8230c$export$4dc1a8917bf18661);

function $8abc84d2fff8230c$export$9d843bc97e7022ed(shape, indices, updates) {
    const sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
    const batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
    const shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' + `shape[sliceDim:], got updates.shape: ${updates.shape}` + `, indices.shape: ${indices.shape}, shape: ${shape}` + `, sliceDim: ${sliceDim}, and batchDim: ${batchDim}.`;
    if (updates.rank < batchDim) throw new Error(shapeError + ` update.rank < ${batchDim}. `);
    if (shape.length < sliceDim + (updates.rank - batchDim)) throw new Error(shapeError + ` Output shape length < ${sliceDim + (updates.rank - batchDim)}`);
    if (updates.rank !== batchDim + shape.length - sliceDim) throw new Error(shapeError + ` update.rank != ${batchDim + shape.length - sliceDim}`);
    for(let d = 0; d < batchDim; ++d){
        if (updates.shape[d] !== indices.shape[d]) throw new Error(shapeError + ` updates.shape[${d}] (${updates.shape[d]}) != indices.shape[${d}] (${indices.shape[d]}).`);
    }
    for(let d = 0; d < updates.rank - batchDim; ++d){
        if (updates.shape[d + batchDim] !== shape[d + sliceDim]) throw new Error(shapeError + ` updates.shape[${d + batchDim}] (${updates.shape[d + batchDim]}) != shape[${d + batchDim}] (${shape[d + batchDim]})`);
    }
}
function $8abc84d2fff8230c$export$4d09d4ac8ba225dd(updates, indices, shape) {
    if (indices.rank < 1) throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indices.rank}.`);
    if (updates.rank < 1) throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' + ` but the rank was ${updates.rank}.`);
    if (indices.dtype !== 'int32') throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${indices.dtype}`);
    if (shape.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${shape}`);
    if (shape.length === 0) {
        if (indices.size === 0) throw new Error(`Indices specified for empty output. indices shape: ${indices.shape}`);
        if (updates.size === 0) throw new Error(`Updates specified for empty output. updates shape: ${updates.shape}`);
    }
    $8abc84d2fff8230c$export$9d843bc97e7022ed(shape, indices, updates);
}
function $8abc84d2fff8230c$export$4dc1a8917bf18661(updates, indices, shape) {
    // Calculate the number of dimensions in indices
    const indicesRank = indices.shape.length;
    const sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1;
    // Calculate the number of elements that make up each slice of our updated
    // tensor. This allows us to work with flattened tensors and copy over whole
    // slices at a time.
    const totalNd = shape.length;
    let sliceSize = 1;
    for(let i = sliceRank; i < totalNd; ++i)sliceSize *= shape[i];
    const safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
    const numUpdates = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(indices.shape) / safeSliceDim;
    const strides = [
        ...(0, $9e4a6174e3538e7d$export$6ad0292cf4d50f79)(shape.slice(0, sliceRank)),
        1
    ];
    const outputSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape);
    return {
        sliceRank: sliceRank,
        numUpdates: numUpdates,
        sliceSize: sliceSize,
        strides: strides,
        outputSize: outputSize
    };
}


var $1be6a6a5a2d8ac10$exports = {};

$parcel$export($1be6a6a5a2d8ac10$exports, "SELU_SCALEALPHA", () => $1be6a6a5a2d8ac10$export$49dc487a025ce2d0);
$parcel$export($1be6a6a5a2d8ac10$exports, "SELU_SCALE", () => $1be6a6a5a2d8ac10$export$e6ebc294ea9ea7e7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1be6a6a5a2d8ac10$export$49dc487a025ce2d0 = 1.7580993408473768599402175208123;
const $1be6a6a5a2d8ac10$export$e6ebc294ea9ea7e7 = 1.0507009873554804934193349852946;


var $45f58ffee021a96f$exports = {};

$parcel$export($45f58ffee021a96f$exports, "ERF_P", () => $45f58ffee021a96f$export$5588b9ca3e514e43);
$parcel$export($45f58ffee021a96f$exports, "ERF_A1", () => $45f58ffee021a96f$export$2ac384940e9cdd31);
$parcel$export($45f58ffee021a96f$exports, "ERF_A2", () => $45f58ffee021a96f$export$db2d4485da836713);
$parcel$export($45f58ffee021a96f$exports, "ERF_A3", () => $45f58ffee021a96f$export$644ec7b31d43803f);
$parcel$export($45f58ffee021a96f$exports, "ERF_A4", () => $45f58ffee021a96f$export$904f8b3bbafadf78);
$parcel$export($45f58ffee021a96f$exports, "ERF_A5", () => $45f58ffee021a96f$export$e40fe2da7629526);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $45f58ffee021a96f$export$5588b9ca3e514e43 = 0.3275911;
const $45f58ffee021a96f$export$2ac384940e9cdd31 = 0.254829592;
const $45f58ffee021a96f$export$db2d4485da836713 = -0.284496736;
const $45f58ffee021a96f$export$644ec7b31d43803f = 1.421413741;
const $45f58ffee021a96f$export$904f8b3bbafadf78 = -1.453152027;
const $45f58ffee021a96f$export$e40fe2da7629526 = 1.061405429;



var $e6885bd49f205a64$exports = {};

$parcel$export($e6885bd49f205a64$exports, "mergeRealAndImagArrays", () => $e6885bd49f205a64$export$e54cb13fcd32a531);
$parcel$export($e6885bd49f205a64$exports, "splitRealAndImagArrays", () => $e6885bd49f205a64$export$fa0ac0984ed1da1c);
$parcel$export($e6885bd49f205a64$exports, "complexWithEvenIndex", () => $e6885bd49f205a64$export$270b4351d25667e0);
$parcel$export($e6885bd49f205a64$exports, "complexWithOddIndex", () => $e6885bd49f205a64$export$36193f08102303b4);
$parcel$export($e6885bd49f205a64$exports, "getComplexWithIndex", () => $e6885bd49f205a64$export$628d071452d50aaf);
$parcel$export($e6885bd49f205a64$exports, "assignToTypedArray", () => $e6885bd49f205a64$export$b7f57c25a82b9fba);
$parcel$export($e6885bd49f205a64$exports, "exponents", () => $e6885bd49f205a64$export$7d98ee6b5f9e9f08);
$parcel$export($e6885bd49f205a64$exports, "exponent", () => $e6885bd49f205a64$export$abde88043842a778);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Merges real and imaginary Float32Arrays into a single complex Float32Array.
 *
 * The memory layout is interleaved as follows:
 * real: [r0, r1, r2]
 * imag: [i0, i1, i2]
 * complex: [r0, i0, r1, i1, r2, i2]
 *
 * This is the inverse of splitRealAndImagArrays.
 *
 * @param real The real values of the complex tensor values.
 * @param imag The imag values of the complex tensor values.
 * @returns A complex tensor as a Float32Array with merged values.
 */ function $e6885bd49f205a64$export$e54cb13fcd32a531(real, imag) {
    if (real.length !== imag.length) throw new Error(`Cannot merge real and imag arrays of different lengths. real:` + `${real.length}, imag: ${imag.length}.`);
    const result = new Float32Array(real.length * 2);
    for(let i = 0; i < result.length; i += 2){
        result[i] = real[i / 2];
        result[i + 1] = imag[i / 2];
    }
    return result;
}
function $e6885bd49f205a64$export$fa0ac0984ed1da1c(complex) {
    const real = new Float32Array(complex.length / 2);
    const imag = new Float32Array(complex.length / 2);
    for(let i = 0; i < complex.length; i += 2){
        real[i / 2] = complex[i];
        imag[i / 2] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $e6885bd49f205a64$export$270b4351d25667e0(complex) {
    const len = Math.ceil(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 0; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $e6885bd49f205a64$export$36193f08102303b4(complex) {
    const len = Math.floor(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 2; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $e6885bd49f205a64$export$628d071452d50aaf(complex, index) {
    const real = complex[index * 2];
    const imag = complex[index * 2 + 1];
    return {
        real: real,
        imag: imag
    };
}
function $e6885bd49f205a64$export$b7f57c25a82b9fba(data, real, imag, index) {
    data[index * 2] = real;
    data[index * 2 + 1] = imag;
}
function $e6885bd49f205a64$export$7d98ee6b5f9e9f08(n, inverse) {
    const real = new Float32Array(n / 2);
    const imag = new Float32Array(n / 2);
    for(let i = 0; i < Math.ceil(n / 2); i++){
        const x = (inverse ? 2 : -2) * Math.PI * (i / n);
        real[i] = Math.cos(x);
        imag[i] = Math.sin(x);
    }
    return {
        real: real,
        imag: imag
    };
}
function $e6885bd49f205a64$export$abde88043842a778(k, n, inverse) {
    const x = (inverse ? 2 : -2) * Math.PI * (k / n);
    const real = Math.cos(x);
    const imag = Math.sin(x);
    return {
        real: real,
        imag: imag
    };
}


var $08171e0fdd25ce24$exports = {};

$parcel$export($08171e0fdd25ce24$exports, "decodeEinsumEquation", () => $08171e0fdd25ce24$export$2f615958577142db);
$parcel$export($08171e0fdd25ce24$exports, "getEinsumPermutation", () => $08171e0fdd25ce24$export$ce55bd5175fdcdbf);
$parcel$export($08171e0fdd25ce24$exports, "checkEinsumDimSizes", () => $08171e0fdd25ce24$export$40ac7c38e2986bbe);
$parcel$export($08171e0fdd25ce24$exports, "getEinsumComputePath", () => $08171e0fdd25ce24$export$3f6835c0d48b762d);
$parcel$export($08171e0fdd25ce24$exports, "isIdentityPermutation", () => $08171e0fdd25ce24$export$6a8a32f5fc3d978e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $08171e0fdd25ce24$var$ARROW = '->';
const $08171e0fdd25ce24$var$ARROW_REGEX = /->/g;
const $08171e0fdd25ce24$var$COMMA = ',';
const $08171e0fdd25ce24$var$ELLIPSIS = '...';
function $08171e0fdd25ce24$export$2f615958577142db(equation, numTensors) {
    equation = equation.replace(/\s/g, ''); // Remove witespace in equation.
    const numArrows = (equation.length - equation.replace($08171e0fdd25ce24$var$ARROW_REGEX, '').length) / $08171e0fdd25ce24$var$ARROW.length;
    if (numArrows < 1) throw new Error('Equations without an arrow are not supported.');
    else if (numArrows > 1) throw new Error(`Equation must contain exactly one arrow ("${$08171e0fdd25ce24$var$ARROW}").`);
    const [inputString, outputString] = equation.split($08171e0fdd25ce24$var$ARROW);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(inputString.indexOf($08171e0fdd25ce24$var$ELLIPSIS) === -1, ()=>`The ellipsis notation ("${$08171e0fdd25ce24$var$ELLIPSIS}") is not supported yet.`);
    const inputTerms = inputString.split($08171e0fdd25ce24$var$COMMA);
    const numInputs = inputTerms.length;
    if (numTensors !== numInputs) throw new Error(`Expected ${numInputs} input tensors, received ${numTensors}`);
    if (numInputs > 2) throw new Error('Support for more than 2 input tensors is not implemented yet.');
    const allDims = [];
    for(let i = 0; i < outputString.length; ++i){
        const dimName = outputString[i];
        if (!inputTerms.some((inputTerm)=>inputTerm.indexOf(dimName) !== -1)) throw new Error(`Output subscripts contain the label ${dimName} ` + `not present in the input subscripts.`);
        if (allDims.indexOf(dimName) === -1) allDims.push(dimName);
    }
    for(let i = 0; i < inputString.length; ++i){
        const dimName = inputString[i];
        if (allDims.indexOf(dimName) === -1 && dimName !== $08171e0fdd25ce24$var$COMMA) allDims.push(dimName);
    }
    const idDims = new Array(inputTerms.length);
    for(let i = 0; i < numInputs; ++i){
        if (new Set(inputTerms[i].split('')).size !== inputTerms[i].length) throw new Error(`Found duplicate axes in input component ${inputTerms[i]}. ` + `Support for duplicate axes in input is not implemented yet.`);
        idDims[i] = [];
        for(let j = 0; j < inputTerms[i].length; ++j)idDims[i].push(allDims.indexOf(inputTerms[i][j]));
    }
    const numDims = allDims.length; // Number of unique dimensions.
    const numOutDims = outputString.length; // Number of output dimensions.
    const summedDims = []; // Dimensions being summed over.
    for(let i = numOutDims; i < numDims; ++i)summedDims.push(i);
    return {
        allDims: allDims,
        summedDims: summedDims,
        idDims: idDims
    };
}
function $08171e0fdd25ce24$export$ce55bd5175fdcdbf(nDims, idDims) {
    let permutationIndices = new Array(nDims);
    permutationIndices.fill(-1);
    for(let i = 0; i < idDims.length; ++i)permutationIndices[idDims[i]] = i;
    const expandDims = [];
    for(let i = 0; i < nDims; ++i)if (permutationIndices[i] === -1) expandDims.push(i);
    permutationIndices = permutationIndices.filter((d)=>d !== -1);
    return {
        permutationIndices: permutationIndices,
        expandDims: expandDims
    };
}
function $08171e0fdd25ce24$export$40ac7c38e2986bbe(nDims, idDims, tensors) {
    const dimSizes = new Array(nDims);
    for(let i = 0; i < tensors.length; ++i){
        const shape = tensors[i].shape;
        for(let j = 0; j < idDims[i].length; ++j)if (dimSizes[idDims[i][j]] === undefined) dimSizes[idDims[i][j]] = shape[j];
        else (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(dimSizes[idDims[i][j]] === shape[j], ()=>`Expected dimension ${dimSizes[idDims[i][j]]} at axis ${j} ` + `of input shaped ${JSON.stringify(shape)}, ` + `but got dimension ${shape[j]}`);
    }
}
function $08171e0fdd25ce24$export$3f6835c0d48b762d(summedDims, idDims) {
    const path = summedDims;
    const steps = [];
    let nSteps = 0;
    if (summedDims.length === 0) // Einsum that involes no summing: e.g., transpose and outer product.
    path.push(-1);
    nSteps = summedDims.length + 1;
    for(let i = 0; i < nSteps; ++i)steps.push([]);
    const computedTermIndices = [];
    for(let i = 0; i < path.length; ++i){
        const summedDim = path[i];
        const termIndices = $08171e0fdd25ce24$var$findTermsWithDim(idDims, summedDim);
        for (const termIndex of termIndices)if (computedTermIndices.indexOf(termIndex) === -1) {
            steps[i].push(termIndex);
            computedTermIndices.push(termIndex);
        }
    }
    return {
        path: path,
        steps: steps
    };
}
function $08171e0fdd25ce24$export$6a8a32f5fc3d978e(perm) {
    return perm.every((dim, index)=>dim === index);
}
function $08171e0fdd25ce24$var$findTermsWithDim(idDims, dim) {
    const termIndices = [];
    for(let i = 0; i < idDims.length; ++i)if (idDims[i].length === 0 || idDims[i].indexOf(dim) !== -1 || dim === -1) termIndices.push(i);
    return termIndices;
}


var $f74c6152e3df2c0d$exports = {};

$parcel$export($f74c6152e3df2c0d$exports, "prepareSplitSize", () => $f74c6152e3df2c0d$export$b45a3b30df9d4b49);

function $f74c6152e3df2c0d$export$b45a3b30df9d4b49(x, numOrSizeSplits, axis = 0) {
    let splitSizes = [];
    if (typeof numOrSizeSplits === 'number') {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(x.shape[axis] % numOrSizeSplits === 0, ()=>'Number of splits must evenly divide the axis.');
        splitSizes = new Array(numOrSizeSplits).fill(x.shape[axis] / numOrSizeSplits);
    } else {
        const numOfNegs = numOrSizeSplits.reduce((count, value)=>{
            if (value === -1) count += 1;
            return count;
        }, 0);
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numOfNegs <= 1, ()=>'There should be only one negative value in split array.');
        const negIndex = numOrSizeSplits.indexOf(-1);
        // Allow the number of split array to be -1, which indicates the rest
        // of dimension is allocated to that split.
        if (negIndex !== -1) {
            const total = numOrSizeSplits.reduce((a, b)=>b > 0 ? a + b : a);
            numOrSizeSplits[negIndex] = x.shape[axis] - total;
        }
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(x.shape[axis] === numOrSizeSplits.reduce((a, b)=>a + b), ()=>'The sum of sizes must match the size of the axis dimension.');
        splitSizes = numOrSizeSplits;
    }
    return splitSizes;
}


var $ad6711658c006cca$exports = {};

$parcel$export($ad6711658c006cca$exports, "getSparseFillEmptyRowsIndicesDenseShapeMismatch", () => $ad6711658c006cca$export$afc2f2dec50723b1);
$parcel$export($ad6711658c006cca$exports, "getSparseFillEmptyRowsNegativeIndexErrorMessage", () => $ad6711658c006cca$export$69038529bd45dbce);
$parcel$export($ad6711658c006cca$exports, "getSparseFillEmptyRowsOutOfRangeIndexErrorMessage", () => $ad6711658c006cca$export$4179b115ac384c01);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse fill empty rows indices, dense shape mismatch error message.
 *
 * @param indicesLength The first dimension of indices.
 */ function $ad6711658c006cca$export$afc2f2dec50723b1(indicesLength) {
    return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${indicesLength}`;
}
function $ad6711658c006cca$export$69038529bd45dbce(index, value) {
    return `indices(${index}, 0) is invalid: ${value} < 0`;
}
function $ad6711658c006cca$export$4179b115ac384c01(index, value, limit) {
    return `indices(${index}, 0) is invalid: ${value} >= ${limit}`;
}


var $bd11636660a14e49$exports = {};

$parcel$export($bd11636660a14e49$exports, "getSparseReshapeMultipleNegativeOneOutputDimErrorMessage", () => $bd11636660a14e49$export$22b04105649d1e3d);
$parcel$export($bd11636660a14e49$exports, "getSparseReshapeNegativeOutputDimErrorMessage", () => $bd11636660a14e49$export$3350ee0ca4641eae);
$parcel$export($bd11636660a14e49$exports, "getSparseReshapeEmptyTensorZeroOutputDimErrorMessage", () => $bd11636660a14e49$export$632a7731cfb4dc4b);
$parcel$export($bd11636660a14e49$exports, "getSparseReshapeInputOutputMultipleErrorMessage", () => $bd11636660a14e49$export$6996eb40ec18f24);
$parcel$export($bd11636660a14e49$exports, "getSparseReshapeInputOutputMismatchErrorMessage", () => $bd11636660a14e49$export$7c74c1672e7ca2d1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $bd11636660a14e49$export$22b04105649d1e3d(dim1, dim2) {
    return `only one output dimension may be -1, not both ${dim1} and ${dim2}`;
}
function $bd11636660a14e49$export$3350ee0ca4641eae(dim, value) {
    return `size ${dim} must be non-negative, not ${value}`;
}
function $bd11636660a14e49$export$632a7731cfb4dc4b() {
    return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function $bd11636660a14e49$export$6996eb40ec18f24(inputShape, outputShape) {
    const inputSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(inputShape);
    const outputSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(outputShape);
    return `Input to reshape is a SparseTensor with ${inputSize}
  dense values, but the requested shape requires a multiple of ${outputSize}. inputShape=${inputShape} outputShape= ${outputShape}`;
}
function $bd11636660a14e49$export$7c74c1672e7ca2d1(inputShape, outputShape) {
    const inputSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(inputShape);
    const outputSize = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(outputShape);
    return `Input to reshape is a tensor with ${inputSize} dense values, but the requested shape has ${outputSize}. inputShape=${inputShape} outputShape=${outputShape}`;
}


var $6e7be0e48ca1e7b9$exports = {};

$parcel$export($6e7be0e48ca1e7b9$exports, "getSparseSegmentReductionNegativeSegmentIdsErrorMessage", () => $6e7be0e48ca1e7b9$export$cb1b83ffdf66736);
$parcel$export($6e7be0e48ca1e7b9$exports, "getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage", () => $6e7be0e48ca1e7b9$export$6f5af72ace1661e1);
$parcel$export($6e7be0e48ca1e7b9$exports, "getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage", () => $6e7be0e48ca1e7b9$export$bdc282d2ae15e823);
$parcel$export($6e7be0e48ca1e7b9$exports, "getSparseSegmentReductionIndicesOutOfRangeErrorMessage", () => $6e7be0e48ca1e7b9$export$c470f477911f1cb7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse segment reduction negative segment ids error message.
 *
 */ function $6e7be0e48ca1e7b9$export$cb1b83ffdf66736() {
    return `segment ids must be >= 0`;
}
function $6e7be0e48ca1e7b9$export$6f5af72ace1661e1() {
    return `segment ids are not increasing`;
}
function $6e7be0e48ca1e7b9$export$bdc282d2ae15e823(segmentId, outputRows) {
    return `Segment id ${segmentId} out of range [0, ${outputRows}), possibly because segmentIds input is not sorted.`;
}
function $6e7be0e48ca1e7b9$export$c470f477911f1cb7(index, indexValue, inputRows) {
    return `Bad: indices[${index}] == ${indexValue} out of range [0, ${inputRows})`;
}


var $1ce909f7dd4e3bbe$exports = {};

$parcel$export($1ce909f7dd4e3bbe$exports, "segOpComputeOptimalWindowSize", () => $1ce909f7dd4e3bbe$export$6ef0c7b128709ff);
$parcel$export($1ce909f7dd4e3bbe$exports, "computeOutShape", () => $1ce909f7dd4e3bbe$export$22fa6b3b1305508e);
$parcel$export($1ce909f7dd4e3bbe$exports, "collectGatherOpShapeInfo", () => $1ce909f7dd4e3bbe$export$fa9ad97afacf8191);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $1ce909f7dd4e3bbe$export$6ef0c7b128709ff(inSize, numSegments) {
    let done = false;
    let res;
    if (inSize <= (0, $1582b44fb207af36$export$ee3544492fe530f6)) {
        res = inSize;
        done = true;
    } else res = (0, $9e4a6174e3538e7d$export$c0ff3276320ddb5e)(inSize, Math.floor(Math.sqrt(inSize)));
    while(!done)if (res > numSegments || res === inSize) done = true;
    else res = (0, $9e4a6174e3538e7d$export$c0ff3276320ddb5e)(inSize, res + 1);
    return res;
}
function $1ce909f7dd4e3bbe$export$22fa6b3b1305508e(aShape, axis, numSegments) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (dim !== axis) outShape.push(aShape[dim]);
    else outShape.push(numSegments);
    return outShape;
}
function $1ce909f7dd4e3bbe$export$fa9ad97afacf8191(x, indices, axis, batchDims) {
    const indicesRank = indices.shape.length;
    const xRank = x.shape.length;
    if (batchDims !== 0) {
        if (batchDims < -indicesRank || batchDims > indicesRank) throw new Error(`Expect batchDims in the range of [-${indicesRank}, ${indicesRank}], but got ${batchDims}`);
    }
    if (batchDims < 0) batchDims += indicesRank;
    if (batchDims > xRank) throw new Error(`batchDims (${batchDims}) must be less than rank(x) (
    ${xRank}).`);
    if (axis < batchDims) throw new Error(`batchDims (${batchDims}) must be less than or equal to axis (${axis}).`);
    for(let i = 0; i < batchDims; ++i){
        if (x.shape[i] !== indices.shape[i]) throw new Error(`x.shape[${i}]: ${x.shape[i]} should be equal to indices.shape[${i}]: ${indices.shape[i]}.`);
    }
    const dimSize = x.shape[axis];
    const outputShape = [];
    let batchSize = 1;
    let outerSize = 1;
    let sliceSize = 1;
    for(let i = 0; i < batchDims; ++i){
        outputShape.push(x.shape[i]);
        batchSize *= x.shape[i];
    }
    for(let i = batchDims; i < axis; i++){
        outputShape.push(x.shape[i]);
        outerSize *= x.shape[i];
    }
    for(let i = batchDims; i < indicesRank; i++)outputShape.push(indices.shape[i]);
    for(let i = axis + 1; i < xRank; i++){
        outputShape.push(x.shape[i]);
        sliceSize *= x.shape[i];
    }
    return {
        batchSize: batchSize,
        sliceSize: sliceSize,
        outerSize: outerSize,
        dimSize: dimSize,
        outputShape: outputShape
    };
}


function $f35e0c1a651337db$export$debaff328bdca650(vals) {
    try {
        // Decode the bytes into string.
        return vals.map((val)=>(0, $0775da5e684c8c0d$export$a0fb664af7d0cc44)(val));
    } catch (err) {
        throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${err}`);
    }
}
function $f35e0c1a651337db$export$ce1f4ec5bdd0ab9a(strings) {
    return strings.map((s)=>(0, $0775da5e684c8c0d$export$8146d2e653b87d6a)(s));
}
$parcel$exportWildcard($f35e0c1a651337db$exports, $fab93e7418eff1cc$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $5ede3b6f723b9f5a$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $5be849e9fa3ddc21$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $f9c374363849dff2$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $c561cfa6a1183f44$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $2ca7341467f87d13$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $2164e21a23ca882e$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $1582b44fb207af36$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $0f2b3b4de1fbd15d$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $b7dc8cc8406bb92b$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $49ed19fada82bbf9$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $8abc84d2fff8230c$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $1be6a6a5a2d8ac10$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $45f58ffee021a96f$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $720e4308e1a7c928$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $e6885bd49f205a64$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $08171e0fdd25ce24$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $f74c6152e3df2c0d$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $ad6711658c006cca$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $bd11636660a14e49$exports);
$parcel$exportWildcard($f35e0c1a651337db$exports, $6e7be0e48ca1e7b9$exports);

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Broadcast an array to a compatible shape NumPy-style.
 *
 * The tensor's shape is compared to the broadcast shape from end to beginning.
 * Ones are prepended to the tensor's shape until it has the same length as
 * the broadcast shape. If input.shape[i]==shape[i], the (i+1)-th axis is
 * already broadcast-compatible. If input.shape[i]==1 and shape[i]==N, then
 * the input tensor is tiled N times along that axis (using tf.tile).
 *
 * @param input The tensor that is to be broadcasted.
 * @param shape The input is to be broadcast to this shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $8660a1872a3f456e$var$broadcastTo_(x, shape) {
    let input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'broadcastTo', 'x');
    const xShape = input.shape;
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    if (shape.length < input.rank) throw new Error(`broadcastTo(): shape.length=${shape.length} < input.rank=${input.rank}.`);
    if (shape.length > input.rank) {
        const newShape = input.shape.slice();
        while(newShape.length < shape.length)newShape.unshift(1);
        input = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(input, newShape);
    }
    const inputShape = input.shape;
    const reps = Array.from(shape);
    for(let i = shape.length - 1; i >= 0; i--){
        if (inputShape[i] === shape[i]) reps[i] = 1;
        else if (input.shape[i] !== 1) throw new Error(`broadcastTo(): [${xShape}] cannot be broadcast to [${shape}].`);
    }
    const axes = reps.map((n, i)=>n > 1 ? i : -1).filter((i)=>i >= 0);
    if (axes.length === 0) return (0, $765aa12b24d3e86a$export$9cd59f9826255e47)(input);
    // TODO call broadcastTo kernel directly once backends implement broadcstTo
    const inputs = {
        x: input
    };
    const attrs = {
        reps: reps
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$235cb65c20ad2b7), inputs, attrs);
}
const $8660a1872a3f456e$export$ec9086aff2624eab = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    broadcastTo_: $8660a1872a3f456e$var$broadcastTo_
});

var $79d3f34cef1b5242$exports = {};

$parcel$export($79d3f34cef1b5242$exports, "fromPixelsAsync", () => $79d3f34cef1b5242$export$6b17f27238fa6bff);
$parcel$export($79d3f34cef1b5242$exports, "toPixels", () => $79d3f34cef1b5242$export$89b6cc959998e12e);
$parcel$export($79d3f34cef1b5242$exports, "draw", () => $79d3f34cef1b5242$export$e529deb2bfd496dc);
$parcel$export($79d3f34cef1b5242$exports, "fromPixels", () => $79d3f34cef1b5242$export$5a3bc84b10e77d32);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $6493cf21bc51a2cb$export$aa36a9de53c6d912(values, shape, dtype) {
    (0, $9e4a6174e3538e7d$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 3) throw new Error('tensor3d() requires shape to have three numbers');
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 3 && inferredShape.length !== 1) throw new Error('tensor3d() requires values to be number[][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


let $79d3f34cef1b5242$var$fromPixels2DContext;
let $79d3f34cef1b5242$var$hasToPixelsWarned = false;
/**
 * Creates a `tf.Tensor` from an image.
 *
 * ```js
 * const image = new ImageData(1, 1);
 * image.data[0] = 100;
 * image.data[1] = 150;
 * image.data[2] = 200;
 * image.data[3] = 255;
 *
 * tf.browser.fromPixels(image).print();
 * ```
 *
 * @param pixels The input image to construct the tensor from. The
 * supported image types are all 4-channel. You can also pass in an image
 * object with following attributes:
 * `{data: Uint8Array; width: number; height: number}`
 * @param numChannels The number of channels of the output tensor. A
 * numChannels value less than 4 allows you to ignore channels. Defaults to
 * 3 (ignores alpha channel of input image).
 *
 * @returns A Tensor3D with the shape `[height, width, numChannels]`.
 *
 * Note: fromPixels can be lossy in some cases, same image may result in
 * slightly different tensor values, if rendered by different rendering
 * engines. This means that results from different browsers, or even same
 * browser with CPU and GPU rendering engines can be different. See discussion
 * in details:
 * https://github.com/tensorflow/tfjs/issues/5482
 *
 * @doc {heading: 'Browser', namespace: 'browser', ignoreCI: true}
 */ function $79d3f34cef1b5242$var$fromPixels_(pixels, numChannels = 3) {
    // Sanity checks.
    if (numChannels > 4) throw new Error('Cannot construct Tensor with more than 4 channels from pixels.');
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    let isPixelData = false;
    let isImageData = false;
    let isVideo = false;
    let isImage = false;
    let isCanvasLike = false;
    let isImageBitmap = false;
    if (pixels.data instanceof Uint8Array) isPixelData = true;
    else if (typeof ImageData !== 'undefined' && pixels instanceof ImageData) isImageData = true;
    else if (typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement) isVideo = true;
    else if (typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement) isImage = true;
    else if (pixels.getContext != null) isCanvasLike = true;
    else if (typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap) isImageBitmap = true;
    else throw new Error('pixels passed to tf.browser.fromPixels() must be either an ' + `HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData ` + `in browser, or OffscreenCanvas, ImageData in webworker` + ` or {data: Uint32Array, width: number, height: number}, ` + `but was ${pixels.constructor.name}`);
    // If the current backend has 'FromPixels' registered, it has a more
    // efficient way of handling pixel uploads, so we call that.
    const kernel = (0, $071cf1fd9dc2117e$export$1b85808c967cc434)((0, $507890e4aa8e1463$export$d0eb4e7054966c48), (0, $6a645535e157b279$export$33b63313cc511a3b).backendName);
    if (kernel != null) {
        const inputs = {
            pixels: pixels
        };
        const attrs = {
            numChannels: numChannels
        };
        return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d0eb4e7054966c48), inputs, attrs);
    }
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    let vals;
    if (isCanvasLike) vals = // tslint:disable-next-line:no-any
    pixels.getContext('2d').getImageData(0, 0, width, height).data;
    else if (isImageData || isPixelData) vals = pixels.data;
    else if (isImage || isVideo || isImageBitmap) {
        if ($79d3f34cef1b5242$var$fromPixels2DContext == null) {
            if (typeof document === 'undefined') {
                if (typeof OffscreenCanvas !== 'undefined' && typeof OffscreenCanvasRenderingContext2D !== 'undefined') // @ts-ignore
                $79d3f34cef1b5242$var$fromPixels2DContext = new OffscreenCanvas(1, 1).getContext('2d');
                else throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
            } else $79d3f34cef1b5242$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: true
            });
        }
        $79d3f34cef1b5242$var$fromPixels2DContext.canvas.width = width;
        $79d3f34cef1b5242$var$fromPixels2DContext.canvas.height = height;
        $79d3f34cef1b5242$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        vals = $79d3f34cef1b5242$var$fromPixels2DContext.getImageData(0, 0, width, height).data;
    }
    let values;
    if (numChannels === 4) values = new Int32Array(vals);
    else {
        const numPixels = width * height;
        values = new Int32Array(numPixels * numChannels);
        for(let i = 0; i < numPixels; i++)for(let channel = 0; channel < numChannels; ++channel)values[i * numChannels + channel] = vals[i * 4 + channel];
    }
    const outShape = [
        height,
        width,
        numChannels
    ];
    return (0, $6493cf21bc51a2cb$export$aa36a9de53c6d912)(values, outShape, 'int32');
}
// Helper functions for |fromPixelsAsync| to check whether the input can
// be wrapped into imageBitmap.
function $79d3f34cef1b5242$var$isPixelData(pixels) {
    return pixels != null && pixels.data instanceof Uint8Array;
}
function $79d3f34cef1b5242$var$isImageBitmapFullySupported() {
    return typeof window !== 'undefined' && typeof ImageBitmap !== 'undefined' && window.hasOwnProperty('createImageBitmap');
}
function $79d3f34cef1b5242$var$isNonEmptyPixels(pixels) {
    return pixels != null && pixels.width !== 0 && pixels.height !== 0;
}
function $79d3f34cef1b5242$var$canWrapPixelsToImageBitmap(pixels) {
    return $79d3f34cef1b5242$var$isImageBitmapFullySupported() && !(pixels instanceof ImageBitmap) && $79d3f34cef1b5242$var$isNonEmptyPixels(pixels) && !$79d3f34cef1b5242$var$isPixelData(pixels);
}
async function $79d3f34cef1b5242$export$6b17f27238fa6bff(pixels, numChannels = 3) {
    let inputs = null;
    // Check whether the backend needs to wrap |pixels| to imageBitmap and
    // whether |pixels| can be wrapped to imageBitmap.
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WRAP_TO_IMAGEBITMAP') && $79d3f34cef1b5242$var$canWrapPixelsToImageBitmap(pixels)) {
        // Force the imageBitmap creation to not do any premultiply alpha
        // ops.
        let imageBitmap;
        try {
            // wrap in try-catch block, because createImageBitmap may not work
            // properly in some browsers, e.g.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1335594
            // tslint:disable-next-line: no-any
            imageBitmap = await createImageBitmap(pixels, {
                premultiplyAlpha: 'none'
            });
        } catch (e) {
            imageBitmap = null;
        }
        // createImageBitmap will clip the source size.
        // In some cases, the input will have larger size than its content.
        // E.g. new Image(10, 10) but with 1 x 1 content. Using
        // createImageBitmap will clip the size from 10 x 10 to 1 x 1, which
        // is not correct. We should avoid wrapping such resouce to
        // imageBitmap.
        if (imageBitmap != null && imageBitmap.width === pixels.width && imageBitmap.height === pixels.height) inputs = imageBitmap;
        else inputs = pixels;
    } else inputs = pixels;
    return $79d3f34cef1b5242$var$fromPixels_(inputs, numChannels);
}
function $79d3f34cef1b5242$var$validateImgTensor(img) {
    if (img.rank !== 2 && img.rank !== 3) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${img.rank}.`);
    const depth = img.rank === 2 ? 1 : img.shape[2];
    if (depth > 4 || depth === 2) throw new Error(`toPixels only supports depth of size ` + `1, 3 or 4 but got ${depth}`);
    if (img.dtype !== 'float32' && img.dtype !== 'int32') throw new Error(`Unsupported type for toPixels: ${img.dtype}.` + ` Please use float32 or int32 tensors.`);
}
function $79d3f34cef1b5242$var$validateImageOptions(imageOptions) {
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    if (alpha > 1 || alpha < 0) throw new Error(`Alpha value ${alpha} is suppoed to be in range [0 - 1].`);
}
async function $79d3f34cef1b5242$export$89b6cc959998e12e(img, canvas) {
    let $img = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(img, 'img', 'toPixels');
    if (!(img instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $79d3f34cef1b5242$var$validateImgTensor($img);
    const [height, width] = $img.shape.slice(0, 2);
    const depth = $img.rank === 2 ? 1 : $img.shape[2];
    const data = await $img.data();
    const multiplier = $img.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if ($img.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if ($img.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    if (canvas != null) {
        if (!$79d3f34cef1b5242$var$hasToPixelsWarned) {
            const kernel = (0, $071cf1fd9dc2117e$export$1b85808c967cc434)((0, $507890e4aa8e1463$export$dca20402ebea5ece), (0, $6a645535e157b279$export$33b63313cc511a3b).backendName);
            if (kernel != null) {
                console.warn("tf.browser.toPixels is not efficient to draw tensor on canvas. Please try tf.browser.draw instead.");
                $79d3f34cef1b5242$var$hasToPixelsWarned = true;
            }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const imageData = new ImageData(bytes, width, height);
        ctx.putImageData(imageData, 0, 0);
    }
    if ($img !== img) $img.dispose();
    return bytes;
}
function $79d3f34cef1b5242$export$e529deb2bfd496dc(image, canvas, options) {
    let $img = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'img', 'draw');
    if (!(image instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $79d3f34cef1b5242$var$validateImgTensor($img);
    $79d3f34cef1b5242$var$validateImageOptions(options === null || options === void 0 ? void 0 : options.imageOptions);
    const inputs = {
        image: $img
    };
    const attrs = {
        canvas: canvas,
        options: options
    };
    (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$dca20402ebea5ece), inputs, attrs);
}
const $79d3f34cef1b5242$export$5a3bc84b10e77d32 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    fromPixels_: $79d3f34cef1b5242$var$fromPixels_
});

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Clips values element-wise. `max(min(x, clipValueMax), clipValueMin)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.clipByValue(-2, 3).print();  // or tf.clipByValue(x, -2, 3)
 * ```
 * @param x The input tensor.
 * @param clipValueMin Lower bound of range to be clipped to.
 * @param clipValueMax Upper bound of range to be clipped to.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $454af21933ae7636$var$clipByValue_(x, clipValueMin, clipValueMax) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'clipByValue');
    $9e4a6174e3538e7d$export$a7a9523472993e97(clipValueMin <= clipValueMax, ()=>`Error in clip: min (${clipValueMin}) must be ` + `less than or equal to max (${clipValueMax}).`);
    if (clipValueMin === clipValueMax) return (0, $a1afd8d5a9faad9a$export$9563e054e6f787fb)($x.shape, clipValueMin, $x.dtype);
    const inputs = {
        x: $x
    };
    const attrs = {
        clipValueMin: clipValueMin,
        clipValueMax: clipValueMax
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$611c0e357ac37f7d), inputs, attrs);
}
const $454af21933ae7636$export$fa97baf70ad024c0 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    clipByValue_: $454af21933ae7636$var$clipByValue_
});

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Concatenates a list of `tf.Tensor`s along a given axis.
 *
 * The tensors ranks and types must match, and their sizes must match in all
 * dimensions except `axis`.
 *
 * Also available are stricter rank-specific methods that assert that
 * `tensors` are of the given rank:
 *   - `tf.concat1d`
 *   - `tf.concat2d`
 *   - `tf.concat3d`
 *   - `tf.concat4d`
 *
 * Except `tf.concat1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * a.concat(b).print();  // or a.concat(b)
 * ```
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.concat([a, b, c]).print();
 * ```
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [10, 20]]);
 * const b = tf.tensor2d([[3, 4], [30, 40]]);
 * const axis = 1;
 * tf.concat([a, b], axis).print();
 * ```
 * @param tensors A list of tensors to concatenate.
 * @param axis The axis to concatenate along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $5ddc229895c6e9a9$var$concat_(tensors, axis = 0) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(tensors.length >= 1, ()=>'Pass at least one tensor to concat');
    const $tensors = (0, $539f0ce07f2139cd$export$758e66616b4d410b)(tensors, 'tensors', 'concat', 'string_or_numeric');
    if ($tensors[0].dtype === 'complex64') $tensors.forEach((tensor)=>{
        if (tensor.dtype !== 'complex64') throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${tensor.dtype}. `);
    });
    if ($tensors.length === 1) return (0, $765aa12b24d3e86a$export$9cd59f9826255e47)($tensors[0]);
    const inputs = $tensors;
    const attr = {
        axis: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$936bbfc007425eea), inputs, attr);
}
const $5ddc229895c6e9a9$export$ee1b3e54f0441b22 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    concat_: $5ddc229895c6e9a9$var$concat_
});

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes exponential of the input `tf.Tensor` element-wise. `e ^ x`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.exp().print();  // or tf.exp(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $87d347fdc039529f$var$exp_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'exp');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f908be7a96fb3363), inputs);
}
const $87d347fdc039529f$export$b310ec824aaee37f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    exp_: $87d347fdc039529f$var$exp_
});

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
 * into the tensor's shape.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const axis = 1;
 * x.expandDims(axis).print();
 * ```
 *
 * @param x The input tensor whose dimensions are to be expanded.
 * @param axis The dimension index at which to insert shape of `1`. Defaults
 *     to 0 (the first dimension).
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $31018343da089cd7$var$expandDims_(x, axis = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'expandDims', 'string_or_numeric');
    $9e4a6174e3538e7d$export$a7a9523472993e97(axis <= $x.rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = {
        input: $x
    };
    const attrs = {
        dim: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$2391750b1d901146), inputs, attrs);
}
const $31018343da089cd7$export$d660d8ed21f46635 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    expandDims_: $31018343da089cd7$var$expandDims_
});

var $0d9cd03b68b74ca9$exports = {};

$parcel$export($0d9cd03b68b74ca9$exports, "spectral", () => $0d9cd03b68b74ca9$export$e0ccf6166915bd59);
$parcel$export($0d9cd03b68b74ca9$exports, "signal", () => $0d9cd03b68b74ca9$export$e2ef10f86a8d60e8);
$parcel$export($0d9cd03b68b74ca9$exports, "image", () => $0d9cd03b68b74ca9$export$5c452ff88e35e47d);
$parcel$export($0d9cd03b68b74ca9$exports, "linalg", () => $0d9cd03b68b74ca9$export$dbc5be37a4415193);
$parcel$export($0d9cd03b68b74ca9$exports, "losses", () => $0d9cd03b68b74ca9$export$24b113a95118cbdc);
$parcel$export($0d9cd03b68b74ca9$exports, "sparse", () => $0d9cd03b68b74ca9$export$b6b7e189aa5d134c);
$parcel$export($0d9cd03b68b74ca9$exports, "string", () => $0d9cd03b68b74ca9$export$22b082955e083ec3);
$parcel$export($0d9cd03b68b74ca9$exports, "abs", () => $ac4659b792ae4bef$export$2335f513bbd82c6d);
$parcel$export($0d9cd03b68b74ca9$exports, "acos", () => $5a845929cda44a47$export$fd6306be3fde5b04);
$parcel$export($0d9cd03b68b74ca9$exports, "acosh", () => $bea4fbf64b7d3e52$export$b26caf0f29211d08);
$parcel$export($0d9cd03b68b74ca9$exports, "add", () => $8efd352f234ac278$export$e16d8520af44a096);
$parcel$export($0d9cd03b68b74ca9$exports, "addN", () => $178ea3865fb9608d$export$37b75d0026f96b8d);
$parcel$export($0d9cd03b68b74ca9$exports, "all", () => $57070ca8a9a464f1$export$84bf76cd7afc7469);
$parcel$export($0d9cd03b68b74ca9$exports, "any", () => $7484d7f14f932b49$export$4154a199d7d90455);
$parcel$export($0d9cd03b68b74ca9$exports, "argMax", () => $3cfdfd16cd19c85f$export$7980a683c1b852b4);
$parcel$export($0d9cd03b68b74ca9$exports, "argMin", () => $ee734323ebfac5fd$export$ec99a91cddfb29a2);
$parcel$export($0d9cd03b68b74ca9$exports, "asin", () => $f07fbaaacb1f7c88$export$41726bdb1fc63f);
$parcel$export($0d9cd03b68b74ca9$exports, "asinh", () => $5f2f9281f394b8c7$export$839d8a01b6af4fc0);
$parcel$export($0d9cd03b68b74ca9$exports, "atan", () => $d23e246a876af1cf$export$628dc4eed22b0fbd);
$parcel$export($0d9cd03b68b74ca9$exports, "atan2", () => $f87b22742f77c39f$export$b8b770ee6a0d9760);
$parcel$export($0d9cd03b68b74ca9$exports, "atanh", () => $6c5627e71ce13ea3$export$21ea955025ceb08b);
$parcel$export($0d9cd03b68b74ca9$exports, "avgPool", () => $7a3c766bcf29cf34$export$d5c65a2abd3d97dc);
$parcel$export($0d9cd03b68b74ca9$exports, "avgPool3d", () => $51cc83f9ae0b2378$export$ee1b0efb53eb29c3);
$parcel$export($0d9cd03b68b74ca9$exports, "basicLSTMCell", () => $7946b06b7c7334c8$export$5f13ab10a3272278);
$parcel$export($0d9cd03b68b74ca9$exports, "batchToSpaceND", () => $0c9cd7e5361fb9c5$export$ea37d960c1808536);
$parcel$export($0d9cd03b68b74ca9$exports, "batchNorm", () => $222bc9281dad73cf$export$8ea8088e6d0cdd02);
$parcel$export($0d9cd03b68b74ca9$exports, "batchNorm2d", () => $ffc08554bd380b4b$export$4104d1fc5afa918a);
$parcel$export($0d9cd03b68b74ca9$exports, "batchNorm3d", () => $242f86ebeb9f9472$export$76211212fb57f1fa);
$parcel$export($0d9cd03b68b74ca9$exports, "batchNorm4d", () => $0902e4cfc4df4955$export$4573a348ef14e569);
$parcel$export($0d9cd03b68b74ca9$exports, "bincount", () => $6dec9946bca0316c$export$7e474bab088ed182);
$parcel$export($0d9cd03b68b74ca9$exports, "bitwiseAnd", () => $c76d7b3a95d697d0$export$84529b0ad3b42cd1);
$parcel$export($0d9cd03b68b74ca9$exports, "broadcastArgs", () => $d818f965eda43343$export$d226d344aedce941);
$parcel$export($0d9cd03b68b74ca9$exports, "broadcastTo", () => $8660a1872a3f456e$export$ec9086aff2624eab);
$parcel$export($0d9cd03b68b74ca9$exports, "buffer", () => $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a);
$parcel$export($0d9cd03b68b74ca9$exports, "cast", () => $262a02e810d931f1$export$f2db7d5238e1d23f);
$parcel$export($0d9cd03b68b74ca9$exports, "ceil", () => $b0c5ba6a70687623$export$803ce6b71a0a94b2);
$parcel$export($0d9cd03b68b74ca9$exports, "clipByValue", () => $454af21933ae7636$export$fa97baf70ad024c0);
$parcel$export($0d9cd03b68b74ca9$exports, "clone", () => $765aa12b24d3e86a$export$9cd59f9826255e47);
$parcel$export($0d9cd03b68b74ca9$exports, "complex", () => $974747594bfdbaee$export$83a0e34f1302825b);
$parcel$export($0d9cd03b68b74ca9$exports, "concat", () => $5ddc229895c6e9a9$export$ee1b3e54f0441b22);
$parcel$export($0d9cd03b68b74ca9$exports, "concat1d", () => $60a674b9995827dc$export$1e0bfb2ad280a475);
$parcel$export($0d9cd03b68b74ca9$exports, "concat2d", () => $53e99ac0d35f46a3$export$ba044983349051fd);
$parcel$export($0d9cd03b68b74ca9$exports, "concat3d", () => $7c41a333eefef52a$export$23e0f187dd67babf);
$parcel$export($0d9cd03b68b74ca9$exports, "concat4d", () => $eb71a111a6055dca$export$731e01cced6c0a23);
$parcel$export($0d9cd03b68b74ca9$exports, "conv1d", () => $514edc7e5d8da1cf$export$d8aa844fa36b350e);
$parcel$export($0d9cd03b68b74ca9$exports, "conv2d", () => $f6443e17dde6414c$export$188f9215482e3db8);
$parcel$export($0d9cd03b68b74ca9$exports, "conv2dTranspose", () => $9521e6c8393e9aaa$export$d5e924cbc07fb966);
$parcel$export($0d9cd03b68b74ca9$exports, "conv3d", () => $facc3bce4b597db3$export$c476b02bcf7b2def);
$parcel$export($0d9cd03b68b74ca9$exports, "conv3dTranspose", () => $9e27ff6ae2e73223$export$5eac62031b3f449f);
$parcel$export($0d9cd03b68b74ca9$exports, "cos", () => $1d4f28947ee6188f$export$50d414a77b60d802);
$parcel$export($0d9cd03b68b74ca9$exports, "cosh", () => $22f45c18cccd8888$export$2e2fd1ad24e4d350);
$parcel$export($0d9cd03b68b74ca9$exports, "cumprod", () => $04796872a0f4a696$export$dc7513e907e94b8d);
$parcel$export($0d9cd03b68b74ca9$exports, "cumsum", () => $1be40d302ebd83bb$export$71990b1e1c4912fe);
$parcel$export($0d9cd03b68b74ca9$exports, "denseBincount", () => $b350807f1cdf8378$export$436934e6cf1946f1);
$parcel$export($0d9cd03b68b74ca9$exports, "depthToSpace", () => $b83b95afe01d99d8$export$3b50daec0f185f12);
$parcel$export($0d9cd03b68b74ca9$exports, "depthwiseConv2d", () => $e24ad3a56ebef85b$export$48a8ad9494a8fad8);
$parcel$export($0d9cd03b68b74ca9$exports, "diag", () => $d1e4fa9967900292$export$c042e7c2f59bc046);
$parcel$export($0d9cd03b68b74ca9$exports, "dilation2d", () => $a9e9382c4d6ab295$export$d9b8f675671875b9);
$parcel$export($0d9cd03b68b74ca9$exports, "div", () => $3321ac17b3d0dfc7$export$159d9494db57879b);
$parcel$export($0d9cd03b68b74ca9$exports, "divNoNan", () => $3d11f29e3a06b28a$export$9c5df3eb9e56f19e);
$parcel$export($0d9cd03b68b74ca9$exports, "dot", () => $3804ba7949be197b$export$94132a0e348806d4);
$parcel$export($0d9cd03b68b74ca9$exports, "einsum", () => $86c3e2507ff73220$export$27265e7daac5c403);
$parcel$export($0d9cd03b68b74ca9$exports, "elu", () => $5bdd6bdcdfee63f8$export$796b583dd79d8524);
$parcel$export($0d9cd03b68b74ca9$exports, "ensureShape", () => $fdd727f9f1f5c03c$export$6699c34d603c5978);
$parcel$export($0d9cd03b68b74ca9$exports, "equal", () => $c70ba06b415a1f15$export$411ce8e5a71e3069);
$parcel$export($0d9cd03b68b74ca9$exports, "erf", () => $812d049313eea70b$export$d3896f355fc09423);
$parcel$export($0d9cd03b68b74ca9$exports, "euclideanNorm", () => $6bae998afca941ee$export$38d83b337e7c2edd);
$parcel$export($0d9cd03b68b74ca9$exports, "exp", () => $87d347fdc039529f$export$b310ec824aaee37f);
$parcel$export($0d9cd03b68b74ca9$exports, "expandDims", () => $31018343da089cd7$export$d660d8ed21f46635);
$parcel$export($0d9cd03b68b74ca9$exports, "expm1", () => $a0e551d3dab48311$export$b6c0a80d46d3391d);
$parcel$export($0d9cd03b68b74ca9$exports, "eye", () => $311a450f987992a1$export$4e18cf730a59887e);
$parcel$export($0d9cd03b68b74ca9$exports, "fill", () => $a1afd8d5a9faad9a$export$9563e054e6f787fb);
$parcel$export($0d9cd03b68b74ca9$exports, "floor", () => $2f0cea174d82bbd9$export$a3fe094919f356fd);
$parcel$export($0d9cd03b68b74ca9$exports, "floorDiv", () => $a4de2f9f568ab684$export$112397bc52715a8);
$parcel$export($0d9cd03b68b74ca9$exports, "gather", () => $81ed3ff29d6a051b$export$9e05546f00427e8);
$parcel$export($0d9cd03b68b74ca9$exports, "greater", () => $0034e349e70db944$export$9dca161faaf6308b);
$parcel$export($0d9cd03b68b74ca9$exports, "greaterEqual", () => $eceec4f09b66c311$export$c2fd4164cadc1fa2);
$parcel$export($0d9cd03b68b74ca9$exports, "imag", () => $8374544a706e8d44$export$d78fab5778ab392b);
$parcel$export($0d9cd03b68b74ca9$exports, "isFinite", () => $7e98b4b51c263920$export$65f0b13f2f82375a);
$parcel$export($0d9cd03b68b74ca9$exports, "isInf", () => $5911e516e026fa36$export$e5d3415c656f7096);
$parcel$export($0d9cd03b68b74ca9$exports, "isNaN", () => $ba12a83b0cfe3e36$export$c9f5652083b8129d);
$parcel$export($0d9cd03b68b74ca9$exports, "leakyRelu", () => $0c93893b76e462ad$export$23a860e40a2c6b61);
$parcel$export($0d9cd03b68b74ca9$exports, "less", () => $d2eb0cc564463c61$export$bb1a638da8ad190f);
$parcel$export($0d9cd03b68b74ca9$exports, "lessEqual", () => $9b3d78d7d568ec20$export$c24ad19a692bb92);
$parcel$export($0d9cd03b68b74ca9$exports, "linspace", () => $84e8c3ee1758a842$export$71255ea3f595147c);
$parcel$export($0d9cd03b68b74ca9$exports, "localResponseNormalization", () => $09cec53f2c18e160$export$b6127073705f6321);
$parcel$export($0d9cd03b68b74ca9$exports, "log", () => $efc3c6c91f7ffb3e$export$bef1f36f5486a6a3);
$parcel$export($0d9cd03b68b74ca9$exports, "log1p", () => $943a5cd04e004157$export$144dcf16adfb9698);
$parcel$export($0d9cd03b68b74ca9$exports, "logSigmoid", () => $ccada41132b66a52$export$9e0b8feed033df47);
$parcel$export($0d9cd03b68b74ca9$exports, "logSoftmax", () => $d2d9b5a54ac4b8bb$export$676379a046a2e437);
$parcel$export($0d9cd03b68b74ca9$exports, "logSumExp", () => $46447b0d409676ff$export$e20aca1e89397787);
$parcel$export($0d9cd03b68b74ca9$exports, "logicalAnd", () => $43e415e5ff25d286$export$db5dd0ef9d505f);
$parcel$export($0d9cd03b68b74ca9$exports, "logicalNot", () => $f04fdf3ce24a6ad4$export$c836ff7b605b1617);
$parcel$export($0d9cd03b68b74ca9$exports, "logicalOr", () => $b2cb91e587cc1ee5$export$e2a73975983cadd8);
$parcel$export($0d9cd03b68b74ca9$exports, "logicalXor", () => $f2064c5f0ccce267$export$20f90b62b30dbaef);
$parcel$export($0d9cd03b68b74ca9$exports, "lowerBound", () => $e9809ccc01605fb1$export$450bb71ab40039dc);
$parcel$export($0d9cd03b68b74ca9$exports, "matMul", () => $8a13d3789789217b$export$6706882a873e9a8f);
$parcel$export($0d9cd03b68b74ca9$exports, "max", () => $a7ac59438638606f$export$8960430cfd85939f);
$parcel$export($0d9cd03b68b74ca9$exports, "maxPool", () => $4a7523a0f2407497$export$e4aadcf115842782);
$parcel$export($0d9cd03b68b74ca9$exports, "maxPool3d", () => $4e9f4d29d50590f0$export$822a6e53be1125f9);
$parcel$export($0d9cd03b68b74ca9$exports, "maxPoolWithArgmax", () => $77d0f65983551a81$export$3d8b1b819d23351e);
$parcel$export($0d9cd03b68b74ca9$exports, "maximum", () => $23b950e6abbae120$export$b25e0be55f42c9a);
$parcel$export($0d9cd03b68b74ca9$exports, "mean", () => $050f28c39276830f$export$1ce691f85baaa52);
$parcel$export($0d9cd03b68b74ca9$exports, "meshgrid", () => $9908cc81353f6753$export$2fab8e71e5fefc1a);
$parcel$export($0d9cd03b68b74ca9$exports, "min", () => $51299ddc709e72aa$export$96ec731ed4dcb222);
$parcel$export($0d9cd03b68b74ca9$exports, "minimum", () => $4315eb3f5ec9063a$export$916782c1f0ddb132);
$parcel$export($0d9cd03b68b74ca9$exports, "mirrorPad", () => $cae387b6339c4711$export$c0b11600e90b86ae);
$parcel$export($0d9cd03b68b74ca9$exports, "mod", () => $102378bc37a939ad$export$842a2cf37af977e1);
$parcel$export($0d9cd03b68b74ca9$exports, "moments", () => $72a959a6cb42aff7$export$19ef085469537740);
$parcel$export($0d9cd03b68b74ca9$exports, "mul", () => $582b63c19659e1cf$export$6e3a27864ab166fe);
$parcel$export($0d9cd03b68b74ca9$exports, "multiRNNCell", () => $25da887321c007b8$export$cc05b5217b9b924f);
$parcel$export($0d9cd03b68b74ca9$exports, "multinomial", () => $aa159b2c998f6945$export$f4d580f3101a1c7e);
$parcel$export($0d9cd03b68b74ca9$exports, "neg", () => $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5);
$parcel$export($0d9cd03b68b74ca9$exports, "notEqual", () => $3b3172df4948dc0b$export$53a6892c50694894);
$parcel$export($0d9cd03b68b74ca9$exports, "oneHot", () => $fa50897246093fc8$export$341b5490a776d041);
$parcel$export($0d9cd03b68b74ca9$exports, "ones", () => $5bbaaacdaecf5fa4$export$21041dee6b8001b0);
$parcel$export($0d9cd03b68b74ca9$exports, "onesLike", () => $4f24ce9b876632b2$export$fb6afd6214fee9e9);
$parcel$export($0d9cd03b68b74ca9$exports, "outerProduct", () => $ea9074c3ac34a33a$export$8481b38c75c91cc7);
$parcel$export($0d9cd03b68b74ca9$exports, "pad", () => $6d3dcf71964d715a$export$5d04458e2a6c373e);
$parcel$export($0d9cd03b68b74ca9$exports, "pad1d", () => $2e4218e952802c5e$export$be67ff622a7fd5);
$parcel$export($0d9cd03b68b74ca9$exports, "pad2d", () => $d45b582f4a35e9ce$export$38e9137d79715c2d);
$parcel$export($0d9cd03b68b74ca9$exports, "pad3d", () => $53479bd083cf15cd$export$880821ebecb16ceb);
$parcel$export($0d9cd03b68b74ca9$exports, "pad4d", () => $c2099fc3afb4b0cc$export$4aef6fb43f1346f4);
$parcel$export($0d9cd03b68b74ca9$exports, "pool", () => $7fb5e0b8a7333410$export$7a0e2789ec54f0db);
$parcel$export($0d9cd03b68b74ca9$exports, "pow", () => $dfeb0ec8a84c566a$export$9c297f60e22e3389);
$parcel$export($0d9cd03b68b74ca9$exports, "prelu", () => $69a5169271dc480f$export$5882f235222e6729);
$parcel$export($0d9cd03b68b74ca9$exports, "print", () => $25c41199dcd2e1a0$export$c2d084dc44961371);
$parcel$export($0d9cd03b68b74ca9$exports, "prod", () => $19a586127900ac98$export$5e143010dea16c85);
$parcel$export($0d9cd03b68b74ca9$exports, "raggedGather", () => $0e93c4003fe85c10$export$e7118f605df251dd);
$parcel$export($0d9cd03b68b74ca9$exports, "raggedRange", () => $4adb37d3e00c3c62$export$a173be400c6762b5);
$parcel$export($0d9cd03b68b74ca9$exports, "raggedTensorToTensor", () => $b4dbb3f1130f0eaa$export$621e390307cbbaa1);
$parcel$export($0d9cd03b68b74ca9$exports, "rand", () => $ba18400447ccf3b8$export$bb0a9c36cf454ea0);
$parcel$export($0d9cd03b68b74ca9$exports, "randomGamma", () => $225d8d6649e70557$export$63a8048b65295cb7);
$parcel$export($0d9cd03b68b74ca9$exports, "randomNormal", () => $10c29e3bf2646a65$export$a0ac5549a8bec918);
$parcel$export($0d9cd03b68b74ca9$exports, "randomStandardNormal", () => $4504dc5770f2ed6f$export$5a8aa20f8ebaee69);
$parcel$export($0d9cd03b68b74ca9$exports, "randomUniform", () => $efc9b1d03c9e7df6$export$bd6fd37822e292fa);
$parcel$export($0d9cd03b68b74ca9$exports, "randomUniformInt", () => $33d730612f2006bb$export$134fe7f07fd7b492);
$parcel$export($0d9cd03b68b74ca9$exports, "range", () => $7a9b6c8fcbba0cfb$export$d02631cccf789723);
$parcel$export($0d9cd03b68b74ca9$exports, "real", () => $dd915d18522f1450$export$9fc57fb453bdbd67);
$parcel$export($0d9cd03b68b74ca9$exports, "reciprocal", () => $7532fe118ac8f9c2$export$163bc8c839a1ac04);
$parcel$export($0d9cd03b68b74ca9$exports, "relu", () => $6c8b0dbda17f9033$export$16d1e4612cc0139f);
$parcel$export($0d9cd03b68b74ca9$exports, "relu6", () => $9412c844ada93d82$export$4a62bcb95e9c44c4);
$parcel$export($0d9cd03b68b74ca9$exports, "reshape", () => $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b);
$parcel$export($0d9cd03b68b74ca9$exports, "reverse", () => $50ede1b45b382c7d$export$66c1ae025e96b4bc);
$parcel$export($0d9cd03b68b74ca9$exports, "reverse1d", () => $2e0480d314e75948$export$ec29ded9cbde7103);
$parcel$export($0d9cd03b68b74ca9$exports, "reverse2d", () => $2bce5c5a5a9cf199$export$12170f5f8cb48014);
$parcel$export($0d9cd03b68b74ca9$exports, "reverse3d", () => $3b42757d0887c94a$export$1ecb65b2ca41f0e);
$parcel$export($0d9cd03b68b74ca9$exports, "reverse4d", () => $14a85ea26d68967a$export$76a1df46e0e42da4);
$parcel$export($0d9cd03b68b74ca9$exports, "round", () => $b8e64b0c5bfbfd9b$export$2077e0241d6afd3c);
$parcel$export($0d9cd03b68b74ca9$exports, "rsqrt", () => $5b6251eca9cf0835$export$1cc01d192953037e);
$parcel$export($0d9cd03b68b74ca9$exports, "scalar", () => $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46);
$parcel$export($0d9cd03b68b74ca9$exports, "selu", () => $a07498b92d052ec8$export$a5f8240d9e99b438);
$parcel$export($0d9cd03b68b74ca9$exports, "separableConv2d", () => $95d8c4dd241bf4ec$export$2586c92899c2d0fb);
$parcel$export($0d9cd03b68b74ca9$exports, "setdiff1dAsync", () => $1035d52388d298b8$export$cd50e5d116ec1774);
$parcel$export($0d9cd03b68b74ca9$exports, "sigmoid", () => $4e7e1888b524d401$export$3b295495ca3cad7c);
$parcel$export($0d9cd03b68b74ca9$exports, "sign", () => $d0f80db0cefed32f$export$c5552dfdbc7cec71);
$parcel$export($0d9cd03b68b74ca9$exports, "sin", () => $ce2da5a3db38a0bc$export$5de3937cb4b592ed);
$parcel$export($0d9cd03b68b74ca9$exports, "sinh", () => $790a75f63469cd19$export$545004b505d7c555);
$parcel$export($0d9cd03b68b74ca9$exports, "slice", () => $5ac259fe82d1a965$export$58adb3bec8346d0f);
$parcel$export($0d9cd03b68b74ca9$exports, "slice1d", () => $56411002fecff555$export$95433662b275eb82);
$parcel$export($0d9cd03b68b74ca9$exports, "slice2d", () => $50c4b0df2d499845$export$e5c6a6611cb43a9d);
$parcel$export($0d9cd03b68b74ca9$exports, "slice3d", () => $c0cf3b7aeb1d3f8b$export$dec56af20749d733);
$parcel$export($0d9cd03b68b74ca9$exports, "slice4d", () => $59045228e6ed5362$export$9833e35e879da26c);
$parcel$export($0d9cd03b68b74ca9$exports, "softmax", () => $a8baad5804a245dd$export$e008137e76238601);
$parcel$export($0d9cd03b68b74ca9$exports, "softplus", () => $c6f989486c1f1c8b$export$76aa560a8c2b0055);
$parcel$export($0d9cd03b68b74ca9$exports, "spaceToBatchND", () => $5e82eb397f4e7578$export$effb9d7cae92012f);
$parcel$export($0d9cd03b68b74ca9$exports, "fft", () => $0c1f0be368155dff$export$a535ef183b6128fa);
$parcel$export($0d9cd03b68b74ca9$exports, "ifft", () => $349f5d08af454fa3$export$776649b0bf8ce1fd);
$parcel$export($0d9cd03b68b74ca9$exports, "irfft", () => $0d3fdeaac3c3258b$export$f47f4e5bcd3d6a66);
$parcel$export($0d9cd03b68b74ca9$exports, "rfft", () => $ba0ceb1c91713e10$export$72aff1768917e9e5);
$parcel$export($0d9cd03b68b74ca9$exports, "split", () => $78850daf663d7633$export$65980d18b75784e2);
$parcel$export($0d9cd03b68b74ca9$exports, "sqrt", () => $829be0ea336e2128$export$eba8049fb5020b81);
$parcel$export($0d9cd03b68b74ca9$exports, "square", () => $7c706d812ea019b4$export$dd4f28cef696bc7d);
$parcel$export($0d9cd03b68b74ca9$exports, "squaredDifference", () => $ccd5a9fa9e8cfcbf$export$b178697fb6d0b37f);
$parcel$export($0d9cd03b68b74ca9$exports, "squeeze", () => $d85a848eb4aff9d2$export$889c931173b77c2f);
$parcel$export($0d9cd03b68b74ca9$exports, "stack", () => $63dcfd1fd312c0ca$export$a57ab32f40f83ea9);
$parcel$export($0d9cd03b68b74ca9$exports, "step", () => $9412dac12debc677$export$35d34bc0ed591a92);
$parcel$export($0d9cd03b68b74ca9$exports, "stridedSlice", () => $d49699aade4fd383$export$4ae57224f3b0605c);
$parcel$export($0d9cd03b68b74ca9$exports, "sub", () => $6b10a09db634e9ba$export$f93b5905241a7cca);
$parcel$export($0d9cd03b68b74ca9$exports, "sum", () => $140b816be4851e95$export$8a63f25cc62965f1);
$parcel$export($0d9cd03b68b74ca9$exports, "tan", () => $6435bef2c868efdb$export$fcdd3b0b3246a325);
$parcel$export($0d9cd03b68b74ca9$exports, "tanh", () => $511354a997a9a34b$export$7128670e45beef9a);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor", () => $141b1f68c03d4acb$export$65df3ad1ad888abb);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor1d", () => $efe757e3a7d314f1$export$8133e3bf3cd8f464);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor2d", () => $bb1fb3a4fbd244b1$export$b5469a65e8732256);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor3d", () => $6493cf21bc51a2cb$export$aa36a9de53c6d912);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor4d", () => $4d7ed8a52e882f92$export$b43603ce4e7542a7);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor5d", () => $933a6cb3fcb4c6cf$export$ab0278981fc9e727);
$parcel$export($0d9cd03b68b74ca9$exports, "tensor6d", () => $619d041b413939f0$export$7b9f27dd2306a502);
$parcel$export($0d9cd03b68b74ca9$exports, "tensorScatterUpdate", () => $7138839c02670096$export$d3ac02769385eb36);
$parcel$export($0d9cd03b68b74ca9$exports, "tile", () => $e6ca18ccb4a89ccc$export$3c17558da18e4d75);
$parcel$export($0d9cd03b68b74ca9$exports, "topk", () => $a34564a7dc7bfbd8$export$4e6b28a600f8b4df);
$parcel$export($0d9cd03b68b74ca9$exports, "truncatedNormal", () => $331921fa75ce86ae$export$8ad5625727f3fa1d);
$parcel$export($0d9cd03b68b74ca9$exports, "unique", () => $e5315ba40f5543a5$export$7a5d5c156e7dc406);
$parcel$export($0d9cd03b68b74ca9$exports, "unsortedSegmentSum", () => $de795b6a78c6b444$export$ba7c4d144d85a309);
$parcel$export($0d9cd03b68b74ca9$exports, "unstack", () => $18be989171d2a470$export$3c05285afa115eec);
$parcel$export($0d9cd03b68b74ca9$exports, "upperBound", () => $fa8aa635c349da99$export$1e7f253df265a2ba);
$parcel$export($0d9cd03b68b74ca9$exports, "variable", () => $9452087a694f1769$export$3a9d57cefcd2c285);
$parcel$export($0d9cd03b68b74ca9$exports, "where", () => $5ca12d297e319cbc$export$9c59b80dda569a6e);
$parcel$export($0d9cd03b68b74ca9$exports, "whereAsync", () => $9b1ea25d493590e8$export$b95962138b7a377d);
$parcel$export($0d9cd03b68b74ca9$exports, "zeros", () => $a0e8420b37ff8039$export$4445a00dafa2633b);
$parcel$export($0d9cd03b68b74ca9$exports, "zerosLike", () => $a5cb5e205b190f05$export$cb1f824e7733584d);
$parcel$export($0d9cd03b68b74ca9$exports, "op", () => $90f933163f6ac994$export$f59964a629598e2);
$parcel$export($0d9cd03b68b74ca9$exports, "OP_SCOPE_SUFFIX", () => $90f933163f6ac994$export$93114f1494faf9bb);
$parcel$export($0d9cd03b68b74ca9$exports, "fused", () => $2712b959896a25e5$exports);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Modularized ops.

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes acos of the input `tf.Tensor` element-wise: `acos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.acos().print();  // or tf.acos(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5a845929cda44a47$var$acos_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'acos');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$3b952c9980dac550), inputs);
}
const $5a845929cda44a47$export$fd6306be3fde5b04 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    acos_: $5a845929cda44a47$var$acos_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the inverse hyperbolic cos of the input `tf.Tensor` element-wise:
 * `acosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([10, 1, 3, 5.7]);
 *
 * x.acosh().print();  // or tf.acosh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $bea4fbf64b7d3e52$var$acosh_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'acosh');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$987da490b7c2e7dd), inputs);
}
const $bea4fbf64b7d3e52$export$b26caf0f29211d08 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    acosh_: $bea4fbf64b7d3e52$var$acosh_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Adds a list of `tf.Tensor`s element-wise, each with the same shape and dtype.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 *
 * tf.addN([a, b, c]).print();
 * ```
 * @param tensors A list of tensors with the same shape and dtype.
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $178ea3865fb9608d$var$addN_(tensors) {
    $9e4a6174e3538e7d$export$a7a9523472993e97(Array.isArray(tensors), ()=>'The argument passed to tf.addN() must be a list of tensors');
    $9e4a6174e3538e7d$export$a7a9523472993e97(tensors.length >= 1, ()=>`Must pass at least one tensor to tf.addN(), but got ` + `${tensors.length}`);
    const $tensors = tensors.map((t, i)=>(0, $539f0ce07f2139cd$export$ede379c4c939d71a)(t, `tensors${i}`, 'addN'));
    const firstTensor = $tensors[0];
    $tensors.forEach((t)=>{
        if (t.dtype !== firstTensor.dtype) throw new Error('All tensors passed to tf.addN() must have the same dtype');
    });
    $tensors.forEach((t)=>{
        if (!$9e4a6174e3538e7d$export$234180f8206db11b(t.shape, firstTensor.shape)) throw new Error('All tensors passed to tf.addN() must have the same shape');
    });
    const inputs = $tensors;
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$eef235ad06d3226a), inputs);
}
const $178ea3865fb9608d$export$37b75d0026f96b8d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    addN_: $178ea3865fb9608d$var$addN_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the logical and of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.all().print();  // or tf.all(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.all(axis).print();  // or tf.all(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $57070ca8a9a464f1$var$all_(x, axis = null, keepDims = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'all', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5dceb1ab650a1776), inputs, attrs);
}
const $57070ca8a9a464f1$export$84bf76cd7afc7469 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    all_: $57070ca8a9a464f1$var$all_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the logical or of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.any().print();  // or tf.any(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.any(axis).print();  // or tf.any(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $7484d7f14f932b49$var$any_(x, axis = null, keepDims = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'any', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b24b633b1364b94b), inputs, attrs);
}
const $7484d7f14f932b49$export$4154a199d7d90455 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    any_: $7484d7f14f932b49$var$any_
});



/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the indices of the minimum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMin().print();  // or tf.argMin(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMin(axis).print();  // or tf.argMin(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $ee734323ebfac5fd$var$argMin_(x, axis = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'argMin');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$baabd09270cbbd94), inputs, attrs);
}
const $ee734323ebfac5fd$export$ec99a91cddfb29a2 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    argMin_: $ee734323ebfac5fd$var$argMin_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes asin of the input `tf.Tensor` element-wise: `asin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asin().print();  // or tf.asin(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f07fbaaacb1f7c88$var$asin_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'asin');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$664c8ca7e7e5c126), inputs);
}
const $f07fbaaacb1f7c88$export$41726bdb1fc63f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    asin_: $f07fbaaacb1f7c88$var$asin_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes inverse hyperbolic sin of the input `tf.Tensor` element-wise:
 * `asinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asinh().print();  // or tf.asinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5f2f9281f394b8c7$var$asinh_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'asinh');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$847c88940cb7dcb5), inputs);
}
const $5f2f9281f394b8c7$export$839d8a01b6af4fc0 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    asinh_: $5f2f9281f394b8c7$var$asinh_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes atan of the input `tf.Tensor` element-wise: `atan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.atan().print();  // or tf.atan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d23e246a876af1cf$var$atan_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'atan');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$bac667d46ac043ae), inputs);
}
const $d23e246a876af1cf$export$628dc4eed22b0fbd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    atan_: $d23e246a876af1cf$var$atan_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes arctangent of `tf.Tensor`s a / b element-wise: `atan2(a, b)`.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1.0, 1.0, -1.0, .7]);
 * const b = tf.tensor1d([2.0, 13.0, 3.5, .21]);
 *
 * tf.atan2(a, b).print()
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f87b22742f77c39f$var$atan2_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'atan2');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'atan2');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$3bf4c619ce589f4b), inputs);
}
const $f87b22742f77c39f$export$b8b770ee6a0d9760 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    atan2_: $f87b22742f77c39f$var$atan2_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes inverse hyperbolic tan of the input `tf.Tensor` element-wise:
 * `atanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.atanh().print();  // or tf.atanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6c5627e71ce13ea3$var$atanh_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'atanh');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$98981a86fa2b1366), inputs);
}
const $6c5627e71ce13ea3$export$21ea955025ceb08b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    atanh_: $6c5627e71ce13ea3$var$atanh_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * Computes the 2D average pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $7a3c766bcf29cf34$var$avgPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'avgPool', 'float32');
    const dilations = 1;
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in avgPool: x must be rank 4 but got rank ${x4D.rank}.`);
    $f9c374363849dff2$export$1b3400c26a44af8('avgPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$37f2cc7be1add88c), inputs, attrs);
    res = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(res, $x.dtype);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $7a3c766bcf29cf34$export$d5c65a2abd3d97dc = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    avgPool_: $7a3c766bcf29cf34$var$avgPool_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * Computes the 3D average pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.avgPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $51cc83f9ae0b2378$var$avgPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'avgPool3d', 'float32');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x5D.rank === 5, ()=>`Error in avgPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NDHWC', ()=>`Error in avgPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(typeof strides === 'number' && strides > 0 || Array.isArray(strides) && strides[0] > 0 && strides[1] > 0 && strides[2] > 0, ()=>`Error in avgPool3d: Stride must be > 0, but got '${strides}'`);
    (0, $f9c374363849dff2$export$1b3400c26a44af8)('avgPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$390ecb697af103f6), inputs, attrs);
    res = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(res, x5D.dtype);
    if (reshapedTo5D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $51cc83f9ae0b2378$export$ee1b0efb53eb29c3 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    avgPool3d_: $51cc83f9ae0b2378$var$avgPool3d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the dot product of two matrices, A * B. These must be matrices.
 *
 * ```js
 * const a = tf.tensor2d([1, 2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.matMul(b).print();  // or tf.matMul(a, b)
 * ```
 * @param a First matrix in dot product operation.
 * @param b Second matrix in dot product operation.
 * @param transposeA If true, `a` is transposed before multiplication.
 * @param transposeB If true, `b` is transposed before multiplication.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $8a13d3789789217b$var$matMul_(a, b, transposeA = false, transposeB = false) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'matMul');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'matMul');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9a3bf60b23f63c8), inputs, attrs);
}
const $8a13d3789789217b$export$6706882a873e9a8f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    matMul_: $8a13d3789789217b$var$matMul_
});





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a slice from a `tf.Tensor` starting at coordinates `begin`
 * and is of size `size`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `x` is of the given rank:
 *   - `tf.slice1d`
 *   - `tf.slice2d`
 *   - `tf.slice3d`
 *   - `tf.slice4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.slice([1], [2]).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * x.slice([1, 0], [1, 2]).print();
 * ```
 * @param x The input `tf.Tensor` to slice from.
 * @param begin The coordinates to start the slice from. The length can be
 *     less than the rank of x - the rest of the axes will have implicit 0 as
 *     start. Can also be a single number, in which case it specifies the
 *     first axis.
 * @param size The size of the slice. The length can be less than the rank of
 *     x - the rest of the axes will have implicit -1. A value of -1 requests
 *     the rest of the dimensions in the axis. Can also be a single number,
 *     in which case it specifies the size of the first axis.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $5ac259fe82d1a965$var$slice_(x, begin, size) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'slice', 'string_or_numeric');
    if ($x.rank === 0) throw new Error('Slicing scalar is not possible');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        size: size
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b3f2e2de3a8baa1e), inputs, attrs);
}
const $5ac259fe82d1a965$export$58adb3bec8346d0f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    slice_: $5ac259fe82d1a965$var$slice_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes hyperbolic tangent of the input `tf.Tensor` element-wise: `tanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, 70]);
 *
 * x.tanh().print();  // or tf.tanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $511354a997a9a34b$var$tanh_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'tanh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$893b6e865e352c83), inputs);
}
const $511354a997a9a34b$export$7128670e45beef9a = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    tanh_: $511354a997a9a34b$var$tanh_
});


/**
 * Computes the next state and output of a BasicLSTMCell.
 *
 * Returns `[newC, newH]`.
 *
 * Derived from tf.contrib.rnn.BasicLSTMCell.
 *
 * @param forgetBias Forget bias for the cell.
 * @param lstmKernel The weights for the cell.
 * @param lstmBias The bias for the cell.
 * @param data The input to the cell.
 * @param c Previous cell state.
 * @param h Previous cell output.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $7946b06b7c7334c8$var$basicLSTMCell_(forgetBias, lstmKernel, lstmBias, data, c, h) {
    const $forgetBias = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(forgetBias, 'forgetBias', 'basicLSTMCell');
    const $lstmKernel = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(lstmKernel, 'lstmKernel', 'basicLSTMCell');
    const $lstmBias = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(lstmBias, 'lstmBias', 'basicLSTMCell');
    const $data = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(data, 'data', 'basicLSTMCell');
    const $c = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(c, 'c', 'basicLSTMCell');
    const $h = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(h, 'h', 'basicLSTMCell');
    const combined = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
        $data,
        $h
    ], 1);
    const weighted = (0, $8a13d3789789217b$export$6706882a873e9a8f)(combined, $lstmKernel);
    const res = (0, $8efd352f234ac278$export$e16d8520af44a096)(weighted, $lstmBias);
    // i = input_gate, j = new_input, f = forget_gate, o = output_gate
    const batchSize = res.shape[0];
    const sliceCols = res.shape[1] / 4;
    const sliceSize = [
        batchSize,
        sliceCols
    ];
    const i = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(res, [
        0,
        0
    ], sliceSize);
    const j = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(res, [
        0,
        sliceCols
    ], sliceSize);
    const f = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(res, [
        0,
        sliceCols * 2
    ], sliceSize);
    const o = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(res, [
        0,
        sliceCols * 3
    ], sliceSize);
    const newC = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $4e7e1888b524d401$export$3b295495ca3cad7c)(i), (0, $511354a997a9a34b$export$7128670e45beef9a)(j)), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)($c, (0, $4e7e1888b524d401$export$3b295495ca3cad7c)((0, $8efd352f234ac278$export$e16d8520af44a096)($forgetBias, f))));
    const newH = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $511354a997a9a34b$export$7128670e45beef9a)(newC), (0, $4e7e1888b524d401$export$3b295495ca3cad7c)(o));
    return [
        newC,
        newH
    ];
}
const $7946b06b7c7334c8$export$5f13ab10a3272278 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    basicLSTMCell_: $7946b06b7c7334c8$var$basicLSTMCell_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * This operation reshapes the "batch" dimension 0 into `M + 1` dimensions of
 * shape `blockShape + [batch]`, interleaves these blocks back into the grid
 * defined by the spatial dimensions `[1, ..., M]`, to obtain a result with
 * the same rank as the input. The spatial dimensions of this intermediate
 * result are then optionally cropped according to `crops` to produce the
 * output. This is the reverse of `tf.spaceToBatchND`. See below for a precise
 * description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [4, 1, 1, 1]);
 * const blockShape = [2, 2];
 * const crops = [[0, 0], [0, 0]];
 *
 * x.batchToSpaceND(blockShape, crops).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param crops A 2-D array.  Must have shape `[M, 2]`, all values must be >= 0.
 * `crops[i] = [cropStart, cropEnd]` specifies the amount to crop from input
 * dimension `i + 1`, which corresponds to spatial dimension `i`. It is required
 * that `cropStart[i] + cropEnd[i] <= blockShape[i] * inputShape[i + 1]`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Reshape `x` to `reshaped` of shape: `[blockShape[0], ...,
 * blockShape[M-1], batch / prod(blockShape), x.shape[1], ...,
 * x.shape[N-1]]`
 *
 * 2. Permute dimensions of `reshaped` to produce `permuted` of shape `[batch /
 * prod(blockShape),x.shape[1], blockShape[0], ..., x.shape[M],
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 3. Reshape `permuted` to produce `reshapedPermuted` of shape `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0], ..., x.shape[M] *
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 4. Crop the start and end of dimensions `[1, ..., M]` of `reshapedPermuted`
 * according to `crops` to produce the output of shape: `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0] - crops[0,0] - crops[0,1],
 * ..., x.shape[M] * blockShape[M-1] - crops[M-1,0] -
 * crops[M-1,1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $0c9cd7e5361fb9c5$var$batchToSpaceND_(x, blockShape, crops) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank >= 1 + blockShape.length, ()=>`input rank is ${$x.rank} but should be > than blockShape.length ${blockShape.length}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(crops.length === blockShape.length, ()=>`crops.length is ${crops.length} but should be equal to blockShape.length  ${blockShape.length}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.shape[0] % prod === 0, ()=>`input tensor batch is ${$x.shape[0]} but is not divisible by the product of ` + `the elements of blockShape ${blockShape.join(' * ')} === ${prod}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        crops: crops
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$e2743f47f61cca1f), inputs, attrs);
}
const $0c9cd7e5361fb9c5$export$ea37d960c1808536 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    batchToSpaceND_: $0c9cd7e5361fb9c5$var$batchToSpaceND_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




function $613795aa28d33479$export$b76c765a8a7b5836(x) {
    let x4D;
    if (x.rank === 0 || x.rank === 1) x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
        1,
        1,
        1,
        x.size
    ]);
    else if (x.rank === 2) x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
        1,
        1,
        x.shape[0],
        x.shape[1]
    ]);
    else if (x.rank === 3) x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    else x4D = x;
    return x4D;
}




/**
 * Batch normalization.
 *
 * As described in
 * [http://arxiv.org/abs/1502.03167](http://arxiv.org/abs/1502.03167).
 *
 * Mean, variance, scale, and offset can be of two shapes:
 *   - The same shape as the input.
 *   - In the common case, the depth dimension is the last dimension of x, so
 *     the values would be a `tf.Tensor1D` of shape [depth].
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that parameters passed are of given rank
 *   - `tf.batchNorm2d`
 *   - `tf.batchNorm3d`
 *   - `tf.batchNorm4d`
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $222bc9281dad73cf$var$batchNorm_(x, mean, variance, offset, scale, varianceEpsilon) {
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $9e4a6174e3538e7d$export$a7a9523472993e97($mean.rank === $variance.rank, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    $9e4a6174e3538e7d$export$a7a9523472993e97($offset == null || $mean.rank === $offset.rank, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    $9e4a6174e3538e7d$export$a7a9523472993e97($scale == null || $mean.rank === $scale.rank, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    const x4D = (0, $613795aa28d33479$export$b76c765a8a7b5836)($x);
    const inputs = {
        x: x4D,
        scale: $scale,
        offset: $offset,
        mean: $mean,
        variance: $variance
    };
    const attrs = {
        varianceEpsilon: varianceEpsilon
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$3821a0416660aaa2), inputs, attrs);
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, $x.shape);
}
const $222bc9281dad73cf$export$8ea8088e6d0cdd02 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    batchNorm_: $222bc9281dad73cf$var$batchNorm_
});






/**
 * Batch normalization, strictly for 2D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $ffc08554bd380b4b$var$batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 2, ()=>`Error in batchNorm2D: x must be rank 2 but got rank ` + `${$x.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($mean.rank === 2 || $mean.rank === 1, ()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($variance.rank === 2 || $variance.rank === 1, ()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $9e4a6174e3538e7d$export$a7a9523472993e97($scale.rank === 2 || $scale.rank === 1, ()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $9e4a6174e3538e7d$export$a7a9523472993e97($offset.rank === 2 || $offset.rank === 1, ()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $222bc9281dad73cf$export$8ea8088e6d0cdd02)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $ffc08554bd380b4b$export$4104d1fc5afa918a = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    batchNorm2d_: $ffc08554bd380b4b$var$batchNorm2d_
});






/**
 * Batch normalization, strictly for 3D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $242f86ebeb9f9472$var$batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 3, ()=>`Error in batchNorm3D: x must be rank 3 but got rank ` + `${$x.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($mean.rank === 3 || $mean.rank === 1, ()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($variance.rank === 3 || $variance.rank === 1, ()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $9e4a6174e3538e7d$export$a7a9523472993e97($scale.rank === 3 || $scale.rank === 1, ()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $9e4a6174e3538e7d$export$a7a9523472993e97($offset.rank === 3 || $offset.rank === 1, ()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $222bc9281dad73cf$export$8ea8088e6d0cdd02)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $242f86ebeb9f9472$export$76211212fb57f1fa = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    batchNorm3d_: $242f86ebeb9f9472$var$batchNorm3d_
});






/**
 * Batch normalization, strictly for 4D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $0902e4cfc4df4955$var$batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 4, ()=>`Error in batchNorm4D: x must be rank 4 but got rank ` + `${$x.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($mean.rank === 4 || $mean.rank === 1, ()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($variance.rank === 4 || $variance.rank === 1, ()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $9e4a6174e3538e7d$export$a7a9523472993e97($scale.rank === 4 || $scale.rank === 1, ()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $9e4a6174e3538e7d$export$a7a9523472993e97($offset.rank === 4 || $offset.rank === 1, ()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $222bc9281dad73cf$export$8ea8088e6d0cdd02)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $0902e4cfc4df4955$export$4573a348ef14e569 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    batchNorm4d_: $0902e4cfc4df4955$var$batchNorm4d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $6dec9946bca0316c$var$bincount_(x, weights, size) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'bincount');
    const $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'bincount');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.dtype === 'int32', ()=>`Error in bincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($weights.size === $x.size || $weights.size === 0, ()=>`Error in bincount: weights must have the same size as input or` + `0-length, but got input shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$45dfbbff595c32aa), inputs, attrs);
}
const $6dec9946bca0316c$export$7e474bab088ed182 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    bincount_: $6dec9946bca0316c$var$bincount_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Bitwise `AND` operation for input tensors.
 *
 * Given two input tensors, returns a new tensor
 * with the `AND` calculated values.
 *
 * The method supports int32 values
 *
 *
 * ```js
 * const x = tf.tensor1d([0, 5, 3, 14], 'int32');
 * const y = tf.tensor1d([5, 0, 7, 11], 'int32');
 * tf.bitwiseAnd(x, y).print();
 * ```
 *
 * @param x The input tensor to be calculated.
 * @param y The input tensor to be calculated.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $c76d7b3a95d697d0$var$bitwiseAnd_(x, y) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'bitwiseAnd');
    const $y = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(y, 'y', 'bitwiseAnd');
    if (!(0, $9e4a6174e3538e7d$export$234180f8206db11b)($x.shape, $y.shape)) throw new Error(`BitwiseAnd: Tensors must have the same shape. x: ${$x.shape}, y: ${$y.shape}`);
    if ($x.dtype !== 'int32' || $y.dtype !== 'int32') throw new Error(`BitwiseAnd: Only supports 'int32' values in tensor, found type of x: ${$x.dtype} and type of y: ${$y.dtype}`);
    const inputs = {
        a: $x,
        b: $y
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$a9e259e32a62221f), inputs);
}
const $c76d7b3a95d697d0$export$84529b0ad3b42cd1 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    bitwiseAnd_: $c76d7b3a95d697d0$var$bitwiseAnd_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Return the shape of s0 op s1 with broadcast.
 *
 * compute r0, the broadcasted shape as a tensor.
 * s0, s1 and r0 are all integer vectors.
 *
 * This function returns the shape of the result of an operation between
 * two tensors of size s0 and s1 performed with broadcast.
 *
 * @param s0 A tensor representing a shape
 * @param s1 A tensor representing a shape
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $d818f965eda43343$var$broadcastArgs_(s0, s1) {
    const shape1Input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(s0, 's0', 'broadcastArgs', 'int32');
    const shape2Input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(s1, 's1', 'broadcastArgs', 'int32');
    if (shape1Input.rank !== 1) throw new Error('broadcastArgs(): first input must be a vector (rank=1). ' + `Has rank ${shape1Input.rank}`);
    if (shape2Input.rank !== 1) throw new Error('broadcastArgs(): second input must be a vector (rank=1). ' + `Has rank ${shape2Input.rank}`);
    const inputs = {
        s0: shape1Input,
        s1: shape2Input
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$32877b1d6d497805), inputs);
}
const $d818f965eda43343$export$d226d344aedce941 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    broadcastArgs_: $d818f965eda43343$var$broadcastArgs_
});





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes ceiling of input `tf.Tensor` element-wise: `ceil(x)`
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.ceil().print();  // or tf.ceil(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b0c5ba6a70687623$var$ceil_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'ceil', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d4a1bccfd52ebd3), inputs);
}
const $b0c5ba6a70687623$export$803ce6b71a0a94b2 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    ceil_: $b0c5ba6a70687623$var$ceil_
});








/**
 * Concatenates a list of`tf.Tensor1D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(3) = |r1, g1, b1|
 * B: shape(2) = |r2, g2|
 * C = tf.concat1d([A, B]) == |r1, g1, b1, r2, g2|
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @return The concatenated array.
 */ function $60a674b9995827dc$var$concat1d_(tensors) {
    return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(tensors, 0 /* axis */ );
}
const $60a674b9995827dc$export$1e0bfb2ad280a475 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    concat1d_: $60a674b9995827dc$var$concat1d_
});




/**
 * Concatenates a list of`tf.Tensor2D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *
 * B: shape(2, 3) = | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * C = tf.concat2d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *                  | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * if axis = 1:
 * C = shape(2, 6) = | r1, g1, b1, r3, g3, b3 |
 *                   | r2, g2, b2, r4, g4, b4 |
 *
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concatenate along.
 * @return The concatenated array.
 */ function $53e99ac0d35f46a3$var$concat2d_(tensors, axis) {
    return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(tensors, axis);
}
const $53e99ac0d35f46a3$export$ba044983349051fd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    concat2d_: $53e99ac0d35f46a3$var$concat2d_
});




/**
 * Concatenates a list of `tf.Tensor3D`s along an axis.
 * See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *
 * B: shape(2, 1, 3) = | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * C = tf.concat3d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *                     | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * if axis = 1:
 * C: shape(2, 2, 3) = | r1, g1, b1, r3, g3, b3 |
 *                     | r2, g2, b2, r4, g4, b4 |
 *
 * if axis = 2:
 * C = shape(2, 1, 6) = | r1, g1, b1, r3, g3, b3 |
 *                      | r2, g2, b2, r4, g4, b4 |
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $7c41a333eefef52a$var$concat3d_(tensors, axis) {
    return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(tensors, axis);
}
const $7c41a333eefef52a$export$23e0f187dd67babf = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    concat3d_: $7c41a333eefef52a$var$concat3d_
});




/**
 * Concatenates a list of `tf.Tensor4D`s along an axis.
 * See `concat` for details.
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $eb71a111a6055dca$var$concat4d_(tensors, axis) {
    return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(tensors, axis);
}
const $eb71a111a6055dca$export$731e01cced6c0a23 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    concat4d_: $eb71a111a6055dca$var$concat4d_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes a 2D convolution over the input x.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $f6443e17dde6414c$var$conv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $f9c374363849dff2$export$1b3400c26a44af8('conv2d', pad, dimRoundingMode);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $9e4a6174e3538e7d$export$a7a9523472993e97(inDepth === $filter.shape[2], ()=>`Error in conv2d: depth of input (${inDepth}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$6f24ba18d950c7e3(dilations), ()=>'Error in conv2D: Dilated rates should be larger than 0.');
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$6f24ba18d950c7e3(strides), ()=>'Error in conv2D: Strides should be larger than 0.');
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$57742e605d475795), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $f6443e17dde6414c$export$188f9215482e3db8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv2d_: $f6443e17dde6414c$var$conv2d_
});





/**
 * Computes a 1D convolution over the input x.
 *
 * @param x The input tensor, of rank 3 or rank 2, of shape
 *     `[batch, width, inChannels]`. If rank 2, batch of 1 is assumed.
 * @param filter The filter, rank 3, of shape
 *     `[filterWidth, inDepth, outDepth]`.
 * @param stride The number of entries by which the filter is moved right at
 *     each step.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from "NWC", "NCW". Defaults to "NWC",
 *     the data is stored in the order of [batch, in_width, in_channels]. Only
 *     "NWC" is currently supported.
 * @param dilation The dilation rate in which we sample input values in
 *     atrous convolution. Defaults to `1`. If it is greater than 1, then
 *     stride must be `1`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $514edc7e5d8da1cf$var$conv1d_(x, filter, stride, pad, dataFormat = 'NWC', dilation = 1, dimRoundingMode) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'conv1d');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'conv1d');
    let x3D = $x;
    let reshapedTo3D = false;
    if ($x.rank === 2) {
        reshapedTo3D = true;
        x3D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x3D.rank === 3, ()=>`Error in conv1d: input must be rank 3, but got rank ${x3D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 3, ()=>`Error in conv1d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $f9c374363849dff2$export$1b3400c26a44af8('conv1d', pad, dimRoundingMode);
    $9e4a6174e3538e7d$export$a7a9523472993e97(x3D.shape[2] === $filter.shape[1], ()=>`Error in conv1d: depth of input (${x3D.shape[2]}) must match ` + `input depth for filter ${$filter.shape[1]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(stride, dilation), ()=>'Error in conv1D: Either stride or dilation must be 1. ' + `Got stride ${stride} and dilation '${dilation}'`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$6f24ba18d950c7e3(dilation), ()=>'Error in conv1D: Dilated rates should be larger than 0.');
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$6f24ba18d950c7e3(stride), ()=>'Error in conv1D: Stride should be larger than 0.');
    $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NWC', ()=>`Error in conv1d: got dataFormat of ${dataFormat} but only NWC is currently supported.`);
    const filter4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($filter, [
        1,
        $filter.shape[0],
        $filter.shape[1],
        $filter.shape[2]
    ]);
    const input4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x3D, [
        x3D.shape[0],
        1,
        x3D.shape[1],
        x3D.shape[2]
    ]);
    const strides = [
        1,
        stride
    ];
    const dilations = [
        1,
        dilation
    ];
    const conv2dDataFormat = 'NHWC';
    const res = (0, $f6443e17dde6414c$export$188f9215482e3db8)(input4D, filter4D, strides, pad, conv2dDataFormat, dilations, dimRoundingMode);
    if (reshapedTo3D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[2],
        res.shape[3]
    ]);
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[0],
        res.shape[2],
        res.shape[3]
    ]);
}
const $514edc7e5d8da1cf$export$d8aa844fa36b350e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv1d_: $514edc7e5d8da1cf$var$conv1d_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the derivative of the input of a 2D convolution.
 *
 * @param xShape The shape of the input: [batch, height, width, inDepth].
 * If length of 3, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 4 or rank 3 of shape
 *   `[batch, outHeight, outWidth, outDepth]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $fb5a8be2da90b3a1$var$conv2DBackpropInput_(xShape, dy, filter, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    $9e4a6174e3538e7d$export$a7a9523472993e97(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape4D = xShape;
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
        xShape4D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2]
        ];
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(xShape4D.length === 4, ()=>`Error in conv2dDerInput: inShape must be length 4, but got length ` + `${xShape4D.length}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dy4D.rank === 4, ()=>`Error in conv2dDerInput: dy must be rank 4, but got ` + `rank ${dy4D.rank}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(filter.rank === 4, ()=>`Error in conv2dDerInput: filter must be rank 4, but got ` + `rank ${filter.rank}`);
    const inDepth = dataFormat === 'NHWC' ? xShape4D[3] : xShape4D[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $9e4a6174e3538e7d$export$a7a9523472993e97(inDepth === filter.shape[2], ()=>`Error in conv2dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[2]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(outDepth === filter.shape[3], ()=>`Error in conv2dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[3]}.`);
    $f9c374363849dff2$export$1b3400c26a44af8('conv2dDerInput', pad, dimRoundingMode);
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        inputShape: xShape4D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$e26961e8ed0eb404), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $fb5a8be2da90b3a1$export$633310eed0c26e72 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv2DBackpropInput_: $fb5a8be2da90b3a1$var$conv2DBackpropInput_
});



/**
 * Computes the transposed 2D convolution of an image, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 4 or rank 3, of shape
 *   `[batch, height, width, inDepth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 4 or rank 3:
 *     `[batch, height, width, outDepth]`. If rank 3, batch of 1 is assumed.
 * @param strides The strides of the original convolution:
 *     `[strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $9521e6c8393e9aaa$var$conv2dTranspose_(x, filter, outputShape, strides, pad, dimRoundingMode) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'conv2dTranspose');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'conv2dTranspose');
    return (0, $fb5a8be2da90b3a1$export$633310eed0c26e72)(outputShape, $x, $filter, strides, pad, 'NHWC', dimRoundingMode);
}
const $9521e6c8393e9aaa$export$d5e924cbc07fb966 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv2dTranspose_: $9521e6c8393e9aaa$var$conv2dTranspose_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes a 3D convolution over the input x.
 *
 * @param x The input tensor, of rank 5 or rank 4, of shape
 *     `[batch, depth, height, width, channels]`. If rank 4,
 * batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inChannels, outChannels]`.
 *      inChannels must match between input and filter.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationDepth, dilationHeight,
 *     dilationWidth]` in which we sample input values across the height
 *     and width dimensions in atrous convolution. Defaults to `[1, 1, 1]`.
 *     If `dilations` is a single number, then
 *     `dilationDepth == dilationHeight == dilationWidth`. If it is greater
 *     than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $facc3bce4b597db3$var$conv3d_(x, filter, strides, pad, dataFormat = 'NDHWC', dilations = [
    1,
    1,
    1
]) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'conv3d');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'conv3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x5D.rank === 5, ()=>`Error in conv3d: input must be rank 5, but got rank ${x5D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 5, ()=>`Error in conv3d: filter must be rank 5, but got rank ` + `${$filter.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(x5D.shape[4] === $filter.shape[3], ()=>`Error in conv3d: depth of input (${x5D.shape[4]}) must match ` + `input depth for filter ${$filter.shape[3]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97((0, $f9c374363849dff2$export$1e13dbff91e2f5ca)(strides, dilations), ()=>'Error in conv3D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NDHWC', ()=>`Error in conv3d: got dataFormat of ${dataFormat} but only NDHWC is currently supported.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97((0, $f9c374363849dff2$export$6f24ba18d950c7e3)(dilations), ()=>'Error in conv3D: Dilated rates should be larger than 0.');
    $9e4a6174e3538e7d$export$a7a9523472993e97((0, $f9c374363849dff2$export$6f24ba18d950c7e3)(strides), ()=>'Error in conv3D: Strides should be larger than 0.');
    const inputs = {
        x: x5D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9d3874201dd21933), inputs, attrs);
    if (reshapedTo5D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $facc3bce4b597db3$export$c476b02bcf7b2def = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv3d_: $facc3bce4b597db3$var$conv3d_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the derivative of the input of a 3D convolution.
 *
 * @param xShape The shape of the input: [batch, depth, height, width,
 * in_channels]. If length of 4, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 5 or rank 4 of shape
 *   `[batch, outDepth, outHeight, outWidth, in_channels]`.
 * If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 */ function $6695592933893206$var$conv3DBackpropInput_(xShape, dy, filter, strides, pad) {
    $9e4a6174e3538e7d$export$a7a9523472993e97(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape5D = xShape;
    let dy5D = dy;
    let reshapedTo5D = false;
    if (dy.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2],
            dy.shape[3]
        ]);
        xShape5D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2],
            xShape[3]
        ];
    }
    const inDepth = xShape5D[4];
    const outDepth = dy5D.shape[4];
    $9e4a6174e3538e7d$export$a7a9523472993e97(xShape5D.length === 5, ()=>`Error in conv3dDerInput: inShape must be length 5, but got length ` + `${xShape5D.length}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dy5D.rank === 5, ()=>`Error in conv3dDerInput: dy must be rank 5, but got ` + `rank ${dy5D.rank}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(filter.rank === 5, ()=>`Error in conv3dDerInput: filter must be rank 5, but got ` + `rank ${filter.rank}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(inDepth === filter.shape[3], ()=>`Error in conv3dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[3]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(outDepth === filter.shape[4], ()=>`Error in conv3dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[4]}.`);
    const inputs = {
        dy: dy5D,
        filter: filter
    };
    const attrs = {
        pad: pad,
        strides: strides,
        inputShape: xShape5D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$a54f552d6d7d521f), inputs, attrs);
    if (reshapedTo5D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $6695592933893206$export$deb6d1ca1fa2977b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv3DBackpropInput_: $6695592933893206$var$conv3DBackpropInput_
});



/**
 * Computes the transposed 3D convolution of a volume, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 5 or rank 4, of shape
 *   `[batch, depth, height, width, inDepth]`. If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[depth, filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 5 or rank 4:
 *     `[batch, depth, height, width, outDepth]`. If rank 3, batch of 1 is
 *    assumed.
 * @param strides The strides of the original convolution:
 *     `[strideDepth, strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $9e27ff6ae2e73223$var$conv3dTranspose_(x, filter, outputShape, strides, pad) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'conv3dTranspose');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'conv3dTranspose');
    return (0, $6695592933893206$export$deb6d1ca1fa2977b)(outputShape, $x, $filter, strides, pad);
}
const $9e27ff6ae2e73223$export$5eac62031b3f449f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv3dTranspose_: $9e27ff6ae2e73223$var$conv3dTranspose_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes cos of the input `tf.Tensor` element-wise: `cos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.cos().print();  // or tf.cos(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $1d4f28947ee6188f$var$cos_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'cos', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ddfd0a983d257666), inputs);
}
const $1d4f28947ee6188f$export$50d414a77b60d802 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cos_: $1d4f28947ee6188f$var$cos_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes hyperbolic cos of the input `tf.Tensor` element-wise: `cosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.cosh().print();  // or tf.cosh(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $22f45c18cccd8888$var$cosh_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'cosh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5e311a1c57b0d27c), inputs);
}
const $22f45c18cccd8888$export$2e2fd1ad24e4d350 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cosh_: $22f45c18cccd8888$var$cosh_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the cumulative product of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumprod().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumprod().print();
 * ```
 *
 * @param x The input tensor to cumulatively multiply.
 * @param axis The axis along which to multiply. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative product. Optional.
 *     Defaults to false. If set to true then the product of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to multiply in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $04796872a0f4a696$var$cumprod_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'cumprod');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$e581acc6014c47a), inputs, attrs);
}
const $04796872a0f4a696$export$dc7513e907e94b8d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cumprod_: $04796872a0f4a696$var$cumprod_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the cumulative sum of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumsum().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumsum().print();
 * ```
 *
 * @param x The input tensor to be summed.
 * @param axis The axis along which to sum. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative sum. Optional.
 *     Defaults to false. If set to true then the sum of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to sum in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $1be40d302ebd83bb$var$cumsum_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'cumsum');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$706617d894ad63da), inputs, attrs);
}
const $1be40d302ebd83bb$export$71990b1e1c4912fe = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cumsum_: $1be40d302ebd83bb$var$cumsum_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1 or rank 2.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 * @param binaryOutput Optional. Whether the kernel should count the appearance
 *     or number of occurrences. Defaults to False.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $b350807f1cdf8378$var$denseBincount_(x, weights, size, binaryOutput = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'denseBincount');
    const $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'denseBincount');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.dtype === 'int32', ()=>`Error in denseBincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank <= 2, ()=>`Error in denseBincount: input must be at most rank 2, but got ` + `rank ${$x.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($weights.size === $x.size || $weights.size === 0, ()=>`Error in denseBincount: weights must have the same shape as x or ` + `0-length, but got x shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size,
        binaryOutput: binaryOutput
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5bab6834954299c5), inputs, attrs);
}
const $b350807f1cdf8378$export$436934e6cf1946f1 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    denseBincount_: $b350807f1cdf8378$var$denseBincount_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Rearranges data from depth into blocks of spatial data. More specifically,
 * this op outputs a copy of the input tensor where values from the `depth`
 * dimension are moved in spatial blocks to the `height` and `width` dimensions.
 * The attr `blockSize` indicates the input block size and how the data is
 * moved.
 *
 *  - Chunks of data of size `blockSize * blockSize` from depth are rearranged
 * into non-overlapping blocks of size `blockSize x blockSize`
 *
 *  - The width the output tensor is `inputWidth * blockSize`, whereas the
 * height is `inputHeight * blockSize`
 *
 *  - The Y, X coordinates within each block of the output image are determined
 * by the high order component of the input channel index
 *
 *  - The depth of the input tensor must be divisible by `blockSize *
 * blockSize`
 *
 * The `dataFormat` attr specifies the layout of the input and output tensors
 * with the following options: "NHWC": [ `batch, height, width, channels` ]
 * "NCHW": [ `batch, channels, height, width` ]
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 1, 1, 4]);
 * const blockSize = 2;
 * const dataFormat = "NHWC";
 *
 * tf.depthToSpace(x, blockSize, dataFormat).print();
 * ```
 *
 * @param x The input tensor of rank 4
 * @param blockSIze  An `int` that is `>= 2`. The size of the spatial block
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to "NHWC"
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $b83b95afe01d99d8$var$depthToSpace_(x, blockSize, dataFormat = 'NHWC') {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'depthToSpace', 'float32');
    const inputHeight = dataFormat === 'NHWC' ? $x.shape[1] : $x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? $x.shape[2] : $x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? $x.shape[3] : $x.shape[1];
    $9e4a6174e3538e7d$export$a7a9523472993e97(blockSize > 1, ()=>`blockSize should be > 1 for depthToSpace, but was: ${blockSize}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(inputHeight * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputHeight} and ${blockSize}  for depthToSpace with input shape
    ${$x.shape}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(inputWidth * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputWidth} and ${blockSize} for depthToSpace with input shape
        ${$x.shape}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(inputDepth % (blockSize * blockSize) === 0, ()=>`Dimension size must be evenly divisible by ${blockSize * blockSize} but is ${inputDepth} for depthToSpace with input shape ${$x.shape}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockSize: blockSize,
        dataFormat: dataFormat
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$fb0ee52d0cd6f233), inputs, attrs);
}
const $b83b95afe01d99d8$export$3b50daec0f185f12 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    depthToSpace_: $b83b95afe01d99d8$var$depthToSpace_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Depthwise 2D convolution.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $e24ad3a56ebef85b$var$depthwiseConv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    const inChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $9e4a6174e3538e7d$export$a7a9523472993e97(inChannels === $filter.shape[2], ()=>`Error in depthwiseConv2d: number of input channels ` + `(${inChannels}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    $f9c374363849dff2$export$1b3400c26a44af8('depthwiseConv2d', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7c0fc590ff9e156f), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $e24ad3a56ebef85b$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    depthwiseConv2d_: $e24ad3a56ebef85b$var$depthwiseConv2d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns a diagonal tensor with given diagonal values.
 *
 * Given a diagonal, this operation returns a tensor with the diagonal and
 * everything else padded with zeros.
 *
 * Assume the input has dimensions `[D1,..., Dk]`, then the output is a tensor
 * of rank 2k with dimensions `[D1,..., Dk, D1,..., Dk]`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * tf.diag(x).print()
 * ```
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [4, 2])
 *
 * tf.diag(x).print()
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $d1e4fa9967900292$var$diag_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'diag');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ca73a25315ddeb7f), inputs);
}
const $d1e4fa9967900292$export$c042e7c2f59bc046 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    diag_: $d1e4fa9967900292$var$diag_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the grayscale dilation over the input `x`.
 *
 * @param x The input tensor, rank 3 or rank 4 of shape
 *     `[batch, height, width, depth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter tensor, rank 3, of shape
 *     `[filterHeight, filterWidth, depth]`.
 * @param strides The strides of the sliding window for each dimension of the
 *     input tensor: `[strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat Specify the data format of the input and output data.
 *      Defaults to 'NHWC'. Only 'NHWC' is currently supported. With the
 *      default format "NHWC", the data is stored in the order of: [batch,
 *      height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     for atrous morphological dilation. Defaults to `[1, 1]`. If `dilations`
 *     is a single number, then `dilationHeight == dilationWidth`. If it is
 *     greater than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $a9e9382c4d6ab295$var$dilation2d_(x, filter, strides, pad, dilations = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'dilation2d');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'dilation2d');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 3 || $x.rank === 4, ()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ` + `${$x.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 3, ()=>`Error in dilation2d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NHWC', ()=>`Error in dilation2d: Only NHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
        reshapedTo4D = true;
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.shape[3] === $filter.shape[2], ()=>`Error in dilation2d:  input and filter must have the same depth: ${x4D.shape[3]} vs ${$filter.shape[2]}`);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$dbbb7830c6497701), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $a9e9382c4d6ab295$export$d9b8f675671875b9 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    dilation2d_: $a9e9382c4d6ab295$var$dilation2d_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a == b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.equal(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $c70ba06b415a1f15$var$equal_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'equal', 'string_or_numeric');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'equal', 'string_or_numeric');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8dcf9f58ce5cdfc), inputs);
}
const $c70ba06b415a1f15$export$411ce8e5a71e3069 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    equal_: $c70ba06b415a1f15$var$equal_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the elements, either `a` or `b` depending on the `condition`.
 *
 * If the condition is true, select from `a`, otherwise select from `b`.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const a = tf.tensor1d([1 , 2, 3]);
 * const b = tf.tensor1d([-1, -2, -3]);
 *
 * a.where(cond, b).print();
 * ```
 *
 * @param condition The input condition. Must be of dtype bool.
 * @param a If `condition` is rank 1, `a` may have a higher rank but
 *     its first dimension must match the size of `condition`.
 * @param b A tensor with the same dtype as `a` and with shape that is
 *     compatible with `a`.
 * @return A tensor with same dtype as `a` and `b`, and shape that is
 *     broadcastable from `a` and `b`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5ca12d297e319cbc$var$where_(condition, a, b) {
    const $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'where');
    const $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'where');
    const $condition = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(condition, 'condition', 'where', 'bool');
    // TODO: move this logic to forward function when the broadcastTo op is
    // implemented in WASM.
    // Find the broadcastable shape for $condition, $a, and $b.
    const broadcastShape = (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)((0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($condition.shape, $a.shape), $b.shape);
    const $broadcastedCondition = (0, $8660a1872a3f456e$export$ec9086aff2624eab)($condition, broadcastShape);
    const $broadcastedA = (0, $8660a1872a3f456e$export$ec9086aff2624eab)($a, broadcastShape);
    const $broadcastedB = (0, $8660a1872a3f456e$export$ec9086aff2624eab)($b, broadcastShape);
    const inputs = {
        condition: $broadcastedCondition,
        t: $broadcastedA,
        e: $broadcastedB
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ef9b1a59e592288f), inputs);
}
const $5ca12d297e319cbc$export$9c59b80dda569a6e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    where_: $5ca12d297e319cbc$var$where_
});



/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting. Return 0
 * if denominator is 0.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 * const c = tf.tensor1d([0, 0, 0, 0]);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 * const c = tf.scalar(0);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $3d11f29e3a06b28a$var$divNoNan_(a, b) {
    // TODO: Make this into its own kernel.
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'div');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'div');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const divResult = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)($a, $b);
    const zeros = (0, $a5cb5e205b190f05$export$cb1f824e7733584d)(divResult);
    const bEqualsZero = (0, $c70ba06b415a1f15$export$411ce8e5a71e3069)($b, zeros);
    return (0, $5ca12d297e319cbc$export$9c59b80dda569a6e)(bEqualsZero, zeros, divResult);
}
const $3d11f29e3a06b28a$export$9c5df3eb9e56f19e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    divNoNan_: $3d11f29e3a06b28a$var$divNoNan_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the dot product of two matrices and/or vectors, `t1` and `t2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor2d([[1, 2], [3, 4]]);
 * const c = tf.tensor2d([[1, 2, 3], [4, 5, 6]]);
 *
 * a.dot(b).print();  // or tf.dot(a, b)
 * b.dot(a).print();
 * b.dot(c).print();
 * ```
 * @param t1 The first tensor in the dot operation.
 * @param t2 The second tensor in the dot operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $3804ba7949be197b$var$dot_(t1, t2) {
    const $t1 = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(t1, 't1', 'dot');
    const $t2 = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(t2, 't2', 'dot');
    $9e4a6174e3538e7d$export$a7a9523472993e97(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), ()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ` + `${$t1.rank} and ${$t2.rank}.`);
    const t1Inner = $t1.rank === 1 ? $t1.size : $t1.shape[1];
    const t2Inner = $t2.rank === 1 ? $t2.size : $t2.shape[0];
    $9e4a6174e3538e7d$export$a7a9523472993e97(t1Inner === t2Inner, ()=>`Error in dot: inner dimensions of inputs must match, but got ` + `${t1Inner} and ${t2Inner}.`);
    if ($t1.rank === 1 && $t2.rank === 1) {
        const t12D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $8a13d3789789217b$export$6706882a873e9a8f)(t12D, t22D);
        return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(t1t2, []);
    } else if ($t1.rank === 1 && $t2.rank === 2) {
        const t12D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $8a13d3789789217b$export$6706882a873e9a8f)(t12D, t22D);
        return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(t1t2, [
            t1t2.size
        ]);
    } else if ($t1.rank === 2 && $t2.rank === 1) {
        const t22D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $8a13d3789789217b$export$6706882a873e9a8f)($t1, t22D);
        return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(t1t2, [
            t1t2.size
        ]);
    } else {
        const t22D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $8a13d3789789217b$export$6706882a873e9a8f)($t1, t22D);
        return t1t2;
    }
}
const $3804ba7949be197b$export$94132a0e348806d4 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    dot_: $3804ba7949be197b$var$dot_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $86c3e2507ff73220$export$f6fde01e521435e1(equation, ...tensors) {
    const $tensors = tensors.map((t, i)=>(0, $539f0ce07f2139cd$export$ede379c4c939d71a)(t, `tensors${i}`, 'einsum'));
    const attrs = {
        equation: equation
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$2541d8be32f3c641), $tensors, attrs);
}
const $86c3e2507ff73220$export$27265e7daac5c403 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    einsum_: $86c3e2507ff73220$export$f6fde01e521435e1
});



/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Checks the input tensor mathes the given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * The method supports the null value in tensor. It will still check the shapes,
 * and null is a placeholder.
 *
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const y = tf.tensor1d([1, null, 3, 4]);
 * const z = tf.tensor2d([1, 2, 3, 4], [2,2]);
 * tf.ensureShape(x, [4]).print();
 * tf.ensureShape(y, [4]).print();
 * tf.ensureShape(z, [null, 2]).print();
 * ```
 *
 * @param x The input tensor to be ensured.
 * @param shape A TensorShape representing the shape of this tensor, an array
 *     or null.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $fdd727f9f1f5c03c$var$ensureShape_(x, shape) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'ensureShape', 'string_or_numeric');
    if (!(0, $9e4a6174e3538e7d$export$9efb31c074e61de7)($x.shape, shape)) throw new Error(`EnsureShape: Shape of tensor ${$x.shape} is not compatible with expected shape ${shape}`);
    return x;
}
const $fdd727f9f1f5c03c$export$6699c34d603c5978 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    ensureShape_: $fdd727f9f1f5c03c$var$ensureShape_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes Gauss error function of the input `tf.Tensor` element-wise:
 * `erf(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.erf().print(); // or tf.erf(x);
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $812d049313eea70b$var$erf_(x) {
    let $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'erf');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.dtype === 'int32' || $x.dtype === 'float32', ()=>'Input dtype must be `int32` or `float32`.');
    if ($x.dtype === 'int32') $x = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($x, 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c2ee2551ce71f1d0), inputs);
}
const $812d049313eea70b$export$d3896f355fc09423 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    erf_: $812d049313eea70b$var$erf_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $7220c998b208dd38$exports = {};

$parcel$export($7220c998b208dd38$exports, "norm", () => $7220c998b208dd38$export$1991ecd29cc92c6b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the maximum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.max().print();  // or tf.max(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.max(axis).print();  // or tf.max(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $a7ac59438638606f$var$max_(x, axis = null, keepDims = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'max');
    const inputs = {
        x: $x
    };
    const attrs = {
        reductionIndices: axis,
        keepDims: keepDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d36c09e5d02927e7), inputs, attrs);
}
const $a7ac59438638606f$export$8960430cfd85939f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    max_: $a7ac59438638606f$var$max_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the minimum value from the input.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axes`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axes` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.min().print();  // or tf.min(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.min(axis).print();  // or tf.min(x, axis)
 * ```
 *
 * @param x The input Tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $51299ddc709e72aa$var$min_(x, axis = null, keepDims = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'min');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$dfed19fabc75a31d), inputs, attrs);
}
const $51299ddc709e72aa$export$96ec731ed4dcb222 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    min_: $51299ddc709e72aa$var$min_
});









/**
 * Computes the norm of scalar, vectors, and matrices.
 * This function can compute several different vector norms (the 1-norm, the
 * Euclidean or 2-norm, the inf-norm, and in general the p-norm for p > 0)
 * and matrix norms (Frobenius, 1-norm, and inf-norm).
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.norm().print();  // or tf.norm(x)
 * ```
 *
 * @param x The input array.
 * @param ord Optional. Order of the norm. Supported norm types are
 * following:
 *
 *  | ord        | norm for matrices         | norm for vectors
 *  |------------|---------------------------|---------------------
 *  |'euclidean' |Frobenius norm             |2-norm
 *  |'fro'       |Frobenius norm	           |
 *  |Infinity    |max(sum(abs(x), axis=1))   |max(abs(x))
 *  |-Infinity   |min(sum(abs(x), axis=1))   |min(abs(x))
 *  |1           |max(sum(abs(x), axis=0))   |sum(abs(x))
 *  |2           |                           |sum(abs(x)^2)^(1/2)
 *
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. norm(x, ord) is equivalent
 * to norm(x.reshape([-1]), ord). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $7220c998b208dd38$var$norm_(x, ord = 'euclidean', axis = null, keepDims = false) {
    x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'norm');
    const norm = $7220c998b208dd38$var$normImpl(x, ord, axis);
    let keepDimsShape = norm.shape;
    if (keepDims) {
        const axes = (0, $9e4a6174e3538e7d$export$72b84eb9fe1f482)(axis, x.shape);
        keepDimsShape = $fab93e7418eff1cc$export$e35db9afe008d7e3(norm.shape, axes);
    }
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(norm, keepDimsShape);
}
function $7220c998b208dd38$var$normImpl(x, p, axis = null) {
    if (x.rank === 0) return (0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x);
    // consider vector when no axis is specified
    if (x.rank !== 1 && axis === null) return $7220c998b208dd38$var$normImpl((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
        -1
    ]), p, axis);
    // vector
    if (x.rank === 1 || typeof axis === 'number' || Array.isArray(axis) && axis.length === 1) {
        if (p === 1) return (0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), axis);
        if (p === Infinity) return (0, $a7ac59438638606f$export$8960430cfd85939f)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), axis);
        if (p === -Infinity) return (0, $51299ddc709e72aa$export$96ec731ed4dcb222)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), axis);
        if (p === 'euclidean' || p === 2) // norm(x, 2) = sum(abs(xi) ^ 2) ^ 1/2
        return (0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $dfeb0ec8a84c566a$export$9c297f60e22e3389)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(2, 'int32')), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    // matrix (assumption axis[0] < axis[1])
    if (Array.isArray(axis) && axis.length === 2) {
        if (p === 1) return (0, $a7ac59438638606f$export$8960430cfd85939f)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), axis[0]), axis[1] - 1);
        if (p === Infinity) return (0, $a7ac59438638606f$export$8960430cfd85939f)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), axis[1]), axis[0]);
        if (p === -Infinity) return (0, $51299ddc709e72aa$export$96ec731ed4dcb222)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)(x), axis[1]), axis[0]);
        if (p === 'fro' || p === 'euclidean') // norm(x) = sqrt(sum(pow(x, 2)))
        return (0, $829be0ea336e2128$export$eba8049fb5020b81)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(x), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    throw new Error(`Error in norm: invalid axis: ${axis}`);
}
const $7220c998b208dd38$export$1991ecd29cc92c6b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    norm_: $7220c998b208dd38$var$norm_
});



/**
 * Computes the Euclidean norm of scalar, vectors, and matrices.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.euclideanNorm().print();  // or tf.euclideanNorm(x)
 * ```
 *
 * @param x The input array.
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. euclideanNorm(x) is equivalent
 * to euclideanNorm(x.reshape([-1])). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $6bae998afca941ee$var$euclideanNorm_(x, axis = null, keepDims = false) {
    return (0, $7220c998b208dd38$export$1991ecd29cc92c6b)(x, 'euclidean', axis, keepDims);
}
const $6bae998afca941ee$export$38d83b337e7c2edd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    euclideanNorm_: $6bae998afca941ee$var$euclideanNorm_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes exponential of the input `tf.Tensor` minus one element-wise.
 * `e ^ x - 1`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.expm1().print();  // or tf.expm1(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a0e551d3dab48311$var$expm1_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'expm1');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$261f26143a1ff3), inputs);
}
const $a0e551d3dab48311$export$b6c0a80d46d3391d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    expm1_: $a0e551d3dab48311$var$expm1_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Construct a tensor by repeating it the number of times given by reps.
 *
 * This operation creates a new tensor by replicating `input` `reps`
 * times. The output tensor's `i`th dimension has `input.shape[i] *
 * reps[i]` elements, and the values of `input` are replicated
 * `reps[i]` times along the `i`th dimension. For example, tiling
 * `[a, b, c, d]` by `[2]` produces `[a, b, c, d, a, b, c, d]`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 *
 * a.tile([2]).print();    // or tf.tile(a, [2])
 * ```
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.tile([1, 2]).print();  // or tf.tile(a, [1,2])
 * ```
 * @param x The tensor to tile.
 * @param reps Determines the number of replications per dimension.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $e6ca18ccb4a89ccc$var$tile_(x, reps) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'tile', 'string_or_numeric');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === reps.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of reps ${reps}.`);
    const inputs = {
        x: $x
    };
    const attrs = {
        reps: reps
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$235cb65c20ad2b7), inputs, attrs);
}
const $e6ca18ccb4a89ccc$export$3c17558da18e4d75 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    tile_: $e6ca18ccb4a89ccc$var$tile_
});


/**
 * Create an identity matrix.
 *
 * @param numRows Number of rows.
 * @param numColumns Number of columns. Defaults to `numRows`.
 * @param batchShape If provided, will add the batch shape to the beginning
 *   of the shape of the returned `tf.Tensor` by repeating the identity
 *   matrix.
 * @param dtype Data type.
 * @returns Identity matrix of the specified size and data type, possibly
 *   with batch repetition if `batchShape` is specified.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $311a450f987992a1$var$eye_(numRows, numColumns, batchShape, dtype = 'float32') {
    if (numColumns == null) numColumns = numRows;
    const buff = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)([
        numRows,
        numColumns
    ], dtype);
    const n = numRows <= numColumns ? numRows : numColumns;
    for(let i = 0; i < n; ++i)buff.set(1, i, i);
    const out = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(buff.toTensor(), [
        numRows,
        numColumns
    ]);
    if (batchShape == null) return out;
    else {
        if (batchShape.length === 1) return (0, $e6ca18ccb4a89ccc$export$3c17558da18e4d75)((0, $31018343da089cd7$export$d660d8ed21f46635)(out, 0), [
            batchShape[0],
            1,
            1
        ]);
        else if (batchShape.length === 2) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $e6ca18ccb4a89ccc$export$3c17558da18e4d75)((0, $31018343da089cd7$export$d660d8ed21f46635)((0, $31018343da089cd7$export$d660d8ed21f46635)(out, 0), 0), [
            batchShape[0],
            batchShape[1],
            1,
            1
        ]);
        else if (batchShape.length === 3) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $e6ca18ccb4a89ccc$export$3c17558da18e4d75)((0, $31018343da089cd7$export$d660d8ed21f46635)((0, $31018343da089cd7$export$d660d8ed21f46635)((0, $31018343da089cd7$export$d660d8ed21f46635)(out, 0), 0), 0), [
            batchShape[0],
            batchShape[1],
            batchShape[2],
            1,
            1
        ]);
        else throw new Error(`eye() currently supports only 1D and 2D ` + // tslint:disable-next-line:no-any
        `batchShapes, but received ${batchShape.length}D.`);
    }
}
const $311a450f987992a1$export$4e18cf730a59887e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    eye_: $311a450f987992a1$var$eye_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes floor of input `tf.Tensor` element-wise: `floor(x)`.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.floor().print();  // or tf.floor(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $2f0cea174d82bbd9$var$floor_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'floor', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$4880b0ae5643c62b), inputs);
}
const $2f0cea174d82bbd9$export$a3fe094919f356fd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    floor_: $2f0cea174d82bbd9$var$floor_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Gather slices from tensor `x`'s axis `axis` according to `indices`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const indices = tf.tensor1d([1, 3, 3], 'int32');
 *
 * x.gather(indices).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const indices = tf.tensor1d([1, 1, 0], 'int32');
 *
 * x.gather(indices).print();
 * ```
 * @param x The input tensor whose slices are to be gathered.
 * @param indices The indices of the values to extract.
 * @param axis The axis over which to select values. Defaults to 0.
 * @param batchDims Optional. The number of batch dimensions. It must be less
 *     than or equal to rank(indices). Defaults to 0.
 *     The output tensor will have shape of
 *     `x.shape[:axis] + indices.shape[batchDims:] + x.shape[axis + 1:]`
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $81ed3ff29d6a051b$var$gather_(x, indices, axis = 0, batchDims = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'gather');
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'gather', 'int32');
    const inputs = {
        x: $x,
        indices: $indices
    };
    const attrs = {
        axis: axis,
        batchDims: batchDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ccd988942e5c0181), inputs, attrs);
}
const $81ed3ff29d6a051b$export$9e05546f00427e8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    gather_: $81ed3ff29d6a051b$var$gather_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a > b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greater(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $0034e349e70db944$var$greater_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'greater', 'string_or_numeric');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'greater', 'string_or_numeric');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$d0a25eac5ee3f515), inputs);
}
const $0034e349e70db944$export$9dca161faaf6308b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    greater_: $0034e349e70db944$var$greater_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a >= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greaterEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $eceec4f09b66c311$var$greaterEqual_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'greaterEqual', 'string_or_numeric');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'greaterEqual', 'string_or_numeric');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$3b7d21bc9aee0851), inputs);
}
const $eceec4f09b66c311$export$c2fd4164cadc1fa2 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    greaterEqual_: $eceec4f09b66c311$var$greaterEqual_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the imaginary part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the imaginary part of each element in input considered as a complex number.
 * If input is real, a tensor of all zeros is returned.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.imag(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $8374544a706e8d44$var$imag_(input) {
    const $input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(input, 'input', 'imag');
    const inputs = {
        input: $input
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$303b4473993a24f), inputs);
}
const $8374544a706e8d44$export$d78fab5778ab392b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    imag_: $8374544a706e8d44$var$imag_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns which elements of x are finite.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isFinite().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7e98b4b51c263920$var$isFinite_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'isFinite');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b9fcc0946d7d485e), inputs);
}
const $7e98b4b51c263920$export$65f0b13f2f82375a = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    isFinite_: $7e98b4b51c263920$var$isFinite_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns which elements of x are Infinity or -Infinity.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isInf().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5911e516e026fa36$var$isInf_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'isInf');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$74b5a3bc735b152), inputs);
}
const $5911e516e026fa36$export$e5d3415c656f7096 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    isInf_: $5911e516e026fa36$var$isInf_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns which elements of x are NaN.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isNaN().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ba12a83b0cfe3e36$var$isNaN_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'isNaN');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9912dc4fc649dbec), inputs);
}
const $ba12a83b0cfe3e36$export$c9f5652083b8129d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    isNaN_: $ba12a83b0cfe3e36$var$isNaN_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a < b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.less(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d2eb0cc564463c61$var$less_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'less', 'string_or_numeric');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'less', 'string_or_numeric');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$728c50f1c88ac779), inputs);
}
const $d2eb0cc564463c61$export$bb1a638da8ad190f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    less_: $d2eb0cc564463c61$var$less_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a <= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.lessEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $9b3d78d7d568ec20$var$lessEqual_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'lessEqual', 'string_or_numeric');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'lessEqual', 'string_or_numeric');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$84afd0d8f7fb8c5d), inputs);
}
const $9b3d78d7d568ec20$export$c24ad19a692bb92 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    lessEqual_: $9b3d78d7d568ec20$var$lessEqual_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $84e8c3ee1758a842$export$71255ea3f595147c(start, stop, num) {
    if (num <= 0) throw new Error('The number of values should be positive.');
    const attrs = {
        start: start,
        stop: stop,
        num: num
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$34f0ab8eba543ee6), {}, attrs);
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Normalizes the activation of a local neighborhood across or within
 * channels.
 *
 * @param x The input tensor. The 4-D input tensor is treated as a 3-D array
 *     of 1D vectors (along the last dimension), and each vector is
 *     normalized independently.
 * @param depthRadius The number of adjacent channels in the 1D normalization
 *     window.
 * @param bias A constant bias term for the basis.
 * @param alpha A scale factor, usually positive.
 * @param beta An exponent.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $09cec53f2c18e160$var$localResponseNormalization_(x, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'localResponseNormalization');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 4 || $x.rank === 3, ()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${$x.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$357fc28f6427af8b(depthRadius), ()=>`Error in localResponseNormalization: depthRadius must be an ` + `integer but got depthRadius ${depthRadius}.`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    const inputs = {
        x: x4D
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$eb2f713fc3e1ca9a), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    else return res;
}
const $09cec53f2c18e160$export$b6127073705f6321 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    localResponseNormalization_: $09cec53f2c18e160$var$localResponseNormalization_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes natural logarithm of the input `tf.Tensor` element-wise: `ln(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E]);
 *
 * x.log().print();  // or tf.log(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $efc3c6c91f7ffb3e$var$log_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'log', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ce30dbb46644d06c), inputs);
}
const $efc3c6c91f7ffb3e$export$bef1f36f5486a6a3 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    log_: $efc3c6c91f7ffb3e$var$log_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes natural logarithm of the input `tf.Tensor` plus one
 * element-wise: `ln(1 + x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E - 1]);
 *
 * x.log1p().print();  // or tf.log1p(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $943a5cd04e004157$var$log1p_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'log1p');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$70f05bf9ddcfca68), inputs);
}
const $943a5cd04e004157$export$144dcf16adfb9698 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    log1p_: $943a5cd04e004157$var$log1p_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes `-1 * x` element-wise.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, -2, 0], [2, 2]);
 *
 * x.neg().print();  // or tf.neg(x)
 * ```
 *
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5e6af6e46b1575dd$var$neg_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'neg');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c07c549000872073), inputs);
}
const $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    neg_: $5e6af6e46b1575dd$var$neg_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes softplus of the input `tf.Tensor` element-wise: `log(exp(x) + 1)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.softplus().print();  // or tf.softplus(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $c6f989486c1f1c8b$var$softplus_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'softplus');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c5af433747f1fd0a), inputs);
}
const $c6f989486c1f1c8b$export$76aa560a8c2b0055 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    softplus_: $c6f989486c1f1c8b$var$softplus_
});


/**
 * Computes log sigmoid of the input `tf.Tensor` element-wise:
 * `logSigmoid(x)`. For numerical stability, we use `-tf.softplus(-x)`.
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.logSigmoid().print();  // or tf.logSigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ccada41132b66a52$var$logSigmoid_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'logSigmoid');
    // Use a custom gradient to maintain previous implementation.
    // There is no LogSigmoid kernel in TF so we can't use engine.runKernel
    // directly
    const customOp = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((x)=>{
        // TODO(yassogba) we can remove the chained softplus call here only
        // after backends have modualrized softplus at which point we can call
        // engine runKernel(..., Sotfplus, ...) directly.
        const value = (0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)((0, $c6f989486c1f1c8b$export$76aa560a8c2b0055)((0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)(x)));
        const gradFunc = (dy)=>{
            const derX = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(dy, (0, $4e7e1888b524d401$export$3b295495ca3cad7c)((0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)(x)));
            return derX;
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($x);
}
const $ccada41132b66a52$export$9e0b8feed033df47 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logSigmoid_: $ccada41132b66a52$var$logSigmoid_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * Computes the log softmax.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param axis The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $d2d9b5a54ac4b8bb$var$logSoftmax_(logits, axis = -1) {
    const $logits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(logits, 'logits', 'logSoftmax');
    if (axis === -1) axis = $logits.rank - 1;
    if (axis !== $logits.rank - 1) throw Error('Log Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and axis was ${axis}`);
    // const forward: ForwardFunc<Tensor> = (backend, save) => {
    //   const keepDims = true;
    //   const xMax = max(logits, axis, true);
    //   const shifted = sub(logits, xMax);
    //   const value =
    //       sub(cast(shifted, 'float32'), log(sum(exp(shifted), axis,
    //       keepDims)));
    //   save([value]);
    //   return value;
    // };
    // Use a custom gradient for numerical stability.
    const customOp = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((logits, save)=>{
        const keepDims = true;
        const xMax = (0, $a7ac59438638606f$export$8960430cfd85939f)(logits, axis, true);
        const shifted = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(logits, xMax);
        const value = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)(shifted, 'float32'), (0, $efc3c6c91f7ffb3e$export$bef1f36f5486a6a3)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $87d347fdc039529f$export$b310ec824aaee37f)(shifted), axis, keepDims)));
        save([
            value
        ]);
        const gradFunc = (dy, saved)=>{
            const [value] = saved;
            const keepDims = true;
            const softmax = (0, $87d347fdc039529f$export$b310ec824aaee37f)(value);
            return (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(dy, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $140b816be4851e95$export$8a63f25cc62965f1)(dy, axis, keepDims), softmax));
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($logits);
// TODO Use Engine.runKernel when CPU/WebGL/WASM backends implement this.
// const inputs: LogSoftmaxInputs = {logits: $logits};
// const attrs: LogSoftmaxAttrs = {axis};
// return ENGINE.runKernel(
//            LogSoftmax, inputs as unknown as NamedTensorMap,
//            attrs as unknown as NamedAttrMap);
}
const $d2d9b5a54ac4b8bb$export$676379a046a2e437 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logSoftmax_: $d2d9b5a54ac4b8bb$var$logSoftmax_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Computes the log(sum(exp(elements across the reduction dimensions))).
 *
 * Reduces the input along the dimensions given in `axis`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.logSumExp().print();  // or tf.logSumExp(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.logSumExp(axis).print();  // or tf.logSumExp(a, axis)
 * ```
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. If null (the default),
 *     reduces all dimensions.
 * @param keepDims If true, retains reduced dimensions with length
 *     of 1. Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $46447b0d409676ff$var$logSumExp_(x, axis = null, keepDims = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'logSumExp');
    const axes = (0, $9e4a6174e3538e7d$export$72b84eb9fe1f482)(axis, $x.shape);
    const xMax = (0, $a7ac59438638606f$export$8960430cfd85939f)($x, axes, true);
    const a = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)($x, xMax);
    const b = (0, $87d347fdc039529f$export$b310ec824aaee37f)(a);
    const c = (0, $140b816be4851e95$export$8a63f25cc62965f1)(b, axes);
    const d = (0, $efc3c6c91f7ffb3e$export$bef1f36f5486a6a3)(c);
    const res = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(xMax, d.shape), d);
    if (keepDims) {
        const newShape = (0, $fab93e7418eff1cc$export$e35db9afe008d7e3)(res.shape, axes);
        return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, newShape);
    }
    return res;
}
const $46447b0d409676ff$export$e20aca1e89397787 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logSumExp_: $46447b0d409676ff$var$logSumExp_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns the truth value of `a AND b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalAnd(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $43e415e5ff25d286$var$logicalAnd_(a, b) {
    const $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'logicalAnd', 'bool');
    const $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'logicalAnd', 'bool');
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8a27ff10dff4d6e5), inputs);
}
const $43e415e5ff25d286$export$db5dd0ef9d505f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logicalAnd_: $43e415e5ff25d286$var$logicalAnd_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the truth value of `NOT x` element-wise.
 *
 * ```js
 * const a = tf.tensor1d([false, true], 'bool');
 *
 * a.logicalNot().print();
 * ```
 *
 * @param x The input tensor. Must be of dtype 'bool'.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f04fdf3ce24a6ad4$var$logicalNot_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'logicalNot', 'bool');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$4393bee5596c68c2), inputs);
}
const $f04fdf3ce24a6ad4$export$c836ff7b605b1617 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logicalNot_: $f04fdf3ce24a6ad4$var$logicalNot_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns the truth value of `a OR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalOr(b).print();
 * ```
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $b2cb91e587cc1ee5$var$logicalOr_(a, b) {
    const $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'logicalOr', 'bool');
    const $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'logicalOr', 'bool');
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c49f9f5ffc6f678c), inputs);
}
const $b2cb91e587cc1ee5$export$e2a73975983cadd8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logicalOr_: $b2cb91e587cc1ee5$var$logicalOr_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of `a XOR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalXor(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f2064c5f0ccce267$var$logicalXor_(a, b) {
    const $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'logicalXor', 'bool');
    const $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'logicalXor', 'bool');
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    // x ^ y = (x | y) & ~(x & y)
    return (0, $43e415e5ff25d286$export$db5dd0ef9d505f)((0, $b2cb91e587cc1ee5$export$e2a73975983cadd8)(a, b), (0, $f04fdf3ce24a6ad4$export$c836ff7b605b1617)((0, $43e415e5ff25d286$export$db5dd0ef9d505f)(a, b)));
}
const $f2064c5f0ccce267$export$20f90b62b30dbaef = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logicalXor_: $f2064c5f0ccce267$var$logicalXor_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $415cbd1cccb3aab5$exports = {};

$parcel$export($415cbd1cccb3aab5$exports, "searchSorted", () => $415cbd1cccb3aab5$export$56fad8d65b0adbdd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





const $415cbd1cccb3aab5$var$INT32_MAX = 2147483648;
/**
 * Searches for where a value would go in a sorted sequence.
 *
 * This is not a method for checking containment (like javascript in).
 *
 * The typical use case for this operation is "binning", "bucketing", or
 * "discretizing". The values are assigned to bucket-indices based on the edges
 * listed in 'sortedSequence'. This operation returns the bucket-index for each
 * value.
 *
 * The side argument controls which index is returned if a value lands exactly
 * on an edge.
 *
 * The axis is not settable for this operation. It always operates on the
 * innermost dimension (axis=-1). The operation will accept any number of outer
 * dimensions.
 *
 * Note: This operation assumes that 'sortedSequence' is sorted along the
 * innermost axis, maybe using 'sort(..., axis=-1)'. If the sequence is not
 * sorted no error is raised and the content of the returned tensor is not well
 * defined.
 *
 * ```js
 * const edges = tf.tensor1d([-1, 3.3, 9.1, 10.0]);
 * let values = tf.tensor1d([0.0, 4.1, 12.0]);
 * const result1 = tf.searchSorted(edges, values, 'left');
 * result1.print(); // [1, 2, 4]
 *
 * const seq = tf.tensor1d([0, 3, 9, 10, 10]);
 * values = tf.tensor1d([0, 4, 10]);
 * const result2 = tf.searchSorted(seq, values, 'left');
 * result2.print(); // [0, 2, 3]
 * const result3 = tf.searchSorted(seq, values, 'right');
 * result3.print(); // [1, 2, 5]
 *
 * const sortedSequence = tf.tensor2d([[0., 3., 8., 9., 10.],
 *                                     [1., 2., 3., 4., 5.]]);
 * values = tf.tensor2d([[9.8, 2.1, 4.3],
 *                       [0.1, 6.6, 4.5, ]]);
 * const result4 = tf.searchSorted(sortedSequence, values, 'left');
 * result4.print(); // [[4, 1, 2], [0, 5, 4]]
 * ```
 * @param sortedSequence: N-D. Sorted sequence.
 * @param values: N-D. Search values.
 * @param side: 'left'|'right'. Defaults to 'left'. 'left' corresponds to lower
 *     bound and 'right' to upper bound.
 * @return An N-D int32 tensor the size of values containing the result of
 *     applying either lower bound or upper bound (depending on side) to each
 *     value. The result is not a global index to the entire Tensor, but the
 *     index in the last dimension.
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $415cbd1cccb3aab5$var$searchSorted_(sortedSequence, values, side = 'left') {
    const $sortedSequence = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(sortedSequence, 'sortedSequence', 'searchSorted');
    const $values = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(values, 'values', 'searchSorted');
    const sequenceSize = $sortedSequence.shape[$sortedSequence.shape.length - 1];
    const valuesSize = $values.shape[$values.shape.length - 1];
    const $sortedSequence2D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($sortedSequence, [
        -1,
        sequenceSize
    ]);
    const $values2D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($values, [
        -1,
        valuesSize
    ]);
    if ($sortedSequence2D.rank < 2) throw new Error(`Sorted input argument must be at least 2-dimensional`);
    if ($sortedSequence2D.shape[0] !== $values2D.shape[0]) throw new Error(`Leading dimension of 'sortedSequence' and 'values' must match.`);
    if ((0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)($values2D.shape) >= $415cbd1cccb3aab5$var$INT32_MAX) throw new Error(`values tensor size must less than ${$415cbd1cccb3aab5$var$INT32_MAX}`);
    if ($sortedSequence2D.shape[1] >= $415cbd1cccb3aab5$var$INT32_MAX) throw new Error(`trailing dim_size must less than ${$415cbd1cccb3aab5$var$INT32_MAX} for int32 output type, was ${$sortedSequence2D.shape[1]}`);
    const inputs = {
        sortedSequence: $sortedSequence2D,
        values: $values2D
    };
    const attrs = {
        side: side
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9a1405490b09867e), inputs, attrs);
}
const $415cbd1cccb3aab5$export$56fad8d65b0adbdd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    searchSorted_: $415cbd1cccb3aab5$var$searchSorted_
});


function $e9809ccc01605fb1$export$450bb71ab40039dc(sortedSequence, values) {
    return (0, $415cbd1cccb3aab5$export$56fad8d65b0adbdd)(sortedSequence, values, 'left');
}




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes the 2D max pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $4a7523a0f2407497$var$maxPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'maxPool');
    const dilations = 1;
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x4D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $f9c374363849dff2$export$1b3400c26a44af8('maxPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$39ea33024ddd5cf), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $4a7523a0f2407497$export$e4aadcf115842782 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    maxPool_: $4a7523a0f2407497$var$maxPool_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes the 3D max pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.maxPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $4e9f4d29d50590f0$var$maxPool3d_(x, filterSize = [
    1,
    1,
    1
], strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'maxPool3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x5D.rank === 5, ()=>`Error in maxPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NDHWC', ()=>`Error in maxPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    (0, $f9c374363849dff2$export$1b3400c26a44af8)('maxPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$88fdc64af890fc53), inputs, attrs);
    if (reshapedTo5D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $4e9f4d29d50590f0$export$822a6e53be1125f9 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    maxPool3d_: $4e9f4d29d50590f0$var$maxPool3d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the 2D max pooling of an image with Argmax index.
 * The indices in argmax are flattened, so that a maximum value at position `[b,
 * y, x, c]` becomes flattened index: `(y * width + x) * channels + c` if
 * include_batch_in_index is False; `((b * height + y) * width + x) * channels
 * +c` if include_batch_in_index is True.
 *
 * The indices returned are always in `[0, height) x [0, width)` before
 * flattening.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param includeBatchIndex Defaults to False. Whether to include batch
 *    dimension in flattened index of argmax.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $77d0f65983551a81$var$maxPoolWithArgmax_(x, filterSize, strides, pad, includeBatchInIndex = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'maxPoolWithArgmax');
    const inputs = {
        x: $x
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        includeBatchInIndex: includeBatchInIndex
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$deac4b7497b4047f), inputs, attrs);
    return {
        result: result[0],
        indexes: result[1]
    };
}
const $77d0f65983551a81$export$3d8b1b819d23351e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    maxPoolWithArgmax_: $77d0f65983551a81$var$maxPoolWithArgmax_
});



/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the mean of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces `x` along the dimensions given in `axis`. Unless `keepDims` is
 * true, the rank of the `tf.Tensor` is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and a `tf.Tensor` with
 * a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.mean().print();  // or tf.mean(a)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.mean(axis).print();  // or tf.mean(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $050f28c39276830f$var$mean_(x, axis = null, keepDims = false) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'mean');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$1c2d59c4b681fbd8), inputs, attrs);
}
const $050f28c39276830f$export$1ce691f85baaa52 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    mean_: $050f28c39276830f$var$mean_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $a0e8420b37ff8039$export$4445a00dafa2633b(shape, dtype = 'float32') {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    if (dtype === 'complex64') {
        const real = $a0e8420b37ff8039$export$4445a00dafa2633b(shape, 'float32');
        const imag = $a0e8420b37ff8039$export$4445a00dafa2633b(shape, 'float32');
        return (0, $974747594bfdbaee$export$83a0e34f1302825b)(real, imag);
    }
    const values = (0, $9e4a6174e3538e7d$export$edbc8aedac4e036f)((0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape), dtype);
    return (0, $6a645535e157b279$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}


function $5bbaaacdaecf5fa4$export$21041dee6b8001b0(shape, dtype = 'float32') {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    if (dtype === 'complex64') {
        const real = $5bbaaacdaecf5fa4$export$21041dee6b8001b0(shape, 'float32');
        const imag = (0, $a0e8420b37ff8039$export$4445a00dafa2633b)(shape, 'float32');
        return (0, $974747594bfdbaee$export$83a0e34f1302825b)(real, imag);
    }
    const values = (0, $9e4a6174e3538e7d$export$b915f681a907ae99)((0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape), dtype);
    return (0, $6a645535e157b279$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}






function $9908cc81353f6753$export$2fab8e71e5fefc1a(x, y, { indexing: indexing = 'xy' } = {}) {
    if (indexing !== 'xy' && indexing !== 'ij') throw new TypeError(`${indexing} is not a valid third argument to meshgrid`);
    if (x === undefined) return [];
    let $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'meshgrid', x instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? x.dtype : 'float32');
    if (y === undefined) return [
        $x
    ];
    let $y = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(y, 'y', 'meshgrid', y instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? y.dtype : 'float32');
    const w = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)($x.shape);
    const h = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)($y.shape);
    if (indexing === 'xy') {
        $x = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            -1
        ]);
        $y = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($y, [
            -1,
            1
        ]);
        return [
            (0, $8a13d3789789217b$export$6706882a873e9a8f)((0, $5bbaaacdaecf5fa4$export$21041dee6b8001b0)([
                h,
                1
            ], $x.dtype), $x),
            (0, $8a13d3789789217b$export$6706882a873e9a8f)($y, (0, $5bbaaacdaecf5fa4$export$21041dee6b8001b0)([
                1,
                w
            ], $y.dtype))
        ];
    }
    $x = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
        -1,
        1
    ]);
    $y = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($y, [
        1,
        -1
    ]);
    return [
        (0, $8a13d3789789217b$export$6706882a873e9a8f)($x, (0, $5bbaaacdaecf5fa4$export$21041dee6b8001b0)([
            1,
            h
        ], $x.dtype)),
        (0, $8a13d3789789217b$export$6706882a873e9a8f)((0, $5bbaaacdaecf5fa4$export$21041dee6b8001b0)([
            w,
            1
        ], $y.dtype), $y)
    ];
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Returns the min of a and b (`a < b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `minimumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * ```js
 * // Broadcast minimum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $4315eb3f5ec9063a$var$minimum_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'minimum');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'minimum');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($a, 'int32');
        $b = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($b, 'int32');
    }
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$23cb308301e89d6b), inputs);
}
const $4315eb3f5ec9063a$export$916782c1f0ddb132 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    minimum_: $4315eb3f5ec9063a$var$minimum_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Pads a `tf.Tensor` using mirror padding.
 *
 * This operation implements the `REFLECT` and `SYMMETRIC` modes of pad.
 *
 * ```js
 * const x = tf.range(0, 9).reshape([1, 1, 3, 3]);
 * x.mirrorPad([[0, 0], [0, 0], [2, 2], [2, 2]], 'reflect').print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * In "reflect" mode, the padded regions do not include the borders,
 * while in "symmetric" mode the padded regions do include the borders.
 * For example, if the input is `[1, 2, 3]` and paddings is `[0, 2]`,
 * then the output is `[1, 2, 3, 2, 1]` in "reflect" mode, and
 * `[1, 2, 3, 3, 2]` in "symmetric" mode.
 * If `mode` is "reflect" then both `paddings[D, 0]` and `paddings[D, 1]`
 * must be no greater than `x.shape[D] - 1`. If mode is "symmetric"
 * then both `paddings[D, 0]` and `paddings[D, 1]` must be no greater than
 * `x.shape[D]`
 * @param mode String to specify padding mode. Can be `'reflect' | 'symmetric'`
 */ /** @doc {heading: 'Tensors', subheading: 'Transformations'} */ function $cae387b6339c4711$var$mirrorPad_(x, paddings, mode) {
    $9e4a6174e3538e7d$export$a7a9523472993e97(mode === 'reflect' || mode === 'symmetric', ()=>`Invalid mode. Mode must be either reflect or symmetric. ` + `Got ${mode}.`);
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'mirrorPad');
    if ($x.rank === 0) throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
    $9e4a6174e3538e7d$export$a7a9523472993e97(paddings.length === $x.rank, ()=>`Padding doesn't match input. Must be ${$x.rank}. ` + `Got ${paddings.length}.`);
    const shapeOffset = mode === 'reflect' ? 1 : 0;
    for(let i = 0; i < $x.rank; i++){
        $9e4a6174e3538e7d$export$a7a9523472993e97(paddings[i].length === 2, ()=>`Invalid number of paddings. Must be length of 2 each.`);
        $9e4a6174e3538e7d$export$a7a9523472993e97(paddings[i][0] >= 0 && paddings[i][0] <= $x.shape[i] - shapeOffset && paddings[i][1] >= 0 && paddings[i][1] <= $x.shape[i] - shapeOffset, ()=>`Padding in dimension ${i} cannot be greater than or equal ` + `to ${$x.shape[i] - shapeOffset} or less than 0 for input of ` + `shape ${$x.shape}`);
    }
    const attrs = {
        paddings: paddings,
        mode: mode
    };
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f4c0e95fd7fd31e5), inputs, attrs);
}
const $cae387b6339c4711$export$c0b11600e90b86ae = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    mirrorPad_: $cae387b6339c4711$var$mirrorPad_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns the mod of a and b element-wise.
 * `floor(x / y) * y + mod(x, y) = x`
 * Supports broadcasting.
 *
 * We also expose `tf.modStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * ```js
 * // Broadcast a mod b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $102378bc37a939ad$var$mod_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'mod');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'mod');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$e4835a5e3f3674d5), inputs);
}
const $102378bc37a939ad$export$842a2cf37af977e1 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    mod_: $102378bc37a939ad$var$mod_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 








/**
 * Calculates the mean and variance of `x`. The mean and variance are
 * calculated by aggregating the contents of `x` across `axes`. If `x` is
 * 1-D and `axes = [0]` this is just the mean and variance of a vector.
 *
 * @param x The input tensor.
 * @param axis The dimension(s) along with to compute mean and
 *     variance. By default it reduces all dimensions.
 * @param keepDims If true, the moments have the same dimensionality as the
 *     input.
 * @return An object with two keys: `mean` and `variance`.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $72a959a6cb42aff7$var$moments_(x, axis = null, keepDims = false) {
    x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'moments');
    const axes = (0, $9e4a6174e3538e7d$export$72b84eb9fe1f482)(axis, x.shape);
    const xMean = (0, $050f28c39276830f$export$1ce691f85baaa52)(x, axes, keepDims);
    let keepDimsShape = xMean.shape;
    if (!keepDims) keepDimsShape = (0, $fab93e7418eff1cc$export$e35db9afe008d7e3)(xMean.shape, axes);
    const devSquared = (0, $7c706d812ea019b4$export$dd4f28cef696bc7d)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)(x, 'float32'), (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(xMean, keepDimsShape)));
    const variance = (0, $050f28c39276830f$export$1ce691f85baaa52)(devSquared, axes, keepDims);
    return {
        mean: xMean,
        variance: variance
    };
}
const $72a959a6cb42aff7$export$19ef085469537740 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    moments_: $72a959a6cb42aff7$var$moments_
});





/**
 * Computes the next states and outputs of a stack of LSTMCells.
 *
 * Each cell output is used as input to the next cell.
 *
 * Returns `[cellState, cellOutput]`.
 *
 * Derived from tf.contrib.rn.MultiRNNCell.
 *
 * @param lstmCells Array of LSTMCell functions.
 * @param data The input to the cell.
 * @param c Array of previous cell states.
 * @param h Array of previous cell outputs.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $25da887321c007b8$var$multiRNNCell_(lstmCells, data, c, h) {
    const $data = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(data, 'data', 'multiRNNCell');
    const $c = (0, $539f0ce07f2139cd$export$758e66616b4d410b)(c, 'c', 'multiRNNCell');
    const $h = (0, $539f0ce07f2139cd$export$758e66616b4d410b)(h, 'h', 'multiRNNCell');
    let input = $data;
    const newStates = [];
    for(let i = 0; i < lstmCells.length; i++){
        const output = lstmCells[i](input, $c[i], $h[i]);
        newStates.push(output[0]);
        newStates.push(output[1]);
        input = output[1];
    }
    const newC = [];
    const newH = [];
    for(let i = 0; i < newStates.length; i += 2){
        newC.push(newStates[i]);
        newH.push(newStates[i + 1]);
    }
    return [
        newC,
        newH
    ];
}
const $25da887321c007b8$export$cc05b5217b9b924f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    multiRNNCell_: $25da887321c007b8$var$multiRNNCell_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Creates a `tf.Tensor` with values drawn from a multinomial distribution.
 *
 * ```js
 * const probs = tf.tensor([.75, .25]);
 * tf.multinomial(probs, 3).print();
 * ```
 *
 * @param logits 1D array with unnormalized log-probabilities, or
 *     2D array of shape `[batchSize, numOutcomes]`. See the `normalized`
 *     parameter.
 * @param numSamples Number of samples to draw for each row slice.
 * @param seed The seed number.
 * @param normalized Whether the provided `logits` are normalized true
 *     probabilities (sum to 1). Defaults to false.
 * @return 1D array of shape `[numSamples]`, or 2D array of shape
 *     `[batchSize, numSamples]`, depending on the rank of the input.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $aa159b2c998f6945$var$multinomial_(logits, numSamples, seed, normalized = false) {
    const $logits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(logits, 'logits', 'multinomial');
    const numOutcomes = $logits.size;
    const origRank = $logits.rank;
    if (numOutcomes < 2) throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ` + `${numOutcomes}.`);
    if (origRank > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${origRank}`);
    // TODO(lina128): Investigate correct seed behavior. The code seems not allow
    // setting see to 0.
    seed = seed || Math.random();
    // The kernel only accepts (and returns) rank 2 tensors.
    const logits2D = origRank === 1 ? (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($logits, [
        1,
        -1
    ]) : $logits;
    const inputs = {
        logits: logits2D
    };
    const attrs = {
        numSamples: numSamples,
        seed: seed,
        normalized: normalized
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ee0a8cfb693e0e3f), inputs, attrs);
    // tslint:disable-next-line:no-unnecessary-type-assertion
    return origRank === 1 ? (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.size
    ]) : res;
}
const $aa159b2c998f6945$export$f4d580f3101a1c7e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    multinomial_: $aa159b2c998f6945$var$multinomial_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a != b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([0, 2, 3]);
 *
 * a.notEqual(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $3b3172df4948dc0b$var$notEqual_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'notEqual', 'string_or_numeric');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'notEqual', 'string_or_numeric');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$385ebe9945cae0c5), inputs);
}
const $3b3172df4948dc0b$export$53a6892c50694894 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    notEqual_: $3b3172df4948dc0b$var$notEqual_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a one-hot `tf.Tensor`. The locations represented by `indices` take
 * value `onValue` (defaults to 1), while all other locations take value
 * `offValue` (defaults to 0). If `indices` is rank `R`, the output has rank
 * `R+1` with the last axis of size `depth`.
 * `indices` used to encode prediction class must start from 0. For example,
 *  if you have 3 classes of data, class 1 should be encoded as 0, class 2
 *  should be 1, and class 3 should be 2.
 *
 * ```js
 * tf.oneHot(tf.tensor1d([0, 1], 'int32'), 3).print();
 * ```
 *
 * @param indices `tf.Tensor` of indices with dtype `int32`. Indices must
 * start from 0.
 * @param depth The depth of the one hot dimension.
 * @param onValue A number used to fill in the output when the index matches
 * the location.
 * @param offValue A number used to fill in the output when the index does
 *     not match the location.
 * @param dtype The dtype of the output tensor, default to 'int32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $fa50897246093fc8$var$oneHot_(indices, depth, onValue = 1, offValue = 0, dtype = 'int32') {
    if (depth < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${depth}`);
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'oneHot', 'int32');
    const inputs = {
        indices: $indices
    };
    const attrs = {
        dtype: dtype,
        depth: depth,
        onValue: onValue,
        offValue: offValue
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$18982b43ba8c02e9), inputs, attrs);
}
const $fa50897246093fc8$export$341b5490a776d041 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    oneHot_: $fa50897246093fc8$var$oneHot_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with all elements set to 1 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.onesLike(x).print();
 * ```
 * @param x A tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $4f24ce9b876632b2$var$onesLike_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'onesLike');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$a2962e735c809d91), inputs);
}
const $4f24ce9b876632b2$export$fb6afd6214fee9e9 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    onesLike_: $4f24ce9b876632b2$var$onesLike_
});







/**
 * Computes the outer product of two vectors, `v1` and `v2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([3, 4, 5]);
 *
 * tf.outerProduct(a, b).print();
 * ```
 * @param v1 The first vector in the outer product operation.
 * @param v2 The second vector in the outer product operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $ea9074c3ac34a33a$var$outerProduct_(v1, v2) {
    const $v1 = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(v1, 'v1', 'outerProduct');
    const $v2 = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(v2, 'v2', 'outerProduct');
    $9e4a6174e3538e7d$export$a7a9523472993e97($v1.rank === 1 && $v2.rank === 1, ()=>`Error in outerProduct: inputs must be rank 1, but got ranks ` + `${$v1.rank} and ${$v2.rank}.`);
    const v12D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($v1, [
        -1,
        1
    ]);
    const v22D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($v2, [
        1,
        -1
    ]);
    return (0, $8a13d3789789217b$export$6706882a873e9a8f)(v12D, v22D);
}
const $ea9074c3ac34a33a$export$8481b38c75c91cc7 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    outerProduct_: $ea9074c3ac34a33a$var$outerProduct_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Pads a `tf.Tensor` with a given value and paddings.
 *
 * This operation implements `CONSTANT` mode. For `REFLECT` and `SYMMETRIC`,
 * refer to `tf.mirrorPad`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `paddings` is of given length.
 *   - `tf.pad1d`
 *   - `tf.pad2d`
 *   - `tf.pad3d`
 *   - `tf.pad4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.pad([[1, 2]]).print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * @param constantValue The pad value to use. Defaults to 0.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $6d3dcf71964d715a$var$pad_(x, paddings, constantValue = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'pad');
    if ($x.rank === 0) throw new Error('pad(scalar) is not defined. Pass non-scalar to pad');
    const attrs = {
        paddings: paddings,
        constantValue: constantValue
    };
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5d47ba206577f0f2), inputs, attrs);
}
const $6d3dcf71964d715a$export$5d04458e2a6c373e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pad_: $6d3dcf71964d715a$var$pad_
});





/**
 * Pads a `tf.Tensor1D` with a given value and paddings. See `pad` for details.
 */ function $2e4218e952802c5e$var$pad1d_(x, paddings, constantValue = 0) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(paddings.length === 2, ()=>'Invalid number of paddings. Must be length of 2.');
    return (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(x, [
        paddings
    ], constantValue);
}
const $2e4218e952802c5e$export$be67ff622a7fd5 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pad1d_: $2e4218e952802c5e$var$pad1d_
});





/**
 * Pads a `tf.Tensor2D` with a given value and paddings. See `pad` for details.
 */ function $d45b582f4a35e9ce$var$pad2d_(x, paddings, constantValue = 0) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(paddings.length === 2 && paddings[0].length === 2 && paddings[1].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(x, paddings, constantValue);
}
const $d45b582f4a35e9ce$export$38e9137d79715c2d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pad2d_: $d45b582f4a35e9ce$var$pad2d_
});





/**
 * Pads a `tf.Tensor3D` with a given value and paddings. See `pad` for details.
 */ function $53479bd083cf15cd$var$pad3d_(x, paddings, constantValue = 0) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(paddings.length === 3 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(x, paddings, constantValue);
}
const $53479bd083cf15cd$export$880821ebecb16ceb = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pad3d_: $53479bd083cf15cd$var$pad3d_
});





/**
 * Pads a `tf.Tensor4D` with a given value and paddings. See `pad` for details.
 */ function $c2099fc3afb4b0cc$var$pad4d_(x, paddings, constantValue = 0) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(paddings.length === 4 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2 && paddings[3].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(x, paddings, constantValue);
}
const $c2099fc3afb4b0cc$export$4aef6fb43f1346f4 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pad4d_: $c2099fc3afb4b0cc$var$pad4d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * This operation divides "spatial" dimensions `[1, ..., M]` of the input into
 * a grid of blocks of shape `blockShape`, and interleaves these blocks with
 * the "batch" dimension (0) such that in the output, the spatial
 * dimensions `[1, ..., M]` correspond to the position within the grid,
 * and the batch dimension combines both the position within a spatial block
 * and the original batch position. Prior to division into blocks,
 * the spatial dimensions of the input are optionally zero padded
 * according to `paddings`. See below for a precise description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]);
 * const blockShape = [2, 2];
 * const paddings = [[0, 0], [0, 0]];
 *
 * x.spaceToBatchND(blockShape, paddings).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param paddings A 2-D array. Must have shape `[M, 2]`, all values must be >=
 *     0. `paddings[i] = [padStart, padEnd]` specifies the amount to zero-pad
 * from input dimension `i + 1`, which corresponds to spatial dimension `i`. It
 * is required that
 * `(inputShape[i + 1] + padStart + padEnd) % blockShape[i] === 0`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Zero-pad the start and end of dimensions `[1, ..., M]` of the input
 * according to `paddings` to produce `padded` of shape paddedShape.
 *
 * 2. Reshape `padded` to `reshapedPadded` of shape:
 * `[batch] + [paddedShape[1] / blockShape[0], blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1], blockShape[M-1]] + remainingShape`
 *
 * 3. Permute dimensions of `reshapedPadded` to produce `permutedReshapedPadded`
 * of shape: `blockShape + [batch] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * 4. Reshape `permutedReshapedPadded` to flatten `blockShape` into the
 * batch dimension, producing an output tensor of shape:
 * `[batch * prod(blockShape)] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $5e82eb397f4e7578$var$spaceToBatchND_(x, blockShape, paddings) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'spaceToBatchND');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank >= 1 + blockShape.length, ()=>`input rank ${$x.rank} should be > than [blockShape] ${blockShape.length}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(paddings.length === blockShape.length, ()=>`paddings.shape[0] ${paddings.length} must be equal to [blockShape] ${blockShape.length}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.shape.reduce((a, b, i)=>{
        if (i > 0 && i <= blockShape.length) return a && (b + paddings[i - 1][0] + paddings[i - 1][1]) % blockShape[i - 1] === 0;
        return a;
    }, true), ()=>`input spatial dimensions ${$x.shape.slice(1)} with paddings ${paddings.toString()} must be divisible by blockShapes ${blockShape.toString()}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        paddings: paddings
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f63ac5409312707c), inputs, attrs);
}
const $5e82eb397f4e7578$export$effb9d7cae92012f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    spaceToBatchND_: $5e82eb397f4e7578$var$spaceToBatchND_
});


/**
 * Performs an N-D pooling operation
 *
 * @param input The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param windowShape The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param poolingType The type of pooling, either 'max' or 'avg'.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilationRate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $7fb5e0b8a7333410$var$pool_(input, windowShape, poolingType, pad, dilations, strides, dimRoundingMode) {
    if (dilations == null) dilations = [
        1,
        1
    ];
    if (strides == null) strides = 1;
    if (pad === 0) pad = 'valid';
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(input, 'x', 'maxPool');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in pool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $f9c374363849dff2$export$67e321f77840205c(x4D.shape, windowShape, strides, dilations, pad);
    const dilation = [
        convInfo.dilationHeight,
        convInfo.dilationWidth
    ];
    // The following implementation does batchToSpace(pool(spaceToBatch(x)))
    // whenever dilation > 1 since the TF kernels do not support dilation > 1.
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L1037
    let basePadding;
    if (pad === 'same') basePadding = $7fb5e0b8a7333410$var$withSpaceToBatchBasePaddings([
        convInfo.filterHeight,
        convInfo.filterWidth
    ], dilation);
    else basePadding = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    const isDilationOne = dilation[0] === 1 && dilation[1] === 1;
    const [adjustedPadding, adjustedCrops] = $7fb5e0b8a7333410$var$requiredSpaceToBatchPaddings([
        convInfo.inHeight,
        convInfo.inWidth
    ], dilation, basePadding);
    const convertedPad = isDilationOne ? pad : 'valid';
    const convertedX = isDilationOne ? x4D : (0, $5e82eb397f4e7578$export$effb9d7cae92012f)(x4D, dilation, adjustedPadding);
    const forwardOp = poolingType === 'avg' ? ()=>(0, $7a3c766bcf29cf34$export$d5c65a2abd3d97dc)(convertedX, windowShape, strides, convertedPad, dimRoundingMode) : ()=>(0, $4a7523a0f2407497$export$e4aadcf115842782)(convertedX, windowShape, strides, convertedPad, dimRoundingMode);
    const y = forwardOp();
    const res = isDilationOne ? y : (0, $0c9cd7e5361fb9c5$export$ea37d960c1808536)(y, dilation, adjustedCrops);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
// Helper function to compute crops and paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/array_ops.py#L2184
function $7fb5e0b8a7333410$var$requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
    const padStart = basePadding.map((b)=>b[0]);
    const origPadEnd = basePadding.map((b)=>b[1]);
    const fullInputShape = inputShape.concat(padStart, origPadEnd);
    const padEndExtra = blockShape.map((b, i)=>(b - fullInputShape[i] % b) % b);
    const padEnd = origPadEnd.map((s, i)=>s + padEndExtra[i]);
    const paddings = blockShape.map((_, i)=>[
            padStart[i],
            padEnd[i]
        ]);
    const crops = blockShape.map((_, i)=>[
            0,
            padEndExtra[i]
        ]);
    return [
        paddings,
        crops
    ];
}
// Helper function to compute base paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L524
function $7fb5e0b8a7333410$var$withSpaceToBatchBasePaddings(filterShape, dilation) {
    // Spatial dimensions of the filters and the upsampled filters in which we
    // introduce (rate - 1) zeros between consecutive filter values.
    const dilatedFilterShape = filterShape.map((s, i)=>{
        return s + (s - 1) * (dilation[i] - 1);
    });
    const padExtraShape = dilatedFilterShape.map((s)=>s - 1);
    // When padding is odd, we pad more at end, following the same
    // convention as conv2d.
    const padExtraStart = padExtraShape.map((s)=>Math.floor(s / 2));
    const padExtraEnd = padExtraShape.map((s, i)=>s - padExtraStart[i]);
    return padExtraShape.map((_, i)=>{
        return [
            padExtraStart[i],
            padExtraEnd[i]
        ];
    });
}
const $7fb5e0b8a7333410$export$7a0e2789ec54f0db = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    pool_: $7fb5e0b8a7333410$var$pool_
});





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the product of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.prod().print();  // or tf.prod(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.prod(axis).print();  // or tf.prod(x, axis)
 * ```
 *
 * @param x The input tensor to compute the product over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $19a586127900ac98$var$prod_(x, axis = null, keepDims = false) {
    let $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'prod');
    if ($x.dtype === 'bool') // bool is not an allowed type for the underlying kernel.
    $x = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b8a16d526a791fb0), inputs, attrs);
}
const $19a586127900ac98$export$5e143010dea16c85 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    prod_: $19a586127900ac98$var$prod_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $0e93c4003fe85c10$var$raggedGather_(paramsNestedSplits, paramsDenseValues, indices, outputRaggedRank) {
    const $paramsNestedSplits = paramsNestedSplits.map((t, i)=>(0, $539f0ce07f2139cd$export$ede379c4c939d71a)(t, `tensors${i}`, 'raggedGather', 'int32'));
    const $paramsDenseValues = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(paramsDenseValues, 'paramsDenseValues', 'raggedGather');
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'raggedGather', 'int32');
    const inputs = {
        paramsNestedSplits: $paramsNestedSplits,
        paramsDenseValues: $paramsDenseValues,
        indices: $indices
    };
    const attrs = {
        outputRaggedRank: outputRaggedRank
    };
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$ffee9c5b4fce08a1), inputs, attrs);
    return {
        outputNestedSplits: result.slice(0, result.length - 1),
        outputDenseValues: result[result.length - 1]
    };
}
const $0e93c4003fe85c10$export$e7118f605df251dd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    raggedGather_: $0e93c4003fe85c10$var$raggedGather_
});


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns a RaggedTensor result composed from rtDenseValues and rtNestedSplits,
 * such that result[i] = [starts[i], starts[i] + deltas[i], ..., limits[i]]).
 *
 * @param starts: A Tensor. Must be one of the following types:
 *     'float32', 'int32'. The starts of each range.
 * @param limits: A Tensor. Must have the same type as starts. The limits of
 *     each range.
 * @param deltas: A Tensor. Must have the same type as starts. The deltas of
 *     each range.
 * @return A map with the following properties:
 *     - rtNestedSplits: A Tensor of type 'int32'.
 *     - rtDenseValues: A Tensor. Has the same type as starts.
 */ function $4adb37d3e00c3c62$var$raggedRange_(starts, limits, deltas) {
    const $starts = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(starts, 'starts', 'raggedRange');
    const $limits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(limits, 'limits', 'raggedRange', $starts.dtype);
    const $deltas = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(deltas, 'deltas', 'raggedRange', $starts.dtype);
    const inputs = {
        starts: $starts,
        limits: $limits,
        deltas: $deltas
    };
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9d0615a9a6d213d2), inputs);
    return {
        rtNestedSplits: result[0],
        rtDenseValues: result[1]
    };
}
const $4adb37d3e00c3c62$export$a173be400c6762b5 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    raggedRange_: $4adb37d3e00c3c62$var$raggedRange_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Create a dense tensor from a ragged tensor, possibly altering its shape.
 *
 * The raggedTensorToTensor op creates a dense tensor from am array of row
 * partition tensors, a value vector, and default values. If the shape is
 * unspecified, the minimal shape required to contain all the elements in the
 * ragged tensor (the natural shape) will be used. If some dimensions are left
 * unspecified, then the size of the natural shape is used in that dimension.
 *
 * The defaultValue will be broadcast to the output shape. After that, the
 * values from the ragged tensor overwrite the default values. Note that the
 * defaultValue must have less dimensions than the value.
 *
 * The row partition tensors are in the order of the dimensions. At present, the
 * types can be: "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *   "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *   "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then it
 * is preceded by "FIRST_DIM_SIZE".
 * ```
 * @param shape: A Tensor. Must be one of the following types: 'int32'. The
 *     desired shape of the output tensor. If left unspecified (empty), the
 *     minimal shape required to contain all the elements in the ragged tensor
 *     (the natural shape) will be used. If some dimensions are left
 *     unspecified, then the size of the natural shape is used in that
 *     dimension.
 *
 *     Note that dense dimensions cannot be modified by the shape argument.
 *     Trying to change the size of a dense dimension will cause the op to fail.
 *     Examples: natural shape: [4, 5, 6] shape: -1 output shape: [4, 5, 6]
 *
 *     natural shape: [4, 5, 6] shape: [3, -1, 2] output shape: [3, 5, 2]
 *
 *     natural shape: [4, 5, 6] shape: [3, 7, 2] output shape: [3, 7, 2]
 * @param values: A Tensor. A 1D tensor representing the values of the ragged
 *     tensor.
 * @param defaultValue: A Tensor. Must have the same type as values. The
 *     defaultValue when the shape is larger than the ragged tensor. The
 *     defaultValue is broadcast until it is the shape of the output tensor,
 *     and then overwritten by values in the ragged tensor. The default value
 *     must be compatible with this broadcast operation, and must have fewer
 *     dimensions than the value tensor.
 * @param rowPartitionTensors: A list of at least 1 Tensor objects with the same
 *     type in: 'int32'.
 * @param rowPartitionTypes: A list of strings. The types of the row partition
 *     tensors. At present, these can be:
 *     "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *     "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *     "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then
 *         it is preceded by "FIRST_DIM_SIZE". The tensors are in the order of
 *         the dimensions.
 * @return A Tensor. Has the same type as values.
 * @doc {heading: 'Operations', subheading: 'Ragged'}
 */ function $b4dbb3f1130f0eaa$var$raggedTensorToTensor_(shape, values, defaultValue, rowPartitionTensors, rowPartitionTypes) {
    const $shape = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(shape, 'shape', 'raggedTensorToTensor', 'int32');
    const $values = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(values, 'values', 'raggedTensorToTensor');
    const $defaultValue = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(defaultValue, 'defaultValue', 'raggedTensorToTensor', $values.dtype);
    const $rowPartitionTensors = rowPartitionTensors.map((t, i)=>(0, $539f0ce07f2139cd$export$ede379c4c939d71a)(t, `tensors${i}`, 'raggedTensorToTensor', 'int32'));
    const inputs = {
        shape: $shape,
        values: $values,
        defaultValue: $defaultValue,
        rowPartitionTensors: $rowPartitionTensors
    };
    const attrs = {
        rowPartitionTypes: rowPartitionTypes
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$616d73a9ab7617c7), inputs, attrs);
}
const $b4dbb3f1130f0eaa$export$621e390307cbbaa1 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    raggedTensorToTensor_: $b4dbb3f1130f0eaa$var$raggedTensorToTensor_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a random number generator
 * function defined by the user.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param randFunction A random number generator function which is called
 * for each element in the output tensor.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $ba18400447ccf3b8$var$rand_(shape, randFunction, dtype) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    const size = (0, $9e4a6174e3538e7d$export$b4c3214a70a0e73f)(shape);
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    for(let i = 0; i < size; i++)values[i] = randFunction();
    return (0, $6a645535e157b279$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}
const $ba18400447ccf3b8$export$bb0a9c36cf454ea0 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    rand_: $ba18400447ccf3b8$var$rand_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $b451ab935132b01f$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $1NWL6 = parcelRequire("1NWL6");

var $8FlDu = parcelRequire("8FlDu");

var $1rFi6 = parcelRequire("1rFi6");

var $iDdZD = parcelRequire("iDdZD");

var $bDA0X = parcelRequire("bDA0X");

var $oBon1 = parcelRequire("oBon1");
var $f6958004dd10691b$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if ($f6958004dd10691b$exports) {
        $f6958004dd10691b$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("aXLS2"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : $f6958004dd10691b$exports, [], Math // math: package containing random, pow, and seedrandom
);


$f6958004dd10691b$exports.alea = $1NWL6;
$f6958004dd10691b$exports.xor128 = $8FlDu;
$f6958004dd10691b$exports.xorwow = $1rFi6;
$f6958004dd10691b$exports.xorshift7 = $iDdZD;
$f6958004dd10691b$exports.xor4096 = $bDA0X;
$f6958004dd10691b$exports.tychei = $oBon1;
$b451ab935132b01f$exports = $f6958004dd10691b$exports;


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $a05ad9cb1f55fcba$var$TEST_EPSILON_FLOAT32 = 1e-3;
const $a05ad9cb1f55fcba$export$a86b4427e7a62065 = 1e-1;
function $a05ad9cb1f55fcba$export$33c766a1062be5b2(actual, expected, epsilon) {
    if (epsilon == null) epsilon = $a05ad9cb1f55fcba$export$e73bb4a504595b05();
    return $a05ad9cb1f55fcba$var$expectArraysPredicate(actual, expected, (a, b)=>$a05ad9cb1f55fcba$var$areClose(a, b, epsilon));
}
function $a05ad9cb1f55fcba$export$e73bb4a504595b05() {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).backend.floatPrecision() === 32 ? $a05ad9cb1f55fcba$var$TEST_EPSILON_FLOAT32 : $a05ad9cb1f55fcba$export$a86b4427e7a62065;
}
function $a05ad9cb1f55fcba$var$expectArraysPredicate(actual, expected, predicate) {
    let checkClassType = true;
    if ((0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(actual) || (0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(expected)) checkClassType = false;
    if ((0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(actual) && (0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(expected)) checkClassType = true;
    if (checkClassType) {
        const aType = actual.constructor.name;
        const bType = expected.constructor.name;
        if (aType !== bType) throw new Error(`Arrays are of different type. Actual: ${aType}. ` + `Expected: ${bType}`);
    }
    if (Array.isArray(actual) && Array.isArray(expected)) {
        const actualShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(actual);
        const expectedShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(expected);
        if (!(0, $9e4a6174e3538e7d$export$234180f8206db11b)(actualShape, expectedShape)) throw new Error(`Arrays have different shapes. ` + `Actual: [${actualShape}]. Expected: [${expectedShape}]`);
    }
    const actualFlat = (0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(actual) ? actual : (0, $0775da5e684c8c0d$export$bffa455ba8c619a6)(actual);
    const expectedFlat = (0, $0775da5e684c8c0d$export$b119cc7e1840e59c)(expected) ? expected : (0, $0775da5e684c8c0d$export$bffa455ba8c619a6)(expected);
    if (actualFlat.length !== expectedFlat.length) throw new Error(`Arrays have different lengths actual: ${actualFlat.length} vs ` + `expected: ${expectedFlat.length}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    for(let i = 0; i < expectedFlat.length; ++i){
        const a = actualFlat[i];
        const e = expectedFlat[i];
        if (!predicate(a, e)) throw new Error(`Arrays differ: actual[${i}] = ${a}, expected[${i}] = ${e}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    }
    if (typeof expect !== 'undefined') expect().nothing();
}
function $a05ad9cb1f55fcba$export$f1ce55133f3520c4(fn, done) {
    fn().then(()=>done.fail(), ()=>done());
    if (typeof expect !== 'undefined') expect().nothing();
}
function $a05ad9cb1f55fcba$export$347f1ed9dcafca0d(actual, expected) {
    const exp = typeof expected === 'string' || typeof expected === 'number' || typeof expected === 'boolean' ? [
        expected
    ] : expected;
    if ((0, $9e4a6174e3538e7d$export$844ec244b1367d54)(actual) || (0, $9e4a6174e3538e7d$export$844ec244b1367d54)(actual[0]) || (0, $9e4a6174e3538e7d$export$844ec244b1367d54)(expected) || (0, $9e4a6174e3538e7d$export$844ec244b1367d54)(expected[0])) // tslint:disable-next-line: triple-equals
    return $a05ad9cb1f55fcba$var$expectArraysPredicate(actual, exp, (a, b)=>a == b);
    return $a05ad9cb1f55fcba$var$expectArraysPredicate(actual, expected, (a, b)=>$a05ad9cb1f55fcba$var$areClose(a, b, 0));
}
function $a05ad9cb1f55fcba$export$a09d1668dd6f88b6(a, e, epsilon) {
    if (epsilon == null) epsilon = $a05ad9cb1f55fcba$export$e73bb4a504595b05();
    if (!$a05ad9cb1f55fcba$var$areClose(a, e, epsilon)) throw new Error(`Numbers differ: actual === ${a}, expected === ${e}`);
    if (typeof expect !== 'undefined') expect().nothing();
}
function $a05ad9cb1f55fcba$var$areClose(a, e, epsilon) {
    if (!isFinite(a) && !isFinite(e)) return true;
    if (isNaN(a) || isNaN(e) || Math.abs(a - e) > epsilon) return false;
    return true;
}
function $a05ad9cb1f55fcba$export$1af4797b1eac800b(actual, low, high) {
    for(let i = 0; i < actual.length; i++){
        if (actual[i] < low || actual[i] > high) throw new Error(`Value out of range:${actual[i]} low: ${low}, high: ${high}`);
    }
}
function $a05ad9cb1f55fcba$export$28801b43871bdbc0(actual, expected) {
    // Safari does not like comparing ArrayBuffers directly. Wrapping in
    // a Float32Array solves this issue.
    const actualArray = new Float32Array(actual);
    const expectedArray = new Float32Array(expected);
    if (actualArray.length !== expectedArray.length) throw new Error('Expected ArrayBuffer to be of length ' + `${expectedArray.length}, but it was ${actualArray.length}`);
    for(let i = 0; i < expectedArray.length; i++){
        if (actualArray[i] !== expectedArray[i]) throw new Error(`Expected ArrayBuffer value at ${i} to be ` + `${expectedArray[i]} but got ${actualArray[i]} instead`);
    }
}
function $a05ad9cb1f55fcba$export$a3027a992fa03b9e(a) {
    for(let i = 0; i < a.length; i++){
        const val = a[i];
        if (Array.isArray(val)) $a05ad9cb1f55fcba$export$a3027a992fa03b9e(val);
        else a[i] = (0, $0775da5e684c8c0d$export$8146d2e653b87d6a)(val);
    }
    return a;
}
function $a05ad9cb1f55fcba$export$f4f3d816544d7e44(source) {
    const video = document.createElement('video');
    if ('playsInline' in video) // tslint:disable-next-line:no-any
    video.playsInline = true;
    video.muted = true;
    video.loop = true;
    video.style.position = 'fixed';
    video.style.left = '0px';
    video.style.top = '0px';
    video.preload = 'auto';
    video.appendChild(source);
    return new Promise((resolve)=>{
        video.addEventListener('loadeddata', (_)=>resolve(video));
        video.load();
    });
}
async function $a05ad9cb1f55fcba$export$899fbdb5fa08b653(video) {
    await video.play();
    if ('requestVideoFrameCallback' in video) await new Promise((resolve)=>{
        // tslint:disable-next-line:no-any
        video.requestVideoFrameCallback(resolve);
    });
}


class $5145d74e708096e8$export$d23b64058df0188a {
    constructor(mean, stdDeviation, dtype, truncated, seed){
        this.mean = mean;
        this.stdDev = stdDeviation;
        this.dtype = dtype;
        this.nextVal = NaN;
        this.truncated = truncated;
        if (this.truncated) {
            this.upper = this.mean + this.stdDev * 2;
            this.lower = this.mean - this.stdDev * 2;
        }
        const seedValue = seed ? seed : Math.random();
        this.random = $b451ab935132b01f$exports.alea(seedValue.toString());
    }
    /** Returns next sample from a Gaussian distribution. */ nextValue() {
        if (!isNaN(this.nextVal)) {
            const value = this.nextVal;
            this.nextVal = NaN;
            return value;
        }
        let resultX, resultY;
        let isValid = false;
        while(!isValid){
            let v1, v2, s;
            do {
                v1 = 2 * this.random() - 1;
                v2 = 2 * this.random() - 1;
                s = v1 * v1 + v2 * v2;
            }while (s >= 1 || s === 0);
            const mul = Math.sqrt(-2 * Math.log(s) / s);
            resultX = this.mean + this.stdDev * v1 * mul;
            resultY = this.mean + this.stdDev * v2 * mul;
            if (!this.truncated || this.isValidTruncated(resultX)) isValid = true;
        }
        if (!this.truncated || this.isValidTruncated(resultY)) this.nextVal = this.convertValue(resultY);
        return this.convertValue(resultX);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype == null || this.dtype === 'float32') return value;
        return Math.round(value);
    }
    /** Returns true if less than 2-standard-deviations from the mean. */ isValidTruncated(value) {
        return value <= this.upper && value >= this.lower;
    }
}
class $5145d74e708096e8$export$bffe1ad508acdb18 {
    constructor(alpha, beta, dtype, seed){
        this.alpha = alpha;
        this.beta = 1 / beta; // convert rate to scale parameter
        this.dtype = dtype;
        const seedValue = seed ? seed : Math.random();
        this.randu = $b451ab935132b01f$exports.alea(seedValue.toString());
        this.randn = new $5145d74e708096e8$export$d23b64058df0188a(0, 1, dtype, false, this.randu());
        if (alpha < 1) this.d = alpha + 2 / 3;
        else this.d = alpha - 1 / 3;
        this.c = 1 / Math.sqrt(9 * this.d);
    }
    /** Returns next sample from a gamma distribution. */ nextValue() {
        let x2, v0, v1, x, u, v;
        while(true){
            do {
                x = this.randn.nextValue();
                v = 1 + this.c * x;
            }while (v <= 0);
            v *= v * v;
            x2 = x * x;
            v0 = 1 - 0.331 * x2 * x2;
            v1 = 0.5 * x2 + this.d * (1 - v + Math.log(v));
            u = this.randu();
            if (u < v0 || Math.log(u) < v1) break;
        }
        v = 1 / this.beta * this.d * v;
        if (this.alpha < 1) v *= Math.pow(this.randu(), 1 / this.alpha);
        return this.convertValue(v);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype === 'float32') return value;
        return Math.round(value);
    }
}
class $5145d74e708096e8$export$1e4a6d1367ace404 {
    constructor(min = 0, max = 1, dtype, seed){
        /** Handles proper rounding for non floating point numbers. */ this.canReturnFloat = ()=>this.dtype == null || this.dtype === 'float32';
        this.min = min;
        this.range = max - min;
        this.dtype = dtype;
        if (seed == null) seed = Math.random();
        if (typeof seed === 'number') seed = seed.toString();
        if (!this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${min} - ${max} <= 1 and dtype is not float`);
        this.random = $b451ab935132b01f$exports.alea(seed);
    }
    convertValue(value) {
        if (this.canReturnFloat()) return value;
        return Math.round(value);
    }
    nextValue() {
        return this.convertValue(this.min + this.range * this.random());
    }
}
function $5145d74e708096e8$export$5f38b2eb2df54d68(values) {
    // https://en.wikipedia.org/wiki/Jarque%E2%80%93Bera_test
    const n = values.length;
    const s = $5145d74e708096e8$var$skewness(values);
    const k = $5145d74e708096e8$var$kurtosis(values);
    const jb = n / 6 * (Math.pow(s, 2) + 0.25 * Math.pow(k - 3, 2));
    // JB test requires 2-degress of freedom from Chi-Square @ 0.95:
    // http://www.itl.nist.gov/div898/handbook/eda/section3/eda3674.htm
    const CHI_SQUARE_2DEG = 5.991;
    if (jb > CHI_SQUARE_2DEG) throw new Error(`Invalid p-value for JB: ${jb}`);
}
function $5145d74e708096e8$export$3286e17febe230d(actual, expectedMean, expectedStdDev, epsilon) {
    if (epsilon == null) epsilon = (0, $a05ad9cb1f55fcba$export$e73bb4a504595b05)();
    const actualMean = $5145d74e708096e8$var$mean(actual);
    (0, $a05ad9cb1f55fcba$export$a09d1668dd6f88b6)(actualMean, expectedMean, epsilon);
    (0, $a05ad9cb1f55fcba$export$a09d1668dd6f88b6)($5145d74e708096e8$var$standardDeviation(actual, actualMean), expectedStdDev, epsilon);
}
function $5145d74e708096e8$var$mean(values) {
    let sum = 0;
    for(let i = 0; i < values.length; i++)sum += values[i];
    return sum / values.length;
}
function $5145d74e708096e8$var$standardDeviation(values, mean) {
    let squareDiffSum = 0;
    for(let i = 0; i < values.length; i++){
        const diff = values[i] - mean;
        squareDiffSum += diff * diff;
    }
    return Math.sqrt(squareDiffSum / values.length);
}
function $5145d74e708096e8$var$kurtosis(values) {
    // https://en.wikipedia.org/wiki/Kurtosis
    const valuesMean = $5145d74e708096e8$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum4 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum4 += Math.pow(v, 4);
    }
    return 1 / n * sum4 / Math.pow(1 / n * sum2, 2);
}
function $5145d74e708096e8$var$skewness(values) {
    // https://en.wikipedia.org/wiki/Skewness
    const valuesMean = $5145d74e708096e8$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum3 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum3 += Math.pow(v, 3);
    }
    return 1 / n * sum3 / Math.pow(1 / (n - 1) * sum2, 1.5);
}


/**
 * Creates a `tf.Tensor` with values sampled from a gamma distribution.
 *
 * ```js
 * tf.randomGamma([2, 2], 1).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param alpha The shape parameter of the gamma distribution.
 * @param beta The inverse scale parameter of the gamma distribution. Defaults
 *     to 1.
 * @param dtype The data type of the output. Defaults to float32.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $225d8d6649e70557$var$randomGamma_(shape, alpha, beta = 1, dtype = 'float32', seed) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    if (beta == null) beta = 1;
    if (dtype == null) dtype = 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Unsupported data type ${dtype}`);
    const rgamma = new (0, $5145d74e708096e8$export$bffe1ad508acdb18)(alpha, beta, dtype, seed);
    const res = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = rgamma.nextValue();
    return res.toTensor();
}
const $225d8d6649e70557$export$63a8048b65295cb7 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    randomGamma_: $225d8d6649e70557$var$randomGamma_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * ```js
 * tf.randomNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $10c29e3bf2646a65$var$randomNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    const randGauss = new (0, $5145d74e708096e8$export$d23b64058df0188a)(mean, stdDev, dtype, false, seed);
    const res = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $10c29e3bf2646a65$export$a0ac5549a8bec918 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    randomNormal_: $10c29e3bf2646a65$var$randomNormal_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * The generated values will have mean 0 and standard deviation 1.
 *
 * ```js
 * tf.randomStandardNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $4504dc5770f2ed6f$var$randomStandardNormal_(shape, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    return (0, $10c29e3bf2646a65$export$a0ac5549a8bec918)(shape, 0, 1, dtype, seed);
}
const $4504dc5770f2ed6f$export$5a8aa20f8ebaee69 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    randomStandardNormal_: $4504dc5770f2ed6f$var$randomStandardNormal_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a uniform distribution.
 *
 * The generated values follow a uniform distribution in the range [minval,
 * maxval). The lower bound minval is included in the range, while the upper
 * bound maxval is excluded.
 *
 * ```js
 * tf.randomUniform([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval The lower bound on the range of random values to generate.
 *   Defaults to 0.
 * @param maxval The upper bound on the range of random values to generate.
 *   Defaults to 1.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $efc9b1d03c9e7df6$var$randomUniform_(shape, minval = 0, maxval = 1, dtype = 'float32', seed) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    const res = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(shape, dtype);
    const random = new (0, $5145d74e708096e8$export$1e4a6d1367ace404)(minval, maxval, null, seed);
    for(let i = 0; i < res.values.length; i++)res.values[i] = random.nextValue();
    return res.toTensor();
}
const $efc9b1d03c9e7df6$export$bd6fd37822e292fa = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    randomUniform_: $efc9b1d03c9e7df6$var$randomUniform_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Creates a `tf.Tensor` with integers sampled from a uniform distribution.
 *
 * The generated values are uniform integers in the range [minval, maxval). The
 * lower bound minval is included in the range, while the upper bound maxval is
 * excluded.
 *
 * ```js
 * tf.randomUniformInt([2, 2], 0, 10).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval Inclusive lower bound on the generated integers.
 * @param maxval Exclusive upper bound on the generated integers.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $33d730612f2006bb$var$randomUniformInt_(shape, minval, maxval, seed) {
    // TODO(mattsoulanille): Handle optional seed2 input.
    return (0, $efc9b1d03c9e7df6$export$bd6fd37822e292fa)(shape, minval, maxval, 'int32', seed);
}
const $33d730612f2006bb$export$134fe7f07fd7b492 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    randomUniformInt_: $33d730612f2006bb$var$randomUniformInt_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $7a9b6c8fcbba0cfb$export$d02631cccf789723(start, stop, step = 1, dtype = 'float32') {
    if (step === 0) throw new Error('Cannot have a step of zero');
    const attrs = {
        start: start,
        stop: stop,
        step: step,
        dtype: dtype
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$9a58ef0d7ad3278c), {} /* inputs */ , attrs);
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the real part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the real part of each element in input considered as a complex number.
 *
 * If the input is real, it simply makes a clone.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.real(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $dd915d18522f1450$var$real_(input) {
    const $input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(input, 'input', 'real');
    const inputs = {
        input: $input
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f41305719b94e675), inputs);
}
const $dd915d18522f1450$export$9fc57fb453bdbd67 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    real_: $dd915d18522f1450$var$real_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes reciprocal of x element-wise: `1 / x`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, 2]);
 *
 * x.reciprocal().print();  // or tf.reciprocal(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7532fe118ac8f9c2$var$reciprocal_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reciprocal');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c6e4a23ed5e0415b), inputs);
}
const $7532fe118ac8f9c2$export$163bc8c839a1ac04 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reciprocal_: $7532fe118ac8f9c2$var$reciprocal_
});





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor` along a specified axis.
 *
 * Also available are stricter rank-specific methods that assert that `x` is
 * of the given rank:
 *   - `tf.reverse1d`
 *   - `tf.reverse2d`
 *   - `tf.reverse3d`
 *   - `tf.reverse4d`
 *
 * Except `tf.reverse1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.reverse().print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.reverse(axis).print();
 * ```
 * @param x The input tensor to be reversed.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $50ede1b45b382c7d$var$reverse_(x, axis) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reverse');
    const inputs = {
        x: $x
    };
    const attrs = {
        dims: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$53c81f36b32e1bba), inputs, attrs);
}
const $50ede1b45b382c7d$export$66c1ae025e96b4bc = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reverse_: $50ede1b45b382c7d$var$reverse_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor1D`.
 *
 * @param x The input tensor.
 */ function $2e0480d314e75948$var$reverse1d_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 1, ()=>`Error in reverse1D: x must be rank 1 but got rank ${$x.rank}.`);
    return (0, $50ede1b45b382c7d$export$66c1ae025e96b4bc)($x, 0);
}
const $2e0480d314e75948$export$ec29ded9cbde7103 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reverse1d_: $2e0480d314e75948$var$reverse1d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor2D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $2bce5c5a5a9cf199$var$reverse2d_(x, axis) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 2, ()=>`Error in reverse2D: x must be rank 2 but got rank ${$x.rank}.`);
    return (0, $50ede1b45b382c7d$export$66c1ae025e96b4bc)($x, axis);
}
const $2bce5c5a5a9cf199$export$12170f5f8cb48014 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reverse2d_: $2bce5c5a5a9cf199$var$reverse2d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor3D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $3b42757d0887c94a$var$reverse3d_(x, axis) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 3, ()=>`Error in reverse3D: x must be rank 3 but got rank ${$x.rank}.`);
    return (0, $50ede1b45b382c7d$export$66c1ae025e96b4bc)($x, axis);
}
const $3b42757d0887c94a$export$1ecb65b2ca41f0e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reverse3d_: $3b42757d0887c94a$var$reverse3d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor4D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $14a85ea26d68967a$var$reverse4d_(x, axis) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 4, ()=>`Error in reverse4D: x must be rank 4 but got rank ${$x.rank}.`);
    return (0, $50ede1b45b382c7d$export$66c1ae025e96b4bc)($x, axis);
}
const $14a85ea26d68967a$export$76a1df46e0e42da4 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    reverse4d_: $14a85ea26d68967a$var$reverse4d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes round of input `tf.Tensor` element-wise: `round(x)`.
 * It implements banker's rounding.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.round().print();  // or tf.round(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b8e64b0c5bfbfd9b$var$round_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'round');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c5ed3eef16c0612f), inputs);
}
const $b8e64b0c5bfbfd9b$export$2077e0241d6afd3c = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    round_: $b8e64b0c5bfbfd9b$var$round_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes reciprocal of square root of the input `tf.Tensor` element-wise:
 * `y = 1 / sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.rsqrt().print();  // or tf.rsqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5b6251eca9cf0835$var$rsqrt_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'rsqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7cc53aa09f5f3a2d), inputs);
}
const $5b6251eca9cf0835$export$1cc01d192953037e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    rsqrt_: $5b6251eca9cf0835$var$rsqrt_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes scaled exponential linear element-wise.
 *
 * `x < 0 ? scale * alpha * (exp(x) - 1) : scale * x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.selu().print();  // or tf.selu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a07498b92d052ec8$var$selu_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'selu');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$6760d858e6f2594a), inputs);
}
const $a07498b92d052ec8$export$a5f8240d9e99b438 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    selu_: $a07498b92d052ec8$var$selu_
});








/**
 * 2-D convolution with separable filters.
 *
 * Performs a depthwise convolution that acts separately on channels followed
 * by a pointwise convolution that mixes channels. Note that this is
 * separability between dimensions [1, 2] and 3, not spatial separability
 * between dimensions 1 and 2.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param depthwiseFilter The depthwise filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`. This is
 *     the filter used in the first step.
 * @param pointwiseFilter The pointwise filter tensor, rank 4, of shape
 *     `[1, 1, inChannels * channelMultiplier, outChannels]`. This is
 *     the filter used in the second step.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $95d8c4dd241bf4ec$var$separableConv2d_(x, depthwiseFilter, pointwiseFilter, strides, pad, dilation = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'separableConv2d');
    const $depthwiseFilter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(depthwiseFilter, 'depthwiseFilter', 'separableConv2d');
    const $pointwiseFilter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(pointwiseFilter, 'pointwiseFilter', 'separableConv2d');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    if (dataFormat === 'NCHW') throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in separableConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($depthwiseFilter.rank === 4, ()=>`Error in separableConv2d: depthwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($pointwiseFilter.rank === 4, ()=>`Error in separableConv2d: pointwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($pointwiseFilter.shape[0] === 1, ()=>`Error in separableConv2d: the first dimension of pointwise filter ` + ` must be 1, but got ${$pointwiseFilter.shape[0]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($pointwiseFilter.shape[1] === 1, ()=>`Error in separableConv2d: the second dimension of pointwise ` + `filter must be 1, but got ${$pointwiseFilter.shape[1]}.`);
    const inChannels = $depthwiseFilter.shape[2];
    const channelMultiplier = $depthwiseFilter.shape[3];
    $9e4a6174e3538e7d$export$a7a9523472993e97($pointwiseFilter.shape[2] === inChannels * channelMultiplier, ()=>`Error in separableConv2d: the third dimension of pointwise filter ` + `must be ${inChannels * channelMultiplier}, ` + `but got ${$pointwiseFilter.shape[2]}.`);
    const depthwise = (0, $e24ad3a56ebef85b$export$48a8ad9494a8fad8)(x4D, $depthwiseFilter, strides, pad, dataFormat, dilation);
    const pointwiseStride = 1;
    const res = (0, $f6443e17dde6414c$export$188f9215482e3db8)(depthwise, $pointwiseFilter, pointwiseStride, 'valid', dataFormat);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $95d8c4dd241bf4ec$export$2586c92899c2d0fb = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    separableConv2d_: $95d8c4dd241bf4ec$var$separableConv2d_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Computes the difference between two lists of numbers.
 *
 * Given a Tensor `x` and a Tensor `y`, this operation returns a Tensor `out`
 * that represents all values that are in `x` but not in `y`. The returned
 * Tensor `out` is sorted in the same order that the numbers appear in `x`
 * (duplicates are preserved). This operation also returns a Tensor indices that
 * represents the position of each out element in `x`. In other words:
 *
 * `out[i] = x[idx[i]] for i in [0, 1, ..., out.length - 1]`
 *
 * ```js
 * const x = [1, 2, 3, 4, 5, 6];
 * const y = [1, 3, 5];
 *
 * const [out, indices] = await tf.setdiff1dAsync(x, y);
 * out.print(); // [2, 4, 6]
 * indices.print(); // [1, 3, 5]
 * ```
 *
 * @param x 1-D Tensor. Values to keep.
 * @param y 1-D Tensor. Must have the same type as x. Values to exclude in the
 *     output.
 * @returns Promise of Tensor tuple [out, indices].
 *  out: Tensor with the same type as x.
 *  indices: A Tensor of type int32.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ async function $1035d52388d298b8$var$setdiff1dAsync_(x, y) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'setdiff1d');
    const $y = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(y, 'y', 'setdiff1d');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.dtype === $y.dtype, ()=>`x and y should have the same dtype, but got x (${$x.dtype}) and y (${$y.dtype}).`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 1, ()=>`x should be 1D tensor, but got x (${$x.shape}).`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($y.rank === 1, ()=>`y should be 1D tensor, but got y (${$y.shape}).`);
    const xVals = await $x.data();
    const yVals = await $y.data();
    const ySet = new Set(yVals);
    let outputSize = 0;
    for(let i = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) outputSize++;
    const buffer = new (0, $4b7222b1b59444b8$export$350df26cd52e08e1)([
        outputSize
    ], $x.dtype);
    const indices = new (0, $4b7222b1b59444b8$export$350df26cd52e08e1)([
        outputSize
    ], 'int32');
    for(let i = 0, p = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) {
        buffer.values[p] = xVals[i];
        indices.values[p] = i;
        p++;
    }
    return [
        buffer.toTensor(),
        indices.toTensor()
    ];
}
const $1035d52388d298b8$export$cd50e5d116ec1774 = $1035d52388d298b8$var$setdiff1dAsync_;



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns an element-wise indication of the sign of a number.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3, NaN, 0]);
 *
 * x.sign().print();  // or tf.sign(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d0f80db0cefed32f$var$sign_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'sign');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$1db683ad541682f6), inputs);
}
const $d0f80db0cefed32f$export$c5552dfdbc7cec71 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sign_: $d0f80db0cefed32f$var$sign_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes sin of the input Tensor element-wise: `sin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.sin().print();  // or tf.sin(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ce2da5a3db38a0bc$var$sin_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'sin', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$75be1b631f7687), inputs);
}
const $ce2da5a3db38a0bc$export$5de3937cb4b592ed = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sin_: $ce2da5a3db38a0bc$var$sin_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes hyperbolic sin of the input `tf.Tensor` element-wise: `sinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.sinh().print();  // or tf.sinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $790a75f63469cd19$var$sinh_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'sinh');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$b8c187376329d79b), inputs);
}
const $790a75f63469cd19$export$545004b505d7c555 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sinh_: $790a75f63469cd19$var$sinh_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 1D slice from 1D array starting at coordinates `begin` and is
 * of length `size`. See `slice` for details.
 */ function $56411002fecff555$var$slice1d_(x, begin, size) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'slice1d');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 1, ()=>`slice1d expects a rank-1 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)($x, [
        begin
    ], [
        size
    ]);
}
const $56411002fecff555$export$95433662b275eb82 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    slice1d_: $56411002fecff555$var$slice1d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 2D slice from a 2D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $50c4b0df2d499845$var$slice2d_(x, begin, size) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'slice2d');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 2, ()=>`slice2d expects a rank-2 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)($x, begin, size);
}
const $50c4b0df2d499845$export$e5c6a6611cb43a9d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    slice2d_: $50c4b0df2d499845$var$slice2d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 3D slice from a 3D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $c0cf3b7aeb1d3f8b$var$slice3d_(x, begin, size) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'slice3d');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 3, ()=>`slice3d expects a rank-3 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)($x, begin, size);
}
const $c0cf3b7aeb1d3f8b$export$dec56af20749d733 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    slice3d_: $c0cf3b7aeb1d3f8b$var$slice3d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 4D slice from a 4D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $59045228e6ed5362$var$slice4d_(x, begin, size) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'slice4d');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === 4, ()=>`slice4d expects a rank-4 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)($x, begin, size);
}
const $59045228e6ed5362$export$9833e35e879da26c = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    slice4d_: $59045228e6ed5362$var$slice4d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the softmax normalized vector given the logits.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $a8baad5804a245dd$var$softmax_(logits, dim = -1) {
    const $logits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(logits, 'logits', 'softmax', 'float32');
    if (dim === -1) dim = $logits.rank - 1;
    if (dim !== $logits.rank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and dim was ${dim}`);
    const inputs = {
        logits: $logits
    };
    const attrs = {
        dim: dim
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$350a526055d3ca6e), inputs, attrs);
}
const $a8baad5804a245dd$export$e008137e76238601 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    softmax_: $a8baad5804a245dd$var$softmax_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the inner-most
 * dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.fft().print();  // tf.spectral.fft(x).print();
 * ```
 * @param input The complex input to compute an fft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $0c1f0be368155dff$var$fft_(input) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.fft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$677347237c014ba), inputs);
}
const $0c1f0be368155dff$export$a535ef183b6128fa = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    fft_: $0c1f0be368155dff$var$fft_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Inverse fast Fourier transform.
 *
 * Computes the inverse 1-dimensional discrete Fourier transform over the
 * inner-most dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.ifft().print();  // tf.spectral.ifft(x).print();
 * ```
 * @param input The complex input to compute an ifft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $349f5d08af454fa3$var$ifft_(input) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.ifft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$21c6f576ae8100e8), inputs);
}
const $349f5d08af454fa3$export$776649b0bf8ce1fd = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    ifft_: $349f5d08af454fa3$var$ifft_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Inversed real value input fast Fourier transform.
 *
 * Computes the 1-dimensional inversed discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([0, 0, 0]);
 * const x = tf.complex(real, imag);
 *
 * x.irfft().print();
 * ```
 * @param input The real value input to compute an irfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $0d3fdeaac3c3258b$var$irfft_(input) {
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let ret;
    if (innerDimensionSize <= 2) {
        const complexInput = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(input, [
            batch,
            innerDimensionSize
        ]);
        ret = (0, $349f5d08af454fa3$export$776649b0bf8ce1fd)(complexInput);
    } else {
        // The length of unique components of the DFT of a real-valued signal
        // is 2 * (input_len - 1)
        const outputShape = [
            batch,
            2 * (innerDimensionSize - 1)
        ];
        const realInput = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $dd915d18522f1450$export$9fc57fb453bdbd67)(input), [
            batch,
            innerDimensionSize
        ]);
        const imagInput = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $8374544a706e8d44$export$d78fab5778ab392b)(input), [
            batch,
            innerDimensionSize
        ]);
        const realConjugate = (0, $50ede1b45b382c7d$export$66c1ae025e96b4bc)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(realInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1);
        const imagConjugate = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $50ede1b45b382c7d$export$66c1ae025e96b4bc)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(imagInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1), (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(-1));
        const r = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
            realInput,
            realConjugate
        ], 1);
        const i = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
            imagInput,
            imagConjugate
        ], 1);
        const complexInput = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $974747594bfdbaee$export$83a0e34f1302825b)(r, i), [
            outputShape[0],
            outputShape[1]
        ]);
        ret = (0, $349f5d08af454fa3$export$776649b0bf8ce1fd)(complexInput);
    }
    ret = (0, $dd915d18522f1450$export$9fc57fb453bdbd67)(ret);
    // reshape the result if the input is 3D tensor.
    if (input.rank === 3 && input.shape[0] !== 0) {
        const temp = ret;
        const batch = input.shape[0];
        ret = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(ret, [
            batch,
            ret.shape[0] / batch,
            ret.shape[1]
        ]);
        temp.dispose();
    }
    return ret;
}
const $0d3fdeaac3c3258b$export$f47f4e5bcd3d6a66 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    irfft_: $0d3fdeaac3c3258b$var$irfft_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Splits a `tf.Tensor` into sub tensors.
 *
 * If `numOrSizeSplits` is a number, splits `x` along dimension `axis`
 * into `numOrSizeSplits` smaller tensors.
 * Requires that `numOrSizeSplits` evenly divides `x.shape[axis]`.
 *
 * If `numOrSizeSplits` is a number array, splits `x` into
 * `numOrSizeSplits.length` pieces. The shape of the `i`-th piece has the
 * same size as `x` except along dimension `axis` where the size is
 * `numOrSizeSplits[i]`.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [2, 4]);
 * const [a, b] = tf.split(x, 2, 1);
 * a.print();
 * b.print();
 *
 * const [c, d, e] = tf.split(x, [1, 2, 1], 1);
 * c.print();
 * d.print();
 * e.print();
 * ```
 *
 * @param x The input tensor to split.
 * @param numOrSizeSplits Either an integer indicating the number of
 * splits along the axis or an array of integers containing the sizes of
 * each output tensor along the axis. If a number then it must evenly divide
 * `x.shape[axis]`; otherwise the sum of sizes must match `x.shape[axis]`.
 * Can contain one -1 indicating that dimension is to be inferred.
 * @param axis The dimension along which to split. Defaults to 0 (the first
 * dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $78850daf663d7633$var$split_(x, numOrSizeSplits, axis = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'split');
    const inputs = {
        x: $x
    };
    const attr = {
        numOrSizeSplits: numOrSizeSplits,
        axis: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8dffabb4071f05aa), inputs, attr);
}
const $78850daf663d7633$export$65980d18b75784e2 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    split_: $78850daf663d7633$var$split_
});





/**
 * Real value input fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 *
 * real.rfft().print();
 * ```
 * @param input The real value input to compute an rfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $ba0ceb1c91713e10$var$rfft_(input, fftLength) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(input.dtype === 'float32', ()=>`The dtype for rfft() must be real value but got ${input.dtype}`);
    let innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let adjustedInput;
    if (fftLength != null && fftLength < innerDimensionSize) {
        // Need to crop
        const begin = input.shape.map((v)=>0);
        const size = input.shape.map((v)=>v);
        size[input.shape.length - 1] = fftLength;
        adjustedInput = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(input, begin, size);
        innerDimensionSize = fftLength;
    } else if (fftLength != null && fftLength > innerDimensionSize) {
        // Need to pad with zeros
        const zerosShape = input.shape.map((v)=>v);
        zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
        adjustedInput = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
            input,
            (0, $a0e8420b37ff8039$export$4445a00dafa2633b)(zerosShape)
        ], input.shape.length - 1);
        innerDimensionSize = fftLength;
    } else adjustedInput = input;
    // Complement the input with zero imaginary numbers.
    const zerosInput = (0, $a5cb5e205b190f05$export$cb1f824e7733584d)(adjustedInput);
    const complexInput = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $974747594bfdbaee$export$83a0e34f1302825b)(adjustedInput, zerosInput), [
        batch,
        innerDimensionSize
    ]);
    const ret = (0, $0c1f0be368155dff$export$a535ef183b6128fa)(complexInput);
    // Exclude complex conjugations. These conjugations are put symmetrically.
    const half = Math.floor(innerDimensionSize / 2) + 1;
    const realValues = (0, $dd915d18522f1450$export$9fc57fb453bdbd67)(ret);
    const imagValues = (0, $8374544a706e8d44$export$d78fab5778ab392b)(ret);
    const realComplexConjugate = (0, $78850daf663d7633$export$65980d18b75784e2)(realValues, [
        half,
        innerDimensionSize - half
    ], realValues.shape.length - 1);
    const imagComplexConjugate = (0, $78850daf663d7633$export$65980d18b75784e2)(imagValues, [
        half,
        innerDimensionSize - half
    ], imagValues.shape.length - 1);
    const outputShape = adjustedInput.shape.slice();
    outputShape[adjustedInput.shape.length - 1] = half;
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $974747594bfdbaee$export$83a0e34f1302825b)(realComplexConjugate[0], imagComplexConjugate[0]), outputShape);
}
const $ba0ceb1c91713e10$export$72aff1768917e9e5 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    rfft_: $ba0ceb1c91713e10$var$rfft_
});





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns (a - b) * (a - b) element-wise.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * ```js
 * // Broadcast squared difference  a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $ccd5a9fa9e8cfcbf$var$squaredDifference_(a, b) {
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'squaredDifference');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'squaredDifference');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    (0, $5ede3b6f723b9f5a$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$2f922d20d66089c6), inputs, attrs);
}
const $ccd5a9fa9e8cfcbf$export$b178697fb6d0b37f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    squaredDifference_: $ccd5a9fa9e8cfcbf$var$squaredDifference_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Removes dimensions of size 1 from the shape of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4], [1, 1, 4]);
 * x.squeeze().print();
 * ```
 *
 * @param x The input tensor to be squeezed.
 * @param axis An optional list of numbers. If specified, only
 *     squeezes the dimensions listed. The dimension index starts at 0. It
 * is an error to squeeze a dimension that is not 1.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $d85a848eb4aff9d2$var$squeeze_(x, axis) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'squeeze', 'string_or_numeric');
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, (0, $9e4a6174e3538e7d$export$3106ace2a3b5396d)($x.shape, axis).newShape);
}
const $d85a848eb4aff9d2$export$889c931173b77c2f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    squeeze_: $d85a848eb4aff9d2$var$squeeze_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Stacks a list of rank-`R` `tf.Tensor`s into one rank-`(R+1)` `tf.Tensor`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.stack([a, b, c]).print();
 * ```
 *
 * @param tensors A list of tensor objects with the same shape and dtype.
 * @param axis The axis to stack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $63dcfd1fd312c0ca$var$stack_(tensors, axis = 0) {
    const $tensors = (0, $539f0ce07f2139cd$export$758e66616b4d410b)(tensors, 'tensors', 'stack', 'string_or_numeric');
    $9e4a6174e3538e7d$export$a7a9523472993e97($tensors.length >= 1, ()=>'Pass at least one tensor to tf.stack');
    if ($tensors.length > 0) $9e4a6174e3538e7d$export$a7a9523472993e97(axis <= $tensors[0].rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = $tensors;
    const attrs = {
        axis: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c26f40b29201e5b7), inputs, attrs);
}
const $63dcfd1fd312c0ca$export$a57ab32f40f83ea9 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    stack_: $63dcfd1fd312c0ca$var$stack_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a strided slice of a tensor.
 *
 * Roughly speaking, this op extracts a slice of size (end-begin)/stride from
 * the given input tensor (x). Starting at the location specified by begin the
 * slice continues by adding stride to the index until all dimensions are not
 * less than end. Note that a stride can be negative, which causes a reverse
 * slice.
 *
 * ```js
 * const t = tf.tensor3d([1, 1, 1 ,2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6],
 *    [3, 2, 3]);
 * t.stridedSlice([1, 0, 0], [2, 1, 3], [1, 1, 1]).print()  // [[[3, 3, 3]]]
 * t.stridedSlice([1, 0, 0], [2, 2, 3], [1, 1, 1]).print()  // [[[3, 3, 3],
 *                                                     // [4, 4, 4]]]
 * t.stridedSlice([1, -1, 0], [2, -3, 3], [1, -1, 1]).print() // [[[4, 4, 4],
 *                                                     // [3, 3, 3]]]
 * ```
 *
 * @param x The tensor to stride slice.
 * @param begin The coordinates to start the slice from.
 * @param end: The coordinates to end the slice at.
 * @param strides: The size of the slice.
 * @param beginMask: If the ith bit of beginMask is set, begin[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param endMask: If the ith bit of endMask is set, end[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param shrinkAxisMask: a bitmask where bit i implies that
 * the ith specification should shrink the dimensionality. begin and end must
 * imply a slice of size 1 in the dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $d49699aade4fd383$var$stridedSlice_(x, begin, end, strides, beginMask = 0, endMask = 0, ellipsisMask = 0, newAxisMask = 0, shrinkAxisMask = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'stridedSlice', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        end: end,
        strides: strides,
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$60c7f9ac271417a9), inputs, attrs);
}
const $d49699aade4fd383$export$4ae57224f3b0605c = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    stridedSlice_: $d49699aade4fd383$var$stridedSlice_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes tan of the input `tf.Tensor` element-wise, `tan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.tan().print();  // or tf.tan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6435bef2c868efdb$var$tan_(x) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'tan', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$115b2d5263ba5985), inputs);
}
const $6435bef2c868efdb$export$fcdd3b0b3246a325 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    tan_: $6435bef2c868efdb$var$tan_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $efe757e3a7d314f1$export$8133e3bf3cd8f464(values, dtype) {
    (0, $9e4a6174e3538e7d$export$44a06cc2759dd036)(values);
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 1) throw new Error('tensor1d() requires values to be a flat/TypedArray');
    const shape = null;
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $bb1fb3a4fbd244b1$export$b5469a65e8732256(values, shape, dtype) {
    (0, $9e4a6174e3538e7d$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 2) throw new Error('tensor2d() requires shape to have two numbers');
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 2 && inferredShape.length !== 1) throw new Error('tensor2d() requires values to be number[][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $4d7ed8a52e882f92$export$b43603ce4e7542a7(values, shape, dtype) {
    (0, $9e4a6174e3538e7d$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 4) throw new Error('tensor4d() requires shape to have four numbers');
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 4 && inferredShape.length !== 1) throw new Error('tensor4d() requires values to be number[][][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $933a6cb3fcb4c6cf$export$ab0278981fc9e727(values, shape, dtype) {
    (0, $9e4a6174e3538e7d$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 5) throw new Error('tensor5d() requires shape to have five numbers');
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 5 && inferredShape.length !== 1) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $619d041b413939f0$export$7b9f27dd2306a502(values, shape, dtype) {
    (0, $9e4a6174e3538e7d$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 6) throw new Error('tensor6d() requires shape to have six numbers');
    const inferredShape = (0, $539f0ce07f2139cd$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 6 && inferredShape.length !== 1) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    shape = shape || inferredShape;
    return (0, $0d6d4026377c0979$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices to the passed in tensor according to
 * indices. This operator is the similar to scatterNd op, except that the
 * udpates are scattered on an existing tensor (as opposed to a zero-tensor).
 *
 * If indices contains duplicates, then we pick the last update for the index.
 *
 * If an out of bound index is found on CPU, an error is returned.
 *
 * Warning: There are some GPU specific semantics for this operation.
 *  - If an out of bound index is found, the index is ignored.
 *  - The order in which updates are applied is nondeterministic, so the output
 * will be nondeterministic if indices contains duplicates.
 * ```js
 * const shape = [8];
 * const tensor = tf.ones(shape);
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 *
 * tf.tensorScatterUpdate(tensor, indices, updates).print();
 *    //[1, 11, 1, 10, 9, 1, 1, 12]
 * ```
 *
 * @param tensor A Tensor. Tensor to copy/update.
 * @param indices The tensor contains the indices into the output tensor, must
 *     have at least 2 axes: (num_updates, index_depth).
 * @param updates The tensor contains the value for the indices.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $7138839c02670096$var$tensorScatterUpdate_(tensor, indices, updates) {
    const $tensor = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(tensor, 'tensor', 'tensorScatterupdate');
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'tensorScatterupdate', 'int32');
    const $updates = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(updates, 'updates', 'tensorScatterupdate');
    $8abc84d2fff8230c$export$4d09d4ac8ba225dd($updates, $indices, $tensor.shape);
    if ($tensor.dtype !== $updates.dtype) throw new Error(`tensor and updates must have the same dtype, instead they are ${$tensor.dtype} and ${$updates.dtype}.`);
    const inputs = {
        tensor: $tensor,
        indices: $indices,
        updates: $updates
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$20050a140fd1de77), inputs, attrs);
}
const $7138839c02670096$export$d3ac02769385eb36 = (0, $90f933163f6ac994$export$f59964a629598e2)({
    tensorScatterUpdate_: $7138839c02670096$var$tensorScatterUpdate_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Finds the values and indices of the `k` largest entries along the last
 * dimension.
 *
 * If the input is a vector (rank=1), finds the k largest entries in the vector
 * and outputs their values and indices as vectors. Thus values[j] is the j-th
 * largest entry in input, and its index is indices[j].
 * For higher rank inputs, computes the top k entries along the last dimension.
 *
 * If two elements are equal, the lower-index element appears first.
 *
 * ```js
 * const a = tf.tensor2d([[1, 5], [4, 3]]);
 * const {values, indices} = tf.topk(a);
 * values.print();
 * indices.print();
 * ```
 * @param x 1-D or higher `tf.Tensor` with last dimension being at least `k`.
 * @param k Number of top elements to look for along the last dimension.
 * @param sorted If true, the resulting `k` elements will be sorted by the
 *     values in descending order.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $a34564a7dc7bfbd8$var$topk_(x, k = 1, sorted = true) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'topk');
    if ($x.rank === 0) throw new Error('topk() expects the input to be of rank 1 or higher');
    const lastDim = $x.shape[$x.shape.length - 1];
    if (k < 0) throw new Error(`'k' passed to topk() must be >= 0 but got ${k}`);
    if (k > lastDim) throw new Error(`'k' passed to topk() must be <= the last dimension (${lastDim}) ` + `but got ${k}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        k: k,
        sorted: sorted
    };
    const [values, indices] = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c593cd1ea0d02ebd), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $a34564a7dc7bfbd8$export$4e6b28a600f8b4df = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    topk_: $a34564a7dc7bfbd8$var$topk_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a truncated normal
 * distribution.
 *
 * ```js
 * tf.truncatedNormal([2, 2]).print();
 * ```
 *
 * The generated values follow a normal distribution with specified mean and
 * standard deviation, except that values whose magnitude is more than 2
 * standard deviations from the mean are dropped and re-picked.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output tensor.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $331921fa75ce86ae$var$truncatedNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type $ { dtype }`);
    const randGauss = new (0, $5145d74e708096e8$export$d23b64058df0188a)(mean, stdDev, dtype, true, seed);
    const res = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $331921fa75ce86ae$export$8ad5625727f3fa1d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    truncatedNormal_: $331921fa75ce86ae$var$truncatedNormal_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Finds unique elements along an axis of a tensor.
 *
 * It returns a tensor `values` containing all of the unique elements along the
 * `axis` of the given tensor `x` in the same order that they occur along the
 * `axis` in `x`; `x` does not need to be sorted. It also returns a tensor
 * `indices` the same size as the number of the elements in `x` along the `axis`
 * dimension. It contains the index in the unique output `values`.
 *
 * ```js
 * // A 1-D tensor
 * const a = tf.tensor1d([1, 1, 2, 4, 4, 4, 7, 8, 8]);
 * const {values, indices} = tf.unique(a);
 * values.print();   // [1, 2, 4, 7, 8,]
 * indices.print();  // [0, 0, 1, 2, 2, 2, 3, 4, 4]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=0
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 0)
 * values.print();   // [[1, 0, 0],
 *                   //  [2, 0, 0]]
 * indices.print();  // [0, 0, 1]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=1
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 1)
 * values.print();   // [[1, 0],
 *                   //  [1, 0],
 *                   //  [2, 0]]
 * indices.print();  // [0, 1, 1]
 * ```
 * @param x A tensor (int32, string, bool).
 * @param axis The axis of the tensor to find the unique elements.
 * @returns [uniqueElements, indices] (see above for details)
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $e5315ba40f5543a5$var$unique_(x, axis = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'unique', 'string_or_numeric');
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)($x.rank > 0, ()=>'The input tensor must be at least 1D');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    const [values, indices] = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8e3adf126971a183), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $e5315ba40f5543a5$export$7a5d5c156e7dc406 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    unique_: $e5315ba40f5543a5$var$unique_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the sum along segments of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const segmentIds = tf.tensor1d([1, 2, 0, 1], 'int32');
 * const numSegments = 3;
 *
 * x.unsortedSegmentSum(segmentIds, numSegments).print()
 * //or tf.unsortedSegmentSum(x, segmentIds, numSegments)
 * ```
 * @param x The `tf.Tensor` that will be summed along its segments.
 * @param segmentIds A `tf.Tensor1D` whose rank is equal to the rank of `x`'s
 * dimension along the `axis`.  Maps each element of `x` to a segment.
 * @param numSegments The number of distinct `segmentIds`.
 *
 * @doc {heading: 'Operations', subheading: 'Segment'}
 */ function $de795b6a78c6b444$var$unsortedSegmentSum_(x, segmentIds, numSegments) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'unsortedSegmentSum');
    const $segmentIds = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(segmentIds, 'segmentIds', 'unsortedSegmentSum', 'int32');
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)((0, $9e4a6174e3538e7d$export$357fc28f6427af8b)(numSegments), ()=>'numSegments must be of dtype int');
    const inputs = {
        x: $x,
        segmentIds: $segmentIds
    };
    const attrs = {
        numSegments: numSegments
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$af810663cded5fe2), inputs, attrs);
}
const $de795b6a78c6b444$export$ba7c4d144d85a309 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    unsortedSegmentSum_: $de795b6a78c6b444$var$unsortedSegmentSum_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Unstacks a `tf.Tensor` of rank-`R` into a list of rank-`(R-1)` `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * tf.unstack(a).forEach(tensor => tensor.print());
 * ```
 *
 * @param x A tensor object.
 * @param axis The axis to unstack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $18be989171d2a470$var$unstack_(x, axis = 0) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'unstack', 'string_or_numeric');
    $9e4a6174e3538e7d$export$a7a9523472993e97(axis >= -$x.shape.length && axis < $x.shape.length, ()=>`Axis = ${axis} is not in [-${$x.shape.length}, ${$x.shape.length})`);
    const inputs = {
        value: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$441ad6bfc5db8ab4), inputs, attrs);
}
const $18be989171d2a470$export$3c05285afa115eec = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    unstack_: $18be989171d2a470$var$unstack_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $fa8aa635c349da99$export$1e7f253df265a2ba(sortedSequence, values) {
    return (0, $415cbd1cccb3aab5$export$56fad8d65b0adbdd)(sortedSequence, values, 'right');
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $9452087a694f1769$export$3a9d57cefcd2c285(initialValue, trainable = true, name, dtype) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).makeVariable(initialValue, trainable, name, dtype);
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the Where kernel shared between cpu and webgl */ 
function $0e4e8bcceb5b6098$export$3a1005f93c3f4453(condShape, condVals) {
    const indices = [];
    for(let i = 0; i < condVals.length; i++)if (condVals[i]) indices.push(i);
    const inBuffer = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(condShape, 'int32');
    const out = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)([
        indices.length,
        condShape.length
    ], 'int32');
    for(let i = 0; i < indices.length; i++){
        const loc = inBuffer.indexToLoc(indices[i]);
        const offset = i * condShape.length;
        out.values.set(loc, offset);
    }
    return out.toTensor();
}



/**
 * Returns the coordinates of true elements of condition.
 *
 * The coordinates are returned in a 2-D tensor where the first dimension (rows)
 * represents the number of true elements, and the second dimension (columns)
 * represents the coordinates of the true elements. Keep in mind, the shape of
 * the output tensor can vary depending on how many true values there are in
 * input. Indices are output in row-major order. The resulting tensor has the
 * shape `[numTrueElems, condition.rank]`.
 *
 * This is analogous to calling the python `tf.where(cond)` without an x or y.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const result = await tf.whereAsync(cond);
 * result.print();
 * ```
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ async function $9b1ea25d493590e8$var$whereAsync_(condition) {
    const $condition = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(condition, 'condition', 'whereAsync', 'bool');
    const vals = await $condition.data();
    const res = (0, $0e4e8bcceb5b6098$export$3a1005f93c3f4453)($condition.shape, vals);
    if (condition !== $condition) $condition.dispose();
    return res;
}
const $9b1ea25d493590e8$export$b95962138b7a377d = $9b1ea25d493590e8$var$whereAsync_;




var $86fbfbd5b79067b7$exports = {};

$parcel$export($86fbfbd5b79067b7$exports, "booleanMaskAsync", () => $86fbfbd5b79067b7$export$358a56c181f796b3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Apply boolean mask to tensor.
 *
 * ```js
 * const tensor = tf.tensor2d([1, 2, 3, 4, 5, 6], [3, 2]);
 * const mask = tf.tensor1d([1, 0, 1], 'bool');
 * const result = await tf.booleanMaskAsync(tensor, mask);
 * result.print();
 * ```
 *
 * @param tensor N-D tensor.
 * @param mask K-D boolean tensor, K <= N and K must be known statically.
 * @param axis A 0-D int Tensor representing the axis in tensor to mask from.
 *     By default, axis is 0 which will mask from the first dimension.
 *     Otherwise K + axis <= N.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ async function $86fbfbd5b79067b7$var$booleanMaskAsync_(tensor, mask, axis) {
    const $tensor = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(tensor, 'tensor', 'boolMask');
    const $mask = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(mask, 'mask', 'boolMask', 'bool');
    const axisFrom = axis == null ? 0 : axis;
    const maskDim = $mask.rank;
    const tensorShape = $tensor.shape;
    $9e4a6174e3538e7d$export$a7a9523472993e97(maskDim > 0, ()=>'mask cannot be scalar');
    $9e4a6174e3538e7d$export$e08b27e7f37e2782(tensorShape.slice(axisFrom, axisFrom + maskDim), $mask.shape, `mask's shape must match the first K dimensions of tensor's shape,`);
    let leadingSize = 1;
    for(let i = axisFrom; i < axisFrom + maskDim; i++)leadingSize *= tensorShape[i];
    const targetTensorShape = tensorShape.slice(0, axisFrom).concat([
        leadingSize
    ], tensorShape.slice(axisFrom + maskDim));
    const reshapedTensor = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($tensor, targetTensorShape);
    const reshapedMask = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($mask, [
        -1
    ]);
    const positivePositions = await (0, $9b1ea25d493590e8$export$b95962138b7a377d)(reshapedMask);
    const indices = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(positivePositions, [
        1
    ]);
    const res = (0, $81ed3ff29d6a051b$export$9e05546f00427e8)(reshapedTensor, indices, axisFrom);
    // Ensure no memory leak.
    if (tensor !== $tensor) $tensor.dispose();
    if (mask !== $mask) $mask.dispose();
    indices.dispose();
    reshapedTensor.dispose();
    reshapedMask.dispose();
    positivePositions.dispose();
    return res;
}
const $86fbfbd5b79067b7$export$358a56c181f796b3 = $86fbfbd5b79067b7$var$booleanMaskAsync_;


var $4c4a44db5126e023$exports = {};

$parcel$export($4c4a44db5126e023$exports, "transpose", () => $4c4a44db5126e023$export$9cb09a71b7d66923);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * Transposes the `tf.Tensor`. Permutes the dimensions according to `perm`.
 *
 * The returned `tf.Tensor`'s dimension `i` will correspond to the input
 * dimension `perm[i]`. If `perm` is not given, it is set to `[n-1...0]`,
 * where `n` is the rank of the input `tf.Tensor`. Hence by default, this
 * operation performs a regular matrix transpose on 2-D input `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4, 5, 6], [2, 3]);
 *
 * a.transpose().print();  // or tf.transpose(a)
 * ```
 *
 * @param x The tensor to transpose.
 * @param perm The permutation of the dimensions of a.
 * @param conjugate Will conjugate complex input if true.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $4c4a44db5126e023$var$transpose_(x, perm, conjugate) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'transpose');
    if (perm == null) perm = $x.shape.map((s, i)=>i).reverse();
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.rank === perm.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of perm ${perm}.`);
    perm.forEach((axis)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(axis >= 0 && axis < $x.rank, ()=>`All entries in 'perm' must be between 0 and ${$x.rank - 1}` + ` but got ${perm}`);
    });
    if ($x.rank <= 1) return $x.clone();
    const inputs = {
        x: $x
    };
    const attrs = {
        perm: perm
    };
    if ($x.dtype === 'complex64') return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
        let $real = (0, $dd915d18522f1450$export$9fc57fb453bdbd67)($x);
        let $imag = (0, $8374544a706e8d44$export$d78fab5778ab392b)($x);
        $real = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7e714455f9a1f8f7), {
            x: $real
        }, attrs);
        $imag = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7e714455f9a1f8f7), {
            x: $imag
        }, attrs);
        if (conjugate) $imag = (0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)($imag);
        return (0, $974747594bfdbaee$export$83a0e34f1302825b)($real, $imag);
    });
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7e714455f9a1f8f7), inputs, attrs);
}
const $4c4a44db5126e023$export$9cb09a71b7d66923 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    transpose_: $4c4a44db5126e023$var$transpose_
});



var $a770653602fd0ab9$exports = {};

$parcel$export($a770653602fd0ab9$exports, "movingAverage", () => $a770653602fd0ab9$export$e0ccbd22a5b3aab6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * Compute the moving average of a variable.
 *
 * Without zeroDebias, the moving average operation is defined by:
 *   `v += delta`
 * where
 *   `delta = (1 - decay) * (x - v)`
 *
 * With zeroDebias (default), the `delta` term is scaled to debias the
 * effect of the (assumed) zero-initialization of `v`.
 *   `delta /= (1 - decay ^ step)`
 *
 * For more details on the zero-debiasing algorithm, see:
 *   https://arxiv.org/abs/1412.6980
 *
 * Note that this function is completely stateless and does not keep track of
 * step count. The step count needs to be maintained by the caller and passed
 * in as `step`.
 *
 * @param v The current moving average value.
 * @param x New input value, must have the same shape and dtype as `v`.
 * @param decay The decay factor. Typical values are 0.95 and 0.99.
 * @param step Step count.
 * @param zeroDebias: Whether zeroDebias is to be performed (default: `true`).
 * @returns The new moving average value.
 *
 * @doc {heading: 'Operations', subheading: 'Moving Average'}
 */ function $a770653602fd0ab9$var$movingAverage_(v, x, decay, step, zeroDebias = true) {
    const $v = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(v, 'v', 'movingAverage');
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'movingAverage');
    const $decay = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(decay, 'decay', 'movingAverage');
    (0, $186e2a8efb04b468$export$8a66522456343d17)($v, $x);
    $9e4a6174e3538e7d$export$a7a9523472993e97($9e4a6174e3538e7d$export$234180f8206db11b($v.shape, $x.shape), ()=>'Shape mismatch in v and x');
    const one = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1);
    const oneMinusDecay = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, $decay);
    let update = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)($x, $v), oneMinusDecay);
    if (zeroDebias) {
        $9e4a6174e3538e7d$export$a7a9523472993e97(step != null, ()=>'When using zeroDebias: true, step is required.');
        const $step = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(step, 'step', 'movingAverage');
        update = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(update, (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, (0, $dfeb0ec8a84c566a$export$9c297f60e22e3389)($decay, $step)));
    }
    return (0, $8efd352f234ac278$export$e16d8520af44a096)($v, update);
}
const $a770653602fd0ab9$export$e0ccbd22a5b3aab6 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    movingAverage_: $a770653602fd0ab9$var$movingAverage_
});


var $e5baeb58226512cf$exports = {};

$parcel$export($e5baeb58226512cf$exports, "scatterND", () => $e5baeb58226512cf$export$5349ba4fee4e4c76);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices within a zero tensor of the given shape tensor according to
 * indices. This operator is the inverse of the `tf.gatherND` operator which
 * extracts values or slices from a given tensor.
 *
 * ```js
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 * const shape = [8];
 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
 * ```
 *
 * @param indices The tensor contains the indices into the output tensor.
 * @param updates The tensor contains the value for the indices.
 * @param shape: The shape of the output tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $e5baeb58226512cf$var$scatterND_(indices, updates, shape) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(shape);
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'scatterND', 'int32');
    const $updates = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(updates, 'updates', 'scatterND');
    $8abc84d2fff8230c$export$4d09d4ac8ba225dd($updates, $indices, shape);
    const inputs = {
        indices: $indices,
        updates: $updates
    };
    const attrs = {
        shape: shape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$28eef6f0168af686), inputs, attrs);
}
const $e5baeb58226512cf$export$5349ba4fee4e4c76 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    scatterND_: $e5baeb58226512cf$var$scatterND_
});



var $a68df053c9fd42d0$exports = {};

$parcel$export($a68df053c9fd42d0$exports, "sparseToDense", () => $a68df053c9fd42d0$export$1be4b823dd1a3080);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Validate sparseToDense inputs.
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape number[]. Shape of the dense output tensor.
 * @param validateIndices boolean. indice validation is not supported, error
 * will be thrown if it is set.
 */ function $0254fa9ade2181c7$export$4d09d4ac8ba225dd(sparseIndices, sparseValues, outputShape, defaultValues) {
    if (sparseIndices.dtype !== 'int32') throw new Error('tf.sparseToDense() expects the indices to be int32 type,' + ` but the dtype was ${sparseIndices.dtype}.`);
    if (sparseIndices.rank > 2) throw new Error('sparseIndices should be a scalar, vector, or matrix,' + ` but got shape ${sparseIndices.shape}.`);
    const numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
    const numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
    if (outputShape.length !== numDims) throw new Error('outputShape has incorrect number of elements:,' + ` ${outputShape.length}, should be: ${numDims}.`);
    const numValues = sparseValues.size;
    if (!(sparseValues.rank === 0 || sparseValues.rank === 1 && numValues === numElems)) throw new Error('sparseValues has incorrect shape ' + `${sparseValues.shape}, should be [] or [${numElems}]`);
    if (sparseValues.dtype !== defaultValues.dtype) throw new Error('sparseValues.dtype must match defaultValues.dtype');
}





/**
 * Converts a sparse representation into a dense tensor.
 *
 * Builds an array dense with shape outputShape such that:
 *
 * // If sparseIndices is scalar
 * dense[i] = (i == sparseIndices ? sparseValues : defaultValue)
 *
 * // If sparseIndices is a vector, then for each i
 * dense[sparseIndices[i]] = sparseValues[i]
 *
 * // If sparseIndices is an n by d matrix, then for each i in [0, n)
 * dense[sparseIndices[i][0], ..., sparseIndices[i][d-1]] = sparseValues[i]
 * All other values in dense are set to defaultValue. If sparseValues is a
 * scalar, all sparse indices are set to this single value.
 *
 * If indices are repeated the final value is summed over all values for those
 * indices.
 *
 * ```js
 * const indices = tf.tensor1d([4, 5, 6, 1, 2, 3], 'int32');
 * const values = tf.tensor1d([10, 11, 12, 13, 14, 15], 'float32');
 * const shape = [8];
 * tf.sparseToDense(indices, values, shape).print();
 * ```
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape Shape of the dense output tensor. The type is inferred.
 * @param defaultValue Scalar. Value to set for indices not specified in
 * sparseIndices. Defaults to zero.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $a68df053c9fd42d0$var$sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue = 0) {
    (0, $9e4a6174e3538e7d$export$3d8b7619bac22cf5)(outputShape);
    const $sparseIndices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(sparseIndices, 'sparseIndices', 'sparseToDense', 'int32');
    const $sparseValues = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(sparseValues, 'sparseValues', 'sparseToDense', 'string_or_numeric');
    const $defaultValue = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(defaultValue, 'defaultValue', 'sparseToDense', $sparseValues.dtype);
    $0254fa9ade2181c7$export$4d09d4ac8ba225dd($sparseIndices, $sparseValues, outputShape, $defaultValue);
    const inputs = {
        sparseIndices: $sparseIndices,
        sparseValues: $sparseValues,
        defaultValue: $defaultValue
    };
    const attrs = {
        outputShape: outputShape
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$2c426709a9332421), inputs, attrs);
}
const $a68df053c9fd42d0$export$1be4b823dd1a3080 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sparseToDense_: $a68df053c9fd42d0$var$sparseToDense_
});


var $cf1cbb74dc1c5ef3$exports = {};

$parcel$export($cf1cbb74dc1c5ef3$exports, "gatherND", () => $cf1cbb74dc1c5ef3$export$15ec1b40f43d319f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Gather slices from input tensor into a Tensor with shape specified by
 * `indices`.
 *
 * `indices` is a K-dimensional integer tensor, best thought of as a
 * (K-1)-dimensional tensor of indices into input, where each element defines a
 * slice of input:
 * output[\\(i_0, ..., i_{K-2}\\)] = input[indices[\\(i_0, ..., i_{K-2}\\)]]
 *
 * Whereas in `tf.gather`, `indices` defines slices into the first dimension of
 * input, in `tf.gatherND`, `indices` defines slices into the first N dimensions
 * of input, where N = indices.shape[-1].
 *
 * The last dimension of indices can be at most the rank of input:
 * indices.shape[-1] <= input.rank
 *
 * The last dimension of `indices` corresponds to elements
 * (if indices.shape[-1] == input.rank) or slices
 * (if indices.shape[-1] < input.rank) along dimension indices.shape[-1] of
 * input.
 * The output tensor has shape
 * indices.shape[:-1] + input.shape[indices.shape[-1]:]
 *
 * Note that on CPU, if an out of bound index is found, an error is returned. On
 * GPU, if an out of bound index is found, a 0 is stored in the corresponding
 * output value.
 *
 * ```js
 * const indices = tf.tensor2d([0, 1, 1, 0], [2,2], 'int32');
 * const input = tf.tensor2d([9, 10, 11, 12], [2, 2]);
 * tf.gatherND(input, indices).print() // [10, 11]
 * ```
 *
 * @param x The tensor from which to gather values.
 * @param indices Index tensor, must be of type int32.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $cf1cbb74dc1c5ef3$var$gatherND_(x, indices) {
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'gatherND', 'int32');
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'gatherND', 'string_or_numeric');
    const inputs = {
        params: $x,
        indices: $indices
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$4ef6e37a23721703), inputs);
}
const $cf1cbb74dc1c5ef3$export$15ec1b40f43d319f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    gatherND_: $cf1cbb74dc1c5ef3$var$gatherND_
});


var $d534d97f12b33c25$exports = {};

$parcel$export($d534d97f12b33c25$exports, "dropout", () => $d534d97f12b33c25$export$fe05aa12367b4e47);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $86bfebeaaa07bd70$export$5cc59b1f6d856c8e(x, noiseShape) {
    if (noiseShape == null) return x.shape.slice();
    if ($9e4a6174e3538e7d$export$234180f8206db11b(x.shape, noiseShape)) return noiseShape;
    if (x.shape.length === noiseShape.length) {
        const newDimension = [];
        for(let i = 0; i < x.shape.length; i++)if (noiseShape[i] == null && x.shape[i] != null) newDimension.push(x.shape[i]);
        else newDimension.push(noiseShape[i]);
        return newDimension;
    }
    return noiseShape;
}






/**
 * Computes dropout.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 2, 1]);
 * const rate = 0.75;
 * const output = tf.dropout(x, rate);
 * output.print();
 * ```
 *
 * @param x A floating point Tensor or TensorLike.
 * @param rate A float in the range [0, 1). The probability that each element
 *   of x is discarded.
 * @param noiseShape An array of numbers of type int32, representing the
 * shape for randomly generated keep/drop flags. If the noiseShape has null
 * value, it will be automatically replaced with the x's relative dimension
 * size. Optional.
 * @param seed Used to create random seeds. Optional.
 * @returns A Tensor of the same shape of x.
 *
 * @doc {heading: 'Operations', subheading: 'Dropout'}
 */ function $d534d97f12b33c25$var$dropout_(x, rate, noiseShape, seed) {
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'dropout');
    $9e4a6174e3538e7d$export$a7a9523472993e97($x.dtype === 'float32', ()=>`x has to be a floating point tensor since it's going to be ` + `scaled, but got a ${$x.dtype} tensor instead.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(rate >= 0 && rate < 1, ()=>`rate must be a float in the range [0, 1), but got ${rate}.`);
    if (rate === 0) return x instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? $x.clone() : $x;
    const $noiseShape = (0, $86bfebeaaa07bd70$export$5cc59b1f6d856c8e)($x, noiseShape);
    const keepProb = 1 - rate;
    const multiplier = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $2f0cea174d82bbd9$export$a3fe094919f356fd)((0, $8efd352f234ac278$export$e16d8520af44a096)((0, $efc9b1d03c9e7df6$export$bd6fd37822e292fa)($noiseShape, 0, 1, 'float32', seed), keepProb)), keepProb);
    return (0, $582b63c19659e1cf$export$6e3a27864ab166fe)($x, multiplier);
}
const $d534d97f12b33c25$export$fe05aa12367b4e47 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    dropout_: $d534d97f12b33c25$var$dropout_
});


var $a9d9c2aa71ee0001$exports = {};

$parcel$export($a9d9c2aa71ee0001$exports, "enclosingPowerOfTwo", () => $a9d9c2aa71ee0001$export$6fc2fe3b19043bf3);
$parcel$export($a9d9c2aa71ee0001$exports, "cosineWindow", () => $a9d9c2aa71ee0001$export$e875398ce092ee45);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $a9d9c2aa71ee0001$export$6fc2fe3b19043bf3(value) {
    // Return 2**N for integer N such that 2**N >= value.
    return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2.0))));
}
function $a9d9c2aa71ee0001$export$e875398ce092ee45(windowLength, a, b) {
    const even = 1 - windowLength % 2;
    const newValues = new Float32Array(windowLength);
    for(let i = 0; i < windowLength; ++i){
        const cosArg = 2.0 * Math.PI * i / (windowLength + even - 1);
        newValues[i] = a - b * Math.cos(cosArg);
    }
    return (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(newValues, 'float32');
}


var $f374788c740c08d5$exports = {};

$parcel$export($f374788c740c08d5$exports, "inTopKAsync", () => $f374788c740c08d5$export$395be9a27e7de9f0);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Returns whether the targets are in the top K predictions.
 *
 * ```js
 * const predictions = tf.tensor2d([[20, 10, 40, 30], [30, 50, -20, 10]]);
 * const targets = tf.tensor1d([2, 0]);
 * const precision = await tf.inTopKAsync(predictions, targets);
 * precision.print();
 * ```
 * @param predictions 2-D or higher `tf.Tensor` with last dimension being
 *     at least `k`.
 * @param targets 1-D or higher `tf.Tensor`.
 * @param k Optional Number of top elements to look at for computing precision,
 *     default to 1.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ async function $f374788c740c08d5$var$inTopKAsync_(predictions, targets, k = 1) {
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'inTopK');
    const $targets = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(targets, 'targets', 'inTopK');
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)($predictions.rank > 1, ()=>'inTopK() expects the predictions to be of rank 2 or higher, ' + `but got ${$predictions.rank}`);
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)($predictions.rank - 1 === $targets.rank, ()=>`predictions rank should be 1 larger than ` + `targets rank, but got predictions rank ` + `${$predictions.rank} and targets rank ${$targets.rank}`);
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($predictions.shape.slice(0, $predictions.shape.length - 1), $targets.shape, `predictions's shape should be align with the targets' shape, ` + 'except the last dimension.');
    const lastDim = $predictions.shape[$predictions.shape.length - 1];
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(k > 0 && k <= lastDim, ()=>`'k' passed to inTopK() must be > 0 && <= the predictions last ` + `dimension (${lastDim}), but got ${k}`);
    const predictionsVals = await $predictions.data();
    const targetsVals = await $targets.data();
    // Reshape predictionsVals into a 2d tensor [batch, lastDim]
    // and look up topK along lastDim.
    const [batch, size] = [
        predictionsVals.length / lastDim,
        lastDim
    ];
    const precision = (0, $9e4a6174e3538e7d$export$3b783bdb77632623)('bool', batch);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = predictionsVals.subarray(offset, offset + size);
        const valAndInd = [];
        for(let i = 0; i < vals.length; i++)valAndInd.push({
            value: vals[i],
            index: i
        });
        valAndInd.sort((a, b)=>b.value - a.value);
        precision[b] = 0;
        for(let i = 0; i < k; i++)if (valAndInd[i].index === targetsVals[b]) {
            precision[b] = 1;
            break;
        }
    }
    if (predictions !== $predictions) $predictions.dispose();
    if (targets !== $targets) $targets.dispose();
    // Output precision has the same shape as targets.
    return (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)(precision, $targets.shape, 'bool');
}
const $f374788c740c08d5$export$395be9a27e7de9f0 = $f374788c740c08d5$var$inTopKAsync_;



var $2712b959896a25e5$exports = {};

$parcel$export($2712b959896a25e5$exports, "conv2d", () => $47d018cbbd2d9571$export$188f9215482e3db8);
$parcel$export($2712b959896a25e5$exports, "depthwiseConv2d", () => $0b61fafee0d34c2f$export$48a8ad9494a8fad8);
$parcel$export($2712b959896a25e5$exports, "matMul", () => $6ebb6ad24087aa3a$export$6706882a873e9a8f);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 








/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the derivative of the filter of a 2D convolution.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     [batch, height, width, inChannels]. If rank 3, batch of 1 is assumed.
 * @param dy The dy image, of rank 4 or rank 3, of shape
 *     [batch, height, width, outDepth]. If rank 3, batch of 1 is assumed.
 * @param filterShape The shape of the filter, length 4,
 *     [filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $5670c187e2f97ce4$var$conv2DBackpropFilter_(x, dy, filterShape, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ` + `${x4D.shape}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(dy4D.rank === 4, ()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ` + `${dy4D.shape}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(filterShape.length === 4, ()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ` + `${filterShape}.`);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $9e4a6174e3538e7d$export$a7a9523472993e97(inDepth === filterShape[2], ()=>`Error in conv2dDerFilter: depth of input ${inDepth}) must ` + `match input depth in filter (${filterShape[2]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(outDepth === filterShape[3], ()=>`Error in conv2dDerFilter: depth of dy (${outDepth}) must ` + `match output depth for filter (${filterShape[3]}).`);
    $f9c374363849dff2$export$1b3400c26a44af8('conv2dDerFilter', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$32a8943c0f1ca5a7), inputs, attrs);
}
const $5670c187e2f97ce4$export$652a30c9379f3de7 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    conv2DBackpropFilter_: $5670c187e2f97ce4$var$conv2DBackpropFilter_
});







/**
 * Computes a 2D convolution over the input x, optionally fused with adding a
 * bias and applying an activation.
 *
 * ```js
 * const inputDepth = 2;
 * const inShape = [2, 2, 2, inputDepth];
 * const outputDepth = 2;
 * const fSize = 1;
 * const pad = 0;
 * const strides = 1;
 *
 * const x = tf.tensor4d( [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
 * 16], inShape);
 * const w = tf.tensor4d([-1, 1, -2, 0.5], [fSize, fSize, inputDepth,
 * outputDepth]);
 *
 * tf.fused.conv2d({ x, filter: w, strides, pad, dataFormat: 'NHWC',
 * dilations: [1, 1], bias: tf.scalar(5), activation: 'relu' }).print();
 * ```
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid` output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`) to be
 *     applied
 *      after biasAdd.
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $47d018cbbd2d9571$var$fusedConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    activation = activation || 'linear';
    if ((0, $c561cfa6a1183f44$export$4904add493b957ab)((0, $6a645535e157b279$export$33b63313cc511a3b).state.gradientDepth, activation) === false) {
        // TODO: Transpose bias and preluActivationWeights properly for NCHW
        // format before computation.
        $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NHWC', ()=>`Error in fused conv2d: got dataFormat of ${dataFormat} but ` + `only NHWC is currently supported for the case of gradient depth ` + `is 0 and the activation is not linear.`);
        let result = (0, $f6443e17dde6414c$export$188f9215482e3db8)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $8efd352f234ac278$export$e16d8520af44a096)(result, bias);
        return (0, $c561cfa6a1183f44$export$a0f250a2ba84196)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in fused conv2d: input must be rank 4, but got rank ` + `${x4D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in fused conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $f9c374363849dff2$export$1b3400c26a44af8('fused conv2d', pad, dimRoundingMode);
    const inputChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.shape[2] === inputChannels, ()=>`Error in conv2d: depth of input (${inputChannels}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $f9c374363849dff2$export$fdd37387e0a3c672(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode);
    let $bias;
    if (bias != null) {
        $bias = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($bias, $x);
        // According to TensorFlow, the bias is supposed be a 1-D tensor or a
        // scalar.
        //
        // 3-D or 4-D bias is not disabled for NHWC format, because they are
        // currently being used in some cases. For examplem in our code base,
        // https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/fused_conv2d_test.ts#L1972.
        if (dataFormat === 'NHWC') $5ede3b6f723b9f5a$export$a3e2a38a57ec8318(convInfo.outShape, $bias.shape);
        else {
            $9e4a6174e3538e7d$export$a7a9523472993e97($bias.shape.length <= 1, ()=>`Error in fused conv2d: only supports scalar or 1-D Tensor ` + `bias for NCHW format but got the bias of ` + `rank-${$bias.shape.length}.`);
            $9e4a6174e3538e7d$export$a7a9523472993e97($bias.shape.length === 0 || $bias.shape[0] === convInfo.outChannels || $bias.shape[0] === 1, ()=>`Error in fused conv2d: bias shape (${$bias.shape}) is not ` + `compatible with the number of output channels ` + `(${convInfo.outChannels})`);
        }
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) {
        // PReLU's activation weights could be a scalar, a 1-D tensor or a 3-D
        // tensor.
        const alphaShape = preluActivationWeights.shape;
        $9e4a6174e3538e7d$export$a7a9523472993e97(alphaShape.length <= 1 || alphaShape.length === 3, ()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or ` + `3-D Tensor PReLU activation weights but got a tensor of ` + `rank-${alphaShape.length}.`);
        if (alphaShape.length === 1) // Whether the data format is NCHW or NHWC, the 1-D PReLU activation
        // weights tensor should be aligned with the output channels of conv2d
        // result.
        $9e4a6174e3538e7d$export$a7a9523472993e97(alphaShape[0] === 1 || alphaShape[0] === convInfo.outChannels, ()=>`Error in fused conv2d: PReLU activation weights ` + `(${alphaShape}) is not compatible with the number of output ` + `channels (${convInfo.outChannels}).`);
        else if (alphaShape.length === 3) // Whether the data format is NCHW or NHWC, the PReLU activation weights
        // tensor should has the compatible shape with the result of conv2d.
        try {
            $5ede3b6f723b9f5a$export$a3e2a38a57ec8318(alphaShape, convInfo.outShape);
        } catch (e) {
            const errMsg = `Error in fused conv2d: PReLU activation weights (${alphaShape}) ` + `is not compatible with the output shape of the conv2d ` + `(${convInfo.outShape}).`;
            throw Error(errMsg);
        }
        $preluActivationWeights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(preluActivationWeights, 'prelu weights', 'fused conv2d');
    }
    const grad = (dy, saved)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97(dataFormat === 'NHWC', ()=>`Error in gradient of fused conv2D: got dataFormat of ${dataFormat} but only NHWC is currently supported.`);
        const [$filter, x4D, y, $bias] = saved;
        const dyActivation = (0, $c561cfa6a1183f44$export$a1905aed55f51aef)(dy, y, activation);
        $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$f16174446c2d5b2a(dilations), ()=>'Error in gradient of fused conv2D: ' + `dilation rates greater than 1 ` + `are not yet supported in gradients. Got dilations '${dilations}'`);
        const xDer = (0, $fb5a8be2da90b3a1$export$633310eed0c26e72)(x4D.shape, dyActivation, $filter, strides, pad);
        const filterDer = (0, $5670c187e2f97ce4$export$652a30c9379f3de7)(x4D, dyActivation, $filter.shape, strides, pad);
        const der = [
            xDer,
            filterDer
        ];
        if ($bias != null) {
            const biasDer = (0, $c561cfa6a1183f44$export$1a797e236ae09d1f)($bias, dyActivation);
            der.push(biasDer);
        }
        return der;
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((x4D, filter, save)=>{
            let res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$86f8a8e3a8f2a8f2), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((x4D, filter, bias, save)=>{
            let res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$86f8a8e3a8f2a8f2), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $47d018cbbd2d9571$export$188f9215482e3db8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    fusedConv2d_: $47d018cbbd2d9571$var$fusedConv2d_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $c5dd5f9bf352dd5c$var$depthwiseConv2dNativeBackpropFilter_(x, dy, filterShape, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c99f139e0d4d1833), inputs, attrs);
}
const $c5dd5f9bf352dd5c$export$cc0ae65e9edc7e1a = (0, $90f933163f6ac994$export$f59964a629598e2)({
    depthwiseConv2dNativeBackpropFilter_: $c5dd5f9bf352dd5c$var$depthwiseConv2dNativeBackpropFilter_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $3896d659df3c1a0a$var$depthwiseConv2dNativeBackpropInput_(xShape, dy, filter, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
    }
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        inputShape: xShape
    };
    const res = // tslint:disable-next-line: no-unnecessary-type-assertion
    (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8649ca3b17033a24), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $3896d659df3c1a0a$export$37e2ab95a4a4c24b = (0, $90f933163f6ac994$export$f59964a629598e2)({
    depthwiseConv2dNativeBackpropInput_: $3896d659df3c1a0a$var$depthwiseConv2dNativeBackpropInput_
});





/**
 * Computes depthwise 2D convolution, optionally fused with adding a
 * bias and applying an activation.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`).
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $0b61fafee0d34c2f$var$fusedDepthwiseConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    if ((0, $c561cfa6a1183f44$export$4904add493b957ab)((0, $6a645535e157b279$export$33b63313cc511a3b).state.gradientDepth, activation) === false) {
        let result = (0, $e24ad3a56ebef85b$export$48a8ad9494a8fad8)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $8efd352f234ac278$export$e16d8520af44a096)(result, bias);
        return (0, $c561cfa6a1183f44$export$a0f250a2ba84196)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in fused depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in fused depthwiseConv2d: filter must be rank 4, ` + `but got rank ${$filter.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(x4D.shape[3] === $filter.shape[2], ()=>`Error in fused depthwiseConv2d: number of input channels ` + `(${x4D.shape[3]}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    if (dilations == null) dilations = [
        1,
        1
    ];
    $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in fused depthwiseConv2d: Either strides or dilations must ' + `be 1. Got strides ${strides} and dilations '${dilations}'`);
    $f9c374363849dff2$export$1b3400c26a44af8('fused depthwiseConv2d', pad, dimRoundingMode);
    const convInfo = $f9c374363849dff2$export$fdd37387e0a3c672(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true);
    let $bias;
    if (bias != null) {
        $bias = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($bias, $x);
        $5ede3b6f723b9f5a$export$a3e2a38a57ec8318(convInfo.outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(preluActivationWeights, 'prelu weights', 'fused depthwiseConv2d');
    const grad = (dy, saved)=>{
        $9e4a6174e3538e7d$export$a7a9523472993e97($f9c374363849dff2$export$f16174446c2d5b2a(dilations), ()=>'Error in gradient of fused depthwiseConv2d: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${dilations}'`);
        const [$filter, x4D, y, bias] = saved;
        const dyActivation = (0, $c561cfa6a1183f44$export$a1905aed55f51aef)(dy, y, activation);
        const xDer = (0, $3896d659df3c1a0a$export$37e2ab95a4a4c24b)(x4D.shape, dyActivation, $filter, strides, pad, dilations, dimRoundingMode);
        const filterDer = (0, $c5dd5f9bf352dd5c$export$cc0ae65e9edc7e1a)(x4D, dyActivation, $filter.shape, strides, pad, dilations, dimRoundingMode);
        if (bias != null) {
            const biasDer = (0, $c561cfa6a1183f44$export$1a797e236ae09d1f)($bias, dyActivation);
            return [
                xDer,
                filterDer,
                biasDer
            ];
        }
        return [
            xDer,
            filterDer
        ];
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((x4D, filter, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5a249e8f498c02c1), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((x4D, filter, bias, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5a249e8f498c02c1), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $0b61fafee0d34c2f$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    fusedDepthwiseConv2d_: $0b61fafee0d34c2f$var$fusedDepthwiseConv2d_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 











/**
 * Computes the dot product of two matrices with optional activation and bias.
 *
 * ```js
 * const a = tf.tensor2d([-1, -2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const bias = tf.tensor2d([1, 2], [1, 2]);
 *
 * tf.fused.matMul({a, b, bias, activation: 'relu'}).print();
 * ```
 *
 * @param obj An object with the following properties:
 * - `a` First matrix in dot product operation.
 * - `b` Second matrix in dot product operation.
 * - `transposeA` If true, `a` is transposed before multiplication.
 * - `transposeB` If true, `b` is transposed before multiplication.
 * - `bias` Matrix to be added to the result.
 * - `activation` Name of activation kernel (defaults to `linear`).
 * - `preluActivationWeights` Tensor of prelu weights.
 * - `leakyreluAlpha` Alpha of leakyrelu.
 */ function $6ebb6ad24087aa3a$var$fusedMatMul_({ a: a, b: b, transposeA: transposeA = false, transposeB: transposeB = false, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha = 0.2 }) {
    if ((0, $c561cfa6a1183f44$export$4904add493b957ab)((0, $6a645535e157b279$export$33b63313cc511a3b).state.gradientDepth, activation) === false) {
        let result = (0, $8a13d3789789217b$export$6706882a873e9a8f)(a, b, transposeA, transposeB);
        if (bias != null) result = (0, $8efd352f234ac278$export$e16d8520af44a096)(result, bias);
        return (0, $c561cfa6a1183f44$export$a0f250a2ba84196)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    let $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'fused matMul');
    let $b = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(b, 'b', 'fused matMul');
    [$a, $b] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($a, $b);
    const innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
    const innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
    const outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
    const outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
    const outerDimsA = $a.shape.slice(0, -2);
    const outerDimsB = $b.shape.slice(0, -2);
    const batchDimA = $9e4a6174e3538e7d$export$b4c3214a70a0e73f(outerDimsA);
    const batchDimB = $9e4a6174e3538e7d$export$b4c3214a70a0e73f(outerDimsB);
    $9e4a6174e3538e7d$export$a7a9523472993e97(innerShapeA === innerShapeB, ()=>`Error in fused matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${$a.shape} and ` + `${$b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const outShapeOuterDims = $5ede3b6f723b9f5a$export$a3e2a38a57ec8318($a.shape.slice(0, -2), $b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    const a3D = transposeA ? (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($a, [
        batchDimA,
        innerShapeA,
        outerShapeA
    ]) : (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($a, [
        batchDimA,
        outerShapeA,
        innerShapeA
    ]);
    const b3D = transposeB ? (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($b, [
        batchDimB,
        outerShapeB,
        innerShapeB
    ]) : (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($b, [
        batchDimB,
        innerShapeB,
        outerShapeB
    ]);
    let $bias;
    if (bias != null) {
        $bias = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(bias, 'bias', 'fused matMul');
        [$bias] = (0, $186e2a8efb04b468$export$8b0e24c749a224d7)($bias, $a);
        $5ede3b6f723b9f5a$export$a3e2a38a57ec8318(outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(preluActivationWeights, 'prelu weights', 'fused matMul');
    const grad = (dy, saved)=>{
        const [a3D, b3D, y, $bias] = saved;
        // we reshape dy because the result of the forward is not
        // necessarily going to be a 3d tensor due to a reshape done at the end of
        // the customOp.
        const dyActivation = (0, $c561cfa6a1183f44$export$a1905aed55f51aef)((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, y.shape), y, activation);
        let aDer;
        let bDer;
        if (!transposeA && !transposeB) {
            aDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(dyActivation, b3D, false, true);
            bDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(a3D, dyActivation, true, false);
        } else if (!transposeA && transposeB) {
            aDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(dyActivation, b3D, false, false);
            bDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(dyActivation, a3D, true, false);
        } else if (transposeA && !transposeB) {
            aDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(b3D, dyActivation, false, true);
            bDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(a3D, dyActivation, false, false);
        } else {
            aDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(b3D, dyActivation, true, true);
            bDer = (0, $8a13d3789789217b$export$6706882a873e9a8f)(dyActivation, a3D, true, true);
        }
        if (bias != null) {
            const biasDer = (0, $c561cfa6a1183f44$export$1a797e236ae09d1f)($bias, dyActivation);
            return [
                aDer,
                bDer,
                biasDer
            ];
        } else return [
            aDer,
            bDer
        ];
    };
    const inputs = {
        a: a3D,
        b: b3D,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((a3D, b3D, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8d1af0f7c2a4da9e), inputs, attrs);
            save([
                a3D,
                b3D,
                res
            ]);
            return {
                value: (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, outShape),
                gradFunc: grad
            };
        });
        return customOp(a3D, b3D);
    } else {
        const customOpWithBias = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((a3D, b3D, $bias, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8d1af0f7c2a4da9e), inputs, attrs);
            save([
                a3D,
                b3D,
                res,
                $bias
            ]);
            return {
                value: (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, outShape),
                gradFunc: grad
            };
        });
        return customOpWithBias(a3D, b3D, $bias);
    }
}
const $6ebb6ad24087aa3a$export$6706882a873e9a8f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    fusedMatMul_: $6ebb6ad24087aa3a$var$fusedMatMul_
});




/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Generate a hamming window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hammingWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $927342ffc2919545$var$hammingWindow_(windowLength) {
    return (0, $a9d9c2aa71ee0001$export$e875398ce092ee45)(windowLength, 0.54, 0.46);
}
const $927342ffc2919545$export$941eafcc99b559fa = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    hammingWindow_: $927342ffc2919545$var$hammingWindow_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Generate a Hann window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hannWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $f28f4f764f4a5d69$var$hannWindow_(windowLength) {
    return (0, $a9d9c2aa71ee0001$export$e875398ce092ee45)(windowLength, 0.5, 0.5);
}
const $f28f4f764f4a5d69$export$f498cfeee84e5e59 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    hannWindow_: $f28f4f764f4a5d69$var$hannWindow_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Expands input into frames of frameLength.
 * Slides a window size with frameStep.
 *
 * ```js
 * tf.signal.frame([1, 2, 3], 2, 1).print();
 * ```
 * @param signal The input tensor to be expanded
 * @param frameLength Length of each frame
 * @param frameStep The frame hop size in samples.
 * @param padEnd Whether to pad the end of signal with padValue.
 * @param padValue A number to use where the input signal does
 *     not exist when padEnd is True.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $155310928eda6858$var$frame_(signal, frameLength, frameStep, padEnd = false, padValue = 0) {
    let start = 0;
    const output = [];
    while(start + frameLength <= signal.size){
        output.push((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(signal, start, frameLength));
        start += frameStep;
    }
    if (padEnd) while(start < signal.size){
        const padLen = start + frameLength - signal.size;
        const pad = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
            (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(signal, start, frameLength - padLen),
            (0, $a1afd8d5a9faad9a$export$9563e054e6f787fb)([
                padLen
            ], padValue)
        ]);
        output.push(pad);
        start += frameStep;
    }
    if (output.length === 0) return (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([], [
        0,
        frameLength
    ]);
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(output), [
        output.length,
        frameLength
    ]);
}
const $155310928eda6858$export$2cef06c20297c17d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    frame_: $155310928eda6858$var$frame_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the Short-time Fourier Transform of signals
 * See: https://en.wikipedia.org/wiki/Short-time_Fourier_transform
 *
 * ```js
 * const input = tf.tensor1d([1, 1, 1, 1, 1])
 * tf.signal.stft(input, 3, 1).print();
 * ```
 * @param signal 1-dimensional real value tensor.
 * @param frameLength The window length of samples.
 * @param frameStep The number of samples to step.
 * @param fftLength The size of the FFT to apply.
 * @param windowFn A callable that takes a window length and returns 1-d tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $73eaadde74ade07b$var$stft_(signal, frameLength, frameStep, fftLength, windowFn = (0, $f28f4f764f4a5d69$export$f498cfeee84e5e59)) {
    if (fftLength == null) fftLength = (0, $a9d9c2aa71ee0001$export$6fc2fe3b19043bf3)(frameLength);
    const framedSignal = (0, $155310928eda6858$export$2cef06c20297c17d)(signal, frameLength, frameStep);
    const windowedSignal = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(framedSignal, windowFn(frameLength));
    return (0, $ba0ceb1c91713e10$export$72aff1768917e9e5)(windowedSignal, fftLength);
}
const $73eaadde74ade07b$export$eb1cf9b274257b4a = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    stft_: $73eaadde74ade07b$var$stft_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Extracts crops from the input image tensor and resizes them using bilinear
 * sampling or nearest neighbor sampling (possibly with aspect ratio change)
 * to a common output size specified by cropSize.
 *
 * @param image 4d tensor of shape `[batch,imageHeight,imageWidth, depth]`,
 *     where imageHeight and imageWidth must be positive, specifying the
 *     batch of images from which to take crops
 * @param boxes 2d float32 tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the normalized
 *     coordinates of the box in the `boxInd[i]`th image in the batch
 * @param boxInd 1d int32 tensor of shape `[numBoxes]` with values in range
 *     `[0, batch)` that specifies the image that the `i`-th box refers to.
 * @param cropSize 1d int32 tensor of 2 elements `[cropHeigh, cropWidth]`
 *     specifying the size to which all crops are resized to.
 * @param method Optional string from `'bilinear' | 'nearest'`,
 *     defaults to bilinear, which specifies the sampling method for resizing
 * @param extrapolationValue A threshold for deciding when to remove boxes based
 *     on score. Defaults to 0.
 * @return A 4D tensor of the shape `[numBoxes,cropHeight,cropWidth,depth]`
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $ed310b04f11591d1$var$cropAndResize_(image, boxes, boxInd, cropSize, method = 'bilinear', extrapolationValue = 0) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'cropAndResize');
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'cropAndResize', 'float32');
    const $boxInd = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxInd, 'boxInd', 'cropAndResize', 'int32');
    const numBoxes = $boxes.shape[0];
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank === 4, ()=>'Error in cropAndResize: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($boxes.rank === 2 && $boxes.shape[1] === 4, ()=>`Error in cropAndResize: boxes must be have size [${numBoxes},4] ` + `but had shape ${$boxes.shape}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, ()=>`Error in cropAndResize: boxInd must be have size [${numBoxes}] ` + `but had shape ${$boxes.shape}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(cropSize.length === 2, ()=>`Error in cropAndResize: cropSize must be of length 2, but got ` + `length ${cropSize.length}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(cropSize[0] >= 1 && cropSize[1] >= 1, ()=>`cropSize must be atleast [1,1], but was ${cropSize}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(method === 'bilinear' || method === 'nearest', ()=>`method must be bilinear or nearest, but was ${method}`);
    const inputs = {
        image: $image,
        boxes: $boxes,
        boxInd: $boxInd
    };
    const attrs = {
        method: method,
        extrapolationValue: extrapolationValue,
        cropSize: cropSize
    };
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$50bc9557793c2e04), inputs, attrs);
    return res;
}
const $ed310b04f11591d1$export$6f0f0090e1f6cd3c = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cropAndResize_: $ed310b04f11591d1$var$cropAndResize_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Flips the image left to right. Currently available in the CPU, WebGL, and
 * WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 */ /** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */ function $0a22e8c7803e3a78$var$flipLeftRight_(image) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'flipLeftRight', 'float32');
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank === 4, ()=>'Error in flipLeftRight: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$34e7296fc8558df5), inputs, {});
    return res;
}
const $0a22e8c7803e3a78$export$8358b9c43b687b22 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    flipLeftRight_: $0a22e8c7803e3a78$var$flipLeftRight_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Converts images from grayscale to RGB format.
 *
 * @param image A grayscale tensor to convert. The `image`'s last dimension must
 *     be size 1 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $a28956bfb10bb242$var$grayscaleToRGB_(image) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'grayscaleToRGB');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank >= 2, ()=>'Error in grayscaleToRGB: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(lastDims === 1, ()=>'Error in grayscaleToRGB: last dimension of a grayscale image ' + `should be size 1, but got size ${lastDims}.`);
    const reps = new Array($image.rank);
    reps.fill(1, 0, lastDimsIdx);
    reps[lastDimsIdx] = 3;
    return (0, $e6ca18ccb4a89ccc$export$3c17558da18e4d75)($image, reps);
}
const $a28956bfb10bb242$export$f68e334bfd7e4be6 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    grayscaleToRGB_: $a28956bfb10bb242$var$grayscaleToRGB_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Converts images from RGB format to grayscale.
 *
 * @param image A RGB tensor to convert. The `image`'s last dimension must
 *     be size 3 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $10e7930ae7b8ab41$var$rgbToGrayscale_(image) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'RGBToGrayscale');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank >= 2, ()=>'Error in RGBToGrayscale: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(lastDims === 3, ()=>'Error in RGBToGrayscale: last dimension of an RGB image ' + `should be size 3, but got size ${lastDims}.`);
    // Remember original dtype so we can convert back if needed
    const origDtype = $image.dtype;
    const fltImage = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($image, 'float32');
    const rgbWeights = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)([
        0.2989,
        0.5870,
        0.1140
    ]);
    let grayFloat;
    switch($image.rank){
        case 2:
            grayFloat = (0, $86c3e2507ff73220$export$27265e7daac5c403)('ij,j->i', fltImage, rgbWeights);
            break;
        case 3:
            grayFloat = (0, $86c3e2507ff73220$export$27265e7daac5c403)('ijk,k->ij', fltImage, rgbWeights);
            break;
        case 4:
            grayFloat = (0, $86c3e2507ff73220$export$27265e7daac5c403)('ijkl,l->ijk', fltImage, rgbWeights);
            break;
        case 5:
            grayFloat = (0, $86c3e2507ff73220$export$27265e7daac5c403)('ijklm,m->ijkl', fltImage, rgbWeights);
            break;
        case 6:
            grayFloat = (0, $86c3e2507ff73220$export$27265e7daac5c403)('ijklmn,n->ijklm', fltImage, rgbWeights);
            break;
        default:
            throw new Error('Not a valid tensor rank.');
    }
    grayFloat = (0, $31018343da089cd7$export$d660d8ed21f46635)(grayFloat, -1);
    return (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(grayFloat, origDtype);
}
const $10e7930ae7b8ab41$export$490c4fde2e852c50 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    rgbToGrayscale_: $10e7930ae7b8ab41$var$rgbToGrayscale_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Rotates the input image tensor counter-clockwise with an optional offset
 * center of rotation. Currently available in the CPU, WebGL, and WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param radians The amount of rotation.
 * @param fillValue The value to fill in the empty space leftover
 *     after rotation. Can be either a single grayscale value (0-255), or an
 *     array of three numbers `[red, green, blue]` specifying the red, green,
 *     and blue channels. Defaults to `0` (black).
 * @param center The center of rotation. Can be either a single value (0-1), or
 *     an array of two numbers `[centerX, centerY]`. Defaults to `0.5` (rotates
 *     the image around its center).
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $6434ae01b5488b19$var$rotateWithOffset_(image, radians, fillValue = 0, center = 0.5) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'rotateWithOffset', 'float32');
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank === 4, ()=>'Error in rotateWithOffset: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const attrs = {
        radians: radians,
        fillValue: fillValue,
        center: center
    };
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$c5a44649815d1c3), inputs, attrs);
    return res;
}
const $6434ae01b5488b19$export$66462c489f5f29d2 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    rotateWithOffset_: $6434ae01b5488b19$var$rotateWithOffset_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $012690c87f9a152b$export$ccf61bcb3b4e6ac6(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    if (iouThreshold == null) iouThreshold = 0.5;
    if (scoreThreshold == null) scoreThreshold = Number.NEGATIVE_INFINITY;
    if (softNmsSigma == null) softNmsSigma = 0.0;
    const numBoxes = boxes.shape[0];
    maxOutputSize = Math.min(maxOutputSize, numBoxes);
    $9e4a6174e3538e7d$export$a7a9523472993e97(0 <= iouThreshold && iouThreshold <= 1, ()=>`iouThreshold must be in [0, 1], but was '${iouThreshold}'`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(boxes.rank === 2, ()=>`boxes must be a 2D tensor, but was of rank '${boxes.rank}'`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(boxes.shape[1] === 4, ()=>`boxes must have 4 columns, but 2nd dimension was ${boxes.shape[1]}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(scores.rank === 1, ()=>'scores must be a 1D tensor');
    $9e4a6174e3538e7d$export$a7a9523472993e97(scores.shape[0] === numBoxes, ()=>`scores has incompatible shape with boxes. Expected ${numBoxes}, ` + `but was ${scores.shape[0]}`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(0 <= softNmsSigma && softNmsSigma <= 1, ()=>`softNmsSigma must be in [0, 1], but was '${softNmsSigma}'`);
    return {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}



/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $5878d767f846ccd0$var$nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppression', 'float32');
    const $scores = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppression', 'float32');
    const inputs = (0, $012690c87f9a152b$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$5e11788439c2f04), {
        boxes: $boxes,
        scores: $scores
    }, attrs);
}
const $5878d767f846ccd0$export$b7d265b19ca1d628 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    nonMaxSuppression_: $5878d767f846ccd0$var$nonMaxSuppression_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inserts a value into a sorted array. This method allows duplicate, meaning it
 * allows inserting duplicate value, in which case, the element will be inserted
 * at the lowest index of the value.
 * @param arr The array to modify.
 * @param element The element to insert.
 * @param comparator Optional. If no comparator is specified, elements are
 * compared using array_util.defaultComparator, which is suitable for Strings
 * and Numbers in ascending arrays. If the array contains multiple instances of
 * the target value, the left-most instance will be returned. To provide a
 * comparator, it should take 2 arguments to compare and return a negative,
 * zero, or a positive number.
 */ function $678ef5908aa33f7e$export$a64fad5e27f22af5(arr, element, comparator) {
    const index = $678ef5908aa33f7e$export$2e0ae67339d5f1ac(arr, element, comparator);
    const insertionPoint = index < 0 ? -(index + 1) : index;
    arr.splice(insertionPoint, 0, element);
}
function $678ef5908aa33f7e$export$2e0ae67339d5f1ac(arr, target, comparator) {
    return $678ef5908aa33f7e$var$binarySearch_(arr, target, comparator || $678ef5908aa33f7e$var$defaultComparator);
}
/**
 * Compares its two arguments for order.
 * @param a The first element to be compared.
 * @param b The second element to be compared.
 * @return A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */ function $678ef5908aa33f7e$var$defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $678ef5908aa33f7e$var$binarySearch_(arr, target, comparator) {
    let left = 0;
    let right = arr.length;
    let middle = 0;
    let found = false;
    while(left < right){
        middle = left + (right - left >>> 1);
        const compareResult = comparator(target, arr[middle]);
        if (compareResult > 0) left = middle + 1;
        else {
            right = middle;
            // If compareResult is 0, the value is found. We record it is found,
            // and then keep looking because there may be duplicate.
            found = !compareResult;
        }
    }
    return found ? left : -left - 1;
}


function $75f28c5b0772c39f$export$89e22275998c2878(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
    return $75f28c5b0772c39f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ );
}
function $75f28c5b0772c39f$export$697e7a8cdfefe3a(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize) {
    return $75f28c5b0772c39f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ , false, padToMaxOutputSize /* padToMaxOutputSize */ , true);
}
function $75f28c5b0772c39f$export$4ff849794bce73c5(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    return $75f28c5b0772c39f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, true);
}
function $75f28c5b0772c39f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor = false, padToMaxOutputSize = false, returnValidOutputs = false) {
    // The list is sorted in ascending order, so that we can always pop the
    // candidate with the largest score in O(1) time.
    const candidates = [];
    for(let i = 0; i < scores.length; i++)if (scores[i] > scoreThreshold) candidates.push({
        score: scores[i],
        boxIndex: i,
        suppressBeginIndex: 0
    });
    candidates.sort($75f28c5b0772c39f$var$ascendingComparator);
    // If softNmsSigma is 0, the outcome of this algorithm is exactly same as
    // before.
    const scale = softNmsSigma > 0 ? -0.5 / softNmsSigma : 0.0;
    const selectedIndices = [];
    const selectedScores = [];
    while(selectedIndices.length < maxOutputSize && candidates.length > 0){
        const candidate = candidates.pop();
        const { score: originalScore, boxIndex: boxIndex, suppressBeginIndex: suppressBeginIndex } = candidate;
        if (originalScore < scoreThreshold) break;
        // Overlapping boxes are likely to have similar scores, therefore we
        // iterate through the previously selected boxes backwards in order to
        // see if candidate's score should be suppressed. We use
        // suppressBeginIndex to track and ensure a candidate can be suppressed
        // by a selected box no more than once. Also, if the overlap exceeds
        // iouThreshold, we simply ignore the candidate.
        let ignoreCandidate = false;
        for(let j = selectedIndices.length - 1; j >= suppressBeginIndex; --j){
            const iou = $75f28c5b0772c39f$var$intersectionOverUnion(boxes, boxIndex, selectedIndices[j]);
            if (iou >= iouThreshold) {
                ignoreCandidate = true;
                break;
            }
            candidate.score = candidate.score * $75f28c5b0772c39f$var$suppressWeight(iouThreshold, scale, iou);
            if (candidate.score <= scoreThreshold) break;
        }
        // At this point, if `candidate.score` has not dropped below
        // `scoreThreshold`, then we know that we went through all of the
        // previous selections and can safely update `suppressBeginIndex` to the
        // end of the selected array. Then we can re-insert the candidate with
        // the updated score and suppressBeginIndex back in the candidate list.
        // If on the other hand, `candidate.score` has dropped below the score
        // threshold, we will not add it back to the candidates list.
        candidate.suppressBeginIndex = selectedIndices.length;
        if (!ignoreCandidate) {
            // Candidate has passed all the tests, and is not suppressed, so
            // select the candidate.
            if (candidate.score === originalScore) {
                selectedIndices.push(boxIndex);
                selectedScores.push(candidate.score);
            } else if (candidate.score > scoreThreshold) // Candidate's score is suppressed but is still high enough to be
            // considered, so add back to the candidates list.
            (0, $678ef5908aa33f7e$export$a64fad5e27f22af5)(candidates, candidate, $75f28c5b0772c39f$var$ascendingComparator);
        }
    }
    // NonMaxSuppressionV4 feature: padding output to maxOutputSize.
    const validOutputs = selectedIndices.length;
    const elemsToPad = maxOutputSize - validOutputs;
    if (padToMaxOutputSize && elemsToPad > 0) {
        selectedIndices.push(...new Array(elemsToPad).fill(0));
        selectedScores.push(...new Array(elemsToPad).fill(0.0));
    }
    const result = {
        selectedIndices: selectedIndices
    };
    if (returnScoresTensor) result['selectedScores'] = selectedScores;
    if (returnValidOutputs) result['validOutputs'] = validOutputs;
    return result;
}
function $75f28c5b0772c39f$var$intersectionOverUnion(boxes, i, j) {
    const iCoord = boxes.subarray(i * 4, i * 4 + 4);
    const jCoord = boxes.subarray(j * 4, j * 4 + 4);
    const yminI = Math.min(iCoord[0], iCoord[2]);
    const xminI = Math.min(iCoord[1], iCoord[3]);
    const ymaxI = Math.max(iCoord[0], iCoord[2]);
    const xmaxI = Math.max(iCoord[1], iCoord[3]);
    const yminJ = Math.min(jCoord[0], jCoord[2]);
    const xminJ = Math.min(jCoord[1], jCoord[3]);
    const ymaxJ = Math.max(jCoord[0], jCoord[2]);
    const xmaxJ = Math.max(jCoord[1], jCoord[3]);
    const areaI = (ymaxI - yminI) * (xmaxI - xminI);
    const areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
    if (areaI <= 0 || areaJ <= 0) return 0.0;
    const intersectionYmin = Math.max(yminI, yminJ);
    const intersectionXmin = Math.max(xminI, xminJ);
    const intersectionYmax = Math.min(ymaxI, ymaxJ);
    const intersectionXmax = Math.min(xmaxI, xmaxJ);
    const intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) * Math.max(intersectionXmax - intersectionXmin, 0.0);
    return intersectionArea / (areaI + areaJ - intersectionArea);
}
// A Gaussian penalty function, this method always returns values in [0, 1].
// The weight is a function of similarity, the more overlap two boxes are, the
// smaller the weight is,meaning highly overlapping boxes will be significantly
// penalized. On the other hand, a non-overlapping box will not be penalized.
function $75f28c5b0772c39f$var$suppressWeight(iouThreshold, scale, iou) {
    const weight = Math.exp(scale * iou * iou);
    return iou <= iouThreshold ? weight : 0.0;
}
function $75f28c5b0772c39f$var$ascendingComparator(c1, c2) {
    // For objects with same scores, we make the object with the larger index go
    // first. In an array that pops from the end, this means that the object with
    // the smaller index will be popped first. This ensures the same output as
    // the TensorFlow python version.
    return c1.score - c2.score || c1.score === c2.score && c2.boxIndex - c1.boxIndex;
}





/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This is the async version of `nonMaxSuppression`
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $2c6c92014403a7d6$var$nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppressionAsync');
    const inputs = (0, $012690c87f9a152b$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices } = (0, $75f28c5b0772c39f$export$89e22275998c2878)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(selectedIndices, 'int32');
}
const $2c6c92014403a7d6$export$cc6d94dffac2ee1a = $2c6c92014403a7d6$var$nonMaxSuppressionAsync_;


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $fe0195b5546f341d$var$nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $012690c87f9a152b$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$cb45d3fcefce2ef0), inputs, attrs);
    return {
        selectedIndices: result[0],
        selectedScores: result[1]
    };
}
const $fe0195b5546f341d$export$d65fe1460f8c5b4e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    nonMaxSuppressionWithScore_: $fe0195b5546f341d$var$nonMaxSuppressionWithScore_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $58abf3e728985344$var$nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $012690c87f9a152b$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $75f28c5b0772c39f$export$4ff849794bce73c5)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(selectedIndices, 'int32'),
        selectedScores: (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(selectedScores)
    };
}
const $58abf3e728985344$export$d1826570c883f7cf = $58abf3e728985344$var$nonMaxSuppressionWithScoreAsync_;


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $2b12037396e50226$var$nonMaxSuppressionPadded_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $012690c87f9a152b$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: $maxOutputSize,
        iouThreshold: $iouThreshold,
        scoreThreshold: $scoreThreshold,
        padToMaxOutputSize: padToMaxOutputSize
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7df908154366fe7f), inputs, attrs);
    return {
        selectedIndices: result[0],
        validOutputs: result[1]
    };
}
const $2b12037396e50226$export$d8d10e31c41c95dc = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    nonMaxSuppressionPadded_: $2b12037396e50226$var$nonMaxSuppressionPadded_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $1b8252b7329dde8c$var$nonMaxSuppressionPaddedAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $012690c87f9a152b$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const [boxesVals, scoresVals] = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    // We call a cpu based impl directly with the typedarray data here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = (0, $75f28c5b0772c39f$export$697e7a8cdfefe3a)(boxesVals, scoresVals, $maxOutputSize, $iouThreshold, $scoreThreshold, padToMaxOutputSize);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(selectedIndices, 'int32'),
        validOutputs: (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(validOutputs, 'int32')
    };
}
const $1b8252b7329dde8c$export$4c5691f9710b88a8 = $1b8252b7329dde8c$var$nonMaxSuppressionPaddedAsync_;


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Bilinear resize a single 3D image or a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to `false`. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixel centers
 *     are at 0.5, which would make the floating point coordinates of the top
 *     left pixel 0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $dd1a21ef8789a001$var$resizeBilinear_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(images, 'images', 'resizeBilinear');
    $9e4a6174e3538e7d$export$a7a9523472993e97($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeBilinear: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(size.length === 2, ()=>`Error in resizeBilinear: new shape must 2D, but got shape ` + `${size}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeBilinear: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$24f2f15d869e0fd), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $dd1a21ef8789a001$export$1f1cbc7da93d06a0 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    resizeBilinear_: $dd1a21ef8789a001$var$resizeBilinear_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * NearestNeighbor resize a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to False. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixels are of
 *      half the actual dimensions, and yield more accurate resizes. This flag
 *      would also make the floating point coordinates of the top left pixel
 *      0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $98e2687b0d12dea1$var$resizeNearestNeighbor_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(images, 'images', 'resizeNearestNeighbor');
    $9e4a6174e3538e7d$export$a7a9523472993e97($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(size.length === 2, ()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ` + `${size}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($images.dtype === 'float32' || $images.dtype === 'int32', ()=>'`images` must have `int32` or `float32` as dtype');
    $9e4a6174e3538e7d$export$a7a9523472993e97(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeNearestNeighbor: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$6c8d8ec26192bb18), inputs, attrs);
    if (reshapedTo4D) return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $98e2687b0d12dea1$export$74a902ae74ac2560 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    resizeNearestNeighbor_: $98e2687b0d12dea1$var$resizeNearestNeighbor_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



















/**
 * Performs image binarization with corresponding threshold
 * (depends on the method)value, which creates a binary image from a grayscale.
 * @param image 3d tensor of shape [imageHeight,imageWidth, depth],
 * where imageHeight and imageWidth must be positive.The image color
 * range should be [0, 255].
 * @param method Optional string from `'binary' | 'otsu'`
 * which specifies the method for thresholding. Defaults to 'binary'.
 * @param inverted Optional boolean whichspecifies
 * if colours should be inverted. Defaults to false.
 * @param threshValue Optional number which defines threshold value from 0 to 1.
 * Defaults to 0.5.
 * @return A 3d tensor of shape [imageHeight,imageWidth, depth], which
 * contains binarized image.
 */ function $fa9131fba8a4ae84$var$threshold_(image, method = 'binary', inverted = false, threshValue = 0.5) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'threshold');
    /* 0.2989, 0.5870, 0.1140 are represent luma coefficients in CCIR601.
    Reference for converting between RGB and grayscale: https://en.wikipedia.org/wiki/Luma_%28video%29  */ const RED_INTENCITY_COEF = 0.2989;
    const GREEN_INTENCITY_COEF = 0.5870;
    const BLUE_INTENCITY_COEF = 0.1140;
    const totalPixelsInImage = $image.shape[0] * $image.shape[1];
    let $threshold = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)([
        threshValue
    ]), 255);
    let r, g, b, grayscale;
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank === 3, ()=>'Error in threshold: image must be rank 3,' + `but got rank ${$image.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.shape[2] === 3 || $image.shape[2] === 1, ()=>"Error in threshold: image color channel must be equal to 3 or 1" + `but got ${$image.shape[2]}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.dtype === 'int32' || $image.dtype === 'float32', ()=>'Error in dtype: image dtype must be int32 or float32,' + `but got dtype ${$image.dtype}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(method === 'otsu' || method === 'binary', ()=>`Method must be binary or otsu, but was ${method}`);
    if ($image.shape[2] === 3) {
        [r, g, b] = (0, $78850daf663d7633$export$65980d18b75784e2)($image, [
            1,
            1,
            1
        ], -1);
        const $r = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(r, RED_INTENCITY_COEF);
        const $g = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(g, GREEN_INTENCITY_COEF);
        const $b = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(b, BLUE_INTENCITY_COEF);
        grayscale = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $8efd352f234ac278$export$e16d8520af44a096)($r, $g), $b);
    } else grayscale = image;
    if (method === 'otsu') {
        const $histogram = (0, $6dec9946bca0316c$export$7e474bab088ed182)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)((0, $b8e64b0c5bfbfd9b$export$2077e0241d6afd3c)(grayscale), 'int32'), (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)([]), 256);
        $threshold = $fa9131fba8a4ae84$var$otsu($histogram, totalPixelsInImage);
    }
    const invCondition = inverted ? (0, $9b3d78d7d568ec20$export$c24ad19a692bb92)(grayscale, $threshold) : (0, $0034e349e70db944$export$9dca161faaf6308b)(grayscale, $threshold);
    const result = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(invCondition, 255), 'int32');
    return result;
}
function $fa9131fba8a4ae84$var$otsu(histogram, total) {
    let bestThresh = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)([
        -1
    ]);
    let bestInBetVar = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)([
        0
    ]);
    let cInBetVar = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)([
        0
    ]);
    let classFirst, classSecond, meanFirst, meanSec, weightForeground, weightBack;
    for(let index = 0; index < histogram.size - 1; index++){
        classFirst = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(histogram, 0, index + 1);
        classSecond = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(histogram, index + 1);
        weightForeground = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $140b816be4851e95$export$8a63f25cc62965f1)(classFirst), total);
        weightBack = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $140b816be4851e95$export$8a63f25cc62965f1)(classSecond), total);
        const meanFirstDivA = (0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(classFirst, (0, $7a9b6c8fcbba0cfb$export$d02631cccf789723)(0, classFirst.size)));
        meanFirst = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(meanFirstDivA, (0, $140b816be4851e95$export$8a63f25cc62965f1)(classFirst));
        const meanSecFill = (0, $a1afd8d5a9faad9a$export$9563e054e6f787fb)(classSecond.shape, classFirst.size);
        const meanSecAdd = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $7a9b6c8fcbba0cfb$export$d02631cccf789723)(0, classSecond.size), meanSecFill);
        const meanSecMul = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(classSecond, meanSecAdd);
        meanSec = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $140b816be4851e95$export$8a63f25cc62965f1)(meanSecMul), (0, $140b816be4851e95$export$8a63f25cc62965f1)(classSecond));
        const cInBetVarSubA = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(meanFirst, meanSec);
        const cInBetVarSubB = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(meanFirst, meanSec);
        const cInBetVarMul = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(weightForeground, weightBack);
        cInBetVar = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(cInBetVarMul, cInBetVarSubA), cInBetVarSubB);
        const condition = (0, $0034e349e70db944$export$9dca161faaf6308b)(cInBetVar, bestInBetVar);
        bestInBetVar = (0, $5ca12d297e319cbc$export$9c59b80dda569a6e)(condition, cInBetVar, bestInBetVar);
        bestThresh = (0, $5ca12d297e319cbc$export$9c59b80dda569a6e)(condition, (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)([
            index
        ]), bestThresh);
    }
    return bestThresh;
}
const $fa9131fba8a4ae84$export$454d09aca5f3ea63 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    threshold_: $fa9131fba8a4ae84$var$threshold_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Applies the given transform(s) to the image(s).
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param transforms Projective transform matrix/matrices. A tensor1d of length
 *     8 or tensor of size N x 8. If one row of transforms is [a0, a1, a2, b0,
 *     b1, b2, c0, c1], then it maps the output point (x, y) to a transformed
 *     input point (x', y') = ((a0 x + a1 y + a2) / k, (b0 x + b1 y + b2) / k),
 *     where k = c0 x + c1 y + 1. The transforms are inverted compared to the
 *     transform mapping input points to output points.
 * @param interpolation Interpolation mode.
 *     Supported values: 'nearest', 'bilinear'. Default to 'nearest'.
 * @param fillMode Points outside the boundaries of the input are filled
 *     according to the given mode, one of 'constant', 'reflect', 'wrap',
 *     'nearest'. Default to 'constant'.
 *     'reflect': (d c b a | a b c d | d c b a ) The input is extended by
 *     reflecting about the edge of the last pixel.
 *     'constant': (k k k k | a b c d | k k k k) The input is extended by
 *     filling all values beyond the edge with the same constant value k.
 *     'wrap': (a b c d | a b c d | a b c d) The input is extended by
 *     wrapping around to the opposite edge.
 *     'nearest': (a a a a | a b c d | d d d d) The input is extended by
 *     the nearest pixel.
 * @param fillValue A float represents the value to be filled outside the
 *     boundaries when fillMode is 'constant'.
 * @param Output dimension after the transform, [height, width]. If undefined,
 *     output is the same size as input image.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $5049ac4f71b8b833$var$transform_(image, transforms, interpolation = 'nearest', fillMode = 'constant', fillValue = 0, outputShape) {
    const $image = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(image, 'image', 'transform', 'float32');
    const $transforms = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(transforms, 'transforms', 'transform', 'float32');
    $9e4a6174e3538e7d$export$a7a9523472993e97($image.rank === 4, ()=>'Error in transform: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $9e4a6174e3538e7d$export$a7a9523472993e97($transforms.rank === 2 && ($transforms.shape[0] === $image.shape[0] || $transforms.shape[0] === 1) && $transforms.shape[1] === 8, ()=>`Error in transform: Input transform should be batch x 8 or 1 x 8`);
    $9e4a6174e3538e7d$export$a7a9523472993e97(outputShape == null || outputShape.length === 2, ()=>'Error in transform: outputShape must be [height, width] or null, ' + `but got ${outputShape}.`);
    const inputs = {
        image: $image,
        transforms: $transforms
    };
    const attrs = {
        interpolation: interpolation,
        fillMode: fillMode,
        fillValue: fillValue,
        outputShape: outputShape
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$563a914cafbdc389), inputs, attrs);
}
const $5049ac4f71b8b833$export$51186ad6e864892a = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    transform_: $5049ac4f71b8b833$var$transform_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 















/**
 * Copy a tensor setting everything outside a central band in each innermost
 * matrix to zero.
 *
 * The band part is computed as follows: Assume input has `k` dimensions
 * `[I, J, K, ..., M, N]`, then the output is a tensor with the same shape where
 * `band[i, j, k, ..., m, n] = in_band(m, n) * input[i, j, k, ..., m, n]`.
 * The indicator function
 * `in_band(m, n) = (num_lower < 0 || (m-n) <= num_lower)`
 * `&& (num_upper < 0 || (n-m) <= num_upper)`
 *
 * ```js
 * const x = tf.tensor2d([[ 0,  1,  2, 3],
 *                        [-1,  0,  1, 2],
 *                        [-2, -1,  0, 1],
 *                        [-3, -2, -1, 0]]);
 * let y = tf.linalg.bandPart(x, 1, -1);
 * y.print(); // [[ 0,  1,  2, 3],
 *            //  [-1,  0,  1, 2],
 *            //  [ 0, -1,  0, 1],
 *            //  [ 0, 0 , -1, 0]]
 * let z = tf.linalg.bandPart(x, 2, 1);
 * z.print(); // [[ 0,  1,  0, 0],
 *            //  [-1,  0,  1, 0],
 *            //  [-2, -1,  0, 1],
 *            //  [ 0, -2, -1, 0]]
 * ```
 *
 * @param x Rank `k` tensor
 * @param numLower Number of subdiagonals to keep.
 *   If negative, keep entire lower triangle.
 * @param numUpper Number of subdiagonals to keep.
 *   If negative, keep entire upper triangle.
 * @returns Rank `k` tensor of the same shape as input.
 *   The extracted banded tensor.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $4450bd2a0f4e89e2$var$bandPart_(a, numLower, numUpper) {
    const $a = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(a, 'a', 'bandPart');
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)($a.rank >= 2, ()=>`bandPart(): Rank must be at least 2, got ${$a.rank}.`);
    const shape = $a.shape;
    const [M, N] = $a.shape.slice(-2);
    let $numLower;
    let $numUpper;
    if (typeof numLower === 'number') {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numLower % 1 === 0, ()=>`bandPart(): numLower must be an integer, got ${numLower}.`);
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numLower <= M, ()=>`bandPart(): numLower (${numLower})` + ` must not be greater than the number of rows (${M}).`);
        $numLower = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(numLower < 0 ? M : numLower, 'numLower', 'bandPart');
    } else {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numLower.dtype === 'int32', ()=>`bandPart(): numLower's dtype must be an int32.`);
        // If numLower is a Scalar, checking `numLower <= M` could hurt performance,
        // but minimum(numLower, M) could avoid unexpected results.
        $numLower = (0, $5ca12d297e319cbc$export$9c59b80dda569a6e)((0, $d2eb0cc564463c61$export$bb1a638da8ad190f)(numLower, 0), M, (0, $4315eb3f5ec9063a$export$916782c1f0ddb132)(numLower, M));
    }
    if (typeof numUpper === 'number') {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numUpper % 1 === 0, ()=>`bandPart(): numUpper must be an integer, got ${numUpper}.`);
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numUpper <= N, ()=>`bandPart(): numUpper (${numUpper})` + ` must not be greater than the number of columns (${N}).`);
        $numUpper = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(numUpper < 0 ? N : numUpper, 'numUpper', 'bandPart');
    } else {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(numUpper.dtype === 'int32', ()=>`bandPart(): numUpper's dtype must be an int32.`);
        $numUpper = (0, $5ca12d297e319cbc$export$9c59b80dda569a6e)((0, $d2eb0cc564463c61$export$bb1a638da8ad190f)(numUpper, 0), N, (0, $4315eb3f5ec9063a$export$916782c1f0ddb132)(numUpper, N));
    }
    const i = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $7a9b6c8fcbba0cfb$export$d02631cccf789723)(0, M, 1, 'int32'), [
        -1,
        1
    ]);
    const j = (0, $7a9b6c8fcbba0cfb$export$d02631cccf789723)(0, N, 1, 'int32');
    const ij = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(i, j);
    const inBand = (0, $43e415e5ff25d286$export$db5dd0ef9d505f)((0, $9b3d78d7d568ec20$export$c24ad19a692bb92)(ij, $numLower), (0, $eceec4f09b66c311$export$c2fd4164cadc1fa2)(ij, (0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)($numUpper)));
    const zero = (0, $a0e8420b37ff8039$export$4445a00dafa2633b)([
        M,
        N
    ], $a.dtype);
    return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)((0, $18be989171d2a470$export$3c05285afa115eec)((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)($a, [
        -1,
        M,
        N
    ])).map((mat)=>(0, $5ca12d297e319cbc$export$9c59b80dda569a6e)(inBand, mat, zero))), shape);
}
const $4450bd2a0f4e89e2$export$8a3da9cb9e5610a0 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    bandPart_: $4450bd2a0f4e89e2$var$bandPart_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Gram-Schmidt orthogonalization.
 *
 * ```js
 * const x = tf.tensor2d([[1, 2], [3, 4]]);
 * let y = tf.linalg.gramSchmidt(x);
 * y.print();
 * console.log('Orthogonalized:');
 * y.dot(y.transpose()).print();  // should be nearly the identity matrix.
 * console.log('First row direction maintained:');
 * const data = await y.array();
 * console.log(data[0][1] / data[0][0]);  // should be nearly 2.
 * ```
 *
 * @param xs The vectors to be orthogonalized, in one of the two following
 *   formats:
 *   - An Array of `tf.Tensor1D`.
 *   - A `tf.Tensor2D`, i.e., a matrix, in which case the vectors are the rows
 *     of `xs`.
 *   In each case, all the vectors must have the same length and the length
 *   must be greater than or equal to the number of vectors.
 * @returns The orthogonalized and normalized vectors or matrix.
 *   Orthogonalization means that the vectors or the rows of the matrix
 *   are orthogonal (zero inner products). Normalization means that each
 *   vector or each row of the matrix has an L2 norm that equals `1`.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $fb77a4819e9e6562$var$gramSchmidt_(xs) {
    let inputIsTensor2D;
    if (Array.isArray(xs)) {
        inputIsTensor2D = false;
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(xs != null && xs.length > 0, ()=>"Gram-Schmidt process: input must not be null, undefined, or empty");
        const dim = xs[0].shape[0];
        for(let i = 1; i < xs.length; ++i)(0, $9e4a6174e3538e7d$export$a7a9523472993e97)(xs[i].shape[0] === dim, ()=>'Gram-Schmidt: Non-unique lengths found in the input vectors: ' + `(${xs[i].shape[0]} vs. ${dim})`);
    } else {
        inputIsTensor2D = true;
        xs = (0, $78850daf663d7633$export$65980d18b75784e2)(xs, xs.shape[0], 0).map((x)=>(0, $d85a848eb4aff9d2$export$889c931173b77c2f)(x, [
                0
            ]));
    }
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(xs.length <= xs[0].shape[0], ()=>`Gram-Schmidt: Number of vectors (${xs.length}) exceeds ` + `number of dimensions (${xs[0].shape[0]}).`);
    const ys = [];
    const xs1d = xs;
    for(let i = 0; i < xs.length; ++i)ys.push((0, $6a645535e157b279$export$33b63313cc511a3b).tidy(()=>{
        let x = xs1d[i];
        if (i > 0) for(let j = 0; j < i; ++j){
            const proj = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(ys[j], x)), ys[j]);
            x = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(x, proj);
        }
        return (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(x, (0, $7220c998b208dd38$export$1991ecd29cc92c6b)(x, 'euclidean'));
    }));
    if (inputIsTensor2D) return (0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(ys, 0);
    else return ys;
}
const $fb77a4819e9e6562$export$d505610386a600de = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    gramSchmidt_: $fb77a4819e9e6562$var$gramSchmidt_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




















/**
 * Compute QR decomposition of m-by-n matrix using Householder transformation.
 *
 * Implementation based on
 *   [http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf]
 * (http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf)
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [3, 4]]);
 * let [q, r] = tf.linalg.qr(a);
 * console.log('Q');
 * q.print();
 * console.log('R');
 * r.print();
 * console.log('Orthogonalized');
 * q.dot(q.transpose()).print()  // should be nearly the identity matrix.
 * console.log('Reconstructed');
 * q.dot(r).print(); // should be nearly [[1, 2], [3, 4]];
 * ```
 *
 * @param x The `tf.Tensor` to be QR-decomposed. Must have rank >= 2. Suppose
 *   it has the shape `[..., M, N]`.
 * @param fullMatrices An optional boolean parameter. Defaults to `false`.
 *   If `true`, compute full-sized `Q`. If `false` (the default),
 *   compute only the leading N columns of `Q` and `R`.
 * @returns An `Array` of two `tf.Tensor`s: `[Q, R]`. `Q` is a unitary matrix,
 *   i.e., its columns all have unit norm and are mutually orthogonal.
 *   If `M >= N`,
 *     If `fullMatrices` is `false` (default),
 *       - `Q` has a shape of `[..., M, N]`,
 *       - `R` has a shape of `[..., N, N]`.
 *     If `fullMatrices` is `true` (default),
 *       - `Q` has a shape of `[..., M, M]`,
 *       - `R` has a shape of `[..., M, N]`.
 *   If `M < N`,
 *     - `Q` has a shape of `[..., M, M]`,
 *     - `R` has a shape of `[..., M, N]`.
 * @throws If the rank of `x` is less than 2.
 *
 * @doc {heading:'Operations',
 *       subheading:'Linear Algebra',
 *       namespace:'linalg'}
 */ function $e9c3650e4f46ded3$var$qr_(x, fullMatrices = false) {
    (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(x.rank >= 2, ()=>`qr() requires input tensor to have a rank >= 2, but got rank ${x.rank}`);
    if (x.rank === 2) return $e9c3650e4f46ded3$var$qr2d(x, fullMatrices);
    else {
        // Rank > 2.
        // TODO(cais): Below we split the input into individual 2D tensors,
        //   perform QR decomposition on them and then stack the results back
        //   together. We should explore whether this can be parallelized.
        const outerDimsProd = x.shape.slice(0, x.shape.length - 2).reduce((value, prev)=>value * prev);
        const x2ds = (0, $18be989171d2a470$export$3c05285afa115eec)((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(x, [
            outerDimsProd,
            x.shape[x.shape.length - 2],
            x.shape[x.shape.length - 1]
        ]), 0);
        const q2ds = [];
        const r2ds = [];
        x2ds.forEach((x2d)=>{
            const [q2d, r2d] = $e9c3650e4f46ded3$var$qr2d(x2d, fullMatrices);
            q2ds.push(q2d);
            r2ds.push(r2d);
        });
        const q = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(q2ds, 0), x.shape);
        const r = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(r2ds, 0), x.shape);
        return [
            q,
            r
        ];
    }
}
function $e9c3650e4f46ded3$var$qr2d(x, fullMatrices = false) {
    return (0, $6a645535e157b279$export$33b63313cc511a3b).tidy(()=>{
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(x.shape.length === 2, ()=>`qr2d() requires a 2D Tensor, but got a ${x.shape.length}D Tensor.`);
        const m = x.shape[0];
        const n = x.shape[1];
        let q = (0, $311a450f987992a1$export$4e18cf730a59887e)(m); // Orthogonal transform so far.
        let r = (0, $765aa12b24d3e86a$export$9cd59f9826255e47)(x); // Transformed matrix so far.
        const one2D = (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([
            [
                1
            ]
        ], [
            1,
            1
        ]);
        let w = (0, $765aa12b24d3e86a$export$9cd59f9826255e47)(one2D);
        const iters = m >= n ? n : m;
        for(let j = 0; j < iters; ++j){
            // This tidy within the for-loop ensures we clean up temporary
            // tensors as soon as they are no longer needed.
            const rTemp = r;
            const wTemp = w;
            const qTemp = q;
            [w, r, q] = (0, $6a645535e157b279$export$33b63313cc511a3b).tidy(()=>{
                // Find H = I - tau * w * w', to put zeros below R(j, j).
                const rjEnd1 = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(r, [
                    j,
                    j
                ], [
                    m - j,
                    1
                ]);
                const normX = (0, $7220c998b208dd38$export$1991ecd29cc92c6b)(rjEnd1);
                const rjj = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(r, [
                    j,
                    j
                ], [
                    1,
                    1
                ]);
                // The sign() function returns 0 on 0, which causes division by zero.
                const s = (0, $5ca12d297e319cbc$export$9c59b80dda569a6e)((0, $0034e349e70db944$export$9dca161faaf6308b)(rjj, 0), (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([
                    [
                        -1
                    ]
                ]), (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([
                    [
                        1
                    ]
                ]));
                const u1 = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(rjj, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(s, normX));
                const wPre = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(rjEnd1, u1);
                if (wPre.shape[0] === 1) w = (0, $765aa12b24d3e86a$export$9cd59f9826255e47)(one2D);
                else w = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
                    one2D,
                    (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(wPre, [
                        1,
                        0
                    ], [
                        wPre.shape[0] - 1,
                        wPre.shape[1]
                    ])
                ], 0);
                const tau = (0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $8a13d3789789217b$export$6706882a873e9a8f)(s, u1), normX));
                // -- R := HR, Q := QH.
                const rjEndAll = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(r, [
                    j,
                    0
                ], [
                    m - j,
                    n
                ]);
                const tauTimesW = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(tau, w);
                const wT = (0, $4c4a44db5126e023$export$9cb09a71b7d66923)(w);
                if (j === 0) r = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(rjEndAll, (0, $8a13d3789789217b$export$6706882a873e9a8f)(tauTimesW, (0, $8a13d3789789217b$export$6706882a873e9a8f)(wT, rjEndAll)));
                else {
                    const rTimesTau = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(rjEndAll, (0, $8a13d3789789217b$export$6706882a873e9a8f)(tauTimesW, (0, $8a13d3789789217b$export$6706882a873e9a8f)(wT, rjEndAll)));
                    r = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
                        (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(r, [
                            0,
                            0
                        ], [
                            j,
                            n
                        ]),
                        rTimesTau
                    ], 0);
                }
                const tawTimesWT = (0, $4c4a44db5126e023$export$9cb09a71b7d66923)(tauTimesW);
                const qAllJEnd = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(q, [
                    0,
                    j
                ], [
                    m,
                    q.shape[1] - j
                ]);
                if (j === 0) q = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(qAllJEnd, (0, $8a13d3789789217b$export$6706882a873e9a8f)((0, $8a13d3789789217b$export$6706882a873e9a8f)(qAllJEnd, w), tawTimesWT));
                else {
                    const qTimesTau = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(qAllJEnd, (0, $8a13d3789789217b$export$6706882a873e9a8f)((0, $8a13d3789789217b$export$6706882a873e9a8f)(qAllJEnd, w), tawTimesWT));
                    q = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
                        (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(q, [
                            0,
                            0
                        ], [
                            m,
                            j
                        ]),
                        qTimesTau
                    ], 1);
                }
                return [
                    w,
                    r,
                    q
                ];
            });
            (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)([
                rTemp,
                wTemp,
                qTemp
            ]);
        }
        if (!fullMatrices && m > n) {
            q = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(q, [
                0,
                0
            ], [
                m,
                n
            ]);
            r = (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(r, [
                0,
                0
            ], [
                n,
                n
            ]);
        }
        return [
            q,
            r
        ];
    });
}
const $e9c3650e4f46ded3$export$7c27fb47516129d9 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    qr_: $e9c3650e4f46ded3$var$qr_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $cbfb65585ec3003c$export$cc9fa7113d70efba;
(function(Reduction) {
    Reduction[Reduction["NONE"] = 0] = "NONE";
    Reduction[Reduction["MEAN"] = 1] = "MEAN";
    Reduction[Reduction["SUM"] = 2] = "SUM";
    Reduction[Reduction["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
})($cbfb65585ec3003c$export$cc9fa7113d70efba || ($cbfb65585ec3003c$export$cc9fa7113d70efba = {}));















/**
 * Computes the weighted loss between two tensors.
 *
 * @param losses Tensor of shape `[batch_size, d1, ..., dN]`.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `losses`, and must be broadcastable to `losses` (i.e., all
 *    dimensions must be either `1`, or the same as the corresponding
 *    `losses` dimension).
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $820fd25004437671$var$computeWeightedLoss_(losses, weights, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $losses = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(losses, 'losses', 'computeWeightedLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'computeWeightedLoss');
    const weightedLoss = $weights == null ? $losses : (0, $582b63c19659e1cf$export$6e3a27864ab166fe)($losses, $weights);
    if (reduction === (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).NONE) return weightedLoss;
    if (reduction === (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM) return (0, $140b816be4851e95$export$8a63f25cc62965f1)(weightedLoss);
    if (reduction === (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).MEAN) {
        if ($weights == null) return (0, $050f28c39276830f$export$1ce691f85baaa52)(weightedLoss);
        else {
            const broadcastFactor = $losses.size / $weights.size;
            const result = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $140b816be4851e95$export$8a63f25cc62965f1)(weightedLoss), (0, $140b816be4851e95$export$8a63f25cc62965f1)($weights));
            return broadcastFactor > 1 ? (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(result, (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(broadcastFactor)) : result;
        }
    }
    if (reduction === (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
        if ($weights == null) return (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $140b816be4851e95$export$8a63f25cc62965f1)(weightedLoss), (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)($losses.size));
        else {
            const broadcastedWeights = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)($weights, (0, $5bbaaacdaecf5fa4$export$21041dee6b8001b0)($losses.shape));
            const numNonZeros = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)((0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $3b3172df4948dc0b$export$53a6892c50694894)(broadcastedWeights, (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0))), 'float32');
            return (0, $3321ac17b3d0dfc7$export$159d9494db57879b)((0, $140b816be4851e95$export$8a63f25cc62965f1)(weightedLoss), numNonZeros);
        }
    }
    throw Error(`Unknown reduction: ${reduction}`);
}
const $820fd25004437671$export$23bdc4cea2e28782 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    computeWeightedLoss_: $820fd25004437671$var$computeWeightedLoss_
});


/**
 * Computes the absolute difference loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $d9f00ce12e6ae39b$var$absoluteDifference_(labels, predictions, weights, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'absoluteDifference');
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'absoluteDifference');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'absoluteDifference');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in absoluteDifference: ');
    const losses = (0, $ac4659b792ae4bef$export$2335f513bbd82c6d)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)($labels, $predictions));
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $d9f00ce12e6ae39b$export$d81f35aebafd8971 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    absoluteDifference_: $d9f00ce12e6ae39b$var$absoluteDifference_
});












/**
 * Computes the cosine distance loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param axis The dimension along which the cosine distance is computed.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $80df439a0f781cbd$var$cosineDistance_(labels, predictions, axis, weights, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'cosineDistance');
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'cosineDistance');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'cosineDistance');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in cosineDistance: ');
    const one = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1);
    const losses = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, (0, $140b816be4851e95$export$8a63f25cc62965f1)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)($labels, $predictions), axis, true));
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $80df439a0f781cbd$export$6168ae03858f836b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    cosineDistance_: $80df439a0f781cbd$var$cosineDistance_
});











/**
 * Computes the Hinge loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $ef637bf240b3376b$var$hingeLoss_(labels, predictions, weights, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    let $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'hingeLoss');
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'hingeLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'hingeLoss');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in hingeLoss: ');
    const one = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1);
    // Convert binary labels to (-1, 1)
    $labels = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(2), $labels), one);
    const losses = (0, $6c8b0dbda17f9033$export$16d1e4612cc0139f)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)($labels, $predictions)));
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $ef637bf240b3376b$export$fc7754731492f43f = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    hingeLoss_: $ef637bf240b3376b$var$hingeLoss_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 











/**
 * Computes the Huber loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param delta Point where Huber loss changes from quadratic to linear.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`.
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $0f10f239b63555a5$var$huberLoss_(labels, predictions, weights, delta = 1.0, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'huberLoss');
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'huberLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'huberLoss');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in huberLoss: ');
    const deltaScalar = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(delta);
    const error = (0, $ac4659b792ae4bef$export$2335f513bbd82c6d)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)($predictions, $labels));
    const quadratic = (0, $4315eb3f5ec9063a$export$916782c1f0ddb132)(error, deltaScalar);
    const linear = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(error, quadratic);
    const losses = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0.5), (0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(quadratic)), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(deltaScalar, linear));
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $0f10f239b63555a5$export$ad2dd557b367bf2b = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    huberLoss_: $0f10f239b63555a5$var$huberLoss_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Computes the log loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param epsilon A small increment to avoid taking log of zero
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $8e8e10bdfd1395c5$var$logLoss_(labels, predictions, weights, epsilon = 1e-7, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'logLoss');
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'logLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'logLoss');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in logLoss: ');
    const one = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1);
    const epsilonScalar = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(epsilon);
    const l1 = (0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)($labels, (0, $efc3c6c91f7ffb3e$export$bef1f36f5486a6a3)((0, $8efd352f234ac278$export$e16d8520af44a096)($predictions, epsilonScalar))));
    const l2 = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, $labels), (0, $efc3c6c91f7ffb3e$export$bef1f36f5486a6a3)((0, $8efd352f234ac278$export$e16d8520af44a096)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, $predictions), epsilonScalar)));
    const losses = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(l1, l2);
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $8e8e10bdfd1395c5$export$5ca6937b99935214 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    logLoss_: $8e8e10bdfd1395c5$var$logLoss_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the mean squared error between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $91eb54970777b251$var$meanSquaredError_(labels, predictions, weights, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'meanSquaredError');
    const $predictions = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(predictions, 'predictions', 'meanSquaredError');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'meanSquaredError');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in meanSquaredError: ');
    const losses = (0, $ccd5a9fa9e8cfcbf$export$b178697fb6d0b37f)($labels, $predictions);
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $91eb54970777b251$export$33de16355e97f7fb = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    meanSquaredError_: $91eb54970777b251$var$meanSquaredError_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 













function $b724683f3ebebaca$var$sigmoidCrossEntropyWithLogits_(labels, logits) {
    const $labels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(labels, 'labels', 'sigmoidCrossEntropyWithLogits');
    const $logits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(logits, 'logits', 'sigmoidCrossEntropyWithLogits');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($labels.shape, $logits.shape, 'Error in sigmoidCrossEntropyWithLogits: ');
    /**
     * Implementation Details:
     *
     * For brevity, let `x = logits`, `z = labels`.  The logistic loss is
     *     z * -log(sigmoid(x)) + (1 - z) * -log(1 - sigmoid(x))
     *   = z * -log(1 / (1 + exp(-x))) + (1 - z) * -log(exp(-x) / (1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (-log(exp(-x)) + log(1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (x + log(1 + exp(-x))
     *   = (1 - z) * x + log(1 + exp(-x))
     *   = x - x * z + log(1 + exp(-x))
     *
     *   For x < 0, to avoid overflow in exp(-x), we reformulate the above
     *     x - x * z + log(1 + exp(-x))
     *   = log(exp(x)) - x * z + log(1 + exp(-x))
     *   = - x * z + log(1 + exp(x))
     *
     * Hence, to ensure stability and avoid overflow, the implementation uses
     * this equivalent formulation:
     *     max(x, 0) - x * z + log(1 + exp(-abs(x)))
     */ const maxOutput = (0, $6c8b0dbda17f9033$export$16d1e4612cc0139f)($logits);
    const outputXTarget = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)($logits, $labels);
    const sigmoidOutput = (0, $943a5cd04e004157$export$144dcf16adfb9698)((0, $87d347fdc039529f$export$b310ec824aaee37f)((0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)((0, $ac4659b792ae4bef$export$2335f513bbd82c6d)($logits))));
    return (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)(maxOutput, outputXTarget), sigmoidOutput);
}
/**
 * Computes the sigmoid cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newMulticlassLabels = multiclassLabels * (1 - labelSmoothing)
 *                         + 0.5 * labelSmoothing
 *
 * @param multiClassLabels The ground truth output tensor of shape
 * [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $b724683f3ebebaca$var$sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing = 0, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    let $multiClassLabels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(multiClassLabels, 'multiClassLabels', 'sigmoidCrossEntropy');
    const $logits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(logits, 'logits', 'sigmoidCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'sigmoidCrossEntropy');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($multiClassLabels.shape, $logits.shape, 'Error in sigmoidCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(labelSmoothing);
        const one = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1);
        const half = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0.5);
        $multiClassLabels = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)($multiClassLabels, (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, labelSmoothingScalar)), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(half, labelSmoothingScalar));
    }
    const losses = $b724683f3ebebaca$var$sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $b724683f3ebebaca$export$d099e04c73e0aede = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sigmoidCrossEntropy_: $b724683f3ebebaca$var$sigmoidCrossEntropy_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

















/**
 * Computes softmax cross entropy between logits and labels.
 *
 * Measures the probability error in discrete classification tasks in which
 * the classes are mutually exclusive (each entry is in exactly one class).
 * For example, each CIFAR-10 image is labeled with one and only one label: an
 * image can be a dog or a truck, but not both.
 *
 * `NOTE`: While the classes are mutually exclusive, their probabilities need
 * not be. All that is required is that each row of labels is a valid
 * probability distribution. If they are not, the computation of the gradient
 * will be incorrect.
 *
 * `WARNING`: This op expects unscaled logits, since it performs a softmax on
 * logits internally for efficiency. Do not call this op with the output of
 * softmax, as it will produce incorrect results.
 *
 * logits and labels must have the same shape, e.g. [batch_size, num_classes]
 * and the same dtype.
 * @param labels The labels array.
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 */ function $7dd952f5e0f8b560$var$softmaxCrossEntropyWithLogits_(labels, logits, dim = -1) {
    if (dim === -1) dim = logits.rank - 1;
    if (dim !== logits.rank - 1) throw Error(`Softmax cross entropy along a non-last dimension is not yet ` + `supported. Labels / logits was rank ${logits.rank} ` + `and dim was ${dim}`);
    // Use a custom gradient for numerical stability.
    const customOp = (0, $d54cf47ed1e7fb8d$export$5519f0eeb00c44e5)((labels, logits, save)=>{
        // Reference:
        //   1. http://cs231n.github.io/linear-classify/#softmax
        //   2. https://blog.feedly.com/tricks-of-the-trade-logsumexp/
        const keepDims = true;
        const lse = (0, $46447b0d409676ff$export$e20aca1e89397787)(logits, [
            dim
        ], keepDims);
        const logResult = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)(logits, 'float32'), lse);
        save([
            labels,
            logResult
        ]);
        const costVector = (0, $5e6af6e46b1575dd$export$d9493ff0dfa0fdd5)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(logResult, labels));
        const value = (0, $140b816be4851e95$export$8a63f25cc62965f1)(costVector, [
            dim
        ]);
        const gradFunc = (dy, saved)=>{
            const [labels, logResult] = saved;
            const dyShape = (0, $fab93e7418eff1cc$export$e35db9afe008d7e3)(dy.shape, [
                dim
            ]);
            return [
                (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, dyShape), (0, $6b10a09db634e9ba$export$f93b5905241a7cca)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)(labels, 'float32'), (0, $87d347fdc039529f$export$b310ec824aaee37f)(logResult))),
                (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(dy, dyShape), (0, $6b10a09db634e9ba$export$f93b5905241a7cca)((0, $87d347fdc039529f$export$b310ec824aaee37f)(logResult), (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(labels, 'float32')))
            ];
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp(labels, logits);
}
/**
 * Computes the softmax cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newOnehotLabels = onehotLabels * (1 - labelSmoothing)
 *                         + labelSmoothing / numClasses
 *
 * @param onehotLabels One hot encoded labels
 *    [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or 1, and must be
 *    broadcastable to `loss`  of shape [batch_size]
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $7dd952f5e0f8b560$var$softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing = 0, reduction = (0, $cbfb65585ec3003c$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    let $onehotLabels = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(onehotLabels, 'onehotLabels', 'softmaxCrossEntropy');
    const $logits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(logits, 'logits', 'softmaxCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(weights, 'weights', 'softmaxCrossEntropy');
    (0, $9e4a6174e3538e7d$export$e08b27e7f37e2782)($onehotLabels.shape, $logits.shape, 'Error in softmaxCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(labelSmoothing);
        const one = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1);
        const numClasses = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)($onehotLabels.shape[1]);
        $onehotLabels = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)($onehotLabels, (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(one, labelSmoothingScalar)), (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(labelSmoothingScalar, numClasses));
    }
    const losses = $7dd952f5e0f8b560$var$softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
    return (0, $820fd25004437671$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $7dd952f5e0f8b560$export$38869aa02829577 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    softmaxCrossEntropy_: $7dd952f5e0f8b560$var$softmaxCrossEntropy_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * The input SparseTensor is represented via the map of inputs {`indices`,
 * `values`, `denseShape`}. The output SparseTensor has the same `denseShape`
 * but with indices `outputIndices` and values `outputValues`. This op inserts a
 * single entry for every row that doesn't have any values. The index is created
 * as `[row, 0, ..., 0]` and the inserted value is `defaultValue`.
 *
 * For example, suppose `spInput` has shape [5, 6] and non-empty values:
 * [0, 1]: a
 * [0, 3]: b
 * [2, 0]: c
 * [3, 1]: d
 *
 * Rows 1 and 4 are empty, so the output will be of shape [5, 6] with values:
 * [0, 1]: a
 * [0, 3]: b
 * [1, 0]: `defaultValue`
 * [2, 0]: c
 * [3, 1]: d
 * [4, 0]: `defaultValue`
 *
 * The output SparseTensor will be in row-major order and will have the same
 * shape as the input.
 *
 * This op also returns an indicator vector shaped [dense_shape[0]] such that
 * emptyRowIndicator[i] = True iff row i was an empty row.
 *
 * And a reverse index map vector shaped [indices.shape[0]] that is used during
 * backpropagation, reverseIndexMap[i] = outi s.t. indices[i, j] ==
 * outputIndices[outi, j] for all j
 *
 * ```js
 * const result = tf.sparse.sparseFillEmptyRows(
 *   [[0, 0], [1, 0], [1, 3], [1, 4], [3, 2], [3, 3]],
 *   [0, 10, 13, 14, 32, 33], [5, 6], -1);
 * console.log(result);
 * result['outputIndices'].print(); // [[0, 0], [1, 0], [1, 3], [1, 4],
 *                                  //  [2, 0], [3, 2], [3, 3], [4, 0]]
 * result['outputValues'].print(); // [0, 10, 13, 14,-1, 32, 33, -1]
 * result['emptyRowIndicator'].print(); // [false, false, true, false, true]
 * result['reverseIndexMap'].print(); // [0, 1, 2, 3, 5, 6]
 * ```
 * @param indices: 2-D. The indices of the sparse tensor.
 * @param values: 1-D. The values of the sparse tensor.
 * @param denseShape: 1-D. The shape of the sparse tensor.
 * @param defaultValue: 0-D. Default value to insert into location [row, 0, ...,
 *     0] for rows missing from the input sparse tensor.
 * @return A map with the following properties:
 *     - outputIndices
 *     - outputValues: 1-D. The values of the filled sparse tensor.
 *     - emptyRowIndicator: 1-D. Whether the dense row was missing in the input
 * sparse tensor.
 *     - reverseIndexMap: 1-D. A map from the input indices to the output
 * indices.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $d7bc3d8a9d9774c0$var$sparseFillEmptyRows_(indices, values, denseShape, defaultValue) {
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'sparseFillEmptyRows', 'int32');
    const $values = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(values, 'values', 'sparseFillEmptyRows');
    const $denseShape = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(denseShape, 'denseShape', 'sparseFillEmptyRows', 'int32');
    const $defaultValue = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(defaultValue, 'defaultValue', 'sparseFillEmptyRows', $values.dtype);
    if ($indices.rank !== 2) throw new Error(`Indices should be Tensor2D but received shape
        ${$indices.shape}`);
    if ($values.rank !== 1) throw new Error(`Values should be Tensor1D but received shape ${$values.shape}`);
    if ($denseShape.rank !== 1) throw new Error(`Dense shape should be Tensor1D but received shape ${$denseShape.shape}`);
    if ($defaultValue.rank !== 0) throw new Error(`Default value should be a scalar but received shape ${$defaultValue.shape}`);
    const inputs = {
        indices: $indices,
        values: $values,
        denseShape: $denseShape,
        defaultValue: $defaultValue
    };
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$8f1933853a5c8cca), inputs);
    return {
        outputIndices: result[0],
        outputValues: result[1],
        emptyRowIndicator: result[2],
        reverseIndexMap: result[3]
    };
}
const $d7bc3d8a9d9774c0$export$c82a1904a15b5028 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sparseFillEmptyRows_: $d7bc3d8a9d9774c0$var$sparseFillEmptyRows_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * This operation has the same semantics as reshape on the represented dense
 * tensor. The `inputIndices` are recomputed based on the requested `newShape`.
 * If one component of `newShape` is the special value -1, the size of that
 * dimension is computed so that the total dense size remains constant. At most
 * one component of `newShape` can be -1. The number of dense elements implied
 * by `newShape` must be the same as the number of dense elements originally
 * implied by `inputShape`. Reshaping does not affect the order of values in the
 * SparseTensor. If the input tensor has rank R_in and N non-empty values, and
 * `newShape` has length R_out, then `inputIndices` has shape [N, R_in],
 * `inputShape` has length R_in, `outputIndices` has shape [N, R_out], and
 * `outputShape` has length R_out.
 *
 * ```js
 * const result = tf.sparse.sparseReshape(
 *   [[0, 0, 0], [0, 0, 1], [0, 1, 0], [1, 0, 0], [1, 2, 3]],
 *   [2, 3, 6], [9, -1]);
 * console.log(result);
 * result['outputIndices'].print(); //[[0, 0], [0, 1], [1, 2], [4, 2], [8, 1]]
 * result['outputShape'].print(); // [9, 4]
 * ```
 * @param inputIndices: 2-D. N x R_in matrix with the indices of non-empty
 * values in a SparseTensor.
 * @param inputShape: 1-D. R_in Tensor1D with the input SparseTensor's dense
 * shape.
 * @param newShape: 1-D. R_out Tensor1D with the requested new dense shape.
 * @return A map with the following properties:
 *     - outputIndices: 2-D. N x R_out matrix with the updated indices of
 *       non-empty values in the output SparseTensor.
 *     - outputShape: 1-D. R_out vector with the full dense shape of the output
 *       SparseTensor. This is the same as newShape but with any -1 dimensions
 *        filled in.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $14321f29da54fc44$var$sparseReshape_(inputIndices, inputShape, newShape) {
    const $inputIndices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(inputIndices, 'inputIndices', 'sparseReshape', 'int32');
    const $inputShape = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(inputShape, 'inputShape', 'sparseReshape', 'int32');
    const $newShape = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(newShape, 'newShape', 'sparseReshape', 'int32');
    if ($inputIndices.rank !== 2) throw new Error(`Input indices should be Tensor2D but received shape
        ${$inputIndices.shape}`);
    if ($inputShape.rank !== 1) throw new Error(`Input shape should be Tensor1D but received shape ${$inputShape.shape}`);
    if ($newShape.rank !== 1) throw new Error(`New shape should be Tensor1D but received shape ${$newShape.shape}`);
    const inputs = {
        inputIndices: $inputIndices,
        inputShape: $inputShape,
        newShape: $newShape
    };
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$f08f0dca44fa542), inputs);
    return {
        outputIndices: result[0],
        outputShape: result[1]
    };
}
const $14321f29da54fc44$export$1408c45865e11fc6 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sparseReshape_: $14321f29da54fc44$var$sparseReshape_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the mean along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [6,7,8,9]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentMean(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1], 'int32'),
 *                                             tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1, 2], 'int32'),
 *                                             tf.tensor1d([0, 1, 1], 'int32'));
 * result3.print(); // [[1.0, 2.0, 3.0, 4.0], [2.5, 2.5, 2.5, 2.5]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $48cc0e22505c577e$var$sparseSegmentMean_(data, indices, segmentIds) {
    const $data = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(data, 'data', 'sparseSegmentMean');
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'sparseSegmentMean', 'int32');
    const $segmentIds = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(segmentIds, 'segmentIds', 'sparseSegmentMean', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
          ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
          ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$610b077aecc2447b), inputs);
}
const $48cc0e22505c577e$export$dbc0c9096869d04e = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sparseSegmentMean_: $48cc0e22505c577e$var$sparseSegmentMean_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the sum along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [5,6,7,8]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1, 2], 'int32'),
 *                                           tf.tensor1d([0, 0, 1], 'int32'));
 * result3.print(); // [[0, 0, 0, 0], [5, 6, 7, 8]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $dac8ecf65ddf5b5a$var$sparseSegmentSum_(data, indices, segmentIds) {
    const $data = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(data, 'data', 'sparseSegmentSum');
    const $indices = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(indices, 'indices', 'sparseSegmentSum', 'int32');
    const $segmentIds = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(segmentIds, 'segmentIds', 'sparseSegmentSum', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
         ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
         ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$68351c28d7116b56), inputs);
}
const $dac8ecf65ddf5b5a$export$2255ce53fc777865 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    sparseSegmentSum_: $dac8ecf65ddf5b5a$var$sparseSegmentSum_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates ngrams from ragged string data.
 *
 * This op accepts a ragged tensor with 1 ragged dimension containing only
 * strings and outputs a ragged tensor with 1 ragged dimension containing ngrams
 * of that string, joined along the innermost axis.
 *
 * ```js
 * const result = tf.string.stringNGrams(
 *   ['a', 'b', 'c', 'd'], tf.tensor1d([0, 2, 4], 'int32'),
 *   '|', [1, 2], 'LP', 'RP', -1, false);
 * result['nGrams'].print(); // ['a', 'b', 'LP|a', 'a|b', 'b|RP',
 *                           //  'c', 'd', 'LP|c', 'c|d', 'd|RP']
 * result['nGramsSplits'].print(); // [0, 5, 10]
 * ```
 * @param data: The values tensor of the ragged string tensor to make ngrams out
 *     of. Must be a 1D string tensor.
 * @param dataSplits: The splits tensor of the ragged string tensor to make
 *     ngrams out of.
 * @param separator: The string to append between elements of the token. Use ""
 *     for no separator.
 * @param nGramWidths: The sizes of the ngrams to create.
 * @param leftPad: The string to use to pad the left side of the ngram sequence.
 *     Only used if pad_width !== 0.
 * @param rightPad: The string to use to pad the right side of the ngram
 *     sequence. Only used if pad_width !== 0.
 * @param padWidth: The number of padding elements to add to each side of each
 *     sequence. Note that padding will never be greater than `nGramWidths`-1
 *     regardless of this value. If `padWidth`=-1, then add max(`nGramWidths`)-1
 *     elements.
 * @param preserveShortSequences: If true, then ensure that at least one ngram
 *     is generated for each input sequence. In particular, if an input sequence
 *     is shorter than min(ngramWidth) + 2*padWidth, then generate a single
 *     ngram containing the entire sequence. If false, then no ngrams are
 *     generated for these short input sequences.
 * @return A map with the following properties:
 *     - nGrams: The values tensor of the output ngrams ragged tensor.
 *     - nGramsSplits: The splits tensor of the output ngrams ragged tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $83b51f93aa32d47b$var$stringNGrams_(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    const $data = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(data, 'data', 'stringNGrams', 'string');
    if ($data.dtype !== 'string') throw new Error('Data must be of datatype string');
    if ($data.shape.length !== 1) throw new Error(`Data must be a vector, saw: ${$data.shape}`);
    const $dataSplits = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(dataSplits, 'dataSplits', 'stringNGrams');
    if ($dataSplits.dtype !== 'int32') throw new Error('Data splits must be of datatype int32');
    const attrs = {
        separator: separator,
        nGramWidths: nGramWidths,
        leftPad: leftPad,
        rightPad: rightPad,
        padWidth: padWidth,
        preserveShortSequences: preserveShortSequences
    };
    const inputs = {
        data: $data,
        dataSplits: $dataSplits
    };
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$11a7f4af7d96ad41), inputs, attrs);
    return {
        nGrams: result[0],
        nGramsSplits: result[1]
    };
}
const $83b51f93aa32d47b$export$3490514dcc63b044 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    stringNGrams_: $83b51f93aa32d47b$var$stringNGrams_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Split elements of `input` based on `delimiter` into a SparseTensor .
 *
 * Let N be the size of source (typically N will be the batch size). Split each
 * element of `input` based on `delimiter` and return a SparseTensor containing
 * the splitted tokens. Empty tokens are ignored if `skipEmpty` is set to True.
 *
 * `delimiter` can be empty, or a string of split characters. If `delimiter` is
 * an empty string, each element of `input` is split into individual
 * character strings. Otherwise every character of `delimiter` is a potential
 * split point.
 *
 * ```js
 * const result = tf.string.stringSplit(['hello world',  'a b c'], ' ');
 * result['indices'].print(); // [[0, 0], [0, 1], [1, 0], [1, 1], [1, 2]]
 * result['values'].print(); // ['hello', 'world', 'a', 'b', 'c']
 * result['shape'].print(); // [2, 3]
 * ```
 * @param input: 1-D. Strings to split.
 * @param delimiter: 0-D. Delimiter characters, or empty string.
 * @param skipEmpty: Optional. If true, skip the empty strings from the result.
 *     Defaults to true.
 * @return A map with the following properties:
 *     - indices: A dense matrix of int32 representing the indices of the sparse
 *       tensor.
 *     - values: A vector of strings corresponding to the splited values.
 *     - shape: a length-2 vector of int32 representing the shape of the sparse
 * tensor, where the first value is N and the second value is the maximum number
 * of tokens in a single input entry.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $c53a8286bd675976$var$stringSplit_(input, delimiter, skipEmpty = true) {
    const $input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(input, 'input', 'stringSplit', 'string');
    const $delimiter = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(delimiter, 'delimiter', 'stringSplit', 'string');
    if ($input.rank !== 1) throw new Error(`Input should be Tensor1D but received shape ${$input.shape}`);
    if ($delimiter.rank !== 0) throw new Error(`Delimiter should be a scalar but received shape ${$delimiter.shape}`);
    const attrs = {
        skipEmpty: skipEmpty
    };
    const inputs = {
        input: $input,
        delimiter: $delimiter
    };
    const result = (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$7e266f7223b9d396), inputs, attrs);
    return {
        indices: result[0],
        values: result[1],
        shape: result[2]
    };
}
const $c53a8286bd675976$export$aa7f8babb17e7672 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    stringSplit_: $c53a8286bd675976$var$stringSplit_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Converts each string in the input Tensor to its hash mod by a number of
 * buckets.
 *
 * The hash function is deterministic on the content of the string within the
 * process and will never change. However, it is not suitable for cryptography.
 * This function may be used when CPU time is scarce and inputs are trusted or
 * unimportant. There is a risk of adversaries constructing inputs that all hash
 * to the same bucket.
 *
 * ```js
 * const result = tf.string.stringToHashBucketFast(
 *   ['Hello', 'TensorFlow', '2.x'], 3);
 * result.print(); // [0, 2, 2]
 * ```
 * @param input: The strings to assign a hash bucket.
 * @param numBuckets: The number of buckets.
 * @return A Tensor of the same shape as the input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $79cc735e4f69b483$var$stringToHashBucketFast_(input, numBuckets) {
    const $input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(input, 'input', 'stringToHashBucketFast', 'string');
    const attrs = {
        numBuckets: numBuckets
    };
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const inputs = {
        input: $input
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$a5639899909bc8ae), inputs, attrs);
}
const $79cc735e4f69b483$export$6195616d6fd0c848 = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    stringToHashBucketFast_: $79cc735e4f69b483$var$stringToHashBucketFast_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Replace the match of a `pattern` in `input` with `rewrite`.
 *
 * ```js
 * const result = tf.string.staticRegexReplace(
 *     ['format       this   spacing      better'], ' +', ' ');
 * result.print(); // ['format this spacing better']
 * ```
 * @param input: A Tensor of type string. The text to be processed.
 * @param pattern: A string. The regular expression to match the input.
 * @param rewrite: A string. The rewrite to be applied to the matched
 *     expression.
 * @param replaceGlobal: An optional bool. Defaults to True. If True, the
 *     replacement is global, otherwise the replacement is done only on the
 *     first match.
 * @return A Tensor of type string.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $47ec680f7a8a071c$var$staticRegexReplace_(input, pattern, rewrite, replaceGlobal = true) {
    const $input = (0, $539f0ce07f2139cd$export$ede379c4c939d71a)(input, 'input', 'staticRegexReplace', 'string');
    const attrs = {
        pattern: pattern,
        rewrite: rewrite,
        replaceGlobal: replaceGlobal
    };
    return (0, $6a645535e157b279$export$33b63313cc511a3b).runKernel((0, $507890e4aa8e1463$export$2fbaa77553edaeff), {
        x: $input
    }, attrs);
}
const $47ec680f7a8a071c$export$2bdfdc7ae087914d = /* @__PURE__ */ (0, $90f933163f6ac994$export$f59964a629598e2)({
    staticRegexReplace_: $47ec680f7a8a071c$var$staticRegexReplace_
});


const $0d9cd03b68b74ca9$export$e0ccf6166915bd59 = {
    fft: $0c1f0be368155dff$export$a535ef183b6128fa,
    ifft: $349f5d08af454fa3$export$776649b0bf8ce1fd,
    rfft: $ba0ceb1c91713e10$export$72aff1768917e9e5,
    irfft: $0d3fdeaac3c3258b$export$f47f4e5bcd3d6a66
};
const $0d9cd03b68b74ca9$export$e2ef10f86a8d60e8 = {
    hammingWindow: $927342ffc2919545$export$941eafcc99b559fa,
    hannWindow: $f28f4f764f4a5d69$export$f498cfeee84e5e59,
    frame: $155310928eda6858$export$2cef06c20297c17d,
    stft: $73eaadde74ade07b$export$eb1cf9b274257b4a
};
const $0d9cd03b68b74ca9$export$5c452ff88e35e47d = {
    flipLeftRight: $0a22e8c7803e3a78$export$8358b9c43b687b22,
    grayscaleToRGB: $a28956bfb10bb242$export$f68e334bfd7e4be6,
    resizeNearestNeighbor: $98e2687b0d12dea1$export$74a902ae74ac2560,
    resizeBilinear: $dd1a21ef8789a001$export$1f1cbc7da93d06a0,
    rgbToGrayscale: $10e7930ae7b8ab41$export$490c4fde2e852c50,
    rotateWithOffset: $6434ae01b5488b19$export$66462c489f5f29d2,
    cropAndResize: $ed310b04f11591d1$export$6f0f0090e1f6cd3c,
    nonMaxSuppression: $5878d767f846ccd0$export$b7d265b19ca1d628,
    nonMaxSuppressionAsync: $2c6c92014403a7d6$export$cc6d94dffac2ee1a,
    nonMaxSuppressionWithScore: $fe0195b5546f341d$export$d65fe1460f8c5b4e,
    nonMaxSuppressionWithScoreAsync: $58abf3e728985344$export$d1826570c883f7cf,
    nonMaxSuppressionPadded: $2b12037396e50226$export$d8d10e31c41c95dc,
    nonMaxSuppressionPaddedAsync: $1b8252b7329dde8c$export$4c5691f9710b88a8,
    threshold: $fa9131fba8a4ae84$export$454d09aca5f3ea63,
    transform: $5049ac4f71b8b833$export$51186ad6e864892a
};
const $0d9cd03b68b74ca9$export$dbc5be37a4415193 = {
    bandPart: $4450bd2a0f4e89e2$export$8a3da9cb9e5610a0,
    gramSchmidt: $fb77a4819e9e6562$export$d505610386a600de,
    qr: $e9c3650e4f46ded3$export$7c27fb47516129d9
};
const $0d9cd03b68b74ca9$export$24b113a95118cbdc = {
    absoluteDifference: $d9f00ce12e6ae39b$export$d81f35aebafd8971,
    computeWeightedLoss: $820fd25004437671$export$23bdc4cea2e28782,
    cosineDistance: $80df439a0f781cbd$export$6168ae03858f836b,
    hingeLoss: $ef637bf240b3376b$export$fc7754731492f43f,
    huberLoss: $0f10f239b63555a5$export$ad2dd557b367bf2b,
    logLoss: $8e8e10bdfd1395c5$export$5ca6937b99935214,
    meanSquaredError: $91eb54970777b251$export$33de16355e97f7fb,
    sigmoidCrossEntropy: $b724683f3ebebaca$export$d099e04c73e0aede,
    softmaxCrossEntropy: $7dd952f5e0f8b560$export$38869aa02829577
};
const $0d9cd03b68b74ca9$export$b6b7e189aa5d134c = {
    sparseFillEmptyRows: $d7bc3d8a9d9774c0$export$c82a1904a15b5028,
    sparseReshape: $14321f29da54fc44$export$1408c45865e11fc6,
    sparseSegmentMean: $48cc0e22505c577e$export$dbc0c9096869d04e,
    sparseSegmentSum: $dac8ecf65ddf5b5a$export$2255ce53fc777865
};
// tslint:disable-next-line:variable-name
const $0d9cd03b68b74ca9$export$22b082955e083ec3 = {
    stringNGrams: $83b51f93aa32d47b$export$3490514dcc63b044,
    stringSplit: $c53a8286bd675976$export$aa7f8babb17e7672,
    stringToHashBucketFast: $79cc735e4f69b483$export$6195616d6fd0c848,
    staticRegexReplace: $47ec680f7a8a071c$export$2bdfdc7ae087914d
};
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $86fbfbd5b79067b7$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $4c4a44db5126e023$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $7220c998b208dd38$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $a770653602fd0ab9$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $e5baeb58226512cf$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $415cbd1cccb3aab5$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $a68df053c9fd42d0$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $cf1cbb74dc1c5ef3$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $d534d97f12b33c25$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $a9d9c2aa71ee0001$exports);
$parcel$exportWildcard($0d9cd03b68b74ca9$exports, $f374788c740c08d5$exports);

var $6259f6994b8d164e$exports = {};

$parcel$export($6259f6994b8d164e$exports, "copyModel", () => $1b50d059503ab55e$export$b5971478866000ed);
$parcel$export($6259f6994b8d164e$exports, "listModels", () => $1b50d059503ab55e$export$8d63af86d795ece4);
$parcel$export($6259f6994b8d164e$exports, "moveModel", () => $1b50d059503ab55e$export$598f168272f4fec2);
$parcel$export($6259f6994b8d164e$exports, "removeModel", () => $1b50d059503ab55e$export$e71037184d1ad0fd);
$parcel$export($6259f6994b8d164e$exports, "browserFiles", () => $f783f75edc452ec2$export$6729643cf069471c);
$parcel$export($6259f6994b8d164e$exports, "browserHTTPRequest", () => $d606e25919312de3$export$624ff5bc4e3a9d72);
$parcel$export($6259f6994b8d164e$exports, "CompositeArrayBuffer", () => $dfd620ba1104fd6f$export$fd7a5551e5344016);
$parcel$export($6259f6994b8d164e$exports, "concatenateArrayBuffers", () => $6b95449a1ec560d1$export$9a3e9c78eb778da8);
$parcel$export($6259f6994b8d164e$exports, "decodeWeights", () => $6b95449a1ec560d1$export$7a14c2428d4f4a2e);
$parcel$export($6259f6994b8d164e$exports, "decodeWeightsStream", () => $6b95449a1ec560d1$export$6c19531ae9ba1204);
$parcel$export($6259f6994b8d164e$exports, "encodeWeights", () => $6b95449a1ec560d1$export$6c50c12dbd6168b);
$parcel$export($6259f6994b8d164e$exports, "fromMemory", () => $4cc15242262df971$export$89ba941c7951a2e8);
$parcel$export($6259f6994b8d164e$exports, "fromMemorySync", () => $4cc15242262df971$export$c22472cb1d774f45);
$parcel$export($6259f6994b8d164e$exports, "getLoadHandlers", () => $cd899f472e2dfa40$export$90c6c4d24103fa9a);
$parcel$export($6259f6994b8d164e$exports, "getModelArtifactsForJSON", () => $6b95449a1ec560d1$export$b867c14eedd5b8a2);
$parcel$export($6259f6994b8d164e$exports, "getModelArtifactsForJSONSync", () => $6b95449a1ec560d1$export$ebf48c0f134e5c8);
$parcel$export($6259f6994b8d164e$exports, "getModelArtifactsInfoForJSON", () => $6b95449a1ec560d1$export$ece8b449d7d29272);
$parcel$export($6259f6994b8d164e$exports, "getSaveHandlers", () => $cd899f472e2dfa40$export$88af18fd9ddb62ff);
$parcel$export($6259f6994b8d164e$exports, "getWeightSpecs", () => $6b95449a1ec560d1$export$9f3fe06e8e8def44);
$parcel$export($6259f6994b8d164e$exports, "http", () => $d606e25919312de3$export$7d6f1c8842f9f527);
$parcel$export($6259f6994b8d164e$exports, "isHTTPScheme", () => $d606e25919312de3$export$18a721ae4733601b);
$parcel$export($6259f6994b8d164e$exports, "loadWeights", () => $e2852ead16278a59$export$55f7d42d35356096);
$parcel$export($6259f6994b8d164e$exports, "registerLoadRouter", () => $cd899f472e2dfa40$export$8bf64df3d1fb9866);
$parcel$export($6259f6994b8d164e$exports, "registerSaveRouter", () => $cd899f472e2dfa40$export$94da4683f36f634e);
$parcel$export($6259f6994b8d164e$exports, "weightsLoaderFactory", () => $e2852ead16278a59$export$635f986c4ab6ebe2);
$parcel$export($6259f6994b8d164e$exports, "withSaveHandler", () => $4cc15242262df971$export$fa4a26428614aae7);
$parcel$export($6259f6994b8d164e$exports, "withSaveHandlerSync", () => $4cc15242262df971$export$53913891eb9f0585);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Importing local_storage and indexed_db is necessary for the routers to be
// registered.


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandlers related to files, such as browser-triggered file downloads,
 * user-selected files in browser.
 */ 




const $f783f75edc452ec2$var$DEFAULT_FILE_NAME_PREFIX = 'model';
const $f783f75edc452ec2$var$DEFAULT_JSON_EXTENSION_NAME = '.json';
const $f783f75edc452ec2$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME = '.weights.bin';
function $f783f75edc452ec2$var$defer(f) {
    return new Promise((resolve)=>setTimeout(resolve)).then(f);
}
class $f783f75edc452ec2$export$cc3c076530f2848f {
    constructor(fileNamePrefix){
        if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) // TODO(cais): Provide info on what IOHandlers are available under the
        //   current environment.
        throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        if (fileNamePrefix.startsWith($f783f75edc452ec2$export$cc3c076530f2848f.URL_SCHEME)) fileNamePrefix = fileNamePrefix.slice($f783f75edc452ec2$export$cc3c076530f2848f.URL_SCHEME.length);
        if (fileNamePrefix == null || fileNamePrefix.length === 0) fileNamePrefix = $f783f75edc452ec2$var$DEFAULT_FILE_NAME_PREFIX;
        this.modelJsonFileName = fileNamePrefix + $f783f75edc452ec2$var$DEFAULT_JSON_EXTENSION_NAME;
        this.weightDataFileName = fileNamePrefix + $f783f75edc452ec2$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
    }
    async save(modelArtifacts) {
        if (typeof document === 'undefined') throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        // TODO(mattsoulanille): Support saving models over 2GB that exceed
        // Chrome's ArrayBuffer size limit.
        const weightBuffer = (0, $dfd620ba1104fd6f$export$fd7a5551e5344016).join(modelArtifacts.weightData);
        const weightsURL = window.URL.createObjectURL(new Blob([
            weightBuffer
        ], {
            type: 'application/octet-stream'
        }));
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
        else {
            const weightsManifest = [
                {
                    paths: [
                        './' + this.weightDataFileName
                    ],
                    weights: modelArtifacts.weightSpecs
                }
            ];
            const modelJSON = (0, $6b95449a1ec560d1$export$a725daa2cfaa7bd5)(modelArtifacts, weightsManifest);
            const modelJsonURL = window.URL.createObjectURL(new Blob([
                JSON.stringify(modelJSON)
            ], {
                type: 'application/json'
            }));
            // If anchor elements are not provided, create them without attaching them
            // to parents, so that the downloaded file names can be controlled.
            const jsonAnchor = this.modelJsonAnchor == null ? document.createElement('a') : this.modelJsonAnchor;
            jsonAnchor.download = this.modelJsonFileName;
            jsonAnchor.href = modelJsonURL;
            // Trigger downloads by evoking a click event on the download anchors.
            // When multiple downloads are started synchronously, Firefox will only
            // save the last one.
            await $f783f75edc452ec2$var$defer(()=>jsonAnchor.dispatchEvent(new MouseEvent('click')));
            if (modelArtifacts.weightData != null) {
                const weightDataAnchor = this.weightDataAnchor == null ? document.createElement('a') : this.weightDataAnchor;
                weightDataAnchor.download = this.weightDataFileName;
                weightDataAnchor.href = weightsURL;
                await $f783f75edc452ec2$var$defer(()=>weightDataAnchor.dispatchEvent(new MouseEvent('click')));
            }
            return {
                modelArtifactsInfo: (0, $6b95449a1ec560d1$export$ece8b449d7d29272)(modelArtifacts)
            };
        }
    }
}
$f783f75edc452ec2$export$cc3c076530f2848f.URL_SCHEME = 'downloads://';
class $f783f75edc452ec2$var$BrowserFiles {
    constructor(files){
        if (files == null || files.length < 1) throw new Error(`When calling browserFiles, at least 1 file is required, ` + `but received ${files}`);
        this.jsonFile = files[0];
        this.weightsFiles = files.slice(1);
    }
    async load() {
        return new Promise((resolve, reject)=>{
            const jsonReader = new FileReader();
            jsonReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const modelJSON = JSON.parse(event.target.result);
                const modelTopology = modelJSON.modelTopology;
                if (modelTopology == null) {
                    reject(new Error(`modelTopology field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                const weightsManifest = modelJSON.weightsManifest;
                if (weightsManifest == null) {
                    reject(new Error(`weightManifest field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (this.weightsFiles.length === 0) {
                    resolve({
                        modelTopology: modelTopology
                    });
                    return;
                }
                const modelArtifactsPromise = (0, $6b95449a1ec560d1$export$b867c14eedd5b8a2)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
                resolve(modelArtifactsPromise);
            };
            jsonReader.onerror = (error)=>reject(`Failed to read model topology and weights manifest JSON ` + `from file '${this.jsonFile.name}'. BrowserFiles supports loading ` + `Keras-style tf.Model artifacts only.`);
            jsonReader.readAsText(this.jsonFile);
        });
    }
    loadWeights(weightsManifest) {
        const weightSpecs = [];
        const paths = [];
        for (const entry of weightsManifest){
            weightSpecs.push(...entry.weights);
            paths.push(...entry.paths);
        }
        const pathToFile = this.checkManifestAndWeightFiles(weightsManifest);
        const promises = paths.map((path)=>this.loadWeightsFile(path, pathToFile[path]));
        return Promise.all(promises).then((buffers)=>[
                weightSpecs,
                buffers
            ]);
    }
    loadWeightsFile(path, file) {
        return new Promise((resolve, reject)=>{
            const weightFileReader = new FileReader();
            weightFileReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const weightData = event.target.result;
                resolve(weightData);
            };
            weightFileReader.onerror = (error)=>reject(`Failed to weights data from file of path '${path}'.`);
            weightFileReader.readAsArrayBuffer(file);
        });
    }
    /**
     * Check the compatibility between weights manifest and weight files.
     */ checkManifestAndWeightFiles(manifest) {
        const basenames = [];
        const fileNames = this.weightsFiles.map((file)=>(0, $6b95449a1ec560d1$export$9bf319d8f74f51d1)(file.name));
        const pathToFile = {};
        for (const group of manifest)group.paths.forEach((path)=>{
            const pathBasename = (0, $6b95449a1ec560d1$export$9bf319d8f74f51d1)(path);
            if (basenames.indexOf(pathBasename) !== -1) throw new Error(`Duplicate file basename found in weights manifest: ` + `'${pathBasename}'`);
            basenames.push(pathBasename);
            if (fileNames.indexOf(pathBasename) === -1) throw new Error(`Weight file with basename '${pathBasename}' is not provided.`);
            else pathToFile[path] = this.weightsFiles[fileNames.indexOf(pathBasename)];
        });
        if (basenames.length !== this.weightsFiles.length) throw new Error(`Mismatch in the number of files in weights manifest ` + `(${basenames.length}) and the number of weight files provided ` + `(${this.weightsFiles.length}).`);
        return pathToFile;
    }
}
const $f783f75edc452ec2$export$6149c5f14395749b = (url)=>{
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($f783f75edc452ec2$export$cc3c076530f2848f.URL_SCHEME)) return $f783f75edc452ec2$export$8fbc9551c735f788(url.slice($f783f75edc452ec2$export$cc3c076530f2848f.URL_SCHEME.length));
        else return null;
    }
};
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerSaveRouter($f783f75edc452ec2$export$6149c5f14395749b);
function $f783f75edc452ec2$export$8fbc9551c735f788(fileNamePrefix = 'model') {
    return new $f783f75edc452ec2$export$cc3c076530f2848f(fileNamePrefix);
}
function $f783f75edc452ec2$export$6729643cf069471c(files) {
    return new $f783f75edc452ec2$var$BrowserFiles(files);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandler implementations based on HTTP requests in the web browser.
 *
 * Uses [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
 */ 




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $ac7ea0cb6d408c65$export$b88cae388b9e062e(promises, onProgress, startFraction, endFraction) {
    checkPromises(promises);
    startFraction = startFraction == null ? 0 : startFraction;
    endFraction = endFraction == null ? 1 : endFraction;
    checkFraction(startFraction, endFraction);
    let resolvedPromise = 0;
    const registerMonitor = (promise)=>{
        promise.then((value)=>{
            const fraction = startFraction + ++resolvedPromise / promises.length * (endFraction - startFraction);
            // pass fraction as parameter to callback function.
            onProgress(fraction);
            return value;
        });
        return promise;
    };
    function checkPromises(promises) {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(promises != null && Array.isArray(promises) && promises.length > 0, ()=>'promises must be a none empty array');
    }
    function checkFraction(startFraction, endFraction) {
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(startFraction >= 0 && startFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got startFraction ${startFraction}`);
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(endFraction >= 0 && endFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got endFraction ${endFraction}`);
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(endFraction >= startFraction, ()=>`startFraction must be no more than endFraction, but ` + `got startFraction ${startFraction} and endFraction ` + `${endFraction}`);
    }
    return Promise.all(promises.map(registerMonitor));
}



async function $e2852ead16278a59$export$6873c1a1d3325bf7(fetchURLs, loadOptions) {
    if (loadOptions == null) loadOptions = {};
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.fetch : loadOptions.fetchFunc;
    // Create the requests for all of the weights in parallel.
    const requests = fetchURLs.map((fetchURL)=>fetchFunc(fetchURL, loadOptions.requestInit, {
            isBinary: true
        }));
    const fetchStartFraction = 0;
    const fetchEndFraction = 0.5;
    const responses = loadOptions.onProgress == null ? await Promise.all(requests) : await (0, $ac7ea0cb6d408c65$export$b88cae388b9e062e)(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction);
    const bufferPromises = responses.map((response)=>response.arrayBuffer());
    const bufferStartFraction = 0.5;
    const bufferEndFraction = 1;
    const buffers = loadOptions.onProgress == null ? await Promise.all(bufferPromises) : await (0, $ac7ea0cb6d408c65$export$b88cae388b9e062e)(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction);
    return buffers;
}
function $e2852ead16278a59$export$4fc61cabab0a1e7e(fetchURLs, loadOptions) {
    var _a;
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.fetch : loadOptions.fetchFunc;
    let fetchIndex = 0;
    let chunkReader;
    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, 0);
    return new ReadableStream({
        pull: async (controller)=>{
            var _a;
            while(fetchIndex < fetchURLs.length){
                if (!chunkReader) {
                    const body = (await fetchFunc(fetchURLs[fetchIndex], loadOptions.requestInit, {
                        isBinary: true
                    })).body;
                    chunkReader = body.getReader();
                }
                const { done: done, value: value } = await chunkReader.read();
                if (done) {
                    fetchIndex++;
                    chunkReader = undefined;
                    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, fetchIndex / fetchURLs.length);
                    continue;
                }
                controller.enqueue(value);
                return;
            }
            controller.close();
        }
    });
}
async function $e2852ead16278a59$export$55f7d42d35356096(manifest, filePathPrefix = '', weightNames, requestInit) {
    // TODO(nsthorat): Groups are currently fetched atomically. If you need a
    // single weight from a group, the whole group will be fetched. At a future
    // date, we should support fetching only the individual shards within a
    // group that are needed to reconstruct the requested weight.
    // TODO(cais): Use `decodeWeights` for implementation.
    const fetchWeights = (fetchUrls)=>$e2852ead16278a59$export$6873c1a1d3325bf7(fetchUrls, {
            requestInit: requestInit
        });
    const loadWeights1 = $e2852ead16278a59$export$635f986c4ab6ebe2(fetchWeights);
    return loadWeights1(manifest, filePathPrefix, weightNames);
}
function $e2852ead16278a59$export$635f986c4ab6ebe2(fetchWeightsFunction) {
    return async (manifest, filePathPrefix = '', weightNames)=>{
        // Collect all the groups, weights, and their relative offsets to be
        // fetched.
        const groupIndicesToFetchMap = manifest.map(()=>false);
        const groupWeightsToFetch = {};
        const weightsFound = weightNames != null ? weightNames.map(()=>false) : [];
        const allManifestWeightNames = [];
        manifest.forEach((manifestGroupConfig, groupIndex)=>{
            let groupOffset = 0;
            manifestGroupConfig.weights.forEach((weightsEntry)=>{
                const rawDtype = 'quantization' in weightsEntry ? weightsEntry.quantization.dtype : weightsEntry.dtype;
                const weightsBytes = (0, $aa89193df21f6c84$export$8103dee73e5eaa46)[rawDtype] * $9e4a6174e3538e7d$export$b4c3214a70a0e73f(weightsEntry.shape);
                const enqueueWeightsForFetchingFn = ()=>{
                    groupIndicesToFetchMap[groupIndex] = true;
                    if (groupWeightsToFetch[groupIndex] == null) groupWeightsToFetch[groupIndex] = [];
                    groupWeightsToFetch[groupIndex].push({
                        manifestEntry: weightsEntry,
                        groupOffset: groupOffset,
                        sizeBytes: weightsBytes
                    });
                };
                if (weightNames != null) weightNames.forEach((weightName, weightIndex)=>{
                    if (weightName === weightsEntry.name) {
                        enqueueWeightsForFetchingFn();
                        weightsFound[weightIndex] = true;
                    }
                });
                else enqueueWeightsForFetchingFn();
                allManifestWeightNames.push(weightsEntry.name);
                groupOffset += weightsBytes;
            });
        });
        if (!weightsFound.every((found)=>found)) {
            const weightsNotFound = weightNames.filter((_, i)=>!weightsFound[i]);
            throw new Error(`Could not find weights in manifest with names: ` + `${weightsNotFound.join(', ')}. \n` + `Manifest JSON has weights with names: ` + `${allManifestWeightNames.join(', ')}.`);
        }
        // Convert the one-hot boolean groupId => shouldFetch map to a list of group
        // IDs.
        const groupIndicesToFetch = groupIndicesToFetchMap.reduce((accumulator, shouldFetch, i)=>{
            if (shouldFetch) accumulator.push(i);
            return accumulator;
        }, []);
        const fetchUrls = [];
        groupIndicesToFetch.forEach((i)=>{
            manifest[i].paths.forEach((filepath)=>{
                const fetchUrl = filePathPrefix + (!filePathPrefix.endsWith('/') ? '/' : '') + filepath;
                fetchUrls.push(fetchUrl);
            });
        });
        const buffers = await fetchWeightsFunction(fetchUrls);
        const weightsTensorMap = {};
        let bufferIndexOffset = 0;
        groupIndicesToFetch.forEach((i)=>{
            const numBuffers = manifest[i].paths.length;
            const weightsBuffer = new (0, $dfd620ba1104fd6f$export$fd7a5551e5344016)(buffers.slice(bufferIndexOffset, bufferIndexOffset + numBuffers));
            const weightsEntries = groupWeightsToFetch[i];
            weightsEntries.forEach((weightsEntry)=>{
                const byteBuffer = weightsBuffer.slice(weightsEntry.groupOffset, weightsEntry.groupOffset + weightsEntry.sizeBytes);
                const nameToTensorMap = (0, $6b95449a1ec560d1$export$7a14c2428d4f4a2e)(byteBuffer, [
                    weightsEntry.manifestEntry
                ]);
                for(const name in nameToTensorMap)weightsTensorMap[name] = nameToTensorMap[name];
            });
            bufferIndexOffset += numBuffers;
        });
        return weightsTensorMap;
    };
}


const $d606e25919312de3$var$OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
const $d606e25919312de3$var$JSON_TYPE = 'application/json';
class $d606e25919312de3$export$3df08bb5d0f8b499 {
    constructor(path, loadOptions){
        this.DEFAULT_METHOD = 'POST';
        if (loadOptions == null) loadOptions = {};
        this.weightPathPrefix = loadOptions.weightPathPrefix;
        this.weightUrlConverter = loadOptions.weightUrlConverter;
        if (loadOptions.fetchFunc != null) {
            (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(typeof loadOptions.fetchFunc === 'function', ()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)");
            this.fetch = loadOptions.fetchFunc;
        } else this.fetch = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.fetch;
        (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(path != null && path.length > 0, ()=>"URL path for http must not be null, undefined or empty.");
        if (Array.isArray(path)) (0, $9e4a6174e3538e7d$export$a7a9523472993e97)(path.length === 2, ()=>'URL paths for http must have a length of 2, ' + `(actual length is ${path.length}).`);
        this.path = path;
        if (loadOptions.requestInit != null && loadOptions.requestInit.body != null) throw new Error('requestInit is expected to have no pre-existing body, but has one.');
        this.requestInit = loadOptions.requestInit || {};
        this.loadOptions = loadOptions;
    }
    async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const init = Object.assign({
            method: this.DEFAULT_METHOD
        }, this.requestInit);
        init.body = new FormData();
        const weightsManifest = [
            {
                paths: [
                    './model.weights.bin'
                ],
                weights: modelArtifacts.weightSpecs
            }
        ];
        const modelTopologyAndWeightManifest = (0, $6b95449a1ec560d1$export$a725daa2cfaa7bd5)(modelArtifacts, weightsManifest);
        init.body.append('model.json', new Blob([
            JSON.stringify(modelTopologyAndWeightManifest)
        ], {
            type: $d606e25919312de3$var$JSON_TYPE
        }), 'model.json');
        if (modelArtifacts.weightData != null) {
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $dfd620ba1104fd6f$export$fd7a5551e5344016).join(modelArtifacts.weightData);
            init.body.append('model.weights.bin', new Blob([
                weightBuffer
            ], {
                type: $d606e25919312de3$var$OCTET_STREAM_MIME_TYPE
            }), 'model.weights.bin');
        }
        const response = await this.fetch(this.path, init);
        if (response.ok) return {
            modelArtifactsInfo: (0, $6b95449a1ec560d1$export$ece8b449d7d29272)(modelArtifacts),
            responses: [
                response
            ]
        };
        else throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ` + `${response.status}.`);
    }
    async loadModelJSON() {
        const modelConfigRequest = await this.fetch(this.path, this.requestInit);
        if (!modelConfigRequest.ok) throw new Error(`Request to ${this.path} failed with status code ` + `${modelConfigRequest.status}. Please verify this URL points to ` + `the model JSON of the model to load.`);
        let modelJSON;
        try {
            modelJSON = await modelConfigRequest.json();
        } catch (e) {
            let message = `Failed to parse model JSON of response from ${this.path}.`;
            // TODO(nsthorat): Remove this after some time when we're comfortable that
            // .pb files are mostly gone.
            if (this.path.endsWith('.pb')) message += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.";
            else message += " Please make sure the server is serving valid JSON for this request.";
            throw new Error(message);
        }
        // We do not allow both modelTopology and weightsManifest to be missing.
        const modelTopology = modelJSON.modelTopology;
        const weightsManifest = modelJSON.weightsManifest;
        if (modelTopology == null && weightsManifest == null) throw new Error(`The JSON from HTTP path ${this.path} contains neither model ` + `topology or manifest for weights.`);
        return modelJSON;
    }
    /**
     * Load model artifacts via HTTP request(s).
     *
     * See the documentation to `tf.io.http` for details on the saved
     * artifacts.
     *
     * @returns The loaded model artifacts (if loading succeeds).
     */ async load() {
        if (this.loadOptions.streamWeights) return this.loadStream();
        const modelJSON = await this.loadModelJSON();
        return (0, $6b95449a1ec560d1$export$b867c14eedd5b8a2)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
    }
    async loadStream() {
        const modelJSON = await this.loadModelJSON();
        const fetchURLs = await this.getWeightUrls(modelJSON.weightsManifest);
        const weightSpecs = (0, $6b95449a1ec560d1$export$9f3fe06e8e8def44)(modelJSON.weightsManifest);
        const stream = ()=>(0, $e2852ead16278a59$export$4fc61cabab0a1e7e)(fetchURLs, this.loadOptions);
        return Object.assign(Object.assign({}, modelJSON), {
            weightSpecs: weightSpecs,
            getWeightStream: stream
        });
    }
    async getWeightUrls(weightsManifest) {
        const weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
        const [prefix, suffix] = $d606e25919312de3$export$7a5253c0f62e0150(weightPath);
        const pathPrefix = this.weightPathPrefix || prefix;
        const fetchURLs = [];
        const urlPromises = [];
        for (const weightsGroup of weightsManifest){
            for (const path of weightsGroup.paths)if (this.weightUrlConverter != null) urlPromises.push(this.weightUrlConverter(path));
            else fetchURLs.push(pathPrefix + path + suffix);
        }
        if (this.weightUrlConverter) fetchURLs.push(...await Promise.all(urlPromises));
        return fetchURLs;
    }
    async loadWeights(weightsManifest) {
        const fetchURLs = await this.getWeightUrls(weightsManifest);
        const weightSpecs = (0, $6b95449a1ec560d1$export$9f3fe06e8e8def44)(weightsManifest);
        const buffers = await (0, $e2852ead16278a59$export$6873c1a1d3325bf7)(fetchURLs, this.loadOptions);
        return [
            weightSpecs,
            buffers
        ];
    }
}
$d606e25919312de3$export$3df08bb5d0f8b499.URL_SCHEME_REGEX = /^https?:\/\//;
function $d606e25919312de3$export$7a5253c0f62e0150(url) {
    const lastSlash = url.lastIndexOf('/');
    const lastSearchParam = url.lastIndexOf('?');
    const prefix = url.substring(0, lastSlash);
    const suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : '';
    return [
        prefix + '/',
        suffix
    ];
}
function $d606e25919312de3$export$18a721ae4733601b(url) {
    return url.match($d606e25919312de3$export$3df08bb5d0f8b499.URL_SCHEME_REGEX) != null;
}
const $d606e25919312de3$export$696b487c8ad531d2 = (url, loadOptions)=>{
    if (typeof fetch === 'undefined' && (loadOptions == null || loadOptions.fetchFunc == null)) // `http` uses `fetch` or `node-fetch`, if one wants to use it in
    // an environment that is not the browser or node they have to setup a
    // global fetch polyfill.
    return null;
    else {
        let isHTTP = true;
        if (Array.isArray(url)) isHTTP = url.every((urlItem)=>$d606e25919312de3$export$18a721ae4733601b(urlItem));
        else isHTTP = $d606e25919312de3$export$18a721ae4733601b(url);
        if (isHTTP) return $d606e25919312de3$export$7d6f1c8842f9f527(url, loadOptions);
    }
    return null;
};
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerSaveRouter($d606e25919312de3$export$696b487c8ad531d2);
(0, $cd899f472e2dfa40$export$512275d398c0bdcd).registerLoadRouter($d606e25919312de3$export$696b487c8ad531d2);
function $d606e25919312de3$export$7d6f1c8842f9f527(path, loadOptions) {
    return new $d606e25919312de3$export$3df08bb5d0f8b499(path, loadOptions);
}
function $d606e25919312de3$export$624ff5bc4e3a9d72(path, loadOptions) {
    return $d606e25919312de3$export$7d6f1c8842f9f527(path, loadOptions);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $4cc15242262df971$var$PassthroughLoader {
    constructor(modelArtifacts){
        this.modelArtifacts = modelArtifacts;
    }
    load() {
        return this.modelArtifacts;
    }
}
class $4cc15242262df971$var$PassthroughSaver {
    constructor(saveHandler){
        this.saveHandler = saveHandler;
    }
    save(modelArtifacts) {
        return this.saveHandler(modelArtifacts);
    }
}
class $4cc15242262df971$var$PassthroughAsync {
    constructor(handler){
        if (handler.load) this.load = ()=>Promise.resolve(handler.load());
        if (handler.save) this.save = (modelArtifacts)=>Promise.resolve(handler.save(modelArtifacts));
    }
}
function $4cc15242262df971$export$89ba941c7951a2e8(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    const args = arguments;
    return new $4cc15242262df971$var$PassthroughAsync($4cc15242262df971$export$c22472cb1d774f45(...args));
}
function $4cc15242262df971$export$c22472cb1d774f45(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    if (arguments.length === 1) {
        const isModelArtifacts = modelArtifacts.modelTopology != null || modelArtifacts.weightSpecs != null;
        if (isModelArtifacts) return new $4cc15242262df971$var$PassthroughLoader(modelArtifacts);
        else {
            // Legacy support: with only modelTopology.
            // TODO(cais): Remove this deprecated API.
            console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
            return new $4cc15242262df971$var$PassthroughLoader({
                modelTopology: modelArtifacts
            });
        }
    } else {
        // Legacy support.
        // TODO(cais): Remove this deprecated API.
        console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
        return new $4cc15242262df971$var$PassthroughLoader({
            modelTopology: modelArtifacts,
            weightSpecs: weightSpecs,
            weightData: weightData,
            trainingConfig: trainingConfig
        });
    }
}
function $4cc15242262df971$export$fa4a26428614aae7(saveHandler) {
    return new $4cc15242262df971$var$PassthroughSaver(saveHandler);
}
function $4cc15242262df971$export$53913891eb9f0585(saveHandler) {
    return new $4cc15242262df971$var$PassthroughSaver(saveHandler);
}







var $543f67484857d7a4$exports = {};

$parcel$export($543f67484857d7a4$exports, "nonMaxSuppressionV3Impl", () => $75f28c5b0772c39f$export$89e22275998c2878);
$parcel$export($543f67484857d7a4$exports, "nonMaxSuppressionV4Impl", () => $75f28c5b0772c39f$export$697e7a8cdfefe3a);
$parcel$export($543f67484857d7a4$exports, "nonMaxSuppressionV5Impl", () => $75f28c5b0772c39f$export$4ff849794bce73c5);
$parcel$export($543f67484857d7a4$exports, "whereImpl", () => $0e4e8bcceb5b6098$export$3a1005f93c3f4453);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $31259e3fec6eb1a8$var$delayCallback = (()=>{
    if (typeof requestAnimationFrame !== 'undefined') return requestAnimationFrame;
    else if (typeof setImmediate !== 'undefined') return setImmediate;
    return (f)=>f(); // no delays
})();
/**
 * Returns a promise that resolves when a requestAnimationFrame has completed.
 *
 * On Node.js this uses setImmediate instead of requestAnimationFrame.
 *
 * This is simply a sugar method so that users can do the following:
 * `await tf.nextFrame();`
 *
 * @doc {heading: 'Performance', subheading: 'Timing'}
 */ function $31259e3fec6eb1a8$export$68d2d147c928d1dd() {
    return new Promise((resolve)=>$31259e3fec6eb1a8$var$delayCallback(()=>resolve()));
}


(0, $4556f4d353a40dfb$export$9a85654c75805c9a)();


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $239ae6d35d1bb02c$var$ENV = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)();
/** Whether to keep intermediate tensors. */ $239ae6d35d1bb02c$var$ENV.registerFlag('KEEP_INTERMEDIATE_TENSORS', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /** DataType enum. */ var $9aa777558864f840$export$45c69700ee30a78c;
(function(DataType) {
    // These properties must be quoted since they are used by parseDtypeParam
    // in tfjs-converter/src/operations/operation_mapper.ts to look up dtypes
    // by string name. If they are not quoted, Closure will mangle their names.
    // Not a legal value for DataType.  Used to indicate a DataType field
    // has not been set.
    DataType[DataType["DT_INVALID"] = 0] = "DT_INVALID";
    // Data types that all computation devices are expected to be
    // capable to support.
    DataType[DataType["DT_FLOAT"] = 1] = "DT_FLOAT";
    DataType[DataType["DT_DOUBLE"] = 2] = "DT_DOUBLE";
    DataType[DataType["DT_INT32"] = 3] = "DT_INT32";
    DataType[DataType["DT_UINT8"] = 4] = "DT_UINT8";
    DataType[DataType["DT_INT16"] = 5] = "DT_INT16";
    DataType[DataType["DT_INT8"] = 6] = "DT_INT8";
    DataType[DataType["DT_STRING"] = 7] = "DT_STRING";
    DataType[DataType["DT_COMPLEX64"] = 8] = "DT_COMPLEX64";
    DataType[DataType["DT_INT64"] = 9] = "DT_INT64";
    DataType[DataType["DT_BOOL"] = 10] = "DT_BOOL";
    DataType[DataType["DT_QINT8"] = 11] = "DT_QINT8";
    DataType[DataType["DT_QUINT8"] = 12] = "DT_QUINT8";
    DataType[DataType["DT_QINT32"] = 13] = "DT_QINT32";
    DataType[DataType["DT_BFLOAT16"] = 14] = "DT_BFLOAT16";
    DataType[DataType["DT_QINT16"] = 15] = "DT_QINT16";
    DataType[DataType["DT_QUINT16"] = 16] = "DT_QUINT16";
    DataType[DataType["DT_UINT16"] = 17] = "DT_UINT16";
    DataType[DataType["DT_COMPLEX128"] = 18] = "DT_COMPLEX128";
    DataType[DataType["DT_HALF"] = 19] = "DT_HALF";
    DataType[DataType["DT_RESOURCE"] = 20] = "DT_RESOURCE";
    DataType[DataType["DT_VARIANT"] = 21] = "DT_VARIANT";
    DataType[DataType["DT_UINT32"] = 22] = "DT_UINT32";
    DataType[DataType["DT_UINT64"] = 23] = "DT_UINT64";
    // Do not use!  These are only for parameters.  Every enum above
    // should have a corresponding value below (verified by types_test).
    DataType[DataType["DT_FLOAT_REF"] = 101] = "DT_FLOAT_REF";
    DataType[DataType["DT_DOUBLE_REF"] = 102] = "DT_DOUBLE_REF";
    DataType[DataType["DT_INT32_REF"] = 103] = "DT_INT32_REF";
    DataType[DataType["DT_UINT8_REF"] = 104] = "DT_UINT8_REF";
    DataType[DataType["DT_INT16_REF"] = 105] = "DT_INT16_REF";
    DataType[DataType["DT_INT8_REF"] = 106] = "DT_INT8_REF";
    DataType[DataType["DT_STRING_REF"] = 107] = "DT_STRING_REF";
    DataType[DataType["DT_COMPLEX64_REF"] = 108] = "DT_COMPLEX64_REF";
    DataType[DataType["DT_INT64_REF"] = 109] = "DT_INT64_REF";
    DataType[DataType["DT_BOOL_REF"] = 110] = "DT_BOOL_REF";
    DataType[DataType["DT_QINT8_REF"] = 111] = "DT_QINT8_REF";
    DataType[DataType["DT_QUINT8_REF"] = 112] = "DT_QUINT8_REF";
    DataType[DataType["DT_QINT32_REF"] = 113] = "DT_QINT32_REF";
    DataType[DataType["DT_BFLOAT16_REF"] = 114] = "DT_BFLOAT16_REF";
    DataType[DataType["DT_QINT16_REF"] = 115] = "DT_QINT16_REF";
    DataType[DataType["DT_QUINT16_REF"] = 116] = "DT_QUINT16_REF";
    DataType[DataType["DT_UINT16_REF"] = 117] = "DT_UINT16_REF";
    DataType[DataType["DT_COMPLEX128_REF"] = 118] = "DT_COMPLEX128_REF";
    DataType[DataType["DT_HALF_REF"] = 119] = "DT_HALF_REF";
    DataType[DataType["DT_RESOURCE_REF"] = 120] = "DT_RESOURCE_REF";
    DataType[DataType["DT_VARIANT_REF"] = 121] = "DT_VARIANT_REF";
    DataType[DataType["DT_UINT32_REF"] = 122] = "DT_UINT32_REF";
    DataType[DataType["DT_UINT64_REF"] = 123] = "DT_UINT64_REF";
})($9aa777558864f840$export$45c69700ee30a78c || ($9aa777558864f840$export$45c69700ee30a78c = {}));
var $9aa777558864f840$export$c7aebf4a33f92df2;
(function(SaverDef) {
    /** CheckpointFormatVersion enum. */ let CheckpointFormatVersion;
    (function(CheckpointFormatVersion) {
        CheckpointFormatVersion[CheckpointFormatVersion["LEGACY"] = 0] = "LEGACY";
        CheckpointFormatVersion[CheckpointFormatVersion["V1"] = 1] = "V1";
        CheckpointFormatVersion[CheckpointFormatVersion["V2"] = 2] = "V2";
    })(CheckpointFormatVersion = SaverDef.CheckpointFormatVersion || (SaverDef.CheckpointFormatVersion = {}));
})($9aa777558864f840$export$c7aebf4a33f92df2 || ($9aa777558864f840$export$c7aebf4a33f92df2 = {}));


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $157d0ae23f71de04$var$CUSTOM_OPS = {};
function $157d0ae23f71de04$export$670e5ae0b581ed28(name, opFunc) {
    const opMapper = {
        tfOpName: name,
        category: 'custom',
        inputs: [],
        attrs: [],
        customExecutor: opFunc
    };
    $157d0ae23f71de04$var$CUSTOM_OPS[name] = opMapper;
}
function $157d0ae23f71de04$export$ad480e5d0b303fdc(name) {
    return $157d0ae23f71de04$var$CUSTOM_OPS[name];
}
function $157d0ae23f71de04$export$26ff69eae92eb5cb(name) {
    delete $157d0ae23f71de04$var$CUSTOM_OPS[name];
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $42f0e497e6c53be2$export$390042a9afe1baa5(paramName, node, tensorMap, context, resourceManager) {
    const inputParam = node.inputParams[paramName];
    if (inputParam && inputParam.inputIndexStart !== undefined) {
        const start = inputParam.inputIndexStart;
        const end = inputParam.inputIndexEnd === 0 ? undefined : inputParam.inputIndexEnd === undefined ? start + 1 : inputParam.inputIndexEnd;
        const shiftedStart = start < 0 ? node.inputNames.length + start : start;
        if (inputParam.type === 'tensor') return $42f0e497e6c53be2$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        if (inputParam.type === 'tensors') {
            // TODO(mattSoulanille): This filters out NoOp nodes during execution, but
            // these should really never be in the execution graph in the first place.
            // They're necessary for ordering the graph, but should not be visible
            // during execution. Perhaps have different sets of children, one for
            // control dependencies and another for real dependencies.
            const inputs = node.inputs.slice(start, end);
            const inputNames = node.inputNames.slice(start, end).filter((_name, index)=>{
                var _a;
                return ((_a = inputs[index]) === null || _a === void 0 ? void 0 : _a.op) !== 'NoOp';
            });
            return inputNames.map((name)=>$42f0e497e6c53be2$export$c5e50df225428195(name, tensorMap, context, resourceManager));
        }
        const tensor = $42f0e497e6c53be2$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        const data = tensor.dataSync();
        return inputParam.type === 'number' ? data[0] : (0, $0775da5e684c8c0d$exports).toNestedArray(tensor.shape, data);
    }
    const attrParam = node.attrParams[paramName];
    return attrParam && attrParam.value;
}
function $42f0e497e6c53be2$export$c5e50df225428195(name, tensorsMap, context, resourceManager) {
    const [nodeName, index] = $42f0e497e6c53be2$export$67aec20b8c372baf(name, context);
    if (resourceManager != null) {
        const tensor = resourceManager.getHashTableHandleByName(nodeName);
        if (tensor != null) return tensor;
    }
    const contextId = context.currentContextIds.find((contextId)=>{
        return !!tensorsMap[$42f0e497e6c53be2$var$getNodeNameWithContextId(nodeName, contextId)];
    });
    return contextId !== undefined ? tensorsMap[$42f0e497e6c53be2$var$getNodeNameWithContextId(nodeName, contextId)][index] : undefined;
}
function $42f0e497e6c53be2$export$d8cd584ff358961a(name, tensorsMap, context) {
    return tensorsMap[$42f0e497e6c53be2$var$getNodeNameWithContextId(name, context.currentContextId)];
}
function $42f0e497e6c53be2$export$6cbb65bf9e07a72(inputName, context) {
    const [nodeName, index, outputName] = $42f0e497e6c53be2$export$67aec20b8c372baf(inputName, context);
    return [
        $42f0e497e6c53be2$var$getNodeNameWithContextId(nodeName, context && context.currentContextId),
        index,
        outputName
    ];
}
function $42f0e497e6c53be2$var$getNodeNameWithContextId(name, contextId) {
    return !!contextId ? `${name}-${contextId}` : name;
}
function $42f0e497e6c53be2$export$67aec20b8c372baf(name, context) {
    if (name === '') return [
        '',
        0,
        undefined
    ];
    const isCacheEnabled = context != null && context.parseNodeNameCache != null;
    if (isCacheEnabled) {
        const cachedResult = context.parseNodeNameCache.get(name);
        if (cachedResult != null) return cachedResult;
    }
    const parts = name.split(':');
    let result;
    if (parts.length === 1) result = [
        name,
        0,
        undefined
    ];
    else {
        const nodeName = parts[0];
        const outputName = parts.length === 3 ? parts[1] : undefined;
        const index = Number(parts[parts.length - 1]);
        result = [
            nodeName,
            index,
            outputName
        ];
    }
    if (isCacheEnabled) context.parseNodeNameCache.set(name, result);
    return result;
}
function $42f0e497e6c53be2$export$65980d18b75784e2(arr, size) {
    const res = [];
    for(let i = 0; i < arr.length; i += size)res.push(arr.slice(i, i + size));
    return res;
}
function $42f0e497e6c53be2$export$d7501e6bee71bfee(node, tensorMap, context) {
    let pad = $42f0e497e6c53be2$export$390042a9afe1baa5('pad', node, tensorMap, context);
    if (pad === 'explicit') {
        // This is 1d array, we need to convert it to 2d array
        pad = $42f0e497e6c53be2$export$390042a9afe1baa5('explicitPaddings', node, tensorMap, context);
        const explicitPadding = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        for(let i = 0; i < 4; i++){
            explicitPadding[i][0] = pad[i * 2];
            explicitPadding[i][1] = pad[i * 2 + 1];
        }
        return explicitPadding;
    }
    return pad;
}
function $42f0e497e6c53be2$export$c2185cfeaef7ba84(tensor) {
    return tensor.kept ? tensor : (0, $765aa12b24d3e86a$export$9cd59f9826255e47)(tensor);
}


var $54ad932bc2f7f405$exports = {};

$parcel$export($54ad932bc2f7f405$exports, "json", () => $54ad932bc2f7f405$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $54ad932bc2f7f405$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Add',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddV2',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddN',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'BiasAdd',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sub',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RealDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Div',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DivNoNan',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mul',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Maximum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Minimum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Pow',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SquaredDifference',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorMod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];


var $c38e3d928927a398$exports = {};

$parcel$export($c38e3d928927a398$exports, "json", () => $c38e3d928927a398$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $c38e3d928927a398$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Abs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan2',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Ceil',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ClipByValue',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'clipValueMin',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'clipValueMax',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Complex',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'real',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'imag',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ComplexAbs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Elu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Exp',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Floor',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Imag',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Neg',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Real',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Prelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'alpha',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu6',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Selu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sigmoid',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Rsqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Square',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sign',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Round',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Expm1',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log1p',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reciprocal',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Softplus',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Erf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LeakyRelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsNan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsFinite',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsInf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];


var $399d5af5dfb396a4$exports = {};

$parcel$export($399d5af5dfb396a4$exports, "json", () => $399d5af5dfb396a4$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $399d5af5dfb396a4$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EmptyTensorList',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'maxNumElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LoopCond',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Switch',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Merge',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Enter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'frame_name',
                'name': 'frameName',
                'type': 'string'
            },
            {
                'tfName': 'is_constant',
                'name': 'isConstant',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Exit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NextIteration',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'size',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'dynamic_size',
                'name': 'dynamicSize',
                'type': 'bool'
            },
            {
                'tfName': 'clear_after_read',
                'name': 'clearAfterRead',
                'type': 'bool'
            },
            {
                'tfName': 'identical_element_shapes',
                'name': 'identicalElementShapes',
                'type': 'bool'
            },
            {
                'tfName': 'tensor_array_name',
                'name': 'name',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayWriteV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayReadV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayGatherV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayScatterV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayConcatV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape_except0',
                'name': 'elementShapeExcept0',
                'type': 'shape',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySplitV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySizeV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayCloseV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'StatelessIf',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'If',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'StatelessWhile',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'While',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatterV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 3,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGather',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListReserve',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListFromTensor',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListStack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            },
            {
                'tfName': 'num_elements',
                'name': 'numElements',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSplit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcat',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcatV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPopBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPushBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListLength',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TensorListResize',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            }
        ]
    }
];


var $de90d4a44c2acea2$exports = {};

$parcel$export($de90d4a44c2acea2$exports, "json", () => $de90d4a44c2acea2$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $de90d4a44c2acea2$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'AvgPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': [],
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPoolWithArgmax',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'include_batch_in_index',
                'name': 'includeBatchInIndex',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AvgPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Conv1D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'stride',
                'name': 'stride',
                'type': 'number'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NWC'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'dilation',
                'name': 'dilation',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'Conv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'useCudnnOnGpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': '_FusedConv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'use_cudnn_on_gpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool',
                'defaultValue': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            }
        ]
    },
    {
        'tfOpName': 'Conv2DBackpropInput',
        'category': 'convolution',
        'inputs': [
            {
                'start': 2,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 0,
                'name': 'outputShape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2d',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'FusedDepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            }
        ]
    },
    {
        'tfOpName': 'Conv3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Dilation2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'rates',
                'name': 'dilations',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            }
        ]
    }
];


var $8cd0915ef76e280d$exports = {};

$parcel$export($8cd0915ef76e280d$exports, "json", () => $8cd0915ef76e280d$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8cd0915ef76e280d$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Fill',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            },
            {
                'start': 1,
                'name': 'value',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LinSpace',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'num',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'OneHot',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'depth',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'onValue',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'start': 3,
                'name': 'offValue',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Ones',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'OnesLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'RandomStandardNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniform',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniformInt',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number'
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Range',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'step',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'Tidx',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TruncatedNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'means',
                'name': 'mean',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'stddev',
                'name': 'stdDev',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Zeros',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ZerosLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Multinomial',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'logits',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numSamples',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'output_dtype',
                'name': 'output_dtype',
                'type': 'dtype'
            }
        ]
    }
];


var $843cf609e6e999c7$exports = {};

$parcel$export($843cf609e6e999c7$exports, "json", () => $843cf609e6e999c7$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $843cf609e6e999c7$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'NonMaxSuppressionV2',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV3',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV4',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'T_threshold',
                'name': 'threshold',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'pad_to_max_output_size',
                'name': 'padToMaxOutputSize',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV5',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            },
            {
                'start': 5,
                'name': 'softNmsSigma',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Where',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ListDiff',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];


var $03fcc82cdb243425$exports = {};

$parcel$export($03fcc82cdb243425$exports, "json", () => $03fcc82cdb243425$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $03fcc82cdb243425$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'LowerBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TopKV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'k',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'sorted',
                'name': 'sorted',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'UpperBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Unique',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'UniqueV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    }
];


var $1cff37718c04f683$exports = {};

$parcel$export($1cff37718c04f683$exports, "json", () => $1cff37718c04f683$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1cff37718c04f683$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'PlaceholderWithDefault',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'default',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Placeholder',
        'category': 'graph',
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Const',
        'category': 'graph'
    },
    {
        'tfOpName': 'Identity',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IdentityN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Snapshot',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Rank',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Size',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Shape',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'ShapeN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Print',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'data',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'message',
                'name': 'message',
                'type': 'string'
            },
            {
                'tfName': 'first_n',
                'name': 'firstN',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'summarize',
                'name': 'summarize',
                'type': 'number',
                'defaultValue': 3
            }
        ]
    },
    {
        'tfOpName': 'NoOp',
        'category': 'graph',
        'inputs': []
    },
    {
        'tfOpName': 'StopGradient',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'FakeQuantWithMinMaxVars',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'min',
                'name': 'min',
                'type': 'number'
            },
            {
                'tfName': 'max',
                'name': 'max',
                'type': 'number'
            }
        ]
    }
];


var $d141e12152fb5634$exports = {};

$parcel$export($d141e12152fb5634$exports, "json", () => $d141e12152fb5634$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $d141e12152fb5634$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'HashTable',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'HashTableV2',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImport',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImportV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFind',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFindV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSize',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSizeV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTable',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTableV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];


var $696da937e18efcb6$exports = {};

$parcel$export($696da937e18efcb6$exports, "json", () => $696da937e18efcb6$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $696da937e18efcb6$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ResizeBilinear',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ResizeNearestNeighbor',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'CropAndResize',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'image',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'boxInd',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'cropSize',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'method',
                'name': 'method',
                'type': 'string'
            },
            {
                'tfName': 'extrapolation_value',
                'name': 'extrapolationValue',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ImageProjectiveTransformV3',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'transforms',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'fillValue',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'interpolation',
                'name': 'interpolation',
                'type': 'string'
            },
            {
                'tfName': 'fill_mode',
                'name': 'fillMode',
                'type': 'string'
            }
        ]
    }
];


var $9b0ed640e6c96b7b$exports = {};

$parcel$export($9b0ed640e6c96b7b$exports, "json", () => $9b0ed640e6c96b7b$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $9b0ed640e6c96b7b$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Equal',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NotEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Greater',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'GreaterEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Less',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LessEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalNot',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalOr',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Select',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SelectV2',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BitwiseAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ]
    }
];


var $145124a13909e257$exports = {};

$parcel$export($145124a13909e257$exports, "json", () => $145124a13909e257$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $145124a13909e257$export$7b419323e6ed4f31 = [
    {
        'tfOpName': '_FusedMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMulV2',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Transpose',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'perm',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Einsum',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'equation',
                'name': 'equation',
                'type': 'string'
            },
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'MatrixBandPart',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numLower',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numUpper',
                'type': 'tensor'
            }
        ]
    }
];


var $92e8da7a11ee8579$exports = {};

$parcel$export($92e8da7a11ee8579$exports, "json", () => $92e8da7a11ee8579$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $92e8da7a11ee8579$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EuclideanNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool',
                'defaultValue': false
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV2',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV3',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LRN',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'depth_radius',
                'name': 'radius',
                'type': 'number',
                'defaultValue': 5
            },
            {
                'tfName': 'bias',
                'name': 'bias',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'beta',
                'name': 'beta',
                'type': 'number',
                'defaultValue': 0.5
            }
        ]
    },
    {
        'tfOpName': 'Softmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LogSoftmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    }
];


var $10ada3b61f2d8ed8$exports = {};

$parcel$export($10ada3b61f2d8ed8$exports, "json", () => $10ada3b61f2d8ed8$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $10ada3b61f2d8ed8$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Bincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'DenseBincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'binary_output',
                'name': 'binaryOutput',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Max',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Mean',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Min',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Sum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'All',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Any',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'ArgMax',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ArgMin',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Prod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cumprod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Cumsum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    }
];


var $40e72ed14d5ad5ba$exports = {};

$parcel$export($40e72ed14d5ad5ba$exports, "json", () => $40e72ed14d5ad5ba$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $40e72ed14d5ad5ba$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ConcatV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': -1,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': -1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'Concat',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 1,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': 0,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'GatherV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'batch_dims',
                'name': 'batchDims',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Gather',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reverse',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dims',
                'type': 'bool[]'
            }
        ]
    },
    {
        'tfOpName': 'ReverseV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Slice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'size',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'StridedSlice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'end',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'strides',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'begin_mask',
                'name': 'beginMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'end_mask',
                'name': 'endMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'new_axis_mask',
                'name': 'newAxisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'ellipsis_mask',
                'name': 'ellipsisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'shrink_axis_mask',
                'name': 'shrinkAxisMask',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Pack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Unpack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'num',
                'name': 'num',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tile',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'reps',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Split',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'start': 1,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_split',
                'name': 'numOrSizeSplits',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'SplitV',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numOrSizeSplits',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'ScatterNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'GatherNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseToDense',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'sparseIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'sparseValues',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'defaultValue': false,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorScatterUpdate',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];


var $7351187f20ad5c9b$exports = {};

$parcel$export($7351187f20ad5c9b$exports, "json", () => $7351187f20ad5c9b$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $7351187f20ad5c9b$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'SparseFillEmptyRows',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'denseShape',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseReshape',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'inputIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'inputShape',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'newShape',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentMean',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentSum',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    }
];


var $619fea5f45aab03c$exports = {};

$parcel$export($619fea5f45aab03c$exports, "json", () => $619fea5f45aab03c$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $619fea5f45aab03c$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'FFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'RFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IRFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    }
];


var $1fd66c46b4d2062f$exports = {};

$parcel$export($1fd66c46b4d2062f$exports, "json", () => $1fd66c46b4d2062f$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1fd66c46b4d2062f$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'StaticRegexReplace',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'pattern',
                'name': 'pattern',
                'type': 'string'
            },
            {
                'tfName': 'rewrite',
                'name': 'rewrite',
                'type': 'string'
            },
            {
                'tfName': 'replace_global',
                'name': 'replaceGlobal',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'StringNGrams',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dataSplits',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'separator',
                'name': 'separator',
                'type': 'string'
            },
            {
                'tfName': 'ngram_widths',
                'name': 'nGramWidths',
                'type': 'number[]'
            },
            {
                'tfName': 'left_pad',
                'name': 'leftPad',
                'type': 'string'
            },
            {
                'tfName': 'right_pad',
                'name': 'rightPad',
                'type': 'string'
            },
            {
                'tfName': 'pad_width',
                'name': 'padWidth',
                'type': 'number'
            },
            {
                'tfName': 'preserve_short_sequences',
                'name': 'preserveShortSequences',
                'type': 'bool'
            }
        ],
        'outputs': [
            'ngrams',
            'ngrams_splits'
        ]
    },
    {
        'tfOpName': 'StringSplit',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'delimiter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'skip_empty',
                'name': 'skipEmpty',
                'type': 'bool'
            }
        ],
        'outputs': [
            'indices',
            'values',
            'shape'
        ]
    },
    {
        'tfOpName': 'StringToHashBucketFast',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_buckets',
                'name': 'numBuckets',
                'type': 'number'
            }
        ]
    }
];


var $248d83c35e186664$exports = {};

$parcel$export($248d83c35e186664$exports, "json", () => $248d83c35e186664$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $248d83c35e186664$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Cast',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'SrcT',
                'name': 'sdtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'DstT',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ExpandDims',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'MirrorPad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'mode',
                'name': 'mode',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'Pad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'constant_value',
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'PadV2',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Reshape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'EnsureShape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Squeeze',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'tfDeprecatedName': 'squeeze_dims',
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'SpaceToBatchND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'paddings',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'BatchToSpaceND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'crops',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthToSpace',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'block_size',
                'name': 'blockSize',
                'type': 'number'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'BroadcastTo',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': []
    },
    {
        'tfOpName': 'BroadcastArgs',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 's0',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 's1',
                'type': 'tensor'
            }
        ],
        'attrs': []
    }
];



var $cbQCu = parcelRequire("cbQCu");
var $87f15013f294f52a$require$Buffer = $cbQCu.Buffer;
class $87f15013f294f52a$export$712e670bcbcf1315 {
    // Singleton instance for the mapper
    static get Instance() {
        return this._instance || (this._instance = new this());
    }
    // Loads the op mapping from the JSON file.
    constructor(){
        const ops = [
            $54ad932bc2f7f405$exports,
            $c38e3d928927a398$exports,
            $399d5af5dfb396a4$exports,
            $de90d4a44c2acea2$exports,
            $8cd0915ef76e280d$exports,
            $843cf609e6e999c7$exports,
            $03fcc82cdb243425$exports,
            $1cff37718c04f683$exports,
            $d141e12152fb5634$exports,
            $696da937e18efcb6$exports,
            $9b0ed640e6c96b7b$exports,
            $145124a13909e257$exports,
            $92e8da7a11ee8579$exports,
            $10ada3b61f2d8ed8$exports,
            $40e72ed14d5ad5ba$exports,
            $7351187f20ad5c9b$exports,
            $619fea5f45aab03c$exports,
            $1fd66c46b4d2062f$exports,
            $248d83c35e186664$exports
        ];
        const mappersJson = [].concat(...ops.map((op)=>op.json));
        this.opMappers = mappersJson.reduce((map, mapper)=>{
            map[mapper.tfOpName] = mapper;
            return map;
        }, {});
    }
    // Converts the model inference graph from Tensorflow GraphDef to local
    // representation for TensorFlow.js API
    transformGraph(graph, signature = {}) {
        const tfNodes = graph.node;
        const placeholders = [];
        const weights = [];
        const initNodes = [];
        const nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op.startsWith('Placeholder')) placeholders.push(map[node.name]);
            else if (node.op === 'Const') weights.push(map[node.name]);
            else if (node.input == null || node.input.length === 0) initNodes.push(map[node.name]);
            return map;
        }, {});
        let inputs = [];
        const outputs = [];
        let inputNodeNameToKey = {};
        let outputNodeNameToKey = {};
        if (signature != null) {
            inputNodeNameToKey = this.mapSignatureEntries(signature.inputs);
            outputNodeNameToKey = this.mapSignatureEntries(signature.outputs);
        }
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        // if signature has not outputs set, add any node that does not have
        // outputs.
        if (Object.keys(outputNodeNameToKey).length === 0) allNodes.forEach((key)=>{
            const node = nodes[key];
            if (node.children.length === 0) outputs.push(node);
        });
        else Object.keys(outputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(name);
            const node = nodes[nodeName];
            if (node != null) {
                node.signatureKey = outputNodeNameToKey[name];
                outputs.push(node);
            }
        });
        if (Object.keys(inputNodeNameToKey).length > 0) Object.keys(inputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(name);
            const node = nodes[nodeName];
            if (node) {
                node.signatureKey = inputNodeNameToKey[name];
                inputs.push(node);
            }
        });
        else inputs = placeholders;
        let functions = {};
        if (graph.library != null && graph.library.function != null) functions = graph.library.function.reduce((functions, func)=>{
            functions[func.signature.name] = this.mapFunction(func);
            return functions;
        }, {});
        const result = {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature,
            functions: functions
        };
        if (initNodes.length > 0) result.initNodes = initNodes;
        return result;
    }
    mapSignatureEntries(entries) {
        return Object.keys(entries || {}).reduce((prev, curr)=>{
            prev[entries[curr].name] = curr;
            return prev;
        }, {});
    }
    mapNode(node) {
        // Unsupported ops will cause an error at run-time (not parse time), since
        // they may not be used by the actual execution subgraph.
        const mapper = (0, $157d0ae23f71de04$export$ad480e5d0b303fdc)(node.op) || this.opMappers[node.op] || {};
        if (node.attr == null) node.attr = {};
        const newNode = {
            name: node.name,
            op: node.op,
            category: mapper.category,
            inputNames: (node.input || []).map((input)=>input.startsWith('^') ? input.slice(1) : input),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: node.attr,
            outputs: mapper.outputs
        };
        if (mapper.inputs != null) newNode.inputParams = mapper.inputs.reduce((map, param)=>{
            map[param.name] = {
                type: param.type,
                inputIndexStart: param.start,
                inputIndexEnd: param.end
            };
            return map;
        }, {});
        if (mapper.attrs != null) newNode.attrParams = mapper.attrs.reduce((map, param)=>{
            const type = param.type;
            let value = undefined;
            switch(param.type){
                case 'string':
                    value = $87f15013f294f52a$export$88878e8ea979e9e0(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$88878e8ea979e9e0(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'string[]':
                    value = $87f15013f294f52a$export$3ad7c1b82be1673b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$3ad7c1b82be1673b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number':
                    value = $87f15013f294f52a$export$9bb8d6def7820923(node.attr, param.tfName, param.defaultValue || 0);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$9bb8d6def7820923(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number[]':
                    value = $87f15013f294f52a$export$a5181f35ff520ed9(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$a5181f35ff520ed9(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool':
                    value = $87f15013f294f52a$export$2dc362e9c5612e66(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$2dc362e9c5612e66(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool[]':
                    value = $87f15013f294f52a$export$71dea7cc6cfe5d6(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$71dea7cc6cfe5d6(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape':
                    value = $87f15013f294f52a$export$2f3f0447f2b6ba0c(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$2f3f0447f2b6ba0c(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape[]':
                    value = $87f15013f294f52a$export$296050a88ff1b217(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$296050a88ff1b217(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype':
                    value = $87f15013f294f52a$export$8ff555328ef39a1b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$8ff555328ef39a1b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype[]':
                    value = $87f15013f294f52a$export$4d8018dacba67c5a(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$4d8018dacba67c5a(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'func':
                    value = $87f15013f294f52a$export$aafe7fbc7c8a8284(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $87f15013f294f52a$export$aafe7fbc7c8a8284(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'tensor':
                case 'tensors':
                    break;
                default:
                    throw new Error(`Unsupported param type: ${param.type} for op: ${node.op}`);
            }
            map[param.name] = {
                value: value,
                type: type
            };
            return map;
        }, {});
        return newNode;
    }
    // map the TFunctionDef to TFJS graph object
    mapFunction(functionDef) {
        const tfNodes = functionDef.nodeDef;
        const placeholders = [];
        const weights = [];
        let nodes = {};
        if (tfNodes != null) nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op === 'Const') weights.push(map[node.name]);
            return map;
        }, {});
        const inputs = [];
        const outputs = [];
        functionDef.signature.inputArg.forEach((arg)=>{
            const [nodeName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(arg.name);
            const node = {
                name: nodeName,
                op: 'Placeholder',
                inputs: [],
                inputNames: [],
                category: 'graph',
                inputParams: {},
                attrParams: {
                    dtype: {
                        value: $87f15013f294f52a$export$863992a6f00f04d8(arg.type),
                        type: 'dtype'
                    }
                },
                children: []
            };
            node.signatureKey = arg.name;
            inputs.push(node);
            nodes[nodeName] = node;
        });
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        const returnNodeMap = functionDef.ret;
        functionDef.signature.outputArg.forEach((output)=>{
            const [nodeName, index] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(returnNodeMap[output.name]);
            const node = nodes[nodeName];
            if (node != null) {
                node.defaultOutput = index;
                outputs.push(node);
            }
        });
        const signature = this.mapArgsToSignature(functionDef);
        return {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature
        };
    }
    mapArgsToSignature(functionDef) {
        return {
            methodName: functionDef.signature.name,
            inputs: functionDef.signature.inputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg);
                return map;
            }, {}),
            outputs: functionDef.signature.outputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg, functionDef.ret);
                return map;
            }, {})
        };
    }
    mapArgToTensorInfo(arg, nameMap) {
        let name = arg.name;
        if (nameMap != null) name = nameMap[name];
        return {
            name: name,
            dtype: arg.type
        };
    }
}
function $87f15013f294f52a$export$94fdf11bafc8de6b(text) {
    const global = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().global;
    if (typeof global.atob !== 'undefined') return global.atob(text);
    else if (typeof $87f15013f294f52a$require$Buffer !== 'undefined') return new $87f15013f294f52a$require$Buffer(text, 'base64').toString();
    else throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
}
function $87f15013f294f52a$export$a112ee1a9f1f58d1(s, keepCase) {
    const value = Array.isArray(s) ? String.fromCharCode.apply(null, s) : $87f15013f294f52a$export$94fdf11bafc8de6b(s);
    return keepCase ? value : value.toLowerCase();
}
function $87f15013f294f52a$export$88878e8ea979e9e0(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param != null) return $87f15013f294f52a$export$a112ee1a9f1f58d1(param.s, keepCase);
    return def;
}
function $87f15013f294f52a$export$2dc362e9c5612e66(attrs, name, def) {
    const param = attrs[name];
    return param ? param.b : def;
}
function $87f15013f294f52a$export$9bb8d6def7820923(attrs, name, def) {
    const param = attrs[name] || {};
    const value = param['i'] != null ? param['i'] : param['f'] != null ? param['f'] : def;
    return typeof value === 'number' ? value : parseInt(value, 10);
}
function $87f15013f294f52a$export$863992a6f00f04d8(value) {
    if (typeof value === 'string') // tslint:disable-next-line:no-any
    value = $9aa777558864f840$export$45c69700ee30a78c[value];
    switch(value){
        case $9aa777558864f840$export$45c69700ee30a78c.DT_FLOAT:
        case $9aa777558864f840$export$45c69700ee30a78c.DT_HALF:
            return 'float32';
        case $9aa777558864f840$export$45c69700ee30a78c.DT_INT32:
        case $9aa777558864f840$export$45c69700ee30a78c.DT_INT64:
        case $9aa777558864f840$export$45c69700ee30a78c.DT_INT8:
        case $9aa777558864f840$export$45c69700ee30a78c.DT_UINT8:
            return 'int32';
        case $9aa777558864f840$export$45c69700ee30a78c.DT_BOOL:
            return 'bool';
        case $9aa777558864f840$export$45c69700ee30a78c.DT_DOUBLE:
            return 'float32';
        case $9aa777558864f840$export$45c69700ee30a78c.DT_STRING:
            return 'string';
        case $9aa777558864f840$export$45c69700ee30a78c.DT_COMPLEX64:
        case $9aa777558864f840$export$45c69700ee30a78c.DT_COMPLEX128:
            return 'complex64';
        default:
            // Unknown dtype error will happen at runtime (instead of parse time),
            // since these nodes might not be used by the actual subgraph execution.
            return null;
    }
}
function $87f15013f294f52a$export$aafe7fbc7c8a8284(attrs, name, def) {
    const param = attrs[name];
    if (param && param.func) return param.func.name;
    return def;
}
function $87f15013f294f52a$export$8ff555328ef39a1b(attrs, name, def) {
    const param = attrs[name];
    if (param && param.type) return $87f15013f294f52a$export$863992a6f00f04d8(param.type);
    return def;
}
function $87f15013f294f52a$export$4d8018dacba67c5a(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.type) return param.list.type.map((v)=>$87f15013f294f52a$export$863992a6f00f04d8(v));
    return def;
}
function $87f15013f294f52a$export$e22e6990f4767045(shape) {
    if (shape.unknownRank) return undefined;
    if (shape.dim != null) return shape.dim.map((dim)=>typeof dim.size === 'number' ? dim.size : parseInt(dim.size, 10));
    return [];
}
function $87f15013f294f52a$export$2f3f0447f2b6ba0c(attrs, name, def) {
    const param = attrs[name];
    if (param && param.shape) return $87f15013f294f52a$export$e22e6990f4767045(param.shape);
    return def;
}
function $87f15013f294f52a$export$a5181f35ff520ed9(attrs, name, def) {
    const param = attrs[name];
    if (param) return ((param.list.f && param.list.f.length ? param.list.f : param.list.i) || []).map((v)=>typeof v === 'number' ? v : parseInt(v, 10));
    return def;
}
function $87f15013f294f52a$export$3ad7c1b82be1673b(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param && param.list && param.list.s) return param.list.s.map((v)=>{
        return $87f15013f294f52a$export$a112ee1a9f1f58d1(v, keepCase);
    });
    return def;
}
function $87f15013f294f52a$export$296050a88ff1b217(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.shape) return param.list.shape.map((v)=>{
        return $87f15013f294f52a$export$e22e6990f4767045(v);
    });
    return def;
}
function $87f15013f294f52a$export$71dea7cc6cfe5d6(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.b) return param.list.b;
    return def;
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $9d4a049a8bcac205$export$2964c493e854c8ad {
    constructor(node, tensorMap, context){
        this.node = node;
        this.tensorMap = tensorMap;
        this.context = context;
        this.inputs = [];
        this.attrs = {};
        this.inputs = node.inputNames.map((name)=>this.getInput(name));
        if (node.rawAttrs != null) this.attrs = Object.keys(node.rawAttrs).reduce((attrs, key)=>{
            attrs[key] = this.getAttr(key);
            return attrs;
        }, {});
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getInput(name) {
        return (0, $42f0e497e6c53be2$export$c5e50df225428195)(name, this.tensorMap, this.context);
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getAttr(name, defaultValue) {
        const value = this.node.rawAttrs[name];
        if (value.tensor != null) return (0, $42f0e497e6c53be2$export$c5e50df225428195)(name, this.tensorMap, this.context);
        if (value.i != null || value.f != null) return (0, $87f15013f294f52a$export$9bb8d6def7820923)(this.node.rawAttrs, name, defaultValue);
        if (value.s != null) return (0, $87f15013f294f52a$export$88878e8ea979e9e0)(this.node.rawAttrs, name, defaultValue);
        if (value.b != null) return (0, $87f15013f294f52a$export$2dc362e9c5612e66)(this.node.rawAttrs, name, defaultValue);
        if (value.shape != null) return (0, $87f15013f294f52a$export$2f3f0447f2b6ba0c)(this.node.rawAttrs, name, defaultValue);
        if (value.type != null) return (0, $87f15013f294f52a$export$8ff555328ef39a1b)(this.node.rawAttrs, name, defaultValue);
        if (value.list != null) {
            if (value.list.i != null || value.list.f != null) return (0, $87f15013f294f52a$export$a5181f35ff520ed9)(this.node.rawAttrs, name, defaultValue);
            if (value.list.s != null) return (0, $87f15013f294f52a$export$3ad7c1b82be1673b)(this.node.rawAttrs, name, defaultValue);
            if (value.list.shape != null) return (0, $87f15013f294f52a$export$296050a88ff1b217)(this.node.rawAttrs, name, defaultValue);
            if (value.list.b != null) return (0, $87f15013f294f52a$export$71dea7cc6cfe5d6)(this.node.rawAttrs, name, defaultValue);
            if (value.list.type != null) return (0, $87f15013f294f52a$export$4d8018dacba67c5a)(this.node.rawAttrs, name, defaultValue);
        }
        return defaultValue;
    }
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist
var $4c8c415cb2743f5a$exports = {};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This file exports ops used by the converters executors. By default it
 * re-exports all ops. In a custom build this is aliased to a file that will
 * only exports ops for a given model.json.
 */ 
$parcel$exportWildcard($4c8c415cb2743f5a$exports, $0d9cd03b68b74ca9$exports);



const $ee39968fddb1bf71$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'BiasAdd':
        case 'AddV2':
        case 'Add':
            return [
                ops.add((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'AddN':
            return [
                ops.addN((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensors', node, tensorMap, context))
            ];
        case 'FloorMod':
        case 'Mod':
            return [
                ops.mod((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Mul':
            return [
                ops.mul((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'RealDiv':
        case 'Div':
            return [
                ops.div((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'DivNoNan':
            return [
                ops.divNoNan((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'FloorDiv':
            return [
                ops.floorDiv((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Sub':
            return [
                ops.sub((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Minimum':
            return [
                ops.minimum((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Maximum':
            return [
                ops.maximum((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Pow':
            return [
                ops.pow((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'SquaredDifference':
            return [
                ops.squaredDifference((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $ee39968fddb1bf71$export$2c04807512a22510 = 'arithmetic';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $a892a6465e274214$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Abs':
        case 'ComplexAbs':
            return [
                ops.abs((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Acos':
            return [
                ops.acos((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Acosh':
            return [
                ops.acosh((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Asin':
            return [
                ops.asin((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Asinh':
            return [
                ops.asinh((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Atan':
            return [
                ops.atan((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Atan2':
            return [
                ops.atan2((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('y', node, tensorMap, context))
            ];
        case 'Atanh':
            return [
                ops.atanh((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Ceil':
            return [
                ops.ceil((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Complex':
            return [
                ops.complex((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('real', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('imag', node, tensorMap, context))
            ];
        case 'Cos':
            return [
                ops.cos((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Cosh':
            return [
                ops.cosh((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Elu':
            return [
                ops.elu((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Erf':
            return [
                ops.erf((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Exp':
            return [
                ops.exp((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Expm1':
            return [
                ops.expm1((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Floor':
            return [
                ops.floor((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Log':
            return [
                ops.log((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Log1p':
            return [
                ops.log1p((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Imag':
            return [
                ops.imag((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Neg':
            return [
                ops.neg((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Reciprocal':
            return [
                ops.reciprocal((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Real':
            return [
                ops.real((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Relu':
            return [
                ops.relu((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Round':
            return [
                ops.round((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Selu':
            return [
                ops.selu((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sigmoid':
            return [
                ops.sigmoid((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sin':
            return [
                ops.sin((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sign':
            return [
                ops.sign((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sinh':
            return [
                ops.sinh((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Softplus':
            return [
                ops.softplus((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sqrt':
            return [
                ops.sqrt((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Square':
            return [
                ops.square((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Tanh':
            return [
                ops.tanh((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Tan':
            return [
                ops.tan((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'ClipByValue':
            return [
                ops.clipByValue((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('clipValueMin', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('clipValueMax', node, tensorMap, context))
            ];
        case 'Relu6':
            return [
                ops.relu6((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Rsqrt':
            return [
                ops.rsqrt((0, $42f0e497e6c53be2$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        case 'LeakyRelu':
            return [
                ops.leakyRelu((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('alpha', node, tensorMap, context))
            ];
        case 'Prelu':
            return [
                ops.prelu((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('alpha', node, tensorMap, context))
            ];
        case 'IsNan':
            return [
                ops.isNaN((0, $42f0e497e6c53be2$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsInf':
            return [
                ops.isInf((0, $42f0e497e6c53be2$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsFinite':
            return [
                ops.isFinite((0, $42f0e497e6c53be2$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $a892a6465e274214$export$2c04807512a22510 = 'basic_math';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This differs from util.assertShapesMatch in that it allows values of
 * negative one, an undefined size of a dimensinon, in a shape to match
 * anything.
 */ 
function $f0a16afd11c1093a$export$c20af1b3c2621826(shapeA, shapeB, errorMessagePrefix = '') {
    // constant shape means unknown rank
    if (typeof shapeA === 'number' || typeof shapeB === 'number') return;
    (0, $0775da5e684c8c0d$exports).assert(shapeA.length === shapeB.length, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    for(let i = 0; i < shapeA.length; i++){
        const dim0 = shapeA[i];
        const dim1 = shapeB[i];
        (0, $0775da5e684c8c0d$exports).assert(dim0 < 0 || dim1 < 0 || dim0 === dim1, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    }
}
function $f0a16afd11c1093a$export$caa10238f73d8dc2(elementShape) {
    if (typeof elementShape === 'number' || elementShape.some((dim)=>dim < 0)) return false;
    return true;
}
function $f0a16afd11c1093a$export$48aa6d00714ed79b(listElementShape, tensors, elementShape) {
    let partialShape = $f0a16afd11c1093a$export$455cf61aa434d74b(listElementShape, elementShape);
    const notfullDefinedShape = !$f0a16afd11c1093a$export$caa10238f73d8dc2(partialShape);
    if (notfullDefinedShape && tensors.length === 0) throw new Error(`Tried to calculate elements of an empty list` + ` with non-fully-defined elementShape: ${partialShape}`);
    if (notfullDefinedShape) tensors.forEach((tensor)=>{
        partialShape = $f0a16afd11c1093a$export$455cf61aa434d74b(tensor.shape, partialShape);
    });
    if (!$f0a16afd11c1093a$export$caa10238f73d8dc2(partialShape)) throw new Error(`Non-fully-defined elementShape: ${partialShape}`);
    return partialShape;
}
function $f0a16afd11c1093a$export$455cf61aa434d74b(elementShapeA, elementShapeB) {
    if (typeof elementShapeA === 'number') return elementShapeB;
    if (typeof elementShapeB === 'number') return elementShapeA;
    if (elementShapeA.length !== elementShapeB.length) throw new Error(`Incompatible ranks during merge: ${elementShapeA} vs. ${elementShapeB}`);
    const result = [];
    for(let i = 0; i < elementShapeA.length; ++i){
        const dim0 = elementShapeA[i];
        const dim1 = elementShapeB[i];
        if (dim0 >= 0 && dim1 >= 0 && dim0 !== dim1) throw new Error(`Incompatible shape during merge: ${elementShapeA} vs. ${elementShapeB}`);
        result[i] = dim0 >= 0 ? dim0 : dim1;
    }
    return result;
}


class $40de0c7b69ce3355$export$854ca114072d2abc {
    constructor(name, dtype, maxSize, elementShape, identicalElementShapes, dynamicSize, clearAfterRead){
        this.name = name;
        this.dtype = dtype;
        this.maxSize = maxSize;
        this.elementShape = elementShape;
        this.identicalElementShapes = identicalElementShapes;
        this.dynamicSize = dynamicSize;
        this.clearAfterRead = clearAfterRead;
        this.tensors = [];
        this.closed_ = false;
        this.idTensor = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0);
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    get closed() {
        return this.closed_;
    }
    /**
     * Dispose the tensors and idTensor and mark the TensoryArray as closed.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.tensor.id)) tensor.tensor.dispose();
        });
        this.tensors = [];
        this.closed_ = true;
        this.idTensor.dispose();
    }
    size() {
        return this.tensors.length;
    }
    /**
     * Read the value at location index in the TensorArray.
     * @param index Number the index to read from.
     */ read(index) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || index >= this.size()) throw new Error(`Tried to read from index ${index}, but array size is: ${this.size()}`);
        const tensorWithState = this.tensors[index];
        if (tensorWithState.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${index} twice because it was cleared after a previous read ` + `(perhaps try setting clear_after_read = false?).`);
        if (this.clearAfterRead) tensorWithState.cleared = true;
        tensorWithState.read = true;
        return tensorWithState.tensor;
    }
    /**
     * Helper method to read multiple tensors from the specified indices.
     */ readMany(indices) {
        return indices.map((index)=>this.read(index));
    }
    /**
     * Write value into the index of the TensorArray.
     * @param index number the index to write to.
     * @param tensor
     */ write(index, tensor) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || !this.dynamicSize && index >= this.maxSize) throw new Error(`Tried to write to index ${index}, but array is not resizeable and size is: ${this.maxSize}`);
        const t = this.tensors[index] || {};
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index},
          because the value dtype is ${tensor.dtype}, but TensorArray dtype is ${this.dtype}.`);
        // Set the shape for the first time write to unknow shape tensor array
        if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0)) this.elementShape = tensor.shape;
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.elementShape, tensor.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${index}.`);
        if (t.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been read.`);
        if (t.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been written.`);
        t.tensor = tensor;
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(tensor);
        t.written = true;
        this.tensors[index] = t;
    }
    /**
     * Helper method to write multiple tensors to the specified indices.
     */ writeMany(indices, tensors) {
        if (indices.length !== tensors.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,` + `because the index size: ${indices.length} is not the same as tensors size: ${tensors.length}.`);
        indices.forEach((i, index)=>this.write(i, tensors[index]));
    }
    /**
     * Return selected values in the TensorArray as a packed Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param [indices] number[] Optional. Taking values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size(). If not specified returns
     *    all tensors in the original order.
     * @param [dtype]
     */ gather(indices, dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${dtype}`);
        if (!indices) {
            indices = [];
            for(let i = 0; i < this.size(); i++)indices.push(i);
        } else indices = indices.slice(0, this.size());
        if (indices.length === 0) return (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)([], [
            0
        ].concat(this.elementShape));
        // Read all the PersistentTensors into a vector to keep track of
        // their memory.
        const tensors = this.readMany(indices);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.elementShape, tensors[0].shape, 'TensorArray shape mismatch: ');
        return (0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(tensors, 0);
    }
    /**
     * Return the values in the TensorArray as a concatenated Tensor.
     */ concat(dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${dtype}`);
        if (this.size() === 0) return (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)([], [
            0
        ].concat(this.elementShape));
        const indices = [];
        for(let i = 0; i < this.size(); i++)indices.push(i);
        // Collect all the tensors from the tensors array.
        const tensors = this.readMany(indices);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.elementShape, tensors[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${tensors[0].shape})`);
        return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(tensors, 0);
    }
    /**
     * Scatter the values of a Tensor in specific indices of a TensorArray.
     * @param indices number[] values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size().
     * @param tensor Tensor input tensor.
     */ scatter(indices, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
        const maxIndex = Math.max(...indices);
        if (!this.dynamicSize && maxIndex >= this.maxSize) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${this.maxSize})`);
        this.writeMany(indices, (0, $18be989171d2a470$export$3c05285afa115eec)(tensor, 0));
    }
    /**
     * Split the values of a Tensor into the TensorArray.
     * @param length number[] with the lengths to use when splitting value along
     *    its first dimension.
     * @param tensor Tensor, the tensor to split.
     */ split(length, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        let totalLength = 0;
        const cumulativeLengths = length.map((len)=>{
            totalLength += len;
            return totalLength;
        });
        if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
        if (!this.dynamicSize && length.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${length.length}), ` + 'and the TensorArray is not marked as dynamically resizeable');
        const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
        const tensors = [];
        (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            tensor = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(tensor, [
                1,
                totalLength,
                elementPerRow
            ]);
            for(let i = 0; i < length.length; ++i){
                const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
                const indices = [
                    0,
                    previousLength,
                    0
                ];
                const sizes = [
                    1,
                    length[i],
                    elementPerRow
                ];
                tensors[i] = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(tensor, indices, sizes), this.elementShape);
            }
            return tensors;
        });
        const indices = [];
        for(let i = 0; i < length.length; i++)indices[i] = i;
        this.writeMany(indices, tensors);
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $80889449dd3dbb46$export$97d48a41015c8fa8 {
    get id() {
        return this.idTensor.id;
    }
    /**
     *
     * @param tensors list of tensors
     * @param elementShape shape of each tensor, this can be a single number (any
     * shape is allowed) or partial shape (dim = -1).
     * @param elementDtype data type of each tensor
     * @param maxNumElements The maximum allowed size of `tensors`. Defaults to -1
     *   meaning that the size of `tensors` is unbounded.
     */ constructor(tensors, elementShape, elementDtype, maxNumElements = -1){
        this.tensors = tensors;
        this.elementShape = elementShape;
        this.elementDtype = elementDtype;
        if (tensors != null) tensors.forEach((tensor)=>{
            if (elementDtype !== tensor.dtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${tensor.dtype}`);
            (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(elementShape, tensor.shape, 'TensorList shape mismatch: ');
            (0, $8a461ef06e070cc9$export$fae3166c418e0471)(tensor);
        });
        this.idTensor = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0);
        this.maxNumElements = maxNumElements;
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(this.idTensor);
    }
    /**
     * Get a new TensorList containing a copy of the underlying tensor container.
     */ copy() {
        return new $80889449dd3dbb46$export$97d48a41015c8fa8([
            ...this.tensors
        ], this.elementShape, this.elementDtype);
    }
    /**
     * Dispose the tensors and idTensor and clear the tensor list.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.id)) tensor.dispose();
        });
        this.tensors.length = 0;
        this.idTensor.dispose();
    }
    /**
     * The size of the tensors in the tensor list.
     */ size() {
        return this.tensors.length;
    }
    /**
     * Return a tensor that stacks a list of rank-R tf.Tensors into one rank-(R+1)
     * tf.Tensor.
     * @param elementShape shape of each tensor
     * @param elementDtype data type of each tensor
     * @param numElements the number of elements to stack
     */ stack(elementShape, elementDtype, numElements = -1) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (numElements !== -1 && this.tensors.length !== numElements) throw new Error(`Operation expected a list with ${numElements} elements but got a list with ${this.tensors.length} elements.`);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(elementShape, this.elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $f0a16afd11c1093a$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const reshapedTensors = this.tensors.map((tensor)=>(0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(tensor, outputElementShape));
            return (0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(reshapedTensors, 0);
        });
    }
    /**
     * Pop a tensor from the end of the list.
     * @param elementShape shape of the tensor
     * @param elementDtype data type of the tensor
     */ popBack(elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (this.size() === 0) throw new Error('Trying to pop from an empty list.');
        const outputElementShape = (0, $f0a16afd11c1093a$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        const tensor = this.tensors.pop();
        tensor.kept = false;
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(tensor.shape, elementShape, 'TensorList shape mismatch: ');
        return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(tensor, outputElementShape);
    }
    /**
     * Push a tensor to the end of the list.
     * @param tensor Tensor to be pushed.
     */ pushBack(tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(tensor.shape, this.elementShape, 'TensorList shape mismatch: ');
        if (this.maxNumElements === this.size()) throw new Error(`Trying to push element into a full list.`);
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(tensor);
        this.tensors.push(tensor);
    }
    /**
     * Update the size of the list.
     * @param size the new size of the list.
     */ resize(size) {
        if (size < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${size}`);
        if (this.maxNumElements !== -1 && size > this.maxNumElements) throw new Error(`TensorListResize input size ${size} is greater maxNumElement ${this.maxNumElements}.`);
        const destTensorList = new $80889449dd3dbb46$export$97d48a41015c8fa8([], this.elementShape, this.elementDtype, this.maxNumElements);
        destTensorList.tensors.length = size;
        for(let i = 0; i < Math.min(this.tensors.length, size); ++i)destTensorList.tensors[i] = this.tensors[i];
        return destTensorList;
    }
    /**
     * Retrieve the element at the provided index
     * @param elementShape shape of the tensor
     * @param elementDtype dtype of the tensor
     * @param elementIndex index of the tensor
     */ getItem(elementIndex, elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || elementIndex > this.tensors.length) throw new Error(`Trying to access element ${elementIndex} in a list with ${this.tensors.length} elements.`);
        if (this.tensors[elementIndex] == null) throw new Error(`element at index ${elementIndex} is null.`);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.tensors[elementIndex].shape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $f0a16afd11c1093a$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        return (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(this.tensors[elementIndex], outputElementShape);
    }
    /**
     * Set the tensor at the index
     * @param elementIndex index of the tensor
     * @param tensor the tensor to be inserted into the list
     */ setItem(elementIndex, tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || this.maxNumElements !== -1 && elementIndex >= this.maxNumElements) throw new Error(`Trying to set element ${elementIndex} in a list with max ${this.maxNumElements} elements.`);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.elementShape, tensor.shape, 'TensorList shape mismatch: ');
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(tensor);
        // dispose the previous value if it is replacing.
        if (this.tensors[elementIndex] != null) this.tensors[elementIndex].kept = false;
        this.tensors[elementIndex] = tensor;
    }
    /**
     * Return selected values in the TensorList as a stacked Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param indices indices of tensors to gather
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ gather(indices, elementDtype, elementShape) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        // When indices is greater than the size of the list, indices beyond the
        // size of the list are ignored.
        indices = indices.slice(0, this.size());
        const outputElementShape = (0, $f0a16afd11c1093a$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        if (indices.length === 0) return (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)([], [
            0
        ].concat(outputElementShape));
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const tensors = indices.map((i)=>(0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(this.tensors[i], outputElementShape));
            return (0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(tensors, 0);
        });
    }
    /**
     * Return the values in the TensorList as a concatenated Tensor.
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ concat(elementDtype, elementShape) {
        if (!!elementDtype && elementDtype !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${elementDtype}`);
        (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $f0a16afd11c1093a$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        if (this.size() === 0) return (0, $141b1f68c03d4acb$export$65df3ad1ad888abb)([], [
            0
        ].concat(outputElementShape));
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const tensors = this.tensors.map((t)=>(0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(t, outputElementShape));
            return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)(tensors, 0);
        });
    }
}
function $80889449dd3dbb46$export$1bc9ee297bacb6e5(tensor, elementShape, elementDtype) {
    const dtype = tensor.dtype;
    if (tensor.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${tensor.shape}`);
    if (tensor.dtype !== elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${elementDtype}`);
    const tensorElementShape = tensor.shape.slice(1);
    (0, $f0a16afd11c1093a$export$c20af1b3c2621826)(tensorElementShape, elementShape, 'TensorList shape mismatch: ');
    const tensorList = (0, $18be989171d2a470$export$3c05285afa115eec)(tensor);
    return new $80889449dd3dbb46$export$97d48a41015c8fa8(tensorList, elementShape, dtype);
}
function $80889449dd3dbb46$export$12d6b2bf497a6811(elementShape, elementDtype, numElements, maxNumElements) {
    return new $80889449dd3dbb46$export$97d48a41015c8fa8([], elementShape, elementDtype, maxNumElements);
}
function $80889449dd3dbb46$export$c97954fff4307550(tensor, indices, elementShape, numElements) {
    if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
    const maxIndex = Math.max(...indices);
    if (numElements != null && numElements !== -1 && maxIndex >= numElements) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${numElements})`);
    const list = new $80889449dd3dbb46$export$97d48a41015c8fa8([], elementShape, tensor.dtype, numElements);
    const tensors = (0, $18be989171d2a470$export$3c05285afa115eec)(tensor, 0);
    indices.forEach((value, index)=>{
        list.setItem(value, tensors[index]);
    });
    return list;
}
function $80889449dd3dbb46$export$65980d18b75784e2(tensor, length, elementShape) {
    let totalLength = 0;
    const cumulativeLengths = length.map((len)=>{
        totalLength += len;
        return totalLength;
    });
    if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
    const shapeWithoutFirstDim = tensor.shape.slice(1);
    const outputElementShape = (0, $f0a16afd11c1093a$export$455cf61aa434d74b)(shapeWithoutFirstDim, elementShape);
    const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
    const tensors = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
        const tensors = [];
        tensor = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(tensor, [
            1,
            totalLength,
            elementPerRow
        ]);
        for(let i = 0; i < length.length; ++i){
            const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
            const indices = [
                0,
                previousLength,
                0
            ];
            const sizes = [
                1,
                length[i],
                elementPerRow
            ];
            tensors[i] = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(tensor, indices, sizes), outputElementShape);
        }
        tensor.dispose();
        return tensors;
    });
    const list = new $80889449dd3dbb46$export$97d48a41015c8fa8([], elementShape, tensor.dtype, length.length);
    for(let i = 0; i < tensors.length; i++)list.setItem(i, tensors[i]);
    return list;
}



const $ae87e2edc892e209$export$7be88578e558e499 = async (node, tensorMap, context)=>{
    switch(node.op){
        case 'If':
        case 'StatelessIf':
            {
                const thenFunc = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('thenBranch', node, tensorMap, context);
                const elseFunc = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elseBranch', node, tensorMap, context);
                const cond = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('cond', node, tensorMap, context);
                const args = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('args', node, tensorMap, context);
                const condValue = await cond.data();
                if (condValue[0]) return context.functionMap[thenFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                else return context.functionMap[elseFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
            }
        case 'While':
        case 'StatelessWhile':
            {
                const bodyFunc = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('body', node, tensorMap, context);
                const condFunc = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('cond', node, tensorMap, context);
                const args = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('args', node, tensorMap, context);
                // Calculate the condition of the loop
                const condResult = await context.functionMap[condFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                const argIds = args.map((tensor)=>tensor.id);
                let condValue = await condResult[0].data();
                // Dispose the intermediate tensors for condition function
                condResult.forEach((tensor)=>{
                    if (!tensor.kept && argIds.indexOf(tensor.id) === -1) tensor.dispose();
                });
                let result = args;
                while(condValue[0]){
                    // Record the previous result for intermediate tensor tracking
                    const origResult = result;
                    // Execution the body of the loop
                    result = await context.functionMap[bodyFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    const resultIds = result.map((tensor)=>tensor.id);
                    // Dispose the intermediate tensor for body function that is not global
                    // kept, not input/output of the body function
                    origResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                    // Recalcuate the condition of the loop using the latest results.
                    const condResult = await context.functionMap[condFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    condValue = await condResult[0].data();
                    // Dispose the intermediate tensors for condition function
                    condResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                }
                return result;
            }
        case 'LoopCond':
            {
                const pred = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pred', node, tensorMap, context);
                return [
                    (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(pred)
                ];
            }
        case 'Switch':
            {
                const pred = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pred', node, tensorMap, context);
                let data = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('data', node, tensorMap, context);
                if (!data.kept) data = (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(data);
                // Outputs nodes :0 => false, :1 => true
                return (await pred.data())[0] ? [
                    undefined,
                    data
                ] : [
                    data,
                    undefined
                ];
            }
        case 'Merge':
            {
                const inputName = node.inputNames.find((name)=>(0, $42f0e497e6c53be2$export$c5e50df225428195)(name, tensorMap, context) !== undefined);
                if (inputName) {
                    const data = (0, $42f0e497e6c53be2$export$c5e50df225428195)(inputName, tensorMap, context);
                    return [
                        (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(data)
                    ];
                }
                return undefined;
            }
        case 'Enter':
            {
                const frameId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('frameName', node, tensorMap, context);
                const data = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                context.enterFrame(frameId);
                return [
                    (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'Exit':
            {
                const data = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                context.exitFrame();
                return [
                    (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'NextIteration':
            {
                const data = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                context.nextIteration();
                return [
                    (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'TensorArrayV3':
            {
                const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const dtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const dynamicSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dynamicSize', node, tensorMap, context);
                const clearAfterRead = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('clearAfterRead', node, tensorMap, context);
                const identicalElementShapes = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('identicalElementShapes', node, tensorMap, context);
                const name = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('name', node, tensorMap, context);
                const tensorArray = new (0, $40de0c7b69ce3355$export$854ca114072d2abc)(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
                context.addTensorArray(tensorArray);
                return [
                    tensorArray.idTensor,
                    (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1.0)
                ];
            }
        case 'TensorArrayWriteV3':
            {
                const id = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const index = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const writeTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const writeTensorArray = context.getTensorArray(id.id);
                writeTensorArray.write(index, writeTensor);
                return [
                    writeTensorArray.idTensor
                ];
            }
        case 'TensorArrayReadV3':
            {
                const readId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const readIndex = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const readTensorArray = context.getTensorArray(readId.id);
                return [
                    readTensorArray.read(readIndex)
                ];
            }
        case 'TensorArrayGatherV3':
            {
                const gatherId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const gatherIndices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const gatherDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const gatherTensorArray = context.getTensorArray(gatherId.id);
                return [
                    gatherTensorArray.gather(gatherIndices, gatherDtype)
                ];
            }
        case 'TensorArrayScatterV3':
            {
                const scatterId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const scatterIndices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const scatterTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const scatterTensorArray = context.getTensorArray(scatterId.id);
                scatterTensorArray.scatter(scatterIndices, scatterTensor);
                return [
                    scatterTensorArray.idTensor
                ];
            }
        case 'TensorArrayConcatV3':
            {
                const concatId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const concatTensorArray = context.getTensorArray(concatId.id);
                const concatDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                return [
                    concatTensorArray.concat(concatDtype)
                ];
            }
        case 'TensorArraySplitV3':
            {
                const splitId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const splitTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const lengths = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('lengths', node, tensorMap, context);
                const splitTensorArray = context.getTensorArray(splitId.id);
                splitTensorArray.split(lengths, splitTensor);
                return [
                    splitTensorArray.idTensor
                ];
            }
        case 'TensorArraySizeV3':
            {
                const sizeId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const sizeTensorArray = context.getTensorArray(sizeId.id);
                return [
                    (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(sizeTensorArray.size(), 'int32')
                ];
            }
        case 'TensorArrayCloseV3':
            {
                const closeId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const closeTensorArray = context.getTensorArray(closeId.id);
                closeTensorArray.clearAndClose();
                return [
                    closeTensorArray.idTensor
                ];
            }
        case 'TensorListSetItem':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const index = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const writeTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.setItem(index, writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGetItem':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const readIndex = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDType = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.getItem(readIndex, elementShape, elementDType)
                ];
            }
        case 'TensorListScatterV2':
        case 'TensorListScatter':
            {
                const scatterIndices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const scatterTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const numElements = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numElements', node, tensorMap, context);
                const tensorList = (0, $80889449dd3dbb46$export$c97954fff4307550)(scatterTensor, scatterIndices, elementShape, numElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListReserve':
        case 'EmptyTensorList':
            {
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                let numElementsParam;
                if (node.op === 'TensorListReserve') numElementsParam = 'numElements';
                else numElementsParam = 'maxNumElements';
                const numElements = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)(numElementsParam, node, tensorMap, context);
                const maxNumElements = node.op === 'TensorListReserve' ? -1 : numElements;
                const tensorList = (0, $80889449dd3dbb46$export$12d6b2bf497a6811)(elementShape, elementDtype, numElements, maxNumElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGather':
            {
                const gatherId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const gatherIndices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(gatherId.id);
                return [
                    tensorList.gather(gatherIndices, elementDtype, elementShape)
                ];
            }
        case 'TensorListStack':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const numElements = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numElements', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.stack(elementShape, elementDtype, numElements)
                ];
            }
        case 'TensorListFromTensor':
            {
                const tensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = (0, $80889449dd3dbb46$export$1bc9ee297bacb6e5)(tensor, elementShape, elementDtype);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListConcat':
        case 'TensorListConcatV2':
            {
                const concatId = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(concatId.id);
                const concatDtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                return [
                    tensorList.concat(concatDtype, elementShape)
                ];
            }
        case 'TensorListPushBack':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const writeTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.pushBack(writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListPopBack':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDType = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.popBack(elementShape, elementDType)
                ];
            }
        case 'TensorListSplit':
            {
                const splitTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const elementShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const lengths = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('lengths', node, tensorMap, context);
                const tensorList = (0, $80889449dd3dbb46$export$65980d18b75784e2)(splitTensor, lengths, elementShape);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListLength':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(tensorList.size(), 'int32')
                ];
            }
        case 'TensorListResize':
            {
                const idTensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const srcTensorList = context.getTensorList(idTensor.id);
                const destTensorList = srcTensorList.resize(size);
                context.addTensorList(destTensorList);
                return [
                    destTensorList.idTensor
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $ae87e2edc892e209$export$2c04807512a22510 = 'control';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


function $ca4cf0b4ccf244c1$var$fusedConvAndDepthWiseParams(node, tensorMap, context) {
    const [extraOp, activationFunc] = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('fusedOps', node, tensorMap, context);
    const isBiasAdd = extraOp === 'biasadd';
    const noBiasAdd = !isBiasAdd;
    const isPrelu = activationFunc === 'prelu';
    const isBatchNorm = extraOp === 'fusedbatchnorm';
    const numArgs = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numArgs', node, tensorMap, context);
    if (isBiasAdd) {
        if (isPrelu && numArgs !== 2) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!isPrelu && isBiasAdd && numArgs !== 1) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
    if (isBatchNorm) throw new Error('FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported');
    const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
    const pad = (0, $42f0e497e6c53be2$export$d7501e6bee71bfee)(node, tensorMap, context);
    const dataFormat = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
    const dilations = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
    let [biasArg, preluArg] = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('args', node, tensorMap, context);
    if (noBiasAdd) {
        preluArg = biasArg;
        biasArg = undefined;
    }
    const leakyreluAlpha = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('leakyreluAlpha', node, tensorMap, context);
    return {
        stride: stride,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        biasArg: biasArg,
        preluArg: preluArg,
        activationFunc: activationFunc,
        leakyreluAlpha: leakyreluAlpha
    };
}
const $ca4cf0b4ccf244c1$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Conv1D':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('stride', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const dataFormat = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilation = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dilation', node, tensorMap, context);
                return [
                    ops.conv1d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context), stride, pad, dataFormat, dilation)
                ];
            }
        case 'Conv2D':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$d7501e6bee71bfee)(node, tensorMap, context);
                const dataFormat = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                return [
                    ops.conv2d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case '_FusedConv2D':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $ca4cf0b4ccf244c1$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.conv2d({
                        x: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context),
                        filter: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'FusedDepthwiseConv2dNative':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $ca4cf0b4ccf244c1$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.depthwiseConv2d({
                        x: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context),
                        filter: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'Conv2DBackpropInput':
        case 'Conv2dTranspose':
            {
                const shape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('outputShape', node, tensorMap, context);
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$d7501e6bee71bfee)(node, tensorMap, context);
                return [
                    ops.conv2dTranspose((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context), shape, [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'DepthwiseConv2dNative':
        case 'DepthwiseConv2d':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$d7501e6bee71bfee)(node, tensorMap, context);
                const dilations = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                const dataFormat = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthwiseConv2d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case 'Conv3D':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const dataFormat = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                return [
                    ops.conv3d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2],
                        dilations[3]
                    ])
                ];
            }
        case 'AvgPool':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPool':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPoolWithArgmax':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                const includeBatchInIndex = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('includeBatchInIndex', node, tensorMap, context);
                const { result: result, indexes: indexes } = ops.maxPoolWithArgmax((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                    kernelSize[1],
                    kernelSize[2]
                ], [
                    stride[1],
                    stride[2]
                ], pad, includeBatchInIndex);
                return [
                    result,
                    indexes
                ];
            }
        case 'AvgPool3D':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool3d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'MaxPool3D':
            {
                const stride = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool3d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'Dilation2D':
            {
                const strides = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const dilations = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                // strides: [1, stride_height, stride_width, 1].
                const strideHeight = strides[1];
                const strideWidth = strides[2];
                // dilations: [1, dilation_height, dilation_width, 1].
                const dilationHeight = dilations[1];
                const dilationWidth = dilations[2];
                return [
                    ops.dilation2d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        strideHeight,
                        strideWidth
                    ], pad, [
                        dilationHeight,
                        dilationWidth
                    ], 'NHWC' /* dataFormat */ )
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $ca4cf0b4ccf244c1$export$2c04807512a22510 = 'convolution';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $637b6a4ef58f5069$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Fill':
            {
                const shape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context);
                const dtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const value = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('value', node, tensorMap, context);
                return [
                    ops.fill(shape, value, dtype)
                ];
            }
        case 'LinSpace':
            {
                const start = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('start', node, tensorMap, context);
                const stop = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('stop', node, tensorMap, context);
                const num = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('num', node, tensorMap, context);
                return [
                    ops.linspace(start, stop, num)
                ];
            }
        case 'Multinomial':
            {
                const logits = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('logits', node, tensorMap, context);
                const numSamples = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numSamples', node, tensorMap, context);
                const seed = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('seed', node, tensorMap, context);
                return [
                    ops.multinomial(logits, numSamples, seed)
                ];
            }
        case 'OneHot':
            {
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const depth = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('depth', node, tensorMap, context);
                const onValue = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('onValue', node, tensorMap, context);
                const offValue = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('offValue', node, tensorMap, context);
                const dtype = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                return [
                    ops.oneHot(indices, depth, onValue, offValue, dtype)
                ];
            }
        case 'Ones':
            return [
                ops.ones((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'OnesLike':
            return [
                ops.onesLike((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'RandomStandardNormal':
            return [
                ops.randomStandardNormal((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('seed', node, tensorMap, context))
            ];
        case 'RandomUniform':
            return [
                ops.randomUniform(// tslint:disable-next-line:no-any
                (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('minval', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('maxval', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'RandomUniformInt':
            return [
                ops.randomUniformInt((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('minval', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('maxval', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('seed', node, tensorMap, context))
            ];
        case 'Range':
            {
                const start = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('start', node, tensorMap, context);
                const stop = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('stop', node, tensorMap, context);
                const step = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('step', node, tensorMap, context);
                return [
                    ops.range(start, stop, step, (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
                ];
            }
        case 'TruncatedNormal':
            {
                const shape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context);
                const mean = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('mean', node, tensorMap, context);
                const stdDev = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('stdDev', node, tensorMap, context);
                const seed = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('seed', node, tensorMap, context);
                return [
                    ops.truncatedNormal(shape, mean, stdDev, (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context), seed)
                ];
            }
        case 'Zeros':
            return [
                ops.zeros((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'ZerosLike':
            return [
                ops.zerosLike((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $637b6a4ef58f5069$export$2c04807512a22510 = 'creation';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


function $484b965941f603fd$var$nmsParams(node, tensorMap, context) {
    const boxes = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('boxes', node, tensorMap, context);
    const scores = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('scores', node, tensorMap, context);
    const maxOutputSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('maxOutputSize', node, tensorMap, context);
    const iouThreshold = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('iouThreshold', node, tensorMap, context);
    const scoreThreshold = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('scoreThreshold', node, tensorMap, context);
    const softNmsSigma = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('softNmsSigma', node, tensorMap, context);
    return {
        boxes: boxes,
        scores: scores,
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}
const $484b965941f603fd$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'NonMaxSuppressionV5':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = $484b965941f603fd$var$nmsParams(node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
                return [
                    result.selectedIndices,
                    result.selectedScores
                ];
            }
        case 'NonMaxSuppressionV4':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $484b965941f603fd$var$nmsParams(node, tensorMap, context);
                const padToMaxOutputSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('padToMaxOutputSize', node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionPaddedAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
                return [
                    result.selectedIndices,
                    result.validOutputs
                ];
            }
        case 'NonMaxSuppressionV3':
        case 'NonMaxSuppressionV2':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $484b965941f603fd$var$nmsParams(node, tensorMap, context);
                return [
                    await ops.image.nonMaxSuppressionAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold)
                ];
            }
        case 'Where':
            {
                const condition = ops.cast((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('condition', node, tensorMap, context), 'bool');
                const result = [
                    await ops.whereAsync(condition)
                ];
                condition.dispose();
                return result;
            }
        case 'ListDiff':
            return ops.setdiff1dAsync((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('y', node, tensorMap, context));
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $484b965941f603fd$export$2c04807512a22510 = 'dynamic';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $c06f9e7bd4637bd2$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'LowerBound':
            {
                const sortedSequence = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('sortedSequence', node, tensorMap, context);
                const values = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context);
                return [
                    ops.lowerBound(sortedSequence, values)
                ];
            }
        case 'TopKV2':
            {
                const x = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const k = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('k', node, tensorMap, context);
                const sorted = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('sorted', node, tensorMap, context);
                const result = ops.topk(x, k, sorted);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UpperBound':
            {
                const sortedSequence = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('sortedSequence', node, tensorMap, context);
                const values = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context);
                return [
                    ops.upperBound(sortedSequence, values)
                ];
            }
        case 'Unique':
            {
                const x = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const result = ops.unique(x);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UniqueV2':
            {
                const x = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const result = ops.unique(x, axis);
                return [
                    result.values,
                    result.indices
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c06f9e7bd4637bd2$export$2c04807512a22510 = 'evaluation';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $c6fd68ebb89a1379$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Const':
            return tensorMap[node.name];
        case 'PlaceholderWithDefault':
            const def = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('default', node, tensorMap, context);
            return [
                (0, $42f0e497e6c53be2$export$c5e50df225428195)(node.name, tensorMap, context) || def
            ];
        case 'Placeholder':
            return [
                (0, $42f0e497e6c53be2$export$c5e50df225428195)(node.name, tensorMap, context)
            ];
        case 'Identity':
        case 'StopGradient':
        case 'FakeQuantWithMinMaxVars':
            {
                const data = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'IdentityN':
            return (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context).map((t)=>(0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(t));
        case 'Snapshot':
            const snapshot = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
            return [
                (0, $42f0e497e6c53be2$export$c2185cfeaef7ba84)(snapshot)
            ];
        case 'Shape':
            return [
                ops.tensor1d((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context).shape, 'int32')
            ];
        case 'ShapeN':
            return (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context).map((t)=>ops.tensor1d(t.shape));
        case 'Size':
            return [
                ops.scalar((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context).size, 'int32')
            ];
        case 'Rank':
            return [
                ops.scalar((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context).rank, 'int32')
            ];
        case 'NoOp':
            return [
                ops.scalar(1)
            ];
        case 'Print':
            const input = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
            const data = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('data', node, tensorMap, context);
            const message = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('message', node, tensorMap, context);
            const summarize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('summarize', node, tensorMap, context);
            console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance.");
            console.log(message);
            for(let i = 0; i < data.length; i++)console.log(Array.prototype.slice.call(data[i].dataSync()).slice(0, summarize));
            return [
                input
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c6fd68ebb89a1379$export$2c04807512a22510 = 'graph';


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $c13167178b8e4544$export$b3bcf29b77543c46 {
    get id() {
        return this.handle.id;
    }
    /**
     * Constructor of HashTable. Creates a hash table.
     *
     * @param keyDType `dtype` of the table keys.
     * @param valueDType `dtype` of the table values.
     */ constructor(keyDType, valueDType){
        this.keyDType = keyDType;
        this.valueDType = valueDType;
        this.handle = (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(0);
        // tslint:disable-next-line: no-any
        this.tensorMap = new Map();
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(this.handle);
    }
    /**
     * Dispose the tensors and handle and clear the hashtable.
     */ clearAndClose() {
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        this.handle.dispose();
    }
    /**
     * The number of items in the hash table.
     */ size() {
        return this.tensorMap.size;
    }
    /**
     * The number of items in the hash table as a rank-0 tensor.
     */ tensorSize() {
        return $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46(this.size(), 'int32');
    }
    /**
     * Replaces the contents of the table with the specified keys and values.
     * @param keys Keys to store in the hashtable.
     * @param values Values to store in the hashtable.
     */ async import(keys, values) {
        this.checkKeyAndValueTensor(keys, values);
        // We only store the primitive values of the keys, this allows lookup
        // to be O(1).
        const $keys = await keys.data();
        // Clear the hashTable before inserting new values.
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const $values = (0, $18be989171d2a470$export$3c05285afa115eec)(values);
            const keysLength = $keys.length;
            const valuesLength = $values.length;
            (0, $0775da5e684c8c0d$exports).assert(keysLength === valuesLength, ()=>`The number of elements doesn't match, keys has ` + `${keysLength} elements, the values has ${valuesLength} ` + `elements.`);
            for(let i = 0; i < keysLength; i++){
                const key = $keys[i];
                const value = $values[i];
                (0, $8a461ef06e070cc9$export$fae3166c418e0471)(value);
                this.tensorMap.set(key, value);
            }
            return this.handle;
        });
    }
    /**
     * Looks up keys in a hash table, outputs the corresponding values.
     *
     * Performs batch lookups, for every element in the key tensor, `find`
     * stacks the corresponding value into the return tensor.
     *
     * If an element is not present in the table, the given `defaultValue` is
     * used.
     *
     * @param keys Keys to look up. Must have the same type as the keys of the
     *     table.
     * @param defaultValue The scalar `defaultValue` is the value output for keys
     *     not present in the table. It must also be of the same type as the
     *     table values.
     */ async find(keys, defaultValue) {
        this.checkKeyAndValueTensor(keys, defaultValue);
        const $keys = await keys.data();
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const result = [];
            for(let i = 0; i < $keys.length; i++){
                const key = $keys[i];
                const value = this.findWithDefault(key, defaultValue);
                result.push(value);
            }
            return (0, $63dcfd1fd312c0ca$export$a57ab32f40f83ea9)(result);
        });
    }
    // tslint:disable-next-line: no-any
    findWithDefault(key, defaultValue) {
        const result = this.tensorMap.get(key);
        return result != null ? result : defaultValue;
    }
    checkKeyAndValueTensor(key, value) {
        if (key.dtype !== this.keyDType) throw new Error(`Expect key dtype ${this.keyDType}, but got ` + `${key.dtype}`);
        if (value.dtype !== this.valueDType) throw new Error(`Expect value dtype ${this.valueDType}, but got ` + `${value.dtype}`);
    }
}



const $c64ae202442db830$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager)=>{
    switch(node.op){
        case 'HashTable':
        case 'HashTableV2':
            {
                const existingTableHandle = resourceManager.getHashTableHandleByName(node.name);
                // Table is shared with initializer.
                if (existingTableHandle != null) return [
                    existingTableHandle
                ];
                else {
                    const keyDType = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keyDType', node, tensorMap, context);
                    const valueDType = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('valueDType', node, tensorMap, context);
                    const hashTable = new (0, $c13167178b8e4544$export$b3bcf29b77543c46)(keyDType, valueDType);
                    resourceManager.addHashTable(node.name, hashTable);
                    return [
                        hashTable.handle
                    ];
                }
            }
        case 'InitializeTable':
        case 'InitializeTableV2':
        case 'LookupTableImport':
        case 'LookupTableImportV2':
            {
                const handle = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keys', node, tensorMap, context);
                const values = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.import(keys, values)
                ];
            }
        case 'LookupTableFind':
        case 'LookupTableFindV2':
            {
                const handle = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keys', node, tensorMap, context);
                const defaultValue = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.find(keys, defaultValue)
                ];
            }
        case 'LookupTableSize':
        case 'LookupTableSizeV2':
            {
                const handle = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tableHandle', node, tensorMap, context, resourceManager);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    hashTable.tensorSize()
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c64ae202442db830$export$2c04807512a22510 = 'hash_table';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $84aa62ecd9bd8000$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'ResizeBilinear':
            {
                const images = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('images', node, tensorMap, context);
                const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const alignCorners = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeBilinear(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'ResizeNearestNeighbor':
            {
                const images = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('images', node, tensorMap, context);
                const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const alignCorners = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeNearestNeighbor(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'CropAndResize':
            {
                const image = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('image', node, tensorMap, context);
                const boxes = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('boxes', node, tensorMap, context);
                const boxInd = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('boxInd', node, tensorMap, context);
                const cropSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('cropSize', node, tensorMap, context);
                const method = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('method', node, tensorMap, context);
                const extrapolationValue = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('extrapolationValue', node, tensorMap, context);
                return [
                    ops.image.cropAndResize(image, boxes, boxInd, cropSize, method, extrapolationValue)
                ];
            }
        case 'ImageProjectiveTransformV3':
            {
                const images = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('images', node, tensorMap, context);
                const transforms = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('transforms', node, tensorMap, context);
                const outputShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('outputShape', node, tensorMap, context);
                const fillValue = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('fillValue', node, tensorMap, context);
                const interpolation = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('interpolation', node, tensorMap, context);
                const fillMode = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('fillMode', node, tensorMap, context);
                return [
                    ops.image.transform(images, transforms, interpolation.toLowerCase(), fillMode.toLowerCase(), fillValue, outputShape)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $84aa62ecd9bd8000$export$2c04807512a22510 = 'image';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $b50f68f6f10be707$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Equal':
            return [
                ops.equal((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'NotEqual':
            return [
                ops.notEqual((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Greater':
            return [
                ops.greater((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'GreaterEqual':
            return [
                ops.greaterEqual((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Less':
            return [
                ops.less((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'LessEqual':
            return [
                ops.lessEqual((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'LogicalAnd':
            return [
                ops.logicalAnd((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'LogicalNot':
            return [
                ops.logicalNot((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context))
            ];
        case 'LogicalOr':
            return [
                ops.logicalOr((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Select':
        case 'SelectV2':
            return [
                ops.where((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('condition', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'BitwiseAnd':
            return [
                ops.bitwiseAnd((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $b50f68f6f10be707$export$2c04807512a22510 = 'logical';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $533326ec2a7d031c$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'BatchMatMul':
        case 'BatchMatMulV2':
        case 'MatMul':
            return [
                ops.matMul((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('transposeA', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('transposeB', node, tensorMap, context))
            ];
        case 'Einsum':
            return [
                ops.einsum((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('equation', node, tensorMap, context), ...(0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensors', node, tensorMap, context))
            ];
        case 'Transpose':
            return [
                ops.transpose((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('perm', node, tensorMap, context))
            ];
        case '_FusedMatMul':
            const [extraOp, activationFunc] = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('fusedOps', node, tensorMap, context);
            const isBiasAdd = extraOp === 'biasadd';
            const isPrelu = activationFunc === 'prelu';
            const numArgs = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numArgs', node, tensorMap, context);
            const leakyreluAlpha = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('leakyreluAlpha', node, tensorMap, context);
            if (isBiasAdd) {
                if (isPrelu && numArgs !== 2) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
                if (!isPrelu && numArgs !== 1) throw new Error('Fused MatMul with BiasAdd must have one extra argument: bias.');
            }
            const [biasArg, preluArg] = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('args', node, tensorMap, context);
            return [
                ops.fused.matMul({
                    a: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context),
                    b: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('b', node, tensorMap, context),
                    transposeA: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('transposeA', node, tensorMap, context),
                    transposeB: (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('transposeB', node, tensorMap, context),
                    bias: biasArg,
                    activation: activationFunc,
                    preluActivationWeights: preluArg,
                    leakyreluAlpha: leakyreluAlpha
                })
            ];
        case 'MatrixBandPart':
            return [
                ops.linalg.bandPart((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numLower', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numUpper', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $533326ec2a7d031c$export$2c04807512a22510 = 'matrices';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $80f7c7fe6e04bb4b$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'EuclideanNorm':
            return [
                ops.euclideanNorm((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context))
            ];
        case 'FusedBatchNorm':
        case 'FusedBatchNormV2':
            return [
                ops.batchNorm((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('mean', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('variance', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('offset', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('scale', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('epsilon', node, tensorMap, context))
            ];
        case 'FusedBatchNormV3':
            return [
                ops.batchNorm((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('mean', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('variance', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('offset', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('scale', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('epsilon', node, tensorMap, context))
            ];
        case 'LRN':
            return [
                ops.localResponseNormalization((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('radius', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('bias', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('alpha', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('beta', node, tensorMap, context))
            ];
        case 'Softmax':
            return [
                ops.softmax((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'LogSoftmax':
            return [
                ops.logSoftmax((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $80f7c7fe6e04bb4b$export$2c04807512a22510 = 'normalization';


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $8eb5411f0679cfe3$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'RaggedGather':
            {
                const { outputNestedSplits: outputNestedSplits, outputDenseValues: outputDenseValues } = ops.raggedGather((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('paramsNestedSplits', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('paramsDenseValues', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('outputRaggedRank', node, tensorMap, context));
                return outputNestedSplits.concat(outputDenseValues);
            }
        case 'RaggedRange':
            {
                const { rtNestedSplits: rtNestedSplits, rtDenseValues: rtDenseValues } = ops.raggedRange((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('starts', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('limits', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('splits', node, tensorMap, context));
                return [
                    rtNestedSplits,
                    rtDenseValues
                ];
            }
        case 'RaggedTensorToTensor':
            return [
                ops.raggedTensorToTensor((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('rowPartitionTensors', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('rowPartitionTypes', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8eb5411f0679cfe3$export$2c04807512a22510 = 'ragged';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $eefb43940d7b3aaa$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Max':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.max((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Mean':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.mean((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Min':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.min((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Sum':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.sum((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'All':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.all((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Any':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.any((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'ArgMax':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.argMax((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'ArgMin':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.argMin((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Prod':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.prod((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Cumprod':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const exclusive = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('exclusive', node, tensorMap, context);
                const reverse = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('reverse', node, tensorMap, context);
                return [
                    ops.cumprod((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Cumsum':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const exclusive = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('exclusive', node, tensorMap, context);
                const reverse = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('reverse', node, tensorMap, context);
                return [
                    ops.cumsum((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Bincount':
            const x = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
            const weights = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('weights', node, tensorMap, context);
            const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
            return [
                ops.bincount(x, weights, size)
            ];
        case 'DenseBincount':
            {
                const x = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const weights = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('weights', node, tensorMap, context);
                const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const binaryOutput = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('binaryOutput', node, tensorMap, context);
                return [
                    ops.denseBincount(x, weights, size, binaryOutput)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $eefb43940d7b3aaa$export$2c04807512a22510 = 'reduction';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $e5f1a886e22e62ec$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'ConcatV2':
        case 'Concat':
            {
                const n = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('n', node, tensorMap, context);
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                let inputs = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensors', node, tensorMap, context);
                inputs = inputs.slice(0, n);
                return [
                    ops.concat(inputs, axis)
                ];
            }
        case 'Gather':
            {
                const input = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), 0)
                ];
            }
        case 'GatherV2':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const batchDims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('batchDims', node, tensorMap, context);
                const input = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), axis, batchDims)
                ];
            }
        case 'Reverse':
            {
                const dims = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dims', node, tensorMap, context);
                const axis = [];
                for(let i = 0; i < dims.length; i++)if (dims[i]) axis.push(i);
                const input = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'ReverseV2':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const input = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'Slice':
            {
                // tslint:disable-next-line:no-any
                const begin = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('begin', node, tensorMap, context);
                // tslint:disable-next-line:no-any
                const size = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('size', node, tensorMap, context);
                return [
                    ops.slice((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), begin, size)
                ];
            }
        case 'StridedSlice':
            {
                const begin = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('begin', node, tensorMap, context);
                const end = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('end', node, tensorMap, context);
                const strides = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const beginMask = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('beginMask', node, tensorMap, context);
                const endMask = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('endMask', node, tensorMap, context);
                const ellipsisMask = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('ellipsisMask', node, tensorMap, context);
                const newAxisMask = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('newAxisMask', node, tensorMap, context);
                const shrinkAxisMask = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shrinkAxisMask', node, tensorMap, context);
                const tensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    ops.stridedSlice(tensor, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask)
                ];
            }
        case 'Pack':
            return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const tensors = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensors', node, tensorMap, context);
                // Reshape the tensors to the first tensor's shape if they don't
                // match.
                const shape = tensors[0].shape;
                const squeezedShape = ops.squeeze(tensors[0]).shape;
                const mapped = tensors.map((tensor)=>{
                    const sameShape = (0, $0775da5e684c8c0d$exports).arraysEqual(tensor.shape, shape);
                    if (!sameShape && !(0, $0775da5e684c8c0d$exports).arraysEqual(ops.squeeze(tensor).shape, squeezedShape)) throw new Error('the input tensors shape does not match');
                    return sameShape ? tensor : ops.reshape(tensor, shape);
                });
                return [
                    ops.stack(mapped, axis)
                ];
            });
        case 'Unpack':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const tensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                return ops.unstack(tensor, axis);
            }
        case 'Tile':
            {
                const reps = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('reps', node, tensorMap, context);
                return [
                    ops.tile((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), reps)
                ];
            }
        case 'Split':
        case 'SplitV':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const numOrSizeSplits = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numOrSizeSplits', node, tensorMap, context);
                const tensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return ops.split(tensor, numOrSizeSplits, axis);
            }
        case 'ScatterNd':
            {
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const values = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context);
                const shape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context);
                return [
                    ops.scatterND(indices, values, shape)
                ];
            }
        case 'GatherNd':
            {
                const x = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                return [
                    ops.gatherND(x, indices)
                ];
            }
        case 'SparseToDense':
            {
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('sparseIndices', node, tensorMap, context);
                const shape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('outputShape', node, tensorMap, context);
                const sparseValues = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('sparseValues', node, tensorMap, context);
                const defaultValue = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context);
                return [
                    ops.sparseToDense(indices, sparseValues, shape, sparseValues.dtype === defaultValue.dtype ? defaultValue : ops.cast(defaultValue, sparseValues.dtype))
                ];
            }
        case 'TensorScatterUpdate':
            {
                const indices = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const values = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context);
                const tensor = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                return [
                    ops.tensorScatterUpdate(tensor, indices, values)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $e5f1a886e22e62ec$export$2c04807512a22510 = 'slice_join';


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $5bbe220ded97d4dc$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'SparseFillEmptyRows':
            {
                const { outputIndices: outputIndices, outputValues: outputValues, emptyRowIndicator: emptyRowIndicator, reverseIndexMap: reverseIndexMap } = ops.sparse.sparseFillEmptyRows((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('values', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('denseShape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context));
                return [
                    outputIndices,
                    outputValues,
                    emptyRowIndicator,
                    reverseIndexMap
                ];
            }
        case 'SparseReshape':
            {
                const { outputIndices: outputIndices, outputShape: outputShape } = ops.sparse.sparseReshape((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('inputIndices', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('inputShape', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('newShape', node, tensorMap, context));
                return [
                    outputIndices,
                    outputShape
                ];
            }
        case 'SparseSegmentMean':
            {
                const outputData = ops.sparse.sparseSegmentMean((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('data', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        case 'SparseSegmentSum':
            {
                const outputData = ops.sparse.sparseSegmentSum((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('data', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5bbe220ded97d4dc$export$2c04807512a22510 = 'sparse';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $722a436a4beef16a$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'FFT':
            return [
                ops.fft((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'IFFT':
            return [
                ops.ifft((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'RFFT':
            return [
                ops.rfft((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'IRFFT':
            return [
                ops.irfft((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $722a436a4beef16a$export$2c04807512a22510 = 'spectral';


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $7c968342273297a4$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'StaticRegexReplace':
            return [
                ops.string.staticRegexReplace((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('pattern', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('rewrite', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('replaceGlobal', node, tensorMap, context))
            ];
        case 'StringNGrams':
            {
                const { nGrams: nGrams, nGramsSplits: nGramsSplits } = ops.string.stringNGrams((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('data', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataSplits', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('separator', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('nGramWidths', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('leftPad', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('rightPad', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('padWidth', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('preserveShortSequences', node, tensorMap, context));
                return [
                    nGrams,
                    nGramsSplits
                ];
            }
        case 'StringSplit':
            {
                const { indices: indices, values: values, shape: shape } = ops.string.stringSplit((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('delimiter', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('skipEmpty', node, tensorMap, context));
                return [
                    indices,
                    values,
                    shape
                ];
            }
        case 'StringToHashBucketFast':
            {
                const output = ops.string.stringToHashBucketFast((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('numBuckets', node, tensorMap, context));
                return [
                    output
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $7c968342273297a4$export$2c04807512a22510 = 'string';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $d0177492954ae4e5$export$7be88578e558e499 = (node, tensorMap, context, ops = $4c8c415cb2743f5a$exports)=>{
    switch(node.op){
        case 'Cast':
            return [
                ops.cast((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'ExpandDims':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.expandDims((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Squeeze':
            {
                const axis = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.squeeze((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Reshape':
            return [
                ops.reshape((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context))
            ];
        case 'EnsureShape':
            return [
                ops.ensureShape((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context))
            ];
        case 'MirrorPad':
            return [
                ops.mirrorPad((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('padding', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('mode', node, tensorMap, context))
            ];
        case 'PadV2':
        case 'Pad':
            return [
                ops.pad((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('padding', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('constantValue', node, tensorMap, context))
            ];
        case 'SpaceToBatchND':
            {
                const blockShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('blockShape', node, tensorMap, context);
                const paddings = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('paddings', node, tensorMap, context);
                return [
                    ops.spaceToBatchND((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), blockShape, paddings)
                ];
            }
        case 'BatchToSpaceND':
            {
                const blockShape = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('blockShape', node, tensorMap, context);
                const crops = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('crops', node, tensorMap, context);
                return [
                    ops.batchToSpaceND((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), blockShape, crops)
                ];
            }
        case 'DepthToSpace':
            {
                const blockSize = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('blockSize', node, tensorMap, context);
                const dataFormat = (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthToSpace((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), blockSize, dataFormat)
                ];
            }
        case 'BroadcastTo':
            return [
                ops.broadcastTo((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('shape', node, tensorMap, context))
            ];
        case 'BroadcastArgs':
            return [
                ops.broadcastArgs((0, $42f0e497e6c53be2$export$390042a9afe1baa5)('s0', node, tensorMap, context), (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('s1', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $d0177492954ae4e5$export$2c04807512a22510 = 'transformation';


function $29ac405e3193f90d$export$7be88578e558e499(node, tensorMap, context, resourceManager, tidy = $8a461ef06e070cc9$export$b841c6a213a653eb) {
    const value = ((node, tensorMap, context)=>{
        switch(node.category){
            case 'arithmetic':
                return tidy(()=>$ee39968fddb1bf71$export$7be88578e558e499(node, tensorMap, context));
            case 'basic_math':
                return tidy(()=>$a892a6465e274214$export$7be88578e558e499(node, tensorMap, context));
            case 'control':
                return $ae87e2edc892e209$export$7be88578e558e499(node, tensorMap, context);
            case 'convolution':
                return tidy(()=>$ca4cf0b4ccf244c1$export$7be88578e558e499(node, tensorMap, context));
            case 'creation':
                return tidy(()=>$637b6a4ef58f5069$export$7be88578e558e499(node, tensorMap, context));
            case 'dynamic':
                return $484b965941f603fd$export$7be88578e558e499(node, tensorMap, context);
            case 'evaluation':
                return tidy(()=>$c06f9e7bd4637bd2$export$7be88578e558e499(node, tensorMap, context));
            case 'image':
                return tidy(()=>$84aa62ecd9bd8000$export$7be88578e558e499(node, tensorMap, context));
            case 'graph':
                return tidy(()=>$c6fd68ebb89a1379$export$7be88578e558e499(node, tensorMap, context));
            case 'logical':
                return tidy(()=>$b50f68f6f10be707$export$7be88578e558e499(node, tensorMap, context));
            case 'matrices':
                return tidy(()=>$533326ec2a7d031c$export$7be88578e558e499(node, tensorMap, context));
            case 'normalization':
                return tidy(()=>$80f7c7fe6e04bb4b$export$7be88578e558e499(node, tensorMap, context));
            case 'ragged':
                return tidy(()=>$8eb5411f0679cfe3$export$7be88578e558e499(node, tensorMap, context));
            case 'reduction':
                return tidy(()=>$eefb43940d7b3aaa$export$7be88578e558e499(node, tensorMap, context));
            case 'slice_join':
                return tidy(()=>$e5f1a886e22e62ec$export$7be88578e558e499(node, tensorMap, context));
            case 'sparse':
                return tidy(()=>$5bbe220ded97d4dc$export$7be88578e558e499(node, tensorMap, context));
            case 'spectral':
                return tidy(()=>$722a436a4beef16a$export$7be88578e558e499(node, tensorMap, context));
            case 'string':
                return tidy(()=>$7c968342273297a4$export$7be88578e558e499(node, tensorMap, context));
            case 'transformation':
                return tidy(()=>$d0177492954ae4e5$export$7be88578e558e499(node, tensorMap, context));
            case 'hash_table':
                return $c64ae202442db830$export$7be88578e558e499(node, tensorMap, context, resourceManager);
            case 'custom':
                const opMapper = (0, $157d0ae23f71de04$export$ad480e5d0b303fdc)(node.op);
                if (opMapper && opMapper.customExecutor) return opMapper.customExecutor(new (0, $9d4a049a8bcac205$export$2964c493e854c8ad)(node, tensorMap, context));
                else throw TypeError(`Custom op ${node.op} is not registered.`);
            default:
                throw TypeError(`Unknown op '${node.op}'. File an issue at ` + `https://github.com/tensorflow/tfjs/issues so we can add it` + `, or register a custom execution with tf.registerOp()`);
        }
    })(node, tensorMap, context);
    if ($0775da5e684c8c0d$exports.isPromise(value)) return value.then((data)=>[].concat(data));
    return [].concat(value);
}


/**
 * ExecutionContext captures the runtime environment of the node. It keeps
 * track of the current frame and iteration for the control flow ops.
 *
 * For example, typical Dynamic RNN model may contain loops, for which
 * TensorFlow will generate graphs with Enter/Exit nodes to control the
 * current execution frame, and NextIteration Nodes for iteration id increment.
 * For model with branch logic, TensorFLow will generate Switch/Merge ops.
 */ class $39663cd58049b0ec$export$f7c638676c8af91d {
    constructor(weightMap = {}, tensorArrayMap = {}, tensorListMap = {}, functionMap = {}, parseNodeNameCache){
        this.weightMap = weightMap;
        this.tensorArrayMap = tensorArrayMap;
        this.tensorListMap = tensorListMap;
        this.functionMap = functionMap;
        this.parseNodeNameCache = parseNodeNameCache;
        this.rootContext = {
            id: 0,
            frameName: '',
            iterationId: 0
        };
        this.contexts = [
            this.rootContext
        ];
        this.lastId = 0;
        this.generateCurrentContextIds();
    }
    newFrame(id, frameName) {
        return {
            id: id,
            frameName: frameName,
            iterationId: 0
        };
    }
    /**
     * Set the current context
     * @param contexts: ExecutionContextInfo[] the current path of execution
     * frames
     */ set currentContext(contexts) {
        if (this.contexts !== contexts) {
            this.contexts = contexts;
            this.generateCurrentContextIds();
        }
    }
    get currentContext() {
        return this.contexts;
    }
    /**
     * Returns the current context in string format.
     */ get currentContextId() {
        return this._currentContextIds[0];
    }
    /**
     * Returns the current context and all parent contexts in string format.
     * This allow access to the nodes in the current and parent frames.
     */ get currentContextIds() {
        return this._currentContextIds;
    }
    generateCurrentContextIds() {
        const names = [];
        for(let i = 0; i < this.contexts.length - 1; i++){
            const contexts = this.contexts.slice(0, this.contexts.length - i);
            names.push(this.contextIdforContexts(contexts));
        }
        names.push('');
        this._currentContextIds = names;
    }
    contextIdforContexts(contexts) {
        return contexts ? contexts.map((context)=>context.id === 0 && context.iterationId === 0 ? '' : `${context.frameName}-${context.iterationId}`).join('/') : '';
    }
    /**
     * Enter a new frame, a new context is pushed on the current context list.
     * @param frameId new frame id
     */ enterFrame(frameId) {
        if (this.contexts) {
            this.lastId++;
            this.contexts = this.contexts.slice();
            this.contexts.push(this.newFrame(this.lastId, frameId));
            this._currentContextIds.unshift(this.contextIdforContexts(this.contexts));
        }
    }
    /**
     * Exit the current frame, the last context is removed from the current
     * context list.
     */ exitFrame() {
        if (this.contexts && this.contexts.length > 1) {
            this.contexts = this.contexts.slice();
            this.contexts.splice(-1);
            this.currentContextIds.shift();
        } else throw new Error('Cannot exit frame, the context is empty');
    }
    /**
     * Enter the next iteration of a loop, the iteration id of last context is
     * increased.
     */ nextIteration() {
        if (this.contexts && this.contexts.length > 0) {
            this.contexts = this.contexts.slice();
            this.lastId++;
            const context = Object.assign({}, this.contexts[this.contexts.length - 1]);
            context.iterationId += 1;
            context.id = this.lastId;
            this.contexts.splice(-1, 1, context);
            this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
        } else throw new Error('Cannot increase frame iteration, the context is empty');
    }
    getWeight(name) {
        return this.weightMap[name];
    }
    addTensorArray(tensorArray) {
        this.tensorArrayMap[tensorArray.id] = tensorArray;
    }
    getTensorArray(id) {
        return this.tensorArrayMap[id];
    }
    addTensorList(tensorList) {
        this.tensorListMap[tensorList.id] = tensorList;
    }
    getTensorList(id) {
        return this.tensorListMap[id];
    }
    dispose(keepIds) {
        for(const key in this.tensorArrayMap)this.tensorArrayMap[key].clearAndClose(keepIds);
        for(const key in this.tensorListMap)this.tensorListMap[key].clearAndClose(keepIds);
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $0e68d1a15f3eca06$export$73c2416e6ab509c5(inputs, outputs, weightMap, initNodes) {
    const usedNodes = new Set();
    const missingInputs = [];
    let dynamicNode = null;
    let syncInputs = null;
    // Start with the outputs, going backwards and find all the nodes that are
    // needed to compute those outputs.
    const seen = new Set();
    const inputNodeNames = new Set(Object.keys(inputs).map((name)=>(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name)[0]));
    initNodes = initNodes || [];
    const initNodeNames = new Set(initNodes.map((node)=>(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(node.name)[0]));
    const frontier = [
        ...outputs
    ];
    while(frontier.length > 0){
        const node = frontier.pop();
        if ($0e68d1a15f3eca06$export$683ae22d42a16fd1(node) || $0e68d1a15f3eca06$export$eee9c104bd05368d(node) || $0e68d1a15f3eca06$export$ad7e54a7e645a447(node)) {
            if (dynamicNode == null) {
                dynamicNode = node;
                syncInputs = dynamicNode.children.map((child)=>child.name).filter((name)=>usedNodes.has(name));
            }
        }
        usedNodes.add(node.name);
        // Weights are dead end since we already have their values.
        if (weightMap[node.name] != null) continue;
        // This node is a dead end since it's one of the user-provided inputs.
        if (inputNodeNames.has(node.name)) continue;
        // This node is a dead end since it doesn't have any inputs.
        if (initNodeNames.has(node.name)) continue;
        if (node.inputs.length === 0) {
            missingInputs.push(node.name);
            continue;
        }
        node.inputs.forEach((input)=>{
            // Don't add to the frontier if it is already there.
            if (seen.has(input.name)) return;
            seen.add(input.name);
            frontier.push(input);
        });
    }
    return {
        inputs: inputs,
        outputs: outputs,
        usedNodes: usedNodes,
        missingInputs: missingInputs,
        dynamicNode: dynamicNode,
        syncInputs: syncInputs
    };
}
function $0e68d1a15f3eca06$export$66747854b63761e1(graph, executionInfo) {
    const { usedNodes: usedNodes, inputs: inputs } = executionInfo;
    const inputNodes = Object.keys(inputs).map((name)=>(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name)[0]).map((name)=>graph.nodes[name]);
    const initNodes = graph.initNodes || [];
    const isUsed = (node)=>usedNodes.has(typeof node === 'string' ? node : node.name);
    function unique(nodes) {
        return [
            ...new Map(nodes.map((node)=>[
                    node.name,
                    node
                ])).values()
        ];
    }
    const predefinedNodes = unique([
        ...inputNodes,
        ...graph.weights,
        ...initNodes
    ]).filter(isUsed);
    const allNodes = unique([
        ...predefinedNodes,
        ...Object.values(graph.nodes)
    ]).filter(isUsed);
    const nameToNode = new Map(allNodes.map((node)=>[
            node.name,
            node
        ]));
    const inCounts = {};
    for (const node of allNodes){
        inCounts[node.name] = inCounts[node.name] || 0;
        for (const child of node.children){
            // When the child is unused, set in counts to infinity so that it will
            // never be decreased to 0 and added to the execution list.
            if (!isUsed(child)) inCounts[child.name] = Number.POSITIVE_INFINITY;
            inCounts[child.name] = (inCounts[child.name] || 0) + 1;
        }
    }
    // Build execution order for all used nodes regardless whether they are
    // predefined or not.
    const frontier = Object.entries(inCounts).filter(([, inCount])=>inCount === 0).map(([name])=>name);
    const orderedNodeNames = [
        ...frontier
    ];
    while(frontier.length > 0){
        const nodeName = frontier.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children.filter(isUsed))if (--inCounts[child.name] === 0) {
            orderedNodeNames.push(child.name);
            frontier.push(child.name);
        }
    }
    const orderedNodes = orderedNodeNames.map((name)=>nameToNode.get(name));
    const filteredOrderedNodes = $0e68d1a15f3eca06$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes);
    // TODO: Turn validation on/off with tf env flag.
    $0e68d1a15f3eca06$var$validateNodesExecutionOrder(filteredOrderedNodes, predefinedNodes);
    return filteredOrderedNodes;
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Returns ordered nodes reachable by at least one predefined node.
 * This can help us filter out redundant nodes from the returned node list.
 * For example:
 * If we have four nodes with dependencies like this:
 *   a --> b --> c --> d
 * when node `c` is predefined (e.g. given as an input tensor), we can
 * skip node `a` and `b` since their outputs will never be used.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $0e68d1a15f3eca06$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes) {
    const nameToNode = new Map(orderedNodes.map((node)=>[
            node.name,
            node
        ]));
    // TODO: Filter out more nodes when >=2 nodes are predefined in a path.
    const stack = predefinedNodes.map((node)=>node.name);
    const predefinedReachableNodeNames = new Set(stack);
    // Perform a DFS starting from the set of all predefined nodes
    // to find the set of all nodes reachable from the predefined nodes.
    while(stack.length > 0){
        const nodeName = stack.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children){
            if (!nameToNode.has(child.name) || predefinedReachableNodeNames.has(child.name)) continue;
            predefinedReachableNodeNames.add(child.name);
            stack.push(child.name);
        }
    }
    // Filter out unreachable nodes and build the ordered node list.
    const filteredOrderedNodes = orderedNodes.filter((node)=>predefinedReachableNodeNames.has(node.name));
    return filteredOrderedNodes;
}
class $0e68d1a15f3eca06$var$NodesExecutionOrderError extends Error {
    constructor(message){
        super(`NodesExecutionOrderError: ${message}`);
    }
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Validates property: given nodes `a` and `b`, Order(a) > Order(b) if `a`
 * is a child of `b`. This function throws an error if validation fails.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $0e68d1a15f3eca06$var$validateNodesExecutionOrder(orderedNodes, predefinedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const predefinedNodeNames = new Set(predefinedNodes.map((node)=>node.name));
    const isPredefined = (node)=>predefinedNodeNames.has(typeof node === 'string' ? node : node.name);
    const willBeExecutedNodeNames = new Set(orderedNodes.map((node)=>node.name));
    const willBeExecuted = (node)=>willBeExecutedNodeNames.has(typeof node === 'string' ? node : node.name);
    for (const node of orderedNodes){
        for (const child of node.children.filter(willBeExecuted)){
            if (!nodeNameToOrder.has(child.name)) throw new $0e68d1a15f3eca06$var$NodesExecutionOrderError(`Child ${child.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(node.name) > nodeNameToOrder.get(child.name)) throw new $0e68d1a15f3eca06$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run after its child ${child.name}.`);
        }
        if (!isPredefined(node)) for (const input of node.inputs){
            if (!nodeNameToOrder.has(input.name)) throw new $0e68d1a15f3eca06$var$NodesExecutionOrderError(`Input ${input.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(input.name) > nodeNameToOrder.get(node.name)) throw new $0e68d1a15f3eca06$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run before its input ${input.name}.`);
        }
    }
}
function $0e68d1a15f3eca06$export$1b4890839d1091f5(orderedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const INF_LIFE = Number.MAX_SAFE_INTEGER;
    // Make control flow nodes (and consequently their direct parents)
    // live forever since they're tricky to track correctly.
    const selfLifespans = orderedNodes.map((node, nodeOrder)=>$0e68d1a15f3eca06$export$683ae22d42a16fd1(node) ? INF_LIFE : nodeOrder);
    const getSelfLifeSpan = (node)=>{
        const selfLife = selfLifespans[nodeNameToOrder.get(node.name)];
        if (selfLife == null) // If nodeToOrder does not contain the node, it is unused or
        // unreachable in graph.
        return -1;
        return selfLife;
    };
    // `liveUntil[i]` points to the last node in the `orderedNodes` array that
    // may depend on tensors from node `i`. It indicates that all the
    // intermediate tensors from `orderedNodes[i]` should be disposed after
    // `orderedNodes[liveUntil[i]]` is executed.
    // A node lives long enough to pass on its tensors to its children.
    // It lives until at least `max(node's position, children's positions)`.
    const liveUntilOrders = orderedNodes.map((node, nodeOrder)=>{
        return node.children.map(getSelfLifeSpan).reduce((a, b)=>Math.max(a, b), selfLifespans[nodeOrder]);
    });
    // liveUntilMap:
    // - Key: Name of a node `x`
    // - Values: All nodes whose intermediate tensors should be disposed
    //           after `x` is executed.
    const liveUntilMap = new Map();
    for(let nodeOrder = 0; nodeOrder < orderedNodes.length; ++nodeOrder){
        const liveUntilOrder = liveUntilOrders[nodeOrder];
        if (liveUntilOrder === INF_LIFE) continue;
        const node = orderedNodes[nodeOrder];
        const liveUntilNode = orderedNodes[liveUntilOrder];
        if (!liveUntilMap.has(liveUntilNode.name)) liveUntilMap.set(liveUntilNode.name, []);
        liveUntilMap.get(liveUntilNode.name).push(node);
    }
    return liveUntilMap;
}
const $0e68d1a15f3eca06$var$CONTROL_FLOW_OPS = new Set([
    'Switch',
    'Merge',
    'Enter',
    'Exit',
    'NextIteration',
    'StatelessIf',
    'StatelessWhile',
    'if',
    'While'
]);
const $0e68d1a15f3eca06$var$DYNAMIC_SHAPE_OPS = new Set([
    'NonMaxSuppressionV2',
    'NonMaxSuppressionV3',
    'NonMaxSuppressionV5',
    'Where'
]);
const $0e68d1a15f3eca06$var$HASH_TABLE_OPS = new Set([
    'HashTable',
    'HashTableV2',
    'LookupTableImport',
    'LookupTableImportV2',
    'LookupTableFind',
    'LookupTableFindV2',
    'LookupTableSize',
    'LookupTableSizeV2'
]);
function $0e68d1a15f3eca06$export$683ae22d42a16fd1(node) {
    return $0e68d1a15f3eca06$var$CONTROL_FLOW_OPS.has(node.op);
}
function $0e68d1a15f3eca06$export$eee9c104bd05368d(node) {
    return $0e68d1a15f3eca06$var$DYNAMIC_SHAPE_OPS.has(node.op);
}
function $0e68d1a15f3eca06$export$ad7e54a7e645a447(node) {
    return $0e68d1a15f3eca06$var$HASH_TABLE_OPS.has(node.op);
}


class $30d601fc5d1891a4$export$289b3892ec35f79a {
    get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds;
    }
    get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
    get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap;
    }
    set weightMap(weightMap) {
        const weightIds = Object.keys(weightMap).map((key)=>weightMap[key].map((tensor)=>tensor.id));
        this._weightIds = [].concat(...weightIds);
        this._weightMap = weightMap;
    }
    /**
     * Set `ResourceManager` shared by executors of a model.
     * @param resourceManager: `ResourceManager` of the `GraphModel`.
     */ set resourceManager(resourceManager) {
        this._resourceManager = resourceManager;
    }
    get inputs() {
        return this._inputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get outputs() {
        return this._outputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get inputNodes() {
        return this._inputs.map((node)=>node.signatureKey || node.name);
    }
    get outputNodes() {
        return this._outputs.map((node)=>{
            const name = node.signatureKey || node.name;
            return node.defaultOutput ? `${name}:${node.defaultOutput}` : name;
        });
    }
    get functions() {
        return Object.keys(this._functions).reduce((map, key)=>{
            map[key] = this._functions[key].signature;
            return map;
        }, {});
    }
    /**
     *
     * @param graph Graph the model or function graph to be executed.
     * @param parent When building function exector you need to set the parent
     * executor. Since the weights and function executor maps are set at parant
     * level, that function executor can access the function maps and weight maps
     * through the parent.
     */ constructor(graph, parent){
        this.graph = graph;
        this.parent = parent;
        this.compiledMap = new Map();
        this.parseNodeNameCache = new Map();
        this._weightMap = {};
        this.SEPARATOR = ',';
        this._functions = {};
        this._functionExecutorMap = {};
        this.keepIntermediateTensors = false;
        this._outputs = graph.outputs;
        this._inputs = graph.inputs;
        this._initNodes = graph.initNodes;
        this._signature = graph.signature;
        this._functions = graph.functions;
        // create sub-graph executors
        if (graph.functions != null) Object.keys(graph.functions).forEach((name)=>{
            this._functionExecutorMap[name] = new $30d601fc5d1891a4$export$289b3892ec35f79a(graph.functions[name], this);
        });
    }
    getCompilationKey(inputs, outputs) {
        const sortedInputs = inputs.map((node)=>node.name).sort();
        const sortedOutputs = outputs.map((node)=>node.name).sort();
        return sortedInputs.join(this.SEPARATOR) + '--' + sortedOutputs.join(this.SEPARATOR);
    }
    /**
     * Compiles the inference graph and returns the minimal set of nodes that are
     * required for execution, in the correct execution order.
     * @returns {Object} compilation The compile result.
     * @returns {Node[]} compilation.orderedNodes Nodes in the correct execution
     *     order.
     * @returns {Map<string, Node[]>} compilation.nodeLiveUntilMap A map from node
     *     to disposable nodes after its execution. That is, for a node `x`,
     *     `nodeLiveUntilMap[x]` indicates all nodes whose intermediate
     *     tensors should be disposed after `x` is executed.
     */ compile(inputs, outputs) {
        const executionInfo = (0, $0e68d1a15f3eca06$export$73c2416e6ab509c5)(inputs, outputs, this.weightMap, this._initNodes);
        const { missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = executionInfo;
        if (dynamicNode != null) throw new Error(`This execution contains the node '${dynamicNode.name}', which has ` + `the dynamic op '${dynamicNode.op}'. Please use ` + `model.executeAsync() instead. Alternatively, to avoid the ` + `dynamic ops, specify the inputs [${syncInputs}]`);
        if (missingInputs.length > 0) {
            const outNames = outputs.map((n)=>n.name);
            const inNames = Object.keys(inputs);
            throw new Error(`Cannot compute the outputs [${outNames}] from the provided inputs ` + `[${inNames}]. Missing the following inputs: [${missingInputs}]`);
        }
        const orderedNodes = (0, $0e68d1a15f3eca06$export$66747854b63761e1)(this.graph, executionInfo);
        const nodeLiveUntilMap = (0, $0e68d1a15f3eca06$export$1b4890839d1091f5)(orderedNodes);
        return {
            orderedNodes: orderedNodes,
            nodeLiveUntilMap: nodeLiveUntilMap
        };
    }
    cloneAndKeepTensor(tensor) {
        if (tensor == null) return null;
        const clone = tensor.clone();
        // Keep the clone because`model.execute()` may be called within
        // a `tidy()`, but the user may inspect these tensors after the
        // tidy.
        (0, $8a461ef06e070cc9$export$fae3166c418e0471)(clone);
        return clone;
    }
    cloneTensorList(tensors) {
        if (!tensors) return null;
        const clonedTensor = tensors.map((tensor)=>{
            return this.cloneAndKeepTensor(tensor);
        });
        return clonedTensor;
    }
    cloneTensorMap(tensorsMap) {
        return Object.fromEntries(Object.entries(tensorsMap).map(([name, tensorsList])=>{
            return [
                name,
                this.cloneTensorList(tensorsList)
            ];
        }));
    }
    /**
     * Executes the inference for given input tensors.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model, if
     * no outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     */ execute(inputs, outputs) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        inputs = this.mapInputs(inputs);
        const names = Object.keys(inputs).sort();
        this.checkInputs(inputs);
        this.checkInputShapeAndType(inputs);
        outputs = this.mapOutputs(outputs);
        this.checkOutputs(outputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name)[0]]);
        const outputNodeNames = outputs.map((name)=>(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const compilationKey = this.getCompilationKey(inputNodes, outputNodes);
        // Do nothing if the compiled graph cache contains the input.
        let compilation = this.compiledMap.get(compilationKey);
        if (compilation == null) {
            compilation = this.compile(inputs, outputNodes);
            this.compiledMap.set(compilationKey, compilation);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const tensorArrayMap = {};
        const tensorListMap = {};
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            const context = new (0, $39663cd58049b0ec$export$f7c638676c8af91d)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
            const tensorsMap = Object.assign({}, this.weightMap);
            if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
            Object.keys(inputs).forEach((name)=>{
                const [nodeName, index] = (0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name, context);
                const tensors = [];
                tensors[index] = inputs[name];
                tensorsMap[nodeName] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
            });
            const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
            const { orderedNodes: orderedNodes, nodeLiveUntilMap: nodeLiveUntilMap } = compilation;
            for (const node of orderedNodes){
                if (tensorsMap[node.name]) continue;
                const tensors = (0, $29ac405e3193f90d$export$7be88578e558e499)(node, tensorsMap, context, this._resourceManager);
                if ((0, $0775da5e684c8c0d$exports).isPromise(tensors)) throw new Error(`The execution of the op '${node.op}' returned a promise. ` + `Please use model.executeAsync() instead.`);
                tensorsMap[node.name] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[node.name] = this.cloneTensorList(tensors);
                this.checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorsMap, context, tensorsToKeep, outputNodeNameSet, nodeLiveUntilMap.get(node.name));
            }
            // dispose the context for the root executor
            if (this.parent == null) context.dispose(tensorsToKeep);
            return outputs.map((name)=>(0, $42f0e497e6c53be2$export$c5e50df225428195)(name, tensorsMap, context));
        });
    }
    getFrozenTensorIds(tensorMap) {
        const ids = [].concat.apply([], Object.keys(tensorMap).map((key)=>tensorMap[key]).map((tensors)=>tensors.map((tensor)=>tensor.id)));
        return new Set(ids);
    }
    checkTensorForDisposal(nodeName, node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount) {
        // Skip output nodes and any control flow nodes, since its dependency is
        // tricky to track correctly.
        if ((0, $0e68d1a15f3eca06$export$683ae22d42a16fd1)(node) || outputNodeNameSet.has(nodeName)) return;
        for (const tensor of tensorMap[nodeName]){
            if (tensor == null) continue;
            intermediateTensorConsumerCount[tensor.id] = (intermediateTensorConsumerCount[tensor.id] || 0) + node.children.length;
        }
        for (const input of node.inputs){
            // Skip any control flow nodes, since its dependency is tricky to track
            // correctly.
            if ((0, $0e68d1a15f3eca06$export$683ae22d42a16fd1)(input)) continue;
            const tensors = (0, $42f0e497e6c53be2$export$d8cd584ff358961a)(input.name, tensorMap, context);
            if (tensors == null) continue;
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                // Only intermediate nodes' tensors have counts set, not marked as
                // kept, and not in `tensorsToKeep`.
                // Input and weight nodes' tensors should exist in `tensorsToKeep`.
                // Output and control flow nodes' tensors should never have count set.
                const count = intermediateTensorConsumerCount[tensor.id];
                if (count === 1) {
                    tensor.dispose();
                    delete intermediateTensorConsumerCount[tensor.id];
                } else if (count != null) intermediateTensorConsumerCount[tensor.id]--;
            }
        }
    }
    checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorMap, context, tensorsToKeep, outputNodeNameSet, liveUntilNodes) {
        function isNonDisposableNode(node) {
            // Skip output nodes and any control flow nodes, since its dependency is
            // tricky to track correctly.
            return (0, $0e68d1a15f3eca06$export$683ae22d42a16fd1)(node) || outputNodeNameSet.has(node.name);
        }
        if ((0, $0e68d1a15f3eca06$export$683ae22d42a16fd1)(node) || liveUntilNodes == null) return;
        for (const nodeToDispose of liveUntilNodes){
            if (isNonDisposableNode(nodeToDispose)) continue;
            const tensors = (0, $42f0e497e6c53be2$export$d8cd584ff358961a)(nodeToDispose.name, tensorMap, context);
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                tensor.dispose();
            }
        }
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs output node name from the Tensorflow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     */ async executeAsync(inputs, outputs) {
        return this._executeAsync(inputs, outputs);
    }
    disposeIntermediateTensors() {
        if (!this.clonedTensorsMap) return;
        Object.values(this.clonedTensorsMap).forEach((tensorsList)=>{
            for (const tensor of tensorsList)if (tensor && !tensor.isDisposed) tensor.dispose();
        });
        this.clonedTensorsMap = null;
    }
    getIntermediateTensors() {
        return this.clonedTensorsMap;
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Optional. Flag for executing a function.
     * @param tensorArrayMap Optional, global TensorArray map by id. Used for
     * function execution.
     * @param tensorArrayMap Optional global TensorList map by id. Used for
     * function execution.
     */ async _executeAsync(inputs, outputs, isFunctionExecution = false, tensorArrayMap = {}, tensorListMap = {}) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        if (!isFunctionExecution) {
            inputs = this.mapInputs(inputs);
            this.checkInputs(inputs);
            this.checkInputShapeAndType(inputs);
            outputs = this.mapOutputs(outputs);
            this.checkOutputs(outputs);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const context = new (0, $39663cd58049b0ec$export$f7c638676c8af91d)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
        if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
        // Graph with control flow op requires runtime evaluation of the execution
        // order, while without control flow the execution order is pre-determined
        // in the compile method.
        const tensorsMap = await this.executeWithControlFlow(inputs, context, outputs, isFunctionExecution);
        const results = outputs.map((name)=>(0, $42f0e497e6c53be2$export$c5e50df225428195)(name, tensorsMap, context));
        // dispose all the intermediate tensors
        const outputIds = results.map((t)=>t.id);
        const inputIds = Object.keys(inputs).map((name)=>inputs[name].id);
        const keepIds = new Set([
            ...outputIds,
            ...inputIds,
            ...this.weightIds
        ]);
        Object.values(tensorsMap).forEach((tensorsList)=>{
            tensorsList.forEach((tensor)=>{
                if (tensor && !tensor.isDisposed && !keepIds.has(tensor.id)) tensor.dispose();
            });
        });
        // dispose the context for the root executor
        if (this.parent == null) context.dispose(keepIds);
        return results;
    }
    async executeFunctionAsync(inputs, tensorArrayMap, tensorListMap) {
        const mappedInputs = inputs.reduce((map, tensor, index)=>{
            map[this.inputs[index].name] = tensor;
            return map;
        }, {});
        return this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap);
    }
    /**
     * When there are control flow nodes in the graph, the graph execution use
     * ExecutionContext to keep track of the frames and loop iterators.
     * @param inputs placeholder tensors for the graph.
     * @param context the execution context object for current execution.
     * @param outputNames Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Flag for executing a function.
     */ async executeWithControlFlow(inputs, context, outputNames, isFunctionExecution) {
        const names = Object.keys(inputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name)[0]]);
        const outputNodeNames = outputNames.map((name)=>(0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const { usedNodes: usedNodes, missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = (0, $0e68d1a15f3eca06$export$73c2416e6ab509c5)(inputs, outputNodes, this.weightMap, this._initNodes);
        // First nodes to execute include inputNodes, weights, and initNodes.
        const stack = [
            ...inputNodes,
            ...this.graph.weights,
            ...this._initNodes || []
        ].map((node)=>{
            return {
                node: node,
                contexts: context.currentContext
            };
        });
        const tensorsMap = Object.assign({}, this.weightMap);
        Object.keys(inputs).forEach((name)=>{
            const [nodeName, index] = (0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name);
            const tensors = [];
            tensors[index] = inputs[name];
            tensorsMap[nodeName] = tensors;
        });
        const intermediateTensorConsumerCount = {};
        const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
        const added = {};
        while(stack.length > 0){
            const promises = this.processStack(inputNodes, stack, context, tensorsMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes);
            await Promise.all(promises);
        }
        if (dynamicNode == null && !isFunctionExecution) console.warn(`This model execution did not contain any nodes with control flow ` + `or dynamic output shapes. You can use model.execute() instead.`);
        const missingOutputs = outputNodes.filter((node)=>!(0, $0e68d1a15f3eca06$export$683ae22d42a16fd1)(node) && !(0, $42f0e497e6c53be2$export$c5e50df225428195)(node.name, tensorsMap, context)).map((node)=>node.name);
        if (missingOutputs.length > 0) {
            let alternativeMsg = '';
            if (dynamicNode != null) alternativeMsg = `Alternatively, to avoid the dynamic ops, use model.execute() ` + `and specify the inputs [${syncInputs}]`;
            throw new Error(`Cannot compute the outputs [${missingOutputs}] from the provided ` + `inputs [${names}]. Consider providing the following inputs: ` + `[${missingInputs}]. ${alternativeMsg}`);
        }
        return tensorsMap;
    }
    processStack(inputNodes, stack, context, tensorMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes) {
        const promises = [];
        while(stack.length > 0){
            const item = stack.pop();
            context.currentContext = item.contexts;
            let nodeName = '';
            // The tensor of the Enter op with isConstant set should be set
            // in the parent scope, so it will be available as constant for the
            // whole loop.
            if (item.node.op === 'Enter' && (0, $42f0e497e6c53be2$export$390042a9afe1baa5)('isConstant', item.node, tensorMap, context)) [nodeName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(item.node.name, context);
            // only process nodes that are not in the tensorMap yet, this include
            // inputNodes and internal initNodes.
            if (tensorMap[item.node.name] == null) {
                const tensors = (0, $29ac405e3193f90d$export$7be88578e558e499)(item.node, tensorMap, context, this._resourceManager);
                if (!nodeName) [nodeName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(item.node.name, context);
                const currentContext = context.currentContext;
                if ((0, $0775da5e684c8c0d$exports).isPromise(tensors)) promises.push(tensors.then((t)=>{
                    tensorMap[nodeName] = t;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(t);
                    context.currentContext = currentContext;
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                    return t;
                }));
                else {
                    tensorMap[nodeName] = tensors;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                }
            } else this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
        }
        return promises;
    }
    processChildNodes(node, stack, context, tensorMap, added, usedNodes) {
        node.children.forEach((childNode)=>{
            const [nodeName] = (0, $42f0e497e6c53be2$export$6cbb65bf9e07a72)(childNode.name, context);
            if (added[nodeName] || !usedNodes.has(childNode.name)) return;
            // Merge op can be pushed if any of its inputs has value.
            if (childNode.op === 'Merge') {
                if (childNode.inputNames.some((name)=>{
                    return !!(0, $42f0e497e6c53be2$export$c5e50df225428195)(name, tensorMap, context);
                })) {
                    added[nodeName] = true;
                    stack.push({
                        contexts: context.currentContext,
                        node: childNode
                    });
                }
            } else if (childNode.inputNames.every((name)=>{
                return !!(0, $42f0e497e6c53be2$export$c5e50df225428195)(name, tensorMap, context);
            })) {
                added[nodeName] = true;
                stack.push({
                    contexts: context.currentContext,
                    node: childNode
                });
            }
        });
    }
    /**
     * Releases the memory used by the weight tensors.
     */ dispose() {
        Object.keys(this.weightMap).forEach((key)=>this.weightMap[key].forEach((tensor)=>tensor.dispose()));
    }
    checkInputShapeAndType(inputs) {
        Object.keys(inputs).forEach((name)=>{
            const input = inputs[name];
            const [nodeName] = (0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name);
            const node = this.graph.nodes[nodeName];
            if (node.attrParams['shape'] && node.attrParams['shape'].value) {
                const shape = node.attrParams['shape'].value;
                const match = shape.length === input.shape.length && input.shape.every((dim, index)=>shape[index] === -1 || shape[index] === dim);
                (0, $0775da5e684c8c0d$exports).assert(match, ()=>`The shape of dict['${node.name}'] provided in ` + `model.execute(dict) must be [${shape}], but was ` + `[${input.shape}]`);
            }
            if (node.attrParams['dtype'] && node.attrParams['dtype'].value) (0, $0775da5e684c8c0d$exports).assert(input.dtype === node.attrParams['dtype'].value, ()=>`The dtype of dict['${node.name}'] provided in ` + `model.execute(dict) must be ` + `${node.attrParams['dtype'].value}, but was ${input.dtype}`);
        });
    }
    mapInputs(inputs) {
        var _a, _b;
        const result = {};
        for(const inputName in inputs){
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName];
            if (tensor != null) result[tensor.name] = inputs[inputName];
            else result[inputName] = inputs[inputName];
        }
        return result;
    }
    checkInputs(inputs) {
        const notInGraph = Object.keys(inputs).filter((name)=>{
            const [nodeName] = (0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name);
            return this.graph.nodes[nodeName] == null;
        });
        if (notInGraph.length > 0) throw new Error(`The dict provided in model.execute(dict) has ` + `keys: [${notInGraph}] that are not part of graph`);
    }
    mapOutputs(outputs) {
        return outputs.map((name)=>{
            var _a, _b;
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.outputs) === null || _b === void 0 ? void 0 : _b[name];
            if (tensor != null) return tensor.name;
            return name;
        }, {});
    }
    checkOutputs(outputs) {
        outputs.forEach((name)=>{
            const [normalizedName] = (0, $42f0e497e6c53be2$export$67aec20b8c372baf)(name);
            if (!this.graph.nodes[normalizedName]) throw new Error(`The output '${name}' is not found in the graph`);
        });
    }
}


/**
 * Contains global resources of a model.
 */ class $b55681c1e71b6ce3$export$60667f9de734e56 {
    constructor(hashTableNameToHandle = {}, hashTableMap = {}){
        this.hashTableNameToHandle = hashTableNameToHandle;
        this.hashTableMap = hashTableMap;
    }
    /**
     * Register a `HashTable` in the resource manager.
     *
     * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
     * where id is the table handle tensor's id.
     *
     * @param name Op node name that creates the `HashTable`.
     * @param hashTable The `HashTable` to be added to resource manager.
     */ addHashTable(name, hashTable) {
        this.hashTableNameToHandle[name] = hashTable.handle;
        this.hashTableMap[hashTable.id] = hashTable;
    }
    /**
     * Get the table handle by node name.
     * @param name Op node name that creates the `HashTable`. This name is also
     *     used in the inputs list of lookup and import `HashTable` ops.
     */ getHashTableHandleByName(name) {
        return this.hashTableNameToHandle[name];
    }
    /**
     * Get the actual `HashTable` by its handle tensor's id.
     * @param id The id of the handle tensor.
     */ getHashTableById(id) {
        return this.hashTableMap[id];
    }
    /**
     * Dispose `ResourceManager`, including its hashTables and tensors in them.
     */ dispose() {
        for(const key in this.hashTableMap){
            this.hashTableMap[key].clearAndClose();
            delete this.hashTableMap[key];
        }
        for(const name in this.hashTableNameToHandle){
            this.hashTableNameToHandle[name].dispose();
            delete this.hashTableNameToHandle[name];
        }
    }
}



const $880ccac6c81e2c8b$export$a9bc79b23e178599 = '?tfjs-format=file';
const $880ccac6c81e2c8b$export$9ffb2eac80132860 = 'model.json';
class $880ccac6c81e2c8b$export$357a78c279dfa8cf {
    // Returns the version information for the tensorflow model GraphDef.
    get modelVersion() {
        return this.version;
    }
    get inputNodes() {
        return this.executor.inputNodes;
    }
    get outputNodes() {
        return this.executor.outputNodes;
    }
    get inputs() {
        return this.executor.inputs;
    }
    get outputs() {
        return this.executor.outputs;
    }
    get weights() {
        return this.executor.weightMap;
    }
    get metadata() {
        return this.artifacts.userDefinedMetadata;
    }
    get modelSignature() {
        return this.signature;
    }
    get modelStructuredOutputKeys() {
        return this.structuredOutputKeys;
    }
    /**
     * @param modelUrl url for the model, or an `io.IOHandler`.
     * @param weightManifestUrl url for the weight file generated by
     * scripts/convert.py script.
     * @param requestOption options for Request, which allows to send credentials
     * and custom headers.
     * @param onProgress Optional, progress callback function, fired periodically
     * before the load is completed.
     */ constructor(modelUrl, loadOptions = {}, tfio = (0, $6259f6994b8d164e$exports)){
        this.modelUrl = modelUrl;
        this.loadOptions = loadOptions;
        this.version = 'n/a';
        this.io = tfio;
        if (loadOptions == null) this.loadOptions = {};
        this.resourceManager = new (0, $b55681c1e71b6ce3$export$60667f9de734e56)();
    }
    findIOHandler() {
        const path = this.modelUrl;
        if (path.load != null) // Path is an IO Handler.
        this.handler = path;
        else if (this.loadOptions.requestInit != null) this.handler = this.io.browserHTTPRequest(path, this.loadOptions);
        else {
            const handlers = this.io.getLoadHandlers(path, this.loadOptions);
            if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
            // assume it is a relative http path.
            handlers.push(this.io.browserHTTPRequest(path, this.loadOptions));
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) load handlers for ` + `URL '${[
                path
            ]}'`);
            this.handler = handlers[0];
        }
    }
    /**
     * Loads the model and weight files, construct the in memory weight map and
     * compile the inference graph.
     */ load() {
        this.findIOHandler();
        if (this.handler.load == null) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const loadResult = this.handler.load();
        if ((0, $0775da5e684c8c0d$exports).isPromise(loadResult)) return loadResult.then((artifacts)=>{
            if (artifacts.getWeightStream == null) return this.loadSync(artifacts);
            return this.loadStreaming(artifacts);
        });
        return this.loadSync(loadResult);
    }
    /**
     * Synchronously construct the in memory weight map and
     * compile the inference graph.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ loadSync(artifacts) {
        const weightMap = this.io.decodeWeights(artifacts.weightData, artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    async loadStreaming(artifacts) {
        if (artifacts.getWeightStream == null) throw new Error('Model artifacts missing streamWeights function');
        const weightMap = await (0, $6b95449a1ec560d1$export$6c19531ae9ba1204)(artifacts.getWeightStream(), artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    loadWithWeightMap(artifacts, weightMap) {
        this.artifacts = artifacts;
        const graph = this.artifacts.modelTopology;
        let signature = this.artifacts.signature;
        if (this.artifacts.userDefinedMetadata != null) {
            const metadata = this.artifacts.userDefinedMetadata;
            if (metadata.signature != null) signature = metadata.signature;
            if (metadata.structuredOutputKeys != null) this.structuredOutputKeys = metadata.structuredOutputKeys;
        }
        this.signature = signature;
        this.version = `${graph.versions.producer}.${graph.versions.minConsumer}`;
        this.executor = new (0, $30d601fc5d1891a4$export$289b3892ec35f79a)((0, $87f15013f294f52a$export$712e670bcbcf1315).Instance.transformGraph(graph, this.signature));
        this.executor.weightMap = this.convertTensorMapToTensorsMap(weightMap);
        // Attach a model-level resourceManager to each executor to share resources,
        // such as `HashTable`.
        this.executor.resourceManager = this.resourceManager;
        if (artifacts.modelInitializer != null && artifacts.modelInitializer.node != null) {
            const initializer = (0, $87f15013f294f52a$export$712e670bcbcf1315).Instance.transformGraph(artifacts.modelInitializer);
            this.initializer = new (0, $30d601fc5d1891a4$export$289b3892ec35f79a)(initializer);
            this.initializer.weightMap = this.executor.weightMap;
            // Attach a model-level resourceManager to the initializer, the
            // hashTables created from when executing the initializer will be stored
            // in the resourceManager.
            this.initializer.resourceManager = this.resourceManager;
            this.initializerSignature = artifacts.initializerSignature;
        }
        return true;
    }
    /**
     * Save the configuration and/or weights of the GraphModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const modelUrl =
     *    'https://storage.googleapis.com/tfjs-models/savedmodel/mobilenet_v2_1.0_224/model.json';
     * const model = await tf.loadGraphModel(modelUrl);
     * const zeros = tf.zeros([1, 224, 224, 3]);
     * model.predict(zeros).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadGraphModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * model.predict(zeros).print();
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = this.io.getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new Error(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return handlerOrURL.save(this.artifacts);
    }
    addStructuredOutputNames(outputTensors) {
        if (this.structuredOutputKeys) {
            const outputTensorsArray = outputTensors instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? [
                outputTensors
            ] : outputTensors;
            const outputTensorMap = {};
            outputTensorsArray.forEach((outputTensor, i)=>outputTensorMap[this.structuredOutputKeys[i]] = outputTensor);
            return outputTensorMap;
        }
        return outputTensors;
    }
    /**
     * Execute the inference for the input tensors.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with multiple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns Inference result tensors. If the model is converted and it
     * originally had structured_outputs in tensorflow, then a NamedTensorMap
     * will be returned matching the structured_outputs. If no structured_outputs
     * are present, the output will be single `tf.Tensor` if the model has single
     * output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(inputs, config) {
        const outputTensors = this.execute(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    /**
     * Execute the inference for the input tensors in async fashion, use this
     * method when your model contains control flow ops.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns A Promise of inference result tensors. If the model is converted
     * and it originally had structured_outputs in tensorflow, then a
     * NamedTensorMap will be returned matching the structured_outputs. If no
     * structured_outputs are present, the output will be single `tf.Tensor` if
     * the model has single output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async predictAsync(inputs, config) {
        const outputTensors = await this.executeAsync(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    normalizeInputs(inputs) {
        var _a;
        if (!(inputs instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814)) && !Array.isArray(inputs)) {
            // The input is already a NamedTensorMap.
            const signatureInputs = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs;
            if (signatureInputs != null) for(const input in signatureInputs){
                const tensor = signatureInputs[input];
                if (tensor.resourceId != null) inputs[input] = this.resourceIdToCapturedInput[tensor.resourceId];
            }
            return inputs;
        }
        inputs = Array.isArray(inputs) ? inputs : [
            inputs
        ];
        const numCapturedInputs = Object.keys(this.resourceIdToCapturedInput).length;
        if (inputs.length + numCapturedInputs !== this.inputNodes.length) throw new Error(`Input tensor count mismatch, the graph model has ${this.inputNodes.length - numCapturedInputs} non-resource placeholders, while there are ${inputs.length} input tensors provided.`);
        let inputIndex = 0;
        return this.inputNodes.reduce((map, inputName)=>{
            var _a, _b, _c;
            const resourceId = (_c = (_b = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName]) === null || _c === void 0 ? void 0 : _c.resourceId;
            if (resourceId != null) map[inputName] = this.resourceIdToCapturedInput[resourceId];
            else map[inputName] = inputs[inputIndex++];
            return map;
        }, {});
    }
    normalizeOutputs(outputs) {
        outputs = outputs || this.outputNodes;
        return !Array.isArray(outputs) ? [
            outputs
        ] : outputs;
    }
    executeInitializerGraph() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.execute({}, []);
        else return this.initializer.execute({}, Object.keys(this.initializerSignature.outputs));
    }
    async executeInitializerGraphAsync() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.executeAsync({}, []);
        else return this.initializer.executeAsync({}, Object.keys(this.initializerSignature.outputs));
    }
    setResourceIdToCapturedInput(outputs) {
        this.resourceIdToCapturedInput = {};
        if (this.initializerSignature) {
            const signatureOutputs = this.initializerSignature.outputs;
            const outputNames = Object.keys(signatureOutputs);
            for(let i = 0; i < outputNames.length; i++){
                const outputName = outputNames[i];
                const tensorInfo = signatureOutputs[outputName];
                this.resourceIdToCapturedInput[tensorInfo.resourceId] = outputs[i];
            }
        }
    }
    /**
     * Executes inference for the model for given input tensors.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no
     * outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     *
     * @returns A single tensor if provided with a single output or no outputs
     * are provided and there is only one default output, otherwise return a
     * tensor array. The order of the tensor array is the same as the outputs
     * if provided, otherwise the order of outputNodes attribute of the model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ execute(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(this.executeInitializerGraph());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = this.executor.execute(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Executes inference for the model for given input tensors in async
     * fashion, use this method when your model contains control flow ops.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     *
     * @returns A Promise of single tensor if provided with a single output or
     * no outputs are provided and there is only one default output, otherwise
     * return a tensor map.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async executeAsync(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(await this.executeInitializerGraphAsync());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = await this.executor.executeAsync(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Get intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ getIntermediateTensors() {
        return this.executor.getIntermediateTensors();
    }
    /**
     * Dispose intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ disposeIntermediateTensors() {
        this.executor.disposeIntermediateTensors();
    }
    convertTensorMapToTensorsMap(map) {
        return Object.keys(map).reduce((newMap, key)=>{
            newMap[key] = [
                map[key]
            ];
            return newMap;
        }, {});
    }
    /**
     * Releases the memory used by the weight tensors and resourceManager.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ dispose() {
        this.executor.dispose();
        if (this.initializer) {
            this.initializer.dispose();
            if (this.resourceIdToCapturedInput) (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.resourceIdToCapturedInput);
        }
        this.resourceManager.dispose();
    }
}
async function $880ccac6c81e2c8b$export$f077572b5d896ffd(modelUrl, options = {}, tfio = (0, $6259f6994b8d164e$exports)) {
    if (modelUrl == null) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
    if (options == null) options = {};
    if (options.fromTFHub && typeof modelUrl === 'string') modelUrl = $880ccac6c81e2c8b$var$getTFHubUrl(modelUrl);
    const model = new $880ccac6c81e2c8b$export$357a78c279dfa8cf(modelUrl, options, tfio);
    await model.load();
    return model;
}
function $880ccac6c81e2c8b$export$64fa41ef6cfbfdd7(modelSource) {
    if (modelSource == null) throw new Error("modelUrl in loadGraphModelSync() cannot be null. Please provide model artifacts or an IOHandler that loads the model");
    let ioHandler;
    if (modelSource instanceof Array) {
        const [modelJSON, weights] = modelSource;
        if (!modelJSON) throw new Error('modelJSON must be the first element of the array');
        if (!weights || !(weights instanceof ArrayBuffer)) throw new Error("An ArrayBuffer of weights must be the second element of the array");
        if (!('modelTopology' in modelJSON)) throw new Error('Model JSON is missing \'modelTopology\'');
        if (!('weightsManifest' in modelJSON)) throw new Error('Model JSON is missing \'weightsManifest\'');
        const weightSpecs = (0, $6259f6994b8d164e$exports).getWeightSpecs(modelJSON.weightsManifest);
        const modelArtifacts = (0, $6259f6994b8d164e$exports).getModelArtifactsForJSONSync(modelJSON, weightSpecs, weights);
        ioHandler = (0, $6259f6994b8d164e$exports).fromMemorySync(modelArtifacts);
    } else if ('load' in modelSource) // Then modelSource is already an IOHandlerSync.
    ioHandler = modelSource;
    else if ('modelTopology' in modelSource && 'weightSpecs' in modelSource && 'weightData' in modelSource) // modelSource is of type ModelArtifacts.
    ioHandler = (0, $6259f6994b8d164e$exports).fromMemorySync(modelSource);
    else throw new Error('Unknown model format');
    const model = new $880ccac6c81e2c8b$export$357a78c279dfa8cf(ioHandler);
    model.load();
    return model;
}
function $880ccac6c81e2c8b$var$getTFHubUrl(modelUrl) {
    if (!modelUrl.endsWith('/')) modelUrl = modelUrl + '/';
    return `${modelUrl}${$880ccac6c81e2c8b$export$9ffb2eac80132860}${$880ccac6c81e2c8b$export$a9bc79b23e178599}`;
}



/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $4a3b1a6fa5741359$export$83d89fbfd8236492 = '4.22.0';




/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $adce22a3d11ab7f4$var$ENV = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)();
/** The batched dispatching calls size in the device queue. */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_DEFERRED_SUBMIT_BATCH_SIZE', ()=>15);
/**
 * Whether we forward execution to the CPU backend if tensors are small and
 * reside on the CPU.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_CPU_FORWARD', ()=>true);
/**
 * This flag is used to test different types of matmul programs.
 *
 * See MatMulProgramType in webgpu_util.ts for a list of available values.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_MATMUL_PROGRAM_TYPE', ()=>-1);
/**
 * Whether to use conv2dTranspose_naive which directly implement the
 * conv2dTranspose logic rather than using a matmul to simulate.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_USE_NAIVE_CONV2D_TRANSPOSE', ()=>true);
/**
 * Whether we use low power GPU. Otherwise, a high performance GPU will be
 * requested.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_USE_LOW_POWER_GPU', ()=>false);
/**
 * Threshold for input tensor size that determines whether WebGPU backend will
 * delegate computation to CPU.
 *
 * Default value is 1000.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD', ()=>1000);
/**
 * Whether to use a dummy canvas to make profiling tools like PIX work with
 * TFJS webgpu backend.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_USE_PROFILE_TOOL', ()=>false);
/**
 * Whether to use import API.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_IMPORT_EXTERNAL_TEXTURE', ()=>true);
/**
 * Whether to use conv2dNaive for debugging.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_USE_NAIVE_CONV2D_DEBUG', ()=>false);
/**
 * Threshold to increase dispatched workgroups for matmul. If too few workgroups
 * are dispatched, it means the hardware may be in low occupancy.
 * -1 means it's not set by the user. A default strategy will be applied.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_THRESHOLD_TO_INCREASE_WORKGROUPS_FOR_MATMUL', ()=>-1);
/**
 * Whether we will run im2col as a separate shader for convolution.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_CONV_SEPARATE_IM2COL_SHADER', ()=>false);
/**
 * A string used to match shader key. If any matches, print the related shader.
 * Seperated by comma. 'all' to print all. 'binary' to print binary(add, mul,
 * etc.). 'unary,conv2d' to print both unary and conv2d.
 */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_PRINT_SHADER', ()=>'');
/** Experimental flag, whether enter compile only phase. */ $adce22a3d11ab7f4$var$ENV.registerFlag('WEBGPU_ENGINE_COMPILE_ONLY', ()=>false);



/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d22002f016172b6d$export$addafb2fcad183eb {
    constructor(adapterInfo){
        if (adapterInfo) {
            this.vendor = adapterInfo.vendor;
            this.architecture = adapterInfo.architecture;
            this.intelGPUGeneration = this.getIntelGPUGeneration();
        }
    }
    getIntelGPUGeneration() {
        if (this.isIntel()) {
            if (this.architecture.startsWith('gen')) return Number(this.architecture.match(/\d+/));
            else if (this.architecture.startsWith('xe')) return 12;
        }
        return 0;
    }
    isIntel() {
        return this.vendor === 'intel';
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $aeebb474468a7549$export$f9938eb95a77a185 {
    constructor(device){
        this.device = device;
        this.numUsedBuffers = 0;
        this.numFreeBuffers = 0;
        this.freeBuffers = new Map();
        this.usedBuffers = new Map();
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
    acquireBuffer(size, usage, mappedAtCreation = false, reuse = true) {
        let buffer;
        const key = $aeebb474468a7549$var$getBufferKey(size, usage);
        if (reuse) {
            if (!this.freeBuffers.has(key)) this.freeBuffers.set(key, []);
            if (this.freeBuffers.get(key).length > 0) {
                buffer = this.freeBuffers.get(key).pop();
                this.numFreeBuffers--;
            } else {
                buffer = this.device.createBuffer({
                    size: size,
                    usage: usage,
                    mappedAtCreation: mappedAtCreation
                });
                this.numBytesAllocated += size;
            }
        } else {
            buffer = this.device.createBuffer({
                size: size,
                usage: usage,
                mappedAtCreation: mappedAtCreation
            });
            this.numBytesAllocated += size;
        }
        if (!this.usedBuffers.has(key)) this.usedBuffers.set(key, []);
        this.usedBuffers.get(key).push(buffer);
        this.numUsedBuffers++;
        this.numBytesUsed += size;
        return buffer;
    }
    releaseBuffer(buffer, reuse = true) {
        if (this.freeBuffers.size === 0) return;
        const size = buffer.size;
        const usage = buffer.usage;
        const key = $aeebb474468a7549$var$getBufferKey(size, usage);
        const bufferArray = this.usedBuffers.get(key);
        const index = bufferArray.indexOf(buffer);
        if (index < 0) throw new Error('Cannot find the buffer in buffer manager');
        bufferArray[index] = bufferArray[bufferArray.length - 1];
        bufferArray.pop();
        this.numUsedBuffers--;
        this.numBytesUsed -= size;
        if (reuse) {
            this.freeBuffers.get(key).push(buffer);
            this.numFreeBuffers++;
        } else {
            buffer.destroy();
            this.numBytesAllocated -= size;
        }
    }
    getNumUsedBuffers() {
        return this.numUsedBuffers;
    }
    getNumFreeBuffers() {
        return this.numFreeBuffers;
    }
    dispose() {
        this.freeBuffers.forEach((buffers, key)=>{
            buffers.forEach((buffer)=>{
                buffer.destroy();
            });
        });
        this.usedBuffers.forEach((buffers, key)=>{
            buffers.forEach((buffer)=>{
                buffer.destroy();
            });
        });
        this.freeBuffers = new Map();
        this.usedBuffers = new Map();
        this.numUsedBuffers = 0;
        this.numFreeBuffers = 0;
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
}
function $aeebb474468a7549$var$getBufferKey(size, usage) {
    return `${size}_${usage}`;
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $60b14d26a2a93dd4$export$337f59f8fd79d24f {
    constructor(device){
        this.device = device;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this.freeTextures = new Map();
        this.usedTextures = new Map();
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
    acquireTexture(width, height, format, usage) {
        const bytesPerElement = $60b14d26a2a93dd4$var$getBytesPerElement(format);
        const byteSize = width * height * bytesPerElement;
        const key = $60b14d26a2a93dd4$var$getTextureKey(width, height, format, usage);
        if (!this.freeTextures.has(key)) this.freeTextures.set(key, []);
        if (!this.usedTextures.has(key)) this.usedTextures.set(key, []);
        this.numBytesUsed += byteSize;
        this.numUsedTextures++;
        if (this.freeTextures.get(key).length > 0) {
            this.numFreeTextures--;
            const newTexture = this.freeTextures.get(key).shift();
            this.usedTextures.get(key).push(newTexture);
            return newTexture;
        }
        this.numBytesAllocated += byteSize;
        const newTexture = this.device.createTexture({
            size: [
                width,
                height
            ],
            format: format,
            usage: usage
        });
        this.usedTextures.get(key).push(newTexture);
        return newTexture;
    }
    releaseTexture(texture) {
        if (this.freeTextures.size === 0) return;
        const width = texture.width;
        const height = texture.height;
        const format = texture.format;
        const usage = texture.usage;
        const key = $60b14d26a2a93dd4$var$getTextureKey(width, height, format, usage);
        if (!this.freeTextures.has(key)) this.freeTextures.set(key, []);
        this.freeTextures.get(key).push(texture);
        this.numFreeTextures++;
        this.numUsedTextures--;
        const textureList = this.usedTextures.get(key);
        const textureIndex = textureList.indexOf(texture);
        if (textureIndex < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        textureList.splice(textureIndex, 1);
        const bytesPerElement = $60b14d26a2a93dd4$var$getBytesPerElement(format);
        const byteSize = width * height * bytesPerElement;
        this.numBytesUsed -= byteSize;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        this.freeTextures.forEach((textures, key)=>{
            textures.forEach((texture)=>{
                texture.destroy();
            });
        });
        this.usedTextures.forEach((textures, key)=>{
            textures.forEach((texture)=>{
                texture.destroy();
            });
        });
        this.freeTextures = new Map();
        this.usedTextures = new Map();
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
}
function $60b14d26a2a93dd4$var$getTextureKey(width, height, format, usage) {
    return `${width}_${height}_${format}_${usage}`;
}
function $60b14d26a2a93dd4$var$getBytesPerElement(format) {
    if (format === 'rgba8unorm') return 16;
    else throw new Error(`${format} is not supported!`);
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Generates WGSL that computes strides.
function $7f8c1ed636e4ac12$export$e21dd4b371e59d34(indicesArr, variableName) {
    if (Math.max(...indicesArr) > 5) throw new Error('Cannot symbolically compute strides for rank > 6 tensor.');
    const numCoords = indicesArr.length;
    const indicesStr = 'xyzwuv';
    const shape = indicesArr.map((d)=>`${variableName}.${indicesStr[d]}`);
    const strides = new Array(numCoords - 1);
    strides[numCoords - 2] = shape[numCoords - 1];
    for(let i = numCoords - 3; i >= 0; --i)strides[i] = `(${strides[i + 1]} * ${shape[i + 1]})`;
    return strides;
}
const $7f8c1ed636e4ac12$export$95fdaaf661ca4063 = (ptr, v, type)=>{
    if (type === 'int32') return `atomicAdd(${ptr}, bitcast<i32>(${v}));`;
    else // atomicAdd only supports uint/int type. For float, we use
    // atomicCompareExchangeWeak to simulate.
    return `
          {
            var oldValue = 0;
            loop {
              let newValueF32 = bitcast<f32>(oldValue) + (${v});
              let newValue = bitcast<i32>(newValueF32);
              let res = atomicCompareExchangeWeak(${ptr}, oldValue, newValue);
              if res.exchanged {
                break;
              }
              oldValue = res.old_value;
            }
          }`;
};


var $0533631f1fe2cae9$export$62104db1eb296622;
(function(PixelsOpType) {
    PixelsOpType[PixelsOpType["FROM_PIXELS"] = 0] = "FROM_PIXELS";
    PixelsOpType[PixelsOpType["DRAW"] = 1] = "DRAW";
})($0533631f1fe2cae9$export$62104db1eb296622 || ($0533631f1fe2cae9$export$62104db1eb296622 = {}));
const $0533631f1fe2cae9$export$5ca2cb6073dd12df = (device, program, inputsData, output, parallelCompilation)=>{
    const outputData = {
        dtype: output.dtype,
        shape: output.shape
    };
    const source = $0533631f1fe2cae9$var$makeShader(inputsData, outputData, program);
    const module = device.createShaderModule({
        code: source,
        label: program.constructor.name
    });
    let printShaderString = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGPU_PRINT_SHADER');
    if (printShaderString !== '') {
        printShaderString = printShaderString.toLowerCase();
        const printShaderArray = printShaderString.split(',');
        if (printShaderString === 'all' || printShaderArray.some((item)=>program.shaderKey.toLowerCase().includes(item))) {
            console.group(program.shaderKey);
            console.debug(source);
            console.groupEnd();
        }
    }
    if (parallelCompilation) return device.createComputePipelineAsync({
        compute: {
            module: module,
            entryPoint: '_start'
        },
        label: program.constructor.name,
        layout: 'auto'
    });
    else return device.createComputePipeline({
        compute: {
            module: module,
            entryPoint: '_start'
        },
        label: program.constructor.name,
        layout: 'auto'
    });
};
const $0533631f1fe2cae9$export$85f585983df3fed3 = (component, type = 'f32')=>{
    switch(component){
        case 1:
            return `${type}`;
        case 2:
            return `vec2<${type}>`;
        case 3:
            return `vec3<${type}>`;
        case 4:
            return `vec4<${type}>`;
        default:
            throw new Error(`${component}-component ${type} is not supported.`);
    }
};
function $0533631f1fe2cae9$export$859efd105c10c755(rank) {
    if (rank <= 1) return 'i32';
    else if (rank === 2) return `vec2<i32>`;
    else if (rank === 3) return `vec3<i32>`;
    else if (rank === 4) return `vec4<i32>`;
    else if (rank === 5) return `vec5`;
    else if (rank === 6) return `vec6`;
    else throw Error(`GPU for rank ${rank} is not yet supported`);
}
function $0533631f1fe2cae9$export$9e429db2fd13bb35(index) {
    if (index === 0) return 'x';
    else if (index === 1) return 'y';
    else if (index === 2) return 'z';
    else if (index === 3) return 'w';
    else if (index === 4) return 'u';
    else if (index === 5) return 'v';
    else throw Error(`Index ${index} is not yet supported`);
}
function $0533631f1fe2cae9$export$28aacf05d5e9d731(...params) {
    let snippet;
    switch(params.length){
        case 0:
            snippet = `
        fn main()
      `;
            break;
        case 1:
            snippet = `
        fn main(${params[0]} : i32)
      `;
            break;
        default:
            throw Error('Unreachable');
    }
    return snippet;
}
function $0533631f1fe2cae9$export$7032d63a04b4010d(useGlobalIndex, program) {
    let snippet;
    snippet = `
     ${$0533631f1fe2cae9$export$4a68c343179bae1c(program)}
      fn _start(@builtin(local_invocation_id) LocalId : vec3<u32>,
                @builtin(global_invocation_id) GlobalId : vec3<u32>,
                @builtin(local_invocation_index) LocalIndex: u32,
                @builtin(workgroup_id) WorkgroupId : vec3<u32>,
                @builtin(num_workgroups) NumWorkgroups : vec3<u32>) {
        localId = LocalId;
        localIndex = LocalIndex;
        globalId = GlobalId;
        numWorkgroups = NumWorkgroups;
        workgroupId = WorkgroupId;
        ${useGlobalIndex ? `main(getGlobalIndex());` : `main();`};
      }
    `;
    return snippet;
}
function $0533631f1fe2cae9$export$4a68c343179bae1c(program) {
    return `
  @compute @workgroup_size(${program.workgroupSize[0]}, ${program.workgroupSize[1]}, ${program.workgroupSize[2]})
`;
}
function $0533631f1fe2cae9$var$makeShader(inputInfo, outputData, program) {
    const prefixSnippets = [];
    const flatWorkgroupSize = program.workgroupSize[0] * program.workgroupSize[1] * program.workgroupSize[2];
    program.outputComponent = program.outputComponent ? program.outputComponent : 1;
    prefixSnippets.push(`

      var<private> localId: vec3<u32>;
      var<private> localIndex: u32;
      var<private> globalId: vec3<u32>;
      var<private> numWorkgroups: vec3<u32>;
      var<private> workgroupId: vec3<u32>;

      // Only used when the y/z dimension of workgroup size is 1.
      fn getGlobalIndex() -> i32 {
        ${$0533631f1fe2cae9$var$isFlatDispatch(program) ? `  return i32(globalId.x);` : `  return i32((workgroupId.z * numWorkgroups.x * numWorkgroups.y +
                workgroupId.y * numWorkgroups.x + workgroupId.x) * ${flatWorkgroupSize}u +
                localIndex);
        `}
      }
    `);
    if (program.pixelsOpType != null) {
        const inoutSnippet = program.pixelsOpType === $0533631f1fe2cae9$export$62104db1eb296622.FROM_PIXELS ? `@group(0) @binding(0) var<storage, read_write> result: array<${$0533631f1fe2cae9$export$342fcff7270d2d1a(outputData.dtype, program.outputComponent)}>;` : `@group(0) @binding(1) var<storage, read> inBuf : array<${$0533631f1fe2cae9$export$342fcff7270d2d1a(inputInfo[0].dtype, program.outputComponent)}>;`;
        const outShapeStridesType = outputData.shape.length === 3 ? 'vec2<i32>' : 'i32';
        prefixSnippets.push(`
        struct Uniform {
          outShapeStrides : ${outShapeStridesType},
          size            : i32,
          numChannels     : i32,
          alpha           : f32,
        };

        ${inoutSnippet}
        @group(0) @binding(2) var<uniform> uniforms: Uniform;
      `);
        const useGlobalIndex = $0533631f1fe2cae9$var$isFlatDispatchLayout(program);
        return [
            $0533631f1fe2cae9$var$commonSnippet,
            prefixSnippets.join('\n'),
            $0533631f1fe2cae9$export$a9674693e382741e(outputData.shape),
            program.getUserCode(),
            $0533631f1fe2cae9$export$7032d63a04b4010d(useGlobalIndex, program)
        ].join('\n');
    }
    let stridesLength;
    let stridesDataType;
    let uniformDeclaration = 'struct Uniforms { NAN : f32, INFINITY : f32, ';
    program.variableNames.forEach((x, i)=>{
        const perDataType = $0533631f1fe2cae9$export$859efd105c10c755(inputInfo[i].shape.length);
        uniformDeclaration += `${x.charAt(0).toLowerCase() + x.slice(1)}Shape : ${perDataType}, `;
        stridesLength = inputInfo[i].shape.length - 1;
        stridesDataType = $0533631f1fe2cae9$export$859efd105c10c755(stridesLength);
        uniformDeclaration += `${x.charAt(0).toLowerCase() + x.slice(1)}ShapeStrides: ${stridesDataType}, `;
    });
    const outputDataType = $0533631f1fe2cae9$export$859efd105c10c755(outputData.shape.length);
    uniformDeclaration += `outShape : ${outputDataType}, `;
    stridesLength = outputData.shape.length - 1;
    stridesDataType = $0533631f1fe2cae9$export$859efd105c10c755(stridesLength);
    uniformDeclaration += `
         outShapeStrides: ${stridesDataType}, `;
    if (program.size) uniformDeclaration += 'size : i32, ';
    if (program.uniforms) uniformDeclaration += program.uniforms;
    uniformDeclaration += '};';
    uniformDeclaration = $0533631f1fe2cae9$var$insertAlignment(uniformDeclaration);
    prefixSnippets.push(uniformDeclaration);
    // Output buffer.
    if (program.atomic) prefixSnippets.push(`
      @group(0) @binding(0) var<storage, read_write> result: array<atomic<i32>>;
    `);
    else prefixSnippets.push(`
      @group(0) @binding(0) var<storage, read_write> result: array<${$0533631f1fe2cae9$export$342fcff7270d2d1a(outputData.dtype, program.outputComponent)}>;
    `);
    program.variableNames.forEach((x, i)=>{
        prefixSnippets.push(`
      @group(0) @binding(${1 + i}) var<storage, read> ${x}: array<${program.variableComponents ? $0533631f1fe2cae9$export$342fcff7270d2d1a(inputInfo[i].dtype, program.variableComponents[i]) : $0533631f1fe2cae9$export$342fcff7270d2d1a(inputInfo[i].dtype, program.outputComponent)}>;
        `);
    });
    if (uniformDeclaration !== '') prefixSnippets.push(`
      @group(0) @binding(${1 + program.variableNames.length}) var<uniform> uniforms: Uniforms;
      `);
    const coordsSnippet = $0533631f1fe2cae9$var$getOutputCoordsSnippet(outputData.shape, program.dispatchLayout);
    const sources = [
        $0533631f1fe2cae9$var$commonSnippet,
        prefixSnippets.join('\n') + $0533631f1fe2cae9$var$isInfSnippet,
        $0533631f1fe2cae9$export$a9674693e382741e(outputData.shape),
        coordsSnippet,
        $0533631f1fe2cae9$var$getOutputIndexFromCoordsSnippet(outputData.shape.length)
    ];
    if (!program.atomic) sources.push($0533631f1fe2cae9$var$setOutputSnippet(outputData.shape, outputData.dtype, program.outputComponent));
    program.variableNames.forEach((x, i)=>{
        sources.push(`${$0533631f1fe2cae9$export$a9674693e382741e(inputInfo[i].shape, x)}`);
    });
    const inputSnippet = inputInfo.map((x, i)=>$0533631f1fe2cae9$var$getInputSnippet(x, outputData.shape, program.variableComponents ? program.variableComponents[i] : program.outputComponent, program.dispatchLayout.x.length === outputData.shape.length)).join('\n');
    sources.push(inputSnippet);
    sources.push(program.getUserCode());
    const useGlobalIndex = $0533631f1fe2cae9$var$isFlatDispatchLayout(program);
    sources.push($0533631f1fe2cae9$export$7032d63a04b4010d(useGlobalIndex, program));
    const source = sources.join('\n');
    return source;
}
function $0533631f1fe2cae9$export$2a17a6d53fe6f5d9(program, inputsData, output) {
    let key = program.shaderKey;
    if (program.pixelsOpType != null) return key;
    const shapes = [];
    const types = [];
    inputsData.forEach((element)=>{
        shapes.push(element.shape);
        types.push(element.dtype);
    });
    shapes.push(output.shape);
    types.push(output.dtype);
    const broadcastDims = inputsData.map((d)=>(0, $f35e0c1a651337db$exports).getBroadcastDims(d.shape, output.shape));
    const inputShapesEqualsOutShape = inputsData.map((d)=>(0, $0775da5e684c8c0d$exports).arraysEqual(d.shape, output.shape)).join('_');
    const broadcastDimsKey = broadcastDims.map((d)=>d.join('_')).join(';');
    const flatDispatchString = $0533631f1fe2cae9$var$isFlatDispatch(program) ? 'flatDispatch' : '';
    key += '_' + (program.workgroupSize ? program.workgroupSize.join(',') : '') + shapes.map((shape)=>shape.length).join(',') + types.join(',') + program.variableNames.join(',') + broadcastDimsKey + inputShapesEqualsOutShape + flatDispatchString;
    return key;
}
const $0533631f1fe2cae9$var$commonSnippet = `
  struct vec5 {x: i32, y: i32, z: i32, w: i32, u: i32};
  struct vec6 {x: i32, y: i32, z: i32, w: i32, u: i32, v: i32};

  // Checks whether coordinates lie within the bounds of the shape.
  fn coordsInBounds2D(coord : vec2<i32>, shape : vec2<i32>) -> bool {
    return all(coord >= vec2<i32>(0)) && all(coord < shape);
  }
  fn coordsInBounds3D(coord : vec3<i32>, shape : vec3<i32>) -> bool {
    return all(coord >= vec3<i32>(0)) && all(coord < shape);
  }
  fn coordsInBounds4D(coord : vec4<i32>, shape : vec4<i32>) -> bool {
    return all(coord >= vec4<i32>(0)) && all(coord < shape);
  }

  fn getIndexFromCoords1D(coord : i32, shape : i32) -> i32 {
    return coord;
  }
  fn getIndexFromCoords2D(coords : vec2<i32>, shape : vec2<i32>) -> i32 {
    return dot(coords, vec2<i32>(shape.y, 1));
  }
  fn getIndexFromCoords3D(coords : vec3<i32>, shape : vec3<i32>) -> i32 {
    return dot(coords, vec3<i32>(shape.y * shape.z, shape.z, 1));
  }
  fn getIndexFromCoords4D(coords : vec4<i32>, shape : vec4<i32>) -> i32 {
    return dot(coords, vec4<i32>(
        shape.y * shape.z * shape.w, shape.z * shape.w, shape.w, 1));
  }
  fn getIndexFromCoords5D(coords : vec5, shape : vec5) -> i32 {
    let shapeStrides: vec5 = vec5(shape.y * shape.z * shape.w * shape.u, shape.z * shape.w * shape.u, shape.w * shape.u, shape.u, 1);
    return coords.x*shapeStrides.x + coords.y*shapeStrides.y + coords.z*shapeStrides.z + coords.w*shapeStrides.w + coords.u*shapeStrides.u;
  }
  fn getIndexFromCoords6D(coords : vec6, shape : vec6) -> i32 {
    let shapeStrides: vec6 = vec6(shape.y * shape.z * shape.w * shape.u * shape.v, shape.z * shape.w * shape.u * shape.v, shape.w * shape.u * shape.v, shape.u * shape.v, shape.v, 1);
    return coords.x*shapeStrides.x + coords.y*shapeStrides.y + coords.z*shapeStrides.z + coords.w*shapeStrides.w + coords.u*shapeStrides.u + coords.v*shapeStrides.v;
  }

  // NaN defination in IEEE 754-1985 is :
  //   - sign = either 0 or 1.
  //   - biased exponent = all 1 bits.
  //   - fraction = anything except all 0 bits (since all 0 bits represents infinity).
  // https://en.wikipedia.org/wiki/IEEE_754-1985#Representation_of_non-numbers
  fn isnan(val: f32) -> bool {
    let floatToUint: u32 = bitcast<u32>(val);
    return (floatToUint & 0x7fffffffu) > 0x7f800000u;
  }
  fn isnanVec4(val : vec4<f32>) -> vec4<bool> {
    let floatToUint: vec4<u32> = bitcast<vec4<u32>>(val);
    return (floatToUint & vec4<u32>(0x7fffffffu)) > vec4<u32>(0x7f800000u);
  }
`;
const $0533631f1fe2cae9$var$isInfSnippet = `
  fn isinf(val: f32) -> bool {
    return abs(val) == uniforms.INFINITY;
  }
`;
function $0533631f1fe2cae9$export$a9674693e382741e(shape, name = '') {
    const rank = shape.length;
    const funcName = name !== '' ? `get${name.charAt(0).toUpperCase() + name.slice(1)}CoordsFromIndex` : 'getCoordsFromIndex';
    const stridesName = name !== '' ? `${name.charAt(0).toLowerCase() + name.slice(1)}ShapeStrides` : `outShapeStrides`;
    if (rank <= 1) return `fn ${funcName}(index : i32) -> i32 { return index; }`;
    const strides = (0, $0775da5e684c8c0d$exports).computeStrides(shape);
    const dtype = $0533631f1fe2cae9$export$859efd105c10c755(rank);
    const coords = [];
    for(let i = 0; i < rank; i++)coords.push(`d${i}`);
    if (strides.length === 1) return `    fn ${funcName}(index : i32) -> vec2<i32> {
      let d0 = index / uniforms.${stridesName}; let d1 = index - d0 * uniforms.${stridesName};
      return vec2<i32>(d0, d1);
    }`;
    let snippet;
    snippet = 'var index2 = index;' + strides.map((_, i)=>{
        const line1 = `let ${coords[i]} = index2 / uniforms.${stridesName}.${$0533631f1fe2cae9$export$9e429db2fd13bb35(i)}`;
        const line2 = i === strides.length - 1 ? `let ${coords[i + 1]} = index2 - ${coords[i]} * uniforms.${stridesName}.${$0533631f1fe2cae9$export$9e429db2fd13bb35(i)}` : `index2 = index2 - ${coords[i]} * uniforms.${stridesName}.${$0533631f1fe2cae9$export$9e429db2fd13bb35(i)}`;
        return `${line1}; ${line2};`;
    }).join('');
    return `
    fn ${funcName}(index : i32) -> ${dtype} {
      ${snippet}
      return ${dtype}(${coords.join(',')});
    }
  `;
}
function $0533631f1fe2cae9$var$getInputAtCoordsSnippet(inputInfo, component) {
    const texName = inputInfo.name;
    const rank = inputInfo.shape.length;
    const type = $0533631f1fe2cae9$export$859efd105c10c755(rank);
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const dims = [
        'd0',
        'd1',
        'd2',
        'd3',
        'd4',
        'd5'
    ].slice(0, rank);
    const inputs = dims.map((d)=>`${d} : i32`).join(', ');
    if (rank < 1) return `
      fn ${funcName}() -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)} {
        return ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}(${texName}[0]);
      }
    `;
    const shapeStr = `uniforms.${texName.charAt(0).toLowerCase() + texName.slice(1)}Shape`;
    let rankStr = `${rank}D`;
    if (rank === 0) rankStr = '1D';
    return `
    fn ${funcName}(${inputs}) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)} {
      return ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}(${texName}[getIndexFromCoords${rankStr}(${type}(${dims.join(',')}),
        ${shapeStr})${component === 1 ? '' : ` / ${component}`}]);
    }
   `;
}
function $0533631f1fe2cae9$var$getInputByOutputSnippet(inputInfo, outShape, component, isFlatDispatchLayout) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'ByOutput';
    const inRank = inputInfo.shape.length;
    const outRank = outShape.length;
    const type = $0533631f1fe2cae9$export$859efd105c10c755(outRank);
    // If the inShape equals the outShape and the dispatch layout is flat, we can
    // directly use |gl_GlobalInvocationID.x| as the index and don't need coords
    // conversion between these two shapes.
    if ((0, $0775da5e684c8c0d$exports).arraysEqual(inputInfo.shape, outShape) && isFlatDispatchLayout) return `
    fn ${funcName}Index(globalIndex : i32) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)} {
      return ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}(${texName}[globalIndex]);
    }

    fn ${funcName}Coords(coords : ${type}) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)} {
      return ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}(${texName}[${outRank > 1 ? 'getOutputIndexFromCoords(coords)' : 'coords'}${component === 1 ? '' : ` / ${component}`}]);
    }
    `;
    const broadcastDims = (0, $f35e0c1a651337db$exports).getBroadcastDims(inputInfo.shape, outShape);
    const rankDiff = outRank - inRank;
    let coordsSnippet = '';
    if (inRank === 0) return `
    fn ${funcName}Index(globalIndex : i32) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}{
      return get${texFuncSnippet}();
    }

    fn ${funcName}Coords(coords : ${type}) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}{
      return get${texFuncSnippet}();
    }
  `;
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${$0533631f1fe2cae9$export$9e429db2fd13bb35(d + rankDiff)} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else if (outRank > 1) {
        const coordsType = $0533631f1fe2cae9$export$859efd105c10c755(inRank);
        const coordsValues = inputInfo.shape.map((s, i)=>`coords.${$0533631f1fe2cae9$export$9e429db2fd13bb35(i + rankDiff)}`).join(', ');
        unpackedCoordsSnippet = `${coordsType}(${coordsValues})`;
    } else unpackedCoordsSnippet = 'coords';
    const shapeStr = `uniforms.${texName.charAt(0).toLowerCase() + texName.slice(1)}Shape`;
    const rankStr = `${inRank}D`;
    return `
  fn ${funcName}Index(globalIndex : i32) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)} {
    var coords = getCoordsFromIndex(globalIndex);
    ${coordsSnippet}
    return ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}(${texName}[getIndexFromCoords${rankStr}(${unpackedCoordsSnippet}, ${shapeStr})${component === 1 ? '' : ` / ${component}`}]);
  }

  fn ${funcName}Coords(coordsIn : ${type}) -> ${$0533631f1fe2cae9$export$85f585983df3fed3(component)} {
    var coords = coordsIn;
    ${coordsSnippet}
    return ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}(${texName}[getIndexFromCoords${rankStr}(${unpackedCoordsSnippet}, ${shapeStr})${component === 1 ? '' : ` / ${component}`}]);
  }
`;
}
function $0533631f1fe2cae9$var$getInputSnippet(inputInfo, outShape, component, isFlatDispatchLayout) {
    let res = $0533631f1fe2cae9$var$getInputAtCoordsSnippet(inputInfo, component);
    const inShape = inputInfo.shape;
    if (inShape.length <= outShape.length) res += $0533631f1fe2cae9$var$getInputByOutputSnippet(inputInfo, outShape, component, isFlatDispatchLayout);
    return res;
}
/**
 * Generates getOutputCoords() function that computes output coordinates
 * from dispatch geometry to reduce arithmetic.
 */ function $0533631f1fe2cae9$var$getOutputCoordsSnippet(outShape, dispatchLayout) {
    const { x: x, y: y = [], z: z = [] } = dispatchLayout;
    const outRank = outShape.length;
    const rank = x.length + y.length + z.length;
    // getOutputCoords is only meaningful when the output rank is same with
    // dispatch layout rank.
    if (rank !== outRank) return '';
    if (x.length === outRank) {
        const dtype = $0533631f1fe2cae9$export$859efd105c10c755(outRank);
        const snippet = `fn getOutputCoords() -> ${dtype}{
    let globalIndex = getGlobalIndex();
    return getCoordsFromIndex(globalIndex);
  }
  `;
        return snippet;
    }
    let gatherDimensionsStr = '';
    const dims = [
        x,
        y,
        z
    ];
    for(let i = 0; i < dims.length; i++){
        const arr = dims[i];
        if (arr.length === 0) continue;
        if (arr.length === 1) gatherDimensionsStr += `let d${arr[0]} = i32(globalId[${i}]);`;
        else {
            const strides = (0, $7f8c1ed636e4ac12$export$e21dd4b371e59d34)(arr, 'uniforms.outShape');
            gatherDimensionsStr += `var index${i} = i32(globalId[${i}]);`;
            for(let j = 0; j < strides.length; j++){
                gatherDimensionsStr += `let d${arr[j]} = index${i} / ${strides[j]};`;
                if (j === strides.length - 1) gatherDimensionsStr += `let d${arr[j + 1]} = ` + `index${i} - d${arr[j]} * ${strides[j]};`;
                else gatherDimensionsStr += `index${i} = index${i} - d${arr[j]} * ${strides[j]};`;
            }
        }
    }
    const dimensions = [];
    for(let i = 0; i < rank; i++)dimensions.push(`d${i}`);
    const dtype = $0533631f1fe2cae9$export$859efd105c10c755(rank);
    let snippet = `fn getOutputCoords() -> ${dtype} {
  ${gatherDimensionsStr}
`;
    if (dimensions.length === 0) snippet += `return ${dtype}(0); }`;
    else snippet += `return ${dtype}(${dimensions.join(',')}); }`;
    return snippet;
}
function $0533631f1fe2cae9$var$getOutputIndexFromCoordsSnippet(outRank) {
    let snippet = '';
    switch(outRank){
        case 0:
        case 1:
            snippet += `
        fn getOutputIndexFromCoords(coords : i32) -> i32 {
          return coords;
        }
        `;
            break;
        case 2:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec2<i32>) -> i32 {
          return dot(coords, vec2<i32>(uniforms.outShapeStrides, 1));
        }
        `;
            break;
        case 3:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec3<i32>) -> i32 {
          return dot(coords, vec3<i32>(uniforms.outShapeStrides.x, uniforms.outShapeStrides.y, 1));
        }
        `;
            break;
        case 4:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec4<i32>) -> i32 {
          return dot(coords, vec4<i32>(
            uniforms.outShapeStrides.x, uniforms.outShapeStrides.y, uniforms.outShapeStrides.z, 1));
        }
        `;
            break;
        case 5:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec5) -> i32 {
          return coords.x * uniforms.outShapeStrides.x +
              coords.y * uniforms.outShapeStrides.y +
              coords.z * uniforms.outShapeStrides.z +
              coords.w * uniforms.outShapeStrides.w +
              coords.u;
        }
        `;
            break;
        case 6:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec6) -> i32 {
          return coords.x * uniforms.outShapeStrides.x +
              coords.y * uniforms.outShapeStrides.y +
              coords.z * uniforms.outShapeStrides.z +
              coords.w * uniforms.outShapeStrides.w +
              coords.u * uniforms.outShapeStrides.u +
              coords.v;
        }
        `;
            break;
        default:
            (0, $0775da5e684c8c0d$exports).assert(false, ()=>`Unsupported ${outRank}D shape`);
            break;
    }
    return snippet;
}
function $0533631f1fe2cae9$var$isFlatDispatch(program) {
    return program.dispatch[1] === 1 && program.dispatch[2] === 1;
}
function $0533631f1fe2cae9$export$342fcff7270d2d1a(type, component = 1) {
    if (type === 'float32') return $0533631f1fe2cae9$export$85f585983df3fed3(component, 'f32');
    else if (type === 'int32' || type === 'bool') return $0533631f1fe2cae9$export$85f585983df3fed3(component, 'i32');
    throw new Error(`type ${type} is not supported.`);
}
function $0533631f1fe2cae9$var$setOutputSnippet(outShape, outBufferType, component) {
    const outRank = outShape.length;
    const gpuType = $0533631f1fe2cae9$export$342fcff7270d2d1a(outBufferType, component);
    let snippet = `fn setOutputAtIndex(flatIndex : i32, value : ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}) {
      result[flatIndex] = ${gpuType}(value);
    }

    fn setOutputAtIndexI32(flatIndex : i32, value : ${$0533631f1fe2cae9$export$85f585983df3fed3(component, 'i32')}) {
      result[flatIndex] = ${gpuType}(value);
    }
    `;
    if (outRank >= 2) {
        const dims = [
            'd0',
            'd1',
            'd2',
            'd3',
            'd4',
            'd5'
        ].slice(0, outRank);
        const type = $0533631f1fe2cae9$export$859efd105c10c755(outRank);
        snippet += `
      fn setOutputAtCoords(${dims.map((d)=>`${d} : i32`).join(', ')}, value : ${$0533631f1fe2cae9$export$85f585983df3fed3(component)}) {
        let flatIndex = getOutputIndexFromCoords(${type}(${dims.join(', ')}));
        setOutputAtIndex(flatIndex${component === 1 ? '' : ` / ${component}`}, value);
      }
      fn setOutputAtCoordsI32(${dims.map((d)=>`${d} : i32`).join(', ')}, value : ${$0533631f1fe2cae9$export$85f585983df3fed3(component, 'i32')}) {
        let flatIndex = getOutputIndexFromCoords(${type}(${dims.join(', ')}));
        setOutputAtIndexI32(flatIndex${component === 1 ? '' : ` / ${component}`}, value);
      }
    `;
    }
    return snippet;
}
function $0533631f1fe2cae9$var$insertAlignment(uniformShader) {
    // insert alignment when current pattern is vec5 or vec6
    const curInsertRe = /(\w+)\s*:\s*vec(5|6)/g;
    uniformShader = uniformShader.replace(curInsertRe, (match)=>{
        return '@align(16) ' + match;
    });
    // insert alignment when previous pattern is vec5 or vec6
    const preInsertRe = /vec(5|6)\s*,\s*(\w+)/g;
    uniformShader = uniformShader.replace(preInsertRe, (_, p1, p2)=>{
        return `vec${p1}, @align(16) ${p2}`;
    });
    return uniformShader;
}
function $0533631f1fe2cae9$var$isFlatDispatchLayout(program) {
    if (program.dispatchLayout.hasOwnProperty('y') && program.dispatchLayout.y.length !== 0) return false;
    if (program.dispatchLayout.hasOwnProperty('z') && program.dispatchLayout.z.length !== 0) return false;
    return true;
}


var $8e83a93f95f027c6$exports = {};

$parcel$export($8e83a93f95f027c6$exports, "tilesFitEvenlyIntoShape", () => $8e83a93f95f027c6$export$a32f526834c8fb8a);
$parcel$export($8e83a93f95f027c6$exports, "computeDispatch", () => $8e83a93f95f027c6$export$e8b81faf4b51e34b);
$parcel$export($8e83a93f95f027c6$exports, "computeWorkgroupInfoForMatMul", () => $8e83a93f95f027c6$export$f6bf47abf12e6a8a);
$parcel$export($8e83a93f95f027c6$exports, "computeWorkgroupSizeForConv2d", () => $8e83a93f95f027c6$export$c017ff3929b35682);
$parcel$export($8e83a93f95f027c6$exports, "computeWorkPerThreadForConv2d", () => $8e83a93f95f027c6$export$1f250f140443453c);
$parcel$export($8e83a93f95f027c6$exports, "flatDispatchLayout", () => $8e83a93f95f027c6$export$9f192dff395c74d);
$parcel$export($8e83a93f95f027c6$exports, "GPUBytesPerElement", () => $8e83a93f95f027c6$export$3b5bd9c5c24b50c9);
$parcel$export($8e83a93f95f027c6$exports, "isWebGPUSupported", () => $8e83a93f95f027c6$export$216169f30082c873);
$parcel$export($8e83a93f95f027c6$exports, "assertNotComplex", () => $8e83a93f95f027c6$export$1412c17b2531581a);
$parcel$export($8e83a93f95f027c6$exports, "MatMulProgramType", () => $8e83a93f95f027c6$export$b83d75b9ab62b8b5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $8e83a93f95f027c6$var$arrayProduct = (arr)=>{
    let product = 1;
    for(let i = 0; i < arr.length; i++)product *= arr[i];
    return product;
};
function $8e83a93f95f027c6$export$a32f526834c8fb8a(tileSize, shape) {
    if (tileSize.length !== shape.length) throw new Error(`Cannot compute whether rank ${tileSize.length}` + ` tiles fit evenly into rank ${shape.length} shape` + ` - ranks must match.`);
    return shape.every((dim, dimIdx)=>dim % tileSize[dimIdx] === 0);
}
function $8e83a93f95f027c6$export$e8b81faf4b51e34b(layout, outputShape, workgroupSize = [
    1,
    1,
    1
], elementsPerThread = [
    1,
    1,
    1
]) {
    const [dispatchX, dispatchY, dispatchZ] = [
        Math.ceil($8e83a93f95f027c6$var$arrayProduct(layout.x.map((d)=>outputShape[d])) / (workgroupSize[0] * elementsPerThread[0])),
        layout.y ? Math.ceil($8e83a93f95f027c6$var$arrayProduct(layout.y.map((d)=>outputShape[d])) / (workgroupSize[1] * elementsPerThread[1])) : 1,
        layout.z ? Math.ceil($8e83a93f95f027c6$var$arrayProduct(layout.z.map((d)=>outputShape[d])) / (workgroupSize[2] * elementsPerThread[2])) : 1
    ];
    return [
        dispatchX,
        dispatchY,
        dispatchZ
    ];
}
function $8e83a93f95f027c6$export$f6bf47abf12e6a8a(dimAOuter, dimInner, dimBOuter, transposeA = false) {
    // These are experimental values. Usually, we need to adjust the work group
    // size based on the input shapes to improve the EU occupancy.
    // TODO: WebGPU limits the maximum allowed shared memory size as 16K. To make
    // sure it doesn't exceed this limitations. Temporarily reduce the work group
    // size to [8, 8, 1] and the work per thread size is [4, 4, 1]. But we should
    // revisit it and find the balance between work group size and work per thread
    // size.
    const workgroupSize = [
        8,
        8,
        1
    ];
    const elementsPerThread = [
        4,
        4,
        1
    ];
    if (!transposeA) {
        if (dimAOuter <= 8) elementsPerThread[1] = 1;
        if (dimInner <= 16 && dimBOuter <= 16) workgroupSize[0] = 4;
    }
    return {
        workgroupSize: workgroupSize,
        elementsPerThread: elementsPerThread
    };
}
function $8e83a93f95f027c6$export$c017ff3929b35682(layout, outputShape, isVec4 = false) {
    if (isVec4) return [
        8,
        8,
        1
    ];
    const dim0 = $8e83a93f95f027c6$var$arrayProduct(layout.x.map((d)=>outputShape[d]));
    const dim1 = $8e83a93f95f027c6$var$arrayProduct(layout.y.map((d)=>outputShape[d]));
    // TODO(jiajia.qin@intel.com): More fine tune based on outputShape.
    // These are experimental values. Usually, we need to adjust the work group
    // size based on the output shape. For example, when one dimension is smaller
    // than 4, it will be wasteful if we assign a larger size for this dimension,
    // which results lots of threads doing useless work and reduces parallelism
    // of hardware threads. But it is always a balance between work group size
    // and shared memory. If one dimension is too small, such as 1, shared memory
    // will won't be fully utilized.
    if (dim0 <= 4) return [
        4,
        16,
        1
    ];
    if (dim1 <= 4) return [
        16,
        4,
        1
    ];
    return [
        16,
        16,
        1
    ];
}
function $8e83a93f95f027c6$export$1f250f140443453c(layout, outputShape, isVec4 = false) {
    if (isVec4) return [
        4,
        4,
        1
    ];
    const dim0 = $8e83a93f95f027c6$var$arrayProduct(layout.x.map((d)=>outputShape[d]));
    const dim1 = $8e83a93f95f027c6$var$arrayProduct(layout.y.map((d)=>outputShape[d]));
    // TODO(jiajia.qin@intel.com): More fine tune based on outputShape.
    // The following conditions correspond to the values set in
    // computeWorkgroupSizeForConv2d.
    if (dim0 <= 4) return [
        1,
        2,
        1
    ];
    if (dim1 <= 4) return [
        2,
        1,
        1
    ];
    return [
        2,
        2,
        1
    ];
}
function $8e83a93f95f027c6$export$9f192dff395c74d(shape) {
    return {
        x: shape.map((d, i)=>i)
    };
}
function $8e83a93f95f027c6$export$3b5bd9c5c24b50c9(dtype) {
    if (dtype === 'float32' || dtype === 'int32' || dtype === 'bool' || dtype === 'string') return 4;
    else if (dtype === 'complex64') return 8;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $8e83a93f95f027c6$export$216169f30082c873() {
    return !!(typeof globalThis !== 'undefined' && globalThis.navigator && globalThis.navigator.gpu);
}
function $8e83a93f95f027c6$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $0775da5e684c8c0d$exports).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors ` + 'in the WebGPU backend.');
    });
}
var $8e83a93f95f027c6$export$b83d75b9ab62b8b5;
(function(MatMulProgramType) {
    MatMulProgramType[MatMulProgramType["MatMulReduceProgram"] = 0] = "MatMulReduceProgram";
    MatMulProgramType[MatMulProgramType["MatMulSplitKProgram"] = 1] = "MatMulSplitKProgram";
    MatMulProgramType[MatMulProgramType["MatMulSmallOutputSizeProgram"] = 2] = "MatMulSmallOutputSizeProgram";
    MatMulProgramType[MatMulProgramType["MatMulPackedProgram"] = 3] = "MatMulPackedProgram";
    MatMulProgramType[MatMulProgramType["MatMulMax"] = 4] = "MatMulMax";
})($8e83a93f95f027c6$export$b83d75b9ab62b8b5 || ($8e83a93f95f027c6$export$b83d75b9ab62b8b5 = {}));


// Empirically determined constant used to determine size threshold for handing
// off execution to the CPU.
const $4a4d6f6879225fff$var$CPU_HANDOFF_SIZE_THRESHOLD = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD');
// Reshape dispatch, not to exceed device limits.
const $4a4d6f6879225fff$var$reshapeDispatch = (device, program)=>{
    const MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE = device.limits.maxComputeWorkgroupsPerDimension;
    const layout = program['dispatchLayout'];
    const dispatch = program['dispatch'];
    if (dispatch.every((d)=>d <= MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE)) return dispatch;
    (0, $0775da5e684c8c0d$exports).assert(dispatch[0] > MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE && layout.y === undefined && layout.z === undefined, ()=>'Dispatch size exceeds WebGPU limits in Y or Z dimension.');
    let dispatchAverage = Math.ceil(Math.sqrt(dispatch[0]));
    if (dispatchAverage > MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE) {
        dispatchAverage = Math.ceil(Math.cbrt(dispatch[0]));
        (0, $0775da5e684c8c0d$exports).assert(dispatchAverage <= MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE, ()=>'Total dispatch size exceeds WebGPU maximum.');
        return [
            dispatchAverage,
            dispatchAverage,
            dispatchAverage
        ];
    } else return [
        dispatchAverage,
        dispatchAverage,
        1
    ];
};
class $4a4d6f6879225fff$export$6f9bc39baf8c093a extends (0, $0f11f47888a734c2$export$543916c62202b50a) {
    nextDataId() {
        return $4a4d6f6879225fff$export$6f9bc39baf8c093a.nextDataId++;
    }
    constructor(device, adapterInfo){
        super();
        this.commandQueueOwnedIds = new WeakSet();
        this.dispatchCountInPass = 0;
        this.disposed = false;
        this.downloadWaitMs = 0;
        this.tensorDataPendingDisposal = [];
        this.queryResolveBuffer = null;
        this.querySet = null;
        this.querySetCount = 2;
        this.stagingPendingDisposal = [];
        this.uniformPendingDisposal = [];
        this.uploadWaitMs = 0;
        this.hasReadSyncWarned = false;
        this.hasTimestampQueryWarned = false;
        if (!$8e83a93f95f027c6$export$216169f30082c873()) throw new Error('WebGPU is not supported on this device');
        this.pipelineCache = {};
        this.device = device;
        this.queue = device.queue;
        this.commandEncoder = null;
        this.computePassEncoder = null;
        this.adapterInfo = new (0, $d22002f016172b6d$export$addafb2fcad183eb)(adapterInfo);
        this.supportTimestampQuery = this.device.features.has('timestamp-query');
        this.thresholdToIncreaseWorkgroups = this.adapterInfo.intelGPUGeneration >= 12 ? 16 : 8;
        this.bufferManager = new (0, $aeebb474468a7549$export$f9938eb95a77a185)(this.device);
        this.textureManager = new (0, $60b14d26a2a93dd4$export$337f59f8fd79d24f)(this.device);
        this.tensorMap = new (0, $0f11f47888a734c2$export$e95767ffe2e60cec)(this, (0, $8a461ef06e070cc9$export$d3c662a6136faebb)());
        // Profiling tools like PIX needs this dummy canvas to
        // trigger capturing a frame.
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_USE_PROFILE_TOOL')) {
            this.dummyCanvas = document.createElement('canvas');
            this.dummyCanvas.width = 1;
            this.dummyCanvas.height = 1;
            this.dummyContext = this.dummyCanvas.getContext('webgpu');
            this.dummyContext.configure({
                device: device,
                format: 'bgra8unorm'
            });
            document.body.appendChild(this.dummyCanvas);
        }
    }
    floatPrecision() {
        return 32;
    }
    /**
     * Dispose the memory if the dataId has 0 refCount. Return true if the memory
     * is released or delayed in this backend, false if there are still
     * references.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        // No-op if already disposed.
        if (!this.tensorMap.has(dataId)) return true;
        const tensorData = this.tensorMap.get(dataId);
        if (force) tensorData.refCount = 0;
        else tensorData.refCount--;
        if (tensorData.refCount > 0) return false;
        if (tensorData.complexTensorInfos != null) {
            this.disposeData(tensorData.complexTensorInfos.real.dataId);
            this.disposeData(tensorData.complexTensorInfos.imag.dataId);
        }
        if (this.commandQueueOwnedIds.has(dataId)) {
            this.tensorDataPendingDisposal.push(dataId);
            return true;
        }
        this.releaseResource(dataId);
        this.tensorMap.delete(dataId);
        return true;
    }
    memory() {
        return {
            numBytesInGPU: this.bufferManager.numBytesUsed,
            numBytesAllocatedInGPU: this.bufferManager.numBytesAllocated,
            unreliable: false
        };
    }
    releaseResource(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        if (!tensorData || !tensorData.resource) return;
        // If tensor's resource is from external, do not release.
        if (tensorData.external) {
            tensorData.resource = null;
            return;
        }
        if (tensorData.resource instanceof GPUBuffer) this.bufferManager.releaseBuffer(tensorData.resource);
        else if (tensorData.resource instanceof GPUTexture) this.textureManager.releaseTexture(tensorData.resource);
        tensorData.resource = null;
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.tensorMap.has(dataId)) {
            const tensorData = this.tensorMap.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TensorData`. */ incRef(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        tensorData.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */ decRef(dataId) {
        if (this.tensorMap.has(dataId)) {
            const tensorData = this.tensorMap.get(dataId);
            tensorData.refCount--;
        }
    }
    write(values, shape, dtype) {
        if (dtype === 'complex64' && values != null) throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        const dataId = {
            id: this.nextDataId()
        };
        this.tensorMap.set(dataId, {
            dtype: dtype,
            shape: shape,
            values: values,
            refCount: 1
        });
        return dataId;
    }
    move(dataId, values, shape, dtype, refCount) {
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        this.tensorMap.set(dataId, {
            dtype: dtype,
            shape: shape,
            values: values,
            refCount: refCount
        });
    }
    submitQueue() {
        this.queue.submit([
            this.commandEncoder.finish()
        ]);
        this.commandEncoder = null;
        this.dispatchCountInPass = 0;
        this.commandQueueOwnedIds = new WeakSet();
        this.tensorDataPendingDisposal.forEach((d)=>{
            this.releaseResource(d);
            this.tensorMap.delete(d);
        });
        this.uniformPendingDisposal.forEach((b)=>this.bufferManager.releaseBuffer(b));
        this.stagingPendingDisposal.forEach((b)=>this.bufferManager.releaseBuffer(b, false));
        this.tensorDataPendingDisposal = [];
        this.uniformPendingDisposal = [];
        this.stagingPendingDisposal = [];
    }
    ensureCommandEncoderReady() {
        if (!this.commandEncoder) this.commandEncoder = this.device.createCommandEncoder();
    }
    endComputePassEncoder() {
        if (this.computePassEncoder) {
            this.computePassEncoder.end();
            this.computePassEncoder = null;
        }
    }
    // Check if parallel compilation is done.
    async checkCompileCompletionAsync() {
        let pipelines;
        try {
            pipelines = await Promise.all(Object.values(this.pipelineCache));
        } catch (e) {
            // TODO: Add test case to catch this exception.
            throw new Error(e.message);
        }
        Object.keys(this.pipelineCache).map((key, i)=>{
            this.pipelineCache[key] = pipelines[i];
        });
    }
    async getBufferData(buffer) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_ENGINE_COMPILE_ONLY')) {
            console.warn('The data may be invalid since WEBGPU_ENGINE_COMPILE_ONLY is true, this can only be called when WEBGPU_ENGINE_COMPILE_ONLY is false');
            return null;
        }
        const size = buffer.size;
        const stagingBuffer = this.bufferManager.acquireBuffer(size, GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ);
        this.ensureCommandEncoderReady();
        this.endComputePassEncoder();
        this.commandEncoder.copyBufferToBuffer(buffer, 0, stagingBuffer, 0, size);
        this.submitQueue();
        await stagingBuffer.mapAsync(GPUMapMode.READ);
        const values = stagingBuffer.getMappedRange().slice(0);
        stagingBuffer.unmap();
        if (stagingBuffer != null) this.bufferManager.releaseBuffer(stagingBuffer);
        // Need to get texture from swapChain to enable profiling tool
        // to capture a frame
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_USE_PROFILE_TOOL')) {
            (0, $0775da5e684c8c0d$exports).assert(this.dummyContext !== undefined, ()=>`Fail to get context for profiling tool`);
            this.dummyContext.getCurrentTexture();
        }
        return values;
    }
    convertAndCacheOnCPU(dataId, data) {
        const tensorData = this.tensorMap.get(dataId);
        tensorData.values = data;
        return tensorData.values;
    }
    readSync(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        const { values: values, complexTensorInfos: complexTensorInfos } = tensorData;
        if (values != null || tensorData.dtype === 'string') return values;
        if (tensorData.dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            const complexVals = (0, $0775da5e684c8c0d$exports).convertBackendValuesAndArrayBuffer((0, $f35e0c1a651337db$exports).mergeRealAndImagArrays(realValues, imagValues).buffer, 'float32');
            this.convertAndCacheOnCPU(dataId, complexVals);
            return complexVals;
        }
        if (!this.hasReadSyncWarned) {
            this.hasReadSyncWarned = true;
            console.warn(`The performance of synchronously reading data from GPU to CPU is ` + `poor on the webgpu backend, please use asynchronous APIs instead.`);
        }
        const alphaModes = [
            'opaque',
            'premultiplied'
        ];
        const buffer = tensorData.resource;
        const bufferSize = buffer.size;
        (0, $0775da5e684c8c0d$exports).assert(bufferSize % 4 === 0, ()=>"Because there is 4 bytes for one pixel, buffer size must be multiple of 4.");
        const pixelsSize = bufferSize / 4;
        const valsGPU = new ArrayBuffer(bufferSize);
        // TODO: adjust the reading window size according the `bufferSize`.
        const canvasWidth = 256, canvasHeight = 256;
        const stagingDeviceStorage = alphaModes.map((_)=>new OffscreenCanvas(canvasWidth, canvasHeight));
        const stagingHostStorage = new OffscreenCanvas(canvasWidth, canvasHeight);
        this.endComputePassEncoder();
        stagingDeviceStorage.map((storage, index)=>{
            const context = storage.getContext('webgpu');
            // TODO: use rgba8unorm format when this format is supported on Mac.
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1298618
            context.configure({
                device: this.device,
                format: 'bgra8unorm',
                usage: GPUTextureUsage.COPY_DST,
                alphaMode: alphaModes[index]
            });
            return context.getCurrentTexture();
        }).map((texture, index)=>{
            const bytesPerRow = canvasWidth * 4;
            const readDataGPUToCPU = (width, height, offset)=>{
                this.ensureCommandEncoderReady();
                this.commandEncoder.copyBufferToTexture({
                    buffer: buffer,
                    bytesPerRow: bytesPerRow,
                    offset: offset
                }, {
                    texture: texture
                }, {
                    width: width,
                    height: height
                });
                this.submitQueue();
                const context = stagingHostStorage.getContext('2d', {
                    willReadFrequently: true
                });
                context.clearRect(0, 0, width, height);
                context.drawImage(stagingDeviceStorage[index], 0, 0);
                const stagingValues = context.getImageData(0, 0, width, height).data;
                const alphaMode = alphaModes[index];
                const span = new Uint8ClampedArray(valsGPU, offset, width * height * 4);
                for(let k = 0; k < span.length; k += 4)if (alphaMode === 'premultiplied') span[k + 3] = stagingValues[k + 3];
                else {
                    const value = stagingValues[k];
                    span[k] = stagingValues[k + 2];
                    span[k + 1] = stagingValues[k + 1];
                    span[k + 2] = value;
                }
            };
            const fullyReadCount = Math.floor(pixelsSize / (canvasWidth * canvasHeight));
            let width = canvasWidth, height = canvasHeight, offset = 0;
            for(let i = 0; i < fullyReadCount; i++){
                // Read the buffer data, which fully fill the whole canvas.
                readDataGPUToCPU(width, height, offset);
                offset += canvasWidth * canvasHeight * 4;
            }
            const remainSize = pixelsSize % (canvasWidth * canvasHeight);
            height = Math.floor(remainSize / canvasWidth);
            if (height > 0) {
                // Read the buffer data, which fully fill certain rows of canvas.
                readDataGPUToCPU(width, height, offset);
                offset += height * (canvasWidth * 4);
            }
            width = remainSize % canvasWidth;
            if (width > 0) // Read the buffer data, which not fully fill one row of canvas.
            readDataGPUToCPU(width, 1, offset);
        });
        const vals = (0, $0775da5e684c8c0d$exports).convertBackendValuesAndArrayBuffer(valsGPU, tensorData.dtype);
        this.convertAndCacheOnCPU(dataId, vals);
        return vals;
    }
    async read(dataId) {
        if (!this.tensorMap.has(dataId)) throw new Error(`Tensor ${dataId} was not registered!`);
        const tensorData = this.tensorMap.get(dataId);
        const { values: values } = tensorData;
        if (values != null) return values;
        // Download the values from the GPU.
        let vals;
        if (tensorData.dtype === 'complex64') {
            const ps = await Promise.all([
                this.read(tensorData.complexTensorInfos.real.dataId),
                this.read(tensorData.complexTensorInfos.imag.dataId)
            ]);
            const realValues = ps[0];
            const imagValues = ps[1];
            vals = (0, $f35e0c1a651337db$exports).mergeRealAndImagArrays(realValues, imagValues);
        } else {
            const data = await this.getBufferData(tensorData.resource);
            vals = (0, $0775da5e684c8c0d$exports).convertBackendValuesAndArrayBuffer(data, tensorData.dtype);
        }
        this.convertAndCacheOnCPU(dataId, vals);
        return vals;
    }
    // The source GPUBuffer and destination GPUBuffer have the same size and
    // usage.
    copyBuffer(srcBuffer) {
        const size = srcBuffer.size;
        const usage = srcBuffer.usage;
        const dstBuffer = this.bufferManager.acquireBuffer(size, usage);
        this.ensureCommandEncoderReady();
        this.endComputePassEncoder();
        this.commandEncoder.copyBufferToBuffer(srcBuffer, 0, dstBuffer, 0, size);
        this.submitQueue();
        return dstBuffer;
    }
    /**
     * Create a TF.js tensor out of an existing WebGPU buffer.
     */ createTensorFromGPUData(webGPUData, shape, dtype) {
        let buffer = webGPUData.buffer;
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. `);
        const dataId = {
            id: this.nextDataId()
        };
        this.tensorMap.set(dataId, {
            dtype: dtype,
            shape: shape,
            values: null,
            refCount: 1,
            external: webGPUData.zeroCopy
        });
        const tensorData = this.tensorMap.get(dataId);
        const size = $8e83a93f95f027c6$export$3b5bd9c5c24b50c9(tensorData.dtype) * (0, $0775da5e684c8c0d$exports).sizeFromShape(tensorData.shape);
        if (webGPUData.buffer.size < size) throw new Error(`GPUBuffer size(${webGPUData.buffer.size}) is smaller than tensor size(${size})!`);
        else if ((webGPUData.buffer.usage & (GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC)) !== (GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC)) throw new Error('GPUBuffer.usage should include GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC!');
        // Do buffer copy by default.
        if (webGPUData.zeroCopy !== true) buffer = this.copyBuffer(buffer);
        tensorData.resource = buffer;
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromDataId(dataId, shape, dtype, this);
    }
    /**
     * Read tensor to a new GPUBuffer.
     * @param dataId The source tensor.
     */ readToGPU(dataId) {
        const srcTensorData = this.tensorMap.get(dataId);
        const { values: values, dtype: dtype, shape: shape, resource: resource } = srcTensorData;
        if (dtype === 'complex64') throw new Error('Does not support reading buffer for complex64 dtype.');
        if (resource == null) {
            if (values != null) throw new Error('Data is not on GPU but on CPU.');
            else throw new Error('There is no data on GPU or CPU.');
        }
        const srcBuffer = resource;
        const size = srcBuffer.size;
        const usage = srcBuffer.usage;
        const buffer = this.bufferManager.acquireBuffer(size, usage);
        this.ensureCommandEncoderReady();
        this.endComputePassEncoder();
        this.commandEncoder.copyBufferToBuffer(resource, 0, buffer, 0, size);
        this.submitQueue();
        const tensorInfo = this.makeTensorInfo(shape, dtype);
        // Make engine track this tensor, so that we can dispose it later.
        const tensorRef = (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(tensorInfo);
        const tensorData = this.tensorMap.get(tensorInfo.dataId);
        tensorData.resource = buffer;
        return {
            tensorRef: tensorRef,
            buffer: buffer
        };
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $0775da5e684c8c0d$exports).decodeString(d));
            return (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(t.shape, t.dtype, data);
    }
    async time(f) {
        if (!this.supportTimestampQuery && !this.hasTimestampQueryWarned) {
            console.warn(`This device doesn't support timestamp-query extension. ` + `Start Chrome browser with flag ` + `--enable-dawn-features=allow_unsafe_apis to try it again. ` + `Otherwise, zero will be shown for the kernel time when profiling ` + `mode is enabled.`);
            this.hasTimestampQueryWarned = true;
        }
        const oldActiveTimers = this.activeTimers;
        const newActiveTimers = [];
        let outerMostTime = false;
        if (this.programTimersStack == null) {
            this.programTimersStack = newActiveTimers;
            outerMostTime = true;
        } else this.activeTimers.push(newActiveTimers);
        this.activeTimers = newActiveTimers;
        f();
        const flattenedActiveTimerQueries = (0, $0775da5e684c8c0d$exports).flatten(this.activeTimers.map((d)=>d.query)).filter((d)=>d != null);
        const flattenedActiveTimerNames = (0, $0775da5e684c8c0d$exports).flatten(this.activeTimers.map((d)=>d.name)).filter((d)=>d != null);
        this.activeTimers = oldActiveTimers;
        if (outerMostTime) this.programTimersStack = null;
        const res = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null
        };
        const kernelMs = await Promise.all(flattenedActiveTimerQueries);
        res['kernelMs'] = (0, $0775da5e684c8c0d$exports).sum(kernelMs);
        res['getExtraProfileInfo'] = ()=>kernelMs.map((d, i)=>({
                    name: flattenedActiveTimerNames[i],
                    ms: d
                })).map((d)=>`${d.name}: ${d.ms}`).join(', ');
        this.uploadWaitMs = 0;
        this.downloadWaitMs = 0;
        return res;
    }
    makeTensorInfo(shape, dtype, values) {
        if (dtype === 'string' && values != null && values.length > 0 && (0, $0775da5e684c8c0d$exports).isString(values[0])) values = values.map((d)=>(0, $0775da5e684c8c0d$exports).encodeString(d));
        const dataId = this.write(values, shape, dtype);
        return {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
    }
    tensorToBinding(tensor) {
        if (!tensor) return null;
        const tensorData = this.tensorMap.get(tensor.dataId);
        const resource = tensorData.resource;
        if (resource instanceof GPUBuffer) return {
            buffer: resource
        };
        if (resource instanceof GPUTexture) return resource.createView();
        // GPUExternalTexture
        return resource;
    }
    uploadToGPU(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        // Already on the GPU.
        if (tensorData.resource != null) return;
        const size = $8e83a93f95f027c6$export$3b5bd9c5c24b50c9(tensorData.dtype) * (0, $0775da5e684c8c0d$exports).sizeFromShape(tensorData.shape);
        let buffer;
        const usage = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST;
        if (tensorData.values) {
            buffer = this.bufferManager.acquireBuffer(size, usage, true);
            if (buffer.mapState === 'unmapped') {
                const stagingBuffer = this.bufferManager.acquireBuffer(size, GPUBufferUsage.MAP_WRITE | GPUBufferUsage.COPY_SRC, true, false);
                const arrayBuffer = stagingBuffer.getMappedRange();
                if (tensorData.dtype === 'int32' || tensorData.dtype === 'bool') new Int32Array(arrayBuffer).set(tensorData.values);
                else new Float32Array(arrayBuffer).set(tensorData.values);
                stagingBuffer.unmap();
                this.ensureCommandEncoderReady();
                this.endComputePassEncoder();
                this.commandEncoder.copyBufferToBuffer(stagingBuffer, 0, buffer, 0, size);
                this.stagingPendingDisposal.push(stagingBuffer);
            } else {
                const arrayBuffer = buffer.getMappedRange();
                if (tensorData.dtype === 'int32' || tensorData.dtype === 'bool') new Int32Array(arrayBuffer).set(tensorData.values);
                else new Float32Array(arrayBuffer).set(tensorData.values);
                buffer.unmap();
            }
            // Once uploaded, don't store the values on cpu.
            tensorData.values = null;
        } else buffer = this.bufferManager.acquireBuffer(size, usage);
        tensorData.resource = buffer;
    }
    makeUniforms(programUniform) {
        let currentOffset = 0;
        let preLength = 0;
        const offsets = [];
        let maxAlignmentOfField = 1;
        programUniform.forEach((d)=>{
            if (d.data.length === 0) d.data = [
                1
            ];
            // https://www.w3.org/TR/WGSL/#alignof
            let baseAlignment;
            switch(d.data.length){
                case 1:
                    baseAlignment = 4;
                    break;
                case 2:
                    baseAlignment = 8;
                    break;
                case 3:
                    baseAlignment = 16;
                    break;
                case 4:
                    baseAlignment = 16;
                    break;
                case 5:
                    baseAlignment = 16;
                    break;
                case 6:
                    baseAlignment = 16;
                    break;
                default:
                    (0, $0775da5e684c8c0d$exports).assert(false, ()=>`Unsupported ${d.data.length}D shape`);
            }
            if (preLength === 5 || preLength === 6) baseAlignment = 16;
            if (baseAlignment > maxAlignmentOfField) maxAlignmentOfField = baseAlignment;
            currentOffset = Math.ceil(currentOffset / baseAlignment) * baseAlignment;
            preLength = d.data.length;
            offsets.push(currentOffset);
            currentOffset += d.data.length * 4;
        });
        currentOffset = Math.ceil(currentOffset / maxAlignmentOfField) * maxAlignmentOfField;
        const arrayBuffer = new ArrayBuffer(currentOffset);
        programUniform.forEach((d, i)=>{
            const offset = offsets[i];
            if (d.type === 'int32') new Int32Array(arrayBuffer, offset, d.data.length).set(d.data);
            else if (d.type === 'uint32') new Uint32Array(arrayBuffer, offset, d.data.length).set(d.data);
            else new Float32Array(arrayBuffer, offset, d.data.length).set(d.data);
        });
        const uniformBuffer = this.bufferManager.acquireBuffer(currentOffset, GPUBufferUsage.COPY_DST | GPUBufferUsage.UNIFORM);
        this.queue.writeBuffer(uniformBuffer, 0, arrayBuffer, 0, currentOffset);
        this.uniformPendingDisposal.push(uniformBuffer);
        return {
            offset: 0,
            size: currentOffset,
            buffer: uniformBuffer
        };
    }
    runWebGPUProgram(program, inputs, outputDtype, programDefinedUniform, output) {
        if (!output) output = this.makeTensorInfo(program.outputShape, outputDtype);
        if ((0, $0775da5e684c8c0d$exports).sizeFromShape(output.shape) === 0) {
            // Short-circuit the computation since the result is empty (has 0 in its
            // shape).
            this.tensorMap.get(output.dataId).values = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType(output.dtype, 0);
            return output;
        }
        this.uploadToGPU(output.dataId);
        program.dispatch = $4a4d6f6879225fff$var$reshapeDispatch(this.device, program);
        const inputsData = inputs.map((input, i)=>{
            if (input.dtype === 'complex64') throw new Error(`GPGPUProgram does not support complex64 input. For complex64 ` + `dtypes, please separate the program into real and imaginary ` + `parts.`);
            this.uploadToGPU(input.dataId);
            return {
                // Returning dtype from tensorMap because it reflects dtype
                // of underlying buffer, rather than abstract dtype.
                dtype: this.tensorMap.get(input.dataId).dtype,
                shape: input.shape,
                name: program.variableNames[i]
            };
        });
        program.shaderKey = $0533631f1fe2cae9$export$2a17a6d53fe6f5d9(program, inputsData, output);
        const parallelCompilation = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_ENGINE_COMPILE_ONLY');
        if (!(program.shaderKey in this.pipelineCache)) this.pipelineCache[program.shaderKey] = $0533631f1fe2cae9$export$5ca2cb6073dd12df(this.device, program, inputsData, output, parallelCompilation);
        program.pipeline = this.pipelineCache[program.shaderKey];
        if (!parallelCompilation) this.recordAndSubmit(program, output, inputs, programDefinedUniform);
        return output;
    }
    recordAndSubmit(program, output, inputs, programDefinedUniform) {
        if (program.pipeline instanceof Promise) throw new Error('Please call checkCompileCompletionAsync to ensure parallel compilation is done!');
        // There are six kinds of uniforms: NAN, INFINITY, shapes, shape strides,
        // program size, program defined uniforms.
        let programUniform = [];
        let bufferShapes = [];
        const uniformsType = 'int32';
        if (program.pixelsOpType == null) {
            programUniform.push({
                type: 'float32',
                data: [
                    NaN
                ]
            }, {
                type: 'float32',
                data: [
                    Infinity
                ]
            });
            bufferShapes = inputs.concat(output).map((d)=>d.shape);
            const uniformsType = 'int32';
            bufferShapes.map((d)=>{
                programUniform.push({
                    type: uniformsType,
                    data: d
                });
                const strides = (0, $0775da5e684c8c0d$exports).computeStrides(d);
                programUniform.push({
                    type: uniformsType,
                    data: strides
                });
            });
        } else {
            const strides = (0, $0775da5e684c8c0d$exports).computeStrides(output.shape);
            programUniform.push({
                type: uniformsType,
                data: strides
            });
        }
        if (program.size) {
            const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(program.outputShape);
            programUniform.push({
                type: uniformsType,
                data: [
                    program.outputComponent ? size / program.outputComponent : size
                ]
            });
        }
        if (programDefinedUniform) programUniform = [
            ...programUniform,
            ...programDefinedUniform
        ];
        const bindings = [
            this.tensorToBinding(output),
            ...inputs.map((t)=>this.tensorToBinding(t)),
            this.makeUniforms(programUniform)
        ];
        inputs.forEach((input)=>{
            this.commandQueueOwnedIds.add(input.dataId);
        });
        this.commandQueueOwnedIds.add(output.dataId);
        const bindGroup = this.device.createBindGroup({
            layout: program.pipeline.getBindGroupLayout(0),
            entries: bindings.map((b, i)=>({
                    binding: i,
                    resource: b
                }))
        });
        const shouldTimeProgram = this.activeTimers != null;
        this.ensureCommandEncoderReady();
        const computePassDescriptor = {};
        if (shouldTimeProgram && this.supportTimestampQuery) {
            this.endComputePassEncoder();
            if (this.querySet == null) this.querySet = this.device.createQuerySet({
                type: 'timestamp',
                count: this.querySetCount
            });
            computePassDescriptor.timestampWrites = {
                querySet: this.querySet,
                beginningOfPassWriteIndex: 0,
                endOfPassWriteIndex: 1
            };
            this.computePassEncoder = this.commandEncoder.beginComputePass(computePassDescriptor);
        } else if (!this.computePassEncoder) this.computePassEncoder = this.commandEncoder.beginComputePass(computePassDescriptor);
        this.computePassEncoder.setPipeline(program.pipeline);
        this.computePassEncoder.setBindGroup(0, bindGroup);
        this.computePassEncoder.dispatchWorkgroups(program.dispatch[0], program.dispatch[1], program.dispatch[2]);
        this.dispatchCountInPass++;
        if (shouldTimeProgram || (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGPU_DEFERRED_SUBMIT_BATCH_SIZE') <= this.dispatchCountInPass || program.pixelsOpType === $0533631f1fe2cae9$export$62104db1eb296622.DRAW) {
            this.endComputePassEncoder();
            if (shouldTimeProgram) this.activeTimers.push({
                name: program.constructor.name,
                query: this.getQueryTime()
            });
            else this.submitQueue();
        }
    }
    async getQueryTime() {
        if (!this.supportTimestampQuery) return 0;
        if (this.queryResolveBuffer == null) this.queryResolveBuffer = this.bufferManager.acquireBuffer(this.querySetCount * 8, GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST | GPUBufferUsage.QUERY_RESOLVE);
        this.commandEncoder.resolveQuerySet(this.querySet, 0, this.querySetCount, this.queryResolveBuffer, 0);
        const queryStagingBuffer = this.bufferManager.acquireBuffer(this.querySetCount * 8, GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST);
        this.commandEncoder.copyBufferToBuffer(this.queryResolveBuffer, 0, queryStagingBuffer, 0, this.querySetCount * 8);
        this.submitQueue();
        await queryStagingBuffer.mapAsync(GPUMapMode.READ);
        const arrayBuffer = new BigUint64Array(queryStagingBuffer.getMappedRange());
        const time = Number(arrayBuffer[1] - arrayBuffer[0]) / 1000000;
        queryStagingBuffer.unmap();
        this.bufferManager.releaseBuffer(queryStagingBuffer);
        return time;
    }
    shouldExecuteOnCPU(inputs, sizeThreshold = $4a4d6f6879225fff$var$CPU_HANDOFF_SIZE_THRESHOLD) {
        return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_CPU_FORWARD') && inputs.every((input)=>this.tensorMap.get(input.dataId).resource == null && (0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape) < sizeThreshold);
    }
    numDataIds() {
        return this.tensorMap.numDataIds() - this.tensorDataPendingDisposal.length;
    }
    dispose() {
        if (this.disposed) return;
        if (this.querySet != null) this.querySet.destroy();
        this.bufferManager.dispose();
        this.textureManager.dispose();
        this.disposed = true;
    }
}
$4a4d6f6879225fff$export$6f9bc39baf8c093a.nextDataId = 0;



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



if ((0, $8e83a93f95f027c6$export$216169f30082c873)()) (0, $8a461ef06e070cc9$export$1ac8c3a90eff05d)('webgpu', async ()=>{
    const gpuDescriptor = {
        powerPreference: (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGPU_USE_LOW_POWER_GPU') ? 'low-power' : 'high-performance'
    };
    const adapter = await navigator.gpu.requestAdapter(gpuDescriptor);
    const deviceDescriptor = {};
    const requiredFeatures = [];
    if (adapter.features.has('timestamp-query')) requiredFeatures.push('timestamp-query');
    if (adapter.features.has('bgra8unorm-storage')) requiredFeatures.push([
        'bgra8unorm-storage'
    ]);
    deviceDescriptor.requiredFeatures = requiredFeatures;
    const adapterLimits = adapter.limits;
    deviceDescriptor.requiredLimits = {
        'maxComputeWorkgroupStorageSize': adapterLimits.maxComputeWorkgroupStorageSize,
        'maxComputeWorkgroupsPerDimension': adapterLimits.maxComputeWorkgroupsPerDimension,
        'maxStorageBufferBindingSize': adapterLimits.maxStorageBufferBindingSize,
        'maxBufferSize': adapterLimits.maxBufferSize,
        'maxComputeWorkgroupSizeX': adapterLimits.maxComputeWorkgroupSizeX,
        'maxComputeInvocationsPerWorkgroup': adapterLimits.maxComputeInvocationsPerWorkgroup
    };
    const device = await adapter.requestDevice(deviceDescriptor);
    const adapterInfo = 'info' in adapter ? adapter.info : 'requestAdapterInfo' in adapter ? await adapter.requestAdapterInfo() : undefined;
    return new (0, $4a4d6f6879225fff$export$6f9bc39baf8c093a)(device, adapterInfo);
}, 3 /*priority*/ );


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $41dab11c37c6072e$export$e5d009af261ea0bd;
(function(BinaryOpType) {
    BinaryOpType[BinaryOpType["ADD"] = 0] = "ADD";
    BinaryOpType[BinaryOpType["ATAN2"] = 1] = "ATAN2";
    BinaryOpType[BinaryOpType["COMPLEX_MULTIPLY_IMAG"] = 2] = "COMPLEX_MULTIPLY_IMAG";
    BinaryOpType[BinaryOpType["COMPLEX_MULTIPLY_REAL"] = 3] = "COMPLEX_MULTIPLY_REAL";
    BinaryOpType[BinaryOpType["DIV"] = 4] = "DIV";
    BinaryOpType[BinaryOpType["ELU_DER"] = 5] = "ELU_DER";
    BinaryOpType[BinaryOpType["EQUAL"] = 6] = "EQUAL";
    BinaryOpType[BinaryOpType["FLOOR_DIV"] = 7] = "FLOOR_DIV";
    BinaryOpType[BinaryOpType["GREATER"] = 8] = "GREATER";
    BinaryOpType[BinaryOpType["GREATER_EQUAL"] = 9] = "GREATER_EQUAL";
    BinaryOpType[BinaryOpType["LESS"] = 10] = "LESS";
    BinaryOpType[BinaryOpType["LESS_EQUAL"] = 11] = "LESS_EQUAL";
    BinaryOpType[BinaryOpType["LOGICAL_AND"] = 12] = "LOGICAL_AND";
    BinaryOpType[BinaryOpType["LOGICAL_OR"] = 13] = "LOGICAL_OR";
    BinaryOpType[BinaryOpType["MAX"] = 14] = "MAX";
    BinaryOpType[BinaryOpType["MIN"] = 15] = "MIN";
    BinaryOpType[BinaryOpType["MOD"] = 16] = "MOD";
    BinaryOpType[BinaryOpType["MUL"] = 17] = "MUL";
    BinaryOpType[BinaryOpType["NOT_EQUAL"] = 18] = "NOT_EQUAL";
    BinaryOpType[BinaryOpType["POW"] = 19] = "POW";
    BinaryOpType[BinaryOpType["PRELU"] = 20] = "PRELU";
    BinaryOpType[BinaryOpType["SQUARED_DIFFERENCE"] = 21] = "SQUARED_DIFFERENCE";
    BinaryOpType[BinaryOpType["SUB"] = 22] = "SUB";
})($41dab11c37c6072e$export$e5d009af261ea0bd || ($41dab11c37c6072e$export$e5d009af261ea0bd = {}));
const $41dab11c37c6072e$var$ADD = 'let resultTemp = a + b;';
const $41dab11c37c6072e$var$ATAN2 = 'let resultTemp = atan2(a, b);';
// (Ar + Ai)(Br + Bi) =
// ArBr + ArBi + AiBr + AiBi = ArBr - AB + ArBi + AiBr
// Yr = ArBr - AB
// Yi = ArBi + AiBr
const $41dab11c37c6072e$var$COMPLEX_MULTIPLY_REAL = 'let resultTemp = areal * breal - aimag * bimag;';
const $41dab11c37c6072e$var$COMPLEX_MULTIPLY_IMAG = 'let resultTemp = areal * bimag + aimag * breal;';
const $41dab11c37c6072e$var$DIV = 'let resultTemp = a / b;';
const $41dab11c37c6072e$var$ELU_DER = 'let resultTemp = select(a * (b + 1.0), a, b >= b - b);';
const $41dab11c37c6072e$var$EQUAL = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a == b);
`;
const $41dab11c37c6072e$var$FLOOR_DIV = `
  let remainder =
      select(a % b, round(a % b), (round(a) == a) & (round(b) == b));
  let quotient = (a - remainder) / b;
  let resultTemp =
      round(select(quotient, quotient - 1, sign(remainder) == -sign(b)));
`;
const $41dab11c37c6072e$var$GREATER = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a > b);
`;
const $41dab11c37c6072e$var$GREATER_EQUAL = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a >= b);
`;
const $41dab11c37c6072e$var$LESS = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a < b);
`;
const $41dab11c37c6072e$var$LESS_EQUAL = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a <= b);
`;
const $41dab11c37c6072e$var$LOGICAL_AND = 'return f32(a >= 1.0 && b >= 1.0);';
const $41dab11c37c6072e$var$LOGICAL_AND_VEC4 = `return (vec4<f32>(a >= vec4<f32>(1.0)) *
  vec4<f32>(b >= vec4<f32>(1.0)));`;
const $41dab11c37c6072e$var$LOGICAL_OR = 'return f32(a >= 1.0 || b >= 1.0);';
const $41dab11c37c6072e$var$LOGICAL_OR_VEC4 = `return min(vec4<f32>(a >= vec4<f32>(1.0)) +
  vec4<f32>(b >= vec4<f32>(1.0)), vec4<f32>(1.0));`;
const $41dab11c37c6072e$var$MAX = 'let resultTemp = max(a, b);';
const $41dab11c37c6072e$var$MIN = 'let resultTemp = min(a, b);';
const $41dab11c37c6072e$var$MOD = `
  let isNaN = b == 0.;
  var resultTemp = a % b;
  resultTemp = select((resultTemp + b) % b, resultTemp,
      (a < 0. && b < 0.) || (a >= 0. && b > 0.));
`;
const $41dab11c37c6072e$var$MOD_VEC4 = `
  let isNaN = !vec4<bool>(b);
  var resultTemp = vec4<f32>(a % b);
  if (!((a[0] < 0. && b[0] < 0.) || (a[0] >= 0. && b[0] > 0.))) {
    resultTemp[0] = (resultTemp[0] + b[0]) % b[0];
  }
  if (!((a[1] < 0. && b[1] < 0.) || (a[1] >= 0. && b[1] > 0.))) {
    resultTemp[1] = (resultTemp[1] + b[1]) % b[1];
  }
  if (!((a[2] < 0. && b[2] < 0.) || (a[2] >= 0. && b[2] > 0.))) {
    resultTemp[2] = (resultTemp[2] + b[2]) % b[2];
  }
  if (!((a[3] < 0. && b[3] < 0.) || (a[3] >= 0. && b[3] > 0.))) {
    resultTemp[3] = (resultTemp[3] + b[3]) % b[3];
  }
`;
const $41dab11c37c6072e$var$MUL = 'let resultTemp = a * b;';
const $41dab11c37c6072e$var$NOT_EQUAL = `
  var resultTemp = f32(a != b);
  let valueForNaN = 1.0;
`;
const $41dab11c37c6072e$var$NOT_EQUAL_VEC4 = `
  var resultTemp = vec4<f32>(a != b);
  let valueForNaN = 1.0;
`;
const $41dab11c37c6072e$var$POW = `
  let isNaN = a < 0.0 && floor(b) < b;
  if (b == 0.0) {
    return 1.0;
  }
  var resultTemp = select(sign(a) * pow(abs(a), b), pow(abs(a), b),
      round(abs(b) % 2.0) != 1.0);
`;
const $41dab11c37c6072e$var$POW_VEC4 = `
  let isModRound1Bool = vec4<i32>(round(abs(b) % vec4<f32>(2.0))) == vec4<i32>(1);
  let isModRound1 = vec4<f32>(isModRound1Bool);
  let multiplier = sign(a) * isModRound1 + (vec4<f32>(1.0) - isModRound1);
  var resultTemp = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  let isExpZero = b == vec4<f32>(0.0);
  if (isExpZero.r) {
    resultTemp.r = 1.0;
  }
  if (isExpZero.g) {
    resultTemp.g = 1.0;
  }
  if (isExpZero.b) {
    resultTemp.b = 1.0;
  }
  if (isExpZero.a) {
    resultTemp.a = 1.0;
  }
  let isNaN = (a < vec4<f32>(0.0)) & (floor(b) < b);
`;
const $41dab11c37c6072e$var$PRELU = `if (a < 0.0) { return b * a; }  return a;`;
const $41dab11c37c6072e$var$PRELU_VEC4 = `
  let aLessThanZero = vec4<f32>(a < vec4<f32>(0.0));
  return (aLessThanZero * (b * a)) + ((vec4<f32>(1.0) - aLessThanZero) * a);
`;
const $41dab11c37c6072e$var$SQUARED_DIFFERENCE = 'let resultTemp = (a - b) * (a - b);';
const $41dab11c37c6072e$var$SUB = 'let resultTemp = a - b;';
function $41dab11c37c6072e$export$20c350df8f4933ab(type, useVec4) {
    let doOpSnippet;
    // Ops with NaN check
    do {
        switch(type){
            case $41dab11c37c6072e$export$e5d009af261ea0bd.ATAN2:
                doOpSnippet = $41dab11c37c6072e$var$ATAN2;
                break;
            case $41dab11c37c6072e$export$e5d009af261ea0bd.MAX:
                doOpSnippet = $41dab11c37c6072e$var$MAX;
                break;
            case $41dab11c37c6072e$export$e5d009af261ea0bd.MIN:
                doOpSnippet = $41dab11c37c6072e$var$MIN;
                break;
            case $41dab11c37c6072e$export$e5d009af261ea0bd.MOD:
                doOpSnippet = useVec4 ? $41dab11c37c6072e$var$MOD_VEC4 : $41dab11c37c6072e$var$MOD;
                break;
            case $41dab11c37c6072e$export$e5d009af261ea0bd.NOT_EQUAL:
                doOpSnippet = useVec4 ? $41dab11c37c6072e$var$NOT_EQUAL_VEC4 : $41dab11c37c6072e$var$NOT_EQUAL;
                break;
            case $41dab11c37c6072e$export$e5d009af261ea0bd.POW:
                doOpSnippet = useVec4 ? $41dab11c37c6072e$var$POW_VEC4 : $41dab11c37c6072e$var$POW;
                break;
            default:
                continue;
        }
        let isNaN;
        let dTypeN;
        let boolN;
        if (useVec4) {
            isNaN = 'isnanVec4';
            dTypeN = 'vec4<f32>';
            boolN = 'vec4<bool>';
        } else {
            isNaN = 'isnan';
            dTypeN = 'f32';
            boolN = 'bool';
        }
        return `
      let aIsNaN = ${isNaN}(a);
      let aPostLegalization = select(a, ${dTypeN}(42), aIsNaN);
      let bIsNaN = ${isNaN}(b);
      let bPostLegalization = select(b, ${dTypeN}(42), bIsNaN);
      let isNaN = false;
      let valueForNaN = uniforms.NAN;
      {
        let a = aPostLegalization;
        let b = bPostLegalization;
        ${doOpSnippet}
        return select(
            resultTemp, ${dTypeN}(valueForNaN),
            ${boolN}(isNaN) | aIsNaN | bIsNaN);
      }
    `;
    }while (false);
    // Ops without NaN check
    switch(type){
        case $41dab11c37c6072e$export$e5d009af261ea0bd.ADD:
            doOpSnippet = $41dab11c37c6072e$var$ADD;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.COMPLEX_MULTIPLY_IMAG:
            doOpSnippet = $41dab11c37c6072e$var$COMPLEX_MULTIPLY_IMAG;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.COMPLEX_MULTIPLY_REAL:
            doOpSnippet = $41dab11c37c6072e$var$COMPLEX_MULTIPLY_REAL;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.DIV:
            doOpSnippet = $41dab11c37c6072e$var$DIV;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.ELU_DER:
            doOpSnippet = $41dab11c37c6072e$var$ELU_DER;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.EQUAL:
            doOpSnippet = $41dab11c37c6072e$var$EQUAL;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.FLOOR_DIV:
            doOpSnippet = $41dab11c37c6072e$var$FLOOR_DIV;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.GREATER:
            doOpSnippet = $41dab11c37c6072e$var$GREATER;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.GREATER_EQUAL:
            doOpSnippet = $41dab11c37c6072e$var$GREATER_EQUAL;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.LESS:
            doOpSnippet = $41dab11c37c6072e$var$LESS;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.LESS_EQUAL:
            doOpSnippet = $41dab11c37c6072e$var$LESS_EQUAL;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.LOGICAL_AND:
            return useVec4 ? $41dab11c37c6072e$var$LOGICAL_AND_VEC4 : $41dab11c37c6072e$var$LOGICAL_AND;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.LOGICAL_OR:
            return useVec4 ? $41dab11c37c6072e$var$LOGICAL_OR_VEC4 : $41dab11c37c6072e$var$LOGICAL_OR;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.MUL:
            doOpSnippet = $41dab11c37c6072e$var$MUL;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.PRELU:
            return useVec4 ? $41dab11c37c6072e$var$PRELU_VEC4 : $41dab11c37c6072e$var$PRELU;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.SQUARED_DIFFERENCE:
            doOpSnippet = $41dab11c37c6072e$var$SQUARED_DIFFERENCE;
            break;
        case $41dab11c37c6072e$export$e5d009af261ea0bd.SUB:
            doOpSnippet = $41dab11c37c6072e$var$SUB;
            break;
        default:
    }
    return `
    ${doOpSnippet}
    return resultTemp;
  `;
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4af106881f0be485$export$5adefdb0f928033b;
(function(UnaryOpType) {
    UnaryOpType[UnaryOpType["ABS"] = 0] = "ABS";
    UnaryOpType[UnaryOpType["ACOS"] = 1] = "ACOS";
    UnaryOpType[UnaryOpType["ACOSH"] = 2] = "ACOSH";
    UnaryOpType[UnaryOpType["ASIN"] = 3] = "ASIN";
    UnaryOpType[UnaryOpType["ASINH"] = 4] = "ASINH";
    UnaryOpType[UnaryOpType["ATAN"] = 5] = "ATAN";
    UnaryOpType[UnaryOpType["ATANH"] = 6] = "ATANH";
    UnaryOpType[UnaryOpType["CEIL"] = 7] = "CEIL";
    UnaryOpType[UnaryOpType["COS"] = 8] = "COS";
    UnaryOpType[UnaryOpType["COSH"] = 9] = "COSH";
    UnaryOpType[UnaryOpType["ELU"] = 10] = "ELU";
    UnaryOpType[UnaryOpType["ERF"] = 11] = "ERF";
    UnaryOpType[UnaryOpType["EXP"] = 12] = "EXP";
    UnaryOpType[UnaryOpType["EXPM1"] = 13] = "EXPM1";
    UnaryOpType[UnaryOpType["FLOOR"] = 14] = "FLOOR";
    UnaryOpType[UnaryOpType["IS_FINITE"] = 15] = "IS_FINITE";
    UnaryOpType[UnaryOpType["IS_INF"] = 16] = "IS_INF";
    UnaryOpType[UnaryOpType["IS_NAN"] = 17] = "IS_NAN";
    UnaryOpType[UnaryOpType["LINEAR"] = 18] = "LINEAR";
    UnaryOpType[UnaryOpType["LOG"] = 19] = "LOG";
    UnaryOpType[UnaryOpType["LOG1P"] = 20] = "LOG1P";
    UnaryOpType[UnaryOpType["LOGICAL_NOT"] = 21] = "LOGICAL_NOT";
    UnaryOpType[UnaryOpType["NEG"] = 22] = "NEG";
    UnaryOpType[UnaryOpType["RELU"] = 23] = "RELU";
    UnaryOpType[UnaryOpType["RELU6"] = 24] = "RELU6";
    UnaryOpType[UnaryOpType["LEAKYRELU"] = 25] = "LEAKYRELU";
    UnaryOpType[UnaryOpType["RECIPROCAL"] = 26] = "RECIPROCAL";
    UnaryOpType[UnaryOpType["ROUND"] = 27] = "ROUND";
    UnaryOpType[UnaryOpType["RSQRT"] = 28] = "RSQRT";
    UnaryOpType[UnaryOpType["SELU"] = 29] = "SELU";
    UnaryOpType[UnaryOpType["SIGMOID"] = 30] = "SIGMOID";
    UnaryOpType[UnaryOpType["SIGN"] = 31] = "SIGN";
    UnaryOpType[UnaryOpType["SIN"] = 32] = "SIN";
    UnaryOpType[UnaryOpType["SINH"] = 33] = "SINH";
    UnaryOpType[UnaryOpType["SOFTPLUS"] = 34] = "SOFTPLUS";
    UnaryOpType[UnaryOpType["SQRT"] = 35] = "SQRT";
    UnaryOpType[UnaryOpType["SQUARE"] = 36] = "SQUARE";
    UnaryOpType[UnaryOpType["STEP"] = 37] = "STEP";
    UnaryOpType[UnaryOpType["TAN"] = 38] = "TAN";
    UnaryOpType[UnaryOpType["TANH"] = 39] = "TANH";
    UnaryOpType[UnaryOpType["TO_INT"] = 40] = "TO_INT";
})($4af106881f0be485$export$5adefdb0f928033b || ($4af106881f0be485$export$5adefdb0f928033b = {}));
const $4af106881f0be485$var$ABS = `return abs(a);`;
const $4af106881f0be485$var$ACOS = `
  if (abs(a) > 1.) {
    return uniforms.NAN;
  }
  return acos(a);
`;
const $4af106881f0be485$var$ACOSH = `
  if (a < 1.) {
    return uniforms.NAN;
  }
  return acosh(a);
`;
const $4af106881f0be485$var$ASIN = `
  if (abs(a) > 1.) {
    return uniforms.NAN;
  }
  return asin(a);
`;
const $4af106881f0be485$var$ASINH = `return asinh(a);`;
const $4af106881f0be485$var$ATAN = `
  if (isnan(a)) {
    return uniforms.NAN;
  }
  return atan(a);
`;
const $4af106881f0be485$var$ATANH = `
  if (abs(a) > 1.) {
    return uniforms.NAN;
  }
  if (a == 1.) {
    return uniforms.INFINITY;
  }
  if (a == -1.) {
    return -uniforms.INFINITY;
  }
  return atanh(a);
`;
const $4af106881f0be485$var$CEIL = `return ceil(a);`;
const $4af106881f0be485$var$COS = `return cos(a);`;
const $4af106881f0be485$var$COSH = `
  let e2x = exp(-a);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const $4af106881f0be485$var$EXPM1 = `return exp(a) - 1.0;`;
const $4af106881f0be485$var$ELU = `if (a >= 0.0) { return a; }  return (exp(a) - 1.0);`;
const $4af106881f0be485$var$ELU_VEC4 = `
  var resFloat = exp(a) - vec4<f32>(1.0);
  if (a.r >= 0.0) {
    resFloat.r = a.r;
  }
  if (a.g >= 0.0) {
    resFloat.g = a.g;
  }
  if (a.b >= 0.0) {
    resFloat.b = a.b;
  }
  if (a.a >= 0.0) {
    resFloat.a = a.a;
  }
  return resFloat;
`;
const $4af106881f0be485$var$ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  let p = ${(0, $f35e0c1a651337db$exports).ERF_P};
  let a1 = ${(0, $f35e0c1a651337db$exports).ERF_A1};
  let a2 = ${(0, $f35e0c1a651337db$exports).ERF_A2};
  let a3 = ${(0, $f35e0c1a651337db$exports).ERF_A3};
  let a4 = ${(0, $f35e0c1a651337db$exports).ERF_A4};
  let a5 = ${(0, $f35e0c1a651337db$exports).ERF_A5};

  let sign = sign(a);
  let absA = abs(a);
  let t = 1.0 / (1.0 + p * absA);
  return sign * (1.0 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * exp(-absA * absA));
`;
const $4af106881f0be485$var$EXP = `return exp(a);`;
const $4af106881f0be485$var$FLOOR = `return floor(a);`;
const $4af106881f0be485$var$IS_FINITE = `return f32(!isnan(a) && !isinf(a));`;
const $4af106881f0be485$var$IS_INF = `return f32(isinf(a));`;
const $4af106881f0be485$var$IS_NAN = `return f32(isnan(a));`;
const $4af106881f0be485$var$LINEAR = `return a;`;
const $4af106881f0be485$var$LOG = `if (a < 0.0) { return uniforms.NAN; }
  return log(a);`;
const $4af106881f0be485$var$LOG1P = `
  if (isnan(a)) { return a; }
  return log(1.0 + a);
`;
const $4af106881f0be485$var$LOGICAL_NOT = `return f32(!(a >= 1.0));`;
const $4af106881f0be485$var$NEG = `return -a;`;
const $4af106881f0be485$var$LEAKYRELU = `if (a < 0.0) { return uniforms.alpha * a; } return a;`;
const $4af106881f0be485$var$LEAKYRELU_VEC4 = `
  let aLessThanZero = vec4<f32>(a < vec4<f32>(0.0));
  return (aLessThanZero * (uniforms.alpha * a)) + ((vec4<f32>(1.0) - aLessThanZero) * a);
`;
const $4af106881f0be485$var$RECIPROCAL = `return 1.0 / a;`;
const $4af106881f0be485$var$RELU = `return select(a, 0.0, a < 0.0);`;
const $4af106881f0be485$var$RELU6 = 'return clamp(a, 0.0, 6.0);';
const $4af106881f0be485$var$RELU6_VEC4 = 'return clamp(a, vec4<f32>(0.0, 0.0, 0.0, 0.0), vec4<f32>(6.0, 6.0, 6.0, 6.0));';
const $4af106881f0be485$var$RELU_VEC4 = `
  return select(a, vec4<f32>(0.0), a < vec4<f32>(0.0));
`;
const $4af106881f0be485$var$ROUND = `return round(a);`;
const $4af106881f0be485$var$RSQRT = `return inverseSqrt(a);`;
// Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
// See: https://arxiv.org/abs/1706.02515
const $4af106881f0be485$var$SELU = `
  if (a >= 0.0) {
    return ${(0, $f35e0c1a651337db$exports).SELU_SCALE} * a;
  } else {
    return ${(0, $f35e0c1a651337db$exports).SELU_SCALEALPHA} * (exp(a) - 1.0);
  }
`;
const $4af106881f0be485$var$SIGMOID = `return 1.0 / (1.0 + exp(-1.0 * a));`;
const $4af106881f0be485$var$SIGN = `return sign(a);`;
const $4af106881f0be485$var$SIN = `return sin(a);`;
const $4af106881f0be485$var$SINH = `
  let e2x = exp(a);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const $4af106881f0be485$var$SOFTPLUS = `
  let epsilon = 1.1920928955078125e-7;
  let threshold = log(epsilon) + 2.0;

  let too_large = a > -threshold;
  let too_small = a < threshold;
  let exp_a = exp(a);

  if (too_large) {
    return a;
  } else if (too_small) {
    return exp_a;
  } else {
    return log(exp_a + 1.0);
  }
`;
const $4af106881f0be485$var$SQRT = `return sqrt(a);`;
const $4af106881f0be485$var$SQUARE = `return a * a;`;
const $4af106881f0be485$var$STEP = `
  if (isnan(a)) {
    return a;
  }

  return select(uniforms.stepAlpha, 1.0, a > 0.0);
`;
const $4af106881f0be485$var$TAN = `return tan(a);`;
const $4af106881f0be485$var$TANH = `
  let e2x = exp(-2.0 * abs(a));
  return sign(a) * (1.0 - e2x) / (1.0 + e2x);
`;
const $4af106881f0be485$var$TO_INT = `return f32(i32((a)));`;
function $4af106881f0be485$export$bf824beefaa2c9b9(type, useVec4) {
    switch(type){
        case $4af106881f0be485$export$5adefdb0f928033b.ABS:
            return $4af106881f0be485$var$ABS;
        case $4af106881f0be485$export$5adefdb0f928033b.ACOS:
            return $4af106881f0be485$var$ACOS;
        case $4af106881f0be485$export$5adefdb0f928033b.ACOSH:
            return $4af106881f0be485$var$ACOSH;
        case $4af106881f0be485$export$5adefdb0f928033b.ASIN:
            return $4af106881f0be485$var$ASIN;
        case $4af106881f0be485$export$5adefdb0f928033b.ASINH:
            return $4af106881f0be485$var$ASINH;
        case $4af106881f0be485$export$5adefdb0f928033b.ATAN:
            return $4af106881f0be485$var$ATAN;
        case $4af106881f0be485$export$5adefdb0f928033b.ATANH:
            return $4af106881f0be485$var$ATANH;
        case $4af106881f0be485$export$5adefdb0f928033b.COS:
            return $4af106881f0be485$var$COS;
        case $4af106881f0be485$export$5adefdb0f928033b.COSH:
            return $4af106881f0be485$var$COSH;
        case $4af106881f0be485$export$5adefdb0f928033b.CEIL:
            return $4af106881f0be485$var$CEIL;
        case $4af106881f0be485$export$5adefdb0f928033b.ELU:
            return useVec4 ? $4af106881f0be485$var$ELU_VEC4 : $4af106881f0be485$var$ELU;
        case $4af106881f0be485$export$5adefdb0f928033b.ERF:
            return $4af106881f0be485$var$ERF;
        case $4af106881f0be485$export$5adefdb0f928033b.EXP:
            return $4af106881f0be485$var$EXP;
        case $4af106881f0be485$export$5adefdb0f928033b.EXPM1:
            return $4af106881f0be485$var$EXPM1;
        case $4af106881f0be485$export$5adefdb0f928033b.FLOOR:
            return $4af106881f0be485$var$FLOOR;
        case $4af106881f0be485$export$5adefdb0f928033b.IS_FINITE:
            return $4af106881f0be485$var$IS_FINITE;
        case $4af106881f0be485$export$5adefdb0f928033b.IS_INF:
            return $4af106881f0be485$var$IS_INF;
        case $4af106881f0be485$export$5adefdb0f928033b.IS_NAN:
            return $4af106881f0be485$var$IS_NAN;
        case $4af106881f0be485$export$5adefdb0f928033b.LINEAR:
            return $4af106881f0be485$var$LINEAR;
        case $4af106881f0be485$export$5adefdb0f928033b.LOG:
            return $4af106881f0be485$var$LOG;
        case $4af106881f0be485$export$5adefdb0f928033b.LOG1P:
            return $4af106881f0be485$var$LOG1P;
        case $4af106881f0be485$export$5adefdb0f928033b.LOGICAL_NOT:
            return $4af106881f0be485$var$LOGICAL_NOT;
        case $4af106881f0be485$export$5adefdb0f928033b.NEG:
            return $4af106881f0be485$var$NEG;
        case $4af106881f0be485$export$5adefdb0f928033b.LEAKYRELU:
            return useVec4 ? $4af106881f0be485$var$LEAKYRELU_VEC4 : $4af106881f0be485$var$LEAKYRELU;
        case $4af106881f0be485$export$5adefdb0f928033b.RECIPROCAL:
            return $4af106881f0be485$var$RECIPROCAL;
        case $4af106881f0be485$export$5adefdb0f928033b.RELU:
            return useVec4 ? $4af106881f0be485$var$RELU_VEC4 : $4af106881f0be485$var$RELU;
        case $4af106881f0be485$export$5adefdb0f928033b.RELU6:
            return useVec4 ? $4af106881f0be485$var$RELU6_VEC4 : $4af106881f0be485$var$RELU6;
        case $4af106881f0be485$export$5adefdb0f928033b.ROUND:
            return $4af106881f0be485$var$ROUND;
        case $4af106881f0be485$export$5adefdb0f928033b.RSQRT:
            return $4af106881f0be485$var$RSQRT;
        case $4af106881f0be485$export$5adefdb0f928033b.SELU:
            return $4af106881f0be485$var$SELU;
        case $4af106881f0be485$export$5adefdb0f928033b.SIGMOID:
            return $4af106881f0be485$var$SIGMOID;
        case $4af106881f0be485$export$5adefdb0f928033b.SIGN:
            return $4af106881f0be485$var$SIGN;
        case $4af106881f0be485$export$5adefdb0f928033b.SIN:
            return $4af106881f0be485$var$SIN;
        case $4af106881f0be485$export$5adefdb0f928033b.SINH:
            return $4af106881f0be485$var$SINH;
        case $4af106881f0be485$export$5adefdb0f928033b.SOFTPLUS:
            return $4af106881f0be485$var$SOFTPLUS;
        case $4af106881f0be485$export$5adefdb0f928033b.SQRT:
            return $4af106881f0be485$var$SQRT;
        case $4af106881f0be485$export$5adefdb0f928033b.SQUARE:
            return $4af106881f0be485$var$SQUARE;
        case $4af106881f0be485$export$5adefdb0f928033b.STEP:
            return $4af106881f0be485$var$STEP;
        case $4af106881f0be485$export$5adefdb0f928033b.TAN:
            return $4af106881f0be485$var$TAN;
        case $4af106881f0be485$export$5adefdb0f928033b.TANH:
            return $4af106881f0be485$var$TANH;
        case $4af106881f0be485$export$5adefdb0f928033b.TO_INT:
            return $4af106881f0be485$var$TO_INT;
        default:
            throw new Error(`BinaryType ${type} is not implemented!`);
    }
}



function $b3e75cba2f4dc261$export$f79ce230bc90dd9f(activation, hasPreluActivationWeights = false, packed = false, coordsLength = 3) {
    if (activation === null) return '';
    let activationOpSnippet = '';
    if (activation === 'linear') activationOpSnippet = (0, $4af106881f0be485$export$bf824beefaa2c9b9)((0, $4af106881f0be485$export$5adefdb0f928033b).LINEAR);
    else if (activation === 'relu') activationOpSnippet = (0, $4af106881f0be485$export$bf824beefaa2c9b9)((0, $4af106881f0be485$export$5adefdb0f928033b).RELU, packed);
    else if (activation === 'elu') activationOpSnippet = (0, $4af106881f0be485$export$bf824beefaa2c9b9)((0, $4af106881f0be485$export$5adefdb0f928033b).ELU, packed);
    else if (activation === 'relu6') activationOpSnippet = (0, $4af106881f0be485$export$bf824beefaa2c9b9)((0, $4af106881f0be485$export$5adefdb0f928033b).RELU6, packed);
    else if (activation === 'prelu') activationOpSnippet = (0, $41dab11c37c6072e$export$20c350df8f4933ab)((0, $41dab11c37c6072e$export$e5d009af261ea0bd).PRELU, packed);
    else if (activation === 'sigmoid') activationOpSnippet = (0, $4af106881f0be485$export$bf824beefaa2c9b9)((0, $4af106881f0be485$export$5adefdb0f928033b).SIGMOID, packed);
    else if (activation === 'leakyrelu') activationOpSnippet = (0, $4af106881f0be485$export$bf824beefaa2c9b9)((0, $4af106881f0be485$export$5adefdb0f928033b).LEAKYRELU, packed);
    else throw new Error(`Activation ${activation} has not been implemented for the WebGPU backend.`);
    const elementSize = packed ? 4 : 1;
    const dataType = (0, $0533631f1fe2cae9$export$85f585983df3fed3)(elementSize);
    let activationFnSnippet1 = '';
    if (hasPreluActivationWeights) activationFnSnippet1 = `
      fn activation(a : ${dataType}, coords : vec${coordsLength}<i32>) -> ${dataType} {
        let b = getPreluActivationWeightsByOutputCoords(coords);
        ${activationOpSnippet}
      }`;
    else activationFnSnippet1 = `
      fn activation(a : ${dataType}, coords : vec${coordsLength}<i32>) -> ${dataType} {
        ${activationOpSnippet}
      }`;
    return activationFnSnippet1;
}
function $b3e75cba2f4dc261$export$9766e8742a87dc55(hasBias, activation) {
    return `
      ${hasBias ? 'value = value + getBiasByOutputCoords(coords);' : ''}
      ${activation ? 'value = activation(value, coords);' : ''}
      `;
}




function $0257e34115d1bde3$export$4831bc2078546fa(transposeA, transposeB, fitAOuter = false, fitBOuter = false, fitInner = false, component = 1) {
    (0, $0775da5e684c8c0d$exports).assert(transposeA && component === 1 || !transposeA, ()=>`transposeA ${transposeA} is not compatible with component size ${component}`);
    const sampleA = `
      ${transposeA ? `value = getA(batch, col, row);` : `value = getA(batch, row, col);`}

    `;
    const sampleB = transposeB ? `value = getB(batch, col, row);` : `value = getB(batch, row, col);`;
    return `
  fn mm_readA(batch: i32, row: i32, col: i32) -> ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(component)} {
    var value = ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(component)}(0.0);
    ${fitAOuter && fitInner ? sampleA : `
    ${transposeA ? `if(row < uniforms.dimAOuter && col < uniforms.dimInner)` : `if(row < uniforms.aShape[1] && col < uniforms.aShape[2])`}
    {
      ${sampleA}
    }
    `}
    return value;
  }

  fn mm_readB(batch: i32, row: i32, col: i32) -> ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(component)} {
    var value = ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(component)}(0.0);
    ${sampleB}
    return value;
  }
  `;
}
function $0257e34115d1bde3$export$be50c46a8ed085fb(hasBias, activation, transposeA, transposeB, fitAOuter = false, fitBOuter = false, fitInner = false, component = 1) {
    return `
  ${$0257e34115d1bde3$export$4831bc2078546fa(transposeA, transposeB, fitAOuter, fitBOuter, fitInner, component)}
  fn mm_write(batch: i32, row: i32, col: i32, valueIn: ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(component)}) {
    ${fitAOuter && fitBOuter ? '' : 'if (row < uniforms.dimAOuter && col < uniforms.dimBOuter)'}
    {
      var value = valueIn;
      let coords = vec3<i32>(batch, row, col);
      ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(hasBias, activation)}
      setOutputAtCoords(coords[0], coords[1], coords[2], value);
    }
  }
  `;
}
const $0257e34115d1bde3$var$writeDataToSubAVec4Snippet = (transpose, innerElementSize)=>{
    if (transpose) return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          kStart + inputRow,
          globalRowStart + inputCol * ${innerElementSize});
        `;
    else return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          globalRow + innerRow,
          kStart + inputCol * ${innerElementSize});
        `;
};
const $0257e34115d1bde3$var$calculateResultSnippet = (transposeA, innerElementSize, rowPerThread, tileInner)=>{
    if (transposeA) return `
      for (var k = 0; k < ${tileInner}; k++) {
        let BCached0 = mm_Bsub[k][tileCol];
        let ACached0 = mm_Asub[k][localRow];
        for (var i = 0; i < ${rowPerThread}; i++) {
          acc[i] = fma(BCached0, vec4<f32>(ACached0[i]), acc[i]);
        }
      }`;
    else {
        let bCachedStr = '';
        let accStr = '';
        for(let i = 0; i < innerElementSize; i++){
            bCachedStr += `let BCached${i} = mm_Bsub[k * ${innerElementSize} + ${i}][tileCol];`;
            accStr += `acc[i] = fma(BCached${i}, vec4<f32>(ACached[${i}]), acc[i]);`;
        }
        return `
      for (var k = 0; k < ${tileInner / innerElementSize}; k++) {
        ${bCachedStr}
        for (var i = 0; i < ${rowPerThread}; i++) {
          let ACached = mm_Asub[tileRow + i][k];
          ${accStr}
        }
      }`;
    }
};
function $0257e34115d1bde3$export$4690dafda830f3a(workPerThread, workgroupSize, transposeA = false, tileInner = 32, splitK = false, splitedDimInner = 32, broadcastBatch = false) {
    const tileAOuter = workgroupSize[1] * workPerThread[1];
    const tileBOuter = workgroupSize[0] * workPerThread[0];
    const tileAWidth = transposeA ? tileAOuter : tileInner;
    const tileAHight = transposeA ? tileInner : tileAOuter;
    const innerElementSize = tileAWidth / workgroupSize[0];
    const rowPerThreadB = tileInner / workgroupSize[1];
    const rowPerThread = workPerThread[1];
    const colPerThread = workPerThread[0];
    (0, $0775da5e684c8c0d$exports).assert((transposeA && innerElementSize === 4 && workPerThread[1] === 4 || !transposeA && (innerElementSize === 3 || innerElementSize === 4)) && tileAWidth % workgroupSize[0] === 0 && tileInner % workgroupSize[1] === 0 && workPerThread[0] === 4, ()=>`If transposeA ${transposeA} is true, innerElementSize ${innerElementSize} and workPerThread[1] ${workPerThread[1]} must be 4.
          Otherwise, innerElementSize ${innerElementSize} must be 3 or 4.
      tileAWidth ${tileAWidth} must be divisible by workgroupSize[0]${workgroupSize[0]}. tileInner ${tileInner} must be divisible by workgroupSize[1] ${workgroupSize[1]}. colPerThread ${workPerThread[0]} must be 4.`);
    return `
  var<workgroup> mm_Asub : array<array<vec${innerElementSize}<f32>, ${tileAWidth / innerElementSize}>, ${tileAHight}>;
  var<workgroup> mm_Bsub : array<array<vec4<f32>, ${tileBOuter / workPerThread[0]}>, ${tileInner}>;

  ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
    let localRow = i32(localId.y);
    let tileRow = localRow * ${rowPerThread};
    let tileCol = i32(localId.x);

    let globalRow = i32(globalId.y) * ${rowPerThread};
    let globalCol = i32(globalId.x) * ${colPerThread};
    let batch = ${splitK ? '0' : 'i32(globalId.z)'};
    let batchA = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.aShape[0]'};
    let batchB = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.bShape[0]'};
    let globalRowStart = i32(workgroupId.y) * ${tileAOuter};

    let numTiles = ${splitK ? `${Math.ceil(splitedDimInner / tileInner)}` : `(uniforms.dimInner - 1) / ${tileInner} + 1`};
    var kStart = ${splitK ? `i32(globalId.z) * ${splitedDimInner}` : '0'};

    var acc: array<vec4<f32>, ${rowPerThread}>;

    // Loop over shared dimension.
    let tileRowB = localRow * ${rowPerThreadB};
    for (var t = 0; t < numTiles; t++) {
        // Load one tile of A into local memory.
        for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
            let inputRow = tileRow + innerRow;
            let inputCol = tileCol;
            ${$0257e34115d1bde3$var$writeDataToSubAVec4Snippet(transposeA, innerElementSize)}
        }

        // Load one tile of B into local memory.
        for (var innerRow = 0; innerRow < ${rowPerThreadB}; innerRow++) {
            let inputRow = tileRowB + innerRow;
            let inputCol = tileCol;
            mm_Bsub[inputRow][inputCol] = mm_readB(batchB, kStart + inputRow, globalCol);
        }
        kStart = kStart + ${tileInner};
        workgroupBarrier();

        // Compute acc values for a single thread.
        ${$0257e34115d1bde3$var$calculateResultSnippet(transposeA, innerElementSize, rowPerThread, tileInner)}
        workgroupBarrier();
    }

    for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        mm_write(batch, globalRow + innerRow, globalCol, acc[innerRow]);
    }
  }`;
}
const $0257e34115d1bde3$var$writeDataToSubASnippet = (transpose)=>{
    if (transpose) return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          kStart + inputRow,
          globalRowStart + inputCol);
        `;
    else return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          globalRowStart + inputRow,
          kStart + inputCol);
        `;
};
const $0257e34115d1bde3$var$readDataFromSubASnippet = (transposeA)=>{
    return transposeA ? 'let ACached = mm_Asub[k][tileRow + innerRow];' : 'let ACached = mm_Asub[tileRow + innerRow][k];';
};
function $0257e34115d1bde3$export$b3a48535ed1d015(workPerThread, workgroupSize, transposeA = false, tileInner = 32, splitK = false, splitedDimInner = 32, sequentialAccessByThreads = false, broadcastBatch = false) {
    const tileAOuter = workPerThread[1] * workgroupSize[1];
    const tileBOuter = workPerThread[0] * workgroupSize[0];
    const tileAWidth = transposeA ? tileAOuter : tileInner;
    const tileAHight = transposeA ? tileInner : tileAOuter;
    (0, $0775da5e684c8c0d$exports).assert(tileAHight % workgroupSize[1] === 0 && tileAWidth % workgroupSize[0] === 0 && tileInner % workgroupSize[1] === 0, ()=>`tileAHight ${tileAHight} must be divisible by workgroupSize[1]${workgroupSize[1]}, tileAWidth ${tileAWidth} must be divisible by workgroupSize[0]${workgroupSize[0]}, tileInner ${tileInner} must be divisible by workgroupSize[1]${workgroupSize[1]}`);
    const rowPerThreadA = tileAHight / workgroupSize[1];
    const colPerThreadA = tileAWidth / workgroupSize[0];
    const rowPerThreadB = tileInner / workgroupSize[1];
    const rowPerThread = workPerThread[1];
    const colPerThread = workPerThread[0];
    const matmulSnippet = sequentialAccessByThreads ? `
      let localRow = i32(localId.y);
      let localCol = i32(localId.x);
      let globalRowStart = i32(workgroupId.y) * ${tileAOuter};
      let globalColStart = i32(workgroupId.x) * ${tileBOuter};

      // Loop over shared dimension.
      for (var t = 0; t < numTiles; t++) {
        // Load one tile of A into local memory.
        for (var inputRow = localRow; inputRow < ${tileAHight}; inputRow = inputRow + ${workgroupSize[1]}) {
          for (var inputCol = localCol; inputCol < ${tileAWidth}; inputCol = inputCol + ${workgroupSize[0]}) {
            ${$0257e34115d1bde3$var$writeDataToSubASnippet(transposeA)}
          }
        }
        // Load one tile of B into local memory.
        for (var inputRow = localRow; inputRow < ${tileInner}; inputRow = inputRow + ${workgroupSize[1]}) {
              for (var inputCol = localCol; inputCol < ${tileBOuter}; inputCol = inputCol + ${workgroupSize[0]}) {
            mm_Bsub[inputRow][inputCol] = mm_readB(batchB,
              kStart + inputRow,
              globalColStart + inputCol);
          }
        }
        kStart = kStart + ${tileInner};
        workgroupBarrier();

        // Compute acc values for a single thread.
        var BCached : array<f32, ${colPerThread}>;
        for (var k = 0; k < ${tileInner}; k++) {
          for (var inner = 0; inner < ${colPerThread}; inner++) {
            BCached[inner] = mm_Bsub[k][localCol + inner * ${workgroupSize[0]}];
          }
          for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
            let ACached = ${transposeA ? `mm_Asub[k][localRow + innerRow * ${workgroupSize[1]}];` : `mm_Asub[localRow + innerRow * ${workgroupSize[1]}][k];`}
            for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
              acc[innerRow][innerCol] =
                  fma(ACached, BCached[innerCol], acc[innerRow][innerCol]);
            }
          }
        }
        workgroupBarrier();
      }
      for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        let gRow = globalRowStart + localRow + innerRow * ${workgroupSize[1]};
        for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
          let gCol = globalColStart + localCol + innerCol * ${workgroupSize[0]};
          mm_write(batch, gRow, gCol, acc[innerRow][innerCol]);
        }
      }
      ` : `
  let tileRow = i32(localId.y) * ${rowPerThread};
  let tileCol = i32(localId.x) * ${colPerThread};

  let globalRow = i32(globalId.y) * ${rowPerThread};
  let globalCol = i32(globalId.x) * ${colPerThread};
  let globalRowStart = i32(workgroupId.y) * ${tileAOuter};

  let tileRowA = i32(localId.y) * ${rowPerThreadA};
  let tileColA = i32(localId.x) * ${colPerThreadA};
  let tileRowB = i32(localId.y) * ${rowPerThreadB};
  // Loop over shared dimension.
  for (var t = 0; t < numTiles; t++) {
    // Load one tile of A into local memory.
    for (var innerRow = 0; innerRow < ${rowPerThreadA}; innerRow++) {
      for (var innerCol = 0; innerCol < ${colPerThreadA}; innerCol++) {
        let inputRow = tileRowA + innerRow;
        let inputCol = tileColA + innerCol;
        ${$0257e34115d1bde3$var$writeDataToSubASnippet(transposeA)}
      }
    }

    // Load one tile of B into local memory.
    for (var innerRow = 0; innerRow < ${rowPerThreadB}; innerRow++) {
      for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
        let inputRow = tileRowB + innerRow;
        let inputCol = tileCol + innerCol;
        mm_Bsub[inputRow][inputCol] = mm_readB(batchB,
          kStart + inputRow,
          globalCol + innerCol);
      }
    }
    kStart = kStart + ${tileInner};
    workgroupBarrier();

    // Compute acc values for a single thread.
    var BCached : array<f32, ${colPerThread}>;
    for (var k = 0; k < ${tileInner}; k++) {
      for (var inner = 0; inner < ${colPerThread}; inner++) {
        BCached[inner] = mm_Bsub[k][tileCol + inner];
      }

      for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        ${$0257e34115d1bde3$var$readDataFromSubASnippet(transposeA)}
        for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
          acc[innerRow][innerCol] =
              fma(ACached, BCached[innerCol], acc[innerRow][innerCol]);
        }
      }
    }

    workgroupBarrier();
  }

  for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
    for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
      mm_write(batch, globalRow + innerRow, globalCol + innerCol,
          acc[innerRow][innerCol]);
    }
  }
  `;
    return `
    var<workgroup> mm_Asub : array<array<f32, ${tileAWidth}>, ${tileAHight}>;
    var<workgroup> mm_Bsub : array<array<f32, ${tileBOuter}>, ${tileInner}>;

    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
      let batch = ${splitK ? '0' : 'i32(globalId.z)'};
      let batchA = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.aShape[0]'};
      let batchB = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.bShape[0]'};
      let numTiles = ${splitK ? `${Math.ceil(splitedDimInner / tileInner)}` : `(uniforms.dimInner - 1) / ${tileInner} + 1`};
      var kStart = ${splitK ? `i32(globalId.z) * ${splitedDimInner}` : '0'};

      var acc : array<array<f32, ${colPerThread}>, ${rowPerThread}>;

      // Without this initialization strange values show up in acc.
      for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
          acc[innerRow][innerCol] = 0.0;
        }
      }
      ${matmulSnippet}
    }
  `;
}
const $0257e34115d1bde3$var$readVectorASnippet = (transpose)=>{
    return transpose ? `
      mm_readA(batchA, colA, globalRow),
      mm_readA(batchA, colA + 1, globalRow),
      mm_readA(batchA, colA + 2, globalRow),
      mm_readA(batchA, colA + 3, globalRow)
  ` : `
      mm_readA(batchA, globalRow, colA),
      mm_readA(batchA, globalRow, colA + 1),
      mm_readA(batchA, globalRow, colA + 2),
      mm_readA(batchA, globalRow, colA + 3)
  `;
};
function $0257e34115d1bde3$export$7f5627c650f57947(workgroupSize, transposeA = false) {
    (0, $0775da5e684c8c0d$exports).assert(workgroupSize[1] === 1 && workgroupSize[2] === 1, ()=>`A linear work group size is required. But got ${workgroupSize}.`);
    const tileSize = workgroupSize[0] * 4;
    return `
    var<workgroup> mm_Asub : array<vec4<f32>, ${workgroupSize[0]}>;

    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
      let tileCol = i32(localId.x);
      let globalCol = i32(globalId.x);
      let globalRow = i32(globalId.y);

      let numTiles = (uniforms.dimInner - 1) / ${tileSize} + 1;
      let batch = i32(globalId.z);
      let batchA = batch % uniforms.aShape[0];
      let batchB = batch % uniforms.bShape[0];
      // Without this initialization strange values show up in acc.
      var acc = 0.0;

      // Loop over shared dimension.
      for (var t = 0; t < numTiles; t++) {
        // Load one tile of A into local memory.
        let colA = t * ${tileSize} + tileCol * 4;
        mm_Asub[tileCol] = vec4<f32>(${$0257e34115d1bde3$var$readVectorASnippet(transposeA)});
        workgroupBarrier();

        // Compute acc values for a single thread.
        for (var k = 0; k < ${tileSize / 4}; k++) {
          let rowB = t * ${tileSize} + k * 4;
          let BCached = vec4<f32>(mm_readB(batchB, rowB, globalCol),
                              mm_readB(batchB, rowB + 1, globalCol),
                              mm_readB(batchB, rowB + 2, globalCol),
                              mm_readB(batchB, rowB + 3, globalCol));

          let ACached = mm_Asub[k];
          acc = acc + dot(ACached, BCached);
        }

        workgroupBarrier();
      }

      mm_write(batch, globalRow, globalCol, acc);
    }
  `;
}
class $0257e34115d1bde3$export$21e5f112101779d8 {
    constructor(aShape, outputShape, transposeA = false, transposeB = false, bias = null, activation = null, preluActivationWeights = null, sequentialAccessByThreads = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0
            ]
        };
        const dimInner = transposeA ? aShape[1] : aShape[2];
        this.isVec4 = (dimInner % 4 === 0 && !transposeA || outputShape[1] % 4 === 0 && transposeA) && outputShape[2] % 4 === 0 && !transposeB;
        this.outputComponent = this.isVec4 ? 4 : 1;
        this.isVectorA = outputShape[1] === 1 && !transposeA;
        if (!this.isVec4 && this.isVectorA) {
            // For makeVectorMatrixProductSource
            this.elementsPerThread = [
                1,
                1,
                1
            ];
            this.workgroupSize = [
                32,
                1,
                1
            ];
        } else {
            const workgroupInfo = (0, $8e83a93f95f027c6$export$f6bf47abf12e6a8a)(outputShape[1], dimInner, outputShape[2], transposeA);
            this.workgroupSize = workgroupInfo.workgroupSize;
            this.elementsPerThread = workgroupInfo.elementsPerThread;
        }
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, this.elementsPerThread);
        const addBias = bias != null;
        const hasPreluActivationWeights = preluActivationWeights != null;
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.sequentialAccessByThreads = sequentialAccessByThreads;
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        [this.fitAOuter, this.fitBOuter, this.fitInner] = this.getShapeFit(outputShape[1], outputShape[2], dimInner);
        this.shaderKey = `matMulPacked_${this.elementsPerThread}_${transposeA}_${transposeB}_${this.activation}_${this.fitAOuter}_${this.fitBOuter}_${this.fitInner}_${this.isVec4}_${this.isVectorA}_${this.sequentialAccessByThreads}`;
    }
    getShapeFit(dimAOuter, dimBOuter, dimInner) {
        const tileAOuter = this.workgroupSize[1] * this.elementsPerThread[1];
        const tileBOuter = this.workgroupSize[0] * this.elementsPerThread[0];
        if (!this.isVec4 && this.isVectorA) // For makeVectorMatrixProductSource
        this.tileInner = this.workgroupSize[0] * 4;
        else this.tileInner = tileBOuter;
        const fitAOuter = dimAOuter % tileAOuter === 0;
        const fitBOuter = dimBOuter % tileBOuter === 0;
        const fitInner = dimInner % this.tileInner === 0;
        return [
            fitAOuter,
            fitBOuter,
            fitInner
        ];
    }
    getUserCode() {
        const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivationWeights, this.isVec4)}
      ${$0257e34115d1bde3$export$be50c46a8ed085fb(this.addBias, this.activation, false, this.transposeB, this.fitAOuter, this.fitBOuter, this.fitInner, this.isVec4 ? 4 : 1)}
      ${this.isVec4 ? $0257e34115d1bde3$export$4690dafda830f3a(this.elementsPerThread, this.workgroupSize, this.transposeA, this.tileInner, false, null, true) : this.isVectorA ? $0257e34115d1bde3$export$7f5627c650f57947(this.workgroupSize, this.transposeA) : $0257e34115d1bde3$export$b3a48535ed1d015(this.elementsPerThread, this.workgroupSize, this.transposeA, this.tileInner, false, null, this.sequentialAccessByThreads, true)}
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $f6ad7ef2c6e2d506$export$9983c79defd8d9aa(workgroupSizeX) {
    return `
    var<workgroup> sumValues : array<f32, ${workgroupSizeX}>;
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
      let coords = getOutputCoords();
      let batch = coords[0];
      let batchA = batch % uniforms.aShape[0];
      let batchB = batch % uniforms.bShape[0];
      let row = coords[1];
      let col = coords[2];
      var sum = 0.0;
      let Length = uniforms.dimInner;
      for (var k = i32(localId.x); k < Length; k = k + ${workgroupSizeX}) {
        let dataA = mm_readA(batchA, row, k);
        let dataB = mm_readB(batchB, k, col);
        sum = sum + dataA * dataB;
      }
      sumValues[localId.x] = sum;
      workgroupBarrier();

      for(var currentSize = ${workgroupSizeX / 2}u; currentSize > 1u;
          currentSize = currentSize / 2u) {
        if (localId.x < currentSize)
        {
          sumValues[localId.x] = sumValues[localId.x] + sumValues[localId.x + currentSize];
        }
        workgroupBarrier();
      }

      if (localId.x == 0u) {
        sum = sumValues[0] + sumValues[1];
        mm_write(batch, row, col, sum);
      }
    }
  `;
}
class $f6ad7ef2c6e2d506$export$f47918074674a3c4 {
    constructor(outputShape, transposeA = false, transposeB = false, bias = null, activation = null, preluActivationWeights = null){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [],
            y: [
                1,
                2
            ],
            z: [
                0
            ]
        };
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        const addBias = bias != null;
        const hasPreluActivationWeights = preluActivationWeights != null;
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        this.shaderKey = `matMulReduce_${this.activation}_${transposeA}_${transposeB}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivationWeights)}
      ${(0, $0257e34115d1bde3$export$be50c46a8ed085fb)(this.addBias, this.activation, this.transposeA, this.transposeB)}
      ${$f6ad7ef2c6e2d506$export$9983c79defd8d9aa(this.workgroupSize[0])}
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $08b2d9066ff24851$export$6a4ab46bf6cbb17(workgroupSize) {
    const tileAOuter = workgroupSize[1];
    const tileBOuter = workgroupSize[0];
    const tileInner = tileAOuter > tileBOuter ? tileAOuter : tileBOuter;
    return `
  var<workgroup> mm_Asub : array<array<f32, ${tileInner}>, ${tileAOuter}>;
  var<workgroup> mm_Bsub : array<array<f32, ${tileBOuter}>, ${tileInner}>;

  // If the output size is small for matrix multiplication, avoid to use vec4
  // and handle some elements per thread to optimally utilize the ALU.
  // Read data from global memory to registers firstly, then store them into
  // shared memory, so it is instruction-Level parallelism for arithmetic
  // operations and others handle IO operations between barrier api, makes ALU
  // and load/store units work simultaneously, could improves the performance.
  ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
    let tileRow = i32(localId.y);
    let tileCol = i32(localId.x);
    let globalRow = i32(globalId.y);
    let globalCol = i32(globalId.x);
    let batch = i32(globalId.z);
    let batchA = batch % uniforms.aShape[0];
    let batchB = batch % uniforms.bShape[0];

    // uniforms.dimInner should be greater than 0.
    let numTiles = (uniforms.dimInner - 1) / ${tileInner} + 1;
    var acc = 0.0;

    var globalColA = tileCol;
    var globalRowB = 0;
    var regA = mm_readA(batchA, globalRow, globalColA);
    var regB0 = mm_readB(batchB, globalRowB + 2 * tileRow, globalCol);
    var regB1 = mm_readB(batchB, globalRowB + 2 * tileRow + 1, globalCol);
    globalColA = globalColA + ${tileInner};
    globalRowB = globalRowB + ${tileInner};

    for (var t = 0; t < numTiles; t = t + 1) {
      mm_Asub[tileRow][tileCol] = regA;
      mm_Bsub[2 * tileRow][tileCol] = regB0;
      mm_Bsub[2 * tileRow + 1][tileCol] = regB1;

      workgroupBarrier();

      regA = mm_readA(batchA, globalRow, globalColA);
      regB0 = mm_readB(batchB, globalRowB + 2 * tileRow, globalCol);
      regB1 = mm_readB(batchB, globalRowB + 2 * tileRow + 1, globalCol);
      globalColA = globalColA + ${tileInner};
      globalRowB = globalRowB + ${tileInner};

      for (var k = 0; k < ${tileInner}; k = k + 1) {
        acc = acc + mm_Asub[tileRow][k] * mm_Bsub[k][tileCol];
      }
      workgroupBarrier();
    }

    mm_write(batch, globalRow, globalCol, acc);
  }
  `;
}
class $08b2d9066ff24851$export$6437443af4f6bfc0 {
    constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, bias = null, activation = null, preluActivationWeights = null){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.workgroupSize = [
            16,
            8,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0
            ]
        };
        this.dispatch = [
            Math.ceil(outputShape[2] / this.workgroupSize[0]),
            Math.ceil(outputShape[1] / this.workgroupSize[1]),
            outputShape[0]
        ];
        const addBias = bias != null;
        if (addBias) this.variableNames.push('bias');
        const hasPreluActivationWeights = preluActivationWeights != null;
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        this.shaderKey = `matMulSmallOutputSize_${this.activation}_${transposeA}_${transposeB}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivationWeights)}
      ${(0, $0257e34115d1bde3$export$be50c46a8ed085fb)(this.addBias, this.activation, this.transposeA, this.transposeB)}
      ${$08b2d9066ff24851$export$6a4ab46bf6cbb17(this.workgroupSize)}
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





class $ebb55abe2f965750$export$5ffddbb35586921b {
    constructor(outputShape, dimInner, transposeA = false, transposeB = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.workgroupSize = [
            8,
            8,
            1
        ];
        this.atomic = true;
        this.splitedDimInner = 128;
        (0, $0775da5e684c8c0d$exports).assert(outputShape[0] === 1, ()=>'MatMulSplitKProgram only supports batch = 1.');
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0,
                3
            ]
        };
        const isVec4 = (transposeA && this.outputShape[1] % 4 === 0 || !transposeA && dimInner % 4 === 0) && this.outputShape[2] % 4 === 0;
        this.elementsPerThread = [
            4,
            4,
            this.splitedDimInner
        ];
        this.outputComponent = isVec4 ? 4 : 1;
        if (!isVec4) {
            if (this.outputShape[1] < 16) this.elementsPerThread[1] = 1;
            if (this.outputShape[2] < 16) this.elementsPerThread[0] = 1;
        }
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, [
            this.outputShape[0],
            this.outputShape[1],
            this.outputShape[2],
            dimInner
        ], this.workgroupSize, this.elementsPerThread);
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.shaderKey = `matMulSplitK_${transposeA}_${transposeB}_${this.elementsPerThread}_${this.outputComponent}`;
    }
    getUserCode() {
        const component = this.outputComponent;
        const userCode = `
      ${(0, $0257e34115d1bde3$export$4831bc2078546fa)(false, this.transposeB, false, false, false, component)}
      fn mm_write(batch: i32, row : i32, col : i32, value : ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(component)}) {
        if (row < uniforms.dimAOuter && col < uniforms.dimBOuter) {
          let coords = vec3<i32>(batch, row, col);
          let flatIndex = getOutputIndexFromCoords(coords);
          // The problem is that we should initialize output to zero before using.
          // Otherwise, the original value will be added to the result.
          for (var i = 0; i < ${component}; i = i + 1) {
            ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[flatIndex + i]', `${component > 1 ? 'value[i]' : 'value'}`, 'float32')}
          }
        }
      }
      ${component === 4 ? (0, $0257e34115d1bde3$export$4690dafda830f3a)(this.elementsPerThread, this.workgroupSize, this.transposeA, 32, true, this.splitedDimInner) : (0, $0257e34115d1bde3$export$b3a48535ed1d015)(this.elementsPerThread, this.workgroupSize, this.transposeA, 32, true, this.splitedDimInner)}
    `;
        return userCode;
    }
}
class $ebb55abe2f965750$export$2533d1b002ed82e6 {
    constructor(outputShape, bias = null, activation = null, preluActivationWeights = null){
        this.uniforms = '';
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.addBias = bias != null;
        this.hasPreluActivationWeights = preluActivationWeights != null;
        this.activation = activation;
        if (this.addBias) this.variableNames.push('bias');
        if (this.hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.shaderKey = `biasActivation_${activation}`;
    }
    getUserCode() {
        return `
    ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivationWeights)}
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        var value = getXByOutputIndex(index);
        ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(this.addBias, this.activation)}
        setOutputAtIndex(index, value);
      }
    }
    `;
    }
}



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $90a4888a8dfcd559$export$758181b12323e997 {
    constructor(shape){
        this.variableNames = [];
        this.outputShape = [];
        this.uniforms = 'value : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'fill';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        setOutputAtIndex(index, uniforms.value);
      }
    }
  `;
        return userCode;
    }
}


function $3f7d95d3d0bb1b0d$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value } = attrs;
    let { dtype: dtype } = attrs;
    dtype = dtype || (0, $0775da5e684c8c0d$exports).inferDtype(value);
    if (dtype === 'string') {
        // String type should be handled in CPU memory.
        const values = (0, $0775da5e684c8c0d$exports).getArrayFromDType(dtype, (0, $0775da5e684c8c0d$exports).sizeFromShape(shape));
        values.fill(value);
        return backend.makeTensorInfo(shape, dtype, values);
    } else {
        const program = new (0, $90a4888a8dfcd559$export$758181b12323e997)(shape);
        const uniformData = [
            {
                type: 'float32',
                data: [
                    value
                ]
            }
        ];
        return backend.runWebGPUProgram(program, [], dtype, uniformData);
    }
}
const $3f7d95d3d0bb1b0d$export$c953bf474b2bde62 = {
    kernelName: (0, $507890e4aa8e1463$export$ffffe40bfa0649a3),
    backendName: 'webgpu',
    kernelFunc: $3f7d95d3d0bb1b0d$export$9563e054e6f787fb
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $22f5ef2885bdfdf5$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const $shape = (0, $0775da5e684c8c0d$exports).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape($shape);
    (0, $0775da5e684c8c0d$exports).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    // Backend needs to track refCount for the dataId for reshape op
    args.backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $22f5ef2885bdfdf5$export$cfa02e698602aca2 = {
    kernelName: (0, $507890e4aa8e1463$export$755ddd847e5abe03),
    backendName: 'webgpu',
    kernelFunc: $22f5ef2885bdfdf5$export$9eaad88cf88cee2b
};


function $75edebe28daa2228$export$d524d65e88e1168b({ a: a, b: b, transposeA: transposeA, transposeB: transposeB, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $0775da5e684c8c0d$exports).sizeFromShape(outerDimsA);
    const batchDimB = (0, $0775da5e684c8c0d$exports).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $5ede3b6f723b9f5a$exports).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $0775da5e684c8c0d$exports).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const intermediates = [
        a3d,
        b3d
    ];
    const batchDim = Math.max(batchDimA, batchDimB);
    const inputs = [
        a3d,
        b3d
    ];
    const dimensions = [
        {
            type: 'int32',
            data: [
                outerShapeA
            ]
        },
        {
            type: 'int32',
            data: [
                outerShapeB
            ]
        },
        {
            type: 'int32',
            data: [
                innerShapeA
            ]
        }
    ];
    let program;
    let out;
    const outputShape = [
        batchDim,
        outerShapeA,
        outerShapeB
    ];
    let matmulProgramType = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGPU_MATMUL_PROGRAM_TYPE');
    if (matmulProgramType < 0) {
        // Usually increasing workgroups is a good way to gain more performance for
        // few workgroups by tiling 32x32 (default matmul algorithm). Currently,
        // there are three ways to increase workgroups. 1) MatMulReduceProgram,
        // which is used only when the output size is very small (128 for now). 2)
        // MatMulSplitKProgram, increasing workgroups by spliting K. 3)
        // MatMulSmallOutputSizeProgram, increasing workgroups by small tile size.
        // For different devices, the minimum optimal workgroups may be different.
        // So here we set a |thresholdToIncreaseWorkgroups| to indicate whether we
        // need to increase workgroups. And the literal number is an empirical
        // value.
        const thresholdFlagValue = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGPU_THRESHOLD_TO_INCREASE_WORKGROUPS_FOR_MATMUL');
        const thresholdToIncreaseWorkgroups = thresholdFlagValue > 0 ? thresholdFlagValue : backend.thresholdToIncreaseWorkgroups;
        const workgroupsBy32x32 = batchDim * Math.ceil(outerShapeA / 32) * Math.ceil(outerShapeB / 32);
        const hasFewWorkgroups = workgroupsBy32x32 <= thresholdToIncreaseWorkgroups || outerShapeA <= 8 && workgroupsBy32x32 <= thresholdToIncreaseWorkgroups * 2;
        if (hasFewWorkgroups) {
            if (batchDim * outerShapeA * outerShapeB <= 128) matmulProgramType = (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulReduceProgram;
            else if (batchDim === 1 && innerShapeB >= 2000) matmulProgramType = (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulSplitKProgram;
            else matmulProgramType = (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulSmallOutputSizeProgram;
        } else matmulProgramType = (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulPackedProgram;
    }
    switch(matmulProgramType){
        case (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulReduceProgram:
            program = new (0, $f6ad7ef2c6e2d506$export$f47918074674a3c4)(outputShape, transposeA, transposeB, bias, activation, preluActivationWeights);
            break;
        case (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulSplitKProgram:
            // The output buffer must be initailzed to zero before using since we
            // use atomicAdd in MatMulSplitKProgram.
            out = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
                backend: backend,
                attrs: {
                    shape: outputShape,
                    value: 0,
                    dtype: a.dtype
                }
            });
            program = new (0, $ebb55abe2f965750$export$5ffddbb35586921b)(outputShape, innerShapeB, transposeA, transposeB);
            if (bias || activation) {
                out = backend.runWebGPUProgram(program, inputs, a.dtype, dimensions, out);
                const biasActivationProgram = new (0, $ebb55abe2f965750$export$2533d1b002ed82e6)(out.shape, bias, activation, preluActivationWeights);
                let uniformData = null;
                const activationInputs = [
                    out
                ];
                if (bias) activationInputs.push(bias);
                if (preluActivationWeights) activationInputs.push(preluActivationWeights);
                if (activation === 'leakyrelu') {
                    uniformData = [
                        {
                            type: 'float32',
                            data: [
                                leakyreluAlpha
                            ]
                        }
                    ];
                    biasActivationProgram.uniforms += ' alpha : f32,';
                }
                const outActivated = backend.runWebGPUProgram(biasActivationProgram, activationInputs, out.dtype, uniformData);
                intermediates.push(out);
                const outReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: outActivated
                    },
                    backend: backend,
                    attrs: {
                        shape: outShape
                    }
                });
                intermediates.push(outActivated);
                for (const i of intermediates)backend.disposeData(i.dataId);
                return outReshaped;
            }
            break;
        case (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulSmallOutputSizeProgram:
            program = new (0, $08b2d9066ff24851$export$6437443af4f6bfc0)(a3dShape, b3dShape, outputShape, transposeA, transposeB, bias, activation, preluActivationWeights);
            break;
        case (0, $8e83a93f95f027c6$export$b83d75b9ab62b8b5).MatMulPackedProgram:
            // Experiments show that sequential access is more friendly for Intel
            // GPUs.
            const sequentialAccessByThreads = backend.adapterInfo.isIntel();
            program = new (0, $0257e34115d1bde3$export$21e5f112101779d8)(a3dShape, outputShape, transposeA, transposeB, bias, activation, preluActivationWeights, sequentialAccessByThreads);
            break;
        default:
            throw new Error(`Unsupported MatMulProgramType ${matmulProgramType}.`);
    }
    if (bias) inputs.push(bias);
    if (preluActivationWeights) inputs.push(preluActivationWeights);
    if (activation === 'leakyrelu') {
        dimensions.push({
            type: 'float32',
            data: [
                leakyreluAlpha
            ]
        });
        program.uniforms += ' alpha : f32,';
    }
    out = backend.runWebGPUProgram(program, inputs, a.dtype, dimensions, out);
    const outReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    intermediates.push(out);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return outReshaped;
}


function $4a8e69a37bc0f2a9$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    return (0, $75edebe28daa2228$export$d524d65e88e1168b)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $4a8e69a37bc0f2a9$export$f70d36da1c218f84 = {
    kernelName: (0, $507890e4aa8e1463$export$8d1af0f7c2a4da9e),
    backendName: 'webgpu',
    kernelFunc: $4a8e69a37bc0f2a9$export$d86ca0bbe0236889
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



class $e0367f31fe83e16d$export$d4e4851a08b0c91 {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'AReal',
            'AImag',
            'BReal',
            'BImag'
        ];
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        this.outputShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `binaryOpComplex_${op}`;
        this.op = op;
    }
    getUserCode() {
        const opStr = (0, $41dab11c37c6072e$export$20c350df8f4933ab)(this.op, false);
        const userCode = `
      fn binaryOpComplex(
          areal : f32, aimag : f32, breal : f32, bimag : f32) -> f32 {
        ${opStr}
      }

      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if(index < uniforms.size) {
          let areal = getARealByOutputIndex(index);
          let aimag = getAImagByOutputIndex(index);
          let breal = getBRealByOutputIndex(index);
          let bimag = getBImagByOutputIndex(index);
          setOutputAtIndex(index, binaryOpComplex(areal, aimag, breal, bimag));
        }
      }
    `;
        return userCode;
    }
}



/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



class $a015d0a4804ef6be$export$9045e9161086790b {
    constructor(op, aShape, bShape){
        this.size = true;
        this.variableNames = [
            'A',
            'B'
        ];
        this.outputShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.op = op;
        this.useSharedMemoryWithA = aShape.length <= 1 && bShape.length > 1 && aShape[0] < 128;
        this.useSharedMemoryWithB = bShape.length <= 1 && aShape.length > 1 && bShape[0] < 128;
        if (this.useSharedMemoryWithA || this.useSharedMemoryWithB) {
            this.outputComponent = 1;
            this.variableComponents = [
                1,
                1
            ];
            // lastDimensionSize is used as sharedBuf array size, so can not be
            // used as uniform.
            this.lastDimensionSize = this.useSharedMemoryWithB ? bShape[0] : aShape[0];
            this.shaderKey = `binary_${op}_${this.lastDimensionSize}`;
            this.type = 'shared';
            // This is an experimental value when using shared memory.
            // Note that the maximum of workgroup X dimension is 256.
            this.workgroupSize = [
                256,
                1,
                1
            ];
        } else {
            const aDivisibleBy4 = aShape.length > 0 && aShape[aShape.length - 1] % 4 === 0;
            const bDivisibleBy4 = bShape.length > 0 && bShape[bShape.length - 1] % 4 === 0;
            if (aDivisibleBy4 && bDivisibleBy4) {
                this.outputComponent = 4;
                this.variableComponents = [
                    4,
                    4
                ];
            } else if (aDivisibleBy4 && ((0, $0775da5e684c8c0d$exports).isScalarShape(bShape) || bShape[bShape.length - 1] === 1) || bDivisibleBy4 && ((0, $0775da5e684c8c0d$exports).isScalarShape(aShape) || aShape[aShape.length - 1] === 1)) {
                this.outputComponent = 4;
                this.variableComponents = aDivisibleBy4 ? [
                    4,
                    1
                ] : [
                    1,
                    4
                ];
            } else {
                this.outputComponent = 1;
                this.variableComponents = [
                    1,
                    1
                ];
            }
            this.type = 'nonshared';
            this.shaderKey = `binary_${op}_${this.variableComponents}`;
            // TODO(jiajia.qin@intel.com): Heuristically select a good work group
            // size.
            this.workgroupSize = [
                128,
                1,
                1
            ];
        }
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.outputComponent,
            1,
            1
        ]);
    }
    getUserCode() {
        let userCode;
        const dType = this.outputComponent === 4 ? 'vec4<f32>' : 'f32';
        const opFnStr = `
    fn binaryOperation(a : ${dType}, b : ${dType}) -> ${dType} {
      ${(0, $41dab11c37c6072e$export$20c350df8f4933ab)(this.op, this.outputComponent === 4)}
    };
    `;
        if (this.type === 'shared') {
            const sharedIndexSnippet = this.lastDimensionSize > 1 ? `coords[${this.outputShape.length - 1}]` : '0';
            const accessDataSnippet = this.useSharedMemoryWithB ? `let a = getAByOutputIndex(index);
          let b = sharedBuf[${sharedIndexSnippet}];` : `let a = sharedBuf[${sharedIndexSnippet}];
          let b = getBByOutputIndex(index);`;
            userCode = `
        ${opFnStr}
        var<workgroup> sharedBuf : array<f32, ${this.lastDimensionSize}>;
        ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
          // Fill in the shared memory buffer.
          let localIndex = i32(localId.x);
          if(localIndex < ${this.lastDimensionSize}) {
            sharedBuf[localIndex] = f32(${this.useSharedMemoryWithB ? 'B' : 'A'}[localIndex]);
          }
          workgroupBarrier();

          if(index < uniforms.size) {
            let coords = getCoordsFromIndex(index);
            ${accessDataSnippet}
            setOutputAtIndex(index, binaryOperation(a, b));
          }
        }
        `;
        } else userCode = `
       ${opFnStr}
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         if (index < uniforms.size) {
           let coords = getCoordsFromIndex(index * ${this.outputComponent});
           let a = ${dType}(getAByOutputCoords(coords));
           let b = ${dType}(getBByOutputCoords(coords));
           setOutputAtIndex(index, binaryOperation(a, b));
         }
       }
       `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $c76b17881110536c$export$f0954fd7d5368655(args) {
    const { inputs: inputs } = args;
    const { x: x } = inputs;
    args.backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $c76b17881110536c$export$c426d3942537ad84 = {
    kernelName: (0, $507890e4aa8e1463$export$544bf02140fa9a77),
    backendName: 'webgpu',
    kernelFunc: $c76b17881110536c$export$f0954fd7d5368655
};


function $94b917209ffdee98$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.tensorMap.get(complexInfo.dataId);
    const realTensorInfo = (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: real
        },
        backend: backend
    });
    const imagTensorInfo = (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: imag
        },
        backend: backend
    });
    complex.complexTensorInfos = {
        real: realTensorInfo,
        imag: imagTensorInfo
    };
    return complexInfo;
}
const $94b917209ffdee98$export$67917f7910d27fd8 = {
    kernelName: (0, $507890e4aa8e1463$export$50ceb3fb9926e63e),
    backendName: 'webgpu',
    kernelFunc: $94b917209ffdee98$export$83a0e34f1302825b
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $8e98bd3037a606b3$export$f93811a5a466fd42 {
    constructor(outputShape, op, uniforms = ''){
        this.variableNames = [
            'A'
        ];
        this.size = true;
        // TODO(jiajia.qin@intel.com): Heuristically select a good work group size.
        const workgroupSizeX = 128;
        this.workgroupSize = [
            workgroupSizeX,
            1,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.op = op;
        if (uniforms !== '') this.uniforms = uniforms;
        this.shaderKey = `unary_${op}`;
    }
    getUserCode() {
        return `
      fn unaryOperation(a : f32) -> f32 {
        ${(0, $4af106881f0be485$export$bf824beefaa2c9b9)(this.op, false)}
      }
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let a = getAByOutputIndex(index);
          setOutputAtIndex(index, unaryOperation(a));
        }
      }
      `;
    }
}


function $55ff9472592af91d$export$ba4daf5748026fba({ opType: opType, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webgpuBackend = backend;
        const $dtype = dtype || x.dtype;
        if (webgpuBackend.shouldExecuteOnCPU([
            x
        ]) && cpuKernelImpl != null) {
            const xData = webgpuBackend.tensorMap.get(x.dataId);
            const outValues = cpuKernelImpl(xData.values, $dtype);
            return webgpuBackend.makeTensorInfo(x.shape, $dtype, outValues);
        }
        const program = new (0, $8e98bd3037a606b3$export$f93811a5a466fd42)(x.shape, opType);
        return webgpuBackend.runWebGPUProgram(program, [
            x
        ], $dtype);
    };
}
function $55ff9472592af91d$export$29353c66e70e3e16({ opType: opType, cpuKernelImpl: cpuKernelImpl, supportsComplex: supportsComplex = false, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const webgpuBackend = backend;
        if (supportsComplex && a.dtype === 'complex64') {
            const aData = webgpuBackend.tensorMap.get(a.dataId);
            const bData = webgpuBackend.tensorMap.get(b.dataId);
            let real, imag;
            if (opType !== (0, $41dab11c37c6072e$export$e5d009af261ea0bd).MUL) [real, imag] = [
                [
                    aData.complexTensorInfos.real,
                    bData.complexTensorInfos.real
                ],
                [
                    aData.complexTensorInfos.imag,
                    bData.complexTensorInfos.imag
                ]
            ].map((complexParts)=>{
                const [aPart, bPart] = complexParts;
                const aHandle = {
                    dataId: aPart.dataId,
                    dtype: aPart.dtype,
                    shape: a.shape
                };
                const bHandle = {
                    dataId: bPart.dataId,
                    dtype: bPart.dtype,
                    shape: b.shape
                };
                const program = new (0, $a015d0a4804ef6be$export$9045e9161086790b)(opType, a.shape, b.shape);
                return webgpuBackend.runWebGPUProgram(program, [
                    aHandle,
                    bHandle
                ], (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(aPart.dtype, bPart.dtype));
            });
            else {
                const realProgram = new (0, $e0367f31fe83e16d$export$d4e4851a08b0c91)((0, $41dab11c37c6072e$export$e5d009af261ea0bd).COMPLEX_MULTIPLY_REAL, a.shape, b.shape);
                const imagProgram = new (0, $e0367f31fe83e16d$export$d4e4851a08b0c91)((0, $41dab11c37c6072e$export$e5d009af261ea0bd).COMPLEX_MULTIPLY_IMAG, a.shape, b.shape);
                const inputs = [
                    {
                        dataId: aData.complexTensorInfos.real.dataId,
                        dtype: aData.complexTensorInfos.real.dtype,
                        shape: a.shape
                    },
                    {
                        dataId: aData.complexTensorInfos.imag.dataId,
                        dtype: aData.complexTensorInfos.imag.dtype,
                        shape: a.shape
                    },
                    {
                        dataId: bData.complexTensorInfos.real.dataId,
                        dtype: bData.complexTensorInfos.real.dtype,
                        shape: b.shape
                    },
                    {
                        dataId: bData.complexTensorInfos.imag.dataId,
                        dtype: bData.complexTensorInfos.imag.dtype,
                        shape: b.shape
                    }
                ];
                real = webgpuBackend.runWebGPUProgram(realProgram, inputs, 'float32');
                imag = webgpuBackend.runWebGPUProgram(imagProgram, inputs, 'float32');
            }
            const complexOutput = (0, $94b917209ffdee98$export$83a0e34f1302825b)({
                inputs: {
                    real: real,
                    imag: imag
                },
                backend: webgpuBackend
            });
            webgpuBackend.disposeData(real.dataId);
            webgpuBackend.disposeData(imag.dataId);
            // TODO: Implement CPU forwarding for complex inputs.
            return complexOutput;
        }
        const $dtype = dtype || (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(a.dtype, b.dtype);
        if ((a.dtype === 'string' || b.dtype === 'string' || webgpuBackend.shouldExecuteOnCPU([
            a,
            b
        ])) && cpuKernelImpl != null) {
            const aData = webgpuBackend.tensorMap.get(a.dataId).values;
            const bData = webgpuBackend.tensorMap.get(b.dataId).values;
            const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(aData) : aData;
            const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(bData) : bData;
            const [outValues, outShape] = cpuKernelImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
            return webgpuBackend.makeTensorInfo(outShape, $dtype, outValues);
        }
        const program = new (0, $a015d0a4804ef6be$export$9045e9161086790b)(opType, a.shape, b.shape);
        return webgpuBackend.runWebGPUProgram(program, [
            a,
            b
        ], $dtype);
    };
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import shared functionality from tfjs-backend-cpu without triggering
// side effects.
// tslint:disable-next-line: no-imports-from-dist
var $f98ae2f32496d64b$exports = {};

$parcel$export($f98ae2f32496d64b$exports, "simpleAbsImpl", () => $142f0506fd3f1bd4$export$9e7ee8a1798ec2d5);
$parcel$export($f98ae2f32496d64b$exports, "addImpl", () => $d51297083cd4dcf4$export$da57353b24bb5e2);
$parcel$export($f98ae2f32496d64b$exports, "bincountImpl", () => $3cd4be26b3a4ca69$export$8e4da6ec633bf0a6);
$parcel$export($f98ae2f32496d64b$exports, "bincountReduceImpl", () => $3cd4be26b3a4ca69$export$486b8d48edd28ba5);
$parcel$export($f98ae2f32496d64b$exports, "bitwiseAndImpl", () => $c4a93011a75a9af7$export$54cf4ba005fa5753);
$parcel$export($f98ae2f32496d64b$exports, "castImpl", () => $22414033e91aa74f$export$aeeb3b33e2cee0c5);
$parcel$export($f98ae2f32496d64b$exports, "ceilImpl", () => $5718e0ed0374d07d$export$72486f20c97f6da8);
$parcel$export($f98ae2f32496d64b$exports, "concatImpl", () => $6db2bf0b85f411fe$export$777da59f594f497d);
$parcel$export($f98ae2f32496d64b$exports, "equalImpl", () => $a8dda2d7e9604f42$export$437b1c87795f120c);
$parcel$export($f98ae2f32496d64b$exports, "expImpl", () => $8dc2eea54c564baf$export$823000b70594f385);
$parcel$export($f98ae2f32496d64b$exports, "expm1Impl", () => $fa62db6857868c29$export$44f6c1b1ff8db911);
$parcel$export($f98ae2f32496d64b$exports, "floorImpl", () => $7254067addf8017a$export$c365361068e97c87);
$parcel$export($f98ae2f32496d64b$exports, "floorDivImpl", () => $9e265eba6c98753b$export$9b7f64e28e98c78e);
$parcel$export($f98ae2f32496d64b$exports, "gatherNdImpl", () => $feb10806205d6e6a$export$eed1912b07a3c4d5);
$parcel$export($f98ae2f32496d64b$exports, "gatherV2Impl", () => $41f5da26ebfd1651$export$d7b732f2e62ccc09);
$parcel$export($f98ae2f32496d64b$exports, "greaterImpl", () => $bee7da2c2bd93509$export$bec57aa1d63b78bc);
$parcel$export($f98ae2f32496d64b$exports, "greaterEqualImpl", () => $c843ce6d423a18c5$export$3cea60aeb61ae586);
$parcel$export($f98ae2f32496d64b$exports, "lessImpl", () => $56eb90096c99b65c$export$d4d22ddbe6cd91a5);
$parcel$export($f98ae2f32496d64b$exports, "lessEqualImpl", () => $73c56c43675cbad2$export$27397851733876fa);
$parcel$export($f98ae2f32496d64b$exports, "linSpaceImpl", () => $81844f357056deb0$export$31412d657cd1cc08);
$parcel$export($f98ae2f32496d64b$exports, "logImpl", () => $6d04d7e0e7fb9b2b$export$8a107ec4d5b0e907);
$parcel$export($f98ae2f32496d64b$exports, "maxImpl", () => $6668f530b9e82f81$export$23c9b99bdac85be0);
$parcel$export($f98ae2f32496d64b$exports, "maximumImpl", () => $5e945553d2d795af$export$4e233ba825c9b60e);
$parcel$export($f98ae2f32496d64b$exports, "minimumImpl", () => $f1b94e222cb7b008$export$756c08a3fa64d43);
$parcel$export($f98ae2f32496d64b$exports, "multiplyImpl", () => $e84bd8ea73d7be0a$export$ac59ae2be94ddda3);
$parcel$export($f98ae2f32496d64b$exports, "negImpl", () => $ffed232f6791b4ba$export$e9053236ce0e659b);
$parcel$export($f98ae2f32496d64b$exports, "notEqualImpl", () => $71381bef5919bc10$export$eaea354630818ed4);
$parcel$export($f98ae2f32496d64b$exports, "prodImpl", () => $020b2810bf048546$export$a3c8a5271f6bb700);
$parcel$export($f98ae2f32496d64b$exports, "raggedGatherImpl", () => $7830d508d2e3908a$export$4104e3de41455909);
$parcel$export($f98ae2f32496d64b$exports, "raggedRangeImpl", () => $dc1e6ed86fd108ed$export$af0dda5a37ea8d94);
$parcel$export($f98ae2f32496d64b$exports, "raggedTensorToTensorImpl", () => $a9fb102be0671807$export$8194a77b1066327a);
$parcel$export($f98ae2f32496d64b$exports, "rangeImpl", () => $8bf82964e317b635$export$3561205b7dff20bf);
$parcel$export($f98ae2f32496d64b$exports, "rsqrtImpl", () => $e844ac4e57f9ec81$export$7ec24de9bffc6b90);
$parcel$export($f98ae2f32496d64b$exports, "scatterImpl", () => $9b4b860bbaecdb6c$export$5fc9b0358a19bd54);
$parcel$export($f98ae2f32496d64b$exports, "sigmoidImpl", () => $7d9b05c0233bd3bd$export$e31bae35ce8238b3);
$parcel$export($f98ae2f32496d64b$exports, "sliceImpl", () => $832ffd19544f6b8c$export$4bdf1ac3fa5d3d6a);
$parcel$export($f98ae2f32496d64b$exports, "sparseFillEmptyRowsImpl", () => $6a2235a7ce50ff56$export$9db01208a1bec190);
$parcel$export($f98ae2f32496d64b$exports, "sparseReshapeImpl", () => $ad3735f9cbaccd53$export$a65a15ebab81f5cd);
$parcel$export($f98ae2f32496d64b$exports, "sparseSegmentReductionImpl", () => $3a28707787dbe8b5$export$7d3f7130c4245e65);
$parcel$export($f98ae2f32496d64b$exports, "sqrtImpl", () => $c3b2ce83ba7256ac$export$c6f4fdf945028fb);
$parcel$export($f98ae2f32496d64b$exports, "squaredDifferenceImpl", () => $5f830d81433de8bd$export$11806d7b3158c032);
$parcel$export($f98ae2f32496d64b$exports, "staticRegexReplaceImpl", () => $239eecea1da1670e$export$d0ac9d977b12e2a1);
$parcel$export($f98ae2f32496d64b$exports, "stridedSliceImpl", () => $a91b14678dc9e667$export$b7c450ffe7e10d88);
$parcel$export($f98ae2f32496d64b$exports, "stringNGramsImpl", () => $922bdc759a835cbf$export$67c0958e8184138b);
$parcel$export($f98ae2f32496d64b$exports, "stringSplitImpl", () => $f02c467c2a81fd0f$export$c3b08e43aa36d65d);
$parcel$export($f98ae2f32496d64b$exports, "stringToHashBucketFastImpl", () => $25c6d5afb1fded19$export$37cbed4d0b2fe56a);
$parcel$export($f98ae2f32496d64b$exports, "subImpl", () => $9ce3a9c9010ae9e5$export$ad8defe68e22c8c1);
$parcel$export($f98ae2f32496d64b$exports, "tileImpl", () => $cac0bebccf7fd356$export$f3e554b937559516);
$parcel$export($f98ae2f32496d64b$exports, "topKImpl", () => $4c965e30a142cad8$export$b083239978762299);
$parcel$export($f98ae2f32496d64b$exports, "transposeImpl", () => $be7c4e293326eeb4$export$986b9e65182e08d);
$parcel$export($f98ae2f32496d64b$exports, "uniqueImpl", () => $7bddd9b297c4c91f$export$58be9cc013c994e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Shared functionality among backends.
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $2db2fd12687c5dab$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $0775da5e684c8c0d$exports).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors in the CPU backend.`);
    });
}


function $142f0506fd3f1bd4$export$9e7ee8a1798ec2d5(vals) {
    const resultValues = new Float32Array(vals.length);
    for(let i = 0; i < vals.length; ++i)resultValues[i] = Math.abs(vals[i]);
    return resultValues;
}
const $142f0506fd3f1bd4$export$2335f513bbd82c6d = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    (0, $2db2fd12687c5dab$export$1412c17b2531581a)(x, 'abs');
    let resultValues = new Float32Array((0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape));
    const values = cpuBackend.data.get(x.dataId).values;
    resultValues = $142f0506fd3f1bd4$export$9e7ee8a1798ec2d5(values);
    return cpuBackend.makeOutput(resultValues, x.shape, x.dtype);
};
const $142f0506fd3f1bd4$export$d66f48648b9d5ec7 = {
    kernelName: (0, $507890e4aa8e1463$export$b73c596ee8758a66),
    backendName: 'cpu',
    kernelFunc: $142f0506fd3f1bd4$export$2335f513bbd82c6d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $513c1c901b9c8a48$export$28de919591fae5d9(op) {
    return (aShape, bShape, aVals, bVals, dtype)=>{
        const newShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        const resultRank = newShape.length;
        const resultStrides = (0, $0775da5e684c8c0d$exports).computeStrides(newShape);
        const resultSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(newShape);
        const result = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType(dtype, resultSize);
        const aRank = aShape.length;
        const bRank = bShape.length;
        const aStrides = (0, $0775da5e684c8c0d$exports).computeStrides(aShape);
        const bStrides = (0, $0775da5e684c8c0d$exports).computeStrides(bShape);
        const aBroadcastDims = (0, $f35e0c1a651337db$exports).getBroadcastDims(aShape, newShape);
        const bBroadcastDims = (0, $f35e0c1a651337db$exports).getBroadcastDims(bShape, newShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < result.length; ++i)result[i] = op(aVals[i % aVals.length], bVals[i % bVals.length]);
        else for(let i = 0; i < result.length; ++i){
            const loc = (0, $0775da5e684c8c0d$exports).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $0775da5e684c8c0d$exports).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $0775da5e684c8c0d$exports).locToIndex(bLoc, bRank, bStrides);
            result[i] = op(aVals[aIndex], bVals[bIndex]);
        }
        return [
            result,
            newShape
        ];
    };
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $1d8c4f7b0c87167d$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const realVals = backend.data.get(real.dataId).values;
    const imagVals = backend.data.get(imag.dataId).values;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.data.get(complexInfo.dataId);
    // The complex tensor owns the underlying real and imag tensorInfos, only the
    // complex tensor tracks refCount, when complexData is disposed the
    // underlying tensorData will be disposed.
    complex.complexTensorInfos = {
        real: backend.makeTensorInfo(real.shape, 'float32', realVals),
        imag: backend.makeTensorInfo(imag.shape, 'float32', imagVals)
    };
    return complexInfo;
}
const $1d8c4f7b0c87167d$export$67917f7910d27fd8 = {
    kernelName: (0, $507890e4aa8e1463$export$50ceb3fb9926e63e),
    backendName: 'cpu',
    kernelFunc: $1d8c4f7b0c87167d$export$83a0e34f1302825b
};


function $7bee567246c396d5$export$4445a00dafa2633b(backend, shape, dtype = 'float32') {
    if (dtype === 'complex64') {
        const real = $7bee567246c396d5$export$4445a00dafa2633b(backend, shape, 'float32');
        const imag = $7bee567246c396d5$export$4445a00dafa2633b(backend, shape, 'float32');
        return (0, $1d8c4f7b0c87167d$export$83a0e34f1302825b)({
            inputs: {
                real: real,
                imag: imag
            },
            backend: backend
        });
    }
    const values = (0, $0775da5e684c8c0d$exports).makeZerosTypedArray((0, $0775da5e684c8c0d$exports).sizeFromShape(shape), dtype);
    return backend.makeTensorInfo(shape, dtype, values);
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $588756ee0590e667$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $588756ee0590e667$export$c426d3942537ad84 = {
    kernelName: (0, $507890e4aa8e1463$export$544bf02140fa9a77),
    backendName: 'cpu',
    kernelFunc: $588756ee0590e667$export$f0954fd7d5368655
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $e349b7b123dd9bbe$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const real = backend.data.get(input.dataId).complexTensorInfos.real;
    const realVal = backend.data.get(real.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the real value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(real.shape, real.dtype, realVal);
}
const $e349b7b123dd9bbe$export$4b7bce57557ae68b = {
    kernelName: (0, $507890e4aa8e1463$export$f41305719b94e675),
    backendName: 'cpu',
    kernelFunc: $e349b7b123dd9bbe$export$9fc57fb453bdbd67
};


function $22414033e91aa74f$export$aeeb3b33e2cee0c5(values, shape, inputType, dtype) {
    if (dtype === 'int32') {
        const resultValues = Int32Array.from(values);
        return [
            shape,
            'int32',
            resultValues
        ];
    }
    if (dtype === 'bool') {
        // This is essentially the result of notEqual(x, 0). We avoid using
        // kernel notEqual to avoid circular dependency, i.e. binary_utils ->
        // cast -> notEqual -> binary_utils.
        const zero = (0, $0775da5e684c8c0d$exports).toTypedArray([
            0
        ], inputType);
        const [resultData, resultShape] = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a !== b ? 1 : 0)(shape, [], values, zero, 'bool');
        return [
            resultShape,
            'bool',
            resultData
        ];
    }
    throw new Error(`Error in Cast: failed to cast ${inputType} to ${dtype}`);
}
function $22414033e91aa74f$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $588756ee0590e667$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        const zerosTensorInfo = (0, $7bee567246c396d5$export$4445a00dafa2633b)(backend, x.shape, x.dtype);
        const floatX = $22414033e91aa74f$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $1d8c4f7b0c87167d$export$83a0e34f1302825b)({
            inputs: {
                real: floatX,
                imag: zerosTensorInfo
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $e349b7b123dd9bbe$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $22414033e91aa74f$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $0775da5e684c8c0d$exports).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $588756ee0590e667$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    const values = backend.data.get(x.dataId).values;
    const [resultShape, resultType, resultData] = $22414033e91aa74f$export$aeeb3b33e2cee0c5(values, x.shape, x.dtype, dtype);
    return backend.makeTensorInfo(resultShape, resultType, resultData);
}
const $22414033e91aa74f$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $507890e4aa8e1463$export$107ecfb3d1ccbd77),
    backendName: 'cpu',
    kernelFunc: $22414033e91aa74f$export$f2db7d5238e1d23f
};



function $350425b01c678d60$export$29353c66e70e3e16(name, simpleImpl, complexImpl, dtype) {
    if (complexImpl == null) return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        (0, $2db2fd12687c5dab$export$1412c17b2531581a)([
            a,
            b
        ], name);
        const aVals = cpuBackend.data.get(a.dataId).values;
        const bVals = cpuBackend.data.get(b.dataId).values;
        const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(aVals) : aVals;
        const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(bVals) : bVals;
        const $dtype = dtype || a.dtype;
        const [resultData, resultShape] = simpleImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
        return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
    };
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
            const $aComplex = (0, $22414033e91aa74f$export$f2db7d5238e1d23f)({
                inputs: {
                    x: a
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $aComplexVals = cpuBackend.data.get($aComplex.dataId);
            const aReal = $aComplexVals.complexTensorInfos.real;
            const aImag = $aComplexVals.complexTensorInfos.imag;
            const aRealVals = cpuBackend.data.get(aReal.dataId).values;
            const aImagVals = cpuBackend.data.get(aImag.dataId).values;
            const $bComplex = (0, $22414033e91aa74f$export$f2db7d5238e1d23f)({
                inputs: {
                    x: b
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $bComplexVals = cpuBackend.data.get($bComplex.dataId);
            const bReal = $bComplexVals.complexTensorInfos.real;
            const bImag = $bComplexVals.complexTensorInfos.imag;
            const bRealVals = cpuBackend.data.get(bReal.dataId).values;
            const bImagVals = cpuBackend.data.get(bImag.dataId).values;
            const [resultRealData, resultImagData, resultShape] = complexImpl(a.shape, b.shape, aRealVals, aImagVals, bRealVals, bImagVals);
            const resultReal = cpuBackend.makeTensorInfo(resultShape, 'float32', resultRealData);
            const resultImag = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImagData);
            const result = (0, $1d8c4f7b0c87167d$export$83a0e34f1302825b)({
                inputs: {
                    real: resultReal,
                    imag: resultImag
                },
                backend: cpuBackend
            });
            cpuBackend.disposeIntermediateTensorInfo($aComplex);
            cpuBackend.disposeIntermediateTensorInfo($bComplex);
            cpuBackend.disposeIntermediateTensorInfo(resultReal);
            cpuBackend.disposeIntermediateTensorInfo(resultImag);
            return result;
        } else {
            const aVals = cpuBackend.data.get(a.dataId).values;
            const bVals = cpuBackend.data.get(b.dataId).values;
            const $dtype = dtype || a.dtype;
            const [resultData, resultShape] = simpleImpl(a.shape, b.shape, aVals, bVals, $dtype);
            return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
        }
    };
}
function $350425b01c678d60$export$79261d982c3c14a7(op) {
    return (aShape, bShape, aRealVals, aImagVals, bRealVals, bImagVals)=>{
        const resultShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        const resultSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(resultShape);
        const resultRank = resultShape.length;
        const resultStrides = (0, $0775da5e684c8c0d$exports).computeStrides(resultShape);
        const resultRealVals = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType('float32', resultSize);
        const resultImagVals = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType('float32', resultSize);
        const aBroadcastDims = (0, $f35e0c1a651337db$exports).getBroadcastDims(aShape, resultShape);
        const bBroadcastDims = (0, $f35e0c1a651337db$exports).getBroadcastDims(bShape, resultShape);
        const aVals = (0, $f35e0c1a651337db$exports).mergeRealAndImagArrays(aRealVals, aImagVals);
        const bVals = (0, $f35e0c1a651337db$exports).mergeRealAndImagArrays(bRealVals, bImagVals);
        const aRank = aShape.length;
        const aStrides = (0, $0775da5e684c8c0d$exports).computeStrides(aShape);
        const bRank = bShape.length;
        const bStrides = (0, $0775da5e684c8c0d$exports).computeStrides(bShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < resultRealVals.length; i++){
            const aIdx = i % aVals.length;
            const bIdx = i % bVals.length;
            const result = op(aVals[aIdx * 2], aVals[aIdx * 2 + 1], bVals[bIdx * 2], bVals[bIdx * 2 + 1]);
            resultRealVals[i] = result.real;
            resultImagVals[i] = result.imag;
        }
        else for(let i = 0; i < resultRealVals.length; i++){
            const loc = (0, $0775da5e684c8c0d$exports).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $0775da5e684c8c0d$exports).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $0775da5e684c8c0d$exports).locToIndex(bLoc, bRank, bStrides);
            const opResult = op(aVals[aIndex * 2], aVals[aIndex * 2 + 1], bVals[bIndex * 2], bVals[bIndex * 2 + 1]);
            resultRealVals[i] = opResult.real;
            resultImagVals[i] = opResult.imag;
        }
        return [
            resultRealVals,
            resultImagVals,
            resultShape
        ];
    };
}


const $d51297083cd4dcf4$export$da57353b24bb5e2 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a + b);
const $d51297083cd4dcf4$export$ace1d0de36b43ba2 = (0, $350425b01c678d60$export$79261d982c3c14a7)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal + bReal,
        imag: aImag + bImag
    };
});
const $d51297083cd4dcf4$export$e16d8520af44a096 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$d0265b2c425512d6), $d51297083cd4dcf4$export$da57353b24bb5e2, $d51297083cd4dcf4$export$ace1d0de36b43ba2);
const $d51297083cd4dcf4$export$b1f3a580afb68e4c = {
    kernelName: (0, $507890e4aa8e1463$export$d0265b2c425512d6),
    backendName: 'cpu',
    kernelFunc: $d51297083cd4dcf4$export$e16d8520af44a096
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $3cd4be26b3a4ca69$export$8e4da6ec633bf0a6(xVals, weightsVals, weightsDtype, weightsShape, size) {
    const weightsSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(weightsShape);
    const outVals = (0, $0775da5e684c8c0d$exports).makeZerosTypedArray(size, weightsDtype);
    for(let i = 0; i < xVals.length; i++){
        const value = xVals[i];
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (weightsSize > 0) outVals[value] += weightsVals[i];
        else outVals[value] += 1;
    }
    return outVals;
}
function $3cd4be26b3a4ca69$export$486b8d48edd28ba5(xBuf, weightsBuf, size, binaryOutput = false) {
    const numRows = xBuf.shape[0];
    const numCols = xBuf.shape[1];
    const outBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)([
        numRows,
        size
    ], weightsBuf.dtype);
    for(let i = 0; i < numRows; i++)for(let j = 0; j < numCols; j++){
        const value = xBuf.get(i, j);
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (binaryOutput) outBuf.set(1, i, value);
        else if (weightsBuf.size > 0) outBuf.set(outBuf.get(i, value) + weightsBuf.get(i, j), i, value);
        else outBuf.set(outBuf.get(i, value) + 1, i, value);
    }
    return outBuf;
}


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $c4a93011a75a9af7$export$54cf4ba005fa5753 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a & b);
const $c4a93011a75a9af7$export$84529b0ad3b42cd1 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$a9e259e32a62221f), $c4a93011a75a9af7$export$54cf4ba005fa5753);
const $c4a93011a75a9af7$export$6d53927dafa38bf9 = {
    kernelName: (0, $507890e4aa8e1463$export$a9e259e32a62221f),
    backendName: 'cpu',
    kernelFunc: $c4a93011a75a9af7$export$84529b0ad3b42cd1
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $25d955d75de86d0d$export$ef8b4452872ef3fc(op) {
    return (values, dtype, attrs)=>{
        const newValues = (0, $0775da5e684c8c0d$exports).getArrayFromDType(dtype, values.length);
        for(let i = 0; i < values.length; ++i)newValues[i] = op(values[i], attrs);
        return newValues;
    };
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $daf1a402932b3109$export$ba4daf5748026fba(name, op, dtype) {
    const impl = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)(op);
    return $daf1a402932b3109$export$34f6865a07ad09b6(name, impl, dtype);
}
function $daf1a402932b3109$export$34f6865a07ad09b6(name, unaryImpl, dtype) {
    return ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        (0, $2db2fd12687c5dab$export$1412c17b2531581a)(x, name);
        const cpuBackend = backend;
        const values = cpuBackend.data.get(x.dataId).values;
        let decoded;
        if (x.dtype === 'string') {
            if (!Array.isArray(values)) throw new Error('String tensor\'s value was not an instance of Array');
            decoded = (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(values);
        } else decoded = values;
        const $dtype = dtype || x.dtype;
        const newValues = unaryImpl(decoded, $dtype, attrs);
        return cpuBackend.makeTensorInfo(x.shape, $dtype, newValues);
    };
}


const $5718e0ed0374d07d$export$72486f20c97f6da8 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>Math.ceil(xi));
const $5718e0ed0374d07d$export$803ce6b71a0a94b2 = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$d4a1bccfd52ebd3), $5718e0ed0374d07d$export$72486f20c97f6da8);
const $5718e0ed0374d07d$export$df387212b1898306 = {
    kernelName: (0, $507890e4aa8e1463$export$d4a1bccfd52ebd3),
    backendName: 'cpu',
    kernelFunc: $5718e0ed0374d07d$export$803ce6b71a0a94b2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $6db2bf0b85f411fe$export$777da59f594f497d(inputs, outShape, dtype, simplyConcat) {
    const outVals = (0, $0775da5e684c8c0d$exports).getArrayFromDType(dtype, (0, $0775da5e684c8c0d$exports).sizeFromShape(outShape));
    if (simplyConcat && dtype !== 'string') {
        // Use built-in TypedArray.set() method for speed.
        let offset = 0;
        inputs.forEach((input)=>{
            const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape);
            outVals.set(input.vals, offset);
            offset += size;
        });
    } else {
        let colOffset = 0;
        inputs.forEach((input)=>{
            const decodedData = dtype === 'string' ? (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(input.vals) : input.vals;
            let tIdx = 0;
            for(let row = 0; row < input.shape[0]; ++row){
                const resIdx = row * outShape[1] + colOffset;
                for(let col = 0; col < input.shape[1]; ++col)outVals[resIdx + col] = decodedData[tIdx++];
            }
            colOffset += input.shape[1];
        });
    }
    return outVals;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $a8dda2d7e9604f42$export$437b1c87795f120c = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a === b ? 1 : 0);
const $a8dda2d7e9604f42$export$411ce8e5a71e3069 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$8dcf9f58ce5cdfc), $a8dda2d7e9604f42$export$437b1c87795f120c, null, 'bool');
const $a8dda2d7e9604f42$export$3c8bc3d8ee318217 = {
    kernelName: (0, $507890e4aa8e1463$export$8dcf9f58ce5cdfc),
    backendName: 'cpu',
    kernelFunc: $a8dda2d7e9604f42$export$411ce8e5a71e3069
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $8dc2eea54c564baf$export$823000b70594f385 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>Math.exp(xi));
const $8dc2eea54c564baf$export$b310ec824aaee37f = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$f908be7a96fb3363), $8dc2eea54c564baf$export$823000b70594f385, 'float32');
const $8dc2eea54c564baf$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $507890e4aa8e1463$export$f908be7a96fb3363),
    backendName: 'cpu',
    kernelFunc: $8dc2eea54c564baf$export$b310ec824aaee37f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $fa62db6857868c29$export$44f6c1b1ff8db911 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>Math.expm1(xi));
const $fa62db6857868c29$export$b6c0a80d46d3391d = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$261f26143a1ff3), $fa62db6857868c29$export$44f6c1b1ff8db911);
const $fa62db6857868c29$export$16db8a08b36f938 = {
    kernelName: (0, $507890e4aa8e1463$export$261f26143a1ff3),
    backendName: 'cpu',
    kernelFunc: $fa62db6857868c29$export$b6c0a80d46d3391d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $7254067addf8017a$export$c365361068e97c87 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>Math.floor(xi));
const $7254067addf8017a$export$a3fe094919f356fd = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$4880b0ae5643c62b), $7254067addf8017a$export$c365361068e97c87);
const $7254067addf8017a$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $507890e4aa8e1463$export$4880b0ae5643c62b),
    backendName: 'cpu',
    kernelFunc: $7254067addf8017a$export$a3fe094919f356fd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $9e265eba6c98753b$export$9b7f64e28e98c78e = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>Math.floor(a / b));
const $9e265eba6c98753b$export$112397bc52715a8 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$d79b5692ede26c2f), $9e265eba6c98753b$export$9b7f64e28e98c78e, null, 'int32');
const $9e265eba6c98753b$export$7eac933a0c7fd37f = {
    kernelName: (0, $507890e4aa8e1463$export$d79b5692ede26c2f),
    backendName: 'cpu',
    kernelFunc: $9e265eba6c98753b$export$112397bc52715a8
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $feb10806205d6e6a$export$eed1912b07a3c4d5(indicesData, paramsBuf, dtype, numSlices, sliceRank, sliceSize, strides, paramsShape, paramsSize) {
    const outBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)([
        numSlices,
        sliceSize
    ], dtype);
    for(let i = 0; i < numSlices; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            flattenIndex += dim * strides[j];
            index.push(dim);
        }
        if (flattenIndex < 0 || flattenIndex >= paramsSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${paramsShape}`);
        for(let k = 0; k < sliceSize; k++)outBuf.values[i * sliceSize + k] = paramsBuf.get(...paramsBuf.indexToLoc(flattenIndex * sliceSize + k));
    }
    return outBuf;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $41f5da26ebfd1651$export$d7b732f2e62ccc09(xBuf, indicesBuf, flattenOutputShape) {
    const outBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(flattenOutputShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const newLoc = outBuf.indexToLoc(i);
        const originalLoc = newLoc.slice();
        const batchIdx = originalLoc[0];
        const indicesIdx = originalLoc[2];
        const indicesIndex = indicesBuf.locToIndex([
            batchIdx,
            indicesIdx
        ]);
        originalLoc[2] = indicesBuf.values[indicesIndex];
        const originalIndex = xBuf.locToIndex(originalLoc);
        if (0 <= originalIndex && originalIndex < xBuf.values.length) outBuf.values[i] = xBuf.values[originalIndex];
         // Else, index is out of bounds, so leave the default zero val in outBuf.
    }
    return outBuf;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $bee7da2c2bd93509$export$bec57aa1d63b78bc = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a > b ? 1 : 0);
const $bee7da2c2bd93509$export$9dca161faaf6308b = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$d0a25eac5ee3f515), $bee7da2c2bd93509$export$bec57aa1d63b78bc, null, 'bool');
const $bee7da2c2bd93509$export$8c4f7e92d92310f8 = {
    kernelName: (0, $507890e4aa8e1463$export$d0a25eac5ee3f515),
    backendName: 'cpu',
    kernelFunc: $bee7da2c2bd93509$export$9dca161faaf6308b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $c843ce6d423a18c5$export$3cea60aeb61ae586 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a >= b ? 1 : 0);
const $c843ce6d423a18c5$export$c2fd4164cadc1fa2 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$3b7d21bc9aee0851), $c843ce6d423a18c5$export$3cea60aeb61ae586, null, 'bool');
const $c843ce6d423a18c5$export$7a6926f9fcac24ca = {
    kernelName: (0, $507890e4aa8e1463$export$3b7d21bc9aee0851),
    backendName: 'cpu',
    kernelFunc: $c843ce6d423a18c5$export$c2fd4164cadc1fa2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $56eb90096c99b65c$export$d4d22ddbe6cd91a5 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a < b ? 1 : 0);
const $56eb90096c99b65c$export$bb1a638da8ad190f = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$728c50f1c88ac779), $56eb90096c99b65c$export$d4d22ddbe6cd91a5, null, 'bool');
const $56eb90096c99b65c$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $507890e4aa8e1463$export$728c50f1c88ac779),
    backendName: 'cpu',
    kernelFunc: $56eb90096c99b65c$export$bb1a638da8ad190f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $73c56c43675cbad2$export$27397851733876fa = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a <= b ? 1 : 0);
const $73c56c43675cbad2$export$c24ad19a692bb92 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$84afd0d8f7fb8c5d), $73c56c43675cbad2$export$27397851733876fa, null, 'bool');
const $73c56c43675cbad2$export$9f26bd257393dd8 = {
    kernelName: (0, $507890e4aa8e1463$export$84afd0d8f7fb8c5d),
    backendName: 'cpu',
    kernelFunc: $73c56c43675cbad2$export$c24ad19a692bb92
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $81844f357056deb0$export$31412d657cd1cc08(start, stop, num) {
    const step = (stop - start) / (num - 1);
    const values = (0, $0775da5e684c8c0d$exports).makeZerosTypedArray(num, 'float32');
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $6d04d7e0e7fb9b2b$export$8a107ec4d5b0e907 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>Math.log(xi));
const $6d04d7e0e7fb9b2b$export$bef1f36f5486a6a3 = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$ce30dbb46644d06c), $6d04d7e0e7fb9b2b$export$8a107ec4d5b0e907);
const $6d04d7e0e7fb9b2b$export$a4ae1f00643ddd14 = {
    kernelName: (0, $507890e4aa8e1463$export$ce30dbb46644d06c),
    backendName: 'cpu',
    kernelFunc: $6d04d7e0e7fb9b2b$export$bef1f36f5486a6a3
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $6668f530b9e82f81$export$23c9b99bdac85be0(aVals, reduceSize, outShape, dtype) {
    const vals = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType(dtype, (0, $0775da5e684c8c0d$exports).sizeFromShape(outShape));
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value > max) max = value;
        }
        vals[i] = max;
    }
    return vals;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $5e945553d2d795af$export$4e233ba825c9b60e = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((aValue, bValue)=>Math.max(aValue, bValue));
const $5e945553d2d795af$export$b25e0be55f42c9a = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$d8d02ac92d161004), $5e945553d2d795af$export$4e233ba825c9b60e);
const $5e945553d2d795af$export$45b97bdc342e72a2 = {
    kernelName: (0, $507890e4aa8e1463$export$d8d02ac92d161004),
    backendName: 'cpu',
    kernelFunc: $5e945553d2d795af$export$b25e0be55f42c9a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $f1b94e222cb7b008$export$756c08a3fa64d43 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((aValue, bValue)=>Math.min(aValue, bValue));
const $f1b94e222cb7b008$export$916782c1f0ddb132 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$23cb308301e89d6b), $f1b94e222cb7b008$export$756c08a3fa64d43);
const $f1b94e222cb7b008$export$ea24ffbbbce8d546 = {
    kernelName: (0, $507890e4aa8e1463$export$23cb308301e89d6b),
    backendName: 'cpu',
    kernelFunc: $f1b94e222cb7b008$export$916782c1f0ddb132
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $e84bd8ea73d7be0a$export$ac59ae2be94ddda3 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((aValue, bValue)=>aValue * bValue);
const $e84bd8ea73d7be0a$export$93ff634b9c7cb5b9 = (0, $350425b01c678d60$export$79261d982c3c14a7)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal * bReal - aImag * bImag,
        imag: aReal * bImag + aImag * bReal
    };
});
const $e84bd8ea73d7be0a$export$2060d2db72cce88f = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$f14f83b3b531d498), $e84bd8ea73d7be0a$export$ac59ae2be94ddda3, $e84bd8ea73d7be0a$export$93ff634b9c7cb5b9);
const $e84bd8ea73d7be0a$export$745576778aafee88 = {
    kernelName: (0, $507890e4aa8e1463$export$f14f83b3b531d498),
    backendName: 'cpu',
    kernelFunc: $e84bd8ea73d7be0a$export$2060d2db72cce88f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $ffed232f6791b4ba$export$e9053236ce0e659b(xVals, xShape, xDtype) {
    const minusOne = (0, $0775da5e684c8c0d$exports).createScalarValue(-1, xDtype);
    return (0, $e84bd8ea73d7be0a$export$ac59ae2be94ddda3)([], xShape, minusOne, xVals, xDtype);
}
function $ffed232f6791b4ba$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    (0, $2db2fd12687c5dab$export$1412c17b2531581a)(x, 'neg');
    const xVals = backend.data.get(x.dataId).values;
    const [res, newShape] = $ffed232f6791b4ba$export$e9053236ce0e659b(xVals, x.shape, x.dtype);
    return backend.makeTensorInfo(newShape, x.dtype, res);
}
const $ffed232f6791b4ba$export$cc7b18b8229c3db = {
    kernelName: (0, $507890e4aa8e1463$export$c07c549000872073),
    backendName: 'cpu',
    kernelFunc: $ffed232f6791b4ba$export$d9493ff0dfa0fdd5
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $71381bef5919bc10$export$eaea354630818ed4 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>a !== b ? 1 : 0);
const $71381bef5919bc10$export$53a6892c50694894 = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$385ebe9945cae0c5), $71381bef5919bc10$export$eaea354630818ed4, null, 'bool');
const $71381bef5919bc10$export$d003d4d7e1500775 = {
    kernelName: (0, $507890e4aa8e1463$export$385ebe9945cae0c5),
    backendName: 'cpu',
    kernelFunc: $71381bef5919bc10$export$53a6892c50694894
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $be7c4e293326eeb4$export$986b9e65182e08d(xVals, xShape, dtype, perm, newShape) {
    const xRank = xShape.length;
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(xShape);
    const xStrides = (0, $0775da5e684c8c0d$exports).computeStrides(xShape);
    const newStrides = (0, $0775da5e684c8c0d$exports).computeStrides(newShape);
    const result = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType(dtype, (0, $0775da5e684c8c0d$exports).sizeFromShape(newShape));
    for(let i = 0; i < xSize; ++i){
        const loc = (0, $0775da5e684c8c0d$exports).indexToLoc(i, xRank, xStrides);
        // Permute location.
        const newLoc = new Array(loc.length);
        for(let i = 0; i < newLoc.length; i++)newLoc[i] = loc[perm[i]];
        const newIndex = (0, $0775da5e684c8c0d$exports).locToIndex(newLoc, xRank, newStrides);
        result[newIndex] = xVals[i];
    }
    return result;
}


function $4fa7540b6829f52d$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    (0, $2db2fd12687c5dab$export$1412c17b2531581a)(x, 'transpose');
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    const values = backend.data.get(x.dataId).values;
    const result = (0, $be7c4e293326eeb4$export$986b9e65182e08d)(values, x.shape, x.dtype, perm, newShape);
    const dataId = backend.write(result, newShape, x.dtype);
    return {
        dataId: dataId,
        shape: newShape,
        dtype: x.dtype
    };
}
const $4fa7540b6829f52d$export$895a002a39b774be = {
    kernelName: (0, $507890e4aa8e1463$export$7e714455f9a1f8f7),
    backendName: 'cpu',
    kernelFunc: $4fa7540b6829f52d$export$9cb09a71b7d66923
};


function $020b2810bf048546$export$a3c8a5271f6bb700(xShape, xDtype, xVals, reductionAxes) {
    const [outShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(xShape, reductionAxes);
    const outDtype = (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(xDtype, 'int32');
    const outVals = (0, $0775da5e684c8c0d$exports).makeZerosTypedArray((0, $0775da5e684c8c0d$exports).sizeFromShape(outShape), outDtype);
    const reduceSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    for(let i = 0; i < outVals.length; ++i){
        const offset = i * reduceSize;
        let prod = 1;
        for(let j = 0; j < reduceSize; ++j)prod *= xVals[offset + j];
        outVals[i] = prod;
    }
    return {
        outVals: outVals,
        outShape: outShape,
        outDtype: outDtype
    };
}
function $020b2810bf048546$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $2db2fd12687c5dab$export$1412c17b2531581a)(x, 'prod');
    const xRank = x.shape.length;
    const axes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    const permutation = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = x;
    const intermediateTensorInfos = [];
    if (permutation != null) {
        permutedX = (0, $4fa7540b6829f52d$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        intermediateTensorInfos.push(permutedX);
        reductionAxes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(reductionAxes.length, xRank);
    }
    const xVals = backend.data.get(permutedX.dataId).values;
    const { outVals: outVals, outShape: outShape, outDtype: outDtype } = $020b2810bf048546$export$a3c8a5271f6bb700(permutedX.shape, permutedX.dtype, xVals, reductionAxes);
    let resultShape = outShape;
    if (keepDims) resultShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(outShape, axes);
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(resultShape, outDtype, outVals);
}
const $020b2810bf048546$export$d556aa935cef5c0c = {
    kernelName: (0, $507890e4aa8e1463$export$b8a16d526a791fb0),
    backendName: 'cpu',
    kernelFunc: $020b2810bf048546$export$5e143010dea16c85
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $7830d508d2e3908a$var$validateIndices(indices, indicesShape, numParams) {
    indices.forEach((index, i)=>{
        if (index < 0 || index >= numParams) {
            const locString = (0, $0775da5e684c8c0d$exports).indexToLoc(i, indicesShape.length, (0, $0775da5e684c8c0d$exports).computeStrides(indicesShape)).join(',');
            throw new Error(`indices[${locString}] = ${index} is not in [0, ${numParams})`);
        }
    });
}
function $7830d508d2e3908a$var$validateSplits(paramsNestedSplits, numParamsDenseValues) {
    // Validate
    for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
        const splits = paramsNestedSplits[dim];
        const lastSplit = dim === paramsNestedSplits.length - 1 ? numParamsDenseValues : paramsNestedSplits[dim + 1].length;
        if (splits.length === 0) throw new Error('Ragged splits may not be empty');
        if (splits[0] < 0) throw new Error('Ragged splits must be non-negative');
        if (splits[splits.length - 1] > lastSplit) throw new Error('Ragged splits must not point past values');
        for(let i = 1; i < splits.length; ++i){
            if (splits[i - 1] > splits[i]) throw new Error('Ragged splits must be sorted in ascending order');
        }
    }
}
// Construct the `splits` output tensors, encoded using a nested vector.
// Also find the slices of values that need to be copied, and store them
// in `valueSlices`.  The total number of values that will be copied (which
// we need for allocating the output values tensor) is stored in `numValues`.
function $7830d508d2e3908a$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues) {
    const valueSlices = [];
    let numValues = 0;
    const numSplits = indicesShape.length - 1 + paramsNestedSplits.length;
    const outSplits = new Array(numSplits).fill(null).map(()=>[
            0
        ]);
    $7830d508d2e3908a$var$validateSplits(paramsNestedSplits, numParamsDenseValues);
    // Add `splits` that come from all but the last dimension of the dense
    // Tensor `indices`.  In particular, for each dimension D, we add a
    // splits tensor whose values are:
    //   range(reduceProd(splits.shape[:D]) + 1) * splits.shape[D+1]
    // E.g., if indices.shape=[2, 3, 4] then we will add splits tensors:
    //   [0, 3, 6]                    # length=2+1, stride=3
    //   [0, 4, 8, 12, 16, 20, 24]    # length=2*3+1, stride=4
    let nrows = 1;
    for(let dim = 0; dim < indicesShape.length - 1; ++dim){
        nrows *= indicesShape[dim];
        const rowLength = indicesShape[dim + 1];
        for(let i = 1; i < nrows + 1; ++i)outSplits[dim].push(i * rowLength);
    }
    // Add `splits` that come from `paramsNestedSplits`.  Starting with the
    // outermost ragged dimension (i.e., the first `splits` tensor), we work
    // our way in, finding the range of values that should be copied.  As we
    // go, we update the output `splits` for each dimension with the appropriate
    // values.  In particular, the *lengths* of the slices from `param_splits`
    // should be copied to generate corresponding slice lengths in the output
    // splits.  E.g., if we are copying a ragged row with length 4, then we
    // should add a new split point to outSplits that is 4 greater than the
    // previous split point in outSplits.
    for(let i = 0; i < indices.length; ++i){
        let start = indices[i];
        let limit = indices[i] + 1;
        // Copy splits.
        for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
            const splits = paramsNestedSplits[dim];
            const outDim = dim + indicesShape.length - 1;
            if (outDim >= 0) {
                const outSplitsOutDim = outSplits[outDim];
                const delta = outSplitsOutDim[outSplitsOutDim.length - 1] - splits[start];
                for(let j = start; j < limit; ++j)outSplits[outDim].push(splits[j + 1] + delta);
            }
            start = splits[start];
            limit = splits[limit];
        }
        if (limit !== start) {
            valueSlices.push([
                start,
                limit
            ]);
            numValues += limit - start;
        }
    }
    return {
        outSplits: outSplits,
        valueSlices: valueSlices,
        numValues: numValues
    };
}
function $7830d508d2e3908a$var$getSplits(outSplits) {
    const splitsOut = [];
    for(let i = 0; i < outSplits.length; ++i){
        const numSplits = outSplits[i].length;
        const splits = (0, $0775da5e684c8c0d$exports).getArrayFromDType('int32', numSplits);
        splitsOut.push(splits);
        outSplits[i].forEach((value, j)=>splits[j] = value);
    }
    return splitsOut;
}
function $7830d508d2e3908a$var$computeFlatOuterDims(orig, numOutDims) {
    const outDims = orig.slice(0, numOutDims);
    while(outDims.length < numOutDims)outDims.push(1);
    for(let inDim = numOutDims; inDim < orig.length; inDim++)outDims[numOutDims - 1] *= orig[inDim];
    return outDims;
}
// For each slice in `(start, limit)` in `valueSlices`, append
// `paramsDenseValues[start,...,limit] to `values`.  `valueSize` indicates
// the number of scalars contained in each value paramsDenseValues[i].
function $7830d508d2e3908a$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, values, valuesShape) {
    const denseM = $7830d508d2e3908a$var$computeFlatOuterDims(paramsDenseValuesShape, 2)[1];
    const valuesM = $7830d508d2e3908a$var$computeFlatOuterDims(valuesShape, 2)[1];
    let outPos = 0;
    for (const slice of valueSlices)for(let i = slice[0]; i < slice[1]; ++i){
        for(let j = 0; j < valueSize; ++j)values[outPos * valuesM + j] = paramsDenseValues[i * denseM + j];
        ++outPos;
    }
}
function $7830d508d2e3908a$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues) {
    const valuesShape = paramsDenseValuesShape.slice();
    valuesShape[0] = numValues;
    const valuesOut = (0, $0775da5e684c8c0d$exports).getArrayFromDType(paramsDenseValuesDType, (0, $0775da5e684c8c0d$exports).sizeFromShape(valuesShape));
    const numElements = paramsDenseValues.length;
    const valueSize = numElements === 0 ? 0 : numElements / paramsDenseValuesShape[0];
    $7830d508d2e3908a$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, valuesOut, valuesShape);
    return [
        valuesOut,
        valuesShape
    ];
}
function $7830d508d2e3908a$export$4104e3de41455909(paramsNestedSplits, paramsNestedSplitsShapes, paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, indices, indicesShape, outputRaggedRank) {
    if (paramsNestedSplits.length === 0) throw new Error('paramsNestedSplits must be non empty');
    if (paramsNestedSplitsShapes[0].length === 0) throw new Error('Split tensors must not be scalars');
    const numParams = paramsNestedSplitsShapes[0][0] - 1;
    $7830d508d2e3908a$var$validateIndices(indices, indicesShape, numParams);
    if (paramsDenseValuesShape.length === 0) throw new Error('params.rank must be nonzero');
    const numParamsDenseValues = paramsDenseValuesShape[0];
    // Calculate the `splits`, and store the value slices that we need to
    // copy in `valueSlices`.
    const { outSplits: outSplits, valueSlices: valueSlices, numValues: numValues } = $7830d508d2e3908a$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues);
    // Write the output tensors.
    const outputNestedSplits = $7830d508d2e3908a$var$getSplits(outSplits);
    const outputDenseValues = $7830d508d2e3908a$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues);
    return [
        outputNestedSplits,
        outputDenseValues[0],
        outputDenseValues[1]
    ];
}


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $dc1e6ed86fd108ed$var$INT32_MAX = 2147483647;
function $dc1e6ed86fd108ed$export$af0dda5a37ea8d94(starts, startsShape, startsDType, limits, limitsShape, deltas, deltasShape) {
    // Check input tensor shapes.
    if (startsShape.length > 1) throw new Error('starts must be a scalar or vector');
    if (limitsShape.length > 1) throw new Error('limits must be a scalar or vector');
    if (deltasShape.length > 1) throw new Error('deltas must be a scalar or vector');
    // Determine which tensors we need to broadcast.
    const broadcastStarts = startsShape.length === 0;
    const broadcastLimits = limitsShape.length === 0;
    const broadcastDeltas = deltasShape.length === 0;
    // nRows (number of output rows) is the size of the non-broadcast inputs,
    // or 1 if all inputs are scalars.
    const inSizes = [];
    if (!broadcastStarts) inSizes.push(startsShape[0]);
    if (!broadcastLimits) inSizes.push(limitsShape[0]);
    if (!broadcastDeltas) inSizes.push(deltasShape[0]);
    for(let i = 1; i < inSizes.length; ++i){
        if (inSizes[i] !== inSizes[i - 1]) throw new Error('starts, limits, and deltas must have the same shape');
    }
    const nRows = inSizes.length === 0 ? 1 : inSizes[0];
    // Construct the rtNestedSplits tensor.
    const rtNestedSplits = (0, $0775da5e684c8c0d$exports).getArrayFromDType('int32', nRows + 1);
    rtNestedSplits[0] = 0;
    for(let row = 0; row < nRows; ++row){
        const start = broadcastStarts ? starts[0] : starts[row];
        const limit = broadcastLimits ? limits[0] : limits[row];
        const delta = broadcastDeltas ? deltas[0] : deltas[row];
        if (delta === 0) throw new Error('Requires delta != 0');
        let size; // The number of elements in the specified range.
        if (delta > 0 && limit < start || delta < 0 && limit > start) size = 0;
        else {
            size = Math.ceil(Math.abs((limit - start) / delta));
            if (size > $dc1e6ed86fd108ed$var$INT32_MAX) throw new Error(`Requires ((limit - start) / delta) <= ${$dc1e6ed86fd108ed$var$INT32_MAX}`);
        }
        rtNestedSplits[row + 1] = rtNestedSplits[row] + size;
    }
    const nVals = rtNestedSplits[nRows];
    // Construct the rtDenseValues tensor.
    const rtDenseValues = (0, $0775da5e684c8c0d$exports).getArrayFromDType(startsDType, nVals);
    let valueIndex = 0;
    for(let row = 0; row < nRows; ++row){
        const rowSize = rtNestedSplits[row + 1] - rtNestedSplits[row];
        let value = broadcastStarts ? starts[0] : starts[row];
        const delta = broadcastDeltas ? deltas[0] : deltas[row];
        for(let i = 0; i < rowSize; ++i){
            rtDenseValues[valueIndex++] = value;
            value += delta;
        }
    }
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $a9fb102be0671807$var$RowPartitionType = (0, $f35e0c1a651337db$exports).RowPartitionType;
// Based on
// https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/ragged_tensor_to_tensor_op.cc
class $a9fb102be0671807$var$RaggedTensorToTensorOp {
    constructor(shape, shapeShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypeStrings){
        this.shape = shape;
        this.shapeShape = shapeShape;
        this.values = values;
        this.valuesShape = valuesShape;
        this.valuesDType = valuesDType;
        this.defaultValue = defaultValue;
        this.defaultValueShape = defaultValueShape;
        this.rowPartitionValues = rowPartitionValues;
        this.rowPartitionValuesShapes = rowPartitionValuesShapes;
        this.rowPartitionTypes = (0, $f35e0c1a651337db$exports).getRowPartitionTypesHelper(rowPartitionTypeStrings);
        this.raggedRank = (0, $f35e0c1a651337db$exports).getRaggedRank(this.rowPartitionTypes);
    }
    getRowPartitionTypeByDimension(dimension) {
        if (this.rowPartitionTypes[0] === $a9fb102be0671807$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionTypes[dimension + 1];
        else return this.rowPartitionTypes[dimension];
    }
    // Returns the relationship between dimension and dimension + 1.
    getRowPartitionTensor(dimension) {
        if (this.rowPartitionTypes[0] === $a9fb102be0671807$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionValues[dimension + 1];
        else return this.rowPartitionValues[dimension];
    }
    getMaxWidth(dimension) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension - 1);
        switch(this.getRowPartitionTypeByDimension(dimension - 1)){
            case $a9fb102be0671807$var$RowPartitionType.VALUE_ROWIDS:
                return $a9fb102be0671807$var$RaggedTensorToTensorOp.getMaxWidthValueRowID(rowPartitionTensor);
            case $a9fb102be0671807$var$RowPartitionType.ROW_SPLITS:
                return $a9fb102be0671807$var$RaggedTensorToTensorOp.getMaxWidthRowSplit(rowPartitionTensor);
            default:
                throw new Error(`Cannot handle partition type ${$a9fb102be0671807$var$RowPartitionType[this.getRowPartitionTypeByDimension(dimension - 1)]}`);
        }
    }
    static getMaxWidthRowSplit(rowSplit) {
        const tensorLength = rowSplit.length;
        if (tensorLength === 0 || tensorLength === 1) return 0;
        let maxWidth = 0;
        for(let i = 0; i < tensorLength - 1; ++i){
            const currentWidth = rowSplit[i + 1] - rowSplit[i];
            if (currentWidth > maxWidth) maxWidth = currentWidth;
        }
        return maxWidth;
    }
    static getMaxWidthValueRowID(valueRowIds) {
        const indexLength = valueRowIds.length;
        if (indexLength === 0) return 0;
        let firstEqualIndex = 0;
        let firstEqualIndexValue = valueRowIds[0];
        let maxWidth = 0;
        for(let i = 1; i < indexLength; ++i){
            const value = valueRowIds[i];
            if (value !== firstEqualIndexValue) {
                firstEqualIndexValue = value;
                maxWidth = Math.max(i - firstEqualIndex, maxWidth);
                firstEqualIndex = i;
            }
        }
        return Math.max(indexLength - firstEqualIndex, maxWidth);
    }
    tensorShapeFromTensor(t, tShape, isPartial = true) {
        if (tShape.length === 0) {
            if (t[0] === -1) return [];
            throw new Error(`The only valid scalar shape tensor is the fully unknown shape specified as -1.`);
        }
        // MakePartialShape/MakeShapeHelper.
        return $a9fb102be0671807$var$makeShape(t, isPartial);
    }
    calculateOutputSize(firstDim) {
        const valueShape = this.valuesShape;
        const defaultValueShape = this.defaultValueShape;
        (0, $f35e0c1a651337db$exports).validateDefaultValueShape(defaultValueShape, valueShape);
        const shape = this.tensorShapeFromTensor(this.shape, this.shapeShape);
        const outputShape = (0, $f35e0c1a651337db$exports).combineRaggedTensorToTensorShapes(this.raggedRank, shape, valueShape);
        const result = outputShape;
        if (result[0] < 0) result[0] = firstDim;
        for(let i = 1; i <= this.raggedRank; ++i)if (result[i] < 0) result[i] = this.getMaxWidth(i);
        return result;
    }
    /**
     * The outputIndex represents the index in the output tensor
     * where the first element of a particular dimension would be written.
     * If it is -1, it indicates that the index is out of scope.
     * Example, given firstDimension = 10, firstDimensionOutput = 6,
     * and outputIndexMultiplier = 100:
     * result = [0 100 200 300 400 500 -1 -1 -1 -1]
     * If firstDimensionOutput = 11 instead, then:
     * result = [0 100 200 300 400 500 600 700 800 900]
     */ calculateFirstParentOutputIndex(firstDimension, outputIndexMultiplier, firstDimensionOutput) {
        const minDimension = Math.min(firstDimension, firstDimensionOutput);
        const result = [];
        let currentOutputIndex = 0;
        for(let i = 0; i < minDimension; ++i, currentOutputIndex += outputIndexMultiplier)result.push(currentOutputIndex);
        for(let i = minDimension; i < firstDimension; ++i)result.push(-1);
        (0, $0775da5e684c8c0d$exports).assert(result.length === firstDimension, ()=>'Final length of result must be equal to firstDimension.');
        return result;
    }
    calculateOutputIndexRowSplit(rowSplit, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowSplitSize = rowSplit.length;
        const result = [];
        for(let i = 0; i < rowSplitSize - 1; ++i){
            const rowLength = rowSplit[i + 1] - rowSplit[i];
            let realLength = Math.min(outputSize, rowLength);
            let parentOutputIndexCurrent = parentOutputIndex[i];
            if (parentOutputIndexCurrent === -1) realLength = 0;
            for(let j = 0; j < realLength; ++j){
                result.push(parentOutputIndexCurrent);
                parentOutputIndexCurrent += outputIndexMultiplier;
            }
            for(let j = 0; j < rowLength - realLength; ++j)result.push(-1);
        }
        if (rowSplitSize > 0 && result.length !== rowSplit[rowSplitSize - 1]) throw new Error('Invalid row split size.');
        return result;
    }
    // Calculate the output index of the first element of a list.
    // The parentOutputIndex is the same computation for the previous list.
    // -1 indicates an element or list that is out of range.
    // The outputIndexMultiplier is the number of output indices one moves
    // forward for each column.
    // E.g., given:
    // valueRowIds:[0 1 2 2 2 3 5 5 6]
    // parentOutputIndex:[1000 1100 2000 2100 -1 3000 4000]
    // outputIndexMultiplier: 10
    // outputSize: 2
    // You get:
    // result = [1000 1100 2000 2010 -1 2100 -1 -1 3000]
    // result[0] = parentOutputIndex[valueRowIds[0]]
    // result[1] = parentOutputIndex[valueRowIds[1]]
    // result[2] = parentOutputIndex[valueRowIds[2]]
    // result[3] = parentOutputIndex[valueRowIds[2] + 10]
    // result[4] = -1 because it is the third element the size is 2.
    // result[5] = parentOutputIndex[valueRowIds[3]]
    // result[6] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[7] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[8] = parentOutputIndex[valueRowIds[7]]
    calculateOutputIndexValueRowID(valueRowIds, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const indexSize = valueRowIds.length;
        const result = [];
        if (indexSize === 0) return [];
        let currentOutputColumn = 0;
        let currentValueRowId = valueRowIds[0];
        if (currentValueRowId >= parentOutputIndex.length) throw new Error(`Got currentValueRowId=${currentValueRowId}, which is not less than ${parentOutputIndex.length}`);
        let currentOutputIndex = parentOutputIndex[currentValueRowId];
        result.push(currentOutputIndex);
        for(let i = 1; i < indexSize; ++i){
            const nextValueRowId = valueRowIds[i];
            if (nextValueRowId === currentValueRowId) {
                if (currentOutputIndex >= 0) {
                    ++currentOutputColumn;
                    if (currentOutputColumn < outputSize) currentOutputIndex += outputIndexMultiplier;
                    else currentOutputIndex = -1;
                }
            } else {
                currentOutputColumn = 0;
                currentValueRowId = nextValueRowId;
                if (nextValueRowId >= parentOutputIndex.length) throw new Error(`Got nextValueRowId=${nextValueRowId} which is not less than ${parentOutputIndex.length}`);
                currentOutputIndex = parentOutputIndex[nextValueRowId];
            }
            result.push(currentOutputIndex);
        }
        if (result.length !== valueRowIds.length) throw new Error('Invalid row ids.');
        return result;
    }
    calculateOutputIndex(dimension, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension);
        const partitionType = this.getRowPartitionTypeByDimension(dimension);
        switch(partitionType){
            case $a9fb102be0671807$var$RowPartitionType.VALUE_ROWIDS:
                return this.calculateOutputIndexValueRowID(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            case $a9fb102be0671807$var$RowPartitionType.ROW_SPLITS:
                if (rowPartitionTensor.length - 1 > parentOutputIndex.length) throw new Error(`Row partition size is greater than output size: ${rowPartitionTensor.length - 1} > ${parentOutputIndex.length}`);
                return this.calculateOutputIndexRowSplit(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            default:
                throw new Error(`Unsupported partition type: ${$a9fb102be0671807$var$RowPartitionType[partitionType]}`);
        }
    }
    getFirstDimensionSize() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (this.rowPartitionTypes.length === 0) throw new Error('No row_partition_types given.');
        const firstPartitionType = this.rowPartitionTypes[0];
        switch(firstPartitionType){
            case $a9fb102be0671807$var$RowPartitionType.FIRST_DIM_SIZE:
                return firstPartitionTensor[0];
            case $a9fb102be0671807$var$RowPartitionType.VALUE_ROWIDS:
                throw new Error('Cannot handle VALUE_ROWIDS in first dimension.');
            case $a9fb102be0671807$var$RowPartitionType.ROW_SPLITS:
                return this.rowPartitionValuesShapes[0][0] - 1;
            default:
                throw new Error(`Cannot handle type ${$a9fb102be0671807$var$RowPartitionType[firstPartitionType]}`);
        }
    }
    compute() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (firstPartitionTensor.length <= 0) throw new Error("Invalid first partition input. Tensor requires at least one element.");
        const firstDimension = this.getFirstDimensionSize();
        const outputSize = this.calculateOutputSize(firstDimension);
        const multiplier = new Array(this.raggedRank + 1);
        multiplier[multiplier.length - 1] = 1;
        for(let i = multiplier.length - 2; i >= 0; --i)multiplier[i] = multiplier[i + 1] * outputSize[i + 1];
        // Full size of the tensor.
        const outputShape = $a9fb102be0671807$var$makeShape(outputSize, false);
        const outputTensor = (0, $0775da5e684c8c0d$exports).getArrayFromDType(this.valuesDType, (0, $0775da5e684c8c0d$exports).sizeFromShape(outputShape));
        const fullSize = multiplier[0] * outputSize[0];
        if (fullSize > 0) {
            let outputIndex = this.calculateFirstParentOutputIndex(firstDimension, multiplier[0], outputSize[0]);
            for(let i = 1; i <= this.raggedRank; ++i){
                const newOutputIndex = this.calculateOutputIndex(i - 1, outputIndex, multiplier[i], outputSize[i]);
                outputIndex = newOutputIndex;
            }
            this.setOutput(this.raggedRank, outputIndex, outputTensor, outputShape);
        }
        return [
            outputShape,
            outputTensor
        ];
    }
    setOutput(raggedRank, outputIndex, outputTensor, outputShape) {
        if (outputTensor.length === 0) return;
        const valuesBase = this.values;
        const outputBase = outputTensor;
        let elementShape = outputShape.slice();
        elementShape = elementShape.slice(raggedRank + 1);
        const valueElementSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(elementShape);
        const outputIndexSize = outputIndex.length;
        // Broadcast the default value to value_element_size.  (We can skip this
        // if defaultValueTensor.size == 1, since we use fill when that's true.)
        let defaultValue = this.defaultValue;
        if (defaultValue.length !== valueElementSize && defaultValue.length !== 1) {
            const srcShape = this.defaultValueShape;
            (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
                const defaultValueTensor = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(defaultValue, srcShape);
                const bCastDefault = (0, $8660a1872a3f456e$export$ec9086aff2624eab)(defaultValueTensor, elementShape);
                defaultValue = bCastDefault.dataSync();
            });
        }
        // Loop through the outputIndex array, finding contiguous regions that
        // should be copied.  Once we find the end of a contiguous region, copy it
        // and add any necessary padding (with defaultValue).
        let srcStart = 0; // Start of contiguous region (in values)
        let dstStart = 0; // Destination for contiguous region (in output)
        let dstEnd = 0; // Destination for contiguous region (in output)
        for(let srcI = 0; srcI <= outputIndexSize; ++srcI){
            // dstI is the destination where the value at srcI should be copied.
            let dstI = srcI < outputIndexSize ? outputIndex[srcI] : -1;
            // If we're still in a contiguous region, then update dstEnd go to the
            // next srcI.
            if (dstI === dstEnd) {
                ++dstEnd;
                continue;
            }
            // We found the end of contiguous region.  This can be because we found
            // a gap (dstI > dstEnd), or a source value that shouldn't be copied
            // because it's out-of-bounds (dstI == -1), or the end of the tensor
            // (dstI === -1).
            if (dstStart < dstEnd) {
                // Copy the contiguous region.
                const src = valuesBase.subarray(srcStart * valueElementSize);
                const dst = outputBase.subarray(dstStart * valueElementSize);
                const nVals = (dstEnd - dstStart) * valueElementSize;
                $a9fb102be0671807$var$copyArray(dst, src, nVals);
            }
            // Add any necessary padding (w/ defaultValue).
            if (srcI >= outputIndexSize) {
                // We reached the end of values: pad to the end of output.
                const outputSize = outputTensor.length;
                dstI = Math.floor(outputSize / valueElementSize);
            }
            if (dstI > dstEnd) {
                if (this.defaultValue.length === 1) {
                    outputBase.subarray(dstEnd * valueElementSize, dstI * valueElementSize).fill(this.defaultValue[0]);
                    dstEnd = dstI;
                } else while(dstI > dstEnd){
                    const dst = outputBase.slice(dstEnd * valueElementSize);
                    $a9fb102be0671807$var$copyArray(dst, defaultValue, valueElementSize);
                    ++dstEnd;
                }
            }
            // Update indices.
            if (dstI < 0) {
                // srcI should be skipped -- leave it out of the contiguous region.
                srcStart = srcI + 1;
                dstStart = dstEnd;
            } else {
                // srcI should be copied -- include it in the contiguous region.
                srcStart = srcI;
                dstStart = dstEnd;
                dstEnd = dstStart + 1;
            }
        }
    }
}
function $a9fb102be0671807$var$copyArray(dst, src, size) {
    for(let i = 0; i < size; i++)dst[i] = src[i];
}
function $a9fb102be0671807$var$makeShape(shape, isPartial) {
    const out = [];
    for (let dim of shape){
        if (dim < 0) {
            if (!isPartial) throw new Error(`Dimension ${dim} must be >= 0`);
            if (dim < -1) throw new Error(`Dimension ${dim} must be >= -1`);
            dim = -1;
        }
        out.push(dim);
    }
    return out;
}
function $a9fb102be0671807$export$8194a77b1066327a(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes) {
    return new $a9fb102be0671807$var$RaggedTensorToTensorOp(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes).compute();
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $8bf82964e317b635$export$3561205b7dff20bf(start, stop, step, dtype) {
    const sameStartStop = start === stop;
    const increasingRangeNegativeStep = start < stop && step < 0;
    const decreasingRangePositiveStep = stop < start && step > 1;
    if (sameStartStop || increasingRangeNegativeStep || decreasingRangePositiveStep) return (0, $0775da5e684c8c0d$exports).makeZerosTypedArray(0, dtype);
    const numElements = Math.abs(Math.ceil((stop - start) / step));
    const values = (0, $0775da5e684c8c0d$exports).makeZerosTypedArray(numElements, dtype);
    if (stop < start && step === 1) // Auto adjust the step's sign if it hasn't been set
    // (or was set to 1)
    step = -1;
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $e844ac4e57f9ec81$export$7ec24de9bffc6b90 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>1 / Math.sqrt(xi));
const $e844ac4e57f9ec81$export$1cc01d192953037e = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$7cc53aa09f5f3a2d), $e844ac4e57f9ec81$export$7ec24de9bffc6b90);
const $e844ac4e57f9ec81$export$941104b789956ef6 = {
    kernelName: (0, $507890e4aa8e1463$export$7cc53aa09f5f3a2d),
    backendName: 'cpu',
    kernelFunc: $e844ac4e57f9ec81$export$1cc01d192953037e
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $9b4b860bbaecdb6c$export$5fc9b0358a19bd54(indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices) {
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    const indicesData = indices.values;
    const updatesData = updates.values;
    if (outputSize === 0) return (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(shape, updates.dtype);
    const outBuf = defaultValue instanceof (0, $4b7222b1b59444b8$export$350df26cd52e08e1) ? defaultValue : (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(flattenShape, updates.dtype);
    if (typeof defaultValue === 'string') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'number') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'boolean') outBuf.values.fill(+defaultValue);
    for(let i = 0; i < numUpdates; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            index.push(dim);
            flattenIndex += dim * strides[j];
        }
        if (flattenIndex < 0 || flattenIndex >= outputSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${shape}`);
        for(let k = 0; k < sliceSize; k++)if (sumDupeIndices) outBuf.values[flattenIndex * sliceSize + k] += updatesData[i * sliceSize + k];
        else outBuf.values[flattenIndex * sliceSize + k] = updates.rank === 0 ? updatesData[0] : updatesData[i * sliceSize + k];
    }
    return outBuf;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $7d9b05c0233bd3bd$export$e31bae35ce8238b3 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>1 / (1 + Math.exp(-xi)));
const $7d9b05c0233bd3bd$export$3b295495ca3cad7c = (0, $daf1a402932b3109$export$ba4daf5748026fba)((0, $507890e4aa8e1463$export$fde18c826dda6b1b), (xi)=>1 / (1 + Math.exp(-xi)));
const $7d9b05c0233bd3bd$export$195d1cf7c59f3ef = {
    kernelName: (0, $507890e4aa8e1463$export$fde18c826dda6b1b),
    backendName: 'cpu',
    kernelFunc: $7d9b05c0233bd3bd$export$3b295495ca3cad7c
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $832ffd19544f6b8c$export$4bdf1ac3fa5d3d6a(vals, begin, size, shape, dtype) {
    const isContinous = (0, $f147fd057118a602$exports).isSliceContinous(shape, begin, size);
    const length = (0, $0775da5e684c8c0d$exports).sizeFromShape(size);
    const xStrides = (0, $0775da5e684c8c0d$exports).computeStrides(shape);
    if (isContinous) {
        const flatOffset = (0, $f147fd057118a602$exports).computeFlatOffset(begin, xStrides);
        if (dtype === 'string') return vals.slice(flatOffset, flatOffset + length);
        return vals.subarray(flatOffset, flatOffset + length);
    }
    const decodedData = dtype === 'string' ? (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(vals) : vals;
    const inBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(shape, dtype, decodedData);
    const outBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(size, dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.map((idx, j)=>idx + begin[j]);
        outBuf.set(inBuf.get(...inLoc), ...outLoc);
    }
    if (dtype === 'string') return (0, $f35e0c1a651337db$exports).fromStringArrayToUint8(outBuf.values);
    return outBuf.values;
}
function $832ffd19544f6b8c$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    (0, $2db2fd12687c5dab$export$1412c17b2531581a)(x, 'slice');
    const [$begin, $size] = (0, $f147fd057118a602$exports).parseSliceParams(x, begin, size);
    (0, $f147fd057118a602$exports).assertParamsValid(x, $begin, $size);
    const vals = backend.data.get(x.dataId).values;
    const outVals = $832ffd19544f6b8c$export$4bdf1ac3fa5d3d6a(vals, $begin, $size, x.shape, x.dtype);
    return backend.makeTensorInfo($size, x.dtype, outVals);
}
const $832ffd19544f6b8c$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $507890e4aa8e1463$export$b3f2e2de3a8baa1e),
    backendName: 'cpu',
    kernelFunc: $832ffd19544f6b8c$export$58adb3bec8346d0f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $6a2235a7ce50ff56$export$9db01208a1bec190(indices, indicesShape, indicesDType, values, valuesDType, denseShape, defaultValue) {
    const indicesCount = indicesShape[0];
    const denseRows = denseShape[0];
    const emptyRowIndicator = new Array(denseRows);
    const reverseIndexMap = new Array(indicesCount);
    const rank = indicesShape[1];
    if (denseRows === 0) {
        if (indicesCount !== 0) throw new Error((0, $f35e0c1a651337db$exports).getSparseFillEmptyRowsIndicesDenseShapeMismatch(indicesCount));
        const outputIndices = (0, $0775da5e684c8c0d$exports).getArrayFromDType(indicesDType, 0);
        const outputValues = (0, $0775da5e684c8c0d$exports).getArrayFromDType(valuesDType, 0);
        return [
            outputIndices,
            [
                0,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
    let rowsAreOrdered = true;
    let lastIndicesRow = 0;
    const csrOffset = new Array(denseRows).fill(0);
    for(let i = 0; i < indicesCount; ++i){
        // indices is a 2d tensor with shape of [N, rank]
        const row = indices[i * rank];
        if (row < 0) throw new Error((0, $f35e0c1a651337db$exports).getSparseFillEmptyRowsNegativeIndexErrorMessage(i, row));
        if (row >= denseRows) throw new Error((0, $f35e0c1a651337db$exports).getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(i, row, denseRows));
        ++csrOffset[row];
        rowsAreOrdered = rowsAreOrdered && row >= lastIndicesRow;
        lastIndicesRow = row;
    }
    let allRowsFull = true;
    for(let row = 0; row < denseRows; ++row){
        // csrOffset here describes the number of elements in this dense row
        const rowEmpty = csrOffset[row] === 0;
        emptyRowIndicator[row] = rowEmpty;
        allRowsFull = allRowsFull && !rowEmpty;
        // In filled version, each row has at least one element.
        csrOffset[row] = Math.max(csrOffset[row], 1);
        // Update csrOffset to represent the number of elements up to and
        // including denseRows + 1:
        //  csrOffset[0] == #{elements of row 0}
        //  csrOffset[1] == #{elements of row 1} + #{elements of row 0}
        //  ..
        //  csrOffset[i] == starting index for elements in row i + 1.
        if (row > 0) csrOffset[row] += csrOffset[row - 1];
    }
    if (allRowsFull && rowsAreOrdered) {
        const outputIndices = indices;
        const outputValues = values;
        for(let i = 0; i < indicesCount; ++i)reverseIndexMap[i] = i;
        return [
            outputIndices,
            [
                indicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    } else {
        const fullIndicesCount = csrOffset[denseRows - 1];
        const outputIndices = (0, $0775da5e684c8c0d$exports).getArrayFromDType(indicesDType, fullIndicesCount * rank);
        const outputValues = (0, $0775da5e684c8c0d$exports).getArrayFromDType(valuesDType, fullIndicesCount);
        const filledCount = new Array(denseRows).fill(0);
        // Fill in values for rows that are not missing
        for(let i = 0; i < indicesCount; ++i){
            // indices is a 2d tensor with shape of [N, rank]
            const row = indices[i * rank];
            const offset = filledCount[row];
            const outputI = (row === 0 ? 0 : csrOffset[row - 1]) + offset;
            filledCount[row]++; // Increment the filled count for this row.
            for(let j = 0; j < rank; ++j)// indices and outputIndices are 2d tensors with shape of [N, rank]
            outputIndices[outputI * rank + j] = indices[i * rank + j];
            outputValues[outputI] = values[i];
            // We'll need this reverse index map to backprop correctly.
            reverseIndexMap[i] = outputI;
        }
        // Fill in values for rows that are missing
        for(let row = 0; row < denseRows; ++row){
            const rowCount = filledCount[row];
            if (rowCount === 0) {
                const startingIndex = row === 0 ? 0 : csrOffset[row - 1];
                // Remaining index values were set to zero already.
                // Just need to set the row index in the right location.
                // outputIndices is a 2d tensor with shape of [N, rank]
                outputIndices[startingIndex * rank + 0] = row;
                for(let col = 1; col < rank; ++col)outputIndices[startingIndex * rank + col] = 0;
                outputValues[startingIndex] = defaultValue;
            }
        }
        return [
            outputIndices,
            [
                fullIndicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $ad3735f9cbaccd53$export$a65a15ebab81f5cd(inputIndices, inputIndicesShape, inputDType, inputShape, targetShape) {
    const denseSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(inputShape);
    const nnz = inputIndicesShape[0];
    const outputRank = targetShape.length;
    // Compute the output shape. Determine product of specified dimensions, and
    // find the index of the unspecified one.
    const outputShape = [];
    let product = 1;
    let unknownIndex = -1;
    for(let d = 0; d < outputRank; ++d){
        const size = targetShape[d];
        if (size === -1) {
            if (unknownIndex !== -1) throw new Error((0, $f35e0c1a651337db$exports).getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(unknownIndex, d));
            unknownIndex = d;
            outputShape.push(1);
        } else {
            if (size < 0) throw new Error((0, $f35e0c1a651337db$exports).getSparseReshapeNegativeOutputDimErrorMessage(d, size));
            product *= size;
            outputShape.push(size);
        }
    }
    if (unknownIndex !== -1) {
        if (product <= 0) throw new Error((0, $f35e0c1a651337db$exports).getSparseReshapeEmptyTensorZeroOutputDimErrorMessage());
        const missing = Math.trunc(denseSize / product);
        if (product * missing !== denseSize) throw new Error((0, $f35e0c1a651337db$exports).getSparseReshapeInputOutputMultipleErrorMessage(inputShape, outputShape));
        outputShape[unknownIndex] = missing;
    }
    const outputSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(outputShape);
    if (outputSize !== denseSize) throw new Error((0, $f35e0c1a651337db$exports).getSparseReshapeInputOutputMismatchErrorMessage(inputShape, outputShape));
    const inputRank = inputShape.length;
    const inputStrides = [];
    if (inputRank > 0) {
        inputStrides[inputRank - 1] = 1;
        for(let d = inputRank - 2; d >= 0; --d)inputStrides[d] = inputStrides[d + 1] * inputShape[d + 1];
    }
    const outputStrides = [];
    if (outputRank > 0) {
        outputStrides[outputRank - 1] = 1;
        for(let d = outputRank - 2; d >= 0; --d)outputStrides[d] = outputStrides[d + 1] * outputShape[d + 1];
    }
    const newIndices = (0, $0775da5e684c8c0d$exports).getArrayFromDType(inputDType, nnz * outputRank);
    for(let i = 0; i < nnz; ++i){
        let id = 0;
        for(let j = 0; j < inputRank; ++j)// inputIndices is a 2d tensor with shape of [nnz, inputRank]
        id += inputIndices[i * inputRank + j] * inputStrides[j];
        for(let j = 0; j < outputRank; ++j){
            // newIndices is a 2d tensor with shape of [nnz, outputRank]
            newIndices[i * outputRank + j] = Math.trunc(id / outputStrides[j]);
            id %= outputStrides[j];
        }
    }
    return [
        newIndices,
        [
            nnz,
            outputRank
        ],
        outputShape
    ];
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $3a28707787dbe8b5$export$7d3f7130c4245e65(input, inputShape, inputDType, indices, segmentIds, isMean = false, defaultValue = 0) {
    const numIndices = indices.length;
    // Flatten the array to two dimensions
    const inputFlat = [
        inputShape[0],
        input.length / inputShape[0]
    ];
    const numCol = inputFlat[1];
    // Note that the current implementation assumes that segmentIds values are
    // sorted.
    const lastSegmentIdPlusOne = numIndices > 0 ? segmentIds[numIndices - 1] + 1 : 0;
    const outputRows = lastSegmentIdPlusOne;
    if (outputRows < 0) throw new Error((0, $f35e0c1a651337db$exports).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    const outputShape = inputShape.slice();
    outputShape[0] = outputRows;
    const outputLength = outputShape.reduce((product, value)=>product * value, 1);
    // Output array is initialized with the value 0 by default.
    const output = (0, $0775da5e684c8c0d$exports).getArrayFromDType(inputDType, outputLength);
    // Note that we do not initialize the output buffer with a default value, so
    // we need to explicitly set missing indices to the default value.
    if (numIndices === 0) {
        if (outputRows > 0) output.fill(defaultValue);
        return [
            output,
            outputShape
        ];
    }
    if (outputRows <= 0) throw new Error((0, $f35e0c1a651337db$exports).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    let start = 0, end = 1;
    // Index from which the output is not initialized.
    let uninitializedIndex = 0;
    let outIndex = segmentIds[start];
    while(true){
        // We initialize nextIndex to 0 to avoid may be uninitialized warning
        let nextIndex = 0;
        if (end < numIndices) {
            nextIndex = segmentIds[end];
            if (outIndex === nextIndex) {
                ++end;
                continue;
            }
            // We have a new segment here.  Verify that the segment ids are growing.
            if (outIndex >= nextIndex) throw new Error((0, $f35e0c1a651337db$exports).getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage());
        }
        if (outIndex < 0 || outIndex >= outputRows) throw new Error((0, $f35e0c1a651337db$exports).getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(outIndex, outputRows));
        // If there is a gap between two indices, we need to set that gap to the
        // default value.
        if (outIndex > uninitializedIndex) output.fill(defaultValue, uninitializedIndex * numCol, outIndex * numCol);
        for(let i = start; i < end; ++i){
            const index = indices[i];
            if (index < 0 || index >= inputFlat[0]) throw new Error((0, $f35e0c1a651337db$exports).getSparseSegmentReductionIndicesOutOfRangeErrorMessage(i, indices[i], inputFlat[0]));
            for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] += input[index * numCol + j];
        }
        if (isMean) for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] /= end - start;
        start = end;
        ++end;
        uninitializedIndex = outIndex + 1;
        outIndex = nextIndex;
        if (end > numIndices) break;
    }
    // Fill the gap at the end with the default value.
    if (uninitializedIndex < outputRows) output.fill(defaultValue, uninitializedIndex * numCol, outputRows * numCol);
    return [
        output,
        outputShape
    ];
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $c3b2ce83ba7256ac$export$c6f4fdf945028fb = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((xi)=>Math.sqrt(xi));
const $c3b2ce83ba7256ac$export$eba8049fb5020b81 = (0, $daf1a402932b3109$export$ba4daf5748026fba)((0, $507890e4aa8e1463$export$21ab404ab9d512a6), (xi)=>Math.sqrt(xi));
const $c3b2ce83ba7256ac$export$a592ba9268f10eeb = {
    kernelName: (0, $507890e4aa8e1463$export$21ab404ab9d512a6),
    backendName: 'cpu',
    kernelFunc: $c3b2ce83ba7256ac$export$eba8049fb5020b81
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $5f830d81433de8bd$export$11806d7b3158c032 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((a, b)=>{
    const diff = a - b;
    return diff * diff;
});
const $5f830d81433de8bd$export$b178697fb6d0b37f = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$2f922d20d66089c6), $5f830d81433de8bd$export$11806d7b3158c032);
const $5f830d81433de8bd$export$9ed4691d69db8a43 = {
    kernelName: (0, $507890e4aa8e1463$export$2f922d20d66089c6),
    backendName: 'cpu',
    kernelFunc: $5f830d81433de8bd$export$b178697fb6d0b37f
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $239eecea1da1670e$export$d0ac9d977b12e2a1 = (0, $25d955d75de86d0d$export$ef8b4452872ef3fc)((x, attrs)=>{
    const { pattern: pattern, replaceGlobal: replaceGlobal, rewrite: rewrite } = attrs;
    // TODO(mattSoulanille): Don't create a regex each time.
    return x.replace(new RegExp(pattern, replaceGlobal ? 'g' : ''), rewrite);
});
const $239eecea1da1670e$var$staticRegexReplace = (0, $daf1a402932b3109$export$34f6865a07ad09b6)((0, $507890e4aa8e1463$export$2fbaa77553edaeff), $239eecea1da1670e$export$d0ac9d977b12e2a1);
const $239eecea1da1670e$export$1069b2f6977254f4 = {
    kernelName: (0, $507890e4aa8e1463$export$2fbaa77553edaeff),
    backendName: 'cpu',
    kernelFunc: $239eecea1da1670e$var$staticRegexReplace
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $a91b14678dc9e667$export$b7c450ffe7e10d88(outShape, xBuf, strides, begin) {
    const outBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(outShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; i++){
        const loc = outBuf.indexToLoc(i);
        const newLoc = new Array(loc.length);
        for(let j = 0; j < newLoc.length; j++)newLoc[j] = loc[j] * strides[j] + begin[j];
        outBuf.set(xBuf.get(...newLoc), ...loc);
    }
    return outBuf;
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * The StringNGramsOp class creates ngrams from ragged string data.
 * The constructor contains all attributes related to the operation such as
 * padding widths and strings, and the compute function can be used to
 * compute the ngrams for different ragged tensor inputs.
 */ class $922bdc759a835cbf$var$StringNGramsOp {
    constructor(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences){
        this.separator = (0, $0775da5e684c8c0d$exports).encodeString(separator);
        this.nGramWidths = nGramWidths;
        this.leftPad = (0, $0775da5e684c8c0d$exports).encodeString(leftPad);
        this.rightPad = (0, $0775da5e684c8c0d$exports).encodeString(rightPad);
        this.padWidth = padWidth;
        this.preserveShort = preserveShortSequences;
    }
    getPadWidth(nGramWidth) {
        // Ngrams can be padded with either a fixed pad width or a dynamic pad
        // width depending on the 'padWidth' arg, but in no case should the padding
        // ever be wider than 'nGramWidth' - 1.
        return Math.min(this.padWidth < 0 ? nGramWidth - 1 : this.padWidth, nGramWidth - 1);
    }
    getNumNGrams(length, nGramWidth) {
        const padWidth = this.getPadWidth(nGramWidth);
        return Math.max(0, length + 2 * padWidth - nGramWidth + 1);
    }
    createNGrams(data, splitIndex, output, outputStartIndex, numNGrams, nGramWidth) {
        for(let nGramIndex = 0; nGramIndex < numNGrams; ++nGramIndex){
            const padWidth = this.getPadWidth(nGramWidth);
            const leftPadding = Math.max(0, padWidth - nGramIndex);
            const rightPadding = Math.max(0, padWidth - (numNGrams - (nGramIndex + 1)));
            const numTokens = nGramWidth - (leftPadding + rightPadding);
            const dataStartIndex = splitIndex + (leftPadding > 0 ? 0 : nGramIndex - padWidth);
            // Calculate the total expected size of the nGram so we can reserve the
            // correct amount of space in the string.
            let nGramSize = 0;
            // Size of the left padding.
            nGramSize += leftPadding * this.leftPad.length;
            // Size of the tokens.
            for(let n = 0; n < numTokens; ++n)nGramSize += data[dataStartIndex + n].length;
            // Size of the right padding.
            nGramSize += rightPadding * this.rightPad.length;
            // Size of the separators.
            const numSeparators = leftPadding + rightPadding + numTokens - 1;
            nGramSize += numSeparators * this.separator.length;
            // Build the nGram.
            output[outputStartIndex + nGramIndex] = new Uint8Array(nGramSize);
            const nGram = output[outputStartIndex + nGramIndex];
            let nextNGramIndex = 0;
            const appendToNGram = (str)=>str.forEach((value)=>nGram[nextNGramIndex++] = value);
            for(let n = 0; n < leftPadding; ++n){
                appendToNGram(this.leftPad);
                appendToNGram(this.separator);
            }
            // Only output first numTokens - 1 pairs of data and separator
            for(let n = 0; n < numTokens - 1; ++n){
                appendToNGram(data[dataStartIndex + n]);
                appendToNGram(this.separator);
            }
            // Handle case when there are no tokens or no right padding as these
            // can result in consecutive separators.
            if (numTokens > 0) {
                // If we have tokens, then output last and then pair each separator
                // with the right padding that follows, to ensure nGram ends either with
                // the token or with the right pad.
                appendToNGram(data[dataStartIndex + numTokens - 1]);
                for(let n = 0; n < rightPadding; ++n){
                    appendToNGram(this.separator);
                    appendToNGram(this.rightPad);
                }
            } else {
                // If we don't have tokens, then the last item inserted into the nGram
                // has been the separator from the left padding loop above. Hence,
                // output right pad and separator and make sure to finish with a
                // padding, not a separator.
                for(let n = 0; n < rightPadding - 1; ++n){
                    appendToNGram(this.rightPad);
                    appendToNGram(this.separator);
                }
                appendToNGram(this.rightPad);
            }
        }
    }
    // Data and splits together form the definition of the ragged tensor,
    // where data is 1 dimensional and contains the values of the tensor
    // and splits denotes the indices at which each row starts.
    compute(data, splits) {
        // Validate that the splits are valid indices into data, only if there are
        // splits specified.
        const inputDataSize = data.length;
        const splitsSize = splits.length;
        if (splitsSize > 0) {
            let prevSplit = splits[0];
            if (prevSplit !== 0) throw new Error(`First split value must be 0, got ${prevSplit}`);
            for(let i = 1; i < splitsSize; ++i){
                let validSplits = splits[i] >= prevSplit;
                validSplits = validSplits && splits[i] <= inputDataSize;
                if (!validSplits) throw new Error(`Invalid split value ${splits[i]}, must be in [${prevSplit}, ${inputDataSize}]`);
                prevSplit = splits[i];
            }
            if (prevSplit !== inputDataSize) throw new Error(`Last split value must be data size. Expected ${inputDataSize}, got ${prevSplit}`);
        }
        const numBatchItems = splitsSize - 1;
        const nGramsSplits = (0, $0775da5e684c8c0d$exports).getArrayFromDType('int32', splitsSize);
        // If there is no data or size, return an empty ragged tensor.
        if (inputDataSize === 0 || splitsSize === 0) {
            const empty = new Array(inputDataSize);
            for(let i = 0; i <= numBatchItems; ++i)nGramsSplits[i] = 0;
            return [
                empty,
                nGramsSplits
            ];
        }
        nGramsSplits[0] = 0;
        for(let i = 1; i <= numBatchItems; ++i){
            const length = splits[i] - splits[i - 1];
            let numNGrams = 0;
            this.nGramWidths.forEach((nGramWidth)=>{
                numNGrams += this.getNumNGrams(length, nGramWidth);
            });
            if (this.preserveShort && length > 0 && numNGrams === 0) numNGrams = 1;
            nGramsSplits[i] = nGramsSplits[i - 1] + numNGrams;
        }
        const nGrams = new Array(nGramsSplits[numBatchItems]);
        for(let i = 0; i < numBatchItems; ++i){
            const splitIndex = splits[i];
            let outputStartIdx = nGramsSplits[i];
            this.nGramWidths.forEach((nGramWidth)=>{
                const length = splits[i + 1] - splits[i];
                const numNGrams = this.getNumNGrams(length, nGramWidth);
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
                outputStartIdx += numNGrams;
            });
            // If we're preserving short sequences, check to see if no sequence was
            // generated by comparing the current output start idx to the original
            // one (nGramSplitsdata). If no ngrams were generated, then they will
            // be equal (since we increment outputStartIdx by numNGrams every
            // time we create a set of ngrams.)
            if (this.preserveShort && outputStartIdx === nGramsSplits[i]) {
                const dataLength = splits[i + 1] - splits[i];
                // One legitimate reason to not have any ngrams when this.preserveShort
                // is true is if the sequence itself is empty. In that case, move on.
                if (dataLength === 0) continue;
                // We don't have to worry about dynamic padding sizes here: if padding
                // was dynamic, every sequence would have had sufficient padding to
                // generate at least one nGram.
                const nGramWidth = dataLength + 2 * this.padWidth;
                const numNGrams = 1;
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
            }
        }
        return [
            nGrams,
            nGramsSplits
        ];
    }
}
function $922bdc759a835cbf$export$67c0958e8184138b(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    return new $922bdc759a835cbf$var$StringNGramsOp(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences).compute(data, dataSplits);
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $f02c467c2a81fd0f$var$split(str, delimiters, skipEmpty, result) {
    if (!str.length) return;
    // When the delimiter is empty, the input is split into individual characters.
    if (delimiters.length === 0) {
        for(let i = 0; i < str.length; ++i)result.push(str.subarray(i, i + 1));
        return;
    }
    // When there is one delimiter, the input is split only at that delimiter.
    if (delimiters.length === 1) {
        const delimiter = delimiters[0];
        let f = str.indexOf(delimiter);
        while(f !== -1){
            const token = str.subarray(0, f);
            if (!skipEmpty || token.length !== 0) result.push(token);
            str = str.subarray(f + 1);
            f = str.indexOf(delimiter);
        }
        if (!skipEmpty || str.length !== 0) result.push(str);
        return;
    }
    // When there are multiple delimiters, the input is split at every instance
    // one of the delimiters appears.
    let tokenStart = 0;
    for(let i = 0; i < str.length + 1; i++)if (i === str.length || delimiters.indexOf(str[i]) !== -1) {
        const token = str.subarray(tokenStart, i);
        if (!skipEmpty || token.length !== 0) result.push(token);
        tokenStart = i + 1;
    }
}
function $f02c467c2a81fd0f$export$c3b08e43aa36d65d(input, delimiter, skipEmpty) {
    const batchSize = input.length;
    // Empty delimiter means split the input character by character.
    const tokens = [];
    let outputSize = 0;
    let maxNumEntries = 0;
    const numIndices = new Array(batchSize);
    for(let i = 0; i < batchSize; ++i){
        const prevTokensLength = tokens.length;
        $f02c467c2a81fd0f$var$split(input[i], delimiter, skipEmpty, tokens);
        const nEntries = tokens.length - prevTokensLength;
        numIndices[i] = nEntries;
        outputSize += nEntries;
        maxNumEntries = Math.max(maxNumEntries, nEntries);
    }
    const indices = (0, $0775da5e684c8c0d$exports).getArrayFromDType('int32', outputSize * 2);
    const values = new Array(outputSize);
    const shape = [
        batchSize,
        maxNumEntries
    ];
    let c = 0;
    for(let i = 0; i < batchSize; ++i)for(let j = 0; j < numIndices[i]; ++j){
        // indices is a 2d tensor with shape of [outputSize, 2]
        indices[c * 2] = i;
        indices[c * 2 + 1] = j;
        values[c] = tokens[c];
        ++c;
    }
    return [
        indices,
        values,
        shape
    ];
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $25c6d5afb1fded19$export$37cbed4d0b2fe56a(input, numBuckets) {
    const output = (0, $0775da5e684c8c0d$exports).getArrayFromDType('int32', input.length);
    for(let i = 0; i < input.length; ++i)output[i] = (0, $0775da5e684c8c0d$exports).fingerPrint64(input[i]).modulo(numBuckets).getLowBitsUnsigned();
    return output;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $9ce3a9c9010ae9e5$export$ad8defe68e22c8c1 = (0, $513c1c901b9c8a48$export$28de919591fae5d9)((aValue, bValue)=>aValue - bValue);
const $9ce3a9c9010ae9e5$export$e56bd24b892e7ec5 = (0, $350425b01c678d60$export$79261d982c3c14a7)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal - bReal,
        imag: aImag - bImag
    };
});
const $9ce3a9c9010ae9e5$export$f93b5905241a7cca = (0, $350425b01c678d60$export$29353c66e70e3e16)((0, $507890e4aa8e1463$export$d7a01e11500dfb6f), $9ce3a9c9010ae9e5$export$ad8defe68e22c8c1, $9ce3a9c9010ae9e5$export$e56bd24b892e7ec5);
const $9ce3a9c9010ae9e5$export$5d068476dad60c4d = {
    kernelName: (0, $507890e4aa8e1463$export$d7a01e11500dfb6f),
    backendName: 'cpu',
    kernelFunc: $9ce3a9c9010ae9e5$export$f93b5905241a7cca
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $cac0bebccf7fd356$export$f3e554b937559516(xBuf, reps) {
    const newShape = new Array(xBuf.rank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = xBuf.shape[i] * reps[i];
    const result = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(newShape, xBuf.dtype);
    for(let i = 0; i < result.values.length; ++i){
        const newLoc = result.indexToLoc(i);
        const originalLoc = new Array(xBuf.rank);
        for(let j = 0; j < originalLoc.length; j++)originalLoc[j] = newLoc[j] % xBuf.shape[j];
        const originalIndex = xBuf.locToIndex(originalLoc);
        result.values[i] = xBuf.values[originalIndex];
    }
    return result;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the TopK kernel shared between webgl and cpu. */ 
const $4c965e30a142cad8$var$comparePair = (a, b)=>{
    const valueDiff = b.value - a.value;
    return valueDiff === 0 ? a.index - b.index : valueDiff;
};
/**
 * Partitions array where all elements smaller than the (k+1) smallest element
 * are found to the left of it, and all larger to the right of it.
 * Based on the Floyd-Rivest Algorithm, ref:
 * https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm
 * @param array: Array to partition
 * @param left: Left index for the interval
 * @param right: Right index for the interval
 * @param k: Desired index value, where array[k] is the (k+1)th smallest element
 *           when left = 0
 */ function $4c965e30a142cad8$var$select(array, k, left = 0, right = array.length - 1) {
    while(right > left){
        // Use select recursively to sample a smaller set of size s
        // the arbitrary constants 600 and 0.5 are used in the original
        // version to minimize execution time.
        if (right - left > 600) {
            const n = right - left + 1;
            const i = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * Math.sign(i - n / 2);
            const newLeft = Math.max(left, Math.floor(k - i * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - i) * s / n + sd));
            $4c965e30a142cad8$var$select(array, k, newLeft, newRight);
        }
        // partition the elements between left and right around t
        const t = array[k];
        let i = left;
        let j = right;
        (0, $0775da5e684c8c0d$exports).swap(array, left, k);
        if ($4c965e30a142cad8$var$comparePair(array[right], t) > 0) (0, $0775da5e684c8c0d$exports).swap(array, left, right);
        while(i < j){
            (0, $0775da5e684c8c0d$exports).swap(array, i, j);
            i++;
            j--;
            while($4c965e30a142cad8$var$comparePair(array[i], t) < 0)i = i + 1;
            while($4c965e30a142cad8$var$comparePair(array[j], t) > 0)j = j - 1;
        }
        if ($4c965e30a142cad8$var$comparePair(array[left], t) === 0) (0, $0775da5e684c8c0d$exports).swap(array, left, j);
        else {
            j = j + 1;
            (0, $0775da5e684c8c0d$exports).swap(array, j, right);
        }
        // Adjust left and right towards the boundaries of the subset
        // containing the (k - left + 1)th smallest element.
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
function $4c965e30a142cad8$export$b083239978762299(x, xShape, xDtype, k, sorted) {
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const lastDim = xShape[xShape.length - 1];
    const [batch, size] = [
        x.length / lastDim,
        lastDim
    ];
    const allTopKVals = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType(xDtype, batch * k);
    const allTopKIndices = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType('int32', batch * k);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = x.subarray(offset, offset + size);
        let valAndInd = new Array(vals.length);
        vals.forEach((value, index)=>valAndInd[index] = {
                value: value,
                index: index
            });
        if (k < valAndInd.length) {
            $4c965e30a142cad8$var$select(valAndInd, k);
            valAndInd = valAndInd.slice(0, k);
        }
        if (sorted) valAndInd.sort($4c965e30a142cad8$var$comparePair);
        const outOffset = b * k;
        const topKVals = allTopKVals.subarray(outOffset, outOffset + k);
        const topKIndices = allTopKIndices.subarray(outOffset, outOffset + k);
        for(let i = 0; i < k; i++){
            topKVals[i] = valAndInd[i].value;
            topKIndices[i] = valAndInd[i].index;
        }
    }
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const outputShape = xShape.slice();
    outputShape[outputShape.length - 1] = k;
    return [
        (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(outputShape, xDtype, allTopKVals),
        (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(outputShape, 'int32', allTopKIndices)
    ];
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $7bddd9b297c4c91f$export$58be9cc013c994e(values, axis, shape, dtype) {
    // Normalize and validate axis.
    const $axis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, shape)[0];
    // Calculate the new shape that is suitable for extracting data along the
    // given axis.
    //
    // The rank is 3.
    // The size of the 1st dimension is the size of all the axes < the given axis.
    // The size of the 2nd dimension is the same as the size of the given axis.
    // The size of the 3rd dimension is the size of all the axes > the given axis.
    //
    // For example, for a 4D tensor with shape=[2, 3, 5, 4] and axis=2, the
    // newShape would be: [2*3, 5, 4].
    //
    // Note that this is not the final output shape. This will be the shape for an
    // intermediate TensorBuffer (see inputBuffer below) to allow us to extract
    // values along the given axis. To demonstrate how it works, consider the
    // following example:
    //
    // Input: a 3D tensor, with shape [1, 2, 3]
    // [
    //   [
    //      [1,2,3],
    //      [4,5,6]
    //   ]
    // ]
    // Axis: 2 (the last axis).
    // Along axis 2, we expect to extract 3 tensors: [1,4], [2,5], [3,6].
    //
    // For this example, newShape would be: [2, 3, 1], where 2 is calculated from
    // 1*2. The re-shaped data would look like:
    //
    // [
    //   [
    //     [1], [2], [3]
    //   ],
    //   [
    //     [4], [5], [6]
    //   ]
    // ]
    //
    // Then, we can construct a 3-level nested loop by the following dimension
    // order to extract the values along the axis (dimension1):
    // i: dimension1       // 0,1,2 (newShape[1])
    //   m: dimension0     // 0,1   (newShape[0])
    //     n: dimension2   // 0     (newShape[2])
    //
    //                       m, i, n
    //                      ---------
    // Iteration 0: data at [0, 0, 0] => "1"
    // Iteration 1: data at [1, 0, 0] => "4"
    // We got [1,4].
    // Iteration 2: data at [0, 1, 0] => "2"
    // Iteration 3: data at [1, 1, 0] => "5"
    // We got [2,5].
    // Iteration 4: data at [0, 2, 0] => "3"
    // Iteration 5: data at [1, 2, 0] => "6"
    // We got [3,6].
    const newShape = [
        1,
        shape[0],
        1
    ];
    for(let i = 0; i < $axis; i++)newShape[0] *= shape[i];
    newShape[1] = shape[$axis];
    for(let i = $axis + 1; i < shape.length; i++)newShape[2] *= shape[i];
    // A map from unique elements (their string representations) to their values
    // in "indices" (below).
    const uniqueElements = new Map();
    // The indices of each unique element in the original tensor along the given
    // axis. It is 1D and has the same size as the given axis.
    const indices = new Int32Array(shape[$axis]);
    // Create a buffer so we can easily extract value at a given location.
    const inputBuffer = new (0, $4b7222b1b59444b8$export$350df26cd52e08e1)(newShape, dtype, values);
    // The indices along the given axis that have unique elements. This is a
    // de-duped version of "indices" above.
    const uniqueIndices = [];
    const is1DTensor = newShape[0] === 1 && newShape[2] === 1;
    for(let i = 0; i < shape[$axis]; i++){
        // Extract values along the axis.
        let element;
        if (is1DTensor) // Fast path for 1D tensor input.
        element = values[i].toString();
        else {
            const axisValues = [];
            for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)axisValues.push(inputBuffer.get(m, i, n));
            element = axisValues.join(',');
        }
        // Dedup and update various indices.
        const existingIndex = uniqueElements.get(element);
        if (existingIndex != null) indices[i] = existingIndex;
        else {
            const uniqueIndex = uniqueElements.size;
            uniqueElements.set(element, uniqueIndex);
            indices[i] = uniqueIndex;
            uniqueIndices.push(i);
        }
    }
    // Now we know where each of the unique elements are located along the axis
    // (uniqueIndices). Extract them from input buffer and store them in the
    // output buffer.
    const outputTmpShape = newShape.slice();
    outputTmpShape[1] = uniqueElements.size;
    const outputBuffer = new (0, $4b7222b1b59444b8$export$350df26cd52e08e1)(outputTmpShape, dtype);
    uniqueIndices.forEach((uniqueElementIndex, i)=>{
        for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)outputBuffer.set(inputBuffer.get(m, uniqueElementIndex, n), m, i, n);
    });
    // The output shape can be calculated from the input shape with the size of
    // the given axis replaced by the number of unique elements along that axis.
    const outputShape = shape.slice();
    outputShape[$axis] = outputTmpShape[1];
    return {
        outputValues: outputBuffer.values,
        outputShape: outputShape,
        indices: indices
    };
}




const { addImpl: $218cb6c8b1f27bad$export$c7f405723b4a93e7, castImpl: $218cb6c8b1f27bad$export$babf602309dd6292, ceilImpl: $218cb6c8b1f27bad$export$bb3ce81256fe261b, concatImpl: $218cb6c8b1f27bad$export$95e7342d25849d64, equalImpl: $218cb6c8b1f27bad$export$13d1298222b29d06, expImpl: $218cb6c8b1f27bad$export$f72e179c9610cb8c, expm1Impl: $218cb6c8b1f27bad$export$5903785c29f035f5, floorImpl: $218cb6c8b1f27bad$export$195a28e6add8ab7e, floorDivImpl: $218cb6c8b1f27bad$export$afb5f31ac42ca629, gatherNdImpl: $218cb6c8b1f27bad$export$e3196a12dce24214, gatherV2Impl: $218cb6c8b1f27bad$export$cffe0fde89e98de6, greaterEqualImpl: $218cb6c8b1f27bad$export$a3d2e203d979d298, greaterImpl: $218cb6c8b1f27bad$export$eabb8927944259dd, lessEqualImpl: $218cb6c8b1f27bad$export$6d1533a3ea9565f, lessImpl: $218cb6c8b1f27bad$export$74c893b3c5e74e60, logImpl: $218cb6c8b1f27bad$export$e88dde64a338f813, maxImpl: $218cb6c8b1f27bad$export$a94164c9f637858e, maximumImpl: $218cb6c8b1f27bad$export$b3afdc53a543e175, minimumImpl: $218cb6c8b1f27bad$export$1f01be3f637863fa, multiplyImpl: $218cb6c8b1f27bad$export$598d1d66b05a298f, negImpl: $218cb6c8b1f27bad$export$1cbcde7624effb15, notEqualImpl: $218cb6c8b1f27bad$export$b91372753635df24, prodImpl: $218cb6c8b1f27bad$export$2d654219115cec80, rangeImpl: $218cb6c8b1f27bad$export$fbee6deed7e76443, rsqrtImpl: $218cb6c8b1f27bad$export$431ccb02913a1aee, scatterImpl: $218cb6c8b1f27bad$export$2295c910080b5ca7, simpleAbsImpl: $218cb6c8b1f27bad$export$d7efa3585619eabe, sliceImpl: $218cb6c8b1f27bad$export$45812d0d8578899, stridedSliceImpl: $218cb6c8b1f27bad$export$efd4e188e5de0188, stringNGramsImpl: $218cb6c8b1f27bad$export$bb9e83cb65884ef3, subImpl: $218cb6c8b1f27bad$export$be7474e96b733333, tileImpl: $218cb6c8b1f27bad$export$349e02a266ab3131, topKImpl: $218cb6c8b1f27bad$export$cc4aa6851cf96e2b, transposeImpl: $218cb6c8b1f27bad$export$a0105d4a7143676c, uniqueImpl: $218cb6c8b1f27bad$export$c417de669ad2e148 } = $f98ae2f32496d64b$exports;



const $b0beb2984c91405d$export$2335f513bbd82c6d = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ABS,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$d7efa3585619eabe)
});
const $b0beb2984c91405d$export$d66f48648b9d5ec7 = {
    kernelName: (0, $507890e4aa8e1463$export$b73c596ee8758a66),
    backendName: 'webgpu',
    kernelFunc: $b0beb2984c91405d$export$2335f513bbd82c6d
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $bce484a8ced809d4$export$fd6306be3fde5b04 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ACOS
});
const $bce484a8ced809d4$export$255826ca70737275 = {
    kernelName: (0, $507890e4aa8e1463$export$3b952c9980dac550),
    backendName: 'webgpu',
    kernelFunc: $bce484a8ced809d4$export$fd6306be3fde5b04
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $ae1cd03edbd311a8$export$b26caf0f29211d08 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ACOSH
});
const $ae1cd03edbd311a8$export$3f520b71a56c9e70 = {
    kernelName: (0, $507890e4aa8e1463$export$987da490b7c2e7dd),
    backendName: 'webgpu',
    kernelFunc: $ae1cd03edbd311a8$export$b26caf0f29211d08
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $371650ba4f8be205$export$d50bf7e4980f70a9 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).ADD,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$c7f405723b4a93e7),
    supportsComplex: true
});
const $371650ba4f8be205$export$b1f3a580afb68e4c = {
    kernelName: (0, $507890e4aa8e1463$export$d0265b2c425512d6),
    backendName: 'webgpu',
    kernelFunc: $371650ba4f8be205$export$d50bf7e4980f70a9
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $a0acd6277350892a$export$156b01c0aab97d90 {
    constructor(shapes){
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shapes[0];
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.shaderKey = 'addN';
    }
    getUserCode() {
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`let v${variable} = get${variable}ByOutputCoords(coords);`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        for (var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let flatIndex = index * ${this.workPerThread} + i;
          if (flatIndex < uniforms.size) {
            let coords = getCoordsFromIndex(flatIndex);
            ${snippets.join('\n        ')}
            setOutputAtIndex(flatIndex, ${operation});
          }
        }
      }
    `;
        return userCode;
    }
}



function $d5d92268ded79447$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    if (tensors.length === 1) return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: tensors[0]
        },
        backend: backend
    });
    const dtype = tensors.map((t)=>t.dtype).reduce((d1, d2)=>(0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(d1, d2));
    const shapes = tensors.map((t)=>t.shape);
    const program = new (0, $a0acd6277350892a$export$156b01c0aab97d90)(shapes);
    return backend.runWebGPUProgram(program, tensors, dtype);
}
const $d5d92268ded79447$export$ff8000bc6f0313e1 = {
    kernelName: (0, $507890e4aa8e1463$export$eef235ad06d3226a),
    backendName: 'webgpu',
    kernelFunc: $d5d92268ded79447$export$37b75d0026f96b8d
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $9df2a6dc4b27cf58$export$bc7d0d329ecc3b4f {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        // Note that the maximum number of workgroup invocations by webgpu is 256.
        this.workgroupSize = [
            16,
            16,
            1
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                0
            ],
            y: [
                1
            ]
        };
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            1,
            1,
            1
        ]);
        this.shaderKey = 'transposeShared';
    }
    getUserCode() {
        (0, $0775da5e684c8c0d$exports).assert(this.workgroupSize[0] === this.workgroupSize[1], ()=>`Must be a square tile, current tile shape is ${this.workgroupSize[0]} x ${this.workgroupSize[1]}`);
        const tileSize = this.workgroupSize[0];
        const userCode = `
      var<workgroup> tile : array<array<f32, ${this.workgroupSize[0] + 1}>, ${this.workgroupSize[0]}>;
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
        var x = i32(workgroupId.x) * ${tileSize} + i32(localId.x);
        var y = i32(workgroupId.y) * ${tileSize} + i32(localId.y);
        let width = uniforms.outShape[0];
        let height = uniforms.outShape[1];
        if (x < width && y < height) {
          tile[localId.y][localId.x] = f32(A[y * width + x]);
        }
        workgroupBarrier();

        x = i32(workgroupId.y) * ${tileSize} + i32(localId.x);
        y = i32(workgroupId.x) * ${tileSize} + i32(localId.y);
        if (x < height && y < width) {
          setOutputAtIndex((y * height + x), tile[localId.x]
            [localId.y]);
        }
      }
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $0801bdf3f95188e8$export$e48ac6bd7e0ddfac {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.newDim = newDim;
        this.shaderKey = `transpose_${newDim}`;
    }
    getUserCode() {
        const dtype = (0, $0533631f1fe2cae9$export$859efd105c10c755)(this.outputShape.length);
        const switched = $0801bdf3f95188e8$export$2fa044c45543b8d9(this.newDim);
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        for(var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let flatIndex = index * ${this.workPerThread} + i;
          if(flatIndex < uniforms.size) {
            let coords = getCoordsFromIndex(flatIndex);
            setOutputAtIndex(flatIndex, A[getIndexFromCoords${this.outputShape.length}D(
              ${dtype}(${switched}), uniforms.aShape)]);
          }
        }
      }
    `;
        return userCode;
    }
}
function $0801bdf3f95188e8$export$2fa044c45543b8d9(newDim) {
    const rank = newDim.length;
    if (rank > 6) throw Error(`Transpose for rank ${rank} is not yet supported`);
    const switchedCoords = new Array(rank);
    for(let i = 0; i < newDim.length; i++)switchedCoords[newDim[i]] = `coords.${(0, $0533631f1fe2cae9$export$9e429db2fd13bb35)(i)}`;
    return switchedCoords.join();
}


function $d17e3185b399f73e$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    const webgpuBackend = backend;
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = webgpuBackend.tensorMap.get(x.dataId);
        const values = xData.values;
        const outValues = (0, $218cb6c8b1f27bad$export$a0105d4a7143676c)(values, x.shape, x.dtype, perm, newShape);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    if (x.shape.length === 2 && (0, $0775da5e684c8c0d$exports).arraysEqual(perm, [
        1,
        0
    ])) {
        const program = new (0, $9df2a6dc4b27cf58$export$bc7d0d329ecc3b4f)(x.shape, perm);
        return webgpuBackend.runWebGPUProgram(program, [
            x
        ], x.dtype);
    }
    const program = new (0, $0801bdf3f95188e8$export$e48ac6bd7e0ddfac)(x.shape, perm);
    return webgpuBackend.runWebGPUProgram(program, [
        x
    ], x.dtype);
}
const $d17e3185b399f73e$export$895a002a39b774be = {
    kernelName: (0, $507890e4aa8e1463$export$7e714455f9a1f8f7),
    backendName: 'webgpu',
    kernelFunc: $d17e3185b399f73e$export$9cb09a71b7d66923
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $bf6b25dd05571ef8$export$14f07173aed228a5 {
    constructor(reduceInfo, reduceType, maxComputeWorkgroupSizeX){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'reduceSize : i32,';
        this.size = true;
        this.inputShape = [
            reduceInfo.batchSize,
            reduceInfo.inSize
        ];
        const [outputShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(this.inputShape, [
            1
        ]);
        this.outputShape = outputShape.length === 0 ? [
            1
        ] : outputShape;
        // If reduceSize |reduceInfo.inSize| is very large, the I/O accessing will
        // become the bottleneck. Increasing workgroupSize can reduce the times of
        // accessing global memory. The threshold value is just to make sure the
        // reduceSize is large enough for a bigger workgroupSize.
        if (reduceInfo.inSize >= 32768 && maxComputeWorkgroupSizeX >= 512) this.workgroupSize = [
            512,
            1,
            1
        ];
        else if (reduceInfo.inSize >= 4096) this.workgroupSize = [
            256,
            1,
            1
        ];
        else this.workgroupSize = [
            64,
            1,
            1
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        // A work group only outputs a data, so we transfer [1, 1, 1] to compute
        // dispatch size.
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, [
            1,
            1,
            1
        ]);
        this.reduceType = reduceType;
        this.shaderKey = `reduce_${reduceType}`;
    }
    getUserCode() {
        let reduceOp = ``;
        let initValue = '0.0';
        const workgroupSizeX = this.workgroupSize[0];
        if (this.reduceType === 'min' || this.reduceType === 'max') {
            reduceOp = `
         if (isnan(candidate)) {
          bestValue = uniforms.NAN;
         } else if (!isnan(bestValue) && candidate ${this.reduceType === 'min' ? '<' : '>'} bestValue)
           {  bestValue = candidate; }`;
            initValue = 'f32(x[offset])';
        } else if (this.reduceType === 'sum' || this.reduceType === 'mean') reduceOp = ' bestValue = bestValue + candidate; ';
        else if (this.reduceType === 'prod') {
            reduceOp = ' bestValue = bestValue * candidate; ';
            initValue = '1.0';
        } else if (this.reduceType === 'all') {
            reduceOp = ' bestValue = f32(bestValue >= 1.0 && candidate >= 1.0); ';
            initValue = '1.0';
        } else if (this.reduceType === 'any') {
            reduceOp = ' bestValue = f32(bestValue >= 1.0 || candidate >= 1.0); ';
            initValue = '0.0';
        }
        const outputSnippet = this.reduceType === 'mean' ? // tslint:disable-next-line:max-line-length
        `setOutputAtIndex(outputIndex, bestValue / f32(uniforms.reduceSize));` : `setOutputAtIndex(outputIndex, bestValue);`;
        const sharedMemorySnippet = `
         var<workgroup> xBestValues : array<f32, ${workgroupSizeX}>;
       `;
        const userCode = `
       fn DIV_CEIL(a : u32, b : u32) -> u32 {
        return ((a - 1u) / b + 1u);
       }

       ${sharedMemorySnippet}
       fn getOffset(outputIndex : i32) -> i32 {
         let outputCoords = getCoordsFromIndex(outputIndex);
         let offset = ${this.outputShape.length === 1 ? 'outputCoords' : 'outputCoords[0]'} * uniforms.reduceSize;
          return offset;
       }
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         let outputIndex = index / ${workgroupSizeX};
         let offset = getOffset(outputIndex);
         var bestValue = ${initValue};
         let Length = uniforms.reduceSize;
         let WorkPerThread = DIV_CEIL(u32(Length), ${workgroupSizeX}u);
         for (var k = i32(localId.x); k < Length && outputIndex < uniforms.size;
             k = k + ${workgroupSizeX}) {
           let candidate = f32(x[offset + k]);
           ${reduceOp}
         }
         xBestValues[localId.x] = bestValue;
         workgroupBarrier();

         var reduceSize = min(u32(Length), ${workgroupSizeX}u);
         for (var currentSize = reduceSize / 2u; reduceSize > 1u;
             currentSize = reduceSize / 2u) {
           let interval = DIV_CEIL(reduceSize, 2u);
           if (localId.x < currentSize) {
            let candidate = xBestValues[localId.x + interval];
            ${reduceOp}
            xBestValues[localId.x] = bestValue;
           }
           reduceSize = interval;
           workgroupBarrier();
         }

         if (localId.x == 0u && outputIndex < uniforms.size) {
          ${outputSnippet}
        }
       }
     `;
        return userCode;
    }
}



const $e50db2d696ca0e7f$var$RETURN_TYPES = {
    'mean': 'float32',
    'all': 'bool',
    'any': 'bool'
};
function $e50db2d696ca0e7f$export$533b26079ad0b4b(x, axis, keepDims, reduceType, backend) {
    const xRank = x.shape.length;
    const toDispose = [];
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    let input = x;
    if (permutedAxes != null) {
        input = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            attrs: {
                perm: permutedAxes
            },
            backend: backend
        });
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
        toDispose.push(input);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims(reduceType, axes, xRank);
    const [reduceOutShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(input.shape, axes);
    let resOutShape = reduceOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    resOutShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(reduceOutShape, origAxes);
    let res;
    if ((reduceType === 'max' || reduceType === 'prod') && backend.shouldExecuteOnCPU([
        input
    ])) {
        const xVals = backend.tensorMap.get(input.dataId).values;
        switch(reduceType){
            case 'max':
                const outValues = (0, $218cb6c8b1f27bad$export$a94164c9f637858e)(xVals, (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape), resOutShape, x.dtype);
                res = backend.makeTensorInfo(resOutShape, x.dtype, outValues);
                break;
            case 'prod':
                const { outVals: outVals, outShape: outShape, outDtype: outDtype } = (0, $218cb6c8b1f27bad$export$2d654219115cec80)(input.shape, input.dtype, xVals, axes);
                res = backend.makeTensorInfo(outShape, outDtype, outVals);
                break;
            default:
                throw new Error(`${reduceType} CPU implementation is not yet supported.`);
        }
    } else {
        const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
        const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape);
        const batchSize = xSize / inSize;
        const reduceInfo = {
            windowSize: inSize,
            inSize: inSize,
            batchSize: batchSize,
            outSize: 1
        };
        const dtype = $e50db2d696ca0e7f$var$RETURN_TYPES[reduceType] || (0, $4ccb7c1368387e67$export$3479b4fbed3c0d8d)(x.dtype);
        const uniformData = [
            {
                type: 'int32',
                data: [
                    inSize
                ]
            }
        ];
        const program = new (0, $bf6b25dd05571ef8$export$14f07173aed228a5)(reduceInfo, reduceType, backend.device.limits.maxComputeWorkgroupSizeX);
        const reduced = backend.runWebGPUProgram(program, [
            input
        ], dtype, uniformData);
        toDispose.push(reduced);
        res = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            attrs: {
                shape: resOutShape
            },
            backend: backend
        });
    }
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return res;
}


function $df1d5a3f46ba30ff$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { keepDims: keepDims, axis: axis } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, axis, keepDims, 'all', backend);
}
const $df1d5a3f46ba30ff$export$4e3f081eb1a330fa = {
    kernelName: (0, $507890e4aa8e1463$export$5dceb1ab650a1776),
    backendName: 'webgpu',
    kernelFunc: $df1d5a3f46ba30ff$export$84bf76cd7afc7469
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $f46546394f4ee777$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { keepDims: keepDims, axis: axis } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, axis, keepDims, 'any', backend);
}
const $f46546394f4ee777$export$1a8ff634f2df3da6 = {
    kernelName: (0, $507890e4aa8e1463$export$b24b633b1364b94b),
    backendName: 'webgpu',
    kernelFunc: $f46546394f4ee777$export$4154a199d7d90455
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $7bf5fd582fe4f7fb$export$7fa5759722b57eba {
    constructor(inputShape, axis, reduceType){
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'infinityValue : f32,';
        this.size = true;
        const axes = [
            axis
        ];
        this.op = reduceType === 'min' ? '<' : '>';
        // |outShape| is the shape with the removed axis
        const [outputShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(inputShape, axes);
        this.outputShape = outputShape.length === 0 ? [
            1
        ] : outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        // The shared algorithm is mainly used for large reduce size. It fully
        // utilizes the threads in one workgroup to do the reduction. However,
        // when the reduce size is very small, it's better to use the plain
        // algorithm to reduce the number of workgroups to speedup. The threthold
        // can be further tuned.
        if ((0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape) < 32) {
            this.type = 'plain';
            this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        } else {
            this.type = 'shared';
            // A work group only outputs a data, so we transfer [1, 1, 1] to compute
            // dispatch size.
            this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, [
                1,
                1,
                1
            ]);
        }
        this.inputShape = inputShape;
        this.shaderKey = `argMinMax_${this.op}_${this.type}`;
    }
    getUserCode() {
        const workgroupSizeX = this.workgroupSize[0];
        const getInputShapeLastDim = ()=>{
            if (this.inputShape.length === 1) return 'uniforms.xShape';
            else return `uniforms.xShape.${(0, $0533631f1fe2cae9$export$9e429db2fd13bb35)(this.inputShape.length - 1)}`;
        };
        const splitOutputCoords = ()=>{
            let snippet = '';
            if (this.outputShape.length === 1) {
                if (this.inputShape.length !== 1) snippet += 'outputCoords,';
            } else for(let i = 0; i < this.outputShape.length; i++)snippet += `outputCoords.${(0, $0533631f1fe2cae9$export$9e429db2fd13bb35)(i)},`;
            return snippet;
        };
        if (this.type === 'shared') {
            const sharedMemorySnippet = `
      var<workgroup> xBestIndices : array<i32, ${workgroupSizeX}>;
      var<workgroup> xBestValues : array<f32, ${workgroupSizeX}>;
    `;
            const userCode = `
      fn DIV_CEIL(a : u32, b : u32) -> u32 {
        return ((a - 1u) / b + 1u);
      }

      ${sharedMemorySnippet}

      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        let outputIndex = index / ${workgroupSizeX};
        let reduceLength = ${getInputShapeLastDim()};

        var bestIndex = i32(localId.x);
        var bestValue = uniforms.infinityValue;
        let outputCoords = getCoordsFromIndex(outputIndex);
        for (var k = i32(localId.x); k < reduceLength && outputIndex < uniforms.size;
            k = k + ${workgroupSizeX}) {
          let candidate = getX(${splitOutputCoords()} k);
          if (!isnan(candidate) && candidate ${this.op} bestValue) {
            bestValue = candidate;
            bestIndex = k;
          }
        }
        xBestValues[localId.x] = bestValue;
        xBestIndices[localId.x] = bestIndex;
        workgroupBarrier();

        var reduceSize = min(u32(reduceLength), ${workgroupSizeX}u);
        for (var currentSize = reduceSize / 2u; reduceSize > 1u;
            currentSize = reduceSize / 2u) {
          let interval = DIV_CEIL(reduceSize, 2u);
          if (localId.x < currentSize) {
            let candidate = xBestValues[localId.x + interval];
            if (candidate ${this.op} bestValue) {
              bestValue = candidate;
              xBestValues[localId.x] = bestValue;
              xBestIndices[localId.x] = xBestIndices[localId.x + interval];
            }
          }
          reduceSize = interval;
          workgroupBarrier();
        }

        if (localId.x == 0u && outputIndex < uniforms.size) {
          setOutputAtIndexI32(outputIndex, xBestIndices[localId.x]);
        }
      }
    `;
            return userCode;
        } else {
            const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let outputCoords = getCoordsFromIndex(index);
          var bestIndex = 0;
          var bestValue = getX(${splitOutputCoords()} 0);
          let reduceLength = ${getInputShapeLastDim()};
          for (var i = 1; i < reduceLength; i++) {
            let candidate = getX(${splitOutputCoords()} i);
            if (candidate ${this.op} bestValue) {
              bestValue = candidate;
              bestIndex = i;
            }
          }
          setOutputAtIndexI32(index, bestIndex);
        }
      }
      `;
            return userCode;
        }
    }
}



function $bdd8269f2dca2b42$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('argMax', [
        axes[0]
    ], $x.shape.length);
    const program = new (0, $7bf5fd582fe4f7fb$export$7fa5759722b57eba)($x.shape, axes[0], 'max');
    const uniformData = [
        {
            type: 'float32',
            data: [
                Number.NEGATIVE_INFINITY
            ]
        }
    ];
    const out = backend.runWebGPUProgram(program, [
        $x
    ], 'int32', uniformData);
    intermediateTensorInfos.forEach((t)=>backend.disposeData(t.dataId));
    return out;
}
const $bdd8269f2dca2b42$export$ec7419fc9ad0069e = {
    kernelName: (0, $507890e4aa8e1463$export$17612294a1503e1c),
    backendName: 'webgpu',
    kernelFunc: $bdd8269f2dca2b42$export$7980a683c1b852b4
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $521748339c7c65b9$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('argMin', [
        axes[0]
    ], $x.shape.length);
    const program = new (0, $7bf5fd582fe4f7fb$export$7fa5759722b57eba)($x.shape, axes[0], 'min');
    const uniformData = [
        {
            type: 'float32',
            data: [
                Number.POSITIVE_INFINITY
            ]
        }
    ];
    const out = backend.runWebGPUProgram(program, [
        $x
    ], 'int32', uniformData);
    intermediateTensorInfos.forEach((t)=>backend.disposeData(t.dataId));
    return out;
}
const $521748339c7c65b9$export$21836a5e5fa09eb4 = {
    kernelName: (0, $507890e4aa8e1463$export$baabd09270cbbd94),
    backendName: 'webgpu',
    kernelFunc: $521748339c7c65b9$export$ec99a91cddfb29a2
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $df1d96c3cbe980ac$export$41726bdb1fc63f = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ASIN
});
const $df1d96c3cbe980ac$export$de5cb0ef95dd6700 = {
    kernelName: (0, $507890e4aa8e1463$export$664c8ca7e7e5c126),
    backendName: 'webgpu',
    kernelFunc: $df1d96c3cbe980ac$export$41726bdb1fc63f
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $50112035ba89aae0$export$839d8a01b6af4fc0 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ASINH
});
const $50112035ba89aae0$export$20d424616c76166 = {
    kernelName: (0, $507890e4aa8e1463$export$847c88940cb7dcb5),
    backendName: 'webgpu',
    kernelFunc: $50112035ba89aae0$export$839d8a01b6af4fc0
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $fbbf7ffb0ec2c44b$export$628dc4eed22b0fbd = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ATAN
});
const $fbbf7ffb0ec2c44b$export$159d632e3ff13624 = {
    kernelName: (0, $507890e4aa8e1463$export$bac667d46ac043ae),
    backendName: 'webgpu',
    kernelFunc: $fbbf7ffb0ec2c44b$export$628dc4eed22b0fbd
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $7f8a5bdf018b4aae$export$b8b770ee6a0d9760 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).ATAN2
});
const $7f8a5bdf018b4aae$export$c53c7ab019edb8a0 = {
    kernelName: (0, $507890e4aa8e1463$export$3bf4c619ce589f4b),
    backendName: 'webgpu',
    kernelFunc: $7f8a5bdf018b4aae$export$b8b770ee6a0d9760
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $60134a26ea8d2664$export$21ea955025ceb08b = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ATANH
});
const $60134a26ea8d2664$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $507890e4aa8e1463$export$98981a86fa2b1366),
    backendName: 'webgpu',
    kernelFunc: $60134a26ea8d2664$export$21ea955025ceb08b
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $0064e6f4543de7d6$export$d92105defeb38496 {
    constructor(convInfo){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `strides : vec2<i32>,`;
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'poolWithFilterSizeEqualsOne';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let batch = coords[0];
          let d = coords[3];

          let xRCCorner = coords.yz * uniforms.strides;
          let xRCorner = xRCCorner.x;
          let xCCorner = xRCCorner.y;

          let value = getX(batch, xRCorner, xCCorner, d);
          setOutputAtIndex(index, value);
        }
      }
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $31696987a1481d22$export$ddaa65439647a5ac {
    constructor(convInfo, poolType, computePositions = false, flattenPositions = false, includeBatchIndex = false){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, dilations : vec2<i32>, convDims : vec2<i32>, filterDims : vec2<i32>,`;
        // TODO(jiajia.qin@intel.com): Dynamically choose different workgroupSize for
        // different output shapes.
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.poolType = poolType;
        this.computePositions = computePositions;
        this.flattenPositions = flattenPositions;
        this.includeBatchIndex = includeBatchIndex;
        this.shaderKey = `pool2D_${poolType}_${computePositions}_${flattenPositions}_${includeBatchIndex}`;
    }
    getUserCode() {
        let updateSnippet;
        if (this.poolType === 'avg') updateSnippet = `resultValue = resultValue + value; count = count + 1.0;`;
        else if (this.computePositions) {
            const positionStr = this.flattenPositions ? this.includeBatchIndex ? `((batch * uniforms.xShape[1] + xR) * uniforms.xShape[2] + xC) * uniforms.xShape[3] + d` : `(xR * uniforms.xShape[2] + xC) * uniforms.xShape[3] + d` : `wR * uniforms.filterDims.y + wC`;
            updateSnippet = `let currMaxValue = mix(value, maxValue, maxValueFound);
      if (value >= currMaxValue) {
        maxValue = value;
        maxValueFound = 1.0;
        maxPosition = ${positionStr};
      }`;
        } else updateSnippet = `resultValue = max(value, resultValue);`;
        let returnValue = `resultValue`;
        if (this.poolType === 'avg') returnValue = `resultValue / max(count, 1.0)`;
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
          let batch = coords[0];
          let d = coords[3];
          let xRCCorner = vec2<i32>(coords.yz) * uniforms.strides - uniforms.pads;
          let xRCorner = xRCCorner.x;
          let xCCorner = xRCCorner.y;

          ${this.computePositions ? `var maxValue = 0.0;
            var maxValueFound = 0.0;
            var maxPosition = 0;` : `var resultValue = ${this.poolType === 'avg' ? '0.0' : '-1.0 / pow(10.0, -20.0)'};`}

          var count = 0.0;
          for (var wR = 0; wR < uniforms.filterDims.x; wR = wR + uniforms.dilations.x) {
            let xR = xRCorner + wR;

            if (xR < 0 || xR >= uniforms.convDims.x) {
              continue;
            }

            for (var wC = 0; wC < uniforms.filterDims.y; wC = wC + uniforms.dilations.y) {
              let xC = xCCorner + wC;
              if (xC < 0 || xC >= uniforms.convDims.y) {
                continue;
              }

              let value = getX(batch, xR, xC, d);
              ${updateSnippet}
            }
          }

          ${this.computePositions ? `setOutputAtIndexI32(index, maxPosition);` : `setOutputAtIndex(index, ${returnValue});`}
        }
      }
    `;
        return userCode;
    }
}
class $31696987a1481d22$export$a835a97097fdbb0f {
    constructor(convInfo, poolType, computePositions = false, flattenPositions = false, includeBatchIndex = false){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `strides : vec3<i32>, pads : vec3<i32>, convDims : vec3<i32>, filterDims : vec3<i32>,`;
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.poolType = poolType;
        this.computePositions = computePositions;
        this.flattenPositions = flattenPositions;
        this.includeBatchIndex = includeBatchIndex;
        this.shaderKey = `pool3D_${poolType}_${computePositions}_${flattenPositions}_${includeBatchIndex}`;
    }
    getUserCode() {
        let updateSnippet;
        if (this.poolType === 'avg') updateSnippet = `resultValue += value; count += 1.0;`;
        else if (this.computePositions) {
            const positionStr = this.flattenPositions ? this.includeBatchIndex ? `(((batch * uniforms.xShape.y + xD) * uniforms.xShape.z + xR) * uniforms.xShape.w + xC) * uniforms.xShape.u + ch` : `((xD * uniforms.xShape.z + xR) * uniforms.xShape.w + xC) * uniforms.xShape.u + ch` : `wD * uniforms.filterDims.y * uniforms.filterDims.y + wR * uniforms.filterDims.z + wC`;
            updateSnippet = `let currMaxValue = mix(value, maxValue, maxValueFound);
      if (value >= currMaxValue) {
        maxValue = value;
        maxValueFound = 1.0;
        maxPosition = ${positionStr};
      }`;
        } else updateSnippet = `resultValue = max(value, resultValue);`;
        let returnValue = `resultValue`;
        if (this.poolType === 'avg') returnValue = `resultValue / max(count, 1.0)`;
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let batch = coords.x;
          let ch = coords.u;

          let xCorner = vec3<i32>(coords.y, coords.z, coords.w) * uniforms.strides - uniforms.pads;
          let xDCorner = xCorner.x;
          let xRCorner = xCorner.y;
          let xCCorner = xCorner.z;

          ${this.computePositions ? `var maxValue = 0.0;
            var maxValueFound = 0.0;
            var maxPosition = 0;` : `var resultValue = ${this.poolType === 'avg' ? '0.0' : '-1.0 / pow(10.0, -20.0)'};`}

          var count = 0.0;
          for (var wD = 0; wD < uniforms.filterDims.x; wD++) {
            let xD = xDCorner + wD;
            if (xD < 0 || xD >= uniforms.convDims.x) {
              continue;
            }

            for (var wR = 0; wR < uniforms.filterDims.y; wR++) {
              let xR = xRCorner + wR;
              if (xR < 0 || xR >= uniforms.convDims.y) {
                continue;
              }

              for (var wC = 0; wC < uniforms.filterDims.z; wC++) {
                let xC = xCCorner + wC;
                if (xC < 0 || xC >= uniforms.convDims.z) {
                  continue;
                }

                let value = getX(batch, xD, xR, xC, ch);
                ${updateSnippet}
              }
            }
          }

          ${this.computePositions ? `setOutputAtIndexI32(index, maxPosition);` : `setOutputAtIndex(index, ${returnValue});`}
        }
      }
    `;
        return userCode;
    }
}



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $24c613ac367ff181$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, reductionIndices, keepDims, 'max', backend);
}
const $24c613ac367ff181$export$7d79147246e312bb = {
    kernelName: (0, $507890e4aa8e1463$export$d36c09e5d02927e7),
    backendName: 'webgpu',
    kernelFunc: $24c613ac367ff181$export$8960430cfd85939f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $ccebf01d47069530$export$1ce691f85baaa52(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { keepDims: keepDims, axis: axis } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, axis, keepDims, 'mean', backend);
}
const $ccebf01d47069530$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $507890e4aa8e1463$export$1c2d59c4b681fbd8),
    backendName: 'webgpu',
    kernelFunc: $ccebf01d47069530$export$1ce691f85baaa52
};



function $0e6ffef9a5f3f01d$export$297e48da7c82a356(x, convInfo, poolType, backend) {
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $0775da5e684c8c0d$exports).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    if (convInfo.filterWidth === convInfo.inWidth && convInfo.filterHeight === convInfo.inHeight && convInfo.batchSize === 1 && convInfo.padInfo.type === 'VALID') {
        const length = x.shape.length;
        const reshapeX = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: [
                    x.shape[length - 3] * x.shape[length - 2],
                    x.shape[length - 1]
                ]
            }
        });
        let reduceX;
        if (poolType === 'avg') reduceX = (0, $ccebf01d47069530$export$1ce691f85baaa52)({
            inputs: {
                x: reshapeX
            },
            backend: backend,
            attrs: {
                axis: 0,
                keepDims: false
            }
        });
        else {
            (0, $0775da5e684c8c0d$exports).assert(poolType === 'max', ()=>`Invalid pool type ${poolType}`);
            reduceX = (0, $24c613ac367ff181$export$8960430cfd85939f)({
                inputs: {
                    x: reshapeX
                },
                backend: backend,
                attrs: {
                    reductionIndices: 0,
                    keepDims: false
                }
            });
        }
        const result = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduceX
            },
            backend: backend,
            attrs: {
                shape: convInfo.outShape
            }
        });
        backend.disposeData(reshapeX.dataId);
        backend.disposeData(reduceX.dataId);
        return result;
    }
    let program;
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        }
    ];
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1) program = new (0, $0064e6f4543de7d6$export$d92105defeb38496)(convInfo);
    else {
        if (poolType === 'avg') program = new (0, $31696987a1481d22$export$ddaa65439647a5ac)(convInfo, 'avg');
        else {
            (0, $0775da5e684c8c0d$exports).assert(poolType === 'max', ()=>`Invalid pool type ${poolType}`);
            program = new (0, $31696987a1481d22$export$ddaa65439647a5ac)(convInfo, 'max');
        }
        dimensions.push({
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        });
    }
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, dimensions);
}


function $10a97fd5e68dfa23$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    return (0, $0e6ffef9a5f3f01d$export$297e48da7c82a356)(x, convInfo, 'avg', backend);
}
const $10a97fd5e68dfa23$export$6c901824a23e6150 = {
    kernelName: (0, $507890e4aa8e1463$export$37f2cc7be1add88c),
    backendName: 'webgpu',
    kernelFunc: $10a97fd5e68dfa23$export$d5c65a2abd3d97dc
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $f95e836468fed162$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const avgPoolProgram = new (0, $31696987a1481d22$export$a835a97097fdbb0f)(convInfo, 'avg');
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth,
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(avgPoolProgram, [
        x
    ], x.dtype, dimensions);
}
const $f95e836468fed162$export$5a9c81d240244392 = {
    kernelName: (0, $507890e4aa8e1463$export$390ecb697af103f6),
    backendName: 'webgpu',
    kernelFunc: $f95e836468fed162$export$8e92f7d23b27f144
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d7ac6f8525d71063$export$5dc4ec478e6759de {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, dilations : vec2<i32>, filterDims : vec2<i32>,
       outHeight : i32, outWidth : i32, avgMultiplier : f32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `avgPool2DBackprop`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d = coords[3];

        let dyRCCorner = vec2<i32>(coords.yz) - uniforms.pads;
        let dyRCorner = dyRCCorner.x;
        let dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var wR = 0; wR < uniforms.filterDims[0]; wR = wR + uniforms.dilations[0]) {
          let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[0]);

          if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
            continue;
          }
          let idyR = i32(dyR);

          for (var wC = 0; wC < uniforms.filterDims[1]; wC = wC + uniforms.dilations[1]) {
            let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[1]);

            if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
              continue;
            }
            let idyC = i32(dyC);

            let dyValue = getDy(batch, idyR, idyC, d);

            dotProd = dotProd + dyValue * uniforms.avgMultiplier;
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}
class $d7ac6f8525d71063$export$f166702869bc274f {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `strides : vec3<i32>, pads : vec3<i32>, filterDims : vec3<i32>,
       outDepth : i32, outHeight : i32, outWidth : i32, avgMultiplier : f32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `avgPool3DBackprop`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords.x;
        let ch = coords.u;

        let dyCorner = vec3<i32>(coords.y, coords.z, coords.w) - uniforms.pads;
        let dyDCorner = dyCorner.x;
        let dyRCorner = dyCorner.y;
        let dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var wD = 0; wD < uniforms.filterDims[0]; wD++) {
          let dyD = f32(dyDCorner + wD) / f32(uniforms.strides[0]);

          if (dyD < 0.0 || dyD >= f32(uniforms.outDepth) || fract(dyD) > 0.0) {
            continue;
          }
          let idyD = i32(dyD);

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[1]);

            if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
              continue;
            }
            let idyR = i32(dyR);

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[2]);

              if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
                continue;
              }
              let idyC = i32(dyC);

              let dyValue = getDy(batch, idyD, idyR, idyC, ch);
              dotProd += dyValue * uniforms.avgMultiplier;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}


function $d587ab757c24c077$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const program = new (0, $d7ac6f8525d71063$export$f166702869bc274f)(convInfo);
    const avgMultiplier = 1 / (convInfo.filterDepth * convInfo.filterHeight * convInfo.filterWidth);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth - 1 - convInfo.padInfo.front,
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'float32',
            data: [
                avgMultiplier
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], x.dtype, uniformData);
}
const $d587ab757c24c077$export$1eeb8780807d0508 = {
    kernelName: (0, $507890e4aa8e1463$export$7163112adf28c062),
    backendName: 'webgpu',
    kernelFunc: $d587ab757c24c077$export$798cb4034e996ff4
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $76bb39c837f34b12$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $8e83a93f95f027c6$export$1412c17b2531581a)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const program = new (0, $d7ac6f8525d71063$export$5dc4ec478e6759de)(convInfo);
    const avgMultiplier = 1 / (convInfo.filterHeight * convInfo.filterWidth);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'float32',
            data: [
                avgMultiplier
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], x.dtype, uniformData);
}
const $76bb39c837f34b12$export$ac3f8709351ab225 = {
    kernelName: (0, $507890e4aa8e1463$export$9873fd6046cd6951),
    backendName: 'webgpu',
    kernelFunc: $76bb39c837f34b12$export$2f098171d1c79aea
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $36180c4f94c7c4c7$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    return (0, $75edebe28daa2228$export$d524d65e88e1168b)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend
    });
}
const $36180c4f94c7c4c7$export$d0dd993198185538 = {
    kernelName: (0, $507890e4aa8e1463$export$9a3bf60b23f63c8),
    backendName: 'webgpu',
    kernelFunc: $36180c4f94c7c4c7$export$8f97894b482227f0
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $72c629ca2921537c$export$ef8bf52bc4951c85 {
    constructor(start, destSize){
        this.variableNames = [
            'source'
        ];
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = destSize;
        this.rank = destSize.length;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.start = start;
        this.uniforms = `start : ${(0, $0533631f1fe2cae9$export$859efd105c10c755)(start.length)}, `;
        this.shaderKey = 'slice';
    }
    getUserCode() {
        const dtype = (0, $0533631f1fe2cae9$export$859efd105c10c755)(this.rank);
        const sourceCoords = $72c629ca2921537c$var$getCoords(this.rank);
        let coordSum;
        if (this.start.length === 1) coordSum = this.outputShape.map((_, i)=>{
            return `sourceLoc = uniforms.start + coords;`;
        });
        else coordSum = this.outputShape.map((_, i)=>{
            return `sourceLoc.${$72c629ca2921537c$var$coords[i]} = uniforms.start.${(0, $0533631f1fe2cae9$export$9e429db2fd13bb35)(i)} + coords.${$72c629ca2921537c$var$coords[i]};`;
        });
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          var sourceLoc : ${dtype};
          let coords = getCoordsFromIndex(index);
          ${coordSum.join('\n')}
          setOutputAtIndex(index, getSource(${sourceCoords}));
        }
      }
    `;
        return userCode;
    }
}
const $72c629ca2921537c$var$coords = [
    'x',
    'y',
    'z',
    'w',
    'u',
    'v'
];
function $72c629ca2921537c$var$getCoords(rank) {
    if (rank === 1) return 'sourceLoc';
    else if (rank <= 6) return $72c629ca2921537c$var$coords.slice(0, rank).map((coord)=>`sourceLoc.${coord}`).join(',');
    else throw Error(`Slicing for rank ${rank} is not yet supported`);
}


function $fc251d31bd35efe1$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    const [$begin, $size] = (0, $f147fd057118a602$exports).parseSliceParams(x, begin, size);
    (0, $f147fd057118a602$exports).assertParamsValid(x, $begin, $size);
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string') {
        const xTensorData = backend.tensorMap.get(x.dataId);
        const outValues = (0, $218cb6c8b1f27bad$export$45812d0d8578899)(xTensorData.values, $begin, $size, x.shape, x.dtype);
        return backend.makeTensorInfo($size, x.dtype, outValues);
    }
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape($size) === 0) return backend.makeTensorInfo($size, x.dtype, []);
    // TODO(xing.xu): Add shadow slice support.
    const program = new (0, $72c629ca2921537c$export$ef8bf52bc4951c85)($begin, $size);
    const uniformData = [
        {
            type: 'int32',
            data: $begin
        }
    ];
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $fc251d31bd35efe1$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $507890e4aa8e1463$export$b3f2e2de3a8baa1e),
    backendName: 'webgpu',
    kernelFunc: $fc251d31bd35efe1$export$58adb3bec8346d0f
};



const $0a7cd4990de6001d$export$ea37d960c1808536 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $0775da5e684c8c0d$exports).assert(x.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGPU backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $f35e0c1a651337db$exports).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $f35e0c1a651337db$exports).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $f35e0c1a651337db$exports).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $f35e0c1a651337db$exports).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $f35e0c1a651337db$exports).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const toDispose = [];
    const reshapedIntermediate = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const transposedIntermediate = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
        inputs: {
            x: reshapedIntermediate
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const reshapedIntermediate2 = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: transposedIntermediate
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const sliced = (0, $fc251d31bd35efe1$export$58adb3bec8346d0f)({
        inputs: {
            x: reshapedIntermediate2
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    toDispose.push(reshapedIntermediate);
    toDispose.push(transposedIntermediate);
    toDispose.push(reshapedIntermediate2);
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return sliced;
};
const $0a7cd4990de6001d$export$44e08e19f97e5513 = {
    kernelName: (0, $507890e4aa8e1463$export$e2743f47f61cca1f),
    backendName: 'webgpu',
    kernelFunc: $0a7cd4990de6001d$export$ea37d960c1808536
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $4865bee36b5e2471$var$writeSnippet = `
  fn bincount_write(index: i32, value: f32) {
    ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[index]', 'value', 'float32')}
  }
`;
const $4865bee36b5e2471$var$binaryWriteSnippet = `
  fn bincount_write(index: i32, value: f32) {
    atomicStore(&result[index], bitcast<i32>(value));
  }
`;
class $4865bee36b5e2471$export$7535c7c7286368eb {
    constructor(shape, hasWeights, binaryOutput = false){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'binCountSize : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.hasWeights = true;
        this.binaryOutput = false;
        this.outputShape = shape;
        this.rank = shape.length;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.binaryOutput = binaryOutput;
        if (binaryOutput) this.atomic = false;
        this.hasWeights = hasWeights;
        if (this.hasWeights) this.variableNames.push('w');
        this.shaderKey = `bincount_${this.hasWeights}_${this.binaryOutput}_${this.rank}`;
    }
    getUserCode() {
        const userCode = `
    ${this.binaryOutput ? $4865bee36b5e2471$var$binaryWriteSnippet : $4865bee36b5e2471$var$writeSnippet}
  ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
    ${this.rank === 1 ? `if (index < uniforms.xShape) {
      let indexVal = i32(getX(index));
      if (indexVal < uniforms.binCountSize) {
        let value = ${this.binaryOutput ? 1. : this.hasWeights ? 'getW(index)' : '1.'};
        bincount_write(indexVal, value);
      }
    }` : `let coord = getCoordsFromIndex(index);
    if (coordsInBounds2D(coord, uniforms.xShape)) {
      let indexVal = i32(getX(coord[0], coord[1]));
      if (indexVal < uniforms.binCountSize) {
        let value = ${this.binaryOutput ? 1. : this.hasWeights ? 'getW(coord[0], coord[1])' : '1.'};
        bincount_write(coord.x * uniforms.binCountSize + indexVal, value);
      }
    }`}
  }
  `;
        return userCode;
    }
}



function $886c1b7d5adb0636$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const weightsSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(weights.shape);
    const hasWeights = weightsSize > 0;
    const outputSize = [
        size
    ];
    const dtype = weights.dtype;
    const output = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: outputSize,
            value: 0,
            dtype: dtype
        }
    });
    const program = new (0, $4865bee36b5e2471$export$7535c7c7286368eb)([
        xSize
    ], hasWeights);
    const uniformData = [
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const bincountInputs = hasWeights ? [
        x,
        weights
    ] : [
        x
    ];
    const res = backend.runWebGPUProgram(program, bincountInputs, dtype, uniformData, output);
    return res;
}
const $886c1b7d5adb0636$export$af9f0093738840fb = {
    kernelName: (0, $507890e4aa8e1463$export$45dfbbff595c32aa),
    backendName: 'webgpu',
    kernelFunc: $886c1b7d5adb0636$export$7e474bab088ed182
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $2bac7efeb891da43$export$de6bebf36995b14 {
    constructor(shape){
        this.outputShape = [];
        this.variableNames = [
            's0',
            's1'
        ];
        this.uniforms = 's0Size : i32, s1Size : i32, ';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            shape
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'broadcastArgs';
    }
    getUserCode() {
        const userCode = `
  ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
    if (index < uniforms.size) {
      var s0 = 1.0;
      var s1 = 1.0;
      let indexS0 = index - uniforms.size + uniforms.s0Size;
      let indexS1 = index - uniforms.size + uniforms.s1Size;
      if (indexS0 >= 0) {
        s0 = getS0(indexS0);
      }
      if (indexS1 >= 0) {
        s1 = getS1(indexS1);
      }

      if (s0 == 1.0) {
        setOutputAtIndex(index, s1);
      } else if (s1 == 1.0) {
        setOutputAtIndex(index, s0);
      } else if (s0 != s1) {
        setOutputAtIndex(index, uniforms.NAN);
      } else {
        setOutputAtIndex(index, s0);
      }
    }
  }
  `;
        return userCode;
    }
}


function $b3e7133a9986174a$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    if (backend.shouldExecuteOnCPU([
        s0,
        s1
    ])) {
        const s0TensorInfo = backend.tensorMap.get(s0.dataId);
        const s1TensorInfo = backend.tensorMap.get(s1.dataId);
        const s0Vals = s0TensorInfo.values;
        const s1Vals = s1TensorInfo.values;
        const broadcastShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
        return backend.makeTensorInfo([
            broadcastShape.length
        ], 'int32', Int32Array.from(broadcastShape));
    }
    const s0Size = (0, $0775da5e684c8c0d$exports).sizeFromShape(s0.shape);
    const s1Size = (0, $0775da5e684c8c0d$exports).sizeFromShape(s1.shape);
    const outputSize = Math.max(s0Size, s1Size);
    const program = new (0, $2bac7efeb891da43$export$de6bebf36995b14)(outputSize);
    const uniformData = [
        {
            type: 'int32',
            data: [
                s0Size
            ]
        },
        {
            type: 'int32',
            data: [
                s1Size
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        s0,
        s1
    ], 'int32', uniformData);
}
const $b3e7133a9986174a$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $507890e4aa8e1463$export$32877b1d6d497805),
    backendName: 'webgpu',
    kernelFunc: $b3e7133a9986174a$export$d226d344aedce941
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $e54f7fc9b0aeee77$export$53a6892c50694894 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).NOT_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$b91372753635df24)
});
const $e54f7fc9b0aeee77$export$d003d4d7e1500775 = {
    kernelName: (0, $507890e4aa8e1463$export$385ebe9945cae0c5),
    backendName: 'webgpu',
    kernelFunc: $e54f7fc9b0aeee77$export$53a6892c50694894
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $ee772b4e6a775b63$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.tensorMap.get(input.dataId);
    return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: inputData.complexTensorInfos.real
        },
        backend: backend
    });
}
const $ee772b4e6a775b63$export$4b7bce57557ae68b = {
    kernelName: (0, $507890e4aa8e1463$export$f41305719b94e675),
    backendName: 'webgpu',
    kernelFunc: $ee772b4e6a775b63$export$9fc57fb453bdbd67
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $753abafd2a16ccd3$export$7d260a2a5f8bc19e(input, backend) {
    const program = new (0, $8e98bd3037a606b3$export$f93811a5a466fd42)(input.shape, (0, $4af106881f0be485$export$5adefdb0f928033b).TO_INT);
    const output = backend.runWebGPUProgram(program, [
        input
    ], 'int32');
    return {
        dataId: output.dataId,
        shape: output.shape,
        dtype: output.dtype
    };
}


function $e5c1d83690f88666$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $c76b17881110536c$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        // TODO: Import kernel function once zeros is modularized.
        const zerosTensor = $a0e8420b37ff8039$export$4445a00dafa2633b(x.shape);
        const floatX = $e5c1d83690f88666$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $94b917209ffdee98$export$83a0e34f1302825b)({
            inputs: {
                real: floatX,
                imag: zerosTensor
            },
            backend: backend
        });
        zerosTensor.dispose();
        backend.disposeData(floatX.dataId);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $ee772b4e6a775b63$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $e5c1d83690f88666$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeData(realPart.dataId);
        return result;
    }
    if (!(0, $0775da5e684c8c0d$exports).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $c76b17881110536c$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const values = backend.tensorMap.get(x.dataId).values;
        const [resultShape, resultType, resultData] = (0, $218cb6c8b1f27bad$export$babf602309dd6292)(values, x.shape, x.dtype, dtype);
        return backend.makeTensorInfo(resultShape, resultType, resultData);
    }
    if (dtype === 'int32') return (0, $753abafd2a16ccd3$export$7d260a2a5f8bc19e)(x, backend);
    if (dtype === 'bool') {
        const zerosTensorInfo = backend.makeTensorInfo([], 'bool', (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType('bool', 1));
        const binaryInputs = {
            a: x,
            b: zerosTensorInfo
        };
        const result = (0, $e54f7fc9b0aeee77$export$53a6892c50694894)({
            inputs: binaryInputs,
            backend: backend
        });
        backend.disposeData(zerosTensorInfo.dataId);
        return result;
    }
    throw new Error(`Error in Cast: failed to cast ${x.dtype} to ${dtype}`);
}
const $e5c1d83690f88666$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $507890e4aa8e1463$export$107ecfb3d1ccbd77),
    backendName: 'webgpu',
    kernelFunc: $e5c1d83690f88666$export$f2db7d5238e1d23f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $f875dd35eb850147$export$803ce6b71a0a94b2 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).CEIL,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$bb3ce81256fe261b)
});
const $f875dd35eb850147$export$df387212b1898306 = {
    kernelName: (0, $507890e4aa8e1463$export$d4a1bccfd52ebd3),
    backendName: 'webgpu',
    kernelFunc: $f875dd35eb850147$export$803ce6b71a0a94b2
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $3e0a65b93233edbf$export$431f4d28c8da57b6 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.uniforms = 'minVal : f32, maxVal : f32,';
        this.workPerThread = 4;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.outputComponent = 4;
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.shaderKey = 'clipVec4';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if(index < uniforms.size) {
          let value = getAByOutputIndex(index);
          var clampedValue = clamp(
              value, vec4<f32>(uniforms.minVal), vec4<f32>(uniforms.maxVal));
          clampedValue = select(clampedValue, value, isnanVec4(value));
          setOutputAtIndex(index, clampedValue);
        }
      }
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $96acbfaabf179490$export$ce48b7c79e7985d1 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.uniforms = 'minVal : f32, maxVal : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'clip';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if(index < uniforms.size) {
          let value = getAByOutputIndex(index);
          if (isnan(value)) {
            setOutputAtIndex(index, value);
            return;
          }
          setOutputAtIndex(index, clamp(value, uniforms.minVal, uniforms.maxVal));
        }
      }
    `;
        return userCode;
    }
}


function $8c83d8a076c30d5c$export$fa97baf70ad024c0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
    let program;
    const uniformData = [
        {
            type: 'float32',
            data: [
                clipValueMin
            ]
        },
        {
            type: 'float32',
            data: [
                clipValueMax
            ]
        }
    ];
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape) % 4 === 0) program = new (0, $3e0a65b93233edbf$export$431f4d28c8da57b6)(x.shape);
    else program = new (0, $96acbfaabf179490$export$ce48b7c79e7985d1)(x.shape);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $8c83d8a076c30d5c$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $507890e4aa8e1463$export$611c0e357ac37f7d),
    backendName: 'webgpu',
    kernelFunc: $8c83d8a076c30d5c$export$fa97baf70ad024c0
};



/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $59508c55d1352706$export$d03dbc86862098f5 {
    constructor(shape){
        this.outputShape = [];
        this.variableNames = [
            'real',
            'imag'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'complexAbs';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let re = abs(getRealByOutputIndex(index));
        let im = abs(getImagByOutputIndex(index));
        let mx = max(re, im);

        // The length function in wgsl may be not underflow-safe on some GPUs.
        // So the safe solution is to ensure underflow-safety in all cases.
        setOutputAtIndex(index, select(mx * length(vec2<f32>(1, min(re, im)/mx)), 0.0, mx == 0.0));
      }
    }
  `;
        return userCode;
    }
}


// Returns a TensorInfo with the complex shape and the dataId of the
// underlying part. We need to do this because a reshaped complex tensor is
// not reflected in its parts.
function $0181ca78e47316de$var$makeComplexComponentTensorInfo(complexTensor, complexPart) {
    return {
        dataId: complexPart.dataId,
        dtype: complexPart.dtype,
        shape: complexTensor.shape
    };
}
function $0181ca78e47316de$export$2837bc62566f8808(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xData = backend.tensorMap.get(x.dataId);
    const program = new (0, $59508c55d1352706$export$d03dbc86862098f5)(x.shape);
    const programInputs = [
        $0181ca78e47316de$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.real),
        $0181ca78e47316de$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.imag)
    ];
    return backend.runWebGPUProgram(program, programInputs, programInputs[0].dtype);
}
const $0181ca78e47316de$export$a4817d2978acc054 = {
    kernelName: (0, $507890e4aa8e1463$export$32902e58f1b48f4b),
    backendName: 'webgpu',
    kernelFunc: $0181ca78e47316de$export$2837bc62566f8808
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $531d4525e2486ad8$export$9059cb52ee2cb142 {
    constructor(shapes){
        this.uniforms = '';
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = (0, $f35e0c1a651337db$exports).computeOutShape(shapes, 1 /* axis */ );
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.offsetLength = shapes.length - 1;
        for(let i = 0; i < this.offsetLength; i++)this.uniforms += `offset${i} : i32,`;
        this.shaderKey = 'concat';
    }
    getUserCode() {
        const snippets = [];
        if (this.offsetLength > 0) {
            snippets.push(`if (yC < uniforms.offset0){ setOutputAtCoords(coords.x, coords.y, getT0(yR, yC)); }`);
            for(let i = 1; i < this.offsetLength; i++)snippets.push(`else if (yC < uniforms.offset${[
                i
            ]}){ ` + `setOutputAtCoords(coords.x, coords.y, getT${i}(yR, yC - uniforms.offset${i - 1})); }`);
            const lastIndex = this.offsetLength;
            const lastShiftIndex = this.offsetLength - 1;
            snippets.push(`else { setOutputAtCoords(coords.x, coords.y, getT${lastIndex}(yR, yC - uniforms.offset${lastShiftIndex})); }`);
        } else snippets.push(`setOutputAtCoords(coords.x, coords.y, getT0(yR, yC));`);
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        for(var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let flatIndex = index * ${this.workPerThread} + i;
          if(flatIndex < uniforms.size) {
            let coords = getCoordsFromIndex(flatIndex);
            let yR = coords.x;
            let yC = coords.y;

            ${snippets.join('\n        ')}
          }
        }
      }
    `;
        return userCode;
    }
}




/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $10ab56078456f8d4$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.tensorMap.get(input.dataId);
    return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: inputData.complexTensorInfos.imag
        },
        backend: backend
    });
}
const $10ab56078456f8d4$export$ddfc128c2801add7 = {
    kernelName: (0, $507890e4aa8e1463$export$303b4473993a24f),
    backendName: 'webgpu',
    kernelFunc: $10ab56078456f8d4$export$d78fab5778ab392b
};




function $6985573a28915941$export$777da59f594f497d(inputs, axis, backend) {
    const dtype = inputs[0].dtype;
    if (dtype === 'complex64') {
        const reals = inputs.map((t)=>(0, $ee772b4e6a775b63$export$9fc57fb453bdbd67)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = inputs.map((t)=>(0, $10ab56078456f8d4$export$d78fab5778ab392b)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $6985573a28915941$export$777da59f594f497d(reals, axis, backend);
        const imagConcated = $6985573a28915941$export$777da59f594f497d(imags, axis, backend);
        const result = (0, $94b917209ffdee98$export$83a0e34f1302825b)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeData(r.dataId));
        imags.forEach((i)=>backend.disposeData(i.dataId));
        backend.disposeData(realConcated.dataId);
        backend.disposeData(imagConcated.dataId);
        return result;
    }
    let runOnCpu = backend.shouldExecuteOnCPU(inputs);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgpu doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (dtype === 'string') runOnCpu = true;
    if (runOnCpu) {
        // Any concat of n-dimensional tensors across any axis can be reduced to
        // a concatenation of two-dimensional tensors across the axis 1 by first
        // partitioning the axes of the original tensors into those less than the
        // axis to be concatenated and the rest. Then reshape the tensors
        // into a two-dimensional tensor by collapsing these two sets of axes and
        // concatenate the resulting matrices across the axis 1, finally reshaping
        // the result to have the proper shape.
        const tensors2D = inputs.map((t)=>{
            const innerSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape.slice(axis));
            const shape = [
                -1,
                innerSize
            ];
            return (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: t
                },
                backend: backend,
                attrs: {
                    shape: shape
                }
            });
        });
        const inputsValShapes = tensors2D.map((t)=>{
            return {
                vals: backend.readSync(t.dataId),
                shape: t.shape
            };
        });
        // Concats 2d tensors along axis=1.
        const outShape = (0, $f35e0c1a651337db$exports).computeOutShape(tensors2D.map((t)=>t.shape), 1 /* axis */ );
        const simplyConcat = tensors2D[0].shape[0] === 1;
        const outVals = (0, $218cb6c8b1f27bad$export$95e7342d25849d64)(inputsValShapes, outShape, dtype, simplyConcat);
        const finalOutShape = (0, $f35e0c1a651337db$exports).computeOutShape(inputs.map((t)=>t.shape), axis);
        const outInfo = backend.makeTensorInfo(finalOutShape, dtype, outVals);
        tensors2D.forEach((t)=>backend.disposeData(t.dataId));
        return outInfo;
    }
    // There is a storage buffer limitation in compute stage, one for output so
    // the maximum for input is limits.maxStorageBuffersPerShaderStage - 1
    const maxInputNum = backend.device.limits.maxStorageBuffersPerShaderStage - 1;
    if (inputs.length > maxInputNum) {
        const reducedInputs = [];
        for(let i = 0; i < inputs.length; i += maxInputNum){
            const subArray = inputs.slice(i, i + maxInputNum);
            reducedInputs.push($6985573a28915941$export$777da59f594f497d(subArray, axis, backend));
        }
        const result = $6985573a28915941$export$777da59f594f497d(reducedInputs, axis, backend);
        for (const i of reducedInputs)backend.disposeData(i.dataId);
        return result;
    }
    const { tensors2D: tensors2D, outShape: outShape } = $6985573a28915941$var$computeTensors2D(inputs, axis, backend);
    const shapes = tensors2D.map((t)=>t.shape);
    const program = new (0, $531d4525e2486ad8$export$9059cb52ee2cb142)(shapes);
    const uniformData = [];
    const offsets = new Array(shapes.length - 1);
    if (offsets.length > 0) {
        offsets[0] = shapes[0][1];
        uniformData.push({
            type: 'int32',
            data: [
                offsets[0]
            ]
        });
        for(let i = 1; i < offsets.length; i++){
            offsets[i] = offsets[i - 1] + shapes[i][1];
            uniformData.push({
                type: 'int32',
                data: [
                    offsets[i]
                ]
            });
        }
    }
    const res = backend.runWebGPUProgram(program, tensors2D, tensors2D[0].dtype, uniformData);
    tensors2D.forEach((r)=>backend.disposeData(r.dataId));
    const reshapedResult = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeData(res.dataId);
    return reshapedResult;
}
function $6985573a28915941$var$computeTensors2D(inputs, axis, backend) {
    const outShape = (0, $f35e0c1a651337db$exports).computeOutShape(inputs.map((t)=>t.shape), axis);
    const tensors2D = inputs.map((t)=>(0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: t
            },
            backend: backend,
            attrs: {
                shape: [
                    (0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape.slice(0, axis)),
                    (0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape.slice(axis))
                ]
            }
        }));
    return {
        tensors2D: tensors2D,
        outShape: outShape
    };
}



function $2a67ed70be2df080$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $f35e0c1a651337db$exports).assertParamsConsistent(shapes, $axis);
    const outShape = (0, $f35e0c1a651337db$exports).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    return (0, $6985573a28915941$export$777da59f594f497d)($inputs, $axis, backend);
}
const $2a67ed70be2df080$export$c8cf96dae25282e5 = {
    kernelName: (0, $507890e4aa8e1463$export$936bbfc007425eea),
    backendName: 'webgpu',
    kernelFunc: $2a67ed70be2df080$export$ee1b3e54f0441b22
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $134927e6361dfc27$var$conv2dCommonSnippet(isChannelsLast, fitAOuter, fitBOuter, fitInner, addBias = false, activation = null, hasPreluActivationWeights = false, innerElementSizeX = 4, innerElementSizeW = 4, innerElementSize = 4) {
    const getXSnippet = (innerElementSize)=>{
        switch(innerElementSize){
            case 1:
                return 'resData = f32(x[xIndex]);';
            case 3:
                return 'resData = vec3<f32>(x[xIndex], x[xIndex + 1], x[xIndex + 2]);';
            case 4:
                return 'resData = vec4<f32>(x[xIndex / 4]);';
            default:
                throw new Error(`innerElementSize ${innerElementSize} is not supported.`);
        }
    };
    const getWSnippet = (innerElementSize)=>{
        switch(innerElementSize){
            case 1:
                return 'return f32(W[row * uniforms.wShape[3] + col]);';
            case 4:
                return 'return vec4<f32>(W[(row * uniforms.wShape[3] + col) / 4]);';
            default:
                throw new Error(`innerElementSize ${innerElementSize} is not supported.`);
        }
    };
    const coordASnippet = isChannelsLast ? `
      let coord = vec4<i32>(batch, xRow, xCol, xCh);
      ` : `
      let coord = vec4<i32>(batch, xCh, xRow, xCol);
      `;
    const coordResSnippet = isChannelsLast ? `
      let coords = vec4<i32>(
        batch,
        row / outWidth,
        row % outWidth,
        col);
      ` : `
      let coords = vec4<i32>(
        batch,
        row,
        col / outWidth,
        col % outWidth);
      `;
    const xHight = isChannelsLast ? 'uniforms.xShape[1]' : 'uniforms.xShape[2]';
    const xWidth = isChannelsLast ? 'uniforms.xShape[2]' : 'uniforms.xShape[3]';
    const row = isChannelsLast ? 'row' : 'col';
    const col = isChannelsLast ? 'col' : 'row';
    const readXSnippet = `
      let inChannels = uniforms.wShape[2];
      let outWidth = ${isChannelsLast ? 'uniforms.outShape[2]' : 'uniforms.outShape[3]'};
      let outRow = ${row} / outWidth;
      let outCol = ${row} % outWidth;

      let WRow = ${col} / (uniforms.filterDims[1] * inChannels);
      let WCol = ${col} / inChannels % uniforms.filterDims[1];
      let xRow = outRow * uniforms.strides[0] + uniforms.dilations[0] * WRow - uniforms.pads[0];
      let xCol = outCol * uniforms.strides[1] + uniforms.dilations[1] * WCol - uniforms.pads[1];
      let xCh = ${col} % inChannels;
      var resData = ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeX)}(0.0);
      // The bounds checking is always needed since we use it to pad zero for
      // the 'same' padding type.
      if (xRow >= 0 && xRow < ${xHight} && xCol >= 0 && xCol < ${xWidth}) {
        ${coordASnippet}
        let xIndex = getIndexFromCoords4D(coord, uniforms.xShape);
        ${getXSnippet(innerElementSizeX)}
      }
      return resData;`;
    const sampleX = isChannelsLast ? fitAOuter && fitInner ? `
      ${readXSnippet}` : `
      if (row < uniforms.dimAOuter && col < uniforms.dimInner) {
        ${readXSnippet}
      }
      return ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeX)}(0.0);` : fitInner && fitBOuter ? `
      ${readXSnippet}` : `
      if (row < uniforms.dimInner && col < uniforms.dimBOuter) {
        ${readXSnippet}
      }
      return ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeX)}(0.0);`;
    const sampleW = `${getWSnippet(innerElementSizeW)}`;
    const resType = (0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize);
    const aType = isChannelsLast ? (0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeX) : (0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeW);
    const bType = isChannelsLast ? (0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeW) : (0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSizeX);
    const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(activation, hasPreluActivationWeights, innerElementSize === 4, 4)}
      fn mm_readA(batch: i32, row : i32, col : i32) -> ${aType} {
        ${isChannelsLast ? sampleX : sampleW}
      }

      fn mm_readB(batch: i32, row : i32, col : i32) -> ${bType} {
        ${isChannelsLast ? sampleW : sampleX}
      }

      fn mm_write(batch: i32, row : i32, col : i32, valueIn : ${resType}) {
        if (row < uniforms.dimAOuter && col < uniforms.dimBOuter)
        {
        var value = valueIn;
        let outWidth = ${isChannelsLast ? 'uniforms.outShape[2]' : 'uniforms.outShape[3]'};
        ${coordResSnippet}
        ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(addBias, activation)}
        setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
        }
      }`;
    return userCode;
}
class $134927e6361dfc27$export$7cb7f21cacf510bc {
    constructor(convInfo, dimAOuter, dimBOuter, dimInner, addBias = false, activation = null, hasPreluActivationWeights = false, sequentialAccessByThreads = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = `filterDims : vec2<i32>, pads : vec2<i32>, strides : vec2<i32>, dilations : vec2<i32>, dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.outputShape = convInfo.outShape;
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.isVec4 = ((convInfo.inChannels % 4 === 0 || convInfo.inChannels % 3 === 0) && this.isChannelsLast || convInfo.outWidth % 4 === 0 && !this.isChannelsLast) && convInfo.outChannels % 4 === 0;
        this.dispatchLayout = this.isChannelsLast ? {
            x: [
                3
            ],
            y: [
                1,
                2
            ],
            z: [
                0
            ]
        } : {
            x: [
                2,
                3
            ],
            y: [
                1
            ],
            z: [
                0
            ]
        };
        this.workgroupSize = (0, $8e83a93f95f027c6$export$c017ff3929b35682)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.elementsPerThread = (0, $8e83a93f95f027c6$export$1f250f140443453c)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, this.elementsPerThread);
        if (this.isVec4) {
            this.outputComponent = 4;
            if (this.isChannelsLast && convInfo.inChannels % 4 !== 0) {
                this.innerElementSize = 3;
                this.variableComponents = [
                    1,
                    4
                ];
            } else {
                this.innerElementSize = 4;
                this.variableComponents = [
                    4,
                    4
                ];
            }
            if (addBias) {
                this.variableNames.push('bias');
                this.variableComponents.push(4);
            }
            if (hasPreluActivationWeights) {
                this.variableNames.push('preluActivationWeights');
                this.variableComponents.push(4);
            }
        } else {
            this.innerElementSize = this.elementsPerThread[0];
            if (addBias) this.variableNames.push('bias');
            if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        }
        this.sequentialAccessByThreads = sequentialAccessByThreads;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        this.tileAOuter = this.workgroupSize[1] * this.elementsPerThread[1];
        this.tileBOuter = this.workgroupSize[0] * this.elementsPerThread[0];
        this.tileInner = Math.max(this.workgroupSize[0] * this.innerElementSize, this.workgroupSize[1]);
        this.fitAOuter = dimAOuter % this.tileAOuter === 0;
        this.fitBOuter = dimBOuter % this.tileBOuter === 0;
        this.fitInner = dimInner % this.tileInner === 0;
        this.shaderKey = `conv2DMM_${this.elementsPerThread}_${this.activation}}_${this.fitAOuter}_${this.fitBOuter}_${this.fitInner}_${this.isVec4}_${this.innerElementSize}_${this.isChannelsLast}_${this.sequentialAccessByThreads}`;
    }
    getUserCode() {
        const matMulSource = this.isVec4 ? (0, $0257e34115d1bde3$export$4690dafda830f3a)(this.elementsPerThread, this.workgroupSize, !this.isChannelsLast, this.tileInner) : (0, $0257e34115d1bde3$export$b3a48535ed1d015)(this.elementsPerThread, this.workgroupSize, !this.isChannelsLast, this.tileInner, false, null, this.sequentialAccessByThreads);
        const elementsSize = this.isVec4 ? [
            this.innerElementSize,
            4,
            4
        ] : [
            1,
            1,
            1
        ];
        const userCode = `
    ${$134927e6361dfc27$var$conv2dCommonSnippet(this.isChannelsLast, this.fitAOuter, this.fitBOuter, this.fitInner, this.addBias, this.activation, this.hasPreluActivationWeights, elementsSize[0], elementsSize[1], elementsSize[2])}
    ${matMulSource}
  `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $138effc62a395487$export$38cbe6d4e5101719 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>,';
        this.workgroupSize = [
            4,
            4,
            8
        ];
        this.outputShape = convInfo.outShape;
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.dispatchLayout = this.isChannelsLast ? {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0,
                3
            ]
        } : {
            x: [
                3
            ],
            y: [
                2
            ],
            z: [
                0,
                1
            ]
        };
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.shaderKey = `conv2dnaive_${this.activation}_${this.isChannelsLast}`;
    }
    getUserCode() {
        const userCode = `
       ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivationWeights, false, 4)}
       fn readInp(batch : i32, row : i32, col : i32, chan : i32) -> f32{
         let coords = vec4<i32>(batch, row, col, chan);
         if (coordsInBounds4D(coords, uniforms.xShape)) {
           return  getX(batch, row, col, chan);
         } else {
          return 0.0;
         }
       }
       fn readFilt(row : i32, col : i32, xChannel : i32, outChannel : i32) -> f32{
         let coords = vec4<i32>(row, col, xChannel, outChannel);
         if(coordsInBounds4D(coords, uniforms.wShape)) {
           return getW(row, col, xChannel, outChannel);
          } else {
            return 0.0;
          }
       }
       fn writeResult(batch : i32, row : i32, col : i32, chan : i32, valueIn : f32) {
         let coords = ${this.isChannelsLast ? `vec4<i32>(batch, row, col, chan);` : `vec4<i32>(batch, chan, row, col);`}
         if (coordsInBounds4D(coords, uniforms.outShape)) {
           var value = valueIn;
           ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(this.addBias, this.activation)}
           setOutputAtCoords(coords.x, coords.y, coords.z, coords.w, value);
         }
       }
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         let coords = getOutputCoords();
         let batch = coords[0];
         let outChannel = ${this.isChannelsLast ? `coords[3];` : `coords[1];`}
         let outRow = ${this.isChannelsLast ? `coords[1];` : `coords[2];`}
         let outCol = ${this.isChannelsLast ? `coords[2];` : `coords[3];`}
         var acc : f32 = 0.0;
         for (var row = 0; row < uniforms.filterDims[0]; row = row + 1) {
           for (var col = 0; col < uniforms.filterDims[1]; col = col + 1) {
             let xRow = outRow * uniforms.strides[0] + uniforms.dilations[0] * row - uniforms.pads[0];
             let xCol = outCol * uniforms.strides[1] + uniforms.dilations[1] * col - uniforms.pads[1];
             for (var xChannel = 0; xChannel < ${this.isChannelsLast ? `uniforms.xShape[3];` : `uniforms.xShape[1];`} xChannel = xChannel + 1) {
               ${this.isChannelsLast ? `let v = readInp(batch, xRow, xCol, xChannel);` : `let v = readInp(batch, xChannel, xRow, xCol);`}
               let f = readFilt(row, col, xChannel, outChannel);
               acc = acc + v * f;
             }
           }
         }
         writeResult(batch, outRow, outCol, outChannel, acc);
       }
     `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $2bbff9bb990a4280$export$6f6c634918904ed8 {
    constructor(outputShape, isChannelsLast){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `pads : vec2<i32>, strides : vec2<i32>, dilations : vec2<i32>, outWidth : i32, itemsPerBlockRow : i32,
       inChannels : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.isChannelsLast = isChannelsLast;
        this.shaderKey = `im2col_${this.isChannelsLast}`;
    }
    getUserCode() {
        const rowDim = this.isChannelsLast ? 1 : 2;
        const colDim = this.isChannelsLast ? 2 : 3;
        const row = this.isChannelsLast ? 'coords[1]' : 'coords[2]';
        const col = this.isChannelsLast ? 'coords[2]' : 'coords[1]';
        const getXSnippet = this.isChannelsLast ? 'getX(batch, xRow, xCol, ch)' : 'getX(batch, ch, xRow, xCol)';
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      let coords = getCoordsFromIndex(index);
      if(index < uniforms.size) {
        let batch = coords[0];
        let row = ${row};
        let col = ${col};
        let offsetY = (row / uniforms.outWidth) * uniforms.strides[0] - uniforms.pads[0];
        let xRow = offsetY + uniforms.dilations[0] * (col / uniforms.itemsPerBlockRow);
        var value = 0.0;
        if(xRow < uniforms.xShape[${rowDim}] && xRow >= 0) {
          let offsetX = (row % uniforms.outWidth) * uniforms.strides[1] -
              uniforms.pads[1];
          let xCol = offsetX + uniforms.dilations[1] * ((col %
              uniforms.itemsPerBlockRow) / uniforms.inChannels);
          let ch = col % uniforms.inChannels;
          if(xCol < uniforms.xShape[${colDim}] && xCol >= 0) {
            value = ${getXSnippet};
          }
        }
        setOutputAtIndex(index, value);
      }
    }
   `;
        return userCode;
    }
}




// conv2dByMatMul fuses height and width into one dimension to compute
// batchMatMul, so bias and activation weights are also supposed to fuse the two
// dimensions into one.
//
// This function computes the target shape for fusing height and width
// dimensions. Returning null means the shape is already compatible.
function $4c5c73b67a339da3$var$getShapeForBatchMatMul(shape, isChannelsLast) {
    const length = shape.length;
    if (length >= 3) return isChannelsLast ? [
        ...shape.slice(0, -3),
        shape[length - 3] * shape[length - 2],
        shape[length - 1]
    ] : [
        ...shape.slice(0, -3),
        shape[length - 3],
        shape[length - 2] * shape[length - 1]
    ];
    else if (!isChannelsLast && length === 1 && shape[0] > 1) return [
        shape[0],
        1
    ];
    else return null;
}
// For 1x1 kernels that iterate through every point in the input, convolution
// can be expressed as matrix multiplication (without need for memory
// remapping).
function $4c5c73b67a339da3$var$conv2dByMatMul({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const transposeA = isChannelsLast ? false : true;
    const transposeB = false;
    const sameSize = isChannelsLast && convInfo.filterHeight === convInfo.inHeight && convInfo.filterWidth === convInfo.inWidth && convInfo.padInfo.type === 'VALID';
    const intermediates = [];
    let xReshaped;
    let filterReshaped;
    if (sameSize) {
        const sharedDim = convInfo.inHeight * convInfo.inWidth * convInfo.inChannels;
        xReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.batchSize,
                    sharedDim
                ]
            }
        });
        filterReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    sharedDim,
                    convInfo.outChannels
                ]
            }
        });
    } else {
        xReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: isChannelsLast ? [
                    convInfo.batchSize,
                    convInfo.inHeight * convInfo.inWidth,
                    convInfo.inChannels
                ] : [
                    convInfo.batchSize,
                    convInfo.inChannels,
                    convInfo.inHeight * convInfo.inWidth
                ]
            }
        });
        filterReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
    }
    intermediates.push(xReshaped);
    intermediates.push(filterReshaped);
    if (preluActivationWeights != null) {
        const targetShape = $4c5c73b67a339da3$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $4c5c73b67a339da3$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const result = (0, $75edebe28daa2228$export$d524d65e88e1168b)({
        a: isChannelsLast ? xReshaped : filterReshaped,
        b: isChannelsLast ? filterReshaped : xReshaped,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    const out = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(result);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return out;
}
// Implements the im2col algorithm as outlined in "High Performance
// Convolutional Neural Networks for Document Processing" (Suvisoft, 2006)
function $4c5c73b67a339da3$var$conv2dWithIm2Col({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Rearranges conv2d input so each block to be convolved over forms the
    // row of a new matrix with shape [outHeight * outWidth,
    // filterWidth * filterHeight * inChannels]. The filter is also rearranged so
    // each output channel forms a col of a new matrix with shape [
    // filterWidth * filterHeight * inChannels, outChannels]. The convolution is
    // then computed by multiplying these matrices and reshaping the result.
    const { filterWidth: filterWidth, filterHeight: filterHeight, inChannels: inChannels, strideWidth: strideWidth, strideHeight: strideHeight, padInfo: padInfo, outWidth: outWidth, outHeight: outHeight, dilationWidth: dilationWidth, dilationHeight: dilationHeight, dataFormat: dataFormat } = convInfo;
    const isChannelsLast = dataFormat === 'channelsLast';
    const sharedDim = filterWidth * filterHeight * inChannels;
    const numCols = outHeight * outWidth;
    const x2ColShape = isChannelsLast ? [
        convInfo.batchSize,
        numCols,
        sharedDim
    ] : [
        convInfo.batchSize,
        sharedDim,
        numCols
    ];
    const im2ColProgram = new (0, $2bbff9bb990a4280$export$6f6c634918904ed8)(x2ColShape, isChannelsLast);
    const dimensions = [
        {
            type: 'int32',
            data: [
                padInfo.top,
                padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                strideHeight,
                strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                dilationHeight,
                dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                inChannels * filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                inChannels
            ]
        }
    ];
    const x2Col = backend.runWebGPUProgram(im2ColProgram, [
        x
    ], x.dtype, dimensions);
    const intermediates = [];
    intermediates.push(x2Col);
    const filterReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: filter
        },
        backend: backend,
        attrs: {
            shape: [
                1,
                sharedDim,
                -1
            ]
        }
    });
    intermediates.push(filterReshaped);
    if (preluActivationWeights != null) {
        const targetShape = $4c5c73b67a339da3$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $4c5c73b67a339da3$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const transposeA = isChannelsLast ? false : true;
    const transposeB = false;
    const result = (0, $75edebe28daa2228$export$d524d65e88e1168b)({
        a: isChannelsLast ? x2Col : filterReshaped,
        b: isChannelsLast ? filterReshaped : x2Col,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    const out = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(result);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return out;
}
function $4c5c73b67a339da3$export$5d9f3221948b996({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const sameSize = isChannelsLast && convInfo.filterHeight === convInfo.inHeight && convInfo.filterWidth === convInfo.inWidth && convInfo.padInfo.type === 'VALID';
    const useNaiveConv2d = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_USE_NAIVE_CONV2D_DEBUG');
    if (!useNaiveConv2d && (sameSize || convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID'))) return $4c5c73b67a339da3$var$conv2dByMatMul({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    const thresholdFlagValue = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGPU_THRESHOLD_TO_INCREASE_WORKGROUPS_FOR_MATMUL');
    const thresholdToIncreaseWorkgroups = thresholdFlagValue > -1 ? thresholdFlagValue : backend.thresholdToIncreaseWorkgroups;
    const workgroupsBy32x32 = convInfo.batchSize * Math.ceil(convInfo.outHeight * convInfo.outWidth / 32) * Math.ceil(convInfo.outChannels / 32);
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_CONV_SEPARATE_IM2COL_SHADER') || workgroupsBy32x32 <= thresholdToIncreaseWorkgroups) return $4c5c73b67a339da3$var$conv2dWithIm2Col({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
    let program;
    const padInfo = [
        convInfo.padInfo.top,
        convInfo.padInfo.left
    ];
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                ...padInfo
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }
    ];
    if (useNaiveConv2d) program = new (0, $138effc62a395487$export$38cbe6d4e5101719)(convInfo, hasBias, activation, hasPreluActivationWeights);
    else {
        const dimAOuter = isChannelsLast ? convInfo.outHeight * convInfo.outWidth : convInfo.outChannels;
        const dimBOuter = isChannelsLast ? convInfo.outChannels : convInfo.outHeight * convInfo.outWidth;
        const dimInner = convInfo.filterHeight * convInfo.filterWidth * convInfo.inChannels;
        dimensions.push({
            type: 'int32',
            data: [
                dimAOuter
            ]
        }, {
            type: 'int32',
            data: [
                dimBOuter
            ]
        }, {
            type: 'int32',
            data: [
                dimInner
            ]
        });
        // Experiments show that sequential access is more friendly for Intel GPUs.
        const sequentialAccessByThreads = backend.adapterInfo.isIntel();
        program = new (0, $134927e6361dfc27$export$7cb7f21cacf510bc)(convInfo, dimAOuter, dimBOuter, dimInner, hasBias, activation, hasPreluActivationWeights, sequentialAccessByThreads);
    }
    const intermediates = [];
    const inputVar = [
        x,
        filter
    ];
    if (hasBias) {
        if (!isChannelsLast && bias.shape.length === 1) {
            bias = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: [
                        bias.shape[0],
                        1,
                        1
                    ]
                }
            });
            intermediates.push(bias);
        }
        inputVar.push(bias);
    }
    if (hasPreluActivationWeights) {
        if (!isChannelsLast && preluActivationWeights.shape.length === 1) {
            preluActivationWeights = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: [
                        preluActivationWeights.shape[0],
                        1,
                        1
                    ]
                }
            });
            intermediates.push(preluActivationWeights);
        }
        inputVar.push(preluActivationWeights);
    }
    if (activation === 'leakyrelu') {
        dimensions.push({
            type: 'float32',
            data: [
                leakyreluAlpha
            ]
        });
        program.uniforms += ' alpha : f32,';
    }
    const out = backend.runWebGPUProgram(program, inputVar, x.dtype, dimensions);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return out;
}


function $567c4e1f571a0d9e$export$188f9215482e3db8(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    return (0, $4c5c73b67a339da3$export$5d9f3221948b996)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
}
const $567c4e1f571a0d9e$export$4a39bf13b4378042 = {
    kernelName: (0, $507890e4aa8e1463$export$57742e605d475795),
    backendName: 'webgpu',
    kernelFunc: $567c4e1f571a0d9e$export$188f9215482e3db8
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $6f31a08d0438dca8$export$5dc650171c0f6623 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.uniforms = 'filterDims : vec2<i32>, pads : vec2<i32>, strides : vec2<i32>, outBackprop : vec4<i32>,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = false;
        this.isVec4 = false;
        this.workPerThread = 1;
        this.outputShape = convInfo.inShape;
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.isVec4 = this.isChannelsLast && convInfo.outChannels % 4 === 0 && convInfo.inChannels % 4 === 0;
        if (this.isVec4) {
            // TODO: Expand to any value.
            this.workPerThread = 2;
            this.outputComponent = 4;
            this.workgroupSize = [
                4,
                4,
                4
            ];
            this.dispatchLayout = {
                x: [
                    3
                ],
                y: [
                    2
                ],
                z: [
                    0,
                    1
                ]
            };
            this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
                4,
                this.workPerThread,
                1
            ]);
        } else {
            this.size = true;
            this.workPerThread = 1;
            this.workgroupSize = [
                64,
                1,
                1
            ];
            this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
            this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        }
        this.shaderKey = `conv2DDerInput_${this.isChannelsLast}_${this.isVec4}_${this.workPerThread}`;
    }
    getUserCode() {
        const rowDim = this.isChannelsLast ? 1 : 2;
        const colDim = this.isChannelsLast ? 2 : 3;
        const channelDim = this.isChannelsLast ? 3 : 1;
        const vec4Snippet = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
      let batch = i32(globalId.z) / uniforms.outShape[1];
      let r = i32(globalId.z) % uniforms.outShape[1];
      let c = i32(globalId.y) * ${this.workPerThread};
      let d1 = i32(globalId.x) * 4;

      let dyCorner = vec2<i32>(r, c) - uniforms.pads;

      // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
      // ? = to be determined. : = across all values in that axis.
      var dotProd: array<vec4<f32>, ${this.workPerThread}>;
      for (var i = 0; i < ${this.workPerThread}; i++) {
        dotProd[i] = vec4<f32>(0.0);
      }
      for (var wR = 0; wR < uniforms.filterDims.x; wR = wR + 1) {
        let dyR = f32(dyCorner.x + wR) / f32(uniforms.strides.x);
        let wRPerm = uniforms.filterDims.x - 1 - wR;
        if (dyR < 0.0 || dyR >= f32(uniforms.outBackprop[1]) ||
            fract(dyR) > 0.0) {
          continue;
        }
        let idyR = i32(dyR);

        for (var wC = 0; wC < uniforms.filterDims.y; wC = wC + 1) {
          let dyC = f32(dyCorner.y + wC) / f32(uniforms.strides.y);
          let dyC2 = f32(dyCorner.y + 1 + wC) / f32(uniforms.strides.y);
          let wCPerm = uniforms.filterDims.y - 1 - wC;
          var bDyCVal = true;
          var bDyCVal2 = true;
          if (dyC < 0.0 || dyC >= f32(uniforms.outBackprop[2]) ||
              fract(dyC) > 0.0) {
            bDyCVal = false;
          }
          if (dyC2 < 0.0 || dyC2 >= f32(uniforms.outBackprop[2]) ||
              fract(dyC2) > 0.0) {
            bDyCVal2 = false;
          }

          let idyC = i32(dyC);
          let idyC2 = i32(dyC2);
          if (bDyCVal && bDyCVal2) {
            let d2Length = uniforms.outBackprop[3];
            for (var d2 = 0; d2 < d2Length; d2 = d2 + 4) {
              let wValue0 = getW(wRPerm, wCPerm, d1, d2);
              let wValue1 = getW(wRPerm, wCPerm, d1 + 1, d2);
              let wValue2 = getW(wRPerm, wCPerm, d1 + 2, d2);
              let wValue3 = getW(wRPerm, wCPerm, d1 + 3, d2);
              var xValue =  getDy(batch, idyR, idyC, d2);
              let tmpval = vec4<f32>(dot(xValue, wValue0),
                                     dot(xValue, wValue1),
                                     dot(xValue, wValue2),
                                     dot(xValue, wValue3));
              dotProd[0] = dotProd[0] + tmpval;
              xValue = getDy(batch, idyR, idyC2, d2);
              dotProd[1] = dotProd[1] + vec4<f32>(dot(xValue, wValue0),
                                                  dot(xValue, wValue1),
                                                  dot(xValue, wValue2),
                                                  dot(xValue, wValue3));
            }
          } else if (bDyCVal) {
            let d2Length = uniforms.outBackprop[3];
            for (var d2 = 0; d2 < d2Length; d2 = d2 + 4) {
              let wValue0 = getW(wRPerm, wCPerm, d1, d2);
              let wValue1 = getW(wRPerm, wCPerm, d1 + 1, d2);
              let wValue2 = getW(wRPerm, wCPerm, d1 + 2, d2);
              let wValue3 = getW(wRPerm, wCPerm, d1 + 3, d2);
              var xValue =  getDy(batch, idyR, idyC, d2);
              let tmpval = vec4<f32>(dot(xValue, wValue0),
                                     dot(xValue, wValue1),
                                     dot(xValue, wValue2),
                                     dot(xValue, wValue3));
              dotProd[0] = dotProd[0] + tmpval;
            }
          } else if (bDyCVal2) {
            let d2Length = uniforms.outBackprop[3];
            for (var d2 = 0; d2 < d2Length; d2 = d2 + 4) {
              let wValue0 = getW(wRPerm, wCPerm, d1, d2);
              let wValue1 = getW(wRPerm, wCPerm, d1 + 1, d2);
              let wValue2 = getW(wRPerm, wCPerm, d1 + 2, d2);
              let wValue3 = getW(wRPerm, wCPerm, d1 + 3, d2);
              var xValue =  getDy(batch, idyR, idyC2, d2);
              let tmpval = vec4<f32>(dot(xValue, wValue0),
                                     dot(xValue, wValue1),
                                     dot(xValue, wValue2),
                                     dot(xValue, wValue3));
              dotProd[1] = dotProd[1] + tmpval;
            }
          }
        }
      }

      for (var i = 0; i < ${this.workPerThread}; i = i + 1) {
        let coords = vec4<i32>(batch, r, c + i, d1);
        if (coordsInBounds4D(coords, uniforms.outShape)) {
          setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], dotProd[i]);
        }
      }
    }
    `;
        return this.isVec4 ? `
    ${vec4Snippet}
    ` : `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d1 = coords[${channelDim}];

        let dyCorner = vec2<i32>(coords[${rowDim}], coords[${colDim}]) - uniforms.pads;
        let dyRCorner = dyCorner.x;
        let dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var wR = 0; wR < uniforms.filterDims.x; wR = wR + 1) {
          let dyR = (f32(dyRCorner) + f32(wR)) / f32(uniforms.strides.x);
          let wRPerm = uniforms.filterDims.x - 1 - wR;
          if (dyR < 0.0 || dyR >= f32(uniforms.outBackprop[1]) || fract(dyR) > 0.0 ||
              wRPerm < 0) {
            continue;
          }
          let idyR = i32(dyR);

          for (var wC = 0; wC < uniforms.filterDims.y; wC = wC + 1) {
            let dyC = (f32(dyCCorner) + f32(wC)) / f32(uniforms.strides.y);
            let wCPerm = uniforms.filterDims.y - 1 - wC;
            if (dyC < 0.0 || dyC >= f32(uniforms.outBackprop[2]) ||
                fract(dyC) > 0.0 || wCPerm < 0) {
              continue;
            }
            let idyC = i32(dyC);

            for (var d2 = 0; d2 < uniforms.outBackprop[3]; d2 = d2 + 1) {
              let xValue = ${this.isChannelsLast ? 'getDy(batch, idyR, idyC, d2)' : 'getDy(batch, d2, idyR, idyC)'};
              let wValue = getW(wRPerm, wCPerm, d1, d2);
              dotProd = dotProd + xValue * wValue;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}
class $6f31a08d0438dca8$export$1223560f67be2f2d {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.uniforms = 'pads : vec2<i32>, strides : vec2<i32>, batchSize : i32, outHeight : i32, outWidth : i32, inHeight : i32, inWidth : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.shaderKey = `conv2DDerFilter_${this.isChannelsLast}`;
    }
    getUserCode() {
        return `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let wR = coords[0];
        let wC = coords[1];
        let d1 = coords[2];
        let d2 = coords[3];

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var b = 0; b < uniforms.batchSize; b = b + 1) {
          for (var yR = 0; yR < uniforms.outHeight; yR = yR + 1) {
            let xR = wR + yR * uniforms.strides[0] - uniforms.pads[0];
            if (xR < 0 || xR >= uniforms.inHeight) {
              continue;
            }

            for (var yC = 0; yC < uniforms.outWidth; yC = yC + 1) {
              let xC = wC + yC * uniforms.strides[1] - uniforms.pads[1];

              if (xC < 0 || xC >= uniforms.inWidth) {
                continue;
              }

              if (${this.isChannelsLast}) {
                let dyValue = getDy(b, yR, yC, d2);
                let xValue = getX(b, xR, xC, d1);
                dotProd = dotProd + xValue * dyValue;
              } else {
                let dyValue = getDy(b, d2, yR, yC);
                let xValue = getX(b, d1, xR, xC);
                dotProd = dotProd + xValue * dyValue;
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}
class $6f31a08d0438dca8$export$932d18866f409cf3 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.uniforms = `pads : vec3<i32>, strides : vec3<i32>, batchSize : i32, outDepth : i32,
       outHeight : i32, outWidth : i32, inDepth : i32, inHeight : i32, inWidth : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `conv3DDerFilter`;
    }
    getUserCode() {
        return `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let wF = coords.x;
        let wR = coords.y;
        let wC = coords.z;
        let d1 = coords.w;
        let d2 = coords.u;

        var dotProd = 0.0;
        for (var b = 0; b < uniforms.batchSize; b++) {
          for (var yF = 0; yF < uniforms.outDepth; yF++) {
            let xF = wF + yF * uniforms.strides[0] - uniforms.pads[0];
            if (xF < 0 || xF >= uniforms.inDepth) {
              continue;
            }

            for (var yR = 0; yR < uniforms.outHeight; yR++) {
              let xR = wR + yR * uniforms.strides[1] - uniforms.pads[1];
              if (xR < 0 || xR >= uniforms.inHeight) {
                continue;
              }

              for (var yC = 0; yC < uniforms.outWidth; yC++) {
                let xC = wC + yC * uniforms.strides[2] - uniforms.pads[2];
                if (xC < 0 || xC >= uniforms.inWidth) {
                  continue;
                }

                let dyValue = getDy(b, yF, yR, yC, d2);
                let xValue = getX(b, xF, xR, xC, d1);
                dotProd += xValue * dyValue;
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}
class $6f31a08d0438dca8$export$acda329ff653a25 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.uniforms = `filterDims : vec3<i32>, pads : vec3<i32>, strides : vec3<i32>,
      outDepth : i32, outHeight : i32, outWidth : i32, outChannels : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `conv3DDerInput`;
    }
    getUserCode() {
        return `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords.x;
        let d1 = coords.u;

        let dyCorner = vec3<i32>(coords.y, coords.z, coords.w) - uniforms.pads;
        let dyFCorner = dyCorner.x;
        let dyRCorner = dyCorner.y;
        let dyCCorner = dyCorner.z;

        var dotProd = 0.0;
        for (var wF = 0; wF < uniforms.filterDims[0]; wF++) {
          let dyF = f32(dyFCorner + wF) / f32(uniforms.strides[0]);
          if (dyF < 0.0 || dyF >= f32(uniforms.outDepth) || fract(dyF) > 0.0) {
            continue;
          }
          let idyF = i32(dyF);

          let wFPerm = uniforms.filterDims[0] - 1 - wF;

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[1]);

            if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
              continue;
            }
            let idyR = i32(dyR);

            let wRPerm = uniforms.filterDims[1] - 1 - wR;

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[2]);

              if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
                continue;
              }
              let idyC = i32(dyC);

              let wCPerm = uniforms.filterDims[2] - 1 - wC;

              for (var d2 = 0; d2 < uniforms.outChannels; d2++) {
                let xValue = getDy(batch, idyF, idyR, idyC, d2);
                let wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}


function $68d687ad28cbda96$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $6f31a08d0438dca8$export$1223560f67be2f2d)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x,
        dy
    ], x.dtype, uniformData);
}
const $68d687ad28cbda96$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $507890e4aa8e1463$export$32a8943c0f1ca5a7),
    backendName: 'webgpu',
    kernelFunc: $68d687ad28cbda96$export$652a30c9379f3de7
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $494049b15a1aa270$var$conv2dTransposeCommonSnippet(innerElementSize = 4) {
    const getWSnippet = (innerElementSize)=>{
        switch(innerElementSize){
            case 1:
                return 'return W[getIndexFromCoords4D(coord, uniforms.wShape)];';
            case 4:
                return `
            let coord1 = vec4<i32>(coordX, coordY, col + 1, rowInner);
            let coord2 = vec4<i32>(coordX, coordY, col + 2, rowInner);
            let coord3 = vec4<i32>(coordX, coordY, col + 3, rowInner);
            let v0 = W[getIndexFromCoords4D(coord, uniforms.wShape)];
            let v1 = W[getIndexFromCoords4D(coord1, uniforms.wShape)];
            let v2 = W[getIndexFromCoords4D(coord2, uniforms.wShape)];
            let v3 = W[getIndexFromCoords4D(coord3, uniforms.wShape)];
            return vec4<f32>(v0, v1, v2, v3);
            `;
            default:
                throw new Error(`innerElementSize ${innerElementSize} is not supported.`);
        }
    };
    const readASnippet = `
      let outRow = row / uniforms.outShape[2];
      let outCol = row % uniforms.outShape[2];

      let WRow = col / (uniforms.filterDims[1] * uniforms.outBackprop[3]);
      let WCol = col / uniforms.outBackprop[3] % uniforms.filterDims[1];
      let xR = f32(outRow - uniforms.pads[0] + WRow) / f32(uniforms.strides[0]);
      let xC = f32(outCol - uniforms.pads[1] + WCol) / f32(uniforms.strides[1]);
      if (xR < 0.0 || xR >= f32(uniforms.outBackprop[1]) || fract(xR) > 0.0) {
        return ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)}(0.0);
      }
      if (xC < 0.0 || xC >= f32(uniforms.outBackprop[2]) || fract(xC) > 0.0) {
        return ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)}(0.0);
      }
      let coord = vec4<i32>(
          batch,
          i32(xR),
          i32(xC),
          col % uniforms.outBackprop[3]);
      return x[getIndexFromCoords4D(coord, uniforms.xShape)/${innerElementSize}];`;
    const sampleA = `if (row < uniforms.dimAOuter && col < uniforms.dimInner) {
        ${readASnippet}
      }
      return ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)}(0.0);`;
    const userCode = `
  fn mm_readA(batch: i32, row : i32, col : i32) -> ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)} {
    ${sampleA}
  }

  fn mm_readB(batch: i32, row : i32, col : i32) -> ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)} {
    let coordX = uniforms.filterDims.x - 1 -
        row / (uniforms.filterDims[1] * uniforms.outBackprop[3]);
    let coordY = uniforms.filterDims.y - 1 -
        (row / uniforms.outBackprop[3]) % uniforms.filterDims[1];
    if (row < uniforms.dimInner && col < uniforms.dimBOuter &&
        coordX >= 0 && coordY >= 0) {
      let rowInner = row % uniforms.outBackprop[3];
      let coord = vec4<i32>(coordX, coordY, col, rowInner);
      ${getWSnippet(innerElementSize)}
    }
    return ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)}(0.0);
  }

  fn mm_write(batch: i32, row : i32, col : i32, valueInput : ${(0, $0533631f1fe2cae9$export$85f585983df3fed3)(innerElementSize)}) {
    if (row < uniforms.dimAOuter && col < uniforms.dimBOuter) {
      var value = valueInput;
      let outCoord = vec4<i32>(
          batch,
          row / uniforms.outShape[2],
          row % uniforms.outShape[2],
          col);
      result[getIndexFromCoords4D(outCoord, uniforms.outShape)/${innerElementSize}] = value;
    }
  }`;
    return userCode;
}
class $494049b15a1aa270$export$274f8feb1a7dfb31 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'filterDims : vec2<i32>, pads : vec2<i32>, strides : vec2<i32>, outBackprop : vec4<i32>, dimAOuter : i32, dimBOuter : i32, dimInner : i32,';
        this.outputShape = convInfo.inShape;
        (0, $0775da5e684c8c0d$exports).assert(convInfo.dataFormat === 'channelsLast', ()=>'TODO: NCHW is unimplemented');
        this.isVec4 = convInfo.inChannels % 4 === 0 && convInfo.outChannels % 4 === 0;
        this.dispatchLayout = {
            x: [
                3
            ],
            y: [
                1,
                2
            ],
            z: [
                0
            ]
        };
        this.workgroupSize = (0, $8e83a93f95f027c6$export$c017ff3929b35682)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.elementsPerThread = (0, $8e83a93f95f027c6$export$1f250f140443453c)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, this.elementsPerThread);
        if (this.isVec4) {
            this.outputComponent = 4;
            this.variableComponents = [
                4,
                1
            ];
        }
        this.shaderKey = `conv2DDerInputMM_${this.isVec4}_${this.elementsPerThread}`;
    }
    getUserCode() {
        const matMulSource = this.isVec4 ? (0, $0257e34115d1bde3$export$4690dafda830f3a)(this.elementsPerThread, this.workgroupSize) : (0, $0257e34115d1bde3$export$b3a48535ed1d015)(this.elementsPerThread, this.workgroupSize);
        const userCode = `
    ${$494049b15a1aa270$var$conv2dTransposeCommonSnippet(this.isVec4 ? 4 : 1)}
    ${matMulSource}
    `;
        return userCode;
    }
}



function $576b0dae588f8198$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight - 1 - convInfo.padInfo.top,
                convInfo.filterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize,
                convInfo.outHeight,
                convInfo.outWidth,
                convInfo.outChannels
            ]
        }
    ];
    let program;
    // TODO: Experiment when to use Conv2DDerInputMMProgram algorithm.
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_USE_NAIVE_CONV2D_TRANSPOSE') || convInfo.dataFormat !== 'channelsLast') program = new (0, $6f31a08d0438dca8$export$5dc650171c0f6623)(convInfo);
    else {
        program = new (0, $494049b15a1aa270$export$274f8feb1a7dfb31)(convInfo);
        const dimAOuter = convInfo.inHeight * convInfo.inWidth;
        const dimBOuter = convInfo.inChannels;
        const dimInner = convInfo.filterHeight * convInfo.filterWidth * convInfo.outChannels;
        dimensions.push({
            type: 'uint32',
            data: [
                dimAOuter
            ]
        }, {
            type: 'uint32',
            data: [
                dimBOuter
            ]
        }, {
            type: 'uint32',
            data: [
                dimInner
            ]
        });
    }
    return backend.runWebGPUProgram(program, [
        dy,
        filter
    ], 'float32', dimensions);
}
const $576b0dae588f8198$export$19bbc19fff1ed26f = {
    kernelName: (0, $507890e4aa8e1463$export$e26961e8ed0eb404),
    backendName: 'webgpu',
    kernelFunc: $576b0dae588f8198$export$633310eed0c26e72
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $7a0f9acf19b5feef$export$d39b613d7b183f3b {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'filterDims: vec3<i32>, pads: vec3<i32>, strides: vec3<i32>, dilations: vec3<i32>,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `conv3dnaive`;
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let batch = coords.x;
        let d2 = coords.u;

        let xFRCCorner = vec3<i32>(coords.y, coords.z, coords.w) * uniforms.strides - uniforms.pads;
        let xFCorner = xFRCCorner.x;
        let xRCorner = xFRCCorner.y;
        let xCCorner = xFRCCorner.z;

        let inputDepthNearestVec4 = (uniforms.xShape.u / 4) * 4;
        let inputDepthVec4Remainder = uniforms.xShape.u % 4;

        var dotProd = 0.0;
        for (var wF = 0; wF < uniforms.filterDims[0]; wF++) {
          let xF = xFCorner + wF * uniforms.dilations[0];
          if (xF < 0 || xF >= uniforms.xShape.y) {
            continue;
          }

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let xR = xRCorner + wR * uniforms.dilations[1];
            if (xR < 0 || xR >= uniforms.xShape.z) {
              continue;
            }

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let xC = xCCorner + wC * uniforms.dilations[2];
              if (xC < 0 || xC >= uniforms.xShape.w) {
                continue;
              }

              for (var d1 = 0; d1 < inputDepthNearestVec4; d1 += 4) {
                let xValues = vec4<f32>(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                let wValues = vec4<f32>(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (inputDepthVec4Remainder == 1) {
                dotProd += getX(batch, xF, xR, xC, inputDepthNearestVec4) *
                  getW(wF, wR, wC, inputDepthNearestVec4, d2);
              } else if (inputDepthVec4Remainder == 2) {
                let xValues = vec2<f32>(
                  getX(batch, xF, xR, xC, inputDepthNearestVec4),
                  getX(batch, xF, xR, xC, inputDepthNearestVec4 + 1)
                );
                let wValues = vec2<f32>(
                  getW(wF, wR, wC, inputDepthNearestVec4, d2),
                  getW(wF, wR, wC, inputDepthNearestVec4 + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (inputDepthVec4Remainder == 3) {
                let xValues = vec3<f32>(
                  getX(batch, xF, xR, xC, inputDepthNearestVec4),
                  getX(batch, xF, xR, xC, inputDepthNearestVec4 + 1),
                  getX(batch, xF, xR, xC, inputDepthNearestVec4 + 2)
                );
                let wValues = vec3<f32>(
                  getW(wF, wR, wC, inputDepthNearestVec4, d2),
                  getW(wF, wR, wC, inputDepthNearestVec4 + 1, d2),
                  getW(wF, wR, wC, inputDepthNearestVec4 + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }`;
        return userCode;
    }
}


function $c40aa2ab17d638a0$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const padInfo = [
        convInfo.padInfo.front,
        convInfo.padInfo.top,
        convInfo.padInfo.left
    ];
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.filterDepth,
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                ...padInfo
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationDepth,
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }
    ];
    const program = new (0, $7a0f9acf19b5feef$export$d39b613d7b183f3b)(convInfo);
    const dtype = (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(x.dtype, filter.dtype);
    return backend.runWebGPUProgram(program, [
        x,
        filter
    ], dtype, dimensions);
}
const $c40aa2ab17d638a0$export$1fe590fda0829040 = {
    kernelName: (0, $507890e4aa8e1463$export$9d3874201dd21933),
    backendName: 'webgpu',
    kernelFunc: $c40aa2ab17d638a0$export$1929932f31d07956
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $859c5fbafb0d4aa0$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const program = new (0, $6f31a08d0438dca8$export$932d18866f409cf3)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x,
        dy
    ], dy.dtype, uniformData);
}
const $859c5fbafb0d4aa0$export$6dce9169640850fa = {
    kernelName: (0, $507890e4aa8e1463$export$dd2885efe6043eee),
    backendName: 'webgpu',
    kernelFunc: $859c5fbafb0d4aa0$export$b57760dc3101cea7
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $5388c17cea921b14$export$ab31b884dc9f0971(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, pad: pad, inputShape: inputShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const program = new (0, $6f31a08d0438dca8$export$acda329ff653a25)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterDepth,
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterDepth - 1 - convInfo.padInfo.front,
                convInfo.filterHeight - 1 - convInfo.padInfo.top,
                convInfo.filterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outChannels
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy,
        filter
    ], dy.dtype, uniformData);
}
const $5388c17cea921b14$export$40ece1caaaf084b2 = {
    kernelName: (0, $507890e4aa8e1463$export$a54f552d6d7d521f),
    backendName: 'webgpu',
    kernelFunc: $5388c17cea921b14$export$ab31b884dc9f0971
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $495a6ae661d06089$export$50d414a77b60d802 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).COS
});
const $495a6ae661d06089$export$ff099a1da5235a7e = {
    kernelName: (0, $507890e4aa8e1463$export$ddfd0a983d257666),
    backendName: 'webgpu',
    kernelFunc: $495a6ae661d06089$export$50d414a77b60d802
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $c4b3baf836b397c2$export$2e2fd1ad24e4d350 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).COSH
});
const $c4b3baf836b397c2$export$c5824052b09ba0ed = {
    kernelName: (0, $507890e4aa8e1463$export$5e311a1c57b0d27c),
    backendName: 'webgpu',
    kernelFunc: $c4b3baf836b397c2$export$2e2fd1ad24e4d350
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $f501ad6f875c3681$export$c889a58f7ea63106 {
    constructor(channnel, boxShape, cropSize, method){
        this.variableNames = [
            'Image',
            'Boxes',
            'BoxInd'
        ];
        this.uniforms = 'extrapolationValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const [numBoxes] = boxShape;
        this.outputShape = [
            numBoxes,
            cropSize[0],
            cropSize[1],
            channnel
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.methodId = method === 'bilinear' ? 1 : 0;
        this.cropHeightBiggerThan1 = this.outputShape[1] > 1;
        this.cropWidthBiggerThan1 = this.outputShape[2] > 1;
        this.shaderKey = `cropAndResize_${this.methodId}_${this.cropHeightBiggerThan1}_${this.cropWidthBiggerThan1}`;
    }
    getUserCode() {
        const [inputHeightFloat, inputWidthFloat] = [
            `f32(uniforms.imageShape[1] - 1)`,
            `f32(uniforms.imageShape[2] - 1)`
        ];
        const [heightRatio, heightScale, inY] = this.cropHeightBiggerThan1 ? [
            `(${inputHeightFloat} / f32(uniforms.outShape[1] - 1))`,
            '(y2-y1) * height_ratio',
            `y1*${inputHeightFloat} + f32(y)*(height_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (y1+y2) * ${inputHeightFloat}`
        ];
        const [widthRatio, widthScale, inX] = this.cropWidthBiggerThan1 ? [
            `(${inputWidthFloat} / f32(uniforms.outShape[2] - 1))`,
            '(x2-x1) * width_ratio',
            `x1*${inputWidthFloat} + f32(x)*(width_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (x1+x2) * ${inputWidthFloat}`
        ];
        // Reference implementation
        // tslint:disable-next-line:max-line-length
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let height_ratio = f32(${heightRatio});
        let width_ratio = f32(${widthRatio});
        let b = coords[0];
        let y = coords[1];
        let x = coords[2];
        let d = coords[3];
        // get box vals
        let y1 = getBoxes(b, 0);
        let x1 = getBoxes(b, 1);
        let y2 = getBoxes(b, 2);
        let x2 = getBoxes(b, 3);
        // get image in batch index
        let bInd = i32(round(getBoxInd(b)));
        if(bInd < 0 || bInd >= uniforms.outShape[0]) {
          return;
        }
        let height_scale = ${heightScale};
        let width_scale = ${widthScale};
        let in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutputAtIndex(index, uniforms.extrapolationValue);
          return;
        }
        let in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutputAtIndex(index, uniforms.extrapolationValue);
          return;
        }
        let sourceFracIndexCR = vec2<f32>(in_x,in_y);
        if(${this.methodId} == 1) {
          // Compute the four integer indices.
          let sourceFloorCR = vec2<i32>(sourceFracIndexCR);
          let sourceCeilCR = vec2<i32>(ceil(sourceFracIndexCR));
          let topLeft = getImage(bInd, sourceFloorCR.y, sourceFloorCR.x, d);
          let bottomLeft = getImage(bInd, sourceCeilCR.y, sourceFloorCR.x, d);
          let topRight = getImage(bInd, sourceFloorCR.y, sourceCeilCR.x, d);
          let bottomRight = getImage(bInd, sourceCeilCR.y, sourceCeilCR.x, d);
          let fracCR = sourceFracIndexCR - vec2<f32>(sourceFloorCR);
          let top = topLeft + (topRight - topLeft) * fracCR.x;
          let bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          let newValue = top + (bottom - top) * fracCR.y;
          setOutputAtIndex(index, newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          let sourceNearestCR = vec2<i32>(floor(
            sourceFracIndexCR + vec2<f32>(0.5,0.5)));
          let newValue = getImage(
            bInd, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutputAtIndex(index, newValue);
        }
      }
    }
    `;
        return userCode;
    }
}


const $41779e8d85e01aab$export$6f0f0090e1f6cd3c = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const program = new (0, $f501ad6f875c3681$export$c889a58f7ea63106)(image.shape[3], boxes.shape, cropSize, method);
    const uniformData = [
        {
            type: 'float32',
            data: [
                extrapolationValue
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        image,
        boxes,
        boxInd
    ], 'float32', uniformData);
};
const $41779e8d85e01aab$export$f7086edcf0050c7f = {
    kernelName: (0, $507890e4aa8e1463$export$50bc9557793c2e04),
    backendName: 'webgpu',
    kernelFunc: $41779e8d85e01aab$export$6f0f0090e1f6cd3c
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

var $b30793a3a757ff51$export$5245168906ddd3d9;
(function(CumOpType) {
    CumOpType["Prod"] = "*";
    CumOpType["Sum"] = "+";
})($b30793a3a757ff51$export$5245168906ddd3d9 || ($b30793a3a757ff51$export$5245168906ddd3d9 = {}));
class $b30793a3a757ff51$export$6788a4605888e813 {
    constructor(op, shape, exclusive, reverse){
        this.variableNames = [
            'x'
        ];
        // pow(i32, i32) is not supported, use pow(f32, f32) instead.
        this.uniforms = 'index : f32,';
        this.size = true;
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.exclusive = exclusive;
        this.reverse = reverse;
        this.op = op;
        this.shaderKey = `cum_${this.op}_${this.exclusive}_${this.reverse}`;
    }
    getUserCode() {
        const rank = this.outputShape.length;
        const initVal = this.op === $b30793a3a757ff51$export$5245168906ddd3d9.Prod ? '1.0' : '0.0';
        const val = this.exclusive ? initVal : `getX(${$b30793a3a757ff51$var$getCoords(rank, 'coords', this.op)})`;
        const length = this.outputShape[this.outputShape.length - 1];
        let condition = '';
        let idxString = '';
        // When exclusive is set, the cum op becomes roll op that copies the
        // value from the previous index based on the direction specified by the
        // reverse flag.
        if (this.exclusive) {
            condition = this.reverse ? `end != ${length - 1}` : 'end != 0';
            idxString = this.reverse ? 'end + 1' : 'end - 1';
        } else {
            condition = this.reverse ? `end + pow2 < ${length}` : 'end >= pow2';
            idxString = this.reverse ? 'end + pow2' : 'end - pow2';
        }
        return `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
       if (index < uniforms.size) {
         var coords = getCoordsFromIndex(index);

         let end = ${$b30793a3a757ff51$var$getFinalCoord(rank, 'coords', this.op)};
         var val = ${val};
         let pow2 = i32(pow(2.0, uniforms.index));
         if (${condition}) {
           let idx = ${idxString};
           ${$b30793a3a757ff51$var$getFinalCoord(rank, 'coords', this.op)} = idx;
           val ${this.op}= getX(${$b30793a3a757ff51$var$getCoords(rank, 'coords', this.op)});
         }
         setOutputAtIndex(index, val);
       }
      }
    `;
    }
}
function $b30793a3a757ff51$var$getCoords(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.x, ${name}.y`;
    else if (rank === 3) return `${name}.x, ${name}.y, ${name}.z`;
    else if (rank === 4) return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
    else throw Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}
function $b30793a3a757ff51$var$getFinalCoord(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.y`;
    else if (rank === 3) return `${name}.z`;
    else if (rank === 4) return `${name}.w`;
    else throw Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $5cc99f9a40c5ec46$export$88973bdd32b5a724(op, x, backend, axis, exclusive, reverse) {
    const xRank = x.shape.length;
    const permutation = (0, $f35e0c1a651337db$exports).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) permutedX = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $f35e0c1a651337db$exports).getInnerMostAxes(1, xRank)[0];
    if (permutedAxis !== xRank - 1) throw new Error(`WebGPU cumprod shader expects an inner-most axis=${x.shape.length - 1} ` + `but got axis=${axis}`);
    const size = permutedX.shape[permutedAxis];
    let result = (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: permutedX
        },
        backend: backend
    });
    // Use cum parallel algorithm, inspired by:
    // https://developer.nvidia.com/gpugems/gpugems3/part-vi-gpu-computing/chapter-39-parallel-prefix-sum-scan-cuda
    // Note: although the algorithm is called sum, it works for any associtative
    // operator with an identity.
    for(let i = 0; i <= Math.ceil(Math.log2(size)) - 1; i++){
        const program = new (0, $b30793a3a757ff51$export$6788a4605888e813)(op, permutedX.shape, false, reverse);
        const prevResult = result;
        const uniformData = [
            {
                type: 'float32',
                data: [
                    i
                ]
            }
        ];
        result = backend.runWebGPUProgram(program, [
            result
        ], result.dtype, uniformData);
        backend.disposeData(prevResult.dataId);
    }
    // For exclusive cum, shift the end result in the direction of product or sum
    // and add 1 for product or 0 for sum to the front index.
    if (exclusive) {
        const program = new (0, $b30793a3a757ff51$export$6788a4605888e813)(op, permutedX.shape, exclusive, reverse);
        const prevResult = result;
        const uniformData = [
            {
                type: 'float32',
                data: [
                    0
                ]
            }
        ];
        result = backend.runWebGPUProgram(program, [
            result
        ], result.dtype, uniformData);
        backend.disposeData(prevResult.dataId);
    }
    if (permutation != null) {
        const reversePermutation = (0, $f35e0c1a651337db$exports).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeData(result.dataId);
        backend.disposeData(permutedX.dataId);
        return reverseTransposedResult;
    }
    return result;
}


function $21bb4613ed08f372$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $5cc99f9a40c5ec46$export$88973bdd32b5a724)((0, $b30793a3a757ff51$export$5245168906ddd3d9).Prod, x, backend, axis, exclusive, reverse);
}
const $21bb4613ed08f372$export$db50d81ed60c5a35 = {
    kernelName: (0, $507890e4aa8e1463$export$e581acc6014c47a),
    backendName: 'webgpu',
    kernelFunc: $21bb4613ed08f372$export$dc7513e907e94b8d
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $6cada2a4f2eececd$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $5cc99f9a40c5ec46$export$88973bdd32b5a724)((0, $b30793a3a757ff51$export$5245168906ddd3d9).Sum, x, backend, axis, exclusive, reverse);
}
const $6cada2a4f2eececd$export$2f6196f3316e7ed2 = {
    kernelName: (0, $507890e4aa8e1463$export$706617d894ad63da),
    backendName: 'webgpu',
    kernelFunc: $6cada2a4f2eececd$export$71990b1e1c4912fe
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $25be7e6cd1792cbe$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    const xRankOne = x.shape.length === 1;
    const weightsSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(weights.shape);
    const hasWeights = weightsSize > 0;
    const dtype = weights.dtype;
    const xSize = xRankOne ? [
        x.shape[0]
    ] : [
        x.shape[0],
        x.shape[1]
    ];
    const outputSize = xRankOne ? [
        size
    ] : [
        x.shape[0],
        size
    ];
    const output = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: outputSize,
            value: 0,
            dtype: dtype
        }
    });
    const program = new (0, $4865bee36b5e2471$export$7535c7c7286368eb)(xSize, hasWeights, binaryOutput);
    const uniformData = [
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const bincountInputs = hasWeights ? [
        x,
        weights
    ] : [
        x
    ];
    const res = backend.runWebGPUProgram(program, bincountInputs, dtype, uniformData, output);
    return res;
}
const $25be7e6cd1792cbe$export$88ba267b84334692 = {
    kernelName: (0, $507890e4aa8e1463$export$5bab6834954299c5),
    backendName: 'webgpu',
    kernelFunc: $25be7e6cd1792cbe$export$436934e6cf1946f1
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $ea5d63b67db40401$export$eb07f17369165f28 {
    constructor(outputShape, dataFormat){
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.uniforms = 'blockSize : i32,';
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `depthToSpace_${dataFormat}`;
        this.dataFormat = dataFormat;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let b = coords[0];
          let h = ${this.getHeightCoordString()};
          let w = ${this.getWidthCoordString()};
          let d = ${this.getDepthCoordString()};

          let in_h = h / uniforms.blockSize;
          let offset_h = h % uniforms.blockSize;
          let in_w = w / uniforms.blockSize;
          let offset_w = w % uniforms.blockSize;
          let offset_d = (offset_h * uniforms.blockSize + offset_w) *
            ${this.getOutputDepthSize()};
          let in_d = d + offset_d;

          let rlt = ${this.getInputSamplingString()};
          setOutputAtIndex(index, rlt);
        }
      }`;
        return userCode;
    }
    getHeightCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[1]`;
        else return `coords[2]`;
    }
    getWidthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[2]`;
        else return `coords[3]`;
    }
    getDepthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[3]`;
        else return `coords[1]`;
    }
    getOutputDepthSize() {
        if (this.dataFormat === 'NHWC') return `uniforms.outShape[3]`;
        else return `uniforms.outShape[1]`;
    }
    getInputSamplingString() {
        if (this.dataFormat === 'NHWC') return `getX(b, in_h, in_w, in_d)`;
        else return `getX(b, in_d, in_h, in_w)`;
    }
}


function $20430029a9dc6be1$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    const batchSize = x.shape[0];
    const inputHeight = dataFormat === 'NHWC' ? x.shape[1] : x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? x.shape[2] : x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? x.shape[3] : x.shape[1];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const outputShape = dataFormat === 'NHWC' ? [
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ] : [
        batchSize,
        outputDepth,
        outputHeight,
        outputWidth
    ];
    const uniformData = [
        {
            type: 'int32',
            data: [
                blockSize
            ]
        }
    ];
    const program = new (0, $ea5d63b67db40401$export$eb07f17369165f28)(outputShape, dataFormat);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $20430029a9dc6be1$export$9c5b88dcb1d2008b = {
    kernelName: (0, $507890e4aa8e1463$export$fb0ee52d0cd6f233),
    backendName: 'webgpu',
    kernelFunc: $20430029a9dc6be1$export$3b50daec0f185f12
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $b13fa0c289e05bec$export$c20669e15027e214 {
    constructor(outputShape, filterHeight, filterWidth, addBias = false, activation = null, hasPreluActivation = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = `pads : vec2<i32>, inDims : vec2<i32>,`;
        this.workgroupSize = [
            16,
            16,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                3
            ],
            y: [
                2
            ],
            z: [
                0,
                1
            ]
        };
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivation = hasPreluActivation;
        this.filterHeight = filterHeight;
        this.filterWidth = filterWidth;
        this.shaderKey = `depthwiseNCHW_${this.activation}_${this.filterHeight}_${this.filterWidth}`;
    }
    getUserCode() {
        const filterSize = this.filterWidth * this.filterHeight;
        const flatWorkgroupSize = this.workgroupSize[0] * this.workgroupSize[1] * this.workgroupSize[2];
        const tileAHeight = this.workgroupSize[1] + this.filterHeight - 1;
        const tileAWidth = this.workgroupSize[0] + this.filterWidth - 1;
        const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivation, false, 4)}

      var<workgroup> mm_Asub : array<array<f32, ${tileAWidth}>, ${tileAHeight}>;
      var<workgroup> mm_Bsub : array<array<f32, ${this.filterWidth}>, ${this.filterHeight}>;
      fn readX(batch : i32, channel : i32, row : i32, col : i32) -> f32 {
        var value = 0.0;
        if (row >=0 && row < uniforms.inDims[0] && col >=0 && col < uniforms.inDims[1])
        {
          value = getX(batch, channel, row, col);
        }
        return value;
      }

      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
        let coords = getOutputCoords();
        let batch = coords[0];
        let xRCCorner = vec2<i32>(coords.zw) - uniforms.pads;
        let channelMul = uniforms.wShape[3];
        let d1 = coords[1] / channelMul;
        let q = coords[1] % channelMul;

        let inputRowStart = xRCCorner.x;
        let inputColStart = xRCCorner.y;

        let localRow = i32(localId.y);
        let localCol = i32(localId.x);

        // Load one tile of X into local memory.
        for (var inputRow = localRow; inputRow < ${tileAHeight}; inputRow = inputRow + ${this.workgroupSize[1]}) {
          for (var inputCol = localCol; inputCol < ${tileAWidth}; inputCol = inputCol + ${this.workgroupSize[0]}) {
            let rowOffset = inputRow - localRow;
            let colOffset = inputCol - localCol;
            mm_Asub[inputRow][inputCol] = readX(batch, d1, inputRowStart + rowOffset, inputColStart + colOffset);
          }
        }

        // Load one tile of W into local memory.
        var wIndex = i32(localIndex);
        ${filterSize < flatWorkgroupSize ? `if (wIndex < ${filterSize})` : `for(; wIndex < ${filterSize}; wIndex = wIndex + ${flatWorkgroupSize})`}

        {
          let wRow = wIndex / ${this.filterWidth};
          let wCol = wIndex % ${this.filterWidth};
          mm_Bsub[wRow][wCol] = getW(wRow, wCol, d1, q);
        }

        workgroupBarrier();

        var value = 0.0;
        for (var wR = 0; wR < ${this.filterHeight}; wR = wR + 1) {
          for (var wC = 0; wC < ${this.filterWidth}; wC = wC + 1) {
            let xVal = mm_Asub[localRow + wR][localCol + wC];
            let wVal = mm_Bsub[wR][wC];
            value = fma(xVal, wVal, value);
          }
        }
        ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(this.addBias, this.activation)}
        if (coordsInBounds4D(coords, uniforms.outShape)) {
          setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
        }
      }
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



class $84cea51a019dd6b6$export$6bf670667b9eeec7 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'pads : vec2<i32>, inDims : vec2<i32>, virtualWidth : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.workPerThread = 4;
        this.outputComponent = 4;
        this.outputShape = convInfo.outShape;
        this.virtualWidth = Math.ceil(this.outputShape[2] / this.workPerThread) * this.workPerThread;
        const virtualOutputShape = [
            this.outputShape[0],
            this.outputShape[1],
            this.virtualWidth,
            this.outputShape[3]
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(virtualOutputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, virtualOutputShape, this.workgroupSize, [
            this.outputComponent * this.workPerThread,
            1,
            1
        ]);
        (0, $0775da5e684c8c0d$exports).assert(convInfo.dataFormat === 'channelsLast', ()=>'TODO: NCHW is unimplemented');
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        this.convInfo = convInfo;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivation = hasPreluActivation;
        this.shaderKey = `depthwiseVec4_${activation}_${this.convInfo.filterHeight}_${this.convInfo.filterWidth}_${this.convInfo.strideHeight}_${this.convInfo.strideWidth}_${this.workPerThread}`;
    }
    getUserCode() {
        const xNumber = (this.workPerThread - 1) * this.convInfo.strideWidth + this.convInfo.filterWidth;
        const strideHeight = this.convInfo.strideHeight;
        const strideWidth = this.convInfo.strideWidth;
        const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivation, true, 4)}
      fn readX(batch : i32, row : i32, col : i32, channel : i32) -> vec4<f32> {
        var value = vec4<f32>(0.0);
        if (col >=0 && col < uniforms.inDims[1]) {
          value = getX(batch, row, col, channel);
        }
        return value;
      }

      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        let width0 = uniforms.outShape[3] / ${this.outputComponent};
        let d1 = (index % width0) * ${this.outputComponent};
        var index1 = index / width0;
        let width1 = uniforms.virtualWidth / ${this.workPerThread};
        let c = (index1 % width1) * ${this.workPerThread};
        index1 = index1 / width1;
        let r = index1 % uniforms.outShape[1];
        let batch = index1 / uniforms.outShape[1];

        let xRCCorner = vec2<i32>(r, c) * vec2<i32>(${strideHeight}, ${strideWidth}) - uniforms.pads;

        let xRCorner = xRCCorner.x;
        let xCCorner = xRCCorner.y;
        var xVals : array<vec4<f32>, ${xNumber}>;
        var dotProd : array<vec4<f32>, ${this.workPerThread}>;
        for (var i = 0; i < ${this.workPerThread}; i++) {
          dotProd[i] = vec4<f32>(0.0);
        }

        // Use constant instead of uniform can give better performance.
        for (var wR = 0; wR < ${this.convInfo.filterHeight}; wR = wR + 1) {
          let xR = xRCorner + wR;
          if (xR >=0 && xR < uniforms.inDims[0]) {
            for (var i = 0; i < ${xNumber}; i++) {
              xVals[i] = readX(batch, xR, xCCorner + i, d1);
            }
            for (var wC = 0; wC < ${this.convInfo.filterWidth}; wC = wC + 1) {
              let wValue = getW(wR, wC, d1, 0);
              for (var i = 0; i < ${this.workPerThread}; i++) {
                dotProd[i] = fma(xVals[i * ${strideWidth} + wC], wValue, dotProd[i]);
              }
            }
          }
        }

        for (var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let coords = vec4<i32>(batch, r, c + i, d1);
          if (coordsInBounds4D(coords, uniforms.outShape)) {
            var value = dotProd[i];
            ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(this.addBias, this.activation)}
            setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
          }
        }
      }
    `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $e04406b56fbb85c7$export$4ead5a4ba22ede40 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = `pads : vec2<i32>, inDims : vec2<i32>, filterHeight : i32,
      filterWidth : i32, strides : vec2<i32>, dilations : vec2<i32>,`;
        // This is an experimental value.
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        this.convInfo = convInfo;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivation = hasPreluActivation;
        this.shaderKey = `depthwise_${this.activation}_${this.isChannelsLast}`;
    }
    getUserCode() {
        const getXSnippet = this.isChannelsLast ? 'getX(batch, xR, xC, d1);' : 'getX(batch, d1, xR, xC);';
        const userCode = `
      ${(0, $b3e75cba2f4dc261$export$f79ce230bc90dd9f)(this.activation, this.hasPreluActivation, false, 4)}

      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let batch = coords[0];
          let xRCCorner = vec2<i32>(coords.${this.isChannelsLast ? 'yz' : 'zw'}) * uniforms.strides - uniforms.pads;
          let d2 = coords[${this.isChannelsLast ? 3 : 1}];
          let channelMul = uniforms.wShape[3];
          let d1 = d2 / channelMul;
          let q = d2 % channelMul;

          let inputRowStart = xRCCorner.x;
          let inputColStart = xRCCorner.y;
          let inputRowEnd = inputRowStart + uniforms.filterHeight *
              uniforms.dilations[0];
          let inputColEnd = inputColStart + uniforms.filterWidth *
              uniforms.dilations[1];

          // Convolve x(?, ?, d1)|x(d1, ?, ?) with w(:, :, d1, q) to get
          // y(yR, yC, d2)|y(d2, yR, yC). ? = to be determined. : = across all
          // values in that axis. x(?, ?, d1) and y(yR, yC, d2) is for NHWC.
          // x(d1, ?, ?) and y(d2, yR, yC) is for NCHW.
          var value = 0.0;

          // Extract if checking out of for loop for performance.
          if (inputRowStart >= 0 && inputColStart >= 0 &&
            inputRowEnd < uniforms.inDims[0] &&
                inputColEnd < uniforms.inDims[1]) {
              for (var wR = 0; wR < uniforms.filterHeight; wR = wR + 1) {
                let xR = inputRowStart + wR * uniforms.dilations[0];

                for (var wC = 0; wC < uniforms.filterWidth; wC = wC + 1) {
                  let xC = inputColStart + wC * uniforms.dilations[1];

                  let xVal = ${getXSnippet};
                  let wVal = getW(wR, wC, d1, q);
                  value = value + xVal * wVal;
                }
              }
            } else {
              for (var wR = 0; wR < uniforms.filterHeight; wR = wR + 1) {
                let xR = inputRowStart + wR * uniforms.dilations[0];

                if (xR < 0 || xR >= uniforms.inDims[0]) {
                  continue;
                }

                for (var wC = 0; wC < uniforms.filterWidth; wC = wC + 1) {
                  let xC = inputColStart + wC * uniforms.dilations[1];

                  if (xC < 0 || xC >= uniforms.inDims[1]) {
                    continue;
                  }

                  let xVal = ${getXSnippet};
                  let wVal = getW(wR, wC, d1, q);
                  value = value + xVal * wVal;
                }
              }
            }
            ${(0, $b3e75cba2f4dc261$export$9766e8742a87dc55)(this.addBias, this.activation)}
          setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
        }
      }
    `;
        return userCode;
    }
}


function $a0161762b26e00a8$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true, $dataFormat);
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        }
    ];
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    let program;
    if (!isChannelsLast && convInfo.inHeight > 16 && convInfo.inWidth > 16 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && convInfo.dilationWidth === 1 && convInfo.dilationHeight === 1 && convInfo.inChannels === convInfo.outChannels) program = new (0, $b13fa0c289e05bec$export$c20669e15027e214)(convInfo.outShape, convInfo.filterHeight, convInfo.filterWidth);
    else if (isChannelsLast && convInfo.outHeight > 4 && convInfo.outWidth > 4 && convInfo.strideWidth <= 2 && convInfo.inChannels === convInfo.outChannels && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.inChannels % 4 === 0) {
        program = new (0, $84cea51a019dd6b6$export$6bf670667b9eeec7)(convInfo);
        dimensions.push({
            type: 'int32',
            data: [
                program.virtualWidth
            ]
        });
    } else {
        program = new (0, $e04406b56fbb85c7$export$4ead5a4ba22ede40)(convInfo);
        dimensions.push({
            type: 'int32',
            data: [
                convInfo.filterHeight
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.filterWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        });
    }
    return backend.runWebGPUProgram(program, [
        x,
        filter
    ], x.dtype, dimensions);
}
const $a0161762b26e00a8$export$240667804b7c390e = {
    kernelName: (0, $507890e4aa8e1463$export$7c0fc590ff9e156f),
    backendName: 'webgpu',
    kernelFunc: $a0161762b26e00a8$export$14e793fe8822afd1
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $0f7bbd579045b0a9$export$9f5b7866589daeae {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, filterDims : vec2<i32>, outHeight : i32,
      outWidth : i32, inHeight : i32, inWidth : i32, batchSize : i32, channelMul : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `depthwise_conv2d_backprop_filter`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let wR = coords[0];
        let wC = coords[1];
        let d1 = coords[2];
        let dm = coords[3];
        let d2 = d1 * uniforms.channelMul + dm;

        var dotProd = 0.0;
        for (var b = 0; b < uniforms.batchSize; b++) {
          for (var yR = 0; yR < uniforms.outHeight; yR++) {
            let xR = wR + yR * uniforms.strides[0] - uniforms.pads[0];

            if (xR < 0 || xR >= uniforms.inHeight) {
              continue;
            }

            for (var yC = 0; yC < uniforms.outWidth; yC++) {
              let xC = wC + yC * uniforms.strides[1] - uniforms.pads[1];

              if (xC < 0 || xC >= uniforms.inWidth) {
                continue;
              }

              let dyValue = getDy(b, yR, yC, d2);
              let xValue = getX(b, xR, xC, d1);
              dotProd += xValue * dyValue;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}
class $0f7bbd579045b0a9$export$9b7e054f73b1374b {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, filterDims : vec2<i32>,
       outHeight : i32, outWidth : i32, channelMul : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `depthwise_conv2d_backprop_input`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d1 = coords[3];
        let dyCorner = coords.yz - uniforms.pads;
        let dyRCorner = dyCorner.x;
        let dyCCorner = dyCorner.y;

        var dotProd = 0.0;
        for (var wR = 0; wR < uniforms.filterDims[0]; wR++) {
          let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[0]);

          if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
            continue;
          }

          let idyR = i32(dyR);
          let wRPerm = uniforms.filterDims[0] - 1 - wR;

          for (var wC = 0; wC < uniforms.filterDims[1]; wC++) {
            let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[1]);

            if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
              continue;
            }

            let idyC = i32(dyC);
            let wCPerm = uniforms.filterDims[1] - 1 - wC;

            for (var dm = 0; dm < uniforms.channelMul; dm++) {
              let d2 = d1 * uniforms.channelMul + dm;
              let xValue = getDy(batch, idyR, idyC, d2);
              let wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}


function $4ace6e29dd7d9dd0$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $0f7bbd579045b0a9$export$9f5b7866589daeae)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outChannels / convInfo.inChannels
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x,
        dy
    ], 'float32', uniformData);
}
const $4ace6e29dd7d9dd0$export$30bc0ac3775583fc = {
    kernelName: (0, $507890e4aa8e1463$export$c99f139e0d4d1833),
    backendName: 'webgpu',
    kernelFunc: $4ace6e29dd7d9dd0$export$cc0ae65e9edc7e1a
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $395321f3e3a4ddd0$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $0f7bbd579045b0a9$export$9b7e054f73b1374b)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight - 1 - convInfo.padInfo.top,
                convInfo.filterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outChannels / convInfo.inChannels
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy,
        filter
    ], dy.dtype, uniformData);
}
const $395321f3e3a4ddd0$export$55d12409e744bebe = {
    kernelName: (0, $507890e4aa8e1463$export$8649ca3b17033a24),
    backendName: 'webgpu',
    kernelFunc: $395321f3e3a4ddd0$export$37e2ab95a4a4c24b
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d4cb01178b86341c$export$d3d3824ae4245092 {
    constructor(size){
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            size,
            size
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'diag';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let value = select(0.0, getX(coords[0]), coords[0] == coords[1]);
          setOutputAtIndex(index, value);
        }
      }
    `;
        return userCode;
    }
}



function $c7dcbf918ad0c0a0$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const flat = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                xSize
            ]
        }
    });
    const program = new (0, $d4cb01178b86341c$export$d3d3824ae4245092)(xSize);
    const res = backend.runWebGPUProgram(program, [
        flat
    ], flat.dtype);
    const out = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeData(flat.dataId);
    backend.disposeData(res.dataId);
    return out;
}
const $c7dcbf918ad0c0a0$export$56dc5d812a22748f = {
    kernelName: (0, $507890e4aa8e1463$export$ca73a25315ddeb7f),
    backendName: 'webgpu',
    kernelFunc: $c7dcbf918ad0c0a0$export$c042e7c2f59bc046
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $cd7070730508aa64$export$b3acfd0493b4c03e {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'w'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'dilation2d';
    }
    getUserCode() {
        const userCode = `
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         if (index < uniforms.size) {
           let neg_infinity = -3.4e38;
           let coords = getOutputCoords();
           let batch = coords.x;
           let d1 = coords.w;
           let outTopLeftCorner = coords.yz * uniforms.strides - uniforms.pads;
           let hBeg = outTopLeftCorner.x;
           let wBeg = outTopLeftCorner.y;

           var curVal = neg_infinity;
           for (var h = 0; h < uniforms.filterDims[0]; h = h + 1) {
             let hIn = hBeg + h * uniforms.dilations[0];

             if (hIn >= 0 && hIn < uniforms.xShape[1]) {
               for (var w = 0; w < uniforms.filterDims[1]; w = w + 1) {
                 let wIn = wBeg + w * uniforms.dilations[1];

                 if (wIn >= 0 && wIn < uniforms.xShape[2]) {
                   let val = getX(batch, hIn, wIn, d1) + getW(h, w, d1);
                   if (val > curVal) {
                     curVal = val;
                   }
                 }
               }
             }
           }

           setOutputAtIndex(index, curVal);
         }
       }
     `;
        return userCode;
    }
}


function $e21cc877880208e1$export$544ec6096a7ab30(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    const padInfo = [
        convInfo.padInfo.top,
        convInfo.padInfo.left
    ];
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                ...padInfo
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }
    ];
    const program = new (0, $cd7070730508aa64$export$b3acfd0493b4c03e)(convInfo);
    const out = backend.runWebGPUProgram(program, [
        x,
        filter
    ], x.dtype, uniformData);
    return out;
}
const $e21cc877880208e1$export$36d3c11f61a8891a = {
    kernelName: (0, $507890e4aa8e1463$export$dbbb7830c6497701),
    backendName: 'webgpu',
    kernelFunc: $e21cc877880208e1$export$544ec6096a7ab30
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $d9cac6af33a0557a$export$590f943d037e2e09 {
    constructor(convInfo, outputDtype){
        this.variableNames = [
            'x',
            'w',
            'dy'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>, dySize: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(convInfo.outShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, convInfo.outShape, this.workgroupSize);
        if (outputDtype !== 'float32' && outputDtype !== 'int32') throw new Error(`Dilation2DBackpropInput only supports float32 and int32
          types, does not support ${outputDtype} type.`);
        this.type = outputDtype;
        this.shaderKey = 'dilation2DBackpropInput';
    }
    getUserCode() {
        // This implementation follows the TF c++ cuda implementation:
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/dilation_ops_gpu.cu.cc
        const userCode = `
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         if (index < uniforms.dySize) {
           let coords = getDyCoordsFromIndex(index);
           let b = coords[0];
           let r = coords[1];
           let c = coords[2];
           let d = coords[3];

           let dyCorner = vec2<i32>(r, c) * uniforms.strides - uniforms.pads;
           var curVal = -3.4e38;  // neg_infinity
           var xRMax = 0;
           var xCMax = 0;

           // In the case of multiple argmax branches, we only back-propagate
           // along the last branch, i.e., the one with largest value of
           // 'wR * uniforms.filterDims[1] + wC', similarly to the max-pooling
           // backward routines.
           for (var wR = 0; wR < uniforms.filterDims[0]; wR++) {
             let xR = dyCorner.x + wR * uniforms.dilations[0];

             if (xR >= 0 && xR < uniforms.xShape[1]) {
               for (var wC = 0; wC < uniforms.filterDims[1]; wC++) {
                 let xC = dyCorner.y + wC * uniforms.dilations[1];

                 if (xC >= 0 && xC < uniforms.xShape[2]) {
                   let val = getX(b, xR, xC, d) + getW(wR, wC, d);
                   if (val > curVal) {
                     curVal = val;
                     xRMax = xR;
                     xCMax = xC;
                   }
                 }
               }
             }
           }

           let flatIndexIn = d + uniforms.xShape[3] *
               (xCMax + uniforms.xShape[2] * (xRMax + uniforms.xShape[1] * b));
           let value = getDy(b, r, c, d);
           ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[flatIndexIn]', 'value', this.type)}
         }
       }
     `;
        return userCode;
    }
}
class $d9cac6af33a0557a$export$b593d838ca648ee3 {
    constructor(convInfo, shape, outputDtype){
        this.variableNames = [
            'x',
            'w',
            'dy'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>, dySize: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(convInfo.outShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, convInfo.outShape, this.workgroupSize);
        if (outputDtype !== 'float32' && outputDtype !== 'int32') throw new Error(`Dilation2DBackpropFilter only supports float32 and int32
          types, does not support ${outputDtype} type.`);
        this.type = outputDtype;
        this.shaderKey = 'dilation2DBackpropFilter';
    }
    getUserCode() {
        // This implementation follows the TF c++ cuda implementation:
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/dilation_ops_gpu.cu.cc
        const userCode = `
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         if (index < uniforms.dySize) {
           let coords = getDyCoordsFromIndex(index);
           let b = coords[0];
           let r = coords[1];
           let c = coords[2];
           let d = coords[3];

           let dyCorner = vec2<i32>(r, c) * uniforms.strides - uniforms.pads;
           var curVal = -3.4e38;  // neg_infinity
           var wRMax = 0;
           var wCMax = 0;

           // In the case of multiple argmax branches, we only back-propagate
           // along the last branch, i.e., the one with largest value of
           // 'wR * uniforms.filterDims[1] + wC', similarly to the max-pooling
           // backward routines.
           for (var wR = 0; wR < uniforms.filterDims[0]; wR++) {
             let xR = dyCorner.x + wR * uniforms.dilations[0];

             if (xR >= 0 && xR < uniforms.xShape[1]) {
               for (var wC = 0; wC < uniforms.filterDims[1]; wC++) {
                 let xC = dyCorner.y + wC * uniforms.dilations[1];

                 if (xC >= 0 && xC < uniforms.xShape[2]) {
                   let val = getX(b, xR, xC, d) + getW(wR, wC, d);
                   if (val > curVal) {
                     curVal = val;
                     wRMax = wR;
                     wCMax = wC;
                   }
                 }
               }
             }
           }

           let flatIndexIn = d + uniforms.wShape[2] * (wCMax + wRMax * uniforms.wShape[1]);
           let value = getDy(b, r, c, d);
           ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[flatIndexIn]', 'value', this.type)}
         }
       }
     `;
        return userCode;
    }
}



function $dd92049c124e10b3$export$5ccd66c3b92fb998(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, dy: dy } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    const dtype = filter.dtype;
    const program = new (0, $d9cac6af33a0557a$export$b593d838ca648ee3)(convInfo, filter.shape, dtype);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                (0, $0775da5e684c8c0d$exports).sizeFromShape(convInfo.outShape)
            ]
        }
    ];
    const output = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: filter.shape,
            value: 0,
            dtype: dtype
        }
    });
    return backend.runWebGPUProgram(program, [
        x,
        filter,
        dy
    ], dtype, uniformData, output);
}
const $dd92049c124e10b3$export$cf83abe0e8c87ce8 = {
    kernelName: (0, $507890e4aa8e1463$export$91add972be69d592),
    backendName: 'webgpu',
    kernelFunc: $dd92049c124e10b3$export$5ccd66c3b92fb998
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $fb39d7cac5895593$export$7fbe49a07e48139e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, dy: dy } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    const dtype = x.dtype;
    const program = new (0, $d9cac6af33a0557a$export$590f943d037e2e09)(convInfo, dtype);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                (0, $0775da5e684c8c0d$exports).sizeFromShape(convInfo.outShape)
            ]
        }
    ];
    const output = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: convInfo.inShape,
            value: 0,
            dtype: dtype
        }
    });
    return backend.runWebGPUProgram(program, [
        x,
        filter,
        dy
    ], dtype, uniformData, output);
}
const $fb39d7cac5895593$export$42e4451417dc5ea0 = {
    kernelName: (0, $507890e4aa8e1463$export$5dd675a6b0f37e17),
    backendName: 'webgpu',
    kernelFunc: $fb39d7cac5895593$export$7fbe49a07e48139e
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use backend file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $6aa93bac1ab05868$export$85a6e8018f8156c {
    constructor(outShape, type, textureFormat){
        this.variableNames = [
            'Image'
        ];
        this.uniforms = 'alpha: f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.pixelsOpType = (0, $0533631f1fe2cae9$export$62104db1eb296622).DRAW;
        this.size = true;
        this.outputShape = outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.type = type;
        this.textureFormat = textureFormat;
        this.shaderKey = `draw_${type}_${textureFormat}`;
    }
    getUserCode() {
        let calculateResult;
        const value = this.type === 'float32' ? 'value' : 'value / 255.0';
        calculateResult = `
      if (uniforms.numChannels == 1) {
        rgba[0] = ${value};
        rgba[1] = ${value};
        rgba[2] = ${value};
      } else {
        rgba[d] = ${value};
      }`;
        const userCode = `
       @group(0) @binding(0) var outImage : texture_storage_2d<${this.textureFormat}, write>;
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         if (index < uniforms.size) {
           var rgba = vec4<f32>(0.0, 0.0, 0.0, uniforms.alpha);
           for (var d = 0; d < uniforms.numChannels; d = d + 1) {
             let value = f32(inBuf[index * uniforms.numChannels + d]);
             ${calculateResult}
           }
           rgba.x = rgba.x * rgba.w;
           rgba.y = rgba.y * rgba.w;
           rgba.z = rgba.z * rgba.w;
           let coords = getCoordsFromIndex(index);
           textureStore(outImage, vec2<i32>(coords.yx), rgba);
         }
       }
      `;
        return userCode;
    }
}


function $7cf29044158b365d$export$e529deb2bfd496dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image } = inputs;
    const { canvas: canvas, options: options } = attrs;
    const [height, width] = image.shape.slice(0, 2);
    const { imageOptions: imageOptions } = options || {};
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    //  'rgba8unorm' should work on macOS according to
    //  https://bugs.chromium.org/p/chromium/issues/detail?id=1298618. But
    //  failed on macOS/M2. So use 'bgra8unorm' first when available.
    const format = backend.device.features.has('bgra8unorm-storage') ? 'bgra8unorm' : 'rgba8unorm';
    const outShape = [
        height,
        width
    ];
    const program = new (0, $6aa93bac1ab05868$export$85a6e8018f8156c)(outShape, image.dtype, format);
    canvas.width = width;
    canvas.height = height;
    const backendName = 'webgpu';
    let gpuContext = canvas.getContext(backendName);
    let canvasWebGPU;
    if (!gpuContext) {
        canvasWebGPU = new OffscreenCanvas(width, height);
        gpuContext = canvasWebGPU.getContext(backendName);
    }
    const numChannels = image.shape.length === 3 ? image.shape[2] : 1;
    gpuContext.configure({
        device: backend.device,
        format: format,
        usage: GPUTextureUsage.STORAGE_BINDING,
        alphaMode: 'premultiplied'
    });
    const outputDtype = 'int32';
    const output = backend.makeTensorInfo(outShape, outputDtype);
    const info = backend.tensorMap.get(output.dataId);
    info.resource = gpuContext.getCurrentTexture();
    info.external = true;
    const uniformData = [
        {
            type: 'uint32',
            data: [
                numChannels
            ]
        },
        {
            type: 'float32',
            data: [
                alpha
            ]
        }
    ];
    backend.runWebGPUProgram(program, [
        image
    ], outputDtype, uniformData, output);
    if (canvasWebGPU) {
        const canvas2dContext = canvas.getContext('2d');
        if (!canvas2dContext) throw new Error(`Please make sure this canvas has only been used for 2d or webgpu context!`);
        canvas2dContext.drawImage(canvasWebGPU, 0, 0);
    }
    backend.disposeData(output.dataId);
    return image;
}
const $7cf29044158b365d$export$917213cafa72964b = {
    kernelName: (0, $507890e4aa8e1463$export$dca20402ebea5ece),
    backendName: 'webgpu',
    kernelFunc: $7cf29044158b365d$export$e529deb2bfd496dc
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $24358616068660dd$export$813063b94243a885 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).MUL,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$598d1d66b05a298f),
    supportsComplex: true
});
const $24358616068660dd$export$745576778aafee88 = {
    kernelName: (0, $507890e4aa8e1463$export$f14f83b3b531d498),
    backendName: 'webgpu',
    kernelFunc: $24358616068660dd$export$813063b94243a885
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $5b2ff23a08187cd4$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, axis, keepDims, 'sum', backend);
}
const $5b2ff23a08187cd4$export$47edea402251c258 = {
    kernelName: (0, $507890e4aa8e1463$export$534760f50726d5),
    backendName: 'webgpu',
    kernelFunc: $5b2ff23a08187cd4$export$8a63f25cc62965f1
};



function $0c3190a8b76ce612$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $f35e0c1a651337db$exports).decodeEinsumEquation(equation, tensors.length);
    (0, $f35e0c1a651337db$exports).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $f35e0c1a651337db$exports).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $f35e0c1a651337db$exports).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $f35e0c1a651337db$exports).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $0775da5e684c8c0d$exports).arraysEqual(x.shape, targetShape)) {
                x = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $24358616068660dd$export$813063b94243a885)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $5b2ff23a08187cd4$export$8a63f25cc62965f1)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeData(tensorInfo.dataId);
    }
    return out;
}
const $0c3190a8b76ce612$export$40bbf341885a23b7 = {
    kernelName: (0, $507890e4aa8e1463$export$2541d8be32f3c641),
    backendName: 'webgpu',
    kernelFunc: $0c3190a8b76ce612$export$27265e7daac5c403
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $995ef7a5aa8aa095$export$796b583dd79d8524 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ELU
});
const $995ef7a5aa8aa095$export$b990686634ee3cce = {
    kernelName: (0, $507890e4aa8e1463$export$64636e173424d83d),
    backendName: 'webgpu',
    kernelFunc: $995ef7a5aa8aa095$export$796b583dd79d8524
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $ce6d45596ea87001$export$a346244024505ff9 = (args)=>{
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    const program = new (0, $a015d0a4804ef6be$export$9045e9161086790b)((0, $41dab11c37c6072e$export$e5d009af261ea0bd).ELU_DER, dy.shape, y.shape);
    return backend.runWebGPUProgram(program, [
        dy,
        y
    ], dy.dtype);
};
const $ce6d45596ea87001$export$59bb07dd04647a1d = {
    kernelName: (0, $507890e4aa8e1463$export$9906be4699a73c53),
    backendName: 'webgpu',
    kernelFunc: $ce6d45596ea87001$export$a346244024505ff9
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $45522c2607904f92$export$411ce8e5a71e3069 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$13d1298222b29d06)
});
const $45522c2607904f92$export$3c8bc3d8ee318217 = {
    kernelName: (0, $507890e4aa8e1463$export$8dcf9f58ce5cdfc),
    backendName: 'webgpu',
    kernelFunc: $45522c2607904f92$export$411ce8e5a71e3069
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $8fa24252b18dca8c$export$d3896f355fc09423 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ERF
});
const $8fa24252b18dca8c$export$d044ffef16079bd = {
    kernelName: (0, $507890e4aa8e1463$export$c2ee2551ce71f1d0),
    backendName: 'webgpu',
    kernelFunc: $8fa24252b18dca8c$export$d3896f355fc09423
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $b64311930618399e$export$b310ec824aaee37f = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).EXP,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$f72e179c9610cb8c),
    dtype: 'float32'
});
const $b64311930618399e$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $507890e4aa8e1463$export$f908be7a96fb3363),
    backendName: 'webgpu',
    kernelFunc: $b64311930618399e$export$b310ec824aaee37f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $26998513a525e7c2$export$d660d8ed21f46635(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { dim: dim } = attrs;
    const { input: input } = inputs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $0775da5e684c8c0d$exports).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $26998513a525e7c2$export$86341ba0ce5d8e60 = {
    kernelName: (0, $507890e4aa8e1463$export$2391750b1d901146),
    backendName: 'webgpu',
    kernelFunc: $26998513a525e7c2$export$d660d8ed21f46635
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $80e0463d1c862033$export$b6c0a80d46d3391d = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).EXPM1,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$5903785c29f035f5)
});
const $80e0463d1c862033$export$16db8a08b36f938 = {
    kernelName: (0, $507890e4aa8e1463$export$261f26143a1ff3),
    backendName: 'webgpu',
    kernelFunc: $80e0463d1c862033$export$b6c0a80d46d3391d
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $3df04712f0382095$export$234ba885e3a114f6 {
    constructor(component, shape){
        this.variableNames = [
            'real',
            'imag'
        ];
        this.outputShape = [];
        this.uniforms = 'exponentMultiplier : f32, denominator: f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.component = component;
        this.shaderKey = `fft_${component}`;
    }
    getUserCode() {
        const opString = this.component === 'real' ? 'return real * expR - imag * expI;' : 'return real * expI + imag * expR;';
        const userCode = `
    fn unaryOpComplex(real: f32, expR: f32, imag: f32, expI: f32) -> f32 {
      ${opString}
    }

    fn mulMatDFT(batch: i32, index: i32) -> f32 {
      let indexRatio = f32(index) / f32(uniforms.realShape[1]);
      let exponentMultiplierTimesIndexRatio =
          uniforms.exponentMultiplier * indexRatio;

      var result = 0.0;

      for (var i = 0; i < uniforms.realShape[1]; i = i + 1) {
        // x = (-2|2 * PI / N) * index * i;
        let x = exponentMultiplierTimesIndexRatio * f32(i);
        let expR = cos(x);
        let expI = sin(x);
        let real = getReal(batch, i);
        let imag = getImag(batch, i);

        result = result +
            unaryOpComplex(real, expR, imag, expI) / uniforms.denominator;
      }

      return result;
    }

    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        setOutputAtIndex(index, mulMatDFT(coords[0], coords[1]));
      }
    }
  `;
        return userCode;
    }
}




function $f6df8fdd2f2477ad$export$75d3742a7578721e(x, inverse, backend) {
    const xData = backend.tensorMap.get(x.dataId);
    const inputSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = x.shape[x.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const toDispose = [];
    const input2D = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    toDispose.push(input2D);
    const xShape = input2D.shape;
    const realProgram = new (0, $3df04712f0382095$export$234ba885e3a114f6)('real', xShape);
    const imagProgram = new (0, $3df04712f0382095$export$234ba885e3a114f6)('imag', xShape);
    const inputs = [
        {
            dataId: xData.complexTensorInfos.real.dataId,
            dtype: xData.complexTensorInfos.real.dtype,
            shape: xShape
        },
        {
            dataId: xData.complexTensorInfos.imag.dataId,
            dtype: xData.complexTensorInfos.imag.dtype,
            shape: xShape
        }
    ];
    const exponentMultiplier = inverse ? 2.0 * Math.PI : -2 * Math.PI;
    const denominator = inverse ? xShape[1] : 1.0;
    const uniformData = [
        {
            type: 'float32',
            data: [
                exponentMultiplier
            ]
        },
        {
            type: 'float32',
            data: [
                denominator
            ]
        }
    ];
    const realPart = backend.runWebGPUProgram(realProgram, inputs, 'float32', uniformData);
    toDispose.push(realPart);
    const imagPart = backend.runWebGPUProgram(imagProgram, inputs, 'float32', uniformData);
    toDispose.push(imagPart);
    const complexOutput = (0, $94b917209ffdee98$export$83a0e34f1302825b)({
        inputs: {
            real: realPart,
            imag: imagPart
        },
        backend: backend
    });
    toDispose.push(complexOutput);
    const complexOutputReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: complexOutput
        },
        backend: backend,
        attrs: {
            shape: x.shape
        }
    });
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return complexOutputReshaped;
}


function $0fc3d0c8c28fe0b5$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $f6df8fdd2f2477ad$export$75d3742a7578721e)(input, false, backend);
}
const $0fc3d0c8c28fe0b5$export$a4d564e380763c78 = {
    kernelName: (0, $507890e4aa8e1463$export$677347237c014ba),
    backendName: 'webgpu',
    kernelFunc: $0fc3d0c8c28fe0b5$export$a535ef183b6128fa
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d5e8418cbe31460e$export$872622c1de722f28 {
    constructor(imageShape){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = imageShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'flipLeftRight';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let coordX = uniforms.xShape[2] - coords[2] - 1;
          let outputValue = getX(coords[0], coords[1], coordX, coords[3]);
          setOutputAtIndex(index, outputValue);
        }
      }
    `;
        return userCode;
    }
}


const $dbda0389733c0764$export$c9ec83cb23304466 = {
    kernelName: (0, $507890e4aa8e1463$export$34e7296fc8558df5),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { image: image } = inputs;
        const webgpuBackend = backend;
        const program = new (0, $d5e8418cbe31460e$export$872622c1de722f28)(image.shape);
        const output = webgpuBackend.runWebGPUProgram(program, [
            image
        ], image.dtype);
        return output;
    }
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $1e5b3ac86a30009d$export$a3fe094919f356fd = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).FLOOR,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$195a28e6add8ab7e)
});
const $1e5b3ac86a30009d$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $507890e4aa8e1463$export$4880b0ae5643c62b),
    backendName: 'webgpu',
    kernelFunc: $1e5b3ac86a30009d$export$a3fe094919f356fd
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $f371bd44afc40e31$export$112397bc52715a8 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).FLOOR_DIV,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$afb5f31ac42ca629),
    dtype: 'int32'
});
const $f371bd44afc40e31$export$7eac933a0c7fd37f = {
    kernelName: (0, $507890e4aa8e1463$export$d79b5692ede26c2f),
    backendName: 'webgpu',
    kernelFunc: $f371bd44afc40e31$export$112397bc52715a8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use backend file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $e9e7b760b2ad7745$export$7ffba7be7a218615 {
    constructor(outputShape, numChannels, importVideo = false){
        this.pixelsOpType = (0, $0533631f1fe2cae9$export$62104db1eb296622).FROM_PIXELS;
        this.outputShape = [
            0
        ];
        this.variableNames = [];
        this.workgroupSize = [
            256,
            1,
            1
        ]; // The empirical value.
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            numChannels,
            1,
            1
        ]);
        this.importVideo = importVideo;
        this.shaderKey = `fromPixels_${this.importVideo}`;
    }
    getUserCode() {
        const textureLoad = this.importVideo ? 'textureLoad(src, vec2<i32>(coords.yx));' : 'textureLoad(src, vec2<i32>(coords.yx), 0)';
        const textureType = this.importVideo ? 'texture_external' : 'texture_2d<f32>';
        return `
      @binding(1) @group(0) var src: ${textureType};
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        let flatIndex = index * uniforms.numChannels;
        if (flatIndex < uniforms.size) {
          let coords = getCoordsFromIndex(flatIndex);
          let values = ${textureLoad};
          for (var i = 0; i < uniforms.numChannels; i = i + 1) {
            result[flatIndex + i] = i32(floor(255.0 * values[i]));
          }
        }
      }
  `;
    }
}


const $4843c5d9e48cd72f$export$b22e14d614fc7178 = {
    kernelName: (0, $507890e4aa8e1463$export$d0eb4e7054966c48),
    backendName: 'webgpu',
    kernelFunc: $4843c5d9e48cd72f$export$5a3bc84b10e77d32
};
let $4843c5d9e48cd72f$var$fromPixels2DContext;
let $4843c5d9e48cd72f$var$willReadFrequently = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
function $4843c5d9e48cd72f$export$5a3bc84b10e77d32(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    let { pixels: pixels } = inputs;
    const { numChannels: numChannels } = attrs;
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    const isVideo = typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement;
    const isImage = typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement;
    const isCanvas = typeof HTMLCanvasElement !== 'undefined' && pixels instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && pixels instanceof OffscreenCanvas;
    const isImageBitmap = typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap;
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    const outputShape = [
        height,
        width,
        numChannels
    ];
    const importVideo = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGPU_IMPORT_EXTERNAL_TEXTURE') && isVideo;
    const isVideoOrImage = isVideo || isImage;
    if (isImageBitmap || isCanvas || isVideoOrImage) {
        let resource;
        if (importVideo) resource = backend.device.importExternalTexture({
            source: pixels
        });
        else {
            if (isVideoOrImage) {
                const newWillReadFrequently = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
                if ($4843c5d9e48cd72f$var$fromPixels2DContext == null || newWillReadFrequently !== $4843c5d9e48cd72f$var$willReadFrequently) {
                    $4843c5d9e48cd72f$var$willReadFrequently = newWillReadFrequently;
                    $4843c5d9e48cd72f$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                        willReadFrequently: $4843c5d9e48cd72f$var$willReadFrequently
                    });
                }
                $4843c5d9e48cd72f$var$fromPixels2DContext.canvas.width = width;
                $4843c5d9e48cd72f$var$fromPixels2DContext.canvas.height = height;
                $4843c5d9e48cd72f$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
                pixels = $4843c5d9e48cd72f$var$fromPixels2DContext.canvas;
            }
            const usage = GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING;
            const format = 'rgba8unorm';
            const texture = backend.textureManager.acquireTexture(outputShape[1], outputShape[0], format, usage);
            backend.queue.copyExternalImageToTexture({
                source: pixels
            }, {
                texture: texture
            }, [
                outputShape[1],
                outputShape[0]
            ]);
            resource = texture;
        }
        const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(outputShape);
        const strides = (0, $0775da5e684c8c0d$exports).computeStrides(outputShape);
        const program = new (0, $e9e7b760b2ad7745$export$7ffba7be7a218615)(outputShape, numChannels, importVideo);
        const uniformData = [
            {
                type: 'uint32',
                data: [
                    size
                ]
            },
            {
                type: 'uint32',
                data: [
                    numChannels
                ]
            },
            {
                type: 'uint32',
                data: [
                    ...strides
                ]
            }
        ];
        const input = backend.makeTensorInfo([
            height,
            width
        ], 'int32');
        const info = backend.tensorMap.get(input.dataId);
        info.resource = resource;
        const result = backend.runWebGPUProgram(program, [
            input
        ], 'int32', uniformData);
        backend.disposeData(input.dataId);
        return result;
    }
    // TODO: Encoding should happen on GPU once we no longer have to download
    // image data to the CPU.
    const imageData = pixels.data;
    let pixelArray = imageData;
    if (numChannels != null && numChannels !== 4) {
        pixelArray = new Uint8Array(pixels.width * pixels.height * numChannels);
        const dataLength = imageData.length;
        let j = 0;
        for(let i = 0; i < dataLength; i++)if (i % 4 < numChannels) pixelArray[j++] = imageData[i];
    }
    const output = backend.makeTensorInfo(outputShape, 'int32', new Int32Array(pixelArray));
    backend.uploadToGPU(output.dataId);
    return output;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $4b73319f51bfbf20$export$bd15a4172044baef {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape){
        this.uniforms = 'varianceEpsilon : f32,';
        // This is an experimental value.
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, varianceShape);
        this.outputShape = xShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        if (offsetShape != null) {
            (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
        }
        if (scaleShape != null) {
            (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
        }
        this.offsetShape = offsetShape;
        this.scaleShape = scaleShape;
        this.shaderKey = 'batchNorm';
    }
    getUserCode() {
        let offsetSnippet = '0.0';
        if (this.offsetShape != null) offsetSnippet = 'getOffsetByOutputIndex(index)';
        let scaleSnippet = '1.0';
        if (this.scaleShape != null) scaleSnippet = 'getScaleByOutputIndex(index)';
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size)
        {
          let xValue = getXByOutputIndex(index);
          let meanValue = getMeanByOutputIndex(index);
          let varianValue = getVarianceByOutputIndex(index);
          let offsetValue = ${offsetSnippet};
          let scaleValue = ${scaleSnippet};
          let inv = scaleValue * inverseSqrt(varianValue + f32(uniforms.varianceEpsilon));
          setOutputAtIndex(index,dot(vec3<f32>(xValue, -meanValue, offsetValue), vec3<f32>(inv, inv, 1.0)));
        }
      }
  `;
        return userCode;
    }
}


const $e34a1aeb7eca700a$export$bfc6b905951b4903 = {
    kernelName: (0, $507890e4aa8e1463$export$3821a0416660aaa2),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x, scale: scale, offset: offset, mean: mean, variance: variance } = inputs;
        const { varianceEpsilon: varianceEpsilon } = attrs;
        const webGPUBackend = backend;
        const batchNormInputs = [
            x,
            mean,
            variance
        ];
        let offsetShape = null;
        if (offset != null) {
            offsetShape = offset.shape;
            batchNormInputs.push(offset);
        }
        let scaleShape = null;
        if (scale != null) {
            scaleShape = scale.shape;
            batchNormInputs.push(scale);
        }
        const program = new (0, $4b73319f51bfbf20$export$bd15a4172044baef)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape);
        const uniformData = [
            {
                type: 'float32',
                data: [
                    varianceEpsilon
                ]
            }
        ];
        return webGPUBackend.runWebGPUProgram(program, batchNormInputs, x.dtype, uniformData);
    }
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $050329eea2323ea1$export$b4f4a900a93010a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    return (0, $4c5c73b67a339da3$export$5d9f3221948b996)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $050329eea2323ea1$export$5b64efa829ddf94e = {
    kernelName: (0, $507890e4aa8e1463$export$86f8a8e3a8f2a8f2),
    backendName: 'webgpu',
    kernelFunc: $050329eea2323ea1$export$b4f4a900a93010a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $1179d5c4f42260f6$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const programInputs = [
        x,
        filter
    ];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    if (hasBias) programInputs.push(bias);
    if (hasPreluActivationWeights) programInputs.push(preluActivationWeights);
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        }
    ];
    let program;
    if (convInfo.outHeight > 4 && convInfo.outWidth > 4 && convInfo.strideWidth <= 2 && convInfo.inChannels === convInfo.outChannels && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.inChannels % 4 === 0) {
        program = new (0, $84cea51a019dd6b6$export$6bf670667b9eeec7)(convInfo, hasBias, activation, hasPreluActivationWeights);
        dimensions.push({
            type: 'int32',
            data: [
                program.virtualWidth
            ]
        });
    } else {
        program = new (0, $e04406b56fbb85c7$export$4ead5a4ba22ede40)(convInfo, hasBias, activation, hasPreluActivationWeights);
        dimensions.push({
            type: 'int32',
            data: [
                convInfo.filterHeight
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.filterWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        });
    }
    if (activation === 'leakyrelu') {
        dimensions.push({
            type: 'float32',
            data: [
                leakyreluAlpha
            ]
        });
        program.uniforms += ' alpha : f32,';
    }
    const result = backend.runWebGPUProgram(program, programInputs, 'float32', dimensions);
    return result;
}
const $1179d5c4f42260f6$export$58481cc3409b412c = {
    kernelName: (0, $507890e4aa8e1463$export$5a249e8f498c02c1),
    backendName: 'webgpu',
    kernelFunc: $1179d5c4f42260f6$export$d61de7729228094b
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $acfcafee8157fe04$export$ffd508d535a7dba1 {
    constructor(sliceDim, shape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `gathernd_${sliceDim}`;
        this.sliceDim = sliceDim;
        this.uniforms = `sliceDim : i32, strides : ${(0, $0533631f1fe2cae9$export$859efd105c10c755)(sliceDim)},`;
    }
    getUserCode() {
        let strideString;
        if (this.sliceDim > 1) strideString = 'uniforms.strides[j]';
        else strideString = 'uniforms.strides';
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          var flattenIndex = 0;
          for (var j = 0; j < uniforms.sliceDim; j = j + 1) {
            let indexTemp = i32(round(getIndices(coords[0], j)));
            let strideNum = ${strideString};
            flattenIndex = flattenIndex + indexTemp * strideNum;
          }

          setOutputAtIndex(index, getA(flattenIndex, coords[1]));
        }
      }
      `;
        return userCode;
    }
}




function $cde9848693cf1385$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const paramsSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(params.shape);
    const [resultShape, numSlices, sliceSize, strides] = (0, $f35e0c1a651337db$exports).prepareAndValidate(params, indices);
    const flattenIndices = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numSlices,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: params
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $0775da5e684c8c0d$exports).sizeFromShape(params.shape) / sliceSize,
                sliceSize
            ]
        }
    });
    if (backend.shouldExecuteOnCPU([
        params,
        indices
    ]) || params.dtype === 'string') {
        const indicesData = backend.readSync(indices.dataId);
        const paramsBuf = backend.bufferSync(params);
        const outValue = (0, $218cb6c8b1f27bad$export$e3196a12dce24214)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
        return backend.makeTensorInfo(resultShape, params.dtype, outValue.values);
    }
    const program = new (0, $acfcafee8157fe04$export$ffd508d535a7dba1)(sliceRank, [
        numSlices,
        sliceSize
    ]);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndices
    ], flattenX.dtype, uniformData);
    const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: resultShape
        }
    });
    backend.disposeData(flattenIndices.dataId);
    backend.disposeData(flattenX.dataId);
    backend.disposeData(res.dataId);
    return reshaped;
}
const $cde9848693cf1385$export$d9700eb1c7f5c969 = {
    kernelName: (0, $507890e4aa8e1463$export$4ef6e37a23721703),
    backendName: 'webgpu',
    kernelFunc: $cde9848693cf1385$export$3c586830e482d2b9
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $ffa76ff1534e1c5e$export$e8921930334c8ed5 {
    constructor(aShape, outputShape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = aShape.slice();
        this.aShape = aShape;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `gather`;
    }
    getUserCode() {
        const sourceCoords = $ffa76ff1534e1c5e$var$getSourceCoords(this.aShape);
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let resRC = getCoordsFromIndex(index);
          let indexZ = i32(getIndices(resRC.x, resRC.z));
          let inBounds = select(0.0, 1.0, indexZ >= 0 && indexZ < uniforms.aShape[2]);
          setOutputAtIndex(index, inBounds * getA(${sourceCoords}));
        }
      }
    `;
        return userCode;
    }
}
// The input and output are always flattened into rank 4 tensors.
function $ffa76ff1534e1c5e$var$getSourceCoords(aShape) {
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)if (i === 2) sourceCoords.push('indexZ');
    else sourceCoords.push(`${currentCoords[i]}`);
    return sourceCoords.join();
}




function $2f071354cda7fee0$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    // Unlike WebGL, WebGPU won't check if index is out of bound by calling
    // backend.readSync() function in debug mode.
    const parsedAxis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape)[0];
    const shapeInfo = (0, $f35e0c1a651337db$exports).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, batchDims);
    const indicesSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(indices.shape);
    const toDispose = [];
    const flattenX = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    toDispose.push(flattenX);
    toDispose.push(flattenIndex);
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    if (backend.shouldExecuteOnCPU([
        x,
        indices
    ])) {
        const indicesTensorData = backend.tensorMap.get(flattenIndex.dataId);
        const indicesValues = indicesTensorData.values;
        const indicesBuffer = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(flattenIndex.shape, flattenIndex.dtype, indicesValues);
        const flattenXTensorData = backend.tensorMap.get(flattenX.dataId);
        const xValues = flattenXTensorData.values;
        const xBuffer = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(flattenX.shape, flattenX.dtype, xValues);
        const outBuf = (0, $218cb6c8b1f27bad$export$cffe0fde89e98de6)(xBuffer, indicesBuffer, flattenOutputShape);
        toDispose.forEach((t)=>backend.disposeData(t.dataId));
        return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $ffa76ff1534e1c5e$export$e8921930334c8ed5)(flattenX.shape, flattenOutputShape);
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndex
    ], flattenX.dtype);
    toDispose.push(res);
    const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shapeInfo.outputShape
        }
    });
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return reshaped;
}
const $2f071354cda7fee0$export$b1bd3139c91d8765 = {
    kernelName: (0, $507890e4aa8e1463$export$ccd988942e5c0181),
    backendName: 'webgpu',
    kernelFunc: $2f071354cda7fee0$export$3d75b4295ded9925
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $6add830524063c1c$export$9dca161faaf6308b = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).GREATER,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$eabb8927944259dd),
    dtype: 'bool'
});
const $6add830524063c1c$export$8c4f7e92d92310f8 = {
    kernelName: (0, $507890e4aa8e1463$export$d0a25eac5ee3f515),
    backendName: 'webgpu',
    kernelFunc: $6add830524063c1c$export$9dca161faaf6308b
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $eb00d03dc30c68cb$export$c2fd4164cadc1fa2 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).GREATER_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$a3d2e203d979d298)
});
const $eb00d03dc30c68cb$export$7a6926f9fcac24ca = {
    kernelName: (0, $507890e4aa8e1463$export$3b7d21bc9aee0851),
    backendName: 'webgpu',
    kernelFunc: $eb00d03dc30c68cb$export$c2fd4164cadc1fa2
};



/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $59acff9bfcbad9aa$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $f6df8fdd2f2477ad$export$75d3742a7578721e)(input, true, backend);
}
const $59acff9bfcbad9aa$export$dc267425bf21b465 = {
    kernelName: (0, $507890e4aa8e1463$export$21c6f576ae8100e8),
    backendName: 'webgpu',
    kernelFunc: $59acff9bfcbad9aa$export$776649b0bf8ce1fd
};



/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $a0b35f4fe5737cc4$export$65f0b13f2f82375a = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).IS_FINITE,
    dtype: 'bool'
});
const $a0b35f4fe5737cc4$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $507890e4aa8e1463$export$b9fcc0946d7d485e),
    backendName: 'webgpu',
    kernelFunc: $a0b35f4fe5737cc4$export$65f0b13f2f82375a
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $40d3d87113413fdd$export$e5d3415c656f7096 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).IS_INF,
    dtype: 'bool'
});
const $40d3d87113413fdd$export$bc383b82282e9b5a = {
    kernelName: (0, $507890e4aa8e1463$export$74b5a3bc735b152),
    backendName: 'webgpu',
    kernelFunc: $40d3d87113413fdd$export$e5d3415c656f7096
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $4fc3a7323c3242c6$export$c9f5652083b8129d = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).IS_NAN,
    dtype: 'bool'
});
const $4fc3a7323c3242c6$export$d58ff790c765c1f0 = {
    kernelName: (0, $507890e4aa8e1463$export$9912dc4fc649dbec),
    backendName: 'webgpu',
    kernelFunc: $4fc3a7323c3242c6$export$c9f5652083b8129d
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $c8a9d59b0569b279$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    const uniformData = [
        {
            type: 'float32',
            data: [
                alpha
            ]
        }
    ];
    const program = new (0, $8e98bd3037a606b3$export$f93811a5a466fd42)(x.shape, (0, $4af106881f0be485$export$5adefdb0f928033b).LEAKYRELU, 'alpha : f32,');
    return backend.runWebGPUProgram(program, [
        x
    ], 'float32', uniformData);
}
const $c8a9d59b0569b279$export$aa04ab963fdf437f = {
    kernelName: (0, $507890e4aa8e1463$export$f0c7162bb7af1a2d),
    backendName: 'webgpu',
    kernelFunc: $c8a9d59b0569b279$export$23a860e40a2c6b61
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $694410787c8c43d8$export$bb1a638da8ad190f = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).LESS,
    dtype: 'bool',
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$74c893b3c5e74e60)
});
const $694410787c8c43d8$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $507890e4aa8e1463$export$728c50f1c88ac779),
    backendName: 'webgpu',
    kernelFunc: $694410787c8c43d8$export$bb1a638da8ad190f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $23de7bc674936aa0$export$c24ad19a692bb92 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).LESS_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$6d1533a3ea9565f)
});
const $23de7bc674936aa0$export$9f26bd257393dd8 = {
    kernelName: (0, $507890e4aa8e1463$export$84afd0d8f7fb8c5d),
    backendName: 'webgpu',
    kernelFunc: $23de7bc674936aa0$export$c24ad19a692bb92
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $0c8e730dca85fa82$export$575158e615b03e10 {
    constructor(shape){
        this.variableNames = [];
        this.outputShape = [];
        this.uniforms = 'start : f32, step : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            shape
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'linSpace';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          setOutputAtIndex(index, uniforms.start + f32(index) * uniforms.step);
        }
      }
    `;
        return userCode;
    }
}


function $436a0529f8887866$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    const step = (stop - start) / (num - 1);
    const program = new (0, $0c8e730dca85fa82$export$575158e615b03e10)(num);
    const uniformData = [
        {
            type: 'float32',
            data: [
                start
            ]
        },
        {
            type: 'float32',
            data: [
                step
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [], 'float32', uniformData);
}
const $436a0529f8887866$export$46b96f742c70959b = {
    kernelName: (0, $507890e4aa8e1463$export$34f0ab8eba543ee6),
    backendName: 'webgpu',
    kernelFunc: $436a0529f8887866$export$865a19adce4d7a46
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $dbb72f3513f3bf29$export$bef1f36f5486a6a3 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).LOG,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$e88dde64a338f813)
});
const $dbb72f3513f3bf29$export$a4ae1f00643ddd14 = {
    kernelName: (0, $507890e4aa8e1463$export$ce30dbb46644d06c),
    backendName: 'webgpu',
    kernelFunc: $dbb72f3513f3bf29$export$bef1f36f5486a6a3
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $fbd6b145d84339cc$export$144dcf16adfb9698 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).LOG1P
});
const $fbd6b145d84339cc$export$c458b9e5ba980198 = {
    kernelName: (0, $507890e4aa8e1463$export$70f05bf9ddcfca68),
    backendName: 'webgpu',
    kernelFunc: $fbd6b145d84339cc$export$144dcf16adfb9698
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $30665312aa29173b$export$db5dd0ef9d505f = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).LOGICAL_AND,
    dtype: 'bool'
});
const $30665312aa29173b$export$257f1e82e69113fb = {
    kernelName: (0, $507890e4aa8e1463$export$8a27ff10dff4d6e5),
    backendName: 'webgpu',
    kernelFunc: $30665312aa29173b$export$db5dd0ef9d505f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $7291e10ca8dd8c21$export$c836ff7b605b1617 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).LOGICAL_NOT
});
const $7291e10ca8dd8c21$export$68e2dd0840056271 = {
    kernelName: (0, $507890e4aa8e1463$export$4393bee5596c68c2),
    backendName: 'webgpu',
    kernelFunc: $7291e10ca8dd8c21$export$c836ff7b605b1617
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $930860af0431f209$export$e2a73975983cadd8 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).LOGICAL_OR
});
const $930860af0431f209$export$ce04b6546987ef43 = {
    kernelName: (0, $507890e4aa8e1463$export$c49f9f5ffc6f678c),
    backendName: 'webgpu',
    kernelFunc: $930860af0431f209$export$e2a73975983cadd8
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $bcaa211c60eb2914$var$powOperatorSnippet = `
  var powValue = 0.0;
  let basis = uniforms.bias + uniforms.alpha * sum;
  if (uniforms.beta == 0.5) {
    powValue = inverseSqrt(basis);
  } else if (uniforms.beta == 1.0) {
    powValue = 1.0 / basis;
  } else {
    powValue = exp(log(basis) * (-uniforms.beta));
  }
`;
class $bcaa211c60eb2914$export$2214c2ca22968528 {
    constructor(xShape){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'radius : i32, bias : f32, alpha : f32, beta : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = xShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'lrn';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let b = coords[0];
        let r = coords[1];
        let c = coords[2];
        let d = coords[3];

        let x = getX(b, r, c, d);
        var sum = 0.0;
        for (var i = -uniforms.radius; i <= uniforms.radius; i = i + 1) {
          let idx = d + i;
          if (idx >= 0 && idx < uniforms.xShape[3]) {
            let z = getX(b, r, c, idx);
            sum = sum + z * z;
          }
        }
        ${$bcaa211c60eb2914$var$powOperatorSnippet}

        setOutputAtIndex(index, x * powValue);
      }
    }
  `;
        return userCode;
    }
}
class $bcaa211c60eb2914$export$f1c3ae97c33db409 {
    constructor(xShape, radius){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'radius : i32, bias : f32, alpha : f32, beta : f32,';
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.maxAllowRadius = 16;
        (0, $0775da5e684c8c0d$exports).assert(radius <= this.maxAllowRadius, ()=>`Radius must be less than or equal to ${this.maxAllowRadius}, current radius is ${radius}`);
        this.outputShape = xShape;
        // The reason why not using this.workgroupSize[0] + 2 * maxAllowRadius here
        // is to make sure that there is only one time global memory load access for
        // each thread.
        this.elementsPerWorkgroup = this.workgroupSize[0] - 2 * this.maxAllowRadius;
        this.dispatchLayout = {
            x: [
                3
            ],
            y: [
                2
            ],
            z: [
                0,
                1
            ]
        };
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, [
            this.elementsPerWorkgroup,
            this.workgroupSize[1],
            this.workgroupSize[2]
        ]);
        this.shaderKey = 'lrn_shared';
    }
    getUserCode() {
        const userCode = `
    var <workgroup>lrnSub: array<f32, ${this.workgroupSize[0]}>;
    const elementsPerWorkgroup = ${this.elementsPerWorkgroup};
    const maxAllowRadius = ${this.maxAllowRadius};

    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)()} {
      let localDepth = i32(localId.x);
      let workgroupDepth = i32(workgroupId.x) * elementsPerWorkgroup;
      let xDepth = workgroupDepth + localDepth - maxAllowRadius;
      let b = i32(globalId.z) / uniforms.xShape[1];
      let r = i32(globalId.z) - b * uniforms.xShape[1];
      let c = i32(globalId.y);
      let d = workgroupDepth + localDepth;

      var x = 0.0;
      if (xDepth >= 0 && xDepth < uniforms.xShape[3]) {
        x = getX(b, r, c, xDepth);
      }
      lrnSub[localDepth] = x;
      workgroupBarrier();

      if (localDepth < elementsPerWorkgroup && d < uniforms.outShape[3]) {
        var sum = 0.0;
        let index = localDepth + maxAllowRadius;
        for (var i = -uniforms.radius; i <= uniforms.radius; i = i + 1) {
          let z = lrnSub[index + i];
          sum = sum + z * z;
        }
        ${$bcaa211c60eb2914$var$powOperatorSnippet}

        setOutputAtCoords(b, r, c, d, lrnSub[index] * powValue);
      }
    } `;
        return userCode;
    }
}


function $9a8e15be15db11fd$export$4e4a7896ae51c2f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    // When the adjacent channels is less than or equal to 16, which could cover
    // most cases, we use shared memory version to get better performance.
    // The theoretical adjacent channels may be very large, but the shared memory
    // size of hardware is limited, so we use the naive version when the adjacent
    // channels is large.
    let program;
    if (depthRadius > 16) program = new (0, $bcaa211c60eb2914$export$2214c2ca22968528)(x.shape);
    else program = new (0, $bcaa211c60eb2914$export$f1c3ae97c33db409)(x.shape, depthRadius);
    const uniformData = [
        {
            type: 'int32',
            data: [
                depthRadius
            ]
        },
        {
            type: 'float32',
            data: [
                bias
            ]
        },
        {
            type: 'float32',
            data: [
                alpha
            ]
        },
        {
            type: 'float32',
            data: [
                beta
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
    return res;
}
const $9a8e15be15db11fd$export$8817e4cec9f1a309 = {
    kernelName: (0, $507890e4aa8e1463$export$eb2f713fc3e1ca9a),
    backendName: 'webgpu',
    kernelFunc: $9a8e15be15db11fd$export$4e4a7896ae51c2f1
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $1e552c6a36048fdc$export$f121c71e68d75e {
    constructor(inputShape){
        this.outputShape = [];
        this.variableNames = [
            'inputImage',
            'outputImage',
            'dy'
        ];
        this.uniforms = 'depthRadius : i32, bias : f32, alpha : f32, beta : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = inputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'lrn_grad';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let b = coords[0];
        let r = coords[1];
        let c = coords[2];

        let MIN_DEPTH_BEGIN = 0;
        let MAX_DEPTH_END = uniforms.outShape[3];
        var result = 0.0;
        for (var d = MIN_DEPTH_BEGIN; d < MAX_DEPTH_END; d++) {
          let depthBegin = max(MIN_DEPTH_BEGIN, d - uniforms.depthRadius);
          let depthEnd = min(MAX_DEPTH_END, d + uniforms.depthRadius + 1);

          var norm = 0.0;
          for (var k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; k++) {
            if (k < depthBegin) {
              continue;
            } else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            } else {
              break;
            }
          }

          norm = uniforms.alpha * norm + uniforms.bias;

          for (var k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; k++) {
            if (k < depthBegin) {
              continue;
            } else if (k >= depthBegin && k < depthEnd) {
              var dyi = -2.0 * uniforms.alpha * uniforms.beta
                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d) / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * uniforms.beta);
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            } else {
              break;
            }
          }
        }

        setOutputAtIndex(index, result);
      }
    }
  `;
        return userCode;
    }
}


function $ec852d14727809c9$export$c1529e4348811bb5(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = new (0, $1e552c6a36048fdc$export$f121c71e68d75e)(x.shape);
    const uniformData = [
        {
            type: 'int32',
            data: [
                depthRadius
            ]
        },
        {
            type: 'float32',
            data: [
                bias
            ]
        },
        {
            type: 'float32',
            data: [
                alpha
            ]
        },
        {
            type: 'float32',
            data: [
                beta
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        x,
        y,
        dy
    ], x.dtype, uniformData);
    return res;
}
const $ec852d14727809c9$export$9250622395b66a34 = {
    kernelName: (0, $507890e4aa8e1463$export$73ba43cd0ce95b10),
    backendName: 'webgpu',
    kernelFunc: $ec852d14727809c9$export$c1529e4348811bb5
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $bdf47426e27731ff$export$b25e0be55f42c9a = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).MAX,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$b3afdc53a543e175)
});
const $bdf47426e27731ff$export$45b97bdc342e72a2 = {
    kernelName: (0, $507890e4aa8e1463$export$d8d02ac92d161004),
    backendName: 'webgpu',
    kernelFunc: $bdf47426e27731ff$export$b25e0be55f42c9a
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $6b2814b009ee010b$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    return (0, $0e6ffef9a5f3f01d$export$297e48da7c82a356)(x, convInfo, 'max', backend);
}
const $6b2814b009ee010b$export$45c8263b38f19e33 = {
    kernelName: (0, $507890e4aa8e1463$export$39ea33024ddd5cf),
    backendName: 'webgpu',
    kernelFunc: $6b2814b009ee010b$export$e4aadcf115842782
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $7a9f38f4fa1692c3$export$822a6e53be1125f9(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const maxPoolProgram = new (0, $31696987a1481d22$export$a835a97097fdbb0f)(convInfo, 'max');
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth,
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(maxPoolProgram, [
        x
    ], x.dtype, dimensions);
}
const $7a9f38f4fa1692c3$export$91a8fc5da39ec855 = {
    kernelName: (0, $507890e4aa8e1463$export$88fdc64af890fc53),
    backendName: 'webgpu',
    kernelFunc: $7a9f38f4fa1692c3$export$822a6e53be1125f9
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $433972f4fb4c8207$export$ab6144ed51884dd {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, dilations : vec2<i32>, filterDims : vec2<i32>,
       outHeight : i32, outWidth : i32`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'maxPool2DBackprop';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d = coords[3];

        let dyRCCorner = vec2<i32>(coords.yz) - uniforms.pads;
        let dyRCorner = dyRCCorner.x;
        let dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        let lastIndex = uniforms.filterDims[0] * uniforms.filterDims[1] - 1;
        for (var wR = 0; wR < uniforms.filterDims[0]; wR += uniforms.dilations[0]) {
          let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[0]);

          if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
            continue;
          }
          let idyR = i32(dyR);

          for (var wC = 0; wC < uniforms.filterDims[1]; wC += uniforms.dilations[1]) {
            let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[1]);

            if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
              continue;
            }
            let idyC = i32(dyC);

            let dyValue = getDy(batch, idyR, idyC, d);
            let maxPosValue = lastIndex - i32(getMaxPos(batch, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            let curPosValue = wR * uniforms.filterDims[1] + wC;
            let mask = select(0.0, 1.0, maxPosValue == curPosValue);
            dotProd += dyValue * mask;
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}
class $433972f4fb4c8207$export$ae61ae287bf9d719 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.uniforms = `strides : vec3<i32>, pads : vec3<i32>, filterDims : vec3<i32>,
      outDepth : i32, outHeight : i32, outWidth : i32`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'maxPool3DBackprop';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords.x;
        let ch = coords.u;

        let dyCorner = vec3<i32>(coords.y, coords.z, coords.w) - uniforms.pads;
        let dyDCorner = dyCorner.x;
        let dyRCorner = dyCorner.y;
        let dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        let lastIndex = uniforms.filterDims[0] * uniforms.filterDims[1] * uniforms.filterDims[2] - 1;

        for (var wD = 0; wD < uniforms.filterDims[0]; wD++) {
          let dyD = f32(dyDCorner + wD) / f32(uniforms.strides[0]);

          if (dyD < 0.0 || dyD >= f32(uniforms.outDepth) || fract(dyD) > 0.0) {
            continue;
          }
          let idyD = i32(dyD);

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[1]);

            if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
              continue;
            }
            let idyR = i32(dyR);

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[2]);

              if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
                continue;
              }
              let idyC = i32(dyC);

              let dyValue = getDy(batch, idyD, idyR, idyC, ch);
              let maxPosValue = lastIndex - i32(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              let curPosValue = wD * uniforms.filterDims[1] * uniforms.filterDims[2] + wR * uniforms.filterDims[2] + wC;
              let mask = select(0.0, 1.0, maxPosValue == curPosValue);
              dotProd += dyValue * mask;
            }
          }
        }

        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}



function $d5104e48ebacf4a7$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const maxPool3dPositionsProgram = new (0, $31696987a1481d22$export$a835a97097fdbb0f)(convInfo, 'max', true);
    let uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth,
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    const maxPool3dPositions = backend.runWebGPUProgram(maxPool3dPositionsProgram, [
        x
    ], 'int32', uniformData);
    const maxPool3dBackpropProgram = new (0, $433972f4fb4c8207$export$ae61ae287bf9d719)(convInfo);
    uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth - 1 - convInfo.padInfo.front,
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        }
    ];
    const result = backend.runWebGPUProgram(maxPool3dBackpropProgram, [
        dy,
        maxPool3dPositions
    ], x.dtype, uniformData);
    backend.disposeData(maxPool3dPositions.dataId);
    return result;
}
const $d5104e48ebacf4a7$export$5201426bb10bd5eb = {
    kernelName: (0, $507890e4aa8e1463$export$52be2c00371a1350),
    backendName: 'webgpu',
    kernelFunc: $d5104e48ebacf4a7$export$e68b9bef571dd4ea
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $847218d261768cc9$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $8e83a93f95f027c6$export$1412c17b2531581a)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const maxPoolPositionsProgram = new (0, $31696987a1481d22$export$ddaa65439647a5ac)(convInfo, 'max', true);
    let uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    const maxPoolPositions = backend.runWebGPUProgram(maxPoolPositionsProgram, [
        x
    ], 'int32', uniformData);
    const maxPoolBackpropProgram = new (0, $433972f4fb4c8207$export$ab6144ed51884dd)(convInfo);
    uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        }
    ];
    const result = backend.runWebGPUProgram(maxPoolBackpropProgram, [
        dy,
        maxPoolPositions
    ], x.dtype, uniformData);
    backend.disposeData(maxPoolPositions.dataId);
    return result;
}
const $847218d261768cc9$export$e01a7f8dbee29127 = {
    kernelName: (0, $507890e4aa8e1463$export$f0f010b1d1db8a46),
    backendName: 'webgpu',
    kernelFunc: $847218d261768cc9$export$85dfd1121f049514
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $5a4369133ca3a3d1$export$3d8b1b819d23351e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
    const { x: x } = inputs;
    (0, $0775da5e684c8c0d$exports).assert(x.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x.shape.length}.`);
    const dilations = [
        1,
        1
    ];
    (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, dilations, pad);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    let program = new (0, $31696987a1481d22$export$ddaa65439647a5ac)(convInfo, 'max', false);
    const poolOutput = backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
    program = new (0, $31696987a1481d22$export$ddaa65439647a5ac)(convInfo, 'max', true, true, includeBatchInIndex);
    const indexOutput = backend.runWebGPUProgram(program, [
        x
    ], 'int32', uniformData);
    return [
        poolOutput,
        indexOutput
    ];
}
const $5a4369133ca3a3d1$export$a069ee2247a7d1ce = {
    kernelName: (0, $507890e4aa8e1463$export$deac4b7497b4047f),
    backendName: 'webgpu',
    kernelFunc: $5a4369133ca3a3d1$export$3d8b1b819d23351e
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $ef39e986cf27a638$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, axis, keepDims, 'min', backend);
}
const $ef39e986cf27a638$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $507890e4aa8e1463$export$dfed19fabc75a31d),
    backendName: 'webgpu',
    kernelFunc: $ef39e986cf27a638$export$96ec731ed4dcb222
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $d2225bb3536c52a2$export$916782c1f0ddb132 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).MIN,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$1f01be3f637863fa)
});
const $d2225bb3536c52a2$export$ea24ffbbbce8d546 = {
    kernelName: (0, $507890e4aa8e1463$export$23cb308301e89d6b),
    backendName: 'webgpu',
    kernelFunc: $d2225bb3536c52a2$export$916782c1f0ddb132
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $c5c2b734bcba75ec$export$284b676bb83fc2a7 {
    constructor(xShape, paddings, mode){
        this.uniforms = '';
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.xShape = xShape;
        paddings.map((_, i)=>{
            this.uniforms += ` pad${i} : vec2<i32>,`;
        });
        this.offset = mode === 'reflect' ? 0 : 1;
        this.shaderKey = `mirrorPad_${mode}`;
    }
    getUserCode() {
        const rank = this.xShape.length;
        // The length of paddings are same with the rank of the input tensor.
        const start = this.xShape.map((_, i)=>`uniforms.pad${i}[0]`).join(',');
        const end = this.xShape.map((_, i)=>`uniforms.pad${i}[0] + uniforms.xShape${rank > 1 ? `[${i}]` : ''}`).join(',');
        const shaderStart = rank === 1 ? 'start' : 'start[i]';
        const shaderEnd = rank === 1 ? 'end' : 'end[i]';
        const shaderOutC = rank === 1 ? 'outC' : 'outC[i]';
        const dtype = (0, $0533631f1fe2cae9$export$859efd105c10c755)(rank);
        const unpackedCoords = rank > 1 ? [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank) : 'coords';
        return `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let start = ${dtype}(${start});
          let end = ${dtype}(${end});
          var outC = getCoordsFromIndex(index);
          for (var i = 0; i < ${rank}; i = i + 1) {
            if (${shaderOutC} < ${shaderStart}) {
              ${shaderOutC} = ${shaderStart} * 2 - ${shaderOutC} - ${this.offset};
            } else if(${shaderOutC} >= ${shaderEnd}) {
              ${shaderOutC} = (${shaderEnd} - 1) * 2 - ${shaderOutC} + ${this.offset};
            }
          }
          let coords = outC - start;
          setOutputAtIndex(index, getX(${unpackedCoords}));
        }
      }
    `;
    }
}


const $822e9528f71a9801$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $507890e4aa8e1463$export$f4c0e95fd7fd31e5),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { paddings: paddings, mode: mode } = attrs;
        const webGPUBackend = backend;
        const uniformData = paddings.map((p)=>{
            return {
                type: 'int32',
                data: [
                    p[0],
                    p[1]
                ]
            };
        });
        const program = new (0, $c5c2b734bcba75ec$export$284b676bb83fc2a7)(x.shape, paddings, mode);
        const output = webGPUBackend.runWebGPUProgram(program, [
            x
        ], x.dtype, uniformData);
        return output;
    }
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $79072cb2e80d3ece$export$842a2cf37af977e1 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).MOD
});
const $79072cb2e80d3ece$export$9037685a81180a9c = {
    kernelName: (0, $507890e4aa8e1463$export$e4835a5e3f3674d5),
    backendName: 'webgpu',
    kernelFunc: $79072cb2e80d3ece$export$842a2cf37af977e1
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $9a04cd0168510a31$export$f8cda6c8ea4f2110 {
    constructor(batchSize, numSamples){
        this.variableNames = [
            'probs'
        ];
        this.outputShape = [];
        this.uniforms = 'seed : f32, numOutcomes: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            batchSize,
            numSamples
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'multinomial';
    }
    getUserCode() {
        const userCode = `
    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    fn random (seed : f32, resultUV : vec2<f32>) -> f32 {
      let HASHSCALE1 = 443.8975;
      let p = resultUV * seed;
      var p3  = fract(vec3<f32>(p.xyx) * HASHSCALE1);
      p3 = p3 + dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let batch = coords[0];

        let resUV = vec2<f32>(f32(coords[1]) / f32(uniforms.outShape[1]),
            f32(coords[0]) / f32(uniforms.outShape[0]));
        let r = random(uniforms.seed, resUV);
        var cdf = 0.0;
        for (var i = 0; i < uniforms.numOutcomes - 1; i = i + 1) {
          cdf = cdf + getProbs(batch, i);

          if (r < cdf) {
            setOutputAtIndexI32(index, i);
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutputAtIndexI32(index, uniforms.numOutcomes - 1);
      }
    }
  `;
        return userCode;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $baa6e51c149f431b$export$f5cbdf455df96cd3 {
    constructor(outputShape){
        this.variableNames = [
            'logits'
        ];
        this.outputShape = outputShape; // [rows, cols]
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = [
            this.outputShape[0],
            1,
            1
        ];
        if (this.outputShape[1] >= 4096) this.workgroupSize = [
            256,
            1,
            1
        ];
        else this.workgroupSize = [
            64,
            1,
            1
        ];
        this.shaderKey = 'softmax';
    }
    getUserCode() {
        const userCode = `
    var<workgroup> buf : array<f32, ${this.workgroupSize[0]}>;
    var<workgroup> rowMaxShared : f32;
    var<workgroup> rowSumShared : f32;
    const blockSize = ${this.workgroupSize[0]};
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      let row = index / blockSize;
      let tid = i32(localId.x);
      let cols = uniforms.outShape[1];

      var threadMax = -3.402823e+38f;
      for (var col = tid; col < cols; col += blockSize) {
        let value = getLogits(row, col);
        threadMax = max(threadMax, value);
      }
      if (tid < cols) {
        buf[tid] = threadMax;
      }
      workgroupBarrier();

      var reduceSize = min(cols, blockSize);
      for (var currSize = reduceSize >> 1;  currSize > 0; currSize = reduceSize >> 1) {
        reduceSize = currSize + (reduceSize & 1);
        if (tid < currSize) {
          buf[tid] = max(buf[tid], buf[tid + reduceSize]);
        }
        workgroupBarrier();
      }

      if (tid == 0) {
        rowMaxShared = buf[0];
      }
      workgroupBarrier();

      var threadSum = 0.0;
      for (var col = tid; col < cols; col += blockSize) {
        let subExp = exp(getLogits(row, col) - rowMaxShared);
        threadSum += subExp;
      }
      buf[tid] = threadSum;
      workgroupBarrier();

      for (var currSize = blockSize >> 1;  currSize > 0; currSize = currSize >> 1) {
        if (tid < currSize) {
          buf[tid] = buf[tid] + buf[tid + currSize];
        }
        workgroupBarrier();
      }

      if (tid == 0) {
        rowSumShared = buf[0];
      }
      workgroupBarrier();

      for (var col = tid; col < cols; col += blockSize) {
        let value = exp(getLogits(row, col) - rowMaxShared) / rowSumShared;
        setOutputAtCoords(row, col, value);
      }
  }
    `;
        return userCode;
    }
}



function $10988fb9b207e23c$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const logitsReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $0775da5e684c8c0d$exports).sizeFromShape(logits.shape) / logits.shape[dim],
                logits.shape[dim]
            ]
        }
    });
    const program = new (0, $baa6e51c149f431b$export$f5cbdf455df96cd3)(logitsReshaped.shape);
    const res = backend.runWebGPUProgram(program, [
        logitsReshaped
    ], logits.dtype);
    const resReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: logits.shape
        }
    });
    backend.disposeData(logitsReshaped.dataId);
    backend.disposeData(res.dataId);
    return resReshaped;
}
const $10988fb9b207e23c$export$c022691f23e2ee69 = {
    kernelName: (0, $507890e4aa8e1463$export$350a526055d3ca6e),
    backendName: 'webgpu',
    kernelFunc: $10988fb9b207e23c$export$e008137e76238601
};


function $6c8d4c16c81c70c2$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    const probs = normalized ? logits : (0, $10988fb9b207e23c$export$e008137e76238601)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: logits.shape.length - 1
        }
    });
    const batchSize = probs.shape[0];
    const numOutcomes = probs.shape[1];
    const program = new (0, $9a04cd0168510a31$export$f8cda6c8ea4f2110)(batchSize, numSamples);
    const uniformData = [
        {
            type: 'float32',
            data: [
                seed
            ]
        },
        {
            type: 'int32',
            data: [
                numOutcomes
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        probs
    ], 'int32', uniformData);
    if (!normalized) backend.disposeData(probs.dataId);
    return res;
}
const $6c8d4c16c81c70c2$export$ad960e364767f0e2 = {
    kernelName: (0, $507890e4aa8e1463$export$ee0a8cfb693e0e3f),
    backendName: 'webgpu',
    kernelFunc: $6c8d4c16c81c70c2$export$f4d580f3101a1c7e
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $1d050e4135d5ad8b$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = backend.tensorMap.get(x.dataId);
        const [outValues, newShape] = (0, $218cb6c8b1f27bad$export$1cbcde7624effb15)(xData.values, x.shape, x.dtype);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    const program = new (0, $8e98bd3037a606b3$export$f93811a5a466fd42)(x.shape, (0, $4af106881f0be485$export$5adefdb0f928033b).NEG);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype);
}
const $1d050e4135d5ad8b$export$cc7b18b8229c3db = {
    kernelName: (0, $507890e4aa8e1463$export$c07c549000872073),
    backendName: 'webgpu',
    kernelFunc: $1d050e4135d5ad8b$export$d9493ff0dfa0fdd5
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $13b9efbf574374eb$export$8917e4bf7f7f5d42(args) {
    console.warn("tf.nonMaxSuppression() in webgpu locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices } = (0, $543f67484857d7a4$exports).nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $13b9efbf574374eb$export$549561cd158f260a = {
    kernelName: (0, $507890e4aa8e1463$export$5e11788439c2f04),
    backendName: 'webgpu',
    kernelFunc: $13b9efbf574374eb$export$8917e4bf7f7f5d42
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $2c62aebf50633014$export$49e389fdbe01a534(args) {
    console.warn("tf.nonMaxSuppression() in webgpu locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $543f67484857d7a4$exports).nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $2c62aebf50633014$export$4c00b682f309701d = {
    kernelName: (0, $507890e4aa8e1463$export$cb45d3fcefce2ef0),
    backendName: 'webgpu',
    kernelFunc: $2c62aebf50633014$export$49e389fdbe01a534
};



/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $86aeddffc36046aa$export$314e506cf5800fc5 {
    constructor(numIndices, depth){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'onValue : f32, offValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            numIndices,
            depth
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'onehot';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if(index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          setOutputAtIndex(index, mix(uniforms.offValue, uniforms.onValue,
                                      f32(i32(round(getX(coords.x))) == coords.y)));
        }
      }
    `;
        return userCode;
    }
}



function $b4f47e2cbb241cd4$export$341b5490a776d041(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    const indicesSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(indices.shape);
    const program = new (0, $86aeddffc36046aa$export$314e506cf5800fc5)(indicesSize, depth);
    const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                indicesSize
            ]
        }
    });
    const uniformData = [
        {
            type: 'float32',
            data: [
                onValue
            ]
        },
        {
            type: 'float32',
            data: [
                offValue
            ]
        }
    ];
    const result = backend.runWebGPUProgram(program, [
        reshaped
    ], dtype, uniformData);
    backend.disposeData(reshaped.dataId);
    const outShape = [
        ...indices.shape,
        depth
    ];
    const out = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeData(result.dataId);
    return out;
}
const $b4f47e2cbb241cd4$export$dde5645b472b80b2 = {
    kernelName: (0, $507890e4aa8e1463$export$18982b43ba8c02e9),
    backendName: 'webgpu',
    kernelFunc: $b4f47e2cbb241cd4$export$341b5490a776d041
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




function $40498200f1e85b5e$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'complex64') {
        const realPart = (0, $ee772b4e6a775b63$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $40498200f1e85b5e$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $10ab56078456f8d4$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $40498200f1e85b5e$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $94b917209ffdee98$export$83a0e34f1302825b)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeData(realPart.dataId);
        backend.disposeData(r.dataId);
        backend.disposeData(imagPart.dataId);
        backend.disposeData(i.dataId);
        return result;
    } else return (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: x.dtype === 'string' ? '' : 0
        },
        backend: backend
    });
}
const $40498200f1e85b5e$export$15368df05c479e41 = {
    kernelName: (0, $507890e4aa8e1463$export$430969a37eda1e88),
    backendName: 'webgpu',
    kernelFunc: $40498200f1e85b5e$export$cb1f824e7733584d
};


function $f1adb5ac59d8775f$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported under string dtype');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $ee772b4e6a775b63$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $f1adb5ac59d8775f$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $10ab56078456f8d4$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $40498200f1e85b5e$export$cb1f824e7733584d)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $94b917209ffdee98$export$83a0e34f1302825b)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeData(realPart.dataId);
        backend.disposeData(r.dataId);
        backend.disposeData(imagPart.dataId);
        backend.disposeData(i.dataId);
        return result;
    } else return (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: 1
        },
        backend: backend
    });
}
const $f1adb5ac59d8775f$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $507890e4aa8e1463$export$a2962e735c809d91),
    backendName: 'webgpu',
    kernelFunc: $f1adb5ac59d8775f$export$fb6afd6214fee9e9
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $df6ec86f7921c17c$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $26998513a525e7c2$export$d660d8ed21f46635)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $0775da5e684c8c0d$exports).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $0775da5e684c8c0d$exports).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $26998513a525e7c2$export$d660d8ed21f46635)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $2a67ed70be2df080$export$ee1b3e54f0441b22)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeData(t.dataId));
    return result;
}
const $df6ec86f7921c17c$export$1645fa8803aa1f86 = {
    kernelName: (0, $507890e4aa8e1463$export$c26f40b29201e5b7),
    backendName: 'webgpu',
    kernelFunc: $df6ec86f7921c17c$export$2a703dbb0cb35339
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $9290f6beebce8055$export$dddcb5890916ec63(shape, fillZero = false) {
    const rank = shape.length;
    const type = (0, $0533631f1fe2cae9$export$859efd105c10c755)(rank);
    const start = shape.map((_, i)=>`uniforms.pad${i}[0]`).join(',');
    const end = shape.map((_, i)=>`uniforms.pad${i}[0] + uniforms.xShape${rank > 1 ? `[${i}]` : ''}`).join(',');
    const startValue = rank > 1 ? `${type}(${start})` : `${start}`;
    const endValue = rank > 1 ? `${type}(${end})` : `${end}`;
    const leftPadCondition = rank > 1 ? `any(paddedCoords < start)` : `paddedCoords < start`;
    const rightPadCondition = rank > 1 ? `any(paddedCoords >= end)` : `paddedCoords >= end`;
    const unpackedCoords = rank > 1 ? [
        'coords[0]',
        'coords[1]',
        'coords[2]',
        'coords[3]'
    ].slice(0, rank) : 'coords';
    return `
        let start = ${startValue};
        let end = ${endValue};
        if (${leftPadCondition} || ${rightPadCondition}) {
          setOutputAtIndex(index, ${fillZero ? 0.0 : 'uniforms.constantValue'});
        } else {
          let coords = paddedCoords - start;
          setOutputAtIndex(index, getX(${unpackedCoords}));
        }
  `;
}
class $9290f6beebce8055$export$15f19b307ce21f0a {
    constructor(xShape, paddings){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'constantValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        paddings.map((_, i)=>{
            this.uniforms += ` pad${i} : vec2<i32>,`;
        });
        this.xShape = xShape;
        this.shaderKey = 'pad';
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let paddedCoords = getCoordsFromIndex(index);
          ${$9290f6beebce8055$export$dddcb5890916ec63(this.xShape)}
        }
      }
    `;
        return userCode;
    }
}



const $a1e920c578521c08$export$f676d6ad4f38bb89 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    if (paddings.every((p)=>(0, $0775da5e684c8c0d$exports).arraysEqual(p, [
            0,
            0
        ]))) return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape) === 0) {
        // Short-circuit the computation, since x doesn't have value, only
        // the shape is used to compute output shape to pad.
        const outputShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
        return (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
            backend: backend,
            attrs: {
                shape: outputShape,
                value: constantValue,
                dtype: x.dtype
            }
        });
    }
    const uniformData = [
        {
            type: 'float32',
            data: [
                constantValue
            ]
        }
    ];
    paddings.map((p)=>uniformData.push({
            type: 'int32',
            data: [
                p[0],
                p[1]
            ]
        }));
    const program = new (0, $9290f6beebce8055$export$15f19b307ce21f0a)(x.shape, paddings);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
};
const $a1e920c578521c08$export$b0317e720bfd61fc = {
    kernelName: (0, $507890e4aa8e1463$export$5d47ba206577f0f2),
    backendName: 'webgpu',
    kernelFunc: $a1e920c578521c08$export$f676d6ad4f38bb89
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $18e24bc4b0c7ce46$export$9c297f60e22e3389 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).POW
});
const $18e24bc4b0c7ce46$export$b823d49786719761 = {
    kernelName: (0, $507890e4aa8e1463$export$ce28d653ec559ee),
    backendName: 'webgpu',
    kernelFunc: $18e24bc4b0c7ce46$export$9c297f60e22e3389
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $1f4448788a609541$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    const program = new (0, $a015d0a4804ef6be$export$9045e9161086790b)((0, $41dab11c37c6072e$export$e5d009af261ea0bd).PRELU, x.shape, alpha.shape);
    return backend.runWebGPUProgram(program, [
        x,
        alpha
    ], 'float32');
}
const $1f4448788a609541$export$a5c4a9b694579636 = {
    kernelName: (0, $507890e4aa8e1463$export$a42f35f308fc2fa3),
    backendName: 'webgpu',
    kernelFunc: $1f4448788a609541$export$5882f235222e6729
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $3ff7c2614a3691c3$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $e50db2d696ca0e7f$export$533b26079ad0b4b)(x, axis, keepDims, 'prod', backend);
}
const $3ff7c2614a3691c3$export$d556aa935cef5c0c = {
    kernelName: (0, $507890e4aa8e1463$export$b8a16d526a791fb0),
    backendName: 'webgpu',
    kernelFunc: $3ff7c2614a3691c3$export$5e143010dea16c85
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $b78b70a061082d3c$export$d02631cccf789723 = (args)=>{
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, step: step, dtype: dtype } = attrs;
    const values = (0, $218cb6c8b1f27bad$export$fbee6deed7e76443)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
};
const $b78b70a061082d3c$export$361c4075706e31c2 = {
    kernelName: (0, $507890e4aa8e1463$export$9a58ef0d7ad3278c),
    backendName: 'webgpu',
    kernelFunc: $b78b70a061082d3c$export$d02631cccf789723
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $102c994c94c63a45$export$f76766520aabd67 = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).DIV
});
const $102c994c94c63a45$export$15c5d6176b30b9a6 = {
    kernelName: (0, $507890e4aa8e1463$export$b9880b86e1014bb8),
    backendName: 'webgpu',
    kernelFunc: $102c994c94c63a45$export$f76766520aabd67
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $3082ce57b5e9461f$export$163bc8c839a1ac04 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).RECIPROCAL
});
const $3082ce57b5e9461f$export$412a6b66203fdf72 = {
    kernelName: (0, $507890e4aa8e1463$export$c6e4a23ed5e0415b),
    backendName: 'webgpu',
    kernelFunc: $3082ce57b5e9461f$export$163bc8c839a1ac04
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $0fd63ba29ba0a32d$export$16d1e4612cc0139f = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).RELU
});
const $0fd63ba29ba0a32d$export$731f9199bde068eb = {
    kernelName: (0, $507890e4aa8e1463$export$9a6ff968bf961432),
    backendName: 'webgpu',
    kernelFunc: $0fd63ba29ba0a32d$export$16d1e4612cc0139f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $934c938efb9a05f8$export$4a62bcb95e9c44c4 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).RELU6
});
const $934c938efb9a05f8$export$92c30890ad649d53 = {
    kernelName: (0, $507890e4aa8e1463$export$3be9e924f629054e),
    backendName: 'webgpu',
    kernelFunc: $934c938efb9a05f8$export$4a62bcb95e9c44c4
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d253685bbe900b48$export$52b2ccd78b972549 {
    constructor(inputShape, newHeight, newWidth){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'adjustHeightWidth : vec2<f32>, halfPixelCenters : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            inputShape[0],
            newHeight,
            newWidth,
            inputShape[3]
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `resizeBilinear`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
          let b = coords[0];
          let d = coords[3];
          let rc = coords.yz;

          let effectiveInSize = vec2<f32>(
            f32(uniforms.xShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.xShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveOutSize = vec2<f32>(
            f32(uniforms.outShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.outShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveInputOverOutputRatioRC =
              effectiveInSize / effectiveOutSize;

          // Fractional source index
          let sourceFracIndexRC =
            (vec2<f32>(rc) + vec2<f32>(uniforms.halfPixelCenters)) *
            effectiveInputOverOutputRatioRC - vec2<f32>(uniforms.halfPixelCenters);

          // Compute the four integer indices.
          let sourceFloorRC = vec2<i32>(sourceFracIndexRC);
          let sourceCeilRC = vec2<i32>(
            min(vec2<f32>(uniforms.xShape.yz) - vec2<f32>(1.0), ceil(sourceFracIndexRC)));

          let topLeft = getX(b, sourceFloorRC.x, sourceFloorRC.y, d);
          let bottomLeft = getX(b, sourceCeilRC.x, sourceFloorRC.y, d);
          let topRight = getX(b, sourceFloorRC.x, sourceCeilRC.y, d);
          let bottomRight = getX(b, sourceCeilRC.x, sourceCeilRC.y, d);

          let fracRC = sourceFracIndexRC - vec2<f32>(sourceFloorRC);

          let top = topLeft + (topRight - topLeft) * fracRC.y;
          let bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
          let newValue = top + (bottom - top) * fracRC.x;

          setOutputAtIndex(index, newValue);
        }
      }
    `;
        return userCode;
    }
}


function $b9379eb815f3366f$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, size: size, halfPixelCenters: halfPixelCenters } = attrs;
    const [newHeight, newWidth] = size;
    const adjustHeight = alignCorners && newHeight > 1 ? 1.0 : 0.0;
    const adjustWidth = alignCorners && newWidth > 1 ? 1.0 : 0.0;
    const halfPixelCentersValue = halfPixelCenters ? 0.5 : 0.0;
    const uniformData = [
        {
            type: 'float32',
            data: [
                adjustHeight,
                adjustWidth
            ]
        },
        {
            type: 'float32',
            data: [
                halfPixelCentersValue
            ]
        }
    ];
    const program = new (0, $d253685bbe900b48$export$52b2ccd78b972549)(images.shape, newHeight, newWidth);
    return backend.runWebGPUProgram(program, [
        images
    ], 'float32', uniformData);
}
const $b9379eb815f3366f$export$a37a56137abc1357 = {
    kernelName: (0, $507890e4aa8e1463$export$24f2f15d869e0fd),
    backendName: 'webgpu',
    kernelFunc: $b9379eb815f3366f$export$1f1cbc7da93d06a0
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $cebf728cf15ee4c7$export$dd552814323a3592 {
    constructor(inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `effectiveXSize : vec2<i32>, effectiveYSize : vec2<i32>, heightScale : f32, widthScale : f32,
       invHeightScale : f32, invWidthScale : f32, winHeight : i32, winWidth : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = inputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.alignCorners = alignCorners;
        this.shaderKey = `resizeBilinearBackprop_${alignCorners}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let b = coords[0];
          let d = coords[3];
          let r = coords[1];
          let c = coords[2];

          var accumulator = 0.0;

          // Compute bounds for where in dy we will look
          let startRLerp = floor(f32(r) * uniforms.invHeightScale);
          let startDyR = i32(startRLerp - f32(uniforms.winHeight / 2));

          let startCLerp = floor(f32(c) * uniforms.invWidthScale);
          let startDyC = i32(startCLerp - f32(uniforms.winWidth / 2));

          // Loop over dy
          for (var dyROffset = 0; dyROffset < uniforms.winHeight; dyROffset++) {
            let dyR = startDyR + dyROffset;

            // Guard against the window exceeding the bounds of dy
            if (dyR < 0 || dyR >= uniforms.dyShape[1]) {
              continue;
            }

            for (var dyCOffset = 0; dyCOffset < uniforms.winWidth; dyCOffset++) {
              let dyC = startDyC + dyCOffset;

              // Guard against the window exceeding the bounds of dy
              if (dyC < 0 || dyC >= uniforms.dyShape[2]) {
                continue;
              }

              let dxR = f32(dyR) * uniforms.heightScale;
              let topDxRIndex = i32(floor(dxR));
              let bottomDxRIndex = i32(min(ceil(dxR), f32(uniforms.outShape[1] - 1)));
              let dxRLerp = dxR - f32(topDxRIndex);
              let inverseDxRLerp = 1.0 - dxRLerp;

              let dxC = f32(dyC) * uniforms.widthScale;
              let leftDxCIndex = i32(floor(dxC));
              let rightDxCIndex = i32(min(ceil(dxC), f32(uniforms.outShape[2] - 1)));
              let dxCLerp = dxC - f32(leftDxCIndex);
              let inverseDxCLerp = 1.0 - dxCLerp;

              if (r == topDxRIndex && c == leftDxCIndex) {
                // topLeft
                accumulator +=
                  getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
              }

              if (r == topDxRIndex && c == rightDxCIndex) {
                // topRight
                accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
              }

              if (r == bottomDxRIndex && c == leftDxCIndex) {
                // bottomLeft
                accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
              }

              if (r == bottomDxRIndex && c == rightDxCIndex) {
                // bottomRight
                accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
              }
            }
          }
          // End loop over dy

          setOutputAtIndex(index, accumulator);
        }
      }
    `;
        return userCode;
    }
}


function $f4b24576cb0fd0c4$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const [, xHeight, xWidth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    const program = new (0, $cebf728cf15ee4c7$export$dd552814323a3592)(images.shape, alignCorners);
    const uniformData = [
        {
            type: 'int32',
            data: effectiveXSize
        },
        {
            type: 'int32',
            data: effectiveYSize
        },
        {
            type: 'float32',
            data: [
                heightScale
            ]
        },
        {
            type: 'float32',
            data: [
                widthScale
            ]
        },
        {
            type: 'float32',
            data: [
                invHeightScale
            ]
        },
        {
            type: 'float32',
            data: [
                invWidthScale
            ]
        },
        {
            type: 'int32',
            data: [
                winHeight
            ]
        },
        {
            type: 'int32',
            data: [
                winWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], dy.dtype, uniformData);
}
const $f4b24576cb0fd0c4$export$51f84ca614e84763 = {
    kernelName: (0, $507890e4aa8e1463$export$2d3cf759f1538c13),
    backendName: 'webgpu',
    kernelFunc: $f4b24576cb0fd0c4$export$8899506794ec394
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d916dbbe9e0b270f$export$2218952be90fb74a {
    constructor(inputShape, newHeight, newWidth, halfPixelCenters){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'adjustHeightWidth : vec2<f32>, roundBase : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            inputShape[0],
            newHeight,
            newWidth,
            inputShape[3]
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.halfPixelCenters = halfPixelCenters;
        this.shaderKey = `resizeNearest_${halfPixelCenters}`;
    }
    getUserCode() {
        let sourceFracIndexRC;
        if (this.halfPixelCenters) sourceFracIndexRC = `max((vec2<f32>(rc) + vec2<f32>(0.5)) * effectiveInputOverOutputRatioRC` + `, vec2<f32>(0.0))`;
        else sourceFracIndexRC = `vec2<f32>(rc) * effectiveInputOverOutputRatioRC`;
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let b = coords[0];
          let d = coords[3];
          let rc = coords.yz;

          let effectiveInSize = vec2<f32>(
            f32(uniforms.xShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.xShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveOutSize = vec2<f32>(
            f32(uniforms.outShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.outShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveInputOverOutputRatioRC =
              effectiveInSize / effectiveOutSize;

          // Fractional source index
          let sourceFracIndexRC = ${sourceFracIndexRC};

          // Compute the coordinators of nearest neighbor point.
          let inputShapeRC = vec2<f32>(f32(uniforms.xShape.y), f32(uniforms.xShape.z));
          let sourceNearestRC = vec2<i32>(
            min(inputShapeRC - 1.0, floor(sourceFracIndexRC + uniforms.roundBase)));
          let newValue = getX(b, sourceNearestRC.x, sourceNearestRC.y, d);

          setOutputAtIndex(index, newValue);
        }
      }
    `;
        return userCode;
    }
}


function $30761f9aa303a75e$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const adjustHeight = alignCorners && newHeight > 1 ? 1.0 : 0.0;
    const adjustWidth = alignCorners && newWidth > 1 ? 1.0 : 0.0;
    // When align corners is false, we rounds the value with floor.
    const roundBase = alignCorners ? 0.5 : 0.0;
    const uniformData = [
        {
            type: 'float32',
            data: [
                adjustHeight,
                adjustWidth
            ]
        },
        {
            type: 'float32',
            data: [
                roundBase
            ]
        }
    ];
    const program = new (0, $d916dbbe9e0b270f$export$2218952be90fb74a)(images.shape, newHeight, newWidth, halfPixelCenters);
    return backend.runWebGPUProgram(program, [
        images
    ], images.dtype, uniformData);
}
const $30761f9aa303a75e$export$2b6a92caba113b89 = {
    kernelName: (0, $507890e4aa8e1463$export$6c8d8ec26192bb18),
    backendName: 'webgpu',
    kernelFunc: $30761f9aa303a75e$export$74a902ae74ac2560
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $e239d7c9d74ebe82$export$b6671a84abe827c4 {
    constructor(inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `effectiveXSize : vec2<i32>, effectiveYSize : vec2<i32>, invHeightScale : f32, invWidthScale : f32,
       winHeight : i32, winWidth : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = inputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.alignCorners = alignCorners;
        this.shaderKey = `resizeNearestNeigborBackprop_${alignCorners}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let b = coords[0];
          let d = coords[3];
          let r = coords[1];
          let c = coords[2];

          var accumulator = 0.0;

          // Compute bounds for where in dy we will look
          let startRLerp = floor(f32(r) * uniforms.invHeightScale);
          let startDyR = i32(floor(startRLerp - f32(uniforms.winHeight / 2)));

          let startCLerp = floor(f32(c) * uniforms.invWidthScale);
          let startDyC = i32(floor(startCLerp - f32(uniforms.winWidth / 2)));

          // Loop over dy
          for (var dyROffset = 0; dyROffset < uniforms.winHeight; dyROffset++) {
            let dyR = startDyR + dyROffset;

            // Guard against the window exceeding the bounds of dy
            if (dyR < 0 || dyR >= uniforms.dyShape[1]) {
              continue;
            }

            for (var dyCOffset = 0; dyCOffset < uniforms.winWidth; dyCOffset++) {
              let dyC = startDyC + dyCOffset;

              // Guard against the window exceeding the bounds of dy
              if (dyC < 0 || dyC >= uniforms.dyShape[2]) {
                continue;
              }

              let sourceFracRow = f32(uniforms.effectiveXSize[0]) *
                  (f32(dyR) / f32(uniforms.effectiveYSize[0]));

              let sourceFracCol = f32(uniforms.effectiveXSize[1]) *
                  (f32(dyC) / f32(uniforms.effectiveYSize[1]));

              let sourceNearestRow =
                  i32(min(f32(uniforms.outShape[1] - 1),
                  ${this.alignCorners ? 'floor(sourceFracRow + 0.5)' : 'floor(sourceFracRow)'}));

              let sourceNearestCol =
                  i32(min(f32(uniforms.outShape[2] - 1),
                  ${this.alignCorners ? 'floor(sourceFracCol + 0.5)' : 'floor(sourceFracCol)'}));

              if (r == sourceNearestRow && c == sourceNearestCol) {
                accumulator += getDy(b, dyR, dyC, d);
              }
            }
          }
          // End loop over dy

          setOutputAtIndex(index, accumulator);
        }
      }
    `;
        return userCode;
    }
}


function $e8c580e973e9774c$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const [, xHeight, xWidth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    const program = new (0, $e239d7c9d74ebe82$export$b6671a84abe827c4)(images.shape, alignCorners);
    const uniformData = [
        {
            type: 'int32',
            data: effectiveXSize
        },
        {
            type: 'int32',
            data: effectiveYSize
        },
        {
            type: 'float32',
            data: [
                invHeightScale
            ]
        },
        {
            type: 'float32',
            data: [
                invWidthScale
            ]
        },
        {
            type: 'int32',
            data: [
                winHeight
            ]
        },
        {
            type: 'int32',
            data: [
                winWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], dy.dtype, uniformData);
}
const $e8c580e973e9774c$export$2b08d810b5090fe1 = {
    kernelName: (0, $507890e4aa8e1463$export$b84ac31c55aa023b),
    backendName: 'webgpu',
    kernelFunc: $e8c580e973e9774c$export$2b75795f158f1b18
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $938b121e1e992166$export$abc2effa29e77e92 {
    constructor(xShape){
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = xShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.uniforms = ` axis : vec4<i32>,`;
        this.shaderKey = 'reverse';
    }
    getUserCode() {
        const reverseCoordsSnippet = `
      // Using uniform variables as judging conditions, so the function has
      // coherent execution within all threads.
      fn getReverseCoords(coords : vec4<i32>) -> vec4<i32> {
        var reverseCoords = coords;
        if (uniforms.axis[0] == 1) {
          reverseCoords[0] = uniforms.xShape[0] - coords[0] - 1;
        }
        if (uniforms.axis[1] == 1) {
          reverseCoords[1] = uniforms.xShape[1] - coords[1] - 1;
        }
        if (uniforms.axis[2] == 1) {
          reverseCoords[2] = uniforms.xShape[2] - coords[2] - 1;
        }
        if (uniforms.axis[3] == 1) {
          reverseCoords[3] = uniforms.xShape[3] - coords[3] - 1;
        }

        return reverseCoords;
      }
    `;
        const userCode = `
      ${reverseCoordsSnippet}
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let reverseCoords = getReverseCoords(coords);
          setOutputAtIndex(index, getX(reverseCoords[0],
              reverseCoords[1], reverseCoords[2], reverseCoords[3]));
        }
      }
    `;
        return userCode;
    }
}




function $41d789617b483720$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    const xRank = x.shape.length;
    if (xRank === 0) return (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const xShape = x.shape;
    const xShape4D = [
        1,
        1,
        1,
        1
    ];
    xShape.forEach((d, i)=>{
        const index = i + 4 - xRank;
        xShape4D[index] = d;
    });
    const axes = (0, $0775da5e684c8c0d$exports).parseAxisParam(dims, x.shape);
    const dims4D = [
        0,
        0,
        0,
        0
    ];
    axes.forEach((ax)=>{
        const index = ax + 4 - xRank;
        dims4D[index] = 1;
    });
    const uniformData = [
        {
            type: 'int32',
            data: dims4D
        }
    ];
    const xReshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: xShape4D
        }
    });
    const program = new (0, $938b121e1e992166$export$abc2effa29e77e92)(xShape4D);
    const values = backend.runWebGPUProgram(program, [
        xReshaped
    ], xReshaped.dtype, uniformData);
    backend.disposeData(xReshaped.dataId);
    const result = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: values
        },
        backend: backend,
        attrs: {
            shape: xShape
        }
    });
    backend.disposeData(values.dataId);
    return result;
}
const $41d789617b483720$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $507890e4aa8e1463$export$53c81f36b32e1bba),
    backendName: 'webgpu',
    kernelFunc: $41d789617b483720$export$66c1ae025e96b4bc
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $da6f1858927efdfe$export$a37df1d4e69844e7 {
    constructor(imageShape, fillValue){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = imageShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.uniforms = `centerX : f32, centerY : f32, sinRadians : f32,
          cosRadians : f32,`;
        this.shaderKey = 'rotate';
        this.outputShape = imageShape;
        if (typeof fillValue === 'number') {
            this.uniforms += ` fillValue : f32,`;
            this.fillSnippet = `var outputValue = uniforms.fillValue;`;
            this.shaderKey += '_float';
        } else {
            this.uniforms += ` fillValue : vec3<f32>,`;
            this.fillSnippet = `var outputValue = uniforms.fillValue[coords[3]];`;
            this.shaderKey += '_vec3';
        }
    }
    getUserCode() {
        const userCode = `
        ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
          if (index < uniforms.size) {
            let coords = getCoordsFromIndex(index);
            let coordXFloat = (f32(coords[2]) - uniforms.centerX) *
                uniforms.cosRadians - (f32(coords[1]) - uniforms.centerY) *
                uniforms.sinRadians;
            let coordYFloat = (f32(coords[2]) - uniforms.centerX) *
                uniforms.sinRadians + (f32(coords[1]) - uniforms.centerY) *
                uniforms.cosRadians;
            let coordX = i32(round(coordXFloat + uniforms.centerX));
            let coordY = i32(round(coordYFloat + uniforms.centerY));
            ${this.fillSnippet}
            if(coordX >= 0 && coordX < uniforms.xShape[2] && coordY >= 0 &&
                coordY < uniforms.xShape[1]) {
              outputValue = getX(coords[0], coordY, coordX, coords[3]);
            }
            setOutputAtIndex(index, outputValue);
          }
        }
      `;
        return userCode;
    }
}


const $d90024d15bd0b9cc$export$44ba8c83417ab668 = {
    kernelName: (0, $507890e4aa8e1463$export$c5a44649815d1c3),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const webgpuBackend = backend;
        const program = new (0, $da6f1858927efdfe$export$a37df1d4e69844e7)(image.shape, fillValue);
        const [centerX, centerY] = (0, $f35e0c1a651337db$exports).getImageCenter(center, image.shape[1], image.shape[2]);
        const uniformData = [
            {
                type: 'float32',
                data: [
                    centerX
                ]
            },
            {
                type: 'float32',
                data: [
                    centerY
                ]
            },
            {
                type: 'float32',
                data: [
                    Math.sin(radians)
                ]
            },
            {
                type: 'float32',
                data: [
                    Math.cos(radians)
                ]
            }
        ];
        if (typeof fillValue === 'number') uniformData.push({
            type: 'float32',
            data: [
                Number.parseFloat(fillValue.toFixed(2))
            ]
        });
        else uniformData.push({
            type: 'float32',
            data: fillValue
        });
        const output = webgpuBackend.runWebGPUProgram(program, [
            image
        ], image.dtype, uniformData);
        return output;
    }
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $5b5bcf5b55064ff7$export$2077e0241d6afd3c = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).ROUND
});
const $5b5bcf5b55064ff7$export$6c09e3291f636503 = {
    kernelName: (0, $507890e4aa8e1463$export$c5ed3eef16c0612f),
    backendName: 'webgpu',
    kernelFunc: $5b5bcf5b55064ff7$export$2077e0241d6afd3c
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $8330d4dfa9d1f81a$export$1cc01d192953037e = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).RSQRT,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$431ccb02913a1aee)
});
const $8330d4dfa9d1f81a$export$941104b789956ef6 = {
    kernelName: (0, $507890e4aa8e1463$export$7cc53aa09f5f3a2d),
    backendName: 'webgpu',
    kernelFunc: $8330d4dfa9d1f81a$export$1cc01d192953037e
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $c915c0db8a9e4785$export$8d0317f5c5cbc1ac {
    constructor(flattenXShape, sliceDim, indicesRank, updatesRank, strides, shape, outputDtype, sumDupeIndices = true){
        this.variableNames = [
            'updates',
            'indices'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = shape;
        this.type = outputDtype;
        this.sumDupeIndices = sumDupeIndices;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(flattenXShape);
        // Dispatching based on |updates| shape instead of output shape.
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, flattenXShape, this.workgroupSize);
        this.sliceDimGreaterThanOne = sliceDim > 1;
        this.shaderKey = `scatter_${indicesRank}_${updatesRank}_${this.sliceDimGreaterThanOne}_${outputDtype}_${sumDupeIndices}_${strides.length}`;
        const stridesType = (0, $0533631f1fe2cae9$export$859efd105c10c755)(strides.length);
        this.uniforms = `sliceDim : i32, strides: ${stridesType}, updatesSize: i32,`;
        this.updatesRank = updatesRank;
        this.indicesRank = indicesRank;
    }
    getUserCode() {
        let indicesString = '';
        if (this.indicesRank === 1) indicesString = 'coords[0]';
        else if (this.indicesRank === 2) indicesString = 'coords[0], j';
        const indicesSnippet = `getIndices(${indicesString})`;
        const strideString = this.sliceDimGreaterThanOne ? 'uniforms.strides[j]' : 'uniforms.strides';
        let outCoordsString = '';
        let getUpdatesCoordsFromFlatIndex = '';
        if (this.dispatchLayout.x.length === 1) {
            outCoordsString = 'flattenedIndex';
            getUpdatesCoordsFromFlatIndex = `
      fn getUpdatesCoordsFromFlatIndex(index : i32) -> i32 {
        return index;
      }
      `;
        } else if (this.dispatchLayout.x.length === 2) {
            outCoordsString = 'vec2<i32>(flattenedIndex, coords[1])';
            getUpdatesCoordsFromFlatIndex = `
      fn getUpdatesCoordsFromFlatIndex(index : i32) -> vec2<i32> {
        // N.B. |updates| could be a scalar tensor, conceptually representing a
        // 2D tensor with all values equal to that. By design, its size must be
        // the same as |outShape[1]| in one dimension, and |indicesShape[0]|
        // gives the other.
        let sliceSize = uniforms.outShape[1];
        let d0 = index / sliceSize;
        let d1 = index - d0 * sliceSize;
        return vec2<i32>(d0, d1);
      }
      `;
        }
        const updatesString = Array.from({
            length: this.updatesRank
        }, (_, idx)=>`coords[${idx}]`);
        const updatesSnippet = `getUpdates(${updatesString.join(', ')})`;
        const userCode = `
    ${getUpdatesCoordsFromFlatIndex}
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.updatesSize) {
          let coords = getUpdatesCoordsFromFlatIndex(index);
          var flattenedIndex = 0;
          for (var j = 0; j < uniforms.sliceDim; j = j + 1) {
            let indexInside = i32(round(${indicesSnippet}));
            flattenedIndex = flattenedIndex + indexInside * ${strideString};
          }
          let updateValue =
              ${(0, $0533631f1fe2cae9$export$342fcff7270d2d1a)(this.type)}(${updatesSnippet});
          let flatIndex = getOutputIndexFromCoords(${outCoordsString});

          ${this.sumDupeIndices ? (0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[flatIndex]', 'updateValue', this.type) : `atomicStore(&result[flatIndex], bitcast<i32>(updateValue));`}
        }
      }`;
        return userCode;
    }
}




function $5b3ee3851afefc27$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $f35e0c1a651337db$exports).calculateShapes(updates, indices, shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(shape, indices.dtype);
    const flattenIndices = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const type = flattenX.dtype;
    const output = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: flattenShape,
            value: 0,
            dtype: type
        }
    });
    const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(flattenX.shape);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        },
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const program = new (0, $c915c0db8a9e4785$export$8d0317f5c5cbc1ac)(flattenX.shape, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, type);
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndices
    ], type, uniformData, output);
    const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shape
        }
    });
    backend.disposeData(flattenIndices.dataId);
    backend.disposeData(flattenX.dataId);
    backend.disposeData(res.dataId);
    return reshaped;
}
const $5b3ee3851afefc27$export$573371744f044f5 = {
    kernelName: (0, $507890e4aa8e1463$export$28eef6f0168af686),
    backendName: 'webgpu',
    kernelFunc: $5b3ee3851afefc27$export$b6f42038a536d877
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $21b933971afa120c$export$2511b5550383de5c {
    constructor(outputShape, side){
        this.outputShape = [];
        this.variableNames = [
            'sortedSequence',
            'values'
        ];
        this.uniforms = 'numInputs : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.side = side;
        this.shaderKey = `search_sorted_${side}`;
    }
    getUserCode() {
        const boundComparator = this.side === 'left' ? '<' : '<=';
        const userCode = `
      fn findBound(batch: i32, value: f32) -> i32 {
        var left = i32(0);
        var right = uniforms.numInputs;
        while (left < right) {
          var mid = (left + right) / 2;
          if (getSortedSequence(batch, mid) ${boundComparator} value) {
            left = mid + 1;
          } else {
            right = mid;
          }
        }
        return right;
      }

      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let value = getValuesByOutputIndex(index);
          setOutputAtIndexI32(index, findBound(coords[0], value));
        }
      }
    `;
        return userCode;
    }
}


function $3001c96e457e8ebd$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const program = new (0, $21b933971afa120c$export$2511b5550383de5c)([
        values.shape[0],
        values.shape[1]
    ], side);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sortedSequence.shape[1]
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        sortedSequence,
        values
    ], 'int32', uniformData);
}
const $3001c96e457e8ebd$export$4b437b1a1aa6472f = {
    kernelName: (0, $507890e4aa8e1463$export$9a1405490b09867e),
    backendName: 'webgpu',
    kernelFunc: $3001c96e457e8ebd$export$56fad8d65b0adbdd
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $330d6a704bc864f6$export$845ed2d1f74ef297 {
    constructor(cRank, shape, rank){
        this.variableNames = [
            'c',
            'a',
            'b'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.cRank = cRank;
        this.rank = rank;
        this.shaderKey = 'select';
    }
    getUserCode() {
        // TODO(WGSL): below code can be merged with getUserCode.
        let cCoords;
        let abCoords;
        if (this.rank > 4) throw Error(`Where for rank ${this.rank} is not yet supported`);
        if (this.rank === 1) {
            abCoords = `resRC`;
            cCoords = `resRC`;
        } else {
            const currentCoords = [
                'resRC.x',
                'resRC.y',
                'resRC.z',
                'resRC.w'
            ];
            const cCoordVars = [];
            const abCoordVars = [];
            for(let i = 0; i < this.outputShape.length; i++){
                abCoordVars.push(`${currentCoords[i]}`);
                if (i < this.cRank) cCoordVars.push(`${currentCoords[i]}`);
            }
            cCoords = cCoordVars.join();
            abCoords = abCoordVars.join();
        }
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let resRC = getCoordsFromIndex(index);
          let cVal = getC(${cCoords});
          if (cVal >= 1.0) {
            setOutputAtIndex(index, getA(${abCoords}));
          } else {
            setOutputAtIndex(index, getB(${abCoords}));
          }
        }
      }
    `;
        return userCode;
    }
}


function $d4d1421f5a4b56d8$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    const program = new (0, $330d6a704bc864f6$export$845ed2d1f74ef297)(condition.shape.length, t.shape, t.shape.length);
    return backend.runWebGPUProgram(program, [
        condition,
        t,
        e
    ], (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(t.dtype, e.dtype));
}
const $d4d1421f5a4b56d8$export$7ff911e710ee72fc = {
    kernelName: (0, $507890e4aa8e1463$export$ef9b1a59e592288f),
    backendName: 'webgpu',
    kernelFunc: $d4d1421f5a4b56d8$export$2e6c959c16ff56b8
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $e0d67dd337d79231$export$a5f8240d9e99b438 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SELU
});
const $e0d67dd337d79231$export$8afc8558705c1a39 = {
    kernelName: (0, $507890e4aa8e1463$export$6760d858e6f2594a),
    backendName: 'webgpu',
    kernelFunc: $e0d67dd337d79231$export$a5f8240d9e99b438
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $2ae3133b7c267a50$export$3b295495ca3cad7c = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SIGMOID
});
const $2ae3133b7c267a50$export$195d1cf7c59f3ef = {
    kernelName: (0, $507890e4aa8e1463$export$fde18c826dda6b1b),
    backendName: 'webgpu',
    kernelFunc: $2ae3133b7c267a50$export$3b295495ca3cad7c
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $6deb96ce3720149f$export$c5552dfdbc7cec71 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SIGN
});
const $6deb96ce3720149f$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $507890e4aa8e1463$export$1db683ad541682f6),
    backendName: 'webgpu',
    kernelFunc: $6deb96ce3720149f$export$c5552dfdbc7cec71
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $7082cd724d16d91e$export$5de3937cb4b592ed = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SIN
});
const $7082cd724d16d91e$export$d993ec4e5c253b66 = {
    kernelName: (0, $507890e4aa8e1463$export$75be1b631f7687),
    backendName: 'webgpu',
    kernelFunc: $7082cd724d16d91e$export$5de3937cb4b592ed
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $e66396c12d7d037e$export$545004b505d7c555 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SINH
});
const $e66396c12d7d037e$export$b92766b47f18ac85 = {
    kernelName: (0, $507890e4aa8e1463$export$b8c187376329d79b),
    backendName: 'webgpu',
    kernelFunc: $e66396c12d7d037e$export$545004b505d7c555
};




/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $9ed2047a4b9c3a97$export$76aa560a8c2b0055 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SOFTPLUS
});
const $9ed2047a4b9c3a97$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $507890e4aa8e1463$export$c5af433747f1fd0a),
    backendName: 'webgpu',
    kernelFunc: $9ed2047a4b9c3a97$export$76aa560a8c2b0055
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



class $37525cd6b6e92d41$export$9c8dd2624b1658e3 {
    constructor(xShape, paddedXShape, paddings, reshapedPaddedXShape, newDim, paddedXShapeStridesShapeLength){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.uniforms = '';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const outputShape = new Array(reshapedPaddedXShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = reshapedPaddedXShape[newDim[i]];
        this.outputShape = outputShape;
        this.newDim = newDim;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.xShape = xShape;
        this.paddedXShape = paddedXShape;
        this.uniforms += `reshapedPaddedXShape : ${(0, $0533631f1fe2cae9$export$859efd105c10c755)(reshapedPaddedXShape.length)}, paddedXShapeStrides : ${(0, $0533631f1fe2cae9$export$859efd105c10c755)(paddedXShapeStridesShapeLength)}, `;
        paddings.map((_, i)=>{
            this.uniforms += ` pad${i} : vec2<i32>,`;
        });
        this.shaderKey = `spaceToBatchND_${newDim}`;
    }
    getUserCode() {
        const dtype = (0, $0533631f1fe2cae9$export$859efd105c10c755)(this.outputShape.length);
        const switched = (0, $0801bdf3f95188e8$export$2fa044c45543b8d9)(this.newDim);
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$a9674693e382741e)(this.paddedXShape, 'PaddedX')}
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if(index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let switchedIndex = getIndexFromCoords${this.outputShape.length}D(${dtype}(${switched}), uniforms.reshapedPaddedXShape);
          let paddedCoords = getPaddedXCoordsFromIndex(switchedIndex);
          ${(0, $9290f6beebce8055$export$dddcb5890916ec63)(this.xShape, true)}
        }
      }
    `;
        return userCode;
    }
}



const $b278264c794dbb85$export$effb9d7cae92012f = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $0775da5e684c8c0d$exports).assert(x.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGPU backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const paddedXShape = completePaddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const reshapedPaddedShape = (0, $f35e0c1a651337db$exports).getReshaped(paddedXShape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $f35e0c1a651337db$exports).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $f35e0c1a651337db$exports).getReshapedPermuted(paddedXShape, blockShape, prod, false);
    const paddedXShapeStrides = (0, $0775da5e684c8c0d$exports).computeStrides(paddedXShape);
    const program = new (0, $37525cd6b6e92d41$export$9c8dd2624b1658e3)(x.shape, paddedXShape, completePaddings, reshapedPaddedShape, permutedReshapedPaddedPermutation, paddedXShapeStrides.length);
    const uniformData = [
        {
            type: 'int32',
            data: reshapedPaddedShape
        },
        {
            type: 'int32',
            data: paddedXShapeStrides
        }
    ];
    completePaddings.map((p)=>uniformData.push({
            type: 'int32',
            data: [
                p[0],
                p[1]
            ]
        }));
    const paddedXT = backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
    const result = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: paddedXT
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    backend.disposeData(paddedXT.dataId);
    return result;
};
const $b278264c794dbb85$export$2f85417863d2050b = {
    kernelName: (0, $507890e4aa8e1463$export$f63ac5409312707c),
    backendName: 'webgpu',
    kernelFunc: $b278264c794dbb85$export$effb9d7cae92012f
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $d33ae26deddedede$export$359edb6dd2233e21 {
    constructor(outShape, sparseSize, outputDtype){
        this.variableNames = [
            'input',
            'indices',
            'segmentIds'
        ];
        this.outputShape = [];
        this.uniforms = 'segmentSize : i32, sparseSize : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = outShape;
        this.type = outputDtype;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)([
            sparseSize
        ]);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, [
            sparseSize
        ], this.workgroupSize);
        this.shaderKey = 'sparseSegmentSum';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.sparseSize) {
        let indexInSegmentIds = index / uniforms.segmentSize;
        let indexInSegment = index % uniforms.segmentSize;
        let indexInInput = indices[indexInSegmentIds];
        let segmentId = segmentIds[indexInSegmentIds];

        let value = input[indexInInput * uniforms.segmentSize + indexInSegment];
        let outIndex = segmentId * uniforms.segmentSize + indexInSegment;
        ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[outIndex]', 'value', this.type)}
      }
    }
  `;
        return userCode;
    }
}
class $d33ae26deddedede$export$9a8d14fc8669d9b9 {
    constructor(outShape, segmentIdsShape){
        this.variableNames = [
            'segmentIds'
        ];
        this.outputShape = [];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = [
            outShape
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(segmentIdsShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, segmentIdsShape, this.workgroupSize);
        this.shaderKey = 'sparseSegmentIdCountProgram';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.segmentIdsShape) {
        let segmentId = segmentIds[index];
        ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[segmentId]', '1', 'int32')}
      }
    }
  `;
        return userCode;
    }
}
class $d33ae26deddedede$export$f8b388a7cda9eaff {
    constructor(outShape, outputDtype){
        this.variableNames = [
            'segmentSum',
            'sameSegmentIdCount'
        ];
        this.outputShape = [];
        this.uniforms = 'segmentSize : i32';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outShape;
        this.type = outputDtype;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(outShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, outShape, this.workgroupSize);
        this.shaderKey = 'sparseSegmentMean';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.size) {
        let segmentId = index / uniforms.segmentSize;
        let count = sameSegmentIdCount[segmentId];
        if (count != 0) {
          ${this.type === 'float32' ? 'setOutputAtIndex(index, segmentSum[index] / f32(count));' : 'setOutputAtIndexI32(index, segmentSum[index] / count);'}
        }
      }
    }
  `;
        return userCode;
    }
}


function $532311f567098663$export$f1b2d24dec0cd5f(input, indices, segmentIds, isSum = false, backend) {
    const inputSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape);
    const segmentSize = inputSize / input.shape[0];
    const dtype = input.dtype;
    // Note that the current implementation assumes that segmentIds values are
    // sorted.
    const numIndices = (0, $0775da5e684c8c0d$exports).sizeFromShape(indices.shape);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const lastSegmentIdPlusOne = numIndices > 0 ? $segmentIds[numIndices - 1] + 1 : 0;
    const outputRows = lastSegmentIdPlusOne;
    let program;
    const outputShape = input.shape.slice();
    outputShape[0] = outputRows;
    const sparseSize = numIndices * segmentSize;
    const sparseSegmentSum = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: outputShape,
            value: 0,
            dtype: dtype
        }
    });
    program = new (0, $d33ae26deddedede$export$359edb6dd2233e21)(outputShape, sparseSize, dtype);
    let uniformData = [
        {
            type: 'int32',
            data: [
                segmentSize
            ]
        },
        {
            type: 'int32',
            data: [
                sparseSize
            ]
        }
    ];
    const $sparseSegmentSum = backend.runWebGPUProgram(program, [
        input,
        indices,
        segmentIds
    ], dtype, uniformData, sparseSegmentSum);
    if (isSum) return $sparseSegmentSum;
    const sparseSegmentIdCount = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: [
                outputRows
            ],
            value: 0,
            dtype: 'int32'
        }
    });
    program = new (0, $d33ae26deddedede$export$9a8d14fc8669d9b9)(outputRows, segmentIds.shape);
    const $sparseSegmentIdCount = backend.runWebGPUProgram(program, [
        segmentIds
    ], 'int32', null, sparseSegmentIdCount);
    const sparseSegmentMean = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: outputShape,
            value: 0,
            dtype: dtype
        }
    });
    program = new (0, $d33ae26deddedede$export$f8b388a7cda9eaff)(outputShape, dtype);
    uniformData = [
        {
            type: 'int32',
            data: [
                segmentSize
            ]
        }
    ];
    const $sparseSegmentMean = backend.runWebGPUProgram(program, [
        $sparseSegmentSum,
        $sparseSegmentIdCount
    ], dtype, uniformData, sparseSegmentMean);
    backend.disposeData($sparseSegmentSum.dataId);
    backend.disposeData($sparseSegmentIdCount.dataId);
    return $sparseSegmentMean;
}


function $99f83f1a2687d476$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    return (0, $532311f567098663$export$f1b2d24dec0cd5f)(data, indices, segmentIds, false, backend);
}
const $99f83f1a2687d476$export$51e7224ae14d7f78 = {
    kernelName: (0, $507890e4aa8e1463$export$610b077aecc2447b),
    backendName: 'webgpu',
    kernelFunc: $99f83f1a2687d476$export$dbc0c9096869d04e
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $e8b7646f21c3a062$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    return (0, $532311f567098663$export$f1b2d24dec0cd5f)(data, indices, segmentIds, true, backend);
}
const $e8b7646f21c3a062$export$73fa0270f28b9555 = {
    kernelName: (0, $507890e4aa8e1463$export$68351c28d7116b56),
    backendName: 'webgpu',
    kernelFunc: $e8b7646f21c3a062$export$2255ce53fc777865
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $6dea9a26e6970626$export$215140f0ab19f420 {
    constructor(aShape, reps){
        this.variableNames = [
            'A'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[i] * reps[i];
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.rank = this.outputShape.length;
        this.shaderKey = 'tile';
    }
    getUserCode() {
        const sourceCoords = $6dea9a26e6970626$var$getSourceCoords(this.rank, 'uniforms.');
        const userCode = `
      ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
        if (index < uniforms.size) {
          let resRC = getCoordsFromIndex(index);
          setOutputAtIndex(index, getA(${sourceCoords}));
        }
      }
    `;
        return userCode;
    }
}
function $6dea9a26e6970626$var$getSourceCoords(rank, uniformPrefix = '') {
    if (rank >= 5) throw Error(`Tile for rank ${rank} is not yet supported`);
    if (rank === 1) return `(resRC % ${uniformPrefix}aShape)`;
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < rank; i++)sourceCoords.push(`(${currentCoords[i]} % ${uniformPrefix}aShape[${i}])`);
    return sourceCoords.join();
}


function $b4adca6d6116343c$export$3c17558da18e4d75(params) {
    const { inputs: inputs, backend: backend, attrs: attrs } = params;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    // tile gpu program cannot handle rank >= 5 case.
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string' || x.shape.length >= 5) {
        // Even thought string tensor is always on CPU, just to be consistent on how
        // to access tensor data.
        const data = backend.readSync(x.dataId);
        const value = x.dtype === 'string' ? data.map((d)=>(0, $0775da5e684c8c0d$exports).decodeString(d)) : data;
        const buf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(x.shape, x.dtype, value);
        const outBuf = (0, $218cb6c8b1f27bad$export$349e02a266ab3131)(buf, reps);
        return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $6dea9a26e6970626$export$215140f0ab19f420)(x.shape, reps);
    const output = backend.runWebGPUProgram(program, [
        x
    ], x.dtype);
    return output;
}
const $b4adca6d6116343c$export$a5a9f8050ba7f41e = {
    kernelName: (0, $507890e4aa8e1463$export$235cb65c20ad2b7),
    backendName: 'webgpu',
    kernelFunc: $b4adca6d6116343c$export$3c17558da18e4d75
};


function $50a0323119cf2e99$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $f35e0c1a651337db$exports).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    if (sparseValues.dtype === 'string') {
        const indicesBuf = backend.bufferSync(sparseIndices);
        const updatesBuf = backend.bufferSync(sparseValues);
        const $defaultValue = (0, $0775da5e684c8c0d$exports).decodeString(backend.readSync(defaultValue.dataId)[0]);
        const outBuf = (0, $218cb6c8b1f27bad$export$2295c910080b5ca7)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
        return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
    }
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    const $sparseIndices = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: sparseIndices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const $sparseValues = sparseValues.shape.length ? (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: sparseValues
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    }) : (0, $c76b17881110536c$export$f0954fd7d5368655)({
        inputs: {
            x: sparseValues
        },
        backend: backend
    });
    const type = $sparseValues.dtype;
    const zero = backend.makeTensorInfo([], type, (0, $0775da5e684c8c0d$exports).makeZerosTypedArray(1, type));
    // Fill output tensor with the default value.
    const $defaultValue = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: defaultValue
        },
        backend: backend,
        attrs: {
            shape: Array(flattenShape.length).fill(1)
        }
    });
    const $denseValues = (0, $b4adca6d6116343c$export$3c17558da18e4d75)({
        inputs: {
            x: $defaultValue
        },
        backend: backend,
        attrs: {
            reps: flattenShape
        }
    });
    const size = (0, $0775da5e684c8c0d$exports).sizeFromShape([
        numUpdates,
        sliceSize
    ]);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        },
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    switch(numUpdates){
        case 0:
            break;
        case 1:
            {
                const program = new (0, $c915c0db8a9e4785$export$8d0317f5c5cbc1ac)([
                    numUpdates,
                    sliceSize
                ], sliceRank, $sparseIndices.shape.length, $sparseValues.shape.length, strides, flattenShape, type, sumDupeIndices);
                backend.runWebGPUProgram(program, [
                    $sparseValues,
                    $sparseIndices
                ], type, uniformData, $denseValues);
            }
            break;
        default:
            {
                // First replace the default value with 0 at indices.
                const program = new (0, $c915c0db8a9e4785$export$8d0317f5c5cbc1ac)([
                    numUpdates,
                    sliceSize
                ], sliceRank, $sparseIndices.shape.length, zero.shape.length, strides, flattenShape, type, sumDupeIndices);
                backend.runWebGPUProgram(program, [
                    zero,
                    $sparseIndices
                ], type, uniformData, $denseValues);
            }
            {
                // Then replace 0 with the (sum of) sparse value(s) at indices.
                const program = new (0, $c915c0db8a9e4785$export$8d0317f5c5cbc1ac)([
                    numUpdates,
                    sliceSize
                ], sliceRank, $sparseIndices.shape.length, $sparseValues.shape.length, strides, flattenShape, type);
                backend.runWebGPUProgram(program, [
                    $sparseValues,
                    $sparseIndices
                ], type, uniformData, $denseValues);
            }
    }
    const denseValues = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: $denseValues
        },
        backend: backend,
        attrs: {
            shape: outputShape
        }
    });
    backend.disposeData($sparseIndices.dataId);
    backend.disposeData($sparseValues.dataId);
    backend.disposeData($defaultValue.dataId);
    backend.disposeData(zero.dataId);
    backend.disposeData($denseValues.dataId);
    return denseValues;
}
const $50a0323119cf2e99$export$7bc088f8ad44ef99 = {
    kernelName: (0, $507890e4aa8e1463$export$2c426709a9332421),
    backendName: 'webgpu',
    kernelFunc: $50a0323119cf2e99$export$1be4b823dd1a3080
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $66cdb1417c8ddd16$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $f35e0c1a651337db$exports).prepareSplitSize(x, numOrSizeSplits, $axis);
    const xRank = x.shape.length;
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $fc251d31bd35efe1$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $66cdb1417c8ddd16$export$317be24be3af9ea0 = {
    kernelName: (0, $507890e4aa8e1463$export$8dffabb4071f05aa),
    backendName: 'webgpu',
    kernelFunc: $66cdb1417c8ddd16$export$c0085d48b0a75d8f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $9bee9c462b381dc8$export$eba8049fb5020b81 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).SQRT
});
const $9bee9c462b381dc8$export$a592ba9268f10eeb = {
    kernelName: (0, $507890e4aa8e1463$export$21ab404ab9d512a6),
    backendName: 'webgpu',
    kernelFunc: $9bee9c462b381dc8$export$eba8049fb5020b81
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $d897b52d7ec34503$export$7c77bece4d51efc4 = {
    kernelName: (0, $507890e4aa8e1463$export$b09fb900337259de),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webGPUBackend = backend;
        const program = new (0, $8e98bd3037a606b3$export$f93811a5a466fd42)(x.shape, (0, $4af106881f0be485$export$5adefdb0f928033b).SQUARE);
        return webGPUBackend.runWebGPUProgram(program, [
            x
        ], x.dtype);
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $1a8c047e2f2aefc8$export$b178697fb6d0b37f = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).SQUARED_DIFFERENCE
});
const $1a8c047e2f2aefc8$export$9ed4691d69db8a43 = {
    kernelName: (0, $507890e4aa8e1463$export$2f922d20d66089c6),
    backendName: 'webgpu',
    kernelFunc: $1a8c047e2f2aefc8$export$b178697fb6d0b37f
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $f41f2711fbbe7d70$export$35d34bc0ed591a92({ inputs: inputs, attrs: attrs, backend: backend }) {
    const { x: x } = inputs;
    const program = new (0, $8e98bd3037a606b3$export$f93811a5a466fd42)(x.shape, (0, $4af106881f0be485$export$5adefdb0f928033b).STEP, 'stepAlpha : f32,');
    const uniformData = [
        {
            type: 'float32',
            data: [
                attrs.alpha
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $f41f2711fbbe7d70$export$c42ffaf52eb2647 = {
    kernelName: (0, $507890e4aa8e1463$export$fd55ce593607084a),
    backendName: 'webgpu',
    kernelFunc: $f41f2711fbbe7d70$export$35d34bc0ed591a92
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $e31e7bede1def8f1$export$335c52ce94f359f6 {
    constructor(destSize){
        this.variableNames = [
            'x'
        ];
        // TODO(xing.xu): Increase the workPerThread.
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = destSize;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        const dtype = (0, $0533631f1fe2cae9$export$859efd105c10c755)(this.outputShape.length);
        this.uniforms = `begin : ${dtype},  strides : ${dtype}, `;
        this.shaderKey = 'stridedSlice';
    }
    getUserCode() {
        const rank = this.outputShape.length;
        let newCoords = '';
        if (rank === 1) newCoords = 'coords * uniforms.strides + uniforms.begin';
        else {
            let outputAxis = 0;
            newCoords = this.outputShape.map((_, i)=>{
                outputAxis++;
                return this.outputShape.length === 1 ? `coords * uniforms.strides[${i}] + uniforms.begin[${i}]` : `coords[${outputAxis - 1}] * uniforms.strides[${i}] + uniforms.begin[${i}]`;
            }).join(',');
        }
        const userCode = `
       ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
         if (index < uniforms.size) {
           let coords = getCoordsFromIndex(index);
           setOutputAtIndex(index, getX(${newCoords}));
         }
       }
     `;
        return userCode;
    }
}


function $b3c0e0952b3cb9fe$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $f147fd057118a602$exports).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $0775da5e684c8c0d$exports).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $f147fd057118a602$exports).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $fc251d31bd35efe1$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeData(sliced.dataId);
    } else {
        const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
            x
        ]);
        if (shouldExecuteOnCPU) {
            const values = backend.readSync(x.dataId);
            const xBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(x.shape, x.dtype, values);
            const resultValues = (0, $218cb6c8b1f27bad$export$efd4e188e5de0188)(finalShapeSparse, xBuf, $strides, $begin);
            result = backend.makeTensorInfo(finalShape, x.dtype, resultValues.values);
        } else {
            const program = new (0, $e31e7bede1def8f1$export$335c52ce94f359f6)(finalShapeSparse);
            const uniformData = [
                {
                    type: 'int32',
                    data: $begin
                },
                {
                    type: 'int32',
                    data: $strides
                }
            ];
            const resultValues = backend.runWebGPUProgram(program, [
                x
            ], x.dtype, uniformData);
            result = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
                inputs: {
                    x: resultValues
                },
                backend: backend,
                attrs: {
                    shape: finalShape
                }
            });
            backend.disposeData(resultValues.dataId);
        }
    }
    return result;
}
const $b3c0e0952b3cb9fe$export$81773633114187bd = {
    kernelName: (0, $507890e4aa8e1463$export$60c7f9ac271417a9),
    backendName: 'webgpu',
    kernelFunc: $b3c0e0952b3cb9fe$export$4ae57224f3b0605c
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $a1cce26373e9cb41$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.readSync(data.dataId);
    const $dataSplits = backend.readSync(dataSplits.dataId);
    const [nGrams, nGramsSplits] = (0, $218cb6c8b1f27bad$export$bb9e83cb65884ef3)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $a1cce26373e9cb41$export$35e13284eed34c22 = {
    kernelName: (0, $507890e4aa8e1463$export$11a7f4af7d96ad41),
    backendName: 'webgpu',
    kernelFunc: $a1cce26373e9cb41$export$3490514dcc63b044
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $7946318b648a3f8b$export$f93b5905241a7cca = (0, $55ff9472592af91d$export$29353c66e70e3e16)({
    opType: (0, $41dab11c37c6072e$export$e5d009af261ea0bd).SUB,
    cpuKernelImpl: (0, $218cb6c8b1f27bad$export$be7474e96b733333),
    supportsComplex: true
});
const $7946318b648a3f8b$export$5d068476dad60c4d = {
    kernelName: (0, $507890e4aa8e1463$export$d7a01e11500dfb6f),
    backendName: 'webgpu',
    kernelFunc: $7946318b648a3f8b$export$f93b5905241a7cca
};



/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $5471e11807dcfc5d$export$fcdd3b0b3246a325 = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).TAN
});
const $5471e11807dcfc5d$export$97648844df7611f3 = {
    kernelName: (0, $507890e4aa8e1463$export$115b2d5263ba5985),
    backendName: 'webgpu',
    kernelFunc: $5471e11807dcfc5d$export$fcdd3b0b3246a325
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $7ac45886e5a89518$export$7128670e45beef9a = (0, $55ff9472592af91d$export$ba4daf5748026fba)({
    opType: (0, $4af106881f0be485$export$5adefdb0f928033b).TANH
});
const $7ac45886e5a89518$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $507890e4aa8e1463$export$893b6e865e352c83),
    backendName: 'webgpu',
    kernelFunc: $7ac45886e5a89518$export$7128670e45beef9a
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $d7f7673bbcd15338$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const {} = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $f35e0c1a651337db$exports).calculateShapes(updates, indices, tensor.shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(tensor.shape, indices.dtype);
    const toDispose = [];
    const flattenIndices = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    toDispose.push(flattenIndices);
    const flattenX = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    toDispose.push(flattenX);
    const flattenTensor = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: tensor
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    toDispose.push(flattenTensor);
    const output = (0, $b4adca6d6116343c$export$3c17558da18e4d75)({
        inputs: {
            x: flattenTensor
        },
        backend: backend,
        attrs: {
            reps: Array(flattenShape.length).fill(1)
        }
    });
    const program = new (0, $c915c0db8a9e4785$export$8d0317f5c5cbc1ac)([
        numUpdates,
        sliceSize
    ], sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, tensor.dtype, false);
    const size = (0, $0775da5e684c8c0d$exports).sizeFromShape([
        numUpdates,
        sliceSize
    ]);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        },
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndices
    ], flattenTensor.dtype, uniformData, output);
    toDispose.push(res);
    const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: tensor.shape
        }
    });
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return reshaped;
}
const $d7f7673bbcd15338$export$2819813ce8339b64 = {
    kernelName: (0, $507890e4aa8e1463$export$20050a140fd1de77),
    backendName: 'webgpu',
    kernelFunc: $d7f7673bbcd15338$export$d3ac02769385eb36
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $4236515167a51c76$export$5ee54e3c81d6f6e7 {
    constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.uniforms = `inputSize : i32, firstPass : i32, negativeInf : f32,
        dir : i32, inc : i32,`;
        this.shaderKey = 'swap';
    }
    getUserCode() {
        const userCode = `
        ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
          if (index < uniforms.size) {
            let outC = getCoordsFromIndex(index);
            let batch = outC[0];
            let elemIdx = outC[1];
            // We compare elements pair-wise within a group of size 2 * inc.
            // The comparing rule for each group alternates between ascending
            // and descending. Within each group, we compare each pair at
            // positions i and i+inc. To decide whether an element at position i
            // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
            // inc, it is in the first half of the group, we denote it as x0,
            // otherwise we denote it as x1.
            // For example, as shown in the Bitonic top K paper referenced
            // above, Figure5(a) shows that element[1] is in the second half of
            // the group when group size is 2, but it is in the first half of
            // the group when group size is 4.
            let isFirstInPair = elemIdx % (2 * uniforms.inc) < uniforms.inc;
            var i = 0;
            if (isFirstInPair) {
              i = elemIdx;
            } else {
              i = elemIdx - uniforms.inc;
            }

            var i0 = 0;
            if (uniforms.firstPass == 1) {
              i0 = i;
            } else {
              i0 = i32(getIndices(batch, i));
            }

            var i1 = 0;
            if (uniforms.firstPass == 1) {
              i1 = i + uniforms.inc;
            } else {
              i1 = i32(getIndices(batch, i + uniforms.inc));
            }

            var x0 = f32(0.0);
            var x1 = f32(0.0);
            if (i0 < uniforms.inputSize) {
              x0 = getX(batch, i0);
            } else {
              x0 = uniforms.negativeInf;
            }
            if (i1 < uniforms.inputSize) {
              x1 = getX(batch, i1);
            } else {
              x1 = uniforms.negativeInf;
            }

            let reverse = elemIdx % (2 * uniforms.dir) >= uniforms.dir;
            let isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
            if (reverse == isGreater) {
              // Elements in opposite order of direction
              let iTemp = i0;
              i0 = i1;
              i1 = iTemp;
            }
            if (isFirstInPair) {
              setOutputAtIndex(index, f32(i0));
            } else {
              setOutputAtIndex(index, f32(i1));
            }
          }
        }
      `;
        return userCode;
    }
}
class $4236515167a51c76$export$c3fbf8b38d821ac9 {
    constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        // |n| Size of the original input of TopK
        // |firstPass| indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |k| Top k elements desired
        this.uniforms = `inputSize : i32, firstPass : i32, k : i32,`;
        this.shaderKey = 'merge';
    }
    getUserCode() {
        const userCode = `
        ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
          if (index < uniforms.size) {
            let outC = getCoordsFromIndex(index);
            let batch = outC[0];
            let elemIdx = outC[1];
            // The output size is half of the previous size.
            // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _
            // (k=4), we only need to output the indices at positions |, the
            // indices at positions _ can be thrown away, see Figure5(b) After
            // Phase 2 (Merge phase) in the Bitonic Top K paper referenced
            // above.
            // For example, the paper shows we only need to output the orange
            // bars. The output sequence should look like this | | | | | | | |.
            // Because the sequence is halved, to map the output index back to
            // the previous sequence to find the corresponding value, we need
            // to double the index. When we double the index, we basically
            // interpolate a position, so 2i looks like
            // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k
            // position of each 2k positions by - elemIdx % k. E.g. for output
            // at index 4,5,6,7, we want to get the corresponding element at
            // original index 8,9,10,11, for output at index 8,9,10,11,
            // we want to get the corresponding element at original index
            // 16,17,18,19, so on and so forth.

            var i = 0;
            if (elemIdx < uniforms.k) {
              i = elemIdx;
            } else {
              i = elemIdx * 2 - elemIdx % uniforms.k;
            }
            var i0 = 0;
            if (uniforms.firstPass == 1) {
              i0 = i;
            } else {
              i0 = i32(getIndices(batch, i));
            }
            var i1 = 0;
            if (uniforms.firstPass == 1) {
              i1 = i + uniforms.k;
            } else {
              i1 = i32(getIndices(batch, i + uniforms.k));
            }

            let x0 = getX(batch, i0);
            var x1 = f32(0.0);
            if (i1 < uniforms.inputSize) {
              x1 = getX(batch, i1);
            } else {
              x1 = x0;
            }

            if (x0 >= x1) {
              setOutputAtIndex(index, f32(i0));
            } else {
              setOutputAtIndex(index, f32(i1));
            }
          }
        }
      `;
        return userCode;
    }
}






function $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, tensorInfo) {
    if (tensorInfo !== null) backend.disposeData(tensorInfo.dataId);
}
function $3c15f267db0cc255$var$roundUpToPow2(num) {
    let pow2 = 1;
    while(pow2 < num)pow2 *= 2;
    return pow2;
}
function $3c15f267db0cc255$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    const xShape = x.shape;
    const lastDim = xShape[xShape.length - 1];
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xVals = backend.readSync(x.dataId);
        const [allTopKVals, allTopKIndices] = (0, $218cb6c8b1f27bad$export$cc4aa6851cf96e2b)(xVals, xShape, x.dtype, k, sorted);
        return [
            backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
            backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
        ];
    }
    if (k === 0) {
        xShape[xShape.length - 1] = 0;
        return [
            backend.makeTensorInfo(xShape, x.dtype, []),
            backend.makeTensorInfo(xShape, 'int32', [])
        ];
    }
    if (lastDim === 1 /* firstPass */ ) return [
        x,
        (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
            attrs: {
                shape: xShape,
                dtype: 'int32',
                value: 0
            },
            backend: backend
        })
    ];
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(xShape);
    const batch = xSize / lastDim;
    const x2D = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batch,
                lastDim
            ]
        },
        backend: backend
    });
    const kPow2 = $3c15f267db0cc255$var$roundUpToPow2(k);
    const lastDimPow2 = $3c15f267db0cc255$var$roundUpToPow2(lastDim);
    // Only the indices containing the top K are kept at every step to reduce
    // number of outputs in the GPU algorithms, so once the final set of indices
    // is computed then gather is used to grab the corresponding values
    // from the original input.
    let indices = null;
    // GPU algorithm always takes in an indices input but this input is not used
    // on the first run of a GPU algorithm, therefore if indices is null we simply
    // pass in x2D instead of it but the value will not actually be used
    const getInputs = ()=>indices === null ? [
            x2D,
            x2D
        ] : [
            x2D,
            indices
        ];
    const runSwap = (dir, inc, shape)=>{
        const inputs = getInputs();
        const program = new (0, $4236515167a51c76$export$5ee54e3c81d6f6e7)(shape);
        const firstPass = indices === null ? 1 : 0;
        const uniformDataSwap = [
            {
                type: 'int32',
                data: [
                    lastDim
                ]
            },
            {
                type: 'int32',
                data: [
                    firstPass
                ]
            },
            {
                type: 'float32',
                data: [
                    Number.NEGATIVE_INFINITY
                ]
            },
            {
                type: 'int32',
                data: [
                    dir
                ]
            },
            {
                type: 'int32',
                data: [
                    inc
                ]
            }
        ];
        const prevIndices = indices;
        indices = backend.runWebGPUProgram(program, inputs, 'int32', uniformDataSwap);
        $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    };
    // Step 1: local sort
    for(let len = 1; len < kPow2; len *= 2){
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, [
            batch,
            lastDimPow2
        ]);
    }
    // Step 2: merge
    for(let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2){
        const inputs = getInputs();
        const mergeProgram = new (0, $4236515167a51c76$export$c3fbf8b38d821ac9)([
            batch,
            indicesSize / 2
        ]);
        const firstPass = indices === null ? 1 : 0;
        const uniformDataMerge = [
            {
                type: 'int32',
                data: [
                    lastDim
                ]
            },
            {
                type: 'int32',
                data: [
                    firstPass
                ]
            },
            {
                type: 'int32',
                data: [
                    kPow2
                ]
            }
        ];
        const prevIndices = indices;
        indices = backend.runWebGPUProgram(mergeProgram, inputs, 'int32', uniformDataMerge);
        $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
        // Step 3: rebuild
        const len = kPow2 / 2;
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, indices.shape);
    }
    // Keep only the requested top K results instead of kPow2
    let prevIndices = indices;
    indices = (0, $fc251d31bd35efe1$export$58adb3bec8346d0f)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            begin: 0,
            size: [
                batch,
                k
            ]
        }
    });
    $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    // Gather values on last dimension
    let values = (0, $2f071354cda7fee0$export$3d75b4295ded9925)({
        inputs: {
            x: x2D,
            indices: indices
        },
        backend: backend,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, x2D);
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const newShape = xShape.slice(0, -1);
    newShape.push(k);
    prevIndices = indices;
    indices = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    const prevValues = values;
    values = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: values
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $3c15f267db0cc255$var$disposeIntermediateTensorInfoOrNull(backend, prevValues);
    return [
        values,
        indices
    ];
}
const $3c15f267db0cc255$export$cffaee31213314ce = {
    kernelName: (0, $507890e4aa8e1463$export$c593cd1ea0d02ebd),
    backendName: 'webgpu',
    kernelFunc: $3c15f267db0cc255$export$7e641efc73a2d81
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $e5d5d94afef2b137$export$c83a293baf8f269d {
    constructor(outShape){
        this.variableNames = [
            'Image',
            'Transforms'
        ];
        this.uniforms = 'interpolationModeId : i32, fillModeId : i32, fillValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(this.outputShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'transform';
    }
    getUserCode() {
        const userCode = `
          fn mapCoord(outCoord : f32, len : f32) -> f32{
            var inCoord = outCoord;
            if(uniforms.fillModeId == 2) {
              if (inCoord < 0.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz2 = 2.0 * len;
                  if (inCoord < sz2) {
                    inCoord = sz2 * f32(i32(f32(-inCoord / sz2))) +
                    inCoord;
                  }
                  if (inCoord < -len) {
                    inCoord = inCoord + sz2;
                  } else {
                    inCoord = -inCoord - 1.0;
                  }
                }
              } else if (inCoord > len - 1.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz2 = 2.0 * len;
                  inCoord = inCoord - sz2 * f32(i32(f32(inCoord / sz2)));
                  if (inCoord >= len) {
                    inCoord = sz2 - inCoord - 1.0;
                  }
                }
              }
              return clamp(inCoord, 0.0, len - 1.0);
            } else if (uniforms.fillModeId == 3) {
              if (inCoord < 0.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz = len - 1.0;
                  inCoord = inCoord + len * (f32(i32(f32(-inCoord / sz))) + 1.0);
                }
              } else if (inCoord > len - 1.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz = len - 1.0;
                  inCoord = inCoord - len * f32(i32(f32(inCoord / sz)));
                }
              }
              return clamp(inCoord, 0.0, len - 1.0);
            } else if (uniforms.fillModeId == 4) {
              return clamp(outCoord, 0.0, len - 1.0);
            }
            return outCoord;
          }
          fn readWithFillValue(batch : i32, coordY : i32, coordX : i32,
            channel : i32) -> f32 {
            var outputValue : f32;
            if (0 <= coordY && coordY < uniforms.imageShape[1] && 0 <= coordX && coordX < uniforms.imageShape[2]) {
                outputValue = getImage(batch, coordY, coordX, channel);
            } else {
              outputValue = uniforms.fillValue;
            }
            return outputValue;
          }

          ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
            if (index < uniforms.size) {
              let coords = getCoordsFromIndex(index);
              var outputValue : f32;
              let batch = coords[0];
              let x = coords[2];
              let y = coords[1];
              let channel = coords[3];
              let xf = f32(x);
              let yf = f32(y);
              let a1 = getTransforms(batch, 0);
              let a2 = getTransforms(batch, 1);
              let a3 = getTransforms(batch, 2);
              let b1 = getTransforms(batch, 3);
              let b2 = getTransforms(batch, 4);
              let b3 = getTransforms(batch, 5);
              let c1 = getTransforms(batch, 6);
              let c2 = getTransforms(batch, 7);
              let projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = uniforms.fillValue;
              } else {
                let inX = (a1 * xf + a2 * yf + a3) / projection;
                let inY = (b1 * xf + b2 * yf + b3) / projection;
                let mapX = mapCoord(inX, f32(uniforms.imageShape[2]));
                let mapY = mapCoord(inY, f32(uniforms.imageShape[1]));

                if (uniforms.interpolationModeId == 1) {
                  let coordY = i32(round(mapY));
                  let coordX = i32(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  let yFloor = floor(mapY);
                  let xFloor = floor(mapX);
                  let yCeil = yFloor + 1.0;
                  let xCeil = xFloor + 1.0;
                  let valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, i32(yFloor), i32(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, i32(yFloor), i32(xCeil), channel);
                  let valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, i32(yCeil), i32(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, i32(yCeil), i32(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutputAtIndex(index, outputValue);
            }
          }
        `;
        return userCode;
    }
}


function $bc81a600a1b97b74$export$51186ad6e864892a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const program = new (0, $e5d5d94afef2b137$export$c83a293baf8f269d)(outShape);
    const interpolationModeId = interpolation === 'nearest' ? 1 : 2;
    let fillModeId;
    switch(fillMode){
        case 'constant':
            fillModeId = 1;
            break;
        case 'reflect':
            fillModeId = 2;
            break;
        case 'wrap':
            fillModeId = 3;
            break;
        case 'nearest':
            fillModeId = 4;
            break;
        default:
            fillModeId = 1;
            break;
    }
    const uniformData = [
        {
            type: 'int32',
            data: [
                interpolationModeId
            ]
        },
        {
            type: 'int32',
            data: [
                fillModeId
            ]
        },
        {
            type: 'float32',
            data: [
                fillValue
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        image,
        transforms
    ], 'float32', uniformData);
}
const $bc81a600a1b97b74$export$1c7a3de6335954ed = {
    kernelName: (0, $507890e4aa8e1463$export$563a914cafbdc389),
    backendName: 'webgpu',
    kernelFunc: $bc81a600a1b97b74$export$51186ad6e864892a
};



/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $e9c6dc7432c7e61f$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const x = value;
    const xRank = x.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(xRank - 1);
    let outIndex = 0;
    for(let i = 0; i < xRank; i++)if (i !== axis) outShape[outIndex++] = x.shape[i];
    const toDispose = [];
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const sliced = (0, $fc251d31bd35efe1$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        res[i] = reshaped;
        toDispose.push(sliced);
    }
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return res;
}
const $e9c6dc7432c7e61f$export$d06292128cae50d6 = {
    kernelName: (0, $507890e4aa8e1463$export$441ad6bfc5db8ab4),
    backendName: 'webgpu',
    kernelFunc: $e9c6dc7432c7e61f$export$417857010dc9287f
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $1b0f1f869df37089$export$71be9d28dd2ad236 {
    constructor(inShape, outShape, outputDtype){
        this.outputShape = [];
        this.variableNames = [
            'x',
            'segmentIds'
        ];
        this.uniforms = 'numSegments : i32, xSize: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = outShape;
        this.dispatchLayout = (0, $8e83a93f95f027c6$export$9f192dff395c74d)(inShape);
        this.dispatch = (0, $8e83a93f95f027c6$export$e8b81faf4b51e34b)(this.dispatchLayout, inShape, this.workgroupSize);
        if (outputDtype !== 'float32' && outputDtype !== 'int32') throw new Error(`UnsortedSegmentSum only supports float32 and int32
              types, does not support ${outputDtype} type.`);
        this.type = outputDtype;
        this.shaderKey = 'unsortedSegmentSum';
    }
    getUserCode() {
        const userCode = `
    ${(0, $0533631f1fe2cae9$export$28aacf05d5e9d731)('index')} {
      if (index < uniforms.xSize) {
        let coords = getXCoordsFromIndex(index);
        let b = coords[0];
        let inCol = coords[1];

        let segmentId = i32(getSegmentIds(inCol));
        if (segmentId >= 0) {
          let flatIndex = b * uniforms.numSegments + segmentId % uniforms.numSegments;
          let value = getX(b, inCol);

          ${(0, $7f8c1ed636e4ac12$export$95fdaaf661ca4063)('&result[flatIndex]', 'value', this.type)}
        }
      }
    }
  `;
        return userCode;
    }
}





function $db6faa428bc5c24b$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    let axis = 0;
    const permutation = (0, $f35e0c1a651337db$exports).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) {
        permutedX = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        toDispose.push(permutedX);
        axis = (0, $f35e0c1a651337db$exports).getInnerMostAxes(1, xRank)[0];
    }
    const outShape = (0, $f35e0c1a651337db$exports).segment_util.computeOutShape(permutedX.shape, axis, numSegments);
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape([
        permutedX.shape[axis]
    ]);
    const a2D = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    toDispose.push(a2D);
    const dtype = x.dtype;
    const shape = [
        a2D.shape[0],
        numSegments
    ];
    const output = (0, $3f7d95d3d0bb1b0d$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: shape,
            value: 0,
            dtype: dtype
        }
    });
    const program = new (0, $1b0f1f869df37089$export$71be9d28dd2ad236)(a2D.shape, shape, dtype);
    const uniformData = [
        {
            type: 'int32',
            data: [
                numSegments
            ]
        },
        {
            type: 'int32',
            data: [
                (0, $0775da5e684c8c0d$exports).sizeFromShape(a2D.shape)
            ]
        }
    ];
    const segResult = backend.runWebGPUProgram(program, [
        a2D,
        segmentIds
    ], dtype, uniformData, output);
    const reshaped = (0, $22f5ef2885bdfdf5$export$9eaad88cf88cee2b)({
        inputs: {
            x: segResult
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    toDispose.push(segResult);
    let result = reshaped;
    if (permutation != null) {
        toDispose.push(reshaped);
        const perm = (0, $f35e0c1a651337db$exports).getUndoAxesPermutation(permutation);
        result = (0, $d17e3185b399f73e$export$9cb09a71b7d66923)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: perm
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return result;
}
const $db6faa428bc5c24b$export$71e3626a4ca29968 = {
    kernelName: (0, $507890e4aa8e1463$export$af810663cded5fe2),
    backendName: 'webgpu',
    kernelFunc: $db6faa428bc5c24b$export$ba7c4d144d85a309
};



// List all kernel configs here
const $07d8249659223164$var$kernelConfigs = [
    (0, $4a8e69a37bc0f2a9$export$f70d36da1c218f84),
    (0, $b0beb2984c91405d$export$d66f48648b9d5ec7),
    (0, $bce484a8ced809d4$export$255826ca70737275),
    (0, $ae1cd03edbd311a8$export$3f520b71a56c9e70),
    (0, $371650ba4f8be205$export$b1f3a580afb68e4c),
    (0, $d5d92268ded79447$export$ff8000bc6f0313e1),
    (0, $df1d5a3f46ba30ff$export$4e3f081eb1a330fa),
    (0, $f46546394f4ee777$export$1a8ff634f2df3da6),
    (0, $bdd8269f2dca2b42$export$ec7419fc9ad0069e),
    (0, $521748339c7c65b9$export$21836a5e5fa09eb4),
    (0, $df1d96c3cbe980ac$export$de5cb0ef95dd6700),
    (0, $50112035ba89aae0$export$20d424616c76166),
    (0, $fbbf7ffb0ec2c44b$export$159d632e3ff13624),
    (0, $7f8a5bdf018b4aae$export$c53c7ab019edb8a0),
    (0, $60134a26ea8d2664$export$e9ce1ba75fc9b746),
    (0, $10a97fd5e68dfa23$export$6c901824a23e6150),
    (0, $f95e836468fed162$export$5a9c81d240244392),
    (0, $d587ab757c24c077$export$1eeb8780807d0508),
    (0, $76bb39c837f34b12$export$ac3f8709351ab225),
    (0, $36180c4f94c7c4c7$export$d0dd993198185538),
    (0, $0a7cd4990de6001d$export$44e08e19f97e5513),
    (0, $886c1b7d5adb0636$export$af9f0093738840fb),
    (0, $b3e7133a9986174a$export$8f7b2ec0c6f08fb2),
    (0, $e5c1d83690f88666$export$ac4d0f0f3927a8f3),
    (0, $f875dd35eb850147$export$df387212b1898306),
    (0, $8c83d8a076c30d5c$export$f7ee8f07ce0ff4e1),
    (0, $94b917209ffdee98$export$67917f7910d27fd8),
    (0, $0181ca78e47316de$export$a4817d2978acc054),
    (0, $2a67ed70be2df080$export$c8cf96dae25282e5),
    (0, $567c4e1f571a0d9e$export$4a39bf13b4378042),
    (0, $68d687ad28cbda96$export$7a95f55d2d2e7d24),
    (0, $576b0dae588f8198$export$19bbc19fff1ed26f),
    (0, $c40aa2ab17d638a0$export$1fe590fda0829040),
    (0, $859c5fbafb0d4aa0$export$6dce9169640850fa),
    (0, $5388c17cea921b14$export$40ece1caaaf084b2),
    (0, $495a6ae661d06089$export$ff099a1da5235a7e),
    (0, $c4b3baf836b397c2$export$c5824052b09ba0ed),
    (0, $41779e8d85e01aab$export$f7086edcf0050c7f),
    (0, $21bb4613ed08f372$export$db50d81ed60c5a35),
    (0, $6cada2a4f2eececd$export$2f6196f3316e7ed2),
    (0, $25be7e6cd1792cbe$export$88ba267b84334692),
    (0, $20430029a9dc6be1$export$9c5b88dcb1d2008b),
    (0, $4ace6e29dd7d9dd0$export$30bc0ac3775583fc),
    (0, $395321f3e3a4ddd0$export$55d12409e744bebe),
    (0, $a0161762b26e00a8$export$240667804b7c390e),
    (0, $c7dcbf918ad0c0a0$export$56dc5d812a22748f),
    (0, $e21cc877880208e1$export$36d3c11f61a8891a),
    (0, $dd92049c124e10b3$export$cf83abe0e8c87ce8),
    (0, $fb39d7cac5895593$export$42e4451417dc5ea0),
    (0, $7cf29044158b365d$export$917213cafa72964b),
    (0, $0c3190a8b76ce612$export$40bbf341885a23b7),
    (0, $995ef7a5aa8aa095$export$b990686634ee3cce),
    (0, $ce6d45596ea87001$export$59bb07dd04647a1d),
    (0, $45522c2607904f92$export$3c8bc3d8ee318217),
    (0, $8fa24252b18dca8c$export$d044ffef16079bd),
    (0, $b64311930618399e$export$2fd7ea0fcf021f34),
    (0, $26998513a525e7c2$export$86341ba0ce5d8e60),
    (0, $80e0463d1c862033$export$16db8a08b36f938),
    (0, $0fc3d0c8c28fe0b5$export$a4d564e380763c78),
    (0, $3f7d95d3d0bb1b0d$export$c953bf474b2bde62),
    (0, $dbda0389733c0764$export$c9ec83cb23304466),
    (0, $4843c5d9e48cd72f$export$b22e14d614fc7178),
    (0, $1e5b3ac86a30009d$export$7e9a0f96fa6bd01c),
    (0, $f371bd44afc40e31$export$7eac933a0c7fd37f),
    (0, $e34a1aeb7eca700a$export$bfc6b905951b4903),
    (0, $050329eea2323ea1$export$5b64efa829ddf94e),
    (0, $1179d5c4f42260f6$export$58481cc3409b412c),
    (0, $cde9848693cf1385$export$d9700eb1c7f5c969),
    (0, $2f071354cda7fee0$export$b1bd3139c91d8765),
    (0, $6add830524063c1c$export$8c4f7e92d92310f8),
    (0, $eb00d03dc30c68cb$export$7a6926f9fcac24ca),
    (0, $c76b17881110536c$export$c426d3942537ad84),
    (0, $59acff9bfcbad9aa$export$dc267425bf21b465),
    (0, $10ab56078456f8d4$export$ddfc128c2801add7),
    (0, $a0b35f4fe5737cc4$export$4d45c8f7b9ffdaf1),
    (0, $40d3d87113413fdd$export$bc383b82282e9b5a),
    (0, $4fc3a7323c3242c6$export$d58ff790c765c1f0),
    (0, $c8a9d59b0569b279$export$aa04ab963fdf437f),
    (0, $694410787c8c43d8$export$8d4530ce8b6ffc3c),
    (0, $23de7bc674936aa0$export$9f26bd257393dd8),
    (0, $436a0529f8887866$export$46b96f742c70959b),
    (0, $fbd6b145d84339cc$export$c458b9e5ba980198),
    (0, $dbb72f3513f3bf29$export$a4ae1f00643ddd14),
    (0, $30665312aa29173b$export$257f1e82e69113fb),
    (0, $7291e10ca8dd8c21$export$68e2dd0840056271),
    (0, $930860af0431f209$export$ce04b6546987ef43),
    (0, $9a8e15be15db11fd$export$8817e4cec9f1a309),
    (0, $ec852d14727809c9$export$9250622395b66a34),
    (0, $24c613ac367ff181$export$7d79147246e312bb),
    (0, $bdf47426e27731ff$export$45b97bdc342e72a2),
    (0, $6b2814b009ee010b$export$45c8263b38f19e33),
    (0, $847218d261768cc9$export$e01a7f8dbee29127),
    (0, $7a9f38f4fa1692c3$export$91a8fc5da39ec855),
    (0, $d5104e48ebacf4a7$export$5201426bb10bd5eb),
    (0, $5a4369133ca3a3d1$export$a069ee2247a7d1ce),
    (0, $ccebf01d47069530$export$b934af0ccd0cdbe1),
    (0, $ef39e986cf27a638$export$3cd9f9a31b38cf18),
    (0, $d2225bb3536c52a2$export$ea24ffbbbce8d546),
    (0, $822e9528f71a9801$export$2cfd6c6c7daeb5fc),
    (0, $79072cb2e80d3ece$export$9037685a81180a9c),
    (0, $6c8d4c16c81c70c2$export$ad960e364767f0e2),
    (0, $24358616068660dd$export$745576778aafee88),
    (0, $1d050e4135d5ad8b$export$cc7b18b8229c3db),
    (0, $13b9efbf574374eb$export$549561cd158f260a),
    (0, $2c62aebf50633014$export$4c00b682f309701d),
    (0, $e54f7fc9b0aeee77$export$d003d4d7e1500775),
    (0, $b4f47e2cbb241cd4$export$dde5645b472b80b2),
    (0, $f1adb5ac59d8775f$export$d8d7015eb6ab37d0),
    (0, $df6ec86f7921c17c$export$1645fa8803aa1f86),
    (0, $a1e920c578521c08$export$b0317e720bfd61fc),
    (0, $18e24bc4b0c7ce46$export$b823d49786719761),
    (0, $1f4448788a609541$export$a5c4a9b694579636),
    (0, $3ff7c2614a3691c3$export$d556aa935cef5c0c),
    (0, $b78b70a061082d3c$export$361c4075706e31c2),
    (0, $ee772b4e6a775b63$export$4b7bce57557ae68b),
    (0, $102c994c94c63a45$export$15c5d6176b30b9a6),
    (0, $3082ce57b5e9461f$export$412a6b66203fdf72),
    (0, $0fd63ba29ba0a32d$export$731f9199bde068eb),
    (0, $934c938efb9a05f8$export$92c30890ad649d53),
    (0, $22f5ef2885bdfdf5$export$cfa02e698602aca2),
    (0, $b9379eb815f3366f$export$a37a56137abc1357),
    (0, $f4b24576cb0fd0c4$export$51f84ca614e84763),
    (0, $30761f9aa303a75e$export$2b6a92caba113b89),
    (0, $e8c580e973e9774c$export$2b08d810b5090fe1),
    (0, $41d789617b483720$export$cab6a4e8d2ed8e8d),
    (0, $d90024d15bd0b9cc$export$44ba8c83417ab668),
    (0, $5b5bcf5b55064ff7$export$6c09e3291f636503),
    (0, $8330d4dfa9d1f81a$export$941104b789956ef6),
    (0, $5b3ee3851afefc27$export$573371744f044f5),
    (0, $3001c96e457e8ebd$export$4b437b1a1aa6472f),
    (0, $d4d1421f5a4b56d8$export$7ff911e710ee72fc),
    (0, $e0d67dd337d79231$export$8afc8558705c1a39),
    (0, $2ae3133b7c267a50$export$195d1cf7c59f3ef),
    (0, $6deb96ce3720149f$export$9c0fb3eb2124ceb7),
    (0, $7082cd724d16d91e$export$d993ec4e5c253b66),
    (0, $e66396c12d7d037e$export$b92766b47f18ac85),
    (0, $fc251d31bd35efe1$export$8d8a1e11dd2cc6c4),
    (0, $f41f2711fbbe7d70$export$c42ffaf52eb2647),
    (0, $b3c0e0952b3cb9fe$export$81773633114187bd),
    (0, $a1cce26373e9cb41$export$35e13284eed34c22),
    (0, $10988fb9b207e23c$export$c022691f23e2ee69),
    (0, $9ed2047a4b9c3a97$export$d9bcfe553d12d9e3),
    (0, $b278264c794dbb85$export$2f85417863d2050b),
    (0, $99f83f1a2687d476$export$51e7224ae14d7f78),
    (0, $e8b7646f21c3a062$export$73fa0270f28b9555),
    (0, $50a0323119cf2e99$export$7bc088f8ad44ef99),
    (0, $66cdb1417c8ddd16$export$317be24be3af9ea0),
    (0, $9bee9c462b381dc8$export$a592ba9268f10eeb),
    (0, $d897b52d7ec34503$export$7c77bece4d51efc4),
    (0, $1a8c047e2f2aefc8$export$9ed4691d69db8a43),
    (0, $7946318b648a3f8b$export$5d068476dad60c4d),
    (0, $5b2ff23a08187cd4$export$47edea402251c258),
    (0, $5471e11807dcfc5d$export$97648844df7611f3),
    (0, $7ac45886e5a89518$export$a2fc7de1a1e4eee0),
    (0, $d7f7673bbcd15338$export$2819813ce8339b64),
    (0, $b4adca6d6116343c$export$a5a9f8050ba7f41e),
    (0, $3c15f267db0cc255$export$cffaee31213314ce),
    (0, $bc81a600a1b97b74$export$1c7a3de6335954ed),
    (0, $d17e3185b399f73e$export$895a002a39b774be),
    (0, $e9c6dc7432c7e61f$export$d06292128cae50d6),
    (0, $db6faa428bc5c24b$export$71e3626a4ca29968),
    (0, $40498200f1e85b5e$export$15368df05c479e41)
];
for (const kernelConfig of $07d8249659223164$var$kernelConfigs)(0, $071cf1fd9dc2117e$export$f3f7c443f3a606e6)(kernelConfig);




var $a54e498d8d862fdc$var$L = function(t, e) {
    return ($a54e498d8d862fdc$var$L = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    })(t, e);
};
function $a54e498d8d862fdc$var$V(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    $a54e498d8d862fdc$var$L(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var $a54e498d8d862fdc$var$B = function() {
    return ($a54e498d8d862fdc$var$B = Object.assign || function(t) {
        for(var e, n = 1, i = arguments.length; n < i; n++)for(var r in e = arguments[n])Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t;
    }).apply(this, arguments);
};
function $a54e498d8d862fdc$var$N(t, e, n, i) {
    return new (n || (n = Promise))(function(r, o) {
        function a(t) {
            try {
                u(i.next(t));
            } catch (t) {
                o(t);
            }
        }
        function s(t) {
            try {
                u(i.throw(t));
            } catch (t) {
                o(t);
            }
        }
        function u(t) {
            var e;
            t.done ? r(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) {
                t(e);
            })).then(a, s);
        }
        u((i = i.apply(t, e || [])).next());
    });
}
function $a54e498d8d862fdc$var$D(t, e) {
    var n, i, r, o, a = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, i && (r = 2 & o[0] ? i.return : o[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, o[1])).done) return r;
                    switch(i = 0, r && (o = [
                        2 & o[0],
                        r.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            r = o;
                            break;
                        case 4:
                            return a.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            a.label++, i = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                a.label = o[1];
                                break;
                            }
                            if (6 === o[0] && a.label < r[1]) {
                                a.label = r[1], r = o;
                                break;
                            }
                            if (r && a.label < r[2]) {
                                a.label = r[2], a.ops.push(o);
                                break;
                            }
                            r[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    o = e.call(t, a);
                } catch (t) {
                    o = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}
function $a54e498d8d862fdc$var$K(t, e, n) {
    if (n || 2 === arguments.length) for(var i, r = 0, o = e.length; r < o; r++)!i && r in e || (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
    return t.concat(i || Array.prototype.slice.call(e));
}
var $a54e498d8d862fdc$var$U = [
    "nose",
    "left_eye",
    "right_eye",
    "left_ear",
    "right_ear",
    "left_shoulder",
    "right_shoulder",
    "left_elbow",
    "right_elbow",
    "left_wrist",
    "right_wrist",
    "left_hip",
    "right_hip",
    "left_knee",
    "right_knee",
    "left_ankle",
    "right_ankle"
], $a54e498d8d862fdc$var$j = [
    "nose",
    "left_eye_inner",
    "left_eye",
    "left_eye_outer",
    "right_eye_inner",
    "right_eye",
    "right_eye_outer",
    "left_ear",
    "right_ear",
    "mouth_left",
    "mouth_right",
    "left_shoulder",
    "right_shoulder",
    "left_elbow",
    "right_elbow",
    "left_wrist",
    "right_wrist",
    "left_pinky",
    "right_pinky",
    "left_index",
    "right_index",
    "left_thumb",
    "right_thumb",
    "left_hip",
    "right_hip",
    "left_knee",
    "right_knee",
    "left_ankle",
    "right_ankle",
    "left_heel",
    "right_heel",
    "left_foot_index",
    "right_foot_index"
], $a54e498d8d862fdc$var$H = {
    left: [
        1,
        2,
        3,
        7,
        9,
        11,
        13,
        15,
        17,
        19,
        21,
        23,
        25,
        27,
        29,
        31
    ],
    right: [
        4,
        5,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30,
        32
    ],
    middle: [
        0
    ]
}, $a54e498d8d862fdc$var$q = {
    left: [
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        15
    ],
    right: [
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16
    ],
    middle: [
        0
    ]
}, $a54e498d8d862fdc$var$X = [
    [
        0,
        1
    ],
    [
        0,
        2
    ],
    [
        1,
        3
    ],
    [
        2,
        4
    ],
    [
        5,
        6
    ],
    [
        5,
        7
    ],
    [
        5,
        11
    ],
    [
        6,
        8
    ],
    [
        6,
        12
    ],
    [
        7,
        9
    ],
    [
        8,
        10
    ],
    [
        11,
        12
    ],
    [
        11,
        13
    ],
    [
        12,
        14
    ],
    [
        13,
        15
    ],
    [
        14,
        16
    ]
], $a54e498d8d862fdc$var$Y = [
    [
        0,
        1
    ],
    [
        0,
        4
    ],
    [
        1,
        2
    ],
    [
        2,
        3
    ],
    [
        3,
        7
    ],
    [
        4,
        5
    ],
    [
        5,
        6
    ],
    [
        6,
        8
    ],
    [
        9,
        10
    ],
    [
        11,
        12
    ],
    [
        11,
        13
    ],
    [
        11,
        23
    ],
    [
        12,
        14
    ],
    [
        14,
        16
    ],
    [
        12,
        24
    ],
    [
        13,
        15
    ],
    [
        15,
        17
    ],
    [
        16,
        18
    ],
    [
        16,
        20
    ],
    [
        15,
        17
    ],
    [
        15,
        19
    ],
    [
        15,
        21
    ],
    [
        16,
        22
    ],
    [
        17,
        19
    ],
    [
        18,
        20
    ],
    [
        23,
        25
    ],
    [
        23,
        24
    ],
    [
        24,
        26
    ],
    [
        25,
        27
    ],
    [
        26,
        28
    ],
    [
        27,
        29
    ],
    [
        28,
        30
    ],
    [
        27,
        31
    ],
    [
        28,
        32
    ],
    [
        29,
        31
    ],
    [
        30,
        32
    ]
];
function $a54e498d8d862fdc$var$W(t) {
    return t instanceof SVGAnimatedLength ? t.baseVal.value : t;
}
function $a54e498d8d862fdc$var$G(t) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, r;
        return $a54e498d8d862fdc$var$D(this, function(o) {
            switch(o.label){
                case 0:
                    return i = document.createElement("canvas"), t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? [
                        4,
                        (0, $79d3f34cef1b5242$exports).toPixels(t, i)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return o.sent(), [
                        3,
                        3
                    ];
                case 2:
                    i.width = $a54e498d8d862fdc$var$W(t.width), i.height = $a54e498d8d862fdc$var$W(t.height), r = i.getContext("2d"), t instanceof ImageData ? r.putImageData(t, 0, 0) : r.drawImage(t, 0, 0), o.label = 3;
                case 3:
                    return [
                        2,
                        i
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$Q(t) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u;
        return $a54e498d8d862fdc$var$D(this, function(h) {
            switch(h.label){
                case 0:
                    return t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? (i = t.shape.slice(0, 2), r = i[0], o = i[1], a = ImageData.bind, [
                        4,
                        (0, $79d3f34cef1b5242$exports).toPixels(t)
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return [
                        2,
                        new (a.apply(ImageData, [
                            void 0,
                            h.sent(),
                            o,
                            r
                        ]))
                    ];
                case 2:
                    return s = document.createElement("canvas"), u = s.getContext("2d"), s.width = $a54e498d8d862fdc$var$W(t.width), s.height = $a54e498d8d862fdc$var$W(t.height), u.drawImage(t, 0, 0), [
                        2,
                        u.getImageData(0, 0, s.width, s.height)
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$Z(t) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var e, i;
        return $a54e498d8d862fdc$var$D(this, function(r) {
            switch(r.label){
                case 0:
                    return t instanceof SVGImageElement || t instanceof OffscreenCanvas ? [
                        4,
                        $a54e498d8d862fdc$var$G(t)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return i = r.sent(), [
                        3,
                        3
                    ];
                case 2:
                    i = t, r.label = 3;
                case 3:
                    return e = i, [
                        2,
                        (0, $79d3f34cef1b5242$exports).fromPixels(e, 4)
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$$(t) {
    if (t < 0 || t >= 256) throw new Error("Mask value must be in range [0, 255] but got ".concat(t));
    if (!Number.isInteger(t)) throw new Error("Mask value must be an integer but got ".concat(t));
}
var $a54e498d8d862fdc$var$J = {
    runtime: "mediapipe",
    enableSmoothing: !0,
    enableSegmentation: !1,
    smoothSegmentation: !0,
    modelType: "full"
};
var $a54e498d8d862fdc$var$tt = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(t) {
                return [
                    2,
                    $a54e498d8d862fdc$var$Q(this.mask)
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(t) {
                return [
                    2,
                    $a54e498d8d862fdc$var$Z(this.mask)
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "canvasimagesource";
    }, t;
}();
function $a54e498d8d862fdc$var$et(t) {
    return $a54e498d8d862fdc$var$$(t), "person";
}
var $a54e498d8d862fdc$var$nt = function() {
    function i(e) {
        var n, i = this;
        switch(this.width = 0, this.height = 0, this.selfieMode = !1, this.poseSolution = new (0, $670e4c2ab08b8e48$exports.Pose)({
            locateFile: function(t, n) {
                if (e.solutionPath) {
                    var i = e.solutionPath.replace(/\/+$/, "");
                    return "".concat(i, "/").concat(t);
                }
                return "".concat(n, "/").concat(t);
            }
        }), e.modelType){
            case "lite":
                n = 0;
                break;
            case "heavy":
                n = 2;
                break;
            case "full":
            default:
                n = 1;
        }
        this.poseSolution.setOptions({
            modelComplexity: n,
            smoothLandmarks: e.enableSmoothing,
            enableSegmentation: e.enableSegmentation,
            smoothSegmentation: e.smoothSegmentation,
            selfieMode: this.selfieMode
        }), this.poseSolution.onResults(function(t) {
            if (i.height = t.image.height, i.width = t.image.width, null == t.poseLandmarks) i.poses = [];
            else {
                var e = i.translateOutput(t.poseLandmarks, t.poseWorldLandmarks);
                t.segmentationMask && (e.segmentation = {
                    maskValueToLabel: $a54e498d8d862fdc$var$et,
                    mask: new $a54e498d8d862fdc$var$tt(t.segmentationMask)
                }), i.poses = [
                    e
                ];
            }
        });
    }
    return i.prototype.translateOutput = function(t, e) {
        var n = this, i = {
            keypoints: t.map(function(t, e) {
                return {
                    x: t.x * n.width,
                    y: t.y * n.height,
                    z: t.z,
                    score: t.visibility,
                    name: $a54e498d8d862fdc$var$j[e]
                };
            })
        };
        return null != e && (i.keypoints3D = e.map(function(t, e) {
            return {
                x: t.x,
                y: t.y,
                z: t.z,
                score: t.visibility,
                name: $a54e498d8d862fdc$var$j[e]
            };
        })), i;
    }, i.prototype.estimatePoses = function(t, i, r) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var o, a;
            return $a54e498d8d862fdc$var$D(this, function(s) {
                switch(s.label){
                    case 0:
                        return i && i.flipHorizontal && i.flipHorizontal !== this.selfieMode && (this.selfieMode = i.flipHorizontal, this.poseSolution.setOptions({
                            selfieMode: this.selfieMode
                        })), t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? (a = ImageData.bind, [
                            4,
                            (0, $79d3f34cef1b5242$exports).toPixels(t)
                        ]) : [
                            3,
                            2
                        ];
                    case 1:
                        return o = new (a.apply(ImageData, [
                            void 0,
                            s.sent(),
                            t.shape[1],
                            t.shape[0]
                        ])), [
                            3,
                            3
                        ];
                    case 2:
                        o = t, s.label = 3;
                    case 3:
                        return t = o, [
                            4,
                            this.poseSolution.send({
                                image: t
                            }, r)
                        ];
                    case 4:
                        return s.sent(), [
                            2,
                            this.poses
                        ];
                }
            });
        });
    }, i.prototype.dispose = function() {
        this.poseSolution.close();
    }, i.prototype.reset = function() {
        this.poseSolution.reset();
    }, i.prototype.initialize = function() {
        return this.poseSolution.initialize();
    }, i;
}();
function $a54e498d8d862fdc$var$it(t) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var e, n;
        return $a54e498d8d862fdc$var$D(this, function(i) {
            switch(i.label){
                case 0:
                    return e = function(t) {
                        if (null == t) return $a54e498d8d862fdc$var$B({}, $a54e498d8d862fdc$var$J);
                        var e = $a54e498d8d862fdc$var$B({}, t);
                        return e.runtime = "mediapipe", null == e.enableSegmentation && (e.enableSegmentation = $a54e498d8d862fdc$var$J.enableSegmentation), null == e.enableSmoothing && (e.enableSmoothing = $a54e498d8d862fdc$var$J.enableSmoothing), null == e.smoothSegmentation && (e.smoothSegmentation = $a54e498d8d862fdc$var$J.smoothSegmentation), null == e.modelType && (e.modelType = $a54e498d8d862fdc$var$J.modelType), e;
                    }(t), [
                        4,
                        (n = new $a54e498d8d862fdc$var$nt(e)).initialize()
                    ];
                case 1:
                    return i.sent(), [
                        2,
                        n
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$rt(t) {
    return t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? {
        height: t.shape[0],
        width: t.shape[1]
    } : {
        height: t.height,
        width: t.width
    };
}
function $a54e498d8d862fdc$var$ot(t) {
    return t - 2 * Math.PI * Math.floor((t + Math.PI) / (2 * Math.PI));
}
function $a54e498d8d862fdc$var$at(t) {
    return t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) ? t : (0, $79d3f34cef1b5242$exports).fromPixels(t);
}
function $a54e498d8d862fdc$var$st(t, e, n) {
    return $a54e498d8d862fdc$var$ut(n, "inputResolution"), [
        1 / n.width * t[0][0] * e.width,
        1 / n.height * t[0][1] * e.width,
        t[0][3] * e.width,
        1 / n.width * t[1][0] * e.height,
        1 / n.height * t[1][1] * e.height,
        t[1][3] * e.height,
        0,
        0
    ];
}
function $a54e498d8d862fdc$var$ut(t, e) {
    (0, $0775da5e684c8c0d$exports).assert(0 !== t.width, function() {
        return "".concat(e, " width cannot be 0.");
    }), (0, $0775da5e684c8c0d$exports).assert(0 !== t.height, function() {
        return "".concat(e, " height cannot be 0.");
    });
}
function $a54e498d8d862fdc$var$ht(t, e, n) {
    var i = n.rotationVectorStartKeypointIndex, r = n.rotationVectorEndKeypointIndex, o = t.locationData, a = o.relativeKeypoints[i].x * e.width, s = o.relativeKeypoints[i].y * e.height, u = o.relativeKeypoints[r].x * e.width, h = o.relativeKeypoints[r].y * e.height, l = 2 * Math.sqrt((u - a) * (u - a) + (h - s) * (h - s)), c = function(t, e, n) {
        var i, r = t.locationData, o = n.rotationVectorStartKeypointIndex, a = n.rotationVectorEndKeypointIndex;
        i = n.rotationVectorTargetAngle ? n.rotationVectorTargetAngle : Math.PI * n.rotationVectorTargetAngleDegree / 180;
        var s = r.relativeKeypoints[o].x * e.width, u = r.relativeKeypoints[o].y * e.height, h = r.relativeKeypoints[a].x * e.width, l = r.relativeKeypoints[a].y * e.height;
        return $a54e498d8d862fdc$var$ot(i - Math.atan2(-(l - u), h - s));
    }(t, e, n);
    return {
        xCenter: a / e.width,
        yCenter: s / e.height,
        width: l / e.width,
        height: l / e.height,
        rotation: c
    };
}
function $a54e498d8d862fdc$var$lt(t) {
    if (16 !== t.length) throw new Error("Array length must be 16 but got ".concat(t.length));
    return [
        [
            t[0],
            t[1],
            t[2],
            t[3]
        ],
        [
            t[4],
            t[5],
            t[6],
            t[7]
        ],
        [
            t[8],
            t[9],
            t[10],
            t[11]
        ],
        [
            t[12],
            t[13],
            t[14],
            t[15]
        ]
    ];
}
function $a54e498d8d862fdc$var$ct(t, e, n, i, r, o, a) {
    return t[e][r] * (t[n][o] * t[i][a] - t[n][a] * t[i][o]);
}
function $a54e498d8d862fdc$var$pt(t, e, n) {
    var i = (e + 1) % 4, r = (e + 2) % 4, o = (e + 3) % 4, a = (n + 1) % 4, s = (n + 2) % 4, u = (n + 3) % 4;
    return $a54e498d8d862fdc$var$ct(t, i, r, o, a, s, u) + $a54e498d8d862fdc$var$ct(t, r, o, i, a, s, u) + $a54e498d8d862fdc$var$ct(t, o, i, r, a, s, u);
}
function $a54e498d8d862fdc$var$ft(t, e, n) {
    void 0 === n && (n = {
        ignoreRotation: !1
    });
    for(var i = [], r = 0, o = t; r < o.length; r++){
        var a = o[r], s = a.x - .5, u = a.y - .5, h = n.ignoreRotation ? 0 : e.rotation, l = Math.cos(h) * s - Math.sin(h) * u, c = Math.sin(h) * s + Math.cos(h) * u;
        l = l * e.width + e.xCenter, c = c * e.height + e.yCenter;
        var p = a.z * e.width, f = $a54e498d8d862fdc$var$B({}, a);
        f.x = l, f.y = c, f.z = p, i.push(f);
    }
    return i;
}
function $a54e498d8d862fdc$var$dt(t, e) {
    var n = function(t, e, n, i) {
        var r = e - t, o = i - n;
        if (0 === r) throw new Error("Original min and max are both ".concat(t, ", range cannot be 0."));
        var a = o / r;
        return {
            scale: a,
            offset: n - t * a
        };
    }(0, 255, e[0], e[1]);
    return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
        return (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(t, n.scale), n.offset);
    });
}
function $a54e498d8d862fdc$var$mt(t, e, n) {
    var i, o, a, c, p, f, d, m, g, y, v, x, w, k, b = e.outputTensorSize, M = e.keepAspectRatio, S = e.borderMode, T = e.outputTensorFloatRange, P = $a54e498d8d862fdc$var$rt(t), F = function(t, e) {
        return e ? {
            xCenter: e.xCenter * t.width,
            yCenter: e.yCenter * t.height,
            width: e.width * t.width,
            height: e.height * t.height,
            rotation: e.rotation
        } : {
            xCenter: .5 * t.width,
            yCenter: .5 * t.height,
            width: t.width,
            height: t.height,
            rotation: 0
        };
    }(P, n), _ = function(t, e, n) {
        if (void 0 === n && (n = !1), !n) return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
        var i = e.height, r = e.width;
        $a54e498d8d862fdc$var$ut(e, "targetSize"), $a54e498d8d862fdc$var$ut(t, "roi");
        var o, a, s = i / r, u = t.height / t.width, h = 0, l = 0;
        return s > u ? (o = t.width, a = t.width * s, l = (1 - u / s) / 2) : (o = t.height / s, a = t.height, h = (1 - s / u) / 2), t.width = o, t.height = a, {
            top: l,
            left: h,
            right: h,
            bottom: l
        };
    }(F, b, M), O = (i = F, o = P.width, a = P.height, c = !1, p = i.width, f = i.height, d = c ? -1 : 1, m = Math.cos(i.rotation), g = Math.sin(i.rotation), y = i.xCenter, v = i.yCenter, x = 1 / o, w = 1 / a, (k = new Array(16))[0] = p * m * d * x, k[1] = -f * g * x, k[2] = 0, k[3] = (-0.5 * p * m * d + .5 * f * g + y) * x, k[4] = p * g * d * w, k[5] = f * m * w, k[6] = 0, k[7] = (-0.5 * f * m - .5 * p * g * d + v) * w, k[8] = 0, k[9] = 0, k[10] = p * x, k[11] = 0, k[12] = 0, k[13] = 0, k[14] = 0, k[15] = 1, $a54e498d8d862fdc$var$lt(k));
    return {
        imageTensor: (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
            var e = $a54e498d8d862fdc$var$at(t), n = (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)($a54e498d8d862fdc$var$st(O, P, b), [
                1,
                8
            ]), i = "zero" === S ? "constant" : "nearest", r = (0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).transform((0, $31018343da089cd7$export$d660d8ed21f46635)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)(e, "float32")), n, "bilinear", i, 0, [
                b.height,
                b.width
            ]);
            return null != T ? $a54e498d8d862fdc$var$dt(r, T) : r;
        }),
        padding: _,
        transformationMatrix: O
    };
}
function $a54e498d8d862fdc$var$gt(t, e, n, i) {
    return 1 === i ? .5 * (t + e) : t + (e - t) * n / (i - 1);
}
function $a54e498d8d862fdc$var$yt(t) {
    return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
        var e = function(t) {
            return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                return [
                    (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                        0,
                        0,
                        0
                    ], [
                        1,
                        -1,
                        1
                    ]),
                    (0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                        0,
                        0,
                        1
                    ], [
                        1,
                        -1,
                        -1
                    ])
                ];
            });
        }(t), n = e[0], i = e[1];
        return {
            boxes: (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(i),
            logits: (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(n)
        };
    });
}
function $a54e498d8d862fdc$var$vt(t) {
    return null != t && null != t.currentTime;
}
function $a54e498d8d862fdc$var$xt(t) {
    for(var e = {
        locationData: {
            relativeKeypoints: []
        }
    }, n = Number.MAX_SAFE_INTEGER, i = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER, o = Number.MIN_SAFE_INTEGER, a = 0; a < t.length; ++a){
        var s = t[a];
        n = Math.min(n, s.x), i = Math.max(i, s.x), r = Math.min(r, s.y), o = Math.max(o, s.y), e.locationData.relativeKeypoints.push({
            x: s.x,
            y: s.y
        });
    }
    return e.locationData.relativeBoundingBox = {
        xMin: n,
        yMin: r,
        xMax: i,
        yMax: o,
        width: i - n,
        height: o - r
    }, e;
}
function $a54e498d8d862fdc$var$wt(t, e, n, i) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, r, o, a, h;
        return $a54e498d8d862fdc$var$D(this, function(l) {
            switch(l.label){
                case 0:
                    return t.sort(function(t, e) {
                        return Math.max.apply(Math, e.score) - Math.max.apply(Math, t.score);
                    }), i = (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)(t.map(function(t) {
                        return [
                            t.locationData.relativeBoundingBox.yMin,
                            t.locationData.relativeBoundingBox.xMin,
                            t.locationData.relativeBoundingBox.yMax,
                            t.locationData.relativeBoundingBox.xMax
                        ];
                    })), r = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(t.map(function(t) {
                        return t.score[0];
                    })), [
                        4,
                        (0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).nonMaxSuppressionAsync(i, r, e, n)
                    ];
                case 1:
                    return [
                        4,
                        (o = l.sent()).array()
                    ];
                case 2:
                    return a = l.sent(), h = t.filter(function(t, e) {
                        return a.indexOf(e) > -1;
                    }), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)([
                        i,
                        r,
                        o
                    ]), [
                        2,
                        h
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$kt(t, e) {
    return t.map(function(t) {
        var n = $a54e498d8d862fdc$var$B($a54e498d8d862fdc$var$B({}, t), {
            x: t.x * e.width,
            y: t.y * e.height
        });
        return null != t.z && (n.z = t.z * e.width), n;
    });
}
function $a54e498d8d862fdc$var$bt(t, e, n) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u, h, l, c, f, d, m, g, y, v, x, w, k, b, M, S, T, P, F;
        return $a54e498d8d862fdc$var$D(this, function(_) {
            switch(_.label){
                case 0:
                    if (i = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(e, [
                        0
                    ]), r = i.shape, o = r[0], a = r[1], s = r[2], t.length !== s) throw new Error("Expected heatmap to have same number of channels as the number of landmarks. But got landmarks length: " + "".concat(t.length, ", heatmap length: ").concat(s));
                    return u = [], [
                        4,
                        i.buffer()
                    ];
                case 1:
                    for(h = _.sent(), l = 0; l < t.length; l++)if (c = t[l], f = $a54e498d8d862fdc$var$B({}, c), u.push(f), d = Math.trunc(f.x * a), m = Math.trunc(f.y * o), !(d < 0 || d >= a || m < 0 || d >= o)) {
                        for(g = Math.trunc((n.kernelSize - 1) / 2), y = Math.max(0, d - g), v = Math.min(a, d + g + 1), x = Math.max(0, m - g), w = Math.min(o, m + g + 1), k = 0, b = 0, M = 0, S = 0, T = x; T < w; ++T)for(P = y; P < v; ++P)F = h.get(T, P, l), k += F, S = Math.max(S, F), b += P * F, M += T * F;
                        S >= n.minConfidenceToRefine && k > 0 && (f.x = b / a / k, f.y = M / o / k);
                    }
                    return i.dispose(), [
                        2,
                        u
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$Mt(t, e) {
    var n = e.left, i = e.top, r = e.left + e.right, o = e.top + e.bottom;
    return t.map(function(t) {
        return $a54e498d8d862fdc$var$B($a54e498d8d862fdc$var$B({}, t), {
            x: (t.x - n) / (1 - r),
            y: (t.y - i) / (1 - o),
            z: t.z / (1 - r)
        });
    });
}
function $a54e498d8d862fdc$var$St(t, e, n) {
    return "webgl" === (0, $8a461ef06e070cc9$export$b098501f764cdf30)() ? function(t, e, n) {
        var i = n.combineWithPreviousRatio.toFixed(2), o = {
            variableNames: [
                "prevMask",
                "newMask"
            ],
            outputShape: t.shape,
            userCode: "\n  void main() {\n      ivec2 coords = getOutputCoords();\n      int height = coords[0];\n      int width = coords[1];\n\n      float prevMaskValue = getPrevMask(height, width);\n      float newMaskValue = getNewMask(height, width);\n\n      /*\n      * Assume p := newMaskValue\n      * H(p) := 1 + (p * log(p) + (1-p) * log(1-p)) / log(2)\n      * uncertainty alpha(p) =\n      *   Clamp(1 - (1 - H(p)) * (1 - H(p)), 0, 1) [squaring the\n      * uncertainty]\n      *\n      * The following polynomial approximates uncertainty alpha as a\n      * function of (p + 0.5):\n      */\n      const float c1 = 5.68842;\n      const float c2 = -0.748699;\n      const float c3 = -57.8051;\n      const float c4 = 291.309;\n      const float c5 = -624.717;\n      float t = newMaskValue - 0.5;\n      float x = t * t;\n\n      float uncertainty =\n        1.0 - min(1.0, x * (c1 + x * (c2 + x * (c3 + x * (c4 + x * c5)))));\n\n      float outputValue = newMaskValue + (prevMaskValue - newMaskValue) *\n                             (uncertainty * ".concat(i, ");\n\n      setOutput(outputValue);\n    }\n")
        }, a = (0, $8a461ef06e070cc9$export$32a253b6f8b50fb4)();
        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
            var n = a.compileAndRun(o, [
                t,
                e
            ]);
            return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromDataId(n.dataId, n.shape, n.dtype);
        });
    }(t, e, n) : (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
        var i = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(e, .5), r = (0, $7c706d812ea019b4$export$dd4f28cef696bc7d)(i), s = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(1, (0, $4315eb3f5ec9063a$export$916782c1f0ddb132)(1, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(r, (0, $8efd352f234ac278$export$e16d8520af44a096)(5.68842, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(r, (0, $8efd352f234ac278$export$e16d8520af44a096)(-0.748699, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(r, (0, $8efd352f234ac278$export$e16d8520af44a096)(-57.8051, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(r, (0, $8efd352f234ac278$export$e16d8520af44a096)(291.309, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(r, -624.717)))))))))));
        return (0, $8efd352f234ac278$export$e16d8520af44a096)(e, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $6b10a09db634e9ba$export$f93b5905241a7cca)(t, e), (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(s, n.combineWithPreviousRatio)));
    });
}
function $a54e498d8d862fdc$var$Tt(t, e, n) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, s, u, h, l;
        return $a54e498d8d862fdc$var$D(this, function(d) {
            switch(d.label){
                case 0:
                    return i = t[0], s = t[1], u = function(t, e, n) {
                        return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                            var i, r, s, u;
                            n.reverseOutputOrder ? (r = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 0
                            ], [
                                -1,
                                1
                            ])), i = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 1
                            ], [
                                -1,
                                1
                            ])), u = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 2
                            ], [
                                -1,
                                1
                            ])), s = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 3
                            ], [
                                -1,
                                1
                            ]))) : (i = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 0
                            ], [
                                -1,
                                1
                            ])), r = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 1
                            ], [
                                -1,
                                1
                            ])), s = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 2
                            ], [
                                -1,
                                1
                            ])), u = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                0,
                                n.boxCoordOffset + 3
                            ], [
                                -1,
                                1
                            ]))), r = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(r, n.xScale), e.w), e.x), i = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(i, n.yScale), e.h), e.y), n.applyExponentialOnBoxSize ? (s = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $87d347fdc039529f$export$b310ec824aaee37f)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(s, n.hScale)), e.h), u = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $87d347fdc039529f$export$b310ec824aaee37f)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(u, n.wScale)), e.w)) : (s = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(s, n.hScale), e.h), u = (0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(u, n.wScale), e.h));
                            var h = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(i, (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(s, 2)), l = (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(r, (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(u, 2)), f = (0, $8efd352f234ac278$export$e16d8520af44a096)(i, (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(s, 2)), d = (0, $8efd352f234ac278$export$e16d8520af44a096)(r, (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(u, 2)), m = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
                                (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(h, [
                                    n.numBoxes,
                                    1
                                ]),
                                (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(l, [
                                    n.numBoxes,
                                    1
                                ]),
                                (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(f, [
                                    n.numBoxes,
                                    1
                                ]),
                                (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(d, [
                                    n.numBoxes,
                                    1
                                ])
                            ], 1);
                            if (n.numKeypoints) for(var g = 0; g < n.numKeypoints; ++g){
                                var v = n.keypointCoordOffset + g * n.numValuesPerKeypoint, x = void 0, w = void 0;
                                n.reverseOutputOrder ? (x = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                    0,
                                    v
                                ], [
                                    -1,
                                    1
                                ])), w = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                    0,
                                    v + 1
                                ], [
                                    -1,
                                    1
                                ]))) : (w = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                    0,
                                    v
                                ], [
                                    -1,
                                    1
                                ])), x = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $5ac259fe82d1a965$export$58adb3bec8346d0f)(t, [
                                    0,
                                    v + 1
                                ], [
                                    -1,
                                    1
                                ])));
                                var T = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(x, n.xScale), e.w), e.x), P = (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(w, n.yScale), e.h), e.y);
                                m = (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
                                    m,
                                    (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(T, [
                                        n.numBoxes,
                                        1
                                    ]),
                                    (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(P, [
                                        n.numBoxes,
                                        1
                                    ])
                                ], 1);
                            }
                            return m;
                        });
                    }(s, e, n), h = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                        var t = i;
                        return n.sigmoidScore ? (null != n.scoreClippingThresh && (t = (0, $454af21933ae7636$export$fa97baf70ad024c0)(i, -n.scoreClippingThresh, n.scoreClippingThresh)), t = (0, $4e7e1888b524d401$export$3b295495ca3cad7c)(t)) : t;
                    }), [
                        4,
                        $a54e498d8d862fdc$var$Pt(u, h, n)
                    ];
                case 1:
                    return l = d.sent(), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)([
                        u,
                        h
                    ]), [
                        2,
                        l
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$Pt(t, e, n) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u, h, l, c, p, f, d;
        return $a54e498d8d862fdc$var$D(this, function(m) {
            switch(m.label){
                case 0:
                    return i = [], [
                        4,
                        t.data()
                    ];
                case 1:
                    return r = m.sent(), [
                        4,
                        e.data()
                    ];
                case 2:
                    for(o = m.sent(), a = 0; a < n.numBoxes; ++a)if (!(null != n.minScoreThresh && o[a] < n.minScoreThresh || (s = a * n.numCoords, u = $a54e498d8d862fdc$var$Ft(r[s + 0], r[s + 1], r[s + 2], r[s + 3], o[a], n.flipVertically, a), (h = u.locationData.relativeBoundingBox).width < 0 || h.height < 0))) {
                        if (n.numKeypoints > 0) for((l = u.locationData).relativeKeypoints = [], c = n.numKeypoints * n.numValuesPerKeypoint, p = 0; p < c; p += n.numValuesPerKeypoint)f = s + n.keypointCoordOffset + p, d = {
                            x: r[f + 0],
                            y: n.flipVertically ? 1 - r[f + 1] : r[f + 1]
                        }, l.relativeKeypoints.push(d);
                        i.push(u);
                    }
                    return [
                        2,
                        i
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$Ft(t, e, n, i, r, o, a) {
    return {
        score: [
            r
        ],
        ind: a,
        locationData: {
            relativeBoundingBox: {
                xMin: e,
                yMin: o ? 1 - n : t,
                xMax: i,
                yMax: o ? 1 - t : n,
                width: i - e,
                height: n - t
            }
        }
    };
}
function $a54e498d8d862fdc$var$_t(t, e) {
    return "none" === t ? e : function(t) {
        return 1 / (1 + Math.exp(-t));
    }(e);
}
function $a54e498d8d862fdc$var$Ot(t, e, n, i) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var r, o, a, s, u, h, l, c;
        return $a54e498d8d862fdc$var$D(this, function(p) {
            switch(p.label){
                case 0:
                    return n = n || e.flipHorizontally || !1, i = i || e.flipVertically || !1, r = t.size, o = r / e.numLandmarks, [
                        4,
                        t.data()
                    ];
                case 1:
                    for(a = p.sent(), s = [], u = 0; u < e.numLandmarks; ++u)h = u * o, (c = {
                        x: 0,
                        y: 0
                    }).x = n ? e.inputImageWidth - a[h] : a[h], o > 1 && (c.y = i ? e.inputImageHeight - a[h + 1] : a[h + 1]), o > 2 && (c.z = a[h + 2]), o > 3 && (c.score = $a54e498d8d862fdc$var$_t(e.visibilityActivation, a[h + 3])), s.push(c);
                    for(l = 0; l < s.length; ++l)(c = s[l]).x = c.x / e.inputImageWidth, c.y = c.y / e.inputImageHeight, c.z = c.z / e.inputImageWidth / (e.normalizeZ || 1);
                    return [
                        2,
                        s
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$It(t, e, n) {
    var i = t.width, r = t.height, o = t.rotation;
    if (null == n.rotation && null == n.rotationDegree || (o = function(t, e) {
        null != e.rotation ? t += e.rotation : null != e.rotationDegree && (t += Math.PI * e.rotationDegree / 180);
        return $a54e498d8d862fdc$var$ot(t);
    }(o, n)), 0 === o) t.xCenter = t.xCenter + i * n.shiftX, t.yCenter = t.yCenter + r * n.shiftY;
    else {
        var a = (e.width * i * n.shiftX * Math.cos(o) - e.height * r * n.shiftY * Math.sin(o)) / e.width, s = (e.width * i * n.shiftX * Math.sin(o) + e.height * r * n.shiftY * Math.cos(o)) / e.height;
        t.xCenter = t.xCenter + a, t.yCenter = t.yCenter + s;
    }
    if (n.squareLong) {
        var u = Math.max(i * e.width, r * e.height);
        i = u / e.width, r = u / e.height;
    } else if (n.squareShort) {
        var h = Math.min(i * e.width, r * e.height);
        i = h / e.width, r = h / e.height;
    }
    return t.width = i * n.scaleX, t.height = r * n.scaleY, t;
}
function $a54e498d8d862fdc$var$At(t, e) {
    return t.map(function(t) {
        var n = $a54e498d8d862fdc$var$B($a54e498d8d862fdc$var$B({}, t), {
            x: t.x / e.width,
            y: t.y / e.height
        });
        return null != t.z && (t.z = t.z / e.width), n;
    });
}
var $a54e498d8d862fdc$var$zt = function() {
    function t(t) {
        this.alpha = t, this.initialized = !1;
    }
    return t.prototype.apply = function(t, e) {
        var n;
        return this.initialized ? n = null == e ? this.storedValue + this.alpha * (t - this.storedValue) : this.storedValue + this.alpha * e * Math.asinh((t - this.storedValue) / e) : (n = t, this.initialized = !0), this.rawValue = t, this.storedValue = n, n;
    }, t.prototype.applyWithAlpha = function(t, e, n) {
        return this.alpha = e, this.apply(t, n);
    }, t.prototype.hasLastRawValue = function() {
        return this.initialized;
    }, t.prototype.lastRawValue = function() {
        return this.rawValue;
    }, t.prototype.reset = function() {
        this.initialized = !1;
    }, t;
}(), $a54e498d8d862fdc$var$Ct = function() {
    function t(t) {
        this.frequency = t.frequency, this.minCutOff = t.minCutOff, this.beta = t.beta, this.thresholdCutOff = t.thresholdCutOff, this.thresholdBeta = t.thresholdBeta, this.derivateCutOff = t.derivateCutOff, this.x = new $a54e498d8d862fdc$var$zt(this.getAlpha(this.minCutOff)), this.dx = new $a54e498d8d862fdc$var$zt(this.getAlpha(this.derivateCutOff)), this.lastTimestamp = 0;
    }
    return t.prototype.apply = function(t, e, n) {
        if (null == t) return t;
        var i = Math.trunc(e);
        if (this.lastTimestamp >= i) return t;
        0 !== this.lastTimestamp && 0 !== i && (this.frequency = 1 / (1e-6 * (i - this.lastTimestamp))), this.lastTimestamp = i;
        var r = this.x.hasLastRawValue() ? (t - this.x.lastRawValue()) * n * this.frequency : 0, o = this.dx.applyWithAlpha(r, this.getAlpha(this.derivateCutOff)), a = this.minCutOff + this.beta * Math.abs(o), s = null != this.thresholdCutOff ? this.thresholdCutOff + this.thresholdBeta * Math.abs(o) : null;
        return this.x.applyWithAlpha(t, this.getAlpha(a), s);
    }, t.prototype.getAlpha = function(t) {
        return 1 / (1 + this.frequency / (2 * Math.PI * t));
    }, t;
}(), $a54e498d8d862fdc$var$Et = function() {
    function t(t) {
        this.config = t;
    }
    return t.prototype.apply = function(t, e, n) {
        var i = this;
        if (null == t) return this.reset(), null;
        this.initializeFiltersIfEmpty(t);
        var r = 1;
        if (!this.config.disableValueScaling) {
            if (n < this.config.minAllowedObjectScale) return $a54e498d8d862fdc$var$K([], t, !0);
            r = 1 / n;
        }
        return t.map(function(t, n) {
            var o = $a54e498d8d862fdc$var$B($a54e498d8d862fdc$var$B({}, t), {
                x: i.xFilters[n].apply(t.x, e, r),
                y: i.yFilters[n].apply(t.y, e, r)
            });
            return null != t.z && (o.z = i.zFilters[n].apply(t.z, e, r)), o;
        });
    }, t.prototype.reset = function() {
        this.xFilters = null, this.yFilters = null, this.zFilters = null;
    }, t.prototype.initializeFiltersIfEmpty = function(t) {
        var e = this;
        null != this.xFilters && this.xFilters.length === t.length || (this.xFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$Ct(e.config);
        }), this.yFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$Ct(e.config);
        }), this.zFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$Ct(e.config);
        }));
    }, t;
}(), $a54e498d8d862fdc$var$Rt = function() {
    function t(t) {
        this.config = t, this.window = [], this.lowPassFilter = new $a54e498d8d862fdc$var$zt(1), this.lastValue = 0, this.lastValueScale = 1, this.lastTimestamp = -1;
    }
    return t.prototype.apply = function(t, e, n) {
        if (null == t) return t;
        var i, r = Math.trunc(e);
        if (this.lastTimestamp >= r) return t;
        if (-1 === this.lastTimestamp) i = 1;
        else {
            for(var o = t * n - this.lastValue * this.lastValueScale, a = r - this.lastTimestamp, s = o, u = a, h = (1 + this.window.length) * (1e6 / 30), l = 0, c = this.window; l < c.length; l++){
                var p = c[l];
                if (u + p.duration > h) break;
                s += p.distance, u += p.duration;
            }
            var f = s / (1e-6 * u);
            i = 1 - 1 / (1 + this.config.velocityScale * Math.abs(f)), this.window.unshift({
                distance: o,
                duration: a
            }), this.window.length > this.config.windowSize && this.window.pop();
        }
        return this.lastValue = t, this.lastValueScale = n, this.lastTimestamp = r, this.lowPassFilter.applyWithAlpha(t, i);
    }, t;
}(), $a54e498d8d862fdc$var$Lt = function() {
    function t(t) {
        this.config = t;
    }
    return t.prototype.apply = function(t, e, n) {
        var i = this;
        if (null == t) return this.reset(), null;
        var r = 1;
        if (!this.config.disableValueScaling) {
            if (n < this.config.minAllowedObjectScale) return $a54e498d8d862fdc$var$K([], t, !0);
            r = 1 / n;
        }
        return this.initializeFiltersIfEmpty(t), t.map(function(t, n) {
            var o = $a54e498d8d862fdc$var$B($a54e498d8d862fdc$var$B({}, t), {
                x: i.xFilters[n].apply(t.x, e, r),
                y: i.yFilters[n].apply(t.y, e, r)
            });
            return null != t.z && (o.z = i.zFilters[n].apply(t.z, e, r)), o;
        });
    }, t.prototype.reset = function() {
        this.xFilters = null, this.yFilters = null, this.zFilters = null;
    }, t.prototype.initializeFiltersIfEmpty = function(t) {
        var e = this;
        null != this.xFilters && this.xFilters.length === t.length || (this.xFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$Rt(e.config);
        }), this.yFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$Rt(e.config);
        }), this.zFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$Rt(e.config);
        }));
    }, t;
}(), $a54e498d8d862fdc$var$Vt = function() {
    function t(t) {
        if (null != t.velocityFilter) this.keypointsFilter = new $a54e498d8d862fdc$var$Lt(t.velocityFilter);
        else {
            if (null == t.oneEuroFilter) throw new Error("Either configure velocityFilter or oneEuroFilter, but got " + "".concat(t, "."));
            this.keypointsFilter = new $a54e498d8d862fdc$var$Et(t.oneEuroFilter);
        }
    }
    return t.prototype.apply = function(t, e, n, i, r) {
        if (void 0 === i && (i = !1), null == t) return this.keypointsFilter.reset(), null;
        var o = null != r ? function(t, e) {
            return (t.width * e.width + t.height * e.height) / 2;
        }(r, n) : 1, a = i ? $a54e498d8d862fdc$var$kt(t, n) : t, s = this.keypointsFilter.apply(a, e, o);
        return i ? $a54e498d8d862fdc$var$At(s, n) : s;
    }, t;
}(), $a54e498d8d862fdc$var$Bt = function() {
    function t(t) {
        this.alpha = t.alpha;
    }
    return t.prototype.apply = function(t) {
        var e = this;
        if (null == t) return this.visibilityFilters = null, null;
        null != this.visibilityFilters && this.visibilityFilters.length === t.length || (this.visibilityFilters = t.map(function(t) {
            return new $a54e498d8d862fdc$var$zt(e.alpha);
        }));
        for(var n = [], i = 0; i < t.length; ++i){
            var r = t[i], o = $a54e498d8d862fdc$var$B({}, r);
            o.score = this.visibilityFilters[i].apply(r.score), n.push(o);
        }
        return n;
    }, t;
}(), $a54e498d8d862fdc$var$Nt = {
    reduceBoxesInLowestlayer: !1,
    interpolatedScaleAspectRatio: 1,
    featureMapHeight: [],
    featureMapWidth: [],
    numLayers: 5,
    minScale: .1484375,
    maxScale: .75,
    inputSizeHeight: 224,
    inputSizeWidth: 224,
    anchorOffsetX: .5,
    anchorOffsetY: .5,
    strides: [
        8,
        16,
        32,
        32,
        32
    ],
    aspectRatios: [
        1
    ],
    fixedAnchorSize: !0
}, $a54e498d8d862fdc$var$Dt = {
    runtime: "tfjs",
    modelType: "full",
    enableSmoothing: !0,
    enableSegmentation: !1,
    smoothSegmentation: !0,
    detectorModelUrl: "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/detector/1",
    landmarkModelUrl: "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/full/2"
}, $a54e498d8d862fdc$var$Kt = {
    maxPoses: 1,
    flipHorizontal: !1
}, $a54e498d8d862fdc$var$Ut = {
    applyExponentialOnBoxSize: !1,
    flipVertically: !1,
    ignoreClasses: [],
    numClasses: 1,
    numBoxes: 2254,
    numCoords: 12,
    boxCoordOffset: 0,
    keypointCoordOffset: 4,
    numKeypoints: 4,
    numValuesPerKeypoint: 2,
    sigmoidScore: !0,
    scoreClippingThresh: 100,
    reverseOutputOrder: !0,
    xScale: 224,
    yScale: 224,
    hScale: 224,
    wScale: 224,
    minScoreThresh: .5
}, $a54e498d8d862fdc$var$jt = .3, $a54e498d8d862fdc$var$Ht = {
    shiftX: 0,
    shiftY: 0,
    scaleX: 1.25,
    scaleY: 1.25,
    squareLong: !0
}, $a54e498d8d862fdc$var$qt = {
    outputTensorSize: {
        width: 224,
        height: 224
    },
    keepAspectRatio: !0,
    outputTensorFloatRange: [
        -1,
        1
    ],
    borderMode: "zero"
}, $a54e498d8d862fdc$var$Xt = {
    outputTensorSize: {
        width: 256,
        height: 256
    },
    keepAspectRatio: !0,
    outputTensorFloatRange: [
        0,
        1
    ],
    borderMode: "zero"
}, $a54e498d8d862fdc$var$Yt = {
    numLandmarks: 39,
    inputImageWidth: 256,
    inputImageHeight: 256,
    visibilityActivation: "sigmoid",
    flipHorizontally: !1,
    flipVertically: !1
}, $a54e498d8d862fdc$var$Wt = {
    numLandmarks: 39,
    inputImageWidth: 1,
    inputImageHeight: 1,
    visibilityActivation: "sigmoid",
    flipHorizontally: !1,
    flipVertically: !1
}, $a54e498d8d862fdc$var$Gt = {
    kernelSize: 7,
    minConfidenceToRefine: .5
}, $a54e498d8d862fdc$var$Qt = {
    alpha: .1
}, $a54e498d8d862fdc$var$Zt = {
    oneEuroFilter: {
        frequency: 30,
        minCutOff: .05,
        beta: 80,
        derivateCutOff: 1,
        minAllowedObjectScale: 1e-6
    }
}, $a54e498d8d862fdc$var$$t = {
    oneEuroFilter: {
        frequency: 30,
        minCutOff: .01,
        beta: 10,
        derivateCutOff: 1,
        minAllowedObjectScale: 1e-6
    }
}, $a54e498d8d862fdc$var$Jt = {
    oneEuroFilter: {
        frequency: 30,
        minCutOff: .1,
        beta: 40,
        derivateCutOff: 1,
        minAllowedObjectScale: 1e-6,
        disableValueScaling: !0
    }
}, $a54e498d8d862fdc$var$te = {
    activation: "none"
}, $a54e498d8d862fdc$var$ee = {
    combineWithPreviousRatio: .7
};
var $a54e498d8d862fdc$var$ne = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(t) {
                return [
                    2,
                    $a54e498d8d862fdc$var$G(this.mask)
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(t) {
                return [
                    2,
                    $a54e498d8d862fdc$var$Q(this.mask)
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "tensor";
    }, t;
}();
function $a54e498d8d862fdc$var$ie(t) {
    return $a54e498d8d862fdc$var$$(t), "person";
}
var $a54e498d8d862fdc$var$re = function() {
    function t(t, e, n, i, r, o) {
        this.detectorModel = t, this.landmarkModel = e, this.enableSmoothing = n, this.enableSegmentation = i, this.smoothSegmentation = r, this.modelType = o, this.regionOfInterest = null, this.prevFilteredSegmentationMask = null, this.anchors = function(t) {
            null == t.reduceBoxesInLowestLayer && (t.reduceBoxesInLowestLayer = !1), null == t.interpolatedScaleAspectRatio && (t.interpolatedScaleAspectRatio = 1), null == t.fixedAnchorSize && (t.fixedAnchorSize = !1);
            for(var e = [], n = 0; n < t.numLayers;){
                for(var i = [], r = [], o = [], a = [], s = n; s < t.strides.length && t.strides[s] === t.strides[n];){
                    var u = $a54e498d8d862fdc$var$gt(t.minScale, t.maxScale, s, t.strides.length);
                    if (0 === s && t.reduceBoxesInLowestLayer) o.push(1), o.push(2), o.push(.5), a.push(.1), a.push(u), a.push(u);
                    else {
                        for(var h = 0; h < t.aspectRatios.length; ++h)o.push(t.aspectRatios[h]), a.push(u);
                        if (t.interpolatedScaleAspectRatio > 0) {
                            var l = s === t.strides.length - 1 ? 1 : $a54e498d8d862fdc$var$gt(t.minScale, t.maxScale, s + 1, t.strides.length);
                            a.push(Math.sqrt(u * l)), o.push(t.interpolatedScaleAspectRatio);
                        }
                    }
                    s++;
                }
                for(var c = 0; c < o.length; ++c){
                    var p = Math.sqrt(o[c]);
                    i.push(a[c] / p), r.push(a[c] * p);
                }
                var f = 0, d = 0;
                if (t.featureMapHeight.length > 0) f = t.featureMapHeight[n], d = t.featureMapWidth[n];
                else {
                    var m = t.strides[n];
                    f = Math.ceil(t.inputSizeHeight / m), d = Math.ceil(t.inputSizeWidth / m);
                }
                for(var g = 0; g < f; ++g)for(var y = 0; y < d; ++y)for(var v = 0; v < i.length; ++v){
                    var x = {
                        xCenter: (y + t.anchorOffsetX) / d,
                        yCenter: (g + t.anchorOffsetY) / f,
                        width: 0,
                        height: 0
                    };
                    t.fixedAnchorSize ? (x.width = 1, x.height = 1) : (x.width = r[v], x.height = i[v]), e.push(x);
                }
                n = s;
            }
            return e;
        }($a54e498d8d862fdc$var$Nt);
        var a = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(this.anchors.map(function(t) {
            return t.width;
        })), u = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(this.anchors.map(function(t) {
            return t.height;
        })), h = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(this.anchors.map(function(t) {
            return t.xCenter;
        })), l = (0, $efe757e3a7d314f1$export$8133e3bf3cd8f464)(this.anchors.map(function(t) {
            return t.yCenter;
        }));
        this.anchorTensor = {
            x: h,
            y: l,
            w: a,
            h: u
        }, this.prevFilteredSegmentationMask = this.enableSegmentation ? (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([], [
            0,
            0
        ]) : null;
    }
    return t.prototype.estimatePoses = function(t, e, n) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var i, o, a, s, u, c, p, d, m, g, y, v, x, w, k, b, M, S, T, P, O, I, A;
            return $a54e498d8d862fdc$var$D(this, function(z) {
                switch(z.label){
                    case 0:
                        return i = function(t) {
                            var e;
                            if (null == (e = null == t ? $a54e498d8d862fdc$var$Kt : $a54e498d8d862fdc$var$B({}, t)).maxPoses && (e.maxPoses = 1), e.maxPoses <= 0) throw new Error("Invalid maxPoses ".concat(e.maxPoses, ". Should be > 0."));
                            if (e.maxPoses > 1) throw new Error("Multi-pose detection is not implemented yet. Please set maxPoses to 1.");
                            return e;
                        }(e), null == t ? (this.reset(), [
                            2,
                            []
                        ]) : (this.maxPoses = i.maxPoses, this.timestamp = null != n ? 1e3 * n : $a54e498d8d862fdc$var$vt(t) ? 1e6 * t.currentTime : null, o = $a54e498d8d862fdc$var$rt(t), a = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                            return (0, $262a02e810d931f1$export$f2db7d5238e1d23f)($a54e498d8d862fdc$var$at(t), "float32");
                        }), null != (s = this.regionOfInterest) ? [
                            3,
                            2
                        ] : [
                            4,
                            this.detectPose(a)
                        ]);
                    case 1:
                        if (0 === (u = z.sent()).length) return this.reset(), a.dispose(), [
                            2,
                            []
                        ];
                        c = u[0], s = this.poseDetectionToRoi(c, o), z.label = 2;
                    case 2:
                        return [
                            4,
                            this.poseLandmarksByRoi(s, a)
                        ];
                    case 3:
                        return p = z.sent(), a.dispose(), null == p ? (this.reset(), [
                            2,
                            []
                        ]) : (d = p.landmarks, m = p.auxiliaryLandmarks, g = p.poseScore, y = p.worldLandmarks, v = p.segmentationMask, x = this.poseLandmarkFiltering(d, m, y, o), w = x.actualLandmarksFiltered, k = x.auxiliaryLandmarksFiltered, b = x.actualWorldLandmarksFiltered, M = this.poseLandmarksToRoi(k, o), this.regionOfInterest = M, S = this.smoothSegmentation && null != v ? this.poseSegmentationFiltering(v) : v, null != (T = null != w ? $a54e498d8d862fdc$var$kt(w, o) : null) && T.forEach(function(t, e) {
                            t.name = $a54e498d8d862fdc$var$j[e];
                        }), null != (P = b) && P.forEach(function(t, e) {
                            t.name = $a54e498d8d862fdc$var$j[e];
                        }), O = {
                            score: g,
                            keypoints: T,
                            keypoints3D: P
                        }, null !== S && (I = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                            var t = (0, $31018343da089cd7$export$d660d8ed21f46635)(S, 2), e = (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(t, [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    1
                                ]
                            ]);
                            return (0, $cae387b6339c4711$export$c0b11600e90b86ae)(e, [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    2
                                ]
                            ], "symmetric");
                        }), this.smoothSegmentation || (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(S), A = {
                            maskValueToLabel: $a54e498d8d862fdc$var$ie,
                            mask: new $a54e498d8d862fdc$var$ne(I)
                        }, O.segmentation = A), [
                            2,
                            [
                                O
                            ]
                        ]);
                }
            });
        });
    }, t.prototype.poseSegmentationFiltering = function(t) {
        var e = this.prevFilteredSegmentationMask;
        return 0 === e.size ? this.prevFilteredSegmentationMask = t : (this.prevFilteredSegmentationMask = $a54e498d8d862fdc$var$St(e, t, $a54e498d8d862fdc$var$ee), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(t)), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(e), this.prevFilteredSegmentationMask;
    }, t.prototype.dispose = function() {
        this.detectorModel.dispose(), this.landmarkModel.dispose(), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)([
            this.anchorTensor.x,
            this.anchorTensor.y,
            this.anchorTensor.w,
            this.anchorTensor.h,
            this.prevFilteredSegmentationMask
        ]);
    }, t.prototype.reset = function() {
        this.regionOfInterest = null, this.enableSegmentation && ((0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(this.prevFilteredSegmentationMask), this.prevFilteredSegmentationMask = (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([], [
            0,
            0
        ])), this.visibilitySmoothingFilterActual = null, this.visibilitySmoothingFilterAuxiliary = null, this.landmarksSmoothingFilterActual = null, this.landmarksSmoothingFilterAuxiliary = null;
    }, t.prototype.detectPose = function(t) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var e, n, i, r, o, a, s, u, h, l;
            return $a54e498d8d862fdc$var$D(this, function(c) {
                switch(c.label){
                    case 0:
                        return e = $a54e498d8d862fdc$var$mt(t, $a54e498d8d862fdc$var$qt), n = e.imageTensor, i = e.padding, r = this.detectorModel.predict(n), o = $a54e498d8d862fdc$var$yt(r), a = o.boxes, [
                            4,
                            $a54e498d8d862fdc$var$Tt([
                                s = o.logits,
                                a
                            ], this.anchorTensor, $a54e498d8d862fdc$var$Ut)
                        ];
                    case 1:
                        return 0 === (u = c.sent()).length ? ((0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)([
                            n,
                            r,
                            s,
                            a
                        ]), [
                            2,
                            u
                        ]) : [
                            4,
                            $a54e498d8d862fdc$var$wt(u, this.maxPoses, $a54e498d8d862fdc$var$jt)
                        ];
                    case 2:
                        return h = c.sent(), l = function(t, e) {
                            void 0 === t && (t = []);
                            for(var n = e.left, i = e.top, r = e.left + e.right, o = e.top + e.bottom, a = 0; a < t.length; a++){
                                var s = t[a], u = s.locationData.relativeBoundingBox, h = (u.xMin - n) / (1 - r), l = (u.yMin - i) / (1 - o), c = u.width / (1 - r), p = u.height / (1 - o);
                                u.xMin = h, u.yMin = l, u.width = c, u.height = p, u.xMax = h + c, u.yMax = l + p;
                                var f = s.locationData.relativeKeypoints;
                                f && f.forEach(function(t) {
                                    var e = (t.x - n) / (1 - r), a = (t.y - i) / (1 - o);
                                    t.x = e, t.y = a;
                                });
                            }
                            return t;
                        }(h, i), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)([
                            n,
                            r,
                            s,
                            a
                        ]), [
                            2,
                            l
                        ];
                }
            });
        });
    }, t.prototype.poseDetectionToRoi = function(t, e) {
        return $a54e498d8d862fdc$var$It($a54e498d8d862fdc$var$ht(t, e, {
            rotationVectorEndKeypointIndex: 1,
            rotationVectorStartKeypointIndex: 0,
            rotationVectorTargetAngleDegree: 90
        }), e, $a54e498d8d862fdc$var$Ht);
    }, t.prototype.poseLandmarksByRoi = function(t, e) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var n, i, r, o, a, s, u, h, l, c, p, d, m, g;
            return $a54e498d8d862fdc$var$D(this, function(y) {
                switch(y.label){
                    case 0:
                        if (n = $a54e498d8d862fdc$var$rt(e), i = $a54e498d8d862fdc$var$mt(e, $a54e498d8d862fdc$var$Xt, t), r = i.imageTensor, o = i.padding, a = i.transformationMatrix, "lite" !== this.modelType && "full" !== this.modelType && "heavy" !== this.modelType) throw new Error("Model type must be one of lite, full or heavy," + "but got ".concat(this.modelType));
                        return s = [
                            "ld_3d",
                            "output_poseflag",
                            "activation_heatmap",
                            "world_3d"
                        ], this.enableSegmentation && s.push("activation_segmentation"), u = this.landmarkModel.execute(r, s), [
                            4,
                            this.tensorsToPoseLandmarksAndSegmentation(u)
                        ];
                    case 1:
                        return null == (h = y.sent()) ? ((0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(u), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(r), [
                            2,
                            null
                        ]) : (l = h.landmarks, c = h.auxiliaryLandmarks, p = h.poseScore, d = h.worldLandmarks, m = h.segmentationMask, [
                            4,
                            this.poseLandmarksAndSegmentationInverseProjection(n, t, o, a, l, c, d, m)
                        ]);
                    case 2:
                        return g = y.sent(), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(u), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(r), [
                            2,
                            $a54e498d8d862fdc$var$B({
                                poseScore: p
                            }, g)
                        ];
                }
            });
        });
    }, t.prototype.poseLandmarksAndSegmentationInverseProjection = function(t, e, n, i, o, a, h, l) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var c, d, m, g, y, v;
            return $a54e498d8d862fdc$var$D(this, function(x) {
                return c = $a54e498d8d862fdc$var$Mt(o, n), d = $a54e498d8d862fdc$var$Mt(a, n), m = $a54e498d8d862fdc$var$ft(c, e), g = $a54e498d8d862fdc$var$ft(d, e), y = function(t, e) {
                    for(var n = [], i = 0, r = t; i < r.length; i++){
                        var o = r[i], a = o.x, s = o.y, u = e.rotation, h = Math.cos(u) * a - Math.sin(u) * s, l = Math.sin(u) * a + Math.cos(u) * s, c = $a54e498d8d862fdc$var$B({}, o);
                        c.x = h, c.y = l, n.push(c);
                    }
                    return n;
                }(h, e), v = null, this.enableSegmentation && (v = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                    var e = l.shape, n = e[0], r = e[1], o = function(t) {
                        var e = $a54e498d8d862fdc$var$lt(new Array(16).fill(0));
                        e[0][0] = $a54e498d8d862fdc$var$pt(t, 0, 0), e[1][0] = -$a54e498d8d862fdc$var$pt(t, 0, 1), e[2][0] = $a54e498d8d862fdc$var$pt(t, 0, 2), e[3][0] = -$a54e498d8d862fdc$var$pt(t, 0, 3), e[0][2] = $a54e498d8d862fdc$var$pt(t, 2, 0), e[1][2] = -$a54e498d8d862fdc$var$pt(t, 2, 1), e[2][2] = $a54e498d8d862fdc$var$pt(t, 2, 2), e[3][2] = -$a54e498d8d862fdc$var$pt(t, 2, 3), e[0][1] = -$a54e498d8d862fdc$var$pt(t, 1, 0), e[1][1] = $a54e498d8d862fdc$var$pt(t, 1, 1), e[2][1] = -$a54e498d8d862fdc$var$pt(t, 1, 2), e[3][1] = $a54e498d8d862fdc$var$pt(t, 1, 3), e[0][3] = -$a54e498d8d862fdc$var$pt(t, 3, 0), e[1][3] = $a54e498d8d862fdc$var$pt(t, 3, 1), e[2][3] = -$a54e498d8d862fdc$var$pt(t, 3, 2), e[3][3] = $a54e498d8d862fdc$var$pt(t, 3, 3);
                        for(var n = t[0][0] * e[0][0] + t[1][0] * e[0][1] + t[2][0] * e[0][2] + t[3][0] * e[0][3], i = 0; i < e.length; i++)for(var r = 0; r < e.length; r++)e[i][r] /= n;
                        return e;
                    }(i), a = (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)($a54e498d8d862fdc$var$st(o, {
                        width: r,
                        height: n
                    }, t), [
                        1,
                        8
                    ]), h = [
                        1,
                        n,
                        r,
                        1
                    ];
                    return (0, $d85a848eb4aff9d2$export$889c931173b77c2f)((0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).transform((0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(l, h), a, "bilinear", "constant", 0, [
                        t.height,
                        t.width
                    ]), [
                        0,
                        3
                    ]);
                }), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(l)), [
                    2,
                    {
                        landmarks: m,
                        auxiliaryLandmarks: g,
                        worldLandmarks: y,
                        segmentationMask: v
                    }
                ];
            });
        });
    }, t.prototype.tensorsToPoseLandmarksAndSegmentation = function(t) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var e, n, i, o, a, s, h, l, c, f, d, m, g;
            return $a54e498d8d862fdc$var$D(this, function(y) {
                switch(y.label){
                    case 0:
                        return e = t[0], n = t[1], i = t[2], o = t[3], a = this.enableSegmentation ? t[4] : null, [
                            4,
                            n.data()
                        ];
                    case 1:
                        return (s = y.sent()[0]) < .5 ? [
                            2,
                            null
                        ] : [
                            4,
                            $a54e498d8d862fdc$var$Ot(e, $a54e498d8d862fdc$var$Yt)
                        ];
                    case 2:
                        return [
                            4,
                            $a54e498d8d862fdc$var$bt(y.sent(), i, $a54e498d8d862fdc$var$Gt)
                        ];
                    case 3:
                        return h = y.sent(), l = h.slice(0, 33), c = h.slice(33, 35), [
                            4,
                            $a54e498d8d862fdc$var$Ot(o, $a54e498d8d862fdc$var$Wt)
                        ];
                    case 4:
                        return f = y.sent(), d = f.slice(0, 33), m = function(t, e, n) {
                            void 0 === n && (n = !0);
                            for(var i = [], r = 0; r < t.length; r++){
                                var o = $a54e498d8d862fdc$var$B({}, e[r]);
                                n && (o.score = t[r].score), i.push(o);
                            }
                            return i;
                        }(l, d, !0), g = this.enableSegmentation ? function(t, e, n) {
                            return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                                var i = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(t, [
                                    0
                                ]), r = i.shape[2];
                                if (1 === r) {
                                    var o = i;
                                    switch(e.activation){
                                        case "none":
                                            break;
                                        case "sigmoid":
                                            o = (0, $4e7e1888b524d401$export$3b295495ca3cad7c)(o);
                                            break;
                                        case "softmax":
                                            throw new Error("Softmax activation requires two channels.");
                                        default:
                                            throw new Error("Activation not supported (".concat(e.activation, ")"));
                                    }
                                    var a = n ? (0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).resizeBilinear(o, [
                                        n.height,
                                        n.width
                                    ]) : o;
                                    return (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(a, [
                                        2
                                    ]);
                                }
                                throw new Error("Unsupported number of tensor channels ".concat(r));
                            });
                        }(a, $a54e498d8d862fdc$var$te) : null, [
                            2,
                            {
                                landmarks: l,
                                auxiliaryLandmarks: c,
                                poseScore: s,
                                worldLandmarks: m,
                                segmentationMask: g
                            }
                        ];
                }
            });
        });
    }, t.prototype.poseLandmarksToRoi = function(t, e) {
        return $a54e498d8d862fdc$var$It($a54e498d8d862fdc$var$ht($a54e498d8d862fdc$var$xt(t), e, {
            rotationVectorStartKeypointIndex: 0,
            rotationVectorEndKeypointIndex: 1,
            rotationVectorTargetAngleDegree: 90
        }), e, $a54e498d8d862fdc$var$Ht);
    }, t.prototype.poseLandmarkFiltering = function(t, e, n, i) {
        var r, o, a;
        if (null != this.timestamp && this.enableSmoothing) {
            var s = $a54e498d8d862fdc$var$ht($a54e498d8d862fdc$var$xt(e), i, {
                rotationVectorEndKeypointIndex: 0,
                rotationVectorStartKeypointIndex: 1,
                rotationVectorTargetAngleDegree: 90
            });
            null == this.visibilitySmoothingFilterActual && (this.visibilitySmoothingFilterActual = new $a54e498d8d862fdc$var$Bt($a54e498d8d862fdc$var$Qt)), r = this.visibilitySmoothingFilterActual.apply(t), null == this.visibilitySmoothingFilterAuxiliary && (this.visibilitySmoothingFilterAuxiliary = new $a54e498d8d862fdc$var$Bt($a54e498d8d862fdc$var$Qt)), o = this.visibilitySmoothingFilterAuxiliary.apply(e), a = this.visibilitySmoothingFilterActual.apply(n), null == this.landmarksSmoothingFilterActual && (this.landmarksSmoothingFilterActual = new $a54e498d8d862fdc$var$Vt($a54e498d8d862fdc$var$Zt)), r = this.landmarksSmoothingFilterActual.apply(r, this.timestamp, i, !0, s), null == this.landmarksSmoothingFilterAuxiliary && (this.landmarksSmoothingFilterAuxiliary = new $a54e498d8d862fdc$var$Vt($a54e498d8d862fdc$var$$t)), o = this.landmarksSmoothingFilterAuxiliary.apply(o, this.timestamp, i, !0, s), null == this.worldLandmarksSmoothingFilterActual && (this.worldLandmarksSmoothingFilterActual = new $a54e498d8d862fdc$var$Vt($a54e498d8d862fdc$var$Jt)), a = this.worldLandmarksSmoothingFilterActual.apply(n, this.timestamp);
        } else r = t, o = e, a = n;
        return {
            actualLandmarksFiltered: r,
            auxiliaryLandmarksFiltered: o,
            actualWorldLandmarksFiltered: a
        };
    }, t;
}();
function $a54e498d8d862fdc$var$oe(t) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var e, n, i, r, o, a;
        return $a54e498d8d862fdc$var$D(this, function(s) {
            switch(s.label){
                case 0:
                    return e = function(t) {
                        var e = $a54e498d8d862fdc$var$B({}, null == t ? $a54e498d8d862fdc$var$Dt : t);
                        if (null == e.enableSmoothing && (e.enableSmoothing = $a54e498d8d862fdc$var$Dt.enableSmoothing), null == e.enableSegmentation && (e.enableSegmentation = $a54e498d8d862fdc$var$Dt.enableSegmentation), null == e.smoothSegmentation && (e.smoothSegmentation = $a54e498d8d862fdc$var$Dt.smoothSegmentation), null == e.modelType && (e.modelType = $a54e498d8d862fdc$var$Dt.modelType), null == e.detectorModelUrl && (e.detectorModelUrl = $a54e498d8d862fdc$var$Dt.detectorModelUrl), null == e.landmarkModelUrl) switch(e.modelType){
                            case "lite":
                                e.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/lite/2";
                                break;
                            case "heavy":
                                e.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/heavy/2";
                                break;
                            case "full":
                            default:
                                e.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/full/2";
                        }
                        return e;
                    }(t), n = "string" == typeof e.detectorModelUrl && e.detectorModelUrl.indexOf("https://tfhub.dev") > -1, i = "string" == typeof e.landmarkModelUrl && e.landmarkModelUrl.indexOf("https://tfhub.dev") > -1, [
                        4,
                        Promise.all([
                            (0, $880ccac6c81e2c8b$export$f077572b5d896ffd)(e.detectorModelUrl, {
                                fromTFHub: n
                            }),
                            (0, $880ccac6c81e2c8b$export$f077572b5d896ffd)(e.landmarkModelUrl, {
                                fromTFHub: i
                            })
                        ])
                    ];
                case 1:
                    return r = s.sent(), o = r[0], a = r[1], [
                        2,
                        new $a54e498d8d862fdc$var$re(o, a, e.enableSmoothing, e.enableSegmentation, e.smoothSegmentation, e.modelType)
                    ];
            }
        });
    });
}
var $a54e498d8d862fdc$export$71a8b12e11ac26f3, $a54e498d8d862fdc$export$2f09812b4c450c2b, $a54e498d8d862fdc$var$ue = function() {
    function t(t) {
        !function(t) {
            if (t.maxTracks < 1) throw new Error("Must specify 'maxTracks' to be at least 1, but " + "encountered ".concat(t.maxTracks));
            if (t.maxAge <= 0) throw new Error("Must specify 'maxAge' to be positive, but " + "encountered ".concat(t.maxAge));
            if (void 0 !== t.keypointTrackerParams) {
                if (t.keypointTrackerParams.keypointConfidenceThreshold < 0 || t.keypointTrackerParams.keypointConfidenceThreshold > 1) throw new Error("Must specify 'keypointConfidenceThreshold' to be in the range [0, 1], but encountered " + "".concat(t.keypointTrackerParams.keypointConfidenceThreshold));
                if (t.keypointTrackerParams.minNumberOfKeypoints < 1) throw new Error("Must specify 'minNumberOfKeypoints' to be at least 1, but " + "encountered ".concat(t.keypointTrackerParams.minNumberOfKeypoints));
                for(var e = 0, n = t.keypointTrackerParams.keypointFalloff; e < n.length; e++){
                    var i = n[e];
                    if (i <= 0) throw new Error("Must specify each keypoint falloff parameterto be positive " + "but encountered ".concat(i));
                }
            }
        }(t), this.tracks = [], this.maxTracks = t.maxTracks, this.maxAge = 1e3 * t.maxAge, this.minSimilarity = t.minSimilarity, this.nextID = 1;
    }
    return t.prototype.apply = function(t, e) {
        this.filterOldTracks(e);
        var n = this.computeSimilarity(t);
        return this.assignTracks(t, n, e), this.updateTracks(e), t;
    }, t.prototype.getTracks = function() {
        return this.tracks.slice();
    }, t.prototype.getTrackIDs = function() {
        return new Set(this.tracks.map(function(t) {
            return t.id;
        }));
    }, t.prototype.filterOldTracks = function(t) {
        var e = this;
        this.tracks = this.tracks.filter(function(n) {
            return t - n.lastTimestamp <= e.maxAge;
        });
    }, t.prototype.assignTracks = function(t, e, n) {
        for(var i = Array.from(Array(e[0].length).keys()), r = [], o = 0, a = Array.from(Array(t.length).keys()); o < a.length; o++){
            var s = a[o];
            if (0 !== i.length) {
                for(var u = -1, h = -1, l = 0, c = i; l < c.length; l++){
                    var p = c[l], f = e[s][p];
                    f >= this.minSimilarity && f > h && (u = p, h = f);
                }
                if (u >= 0) {
                    var d = this.tracks[u];
                    d = Object.assign(d, this.createTrack(t[s], n, d.id)), t[s].id = d.id;
                    var m = i.indexOf(u);
                    i.splice(m, 1);
                } else r.push(s);
            } else r.push(s);
        }
        for(var g = 0, y = r; g < y.length; g++){
            s = y[g];
            var v = this.createTrack(t[s], n);
            this.tracks.push(v), t[s].id = v.id;
        }
    }, t.prototype.updateTracks = function(t) {
        this.tracks.sort(function(t, e) {
            return e.lastTimestamp - t.lastTimestamp;
        }), this.tracks = this.tracks.slice(0, this.maxTracks);
    }, t.prototype.createTrack = function(t, e, n) {
        var i = {
            id: n || this.nextTrackID(),
            lastTimestamp: e,
            keypoints: $a54e498d8d862fdc$var$K([], t.keypoints, !0).map(function(t) {
                return $a54e498d8d862fdc$var$B({}, t);
            })
        };
        return void 0 !== t.box && (i.box = $a54e498d8d862fdc$var$B({}, t.box)), i;
    }, t.prototype.nextTrackID = function() {
        var t = this.nextID;
        return this.nextID += 1, t;
    }, t.prototype.remove = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        this.tracks = this.tracks.filter(function(e) {
            return !t.includes(e.id);
        });
    }, t.prototype.reset = function() {
        this.tracks = [];
    }, t;
}(), $a54e498d8d862fdc$var$he = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $a54e498d8d862fdc$var$V(e, t), e.prototype.computeSimilarity = function(t) {
        var e = this;
        return 0 === t.length || 0 === this.tracks.length ? [
            []
        ] : t.map(function(t) {
            return e.tracks.map(function(n) {
                return e.iou(t, n);
            });
        });
    }, e.prototype.iou = function(t, e) {
        var n = Math.max(t.box.xMin, e.box.xMin), i = Math.max(t.box.yMin, e.box.yMin), r = Math.min(t.box.xMax, e.box.xMax), o = Math.min(t.box.yMax, e.box.yMax);
        if (n >= r || i >= o) return 0;
        var a = (r - n) * (o - i);
        return a / (t.box.width * t.box.height + e.box.width * e.box.height - a);
    }, e;
}($a54e498d8d862fdc$var$ue), $a54e498d8d862fdc$var$le = function(t) {
    function e(e) {
        var n = t.call(this, e) || this;
        return n.keypointThreshold = e.keypointTrackerParams.keypointConfidenceThreshold, n.keypointFalloff = e.keypointTrackerParams.keypointFalloff, n.minNumKeyoints = e.keypointTrackerParams.minNumberOfKeypoints, n;
    }
    return $a54e498d8d862fdc$var$V(e, t), e.prototype.computeSimilarity = function(t) {
        if (0 === t.length || 0 === this.tracks.length) return [
            []
        ];
        for(var e = [], n = 0, i = t; n < i.length; n++){
            for(var r = i[n], o = [], a = 0, s = this.tracks; a < s.length; a++){
                var u = s[a];
                o.push(this.oks(r, u));
            }
            e.push(o);
        }
        return e;
    }, e.prototype.oks = function(t, e) {
        for(var n = this.area(e.keypoints) + 1e-6, i = 0, r = 0, o = 0; o < t.keypoints.length; ++o){
            var a = t.keypoints[o], s = e.keypoints[o];
            if (!(a.score < this.keypointThreshold || s.score < this.keypointThreshold)) {
                r += 1;
                var u = Math.pow(a.x - s.x, 2) + Math.pow(a.y - s.y, 2), h = 2 * this.keypointFalloff[o];
                i += Math.exp(-1 * u / (2 * n * Math.pow(h, 2)));
            }
        }
        return r < this.minNumKeyoints ? 0 : i / r;
    }, e.prototype.area = function(t) {
        var e = this, n = t.filter(function(t) {
            return t.score > e.keypointThreshold;
        }), i = Math.min.apply(Math, $a54e498d8d862fdc$var$K([
            1
        ], n.map(function(t) {
            return t.x;
        }), !1)), r = Math.max.apply(Math, $a54e498d8d862fdc$var$K([
            0
        ], n.map(function(t) {
            return t.x;
        }), !1)), o = Math.min.apply(Math, $a54e498d8d862fdc$var$K([
            1
        ], n.map(function(t) {
            return t.y;
        }), !1));
        return (r - i) * (Math.max.apply(Math, $a54e498d8d862fdc$var$K([
            0
        ], n.map(function(t) {
            return t.y;
        }), !1)) - o);
    }, e;
}($a54e498d8d862fdc$var$ue);
function $a54e498d8d862fdc$var$ce(t) {
    switch(t){
        case $a54e498d8d862fdc$export$2f09812b4c450c2b.BlazePose:
            return $a54e498d8d862fdc$var$j.reduce(function(t, e, n) {
                return t[e] = n, t;
            }, {});
        case $a54e498d8d862fdc$export$2f09812b4c450c2b.PoseNet:
        case $a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet:
            return $a54e498d8d862fdc$var$U.reduce(function(t, e, n) {
                return t[e] = n, t;
            }, {});
        default:
            throw new Error("Model ".concat(t, " is not supported."));
    }
}
!function(t) {
    t.Keypoint = "keypoint", t.BoundingBox = "boundingBox";
}($a54e498d8d862fdc$export$71a8b12e11ac26f3 || ($a54e498d8d862fdc$export$71a8b12e11ac26f3 = {})), function(t) {
    t.MoveNet = "MoveNet", t.BlazePose = "BlazePose", t.PoseNet = "PoseNet";
}($a54e498d8d862fdc$export$2f09812b4c450c2b || ($a54e498d8d862fdc$export$2f09812b4c450c2b = {}));
var $a54e498d8d862fdc$export$7debb50ef11d5e0b = Object.freeze({
    __proto__: null,
    getKeypointIndexBySide: function(t) {
        switch(t){
            case $a54e498d8d862fdc$export$2f09812b4c450c2b.BlazePose:
                return $a54e498d8d862fdc$var$H;
            case $a54e498d8d862fdc$export$2f09812b4c450c2b.PoseNet:
            case $a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet:
                return $a54e498d8d862fdc$var$q;
            default:
                throw new Error("Model ".concat(t, " is not supported."));
        }
    },
    getAdjacentPairs: function(t) {
        switch(t){
            case $a54e498d8d862fdc$export$2f09812b4c450c2b.BlazePose:
                return $a54e498d8d862fdc$var$Y;
            case $a54e498d8d862fdc$export$2f09812b4c450c2b.PoseNet:
            case $a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet:
                return $a54e498d8d862fdc$var$X;
            default:
                throw new Error("Model ".concat(t, " is not supported."));
        }
    },
    getKeypointIndexByName: $a54e498d8d862fdc$var$ce
}), $a54e498d8d862fdc$var$fe = [
    "SinglePose.Lightning",
    "SinglePose.Thunder",
    "MultiPose.Lightning"
], $a54e498d8d862fdc$var$de = {
    modelType: "SinglePose.Lightning",
    enableSmoothing: !0
}, $a54e498d8d862fdc$var$me = {}, $a54e498d8d862fdc$var$ge = {
    frequency: 30,
    minCutOff: 2.5,
    beta: 300,
    derivateCutOff: 2.5,
    thresholdCutOff: .5,
    thresholdBeta: 5,
    disableValueScaling: !0
}, $a54e498d8d862fdc$var$ye = {
    maxTracks: 18,
    maxAge: 1e3,
    minSimilarity: .2,
    keypointTrackerParams: {
        keypointConfidenceThreshold: .3,
        keypointFalloff: [
            .026,
            .025,
            .025,
            .035,
            .035,
            .079,
            .079,
            .072,
            .072,
            .062,
            .062,
            .107,
            .107,
            .087,
            .087,
            .089,
            .089
        ],
        minNumberOfKeypoints: 4
    }
}, $a54e498d8d862fdc$var$ve = {
    maxTracks: 18,
    maxAge: 1e3,
    minSimilarity: .15,
    trackerParams: {}
};
function $a54e498d8d862fdc$var$xe(t, e, n, i) {
    for(var r = {}, o = 0, a = $a54e498d8d862fdc$var$U; o < a.length; o++){
        var s = a[o];
        r[s] = [
            e[n[s]].y * i.height,
            e[n[s]].x * i.width
        ];
    }
    if (function(t, e) {
        return (t[e.left_hip].score > .2 || t[e.right_hip].score > .2) && (t[e.left_shoulder].score > .2 || t[e.right_shoulder].score > .2);
    }(e, n)) {
        var u = (r.left_hip[0] + r.right_hip[0]) / 2, h = (r.left_hip[1] + r.right_hip[1]) / 2, l = function(t, e, n, i, r) {
            for(var o = [
                "left_shoulder",
                "right_shoulder",
                "left_hip",
                "right_hip"
            ], a = 0, s = 0, u = 0; u < o.length; u++)(f = Math.abs(i - n[o[u]][0])) > a && (a = f), (d = Math.abs(r - n[o[u]][1])) > s && (s = d);
            for(var h = 0, l = 0, c = 0, p = Object.keys(n); c < p.length; c++){
                var f, d, m = p[c];
                if (!(t[e[m]].score < .2)) (f = Math.abs(i - n[m][0])) > h && (h = f), (d = Math.abs(r - n[m][1])) > l && (l = d);
            }
            return [
                a,
                s,
                h,
                l
            ];
        }(e, n, r, u, h), c = l[0], p = l[1], f = l[2], d = l[3], m = Math.max(1.9 * p, 1.9 * c, 1.2 * f, 1.2 * d), g = [
            u - (m = Math.min(m, Math.max(h, i.width - h, u, i.height - u))),
            h - m
        ];
        if (m > Math.max(i.width, i.height) / 2) return $a54e498d8d862fdc$var$we(null == t, i);
        var y = 2 * m;
        return {
            yMin: g[0] / i.height,
            xMin: g[1] / i.width,
            yMax: (g[0] + y) / i.height,
            xMax: (g[1] + y) / i.width,
            height: (g[0] + y) / i.height - g[0] / i.height,
            width: (g[1] + y) / i.width - g[1] / i.width
        };
    }
    return $a54e498d8d862fdc$var$we(null == t, i);
}
function $a54e498d8d862fdc$var$we(t, e) {
    var n, i, r, o;
    return t ? e.width > e.height ? (n = 1, i = e.height / e.width, r = 0, o = (e.width / 2 - e.height / 2) / e.width) : (n = e.width / e.height, i = 1, r = (e.height / 2 - e.width / 2) / e.height, o = 0) : e.width > e.height ? (n = e.width / e.height, i = 1, r = (e.height / 2 - e.width / 2) / e.height, o = 0) : (n = 1, i = e.height / e.width, r = 0, o = (e.width / 2 - e.height / 2) / e.width), {
        yMin: r,
        xMin: o,
        yMax: r + n,
        xMax: o + i,
        height: n,
        width: i
    };
}
function $a54e498d8d862fdc$var$ke(t) {
    var e, n = null == t ? $a54e498d8d862fdc$var$de : $a54e498d8d862fdc$var$B({}, t);
    if (null == n.modelType) n.modelType = "SinglePose.Lightning";
    else if ($a54e498d8d862fdc$var$fe.indexOf(n.modelType) < 0) throw new Error("Invalid architecture ".concat(n.modelType, ". ") + "Should be one of ".concat($a54e498d8d862fdc$var$fe));
    if (null == n.enableSmoothing && (n.enableSmoothing = !0), null != n.minPoseScore && (n.minPoseScore < 0 || n.minPoseScore > 1)) throw new Error("minPoseScore should be between 0.0 and 1.0");
    if (null != n.multiPoseMaxDimension && (n.multiPoseMaxDimension % 32 != 0 || n.multiPoseMaxDimension < 32)) throw new Error("multiPoseMaxDimension must be a multiple of 32 and higher than 0");
    if ("MultiPose.Lightning" === n.modelType && null == n.enableTracking && (n.enableTracking = !0), "MultiPose.Lightning" === n.modelType && !0 === n.enableTracking) {
        if (null == n.trackerType && (n.trackerType = $a54e498d8d862fdc$export$71a8b12e11ac26f3.BoundingBox), n.trackerType === $a54e498d8d862fdc$export$71a8b12e11ac26f3.Keypoint) null != n.trackerConfig ? n.trackerConfig = function(t) {
            var e = $a54e498d8d862fdc$var$be($a54e498d8d862fdc$var$ye, t);
            e.keypointTrackerParams = $a54e498d8d862fdc$var$B({}, $a54e498d8d862fdc$var$ye.keypointTrackerParams), null != t.keypointTrackerParams && (null != t.keypointTrackerParams.keypointConfidenceThreshold && (e.keypointTrackerParams.keypointConfidenceThreshold = t.keypointTrackerParams.keypointConfidenceThreshold), null != t.keypointTrackerParams.keypointFalloff && (e.keypointTrackerParams.keypointFalloff = t.keypointTrackerParams.keypointFalloff), null != t.keypointTrackerParams.minNumberOfKeypoints && (e.keypointTrackerParams.minNumberOfKeypoints = t.keypointTrackerParams.minNumberOfKeypoints));
            return e;
        }(n.trackerConfig) : n.trackerConfig = $a54e498d8d862fdc$var$ye;
        else {
            if (n.trackerType !== $a54e498d8d862fdc$export$71a8b12e11ac26f3.BoundingBox) throw new Error("Tracker type not supported by MoveNet");
            null != n.trackerConfig ? n.trackerConfig = (e = n.trackerConfig, $a54e498d8d862fdc$var$be($a54e498d8d862fdc$var$ve, e)) : n.trackerConfig = $a54e498d8d862fdc$var$ve;
        }
    }
    return n;
}
function $a54e498d8d862fdc$var$be(t, e) {
    var n = {
        maxTracks: t.maxTracks,
        maxAge: t.maxAge,
        minSimilarity: t.minSimilarity
    };
    return null != e.maxTracks && (n.maxTracks = e.maxTracks), null != e.maxAge && (n.maxAge = e.maxAge), null != e.minSimilarity && (n.minSimilarity = e.minSimilarity), n;
}
var $a54e498d8d862fdc$var$Me = function() {
    function t(t, e) {
        this.moveNetModel = t, this.modelInputResolution = {
            height: 0,
            width: 0
        }, this.keypointIndexByName = $a54e498d8d862fdc$var$ce($a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet), "SinglePose.Lightning" === e.modelType ? (this.modelInputResolution.width = 192, this.modelInputResolution.height = 192) : "SinglePose.Thunder" === e.modelType && (this.modelInputResolution.width = 256, this.modelInputResolution.height = 256), this.multiPoseModel = "MultiPose.Lightning" === e.modelType, this.multiPoseModel || (this.keypointFilter = new $a54e498d8d862fdc$var$Et($a54e498d8d862fdc$var$ge), this.cropRegionFilterYMin = new $a54e498d8d862fdc$var$zt(.9), this.cropRegionFilterXMin = new $a54e498d8d862fdc$var$zt(.9), this.cropRegionFilterYMax = new $a54e498d8d862fdc$var$zt(.9), this.cropRegionFilterXMax = new $a54e498d8d862fdc$var$zt(.9)), this.enableSmoothing = e.enableSmoothing, e.minPoseScore ? this.minPoseScore = e.minPoseScore : this.minPoseScore = .25, e.multiPoseMaxDimension ? this.multiPoseMaxDimension = e.multiPoseMaxDimension : this.multiPoseMaxDimension = 256, this.enableTracking = e.enableTracking, this.multiPoseModel && this.enableTracking && (e.trackerType === $a54e498d8d862fdc$export$71a8b12e11ac26f3.Keypoint ? this.tracker = new $a54e498d8d862fdc$var$le(e.trackerConfig) : e.trackerType === $a54e498d8d862fdc$export$71a8b12e11ac26f3.BoundingBox && (this.tracker = new $a54e498d8d862fdc$var$he(e.trackerConfig)), this.enableSmoothing && (this.keypointFilterMap = new Map));
    }
    return t.prototype.runSinglePersonPoseModel = function(t) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var e, n, i, r, o;
            return $a54e498d8d862fdc$var$D(this, function(a) {
                switch(a.label){
                    case 0:
                        if (4 !== (e = this.moveNetModel.execute(t)).shape.length || 1 !== e.shape[0] || 1 !== e.shape[1] || 17 !== e.shape[2] || 3 !== e.shape[3]) throw e.dispose(), new Error("Unexpected output shape from model: [".concat(e.shape, "]"));
                        return "webgpu" === (0, $8a461ef06e070cc9$export$b098501f764cdf30)() ? [
                            3,
                            1
                        ] : (n = e.dataSync(), [
                            3,
                            3
                        ]);
                    case 1:
                        return [
                            4,
                            e.data()
                        ];
                    case 2:
                        n = a.sent(), a.label = 3;
                    case 3:
                        for(e.dispose(), i = {
                            keypoints: [],
                            score: 0
                        }, r = 0, o = 0; o < 17; ++o)i.keypoints[o] = {
                            y: n[3 * o],
                            x: n[3 * o + 1],
                            score: n[3 * o + 2]
                        }, i.keypoints[o].score > .2 && (++r, i.score += i.keypoints[o].score);
                        return r > 0 && (i.score /= r), [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.runMultiPersonPoseModel = function(t) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var e, n, i, r, o, a, s, u;
            return $a54e498d8d862fdc$var$D(this, function(h) {
                switch(h.label){
                    case 0:
                        if (3 !== (e = this.moveNetModel.execute(t)).shape.length || 1 !== e.shape[0] || 56 !== e.shape[2]) throw e.dispose(), new Error("Unexpected output shape from model: [".concat(e.shape, "]"));
                        return "webgpu" === (0, $8a461ef06e070cc9$export$b098501f764cdf30)() ? [
                            3,
                            1
                        ] : (n = e.dataSync(), [
                            3,
                            3
                        ]);
                    case 1:
                        return [
                            4,
                            e.data()
                        ];
                    case 2:
                        n = h.sent(), h.label = 3;
                    case 3:
                        for(e.dispose(), i = [], r = n.length / 56, o = 0; o < r; ++o)for(i[o] = {
                            keypoints: []
                        }, a = 56 * o + 51, i[o].box = {
                            yMin: n[a],
                            xMin: n[a + 1],
                            yMax: n[a + 2],
                            xMax: n[a + 3],
                            width: n[a + 3] - n[a + 1],
                            height: n[a + 2] - n[a]
                        }, s = 56 * o + 55, i[o].score = n[s], i[o].keypoints = [], u = 0; u < 17; ++u)i[o].keypoints[u] = {
                            y: n[56 * o + 3 * u],
                            x: n[56 * o + 3 * u + 1],
                            score: n[56 * o + 3 * u + 2]
                        };
                        return [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.estimatePoses = function(t, n, i) {
        return void 0 === n && (n = $a54e498d8d862fdc$var$me), $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var r, o, a, s, u, l;
            return $a54e498d8d862fdc$var$D(this, function(c) {
                switch(c.label){
                    case 0:
                        return n = function(t) {
                            return null == t ? $a54e498d8d862fdc$var$me : $a54e498d8d862fdc$var$B({}, t);
                        }(n), null == t ? (this.reset(), [
                            2,
                            []
                        ]) : (null == i ? $a54e498d8d862fdc$var$vt(t) && (i = 1e6 * t.currentTime) : i *= 1e3, r = $a54e498d8d862fdc$var$at(t), o = $a54e498d8d862fdc$var$rt(r), a = (0, $31018343da089cd7$export$d660d8ed21f46635)(r, 0), t instanceof (0, $4b7222b1b59444b8$export$7b6b8d90402f8814) || r.dispose(), s = [], this.multiPoseModel ? [
                            3,
                            2
                        ] : [
                            4,
                            this.estimateSinglePose(a, o, i)
                        ]);
                    case 1:
                        return s = c.sent(), [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.estimateMultiplePoses(a, o, i)
                        ];
                    case 3:
                        s = c.sent(), c.label = 4;
                    case 4:
                        for(u = 0; u < s.length; ++u)for(l = 0; l < s[u].keypoints.length; ++l)s[u].keypoints[l].name = $a54e498d8d862fdc$var$U[l], s[u].keypoints[l].y *= o.height, s[u].keypoints[l].x *= o.width;
                        return [
                            2,
                            s
                        ];
                }
            });
        });
    }, t.prototype.estimateSinglePose = function(t, e, n) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var i, o, a, h, c = this;
            return $a54e498d8d862fdc$var$D(this, function(p) {
                switch(p.label){
                    case 0:
                        return this.cropRegion || (this.cropRegion = $a54e498d8d862fdc$var$we(null == this.cropRegion, e)), i = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                            var e = (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)([
                                [
                                    c.cropRegion.yMin,
                                    c.cropRegion.xMin,
                                    c.cropRegion.yMax,
                                    c.cropRegion.xMax
                                ]
                            ]), n = (0, $a0e8420b37ff8039$export$4445a00dafa2633b)([
                                1
                            ], "int32"), i = [
                                c.modelInputResolution.height,
                                c.modelInputResolution.width
                            ];
                            return (0, $262a02e810d931f1$export$f2db7d5238e1d23f)((0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).cropAndResize(t, e, n, i, "bilinear", 0), "int32");
                        }), t.dispose(), [
                            4,
                            this.runSinglePersonPoseModel(i)
                        ];
                    case 1:
                        if (o = p.sent(), i.dispose(), o.score < this.minPoseScore) return this.reset(), [
                            2,
                            []
                        ];
                        for(a = 0; a < o.keypoints.length; ++a)o.keypoints[a].y = this.cropRegion.yMin + o.keypoints[a].y * this.cropRegion.height, o.keypoints[a].x = this.cropRegion.xMin + o.keypoints[a].x * this.cropRegion.width;
                        return null != n && this.enableSmoothing && (o.keypoints = this.keypointFilter.apply(o.keypoints, n, 1)), h = $a54e498d8d862fdc$var$xe(this.cropRegion, o.keypoints, this.keypointIndexByName, e), this.cropRegion = this.filterCropRegion(h), [
                            2,
                            [
                                o
                            ]
                        ];
                }
            });
        });
    }, t.prototype.estimateMultiplePoses = function(t, e, n) {
        return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var i, r, o, a, s, h, c, p, f, d, m, g = this;
            return $a54e498d8d862fdc$var$D(this, function(y) {
                switch(y.label){
                    case 0:
                        return e.width > e.height ? (r = this.multiPoseMaxDimension, o = Math.round(this.multiPoseMaxDimension * e.height / e.width), i = (0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).resizeBilinear(t, [
                            o,
                            r
                        ]), s = r, h = 32 * Math.ceil(o / 32), a = (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(i, [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                h - o
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ])) : (r = Math.round(this.multiPoseMaxDimension * e.width / e.height), o = this.multiPoseMaxDimension, i = (0, $0d9cd03b68b74ca9$export$5c452ff88e35e47d).resizeBilinear(t, [
                            o,
                            r
                        ]), s = 32 * Math.ceil(r / 32), h = o, a = (0, $6d3dcf71964d715a$export$5d04458e2a6c373e)(i, [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                s - r
                            ],
                            [
                                0,
                                0
                            ]
                        ])), i.dispose(), t.dispose(), c = (0, $262a02e810d931f1$export$f2db7d5238e1d23f)(a, "int32"), a.dispose(), [
                            4,
                            this.runMultiPersonPoseModel(c)
                        ];
                    case 1:
                        for(p = y.sent(), c.dispose(), p = p.filter(function(t) {
                            return t.score >= g.minPoseScore;
                        }), d = 0; d < p.length; ++d)for(f = 0; f < p[d].keypoints.length; ++f)p[d].keypoints[f].y *= h / o, p[d].keypoints[f].x *= s / r;
                        if (this.enableTracking && (this.tracker.apply(p, n), this.enableSmoothing)) {
                            for(d = 0; d < p.length; ++d)this.keypointFilterMap.has(p[d].id) || this.keypointFilterMap.set(p[d].id, new $a54e498d8d862fdc$var$Et($a54e498d8d862fdc$var$ge)), p[d].keypoints = this.keypointFilterMap.get(p[d].id).apply(p[d].keypoints, n, 1);
                            m = this.tracker.getTrackIDs(), this.keypointFilterMap.forEach(function(t, e) {
                                m.has(e) || g.keypointFilterMap.delete(e);
                            });
                        }
                        return [
                            2,
                            p
                        ];
                }
            });
        });
    }, t.prototype.filterCropRegion = function(t) {
        if (t) {
            var e = this.cropRegionFilterYMin.apply(t.yMin), n = this.cropRegionFilterXMin.apply(t.xMin), i = this.cropRegionFilterYMax.apply(t.yMax), r = this.cropRegionFilterXMax.apply(t.xMax);
            return {
                yMin: e,
                xMin: n,
                yMax: i,
                xMax: r,
                height: i - e,
                width: r - n
            };
        }
        return this.cropRegionFilterYMin.reset(), this.cropRegionFilterXMin.reset(), this.cropRegionFilterYMax.reset(), this.cropRegionFilterXMax.reset(), null;
    }, t.prototype.dispose = function() {
        this.moveNetModel.dispose();
    }, t.prototype.reset = function() {
        this.cropRegion = null, this.resetFilters();
    }, t.prototype.resetFilters = function() {
        this.keypointFilter.reset(), this.cropRegionFilterYMin.reset(), this.cropRegionFilterXMin.reset(), this.cropRegionFilterYMax.reset(), this.cropRegionFilterXMax.reset();
    }, t;
}();
function $a54e498d8d862fdc$var$Se(t) {
    return void 0 === t && (t = $a54e498d8d862fdc$var$de), $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var e, n, i, r;
        return $a54e498d8d862fdc$var$D(this, function(o) {
            switch(o.label){
                case 0:
                    return e = $a54e498d8d862fdc$var$ke(t), i = !0, e.modelUrl ? (i = "string" == typeof e.modelUrl && e.modelUrl.indexOf("https://tfhub.dev") > -1, [
                        4,
                        (0, $880ccac6c81e2c8b$export$f077572b5d896ffd)(e.modelUrl, {
                            fromTFHub: i
                        })
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return n = o.sent(), [
                        3,
                        4
                    ];
                case 2:
                    return r = void 0, "SinglePose.Lightning" === e.modelType ? r = "https://tfhub.dev/google/tfjs-model/movenet/singlepose/lightning/4" : "SinglePose.Thunder" === e.modelType ? r = "https://tfhub.dev/google/tfjs-model/movenet/singlepose/thunder/4" : "MultiPose.Lightning" === e.modelType && (r = "https://tfhub.dev/google/tfjs-model/movenet/multipose/lightning/1"), [
                        4,
                        (0, $880ccac6c81e2c8b$export$f077572b5d896ffd)(r, {
                            fromTFHub: i
                        })
                    ];
                case 3:
                    n = o.sent(), o.label = 4;
                case 4:
                    return "webgl" === (0, $8a461ef06e070cc9$export$b098501f764cdf30)() && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD", 0), [
                        2,
                        new $a54e498d8d862fdc$var$Me(n, e)
                    ];
            }
        });
    });
}
var $a54e498d8d862fdc$var$Te = {
    architecture: "MobileNetV1",
    outputStride: 16,
    multiplier: .75,
    inputResolution: {
        height: 257,
        width: 257
    }
}, $a54e498d8d862fdc$var$Pe = [
    "MobileNetV1",
    "ResNet50"
], $a54e498d8d862fdc$var$Fe = {
    MobileNetV1: [
        8,
        16
    ],
    ResNet50: [
        16
    ]
}, $a54e498d8d862fdc$var$_e = [
    8,
    16,
    32
], $a54e498d8d862fdc$var$Oe = {
    MobileNetV1: [
        .5,
        .75,
        1
    ],
    ResNet50: [
        1
    ]
}, $a54e498d8d862fdc$var$Ie = [
    1,
    2,
    4
], $a54e498d8d862fdc$var$Ae = {
    maxPoses: 1,
    flipHorizontal: !1
}, $a54e498d8d862fdc$var$ze = {
    maxPoses: 5,
    flipHorizontal: !1,
    scoreThreshold: .5,
    nmsRadius: 20
}, $a54e498d8d862fdc$var$Ce = [
    -123.15,
    -115.9,
    -103.06
];
function $a54e498d8d862fdc$var$Ee(t) {
    return Math.floor(t / 2);
}
var $a54e498d8d862fdc$var$Re = function() {
    function t(t, e) {
        this.priorityQueue = new Array(t), this.numberOfElements = -1, this.getElementValue = e;
    }
    return t.prototype.enqueue = function(t) {
        this.priorityQueue[++this.numberOfElements] = t, this.swim(this.numberOfElements);
    }, t.prototype.dequeue = function() {
        var t = this.priorityQueue[0];
        return this.exchange(0, this.numberOfElements--), this.sink(0), this.priorityQueue[this.numberOfElements + 1] = null, t;
    }, t.prototype.empty = function() {
        return -1 === this.numberOfElements;
    }, t.prototype.size = function() {
        return this.numberOfElements + 1;
    }, t.prototype.all = function() {
        return this.priorityQueue.slice(0, this.numberOfElements + 1);
    }, t.prototype.max = function() {
        return this.priorityQueue[0];
    }, t.prototype.swim = function(t) {
        for(; t > 0 && this.less($a54e498d8d862fdc$var$Ee(t), t);)this.exchange(t, $a54e498d8d862fdc$var$Ee(t)), t = $a54e498d8d862fdc$var$Ee(t);
    }, t.prototype.sink = function(t) {
        for(; 2 * t <= this.numberOfElements;){
            var e = 2 * t;
            if (e < this.numberOfElements && this.less(e, e + 1) && e++, !this.less(t, e)) break;
            this.exchange(t, e), t = e;
        }
    }, t.prototype.getValueAt = function(t) {
        return this.getElementValue(this.priorityQueue[t]);
    }, t.prototype.less = function(t, e) {
        return this.getValueAt(t) < this.getValueAt(e);
    }, t.prototype.exchange = function(t, e) {
        var n = this.priorityQueue[t];
        this.priorityQueue[t] = this.priorityQueue[e], this.priorityQueue[e] = n;
    }, t;
}();
function $a54e498d8d862fdc$var$Le(t, e, n, i, r, o) {
    for(var a = o.shape, s = a[0], u = a[1], h = !0, l = Math.max(n - r, 0), c = Math.min(n + r + 1, s), p = l; p < c; ++p){
        for(var f = Math.max(i - r, 0), d = Math.min(i + r + 1, u), m = f; m < d; ++m)if (o.get(p, m, t) > e) {
            h = !1;
            break;
        }
        if (!h) break;
    }
    return h;
}
function $a54e498d8d862fdc$var$Ve(t) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        return $a54e498d8d862fdc$var$D(this, function(e) {
            return [
                2,
                Promise.all(t.map(function(t) {
                    return t.buffer();
                }))
            ];
        });
    });
}
function $a54e498d8d862fdc$var$Be(t, e, n, i) {
    return {
        y: i.get(t, e, n),
        x: i.get(t, e, n + 17)
    };
}
function $a54e498d8d862fdc$var$Ne(t, e, n) {
    var i = $a54e498d8d862fdc$var$Be(t.heatmapY, t.heatmapX, t.id, n), r = i.y, o = i.x;
    return {
        x: t.heatmapX * e + o,
        y: t.heatmapY * e + r
    };
}
function $a54e498d8d862fdc$var$De(t, e, n, i) {
    var r = n.x, o = n.y;
    return t.some(function(t) {
        var n, a, s, u, h, l, c = t.keypoints;
        return n = o, a = r, s = c[i].y, u = c[i].x, (h = s - n) * h + (l = u - a) * l <= e;
    });
}
var $a54e498d8d862fdc$var$Ke = $a54e498d8d862fdc$var$U.reduce(function(t, e, n) {
    return t[e] = n, t;
}, {}), $a54e498d8d862fdc$var$Ue = [
    [
        "nose",
        "left_eye"
    ],
    [
        "left_eye",
        "left_ear"
    ],
    [
        "nose",
        "right_eye"
    ],
    [
        "right_eye",
        "right_ear"
    ],
    [
        "nose",
        "left_shoulder"
    ],
    [
        "left_shoulder",
        "left_elbow"
    ],
    [
        "left_elbow",
        "left_wrist"
    ],
    [
        "left_shoulder",
        "left_hip"
    ],
    [
        "left_hip",
        "left_knee"
    ],
    [
        "left_knee",
        "left_ankle"
    ],
    [
        "nose",
        "right_shoulder"
    ],
    [
        "right_shoulder",
        "right_elbow"
    ],
    [
        "right_elbow",
        "right_wrist"
    ],
    [
        "right_shoulder",
        "right_hip"
    ],
    [
        "right_hip",
        "right_knee"
    ],
    [
        "right_knee",
        "right_ankle"
    ]
].map(function(t) {
    var e = t[0], n = t[1];
    return [
        $a54e498d8d862fdc$var$Ke[e],
        $a54e498d8d862fdc$var$Ke[n]
    ];
}), $a54e498d8d862fdc$var$je = $a54e498d8d862fdc$var$Ue.map(function(t) {
    return t[1];
}), $a54e498d8d862fdc$var$He = $a54e498d8d862fdc$var$Ue.map(function(t) {
    return t[0];
});
function $a54e498d8d862fdc$var$qe(t, e, n) {
    return t < e ? e : t > n ? n : t;
}
function $a54e498d8d862fdc$var$Xe(t, e, n, i) {
    return {
        y: $a54e498d8d862fdc$var$qe(Math.round(t.y / e), 0, n - 1),
        x: $a54e498d8d862fdc$var$qe(Math.round(t.x / e), 0, i - 1)
    };
}
function $a54e498d8d862fdc$var$Ye(t, e) {
    return {
        x: t.x + e.x,
        y: t.y + e.y
    };
}
function $a54e498d8d862fdc$var$We(t, e, n, i, r, o, a, s) {
    void 0 === s && (s = 2);
    for(var u = i.shape, h = u[0], l = u[1], c = {
        y: e.y,
        x: e.x
    }, p = $a54e498d8d862fdc$var$Ye(c, function(t, e, n) {
        var i = n.shape[2] / 2;
        return {
            y: n.get(e.y, e.x, t),
            x: n.get(e.y, e.x, i + t)
        };
    }(t, $a54e498d8d862fdc$var$Xe(c, o, h, l), a)), f = 0; f < s; f++){
        var d = $a54e498d8d862fdc$var$Xe(p, o, h, l), m = $a54e498d8d862fdc$var$Be(d.y, d.x, n, r);
        p = $a54e498d8d862fdc$var$Ye({
            x: d.x * o,
            y: d.y * o
        }, {
            x: m.x,
            y: m.y
        });
    }
    var g = $a54e498d8d862fdc$var$Xe(p, o, h, l), y = i.get(g.y, g.x, n);
    return {
        y: p.y,
        x: p.x,
        name: $a54e498d8d862fdc$var$U[n],
        score: y
    };
}
function $a54e498d8d862fdc$var$Ge(t, e, n, i, r, o) {
    var a = e.shape[2], s = $a54e498d8d862fdc$var$je.length, u = new Array(a), h = t.part, l = t.score, c = $a54e498d8d862fdc$var$Ne(h, i, n);
    u[h.id] = {
        score: l,
        name: $a54e498d8d862fdc$var$U[h.id],
        y: c.y,
        x: c.x
    };
    for(var p = s - 1; p >= 0; --p){
        var f = $a54e498d8d862fdc$var$je[p], d = $a54e498d8d862fdc$var$He[p];
        u[f] && !u[d] && (u[d] = $a54e498d8d862fdc$var$We(p, u[f], d, e, n, i, o));
    }
    for(p = 0; p < s; ++p){
        f = $a54e498d8d862fdc$var$He[p], d = $a54e498d8d862fdc$var$je[p];
        u[f] && !u[d] && (u[d] = $a54e498d8d862fdc$var$We(p, u[f], d, e, n, i, r));
    }
    return u;
}
function $a54e498d8d862fdc$var$Qe(t, e, n) {
    return n.reduce(function(n, i, r) {
        var o = i.y, a = i.x, s = i.score;
        return $a54e498d8d862fdc$var$De(t, e, {
            y: o,
            x: a
        }, r) || (n += s), n;
    }, 0) / n.length;
}
function $a54e498d8d862fdc$var$Ze(t, e, n, i, r, o, a, s) {
    return void 0 === a && (a = .5), void 0 === s && (s = 20), $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var u, h, l, c, p, f, d, m, g, y, v, x;
        return $a54e498d8d862fdc$var$D(this, function(w) {
            switch(w.label){
                case 0:
                    return [
                        4,
                        $a54e498d8d862fdc$var$Ve([
                            t,
                            e,
                            n,
                            i
                        ])
                    ];
                case 1:
                    for(u = w.sent(), h = u[0], l = u[1], c = u[2], p = u[3], f = [], d = function(t, e, n) {
                        for(var i = n.shape, r = i[0], o = i[1], a = i[2], s = new $a54e498d8d862fdc$var$Re(r * o * a, function(t) {
                            return t.score;
                        }), u = 0; u < r; ++u)for(var h = 0; h < o; ++h)for(var l = 0; l < a; ++l){
                            var c = n.get(u, h, l);
                            c < t || $a54e498d8d862fdc$var$Le(l, c, u, h, e, n) && s.enqueue({
                                score: c,
                                part: {
                                    heatmapY: u,
                                    heatmapX: h,
                                    id: l
                                }
                            });
                        }
                        return s;
                    }(a, 1, h), m = s * s; f.length < o && !d.empty();)g = d.dequeue(), y = $a54e498d8d862fdc$var$Ne(g.part, r, l), $a54e498d8d862fdc$var$De(f, m, y, g.part.id) || (v = $a54e498d8d862fdc$var$Ge(g, h, l, r, c, p), x = $a54e498d8d862fdc$var$Qe(f, m, v), f.push({
                        keypoints: v,
                        score: x
                    }));
                    return [
                        2,
                        f
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$$e() {
    for(var t, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
    switch(e.length){
        case 0:
            t = "fn main() ";
            break;
        case 1:
            t = "fn main(".concat(e[0], " : i32)");
            break;
        default:
            throw Error("Unreachable");
    }
    return t;
}
var $a54e498d8d862fdc$var$Je = function() {
    function t(t) {
        this.variableNames = [
            "A",
            "B"
        ], this.size = !0;
        this.workgroupSize = [
            32,
            1,
            1
        ], this.outputShape = [
            t[0],
            1
        ], this.dispatchLayout = (0, $8e83a93f95f027c6$exports).flatDispatchLayout(this.outputShape), this.dispatch = (0, $8e83a93f95f027c6$exports).computeDispatch(this.dispatchLayout, this.outputShape, this.workgroupSize), this.shaderKey = "getpointsConfidenceOp";
    }
    return t.prototype.getUserCode = function() {
        return "\n        ".concat($a54e498d8d862fdc$var$$e("index"), " {\n          if (index < uniforms.size) {\n            let y = B[index * 2];\n            let x = B[index * 2 + 1];\n            let outIndex = y * uniforms.aShape.x * uniforms.aShape.z + x * uniforms.aShape.z + index;\n            result[index] = A[outIndex];\n          }\n        }\n        ");
    }, t;
}();
function $a54e498d8d862fdc$var$tn(t, e) {
    if ((0, $8a461ef06e070cc9$export$32a253b6f8b50fb4)() instanceof (0, $4a4d6f6879225fff$export$6f9bc39baf8c093a)) return function(t, e) {
        var n = (0, $8a461ef06e070cc9$export$32a253b6f8b50fb4)(), i = new $a54e498d8d862fdc$var$Je(e.shape), r = n.runWebGPUProgram(i, [
            t,
            e
        ], "float32");
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(r);
    }(t, e);
    throw new Error("getPointsConfidenceWebGPU is not supported in this backend!");
}
var $a54e498d8d862fdc$var$en = function() {
    function t(t) {
        if (this.variableNames = [
            "A",
            "B"
        ], this.size = !0, this.supportedLastDimension = 2, 2 !== t.length || t[1] !== this.supportedLastDimension) throw new Error("GetOffsetVectorsProgram only supports shape of [x, ".concat(this.supportedLastDimension, "], but current shape is ").concat(t));
        this.workgroupSize = [
            32,
            1,
            1
        ], this.outputShape = t;
        var e = [
            t[0],
            1
        ];
        this.dispatchLayout = (0, $8e83a93f95f027c6$exports).flatDispatchLayout(e), this.dispatch = (0, $8e83a93f95f027c6$exports).computeDispatch(this.dispatchLayout, e, this.workgroupSize), this.shaderKey = "GetOffsetVectors";
    }
    return t.prototype.getUserCode = function() {
        return "\n    fn getOffsetPoint(y: i32, x: i32, index: i32) -> vec2<i32> {\n      let outIndexY = y * uniforms.bShape.x * uniforms.bShape.y + x * uniforms.bShape.y + index;\n      let outIndexX = outIndexY + uniforms.bShape.z;\n      let outY = i32(B[outIndexY]);\n      let outX = i32(B[outIndexX]);\n      return vec2<i32>(outY, outX);\n    }\n\n    ".concat($a54e498d8d862fdc$var$$e("index"), " {\n      if (index < uniforms.size) {\n        let indexY = index * ").concat(this.supportedLastDimension, ";\n        let indexX = indexY + 1;\n        let heatmapY = A[indexY];\n        let heatmapX = A[indexX];\n        let out = getOffsetPoint(i32(heatmapY), i32(heatmapX), index);\n        result[indexY] = f32(out[0]);\n        result[indexX] = f32(out[1]);\n      }\n    }\n    ");
    }, t;
}();
function $a54e498d8d862fdc$var$nn(t, e) {
    if ((0, $8a461ef06e070cc9$export$32a253b6f8b50fb4)() instanceof (0, $4a4d6f6879225fff$export$6f9bc39baf8c093a)) return function(t, e) {
        var n = (0, $8a461ef06e070cc9$export$32a253b6f8b50fb4)(), i = new $a54e498d8d862fdc$var$en(t.shape), r = n.runWebGPUProgram(i, [
            t,
            e
        ], "float32");
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(r);
    }(t, e);
    throw new Error("getOffsetVectorsGPU is not supported in this backend!");
}
function $a54e498d8d862fdc$var$rn(t) {
    var e = t.shape, n = e[0], i = e[1], o = e[2];
    return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
        var e, s, u = (0, $6e2ae4fe7bb01bb0$export$9eaad88cf88cee2b)(t, [
            n * i,
            o
        ]), l = (0, $3cfdfd16cd19c85f$export$7980a683c1b852b4)(u, 0), c = (0, $31018343da089cd7$export$d660d8ed21f46635)((0, $3321ac17b3d0dfc7$export$159d9494db57879b)(l, (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(i, "int32")), 1), p = (0, $31018343da089cd7$export$d660d8ed21f46635)((e = l, s = i, (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
            var t = (0, $3321ac17b3d0dfc7$export$159d9494db57879b)(e, (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(s, "int32"));
            return (0, $6b10a09db634e9ba$export$f93b5905241a7cca)(e, (0, $582b63c19659e1cf$export$6e3a27864ab166fe)(t, (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(s, "int32")));
        })), 1);
        return (0, $5ddc229895c6e9a9$export$ee1b3e54f0441b22)([
            c,
            p
        ], 1);
    });
}
function $a54e498d8d862fdc$var$on(t, e, n) {
    return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
        var i = function(t, e) {
            for(var n = [], i = 0; i < $a54e498d8d862fdc$var$U.length; i++){
                var r = t.get(i, 0).valueOf(), o = t.get(i, 1).valueOf(), a = $a54e498d8d862fdc$var$an(r, o, i, e), u = a.x, h = a.y;
                n.push(h), n.push(u);
            }
            return (0, $bb1fb3a4fbd244b1$export$b5469a65e8732256)(n, [
                $a54e498d8d862fdc$var$U.length,
                2
            ]);
        }(t, n);
        return (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(t.toTensor(), (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(e, "int32")), "float32"), i);
    });
}
function $a54e498d8d862fdc$var$an(t, e, n, i) {
    return {
        y: i.get(t, e, n),
        x: i.get(t, e, n + $a54e498d8d862fdc$var$U.length)
    };
}
function $a54e498d8d862fdc$var$sn(t, e, n) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u, h, l, c, p;
        return $a54e498d8d862fdc$var$D(this, function(f) {
            switch(f.label){
                case 0:
                    return i = 0, r = $a54e498d8d862fdc$var$rn(t), [
                        4,
                        Promise.all([
                            t.buffer(),
                            e.buffer(),
                            r.buffer()
                        ])
                    ];
                case 1:
                    return o = f.sent(), a = o[0], s = o[1], u = o[2], [
                        4,
                        (h = $a54e498d8d862fdc$var$on(u, n, s)).buffer()
                    ];
                case 2:
                    return l = f.sent(), c = Array.from(function(t, e) {
                        for(var n = e.shape[0], i = new Float32Array(n), r = 0; r < n; r++){
                            var o = e.get(r, 0), a = e.get(r, 1);
                            i[r] = t.get(o, a, r);
                        }
                        return i;
                    }(a, u)), p = c.map(function(t, e) {
                        return i += t, {
                            y: l.get(e, 0),
                            x: l.get(e, 1),
                            score: t,
                            name: $a54e498d8d862fdc$var$U[e]
                        };
                    }), r.dispose(), h.dispose(), [
                        2,
                        {
                            keypoints: p,
                            score: i / p.length
                        }
                    ];
            }
        });
    });
}
function $a54e498d8d862fdc$var$un(t, e, n) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var i, s, u;
        return $a54e498d8d862fdc$var$D(this, function(h) {
            return i = $a54e498d8d862fdc$var$rn(t), s = function(t, e, n) {
                return (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(function() {
                    var i = $a54e498d8d862fdc$var$nn(t, n);
                    return (0, $8efd352f234ac278$export$e16d8520af44a096)((0, $262a02e810d931f1$export$f2db7d5238e1d23f)((0, $582b63c19659e1cf$export$6e3a27864ab166fe)(t, (0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(e, "int32")), "float32"), i);
                });
            }(i, n, e), u = $a54e498d8d862fdc$var$tn(t, i), [
                2,
                [
                    s,
                    u
                ]
            ];
        });
    });
}
function $a54e498d8d862fdc$var$hn(t, e) {
    return (t - 1) % e == 0;
}
var $a54e498d8d862fdc$var$ln = "https://storage.googleapis.com/tfjs-models/savedmodel/posenet/mobilenet/", $a54e498d8d862fdc$var$cn = "https://storage.googleapis.com/tfjs-models/savedmodel/posenet/resnet50/";
function $a54e498d8d862fdc$var$pn(t, e) {
    return function(t, e) {
        return (t - 1) % e == 0;
    }(t, e) ? t : Math.floor(t / e) * e + 1;
}
var $a54e498d8d862fdc$var$fn = function() {
    function t(t, e) {
        this.posenetModel = t;
        var n = this.posenetModel.inputs[0].shape;
        (0, $0775da5e684c8c0d$exports).assert(-1 === n[1] && -1 === n[2], function() {
            return "Input shape [".concat(n[1], ", ").concat(n[2], "] ") + "must both be equal to or -1";
        });
        var r, o, a = (r = e.inputResolution, o = e.outputStride, {
            height: $a54e498d8d862fdc$var$pn(r.height, o),
            width: $a54e498d8d862fdc$var$pn(r.width, o)
        });
        !function(t) {
            (0, $0775da5e684c8c0d$exports).assert($a54e498d8d862fdc$var$_e.indexOf(t) >= 0, function() {
                return "outputStride of ".concat(t, " is invalid. ") + "It must be either 8 or 16.";
            });
        }(e.outputStride), function(t, e) {
            (0, $0775da5e684c8c0d$exports).assert($a54e498d8d862fdc$var$hn(t.height, e), function() {
                return "height of ".concat(t.height, " is invalid for output stride ") + "".concat(e, ".");
            }), (0, $0775da5e684c8c0d$exports).assert($a54e498d8d862fdc$var$hn(t.width, e), function() {
                return "width of ".concat(t.width, " is invalid for output stride ") + "".concat(e, ".");
            });
        }(a, e.outputStride), this.inputResolution = a, this.outputStride = e.outputStride, this.architecture = e.architecture;
    }
    return t.prototype.estimatePoses = function(t, e) {
        return void 0 === e && (e = $a54e498d8d862fdc$var$Ae), $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            return $a54e498d8d862fdc$var$D(this, function(n) {
                return [
                    2,
                    this.estimatePosesGPU(t, e, !1)
                ];
            });
        });
    }, t.prototype.estimatePosesGPU = function(t, e, n) {
        return void 0 === e && (e = $a54e498d8d862fdc$var$Ae), void 0 === n && (n = !1), $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
            var i, r, a, s, u, h, l, c, d, m, g, y, v, x, w, k, b, M;
            return $a54e498d8d862fdc$var$D(this, function(S) {
                switch(S.label){
                    case 0:
                        return i = function(t) {
                            var e = t;
                            if (null == e.maxPoses && (e.maxPoses = 1), e.maxPoses <= 0) throw new Error("Invalid maxPoses ".concat(e.maxPoses, ". Should be > 0."));
                            if (e.maxPoses > 1) {
                                if ((e = $a54e498d8d862fdc$var$B($a54e498d8d862fdc$var$B({}, $a54e498d8d862fdc$var$ze), e)).scoreThreshold < 0 || e.scoreThreshold > 1) throw new Error("Invalid scoreThreshold ".concat(e.scoreThreshold, ". ") + "Should be in range [0.0, 1.0]");
                                if (e.nmsRadius <= 0) throw new Error("Invalid nmsRadius ".concat(e.nmsRadius, "."));
                            }
                            return e;
                        }(e), null == t ? [
                            2,
                            n ? [
                                [],
                                []
                            ] : []
                        ] : (this.maxPoses = i.maxPoses, r = $a54e498d8d862fdc$var$mt(t, {
                            outputTensorSize: this.inputResolution,
                            keepAspectRatio: !0,
                            borderMode: "replicate"
                        }), a = r.imageTensor, s = r.padding, u = "ResNet50" === this.architecture ? (0, $8efd352f234ac278$export$e16d8520af44a096)(a, $a54e498d8d862fdc$var$Ce) : $a54e498d8d862fdc$var$dt(a, [
                            -1,
                            1
                        ]), h = this.posenetModel.predict(u), "ResNet50" === this.architecture ? (l = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[2], [
                            0
                        ]), c = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[3], [
                            0
                        ]), d = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[0], [
                            0
                        ]), m = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[1], [
                            0
                        ])) : (l = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[0], [
                            0
                        ]), c = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[1], [
                            0
                        ]), d = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[2], [
                            0
                        ]), m = (0, $d85a848eb4aff9d2$export$889c931173b77c2f)(h[3], [
                            0
                        ])), g = (0, $4e7e1888b524d401$export$3b295495ca3cad7c)(c), 1 !== this.maxPoses ? [
                            3,
                            5
                        ] : n ? [
                            4,
                            $a54e498d8d862fdc$var$un(g, l, this.outputStride)
                        ] : [
                            3,
                            2
                        ]);
                    case 1:
                        return v = S.sent(), w = v[0], x = v[1], y = [
                            w,
                            x
                        ], [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            $a54e498d8d862fdc$var$sn(g, l, this.outputStride)
                        ];
                    case 3:
                        w = S.sent(), y = [
                            w
                        ], S.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        if (n) throw new Error("GPU renderer only supports single pose!");
                        return [
                            4,
                            $a54e498d8d862fdc$var$Ze(g, l, d, m, this.outputStride, this.maxPoses, i.scoreThreshold, i.nmsRadius)
                        ];
                    case 6:
                        y = S.sent(), S.label = 7;
                    case 7:
                        if (n) {
                            if (!0 === i.flipHorizontal) throw new Error("flipHorizontal is not supported!");
                            k = this.getCanvasInfo($a54e498d8d862fdc$var$rt(t), this.inputResolution, s);
                        } else M = $a54e498d8d862fdc$var$rt(t), b = function(t, e, n, i) {
                            var r = e.height, o = e.width, a = r / (n.height * (1 - i.top - i.bottom)), s = o / (n.width * (1 - i.left - i.right)), u = -i.top * n.height, h = -i.left * n.width;
                            if (1 === s && 1 === a && 0 === u && 0 === h) return t;
                            for(var l = 0, c = t; l < c.length; l++)for(var p = 0, f = c[l].keypoints; p < f.length; p++){
                                var d = f[p];
                                d.x = (d.x + h) * s, d.y = (d.y + u) * a;
                            }
                            return t;
                        }(y, M, this.inputResolution, s), i.flipHorizontal && (b = function(t, e) {
                            for(var n = 0, i = t; n < i.length; n++)for(var r = 0, o = i[n].keypoints; r < o.length; r++){
                                var a = o[r];
                                a.x = e.width - 1 - a.x;
                            }
                            return t;
                        }(b, M));
                        return a.dispose(), u.dispose(), (0, $8a461ef06e070cc9$export$fcfbbcec2cb820d5)(h), l.dispose(), c.dispose(), d.dispose(), m.dispose(), g.dispose(), [
                            2,
                            n ? [
                                y,
                                k
                            ] : b
                        ];
                }
            });
        });
    }, t.prototype.getCanvasInfo = function(t, e, n) {
        var i = t.height, r = t.width, o = i / (e.height * (1 - n.top - n.bottom)), a = r / (e.width * (1 - n.left - n.right)), s = -n.top * e.height;
        return [
            -n.left * e.width,
            s,
            a,
            o,
            t.width,
            t.height
        ];
    }, t.prototype.dispose = function() {
        this.posenetModel.dispose();
    }, t.prototype.reset = function() {}, t;
}();
function $a54e498d8d862fdc$var$dn(t) {
    return void 0 === t && (t = $a54e498d8d862fdc$var$Te), $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var e, n, i, r, o;
        return $a54e498d8d862fdc$var$D(this, function(a) {
            switch(a.label){
                case 0:
                    return "ResNet50" !== (e = function(t) {
                        var e = t || $a54e498d8d862fdc$var$Te;
                        if (null == e.architecture && (e.architecture = "MobileNetV1"), $a54e498d8d862fdc$var$Pe.indexOf(e.architecture) < 0) throw new Error("Invalid architecture ".concat(e.architecture, ". ") + "Should be one of ".concat($a54e498d8d862fdc$var$Pe));
                        if (null == e.inputResolution && (e.inputResolution = {
                            height: 257,
                            width: 257
                        }), null == e.outputStride && (e.outputStride = 16), $a54e498d8d862fdc$var$Fe[e.architecture].indexOf(e.outputStride) < 0) throw new Error("Invalid outputStride ".concat(e.outputStride, ". ") + "Should be one of ".concat($a54e498d8d862fdc$var$Fe[e.architecture], " ") + "for architecture ".concat(e.architecture, "."));
                        if (null == e.multiplier && (e.multiplier = 1), $a54e498d8d862fdc$var$Oe[e.architecture].indexOf(e.multiplier) < 0) throw new Error("Invalid multiplier ".concat(e.multiplier, ". ") + "Should be one of ".concat($a54e498d8d862fdc$var$Oe[e.architecture], " ") + "for architecture ".concat(e.architecture, "."));
                        if (null == e.quantBytes && (e.quantBytes = 4), $a54e498d8d862fdc$var$Ie.indexOf(e.quantBytes) < 0) throw new Error("Invalid quantBytes ".concat(e.quantBytes, ". ") + "Should be one of ".concat($a54e498d8d862fdc$var$Ie, " ") + "for architecture ".concat(e.architecture, "."));
                        if ("MobileNetV1" === e.architecture && 32 === e.outputStride && 1 !== e.multiplier) throw new Error("When using an output stride of 32, you must select 1 as the multiplier.");
                        return e;
                    }(t)).architecture ? [
                        3,
                        2
                    ] : (s = e.outputStride, u = e.quantBytes, h = "model-stride".concat(s, ".json"), n = 4 === u ? $a54e498d8d862fdc$var$cn + "float/" + h : $a54e498d8d862fdc$var$cn + "quant".concat(u, "/") + h, [
                        4,
                        (0, $880ccac6c81e2c8b$export$f077572b5d896ffd)(e.modelUrl || n)
                    ]);
                case 1:
                    return i = a.sent(), [
                        2,
                        new $a54e498d8d862fdc$var$fn(i, e)
                    ];
                case 2:
                    return r = function(t, e, n) {
                        var i = {
                            1: "100",
                            .75: "075",
                            .5: "050"
                        }, r = "model-stride".concat(t, ".json");
                        return 4 === n ? $a54e498d8d862fdc$var$ln + "float/".concat(i[e], "/") + r : $a54e498d8d862fdc$var$ln + "quant".concat(n, "/").concat(i[e], "/") + r;
                    }(e.outputStride, e.multiplier, e.quantBytes), [
                        4,
                        (0, $880ccac6c81e2c8b$export$f077572b5d896ffd)(e.modelUrl || r)
                    ];
                case 3:
                    return o = a.sent(), [
                        2,
                        new $a54e498d8d862fdc$var$fn(o, e)
                    ];
            }
            var s, u, h;
        });
    });
}
function $a54e498d8d862fdc$export$5221435586e5381b(t, e) {
    return $a54e498d8d862fdc$var$N(this, void 0, void 0, function() {
        var n, i;
        return $a54e498d8d862fdc$var$D(this, function(r) {
            switch(t){
                case $a54e498d8d862fdc$export$2f09812b4c450c2b.PoseNet:
                    return [
                        2,
                        $a54e498d8d862fdc$var$dn(e)
                    ];
                case $a54e498d8d862fdc$export$2f09812b4c450c2b.BlazePose:
                    if (i = void 0, null != (n = e)) {
                        if ("tfjs" === n.runtime) return [
                            2,
                            $a54e498d8d862fdc$var$oe(e)
                        ];
                        if ("mediapipe" === n.runtime) return [
                            2,
                            $a54e498d8d862fdc$var$it(e)
                        ];
                        i = n.runtime;
                    }
                    throw new Error("Expect modelConfig.runtime to be either 'tfjs' " + "or 'mediapipe', but got ".concat(i));
                case $a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet:
                    return [
                        2,
                        $a54e498d8d862fdc$var$Se(e)
                    ];
                default:
                    throw new Error("".concat(t, " is not a supported model name."));
            }
        });
    });
}
var $a54e498d8d862fdc$export$b5d09566951d5e0f = {
    keypointsToNormalizedKeypoints: $a54e498d8d862fdc$var$At
}, $a54e498d8d862fdc$export$86beb49ae50c5d8b = {
    modelType: {
        SINGLEPOSE_LIGHTNING: "SinglePose.Lightning",
        SINGLEPOSE_THUNDER: "SinglePose.Thunder",
        MULTIPOSE_LIGHTNING: "MultiPose.Lightning"
    }
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // base.ts is the webgl backend without auto kernel registration.

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import webgl flags.
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $2cb790622144e5be$var$contexts = {};
const $2cb790622144e5be$var$WEBGL_ATTRIBUTES = {
    alpha: false,
    antialias: false,
    premultipliedAlpha: false,
    preserveDrawingBuffer: false,
    depth: false,
    stencil: false,
    failIfMajorPerformanceCaveat: true
};
function $2cb790622144e5be$export$c5302deff3a07920(webGLVersion) {
    delete $2cb790622144e5be$var$contexts[webGLVersion];
}
function $2cb790622144e5be$export$4b8d5e1525955c68(webGLVersion, gl) {
    $2cb790622144e5be$var$contexts[webGLVersion] = gl;
}
function $2cb790622144e5be$export$c7a808a518b9a146(webGLVersion, customCanvas) {
    if (!(webGLVersion in $2cb790622144e5be$var$contexts) || customCanvas != null) {
        const newCtx = $2cb790622144e5be$var$getWebGLRenderingContext(webGLVersion, customCanvas);
        if (newCtx !== null) $2cb790622144e5be$var$contexts[webGLVersion] = newCtx;
        else {
            console.log('Could not get context for WebGL version', webGLVersion);
            return null;
        }
    }
    const gl = $2cb790622144e5be$var$contexts[webGLVersion];
    if (gl == null || gl.isContextLost()) {
        delete $2cb790622144e5be$var$contexts[webGLVersion];
        return $2cb790622144e5be$export$c7a808a518b9a146(webGLVersion);
    }
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.BLEND);
    gl.disable(gl.DITHER);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SAMPLE_COVERAGE);
    gl.enable(gl.SCISSOR_TEST);
    gl.enable(gl.CULL_FACE);
    gl.cullFace(gl.BACK);
    return $2cb790622144e5be$var$contexts[webGLVersion];
}
function $2cb790622144e5be$var$createCanvas(webGLVersion) {
    // Use canvas element for Safari, since its offscreen canvas does not support
    // fencing.
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_SAFARI') && typeof OffscreenCanvas !== 'undefined' && webGLVersion === 2) return new OffscreenCanvas(300, 150);
    else if (typeof document !== 'undefined') return document.createElement('canvas');
    else throw new Error('Cannot create a canvas in this context');
}
function $2cb790622144e5be$var$getWebGLRenderingContext(webGLVersion, customCanvas) {
    if (webGLVersion !== 1 && webGLVersion !== 2) throw new Error('Cannot get WebGL rendering context, WebGL is disabled.');
    const canvas = customCanvas == null ? $2cb790622144e5be$var$createCanvas(webGLVersion) : customCanvas;
    canvas.addEventListener('webglcontextlost', (ev)=>{
        ev.preventDefault();
        delete $2cb790622144e5be$var$contexts[webGLVersion];
    }, false);
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('SOFTWARE_WEBGL_ENABLED')) $2cb790622144e5be$var$WEBGL_ATTRIBUTES.failIfMajorPerformanceCaveat = false;
    if (webGLVersion === 1) return(// tslint:disable-next-line
    canvas.getContext('webgl', $2cb790622144e5be$var$WEBGL_ATTRIBUTES) || canvas.getContext('experimental-webgl', $2cb790622144e5be$var$WEBGL_ATTRIBUTES));
    return canvas.getContext('webgl2', $2cb790622144e5be$var$WEBGL_ATTRIBUTES);
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $44ae700445690738$export$81d5c79efa1086f2;
(function(PackingScheme) {
    /**
     * All values in a single texel are densely packed without any constraints.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 4]
     * (indices are [batch, row, col]).
     *
     * 000|001   010|011   020|021
     * -------   -------   -------
     * 002|003   012|013   022|023
     *
     * 100|101   110|111   120|121
     * -------   -------   -------
     * 102|103   112|113   122|123
     *
     */ PackingScheme[PackingScheme["DENSE"] = 0] = "DENSE";
    /**
     * Single texels contain only values from the same batch, and from adjacent
     * rows and columns.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 5]
     * (indices are [batch, row, col]).
     *
     * 000|001   002|003   004|xxx   020|021   022|023   024|xxx
     * -------   -------   -------   -------   -------   -------
     * 010|011   012|013   014|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     * 100|101   102|103   104|xxx   120|121   122|123   124|xxx
     * -------   -------   -------   -------   -------   -------
     * 110|111   112|113   114|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     */ PackingScheme[PackingScheme["SHARED_BATCH"] = 1] = "SHARED_BATCH";
})($44ae700445690738$export$81d5c79efa1086f2 || ($44ae700445690738$export$81d5c79efa1086f2 = {}));
var $44ae700445690738$export$6bf4bd1b6beb0bfd;
(function(TextureUsage) {
    TextureUsage[TextureUsage["RENDER"] = 0] = "RENDER";
    TextureUsage[TextureUsage["UPLOAD"] = 1] = "UPLOAD";
    TextureUsage[TextureUsage["PIXELS"] = 2] = "PIXELS";
    TextureUsage[TextureUsage["DOWNLOAD"] = 3] = "DOWNLOAD";
})($44ae700445690738$export$6bf4bd1b6beb0bfd || ($44ae700445690738$export$6bf4bd1b6beb0bfd = {}));
var $44ae700445690738$export$bde70ab3692e385c;
(function(PhysicalTextureType) {
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT16"] = 0] = "UNPACKED_FLOAT16";
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT32"] = 1] = "UNPACKED_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_4X1_UNSIGNED_BYTE"] = 2] = "PACKED_4X1_UNSIGNED_BYTE";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT32"] = 3] = "PACKED_2X2_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT16"] = 4] = "PACKED_2X2_FLOAT16";
})($44ae700445690738$export$bde70ab3692e385c || ($44ae700445690738$export$bde70ab3692e385c = {}));
function $44ae700445690738$export$95fb8493b25f77a4(rows, columns) {
    return [
        columns,
        rows
    ];
}
function $44ae700445690738$export$9427543edb6e188a(matrixSize, channelsPerTexture) {
    return matrixSize * channelsPerTexture;
}
function $44ae700445690738$export$bb1043669f490840(rows, columns) {
    return [
        columns * 4,
        rows
    ];
}
function $44ae700445690738$export$2cc7cc972aa2533d(shape) {
    const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(shape);
    const texelsNeeded = Math.ceil(size / 4);
    return (0, $0775da5e684c8c0d$exports).sizeToSquarishShape(texelsNeeded);
}
function $44ae700445690738$export$4c2d3be5c837367c(unpackedSize, channelsPerTexture) {
    if (unpackedSize % channelsPerTexture !== 0) throw new Error(`unpackedSize (${unpackedSize}) must be a multiple of ` + `${channelsPerTexture}`);
    return unpackedSize / channelsPerTexture;
}
function $44ae700445690738$export$ccf59730cad262bd(unpackedArray, matrix, channels) {
    const requiredSize = unpackedArray.length * channels / 4;
    if (matrix.length < requiredSize) throw new Error(`matrix length (${matrix.length}) must be >= ${requiredSize}`);
    let dst = 0;
    for(let src = 0; src < unpackedArray.length; src += 4)for(let c = 0; c < channels; c++)matrix[dst++] = unpackedArray[src + c];
}
function $44ae700445690738$export$2754e02fa98f5582(rows, columns) {
    return [
        Math.max(1, Math.ceil(columns / 2)),
        Math.max(1, Math.ceil(rows / 2))
    ];
}
function $44ae700445690738$export$12d4e412f879b1d4(rows, columns) {
    const [w, h] = $44ae700445690738$export$2754e02fa98f5582(rows, columns);
    return w * h * 4;
}
function $44ae700445690738$export$129d92ae6e74c416(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    let internalFormatFloat;
    let internalFormatHalfFloat;
    let internalFormatPackedHalfFloat;
    let internalFormatPackedFloat;
    let textureFormatFloat;
    let downloadTextureFormat;
    let downloadUnpackNumChannels;
    let defaultNumChannels;
    let textureTypeHalfFloat;
    let textureTypeFloat;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) {
        internalFormatFloat = glany.R32F;
        internalFormatHalfFloat = glany.R16F;
        internalFormatPackedHalfFloat = glany.RGBA16F;
        internalFormatPackedFloat = glany.RGBA32F;
        textureFormatFloat = glany.RED;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 1;
        textureTypeHalfFloat = glany.HALF_FLOAT;
        textureTypeFloat = glany.FLOAT;
        downloadTextureFormat = glany.RGBA8;
    } else {
        internalFormatFloat = gl.RGBA;
        internalFormatHalfFloat = gl.RGBA;
        internalFormatPackedHalfFloat = gl.RGBA;
        internalFormatPackedFloat = glany.RGBA;
        textureFormatFloat = gl.RGBA;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 4;
        textureTypeHalfFloat = textureHalfFloatExtension != null ? textureHalfFloatExtension.HALF_FLOAT_OES : null;
        textureTypeFloat = gl.FLOAT;
        downloadTextureFormat = gl.RGBA;
    }
    return {
        internalFormatFloat: internalFormatFloat,
        internalFormatHalfFloat: internalFormatHalfFloat,
        internalFormatPackedHalfFloat: internalFormatPackedHalfFloat,
        internalFormatPackedFloat: internalFormatPackedFloat,
        textureFormatFloat: textureFormatFloat,
        downloadTextureFormat: downloadTextureFormat,
        downloadUnpackNumChannels: downloadUnpackNumChannels,
        defaultNumChannels: defaultNumChannels,
        textureTypeHalfFloat: textureTypeHalfFloat,
        textureTypeFloat: textureTypeFloat
    };
}


function $f6f0bdab98aa0468$export$7642ac97981532b8(gl, func) {
    const returnValue = func();
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) $f6f0bdab98aa0468$var$checkWebGLError(gl);
    return returnValue;
}
function $f6f0bdab98aa0468$var$checkWebGLError(gl) {
    const error = gl.getError();
    if (error !== gl.NO_ERROR) throw new Error('WebGL Error: ' + $f6f0bdab98aa0468$export$ee3c7ff80964e13e(gl, error));
}
// https://en.wikipedia.org/wiki/Half-precision_floating-point_format
const $f6f0bdab98aa0468$var$MIN_FLOAT16 = 5.96e-8;
const $f6f0bdab98aa0468$var$MAX_FLOAT16 = 65504;
function $f6f0bdab98aa0468$export$829768a5b7625879(num) {
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_RENDER_FLOAT32_ENABLED') || num === 0 || $f6f0bdab98aa0468$var$MIN_FLOAT16 < Math.abs(num) && Math.abs(num) < $f6f0bdab98aa0468$var$MAX_FLOAT16) return true;
    return false;
}
function $f6f0bdab98aa0468$export$ee3c7ff80964e13e(gl, status) {
    switch(status){
        case gl.NO_ERROR:
            return 'NO_ERROR';
        case gl.INVALID_ENUM:
            return 'INVALID_ENUM';
        case gl.INVALID_VALUE:
            return 'INVALID_VALUE';
        case gl.INVALID_OPERATION:
            return 'INVALID_OPERATION';
        case gl.INVALID_FRAMEBUFFER_OPERATION:
            return 'INVALID_FRAMEBUFFER_OPERATION';
        case gl.OUT_OF_MEMORY:
            return 'OUT_OF_MEMORY';
        case gl.CONTEXT_LOST_WEBGL:
            return 'CONTEXT_LOST_WEBGL';
        default:
            return `Unknown error code ${status}`;
    }
}
function $f6f0bdab98aa0468$export$3a5e7a891790a26c(gl, extensionName) {
    return $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.getExtension(extensionName), 'Extension "' + extensionName + '" not supported on this browser.');
}
function $f6f0bdab98aa0468$export$4ca6704ce1875929(gl, vertexShaderSource) {
    const vertexShader = $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createShader(gl.VERTEX_SHADER), 'Unable to create vertex WebGLShader.');
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.shaderSource(vertexShader, vertexShaderSource));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.compileShader(vertexShader));
    if (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) === false) {
        console.log(gl.getShaderInfoLog(vertexShader));
        throw new Error('Failed to compile vertex shader.');
    }
    return vertexShader;
}
function $f6f0bdab98aa0468$export$a8ab0e04b20572c0(gl, fragmentShaderSource) {
    const fragmentShader = $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createShader(gl.FRAGMENT_SHADER), 'Unable to create fragment WebGLShader.');
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.shaderSource(fragmentShader, fragmentShaderSource));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.compileShader(fragmentShader));
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('ENGINE_COMPILE_ONLY')) return fragmentShader;
    if (gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) === false) {
        $f6f0bdab98aa0468$export$f7b23987b58d218(fragmentShaderSource, gl.getShaderInfoLog(fragmentShader));
        throw new Error('Failed to compile fragment shader.');
    }
    return fragmentShader;
}
const $f6f0bdab98aa0468$var$lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;
function $f6f0bdab98aa0468$export$f7b23987b58d218(shaderSource, shaderInfoLog) {
    const lineNumberRegexResult = $f6f0bdab98aa0468$var$lineNumberRegex.exec(shaderInfoLog);
    if (lineNumberRegexResult == null) {
        console.log(`Couldn't parse line number in error: ${shaderInfoLog}`);
        console.log(shaderSource);
        return;
    }
    const lineNumber = +lineNumberRegexResult[1];
    const shaderLines = shaderSource.split('\n');
    const pad = shaderLines.length.toString().length + 2;
    const linesWithLineNumbers = shaderLines.map((line, lineNumber)=>(0, $0775da5e684c8c0d$exports).rightPad((lineNumber + 1).toString(), pad) + line);
    let maxLineLength = 0;
    for(let i = 0; i < linesWithLineNumbers.length; i++)maxLineLength = Math.max(linesWithLineNumbers[i].length, maxLineLength);
    const beforeErrorLines = linesWithLineNumbers.slice(0, lineNumber - 1);
    const errorLine = linesWithLineNumbers.slice(lineNumber - 1, lineNumber);
    const afterErrorLines = linesWithLineNumbers.slice(lineNumber);
    console.log(beforeErrorLines.join('\n'));
    console.log(shaderInfoLog.split('\n')[0]);
    console.log(`%c ${(0, $0775da5e684c8c0d$exports).rightPad(errorLine[0], maxLineLength)}`, 'border:1px solid red; background-color:#e3d2d2; color:#a61717');
    console.log(afterErrorLines.join('\n'));
}
function $f6f0bdab98aa0468$export$327d24a04cd0dc17(gl) {
    return $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createProgram(), 'Unable to create WebGLProgram.');
}
function $f6f0bdab98aa0468$export$d879afae78b531a5(gl, program) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.linkProgram(program));
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('ENGINE_COMPILE_ONLY')) return;
    if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Failed to link vertex and fragment shaders.');
    }
}
function $f6f0bdab98aa0468$export$e2dfaf93681cde16(gl, program) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.validateProgram(program));
    if (gl.getProgramParameter(program, gl.VALIDATE_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Shader program validation failed.');
    }
}
function $f6f0bdab98aa0468$export$3871e1d1e28ac6cb(gl, data) {
    const buffer = $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $f6f0bdab98aa0468$export$f9b26b97ca2b25e9(gl, data) {
    const buffer = $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $f6f0bdab98aa0468$export$45c2ce5fe87dcf0f() {
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) return 1;
    return 4;
}
function $f6f0bdab98aa0468$export$37b981a8c575f415(gl) {
    return $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createTexture(), 'Unable to create WebGLTexture.');
}
function $f6f0bdab98aa0468$export$3543950a45505554(width, height) {
    const maxTextureSize = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    if (width <= 0 || height <= 0) {
        const requested = `[${width}x${height}]`;
        throw new Error('Requested texture size ' + requested + ' is invalid.');
    }
    if (width > maxTextureSize || height > maxTextureSize) {
        const requested = `[${width}x${height}]`;
        const max = `[${maxTextureSize}x${maxTextureSize}]`;
        throw new Error('Requested texture size ' + requested + ' greater than WebGL maximum on this browser / GPU ' + max + '.');
    }
}
function $f6f0bdab98aa0468$export$366d1e3e32f5a700(gl) {
    return $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.createFramebuffer(), 'Unable to create WebGLFramebuffer.');
}
function $f6f0bdab98aa0468$export$4c858b3c953a013f(gl, program, attribute, buffer, arrayEntriesPerItem, itemStrideInBytes, itemOffsetInBytes) {
    const loc = gl.getAttribLocation(program, attribute);
    if (loc === -1) // The GPU compiler decided to strip out this attribute because it's unused,
    // thus no need to bind.
    return false;
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.vertexAttribPointer(loc, arrayEntriesPerItem, gl.FLOAT, false, itemStrideInBytes, itemOffsetInBytes));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.enableVertexAttribArray(loc));
    return true;
}
function $f6f0bdab98aa0468$export$520907fe7b2c7a2d(gl, texture, textureUnit) {
    $f6f0bdab98aa0468$var$validateTextureUnit(gl, textureUnit);
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
}
function $f6f0bdab98aa0468$export$9bed01c46f4769b6(gl, textureUnit) {
    $f6f0bdab98aa0468$var$validateTextureUnit(gl, textureUnit);
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $f6f0bdab98aa0468$export$748cafa2cdf50d8(gl, program, uniformName) {
    return $f6f0bdab98aa0468$var$throwIfNull(gl, ()=>gl.getUniformLocation(program, uniformName), 'uniform "' + uniformName + '" not present in program.');
}
function $f6f0bdab98aa0468$export$d27256445dd7e8dd(gl, program, uniformName) {
    return gl.getUniformLocation(program, uniformName);
}
function $f6f0bdab98aa0468$export$f9ffd997f3c8b98f(gl, texture, uniformSamplerLocation, textureUnit) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>$f6f0bdab98aa0468$export$520907fe7b2c7a2d(gl, texture, textureUnit));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.uniform1i(uniformSamplerLocation, textureUnit));
}
function $f6f0bdab98aa0468$export$2e43f6b5d575e241(gl) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.viewport(0, 0, gl.canvas.width, gl.canvas.height));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.scissor(0, 0, gl.canvas.width, gl.canvas.height));
}
function $f6f0bdab98aa0468$export$4e154f0d71f19013(gl, texture, framebuffer) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0));
}
function $f6f0bdab98aa0468$export$d3c809959a3c24fa(gl, framebuffer) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0));
}
function $f6f0bdab98aa0468$export$ca09b577525e6519(gl) {
    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) throw new Error('Error binding framebuffer: ' + $f6f0bdab98aa0468$export$851c7fde035f5bf6(gl, status));
}
function $f6f0bdab98aa0468$export$851c7fde035f5bf6(gl, status) {
    switch(status){
        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS';
        case gl.FRAMEBUFFER_UNSUPPORTED:
            return 'FRAMEBUFFER_UNSUPPORTED';
        default:
            return `unknown error ${status}`;
    }
}
function $f6f0bdab98aa0468$var$throwIfNull(gl, returnTOrNull, failureMessage) {
    const tOrNull = $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>returnTOrNull());
    if (tOrNull == null) throw new Error(failureMessage);
    return tOrNull;
}
function $f6f0bdab98aa0468$var$validateTextureUnit(gl, textureUnit) {
    const maxTextureUnit = gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1;
    const glTextureUnit = textureUnit + gl.TEXTURE0;
    if (glTextureUnit < gl.TEXTURE0 || glTextureUnit > maxTextureUnit) {
        const textureUnitRange = `[gl.TEXTURE0, gl.TEXTURE${maxTextureUnit}]`;
        throw new Error(`textureUnit must be in ${textureUnitRange}.`);
    }
}
function $f6f0bdab98aa0468$export$4dfd7bc0667970e0(shape, dimsToSkip = 2) {
    return (0, $0775da5e684c8c0d$exports).sizeFromShape(shape.slice(0, shape.length - dimsToSkip));
}
function $f6f0bdab98aa0468$export$e8f6c350b57b8270(shape) {
    if (shape.length === 0) throw Error('Cannot get rows and columns of an empty shape array.');
    return [
        shape.length > 1 ? shape[shape.length - 2] : 1,
        shape[shape.length - 1]
    ];
}
function $f6f0bdab98aa0468$export$f944c0101b593a79(shape) {
    let shapeAs3D = [
        1,
        1,
        1
    ];
    const isScalar = shape.length === 0 || shape.length === 1 && shape[0] === 1;
    if (!isScalar) shapeAs3D = [
        $f6f0bdab98aa0468$export$4dfd7bc0667970e0(shape),
        ...$f6f0bdab98aa0468$export$e8f6c350b57b8270(shape)
    ];
    return shapeAs3D;
}
function $f6f0bdab98aa0468$export$80bf57c6927be1d9(logShape, isPacked = false) {
    let maxTexSize = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    let maxSizeForNarrowTex = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE');
    if (maxSizeForNarrowTex === Infinity && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE')) maxSizeForNarrowTex = maxTexSize / 2;
    if (isPacked) {
        maxTexSize = maxTexSize * 2;
        maxSizeForNarrowTex = maxSizeForNarrowTex * 2;
        // This logic ensures we accurately count the number of packed texels needed
        // to accommodate the tensor. We can only pack values in the same texel if
        // they are from adjacent pairs of rows/cols within the same batch. So if a
        // tensor has 3 rows, we pretend it has 4 rows in order to account for the
        // fact that the texels containing the third row are half empty.
        logShape = logShape.map((d, i)=>i >= logShape.length - 2 ? (0, $0775da5e684c8c0d$exports).nearestLargerEven(logShape[i]) : logShape[i]);
        // Packed texture height is at least 2 (the channel height of a single
        // texel).
        if (logShape.length === 1) logShape = [
            2,
            logShape[0]
        ];
    }
    // If logical shape is 2, we don't squeeze, since we want to match physical.
    if (logShape.length !== 2) {
        const squeezeResult = (0, $0775da5e684c8c0d$exports).squeezeShape(logShape);
        logShape = squeezeResult.newShape;
    }
    let size = (0, $0775da5e684c8c0d$exports).sizeFromShape(logShape);
    let textureShape = null;
    if (logShape.length <= 1 && size <= maxTexSize) textureShape = [
        1,
        size
    ];
    else if (logShape.length === 2 && logShape[0] <= maxTexSize && logShape[1] <= maxTexSize) textureShape = logShape;
    else if (logShape.length === 3 && logShape[0] * logShape[1] <= maxTexSize && logShape[2] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1],
        logShape[2]
    ];
    else if (logShape.length === 3 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2]
    ];
    else if (logShape.length === 4 && logShape[0] * logShape[1] * logShape[2] <= maxTexSize && logShape[3] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1] * logShape[2],
        logShape[3]
    ];
    else if (logShape.length === 4 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] * logShape[3] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2] * logShape[3]
    ];
    // true if one edge length is 1 (1 or 2, if packed), while another edge
    // length exceeds maxSizeForNarrowTex.
    const isLongNarrowTex = textureShape != null && Math.max(...textureShape) > maxSizeForNarrowTex && Math.min(...textureShape) <= (isPacked ? 2 : 1) && Math.min(...textureShape) > 0;
    if (textureShape == null || isLongNarrowTex) {
        if (isPacked) {
            // For packed textures size equals the number of channels required to
            // accommodate the texture data. However in order to squarify such that
            // inner dimensions stay even, we rewrite size to equal the number of
            // texels. Then in the return statement we rehydrate the squarified
            // dimensions to channel units.
            const batchDim = $f6f0bdab98aa0468$export$4dfd7bc0667970e0(logShape);
            let rows = 2, cols = 2;
            if (logShape.length) [rows, cols] = $f6f0bdab98aa0468$export$e8f6c350b57b8270(logShape);
            size = batchDim * (rows / 2) * (cols / 2);
            textureShape = (0, $0775da5e684c8c0d$exports).sizeToSquarishShape(size).map((d)=>d * 2);
        } else textureShape = (0, $0775da5e684c8c0d$exports).sizeToSquarishShape(size);
    }
    return textureShape;
}
function $f6f0bdab98aa0468$var$isEven(n) {
    return n % 2 === 0;
}
function $f6f0bdab98aa0468$export$951b388203a0422d(shape1, shape2) {
    shape1 = shape1.slice(-2);
    shape2 = shape2.slice(-2);
    if ((0, $0775da5e684c8c0d$exports).arraysEqual(shape1, shape2)) return true;
    if (!shape1.length || !shape2.length) return true;
    if (shape1[0] === 0 || shape1[1] === 0 || shape2[0] === 0 || shape2[1] === 0) return true;
    if (shape1.length !== shape2.length) {
        const shape1Cols = shape1[shape1.length - 1];
        const shape2Cols = shape2[shape2.length - 1];
        if (shape1Cols === shape2Cols) return true;
        if ($f6f0bdab98aa0468$var$isEven(shape1Cols) && $f6f0bdab98aa0468$var$isEven(shape2Cols) && (shape1[0] === 1 || shape2[0] === 1)) return true;
    }
    return shape1[1] === shape2[1] && $f6f0bdab98aa0468$var$isEven(shape1[0]) && $f6f0bdab98aa0468$var$isEven(shape2[0]);
}
// We cache webgl params because the environment gets reset between
// unit tests and we don't want to constantly query the WebGLContext for
// MAX_TEXTURE_SIZE.
let $f6f0bdab98aa0468$var$MAX_TEXTURE_SIZE;
let $f6f0bdab98aa0468$var$MAX_TEXTURES_IN_SHADER;
function $f6f0bdab98aa0468$export$9dbf32263e41ec5(webGLVersion) {
    if ($f6f0bdab98aa0468$var$MAX_TEXTURE_SIZE == null) {
        const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
        $f6f0bdab98aa0468$var$MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    }
    return $f6f0bdab98aa0468$var$MAX_TEXTURE_SIZE;
}
function $f6f0bdab98aa0468$export$3bb3363a1d77ce11() {
    $f6f0bdab98aa0468$var$MAX_TEXTURE_SIZE = null;
}
function $f6f0bdab98aa0468$export$295b7d11bb89e671() {
    $f6f0bdab98aa0468$var$MAX_TEXTURES_IN_SHADER = null;
}
function $f6f0bdab98aa0468$export$ce91baf6aebded89(webGLVersion) {
    if ($f6f0bdab98aa0468$var$MAX_TEXTURES_IN_SHADER == null) {
        const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
        $f6f0bdab98aa0468$var$MAX_TEXTURES_IN_SHADER = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    }
    // We cap at 16 to avoid spurious runtime "memory exhausted" error.
    return Math.min(16, $f6f0bdab98aa0468$var$MAX_TEXTURES_IN_SHADER);
}
function $f6f0bdab98aa0468$export$8a49d28f4bb7b8a0(webGLVersion) {
    if (webGLVersion === 0) return 0;
    let queryTimerVersion;
    const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
    if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query_webgl2') && webGLVersion === 2) queryTimerVersion = 2;
    else if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query')) queryTimerVersion = 1;
    else queryTimerVersion = 0;
    return queryTimerVersion;
}
function $f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, extensionName) {
    const ext = gl.getExtension(extensionName);
    return ext != null;
}
function $f6f0bdab98aa0468$export$9232c111e2230c00(webGLVersion) {
    try {
        const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
        if (gl != null) return true;
    } catch (e) {
        console.log('Error when getting WebGL context: ', e);
        return false;
    }
    return false;
}
function $f6f0bdab98aa0468$export$d571cb60e9b5ec74(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
    } else {
        if (!$f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return false;
    }
    const isFrameBufferComplete = $f6f0bdab98aa0468$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $f6f0bdab98aa0468$export$9cd61c8662dbbc66(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
        if (!$f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'WEBGL_color_buffer_float')) return false;
    } else {
        if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return $f6f0bdab98aa0468$var$createFloatTextureAndBindToFramebuffer(gl);
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(gl, COLOR_BUFFER_HALF_FLOAT)) {
            const textureHalfFloatExtension = gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            return $f6f0bdab98aa0468$var$createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension);
        }
        return false;
    }
    const isFrameBufferComplete = $f6f0bdab98aa0468$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $f6f0bdab98aa0468$var$createFloatTextureAndBindToFramebuffer(gl) {
    const texConfig = (0, $44ae700445690738$export$129d92ae6e74c416)(gl);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $f6f0bdab98aa0468$var$createHalfFloatTextureAndBindToFramebuffer(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    const texConfig = (0, $44ae700445690738$export$129d92ae6e74c416)(gl, textureHalfFloatExtension);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatHalfFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeHalfFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $f6f0bdab98aa0468$export$77efcdc20b17e5f2(webGLVersion) {
    if (webGLVersion !== 2) return false;
    const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(webGLVersion);
    // tslint:disable-next-line:no-any
    const isEnabled = gl.fenceSync != null;
    return isEnabled;
}
function $f6f0bdab98aa0468$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $0775da5e684c8c0d$exports).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors ` + 'in the WebGL backend.');
    });
}


const $e53155c415c3059c$var$ENV = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)();
/**
 * This file contains WebGL-specific flag registrations.
 */ /**
 * True if WebGL is supported.
 */ $e53155c415c3059c$var$ENV.registerFlag('HAS_WEBGL', ()=>$e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION') > 0);
/** 0: No WebGL, 1: WebGL 1.0, 2: WebGL 2.0. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_VERSION', ()=>{
    if ((0, $f6f0bdab98aa0468$export$9232c111e2230c00)(2)) return 2;
    else if ((0, $f6f0bdab98aa0468$export$9232c111e2230c00)(1)) return 1;
    return 0;
});
/** Whether to check for numerical representation problems. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_CHECK_NUMERICAL_PROBLEMS', ()=>false);
$e53155c415c3059c$var$ENV.registerFlag('WEBGL_BUFFER_SUPPORTED', ()=>$e53155c415c3059c$var$ENV.get('WEBGL_VERSION') === 2);
/** Whether the WebGL backend will sometimes forward ops to the CPU. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_CPU_FORWARD', ()=>true);
/** Whether the WebGL backend will always use f16 textures for rendering. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_FORCE_F16_TEXTURES', ()=>false);
/** Whether to turn all packing related flags on. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK', ()=>$e53155c415c3059c$var$ENV.getBool('HAS_WEBGL'));
/** Whether we will pack the batchnormalization op. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_NORMALIZATION', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the clip op. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_CLIP', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the depthwise conv op. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_DEPTHWISECONV', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack binary ops. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_BINARY_OPERATIONS', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack unary ops. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_UNARY_OPERATIONS', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack array ops. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_ARRAY_OPERATIONS', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack image ops. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_IMAGE_OPERATIONS', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack reduce ops. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_REDUCE', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether packed WebGL kernels lazily unpack their outputs. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_LAZILY_UNPACK', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will use the im2col algorithm to speed up convolutions. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_CONV_IM2COL', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack conv2dTranspose op. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_PACK_CONV2DTRANSPOSE', ()=>$e53155c415c3059c$var$ENV.getBool('WEBGL_PACK'));
/** The maximum texture dimension. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_MAX_TEXTURE_SIZE', ()=>(0, $f6f0bdab98aa0468$export$9dbf32263e41ec5)($e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION')));
/** The maximum texture dimension. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_MAX_TEXTURES_IN_SHADER', ()=>(0, $f6f0bdab98aa0468$export$ce91baf6aebded89)($e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * The disjoint_query_timer extension version.
 * 0: disabled, 1: EXT_disjoint_timer_query, 2:
 * EXT_disjoint_timer_query_webgl2.
 * In Firefox with WebGL 2.0,
 * EXT_disjoint_timer_query_webgl2 is not available, so we must use the
 * WebGL 1.0 extension.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION', ()=>{
    const webGLVersion = $e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION');
    if (webGLVersion === 0) return 0;
    return (0, $f6f0bdab98aa0468$export$8a49d28f4bb7b8a0)(webGLVersion);
});
/**
 * Whether the timer object from the disjoint_query_timer extension gives
 * timing information that is reliable.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE', ()=>$e53155c415c3059c$var$ENV.getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0 && !(0, $0479127e9813c50e$exports).isMobile());
/**
 * Whether the device is physically capable of rendering to float32 textures.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_CAPABLE', ()=>(0, $f6f0bdab98aa0468$export$d571cb60e9b5ec74)($e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Whether rendering to float32 textures is enabled. If disabled, renders to
 * float16 textures.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_ENABLED', ()=>{
    return $e53155c415c3059c$var$ENV.getBool('WEBGL_FORCE_F16_TEXTURES') ? false : $e53155c415c3059c$var$ENV.getBool('WEBGL_RENDER_FLOAT32_CAPABLE');
});
/**
 * Whether downloading float textures is enabled (16 or 32 bit). If disabled,
 * uses IEEE 754 encoding of the float32 values to 4 uint8 when downloading.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_DOWNLOAD_FLOAT_ENABLED', ()=>(0, $f6f0bdab98aa0468$export$9cd61c8662dbbc66)($e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION')));
/** Whether the fence API is available. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_FENCE_API_ENABLED', ()=>(0, $f6f0bdab98aa0468$export$77efcdc20b17e5f2)($e53155c415c3059c$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Tensors with size <= than this will be uploaded as uniforms, not textures.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_SIZE_UPLOAD_UNIFORM', ()=>{
    // Use uniform uploads only when 32bit floats are supported. In
    // 16bit
    // environments there are problems with comparing a 16bit texture value
    // with a 32bit uniform value.
    const useUniforms = $e53155c415c3059c$var$ENV.getBool('WEBGL_RENDER_FLOAT32_ENABLED');
    return useUniforms ? 4 : 0;
});
/**
 * If the total number of bytes allocated on the GPU is greater than this
 * number, we will aggressively delete textures upon disposal with
 * gl.deleteMatrixTexture, rather than making them available for reuse.
 *
 * Default value -1 indicates that we will never aggressively delete textures.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_DELETE_TEXTURE_THRESHOLD', ()=>{
    return -1;
}, (threshold)=>{
    if (!(typeof threshold === 'number')) throw new Error('WEBGL_DELETE_TEXTURE_THRESHOLD must be a number but ' + `got ${threshold}.`);
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never ` + `delete) or at least 0, but got ${threshold}.`);
});
/**
 * Trigger a manual GL command flush if the threshold of time has passed since
 * previous Kernel execution. This can be useful for Andorid device where GL
 * command flush are delayed un til the end of javascript task. This value is
 * measured in millisecond. Typically you want to set this value to close to 1.
 *
 * Default value 1 for mobile chrome, and -1 for rest cases. -1 indicates that
 * we will not enforce manual flush and depend on system default flush schedule.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_FLUSH_THRESHOLD', ()=>{
    return (0, $0479127e9813c50e$exports).isMobile() ? 1 : -1;
}, (threshold)=>{
    if (!(typeof threshold === 'number')) throw new Error('WEBGL_FLUSH_THRESHOLD must be a number but got ' + `${threshold}.`);
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never ` + `manual flush) or at least 0, but got ${threshold}.`);
});
/**
 * Threshold for input tensor size that determines whether WebGL backend will
 * delegate computation to CPU.
 *
 * Default value is 128.
 */ $e53155c415c3059c$var$ENV.registerFlag('CPU_HANDOFF_SIZE_THRESHOLD', ()=>128);
/** Whether we will use shapes uniforms. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_USE_SHAPES_UNIFORMS', ()=>false);
/**
 * Threshold for last dimension of input tensor that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If input
 * is smaller than threshold then CPU will be used
 *
 * Default value is 100000.
 */ $e53155c415c3059c$var$ENV.registerFlag('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD', ()=>100000);
/**
 * Threshold for K that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If k
 * is larger than threshold then CPU will be used
 *
 * Default value is 128.
 */ $e53155c415c3059c$var$ENV.registerFlag('TOPK_K_CPU_HANDOFF_THRESHOLD', ()=>128);
/** Whether we will use the experimental conv op. */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_EXP_CONV', ()=>false);
/**
 * If the device performance is low or if no hardware GPU is available, whether
 * software WebGL will be used.
 */ $e53155c415c3059c$var$ENV.registerFlag('SOFTWARE_WEBGL_ENABLED', ()=>$e53155c415c3059c$var$ENV.getBool('IS_TEST'));
/**
 * For narrow texture (physical height or physical width is 1), if the length of
 * any texture edges exceed the threshold, the texture will be reshaped to be
 * more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE', ()=>Infinity);
/**
 * If the flag is set to true, the max size of the narrow texture will be auto
 * computed and it will be considerred as a threshold to reshape the narrow
 * texture to be more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE', ()=>false);
/**
 * Whether to use the customized isnan. It's only useful for webgl2 since webgl1
 * doesn't have the builtin isnan.
 */ $e53155c415c3059c$var$ENV.registerFlag('WEBGL2_ISNAN_CUSTOM', ()=>false);
/** Experimental flag, whether enter compile only phase. */ $e53155c415c3059c$var$ENV.registerFlag('ENGINE_COMPILE_ONLY', ()=>false);




/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $2a1c84527da6ba7d$export$3ebf4a18d6319f7a() {
    let version;
    let attribute;
    let varyingVs;
    let varyingFs;
    let texture2D;
    let output;
    let defineOutput;
    let defineSpecialNaN;
    let defineSpecialInf;
    let defineRound;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) {
        version = '#version 300 es';
        attribute = 'in';
        varyingVs = 'out';
        varyingFs = 'in';
        texture2D = 'texture';
        output = 'outputColor';
        defineOutput = 'out vec4 outputColor;';
        // Use custom isnan definition to work across differences between
        // implementations on various platforms. While this should happen in ANGLE
        // we still see differences between android and windows (on chrome) when
        // using isnan directly. Since WebGL2 supports uint type and
        // floatBitsToUinT built-in function, we could implment isnan following
        // IEEE 754 rules.
        // NaN defination in IEEE 754-1985 is :
        //   - sign = either 0 or 1.
        //   - biased exponent = all 1 bits.
        //   - fraction = anything except all 0 bits (since all 0 bits represents
        //   infinity).
        // https://en.wikipedia.org/wiki/IEEE_754-1985#Representation_of_non-numbers
        defineSpecialNaN = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL2_ISNAN_CUSTOM') ? `
      bool isnan_custom(float val) {
        uint floatToUint = floatBitsToUint(val);
        return (floatToUint & 0x7fffffffu) > 0x7f800000u;
      }

      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan_custom(val.x),
          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));
      }

      #define isnan(value) isnan_custom(value)
    ` : '';
        // In webgl 2 we do not need to specify a custom isinf so there is no
        // need for a special INFINITY constant.
        defineSpecialInf = ``;
        defineRound = `
      #define round(value) newRound(value)
      int newRound(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 newRound(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    } else {
        version = '';
        attribute = 'attribute';
        varyingVs = 'varying';
        varyingFs = 'varying';
        texture2D = 'texture2D';
        output = 'gl_FragColor';
        defineOutput = '';
        // WebGL1 has no built in isnan so we define one here.
        defineSpecialNaN = `
      #define isnan(value) isnan_custom(value)
      bool isnan_custom(float val) {
        return (val > 0. || val < 1. || val == 0.) ? false : true;
      }
      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));
      }
    `;
        defineSpecialInf = `
      uniform float INFINITY;

      bool isinf(float val) {
        return abs(val) == INFINITY;
      }
      bvec4 isinf(vec4 val) {
        return equal(abs(val), vec4(INFINITY));
      }
    `;
        defineRound = `
      int round(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 round(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    }
    return {
        version: version,
        attribute: attribute,
        varyingVs: varyingVs,
        varyingFs: varyingFs,
        texture2D: texture2D,
        output: output,
        defineOutput: defineOutput,
        defineSpecialNaN: defineSpecialNaN,
        defineSpecialInf: defineSpecialInf,
        defineRound: defineRound
    };
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Please make sure the shaker key in makeShaderKey in gpgpu_math.ts is well
// mapped if any shader source code is changed in this file.


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $5574d094388bec90$export$53c37f67510642ce(coords, shape, index = 'index') {
    const strides = (0, $0775da5e684c8c0d$exports).computeStrides(shape);
    return strides.map((stride, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${stride}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${stride}` : `index -= ${coords[i]} * ${stride}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $5574d094388bec90$export$ae684ebb20c3e80c(coords, shape, index = 'index') {
    const strides = (0, $0775da5e684c8c0d$exports).computeStrides(shape);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / outShapeStrides[${i}]`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * outShapeStrides[${i}]` : `index -= ${coords[i]} * outShapeStrides[${i}]`;
        return `${line1}; ${line2};`;
    }).join('');
}
// Produces GLSL code that computes strides.
function $5574d094388bec90$var$symbolicallyComputeStrides(indicesArr, variableName) {
    const numCoords = indicesArr.length;
    const shape = indicesArr.map((d)=>`${variableName}[${d}]`);
    const strides = new Array(numCoords - 1);
    strides[numCoords - 2] = shape[numCoords - 1];
    for(let i = numCoords - 3; i >= 0; --i)strides[i] = `(${strides[i + 1]} * ${shape[i + 1]})`;
    return strides;
}
function $5574d094388bec90$export$a1b266196cc2d8ea(coords, variableName, index = 'index') {
    const indicesArray = coords.map((_, i)=>i);
    const strides = $5574d094388bec90$var$symbolicallyComputeStrides(indicesArray, variableName);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${strides[i]}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${strides[i]}` : `index -= ${coords[i]} * ${strides[i]}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $5574d094388bec90$var$buildVec(x) {
    if (x.length === 1) return `${x[0]}`;
    return `vec${x.length}(${x.join(',')})`;
}
function $5574d094388bec90$export$fe4cd89a7b9cb48b(x, y) {
    if (x.length !== y.length) throw new Error(`Vectors to be dotted must be of the same length -` + `got ${x.length} and ${y.length}`);
    const slices = [];
    const nearestVec4 = Math.floor(x.length / 4);
    const nearestVec4Remainder = x.length % 4;
    for(let i = 0; i < nearestVec4; i++){
        const xSlice = x.slice(i * 4, i * 4 + 4);
        const ySlice = y.slice(i * 4, i * 4 + 4);
        slices.push(`${$5574d094388bec90$var$buildVec(xSlice)}, ${$5574d094388bec90$var$buildVec(ySlice)}`);
    }
    if (nearestVec4Remainder !== 0) {
        let xSlice = x.slice(nearestVec4 * 4);
        let ySlice = y.slice(nearestVec4 * 4);
        if (xSlice.length === 1) {
            xSlice = xSlice.map((d)=>`float(${d})`);
            ySlice = ySlice.map((d)=>`float(${d})`);
        }
        slices.push(`${$5574d094388bec90$var$buildVec(xSlice)}, ${$5574d094388bec90$var$buildVec(ySlice)}`);
    }
    return slices.map((d, i)=>`dot(${d})`).join('+');
}
function $5574d094388bec90$export$4c68558c71205a01(shape) {
    const strides = (0, $0775da5e684c8c0d$exports).computeStrides(shape).map((d)=>d.toString());
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * ${strides[0]} + coords.y * ${strides[1]} + coords.z;
  }
`;
}
function $5574d094388bec90$export$4ec1e3f6361de451() {
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;
  }
`;
}
const $5574d094388bec90$export$2ac12a308a563905 = `
  const float FLOAT_MAX = 1.70141184e38;
  const float FLOAT_MIN = 1.17549435e-38;

  lowp vec4 encode_float(highp float v) {
    if (isnan(v)) {
      return vec4(255, 255, 255, 255);
    }

    highp float av = abs(v);

    if(av < FLOAT_MIN) {
      return vec4(0.0, 0.0, 0.0, 0.0);
    } else if(v > FLOAT_MAX) {
      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;
    } else if(v < -FLOAT_MAX) {
      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;
    }

    highp vec4 c = vec4(0,0,0,0);

    highp float e = floor(log2(av));
    highp float m = exp2(fract(log2(av))) - 1.0;

    c[2] = floor(128.0 * m);
    m -= c[2] / 128.0;
    c[1] = floor(32768.0 * m);
    m -= c[1] / 32768.0;
    c[0] = floor(8388608.0 * m);

    highp float ebias = e + 127.0;
    c[3] = floor(ebias / 2.0);
    ebias -= c[3] * 2.0;
    c[2] += floor(ebias) * 128.0;

    c[3] += 128.0 * step(0.0, -v);

    return c / 255.0;
  }
`;


const { getBroadcastDims: $a18658cdba53b459$var$getBroadcastDims } = (0, $f35e0c1a651337db$exports);
function $a18658cdba53b459$export$37f33ba844563dd2(inputsInfo, outputShape, program) {
    const prefixSnippets = [];
    inputsInfo.forEach((x)=>{
        const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shapeInfo.logicalShape);
        // Snippet when we decided to upload the values as uniform.
        if (x.shapeInfo.isUniform) prefixSnippets.push(`uniform float ${x.name}${size > 1 ? `[${size}]` : ''};`);
        else {
            prefixSnippets.push(`uniform sampler2D ${x.name};`);
            prefixSnippets.push(`uniform int offset${x.name};`);
        }
        if (program.enableShapeUniforms) {
            const { uniformShape: uniformShape } = $a18658cdba53b459$export$19e35a0844e29cf9(program.packedInputs, x.shapeInfo.logicalShape, x.shapeInfo.texShape);
            switch(uniformShape.length){
                case 1:
                    prefixSnippets.push(`uniform int ${x.name}Shape;`);
                    break;
                case 2:
                    prefixSnippets.push(`uniform ivec2 ${x.name}Shape;`);
                    break;
                case 3:
                    prefixSnippets.push(`uniform ivec3 ${x.name}Shape;`);
                    break;
                case 4:
                    prefixSnippets.push(`uniform ivec4 ${x.name}Shape;`);
                    break;
                default:
                    break;
            }
            prefixSnippets.push(`uniform ivec2 ${x.name}TexShape;`);
        }
    });
    if (program.enableShapeUniforms) {
        switch(outputShape.logicalShape.length){
            case 1:
                prefixSnippets.push(`uniform int outShape;`);
                break;
            case 2:
                prefixSnippets.push(`uniform ivec2 outShape;`);
                prefixSnippets.push(`uniform int outShapeStrides;`);
                break;
            case 3:
                prefixSnippets.push(`uniform ivec3 outShape;`);
                prefixSnippets.push(`uniform ivec2 outShapeStrides;`);
                break;
            case 4:
                prefixSnippets.push(`uniform ivec4 outShape;`);
                prefixSnippets.push(`uniform ivec3 outShapeStrides;`);
                break;
            default:
                break;
        }
        prefixSnippets.push(`uniform ivec2 outTexShape;`);
    }
    if (program.customUniforms) program.customUniforms.forEach((d)=>{
        prefixSnippets.push(`uniform ${d.type} ${d.name}${d.arrayIndex ? `[${d.arrayIndex}]` : ''};`);
    });
    const inputPrefixSnippet = prefixSnippets.join('\n');
    const inputSamplingSnippet = inputsInfo.map((x)=>$a18658cdba53b459$var$getInputSamplingSnippet(x, outputShape, program.packedInputs, program.enableShapeUniforms)).join('\n');
    const outTexShape = outputShape.texShape;
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    const floatTextureSampleSnippet = $a18658cdba53b459$var$getFloatTextureSampleSnippet(glsl);
    let outputSamplingSnippet;
    let floatTextureSetOutputSnippet;
    let shaderPrefix = $a18658cdba53b459$var$getShaderPrefix(glsl);
    if (outputShape.isPacked) {
        outputSamplingSnippet = $a18658cdba53b459$var$getPackedOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $a18658cdba53b459$var$getFloatTextureSetRGBASnippet(glsl);
    } else {
        outputSamplingSnippet = $a18658cdba53b459$var$getOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $a18658cdba53b459$var$getFloatTextureSetRSnippet(glsl);
    }
    if (program.packedInputs) shaderPrefix += $a18658cdba53b459$var$SHADER_PACKED_PREFIX;
    const source = [
        shaderPrefix,
        floatTextureSampleSnippet,
        floatTextureSetOutputSnippet,
        inputPrefixSnippet,
        outputSamplingSnippet,
        inputSamplingSnippet,
        program.userCode
    ].join('\n');
    return source;
}
function $a18658cdba53b459$var$getSamplerFromInInfo(inInfo, enableShapeUniforms = false) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $a18658cdba53b459$var$getSamplerScalar(inInfo, enableShapeUniforms);
        case 1:
            return $a18658cdba53b459$var$getSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $a18658cdba53b459$var$getSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $a18658cdba53b459$var$getSampler3D(inInfo, enableShapeUniforms);
        case 4:
            return $a18658cdba53b459$var$getSampler4D(inInfo, enableShapeUniforms);
        case 5:
            return $a18658cdba53b459$var$getSampler5D(inInfo);
        case 6:
            return $a18658cdba53b459$var$getSampler6D(inInfo);
        default:
            throw new Error(`${shape.length}-D input sampling` + ` is not yet supported`);
    }
}
function $a18658cdba53b459$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $a18658cdba53b459$var$getPackedSamplerScalar(inInfo);
        case 1:
            return $a18658cdba53b459$var$getPackedSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $a18658cdba53b459$var$getPackedSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $a18658cdba53b459$var$getPackedSampler3D(inInfo, enableShapeUniforms);
        default:
            return $a18658cdba53b459$var$getPackedSamplerND(inInfo, enableShapeUniforms);
    }
}
function $a18658cdba53b459$var$getInputSamplingSnippet(inInfo, outShapeInfo, usesPackedTextures = false, enableShapeUniforms) {
    let res = '';
    if (usesPackedTextures) res += $a18658cdba53b459$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms);
    else res += $a18658cdba53b459$var$getSamplerFromInInfo(inInfo, enableShapeUniforms);
    const inShape = inInfo.shapeInfo.logicalShape;
    const outShape = outShapeInfo.logicalShape;
    if (inShape.length <= outShape.length) {
        if (usesPackedTextures) res += $a18658cdba53b459$var$getPackedSamplerAtOutputCoords(inInfo, outShapeInfo);
        else res += $a18658cdba53b459$var$getSamplerAtOutputCoords(inInfo, outShapeInfo);
    }
    return res;
}
function $a18658cdba53b459$var$getPackedOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $a18658cdba53b459$var$getOutputScalarCoords();
        case 1:
            return $a18658cdba53b459$var$getOutputPacked1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $a18658cdba53b459$var$getOutputPacked2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $a18658cdba53b459$var$getOutputPacked3DCoords(outShape, outTexShape, enableShapeUniforms);
        default:
            return $a18658cdba53b459$var$getOutputPackedNDCoords(outShape, outTexShape, enableShapeUniforms);
    }
}
function $a18658cdba53b459$var$getOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $a18658cdba53b459$var$getOutputScalarCoords();
        case 1:
            return $a18658cdba53b459$var$getOutput1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $a18658cdba53b459$var$getOutput2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $a18658cdba53b459$var$getOutput3DCoords(outShape, outTexShape, enableShapeUniforms);
        case 4:
            return $a18658cdba53b459$var$getOutput4DCoords(outShape, outTexShape, enableShapeUniforms);
        case 5:
            return $a18658cdba53b459$var$getOutput5DCoords(outShape, outTexShape);
        case 6:
            return $a18658cdba53b459$var$getOutput6DCoords(outShape, outTexShape);
        default:
            throw new Error(`${outShape.length}-D output sampling is not yet supported`);
    }
}
function $a18658cdba53b459$var$getFloatTextureSampleSnippet(glsl) {
    return `
    float sampleTexture(sampler2D textureSampler, vec2 uv) {
      return ${glsl.texture2D}(textureSampler, uv).r;
    }
  `;
}
function $a18658cdba53b459$var$getFloatTextureSetRSnippet(glsl) {
    return `
    void setOutput(float val) {
      ${glsl.output} = vec4(val, 0, 0, 0);
    }
  `;
}
function $a18658cdba53b459$var$getFloatTextureSetRGBASnippet(glsl) {
    return `
    void setOutput(vec4 val) {
      ${glsl.output} = val;
    }
  `;
}
function $a18658cdba53b459$var$getShaderPrefix(glsl) {
    const SHADER_PREFIX = `${glsl.version}
    precision highp float;
    precision highp int;
    precision highp sampler2D;
    ${glsl.varyingFs} vec2 resultUV;
    ${glsl.defineOutput}
    const vec2 halfCR = vec2(0.5, 0.5);

    struct ivec5
    {
      int x;
      int y;
      int z;
      int w;
      int u;
    };

    struct ivec6
    {
      int x;
      int y;
      int z;
      int w;
      int u;
      int v;
    };

    uniform float NAN;
    ${glsl.defineSpecialNaN}
    ${glsl.defineSpecialInf}
    ${glsl.defineRound}

    int imod(int x, int y) {
      return x - y * (x / y);
    }

    int idiv(int a, int b, float sign) {
      int res = a / b;
      int mod = imod(a, b);
      if (sign < 0. && mod != 0) {
        res -= 1;
      }
      return res;
    }

    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    #define HASHSCALE1 443.8975
    float random(float seed){
      vec2 p = resultUV * seed;
      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
      p3 += dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${$a18658cdba53b459$var$SAMPLE_1D_SNIPPET}
    ${$a18658cdba53b459$var$SAMPLE_2D_SNIPPET}
    ${$a18658cdba53b459$var$SAMPLE_3D_SNIPPET}
  `;
    return SHADER_PREFIX;
}
const $a18658cdba53b459$var$SAMPLE_1D_SNIPPET = `
vec2 uvFromFlat(int texNumR, int texNumC, int index) {
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
  int texelIndex = index / 2;
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $a18658cdba53b459$var$SAMPLE_2D_SNIPPET = `
vec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,
  int texNumC, int row, int col) {
  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $a18658cdba53b459$var$SAMPLE_3D_SNIPPET = `
vec2 packedUVfrom3D(int texNumR, int texNumC,
    int texelsInBatch, int texelsInLogicalRow, int b,
    int row, int col) {
  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $a18658cdba53b459$var$SHADER_PACKED_PREFIX = `
  float getChannel(vec4 frag, vec2 innerDims) {
    vec2 modCoord = mod(innerDims, 2.);
    return modCoord.x == 0. ?
      (modCoord.y == 0. ? frag.r : frag.g) :
      (modCoord.y == 0. ? frag.b : frag.a);
  }
  float getChannel(vec4 frag, int dim) {
    float modCoord = mod(float(dim), 2.);
    return modCoord == 0. ? frag.r : frag.g;
  }
`;
function $a18658cdba53b459$var$getOutputScalarCoords() {
    return `
    int getOutputCoords() {
      return 0;
    }
  `;
}
function $a18658cdba53b459$var$getOutputPacked1DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (packedTexShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ${packedTexShape[1]}.0);
      }
    `;
    }
    if (packedTexShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ${packedTexShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      return 2 * (resTexRC.x * ${packedTexShape[1]} + resTexRC.y);
    }
  `;
}
function $a18658cdba53b459$var$getOutput1DCoords(shape, texShape, enableShapeUniforms) {
    if (texShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.x * float(outTexShape[1]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.x * ${texShape[1]}.0);
      }
    `;
    }
    if (texShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.y * float(outTexShape[0]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.y * ${texShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      return resTexRC.x * outTexShape[1] + resTexRC.y;
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      return resTexRC.x * ${texShape[1]} + resTexRC.y;
    }
  `;
}
function $a18658cdba53b459$var$getOutputPacked3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) return `
    ivec3 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec3(b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[1] / 2);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec3(b, r, c);
    }
  `;
}
function $a18658cdba53b459$var$getOutput3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $5574d094388bec90$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd'
        ], shape);
        return `
  ivec3 getOutputCoords() {
    ivec2 resTexRC = ivec2(resultUV.yx *
                           vec2(outTexShape[0], outTexShape[1]));
    int index = resTexRC.x * outTexShape[1] + resTexRC.y;
    ${coordsFromIndexSnippet}
    return ivec3(r, c, d);
  }
`;
    }
    const coordsFromIndexSnippet = $5574d094388bec90$export$53c37f67510642ce([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}
function $a18658cdba53b459$var$getOutputPackedNDCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    ivec4 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatchN = texelsInBatch * outShape[1];

      int b2 = index / texelsInBatchN;
      index -= b2 * texelsInBatchN;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec4(b2, b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[shape.length - 1] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[shape.length - 2] / 2);
    let texelsInBatchN = texelsInBatch;
    let batches = ``;
    let coords = 'b, r, c';
    for(let b = 2; b < shape.length - 1; b++){
        texelsInBatchN *= shape[shape.length - b - 1];
        batches = `
      int b${b} = index / ${texelsInBatchN};
      index -= b${b} * ${texelsInBatchN};
    ` + batches;
        coords = `b${b}, ` + coords;
    }
    return `
    ivec${shape.length} getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      ${batches}

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec${shape.length}(${coords});
    }
  `;
}
function $a18658cdba53b459$var$getOutput4DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $5574d094388bec90$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd',
            'd2'
        ], shape);
        return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
    }
    const coordsFromIndexSnippet = $5574d094388bec90$export$53c37f67510642ce([
        'r',
        'c',
        'd',
        'd2'
    ], shape);
    return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
}
function $a18658cdba53b459$var$getOutput5DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $5574d094388bec90$export$53c37f67510642ce([
        'r',
        'c',
        'd',
        'd2',
        'd3'
    ], shape);
    return `
    ivec5 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${texShape[0]},
                             ${texShape[1]}));

      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec5 outShape = ivec5(r, c, d, d2, d3);
      return outShape;
    }
  `;
}
function $a18658cdba53b459$var$getOutput6DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $5574d094388bec90$export$53c37f67510642ce([
        'r',
        'c',
        'd',
        'd2',
        'd3',
        'd4'
    ], shape);
    return `
    ivec6 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec6 result = ivec6(r, c, d, d2, d3, d4);
      return result;
    }
  `;
}
function $a18658cdba53b459$var$getOutputPacked2DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if ((0, $0775da5e684c8c0d$exports).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return 2 * ivec2(resultUV.yx * vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      }
    `;
    }
    // texels needed to accommodate a logical row
    const texelsInLogicalRow = Math.ceil(shape[1] / 2);
    /**
     * getOutputCoords
     *
     * resTexRC: The rows and columns of the texels. If you move over one
     * texel to the right in the packed texture, you are moving over one column
     * (not two).
     *
     * index: The texel index
     */ if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));

      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;
      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));

      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;
      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec2(r, c);
    }
  `;
}
function $a18658cdba53b459$var$getOutput2DCoords(shape, texShape, enableShapeUniforms) {
    if ((0, $0775da5e684c8c0d$exports).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(${texShape[0]}, ${texShape[1]}));
      }
    `;
    }
    if (shape[1] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
    }
    if (shape[0] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(0, index);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(0, index);
      }
    `;
    }
    if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      int r = index / outShape[1];
      int c = index - r * outShape[1];
      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      int r = index / ${shape[1]};
      int c = index - r * ${shape[1]};
      return ivec2(r, c);
    }
  `;
}
function $a18658cdba53b459$var$getFlatOffsetUniformName(texName) {
    return `offset${texName}`;
}
function $a18658cdba53b459$var$getPackedSamplerScalar(inputInfo) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    return `
    vec4 ${funcName}() {
      return ${glsl.texture2D}(${texName}, halfCR);
    }
  `;
}
function $a18658cdba53b459$var$getSamplerScalar(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) return `float ${funcName}() {return ${texName};}`;
    const [texNumR, texNumC] = inputInfo.shapeInfo.texShape;
    if (texNumR === 1 && texNumC === 1) return `
      float ${funcName}() {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    const [tNumR, tNumC] = inputInfo.shapeInfo.texShape;
    return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getPackedSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int index) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      vec2 uv = packedUVfrom1D(
        packedTexShape[0], packedTexShape[1], index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    return `
    vec4 ${funcName}(int index) {
      vec2 uv = packedUVfrom1D(
        ${packedTexShape[0]}, ${packedTexShape[1]}, index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int index) {
        ${$a18658cdba53b459$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const tNumR = texShape[0];
    const tNumC = texShape[1];
    if (tNumC === 1 && tNumR === 1) return `
      float ${funcName}(int index) {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    if (tNumC === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / ${tNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (tNumR === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / ${tNumC}.0, 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getPackedSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    if (texShape != null && (0, $0775da5e684c8c0d$exports).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
        return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const valuesPerRow = Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int row, int col) {
      vec2 uv = packedUVfrom2D(${valuesPerRow}, ${packedTexShape[0]}, ${packedTexShape[1]}, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    if (texShape != null && (0, $0775da5e684c8c0d$exports).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        const texNumR = texShape[0];
        const texNumC = texShape[1];
        return `
    float ${funcName}(int row, int col) {
      vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const { newShape: newShape, keptDims: keptDims } = (0, $0775da5e684c8c0d$exports).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $a18658cdba53b459$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col'
        ];
        return `
      ${$a18658cdba53b459$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col) {
        return ${funcName}(${$a18658cdba53b459$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col) {
        int index = round(dot(vec2(row, col), vec2(${shape[1]}, 1)));
        ${$a18658cdba53b459$var$getUniformSampler(inputInfo)}
      }
    `;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    if (texNumC === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2(0.5, (index + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2(0.5, (index + 0.5) / ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (texNumR === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2((index + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2((index + 0.5) / ${texNumC}.0, 0.5);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${texName}Shape[1] + col + ${offset};
        vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
        return sampleTexture(${texName}, uv);
      }
    `;
    return `
  float ${funcName}(int row, int col) {
    // Explicitly use integer operations as dot() only works on floats.
    int index = row * ${shape[1]} + col + ${offset};
    vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
    return sampleTexture(${texName}, uv);
  }
`;
}
function $a18658cdba53b459$var$getPackedSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (shape[0] === 1) {
        const squeezedShape = shape.slice(1);
        const keptDims = [
            1,
            2
        ];
        const newInputInfo = $a18658cdba53b459$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'b',
            'row',
            'col'
        ];
        return `
        ${$a18658cdba53b459$var$getPackedSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        vec4 ${funcName}(int b, int row, int col) {
          return ${funcName}(${$a18658cdba53b459$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int b, int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[2]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom3D(
        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = valuesPerRow * Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int b, int row, int col) {
      vec2 uv = packedUVfrom3D(
        ${texNumR}, ${texNumC}, ${texelsInBatch}, ${valuesPerRow}, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride0 = shape[1] * shape[2];
    const stride1 = shape[2];
    const { newShape: newShape, keptDims: keptDims } = (0, $0775da5e684c8c0d$exports).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $a18658cdba53b459$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col',
            'depth'
        ];
        return `
        ${$a18658cdba53b459$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        float ${funcName}(int row, int col, int depth) {
          return ${funcName}(${$a18658cdba53b459$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth) {
        int index = round(dot(vec3(row, col, depth),
                          vec3(${stride0}, ${stride1}, 1)));
        ${$a18658cdba53b459$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        int stride1 = ${texName}Shape[2];
        float texR = float(row);
        float texC = dot(vec2(col, depth), vec2(stride1, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
        float ${funcName}(int row, int col, int depth) {
          float texR = float(row);
          float texC = dot(vec2(col, depth), vec2(${stride1}, 1));
          vec2 uv = (vec2(texC, texR) + halfCR) /
                     vec2(${texNumC}.0, ${texNumR}.0);
          return sampleTexture(${texName}, uv);
        }
      `;
    }
    if (texNumC === stride1 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        float texR = dot(vec2(row, col), vec2(${texName}Shape[1], 1));
        float texC = float(depth);
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col, int depth) {
      float texR = dot(vec2(row, col), vec2(${shape[1]}, 1));
      float texC = float(depth);
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth) {
      // Explicitly use integer operations as dot() only works on floats.
      int stride0 = ${texName}Shape[1] * ${texName}Shape[2];
      int stride1 = ${texName}Shape[2];
      int index = row * stride0 + col * stride1 + depth + ${offset};
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
      return sampleTexture(${texName}, uv);
    }
    `;
    return `
      float ${funcName}(int row, int col, int depth) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${stride0} + col * ${stride1} + depth + ${offset};
        vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
        return sampleTexture(${texName}, uv);
      }
  `;
}
function $a18658cdba53b459$var$getPackedSamplerND(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    vec4 ${funcName}(int b2, int b, int row, int col) {
      int valuesPerRow = int(ceil(float(${texName}Shape[3]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[2]) / 2.0));
      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);
      texelsInBatch *= ${texName}Shape[1];
      index = b2 * texelsInBatch + index;
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int texR = index / packedTexShape[1];
      int texC = index - texR * packedTexShape[1];
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const shape = inputInfo.shapeInfo.logicalShape;
    const rank = shape.length;
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[rank - 1] / 2);
    let texelsInBatch = valuesPerRow * Math.ceil(shape[rank - 2] / 2);
    let params = `int b, int row, int col`;
    let index = `b * ${texelsInBatch} + (row / 2) * ${valuesPerRow} + (col / 2)`;
    for(let b = 2; b < rank - 1; b++){
        params = `int b${b}, ` + params;
        texelsInBatch *= shape[rank - b - 1];
        index = `b${b} * ${texelsInBatch} + ` + index;
    }
    return `
    vec4 ${funcName}(${params}) {
      int index = ${index};
      int texR = index / ${texNumC};
      int texC = index - texR * ${texNumC};
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}, ${texNumR});
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getSampler4D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride2 = shape[3];
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $0775da5e684c8c0d$exports).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $a18658cdba53b459$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2'
        ];
        return `
      ${$a18658cdba53b459$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col, int depth, int depth2) {
        return ${funcName}(${$a18658cdba53b459$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        int index = round(dot(vec4(row, col, depth, depth2),
                          vec4(${stride0}, ${stride1}, ${stride2}, 1)));
        ${$a18658cdba53b459$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const stride2Str = `int stride2 = ${texName}Shape[3];`;
    const stride1Str = `int stride1 = ${texName}Shape[2] * stride2;`;
    const stride0Str = `int stride0 = ${texName}Shape[1] * stride1;`;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        ${stride2Str}
        ${stride1Str}
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(stride1, stride2, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(${stride1}, ${stride2}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (texNumC === stride2 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${texName}Shape[1] * ${texName}Shape[2], ${texName}Shape[2], 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${shape[1] * shape[2]}, ${shape[2]}, 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      ${stride2Str}
      ${stride1Str}
      ${stride0Str}
      int index = row * stride0 + col * stride1 +
          depth * stride2 + depth2;
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} +
          depth * ${stride2} + depth2;
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getSampler5D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride3 = shape[4];
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $0775da5e684c8c0d$exports).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $a18658cdba53b459$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3'
        ];
        return `
      ${$a18658cdba53b459$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        return ${funcName}(${$a18658cdba53b459$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float index = dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          depth3;
        ${$a18658cdba53b459$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
                         vec4(${stride1}, ${stride2}, ${stride3}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride3 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float texR = dot(
          vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3]},
               ${shape[2] * shape[3]}, ${shape[3]}, 1));
        int texC = depth3;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getSampler6D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const { newShape: newShape, keptDims: keptDims } = (0, $0775da5e684c8c0d$exports).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $a18658cdba53b459$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3',
            'depth4'
        ];
        return `
      ${$a18658cdba53b459$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        return ${funcName}(${$a18658cdba53b459$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    const stride4 = shape[5];
    const stride3 = shape[4] * stride4;
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
        int index = round(dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          dot(
            vec2(depth3, depth4),
            vec2(${stride4}, 1)));
        ${$a18658cdba53b459$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
          vec4(${stride1}, ${stride2}, ${stride3}, ${stride4})) +
               float(depth4);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride4 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        float texR = dot(vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3] * shape[4]},
               ${shape[2] * shape[3] * shape[4]},
               ${shape[3] * shape[4]},
               ${shape[4]})) + float(depth3);
        int texC = depth4;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $a18658cdba53b459$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 * ${stride4} + depth4 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $a18658cdba53b459$var$getUniformSampler(inputInfo) {
    const texName = inputInfo.name;
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    if (inSize < 2) return `return ${texName};`;
    return `
    for (int i = 0; i < ${inSize}; i++) {
      if (i == index) {
        return ${texName}[i];
      }
    }
  `;
}
function $a18658cdba53b459$var$getPackedSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    const broadcastDims = $a18658cdba53b459$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const type = $a18658cdba53b459$export$859efd105c10c755(outRank);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    let output = `return outputValue;`;
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    const isInputScalar = inSize === 1;
    const outSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(outShapeInfo.logicalShape);
    const isOutputScalar = outSize === 1;
    if (inRank === 1 && !isInputScalar && !isOutputScalar) output = `
      return vec4(outputValue.xy, outputValue.xy);
    `;
    else if (isInputScalar && !isOutputScalar) {
        if (outRank === 1) output = `
        return vec4(outputValue.x, outputValue.x, 0., 0.);
      `;
        else output = `
        return vec4(outputValue.x);
      `;
    } else if (broadcastDims.length) {
        const rows = inRank - 2;
        const cols = inRank - 1;
        if (broadcastDims.indexOf(rows) > -1 && broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.x);`;
        else if (broadcastDims.indexOf(rows) > -1) output = `return vec4(outputValue.x, outputValue.y, ` + `outputValue.x, outputValue.y);`;
        else if (broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.xx, outputValue.zz);`;
    }
    return `
    vec4 ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      vec4 outputValue = get${texFuncSnippet}(${unpackedCoordsSnippet});
      ${output}
    }
  `;
}
function $a18658cdba53b459$var$getSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const outTexShape = outShapeInfo.texShape;
    const inTexShape = inputInfo.shapeInfo.texShape;
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    if (!inputInfo.shapeInfo.isUniform && inRank === outRank && inputInfo.shapeInfo.flatOffset == null && (0, $0775da5e684c8c0d$exports).arraysEqual(inTexShape, outTexShape)) return `
      float ${funcName}() {
        return sampleTexture(${texName}, resultUV);
      }
    `;
    const type = $a18658cdba53b459$export$859efd105c10c755(outRank);
    const broadcastDims = $a18658cdba53b459$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    return `
    float ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      return get${texFuncSnippet}(${unpackedCoordsSnippet});
    }
  `;
}
function $a18658cdba53b459$export$859efd105c10c755(rank) {
    if (rank <= 1) return 'int';
    else if (rank === 2) return 'ivec2';
    else if (rank === 3) return 'ivec3';
    else if (rank === 4) return 'ivec4';
    else if (rank === 5) return 'ivec5';
    else if (rank === 6) return 'ivec6';
    else throw Error(`GPU for rank ${rank} is not yet supported`);
}
function $a18658cdba53b459$export$19e35a0844e29cf9(isPacked, shape, texShape) {
    const { newShape: newShape, keptDims: keptDims } = (0, $0775da5e684c8c0d$exports).squeezeShape(shape);
    const rank = shape.length;
    const useSqueezePackedShape = isPacked && rank === 3 && shape[0] === 1;
    const squeezeShape = useSqueezePackedShape ? shape.slice(1) : newShape;
    const useSqueezeShape = !isPacked && rank > 1 && !(0, $0775da5e684c8c0d$exports).arraysEqual(shape, texShape) && newShape.length < rank || useSqueezePackedShape;
    const uniformShape = useSqueezeShape ? squeezeShape : shape;
    return {
        useSqueezeShape: useSqueezeShape,
        uniformShape: uniformShape,
        keptDims: keptDims
    };
}
function $a18658cdba53b459$export$5d06d3f48295bf13(inInfo, squeezedShape) {
    // Deep copy.
    const newInputInfo = JSON.parse(JSON.stringify(inInfo));
    newInputInfo.shapeInfo.logicalShape = squeezedShape;
    return newInputInfo;
}
function $a18658cdba53b459$var$getSqueezedParams(params, keptDims) {
    return keptDims.map((d)=>params[d]).join(', ');
}



function $ea5724662c9cdeb8$export$5ca2cb6073dd12df(gpgpu, program, inputs, output) {
    const inputInfos = inputs.map((input, i)=>{
        const shapeInfo = {
            logicalShape: input.shape,
            texShape: input.isUniform ? null : input.texData.texShape,
            isUniform: input.isUniform,
            isPacked: input.isUniform ? false : input.texData.isPacked,
            flatOffset: null
        };
        if (input.texData != null && input.texData.slice != null && input.texData.slice.flatOffset > 0) shapeInfo.flatOffset = input.texData.slice.flatOffset;
        return {
            name: program.variableNames[i],
            shapeInfo: shapeInfo
        };
    });
    const inShapeInfos = inputInfos.map((x)=>x.shapeInfo);
    const outShapeInfo = {
        logicalShape: output.shape,
        texShape: output.texData.texShape,
        isUniform: false,
        isPacked: output.texData.isPacked,
        flatOffset: null
    };
    const source = $a18658cdba53b459$export$37f33ba844563dd2(inputInfos, outShapeInfo, program);
    const fragmentShader = (0, $f6f0bdab98aa0468$export$a8ab0e04b20572c0)(gpgpu.gl, source);
    const webGLProgram = gpgpu.createProgram(fragmentShader);
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('ENGINE_COMPILE_ONLY')) {
        gpgpu.buildVao(webGLProgram);
        return Object.assign({
            program: program,
            fragmentShader: fragmentShader,
            source: source,
            webGLProgram: webGLProgram,
            inShapeInfos: inShapeInfos,
            outShapeInfo: outShapeInfo
        }, $ea5724662c9cdeb8$export$d421ceceafba9cc0(gpgpu, program, webGLProgram));
    } else return {
        program: program,
        fragmentShader: fragmentShader,
        source: source,
        webGLProgram: webGLProgram,
        inShapeInfos: inShapeInfos,
        outShapeInfo: outShapeInfo,
        variablesLocations: null,
        customUniformLocations: null,
        infLoc: null,
        nanLoc: null,
        outShapeLocation: null,
        outShapeStridesLocation: null,
        outTexShapeLocation: null
    };
}
function $ea5724662c9cdeb8$export$d421ceceafba9cc0(gpgpu, program, webGLProgram) {
    const variablesLocations = [];
    const customUniformLocations = [];
    let outShapeLocation;
    let outTexShapeLocation;
    let outShapeStridesLocation;
    let infLoc = null;
    let nanLoc = null;
    // Add special uniforms (NAN, INFINITY)
    nanLoc = gpgpu.getUniformLocation(webGLProgram, 'NAN', false);
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 1) infLoc = gpgpu.getUniformLocation(webGLProgram, 'INFINITY', false);
    // Add user-defined uniforms
    const shouldThrow = false;
    for (const varName of program.variableNames){
        const varLocs = {
            name: varName,
            uniform: gpgpu.getUniformLocation(webGLProgram, varName, shouldThrow),
            offset: gpgpu.getUniformLocation(webGLProgram, `offset${varName}`, shouldThrow)
        };
        if (program.enableShapeUniforms) {
            varLocs.shape = gpgpu.getUniformLocation(webGLProgram, `${varName}Shape`, shouldThrow);
            varLocs.texShape = gpgpu.getUniformLocation(webGLProgram, `${varName}TexShape`, shouldThrow);
        }
        variablesLocations.push(varLocs);
    }
    if (program.enableShapeUniforms) {
        outShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outShape', shouldThrow);
        outShapeStridesLocation = gpgpu.getUniformLocation(webGLProgram, 'outShapeStrides', shouldThrow);
        outTexShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outTexShape', shouldThrow);
    }
    if (program.customUniforms) for (const d of program.customUniforms)customUniformLocations.push(gpgpu.getUniformLocation(webGLProgram, d.name, shouldThrow));
    return {
        variablesLocations: variablesLocations,
        customUniformLocations: customUniformLocations,
        infLoc: infLoc,
        nanLoc: nanLoc,
        outShapeLocation: outShapeLocation,
        outShapeStridesLocation: outShapeStridesLocation,
        outTexShapeLocation: outTexShapeLocation
    };
}
function $ea5724662c9cdeb8$var$validateBinaryAndProgram(shapeInfos, inputs) {
    if (shapeInfos.length !== inputs.length) throw Error(`Binary was compiled with ${shapeInfos.length} inputs, but ` + `was executed with ${inputs.length} inputs`);
    shapeInfos.forEach((s, i)=>{
        const shapeA = s.logicalShape;
        const input = inputs[i];
        const shapeB = input.shape;
        if (!(0, $0775da5e684c8c0d$exports).arraysEqual(shapeA, shapeB)) throw Error(`Binary was compiled with different shapes than ` + `the current args. Shapes ${shapeA} and ${shapeB} must match`);
        // The input is uploaded as uniform.
        if (s.isUniform && input.isUniform) return;
        const texShapeA = s.texShape;
        const texShapeB = input.isUniform ? null : input.texData.texShape;
        if (!(0, $0775da5e684c8c0d$exports).arraysEqual(texShapeA, texShapeB)) throw Error(`Binary was compiled with different texture shapes than the` + ` current args. Shape ${texShapeA} and ${texShapeB} must match`);
    });
}
function $ea5724662c9cdeb8$export$4e01d2c5eea12ae3(gpgpu, binary, inputs, output, customUniformValues) {
    if (!binary.program.enableShapeUniforms) {
        $ea5724662c9cdeb8$var$validateBinaryAndProgram(binary.inShapeInfos, inputs);
        $ea5724662c9cdeb8$var$validateBinaryAndProgram([
            binary.outShapeInfo
        ], [
            output
        ]);
    }
    const outTex = output.texData.texture;
    const outTexShape = output.texData.texShape;
    if (output.texData.isPacked) gpgpu.setOutputPackedMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    else gpgpu.setOutputMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    gpgpu.setProgram(binary.webGLProgram);
    gpgpu.bindVertexArray(binary.webGLProgram.vao);
    // Set special uniforms (NAN, INFINITY)
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 1) {
        if (binary.infLoc !== null) gpgpu.gl.uniform1f(binary.infLoc, Infinity);
    }
    if (binary.nanLoc !== null) gpgpu.gl.uniform1f(binary.nanLoc, NaN);
    // Set user-defined inputs
    for(let i = 0; i < inputs.length; ++i){
        const input = inputs[i];
        const { uniform: varLoc, offset: varOffsetLoc, shape: varShapeLoc, texShape: varTexShapeLoc } = binary.variablesLocations[i];
        if (varShapeLoc) {
            const { uniformShape: uniformShape } = $a18658cdba53b459$export$19e35a0844e29cf9(binary.program.packedInputs, input.shape, input.texData.texShape);
            switch(uniformShape.length){
                case 1:
                    gpgpu.gl.uniform1iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 2:
                    gpgpu.gl.uniform2iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 3:
                    gpgpu.gl.uniform3iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 4:
                    gpgpu.gl.uniform4iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                default:
                    break;
            }
        }
        if (varTexShapeLoc) gpgpu.gl.uniform2i(varTexShapeLoc, input.texData.texShape[0], input.texData.texShape[1]);
        if (varLoc == null) continue;
        if (input.isUniform) {
            // Upload the values of the tensor as uniform.
            if ((0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape) < 2) gpgpu.gl.uniform1f(varLoc, input.uniformValues[0]);
            else {
                let vals = input.uniformValues;
                if (!(vals instanceof Float32Array)) vals = new Float32Array(vals);
                gpgpu.gl.uniform1fv(varLoc, vals);
            }
            continue;
        }
        // If the input was sliced, upload the flat offset index.
        if (input.texData.slice != null && varOffsetLoc != null) gpgpu.gl.uniform1i(varOffsetLoc, input.texData.slice.flatOffset);
        gpgpu.setInputMatrixTexture(input.texData.texture.texture, varLoc, i);
    }
    const outShapeLoc = binary.outShapeLocation;
    if (outShapeLoc) switch(output.shape.length){
        case 1:
            gpgpu.gl.uniform1iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 2:
            gpgpu.gl.uniform2iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 3:
            gpgpu.gl.uniform3iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 4:
            gpgpu.gl.uniform4iv(outShapeLoc, new Int32Array(output.shape));
            break;
        default:
            break;
    }
    if (binary.outShapeStridesLocation) {
        const strides = (0, $0775da5e684c8c0d$exports).computeStrides(output.shape);
        switch(output.shape.length){
            case 2:
                gpgpu.gl.uniform1iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 3:
                gpgpu.gl.uniform2iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 4:
                gpgpu.gl.uniform3iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            default:
                break;
        }
    }
    if (binary.outTexShapeLocation) gpgpu.gl.uniform2i(binary.outTexShapeLocation, output.texData.texShape[0], output.texData.texShape[1]);
    if (binary.program.customUniforms && customUniformValues) for(let i = 0; i < binary.program.customUniforms.length; ++i){
        const d = binary.program.customUniforms[i];
        const customLoc = binary.customUniformLocations[i];
        const customValue = customUniformValues[i];
        if (d.type === 'float') gpgpu.gl.uniform1fv(customLoc, customValue);
        else if (d.type === 'vec2') gpgpu.gl.uniform2fv(customLoc, customValue);
        else if (d.type === 'vec3') gpgpu.gl.uniform3fv(customLoc, customValue);
        else if (d.type === 'vec4') gpgpu.gl.uniform4fv(customLoc, customValue);
        else if (d.type === 'int') gpgpu.gl.uniform1iv(customLoc, customValue);
        else if (d.type === 'ivec2') gpgpu.gl.uniform2iv(customLoc, customValue);
        else if (d.type === 'ivec3') gpgpu.gl.uniform3iv(customLoc, customValue);
        else if (d.type === 'ivec4') gpgpu.gl.uniform4iv(customLoc, customValue);
        else throw Error(`uniform type ${d.type} is not supported yet.`);
    }
    gpgpu.executeProgram();
}
function $ea5724662c9cdeb8$export$2a17a6d53fe6f5d9(program, inputs, output) {
    let keyInputs = '';
    inputs.concat(output).forEach((x)=>{
        const hasOffset = x.texData != null && x.texData.slice != null && x.texData.slice.flatOffset > 0;
        // TODO: Remove the condition of !x.isUniform.
        if (program.enableShapeUniforms && !x.isUniform) {
            const xTexShape = x.texData.texShape;
            const { useSqueezeShape: useSqueezeShape, uniformShape: uniformShape, keptDims: keptDims } = $a18658cdba53b459$export$19e35a0844e29cf9(program.packedInputs, x.shape, xTexShape);
            let rank1 = '', rank2 = '', rank34 = '';
            if (uniformShape.length === 1 && program.packedInputs) {
                const packedTexShape = [
                    Math.ceil(xTexShape[0] / 2),
                    Math.ceil(xTexShape[1] / 2)
                ];
                rank1 = `${packedTexShape[0] > 1}_${packedTexShape[1] > 1}`;
            } else if (uniformShape.length === 2 && !program.packedInputs) rank2 = `${uniformShape[0] > 1}_${uniformShape[1] > 1}`;
            else if (uniformShape.length > 2 && !program.packedInputs) {
                const strides = (0, $0775da5e684c8c0d$exports).computeStrides(uniformShape);
                rank34 = `${strides[0] === xTexShape[1]}_${strides[strides.length - 1] === xTexShape[1]}`;
            }
            const xRank = x.shape.length;
            const isLogicalShapTexShapeEqual = uniformShape.length === 2 && (0, $0775da5e684c8c0d$exports).arraysEqual(x.shape, xTexShape);
            const isScalar = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape) === 1;
            const broadcastDims = (0, $f35e0c1a651337db$exports).getBroadcastDims(x.shape, output.shape);
            const isInOutTexShapeEqual = !program.packedInputs && xRank === output.shape.length && (0, $0775da5e684c8c0d$exports).arraysEqual(xTexShape, output.texData.texShape);
            const isTexShapeGreaterThanOne = program.packedInputs || uniformShape.length > 2 ? '' : `${xTexShape[0] > 1}_${xTexShape[1] > 1}`;
            // These key components are needed due to shader_compiler is embedding
            // them in the shader.
            // |xRank| is used to determine the coords length. See
            // get[Packed]SamplerAtOutputCoords.
            // |isInOutTexShapeEqual| is used to determine whether going to an
            // optimization path in getSamplerAtOutputCoords.
            // |useSqueezeShape| is extracted from squeezeInputInfo of
            // getSampler[2|3|4]D/getPackedSampler3D.
            // |isScalar| is extracted from isInputScalar/isOutputScalar in
            // getPackedSamplerAtOutputCoords.
            // |broadcastDims| is extracted from get[Packed]SamplerAtOutputCoords.
            // |isLogicalShapTexShapeEqual| is used in
            // getOutput[Packed]2DCoords/get[Packed]Sampler2D.
            // |rank1| is used in getOutputPacked1DCoords.
            // |rank2| is used in getOutput2DCoords.
            // |rank34| is used in getSampler3D/getSampler4D.
            // |isTexShapeGreaterThanOne| are used in
            // getSampler[Scalar|1D|2D]/getOutput1DCoords.
            keyInputs += `${xRank}_${isInOutTexShapeEqual}_${useSqueezeShape ? keptDims : ''}_${uniformShape.length}_${isScalar}_${broadcastDims}_${isLogicalShapTexShapeEqual}_${rank1}_${rank2}_${rank34}_${isTexShapeGreaterThanOne}_${hasOffset}`;
        } else {
            const texShape = x.isUniform ? 'uniform' : x.texData.texShape;
            keyInputs += `${x.shape}_${texShape}_${hasOffset}`;
        }
    });
    const keyUserCode = program.userCode;
    let key = program.constructor.name;
    // Fast string concat. See https://jsperf.com/string-concatenation/14.
    key += '_' + keyInputs + '_' + keyUserCode + `${(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION')}`;
    return key;
}
function $ea5724662c9cdeb8$export$5acc770fc06a0138(rank) {
    // TODO: Remove the limitaion of rank <= 4.
    return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_USE_SHAPES_UNIFORMS') && rank <= 4;
}




class $a2284d5d00873bfd$export$f6ee51c6efbee026 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.outPackingScheme = (0, $44ae700445690738$export$81d5c79efa1086f2).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $5574d094388bec90$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd'
        ], outputShape) : $5574d094388bec90$export$53c37f67510642ce([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getA(rc.x, rc.y, rc.z);
        }

        ${glsl.output} = result;
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



class $361b8415b15aa7b6$export$4434db41c70879cb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outPackingScheme = (0, $44ae700445690738$export$81d5c79efa1086f2).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $5574d094388bec90$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd'
        ], outputShape) : $5574d094388bec90$export$53c37f67510642ce([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));
        }

        ${glsl.output} = result;
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $58395748eceebc7d$export$dae4f112167b5aac {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.outTexUsage = (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).DOWNLOAD;
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $5574d094388bec90$export$2ac12a308a563905}

      void main() {
        float x = getAAtOutCoords();
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $b882b25be7b10b8f$export$97e262e8a4818e2e {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outTexUsage = (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).DOWNLOAD;
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $5574d094388bec90$export$2ac12a308a563905}

      void main() {
        ivec3 coords = getOutputCoords();
        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $eb7de15916d0d681$var$CHANNEL_CHAR_TO_INDEX_MAP = {
    'R': 0,
    'G': 1,
    'B': 2,
    'A': 3
};
class $eb7de15916d0d681$export$b2e063313033aeab {
    constructor(outputShape, inputIsUnsignedByte = false, usedChannels = 'RGBA'){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        let output = `result`;
        if (inputIsUnsignedByte) output = `floor(result * 255. + 0.5)`;
        let mainLoop = '';
        for(let usedChannelIndex = 0; usedChannelIndex < usedChannels.length; usedChannelIndex++){
            const curChannel = usedChannels[usedChannelIndex];
            mainLoop += `
          if(offset == ${usedChannelIndex}) {
            result = values[${$eb7de15916d0d681$var$CHANNEL_CHAR_TO_INDEX_MAP[curChannel]}];
          }`;
        }
        this.userCode = `
      ${this.enableShapeUniforms ? $5574d094388bec90$export$4ec1e3f6361de451() : $5574d094388bec90$export$4c68558c71205a01(outputShape)}

      void main() {
        ivec3 coords = getOutputCoords();
        int flatIndex = getFlatIndex(coords);
        float result = 0.;
        int offset = imod(flatIndex, ${usedChannels.length});

        flatIndex = idiv(flatIndex, ${usedChannels.length}, 1.);

        int r = flatIndex / texShape[1];
        if (r < texShape[0]) {
          int c = imod(flatIndex, texShape[1]);
          vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
          vec4 values = ${glsl.texture2D}(A, uv);
          ${mainLoop}
        }
        ${glsl.output} = vec4(${output}, 0., 0., 0.);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $01a0bda8aab8b30a$export$3b3e6b1f67c8c4d5 {
    constructor(outputShape, inputIsUnsignedByte = false){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        let mainLoop = '';
        let output = 'result';
        if (inputIsUnsignedByte) output = 'floor(result * 255. + 0.5)';
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            const channel = row * 2 + col;
            mainLoop += `
          localCoords = coords;
          if(localCoords[2] + ${col} < ${this.enableShapeUniforms ? 'outShape[2]' : `${outputShape[2]}`}) {
          localCoords[2] += ${col};
          if (localCoords[1] + ${row} < ${this.enableShapeUniforms ? 'outShape[1]' : `${outputShape[1]}`}) {
            localCoords[1] += ${row};

            flatIndex = getFlatIndex(localCoords);
            offset = imod(flatIndex, 4);

            flatIndex = idiv(flatIndex, 4, 1.);

            int r = flatIndex / texShape[1];
            int c = imod(flatIndex, texShape[1]);
            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
            values = ${glsl.texture2D}(A, uv);

            if (offset == 0) {
              result[${channel}] = values[0];
            } else if (offset == 1) {
              result[${channel}] = values[1];
            } else if (offset == 2) {
              result[${channel}] = values[2];
            } else {
              result[${channel}] = values[3];
            }
          }
        }
        `;
        }
        this.userCode = `
        ${this.enableShapeUniforms ? $5574d094388bec90$export$4ec1e3f6361de451() : $5574d094388bec90$export$4c68558c71205a01(outputShape)}

        void main() {
          ivec3 coords = getOutputCoords();

          vec4 result = vec4(0.);
          int flatIndex, r, c, offset;
          ivec3 localCoords;
          vec2 uv;
          vec4 values;

          ${mainLoop}

          ${glsl.output} = ${output};
        }
    `;
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $64fbedee815fbec3$export$4ca6704ce1875929(gl) {
    const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
    const vertexShaderSource = `${glsl.version}
    precision highp float;
    ${glsl.attribute} vec3 clipSpacePos;
    ${glsl.attribute} vec2 uv;
    ${glsl.varyingVs} vec2 resultUV;

    void main() {
      gl_Position = vec4(clipSpacePos, 1);
      resultUV = uv;
    }`;
    return $f6f0bdab98aa0468$export$4ca6704ce1875929(gl, vertexShaderSource);
}
function $64fbedee815fbec3$export$8ddd35f9c5bd5634(gl) {
    // [x y z u v] * [upper-left, lower-left, upper-right, lower-right]
    const vertexArray = new Float32Array([
        -1,
        1,
        0,
        0,
        1,
        -1,
        -1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        -1,
        0,
        1,
        0
    ]);
    return $f6f0bdab98aa0468$export$3871e1d1e28ac6cb(gl, vertexArray);
}
function $64fbedee815fbec3$export$2be7df49658092d0(gl) {
    // OpenGL (and WebGL) have "CCW == front" winding
    const triangleVertexIndices = new Uint16Array([
        0,
        1,
        2,
        2,
        1,
        3
    ]);
    return $f6f0bdab98aa0468$export$f9b26b97ca2b25e9(gl, triangleVertexIndices);
}
function $64fbedee815fbec3$var$createAndConfigureTexture(gl, width, height, internalFormat, textureFormat, textureType) {
    $f6f0bdab98aa0468$export$3543950a45505554(width, height);
    const texture = $f6f0bdab98aa0468$export$37b981a8c575f415(gl);
    const tex2d = gl.TEXTURE_2D;
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(tex2d, texture));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MIN_FILTER, gl.NEAREST));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MAG_FILTER, gl.NEAREST));
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 1) $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texImage2D(tex2d, 0, internalFormat, width, height, 0, textureFormat, textureType, null));
    else $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texStorage2D(tex2d, 1, internalFormat, width, height));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
    return {
        texture: texture,
        texShape: [
            height,
            width
        ]
    };
}
function $64fbedee815fbec3$export$46e83db9ed4a55ec(textureConfig) {
    return textureConfig.internalFormatFloat;
}
function $64fbedee815fbec3$export$b6545ebc87bceaba(gl, rows, columns, textureConfig) {
    const [width, height] = $44ae700445690738$export$95fb8493b25f77a4(rows, columns);
    return $64fbedee815fbec3$var$createAndConfigureTexture(gl, width, height, $64fbedee815fbec3$export$46e83db9ed4a55ec(textureConfig), textureConfig.textureFormatFloat, gl.FLOAT);
}
function $64fbedee815fbec3$export$c3c5df7eccaed480(textureConfig) {
    return textureConfig.internalFormatHalfFloat;
}
function $64fbedee815fbec3$export$3e231b7a052616c2(gl, rows, columns, textureConfig) {
    const [width, height] = $44ae700445690738$export$95fb8493b25f77a4(rows, columns);
    return $64fbedee815fbec3$var$createAndConfigureTexture(gl, width, height, $64fbedee815fbec3$export$c3c5df7eccaed480(textureConfig), textureConfig.textureFormatFloat, textureConfig.textureTypeHalfFloat);
}
function $64fbedee815fbec3$export$ed62004e3546feef(textureConfig) {
    return textureConfig.downloadTextureFormat;
}
function $64fbedee815fbec3$export$23456bef7917c292(gl, rows, columns, textureConfig) {
    const [width, height] = $44ae700445690738$export$95fb8493b25f77a4(rows, columns);
    return $64fbedee815fbec3$var$createAndConfigureTexture(gl, width, height, $64fbedee815fbec3$export$ed62004e3546feef(textureConfig), gl.RGBA, gl.UNSIGNED_BYTE);
}
function $64fbedee815fbec3$export$dcae4a9709a9d6(textureConfig) {
    return textureConfig.internalFormatPackedFloat;
}
function $64fbedee815fbec3$export$9edab265a05c8d3a(gl, rows, columns, textureConfig) {
    const [width, height] = $44ae700445690738$export$2754e02fa98f5582(rows, columns);
    return $64fbedee815fbec3$var$createAndConfigureTexture(gl, width, height, $64fbedee815fbec3$export$dcae4a9709a9d6(textureConfig), gl.RGBA, gl.FLOAT);
}
function $64fbedee815fbec3$export$9b8d6c2b6b2037b0(textureConfig) {
    return textureConfig.internalFormatPackedHalfFloat;
}
function $64fbedee815fbec3$export$9c51ae7c3160b50c(gl, rows, columns, textureConfig) {
    const [width, height] = $44ae700445690738$export$2754e02fa98f5582(rows, columns);
    return $64fbedee815fbec3$var$createAndConfigureTexture(gl, width, height, $64fbedee815fbec3$export$9b8d6c2b6b2037b0(textureConfig), gl.RGBA, textureConfig.textureTypeHalfFloat);
}
function $64fbedee815fbec3$export$9080d84e4e2d38c9(gl, program, vertexBuffer) {
    const posOffset = 0; // x is the first buffer element
    const uvOffset = 12; // uv comes after [x y z]
    const stride = 20; // xyz + uv, each entry is 4-byte float.
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer));
    const success = $f6f0bdab98aa0468$export$4c858b3c953a013f(gl, program, 'clipSpacePos', vertexBuffer, 3, stride, posOffset);
    return success && $f6f0bdab98aa0468$export$4c858b3c953a013f(gl, program, 'uv', vertexBuffer, 2, stride, uvOffset);
}
function $64fbedee815fbec3$export$fe948dd2858cae63(gl, texture, width, height, data, textureConfig) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    let dataForUpload, texelDataType, internalFormat;
    if (data instanceof Uint8Array) {
        dataForUpload = new Uint8Array(width * height * 4);
        texelDataType = gl.UNSIGNED_BYTE;
        internalFormat = gl.RGBA;
    } else {
        dataForUpload = new Float32Array(width * height * 4);
        texelDataType = gl.FLOAT;
        internalFormat = textureConfig.internalFormatPackedFloat;
    }
    dataForUpload.set(data);
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, gl.RGBA, texelDataType, dataForUpload));
    else $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, gl.RGBA, texelDataType, dataForUpload));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $64fbedee815fbec3$export$2d42c33b8625a8d7(gl, texture, pixels) {
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    if (pixels.data instanceof Uint8Array) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, pixels.width, pixels.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
        else $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pixels.width, pixels.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
    } else if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    else $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $64fbedee815fbec3$export$2983fc3c819070e9(gl2, rows, columns, textureConfig) {
    // Create and bind the buffer.
    const buffer = gl2.createBuffer();
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer));
    // Initialize the buffer to the size of the texture in bytes.
    const bytesPerFloat = 4;
    const valuesPerTexel = 4;
    const bufferSizeBytes = bytesPerFloat * valuesPerTexel * rows * columns;
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.bufferData(gl2.PIXEL_PACK_BUFFER, bufferSizeBytes, gl2.STREAM_READ));
    // Enqueue a command on the GPU command queue to copy of texture into the
    // buffer.
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.readPixels(0, 0, columns, rows, gl2.RGBA, gl2.FLOAT, 0));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null));
    return buffer;
}
function $64fbedee815fbec3$export$3d2780ea6b3027ca(gl, buffer, size) {
    const gl2 = gl;
    const downloadTarget = new Float32Array(size);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $64fbedee815fbec3$export$6bc5a1ce24b8dc6c(gl, rows, columns, textureConfig) {
    const [w, h] = $44ae700445690738$export$95fb8493b25f77a4(rows, columns);
    const numChannels = 4;
    const downloadTarget = new Uint8Array($44ae700445690738$export$9427543edb6e188a(rows * columns, numChannels));
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.readPixels(0, 0, w, h, textureConfig.downloadTextureFormat, gl.UNSIGNED_BYTE, downloadTarget));
    // By wrapping the buffer in a Float32Array, we use native browser IEEE 754
    // decoding of the 4 bytes that back each 32 bit float.
    return new Float32Array(downloadTarget.buffer);
}
function $64fbedee815fbec3$export$4fe1bc4caaf85c22(gl, buffer, batch, rows, cols, physicalRows, physicalCols, textureConfig) {
    const gl2 = gl;
    const downloadTarget = new Float32Array($44ae700445690738$export$12d4e412f879b1d4(physicalRows, physicalCols));
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $64fbedee815fbec3$export$7287c6a301610ce2(gl, physicalRows, physicalCols) {
    const packedRGBA = new Float32Array(physicalRows * physicalCols * 4);
    $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.readPixels(0, 0, physicalCols, physicalRows, gl.RGBA, gl.FLOAT, packedRGBA));
    return packedRGBA;
}




class $1f82cab824353cd6$export$fa7a74a0ce382ac5 {
    constructor(gl){
        this.outputTexture = null;
        this.program = null;
        this.disposed = false;
        this.itemsToPoll = [];
        const glVersion = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION');
        if (gl != null) {
            this.gl = gl;
            (0, $2cb790622144e5be$export$4b8d5e1525955c68)(glVersion, gl);
        } else this.gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)(glVersion);
        gl = this.gl;
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) {
            const gl2 = gl;
            this.createVertexArray = ()=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.createVertexArray());
            };
            this.bindVertexArray = (vao)=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.bindVertexArray(vao));
            };
            this.deleteVertexArray = (vao)=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.deleteVertexArray(vao));
            };
            this.getVertexArray = ()=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl2, ()=>gl2.getParameter(gl2.VERTEX_ARRAY_BINDING));
            };
        } else if (gl != null) {
            const ext = gl.getExtension('OES_vertex_array_object');
            if (ext == null) throw new Error("All WebGL1 implementations are expected to offer OES_vertex_array_object.");
            this.createVertexArray = ()=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>ext.createVertexArrayOES());
            };
            this.bindVertexArray = (vao)=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>ext.bindVertexArrayOES(vao));
            };
            this.deleteVertexArray = (vao)=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>ext.deleteVertexArrayOES(vao));
            };
            this.getVertexArray = ()=>{
                return $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.getParameter(ext.VERTEX_ARRAY_BINDING_OES));
            };
        }
        // WebGL 2.0 enables texture floats without an extension.
        let COLOR_BUFFER_FLOAT = 'WEBGL_color_buffer_float';
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        this.parallelCompilationExtension = this.gl.getExtension('KHR_parallel_shader_compile');
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 1) {
            const TEXTURE_FLOAT = 'OES_texture_float';
            const TEXTURE_HALF_FLOAT = 'OES_texture_half_float';
            this.textureFloatExtension = $f6f0bdab98aa0468$export$3a5e7a891790a26c(this.gl, TEXTURE_FLOAT);
            if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(this.gl, TEXTURE_HALF_FLOAT)) this.textureHalfFloatExtension = $f6f0bdab98aa0468$export$3a5e7a891790a26c(this.gl, TEXTURE_HALF_FLOAT);
            else if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
            this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = $f6f0bdab98aa0468$export$3a5e7a891790a26c(this.gl, COLOR_BUFFER_HALF_FLOAT);
            else if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
        } else {
            COLOR_BUFFER_FLOAT = 'EXT_color_buffer_float';
            if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(this.gl, COLOR_BUFFER_FLOAT)) this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            else if ($f6f0bdab98aa0468$export$4f402f57c05c9ec3(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            else throw new Error('GL context does not support color renderable floats');
        }
        this.vertexBuffer = $64fbedee815fbec3$export$8ddd35f9c5bd5634(this.gl);
        this.indexBuffer = $64fbedee815fbec3$export$2be7df49658092d0(this.gl);
        this.framebuffer = $f6f0bdab98aa0468$export$366d1e3e32f5a700(this.gl);
        this.textureConfig = $44ae700445690738$export$129d92ae6e74c416(this.gl, this.textureHalfFloatExtension);
    }
    get debug() {
        return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG');
    }
    dispose() {
        if (this.disposed) return;
        if (this.program != null) console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing.");
        if (this.outputTexture != null) console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
        const gl = this.gl;
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.finish());
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.deleteFramebuffer(this.framebuffer));
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, null));
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null));
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.deleteBuffer(this.indexBuffer));
        this.disposed = true;
    }
    createFloat32MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $64fbedee815fbec3$export$b6545ebc87bceaba(this.gl, rows, columns, this.textureConfig);
    }
    createFloat16MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $64fbedee815fbec3$export$3e231b7a052616c2(this.gl, rows, columns, this.textureConfig);
    }
    createUnsignedBytesMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $64fbedee815fbec3$export$23456bef7917c292(this.gl, rows, columns, this.textureConfig);
    }
    uploadPixelDataToTexture(texture, pixels) {
        this.throwIfDisposed();
        $64fbedee815fbec3$export$2d42c33b8625a8d7(this.gl, texture, pixels);
    }
    uploadDenseMatrixToTexture(texture, width, height, data) {
        this.throwIfDisposed();
        $64fbedee815fbec3$export$fe948dd2858cae63(this.gl, texture, width, height, data, this.textureConfig);
    }
    createFloat16PackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $64fbedee815fbec3$export$9c51ae7c3160b50c(this.gl, rows, columns, this.textureConfig);
    }
    createPackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $64fbedee815fbec3$export$9edab265a05c8d3a(this.gl, rows, columns, this.textureConfig);
    }
    deleteMatrixTexture(texture) {
        this.throwIfDisposed();
        if (this.outputTexture === texture) {
            $f6f0bdab98aa0468$export$d3c809959a3c24fa(this.gl, this.framebuffer);
            this.outputTexture = null;
        }
        $f6f0bdab98aa0468$export$7642ac97981532b8(this.gl, ()=>this.gl.deleteTexture(texture));
    }
    downloadByteEncodedFloatMatrixFromOutputTexture(texture, rows, columns) {
        return this.downloadMatrixDriver(texture, ()=>$64fbedee815fbec3$export$6bc5a1ce24b8dc6c(this.gl, rows, columns, this.textureConfig));
    }
    downloadPackedMatrixFromBuffer(buffer, batch, rows, columns, physicalRows, physicalCols) {
        return $64fbedee815fbec3$export$4fe1bc4caaf85c22(this.gl, buffer, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
    }
    downloadFloat32MatrixFromBuffer(buffer, size) {
        return $64fbedee815fbec3$export$3d2780ea6b3027ca(this.gl, buffer, size);
    }
    createBufferFromTexture(texture, rows, columns) {
        this.bindTextureToFrameBuffer(texture);
        const result = $64fbedee815fbec3$export$2983fc3c819070e9(this.gl, rows, columns, this.textureConfig);
        this.unbindTextureToFrameBuffer();
        return result;
    }
    createAndWaitForFence() {
        const fenceContext = this.createFence(this.gl);
        return this.pollFence(fenceContext);
    }
    createFence(gl) {
        let query;
        let isFencePassed;
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_FENCE_API_ENABLED')) {
            const gl2 = gl;
            const sync = gl2.fenceSync(gl2.SYNC_GPU_COMMANDS_COMPLETE, 0);
            gl.flush();
            isFencePassed = ()=>{
                const status = gl2.clientWaitSync(sync, 0, 0);
                return status === gl2.ALREADY_SIGNALED || status === gl2.CONDITION_SATISFIED;
            };
            query = sync;
        } else if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0) {
            query = this.beginQuery();
            this.endQuery();
            isFencePassed = ()=>this.isQueryAvailable(query, (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
        } else // If we have no way to fence, return true immediately. This will fire in
        // WebGL 1.0 when there is no disjoint query timer. In this case, because
        // the fence passes immediately, we'll immediately ask for a download of
        // the texture, which will cause the UI thread to hang.
        isFencePassed = ()=>true;
        return {
            query: query,
            isFencePassed: isFencePassed
        };
    }
    downloadMatrixFromPackedTexture(texture, physicalRows, physicalCols) {
        return this.downloadMatrixDriver(texture, ()=>$64fbedee815fbec3$export$7287c6a301610ce2(this.gl, physicalRows, physicalCols));
    }
    createProgram(fragmentShader) {
        this.throwIfDisposed();
        const gl = this.gl;
        if (this.vertexShader == null) this.vertexShader = $64fbedee815fbec3$export$4ca6704ce1875929(gl);
        const program = $f6f0bdab98aa0468$export$327d24a04cd0dc17(gl);
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.attachShader(program, this.vertexShader));
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.attachShader(program, fragmentShader));
        $f6f0bdab98aa0468$export$d879afae78b531a5(gl, program);
        const program2 = Object.assign(program, {
            vao: this.createVertexArray()
        });
        if (this.debug) $f6f0bdab98aa0468$export$e2dfaf93681cde16(gl, program2);
        return program2;
    }
    buildVao(program) {
        this.setProgram(program);
        this.bindVertexArray(program.vao);
        const gl = this.gl;
        // Bind index buffer, and vertex buffers based on program attrib
        // locations.
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer));
        $64fbedee815fbec3$export$9080d84e4e2d38c9(gl, program, this.vertexBuffer);
    }
    deleteProgram(program) {
        this.throwIfDisposed();
        if (program === this.program) this.program = null;
        if (program != null) {
            $f6f0bdab98aa0468$export$7642ac97981532b8(this.gl, ()=>this.gl.deleteProgram(program));
            this.deleteVertexArray(program.vao);
        }
    }
    setProgram(program) {
        this.throwIfDisposed();
        this.program = program;
        if (this.program != null) {
            if (this.debug) $f6f0bdab98aa0468$export$e2dfaf93681cde16(this.gl, this.program);
        }
        $f6f0bdab98aa0468$export$7642ac97981532b8(this.gl, ()=>this.gl.useProgram(program));
    }
    getUniformLocation(program, uniformName, shouldThrow = true) {
        this.throwIfDisposed();
        if (shouldThrow) return $f6f0bdab98aa0468$export$748cafa2cdf50d8(this.gl, program, uniformName);
        else return $f6f0bdab98aa0468$export$d27256445dd7e8dd(this.gl, program, uniformName);
    }
    getAttributeLocation(program, attribute) {
        this.throwIfDisposed();
        return $f6f0bdab98aa0468$export$7642ac97981532b8(this.gl, ()=>this.gl.getAttribLocation(program, attribute));
    }
    getUniformLocationNoThrow(program, uniformName) {
        this.throwIfDisposed();
        return this.gl.getUniformLocation(program, uniformName);
    }
    setInputMatrixTexture(inputMatrixTexture, uniformLocation, textureUnit) {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        $f6f0bdab98aa0468$export$f9ffd997f3c8b98f(this.gl, inputMatrixTexture, uniformLocation, textureUnit);
    }
    setOutputMatrixTexture(outputMatrixTexture, rows, columns) {
        this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
    }
    setOutputPackedMatrixTexture(outputPackedMatrixTexture, rows, columns) {
        this.throwIfDisposed();
        const [width, height] = $44ae700445690738$export$2754e02fa98f5582(rows, columns);
        this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width, height);
    }
    setOutputMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
    }
    setOutputPackedMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        throw new Error('setOutputPackedMatrixWriteRegion not implemented.');
    }
    debugValidate() {
        if (this.program != null) $f6f0bdab98aa0468$export$e2dfaf93681cde16(this.gl, this.program);
        $f6f0bdab98aa0468$export$ca09b577525e6519(this.gl);
    }
    executeProgram() {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        const gl = this.gl;
        if (this.debug) {
            const boundVao = this.getVertexArray();
            console.assert(boundVao === this.program.vao, 'VAO changed between setProgram and executeProgram!');
            this.debugValidate();
        }
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0));
    }
    blockUntilAllProgramsCompleted() {
        this.throwIfDisposed();
        $f6f0bdab98aa0468$export$7642ac97981532b8(this.gl, ()=>this.gl.finish());
    }
    getQueryTimerExtension() {
        if (this.disjointQueryTimerExtension == null) this.disjointQueryTimerExtension = $f6f0bdab98aa0468$export$3a5e7a891790a26c(this.gl, (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2 ? 'EXT_disjoint_timer_query_webgl2' : 'EXT_disjoint_timer_query');
        return this.disjointQueryTimerExtension;
    }
    getQueryTimerExtensionWebGL2() {
        return this.getQueryTimerExtension();
    }
    getQueryTimerExtensionWebGL1() {
        return this.getQueryTimerExtension();
    }
    beginQuery() {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const query = gl2.createQuery();
            gl2.beginQuery(ext.TIME_ELAPSED_EXT, query);
            return query;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        const query = ext.createQueryEXT();
        ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
        return query;
    }
    endQuery() {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            gl2.endQuery(ext.TIME_ELAPSED_EXT);
            return;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
    }
    async waitForQueryAndGetTime(query) {
        await (0, $0775da5e684c8c0d$exports).repeatedTry(()=>this.disposed || // while testing contexts are created / disposed
            // in rapid succession, so without this check we
            // may poll for the query timer indefinitely
            this.isQueryAvailable(query, (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')));
        return this.getQueryTime(query, (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
    }
    getQueryTime(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return null;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        }
    }
    isQueryAvailable(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return true;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const available = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_AVAILABLE_EXT);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        }
    }
    pollFence(fenceContext) {
        return new Promise((resolve)=>{
            this.addItemToPoll(()=>fenceContext.isFencePassed(), ()=>resolve());
        });
    }
    pollItems() {
        // Find the last query that has finished.
        const index = $1f82cab824353cd6$export$4a09b41294052731(this.itemsToPoll.map((x)=>x.isDoneFn));
        for(let i = 0; i <= index; ++i){
            const { resolveFn: resolveFn } = this.itemsToPoll[i];
            resolveFn();
        }
        this.itemsToPoll = this.itemsToPoll.slice(index + 1);
    }
    addItemToPoll(isDoneFn, resolveFn) {
        this.itemsToPoll.push({
            isDoneFn: isDoneFn,
            resolveFn: resolveFn
        });
        if (this.itemsToPoll.length > 1) // We already have a running loop that polls.
        return;
        // Start a new loop that polls.
        let scheduleFn = undefined;
        if ('setTimeoutCustom' in (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform) scheduleFn = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform.setTimeoutCustom.bind((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().platform);
        (0, $0775da5e684c8c0d$exports).repeatedTry(()=>{
            this.pollItems();
            // End the loop if no more items to poll.
            return this.itemsToPoll.length === 0;
        }, ()=>0, null, scheduleFn);
    }
    bindTextureToFrameBuffer(texture) {
        this.throwIfDisposed();
        $f6f0bdab98aa0468$export$4e154f0d71f19013(this.gl, texture, this.framebuffer);
        if (this.debug) $f6f0bdab98aa0468$export$ca09b577525e6519(this.gl);
    }
    unbindTextureToFrameBuffer() {
        if (this.outputTexture != null) {
            $f6f0bdab98aa0468$export$4e154f0d71f19013(this.gl, this.outputTexture, this.framebuffer);
            if (this.debug) $f6f0bdab98aa0468$export$ca09b577525e6519(this.gl);
        } else $f6f0bdab98aa0468$export$d3c809959a3c24fa(this.gl, this.framebuffer);
    }
    downloadMatrixDriver(texture, downloadAndDecode) {
        this.bindTextureToFrameBuffer(texture);
        const result = downloadAndDecode();
        this.unbindTextureToFrameBuffer();
        return result;
    }
    setOutputMatrixTextureDriver(outputMatrixTextureMaybePacked, width, height) {
        this.throwIfDisposed();
        const gl = this.gl;
        $f6f0bdab98aa0468$export$4e154f0d71f19013(gl, outputMatrixTextureMaybePacked, this.framebuffer);
        if (this.debug) $f6f0bdab98aa0468$export$ca09b577525e6519(gl);
        this.outputTexture = outputMatrixTextureMaybePacked;
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.viewport(0, 0, width, height));
        $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.scissor(0, 0, width, height));
    }
    setOutputMatrixWriteRegionDriver(x, y, width, height) {
        this.throwIfDisposed();
        $f6f0bdab98aa0468$export$7642ac97981532b8(this.gl, ()=>this.gl.scissor(x, y, width, height));
    }
    throwIfDisposed() {
        if (this.disposed) throw new Error('Attempted to use disposed GPGPUContext.');
    }
    throwIfNoProgram() {
        if (this.program == null) throw new Error('No GPU program is currently set.');
    }
}
function $1f82cab824353cd6$export$4a09b41294052731(arr) {
    let i = 0;
    for(; i < arr.length; ++i){
        const isDone = arr[i]();
        if (!isDone) break;
    }
    return i - 1;
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import shared functionality from tfjs-backend-cpu without triggering
// side effects.
// tslint:disable-next-line: no-imports-from-dist

const { addImpl: $1cec302811203101$export$c7f405723b4a93e7, bincountImpl: $1cec302811203101$export$566def819e5d4601, bincountReduceImpl: $1cec302811203101$export$447b89266e53682e, bitwiseAndImpl: $1cec302811203101$export$b9ea48282fa3ef20, castImpl: $1cec302811203101$export$babf602309dd6292, ceilImpl: $1cec302811203101$export$bb3ce81256fe261b, concatImpl: $1cec302811203101$export$95e7342d25849d64, equalImpl: $1cec302811203101$export$13d1298222b29d06, expImpl: $1cec302811203101$export$f72e179c9610cb8c, expm1Impl: $1cec302811203101$export$5903785c29f035f5, floorImpl: $1cec302811203101$export$195a28e6add8ab7e, gatherNdImpl: $1cec302811203101$export$e3196a12dce24214, gatherV2Impl: $1cec302811203101$export$cffe0fde89e98de6, greaterImpl: $1cec302811203101$export$eabb8927944259dd, greaterEqualImpl: $1cec302811203101$export$a3d2e203d979d298, lessImpl: $1cec302811203101$export$74c893b3c5e74e60, lessEqualImpl: $1cec302811203101$export$6d1533a3ea9565f, linSpaceImpl: $1cec302811203101$export$c86a2be8970d7a7d, logImpl: $1cec302811203101$export$e88dde64a338f813, maxImpl: $1cec302811203101$export$a94164c9f637858e, maximumImpl: $1cec302811203101$export$b3afdc53a543e175, minimumImpl: $1cec302811203101$export$1f01be3f637863fa, multiplyImpl: $1cec302811203101$export$598d1d66b05a298f, negImpl: $1cec302811203101$export$1cbcde7624effb15, notEqualImpl: $1cec302811203101$export$b91372753635df24, prodImpl: $1cec302811203101$export$2d654219115cec80, raggedGatherImpl: $1cec302811203101$export$7cf38d50772f4bbc, raggedRangeImpl: $1cec302811203101$export$46d9d0942af5d1c2, raggedTensorToTensorImpl: $1cec302811203101$export$b3c4ab635ddc431f, rangeImpl: $1cec302811203101$export$fbee6deed7e76443, rsqrtImpl: $1cec302811203101$export$431ccb02913a1aee, scatterImpl: $1cec302811203101$export$2295c910080b5ca7, sigmoidImpl: $1cec302811203101$export$9b816377c2ca1f1f, simpleAbsImpl: $1cec302811203101$export$d7efa3585619eabe, sliceImpl: $1cec302811203101$export$45812d0d8578899, sparseFillEmptyRowsImpl: $1cec302811203101$export$6cee5fb970d08428, sparseReshapeImpl: $1cec302811203101$export$d17b3360054ff370, sparseSegmentReductionImpl: $1cec302811203101$export$a503222c03b33888, sqrtImpl: $1cec302811203101$export$548a22b20eeaf85b, staticRegexReplaceImpl: $1cec302811203101$export$b3e893e48b8d1e39, stridedSliceImpl: $1cec302811203101$export$efd4e188e5de0188, stringNGramsImpl: $1cec302811203101$export$bb9e83cb65884ef3, stringSplitImpl: $1cec302811203101$export$bb4b4a9a1db97dea, stringToHashBucketFastImpl: $1cec302811203101$export$d7d8a9bba3df6e63, subImpl: $1cec302811203101$export$be7474e96b733333, tileImpl: $1cec302811203101$export$349e02a266ab3131, topKImpl: $1cec302811203101$export$cc4aa6851cf96e2b, transposeImpl: $1cec302811203101$export$a0105d4a7143676c, uniqueImpl: $1cec302811203101$export$c417de669ad2e148 } = $f98ae2f32496d64b$exports;


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $70e72a00a69a2f93$export$a7c2113d79df2971(name, rank) {
    return [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ].slice(0, rank).map((d)=>`${name}.${d}`);
}
function $70e72a00a69a2f93$export$7a4d1d0d17b69972(name, rank) {
    if (rank === 1) return [
        name
    ];
    return $70e72a00a69a2f93$export$a7c2113d79df2971(name, rank);
}
function $70e72a00a69a2f93$export$8f96407d418c6727(rank, dims) {
    if (rank === 1) return 'rc';
    let coords = '';
    for(let i = 0; i < rank; i++){
        coords += dims[i];
        if (i < rank - 1) coords += ',';
    }
    return coords;
}



class $007ac94798e454eb$export$5ebf74a9a135ce1d {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        // Only input / output 3D tensors.
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        if (this.rank === 0) this.userCode = `
        void main() {
          setOutput(vec4(getA(), 0., 0., 0.));
        }
      `;
        else {
            const channels = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('rc', this.rank);
            const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
            const outOfBoundsCondition = this.getOutOfBoundsCondition(channels);
            const setup = this.getSetup(channels);
            const output = this.getOutput(channels);
            this.userCode = `
        void main() {
          ${dtype} rc = getOutputCoords();

          if(${outOfBoundsCondition}) {
            setOutput(vec4(0));
          } else {
            ${setup}

            setOutput(vec4(${output}));
          }
        }
      `;
        }
    }
    getSourceCoordsArr(dims) {
        const coords = [];
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            let coord = `${row === 0 ? 'r' : 'rp1'}, ${col === 0 ? 'c' : 'cp1'}`;
            for(let d = 2; d < this.rank; d++)coord = `${dims[dims.length - 1 - d]},` + coord;
            coords.push(coord);
        }
        return coords;
    }
    getOutOfBoundsCondition(dims) {
        if (this.rank === 1) return `rc > ${this.enableShapeUniforms ? 'outShape' : this.outputShape[0]}`;
        let cond = '';
        for(let i = this.rank - 2; i < this.rank; i++){
            cond += `${dims[i]} >= ${this.enableShapeUniforms ? `outShape[${i}]` : this.outputShape[i]}`;
            if (i < this.rank - 1) cond += '||';
        }
        return cond;
    }
    getSetup(dims) {
        if (this.rank === 1) return '';
        const innerDims = dims.slice(-2);
        const col = this.enableShapeUniforms ? `outShape[${this.rank} - 1]` : this.outputShape[this.rank - 1];
        const row = this.enableShapeUniforms ? `outShape[${this.rank} - 2]` : this.outputShape[this.rank - 2];
        return `
      int r = ${innerDims[0]};
      int c = ${innerDims[1]};
      int rp1 = r + 1;
      int cp1 = c + 1;

      bool cEdge = cp1 >= ${col};
      bool rEdge = rp1 >= ${row};
    `;
    }
    getOutput(dims) {
        const sourceCoords = this.getSourceCoordsArr(dims);
        if (this.rank === 1) {
            const outShape = this.enableShapeUniforms ? 'outShape' : this.outputShape[0];
            return `getA(rc), (rc + 1 >= ${outShape} ? 0. : getA(rc + 1)), 0, 0`;
        }
        return `getA(${sourceCoords[0]}),
            cEdge ? 0. : getA(${sourceCoords[1]}),
            rEdge ? 0. : getA(${sourceCoords[2]}),
            rEdge || cEdge ? 0. : getA(${sourceCoords[3]})`;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $95376b668d58fbfd$export$ce249f6fedcc44de {
    constructor(outputShape, inputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec3'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        let mainLoop = ``;
        for(let i = 0; i < 4; i++){
            let thisRC = `thisRC = rc;`;
            if (i % 2 === 1) thisRC += `thisRC.z += 1;`;
            if (i > 1) thisRC += `thisRC.y += 1;`;
            mainLoop += `
        ${thisRC}
        ${i > 0 ? `if(thisRC.y < rows && thisRC.z < cols){` : ''}
          int flatIndex = getFlatIndex(thisRC);

          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);
          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));

          result[${i}] =
            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);
        ${i > 0 ? '}' : ''}
      `;
        }
        this.userCode = `
      ${$95376b668d58fbfd$var$getReshapedInputCoords(inputShape, this.enableShapeUniforms)}
      ${this.enableShapeUniforms ? $5574d094388bec90$export$4ec1e3f6361de451() : $5574d094388bec90$export$4c68558c71205a01(outputShape)}

      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0.);

        ivec3 thisRC;
        int rows = ${this.enableShapeUniforms ? 'outShape[1]' : outputShape[1]};
        int cols = ${this.enableShapeUniforms ? 'outShape[2]' : outputShape[2]};

        ${mainLoop}

        setOutput(result);
      }
    `;
    }
}
function $95376b668d58fbfd$var$getReshapedInputCoords(shape, enableShapeUniforms) {
    const coordsFromIndexSnippet = enableShapeUniforms ? $5574d094388bec90$export$a1b266196cc2d8ea([
        'r',
        'c',
        'd'
    ], 'inputShape') : $5574d094388bec90$export$53c37f67510642ce([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 inputCoordsFromReshapedOutCoords(int index) {
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}



/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $bd9d1760febc3e15$export$337f59f8fd79d24f {
    constructor(gpgpu){
        this.gpgpu = gpgpu;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        // Number of bytes that have been allocated and available for reuse.
        this._numBytesFree = 0;
        this.freeTextures = {};
        this.usedTextures = {};
        this.logEnabled = false;
    }
    acquireTexture(shapeRC, usage, isPacked) {
        const physicalTexType = $bd9d1760febc3e15$var$getPhysicalFromLogicalTextureType(usage, isPacked);
        const shapeKey = $bd9d1760febc3e15$var$getKeyFromTextureShape(shapeRC, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        if (!(shapeKey in this.usedTextures)) this.usedTextures[shapeKey] = [];
        const texBytes = $bd9d1760febc3e15$export$66c19e55ce03e099(shapeRC, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        if (this.freeTextures[shapeKey].length > 0) {
            this.numFreeTextures--;
            this.numUsedTextures++;
            this._numBytesFree -= texBytes;
            this.log();
            const newTexture = this.freeTextures[shapeKey].pop();
            this.usedTextures[shapeKey].push(newTexture);
            return newTexture;
        }
        let newTexture;
        if (physicalTexType === (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT32) newTexture = this.gpgpu.createPackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT16) newTexture = this.gpgpu.createFloat16PackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $44ae700445690738$export$bde70ab3692e385c).UNPACKED_FLOAT32) newTexture = this.gpgpu.createFloat32MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $44ae700445690738$export$bde70ab3692e385c).UNPACKED_FLOAT16) newTexture = this.gpgpu.createFloat16MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_4X1_UNSIGNED_BYTE) newTexture = this.gpgpu.createUnsignedBytesMatrixTexture(shapeRC[0], shapeRC[1]);
        this.usedTextures[shapeKey].push(newTexture);
        this.numUsedTextures++;
        this._numBytesAllocated += texBytes;
        this.log();
        return newTexture;
    }
    releaseTexture(texture, shape, logicalTexType, isPacked) {
        if (this.freeTextures == null) // Already disposed.
        return;
        const physicalTexType = $bd9d1760febc3e15$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked);
        const shapeKey = $bd9d1760febc3e15$var$getKeyFromTextureShape(shape, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        const texBytes = $bd9d1760febc3e15$export$66c19e55ce03e099(shape, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        const deleteTexThreshold = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DELETE_TEXTURE_THRESHOLD');
        if (deleteTexThreshold !== -1 && this._numBytesAllocated > deleteTexThreshold) {
            this.gpgpu.deleteMatrixTexture(texture.texture);
            this._numBytesAllocated -= texBytes;
        } else {
            this.freeTextures[shapeKey].push(texture);
            this.numFreeTextures++;
            this._numBytesFree += texBytes;
        }
        this.numUsedTextures--;
        const texList = this.usedTextures[shapeKey];
        const texIndex = texList && texList.indexOf(texture);
        if (texIndex == null || texIndex < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        texList[texIndex] = texList[texList.length - 1];
        texList.pop();
        this.log();
    }
    log() {
        if (!this.logEnabled) return;
        const total = this.numFreeTextures + this.numUsedTextures;
        console.log('Free/Used', `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${total})`);
        const freeRatio = this._numBytesFree / this._numBytesAllocated;
        console.log(`Bytes allocated: ${this._numBytesAllocated}`);
        console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100 * freeRatio)}%)`);
    }
    get numBytesAllocated() {
        return this._numBytesAllocated;
    }
    get numBytesFree() {
        return this._numBytesFree;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        if (this.freeTextures == null) // Already disposed.
        return;
        for(const texShape in this.freeTextures)this.freeTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        for(const texShape in this.usedTextures)this.usedTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        // TODO: Assign non-null value (empty object) to textures after disposed.
        this.freeTextures = null;
        this.usedTextures = null;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        this._numBytesFree = 0;
    }
}
function $bd9d1760febc3e15$var$numBytesForInternalFormat(gl, internalFormat) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    if (internalFormat === glany.R32F) return 4;
    else if (internalFormat === glany.R16F) return 2;
    else if (internalFormat === glany.RGBA32F) return 16;
    else if (internalFormat === gl.RGBA) return 16;
    else if (internalFormat === glany.RGBA16F) return 8;
    else if (internalFormat === glany.RGBA8) return 4;
    throw new Error(`Unknown internal format ${internalFormat}`);
}
function $bd9d1760febc3e15$export$66c19e55ce03e099(shape, physicalTexType, gl, textureConfig, isPacked) {
    // It is not possible to infer packed status from the texture type because
    // depending on the textureConfig, different  texture types may resolve to the
    // same internal format (e.g. in WebGL1, the internal format for
    // UNPACKED_FLOAT16 textures is gl.RGBA). Therefore we pass in `isPacked`
    // explicitly.
    const internalFormat = $bd9d1760febc3e15$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig);
    let numElements;
    if (isPacked) {
        const [packedWidth, packedHeight] = (0, $44ae700445690738$export$2754e02fa98f5582)(shape[0], shape[1]);
        numElements = packedWidth * packedHeight;
    } else {
        const [width, height] = (0, $44ae700445690738$export$95fb8493b25f77a4)(shape[0], shape[1]);
        numElements = width * height;
    }
    const bytesPerElement = $bd9d1760febc3e15$var$numBytesForInternalFormat(gl, internalFormat);
    return numElements * bytesPerElement;
}
function $bd9d1760febc3e15$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig) {
    switch(physicalTexType){
        case (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT32:
            return (0, $64fbedee815fbec3$export$dcae4a9709a9d6)(textureConfig);
        case (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT16:
            return (0, $64fbedee815fbec3$export$9b8d6c2b6b2037b0)(textureConfig);
        case (0, $44ae700445690738$export$bde70ab3692e385c).UNPACKED_FLOAT32:
            return (0, $64fbedee815fbec3$export$46e83db9ed4a55ec)(textureConfig);
        case (0, $44ae700445690738$export$bde70ab3692e385c).UNPACKED_FLOAT16:
            return (0, $64fbedee815fbec3$export$c3c5df7eccaed480)(textureConfig);
        case (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_4X1_UNSIGNED_BYTE:
            return (0, $64fbedee815fbec3$export$ed62004e3546feef)(textureConfig);
        default:
            throw new Error(`Unknown physical texture type ${physicalTexType}`);
    }
}
function $bd9d1760febc3e15$var$getPhysicalTextureForRendering(isPacked) {
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_RENDER_FLOAT32_ENABLED')) {
        if (isPacked) return (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT32;
        return (0, $44ae700445690738$export$bde70ab3692e385c).UNPACKED_FLOAT32;
    }
    if (isPacked) return (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT16;
    return (0, $44ae700445690738$export$bde70ab3692e385c).UNPACKED_FLOAT16;
}
function $bd9d1760febc3e15$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked) {
    if (logicalTexType === (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).UPLOAD) return (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_2X2_FLOAT32;
    else if (logicalTexType === (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).RENDER || logicalTexType == null) return $bd9d1760febc3e15$var$getPhysicalTextureForRendering(isPacked);
    else if (logicalTexType === (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).DOWNLOAD || logicalTexType === (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).PIXELS) return (0, $44ae700445690738$export$bde70ab3692e385c).PACKED_4X1_UNSIGNED_BYTE;
    throw new Error(`Unknown logical texture type ${logicalTexType}`);
}
function $bd9d1760febc3e15$var$getKeyFromTextureShape(shapeRowsCol, physicalTexType, isPacked) {
    return `${shapeRowsCol[0]}_${shapeRowsCol[1]}_${physicalTexType}_${isPacked}`;
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $b1c981bb7af6249a$export$f93811a5a466fd42 {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      float unaryOperation(float x) {
        ${opSnippet}
      }

      void main() {
        float x = getAAtOutCoords();
        float y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}
const $b1c981bb7af6249a$export$39f0cca2b63399f6 = `if (isnan(x)) return x;`;
const $b1c981bb7af6249a$export$8244104593af74a6 = `return x;`;
const $b1c981bb7af6249a$export$3f020f6dcff67a1b = `return abs(x);`;
function $b1c981bb7af6249a$export$8a2ed3f7f077984e(alpha = 0.0) {
    return $b1c981bb7af6249a$export$39f0cca2b63399f6 + `
    return x > 0.0 ? 1.0 : float(${alpha});
  `;
}
const $b1c981bb7af6249a$export$945a5ccf96adb3b2 = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $b1c981bb7af6249a$export$27041fe53e1ee6da = $b1c981bb7af6249a$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : x;
`;
const $b1c981bb7af6249a$export$94bf29e9c85fc840 = $b1c981bb7af6249a$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $b1c981bb7af6249a$export$c07b68c109124fe2 = 'return x;';
const $b1c981bb7af6249a$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $262948717bc1c671$export$8244104593af74a6 = `return x;`;
const $262948717bc1c671$export$945a5ccf96adb3b2 = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $262948717bc1c671$export$27041fe53e1ee6da = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $262948717bc1c671$export$94bf29e9c85fc840 = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $262948717bc1c671$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;
class $262948717bc1c671$export$4d8daca4f85ed73d {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      vec4 unaryOperation(vec4 x) {
        ${opSnippet}
      }

      void main() {
        vec4 x = getAAtOutCoords();
        vec4 y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $b781fc92cb2569f3$export$c457dd67217cb5eb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const rank = outputShape.length;
        const channels = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('rc', rank);
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const sourceCoords = (0, $70e72a00a69a2f93$export$8f96407d418c6727)(rank, channels);
        const innerDims = channels.slice(-2);
        const coords = rank <= 1 ? 'rc' : `vec2(${innerDims.join(',')})`;
        this.userCode = `
      void main() {
        ${dtype} rc = getOutputCoords();
        vec4 packedInput = getA(${sourceCoords});

        setOutput(getChannel(packedInput, ${coords}));
      }
    `;
    }
}



const $5f6d1dea974a8a05$var$whereImpl = (0, $543f67484857d7a4$exports).whereImpl;
const $5f6d1dea974a8a05$export$76e53a66c52b6d4d = 1e-7;
const $5f6d1dea974a8a05$export$49716d145771e6a2 = 1e-4;
const $5f6d1dea974a8a05$var$binaryCaches = {};
function $5f6d1dea974a8a05$export$5863a14c5c829662(webGLVersion) {
    if (webGLVersion in $5f6d1dea974a8a05$var$binaryCaches) return $5f6d1dea974a8a05$var$binaryCaches[webGLVersion];
    $5f6d1dea974a8a05$var$binaryCaches[webGLVersion] = {};
    return $5f6d1dea974a8a05$var$binaryCaches[webGLVersion];
}
// Empirically determined constant used to determine size threshold for handing
// off execution to the CPU.
const $5f6d1dea974a8a05$var$CPU_HANDOFF_SIZE_THRESHOLD = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('CPU_HANDOFF_SIZE_THRESHOLD');
// Empirically determined constant used to decide the number of MB on GPU
// before we warn about high memory use. The MB are this constant * screen area
// * dpi / 1024 / 1024.
const $5f6d1dea974a8a05$var$BEFORE_PAGING_CONSTANT = 600;
function $5f6d1dea974a8a05$var$numMBBeforeWarning() {
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().global.screen == null) return 1024; // 1 GB.
    return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().global.screen.height * (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().global.screen.width * window.devicePixelRatio * $5f6d1dea974a8a05$var$BEFORE_PAGING_CONSTANT / 1024 / 1024;
}
class $5f6d1dea974a8a05$export$33567d88bc7c6249 extends (0, $0f11f47888a734c2$export$543916c62202b50a) {
    nextDataId() {
        return $5f6d1dea974a8a05$export$33567d88bc7c6249.nextDataId++;
    }
    constructor(gpuResource){
        super();
        // Maps data ids that have a pending read operation, to list of subscribers.
        this.pendingRead = new WeakMap();
        // List of data ids that are scheduled for disposal, but are waiting on a
        // pending read operation.
        this.pendingDisposal = new WeakSet();
        // Used to count the number of 'shallow' sliced tensors that point to the
        // same data id.
        this.dataRefCount = new WeakMap();
        this.numBytesInGPU = 0;
        // Accumulated time spent (including blocking) in uploading data to webgl.
        this.uploadWaitMs = 0;
        // Accumulated time spent (including blocking in downloading data from webgl.
        this.downloadWaitMs = 0;
        // record the last manual GL Flush time.
        this.lastGlFlushTime = 0;
        this.warnedAboutMemory = false;
        this.pendingDeletes = 0;
        this.disposed = false;
        if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('HAS_WEBGL')) throw new Error('WebGL is not supported on this device');
        let newGPGPU;
        if (gpuResource != null) {
            if (gpuResource instanceof (0, $1f82cab824353cd6$export$fa7a74a0ce382ac5)) newGPGPU = gpuResource;
            else {
                const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION'), gpuResource);
                newGPGPU = new (0, $1f82cab824353cd6$export$fa7a74a0ce382ac5)(gl);
            }
            this.binaryCache = {};
            this.gpgpuCreatedLocally = false;
        } else {
            const gl = (0, $2cb790622144e5be$export$c7a808a518b9a146)((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION'));
            newGPGPU = new (0, $1f82cab824353cd6$export$fa7a74a0ce382ac5)(gl);
            this.binaryCache = $5f6d1dea974a8a05$export$5863a14c5c829662((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION'));
            this.gpgpuCreatedLocally = true;
        }
        this.gpgpu = newGPGPU;
        this.canvas = this.gpgpu.gl.canvas;
        this.textureManager = new (0, $bd9d1760febc3e15$export$337f59f8fd79d24f)(this.gpgpu);
        this.numMBBeforeWarning = $5f6d1dea974a8a05$var$numMBBeforeWarning();
        this.texData = new (0, $0f11f47888a734c2$export$e95767ffe2e60cec)(this, (0, $8a461ef06e070cc9$export$d3c662a6136faebb)());
    }
    numDataIds() {
        return this.texData.numDataIds() - this.pendingDeletes;
    }
    // Writes a new entry to the data store with a WebGL texture, and registers it
    // to the texture manager.
    writeTexture(texture, shape, dtype, texHeight, texWidth, channels) {
        // Temporarily create an tensor info to make the texture compatible with
        // the runWebGLProgram's input.
        const input = this.makeTensorInfo(shape, dtype);
        const inData = this.texData.get(input.dataId);
        // Even though the input texture could be unpacked or dense packed, it is
        // always considered as unpacked for EncodeMatrixProgram.
        inData.isPacked = false;
        // Bind texture to the input tensor.
        inData.texture = {
            texture: texture,
            texShape: [
                texHeight,
                texWidth
            ]
        };
        inData.texShape = [
            texHeight,
            texWidth
        ];
        const shapeAs3D = $f6f0bdab98aa0468$export$f944c0101b593a79(shape);
        const program = new (0, $eb7de15916d0d681$export$b2e063313033aeab)(shapeAs3D, false, channels);
        const output = this.runWebGLProgram(program, [
            input
        ], dtype, [
            [
                texHeight,
                texWidth
            ]
        ]);
        output.shape = shape;
        // Unbind the texture from the input tensor to avoid the texture being
        // released.
        inData.texture = null;
        this.disposeIntermediateTensorInfo(input);
        return output.dataId;
    }
    write(values, shape, dtype) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_CHECK_NUMERICAL_PROBLEMS') || (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64' && values != null) throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        const dataId = {
            id: this.nextDataId()
        };
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).UPLOAD,
            refCount: 1
        });
        return dataId;
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.texData.has(dataId)) {
            const tensorData = this.texData.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TextureData`. */ incRef(dataId) {
        const texData = this.texData.get(dataId);
        texData.refCount++;
    }
    /** Decrease refCount of a `TextureData`. */ decRef(dataId) {
        if (this.texData.has(dataId)) {
            const texData = this.texData.get(dataId);
            texData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).UPLOAD,
            refCount: refCount
        });
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    readSync(dataId) {
        const texData = this.texData.get(dataId);
        const { values: values, dtype: dtype, complexTensorInfos: complexTensorInfos, slice: slice, shape: shape, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(shape, $b1c981bb7af6249a$export$c07b68c109124fe2);
            else program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(shape, $b1c981bb7af6249a$export$c07b68c109124fe2);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.readSync(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if (dtype === 'string') return values;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $0775da5e684c8c0d$exports).now();
        let result;
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            result = (0, $f35e0c1a651337db$exports).mergeRealAndImagArrays(realValues, imagValues);
        } else result = this.getValuesFromTexture(dataId);
        if (shouldTimeProgram) this.downloadWaitMs += (0, $0775da5e684c8c0d$exports).now() - start;
        return this.convertAndCacheOnCPU(dataId, result);
    }
    async read(dataId) {
        if (this.pendingRead.has(dataId)) {
            const subscribers = this.pendingRead.get(dataId);
            return new Promise((resolve)=>subscribers.push(resolve));
        }
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, complexTensorInfos: complexTensorInfos, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(shape, $b1c981bb7af6249a$export$c07b68c109124fe2);
            else program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(shape, $b1c981bb7af6249a$export$c07b68c109124fe2);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.read(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) {
            // getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') caused a blocking GPU call.
            // For performance reason, only check it for debugging. In production,
            // it doesn't handle this use case anyway, so behavior is not changed.
            if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2) throw new Error(`tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and ` + `WEBGL_VERSION=2 not yet supported.`);
        }
        let buffer = null;
        let tmpDownloadTarget;
        if (dtype !== 'complex64' && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGL_BUFFER_SUPPORTED')) {
            // Possibly copy the texture into a buffer before inserting a fence.
            tmpDownloadTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpDownloadTarget.dataId);
            buffer = this.gpgpu.createBufferFromTexture(tmpData.texture.texture, ...$44ae700445690738$export$2cc7cc972aa2533d(shape));
        }
        this.pendingRead.set(dataId, []);
        if (dtype !== 'complex64') // Create a fence and wait for it to resolve.
        await this.gpgpu.createAndWaitForFence();
        // Download the values from the GPU.
        let vals;
        if (dtype === 'complex64') {
            const ps = await Promise.all([
                this.read(complexTensorInfos.real.dataId),
                this.read(complexTensorInfos.imag.dataId)
            ]);
            const realValues = ps[0];
            const imagValues = ps[1];
            vals = (0, $f35e0c1a651337db$exports).mergeRealAndImagArrays(realValues, imagValues);
        } else if (buffer == null) vals = this.getValuesFromTexture(dataId);
        else {
            const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(shape);
            vals = this.gpgpu.downloadFloat32MatrixFromBuffer(buffer, size);
        }
        if (tmpDownloadTarget != null) this.disposeIntermediateTensorInfo(tmpDownloadTarget);
        if (buffer != null) {
            const gl = this.gpgpu.gl;
            $f6f0bdab98aa0468$export$7642ac97981532b8(gl, ()=>gl.deleteBuffer(buffer));
        }
        const dTypeVals = this.convertAndCacheOnCPU(dataId, vals);
        const subscribers = this.pendingRead.get(dataId);
        this.pendingRead.delete(dataId);
        // Notify all pending reads.
        subscribers.forEach((resolve)=>resolve(dTypeVals));
        if (this.pendingDisposal.has(dataId)) {
            this.pendingDisposal.delete(dataId);
            if (this.disposeData(dataId)) (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().removeDataId(dataId, this);
            this.pendingDeletes--;
        }
        return dTypeVals;
    }
    /**
     * Read tensor to a new texture that is densely packed for ease of use.
     * @param dataId The source tensor.
     * @param options
     *     customTexShape: Optional. If set, will use the user defined texture
     *     shape to create the texture.
     */ readToGPU(dataId, options = {}) {
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, isPacked: isPacked, texture: texture } = texData;
        if (dtype === 'complex64') throw new Error('Does not support reading texture for complex64 dtype.');
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(shape, $b1c981bb7af6249a$export$c07b68c109124fe2);
            else program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(shape, $b1c981bb7af6249a$export$c07b68c109124fe2);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const gpuResouorce = this.readToGPU(res, options);
            this.disposeIntermediateTensorInfo(res);
            return gpuResouorce;
        }
        if (texture == null) {
            if (values != null) throw new Error('Data is not on GPU but on CPU.');
            else throw new Error('There is no data on GPU or CPU.');
        }
        // Decode the texture so that it is stored densely (using four channels).
        const tmpTarget = this.decode(dataId, options.customTexShape);
        // Make engine track this tensor, so that we can dispose it later.
        const tensorRef = (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(tmpTarget);
        const tmpData = this.texData.get(tmpTarget.dataId);
        return Object.assign({
            tensorRef: tensorRef
        }, tmpData.texture);
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $0775da5e684c8c0d$exports).decodeString(d));
            return (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(t.shape, t.dtype, data);
    }
    checkNumericalProblems(values) {
        if (values == null) return;
        for(let i = 0; i < values.length; i++){
            const num = values[i];
            if (!$f6f0bdab98aa0468$export$829768a5b7625879(num)) {
                if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_RENDER_FLOAT32_CAPABLE')) throw Error(`The value ${num} cannot be represented with your ` + `current settings. Consider enabling float32 rendering: ` + `'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`);
                throw Error(`The value ${num} cannot be represented on this device.`);
            }
        }
    }
    getValuesFromTexture(dataId) {
        const { shape: shape, dtype: dtype, isPacked: isPacked } = this.texData.get(dataId);
        const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(shape);
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED')) {
            const tmpTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpTarget.dataId);
            const vals = this.gpgpu.downloadMatrixFromPackedTexture(tmpData.texture.texture, ...$44ae700445690738$export$2cc7cc972aa2533d(shape)).subarray(0, size);
            this.disposeIntermediateTensorInfo(tmpTarget);
            return vals;
        }
        const shouldUsePackedProgram = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK') && isPacked === true;
        const outputShape = shouldUsePackedProgram ? $f6f0bdab98aa0468$export$f944c0101b593a79(shape) : shape;
        const program = shouldUsePackedProgram ? new (0, $b882b25be7b10b8f$export$97e262e8a4818e2e)(outputShape) : new (0, $58395748eceebc7d$export$dae4f112167b5aac)(outputShape);
        const output = this.runWebGLProgram(program, [
            {
                shape: outputShape,
                dtype: dtype,
                dataId: dataId
            }
        ], 'float32');
        const tmpData = this.texData.get(output.dataId);
        const vals = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(tmpData.texture.texture, tmpData.texShape[0], tmpData.texShape[1]).subarray(0, size);
        this.disposeIntermediateTensorInfo(output);
        return vals;
    }
    timerAvailable() {
        return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0;
    }
    time(f) {
        const oldActiveTimers = this.activeTimers;
        const newActiveTimers = [];
        let outerMostTime = false;
        if (this.programTimersStack == null) {
            this.programTimersStack = newActiveTimers;
            outerMostTime = true;
        } else this.activeTimers.push(newActiveTimers);
        this.activeTimers = newActiveTimers;
        f();
        // needing to split these up because util.flatten only accepts certain types
        const flattenedActiveTimerQueries = (0, $0775da5e684c8c0d$exports).flatten(this.activeTimers.map((d)=>d.query)).filter((d)=>d != null);
        const flattenedActiveTimerNames = (0, $0775da5e684c8c0d$exports).flatten(this.activeTimers.map((d)=>d.name)).filter((d)=>d != null);
        this.activeTimers = oldActiveTimers;
        if (outerMostTime) this.programTimersStack = null;
        const res = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null // will be filled by the engine
        };
        return (async ()=>{
            if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
                const kernelMs = await Promise.all(flattenedActiveTimerQueries);
                res['kernelMs'] = (0, $0775da5e684c8c0d$exports).sum(kernelMs);
                res['getExtraProfileInfo'] = ()=>kernelMs.map((d, i)=>({
                            name: flattenedActiveTimerNames[i],
                            ms: d
                        })).map((d)=>`${d.name}: ${d.ms}`).join(', ');
            } else res['kernelMs'] = {
                error: 'WebGL query timers are not supported in this environment.'
            };
            this.uploadWaitMs = 0;
            this.downloadWaitMs = 0;
            return res;
        })();
    }
    memory() {
        return {
            unreliable: false,
            numBytesInGPU: this.numBytesInGPU,
            numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
            numBytesInGPUFree: this.textureManager.numBytesFree
        };
    }
    startTimer() {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.beginQuery();
        return {
            startMs: (0, $0775da5e684c8c0d$exports).now(),
            endMs: null
        };
    }
    endTimer(query) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
            this.gpgpu.endQuery();
            return query;
        }
        query.endMs = (0, $0775da5e684c8c0d$exports).now();
        return query;
    }
    async getQueryTime(query) {
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.waitForQueryAndGetTime(query);
        const timerQuery = query;
        return timerQuery.endMs - timerQuery.startMs;
    }
    /**
     * Decrease the RefCount on the dataId and dispose the memory if the dataId
     * has 0 refCount. If there are pending read on the data, the disposal would
     * added to the pending delete queue. Return true if the dataId is removed
     * from backend or the backend does not contain the dataId, false if the
     * dataId is not removed. Memory may or may not be released even when dataId
     * is removed, which also depends on dataRefCount, see `releaseGPU`.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.pendingDisposal.has(dataId)) return false;
        // No-op if already disposed.
        if (!this.texData.has(dataId)) return true;
        // if force flag is set, change refCount to 0, this would ensure disposal
        // when added to the pendingDisposal queue. Memory may or may not be
        // released, which also depends on dataRefCount, see `releaseGPU`.
        if (force) this.texData.get(dataId).refCount = 0;
        else this.texData.get(dataId).refCount--;
        if (!force && this.texData.get(dataId).refCount > 0) return false;
        if (this.pendingRead.has(dataId)) {
            this.pendingDisposal.add(dataId);
            this.pendingDeletes++;
            return false;
        }
        this.releaseGPUData(dataId);
        const { complexTensorInfos: complexTensorInfos } = this.texData.get(dataId);
        if (complexTensorInfos != null) {
            this.disposeData(complexTensorInfos.real.dataId, force);
            this.disposeData(complexTensorInfos.imag.dataId, force);
        }
        this.texData.delete(dataId);
        return true;
    }
    releaseGPUData(dataId) {
        const { texture: texture, dtype: dtype, texShape: texShape, usage: usage, isPacked: isPacked, slice: slice } = this.texData.get(dataId);
        const key = slice && slice.origDataId || dataId;
        const refCount = this.dataRefCount.get(key);
        if (refCount > 1) this.dataRefCount.set(key, refCount - 1);
        else {
            this.dataRefCount.delete(key);
            if (texture != null) {
                this.numBytesInGPU -= this.computeBytes(texShape, dtype);
                this.textureManager.releaseTexture(texture, texShape, usage, isPacked);
            }
        }
        const texData = this.texData.get(dataId);
        texData.texture = null;
        texData.texShape = null;
        texData.isPacked = false;
        texData.slice = null;
    }
    getTexture(dataId) {
        this.uploadToGPU(dataId);
        return this.texData.get(dataId).texture.texture;
    }
    /**
     * Returns internal information for the specific data bucket. Used in unit
     * tests.
     */ getDataInfo(dataId) {
        return this.texData.get(dataId);
    }
    /*
    Tests whether all the inputs to an op are small and on the CPU. This heuristic
    determines when it would be faster to execute a kernel on the CPU. WebGL
    kernels opt into running this check and forwarding when appropriate.
    TODO(https://github.com/tensorflow/tfjs/issues/872): Develop a more
    sustainable strategy for optimizing backend execution of ops.
     */ shouldExecuteOnCPU(inputs, sizeThreshold = $5f6d1dea974a8a05$var$CPU_HANDOFF_SIZE_THRESHOLD) {
        return (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_CPU_FORWARD') && inputs.every((input)=>this.texData.get(input.dataId).texture == null && (0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape) < sizeThreshold);
    }
    getGPGPUContext() {
        return this.gpgpu;
    }
    where(condition) {
        (0, $f35e0c1a651337db$exports).warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        const condVals = condition.dataSync();
        return $5f6d1dea974a8a05$var$whereImpl(condition.shape, condVals);
    }
    packedUnaryOp(x, op, dtype) {
        const program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(x.shape, op);
        const outInfo = this.compileAndRun(program, [
            x
        ], dtype);
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(outInfo);
    }
    // TODO(msoulanille) remove this once the backend has been modularized
    // a copy is needed here to break a circular dependency.
    // Also remove the op from unary_op.
    abs(x) {
        // TODO: handle cases when x is complex.
        if (this.shouldExecuteOnCPU([
            x
        ]) && x.dtype !== 'complex64') {
            const outValues = (0, $1cec302811203101$export$d7efa3585619eabe)(this.texData.get(x.dataId).values);
            return this.makeOutput(x.shape, x.dtype, outValues);
        }
        if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) return this.packedUnaryOp(x, $b1c981bb7af6249a$export$3f020f6dcff67a1b, x.dtype);
        const program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(x.shape, $b1c981bb7af6249a$export$3f020f6dcff67a1b);
        const outInfo = this.compileAndRun(program, [
            x
        ]);
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(outInfo);
    }
    makeTensorInfo(shape, dtype, values) {
        let dataId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $0775da5e684c8c0d$exports).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $0775da5e684c8c0d$exports).encodeString(d));
            dataId = this.write(encodedValues, shape, dtype);
        } else dataId = this.write(values, shape, dtype);
        this.texData.get(dataId).usage = null;
        return {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
    }
    makeOutput(shape, dtype, values) {
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    unpackTensor(input) {
        const program = new (0, $b781fc92cb2569f3$export$c457dd67217cb5eb)(input.shape);
        return this.runWebGLProgram(program, [
            input
        ], input.dtype);
    }
    packTensor(input) {
        const program = new (0, $007ac94798e454eb$export$5ebf74a9a135ce1d)(input.shape);
        const preventEagerUnpackingOutput = true;
        return this.runWebGLProgram(program, [
            input
        ], input.dtype, null, preventEagerUnpackingOutput);
    }
    packedReshape(input, afterShape) {
        const input3DShape = [
            $f6f0bdab98aa0468$export$4dfd7bc0667970e0(input.shape),
            ...$f6f0bdab98aa0468$export$e8f6c350b57b8270(input.shape)
        ];
        const input3D = {
            dtype: input.dtype,
            shape: input3DShape,
            dataId: input.dataId
        };
        const afterShapeAs3D = [
            $f6f0bdab98aa0468$export$4dfd7bc0667970e0(afterShape),
            ...$f6f0bdab98aa0468$export$e8f6c350b57b8270(afterShape)
        ];
        const program = new (0, $95376b668d58fbfd$export$ce249f6fedcc44de)(afterShapeAs3D, input3DShape);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            input3DShape
        ];
        const output = this.runWebGLProgram(program, [
            input3D
        ], input.dtype, customValues, preventEagerUnpackingOfOutput);
        return {
            dataId: output.dataId,
            shape: afterShape,
            dtype: output.dtype
        };
    }
    decode(dataId, customTexShape) {
        const texData = this.texData.get(dataId);
        const { isPacked: isPacked, shape: shape, dtype: dtype } = texData;
        if (customTexShape != null) {
            const size = (0, $0775da5e684c8c0d$exports).sizeFromShape(shape);
            const texSize = customTexShape[0] * customTexShape[1] * 4;
            (0, $0775da5e684c8c0d$exports).assert(size <= texSize, ()=>"customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data.");
        }
        const shapeAs3D = $f6f0bdab98aa0468$export$f944c0101b593a79(shape);
        let program;
        if (isPacked) program = new (0, $361b8415b15aa7b6$export$4434db41c70879cb)(shapeAs3D);
        else program = new (0, $a2284d5d00873bfd$export$f6ee51c6efbee026)(shapeAs3D);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            customTexShape != null ? customTexShape : $44ae700445690738$export$2cc7cc972aa2533d(shapeAs3D)
        ];
        const out = this.runWebGLProgram(program, [
            {
                shape: shapeAs3D,
                dtype: dtype,
                dataId: dataId
            }
        ], dtype, customValues, preventEagerUnpackingOfOutput, customTexShape);
        return {
            dtype: dtype,
            shape: shape,
            dataId: out.dataId
        };
    }
    runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false, customTexShape) {
        const output = this.makeTensorInfo(program.outputShape, outputDtype);
        const outData = this.texData.get(output.dataId);
        if (program.packedOutput) outData.isPacked = true;
        if (program.outPackingScheme === $44ae700445690738$export$81d5c79efa1086f2.DENSE) {
            const texelShape = customTexShape != null ? customTexShape : $44ae700445690738$export$2cc7cc972aa2533d(program.outputShape);
            // For a densely packed output, we explicitly set texShape
            // so it doesn't get assigned later according to our typical packing
            // scheme wherein a single texel can only contain values from adjacent
            // rows/cols.
            outData.texShape = texelShape.map((d)=>d * 2);
        }
        if (program.outTexUsage != null) outData.usage = program.outTexUsage;
        if ((0, $0775da5e684c8c0d$exports).sizeFromShape(output.shape) === 0) {
            // Short-circuit the computation since the result is empty (has 0 in its
            // shape).
            outData.values = (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType(output.dtype, 0);
            return output;
        }
        const dataToDispose = [];
        const inputsData = inputs.map((input)=>{
            if (input.dtype === 'complex64') throw new Error(`GPGPUProgram does not support complex64 input. For complex64 ` + `dtypes, please separate the program into real and imaginary ` + `parts.`);
            let texData = this.texData.get(input.dataId);
            if (texData.texture == null) {
                if (!program.packedInputs && (0, $0775da5e684c8c0d$exports).sizeFromShape(input.shape) <= (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_SIZE_UPLOAD_UNIFORM')) // Upload small tensors that live on the CPU as uniforms, not as
                // textures. Do this only when the environment supports 32bit floats
                // due to problems when comparing 16bit floats with 32bit floats.
                // TODO(https://github.com/tensorflow/tfjs/issues/821): Make it
                // possible for packed shaders to sample from uniforms.
                return {
                    shape: input.shape,
                    texData: null,
                    isUniform: true,
                    uniformValues: texData.values
                };
                // This ensures that if a packed program's inputs have not yet been
                // uploaded to the GPU, they get uploaded as packed right off the bat.
                if (program.packedInputs) {
                    texData.isPacked = true;
                    texData.shape = input.shape;
                }
            }
            this.uploadToGPU(input.dataId);
            if (!!texData.isPacked !== !!program.packedInputs) {
                input = texData.isPacked ? this.unpackTensor(input) : this.packTensor(input);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
            } else if (texData.isPacked && !$f6f0bdab98aa0468$export$951b388203a0422d(texData.shape, input.shape)) {
                // This is a special case where a texture exists for a tensor
                // but the shapes are incompatible (due to packing constraints) because
                // the tensor did not have a chance to go through the packed reshape
                // shader. This only happens when we reshape the *same* tensor to form
                // *distinct* inputs to an op, e.g. dotting a vector with itself. This
                // case will disappear once packed uploading is the default.
                const savedInput = input;
                const targetShape = input.shape;
                input.shape = texData.shape;
                input = this.packedReshape(input, targetShape);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
                savedInput.shape = targetShape;
            }
            return {
                shape: input.shape,
                texData: texData,
                isUniform: false
            };
        });
        this.uploadToGPU(output.dataId);
        const outputData = {
            shape: output.shape,
            texData: outData,
            isUniform: false
        };
        const key = $ea5724662c9cdeb8$export$2a17a6d53fe6f5d9(program, inputsData, outputData);
        const binary = this.getAndSaveBinary(key, ()=>{
            return $ea5724662c9cdeb8$export$5ca2cb6073dd12df(this.gpgpu, program, inputsData, outputData);
        });
        const shouldTimeProgram = this.activeTimers != null;
        let query;
        if (shouldTimeProgram) query = this.startTimer();
        if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('ENGINE_COMPILE_ONLY')) $ea5724662c9cdeb8$export$4e01d2c5eea12ae3(this.gpgpu, binary, inputsData, outputData, customUniformValues);
        dataToDispose.forEach((info)=>this.disposeIntermediateTensorInfo(info));
        if (shouldTimeProgram) {
            query = this.endTimer(query);
            this.activeTimers.push({
                name: program.constructor.name,
                query: this.getQueryTime(query)
            });
        }
        const glFlushThreshold = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_FLUSH_THRESHOLD');
        // Manually GL flush requested
        if (glFlushThreshold > 0) {
            const time = (0, $0775da5e684c8c0d$exports).now();
            if (time - this.lastGlFlushTime > glFlushThreshold) {
                this.gpgpu.gl.flush();
                this.lastGlFlushTime = time;
            }
        }
        if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_LAZILY_UNPACK') && outData.isPacked && preventEagerUnpackingOfOutput === false) {
            const unpacked = this.unpackTensor(output);
            this.disposeIntermediateTensorInfo(output);
            return unpacked;
        }
        return output;
    }
    compileAndRun(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false) {
        outputDtype = outputDtype || inputs[0].dtype;
        const outInfo = this.runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput);
        return outInfo;
    }
    getAndSaveBinary(key, getBinary) {
        if (!(key in this.binaryCache)) this.binaryCache[key] = getBinary();
        return this.binaryCache[key];
    }
    getTextureManager() {
        return this.textureManager;
    }
    dispose() {
        if (this.disposed) return;
        // Avoid disposing the compiled webgl programs during unit testing because
        // it slows down test execution.
        if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('IS_TEST')) {
            const allKeys = Object.keys(this.binaryCache);
            allKeys.forEach((key)=>{
                this.gpgpu.deleteProgram(this.binaryCache[key].webGLProgram);
                delete this.binaryCache[key];
            });
        }
        this.textureManager.dispose();
        if (this.canvas != null && typeof HTMLCanvasElement !== 'undefined' && this.canvas instanceof HTMLCanvasElement) this.canvas.remove();
        else this.canvas = null;
        if (this.gpgpuCreatedLocally) {
            this.gpgpu.program = null;
            this.gpgpu.dispose();
        }
        this.disposed = true;
    }
    floatPrecision() {
        if (this.floatPrecisionValue == null) this.floatPrecisionValue = (0, $8a461ef06e070cc9$export$b841c6a213a653eb)(()=>{
            if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('WEBGL_RENDER_FLOAT32_ENABLED')) {
                // Momentarily switching DEBUG flag to false so we don't throw an
                // error trying to upload a small value.
                const debugFlag = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('DEBUG');
                (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set('DEBUG', false);
                const underflowCheckValue = this.abs((0, $8cc53f9f8ebe4938$export$7de3fcd3cdba2a46)(1e-8)).dataSync()[0];
                (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set('DEBUG', debugFlag);
                if (underflowCheckValue > 0) return 32;
            }
            return 16;
        });
        return this.floatPrecisionValue;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $5f6d1dea974a8a05$export$76e53a66c52b6d4d : $5f6d1dea974a8a05$export$49716d145771e6a2;
    }
    uploadToGPU(dataId) {
        const texData = this.texData.get(dataId);
        const { shape: shape, dtype: dtype, values: values, texture: texture, usage: usage, isPacked: isPacked } = texData;
        if (texture != null) // Array is already on GPU. No-op.
        return;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $0775da5e684c8c0d$exports).now();
        let texShape = texData.texShape;
        if (texShape == null) {
            // This texShape may not be the final texture shape. For packed or dense
            // textures, the texShape will be changed when textures are created.
            texShape = $f6f0bdab98aa0468$export$80bf57c6927be1d9(shape, isPacked);
            texData.texShape = texShape;
        }
        if (values != null) {
            const shapeAs3D = $f6f0bdab98aa0468$export$f944c0101b593a79(shape);
            let program;
            let width = texShape[1], height = texShape[0];
            const isByteArray = values instanceof Uint8Array || values instanceof Uint8ClampedArray;
            // texture for float array is PhysicalTextureType.PACKED_2X2_FLOAT32, we
            // need to make sure the upload uses the same packed size
            if (isPacked || !isByteArray) [width, height] = $44ae700445690738$export$2754e02fa98f5582(texShape[0], texShape[1]);
            if (isPacked) program = new (0, $01a0bda8aab8b30a$export$3b3e6b1f67c8c4d5)(shapeAs3D, isByteArray);
            else program = new (0, $eb7de15916d0d681$export$b2e063313033aeab)(shapeAs3D, isByteArray);
            // TexShape for float array needs to be the original shape, which byte
            // array needs to be packed size. This allow the data upload shape to be
            // matched with texture creation logic.
            const tempDenseInputTexShape = isByteArray ? [
                height,
                width
            ] : texShape;
            const tempDenseInputHandle = this.makeTensorInfo(tempDenseInputTexShape, dtype);
            const tempDenseInputTexData = this.texData.get(tempDenseInputHandle.dataId);
            if (isByteArray) tempDenseInputTexData.usage = (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).PIXELS;
            else tempDenseInputTexData.usage = (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).UPLOAD;
            tempDenseInputTexData.texShape = tempDenseInputTexShape;
            this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(tempDenseInputHandle.dataId), width, height, values);
            const customValues = [
                [
                    height,
                    width
                ]
            ];
            // We want the output to remain packed regardless of the value of
            // WEBGL_PACK.
            const preventEagerUnpacking = true;
            const encodedOutputTarget = this.runWebGLProgram(program, [
                tempDenseInputHandle
            ], dtype, customValues, preventEagerUnpacking);
            // Have the original texture assume the identity of the encoded output.
            const outputTexData = this.texData.get(encodedOutputTarget.dataId);
            texData.texShape = outputTexData.texShape;
            texData.isPacked = outputTexData.isPacked;
            texData.usage = outputTexData.usage;
            if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('ENGINE_COMPILE_ONLY')) {
                texData.texture = outputTexData.texture;
                // Once uploaded, don't store the values on cpu.
                texData.values = null;
                this.texData.delete(encodedOutputTarget.dataId);
            } else this.disposeData(encodedOutputTarget.dataId);
            this.disposeIntermediateTensorInfo(tempDenseInputHandle);
            if (shouldTimeProgram) this.uploadWaitMs += (0, $0775da5e684c8c0d$exports).now() - start;
        } else {
            const newTexture = this.acquireTexture(texShape, usage, dtype, isPacked);
            texData.texture = newTexture;
        }
    }
    convertAndCacheOnCPU(dataId, float32Values) {
        const texData = this.texData.get(dataId);
        const { dtype: dtype } = texData;
        if (float32Values != null) texData.values = $5f6d1dea974a8a05$var$float32ToTypedArray(float32Values, dtype);
        return texData.values;
    }
    acquireTexture(texShape, texType, dtype, isPacked) {
        this.numBytesInGPU += this.computeBytes(texShape, dtype);
        if (!this.warnedAboutMemory && this.numBytesInGPU > this.numMBBeforeWarning * 1048576) {
            const mb = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
            this.warnedAboutMemory = true;
            console.warn(`High memory usage in GPU: ${mb} MB, ` + `most likely due to a memory leak`);
        }
        return this.textureManager.acquireTexture(texShape, texType, isPacked);
    }
    computeBytes(shape, dtype) {
        return shape[0] * shape[1] * (0, $0775da5e684c8c0d$exports).bytesPerElement(dtype);
    }
    checkCompileCompletion() {
        for (const [, binary] of Object.entries(this.binaryCache))this.checkCompletion_(binary);
    }
    async checkCompileCompletionAsync() {
        const ps = [];
        if (this.gpgpu.parallelCompilationExtension) {
            for (const [, binary] of Object.entries(this.binaryCache))ps.push(this.checkCompletionAsync_(binary));
            return Promise.all(ps);
        } else {
            for (const [, binary] of Object.entries(this.binaryCache)){
                const p = new Promise((resolve)=>{
                    try {
                        this.checkCompletion_(binary);
                        resolve(true);
                    } catch (error) {
                        throw error;
                    }
                });
                ps.push(p);
            }
            return Promise.all(ps);
        }
    }
    async checkCompletionAsync_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR)) return this.checkCompletion_(binary);
        else {
            await (0, $31259e3fec6eb1a8$export$68d2d147c928d1dd)();
            return this.checkCompletionAsync_(binary);
        }
    }
    checkCompletion_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.gl.LINK_STATUS) === false) {
            console.log(this.gpgpu.gl.getProgramInfoLog(binary.webGLProgram));
            if (this.gpgpu.gl.getShaderParameter(binary.fragmentShader, this.gpgpu.gl.COMPILE_STATUS) === false) {
                $f6f0bdab98aa0468$export$f7b23987b58d218(binary.source, this.gpgpu.gl.getShaderInfoLog(binary.fragmentShader));
                throw new Error('Failed to compile fragment shader.');
            }
            throw new Error('Failed to link vertex and fragment shaders.');
        }
        return true;
    }
    getUniformLocations() {
        for (const binary of Object.values(this.binaryCache)){
            // TODO: Iterating through all binaries to build VAOs is supposed to be in
            // a seperate function, like 'setVaos'. However, to avoid breaking changes
            // for the users using parallel compile feature now, buildVao is silently
            // added here.
            this.gpgpu.buildVao(binary.webGLProgram);
            const { variablesLocations: variablesLocations, customUniformLocations: customUniformLocations, infLoc: infLoc, nanLoc: nanLoc, outShapeLocation: outShapeLocation, outShapeStridesLocation: outShapeStridesLocation, outTexShapeLocation: outTexShapeLocation } = (0, $ea5724662c9cdeb8$export$d421ceceafba9cc0)(this.gpgpu, binary.program, binary.webGLProgram);
            binary.variablesLocations = variablesLocations;
            binary.customUniformLocations = customUniformLocations;
            binary.infLoc = infLoc;
            binary.nanLoc = nanLoc;
            binary.outShapeLocation = outShapeLocation;
            binary.outShapeStridesLocation = outShapeStridesLocation;
            binary.outTexShapeLocation = outTexShapeLocation;
        }
    }
    /**
     * Create a TF.js tensor out of an existing WebGL texture. A new texture will
     * be created.
     */ createTensorFromGPUData(values, shape, dtype) {
        values.channels = values.channels || 'RGBA';
        const { texture: texture, height: height, width: width, channels: channels } = values;
        const backend = (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().backend;
        // Have to throw an error, otherwise WebGL just warns and returns wrong
        // values.
        if (!backend.gpgpu.gl.isTexture(texture)) throw new Error(`The texture is invalid. Also, please make sure the texture and ` + `the TFJS WebGL backend are using the same canvas. If you want to ` + `use your own custom canvas, you have to create and use the custom ` + `TFJS WebGL backend created from the canvas through ` + `'new tf.MathBackendWebGL(customCanvas)'.`);
        const dataId = backend.writeTexture(texture, shape, dtype, height, width, channels);
        return (0, $8a461ef06e070cc9$export$d3c662a6136faebb)().makeTensorFromDataId(dataId, shape, dtype, backend);
    }
}
$5f6d1dea974a8a05$export$33567d88bc7c6249.nextDataId = 0;
function $5f6d1dea974a8a05$var$float32ToTypedArray(a, dtype) {
    if (dtype === 'float32' || dtype === 'complex64') return a;
    else if (dtype === 'int32' || dtype === 'bool') {
        const result = dtype === 'int32' ? new Int32Array(a.length) : new Uint8Array(a.length);
        for(let i = 0; i < result.length; ++i)result[i] = Math.round(a[i]);
        return result;
    } else throw new Error(`Unknown dtype ${dtype}`);
}



/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





function $16e53f70db539fde$export$3f638ed94e6c5baa() {
    (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().set('WEBGL_FORCE_F16_TEXTURES', true);
}


if ((0, $0479127e9813c50e$exports).isBrowser()) (0, $8a461ef06e070cc9$export$1ac8c3a90eff05d)('webgl', ()=>new (0, $5f6d1dea974a8a05$export$33567d88bc7c6249)(), 2 /* priority */ );
const $5273758179af7d37$export$d55298c9efc5ed14 = {
    forceHalfFloat: $16e53f70db539fde$export$3f638ed94e6c5baa
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $6e99a2fc879307b0$export$39f0cca2b63399f6 = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
const $6e99a2fc879307b0$export$1e6d79ff8c3b3c83 = 'return (a - b) * (a - b);';
class $6e99a2fc879307b0$export$9045e9161086790b {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'A',
            'B'
        ];
        this.outputShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      float binaryOperation(float a, float b) {
        ${op}
      }

      void main() {
        float a = getAAtOutCoords();
        float b = getBAtOutCoords();
        setOutput(binaryOperation(a, b));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd = `
  result.r = isNaN.r ? NAN : result.r;
  result.g = isNaN.g ? NAN : result.g;
  result.b = isNaN.b ? NAN : result.b;
  result.a = isNaN.a ? NAN : result.a;
`;
const $845a6b9d98d1f900$export$54f9164222714c69 = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $845a6b9d98d1f900$export$fd75136f014548e = `
  return vec4(notEqual(a, b));
`;
class $845a6b9d98d1f900$export$7ef3bdc75c177be0 {
    constructor(op, aShape, bShape, checkOutOfBounds = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.supportsBroadcasting = true;
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        const rank = this.outputShape.length;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(rank);
        let checkOutOfBoundsString = '';
        if (checkOutOfBounds) {
            if (rank === 0 || (0, $0775da5e684c8c0d$exports).sizeFromShape(this.outputShape) === 1) checkOutOfBoundsString = `
          result.y = 0.;
          result.z = 0.;
          result.w = 0.;
        `;
            else {
                const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
                checkOutOfBoundsString = `
          ${dtype} coords = getOutputCoords();
        `;
                if (rank === 1) {
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            result.y = (coords + 1) >= outShape ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                    else checkOutOfBoundsString += `
            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                } else {
                    const channels = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('coords', rank);
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= outShape[${rank} - 2];
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= outShape[${rank} - 1];
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                    else checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= ${this.outputShape[rank - 2]};
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= ${this.outputShape[rank - 1]};
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                }
            }
        }
        this.userCode = `
      vec4 binaryOperation(vec4 a, vec4 b) {
        ${op}
      }

      void main() {
        vec4 a = getAAtOutCoords();
        vec4 b = getBAtOutCoords();

        vec4 result = binaryOperation(a, b);
        ${checkOutOfBoundsString}

        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $4565c1320ebddb8a$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $4565c1320ebddb8a$export$c426d3942537ad84 = {
    kernelName: (0, $507890e4aa8e1463$export$544bf02140fa9a77),
    backendName: 'webgl',
    kernelFunc: $4565c1320ebddb8a$export$f0954fd7d5368655
};


function $a1426942a1186ebb$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.texData.get(complexInfo.dataId);
    const realTensorInfo = (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: real
        },
        backend: backend
    });
    const imagTensorInfo = (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: imag
        },
        backend: backend
    });
    complex.complexTensorInfos = {
        real: realTensorInfo,
        imag: imagTensorInfo
    };
    return complexInfo;
}
const $a1426942a1186ebb$export$67917f7910d27fd8 = {
    kernelName: (0, $507890e4aa8e1463$export$50ceb3fb9926e63e),
    backendName: 'webgl',
    kernelFunc: $a1426942a1186ebb$export$83a0e34f1302825b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $61a07a9369feffc0$export$92ed4431d8daa517 = `return (a < 0.) ? b * a : a;`;
const $61a07a9369feffc0$export$e86410c26dcc9bb1 = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $61a07a9369feffc0$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    const $alpha = backend.makeTensorInfo([], 'float32', (0, $0775da5e684c8c0d$exports).createScalarValue(alpha, 'float32'));
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $845a6b9d98d1f900$export$7ef3bdc75c177be0)($61a07a9369feffc0$export$e86410c26dcc9bb1, x.shape, $alpha.shape) : new (0, $6e99a2fc879307b0$export$9045e9161086790b)($61a07a9369feffc0$export$92ed4431d8daa517, x.shape, $alpha.shape);
    const result = backend.runWebGLProgram(program, [
        x,
        $alpha
    ], 'float32');
    backend.disposeIntermediateTensorInfo($alpha);
    return result;
}
const $61a07a9369feffc0$export$aa04ab963fdf437f = {
    kernelName: (0, $507890e4aa8e1463$export$f0c7162bb7af1a2d),
    backendName: 'webgl',
    kernelFunc: $61a07a9369feffc0$export$23a860e40a2c6b61
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $23ae834e36b40056$export$97f8593018a4b737 = `return (a < 0.) ? b * a : a;`;
const $23ae834e36b40056$export$4cc182bd80c9848a = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $23ae834e36b40056$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $845a6b9d98d1f900$export$7ef3bdc75c177be0)($23ae834e36b40056$export$4cc182bd80c9848a, x.shape, alpha.shape) : new (0, $6e99a2fc879307b0$export$9045e9161086790b)($23ae834e36b40056$export$97f8593018a4b737, x.shape, alpha.shape);
    return backend.runWebGLProgram(program, [
        x,
        alpha
    ], 'float32');
}
const $23ae834e36b40056$export$a5c4a9b694579636 = {
    kernelName: (0, $507890e4aa8e1463$export$a42f35f308fc2fa3),
    backendName: 'webgl',
    kernelFunc: $23ae834e36b40056$export$5882f235222e6729
};




const $d770bb96fbeee88f$export$bf39b1cb254b6187 = `if (isnan(x)) return x;`;
function $d770bb96fbeee88f$export$ba4daf5748026fba({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webglBackend = backend;
        const $dtype = dtype || x.dtype;
        if (webglBackend.shouldExecuteOnCPU([
            x
        ]) && cpuKernelImpl != null) {
            const xData = webglBackend.texData.get(x.dataId);
            const outValues = cpuKernelImpl(xData.values, $dtype);
            return webglBackend.makeTensorInfo(x.shape, $dtype, outValues);
        }
        const shouldUsePackedProgram = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_UNARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(x.shape, packedOpSnippet);
        else program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(x.shape, opSnippet);
        return webglBackend.runWebGLProgram(program, [
            x
        ], $dtype);
    };
}
function $d770bb96fbeee88f$export$29353c66e70e3e16({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, checkOutOfBounds: checkOutOfBounds = false, supportsComplex: supportsComplex = false, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const webglBackend = backend;
        if (supportsComplex && a.dtype === 'complex64') {
            const aData = webglBackend.texData.get(a.dataId);
            const bData = webglBackend.texData.get(b.dataId);
            const [real, imag] = [
                [
                    aData.complexTensorInfos.real,
                    bData.complexTensorInfos.real
                ],
                [
                    aData.complexTensorInfos.imag,
                    bData.complexTensorInfos.imag
                ]
            ].map((complexParts)=>{
                const [aPart, bPart] = complexParts;
                const aHandle = {
                    dataId: aPart.dataId,
                    dtype: aPart.dtype,
                    shape: a.shape
                };
                const bHandle = {
                    dataId: bPart.dataId,
                    dtype: bPart.dtype,
                    shape: b.shape
                };
                const program = new (0, $6e99a2fc879307b0$export$9045e9161086790b)(opSnippet, a.shape, b.shape);
                return webglBackend.runWebGLProgram(program, [
                    aHandle,
                    bHandle
                ], (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(aPart.dtype, bPart.dtype));
            });
            const complexOutput = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
                inputs: {
                    real: real,
                    imag: imag
                },
                backend: webglBackend
            });
            webglBackend.disposeIntermediateTensorInfo(real);
            webglBackend.disposeIntermediateTensorInfo(imag);
            // TODO(annxingyuan): Implement CPU forwarding for complex inputs.
            return complexOutput;
        }
        const $dtype = dtype || (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(a.dtype, b.dtype);
        if ((a.dtype === 'string' || b.dtype === 'string' || webglBackend.shouldExecuteOnCPU([
            a,
            b
        ])) && cpuKernelImpl != null) {
            const aVals = webglBackend.texData.get(a.dataId).values;
            const bVals = webglBackend.texData.get(b.dataId).values;
            const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(aVals) : aVals;
            const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $f35e0c1a651337db$exports).fromUint8ToStringArray(bVals) : bVals;
            const [outValues, outShape] = cpuKernelImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
            const out = webglBackend.makeTensorInfo(outShape, $dtype);
            const outData = webglBackend.texData.get(out.dataId);
            outData.values = outValues;
            return out;
        }
        const shouldUsePackedProgram = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_BINARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $845a6b9d98d1f900$export$7ef3bdc75c177be0)(packedOpSnippet, a.shape, b.shape, checkOutOfBounds);
        else program = new (0, $6e99a2fc879307b0$export$9045e9161086790b)(opSnippet, a.shape, b.shape);
        return webglBackend.runWebGLProgram(program, [
            a,
            b
        ], $dtype);
    };
}
function $d770bb96fbeee88f$export$445d43a4039ec7b7(activation, packed = false) {
    if (activation === 'linear') {
        if (packed) return $262948717bc1c671$export$8244104593af74a6;
        return $b1c981bb7af6249a$export$8244104593af74a6;
    } else if (activation === 'relu') {
        if (packed) return $262948717bc1c671$export$27041fe53e1ee6da;
        return $b1c981bb7af6249a$export$27041fe53e1ee6da;
    } else if (activation === 'elu') {
        if (packed) return $262948717bc1c671$export$945a5ccf96adb3b2;
        return $b1c981bb7af6249a$export$945a5ccf96adb3b2;
    } else if (activation === 'relu6') {
        if (packed) return $262948717bc1c671$export$94bf29e9c85fc840;
        return $b1c981bb7af6249a$export$94bf29e9c85fc840;
    } else if (activation === 'prelu') {
        if (packed) return 0, $23ae834e36b40056$export$4cc182bd80c9848a;
        return 0, $23ae834e36b40056$export$97f8593018a4b737;
    } else if (activation === 'leakyrelu') {
        if (packed) return 0, $61a07a9369feffc0$export$e86410c26dcc9bb1;
        return 0, $61a07a9369feffc0$export$92ed4431d8daa517;
    } else if (activation === 'sigmoid') {
        if (packed) return $262948717bc1c671$export$f95dbffd98d0457a;
        return $b1c981bb7af6249a$export$f95dbffd98d0457a;
    }
    throw new Error(`Activation ${activation} has not been implemented for the WebGL backend.`);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $147ea655f4b931fe$export$21e5f112101779d8 {
    constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, addBias = false, activation = null, hasPreluActivation = false, hasLeakyreluActivation = false){
        this.variableNames = [
            'matrixA',
            'matrixB'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const sharedDim = transposeA ? aShape[1] : aShape[2];
        const sharedDimensionPacked = Math.ceil(sharedDim / 2);
        const aSample = transposeA ? 'i * 2, rc.y' : 'rc.y, i * 2';
        const bSample = transposeB ? 'rc.z, i * 2' : 'i * 2, rc.z';
        const aSwizzle = transposeA ? [
            'a.xxyy',
            'a.zzww'
        ] : [
            'a.xxzz',
            'a.yyww'
        ];
        const bSwizzle = transposeB ? [
            'b.xzxz',
            'b.ywyw'
        ] : [
            'b.xyxy',
            'b.zwzw'
        ];
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluActivation) this.variableNames.push('leakyreluAlpha');
        let batchASnippet = 'rc.x';
        let batchBSnippet = 'rc.x';
        if (aShape[0] < bShape[0]) batchASnippet = `imod(rc.x, ${aShape[0]})`;
        else if (bShape[0] < aShape[0]) batchBSnippet = `imod(rc.x, ${bShape[0]})`;
        this.userCode = `
      ${activationSnippet}
      // Don't use uniform for sharedDimensionPacked for performance.
      const float sharedDimension = ${sharedDimensionPacked}.0;

      vec4 dot2x2ARowBCol(ivec3 rc) {
        vec4 result = vec4(0);
        int batchA = ${batchASnippet};
        int batchB = ${batchBSnippet};
        for (int i = 0; i < ${sharedDimensionPacked}; i++) {
          vec4 a = getMatrixA(batchA, ${aSample});
          vec4 b = getMatrixB(batchB, ${bSample});

          // These swizzled products need to be separately added.
          // See: https://github.com/tensorflow/tfjs/issues/1735
          result += (${aSwizzle[0]} * ${bSwizzle[0]});
          result += (${aSwizzle[1]} * ${bSwizzle[1]});
        }
        return result;
      }

      void main() {
        ivec3 rc = getOutputCoords();
        vec4 result = dot2x2ARowBCol(rc);

        ${addBiasSnippet}

        ${applyActivationSnippet}

        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $ae5883458dd43aa5$export$51b2b2579375d8b0 = {
    REAL: 'return areal * breal - aimag * bimag;',
    IMAG: 'return areal * bimag + aimag * breal;'
};
class $ae5883458dd43aa5$export$d4e4851a08b0c91 {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'AReal',
            'AImag',
            'BReal',
            'BImag'
        ];
        this.outputShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(aShape, bShape);
        this.userCode = `
      float binaryOpComplex(
          float areal, float aimag, float breal, float bimag) {
        ${op}
      }

      void main() {
        float areal = getARealAtOutCoords();
        float aimag = getAImagAtOutCoords();
        float breal = getBRealAtOutCoords();
        float bimag = getBImagAtOutCoords();
        setOutput(binaryOpComplex(areal, aimag, breal, bimag));
      }
    `;
    }
}






const $951ae52c1905ecdf$var$MUL = 'return a * b;';
function $951ae52c1905ecdf$export$2060d2db72cce88f(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const dtype = (0, $f35e0c1a651337db$exports).upcastType(a.dtype, b.dtype);
    if (a.dtype === 'complex64') {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const realProgram = new (0, $ae5883458dd43aa5$export$d4e4851a08b0c91)($ae5883458dd43aa5$export$51b2b2579375d8b0.REAL, a.shape, b.shape);
        const imagProgram = new (0, $ae5883458dd43aa5$export$d4e4851a08b0c91)($ae5883458dd43aa5$export$51b2b2579375d8b0.IMAG, a.shape, b.shape);
        const inputs = [
            {
                dataId: aData.complexTensorInfos.real.dataId,
                dtype: aData.complexTensorInfos.real.dtype,
                shape: a.shape
            },
            {
                dataId: aData.complexTensorInfos.imag.dataId,
                dtype: aData.complexTensorInfos.imag.dtype,
                shape: a.shape
            },
            {
                dataId: bData.complexTensorInfos.real.dataId,
                dtype: bData.complexTensorInfos.real.dtype,
                shape: b.shape
            },
            {
                dataId: bData.complexTensorInfos.imag.dataId,
                dtype: bData.complexTensorInfos.imag.dtype,
                shape: b.shape
            }
        ];
        const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
        const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
        const complexOutput = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
            inputs: {
                real: realPart,
                imag: imagPart
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(imagPart);
        // TODO(annxingyuan): CPU forwarding for complex inputs.
        return complexOutput;
    }
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ])) {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const [outValues, outShape] = (0, $1cec302811203101$export$598d1d66b05a298f)(a.shape, b.shape, aData.values, bData.values, dtype);
        const out = backend.makeTensorInfo(outShape, dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_BINARY_OPERATIONS')) program = new (0, $845a6b9d98d1f900$export$7ef3bdc75c177be0)($951ae52c1905ecdf$var$MUL, a.shape, b.shape);
    else program = new (0, $6e99a2fc879307b0$export$9045e9161086790b)($951ae52c1905ecdf$var$MUL, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], dtype);
}
const $951ae52c1905ecdf$export$745576778aafee88 = {
    kernelName: (0, $507890e4aa8e1463$export$f14f83b3b531d498),
    backendName: 'webgl',
    kernelFunc: $951ae52c1905ecdf$export$2060d2db72cce88f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $78895d232e2c9a6d$export$2ae2c9dd4c61df98(input, afterShape, backend) {
    const input3DShape = [
        (0, $f6f0bdab98aa0468$export$4dfd7bc0667970e0)(input.shape),
        ...(0, $f6f0bdab98aa0468$export$e8f6c350b57b8270)(input.shape)
    ];
    const input3D = {
        dtype: input.dtype,
        shape: input3DShape,
        dataId: input.dataId
    };
    const afterShapeAs3D = [
        (0, $f6f0bdab98aa0468$export$4dfd7bc0667970e0)(afterShape),
        ...(0, $f6f0bdab98aa0468$export$e8f6c350b57b8270)(afterShape)
    ];
    const program = new (0, $95376b668d58fbfd$export$ce249f6fedcc44de)(afterShapeAs3D, input3DShape);
    const preventEagerUnpackingOfOutput = true;
    const customValues = [
        input3DShape
    ];
    const output = backend.runWebGLProgram(program, [
        input3D
    ], input.dtype, customValues, preventEagerUnpackingOfOutput);
    return {
        dataId: output.dataId,
        shape: afterShape,
        dtype: output.dtype
    };
}



function $fa3edc728a2e320c$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const webglBackend = backend;
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const $shape = (0, $0775da5e684c8c0d$exports).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape($shape);
    (0, $0775da5e684c8c0d$exports).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    const xTexData = webglBackend.texData.get(x.dataId);
    if (xTexData.isPacked && !(0, $f6f0bdab98aa0468$export$951b388203a0422d)(x.shape, $shape) && !(xTexData.texture !== null && (0, $f6f0bdab98aa0468$export$951b388203a0422d)(xTexData.shape, $shape))) return (0, $78895d232e2c9a6d$export$2ae2c9dd4c61df98)(x, $shape, webglBackend);
    webglBackend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $fa3edc728a2e320c$export$cfa02e698602aca2 = {
    kernelName: (0, $507890e4aa8e1463$export$755ddd847e5abe03),
    backendName: 'webgl',
    kernelFunc: $fa3edc728a2e320c$export$9eaad88cf88cee2b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $cca4f81561048b21$export$a1460fd06abdca4 {
    constructor(reduceInfo, divisor){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `sumValue += dot(values, ones);`;
        if (divisor != null) {
            const denominator = 1 / divisor;
            updateSnippet = `sumValue += dot(values * ${(0, $0775da5e684c8c0d$exports).isInt(denominator) ? denominator.toPrecision(2) : denominator}, ones);`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return 0.0;
        }
      `;
        this.userCode = `
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1), 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2), 0.0);

          ${updateSnippet}
        }
        setOutput(sumValue);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b59b547b506a6b0a$export$14f07173aed228a5 {
    constructor(reduceInfo, reduceType){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        let initializationValue = '0.0';
        let compareOp = ``;
        if (reduceType === 'prod') initializationValue = '1.0';
        else if (reduceType === 'min') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '1.0 / 1e-20';
            compareOp = `min`;
        } else if (reduceType === 'max') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '-1.0 / 1e-20';
            compareOp = `max`;
        }
        let returnValue = `${reduceType}(${reduceType}(${reduceType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (reduceType === 'sum') returnValue = `sumValue`;
        else if (reduceType === 'prod') returnValue = `prodValue`;
        else if (reduceType === 'all') returnValue = `allValue`;
        else if (reduceType === 'any') returnValue = `anyValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `
      if (${reduceType === 'sum'}) {
        sumValue += dot(values, ones);
      } else if (${reduceType === 'prod'}) {
        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);
        prodValue *= tmp[0] * tmp[1];
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
        if (${reduceType === 'min'} || ${reduceType === 'max'}) {
          minMaxValue = ${compareOp}(values, minMaxValue);
          bvec4 isNaN = isnan(values);
          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {
            minMaxValue = vec4(NAN);
          }
        }
      }
    `;
        let vecType = `vec4`;
        if (reduceType === 'all') {
            initializationValue = '1.0';
            updateSnippet = `
        bool reducedAllValue = all(values);
        float floatedReducedAllValue = float(reducedAllValue);
        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);
      `;
            vecType = `bvec4`;
        } else if (reduceType === 'any') {
            initializationValue = '0.0';
            updateSnippet = `
        bool reducedAnyValue = any(values);
        float floatedReducedAnyValue = float(reducedAnyValue);
        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);
      `;
            vecType = `bvec4`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        vec4 minMaxValue = vec4(${initializationValue});
        float prodValue = 1.0;
        float sumValue = 0.0;
        float allValue = 1.0;
        float anyValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}


// Returns an array of configuration objects that describe each stage of the
// reduction.
function $bb5e1efea372a85a$var$getReductionStages(inShape) {
    const stages = [];
    while(stages.length === 0 || stages[stages.length - 1].outSize !== 1){
        const outSize = stages.length ? stages[stages.length - 1].outSize : inShape[1];
        const windowSize = (0, $f35e0c1a651337db$exports).computeOptimalWindowSize(outSize);
        stages.push({
            inSize: outSize,
            windowSize: windowSize,
            outSize: Math.ceil(outSize / windowSize)
        });
    }
    return stages;
}
function $bb5e1efea372a85a$export$533b26079ad0b4b(x, dtype, reductionType, backend) {
    const reductionStages = $bb5e1efea372a85a$var$getReductionStages(x.shape);
    let result = x;
    for(let i = 0; i < reductionStages.length; i++){
        const { inSize: inSize, windowSize: windowSize, outSize: outSize } = reductionStages[i];
        let program;
        let previousResult;
        if (reductionType === 'mean') program = i === 0 ? new (0, $cca4f81561048b21$export$a1460fd06abdca4)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, inSize) : new (0, $cca4f81561048b21$export$a1460fd06abdca4)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        });
        else program = new (0, $b59b547b506a6b0a$export$14f07173aed228a5)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, reductionType);
        previousResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], dtype);
        if (previousResult.dataId !== x.dataId) backend.disposeIntermediateTensorInfo(previousResult);
    }
    return result;
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $dc50754df264e172$export$e48ac6bd7e0ddfac {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
        const switched = $dc50754df264e172$var$getSwitchedCoords(newDim);
        this.userCode = `
    void main() {
      ${dtype} resRC = getOutputCoords();
      setOutput(getA(${switched}));
    }
    `;
    }
}
function $dc50754df264e172$var$getSwitchedCoords(newDim) {
    const rank = newDim.length;
    if (rank > 6) throw Error(`Transpose for rank ${rank} is not yet supported`);
    const originalOrder = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u',
        'resRC.v'
    ];
    const switchedCoords = new Array(rank);
    for(let i = 0; i < newDim.length; i++)switchedCoords[newDim[i]] = originalOrder[i];
    return switchedCoords.join();
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $4fa9b6329df38508$export$4daa0c968248fb58 {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        if (this.rank > 6) throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
        const outputOrder = (0, $70e72a00a69a2f93$export$a7c2113d79df2971)('rc', this.rank);
        const switchedOrder = new Array(this.rank);
        for(let i = 0; i < newDim.length; i++)switchedOrder[newDim[i]] = outputOrder[i];
        const innerDims = `vec2(${switchedOrder.slice(-2).join()})`;
        const nextColumn = `++${outputOrder[this.rank - 1]} < ${outputShape[this.rank - 1]}`;
        const getc = `getChannel(getA(${switchedOrder.join()}), ${innerDims})`;
        this.userCode = `
    void main() {
      ${dtype} rc = getOutputCoords();
      vec4 result = vec4(0.);
      result[0] = ${getc};
      if(${nextColumn}) {
        result[1] = ${getc};
      }
      --${outputOrder[this.rank - 1]};
      if(++${outputOrder[this.rank - 2]} < ${outputShape[this.rank - 2]}) {
        result[2] = ${getc};
        if(${nextColumn}) {
          result[3] = ${getc};
        }
      }
      setOutput(result);
    }
    `;
    }
}


function $2dac94a44dcdc62a$export$986b9e65182e08d(x, perm, backend) {
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $4fa9b6329df38508$export$4daa0c968248fb58)(x.shape, perm) : new (0, $dc50754df264e172$export$e48ac6bd7e0ddfac)(x.shape, perm);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}


function $ab9f24bf472b84c1$export$c29f6d05a9b60dfa(x, axis, keepDims, backend) {
    const reductionIndices = axis;
    const xRank = x.shape.length;
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    const sumInputIsTransposed = permutedAxes != null;
    let sumInput = x;
    if (sumInputIsTransposed) {
        sumInput = (0, $2dac94a44dcdc62a$export$986b9e65182e08d)(x, permutedAxes, backend);
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('sum', axes, xRank);
    const [sumOutShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(sumInput.shape, axes);
    let outShape = sumOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(sumOutShape, origAxes);
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: sumInput
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const outType = (0, $4ccb7c1368387e67$export$3479b4fbed3c0d8d)(x.dtype);
    const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(reshapedInput, outType, 'sum', backend);
    const out = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    if (sumInputIsTransposed) backend.disposeIntermediateTensorInfo(sumInput);
    return out;
}


function $0082ed6af416fef1$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $ab9f24bf472b84c1$export$c29f6d05a9b60dfa)(x, axis, keepDims, backend);
}
const $0082ed6af416fef1$export$47edea402251c258 = {
    kernelName: (0, $507890e4aa8e1463$export$534760f50726d5),
    backendName: 'webgl',
    kernelFunc: $0082ed6af416fef1$export$8a63f25cc62965f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $1c4657c4bdbc3da9$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    const webglBackend = backend;
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    let out;
    if (webglBackend.shouldExecuteOnCPU([
        x
    ])) {
        const xTexData = webglBackend.texData.get(x.dataId);
        const values = xTexData.values;
        const outValues = (0, $1cec302811203101$export$a0105d4a7143676c)(values, x.shape, x.dtype, perm, newShape);
        out = webglBackend.makeTensorInfo(newShape, x.dtype);
        const outData = webglBackend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $2dac94a44dcdc62a$export$986b9e65182e08d)(x, perm, webglBackend);
    return out;
}
const $1c4657c4bdbc3da9$export$895a002a39b774be = {
    kernelName: (0, $507890e4aa8e1463$export$7e714455f9a1f8f7),
    backendName: 'webgl',
    kernelFunc: $1c4657c4bdbc3da9$export$9cb09a71b7d66923
};


const $6461d60c83660fb7$export$42c1ddb439199e73 = 1000;
function $6461d60c83660fb7$export$d524d65e88e1168b({ a: a, b: b, transposeA: transposeA, transposeB: transposeB, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $0775da5e684c8c0d$exports).sizeFromShape(outerDimsA);
    const batchDimB = (0, $0775da5e684c8c0d$exports).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $5ede3b6f723b9f5a$exports).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $0775da5e684c8c0d$exports).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const intermediates = [
        a3d,
        b3d
    ];
    const batchDim = Math.max(batchDimA, batchDimB);
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation != null ? (0, $d770bb96fbeee88f$export$445d43a4039ec7b7)(activation, true) : null;
    const containsFusedOps = hasBias || hasPreluActivationWeights || hasLeakyreluAlpha || fusedActivation != null;
    let out;
    // Since the matrices are vectors, it is faster to call mul().sum()
    // because sum() is O(sqrt(N)) due to divide-and-conquer.
    if ((outerShapeA === 1 || outerShapeB === 1) && sharedDim > $6461d60c83660fb7$export$42c1ddb439199e73 && containsFusedOps === false) {
        let aVec = a3d;
        let bVec = b3d;
        if (transposeA) {
            aVec = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
                inputs: {
                    x: a3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(aVec);
        }
        if (transposeB) {
            bVec = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
                inputs: {
                    x: b3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(bVec);
        }
        const shouldReshapeA = outerShapeB !== 1;
        const shouldReshapeB = outerShapeB === 1;
        let aVec3d = aVec;
        if (shouldReshapeA) {
            aVec3d = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: aVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        sharedDim,
                        1
                    ]
                }
            });
            intermediates.push(aVec3d);
        }
        const axis = outerShapeB === 1 ? 2 : 1;
        let bVec3d = bVec;
        if (shouldReshapeB) {
            bVec3d = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        1,
                        sharedDim
                    ]
                }
            });
            intermediates.push(bVec3d);
        }
        const product = (0, $951ae52c1905ecdf$export$2060d2db72cce88f)({
            inputs: {
                a: aVec3d,
                b: bVec3d
            },
            backend: backend
        });
        out = (0, $0082ed6af416fef1$export$8a63f25cc62965f1)({
            inputs: {
                x: product
            },
            backend: backend,
            attrs: {
                axis: axis,
                keepDims: true
            }
        });
        intermediates.push(product);
    } else {
        const dtype = (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(a.dtype, b.dtype);
        const program = new (0, $147ea655f4b931fe$export$21e5f112101779d8)(a3dShape, b3dShape, [
            batchDim,
            outerShapeA,
            outerShapeB
        ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = [
            a3d,
            b3d
        ];
        if (bias != null) inputs.push(bias);
        if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $0775da5e684c8c0d$exports).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        out = backend.runWebGLProgram(program, inputs, dtype);
    }
    const outReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    intermediates.push(out);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return outReshaped;
}


function $ee939c71e5790a4a$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    return (0, $6461d60c83660fb7$export$d524d65e88e1168b)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $ee939c71e5790a4a$export$f70d36da1c218f84 = {
    kernelName: (0, $507890e4aa8e1463$export$8d1af0f7c2a4da9e),
    backendName: 'webgl',
    kernelFunc: $ee939c71e5790a4a$export$d86ca0bbe0236889
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $699ad679f487e1fb$var$ABS = `return abs(x);`;
function $699ad679f487e1fb$export$2335f513bbd82c6d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    // TODO: handle cases when x is complex. Once the cpu implementation
    // can handle complex values, refactor to use unaryKernelFunc.
    if (backend.shouldExecuteOnCPU([
        x
    ]) && x.dtype !== 'complex64') {
        const xData = backend.texData.get(x.dataId);
        const outValues = (0, $1cec302811203101$export$d7efa3585619eabe)(xData.values);
        return backend.makeTensorInfo(x.shape, x.dtype, outValues);
    }
    let program;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(x.shape, $699ad679f487e1fb$var$ABS);
    else program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(x.shape, $699ad679f487e1fb$var$ABS);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $699ad679f487e1fb$export$d66f48648b9d5ec7 = {
    kernelName: (0, $507890e4aa8e1463$export$b73c596ee8758a66),
    backendName: 'webgl',
    kernelFunc: $699ad679f487e1fb$export$2335f513bbd82c6d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $c2bd9f32ffd620c4$var$ACOS = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return acos(x);
`;
const $c2bd9f32ffd620c4$export$fd6306be3fde5b04 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $c2bd9f32ffd620c4$var$ACOS
});
const $c2bd9f32ffd620c4$export$255826ca70737275 = {
    kernelName: (0, $507890e4aa8e1463$export$3b952c9980dac550),
    backendName: 'webgl',
    kernelFunc: $c2bd9f32ffd620c4$export$fd6306be3fde5b04
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $20f0d10500127df9$var$ACOSH = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  if (x < 1.0) return NAN;
return log(x + sqrt(x * x - 1.0));`;
const $20f0d10500127df9$export$b26caf0f29211d08 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $20f0d10500127df9$var$ACOSH
});
const $20f0d10500127df9$export$3f520b71a56c9e70 = {
    kernelName: (0, $507890e4aa8e1463$export$987da490b7c2e7dd),
    backendName: 'webgl',
    kernelFunc: $20f0d10500127df9$export$b26caf0f29211d08
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $1b609dcf1a546aff$var$ADD = 'return a + b;';
const $1b609dcf1a546aff$export$d50bf7e4980f70a9 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $1b609dcf1a546aff$var$ADD,
    packedOpSnippet: $1b609dcf1a546aff$var$ADD,
    supportsComplex: true,
    cpuKernelImpl: (0, $1cec302811203101$export$c7f405723b4a93e7)
});
const $1b609dcf1a546aff$export$b1f3a580afb68e4c = {
    kernelName: (0, $507890e4aa8e1463$export$d0265b2c425512d6),
    backendName: 'webgl',
    kernelFunc: $1b609dcf1a546aff$export$d50bf7e4980f70a9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $a7c44b3c15d2975e$export$9d269fc8eb4783d5 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`float v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        float result = ${operation};
        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $1fe31aad63cd6eea$export$156b01c0aab97d90 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`vec4 v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        vec4 result = ${operation};
        setOutput(result);
      }
    `;
    }
}



function $f993bb4c35385a7d$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    if (tensors.length === 1) return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: tensors[0]
        },
        backend: backend
    });
    // Limit the number of uploaded textures for optimization.
    if (tensors.length > (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER')) {
        const midIndex = Math.floor(tensors.length / 2);
        const leftSide = $f993bb4c35385a7d$export$37b75d0026f96b8d({
            inputs: tensors.slice(0, midIndex),
            backend: backend
        });
        const rightSide = $f993bb4c35385a7d$export$37b75d0026f96b8d({
            inputs: tensors.slice(midIndex),
            backend: backend
        });
        return $f993bb4c35385a7d$export$37b75d0026f96b8d({
            inputs: [
                leftSide,
                rightSide
            ],
            backend: backend
        });
    }
    const dtype = tensors.map((t)=>t.dtype).reduce((d1, d2)=>(0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(d1, d2));
    const shapes = tensors.map((t)=>t.shape);
    // We can make sure shapes are identical in op level.
    const usePackedOp = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK');
    const program = usePackedOp ? new (0, $1fe31aad63cd6eea$export$156b01c0aab97d90)(tensors[0].shape, shapes) : new (0, $a7c44b3c15d2975e$export$9d269fc8eb4783d5)(tensors[0].shape, shapes);
    return backend.runWebGLProgram(program, tensors, dtype);
}
const $f993bb4c35385a7d$export$ff8000bc6f0313e1 = {
    kernelName: (0, $507890e4aa8e1463$export$eef235ad06d3226a),
    backendName: 'webgl',
    kernelFunc: $f993bb4c35385a7d$export$37b75d0026f96b8d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $c5d671667fdd4ddd$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('all', axes, xRank);
    const [outShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    const a2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(a2D, a2D.dtype, 'all', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $c5d671667fdd4ddd$export$4e3f081eb1a330fa = {
    kernelName: (0, $507890e4aa8e1463$export$5dceb1ab650a1776),
    backendName: 'webgl',
    kernelFunc: $c5d671667fdd4ddd$export$84bf76cd7afc7469
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $3882cc1fb3f31d51$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('any', axes, xRank);
    const [outShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    const a2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(a2D, a2D.dtype, 'any', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $3882cc1fb3f31d51$export$1a8ff634f2df3da6 = {
    kernelName: (0, $507890e4aa8e1463$export$b24b633b1364b94b),
    backendName: 'webgl',
    kernelFunc: $3882cc1fb3f31d51$export$4154a199d7d90455
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $6655159a15830091$export$7fa5759722b57eba {
    constructor(reduceInfo, op, firstPass){
        this.variableNames = [
            'A'
        ];
        const { windowSize: windowSize, batchSize: batchSize, outSize: outSize } = reduceInfo;
        if (!firstPass) this.variableNames.push('bestIndicesA');
        this.outputShape = [
            batchSize,
            outSize
        ];
        const compOp = op === 'max' ? '>' : '<';
        const indexSnippet = firstPass ? 'inOffset + i;' : 'round(getBestIndicesA(batch, inOffset + i));';
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        int bestIndex = inOffset;
        float bestValue = getA(batch, bestIndex);

        for (int i = 0; i < ${windowSize}; i++) {
          int inIdx = ${indexSnippet};
          float candidate = getA(batch, inIdx);
          if (candidate ${compOp} bestValue) {
            bestValue = candidate;
            bestIndex = inIdx;
          }
        }
        setOutput(float(bestIndex));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $ba9343310bfbdcdf$export$6b02cde2348cc418 {
    constructor(shape, windowSize, op, firstPass){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        (0, $0775da5e684c8c0d$exports).assert(shape.length > 2, ()=>`Packed arg${op.charAt(0).toUpperCase() + op.slice(1)} supports only inputs with rank above 2.`);
        const inSize = shape[shape.length - 1];
        const outSize = Math.ceil(inSize / windowSize);
        this.outputShape = shape.slice(0, -1);
        if (outSize > 1) this.outputShape.push(outSize);
        if (!firstPass) this.variableNames.push('bestIndicesA');
        const outShape = this.outputShape;
        const rank = outShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const coords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('coords', rank);
        let sourceLocSetup;
        let sourceRank;
        if (outSize === 1) {
            sourceRank = rank + 1;
            const sourceLocDType = (0, $a18658cdba53b459$export$859efd105c10c755)(sourceRank);
            sourceLocSetup = `
        ${sourceLocDType} sourceLocR = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 1]};
        ${sourceLocDType} sourceLocG = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 2]};
        ${sourceLocDType} sourceLocA = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 1]};
        ${sourceLocDType} sourceLocB = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 2]};`;
        } else {
            sourceRank = rank;
            sourceLocSetup = `
        ${dtype} sourceLocR = coords;
        ++${coords[rank - 1]};
        ${dtype} sourceLocG = coords;
        ++${coords[rank - 2]};
        ${dtype} sourceLocA = coords;
        --${coords[rank - 1]};
        ${dtype} sourceLocB = coords;
        --${coords[rank - 2]};`;
        }
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, sourceRank);
        const inChannel = '.' + channels[sourceRank - 1]; // e.g. ".b" for rank 3.
        const intChannels = channels.map((x)=>'int ' + x);
        const srcRCoords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('sourceLocR', sourceRank - 1).concat('inIdx.r');
        const srcGCoords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('sourceLocG', sourceRank - 1).concat('inIdx.g');
        const srcBCoords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('sourceLocB', sourceRank - 1).concat('inIdx.b');
        const srcACoords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('sourceLocA', sourceRank - 1).concat('inIdx.a');
        const compOp = op === 'max' ? 'greaterThan' : 'lessThan';
        const fetchCandidateIdx = firstPass ? '' : `
          inIdx = round(vec4(getBestIndicesAChannel(${srcRCoords.join()}),
                             getBestIndicesAChannel(${srcGCoords.join()}),
                             getBestIndicesAChannel(${srcBCoords.join()}),
                             getBestIndicesAChannel(${srcACoords.join()})));`;
        const fetchValue = `vec4(
            getAChannel(${srcRCoords.join()}),
            hasNextCol ? getAChannel(${srcGCoords.join()}) : 0.,
            hasNextRow ? getAChannel(${srcBCoords.join()}) : 0.,
            hasNextRow && hasNextCol ? getAChannel(${srcACoords.join()}) : 0.)`;
        const getBestIndicesAChannelSnippet = firstPass ? '' : `
      float getBestIndicesAChannel(${intChannels.join()}) {
        return getChannel(getBestIndicesA(${channels.join()}),
                                          vec2(${channels.slice(-2).join()}));
      }`;
        this.userCode = `
      float getAChannel(${intChannels.join()}) {
        return getChannel(getA(${channels.join()}),
                               vec2(${channels.slice(-2).join()}));
      }
      ${getBestIndicesAChannelSnippet}
      void main() {
        ${dtype} coords = getOutputCoords();
        bool hasNextCol = ${coords[rank - 1]} < ${outShape[rank - 1] - 1};
        bool hasNextRow = ${coords[rank - 2]} < ${outShape[rank - 2] - 1};
        ${sourceLocSetup}
        ivec4 srcIdx = ivec4(sourceLocR${inChannel}, sourceLocG${inChannel},
          sourceLocB${inChannel}, sourceLocA${inChannel}) * ${windowSize};
        ivec4 inIdx = srcIdx;
        vec4 bestIndex = vec4(inIdx);
        vec4 bestValue = ${fetchValue};

        for (int i = 0; i < ${windowSize}; i++) {
          inIdx = srcIdx;
          ${fetchCandidateIdx}
          vec4 candidate = ${fetchValue};
          bvec4 nan = isnan(candidate);
          bvec4 replace = bvec4(
            vec4(${compOp}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));

          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,
                           replace.y  ? candidate.y : bestValue.y,
                           replace.z  ? candidate.z : bestValue.z,
                           replace.w  ? candidate.w : bestValue.w);
          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));
          srcIdx++;
        }
        setOutput(bestIndex);
      }
    `;
    }
}



function $a170049e185d49f6$var$argReduce(backend, x, reduceType, bestIndicesA = null) {
    let batchSize = x.shape[0];
    let inSize = x.shape[1];
    if (bestIndicesA != null) {
        batchSize = bestIndicesA.shape[0];
        inSize = bestIndicesA.shape[1];
    }
    const windowSize = (0, $f35e0c1a651337db$exports).computeOptimalWindowSize(inSize);
    const reduceInfo = {
        windowSize: windowSize,
        inSize: inSize,
        batchSize: batchSize,
        outSize: Math.ceil(inSize / windowSize)
    };
    const program = new (0, $6655159a15830091$export$7fa5759722b57eba)(reduceInfo, reduceType, bestIndicesA == null);
    const inputs = [
        x
    ];
    if (bestIndicesA != null) inputs.push(bestIndicesA);
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    // No need to run another GPGPU program.
    if (output.shape[1] === 1) return output;
    const result = $a170049e185d49f6$var$argReduce(backend, x, reduceType, output);
    backend.disposeIntermediateTensorInfo(output);
    return result;
}
function $a170049e185d49f6$var$argReducePacked(backend, x, reduceType, bestIndicesA = null) {
    const inShape = bestIndicesA != null ? bestIndicesA.shape : x.shape;
    const inSize = inShape[inShape.length - 1];
    const windowSize = (0, $f35e0c1a651337db$exports).computeOptimalWindowSize(inSize);
    const program = new (0, $ba9343310bfbdcdf$export$6b02cde2348cc418)(inShape, windowSize, reduceType, bestIndicesA == null);
    const inputs = bestIndicesA == null ? [
        x
    ] : [
        x,
        bestIndicesA
    ];
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    if (output.shape.length === x.shape.length) {
        const result = $a170049e185d49f6$var$argReducePacked(backend, x, reduceType, output);
        backend.disposeIntermediateTensorInfo(output);
        return result;
    }
    return output;
}
function $a170049e185d49f6$export$63dee7a356b9210b(backend, x, axis, reduceType) {
    const axes = [
        axis
    ];
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('arg' + reduceType.charAt(0).toUpperCase() + reduceType.slice(1), axes, x.shape.length);
    if (!(0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_REDUCE') || x.shape.length <= 2) {
        const intermediateTensorInfos = [];
        // Eagerly unpack x input since it is passed in to all the shaders which
        // require unpacked inputs.
        const xtexData = backend.texData.get(x.dataId);
        const xIsPacked = xtexData !== null && xtexData.isPacked;
        let xUnPacked = x;
        if (xIsPacked) {
            xUnPacked = backend.unpackTensor(x);
            intermediateTensorInfos.push(xUnPacked);
        }
        const [outShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(xUnPacked.shape, axes);
        const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
        const a2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: xUnPacked
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        intermediateTensorInfos.push(a2D);
        const reduced = $a170049e185d49f6$var$argReduce(backend, a2D, reduceType);
        intermediateTensorInfos.push(reduced);
        const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return reshaped;
    }
    return $a170049e185d49f6$var$argReducePacked(backend, x, reduceType);
}



function $14aaa2183f9a3bf0$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('argMax', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $a170049e185d49f6$export$63dee7a356b9210b)(backend, $x, axes[0], 'max');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $14aaa2183f9a3bf0$export$ec7419fc9ad0069e = {
    kernelName: (0, $507890e4aa8e1463$export$17612294a1503e1c),
    backendName: 'webgl',
    kernelFunc: $14aaa2183f9a3bf0$export$7980a683c1b852b4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $ac8a2391b7d02edd$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('argMin', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $a170049e185d49f6$export$63dee7a356b9210b)(backend, $x, axes[0], 'min');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $ac8a2391b7d02edd$export$21836a5e5fa09eb4 = {
    kernelName: (0, $507890e4aa8e1463$export$baabd09270cbbd94),
    backendName: 'webgl',
    kernelFunc: $ac8a2391b7d02edd$export$ec99a91cddfb29a2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $f68e15c4e27b742c$var$ASIN = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return asin(x);
`;
const $f68e15c4e27b742c$export$41726bdb1fc63f = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $f68e15c4e27b742c$var$ASIN
});
const $f68e15c4e27b742c$export$de5cb0ef95dd6700 = {
    kernelName: (0, $507890e4aa8e1463$export$664c8ca7e7e5c126),
    backendName: 'webgl',
    kernelFunc: $f68e15c4e27b742c$export$41726bdb1fc63f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $ad77828faadec38a$var$ASINH = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `return log(x + sqrt(x * x + 1.0));`;
const $ad77828faadec38a$export$839d8a01b6af4fc0 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $ad77828faadec38a$var$ASINH
});
const $ad77828faadec38a$export$20d424616c76166 = {
    kernelName: (0, $507890e4aa8e1463$export$847c88940cb7dcb5),
    backendName: 'webgl',
    kernelFunc: $ad77828faadec38a$export$839d8a01b6af4fc0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $bd86350724669de1$var$ATAN = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  return atan(x);
`;
const $bd86350724669de1$export$628dc4eed22b0fbd = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $bd86350724669de1$var$ATAN
});
const $bd86350724669de1$export$159d632e3ff13624 = {
    kernelName: (0, $507890e4aa8e1463$export$bac667d46ac043ae),
    backendName: 'webgl',
    kernelFunc: $bd86350724669de1$export$628dc4eed22b0fbd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $cabac374ecd3048e$var$ATAN2 = (0, $6e99a2fc879307b0$export$39f0cca2b63399f6) + `
  return atan(a, b);
`;
const $cabac374ecd3048e$var$ATAN2_PACKED = `
  vec4 result = atan(a, b);
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $cabac374ecd3048e$export$b8b770ee6a0d9760 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $cabac374ecd3048e$var$ATAN2,
    packedOpSnippet: $cabac374ecd3048e$var$ATAN2_PACKED
});
const $cabac374ecd3048e$export$c53c7ab019edb8a0 = {
    kernelName: (0, $507890e4aa8e1463$export$3bf4c619ce589f4b),
    backendName: 'webgl',
    kernelFunc: $cabac374ecd3048e$export$b8b770ee6a0d9760
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $5b4556489d3f8cd9$var$ATANH = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  if ((x < -1.0) || (x > 1.0)) return NAN;
return (log(1.0 + x) - log(1.0 - x)) / 2.0;`;
const $5b4556489d3f8cd9$export$21ea955025ceb08b = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $5b4556489d3f8cd9$var$ATANH
});
const $5b4556489d3f8cd9$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $507890e4aa8e1463$export$98981a86fa2b1366),
    backendName: 'webgl',
    kernelFunc: $5b4556489d3f8cd9$export$21ea955025ceb08b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d948c32d7ddb4f9e$export$ddaa65439647a5ac {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        const batchFlattenPositionStr = `((batch  * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        const flattenPositionStr = `(xR * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
        const ivec2 pads = ivec2(${padTop}, ${padLeft});

        void main() {
          ivec4 coords = getOutputCoords();
          int batch = coords[0];
          int d = coords[3];

          ivec2 xRCCorner = coords.yz * strides - pads;
          int xRCorner = xRCCorner.x;
          int xCCorner = xRCCorner.y;

          // max/min x(?, ?, d) to get y(yR, yC, d).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;
          float avgValue = 0.0;

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              int xC = xCCorner + wC;

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float value = getX(batch, xR, xC, d);

              // If a min / max value has already been found, use it. If not,
              // use the current value.
              float currMinMaxValue = mix(
                  value, minMaxValue, minMaxValueFound);
              if (value ${compareOp} currMinMaxValue) {
                minMaxValue = value;
                minMaxValueFound = 1.0;
                minMaxPosition = ${flattenPositions ? includeBatchInIndex ? batchFlattenPositionStr : flattenPositionStr : `wR * ${effectiveFilterWidth} + wC`};
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') returnValue = `avgValue / max(count, 1.0)`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xR, int xC, int d) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xR, xC, d);
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d = coords[3];

        ivec2 xRCCorner = coords.yz * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // max/min x(?, ?, d) to get y(yR, yC, d).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          int xR = xRCorner + wR;

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
            int xC = xCCorner + wC * ${dilationWidth};

            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              getValue(batch, xR, xC + 3 * ${dilationWidth}, d)
            );

            ${updateSnippet}
          }

          int xC = xCCorner + ${filterWidthNearestVec4};
          if (${filterWidthVec4Remainder === 1}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              initializationValue,
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 2}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 3}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              initializationValue
            );

            ${updateSnippet}
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}
class $d948c32d7ddb4f9e$export$a835a97097fdbb0f {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec3 strides =
            ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
        const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

        void main() {
          ivec5 coords = getOutputCoords();
          int batch = coords.x;
          int ch = coords.u;

          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
          int xDCorner = xCorner.x;
          int xRCorner = xCorner.y;
          int xCCorner = xCorner.z;

          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;

          for (int wD = 0; wD < ${effectiveFilterDepth};
              wD += ${dilationDepth}) {
            int xD = xDCorner + wD;

            if (xD < 0 || xD >= ${convInfo.inDepth}) {
              continue;
            }

            for (int wR = 0; wR < ${effectiveFilterHeight};
                wR += ${dilationHeight}) {
              int xR = xRCorner + wR;

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int wC = 0; wC < ${effectiveFilterWidth};
                  wC += ${dilationWidth}) {
                int xC = xCCorner + wC;

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float value = getX(batch, xD, xR, xC, ch);

                // If a min / max value has already been found, use it. If not,
                // use the current value.
                float currMinMaxValue = mix(
                    value, minMaxValue, minMaxValueFound);
                if (value ${compareOp} currMinMaxValue) {
                  minMaxValue = value;
                  minMaxValueFound = 1.0;
                  minMaxPosition = ${flattenPositions ? includeBatchInIndex ? `(((batch * ${convInfo.inDepth} + xD) * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `((xD * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                      wR * ${effectiveFilterWidth} + wC`};
                }
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') // Use `max(count, 1.0)` instead of `count` in case count === 0.0.
        // If count === 0.0, `avgValue` is always 0.0 and we change `count`'s
        // value to avoid dividing zero.
        returnValue = `avgValue / max(count, 1.0)`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec3 strides =
        ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xD, int xR, int xC, int ch) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xD, xR, xC, ch);
      }

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xDCorner = xCorner.x;
        int xRCorner = xCorner.y;
        int xCCorner = xCorner.z;

        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          int xD = xDCorner + wD;

          if (xD < 0 || xD >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
              int xC = xCCorner + wC * ${dilationWidth};

              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 3 * ${dilationWidth}, ch)
              );

              ${updateSnippet}
            }

            int xC = xCCorner + ${filterWidthNearestVec4};
            if (${filterWidthVec4Remainder === 1}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                initializationValue,
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 2}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 3}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                initializationValue
              );

              ${updateSnippet}
            }
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}




function $25e74c1a889062ec$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $f6f0bdab98aa0468$export$1412c17b2531581a)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $0775da5e684c8c0d$exports).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const avgPoolProgram = new (0, $d948c32d7ddb4f9e$export$ddaa65439647a5ac)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $25e74c1a889062ec$export$6c901824a23e6150 = {
    kernelName: (0, $507890e4aa8e1463$export$37f2cc7be1add88c),
    backendName: 'webgl',
    kernelFunc: $25e74c1a889062ec$export$d5c65a2abd3d97dc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $4d3565df9ada271b$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const avgPoolProgram = new (0, $d948c32d7ddb4f9e$export$a835a97097fdbb0f)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $4d3565df9ada271b$export$5a9c81d240244392 = {
    kernelName: (0, $507890e4aa8e1463$export$390ecb697af103f6),
    backendName: 'webgl',
    kernelFunc: $4d3565df9ada271b$export$8e92f7d23b27f144
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c4792e54eb3334c6$export$5dc4ec478e6759de {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterHeight * filterWidth);
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth};
            wC+= ${dilationWidth}) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);

            dotProd += dyValue * avgMultiplier;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $c4792e54eb3334c6$export$f166702869bc274f {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);

              dotProd += dyValue * avgMultiplier;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


function $e09821a54384de8c$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const avgPoolBackpropProgram = new (0, $c4792e54eb3334c6$export$f166702869bc274f)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $e09821a54384de8c$export$1eeb8780807d0508 = {
    kernelName: (0, $507890e4aa8e1463$export$7163112adf28c062),
    backendName: 'webgl',
    kernelFunc: $e09821a54384de8c$export$798cb4034e996ff4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $2536508d1a2a33db$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $f6f0bdab98aa0468$export$1412c17b2531581a)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const avgPoolBackpropProgram = new (0, $c4792e54eb3334c6$export$5dc4ec478e6759de)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $2536508d1a2a33db$export$ac3f8709351ab225 = {
    kernelName: (0, $507890e4aa8e1463$export$9873fd6046cd6951),
    backendName: 'webgl',
    kernelFunc: $2536508d1a2a33db$export$2f098171d1c79aea
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $441717a786130602$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    return (0, $6461d60c83660fb7$export$d524d65e88e1168b)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend
    });
}
const $441717a786130602$export$d0dd993198185538 = {
    kernelName: (0, $507890e4aa8e1463$export$9a3bf60b23f63c8),
    backendName: 'webgl',
    kernelFunc: $441717a786130602$export$8f97894b482227f0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $e9ee916de4dbf223$export$bd15a4172044baef {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.outputShape = [];
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = '0.0';
        if (offsetShape != null) {
            (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = '1.0';
        if (scaleShape != null) {
            (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        float x = getXAtOutCoords();
        float mean = getMeanAtOutCoords();
        float variance = getVarianceAtOutCoords();
        float offset = ${offsetSnippet};
        float scale = ${scaleSnippet};
        float inv = scale * inversesqrt(variance + float(${varianceEpsilon}));
        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $8d151f867ac91f5d$export$cfdd4076f282cff6 {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.packedInputs = true;
        this.packedOutput = true;
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = 'vec4(0.0)';
        if (offsetShape != null) {
            (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = 'vec4(1.0)';
        if (scaleShape != null) {
            (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        vec4 offset = ${offsetSnippet};
        vec4 scale = ${scaleSnippet};

        vec4 x = getXAtOutCoords();
        vec4 mean = getMeanAtOutCoords();
        vec4 variance = getVarianceAtOutCoords();

        vec4 inv = scale * inversesqrt(variance + vec4(${varianceEpsilon}));

        setOutput((x - mean) * inv + offset);
      }
    `;
    }
}


const $72072ccb62d79264$export$8ea8088e6d0cdd02 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x, mean: mean, variance: variance, offset: offset, scale: scale } = inputs;
    (0, $0775da5e684c8c0d$exports).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $0775da5e684c8c0d$exports).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $0775da5e684c8c0d$exports).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const finalInputs = [
        x,
        mean,
        variance
    ];
    let offsetShape = null;
    if (offset != null) {
        offsetShape = offset.shape;
        finalInputs.push(offset);
    }
    let scaleShape = null;
    if (scale != null) {
        scaleShape = scale.shape;
        finalInputs.push(scale);
    }
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $8d151f867ac91f5d$export$cfdd4076f282cff6)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon) : new (0, $e9ee916de4dbf223$export$bd15a4172044baef)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
    const output = backend.runWebGLProgram(program, finalInputs, finalInputs[0].dtype);
    return output;
};
const $72072ccb62d79264$export$df2dc5c7a755e418 = {
    kernelName: (0, $507890e4aa8e1463$export$3821a0416660aaa2),
    backendName: 'webgl',
    kernelFunc: $72072ccb62d79264$export$8ea8088e6d0cdd02
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $d41b6b013b45ad8d$export$ef8bf52bc4951c85 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.outputShape = destSize;
        this.rank = destSize.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const sourceCoords = $d41b6b013b45ad8d$var$getCoords(this.rank);
        let body;
        const coordSum = destSize.map((_, i)=>{
            return `sourceLoc.${$d41b6b013b45ad8d$var$coords[i]} = start[${i}] + coords.${$d41b6b013b45ad8d$var$coords[i]};`;
        });
        body = `
        ${dtype} sourceLoc;
        ${dtype} coords = getOutputCoords();
        ${coordSum.join('\n')}
      `;
        this.userCode = `
      void main() {
        ${body}
        setOutput(getSource(${sourceCoords}));
      }
    `;
    }
}
const $d41b6b013b45ad8d$var$coords = [
    'x',
    'y',
    'z',
    'w',
    'u',
    'v'
];
function $d41b6b013b45ad8d$var$getCoords(rank) {
    if (rank === 1) return 'sourceLoc';
    else if (rank <= 6) return $d41b6b013b45ad8d$var$coords.slice(0, rank).map((x)=>'sourceLoc.' + x).join(',');
    else throw Error(`Slicing for rank ${rank} is not yet supported`);
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $4da1f273ac2d1ce4$export$a6c6101de259f77 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = destSize;
        this.rank = destSize.length;
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
        const coords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('coords', this.rank);
        const sourceLoc = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('sourceLoc', this.rank);
        const innerDims = this.rank === 1 ? 'sourceLoc' : `vec2(${sourceLoc.slice(-2).join()})`;
        const getChannel = `getChannel(getSource(${sourceLoc.join()}), ${innerDims})`;
        const upperRow = `
      result.x = ${getChannel};
      if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
        ++${sourceLoc[this.rank - 1]};
        result.y = ${getChannel};
        --${sourceLoc[this.rank - 1]};
      }
    `;
        const lowerRow = this.rank === 1 ? '' : `
      --${coords[this.rank - 1]};
      if (++${coords[this.rank - 2]} < ${destSize[this.rank - 2]}) {
        ++${sourceLoc[this.rank - 2]};
        result.z = ${getChannel};
        if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
          ++${sourceLoc[this.rank - 1]};
          result.w = ${getChannel};
        }
      }
    `;
        const sourceLocSetup = this.rank <= 4 ? `sourceLoc = coords +
            ${dtype}(${destSize.map((_, i)=>`start[${i}]`).join()});` : destSize.map((_, i)=>`${sourceLoc[i]} = ${coords[i]} + start[${i}];`).join('\n');
        this.userCode = `
      void main() {
        ${dtype} coords = getOutputCoords();
        ${dtype} sourceLoc;
        ${sourceLocSetup}
        vec4 result = vec4(0.);
        ${upperRow}
        ${lowerRow}
        setOutput(result);
      }
    `;
    }
}


function $c77e6e12689cfb9b$var$shallowSlice(x, begin, size, backend) {
    const xTexData = backend.texData.get(x.dataId);
    const t = backend.makeTensorInfo(size, x.dtype);
    const newTexData = backend.texData.get(t.dataId);
    // Copy texture data from the original tensor.
    Object.assign(newTexData, xTexData);
    newTexData.refCount = 1;
    newTexData.shape = size;
    newTexData.dtype = x.dtype;
    let flatOffset = (0, $f147fd057118a602$exports).computeFlatOffset(begin, (0, $0775da5e684c8c0d$exports).computeStrides(x.shape));
    if (xTexData.slice) // We are slicing an already sliced tensor, so we have to accumulate
    // the offset.
    flatOffset += xTexData.slice.flatOffset;
    newTexData.slice = {
        flatOffset: flatOffset,
        // Point to the original dataId, which is used to do ref counting.
        origDataId: xTexData.slice && xTexData.slice.origDataId || x.dataId
    };
    // Increase the ref count for that data bucket.
    const refCount = backend.dataRefCount.get(newTexData.slice.origDataId) || 1;
    backend.dataRefCount.set(newTexData.slice.origDataId, refCount + 1);
    return t;
}
function $c77e6e12689cfb9b$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    const [$begin, $size] = (0, $f147fd057118a602$exports).parseSliceParams(x, begin, size);
    (0, $f147fd057118a602$exports).assertParamsValid(x, $begin, $size);
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape($size) === 0) return backend.makeTensorInfo($size, x.dtype, []);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string') {
        const xTexData = backend.texData.get(x.dataId);
        const outValues = (0, $1cec302811203101$export$45812d0d8578899)(xTexData.values, $begin, $size, x.shape, x.dtype);
        return backend.makeTensorInfo($size, x.dtype, outValues);
    }
    const { isPacked: isPacked } = backend.texData.get(x.dataId);
    const isContinous = (0, $f147fd057118a602$exports).isSliceContinous(x.shape, $begin, $size);
    if (isPacked || !isContinous) {
        const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $4da1f273ac2d1ce4$export$a6c6101de259f77)($size) : new (0, $d41b6b013b45ad8d$export$ef8bf52bc4951c85)($size);
        const customValues = [
            $begin
        ];
        return backend.runWebGLProgram(program, [
            x
        ], x.dtype, customValues);
    }
    backend.uploadToGPU(x.dataId);
    return $c77e6e12689cfb9b$var$shallowSlice(x, $begin, $size, backend);
}
const $c77e6e12689cfb9b$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $507890e4aa8e1463$export$b3f2e2de3a8baa1e),
    backendName: 'webgl',
    kernelFunc: $c77e6e12689cfb9b$export$58adb3bec8346d0f
};



const $5f87b77034830ff7$export$ea37d960c1808536 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $0775da5e684c8c0d$exports).assert(x.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $f35e0c1a651337db$exports).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $f35e0c1a651337db$exports).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $f35e0c1a651337db$exports).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $f35e0c1a651337db$exports).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $f35e0c1a651337db$exports).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const toDispose = [];
    const reshapedIntermediate = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const transposedIntermediate = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
        inputs: {
            x: reshapedIntermediate
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const reshapedIntermediate2 = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: transposedIntermediate
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const sliced = (0, $c77e6e12689cfb9b$export$58adb3bec8346d0f)({
        inputs: {
            x: reshapedIntermediate2
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    toDispose.push(reshapedIntermediate);
    toDispose.push(transposedIntermediate);
    toDispose.push(reshapedIntermediate2);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return sliced;
};
const $5f87b77034830ff7$export$44e08e19f97e5513 = {
    kernelName: (0, $507890e4aa8e1463$export$e2743f47f61cca1f),
    backendName: 'webgl',
    kernelFunc: $5f87b77034830ff7$export$ea37d960c1808536
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $9a8f6dde2b526303$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.readSync(x.dataId);
    const weightsVals = backend.readSync(weights.dataId);
    const outVals = (0, $1cec302811203101$export$566def819e5d4601)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $9a8f6dde2b526303$export$af9f0093738840fb = {
    kernelName: (0, $507890e4aa8e1463$export$45dfbbff595c32aa),
    backendName: 'webgl',
    kernelFunc: $9a8f6dde2b526303$export$7e474bab088ed182
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $1a06e0c150dbdb81$export$c4be938c09e5b0e3 = `
  int r = int(a.r) & int(b.r);
  int g = int(a.g) & int(b.g);
  int rb = int(a.b) & int(b.b);
  int ra = int(a.a) & int(b.a);
  return vec4(r, g, rb, ra);
`;
const $1a06e0c150dbdb81$export$798433bcbadf4947 = `
  return float(int(a.r) & int(b.r));
`;
function $1a06e0c150dbdb81$export$84529b0ad3b42cd1(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const shouldUsePackedProgram = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_BINARY_OPERATIONS');
    const versionNumber = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION');
    // The type of a and b are ensured to be `int32` in core, therefore no need to
    // consider other type situations.
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ]) || versionNumber === 1) {
        const aVals = backend.texData.get(a.dataId).values;
        const bVals = backend.texData.get(b.dataId).values;
        const [outValues, outShape] = (0, $1cec302811203101$export$b9ea48282fa3ef20)(a.shape, b.shape, aVals, bVals, a.dtype);
        const out = backend.makeTensorInfo(outShape, a.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if (shouldUsePackedProgram) program = new (0, $845a6b9d98d1f900$export$7ef3bdc75c177be0)($1a06e0c150dbdb81$export$c4be938c09e5b0e3, a.shape, b.shape, false);
    else program = new (0, $6e99a2fc879307b0$export$9045e9161086790b)($1a06e0c150dbdb81$export$798433bcbadf4947, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], a.dtype);
}
const $1a06e0c150dbdb81$export$6d53927dafa38bf9 = {
    kernelName: (0, $507890e4aa8e1463$export$a9e259e32a62221f),
    backendName: 'webgl',
    kernelFunc: $1a06e0c150dbdb81$export$84529b0ad3b42cd1
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $7b77d3241d159562$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.readSync(s0.dataId);
    const s1Vals = backend.readSync(s1.dataId);
    const broadcastShape = (0, $f35e0c1a651337db$exports).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $7b77d3241d159562$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $507890e4aa8e1463$export$32877b1d6d497805),
    backendName: 'webgl',
    kernelFunc: $7b77d3241d159562$export$d226d344aedce941
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $0257d1a223ca6ecf$var$NOT_EQUAL = `return float(a != b);`;
const $0257d1a223ca6ecf$export$53a6892c50694894 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $0257d1a223ca6ecf$var$NOT_EQUAL,
    cpuKernelImpl: (0, $1cec302811203101$export$b91372753635df24),
    dtype: 'bool'
});
const $0257d1a223ca6ecf$export$d003d4d7e1500775 = {
    kernelName: (0, $507890e4aa8e1463$export$385ebe9945cae0c5),
    backendName: 'webgl',
    kernelFunc: $0257d1a223ca6ecf$export$53a6892c50694894
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $d01fae68c7267ce6$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: inputData.complexTensorInfos.real
        },
        backend: backend
    });
}
const $d01fae68c7267ce6$export$4b7bce57557ae68b = {
    kernelName: (0, $507890e4aa8e1463$export$f41305719b94e675),
    backendName: 'webgl',
    kernelFunc: $d01fae68c7267ce6$export$9fc57fb453bdbd67
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $47f0564d8b7b83b1$var$TO_INT = `return float(int(x));`;
function $47f0564d8b7b83b1$export$7d260a2a5f8bc19e(input, backend) {
    const program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(input.shape, $47f0564d8b7b83b1$var$TO_INT);
    const output = backend.runWebGLProgram(program, [
        input
    ], 'int32');
    return {
        dataId: output.dataId,
        shape: output.shape,
        dtype: output.dtype
    };
}


function $9c293e2e2e5c8de5$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        // TODO(annxingyuan): Import kernel function once zeros is modularized.
        const zerosTensor = $a0e8420b37ff8039$export$4445a00dafa2633b(x.shape);
        const floatX = $9c293e2e2e5c8de5$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
            inputs: {
                real: floatX,
                imag: zerosTensor
            },
            backend: backend
        });
        zerosTensor.dispose();
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $d01fae68c7267ce6$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $9c293e2e2e5c8de5$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $0775da5e684c8c0d$exports).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const values = backend.texData.get(x.dataId).values;
        const [resultShape, resultType, resultData] = (0, $1cec302811203101$export$babf602309dd6292)(values, x.shape, x.dtype, dtype);
        return backend.makeTensorInfo(resultShape, resultType, resultData);
    }
    if (dtype === 'int32') return (0, $47f0564d8b7b83b1$export$7d260a2a5f8bc19e)(x, backend);
    if (dtype === 'bool') {
        const zerosTensorInfo = backend.makeTensorInfo([], 'bool', (0, $0775da5e684c8c0d$exports).getTypedArrayFromDType('bool', 1));
        const binaryInputs = {
            a: x,
            b: zerosTensorInfo
        };
        const result = (0, $0257d1a223ca6ecf$export$53a6892c50694894)({
            inputs: binaryInputs,
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        return result;
    }
    throw new Error(`Error in Cast: failed to cast ${x.dtype} to ${dtype}`);
}
const $9c293e2e2e5c8de5$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $507890e4aa8e1463$export$107ecfb3d1ccbd77),
    backendName: 'webgl',
    kernelFunc: $9c293e2e2e5c8de5$export$f2db7d5238e1d23f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $0fef2d9cfa1a3f46$var$CEIL = `return ceil(x);`;
const $0fef2d9cfa1a3f46$export$803ce6b71a0a94b2 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $0fef2d9cfa1a3f46$var$CEIL,
    packedOpSnippet: $0fef2d9cfa1a3f46$var$CEIL,
    cpuKernelImpl: (0, $1cec302811203101$export$bb3ce81256fe261b)
});
const $0fef2d9cfa1a3f46$export$df387212b1898306 = {
    kernelName: (0, $507890e4aa8e1463$export$d4a1bccfd52ebd3),
    backendName: 'webgl',
    kernelFunc: $0fef2d9cfa1a3f46$export$803ce6b71a0a94b2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $68230cbb2c91efc4$export$ce48b7c79e7985d1 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `

      void main() {
        float value = getAAtOutCoords();
        if (isnan(value)) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, minVal, maxVal));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b61db9e864e83f87$export$812909708a626d33 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `
      void main() {
        vec4 value = getAAtOutCoords();

        if (any(isnan(value))) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));
      }
    `;
    }
}


function $eee2af9d0117e73a$export$fa97baf70ad024c0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
    let program;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_CLIP')) program = new (0, $b61db9e864e83f87$export$812909708a626d33)(x.shape);
    else program = new (0, $68230cbb2c91efc4$export$ce48b7c79e7985d1)(x.shape);
    const customValues = [
        [
            clipValueMin
        ],
        [
            clipValueMax
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
}
const $eee2af9d0117e73a$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $507890e4aa8e1463$export$611c0e357ac37f7d),
    backendName: 'webgl',
    kernelFunc: $eee2af9d0117e73a$export$fa97baf70ad024c0
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $0ef99906d66f3e98$export$d03dbc86862098f5 {
    constructor(shape){
        this.variableNames = [
            'real',
            'imag'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        float re = abs(getRealAtOutCoords());
        float im = abs(getImagAtOutCoords());
        float mx = max(re, im);

        // sadly the length function in glsl is not underflow-safe
        // (at least not on Intel GPUs). So the safe solution is
        // to ensure underflow-safety in all cases.
        setOutput(
          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))
        );
      }
    `;
    }
}


// Returns a TensorInfo with the complex shape and the dataId of the
// underlying part. We need to do this because a reshaped complex tensor is
// not reflected in its parts.
function $263a6d991c175c2d$var$makeComplexComponentTensorInfo(complexTensor, complexPart) {
    return {
        dataId: complexPart.dataId,
        dtype: complexPart.dtype,
        shape: complexTensor.shape
    };
}
function $263a6d991c175c2d$export$2837bc62566f8808(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xData = backend.texData.get(x.dataId);
    const program = new (0, $0ef99906d66f3e98$export$d03dbc86862098f5)(x.shape);
    const programInputs = [
        $263a6d991c175c2d$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.real),
        $263a6d991c175c2d$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.imag)
    ];
    return backend.runWebGLProgram(program, programInputs, programInputs[0].dtype);
}
const $263a6d991c175c2d$export$a4817d2978acc054 = {
    kernelName: (0, $507890e4aa8e1463$export$32902e58f1b48f4b),
    backendName: 'webgl',
    kernelFunc: $263a6d991c175c2d$export$2837bc62566f8808
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $f6e42dc9cf1d3994$export$9059cb52ee2cb142 {
    // Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
    constructor(shapes){
        this.outputShape = [];
        this.outputShape = (0, $f35e0c1a651337db$exports).computeOutShape(shapes, 1 /* axis */ );
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][1];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][1];
        const snippets = [
            `if (yC < ${offsets[0]}) setOutput(getT0(yR, yC));`
        ];
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            snippets.push(`else if (yC < ${offsets[i]}) ` + `setOutput(getT${i}(yR, yC-${shift}));`);
        }
        const lastIndex = offsets.length;
        const lastShift = offsets[offsets.length - 1];
        snippets.push(`else setOutput(getT${lastIndex}(yR, yC-${lastShift}));`);
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int yR = coords.x;
        int yC = coords.y;

        ${snippets.join('\n        ')}
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $d76c1a8a9a40e206$export$e91e551248cfdb97 {
    constructor(shapes, axis){
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        this.outputShape = (0, $f35e0c1a651337db$exports).computeOutShape(shapes, axis);
        const shape = this.outputShape;
        const rank = shape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const coords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('coords', rank);
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, rank);
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][axis];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][axis];
        const channel = channels[axis];
        const lastChannels = channels.slice(-2);
        const allChannels = channels.join();
        let getValueSnippet = `if (${channel} < ${offsets[0]}) {
        return getChannel(
            getT0(${allChannels}), vec2(${lastChannels.join()}));
        }`;
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            // Note: the >= comparison below may seem unnecessary given the check
            // above but is needed to workaround branch execution issues on some
            // devices. It makes all the conditions exclusive without relying on
            // execution order.
            getValueSnippet += `
        if (${channel} < ${offsets[i]}  && ${channel} >= ${offsets[i - 1]}) {
          return getChannel(
            getT${i}(${$d76c1a8a9a40e206$var$shiftedChannels(channels, channel, shift)}),
            vec2(${$d76c1a8a9a40e206$var$shiftedChannels(lastChannels, channel, shift)}));
        }`;
        }
        const lastIndex = offsets.length;
        const shift = offsets[offsets.length - 1];
        getValueSnippet += `
        return getChannel(
          getT${lastIndex}(${$d76c1a8a9a40e206$var$shiftedChannels(channels, channel, shift)}),
          vec2(${$d76c1a8a9a40e206$var$shiftedChannels(lastChannels, channel, shift)}));`;
        this.userCode = `
      float getValue(${channels.map((x)=>'int ' + x)}) {
        ${getValueSnippet}
      }

      void main() {
        ${dtype} coords = getOutputCoords();
        vec4 result = vec4(getValue(${coords}), 0., 0., 0.);

        ${coords[rank - 1]} = ${coords[rank - 1]} + 1;
        if (${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.g = getValue(${coords});
        }

        ${coords[rank - 2]} = ${coords[rank - 2]} + 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]}) {
          result.a = getValue(${coords});
        }

        ${coords[rank - 1]} = ${coords[rank - 1]} - 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]} &&
            ${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.b = getValue(${coords});
        }
        setOutput(result);
      }
    `;
    }
}
/**
 * Return an expression for coordinates into a vector where a given channel
 * will be offset by [shift].
 *
 * @param channels the channels to consider
 * @param channel the channel we want shifted
 * @param shift  the amount to subtract from the channel.
 *
 * @returns a string of the form 'x, y-[shift], z' where any one channel can
 * have the shift applied.
 */ function $d76c1a8a9a40e206$var$shiftedChannels(channels, channel, shift) {
    const channelIdx = channels.indexOf(channel);
    const res = channels.map((c, idx)=>{
        if (idx === channelIdx) return `${c} - ${shift}`;
        else return c;
    });
    return res.join();
}






/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $217ea7e271ca5f11$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: inputData.complexTensorInfos.imag
        },
        backend: backend
    });
}
const $217ea7e271ca5f11$export$ddfc128c2801add7 = {
    kernelName: (0, $507890e4aa8e1463$export$303b4473993a24f),
    backendName: 'webgl',
    kernelFunc: $217ea7e271ca5f11$export$d78fab5778ab392b
};




function $dc540053ef782ae5$export$777da59f594f497d(inputs, axis, backend) {
    const dtype = inputs[0].dtype;
    if (dtype === 'complex64') {
        const reals = inputs.map((t)=>(0, $d01fae68c7267ce6$export$9fc57fb453bdbd67)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = inputs.map((t)=>(0, $217ea7e271ca5f11$export$d78fab5778ab392b)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $dc540053ef782ae5$export$777da59f594f497d(reals, axis, backend);
        const imagConcated = $dc540053ef782ae5$export$777da59f594f497d(imags, axis, backend);
        const result = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    let runOnCpu = backend.shouldExecuteOnCPU(inputs);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (dtype === 'string') runOnCpu = true;
    if (runOnCpu) {
        // Any concat of n-dimensional tensors across any axis can be reduced to
        // a concatenation of two-dimensional tensors across the axis 1 by first
        // partitioning the axes of the original tensors into those less than the
        // axis to be concatenated and the rest. Then reshape the tensors
        // into a two-dimensional tensor by collapsing these two sets of axes and
        // concatenate the resulting matrices across the axis 1, finally reshaping
        // the result to have the proper shape.
        const tensors2D = inputs.map((t)=>{
            const innerSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape.slice(axis));
            const shape = [
                -1,
                innerSize
            ];
            return (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: t
                },
                backend: backend,
                attrs: {
                    shape: shape
                }
            });
        });
        const inputsValShapes = tensors2D.map((t)=>{
            return {
                vals: backend.readSync(t.dataId),
                shape: t.shape
            };
        });
        // Concats 2d tensors along axis=1.
        const outShape = (0, $f35e0c1a651337db$exports).computeOutShape(tensors2D.map((t)=>t.shape), 1 /* axis */ );
        const simplyConcat = tensors2D[0].shape[0] === 1;
        const outVals = (0, $1cec302811203101$export$95e7342d25849d64)(inputsValShapes, outShape, dtype, simplyConcat);
        const finalOutShape = (0, $f35e0c1a651337db$exports).computeOutShape(inputs.map((t)=>t.shape), axis);
        const outInfo = backend.makeTensorInfo(finalOutShape, dtype, outVals);
        tensors2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return outInfo;
    }
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape) > 0);
    const shouldPack = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') && $inputs[0].shape.length > 1;
    if ($inputs.length === 1) {
        // Clone tensor.
        const program = shouldPack ? new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(inputs[0].shape, (0, $b1c981bb7af6249a$export$c07b68c109124fe2)) : new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(inputs[0].shape, (0, $b1c981bb7af6249a$export$c07b68c109124fe2));
        return backend.runWebGLProgram(program, inputs, dtype);
    }
    const maxTexturesInShader = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER');
    if ($inputs.length > maxTexturesInShader) {
        const reducedInputs = [];
        for(let i = 0; i < $inputs.length; i += maxTexturesInShader){
            const subArray = $inputs.slice(i, i + maxTexturesInShader);
            reducedInputs.push($dc540053ef782ae5$export$777da59f594f497d(subArray, axis, backend));
        }
        const result = $dc540053ef782ae5$export$777da59f594f497d(reducedInputs, axis, backend);
        for (const i of reducedInputs)backend.disposeIntermediateTensorInfo(i);
        return result;
    }
    if (shouldPack) {
        const program = new (0, $d76c1a8a9a40e206$export$e91e551248cfdb97)($inputs.map((t)=>t.shape), axis);
        return backend.runWebGLProgram(program, $inputs, dtype);
    }
    const { tensors2D: tensors2D, outShape: outShape } = $dc540053ef782ae5$var$computeTensors2D($inputs, axis, backend);
    const program = new (0, $f6e42dc9cf1d3994$export$9059cb52ee2cb142)(tensors2D.map((t)=>t.shape));
    const result = backend.runWebGLProgram(program, tensors2D, dtype);
    tensors2D.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
    const reshapedResult = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(result);
    return reshapedResult;
}
function $dc540053ef782ae5$var$computeTensors2D(inputs, axis, backend) {
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const outShape = (0, $f35e0c1a651337db$exports).computeOutShape(inputs.map((t)=>t.shape), axis);
    const tensors2D = inputs.map((x)=>(0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            attrs: {
                shape: [
                    -1,
                    (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape.slice(axis))
                ]
            },
            backend: backend
        }));
    return {
        tensors2D: tensors2D,
        outShape: outShape
    };
}



function $96cfa83cf7469b29$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $f35e0c1a651337db$exports).assertParamsConsistent(shapes, $axis);
    const outShape = (0, $f35e0c1a651337db$exports).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $0775da5e684c8c0d$exports).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    return (0, $dc540053ef782ae5$export$777da59f594f497d)($inputs, $axis, backend);
}
const $96cfa83cf7469b29$export$c8cf96dae25282e5 = {
    kernelName: (0, $507890e4aa8e1463$export$936bbfc007425eea),
    backendName: 'webgl',
    kernelFunc: $96cfa83cf7469b29$export$ee1b3e54f0441b22
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $da51f18d98bfd59c$export$8dc36706147178e9 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false, hasLeakyreluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivationWeights) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d2 = coords[${channelDim}];

        ivec2 xRCCorner =
            ivec2(coords[${rowDim}], coords[${colDim}]) * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * ${dilationHeight};

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * ${dilationWidth};

            if (xC < 0 || xC >= ${convInfo.inWidth}) {
              continue;
            }

            for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
              vec4 wValues = vec4(
                getW(wR, wC, d1, d2),
                getW(wR, wC, d1 + 1, d2),
                getW(wR, wC, d1 + 2, d2),
                getW(wR, wC, d1 + 3, d2)
              );

              if (${isChannelsLast}) {
                vec4 xValues = vec4(
                  getX(batch, xR, xC, d1),
                  getX(batch, xR, xC, d1 + 1),
                  getX(batch, xR, xC, d1 + 2),
                  getX(batch, xR, xC, d1 + 3)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec4 xValues = vec4(
                  getX(batch, d1, xR, xC),
                  getX(batch, d1 + 1, xR, xC),
                  getX(batch, d1 + 2, xR, xC),
                  getX(batch, d1 + 3, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }
            }

            if (${inputDepthVec4Remainder === 1}) {

              if (${isChannelsLast}) {
                dotProd +=
                    getX(batch, xR, xC, ${inputDepthNearestVec4}) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              } else {
                dotProd +=
                    getX(batch, ${inputDepthNearestVec4}, xR, xC) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              }

            } else if (${inputDepthVec4Remainder === 2}) {
              vec2 wValues = vec2(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2)
              );

              if (${isChannelsLast}) {
                vec2 xValues = vec2(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec2 xValues = vec2(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            } else if (${inputDepthVec4Remainder === 3}) {
              vec3 wValues = vec3(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 2, d2)
              );

              if (${isChannelsLast}) {
                vec3 xValues = vec3(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec3 xValues = vec3(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 2, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            }
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}
class $da51f18d98bfd59c$export$67aff94cf1ececaf {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        this.userCode = `
      const ivec3 strides = ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d2 = coords.u;

        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xFCorner = xFRCCorner.x;
        int xRCorner = xFRCCorner.y;
        int xCCorner = xFRCCorner.z;

        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get
        // y(yF, yR, yC, d2). ? = to be determined. : = across all
        // values in that axis.
        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          int xF = xFCorner + wF * ${dilationDepth};

          if (xF < 0 || xF >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            int xR = xRCorner + wR * ${dilationHeight};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              int xC = xCCorner + wC * ${dilationWidth};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
                vec4 xValues = vec4(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                vec4 wValues = vec4(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (${inputDepthVec4Remainder === 1}) {
                dotProd +=
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}) *
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2);
              } else if (${inputDepthVec4Remainder === 2}) {
                vec2 xValues = vec2(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                vec2 wValues = vec2(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (${inputDepthVec4Remainder === 3}) {
                vec3 xValues = vec3(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                vec3 wValues = vec3(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $998d8c053e2b0fe7$export$20f35e9a79361289 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
       int xR; int xC; int xCOffset;
       vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           vec4 xTexelC${c * 2};
           int xTexelC${c * 2}Ready;
           vec4 xTexelC${c * 2 + 1};
           int xTexelC${c * 2 + 1}Ready;
           vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
     for (int r = 0; r < ${filterHeight}; r++) {
      for (int d1 = 0; d1 < ${convInfo.inChannels}; d1 += 2) {
       `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           xTexelC${c * 2} = vec4(0.0);
           xTexelC${c * 2}Ready = 0;
           xTexelC${c * 2 + 1} = vec4(0.0);
           xTexelC${c * 2 + 1}Ready = 0;
           xC${c} = vec4(0.0);`;
        mainLoop += `
         xR = xRCorner + r * dilations[0];
         if (xR >=0 && xR < inDims[0]) {
       `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
           xC = xCCorner + ${colIndex * dilationWidth};
           `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                 xCOffset = xC + 1;
                 if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }
               `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                 xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                 `;
                        else mainLoop += `
                   xCOffset = xC + 1 - 2;

                   if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       previous.zw = vec2(0.0);
                     }

                     xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                   } else {
                     xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                   }
                   `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                 if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xC${colIndex} = xTexelC${colIndex};
                 `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $0775da5e684c8c0d$exports).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                   xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                   if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                     xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       xTexelC${colIndex + 1}.zw = vec2(0.0);
                     }
                     xTexelC${colIndex + 1}Ready = 1;
                   }
                   `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                     xCOffset -= 2;
                     if (xCOffset >= 0 && xCOffset < inDims[1]) {
                      previous = getX(batch, xR, xCOffset, d1);
                      xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                     } else {
                      xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                     }
                     `;
                            else mainLoop += `
                     xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                     `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                     xC${colIndex + 1} = xTexelC${colIndex};
                     `;
                        else mainLoop += `
                     xCOffset = xC + ${nextTexelOffset};

                     if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                       xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                       if (xCOffset + 1 >= inDims[1]) {
                         xTexelC${colIndex + 1}.zw = vec2(0.0);
                       }
                       xTexelC${colIndex + 1}Ready = 1;
                     }

                     xC${colIndex + 1} = xTexelC${colIndex + 1};
                     `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                 xCOffset = xC + 1 - strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xC + 2 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   final = vec4(0.0);
                   xCOffset = xC + 1 + strides[1];
                   if(xCOffset >= 0 && xCOffset < inDims[1]) {
                     final = getX(batch, xR, xCOffset, d1);
                   }
                   xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                 `;
                } else {
                    mainLoop += `
                 if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xCOffset = xC + strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(
                   xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                 `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
             wTexel = getW(r, ${colIndex}, d1, d2);
             dotProd += xC${colIndex}.xxzz * vec4(wTexel.xy, wTexel.xy);
             if(d1 + 1 < ${convInfo.inChannels}) {
               dotProd += xC${colIndex}.yyww * vec4(wTexel.zw, wTexel.zw);
             }
           `;
                if (colIndex + 1 < filterWidth) mainLoop += `
               wTexel = getW(r, ${colIndex + 1}, d1, d2);
               dotProd += xC${colIndex + 1}.xxzz * vec4(wTexel.xy, wTexel.xy);
               if(d1 + 1 < ${convInfo.inChannels}) {
                 dotProd += xC${colIndex + 1}.yyww * vec4(wTexel.zw, wTexel.zw);
               }
             `;
            }
        }
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getPreluActivationWeightsAtOutCoords();
           ${activation}
         }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getLeakyreluAlphaAtOutCoords();
           ${activation}
         }`;
            else activationSnippet = `vec4 activation(vec4 x) {
           ${activation}
         }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
       ${activationSnippet}

       void main() {
         ivec4 coords = getOutputCoords();
         int batch = coords.x;
         ivec2 xRCCorner = coords.yz * strides - pads;
         int d2 = coords.w;
         int xRCorner = xRCCorner.x;
         int xCCorner = xRCCorner.y;

         //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
         vec4 dotProd = vec4(0.000000000000001);

         ${mainLoop}

         vec4 result = dotProd - vec4(0.000000000000001);
         ${addBiasSnippet}
         ${applyActivationSnippet}
         setOutput(result);
       }
     `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $dc1d9144a66d7a53$export$d76a638e68b7f211 {
    constructor(outputShape, convInfo){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec4'
            },
            {
                name: 'pad',
                type: 'ivec2'
            },
            {
                name: 'stride',
                type: 'ivec2'
            },
            {
                name: 'dilation',
                type: 'ivec2'
            },
            {
                name: 'inChannels',
                type: 'int'
            },
            {
                name: 'itemsPerBlockRow',
                type: 'int'
            },
            {
                name: 'outWidth',
                type: 'int'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const { dataFormat: dataFormat } = convInfo;
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        const isChannelsLast = dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const boundsCheckingSnippet = this.enableShapeUniforms ? 'if(blockIndex < outShape[2] && pos < outShape[1]) {' : `if(blockIndex < ${outputShape[2]} && pos < ${outputShape[1]}) {`;
        let unrolled = ``;
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++)unrolled += `
          blockIndex = rc.z + ${col};
          pos = rc.y + ${row};

          ${boundsCheckingSnippet}
            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];
            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);

            if(d0 < inputShape[${rowDim}] && d0 >= 0) {
              // Use custom imod instead mod. On Intel GPU, mod may generate
              // unexpected value.
              // https://github.com/tensorflow/tfjs/issues/5447
              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];
              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /
                  inChannels);

              if(d1 < inputShape[${colDim}] && d1 >= 0) {

                ch = imod(pos, inChannels);

                if (${isChannelsLast}) {
                  innerDims = vec2(d1, ch);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, d0, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                } else {
                  innerDims = vec2(d0, d1);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, ch, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                }
              }
            }
          }
        `;
        this.userCode = `
      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0);

        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;
        vec2 innerDims;

        ${unrolled}

        ${glsl.output} = result;
      }
    `;
    }
}








// Both conv2dByMatMul and conv2dWithIm2Row fuse height and width into one
// dimension to compute batchMatMul, so bias and activation weights are also
// supposed to fuse the two dimensions into one.
//
// This function computes the target shape for fusing height and width
// dimensions. Returning null means the shape is already compatible.
//
// Even though the bias is not supposed to be a 3-D or a 4-D (including
// batch) tensor and PReLU activiation weights is not supposed to be a 4-D
// tensor, we still need to support them, because we haven't disabled
// them for NHWC format.
// https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/conv2d.ts#L181-L196
function $c178adb7fa42247e$var$getShapeForBatchMatMul(shape, isChannelsLast) {
    const length = shape.length;
    if (length >= 3) return isChannelsLast ? [
        ...shape.slice(0, -3),
        shape[length - 3] * shape[length - 2],
        shape[length - 1]
    ] : [
        ...shape.slice(0, -3),
        shape[length - 3],
        shape[length - 2] * shape[length - 1]
    ];
    else if (!isChannelsLast && length === 1 && shape[0] > 1) return [
        shape[0],
        1
    ];
    else return null;
}
function $c178adb7fa42247e$export$fe56ce0f8b4bfd45({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Reshapes conv2D input to 2D tensors, uses matMul and then reshape the
    // result from 2D to 4D.
    const xShape = x.shape;
    const xTexData = backend.texData.get(x.dataId);
    const sharedMatMulDim = convInfo.inChannels;
    const outerShapeX = xShape[0] * xShape[1] * xShape[2];
    const outerShapeFilter = convInfo.outChannels;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const transposeA = false;
    const transposeB = false;
    let out;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $c178adb7fa42247e$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $c178adb7fa42247e$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    // TODO: Once reduction ops are packed, batchMatMul will always be packed
    // and we can remove this condition.
    const batchMatMulWillBeUnpacked = (outerShapeX === 1 || outerShapeFilter === 1) && sharedMatMulDim > (0, $6461d60c83660fb7$export$42c1ddb439199e73);
    // The algorithm in the if condition assumes (1) the output will be packed,
    // (2) x is packed, (3) x isChannelsLast, (4)  x's packed texture is already
    // on GPU, (5) col is odd, (6) the width, height and inChannels are the same
    // for xTexData.shape and xShape.
    const canOptimize = !batchMatMulWillBeUnpacked && xTexData.isPacked && isChannelsLast && xTexData.texture != null && xShape[2] % 2 !== 0 && (0, $0775da5e684c8c0d$exports).arraysEqual(xTexData.shape.slice(-3), xShape.slice(-3));
    if (canOptimize) {
        // We avoid expensive packed 2x2 reshape by padding col count to next,
        // even number. When col is odd, the result of packed batchMatMul is
        // the same (has the same texture layout and and values in the texture) as
        // it is for next even col. We make the odd-cols tensor to look like
        // even-cols tensor before the operation and, after the batchMatMul,
        // fix the even-cols result to have odd number of cols.
        const targetShape = xShape[0] * xShape[1] * (xShape[2] + 1);
        const xReshaped = {
            dataId: x.dataId,
            shape: [
                1,
                targetShape,
                convInfo.inChannels
            ],
            dtype: x.dtype
        };
        // xTexData.shape gets referenced from GPGPUBinary.inShapeInfos.
        // Decrementing col count, after batchMatMul->...->compileProgram leads to
        // invalid col count within the reference in GPGPUBinary.inShapeInfos.
        // Alternative fix would be to provide a copy to GPGPUBinary.inShapeInfos
        // in compileProgram method, but that would affect compilation of all
        // programs - instead, provide a copy here, with even col count, before
        // calling batchMatMul->...->compileProgram and after that, the original
        // xTexData.shape is restored.
        const originalXTexDataShape = xTexData.shape;
        xTexData.shape = xTexData.shape.slice();
        xTexData.shape[xTexData.shape.length - 2]++;
        (0, $0775da5e684c8c0d$exports).assert($f6f0bdab98aa0468$export$951b388203a0422d(xTexData.shape, xReshaped.shape), ()=>`packed reshape ${xTexData.shape} to ${xReshaped.shape} isn't free`);
        const filterReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        intermediates.push(filterReshaped);
        const pointwiseConv = (0, $6461d60c83660fb7$export$d524d65e88e1168b)({
            a: xReshaped,
            b: filterReshaped,
            backend: backend,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        const pointwiseConvTexData = backend.texData.get(pointwiseConv.dataId);
        (0, $0775da5e684c8c0d$exports).assert(pointwiseConvTexData.isPacked, ()=>'batchMatMul result is expected to be packed');
        // Restore the input shape to original.
        xTexData.shape = originalXTexDataShape;
        // Set the output shape - there is no need for expensive reshape as data
        // layout is already correct.
        pointwiseConvTexData.shape = convInfo.outShape;
        out = (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
            inputs: {
                x: pointwiseConv
            },
            backend: backend
        });
        out.shape = convInfo.outShape;
        intermediates.push(pointwiseConv);
    } else {
        const numCols = convInfo.outHeight * convInfo.outWidth;
        const xReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: isChannelsLast ? [
                    convInfo.batchSize,
                    numCols,
                    convInfo.inChannels
                ] : [
                    convInfo.batchSize,
                    convInfo.inChannels,
                    numCols
                ]
            }
        });
        const filterReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        const result = (0, $6461d60c83660fb7$export$d524d65e88e1168b)({
            a: isChannelsLast ? xReshaped : filterReshaped,
            b: isChannelsLast ? filterReshaped : xReshaped,
            transposeA: !isChannelsLast,
            transposeB: transposeB,
            backend: backend,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        out = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: convInfo.outShape
            }
        });
        intermediates.push(xReshaped);
        intermediates.push(filterReshaped);
        intermediates.push(result);
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}
function $c178adb7fa42247e$export$65b699e5c77381b8({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Rearranges conv2d input so each block to be convolved over forms the
    // column of a new matrix with shape [filterWidth * filterHeight *
    // inChannels, outHeight * outWidth]. The filter is also rearranged so each
    // output channel forms a row of a new matrix with shape [outChannels,
    // filterWidth * filterHeight * inChannels]. The convolution is then
    // computed by multiplying these matrices and reshaping the result.
    const { filterWidth: filterWidth, filterHeight: filterHeight, inChannels: inChannels, outWidth: outWidth, outHeight: outHeight, dataFormat: dataFormat } = convInfo;
    const isChannelsLast = dataFormat === 'channelsLast';
    const sharedDim = filterWidth * filterHeight * inChannels;
    const numCols = outHeight * outWidth;
    const x2ColShape = [
        convInfo.batchSize,
        sharedDim,
        numCols
    ];
    const transposeA = true;
    const transposeB = false;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $c178adb7fa42247e$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $c178adb7fa42247e$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const w2Row = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: filter
        },
        backend: backend,
        attrs: {
            shape: [
                1,
                sharedDim,
                (0, $0775da5e684c8c0d$exports).sizeFromShape(filter.shape) / sharedDim
            ]
        }
    });
    intermediates.push(w2Row);
    const im2ColProgram = new (0, $dc1d9144a66d7a53$export$d76a638e68b7f211)(x2ColShape, convInfo);
    const customValues = [
        x.shape,
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inChannels
        ],
        [
            convInfo.filterWidth * convInfo.inChannels
        ],
        [
            convInfo.outWidth
        ]
    ];
    const im2Col = backend.runWebGLProgram(im2ColProgram, [
        x
    ], 'float32', customValues);
    const im2ColReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: im2Col
        },
        backend: backend,
        attrs: {
            shape: x2ColShape
        }
    });
    intermediates.push(im2Col);
    intermediates.push(im2ColReshaped);
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation ? (0, $d770bb96fbeee88f$export$445d43a4039ec7b7)(activation, true) : null;
    const matmulProgram = new (0, $147ea655f4b931fe$export$21e5f112101779d8)(isChannelsLast ? im2ColReshaped.shape : w2Row.shape, isChannelsLast ? w2Row.shape : im2ColReshaped.shape, isChannelsLast ? [
        convInfo.batchSize,
        numCols,
        convInfo.outChannels
    ] : [
        convInfo.batchSize,
        convInfo.outChannels,
        numCols
    ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const inputs = isChannelsLast ? [
        im2ColReshaped,
        w2Row
    ] : [
        w2Row,
        im2ColReshaped
    ];
    if (bias) inputs.push(bias);
    if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $0775da5e684c8c0d$exports).createScalarValue(leakyreluAlpha, 'float32'));
        inputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    const product = backend.runWebGLProgram(matmulProgram, inputs, 'float32');
    const out = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: product
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(product);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}



function $37873063552b1d98$export$188f9215482e3db8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $c178adb7fa42247e$export$fe56ce0f8b4bfd45)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_EXP_CONV')) {
        const program = new (0, $998d8c053e2b0fe7$export$20f35e9a79361289)(convInfo);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32', customValues);
    } else if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_CONV_IM2COL')) out = (0, $c178adb7fa42247e$export$65b699e5c77381b8)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else {
        const program = new (0, $da51f18d98bfd59c$export$8dc36706147178e9)(convInfo);
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32');
    }
    const outReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $37873063552b1d98$export$4a39bf13b4378042 = {
    kernelName: (0, $507890e4aa8e1463$export$57742e605d475795),
    backendName: 'webgl',
    kernelFunc: $37873063552b1d98$export$188f9215482e3db8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7698c9d293b4d04a$export$1223560f67be2f2d {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int d2 = coords.w;

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              ${isChannelsLast ? `float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);` : `float dyValue = getDy(b, d2, yR, yC);
              float xValue = getX(b, d1, xR, xC);
              dotProd += (xValue * dyValue);`}
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7698c9d293b4d04a$export$5dc650171c0f6623 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[${channelDim}];

        ivec2 dyCorner = ivec2(coords[${rowDim}], coords[${colDim}]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {

              if (${isChannelsLast}) {
                float xValue = getDy(batch, idyR, idyC, d2);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              } else {
                float xValue = getDy(batch, d2, idyR, idyC);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7698c9d293b4d04a$export$932d18866f409cf3 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.userCode = `
      void main() {
        ivec5 coords = getOutputCoords();
        int wF = coords.x;
        int wR = coords.y;
        int wC = coords.z;
        int d1 = coords.w;
        int d2 = coords.u;

        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yF = 0; yF < ${convInfo.outDepth}; yF++) {
            int xF = wF + yF * ${strideDepth} - ${padFront};

            if (xF < 0 || xF >= ${convInfo.inDepth}) {
              continue;
            }

            for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
              int xR = wR + yR * ${strideHeight} - ${padTop};

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
                int xC = wC + yC * ${strideWidth} - ${padLeft};

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float dyValue = getDy(b, yF, yR, yC, d2);
                float xValue = getX(b, xF, xR, xC, d1);
                dotProd += (xValue * dyValue);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7698c9d293b4d04a$export$acda329ff653a25 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = filterDepth - 1 - convInfo.padInfo.front;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.u;


        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyFCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          float dyF = float(dyFCorner + wF) / ${strideDepth}.0;

          if (dyF < 0.0 || dyF >= ${convInfo.outDepth}.0 || fract(dyF) > 0.0) {
            continue;
          }
          int idyF = int(dyF);

          int wFPerm = ${filterDepth} - 1 - wF;

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
              fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            int wRPerm = ${filterHeight} - 1 - wR;

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              int wCPerm = ${filterWidth} - 1 - wC;

              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {
                float xValue = getDy(batch, idyF, idyR, idyC, d2);
                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


function $fdae7f50dc117069$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $7698c9d293b4d04a$export$1223560f67be2f2d)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $fdae7f50dc117069$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $507890e4aa8e1463$export$32a8943c0f1ca5a7),
    backendName: 'webgl',
    kernelFunc: $fdae7f50dc117069$export$652a30c9379f3de7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $55b27cca14d2e77b$export$9ade432542e381ca {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'strides',
                type: 'vec2'
            }
        ];
        this.outputShape = convInfo.inShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];

        ivec2 dyCorner = ivec2(coords[1], coords[2]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        vec4 result = vec4(0.);
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / strides[0];
          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);
          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int wCPerm = ${filterWidth} - 1 - wC;

            float dyC = float(dyCCorner + wC) / strides[1];
            bool idyCVal = (dyC >= 0.0) && (dyC < ${convInfo.outWidth}.0)
              && (fract(dyC) == 0.0);
            int idyC = int(dyC);

            float dyC2 = float(dyCCorner + wC + 1) / strides[1];
            bool idyCVal2 = (dyC2 >= 0.0) && (dyC2 < ${convInfo.outWidth}.0)
              && (fract(dyC2) == 0.0);
            int idyC2 = int(dyC2);

            if (idyCVal && idyCVal2) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec4 dySample2 = (idyC / 2 == idyC2 / 2) ?
                  dySample : getDy(batch, idyR, idyC2, d2);

                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));

                dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample2.xy : dySample2.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal2) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC2, d2);
                vec2 dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            }
          }
        }
        setOutput(result);
      }
    `;
    }
}


function $e62aaa60a192be5b$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_CONV2DTRANSPOSE') && $dataFormat === 'channelsLast') {
        const customValues = [
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        ];
        const program = new (0, $55b27cca14d2e77b$export$9ade432542e381ca)(convInfo);
        return backend.runWebGLProgram(program, [
            dy,
            filter
        ], 'float32', customValues);
    } else {
        const program = new (0, $7698c9d293b4d04a$export$5dc650171c0f6623)(convInfo);
        return backend.runWebGLProgram(program, [
            dy,
            filter
        ], 'float32');
    }
}
const $e62aaa60a192be5b$export$19bbc19fff1ed26f = {
    kernelName: (0, $507890e4aa8e1463$export$e26961e8ed0eb404),
    backendName: 'webgl',
    kernelFunc: $e62aaa60a192be5b$export$633310eed0c26e72
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $8bc7a4aa68e84b12$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const program = new (0, $da51f18d98bfd59c$export$67aff94cf1ececaf)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
}
const $8bc7a4aa68e84b12$export$1fe590fda0829040 = {
    kernelName: (0, $507890e4aa8e1463$export$9d3874201dd21933),
    backendName: 'webgl',
    kernelFunc: $8bc7a4aa68e84b12$export$1929932f31d07956
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $af1a1036d6ff5a5b$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const program = new (0, $7698c9d293b4d04a$export$932d18866f409cf3)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $af1a1036d6ff5a5b$export$6dce9169640850fa = {
    kernelName: (0, $507890e4aa8e1463$export$dd2885efe6043eee),
    backendName: 'webgl',
    kernelFunc: $af1a1036d6ff5a5b$export$b57760dc3101cea7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $1e452c2c789ec117$export$deb6d1ca1fa2977b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const program = new (0, $7698c9d293b4d04a$export$acda329ff653a25)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $1e452c2c789ec117$export$cdcac766a3ef1744 = {
    kernelName: (0, $507890e4aa8e1463$export$a54f552d6d7d521f),
    backendName: 'webgl',
    kernelFunc: $1e452c2c789ec117$export$deb6d1ca1fa2977b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $ae16523bd100b6ad$var$COS = (0, $d770bb96fbeee88f$export$bf39b1cb254b6187) + `
  return cos(x);
`;
const $ae16523bd100b6ad$var$COS_PACKED = `
  vec4 result = cos(x);
  bvec4 isNaN = isnan(x);
  ${(0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd)}
  return result;
`;
const $ae16523bd100b6ad$export$50d414a77b60d802 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $ae16523bd100b6ad$var$COS,
    packedOpSnippet: $ae16523bd100b6ad$var$COS_PACKED
});
const $ae16523bd100b6ad$export$ff099a1da5235a7e = {
    kernelName: (0, $507890e4aa8e1463$export$ddfd0a983d257666),
    backendName: 'webgl',
    kernelFunc: $ae16523bd100b6ad$export$50d414a77b60d802
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $e219df4d24afa34b$var$COSH = `
  float e2x = exp(-x);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const $e219df4d24afa34b$export$2e2fd1ad24e4d350 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $e219df4d24afa34b$var$COSH
});
const $e219df4d24afa34b$export$c5824052b09ba0ed = {
    kernelName: (0, $507890e4aa8e1463$export$5e311a1c57b0d27c),
    backendName: 'webgl',
    kernelFunc: $e219df4d24afa34b$export$2e2fd1ad24e4d350
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $cf8d55c42888030d$export$c889a58f7ea63106 {
    constructor(imageShape, boxShape, cropSize, method, extrapolationValue){
        this.variableNames = [
            'Image',
            'Boxes',
            'BoxInd'
        ];
        this.outputShape = [];
        const [batch, imageHeight, imageWidth, depth] = imageShape;
        const [numBoxes] = boxShape;
        const [cropHeight, cropWidth] = cropSize;
        this.outputShape = [
            numBoxes,
            cropHeight,
            cropWidth,
            depth
        ];
        const methodId = method === 'bilinear' ? 1 : 0;
        const [inputHeightFloat, inputWidthFloat] = [
            `${imageHeight - 1}.0`,
            `${imageWidth - 1}.0`
        ];
        const [heightRatio, heightScale, inY] = cropHeight > 1 ? [
            `${(imageHeight - 1) / (cropHeight - 1)}`,
            '(y2-y1) * height_ratio',
            `y1*${inputHeightFloat} + float(y)*(height_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (y1+y2) * ${inputHeightFloat}`
        ];
        const [widthRatio, widthScale, inX] = cropWidth > 1 ? [
            `${(imageWidth - 1) / (cropWidth - 1)}`,
            '(x2-x1) * width_ratio',
            `x1*${inputWidthFloat} + float(x)*(width_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (x1+x2) * ${inputWidthFloat}`
        ];
        // Reference implementation
        // tslint:disable-next-line:max-line-length
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
        this.userCode = `
      const float height_ratio = float(${heightRatio});
      const float width_ratio = float(${widthRatio});
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int y = coords[1];
        int x = coords[2];
        int d = coords[3];

        // get box vals
        float y1 = getBoxes(b,0);
        float x1 = getBoxes(b,1);
        float y2 = getBoxes(b,2);
        float x2 = getBoxes(b,3);

        // get image in batch index
        int bInd = round(getBoxInd(b));
        if(bInd < 0 || bInd >= ${batch}) {
          return;
        }

        float height_scale = ${heightScale};
        float width_scale = ${widthScale};

        float in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }
        float in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }

        vec2 sourceFracIndexCR = vec2(in_x,in_y);
        if(${methodId} == 1) {
          // Compute the four integer indices.
          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);
          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));

          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);
          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);
          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);
          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);

          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);

          float top = topLeft + (topRight - topLeft) * fracCR.x;
          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          float newValue = top + (bottom - top) * fracCR.y;
          setOutput(newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          ivec2 sourceNearestCR = ivec2(floor(
            sourceFracIndexCR + vec2(0.5,0.5)));
          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutput(newValue);
        }
      }
    `;
    }
}


const $730670272b7fca20$export$6f0f0090e1f6cd3c = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const program = new (0, $cf8d55c42888030d$export$c889a58f7ea63106)(image.shape, boxes.shape, cropSize, method, extrapolationValue);
    return backend.runWebGLProgram(program, [
        image,
        boxes,
        boxInd
    ], 'float32');
};
const $730670272b7fca20$export$f7086edcf0050c7f = {
    kernelName: (0, $507890e4aa8e1463$export$50bc9557793c2e04),
    backendName: 'webgl',
    kernelFunc: $730670272b7fca20$export$6f0f0090e1f6cd3c
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

var $e3269991b1696bfd$export$5245168906ddd3d9;
(function(CumOpType) {
    CumOpType["Prod"] = "*";
    CumOpType["Sum"] = "+";
})($e3269991b1696bfd$export$5245168906ddd3d9 || ($e3269991b1696bfd$export$5245168906ddd3d9 = {}));
class $e3269991b1696bfd$export$6788a4605888e813 {
    constructor(op, outputShape, exclusive, reverse){
        this.op = op;
        this.outputShape = outputShape;
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'index',
                type: 'float'
            }
        ];
        const rank = this.outputShape.length;
        const initVal = this.op === $e3269991b1696bfd$export$5245168906ddd3d9.Prod ? '1.0' : '0.0';
        const val = exclusive ? initVal : `getX(${$e3269991b1696bfd$var$getCoords(rank, 'coords', this.op)})`;
        const length = this.outputShape[this.outputShape.length - 1];
        let condition = '';
        let idxString = '';
        // When exclusive is set, the cum op becomes roll op that copies the
        // value from the previous index based on the direction specified by the
        // reverse flag.
        if (exclusive) {
            condition = reverse ? `end != ${length - 1}` : 'end != 0';
            idxString = reverse ? 'end + 1' : 'end - 1';
        } else {
            condition = reverse ? `end + pow2 < ${length}` : 'end >= pow2';
            idxString = reverse ? 'end + pow2' : 'end - pow2';
        }
        this.userCode = `
      void main() {
        ${(0, $a18658cdba53b459$export$859efd105c10c755)(rank)} coords = getOutputCoords();
        int end = ${$e3269991b1696bfd$var$getFinalCoord(rank, 'coords', this.op)};
        float val = ${val};
        int pow2 = int(pow(2.0, index));
        if (${condition}) {
          int idx = ${idxString};
          ${$e3269991b1696bfd$var$getFinalCoord(rank, 'coords', this.op)} = idx;
          val ${this.op}= getX(${$e3269991b1696bfd$var$getCoords(rank, 'coords', this.op)});
        }
        setOutput(val);
      }
    `;
    }
}
function $e3269991b1696bfd$var$getCoords(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.x, ${name}.y`;
    else if (rank === 3) return `${name}.x, ${name}.y, ${name}.z`;
    else if (rank === 4) return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}
function $e3269991b1696bfd$var$getFinalCoord(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.y`;
    else if (rank === 3) return `${name}.z`;
    else if (rank === 4) return `${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $839bbeb354f95262$export$88973bdd32b5a724(op, x, backend, axis, exclusive, reverse) {
    const xRank = x.shape.length;
    const permutation = (0, $f35e0c1a651337db$exports).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) permutedX = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $f35e0c1a651337db$exports).getInnerMostAxes(1, xRank)[0];
    if (permutedAxis !== xRank - 1) throw new Error(`WebGL cumprod shader expects an inner-most axis=${x.shape.length - 1} ` + `but got axis=${axis}`);
    const size = permutedX.shape[permutedAxis];
    let result = (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: permutedX
        },
        backend: backend
    });
    // Use cum parallel algorithm, inspired by:
    // https://developer.nvidia.com/gpugems/gpugems3/part-vi-gpu-computing/chapter-39-parallel-prefix-sum-scan-cuda
    // Note: although the algorithm is called sum, it works for any associtative
    // operator with an identity.
    for(let i = 0; i <= Math.ceil(Math.log2(size)) - 1; i++){
        const program = new (0, $e3269991b1696bfd$export$6788a4605888e813)(op, permutedX.shape, false, reverse);
        const customValues = [
            [
                i
            ]
        ];
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype, customValues);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    // For exclusive cum, shift the end result in the direction of product or sum
    // and add 1 for product or 0 for sum to the front index.
    if (exclusive) {
        const program = new (0, $e3269991b1696bfd$export$6788a4605888e813)(op, permutedX.shape, exclusive, reverse);
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    if (permutation != null) {
        const reversePermutation = (0, $f35e0c1a651337db$exports).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo(permutedX);
        return reverseTransposedResult;
    }
    return result;
}


function $1986a8584298489b$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $839bbeb354f95262$export$88973bdd32b5a724)((0, $e3269991b1696bfd$export$5245168906ddd3d9).Prod, x, backend, axis, exclusive, reverse);
}
const $1986a8584298489b$export$db50d81ed60c5a35 = {
    kernelName: (0, $507890e4aa8e1463$export$e581acc6014c47a),
    backendName: 'webgl',
    kernelFunc: $1986a8584298489b$export$dc7513e907e94b8d
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $4592fa10e21b38aa$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $839bbeb354f95262$export$88973bdd32b5a724)((0, $e3269991b1696bfd$export$5245168906ddd3d9).Sum, x, backend, axis, exclusive, reverse);
}
const $4592fa10e21b38aa$export$2f6196f3316e7ed2 = {
    kernelName: (0, $507890e4aa8e1463$export$706617d894ad63da),
    backendName: 'webgl',
    kernelFunc: $4592fa10e21b38aa$export$71990b1e1c4912fe
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $dbfad14251be08d2$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.readSync(x.dataId);
        const weightsVals = backend.readSync(weights.dataId);
        const outVals = (0, $1cec302811203101$export$566def819e5d4601)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $1cec302811203101$export$447b89266e53682e)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $dbfad14251be08d2$export$88ba267b84334692 = {
    kernelName: (0, $507890e4aa8e1463$export$5bab6834954299c5),
    backendName: 'webgl',
    kernelFunc: $dbfad14251be08d2$export$436934e6cf1946f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $820d9d38b6881296$export$eb07f17369165f28 {
    constructor(outputShape, blockSize, dataFormat){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.outputShape = outputShape;
        this.blockSize = blockSize;
        this.dataFormat = dataFormat;
        this.userCode = `
    void main() {
      ivec4 coords = getOutputCoords();
      int b = coords[0];
      int h = ${this.getHeightCoordString()};
      int w = ${this.getWidthCoordString()};
      int d = ${this.getDepthCoordString()};

      int in_h = h / ${blockSize};
      int offset_h = imod(h, ${blockSize});
      int in_w = w / ${blockSize};
      int offset_w = imod(w, ${blockSize});
      int offset_d = (offset_h * ${blockSize} + offset_w) *
        ${this.getOutputDepthSize()};
      int in_d = d + offset_d;

      float result = ${this.getInputSamplingString()};
      setOutput(result);
    }
  `;
    }
    getHeightCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[1]`;
        else return `coords[2]`;
    }
    getWidthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[2]`;
        else return `coords[3]`;
    }
    getDepthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[3]`;
        else return `coords[1]`;
    }
    getOutputDepthSize() {
        if (this.dataFormat === 'NHWC') return this.outputShape[3];
        else return this.outputShape[1];
    }
    getInputSamplingString() {
        if (this.dataFormat === 'NHWC') return `getX(b, in_h, in_w, in_d)`;
        else return `getX(b, in_d, in_h, in_w)`;
    }
}


function $809947e6cef82232$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    const batchSize = x.shape[0];
    const inputHeight = dataFormat === 'NHWC' ? x.shape[1] : x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? x.shape[2] : x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? x.shape[3] : x.shape[1];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const outputShape = dataFormat === 'NHWC' ? [
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ] : [
        batchSize,
        outputDepth,
        outputHeight,
        outputWidth
    ];
    const program = new (0, $820d9d38b6881296$export$eb07f17369165f28)(outputShape, blockSize, dataFormat);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $809947e6cef82232$export$9c5b88dcb1d2008b = {
    kernelName: (0, $507890e4aa8e1463$export$fb0ee52d0cd6f233),
    backendName: 'webgl',
    kernelFunc: $809947e6cef82232$export$3b50daec0f185f12
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $1d3431b176454c6b$export$4ead5a4ba22ede40 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};

        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * dilations[0];

          if (xR < 0 || xR >= inDims[0]) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * dilations[1];

            if (xC < 0 || xC >= inDims[1]) {
              continue;
            }

            float xVal = getX(batch, xR, xC, d1);
            float wVal = getW(wR, wC, d1, q);
            dotProd += xVal * wVal;
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $c18dade22d4a3685$export$acb9287627a2b170 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $ea5724662c9cdeb8$export$5acc770fc06a0138)(this.outputShape.length);
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
      int xR; int xC; int xCOffset;
      vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          vec4 xTexelC${c * 2};
          int xTexelC${c * 2}Ready;
          vec4 xTexelC${c * 2 + 1};
          int xTexelC${c * 2 + 1}Ready;
          vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
    for (int r = 0; r < ${filterHeight}; r++) {
      `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          xTexelC${c * 2} = vec4(0.0);
          xTexelC${c * 2}Ready = 0;
          xTexelC${c * 2 + 1} = vec4(0.0);
          xTexelC${c * 2 + 1}Ready = 0;
          xC${c} = vec4(0.0);`;
        mainLoop += `
        xR = xRCorner + r * dilations[0];
        if (xR >=0 && xR < inDims[0]) {
      `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
          xC = xCCorner + ${colIndex * dilationWidth};
          `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                xCOffset = xC + 1;
                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }
              `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                `;
                        else mainLoop += `
                  xCOffset = xC + 1 - 2;

                  if (xCOffset >= 0 && xCOffset < inDims[1]) {
                    previous = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      previous.zw = vec2(0.0);
                    }

                    xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                  } else {
                    xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                  }
                  `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xC${colIndex} = xTexelC${colIndex};
                `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $0775da5e684c8c0d$exports).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                  xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                    xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      xTexelC${colIndex + 1}.zw = vec2(0.0);
                    }
                    xTexelC${colIndex + 1}Ready = 1;
                  }
                  `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                    xCOffset -= 2;
                    if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);
                     xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                    } else {
                     xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                    }
                    `;
                            else mainLoop += `
                    xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                    `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                    xC${colIndex + 1} = xTexelC${colIndex};
                    `;
                        else mainLoop += `
                    xCOffset = xC + ${nextTexelOffset};

                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                      xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                      if (xCOffset + 1 >= inDims[1]) {
                        xTexelC${colIndex + 1}.zw = vec2(0.0);
                      }
                      xTexelC${colIndex + 1}Ready = 1;
                    }

                    xC${colIndex + 1} = xTexelC${colIndex + 1};
                    `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                xCOffset = xC + 1 - strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xC + 2 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  final = vec4(0.0);
                  xCOffset = xC + 1 + strides[1];
                  if(xCOffset >= 0 && xCOffset < inDims[1]) {
                    final = getX(batch, xR, xCOffset, d1);
                  }
                  xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                `;
                } else {
                    mainLoop += `
                if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xCOffset = xC + strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(
                  xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
            wTexel = getW(r, ${colIndex}, d1, q);
            dotProd += xC${colIndex} * vec4(wTexel.xz, wTexel.xz);
          `;
                if (colIndex + 1 < filterWidth) mainLoop += `
              wTexel = getW(r, ${colIndex + 1}, d1, q);
              dotProd += xC${colIndex + 1} * vec4(wTexel.xz, wTexel.xz);
            `;
            }
        }
        mainLoop += `
    }
  `;
        mainLoop += `
      }
    `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
        vec4 dotProd = vec4(0.000000000000001);

        ${mainLoop}

        vec4 result = dotProd - vec4(0.000000000000001);
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}


function $c27a68ca8c416df2$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    let program;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1) program = new (0, $c18dade22d4a3685$export$acb9287627a2b170)(convInfo);
    else program = new (0, $1d3431b176454c6b$export$4ead5a4ba22ede40)(convInfo);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32', customValues);
}
const $c27a68ca8c416df2$export$240667804b7c390e = {
    kernelName: (0, $507890e4aa8e1463$export$7c0fc590ff9e156f),
    backendName: 'webgl',
    kernelFunc: $c27a68ca8c416df2$export$14e793fe8822afd1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $2c4904d9ea69bc6c$export$9f5b7866589daeae {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int dm = coords.w;
        int d2 = d1 * ${channelMul} + dm;

        float dotProd = 0.0;

        // TO DO: Vec4 over the batch size
        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $2c4904d9ea69bc6c$export$9b7e054f73b1374b {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];
        ivec2 dyCorner = coords.yz - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        float dotProd = 0.0;

        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            // TO DO: Vec4 over the channelMul
            for (int dm = 0; dm < ${channelMul}; dm++) {
              int d2 = d1 * ${channelMul} + dm;
              float xValue = getDy(batch, idyR, idyC, d2);
              float wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


function $205df477dfbf9a46$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $2c4904d9ea69bc6c$export$9f5b7866589daeae)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $205df477dfbf9a46$export$30bc0ac3775583fc = {
    kernelName: (0, $507890e4aa8e1463$export$c99f139e0d4d1833),
    backendName: 'webgl',
    kernelFunc: $205df477dfbf9a46$export$cc0ae65e9edc7e1a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $f4b20c9bea72245e$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $2c4904d9ea69bc6c$export$9b7e054f73b1374b)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $f4b20c9bea72245e$export$55d12409e744bebe = {
    kernelName: (0, $507890e4aa8e1463$export$8649ca3b17033a24),
    backendName: 'webgl',
    kernelFunc: $f4b20c9bea72245e$export$37e2ab95a4a4c24b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $2ece59b5c7652d8d$export$d3d3824ae4245092 {
    constructor(size){
        this.variableNames = [
            'X'
        ];
        this.outputShape = [
            size,
            size
        ];
        this.userCode = `
      void main() {
          ivec2 coords = getOutputCoords();
          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;
          setOutput(val);
      }
    `;
    }
}



function $b43cd568e2967973$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const flat = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                xSize
            ]
        }
    });
    const program = new (0, $2ece59b5c7652d8d$export$d3d3824ae4245092)(xSize);
    const res = backend.runWebGLProgram(program, [
        flat
    ], flat.dtype);
    const out = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(flat);
    backend.disposeIntermediateTensorInfo(res);
    return out;
}
const $b43cd568e2967973$export$56dc5d812a22748f = {
    kernelName: (0, $507890e4aa8e1463$export$ca73a25315ddeb7f),
    backendName: 'webgl',
    kernelFunc: $b43cd568e2967973$export$c042e7c2f59bc046
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d7b739572c5215b0$export$b3acfd0493b4c03e {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const { inHeight: inHeight, inWidth: inWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth } = convInfo;
        const { top: padTop, left: padLeft } = padInfo;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float neg_infinity = -3.4e38;

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.w;
        ivec2 outTopLeftCorner =
            coords.yz * strides - pads;
        int hBeg = outTopLeftCorner.x;
        int wBeg = outTopLeftCorner.y;

        float curVal = neg_infinity;
        for (int h = 0; h < ${filterHeight}; h++) {
          int hIn = hBeg + h * ${dilationHeight};

          if (hIn >= 0 && hIn < ${inHeight}) {
            for (int w = 0; w < ${filterWidth}; w++) {
              int wIn = wBeg + w * ${dilationWidth};

              if (wIn >= 0 && wIn < ${inWidth}) {
                float xVal = getX(batch, hIn, wIn, d1);
                float wVal = getW(h, w, d1);

                float val = xVal + wVal;
                if (val > curVal) {
                  curVal = val;
                }
              }
            }
          }
        }

        float result = curVal;
        setOutput(result);
      }
    `;
    }
}



function $74c153cef2074155$export$544ec6096a7ab30(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    let out;
    const program = new (0, $d7b739572c5215b0$export$b3acfd0493b4c03e)(convInfo);
    out = backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
    const outReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $74c153cef2074155$export$36d3c11f61a8891a = {
    kernelName: (0, $507890e4aa8e1463$export$dbbb7830c6497701),
    backendName: 'webgl',
    kernelFunc: $74c153cef2074155$export$544ec6096a7ab30
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




function $c7b47b0fcf5efe3c$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $f35e0c1a651337db$exports).decodeEinsumEquation(equation, tensors.length);
    (0, $f35e0c1a651337db$exports).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $f35e0c1a651337db$exports).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $f35e0c1a651337db$exports).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $f35e0c1a651337db$exports).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $0775da5e684c8c0d$exports).arraysEqual(x.shape, targetShape)) {
                x = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $951ae52c1905ecdf$export$2060d2db72cce88f)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $0082ed6af416fef1$export$8a63f25cc62965f1)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $c7b47b0fcf5efe3c$export$40bbf341885a23b7 = {
    kernelName: (0, $507890e4aa8e1463$export$2541d8be32f3c641),
    backendName: 'webgl',
    kernelFunc: $c7b47b0fcf5efe3c$export$27265e7daac5c403
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $e67e670418ba0ac4$var$ELU = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $e67e670418ba0ac4$var$ELU_PACKED = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $e67e670418ba0ac4$var$elu = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $e67e670418ba0ac4$var$ELU,
    packedOpSnippet: $e67e670418ba0ac4$var$ELU_PACKED
});
const $e67e670418ba0ac4$export$b990686634ee3cce = {
    kernelName: (0, $507890e4aa8e1463$export$64636e173424d83d),
    backendName: 'webgl',
    kernelFunc: $e67e670418ba0ac4$var$elu
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $b7cec932ff04e96c$var$ELU_DER = `return (b >= 0.0) ? a : a * (b + 1.0);`;
const $b7cec932ff04e96c$var$ELU_DER_PACKED = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $b7cec932ff04e96c$export$a346244024505ff9 = (args)=>{
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $845a6b9d98d1f900$export$7ef3bdc75c177be0)($b7cec932ff04e96c$var$ELU_DER_PACKED, dy.shape, y.shape) : new (0, $6e99a2fc879307b0$export$9045e9161086790b)($b7cec932ff04e96c$var$ELU_DER, dy.shape, y.shape);
    return backend.runWebGLProgram(program, [
        dy,
        y
    ], dy.dtype);
};
const $b7cec932ff04e96c$export$59bb07dd04647a1d = {
    kernelName: (0, $507890e4aa8e1463$export$9906be4699a73c53),
    backendName: 'webgl',
    kernelFunc: $b7cec932ff04e96c$export$a346244024505ff9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $d2569824a1e7c5de$var$PACKED_EQUAL = `
  return vec4(equal(a, b));
`;
const $d2569824a1e7c5de$var$EQUAL = `return float(a == b);`;
const $d2569824a1e7c5de$export$411ce8e5a71e3069 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $d2569824a1e7c5de$var$EQUAL,
    packedOpSnippet: $d2569824a1e7c5de$var$PACKED_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $1cec302811203101$export$13d1298222b29d06)
});
const $d2569824a1e7c5de$export$3c8bc3d8ee318217 = {
    kernelName: (0, $507890e4aa8e1463$export$8dcf9f58ce5cdfc),
    backendName: 'webgl',
    kernelFunc: $d2569824a1e7c5de$export$411ce8e5a71e3069
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $c69f458d2b03591c$var$ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  float p = ${(0, $f35e0c1a651337db$exports).ERF_P};
  float a1 = ${(0, $f35e0c1a651337db$exports).ERF_A1};
  float a2 = ${(0, $f35e0c1a651337db$exports).ERF_A2};
  float a3 = ${(0, $f35e0c1a651337db$exports).ERF_A3};
  float a4 = ${(0, $f35e0c1a651337db$exports).ERF_A4};
  float a5 = ${(0, $f35e0c1a651337db$exports).ERF_A5};

  float sign = sign(x);
  x = abs(x);
  float t = 1.0 / (1.0 + p * x);
  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));
`;
const $c69f458d2b03591c$export$d3896f355fc09423 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $c69f458d2b03591c$var$ERF
});
const $c69f458d2b03591c$export$d044ffef16079bd = {
    kernelName: (0, $507890e4aa8e1463$export$c2ee2551ce71f1d0),
    backendName: 'webgl',
    kernelFunc: $c69f458d2b03591c$export$d3896f355fc09423
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $be243d168303c1ee$export$e17bfbab9ca97165 = (0, $d770bb96fbeee88f$export$bf39b1cb254b6187) + `
  return exp(x);
`;
const $be243d168303c1ee$var$EXP_PACKED = `
  vec4 result = exp(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $be243d168303c1ee$export$b310ec824aaee37f = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $be243d168303c1ee$export$e17bfbab9ca97165,
    packedOpSnippet: $be243d168303c1ee$var$EXP_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$f72e179c9610cb8c),
    dtype: 'float32'
});
const $be243d168303c1ee$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $507890e4aa8e1463$export$f908be7a96fb3363),
    backendName: 'webgl',
    kernelFunc: $be243d168303c1ee$export$b310ec824aaee37f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $3e4008b896c924ea$export$d660d8ed21f46635(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { dim: dim } = attrs;
    const { input: input } = inputs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $0775da5e684c8c0d$exports).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $3e4008b896c924ea$export$86341ba0ce5d8e60 = {
    kernelName: (0, $507890e4aa8e1463$export$2391750b1d901146),
    backendName: 'webgl',
    kernelFunc: $3e4008b896c924ea$export$d660d8ed21f46635
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $652f720f0d7ea8db$var$EXPM1 = `return exp(x) - 1.0;`;
const $652f720f0d7ea8db$export$b6c0a80d46d3391d = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $652f720f0d7ea8db$var$EXPM1,
    packedOpSnippet: $652f720f0d7ea8db$var$EXPM1,
    cpuKernelImpl: (0, $1cec302811203101$export$5903785c29f035f5)
});
const $652f720f0d7ea8db$export$16db8a08b36f938 = {
    kernelName: (0, $507890e4aa8e1463$export$261f26143a1ff3),
    backendName: 'webgl',
    kernelFunc: $652f720f0d7ea8db$export$b6c0a80d46d3391d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $ad7b801aa71eae78$export$234ba885e3a114f6 {
    constructor(component, inputShape, inverse){
        this.variableNames = [
            'real',
            'imag'
        ];
        const innerDim = inputShape[1];
        this.outputShape = inputShape;
        const exponentMultiplierSnippet = inverse ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`;
        const resultDenominator = inverse ? `${innerDim}.0` : '1.0';
        let opString;
        if (component === 'real') opString = 'return real * expR - imag * expI;';
        else if (component === 'imag') opString = 'return real * expI + imag * expR;';
        else throw new Error(`FFT component must be either "real" or "imag", got ${component}.`);
        this.userCode = `
      const float exponentMultiplier = ${exponentMultiplierSnippet};

      float unaryOpComplex(float real, float expR, float imag, float expI) {
        ${opString}
      }

      float mulMatDFT(int batch, int index) {
        float indexRatio = float(index) / float(${innerDim});
        float exponentMultiplierTimesIndexRatio =
            exponentMultiplier * indexRatio;

        float result = 0.0;

        for (int i = 0; i < ${innerDim}; i++) {
          // x = (-2|2 * PI / N) * index * i;
          float x = exponentMultiplierTimesIndexRatio * float(i);
          float expR = cos(x);
          float expI = sin(x);
          float real = getReal(batch, i);
          float imag = getImag(batch, i);

          result +=
              unaryOpComplex(real, expR, imag, expI) / ${resultDenominator};
        }

        return result;
      }

      void main() {
        ivec2 coords = getOutputCoords();
        setOutput(mulMatDFT(coords[0], coords[1]));
      }
    `;
    }
}




function $c5e758779a0635e1$export$75d3742a7578721e(x, inverse, backend) {
    const xData = backend.texData.get(x.dataId);
    const inputSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = x.shape[x.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const xShape = input2D.shape;
    const realProgram = new (0, $ad7b801aa71eae78$export$234ba885e3a114f6)('real', xShape, inverse);
    const imagProgram = new (0, $ad7b801aa71eae78$export$234ba885e3a114f6)('imag', xShape, inverse);
    const inputs = [
        {
            dataId: xData.complexTensorInfos.real.dataId,
            dtype: xData.complexTensorInfos.real.dtype,
            shape: xShape
        },
        {
            dataId: xData.complexTensorInfos.imag.dataId,
            dtype: xData.complexTensorInfos.imag.dtype,
            shape: xShape
        }
    ];
    const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
    const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
    const complexOutput = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
        inputs: {
            real: realPart,
            imag: imagPart
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(realPart);
    backend.disposeIntermediateTensorInfo(imagPart);
    const complexOutputReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: complexOutput
        },
        backend: backend,
        attrs: {
            shape: x.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(complexOutput);
    return complexOutputReshaped;
}


function $b42bd72b22df700c$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $c5e758779a0635e1$export$75d3742a7578721e)(input, false, backend);
}
const $b42bd72b22df700c$export$a4d564e380763c78 = {
    kernelName: (0, $507890e4aa8e1463$export$677347237c014ba),
    backendName: 'webgl',
    kernelFunc: $b42bd72b22df700c$export$a535ef183b6128fa
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $2cc43a305c0ef869$export$758181b12323e997 {
    constructor(shape, value){
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.variableNames = [
            'x'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        // Input can be obtained from uniform value.
        setOutput(value);
      }
    `;
    }
}


function $d717ecf39741148f$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value } = attrs;
    let { dtype: dtype } = attrs;
    dtype = dtype || (0, $0775da5e684c8c0d$exports).inferDtype(value);
    if (dtype === 'string') {
        // String type should be handled in CPU memory.
        const values = (0, $0775da5e684c8c0d$exports).getArrayFromDType(dtype, (0, $0775da5e684c8c0d$exports).sizeFromShape(shape));
        values.fill(value);
        return backend.makeTensorInfo(shape, dtype, values);
    } else {
        const program = new (0, $2cc43a305c0ef869$export$758181b12323e997)(shape, value);
        const customValues = [
            [
                value
            ]
        ];
        return backend.runWebGLProgram(program, [], dtype, customValues);
    }
}
const $d717ecf39741148f$export$c953bf474b2bde62 = {
    kernelName: (0, $507890e4aa8e1463$export$ffffe40bfa0649a3),
    backendName: 'webgl',
    kernelFunc: $d717ecf39741148f$export$9563e054e6f787fb
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $05cdd6c53ca96625$export$872622c1de722f28 {
    constructor(imageShape){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];

          int coordX = ${imageWidth} - x - 1;
          float outputValue;
          if(coordX >= 0 && coordX < ${imageWidth}) {
            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);
          } else {
            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}


const $9139e23ca1b31b0f$export$c9ec83cb23304466 = {
    kernelName: (0, $507890e4aa8e1463$export$34e7296fc8558df5),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { image: image } = inputs;
        const webglBackend = backend;
        const program = new (0, $05cdd6c53ca96625$export$872622c1de722f28)(image.shape);
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype);
        return output;
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $82457195349a997e$var$FLOOR = `return floor(x);`;
const $82457195349a997e$export$a3fe094919f356fd = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $82457195349a997e$var$FLOOR,
    packedOpSnippet: $82457195349a997e$var$FLOOR,
    cpuKernelImpl: (0, $1cec302811203101$export$195a28e6add8ab7e)
});
const $82457195349a997e$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $507890e4aa8e1463$export$4880b0ae5643c62b),
    backendName: 'webgl',
    kernelFunc: $82457195349a997e$export$a3fe094919f356fd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

// We use native integer division to deal with floating point imprecision. Since
// we implement floor division and glsl implements truncated division, we
// correct for this by subtracting 1 from result when the result is negative and
// there is a remainder.
const $340be0d6c1d2ebc5$var$INT_DIV = `
  float s = sign(a) * sign(b);
  int ia = round(a);
  int ib = round(b);
  if (ib != 0) {
    // Windows (D3D) wants guaranteed non-zero int division at compile-time.
    return float(idiv(ia, ib, s));
  } else {
    return NAN;
  }
`;
const $340be0d6c1d2ebc5$var$INT_DIV_PACKED = `
  ivec4 ia = round(a);
  ivec4 ib = round(b);
  bvec4 cond = notEqual(ib, ivec4(0));
  ivec4 result = ivec4(0);
  vec4 s = sign(a) * sign(b);

  // Windows (D3D) wants guaranteed non-zero int division at compile-time.
  if (cond[0]) {
    result[0] = idiv(ia[0], ib[0], s[0]);
  }
  if (cond[1]) {
    result[1] = idiv(ia[1], ib[1], s[1]);
  }
  if (cond[2]) {
    result[2] = idiv(ia[2], ib[2], s[2]);
  }
  if (cond[3]) {
    result[3] = idiv(ia[3], ib[3], s[3]);
  }
  return vec4(result);
`;
const $340be0d6c1d2ebc5$export$112397bc52715a8 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $340be0d6c1d2ebc5$var$INT_DIV,
    packedOpSnippet: $340be0d6c1d2ebc5$var$INT_DIV_PACKED,
    dtype: 'int32'
});
const $340be0d6c1d2ebc5$export$7eac933a0c7fd37f = {
    kernelName: (0, $507890e4aa8e1463$export$d79b5692ede26c2f),
    backendName: 'webgl',
    kernelFunc: $340be0d6c1d2ebc5$export$112397bc52715a8
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $91e65fb3364cb7c0$export$7ffba7be7a218615 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${width}.0, ${height}.0);

        vec4 values = ${glsl.texture2D}(A, uv);
        float value;
        if (depth == 0) {
          value = values.r;
        } else if (depth == 1) {
          value = values.g;
        } else if (depth == 2) {
          value = values.b;
        } else if (depth == 3) {
          value = values.a;
        }

        setOutput(floor(value * 255.0 + 0.5));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $fc13aa589bfb2130$export$5f4cf05de268f9cf {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        const glsl = (0, $2a1c84527da6ba7d$export$3ebf4a18d6319f7a)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];

        vec4 result = vec4(0.);

        for(int row=0; row<=1; row++) {
          for(int col=0; col<=1; col++) {
            texC = coords[1] + row;
            depth = coords[2] + col;

            vec2 uv = (vec2(texC, texR) + halfCR) /
                       vec2(${width}.0, ${height}.0);
            vec4 values = ${glsl.texture2D}(A, uv);
            float value;
            if (depth == 0) {
              value = values.r;
            } else if (depth == 1) {
              value = values.g;
            } else if (depth == 2) {
              value = values.b;
            } else if (depth == 3) {
              value = values.a;
            }

            result[row * 2 + col] = floor(value * 255.0 + 0.5);
          }
        }

        ${glsl.output} = result;
      }
    `;
    }
}


const $33f199f68eb498a4$export$b22e14d614fc7178 = {
    kernelName: (0, $507890e4aa8e1463$export$d0eb4e7054966c48),
    backendName: 'webgl',
    kernelFunc: $33f199f68eb498a4$var$fromPixels
};
let $33f199f68eb498a4$var$fromPixels2DContext;
let $33f199f68eb498a4$var$willReadFrequently = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
function $33f199f68eb498a4$var$fromPixels(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    let { pixels: pixels } = inputs;
    const { numChannels: numChannels } = attrs;
    const isVideo = typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement;
    const isImage = typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement;
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    const texShape = [
        height,
        width
    ];
    const outShape = [
        height,
        width,
        numChannels
    ];
    if (isImage || isVideo) {
        const newWillReadFrequently = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
        if ($33f199f68eb498a4$var$fromPixels2DContext == null || newWillReadFrequently !== $33f199f68eb498a4$var$willReadFrequently) {
            $33f199f68eb498a4$var$willReadFrequently = newWillReadFrequently;
            $33f199f68eb498a4$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: $33f199f68eb498a4$var$willReadFrequently
            });
        }
        $33f199f68eb498a4$var$fromPixels2DContext.canvas.width = width;
        $33f199f68eb498a4$var$fromPixels2DContext.canvas.height = height;
        $33f199f68eb498a4$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        pixels = $33f199f68eb498a4$var$fromPixels2DContext.canvas;
    }
    const tempPixelHandle = backend.makeTensorInfo(texShape, 'int32');
    // This is a byte texture with pixels.
    backend.texData.get(tempPixelHandle.dataId).usage = (0, $44ae700445690738$export$6bf4bd1b6beb0bfd).PIXELS;
    backend.gpgpu.uploadPixelDataToTexture(backend.getTexture(tempPixelHandle.dataId), pixels);
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK') ? new (0, $fc13aa589bfb2130$export$5f4cf05de268f9cf)(outShape) : new (0, $91e65fb3364cb7c0$export$7ffba7be7a218615)(outShape);
    const res = backend.runWebGLProgram(program, [
        tempPixelHandle
    ], 'int32');
    backend.disposeData(tempPixelHandle.dataId);
    return res;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





function $682f2e112362089c$export$b4f4a900a93010a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const $dataFormat = (0, $f35e0c1a651337db$exports).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    const intermediates = [];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const prepareInputs = ()=>{
        const inputs = [
            x,
            filter
        ];
        // If the input is a 1-D tensor, align it with the channels.
        //
        // For fusedConv2d, the inputs (x, W, bias, preluActivationWeights) are
        // supposed to be aligned with the dataFormat. The 4-D tensor inputs or
        // scalar inputs are originally aligned, but the 1-D tensor inputs are
        // supposed to be aligned with the channels (only bias and PReLU activation
        // weights could be a 1-D tensor).
        const alignInputWithDataFormat = (input, dataFormat)=>{
            if (dataFormat === 'NCHW' && input.shape.length === 1 && input.shape[0] !== 1) {
                const alignedInput = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: input
                    },
                    backend: backend,
                    attrs: {
                        shape: [
                            input.shape[0],
                            1,
                            1
                        ]
                    }
                });
                intermediates.push(alignedInput);
                return alignedInput;
            }
            return input;
        };
        if (hasBias) inputs.push(alignInputWithDataFormat(bias, dataFormat));
        if (hasPreluActivationWeights) inputs.push(alignInputWithDataFormat(preluActivationWeights, dataFormat));
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $0775da5e684c8c0d$exports).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        return inputs;
    };
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $c178adb7fa42247e$export$fe56ce0f8b4bfd45)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_EXP_CONV')) {
        const fusedActivation = activation ? (0, $d770bb96fbeee88f$export$445d43a4039ec7b7)(activation, true) : null;
        const program = new (0, $998d8c053e2b0fe7$export$20f35e9a79361289)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32', customValues);
    } else if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_CONV_IM2COL')) out = (0, $c178adb7fa42247e$export$65b699e5c77381b8)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else {
        const fusedActivation = activation ? (0, $d770bb96fbeee88f$export$445d43a4039ec7b7)(activation, false) : null;
        const program = new (0, $da51f18d98bfd59c$export$8dc36706147178e9)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32');
    }
    const outReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(out);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outReshaped;
}
const $682f2e112362089c$export$5b64efa829ddf94e = {
    kernelName: (0, $507890e4aa8e1463$export$86f8a8e3a8f2a8f2),
    backendName: 'webgl',
    kernelFunc: $682f2e112362089c$export$b4f4a900a93010a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $2d2e6fbf41af95a2$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const intermediates = [];
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $f35e0c1a651337db$exports).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const shouldPackDepthwiseConv = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1;
    const fusedActivation = activation ? (0, $d770bb96fbeee88f$export$445d43a4039ec7b7)(activation, shouldPackDepthwiseConv) : null;
    const programInputs = [
        x,
        filter
    ];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    if (hasBias) programInputs.push(bias);
    if (hasPreluActivationWeights) programInputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $0775da5e684c8c0d$exports).createScalarValue(leakyreluAlpha, 'float32'));
        programInputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    let program;
    if (shouldPackDepthwiseConv) program = new (0, $c18dade22d4a3685$export$acb9287627a2b170)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    else program = new (0, $1d3431b176454c6b$export$4ead5a4ba22ede40)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    const result = backend.runWebGLProgram(program, programInputs, 'float32', customValues);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $2d2e6fbf41af95a2$export$58481cc3409b412c = {
    kernelName: (0, $507890e4aa8e1463$export$5a249e8f498c02c1),
    backendName: 'webgl',
    kernelFunc: $2d2e6fbf41af95a2$export$d61de7729228094b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $0562648c8668ebea$export$ffd508d535a7dba1 {
    constructor(sliceDim, strides, shape, paramsShape){
        this.sliceDim = sliceDim;
        this.strides = strides;
        this.paramsShape = paramsShape;
        this.variableNames = [
            'x',
            'indices'
        ];
        this.outputShape = shape;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(shape.length);
        let mainLoop = `
    int index;`;
        for(let j = 0; j < this.sliceDim; j++)mainLoop += `
          index = round(getIndices(coords[0], ${j}));
          out_of_bounds = out_of_bounds || index < 0;
          out_of_bounds = out_of_bounds || index >= ${this.paramsShape[j]};
          flattenIndex += index * ${this.strides[j]};`;
        this.userCode = `
         void main() {
          ${dtype} coords = getOutputCoords();
          int flattenIndex = 0;
          bool out_of_bounds = false;

          ${mainLoop}

          setOutput(out_of_bounds ? 0.0 : getX(flattenIndex, coords[1]));
        }
      `;
    }
}




function $48996d80d58aef83$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const paramsSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(params.shape);
    const [resultShape, numSlices, sliceSize, strides] = (0, $f35e0c1a651337db$exports).prepareAndValidate(params, indices);
    const flattenIndices = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numSlices,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: params
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $0775da5e684c8c0d$exports).sizeFromShape(params.shape) / sliceSize,
                sliceSize
            ]
        }
    });
    if (backend.shouldExecuteOnCPU([
        params,
        indices
    ]) || params.dtype === 'string') {
        const indicesData = backend.readSync(indices.dataId);
        const paramsBuf = backend.bufferSync(params);
        const outValue = (0, $1cec302811203101$export$e3196a12dce24214)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
        return backend.makeTensorInfo(resultShape, params.dtype, outValue.values);
    }
    const program = new (0, $0562648c8668ebea$export$ffd508d535a7dba1)(sliceRank, strides, [
        numSlices,
        sliceSize
    ], params.shape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices
    ], flattenX.dtype);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: resultShape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $48996d80d58aef83$export$d9700eb1c7f5c969 = {
    kernelName: (0, $507890e4aa8e1463$export$4ef6e37a23721703),
    backendName: 'webgl',
    kernelFunc: $48996d80d58aef83$export$3c586830e482d2b9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $efe9f8fb0e869dcb$export$e8921930334c8ed5 {
    constructor(aShape, outputShape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
        const sourceCoords = $efe9f8fb0e869dcb$var$getSourceCoords(aShape, 2);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        int index = int(getIndices(resRC.x, resRC.z));
        float inBounds = (index >= 0) && (index < ${aShape[2]}) ? 1.0 : 0.0;
        setOutput(inBounds * getA(${sourceCoords}));
      }
    `;
    }
}
// The input and output are always flattened into rank 4 tensors.
function $efe9f8fb0e869dcb$var$getSourceCoords(aShape, axis) {
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)if (i === 2) sourceCoords.push('index');
    else sourceCoords.push(`${currentCoords[i]}`);
    return sourceCoords.join();
}




function $0c5a2f4de81ea707$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    const parsedAxis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape)[0];
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().get('DEBUG')) {
        // In debug mode, throw error when any index is out of bound.
        // Otherwise, just fill out of bounds with zeroes.
        const indicesVals = backend.readSync(indices.dataId);
        const axisDim = x.shape[parsedAxis];
        for(let i = 0; i < indicesVals.length; ++i){
            const index = indicesVals[i];
            (0, $0775da5e684c8c0d$exports).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
        }
    }
    const shapeInfo = (0, $f35e0c1a651337db$exports).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, batchDims);
    const indicesSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(indices.shape);
    const toDispose = [];
    const flattenX = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    toDispose.push(flattenX);
    toDispose.push(flattenIndex);
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    if (backend.shouldExecuteOnCPU([
        x,
        indices
    ]) || x.dtype === 'string') {
        const indicesBuf = backend.bufferSync(flattenIndex);
        const xBuf = backend.bufferSync(flattenX);
        const outBuf = (0, $1cec302811203101$export$cffe0fde89e98de6)(xBuf, indicesBuf, flattenOutputShape);
        toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $efe9f8fb0e869dcb$export$e8921930334c8ed5)(flattenX.shape, flattenOutputShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndex
    ], flattenX.dtype);
    toDispose.push(res);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shapeInfo.outputShape
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return reshaped;
}
const $0c5a2f4de81ea707$export$b1bd3139c91d8765 = {
    kernelName: (0, $507890e4aa8e1463$export$ccd988942e5c0181),
    backendName: 'webgl',
    kernelFunc: $0c5a2f4de81ea707$export$3d75b4295ded9925
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $4f66b7828c9623b6$var$GREATER = `return float(a > b);`;
const $4f66b7828c9623b6$var$GREATER_PACKED = `
  return vec4(greaterThan(a, b));
`;
const $4f66b7828c9623b6$export$9dca161faaf6308b = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $4f66b7828c9623b6$var$GREATER,
    packedOpSnippet: $4f66b7828c9623b6$var$GREATER_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$eabb8927944259dd),
    dtype: 'bool'
});
const $4f66b7828c9623b6$export$8c4f7e92d92310f8 = {
    kernelName: (0, $507890e4aa8e1463$export$d0a25eac5ee3f515),
    backendName: 'webgl',
    kernelFunc: $4f66b7828c9623b6$export$9dca161faaf6308b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $66397ffc843f3402$var$GREATER_EQUAL = `return float(a >= b);`;
const $66397ffc843f3402$var$GREATER_EQUAL_PACKED = `
  return vec4(greaterThanEqual(a, b));
`;
const $66397ffc843f3402$export$c2fd4164cadc1fa2 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $66397ffc843f3402$var$GREATER_EQUAL,
    packedOpSnippet: $66397ffc843f3402$var$GREATER_EQUAL_PACKED,
    dtype: 'bool',
    cpuKernelImpl: (0, $1cec302811203101$export$a3d2e203d979d298)
});
const $66397ffc843f3402$export$7a6926f9fcac24ca = {
    kernelName: (0, $507890e4aa8e1463$export$3b7d21bc9aee0851),
    backendName: 'webgl',
    kernelFunc: $66397ffc843f3402$export$c2fd4164cadc1fa2
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $ae59ba4b2df78447$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $c5e758779a0635e1$export$75d3742a7578721e)(input, true, backend);
}
const $ae59ba4b2df78447$export$dc267425bf21b465 = {
    kernelName: (0, $507890e4aa8e1463$export$21c6f576ae8100e8),
    backendName: 'webgl',
    kernelFunc: $ae59ba4b2df78447$export$776649b0bf8ce1fd
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $bdb077694402852d$var$IS_FINITE = `return float(!isnan(x) && !isinf(x));`;
const $bdb077694402852d$export$65f0b13f2f82375a = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $bdb077694402852d$var$IS_FINITE,
    dtype: 'bool'
});
const $bdb077694402852d$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $507890e4aa8e1463$export$b9fcc0946d7d485e),
    backendName: 'webgl',
    kernelFunc: $bdb077694402852d$export$65f0b13f2f82375a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $6d6163a26e43f0d4$var$IS_INF = `return float(isinf(x));`;
const $6d6163a26e43f0d4$export$e5d3415c656f7096 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $6d6163a26e43f0d4$var$IS_INF,
    dtype: 'bool'
});
const $6d6163a26e43f0d4$export$bc383b82282e9b5a = {
    kernelName: (0, $507890e4aa8e1463$export$74b5a3bc735b152),
    backendName: 'webgl',
    kernelFunc: $6d6163a26e43f0d4$export$e5d3415c656f7096
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $96d61689af2c5138$var$IS_NAN = `return float(isnan(x));`;
const $96d61689af2c5138$export$c9f5652083b8129d = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $96d61689af2c5138$var$IS_NAN,
    dtype: 'bool'
});
const $96d61689af2c5138$export$d58ff790c765c1f0 = {
    kernelName: (0, $507890e4aa8e1463$export$9912dc4fc649dbec),
    backendName: 'webgl',
    kernelFunc: $96d61689af2c5138$export$c9f5652083b8129d
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $e1ad69f7f2932036$var$LESS = `return float(a < b);`;
const $e1ad69f7f2932036$var$LESS_PACKED = `
  return vec4(lessThan(a, b));
`;
const $e1ad69f7f2932036$export$bb1a638da8ad190f = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $e1ad69f7f2932036$var$LESS,
    packedOpSnippet: $e1ad69f7f2932036$var$LESS_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$74c893b3c5e74e60),
    dtype: 'bool'
});
const $e1ad69f7f2932036$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $507890e4aa8e1463$export$728c50f1c88ac779),
    backendName: 'webgl',
    kernelFunc: $e1ad69f7f2932036$export$bb1a638da8ad190f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $287f091a50eac9b7$export$8342242c3b80421d = `return float(a <= b);`;
const $287f091a50eac9b7$export$b12559c17f42d056 = `
  return vec4(lessThanEqual(a, b));
`;
const $287f091a50eac9b7$export$c24ad19a692bb92 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $287f091a50eac9b7$export$8342242c3b80421d,
    packedOpSnippet: $287f091a50eac9b7$export$b12559c17f42d056,
    cpuKernelImpl: (0, $1cec302811203101$export$6d1533a3ea9565f),
    dtype: 'bool'
});
const $287f091a50eac9b7$export$9f26bd257393dd8 = {
    kernelName: (0, $507890e4aa8e1463$export$84afd0d8f7fb8c5d),
    backendName: 'webgl',
    kernelFunc: $287f091a50eac9b7$export$c24ad19a692bb92
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $729197add8ee611f$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    // TODO: Use CPU implementation due to the precision problem in Safari.
    const outVals = (0, $1cec302811203101$export$c86a2be8970d7a7d)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $729197add8ee611f$export$46b96f742c70959b = {
    kernelName: (0, $507890e4aa8e1463$export$34f0ab8eba543ee6),
    backendName: 'webgl',
    kernelFunc: $729197add8ee611f$export$865a19adce4d7a46
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


// Windows chrome return 0 if the input is negative value. We will specifically
// return NaN if the input is 0 to solve compatiblity issue.
const $12444958de76b521$var$LOG = (0, $d770bb96fbeee88f$export$bf39b1cb254b6187) + `
  return x < 0.0 ? 0./0. : log(x);
`;
const $12444958de76b521$var$LOG_PACKED = `
  vec4 result = log(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);
  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);
  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);
  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);
  return result;
`;
const $12444958de76b521$export$bef1f36f5486a6a3 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $12444958de76b521$var$LOG,
    packedOpSnippet: $12444958de76b521$var$LOG_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$e88dde64a338f813)
});
const $12444958de76b521$export$a4ae1f00643ddd14 = {
    kernelName: (0, $507890e4aa8e1463$export$ce30dbb46644d06c),
    backendName: 'webgl',
    kernelFunc: $12444958de76b521$export$bef1f36f5486a6a3
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $14f27cac6505d0dd$var$LOG1P = (0, $d770bb96fbeee88f$export$bf39b1cb254b6187) + `
  return log(1.0 + x);
`;
const $14f27cac6505d0dd$export$144dcf16adfb9698 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $14f27cac6505d0dd$var$LOG1P
});
const $14f27cac6505d0dd$export$c458b9e5ba980198 = {
    kernelName: (0, $507890e4aa8e1463$export$70f05bf9ddcfca68),
    backendName: 'webgl',
    kernelFunc: $14f27cac6505d0dd$export$144dcf16adfb9698
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $df613d0358d5aed0$var$LOGICAL_AND = `return float(a >= 1.0 && b >= 1.0);`;
const $df613d0358d5aed0$var$LOGICAL_AND_PACKED = `
  return vec4(
    vec4(greaterThanEqual(a, vec4(1.0))) *
    vec4(greaterThanEqual(b, vec4(1.0))));
`;
const $df613d0358d5aed0$export$db5dd0ef9d505f = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $df613d0358d5aed0$var$LOGICAL_AND,
    packedOpSnippet: $df613d0358d5aed0$var$LOGICAL_AND_PACKED,
    dtype: 'bool'
});
const $df613d0358d5aed0$export$257f1e82e69113fb = {
    kernelName: (0, $507890e4aa8e1463$export$8a27ff10dff4d6e5),
    backendName: 'webgl',
    kernelFunc: $df613d0358d5aed0$export$db5dd0ef9d505f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $6a4c6684daa7041f$var$LOGICAL_NOT = `return float(!(x >= 1.0));`;
const $6a4c6684daa7041f$export$c836ff7b605b1617 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $6a4c6684daa7041f$var$LOGICAL_NOT
});
const $6a4c6684daa7041f$export$68e2dd0840056271 = {
    kernelName: (0, $507890e4aa8e1463$export$4393bee5596c68c2),
    backendName: 'webgl',
    kernelFunc: $6a4c6684daa7041f$export$c836ff7b605b1617
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $6ccef36c3249ec61$var$LOGICAL_OR = `return float(a >= 1.0 || b >= 1.0);`;
const $6ccef36c3249ec61$var$LOGICAL_OR_PACKED = `
  return min(
    vec4(greaterThanEqual(a, vec4(1.0))) +
    vec4(greaterThanEqual(b, vec4(1.0))),
    vec4(1.0));
`;
const $6ccef36c3249ec61$export$e2a73975983cadd8 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $6ccef36c3249ec61$var$LOGICAL_OR,
    packedOpSnippet: $6ccef36c3249ec61$var$LOGICAL_OR_PACKED,
    dtype: 'bool'
});
const $6ccef36c3249ec61$export$ce04b6546987ef43 = {
    kernelName: (0, $507890e4aa8e1463$export$c49f9f5ffc6f678c),
    backendName: 'webgl',
    kernelFunc: $6ccef36c3249ec61$export$e2a73975983cadd8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $47a3e00d2eb7c08a$export$2214c2ca22968528 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];
        int d = coords[3];
        float x = getX(b, r, c, d);
        float sum = 0.0;
        for (int j = -${rad}; j <= ${rad}; j++) {
          int idx = d + j;
          if (idx >= 0 && idx <=  ${maxD}) {
            float z = getX(b, r, c, idx);
            sum += z * z;
          }
        }
        float val = x * ${powOperator};
        setOutput(val);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $8c6d8f3937a9dffb$export$3942340f6b6d7fe9 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords.x;
        int r = coords.y;
        int c = coords.z;
        int d = coords.w;

        bool hasNextCol = d < ${this.outputShape[3]};
        bool hasNextRow = c < ${this.outputShape[2]};

        vec4 sum = vec4(0.);
        vec4 xFragAtOutputCoords = getX(b, r, c, d);

        vec4 xAtOutputCoords = vec4(
          getChannel(xFragAtOutputCoords, vec2(c, d)),
          hasNextCol ?
            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,
          hasNextRow ?
            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,
          (hasNextRow && hasNextCol) ?
            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0
        );

        int firstChannel = d - ${rad};
        vec2 cache = vec2(0.);
        if(firstChannel >= 0){
          vec4 firstChannelFrag = getX(b, r, c, firstChannel);
          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));
            if(hasNextRow){
              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));
            }
        }

        ivec2 depth = ivec2(d, d + 1);
        for (int j = - ${rad}; j <= ${rad}; j++) {
          ivec2 idx = depth + j;
          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));
          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${maxD}));

          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;
          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;

          if(depthInRange || depthPlusOneInRange){
            vec4 z = vec4(0.);
            vec4 xFragAtCurrentDepth;
            z.xz = cache.xy;
            if(depthPlusOneInRange && hasNextCol){
              xFragAtCurrentDepth = idx.y != d ?
                getX(b, r, c, idx.y) : xFragAtOutputCoords;
              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));
              if(hasNextRow){
                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));
              }
            }
            cache.xy = z.yw;
            sum += z * z;
          }
        }
        vec4 result = xAtOutputCoords * ${powOperator};
        setOutput(result);
      }
    `;
    }
}


const $9dc39364e74cd2aa$export$4e4a7896ae51c2f1 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $8c6d8f3937a9dffb$export$3942340f6b6d7fe9)(x.shape, depthRadius, bias, alpha, beta) : new (0, $47a3e00d2eb7c08a$export$2214c2ca22968528)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
};
const $9dc39364e74cd2aa$export$6fb124d5a6994734 = {
    kernelName: (0, $507890e4aa8e1463$export$eb2f713fc3e1ca9a),
    backendName: 'webgl',
    kernelFunc: $9dc39364e74cd2aa$export$4e4a7896ae51c2f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $ab475a4a98ed809d$export$f121c71e68d75e {
    constructor(inputShape, depthRadius, bias, alpha, beta){
        this.variableNames = [
            'inputImage',
            'outputImage',
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        this.depth = inputShape[3];
        this.depthRadius = depthRadius;
        this.bias = bias;
        this.alpha = alpha;
        this.beta = beta;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];

        float result = 0.0;
        for (int d = 0; d < ${this.depth}; ++d) {
          int depthBegin = int(max(0.0, float(d - ${depthRadius})));
          int depthEnd = int(min(float(${this.depth}),
              float(d + ${depthRadius} + 1)));

          const int MIN_DEPTH_BEGIN = 0;
          const int MAX_DEPTH_END = ${this.depth};

          float norm = 0.0;
          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            }
            else {
              break;
            }
          }

          norm = float(${alpha}) * norm + float(${bias});

          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd){
              float dyi = -2.0 * float(${alpha})
                * float(${beta})
                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d)
                / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * ${beta});
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            }
            else {
              break;
            }
          }
      }
      setOutput(result);
      }
    `;
    }
}


const $492a61514ad5bd05$export$c1529e4348811bb5 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = new (0, $ab475a4a98ed809d$export$f121c71e68d75e)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x,
        y,
        dy
    ], x.dtype);
};
const $492a61514ad5bd05$export$99a62fc039d7aca0 = {
    kernelName: (0, $507890e4aa8e1463$export$73ba43cd0ce95b10),
    backendName: 'webgl',
    kernelFunc: $492a61514ad5bd05$export$c1529e4348811bb5
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $014c568874ca9984$export$23c9b99bdac85be0(x, reduceShape, outShape, backend) {
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(reshapedInput, x.dtype, 'max', backend);
    const reshapedOutput = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}



function $8b051c53b11bfa55$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    const maxInputIsTransposed = permutedAxes != null;
    const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
        x
    ]);
    let maxInput = x;
    if (maxInputIsTransposed) {
        if (shouldExecuteOnCPU) {
            const xTexData = backend.texData.get(maxInput.dataId);
            const values = xTexData.values;
            const newShape = new Array(xRank);
            for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
            const maxInputValues = (0, $1cec302811203101$export$a0105d4a7143676c)(values, x.shape, x.dtype, permutedAxes, newShape);
            maxInput = backend.makeTensorInfo(newShape, x.dtype);
            const maxInputData = backend.texData.get(maxInput.dataId);
            maxInputData.values = maxInputValues;
        } else maxInput = (0, $2dac94a44dcdc62a$export$986b9e65182e08d)(x, permutedAxes, backend);
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(maxInput.shape, axes);
    let outShape = maxOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(maxOutShape, origAxes);
    let out;
    if (shouldExecuteOnCPU) {
        const xTexData = backend.texData.get(maxInput.dataId);
        const values = xTexData.values;
        const outValues = (0, $1cec302811203101$export$a94164c9f637858e)(values, (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape), outShape, x.dtype);
        out = backend.makeTensorInfo(outShape, x.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $014c568874ca9984$export$23c9b99bdac85be0)(maxInput, reduceShape, outShape, backend);
    if (maxInputIsTransposed) backend.disposeIntermediateTensorInfo(maxInput);
    return out;
}
const $8b051c53b11bfa55$export$7d79147246e312bb = {
    kernelName: (0, $507890e4aa8e1463$export$d36c09e5d02927e7),
    backendName: 'webgl',
    kernelFunc: $8b051c53b11bfa55$export$8960430cfd85939f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




const $70e6af5f4c85c3fe$var$MAXIMUM = (0, $6e99a2fc879307b0$export$39f0cca2b63399f6) + `
  return max(a, b);
`;
const $70e6af5f4c85c3fe$var$MAXIMUM_PACKED = `
  vec4 result = vec4(max(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $70e6af5f4c85c3fe$export$b25e0be55f42c9a = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $70e6af5f4c85c3fe$var$MAXIMUM,
    packedOpSnippet: $70e6af5f4c85c3fe$var$MAXIMUM_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$b3afdc53a543e175)
});
const $70e6af5f4c85c3fe$export$45b97bdc342e72a2 = {
    kernelName: (0, $507890e4aa8e1463$export$d8d02ac92d161004),
    backendName: 'webgl',
    kernelFunc: $70e6af5f4c85c3fe$export$b25e0be55f42c9a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $3b138df01d90fc23$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $f6f0bdab98aa0468$export$1412c17b2531581a)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $0775da5e684c8c0d$exports).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const maxPoolProgram = new (0, $d948c32d7ddb4f9e$export$ddaa65439647a5ac)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $3b138df01d90fc23$export$45c8263b38f19e33 = {
    kernelName: (0, $507890e4aa8e1463$export$39ea33024ddd5cf),
    backendName: 'webgl',
    kernelFunc: $3b138df01d90fc23$export$e4aadcf115842782
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $a5d40d22c7b0e3fc$export$822a6e53be1125f9(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const maxPoolProgram = new (0, $d948c32d7ddb4f9e$export$a835a97097fdbb0f)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $a5d40d22c7b0e3fc$export$91a8fc5da39ec855 = {
    kernelName: (0, $507890e4aa8e1463$export$88fdc64af890fc53),
    backendName: 'webgl',
    kernelFunc: $a5d40d22c7b0e3fc$export$822a6e53be1125f9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c337a2658ce8fa27$export$ab6144ed51884dd {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
          wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);
            int maxPosValue = ${lastIndex} - int(getMaxPos(b, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            int curPosValue = wR * ${effectiveFilterWidth} + wC;
            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

            dotProd += dyValue * mask;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $c337a2658ce8fa27$export$ae61ae287bf9d719 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
           wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);
              int maxPosValue = ${lastIndex} -
                  int(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              int curPosValue =
                  wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                  wR * ${effectiveFilterWidth} + wC;
              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

              dotProd += dyValue * mask;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}



function $0d6ad0c8d309f708$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $f35e0c1a651337db$exports).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const maxPool3dPositionsProgram = new (0, $d948c32d7ddb4f9e$export$a835a97097fdbb0f)(convInfo, 'max', true);
    const maxPool3dPositions = backend.runWebGLProgram(maxPool3dPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackpropProgram = new (0, $c337a2658ce8fa27$export$ae61ae287bf9d719)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackpropProgram, [
        dy,
        maxPool3dPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPool3dPositions);
    return result;
}
const $0d6ad0c8d309f708$export$5201426bb10bd5eb = {
    kernelName: (0, $507890e4aa8e1463$export$52be2c00371a1350),
    backendName: 'webgl',
    kernelFunc: $0d6ad0c8d309f708$export$e68b9bef571dd4ea
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $0e485e09200039d8$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $f6f0bdab98aa0468$export$1412c17b2531581a)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const getPositions = true;
    const maxPoolPositionsProgram = new (0, $d948c32d7ddb4f9e$export$ddaa65439647a5ac)(convInfo, 'max', getPositions);
    const maxPoolPositions = backend.runWebGLProgram(maxPoolPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackPropProgram = new (0, $c337a2658ce8fa27$export$ab6144ed51884dd)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackPropProgram, [
        dy,
        maxPoolPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPoolPositions);
    return result;
}
const $0e485e09200039d8$export$e01a7f8dbee29127 = {
    kernelName: (0, $507890e4aa8e1463$export$f0f010b1d1db8a46),
    backendName: 'webgl',
    kernelFunc: $0e485e09200039d8$export$85dfd1121f049514
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $d0bceec7e96a3379$export$3cc34964a47e7a3f(x, includeBatchInIndex, convInfo, backend) {
    let program = new (0, $d948c32d7ddb4f9e$export$ddaa65439647a5ac)(convInfo, 'max', false);
    const poolOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    program = new (0, $d948c32d7ddb4f9e$export$ddaa65439647a5ac)(convInfo, 'max', true, true, includeBatchInIndex);
    const indexOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    return [
        poolOutput,
        indexOutput
    ];
}


const $d6c80cf7151f0eb3$export$a069ee2247a7d1ce = {
    kernelName: (0, $507890e4aa8e1463$export$deac4b7497b4047f),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const webglBackend = backend;
        (0, $0775da5e684c8c0d$exports).assert(x.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x.shape.length}.`);
        const dilations = [
            1,
            1
        ];
        (0, $0775da5e684c8c0d$exports).assert((0, $f35e0c1a651337db$exports).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
        const convInfo = (0, $f35e0c1a651337db$exports).computePool2DInfo(x.shape, filterSize, strides, dilations, pad);
        const [result, indexes] = (0, $d0bceec7e96a3379$export$3cc34964a47e7a3f)(x, includeBatchInIndex, convInfo, webglBackend);
        return [
            result,
            indexes
        ];
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $cbdb488c72243807$export$320c6ab5e6e7bcef(x, reduceShape, outShape, backend) {
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(reshapedInput, 'float32', 'mean', backend);
    const reshapedOutput = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}



const $98a58188dd8f469e$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $507890e4aa8e1463$export$1c2d59c4b681fbd8),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { keepDims: keepDims, axis: axis } = attrs;
        const webglBackend = backend;
        const xRank = x.shape.length;
        const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
        let axes = origAxes;
        const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
        const meanInputIsTransposed = permutedAxes != null;
        const shouldExecuteOnCPU = webglBackend.shouldExecuteOnCPU([
            x
        ]);
        const intermediates = [];
        let meanInput = x;
        if (meanInputIsTransposed) {
            if (shouldExecuteOnCPU) {
                const xTexData = webglBackend.texData.get(meanInput.dataId);
                const values = xTexData.values;
                const newShape = new Array(xRank);
                for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
                const meanInputValues = (0, $1cec302811203101$export$a0105d4a7143676c)(values, x.shape, x.dtype, permutedAxes, newShape);
                meanInput = webglBackend.makeTensorInfo(newShape, x.dtype);
                const meanInputData = webglBackend.texData.get(meanInput.dataId);
                meanInputData.values = meanInputValues;
            } else meanInput = (0, $2dac94a44dcdc62a$export$986b9e65182e08d)(x, permutedAxes, webglBackend);
            intermediates.push(meanInput);
            axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
        }
        (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('sum', axes, xRank);
        const [meanOutShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(meanInput.shape, axes);
        let outShape = meanOutShape;
        if (keepDims) // rather than reshape at the end, set the target shape here.
        outShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(meanOutShape, origAxes);
        const out = (0, $cbdb488c72243807$export$320c6ab5e6e7bcef)(meanInput, reduceShape, outShape, webglBackend);
        for (const i of intermediates)webglBackend.disposeIntermediateTensorInfo(i);
        return out;
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $d483c194e7539669$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('min', axes, xRank);
    const [outShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
    const a2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(a2D, a2D.dtype, 'min', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $d483c194e7539669$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $507890e4aa8e1463$export$dfed19fabc75a31d),
    backendName: 'webgl',
    kernelFunc: $d483c194e7539669$export$96ec731ed4dcb222
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




const $e03817dbaa06bbb0$var$MINIMUM = (0, $6e99a2fc879307b0$export$39f0cca2b63399f6) + `
  return min(a, b);
`;
const $e03817dbaa06bbb0$var$MINIMUM_PACKED = `
  vec4 result = vec4(min(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $e03817dbaa06bbb0$export$916782c1f0ddb132 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $e03817dbaa06bbb0$var$MINIMUM,
    packedOpSnippet: $e03817dbaa06bbb0$var$MINIMUM_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$1f01be3f637863fa)
});
const $e03817dbaa06bbb0$export$ea24ffbbbce8d546 = {
    kernelName: (0, $507890e4aa8e1463$export$23cb308301e89d6b),
    backendName: 'webgl',
    kernelFunc: $e03817dbaa06bbb0$export$916782c1f0ddb132
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $491e65397980d6b2$export$284b676bb83fc2a7 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        const offset = mode === 'reflect' ? 0 : 1;
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start) {
            outC = start * 2 - outC - ${offset};
          } else if(outC >= end) {
            outC = (end - 1) * 2 - outC + ${offset};
          }
          setOutput(getX(outC - start));
        }
      `;
            return;
        }
        this.userCode = `
      ${dtype} start = ${dtype}(${start});
      ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outC = getOutputCoords();
        for (int i = 0; i < ${rank}; i++) {
          if (outC[i] < start[i]) {
            outC[i] = start[i] * 2 - outC[i] - ${offset};
          } else if(outC[i] >= end[i]) {
            outC[i] = (end[i] - 1) * 2 - outC[i] + ${offset};
          }
        }
        ${dtype} coords = outC - start;
        setOutput(getX(${unpackedCoords}));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $890170453871789d$export$8b179cde16652b52 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('rc', rank);
        const source = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const offset = mode === 'reflect' ? 0 : 1;
        let mainLoop = '';
        if (rank === 1) {
            const padSetup = `
        ${dtype} source = rc;
        if (source < start) {
          source = start * 2 - source - ${offset};
        } else if (source >= end) {
          source = (end - 1) * 2 - source + ${offset};
        }
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        } else {
            const padSetup = `
        ${dtype} source = rc;
        ${dtype} lt = ${dtype}(lessThan(source, start));
        ${dtype} gte = ${dtype}(greaterThanEqual(source, end));
        ${dtype} orig = 1 - (lt + gte);
        source = orig * source +
                lt * (start * 2 - source - ${offset}) +
                gte * ((end - 1) * 2 - source + ${offset});
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
        rc = outputLoc;
        ${coords[rank - 2]} += 1;
        if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {
          ${padSetup}
          result[2] = getChannel(getX(${source.join()}), ${innerDims});
          ${coords[rank - 1]} += 1;
          if(${cLimit}) {
            ${padSetup}
            result[3] = getChannel(getX(${source.join()}), ${innerDims});
          }
        }
      `;
        }
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}


const $307ad2c13084635b$export$cd4ff5cd9b95abe8 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $890170453871789d$export$8b179cde16652b52)(x.shape, paddings, mode) : new (0, $491e65397980d6b2$export$284b676bb83fc2a7)(x.shape, paddings, mode);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
};
const $307ad2c13084635b$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $507890e4aa8e1463$export$f4c0e95fd7fd31e5),
    backendName: 'webgl',
    kernelFunc: $307ad2c13084635b$export$cd4ff5cd9b95abe8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $d6d08aca45d9c2a1$var$MOD = `if (b == 0.0) return NAN;
  return mod(a, b);`;
const $d6d08aca45d9c2a1$var$MOD_PACKED = `
  vec4 result = mod(a, b);
  bvec4 isNaN = equal(b, vec4(0.0));
  ` + (0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $d6d08aca45d9c2a1$export$842a2cf37af977e1 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $d6d08aca45d9c2a1$var$MOD,
    packedOpSnippet: $d6d08aca45d9c2a1$var$MOD_PACKED
});
const $d6d08aca45d9c2a1$export$9037685a81180a9c = {
    kernelName: (0, $507890e4aa8e1463$export$e4835a5e3f3674d5),
    backendName: 'webgl',
    kernelFunc: $d6d08aca45d9c2a1$export$842a2cf37af977e1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $f5dac788a4a14903$export$f8cda6c8ea4f2110 {
    constructor(batchSize, numOutcomes, numSamples){
        this.variableNames = [
            'probs'
        ];
        this.customUniforms = [
            {
                name: 'seed',
                type: 'float'
            }
        ];
        this.outputShape = [
            batchSize,
            numSamples
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];

        float r = random(seed);
        float cdf = 0.0;

        for (int i = 0; i < ${numOutcomes - 1}; i++) {
          cdf += getProbs(batch, i);

          if (r < cdf) {
            setOutput(float(i));
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutput(float(${numOutcomes - 1}));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

// Without the equality check div produces 0.9999 for a = b, which when
// floored can cause errors.
const $62c8e00f7845e3a1$var$DIV = `
if (a == b) {
  return 1.0;
};
return a / b;`;
// We do the same as in ./binaryop_gpu, with vec4 and ivec4.
// On Linux, the vectorized implementation produces NaNs when a and b are 0.
const $62c8e00f7845e3a1$var$DIV_PACKED = `
  // vec4 one = vec4(equal(a, b));
  // return one + (vec4(1.0) - one) * a / b;
  vec4 result = a / b;
  if(a.x == b.x) {
    result.x = 1.;
  }
  if(a.y == b.y) {
    result.y = 1.;
  }
  if(a.z == b.z) {
    result.z = 1.;
  }
  if(a.w == b.w) {
    result.w = 1.;
  }

  return result;
`;
const $62c8e00f7845e3a1$export$f76766520aabd67 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $62c8e00f7845e3a1$var$DIV,
    packedOpSnippet: $62c8e00f7845e3a1$var$DIV_PACKED,
    checkOutOfBounds: true
});
const $62c8e00f7845e3a1$export$15c5d6176b30b9a6 = {
    kernelName: (0, $507890e4aa8e1463$export$b9880b86e1014bb8),
    backendName: 'webgl',
    kernelFunc: $62c8e00f7845e3a1$export$f76766520aabd67
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $28dc108b32441d03$var$SUB = 'return a - b;';
const $28dc108b32441d03$export$f93b5905241a7cca = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $28dc108b32441d03$var$SUB,
    packedOpSnippet: $28dc108b32441d03$var$SUB,
    supportsComplex: true,
    cpuKernelImpl: (0, $1cec302811203101$export$be7474e96b733333)
});
const $28dc108b32441d03$export$5d068476dad60c4d = {
    kernelName: (0, $507890e4aa8e1463$export$d7a01e11500dfb6f),
    backendName: 'webgl',
    kernelFunc: $28dc108b32441d03$export$f93b5905241a7cca
};



function $08be6664f17d4ed7$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const axes = (0, $0775da5e684c8c0d$exports).parseAxisParam([
        dim
    ], logits.shape);
    const maxLogit = (0, $8b051c53b11bfa55$export$8960430cfd85939f)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitsReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $28dc108b32441d03$export$f93b5905241a7cca)({
        inputs: {
            a: logits,
            b: maxLogitsReshaped
        },
        backend: backend
    });
    const b = (0, $be243d168303c1ee$export$b310ec824aaee37f)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $0082ed6af416fef1$export$8a63f25cc62965f1)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumExpReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const res = (0, $62c8e00f7845e3a1$export$f76766520aabd67)({
        inputs: {
            a: b,
            b: sumExpReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitsReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumExpReshaped);
    return res;
}
const $08be6664f17d4ed7$export$c022691f23e2ee69 = {
    kernelName: (0, $507890e4aa8e1463$export$350a526055d3ca6e),
    backendName: 'webgl',
    kernelFunc: $08be6664f17d4ed7$export$e008137e76238601
};


function $364860dd6df456d8$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    const probs = normalized ? logits : (0, $08be6664f17d4ed7$export$e008137e76238601)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: logits.shape.length - 1
        }
    });
    const batchSize = probs.shape[0];
    const numOutcomes = probs.shape[1];
    const program = new (0, $f5dac788a4a14903$export$f8cda6c8ea4f2110)(batchSize, numOutcomes, numSamples);
    const customValues = [
        [
            seed
        ]
    ];
    const res = backend.runWebGLProgram(program, [
        probs
    ], 'int32', customValues);
    if (!normalized) backend.disposeIntermediateTensorInfo(probs);
    return res;
}
const $364860dd6df456d8$export$ad960e364767f0e2 = {
    kernelName: (0, $507890e4aa8e1463$export$ee0a8cfb693e0e3f),
    backendName: 'webgl',
    kernelFunc: $364860dd6df456d8$export$f4d580f3101a1c7e
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $d75a61973198b844$var$NEG = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  return -x;
`;
const $d75a61973198b844$var$NEG_PACKED = `
  vec4 result = -x;
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
function $d75a61973198b844$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = backend.texData.get(x.dataId);
        const [outValues, newShape] = (0, $1cec302811203101$export$1cbcde7624effb15)(xData.values, x.shape, x.dtype);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    let program;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $262948717bc1c671$export$4d8daca4f85ed73d)(x.shape, $d75a61973198b844$var$NEG_PACKED);
    else program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(x.shape, $d75a61973198b844$var$NEG);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $d75a61973198b844$export$cc7b18b8229c3db = {
    kernelName: (0, $507890e4aa8e1463$export$c07c549000872073),
    backendName: 'webgl',
    kernelFunc: $d75a61973198b844$export$d9493ff0dfa0fdd5
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $7432013e4e671179$var$nonMaxSuppressionV3Impl = (0, $543f67484857d7a4$exports).nonMaxSuppressionV3Impl;
function $7432013e4e671179$export$8917e4bf7f7f5d42(args) {
    (0, $f35e0c1a651337db$exports).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices } = $7432013e4e671179$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $7432013e4e671179$export$549561cd158f260a = {
    kernelName: (0, $507890e4aa8e1463$export$5e11788439c2f04),
    backendName: 'webgl',
    kernelFunc: $7432013e4e671179$export$8917e4bf7f7f5d42
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $5762aa7cfc8d977b$var$nonMaxSuppressionV4Impl = (0, $543f67484857d7a4$exports).nonMaxSuppressionV4Impl;
function $5762aa7cfc8d977b$export$ad519bdebe8f4dcf(args) {
    (0, $f35e0c1a651337db$exports).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $5762aa7cfc8d977b$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $5762aa7cfc8d977b$export$906b8fb32c570e9d = {
    kernelName: (0, $507890e4aa8e1463$export$7df908154366fe7f),
    backendName: 'webgl',
    kernelFunc: $5762aa7cfc8d977b$export$ad519bdebe8f4dcf
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $77cf1115ce0e228c$var$nonMaxSuppressionV5Impl = (0, $543f67484857d7a4$exports).nonMaxSuppressionV5Impl;
function $77cf1115ce0e228c$export$49e389fdbe01a534(args) {
    (0, $f35e0c1a651337db$exports).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $77cf1115ce0e228c$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $77cf1115ce0e228c$export$4c00b682f309701d = {
    kernelName: (0, $507890e4aa8e1463$export$cb45d3fcefce2ef0),
    backendName: 'webgl',
    kernelFunc: $77cf1115ce0e228c$export$49e389fdbe01a534
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $4868d57051fb5fc3$export$314e506cf5800fc5 {
    constructor(numIndices, depth, onValue, offValue){
        this.variableNames = [
            'indices'
        ];
        this.outputShape = [
            numIndices,
            depth
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int index = round(getIndices(coords.x));
        setOutput(mix(float(${offValue}), float(${onValue}),
                      float(index == coords.y)));
      }
    `;
    }
}



const $da13844c5e01268f$export$341b5490a776d041 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    const indicesSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(indices.shape);
    const program = new (0, $4868d57051fb5fc3$export$314e506cf5800fc5)(indicesSize, depth, onValue, offValue);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                indicesSize
            ]
        }
    });
    const result = backend.runWebGLProgram(program, [
        reshaped
    ], dtype);
    backend.disposeIntermediateTensorInfo(reshaped);
    const outShape = [
        ...indices.shape,
        depth
    ];
    const out = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return out;
};
const $da13844c5e01268f$export$dde5645b472b80b2 = {
    kernelName: (0, $507890e4aa8e1463$export$18982b43ba8c02e9),
    backendName: 'webgl',
    kernelFunc: $da13844c5e01268f$export$341b5490a776d041
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




function $079df9c4a2d91c76$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'complex64') {
        const realPart = (0, $d01fae68c7267ce6$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $079df9c4a2d91c76$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $217ea7e271ca5f11$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $079df9c4a2d91c76$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $d717ecf39741148f$export$9563e054e6f787fb)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: x.dtype === 'string' ? '' : 0
        },
        backend: backend
    });
}
const $079df9c4a2d91c76$export$15368df05c479e41 = {
    kernelName: (0, $507890e4aa8e1463$export$430969a37eda1e88),
    backendName: 'webgl',
    kernelFunc: $079df9c4a2d91c76$export$cb1f824e7733584d
};


function $92eba13024379b38$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported under string dtype');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $d01fae68c7267ce6$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $92eba13024379b38$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $217ea7e271ca5f11$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $079df9c4a2d91c76$export$cb1f824e7733584d)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $a1426942a1186ebb$export$83a0e34f1302825b)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else // TODO(cais, smilkov): Add WebGL shader for onesLike:
    //   https://github.com/tensorflow/tfjs/issues/1293
    return (0, $d717ecf39741148f$export$9563e054e6f787fb)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: 1
        },
        backend: backend
    });
}
const $92eba13024379b38$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $507890e4aa8e1463$export$a2962e735c809d91),
    backendName: 'webgl',
    kernelFunc: $92eba13024379b38$export$fb6afd6214fee9e9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $d37d72bc93114742$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $3e4008b896c924ea$export$d660d8ed21f46635)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $0775da5e684c8c0d$exports).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $0775da5e684c8c0d$exports).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $3e4008b896c924ea$export$d660d8ed21f46635)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $96cfa83cf7469b29$export$ee1b3e54f0441b22)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $d37d72bc93114742$export$1645fa8803aa1f86 = {
    kernelName: (0, $507890e4aa8e1463$export$c26f40b29201e5b7),
    backendName: 'webgl',
    kernelFunc: $d37d72bc93114742$export$2a703dbb0cb35339
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $a169164107b67acc$export$15f19b307ce21f0a {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const type = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start || outC >= end) {
            setOutput(value);
          } else {
            setOutput(getX(outC - start));
          }
        }
      `;
            return;
        }
        this.userCode = `
      ${type} start = ${type}(${start});
      ${type} end = ${type}(${end});

      void main() {
        ${type} outC = getOutputCoords();
        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {
          setOutput(value);
        } else {
          ${type} coords = outC - start;
          setOutput(getX(${unpackedCoords}));
        }
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $e075f042f88f77a0$export$ed21e062cfba77c5 {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('rc', rank);
        const source = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const componentSetup = [
            `${dtype} rc = outputLoc;`,
            `${coords[rank - 1]} += 1;
       if(${cLimit}) {
      `,
            rank === 1 ? '' : `}
       rc = outputLoc;
       ${coords[rank - 2]} += 1;
       if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {`,
            rank === 1 ? '' : `  ${coords[rank - 1]} += 1;
         if(${cLimit}) {`
        ];
        const paddingArea = rank === 1 ? 'rc < start || rc >= end' : 'any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))';
        let mainLoop = '';
        for(let i = 0, j = rank === 1 ? 2 : 4; i < j; i++)mainLoop += `
        ${componentSetup[i]}
        if (${paddingArea}) {
          result[${i}] = float(value);
        } else {
          ${dtype} source = rc - start;
          result[${i}] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        mainLoop += rank === 1 ? `} ` : `}}`;
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}



const $29f8dda7be82fac6$export$f676d6ad4f38bb89 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    if ((0, $0775da5e684c8c0d$exports).sizeFromShape(x.shape) === 0) {
        // Short-circuit the computation, since x doesn't have value, only
        // the shape is used to compute output shape to pad.
        const outputShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
        return (0, $d717ecf39741148f$export$9563e054e6f787fb)({
            backend: backend,
            attrs: {
                shape: outputShape,
                value: constantValue,
                dtype: x.dtype
            }
        });
    }
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $e075f042f88f77a0$export$ed21e062cfba77c5)(x.shape, paddings, constantValue) : new (0, $a169164107b67acc$export$15f19b307ce21f0a)(x.shape, paddings, constantValue);
    const customValues = [
        [
            constantValue
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
};
const $29f8dda7be82fac6$export$b0317e720bfd61fc = {
    kernelName: (0, $507890e4aa8e1463$export$5d47ba206577f0f2),
    backendName: 'webgl',
    kernelFunc: $29f8dda7be82fac6$export$f676d6ad4f38bb89
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $8b0c36d89bf8109f$var$POW = `
  if(a < 0.0 && floor(b) < b){
    return NAN;
  }
  if (b == 0.0) {
    return 1.0;
  }
  return (round(mod(b, 2.0)) != 1) ?
      pow(abs(a), b) : sign(a) * pow(abs(a), b);
`;
const $8b0c36d89bf8109f$var$POW_PACKED = `
  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.
  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));
  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);
  vec4 result = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  bvec4 isExpZero = equal(b, vec4(0.0));
  result.r = isExpZero.r ? 1.0 : result.r;
  result.g = isExpZero.g ? 1.0 : result.g;
  result.b = isExpZero.b ? 1.0 : result.b;
  result.a = isExpZero.a ? 1.0 : result.a;

  bvec4 isNaN1 = lessThan(a, vec4(0.0));
  bvec4 isNaN2 = lessThan(floor(b), b);
  bvec4 isNaN = bvec4(isNaN1.x && isNaN2.x, isNaN1.y && isNaN2.y, isNaN1.z && isNaN2.z, isNaN1.w && isNaN2.w);
  ` + (0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $8b0c36d89bf8109f$export$9c297f60e22e3389 = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $8b0c36d89bf8109f$var$POW,
    packedOpSnippet: $8b0c36d89bf8109f$var$POW_PACKED
});
const $8b0c36d89bf8109f$export$b823d49786719761 = {
    kernelName: (0, $507890e4aa8e1463$export$ce28d653ec559ee),
    backendName: 'webgl',
    kernelFunc: $8b0c36d89bf8109f$export$9c297f60e22e3389
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




function $d440bca714405b58$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    const origAxes = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $f35e0c1a651337db$exports).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $f35e0c1a651337db$exports).getInnerMostAxes(axes.length, xRank);
        toDispose.push(permutedX);
    }
    (0, $f35e0c1a651337db$exports).assertAxesAreInnerMostDims('prod', axes, xRank);
    let res;
    if (backend.shouldExecuteOnCPU([
        permutedX
    ])) {
        const xVals = backend.texData.get(permutedX.dataId).values;
        const { outVals: outVals, outShape: outShape, outDtype: outDtype } = (0, $1cec302811203101$export$2d654219115cec80)(permutedX.shape, permutedX.dtype, xVals, axes);
        res = backend.makeTensorInfo(outShape, outDtype, outVals);
    } else {
        const [outShape, reduceShape] = (0, $f35e0c1a651337db$exports).computeOutAndReduceShapes(permutedX.shape, axes);
        const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(reduceShape);
        const a2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: permutedX
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        const outputDType = (0, $4ccb7c1368387e67$export$3479b4fbed3c0d8d)(x.dtype);
        const reduced = (0, $bb5e1efea372a85a$export$533b26079ad0b4b)(a2D, outputDType, 'prod', backend);
        res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        toDispose.push(a2D);
        toDispose.push(reduced);
    }
    if (keepDims) {
        toDispose.push(res);
        const newShape = (0, $f35e0c1a651337db$exports).expandShapeToKeepDim(res.shape, origAxes);
        res = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: res
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $d440bca714405b58$export$d556aa935cef5c0c = {
    kernelName: (0, $507890e4aa8e1463$export$b8a16d526a791fb0),
    backendName: 'webgl',
    kernelFunc: $d440bca714405b58$export$5e143010dea16c85
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $ad9bcf16f925db13$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.readSync(t.dataId));
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.readSync(paramsDenseValues.dataId);
    const $indices = backend.readSync(indices.dataId);
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $1cec302811203101$export$7cf38d50772f4bbc)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $ad9bcf16f925db13$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $507890e4aa8e1463$export$ffee9c5b4fce08a1),
    backendName: 'webgl',
    kernelFunc: $ad9bcf16f925db13$export$e7118f605df251dd
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $6704d5cf1ff66c2b$export$a173be400c6762b5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { starts: starts, limits: limits, deltas: deltas } = inputs;
    const $starts = backend.readSync(starts.dataId);
    const $limits = backend.readSync(limits.dataId);
    const $deltas = backend.readSync(deltas.dataId);
    const [rtNestedSplitsData, rtDenseValuesData] = (0, $1cec302811203101$export$46d9d0942af5d1c2)($starts, starts.shape, starts.dtype, $limits, limits.shape, $deltas, deltas.shape);
    const rtNestedSplits = backend.makeTensorInfo([
        rtNestedSplitsData.length
    ], 'int32', rtNestedSplitsData);
    const rtDenseValues = backend.makeTensorInfo([
        rtDenseValuesData.length
    ], starts.dtype, rtDenseValuesData);
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}
const $6704d5cf1ff66c2b$export$91ddd62a193b9401 = {
    kernelName: (0, $507890e4aa8e1463$export$9d0615a9a6d213d2),
    backendName: 'webgl',
    kernelFunc: $6704d5cf1ff66c2b$export$a173be400c6762b5
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $5aa331d918940d77$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.readSync(shape.dataId);
    const $values = backend.readSync(values.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId);
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.readSync(t.dataId));
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $1cec302811203101$export$b3c4ab635ddc431f)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $5aa331d918940d77$export$792f441e33dcdf26 = {
    kernelName: (0, $507890e4aa8e1463$export$616d73a9ab7617c7),
    backendName: 'webgl',
    kernelFunc: $5aa331d918940d77$export$621e390307cbbaa1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $ad18f707db942307$export$d02631cccf789723 = (args)=>{
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, step: step, dtype: dtype } = attrs;
    const values = (0, $1cec302811203101$export$fbee6deed7e76443)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
};
const $ad18f707db942307$export$361c4075706e31c2 = {
    kernelName: (0, $507890e4aa8e1463$export$9a58ef0d7ad3278c),
    backendName: 'webgl',
    kernelFunc: $ad18f707db942307$export$d02631cccf789723
};




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $76ec15aa63e8617d$var$RECIPROCAL = `return 1.0 / x;`;
const $76ec15aa63e8617d$export$163bc8c839a1ac04 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $76ec15aa63e8617d$var$RECIPROCAL
});
const $76ec15aa63e8617d$export$412a6b66203fdf72 = {
    kernelName: (0, $507890e4aa8e1463$export$c6e4a23ed5e0415b),
    backendName: 'webgl',
    kernelFunc: $76ec15aa63e8617d$export$163bc8c839a1ac04
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $469401a94c8169b1$var$RELU = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  return (x < 0.0) ? 0.0 : x;
`;
const $469401a94c8169b1$var$RELU_PACKED = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $469401a94c8169b1$export$16d1e4612cc0139f = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $469401a94c8169b1$var$RELU,
    packedOpSnippet: $469401a94c8169b1$var$RELU_PACKED
});
const $469401a94c8169b1$export$731f9199bde068eb = {
    kernelName: (0, $507890e4aa8e1463$export$9a6ff968bf961432),
    backendName: 'webgl',
    kernelFunc: $469401a94c8169b1$export$16d1e4612cc0139f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $cbdfdb156dd6be21$var$RELU6 = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $cbdfdb156dd6be21$var$RELU6_PACKED = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $cbdfdb156dd6be21$export$4a62bcb95e9c44c4 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $cbdfdb156dd6be21$var$RELU6,
    packedOpSnippet: $cbdfdb156dd6be21$var$RELU6_PACKED
});
const $cbdfdb156dd6be21$export$92c30890ad649d53 = {
    kernelName: (0, $507890e4aa8e1463$export$3be9e924f629054e),
    backendName: 'webgl',
    kernelFunc: $cbdfdb156dd6be21$export$4a62bcb95e9c44c4
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $82c8b0296c7d6efd$export$52b2ccd78b972549 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + ` - vec2(0.5)`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));
        ivec2 sourceCeilRC = ivec2(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);
        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);
        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);
        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);

        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);

        float top = topLeft + (topRight - topLeft) * fracRC.y;
        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
        float newValue = top + (bottom - top) * fracRC.x;

        setOutput(newValue);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $2087c9359fa8d8d2$export$b334a0f2524628a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC - vec3(0.5)`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));
        ivec3 sourceCeilRC = ivec3(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        // In parallel, construct four corners for all four components in
        // packed 2x2 cell.
        vec4 topLeft = vec4(
          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 bottomLeft = vec4(
          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 topRight = vec4(
          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec4 bottomRight = vec4(
          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);

        vec4 top = mix(topLeft, topRight, fracRC.yyzz);
        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);
        vec4 newValue = mix(top, bottom, fracRC.x);

        setOutput(newValue);
      }
    `;
    }
}


function $13b60e18f1cd3799$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $2087c9359fa8d8d2$export$b334a0f2524628a)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $82c8b0296c7d6efd$export$52b2ccd78b972549)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], 'float32');
}
const $13b60e18f1cd3799$export$a37a56137abc1357 = {
    kernelName: (0, $507890e4aa8e1463$export$24f2f15d869e0fd),
    backendName: 'webgl',
    kernelFunc: $13b60e18f1cd3799$export$1f1cbc7da93d06a0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $db79692d87a64e6c$export$dd552814323a3592 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(startRLerp - float(winHeight / 2));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(startCLerp - float(winWidth / 2));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float dxR = float(dyR) * heightScale;
            int topDxRIndex = int(floor(dxR));
            int bottomDxRIndex = int(min(ceil(dxR), ${xHeight - 1}.0));
            float dxRLerp = dxR - float(topDxRIndex);
            float inverseDxRLerp = 1.0 - dxRLerp;

            float dxC = float(dyC) * widthScale;
            int leftDxCIndex = int(floor(dxC));
            int rightDxCIndex = int(min(ceil(dxC), ${xWidth - 1}.0));
            float dxCLerp = dxC - float(leftDxCIndex);
            float inverseDxCLerp = 1.0 - dxCLerp;

            if (r == topDxRIndex && c == leftDxCIndex) {
              // topLeft
              accumulator +=
                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
            }

            if (r == topDxRIndex && c == rightDxCIndex) {
              // topRight
              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
            }

            if (r == bottomDxRIndex && c == leftDxCIndex) {
              // bottomLeft
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
            }

            if (r == bottomDxRIndex && c == rightDxCIndex) {
              // bottomRight
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}


function $10acce583c51b114$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $db79692d87a64e6c$export$dd552814323a3592)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $10acce583c51b114$export$51f84ca614e84763 = {
    kernelName: (0, $507890e4aa8e1463$export$2d3cf759f1538c13),
    backendName: 'webgl',
    kernelFunc: $10acce583c51b114$export$8899506794ec394
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $fd92ea25ffe3f0c3$export$2218952be90fb74a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + `, vec2(0.0))`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec2 sourceNearestRC = ivec2(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));
        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);

        setOutput(newValue);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $220f82c61e9b28ef$export$a616f6d9a33abf84 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC, vec3(0.0))`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec3 sourceNearestRC = ivec3(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        vec4 newValue = vec4(
          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),
          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);

        setOutput(newValue);
      }
    `;
    }
}


function $0e546ad21d1eeac4$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $220f82c61e9b28ef$export$a616f6d9a33abf84)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $fd92ea25ffe3f0c3$export$2218952be90fb74a)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], images.dtype);
}
const $0e546ad21d1eeac4$export$2b6a92caba113b89 = {
    kernelName: (0, $507890e4aa8e1463$export$6c8d8ec26192bb18),
    backendName: 'webgl',
    kernelFunc: $0e546ad21d1eeac4$export$74a902ae74ac2560
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $e748db4372c2efb5$export$b6671a84abe827c4 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(floor(startRLerp - float(winHeight / 2)));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(floor(startCLerp - float(winWidth / 2)));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float sourceFracRow =
              float(${effectiveXSize[0]}) *
                (float(dyR) / float(${effectiveYSize[0]}));

            float sourceFracCol =
                float(${effectiveXSize[1]}) *
                  (float(dyC) / float(${effectiveYSize[1]}));

            int sourceNearestRow = int(min(
                float(int(${xHeight}) - 1),
                ${alignCorners} ? float(round(sourceFracRow)) :
                                  float(floor(sourceFracRow))));

            int sourceNearestCol = int(min(
                float(int(${xWidth}) - 1),
                ${alignCorners} ? float(round(sourceFracCol)) :
                                  float(floor(sourceFracCol))));

            if (r == sourceNearestRow && c == sourceNearestCol) {
              accumulator += getDy(b, dyR, dyC, d);
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}


function $3d2c6d572ac5702d$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $e748db4372c2efb5$export$b6671a84abe827c4)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $3d2c6d572ac5702d$export$2b08d810b5090fe1 = {
    kernelName: (0, $507890e4aa8e1463$export$b84ac31c55aa023b),
    backendName: 'webgl',
    kernelFunc: $3d2c6d572ac5702d$export$2b75795f158f1b18
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $a47d5eab21f62fff$export$abc2effa29e77e92 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        if (rank === 1) {
            this.userCode = `
        void main() {
          int coord = getOutputCoords();
          setOutput(getX(${xShape[0]} - coord - 1));
        }
      `;
            return;
        }
        const getInCoord = (i)=>{
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - coords[${i}] - 1`;
            return `coords[${i}]`;
        };
        const inCoords = xShape.map((_, i)=>getInCoord(i)).join(',');
        const type = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        this.userCode = `
      void main() {
        ${type} coords = getOutputCoords();
        setOutput(getX(${inCoords}));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d652a8641b1a32bc$export$e427e51a4a356956 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        const channels = (0, $70e72a00a69a2f93$export$7a4d1d0d17b69972)('rc', rank);
        const nextColumn = `${channels[rank - 1]} + 1 < ${this.outputShape[rank - 1]}`;
        const nextRow = `${channels[rank - 2]} + 1 < ${this.outputShape[rank - 2]}`;
        const type = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        if (rank === 1) this.userCode = `
        void main(){
          int rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = getChannel(getX(${xShape[0]} - rc - 1),
            ${xShape[0]} - rc - 1);
          if(${nextColumn}){
              result.g = getChannel(getX(${xShape[0]} - (rc  + 1) - 1),
                ${xShape[0]} - (rc  + 1) - 1);
          }
          setOutput(result);
        }
      `;
        else this.userCode = `
        void main() {
          ${type} rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = ${getR(channels.slice())};
          if(${nextColumn}){
            result.g = ${getG(channels.slice())};
          }
          if(${nextRow}) {
            result.b = ${getB(channels.slice())};
            if(${nextColumn}) {
              result.a = ${getA(channels.slice())};
            }
          }
          setOutput(result);
        }
    `;
        function getR(channels) {
            return getChannel(channels);
        }
        function getG(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            return getChannel(channels);
        }
        function getB(channels) {
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getA(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getChannel(channels) {
            const inCoordsArray = xShape.map((_, i)=>getInCoord(i, channels));
            const inCoords = inCoordsArray.join(',');
            const innerDims = inCoordsArray.slice(-2).join(',');
            return `getChannel(getX(${inCoords}), vec2(${innerDims}))`;
        }
        function getInCoord(i, channels1) {
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - ${channels1[i]} - 1`;
            else return `${channels1[i]}`;
        }
    }
}



function $f02bb32dfb2c0a4e$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    const xRank = x.shape.length;
    const $dims = (0, $0775da5e684c8c0d$exports).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $4565c1320ebddb8a$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const program = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $d652a8641b1a32bc$export$e427e51a4a356956)(x.shape, $dims) : new (0, $a47d5eab21f62fff$export$abc2effa29e77e92)(x.shape, $dims);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $f02bb32dfb2c0a4e$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $507890e4aa8e1463$export$53c81f36b32e1bba),
    backendName: 'webgl',
    kernelFunc: $f02bb32dfb2c0a4e$export$66c1ae025e96b4bc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $fee6f6a643f4d0cd$export$a37df1d4e69844e7 {
    constructor(imageShape, fillValue){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'params',
                type: 'vec4'
            }
        ];
        const imageHeight = imageShape[1];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        let fillSnippet = '';
        if (typeof fillValue === 'number') fillSnippet = `float outputValue = ${fillValue.toFixed(2)};`;
        else fillSnippet = `
        vec3 fill = vec3(${fillValue.join(',')});
        float outputValue = fill[coords[3]];`;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];
          int y = coords[1];
          float coordXFloat = (float(x) - params[0]) * params[3] -
            (float(y) - params[1]) * params[2];
          float coordYFloat = (float(x) - params[0]) * params[2] +
            (float(y) - params[1]) * params[3];
          int coordX = int(round(coordXFloat + params[0]));
          int coordY = int(round(coordYFloat + params[1]));
          ${fillSnippet}
          if(coordX >= 0 && coordX < ${imageWidth} && coordY >= 0 && coordY < ${imageHeight}) {
            outputValue = getImage(coords[0], coordY, coordX, coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}


const $52594bbca9813153$export$44ba8c83417ab668 = {
    kernelName: (0, $507890e4aa8e1463$export$c5a44649815d1c3),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const webglBackend = backend;
        const program = new (0, $fee6f6a643f4d0cd$export$a37df1d4e69844e7)(image.shape, fillValue);
        const [centerX, centerY] = (0, $f35e0c1a651337db$exports).getImageCenter(center, image.shape[1], image.shape[2]);
        const customValues = [
            [
                centerX,
                centerY,
                Math.sin(radians),
                Math.cos(radians)
            ]
        ];
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype, customValues);
        return output;
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $c113d89fd901a82b$var$ROUND = `
  // OpenGL ES does not support round function.
  // The algorithm is based on banker's rounding.
  float base = floor(x);
  if ((x - base) < 0.5) {
    return floor(x);
  } else if ((x - base) > 0.5) {
    return ceil(x);
  } else {
    if (mod(base, 2.0) == 0.0) {
      return base;
    } else {
      return base + 1.0;
    }
  }
`;
const $c113d89fd901a82b$export$2077e0241d6afd3c = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $c113d89fd901a82b$var$ROUND
});
const $c113d89fd901a82b$export$6c09e3291f636503 = {
    kernelName: (0, $507890e4aa8e1463$export$c5ed3eef16c0612f),
    backendName: 'webgl',
    kernelFunc: $c113d89fd901a82b$export$2077e0241d6afd3c
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $c9618968bcc47ea4$var$RSQRT = `return inversesqrt(x);`;
const $c9618968bcc47ea4$export$1cc01d192953037e = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $c9618968bcc47ea4$var$RSQRT,
    cpuKernelImpl: (0, $1cec302811203101$export$431ccb02913a1aee)
});
const $c9618968bcc47ea4$export$941104b789956ef6 = {
    kernelName: (0, $507890e4aa8e1463$export$7cc53aa09f5f3a2d),
    backendName: 'webgl',
    kernelFunc: $c9618968bcc47ea4$export$1cc01d192953037e
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $f0725c2e7dbebe9a$export$8d0317f5c5cbc1ac {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true, defaultIsTensor = false){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.outputShape = shape;
        const stridesType = (0, $a18658cdba53b459$export$859efd105c10c755)(strides.length);
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        let defaultValuesString = '';
        if (defaultIsTensor) defaultValuesString = 'coords[0], coords[1]';
        const defaultValueSnippet = `getDefaultValue(${defaultValuesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          float sum = 0.0;
          bool found = false;
          for (int i = 0; i < ${updateSize}; i++) {
            int flattenedIndex = 0;
            for (int j = 0; j < ${sliceDim}; j++) {
              int index = round(${indicesSnippet});
              flattenedIndex += index * ${strideString};
            }
            if (flattenedIndex == coords[0]) {
              sum += ${updatesSnippet};
              found = true;
            }
          }
          setOutput(mix(${defaultValueSnippet}, sum, float(found)));
        }
      `;
    }
}


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $ea962875745b215e$export$6e81fd9352ed9fbb {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true, defaultIsTensor = false){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = shape;
        const stridesType = (0, $a18658cdba53b459$export$859efd105c10c755)(strides.length);
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        let defaultValuesString = '';
        if (defaultIsTensor) defaultValuesString = 'coords[0], coords[1]';
        const defaultValueSnippet = `getDefaultValue(${defaultValuesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        const strideString2 = sliceDim > 1 ? 'strides[j + 1]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          vec4 sum = vec4(0.);
          vec4 found = vec4(0.);
          for (int i = 0; i < ${updateSize}; i+=2) {
            ivec2 flattenedIndex = ivec2(0);
            for (int j = 0; j < ${sliceDim}; j+=2) {
              ivec4 index = round(${indicesSnippet});
              flattenedIndex += index.xz * ${strideString};
              if (j + 1 < ${sliceDim}) {
                flattenedIndex += index.yw * ${strideString2};
              }
            }
            if (flattenedIndex[0] == coords[0] || flattenedIndex[1] == coords[0] ||
                flattenedIndex[0] == coords[0] + 1 || flattenedIndex[1] == coords[0] + 1) {
              vec4 updVals = ${updatesSnippet};
              if (flattenedIndex[0] == coords[0]) {
                sum.xy += updVals.xy;
                found.xy = vec2(1.);
              } else if (flattenedIndex[0] == coords[0] + 1) {
                sum.zw += updVals.xy;
                found.zw = vec2(1.);
              }
              if (flattenedIndex[1] == coords[0]) {
                sum.xy += updVals.zw;
                found.xy = vec2(1.);
              } else if (flattenedIndex[1] == coords[0] + 1) {
                sum.zw += updVals.zw;
                found.zw = vec2(1.);
              }
            }
          }
          setOutput(mix(${defaultValueSnippet}, sum, found));
        }
      `;
    }
}



function $6effc6492e20302a$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $f35e0c1a651337db$exports).calculateShapes(updates, indices, shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(shape, indices.dtype);
    const flattenIndices = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const defaultValue = backend.makeTensorInfo([], 'float32', new Float32Array([
        0
    ])); // scalar(0)
    let program;
    if ((0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getBool('WEBGL_PACK')) program = new (0, $ea962875745b215e$export$6e81fd9352ed9fbb)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    else program = new (0, $f0725c2e7dbebe9a$export$8d0317f5c5cbc1ac)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        defaultValue
    ], flattenX.dtype);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    backend.disposeIntermediateTensorInfo(defaultValue);
    return reshaped;
}
const $6effc6492e20302a$export$573371744f044f5 = {
    kernelName: (0, $507890e4aa8e1463$export$28eef6f0168af686),
    backendName: 'webgl',
    kernelFunc: $6effc6492e20302a$export$b6f42038a536d877
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $280cead366fb6081$export$2511b5550383de5c {
    constructor(batchSize, numInputs, numValues, side){
        this.variableNames = [
            'sortedSequence',
            'values'
        ];
        this.customUniforms = [
            {
                name: 'numInputs',
                type: 'int'
            }
        ];
        this.outputShape = [
            batchSize,
            numValues
        ];
        const webGL2LoopHead = 'while (left < right) {';
        // WebGL1 doesn't accept non constant loop conditions, so upper bound loop
        // iterations.
        const webGL1LoopHead = `for (int i = 0; i < ${Math.ceil(Math.log2(numInputs + 1))}; ++i) { if (left >= right) break;`;
        const loopHead = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('WEBGL_VERSION') === 2 ? webGL2LoopHead : webGL1LoopHead;
        // left corresponds to lower bound and right to upper bound.
        const boundComparator = side === 'left' ? '<' : '<=';
        this.userCode = `
       int findBound(int batch, float value) {
         int left = 0;
         int right = numInputs;
         int mid;
         ${loopHead}
           mid = (left + right) / 2;
           if (getSortedSequence(batch, mid) ${boundComparator} value) {
             left = mid + 1;
           } else {
             right = mid;
           }
         }
         return right;
       }

       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int valueIndex = coords[1];

         float value = getValues(batch, valueIndex);

         setOutput(float(findBound(batch, value)));
       }
     `;
    }
}


function $26e7863cfdd57514$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const program = new (0, $280cead366fb6081$export$2511b5550383de5c)(sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    const customValues = [
        [
            sortedSequence.shape[1]
        ]
    ];
    return backend.runWebGLProgram(program, [
        sortedSequence,
        values
    ], 'int32', customValues);
}
const $26e7863cfdd57514$export$4b437b1a1aa6472f = {
    kernelName: (0, $507890e4aa8e1463$export$9a1405490b09867e),
    backendName: 'webgl',
    kernelFunc: $26e7863cfdd57514$export$56fad8d65b0adbdd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $834efd065d76e537$export$845ed2d1f74ef297 {
    constructor(cRank, shape, rank){
        this.variableNames = [
            'c',
            'a',
            'b'
        ];
        this.outputShape = shape;
        let cCoords;
        let abCoords;
        if (rank > 4) throw Error(`Where for rank ${rank} is not yet supported`);
        if (rank === 1) {
            abCoords = `resRC`;
            cCoords = `resRC`;
        } else {
            const currentCoords = [
                'resRC.x',
                'resRC.y',
                'resRC.z',
                'resRC.w'
            ];
            const cCoordVars = [];
            const abCoordVars = [];
            for(let i = 0; i < shape.length; i++){
                abCoordVars.push(`${currentCoords[i]}`);
                if (i < cRank) cCoordVars.push(`${currentCoords[i]}`);
            }
            cCoords = cCoordVars.join();
            abCoords = abCoordVars.join();
        }
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(rank);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        float cVal = getC(${cCoords});
        if (cVal >= 1.0) {
          setOutput(getA(${abCoords}));
        } else {
          setOutput(getB(${abCoords}));
        }
      }
    `;
    }
}


function $4bc7e78284177998$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    const program = new (0, $834efd065d76e537$export$845ed2d1f74ef297)(condition.shape.length, t.shape, t.shape.length);
    return backend.runWebGLProgram(program, [
        condition,
        t,
        e
    ], (0, $4ccb7c1368387e67$export$7bcca02d1a156bdf)(t.dtype, e.dtype));
}
const $4bc7e78284177998$export$7ff911e710ee72fc = {
    kernelName: (0, $507890e4aa8e1463$export$ef9b1a59e592288f),
    backendName: 'webgl',
    kernelFunc: $4bc7e78284177998$export$2e6c959c16ff56b8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $82b816405898321f$var$SELU = `
  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
  // see: https://arxiv.org/abs/1706.02515
  float scaleAlpha = ${(0, $f35e0c1a651337db$exports).SELU_SCALEALPHA};
  float scale = ${(0, $f35e0c1a651337db$exports).SELU_SCALE};
  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);
`;
const $82b816405898321f$export$a5f8240d9e99b438 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $82b816405898321f$var$SELU
});
const $82b816405898321f$export$8afc8558705c1a39 = {
    kernelName: (0, $507890e4aa8e1463$export$6760d858e6f2594a),
    backendName: 'webgl',
    kernelFunc: $82b816405898321f$export$a5f8240d9e99b438
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $cf1b91c76ed3232d$var$SIGMOID = (0, $d770bb96fbeee88f$export$bf39b1cb254b6187) + `
  return 1.0 / (1.0 + exp(-1.0 * x));
`;
const $cf1b91c76ed3232d$var$SIGMOID_PACKED = `
  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $cf1b91c76ed3232d$export$3b295495ca3cad7c = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $cf1b91c76ed3232d$var$SIGMOID,
    packedOpSnippet: $cf1b91c76ed3232d$var$SIGMOID_PACKED,
    cpuKernelImpl: (0, $1cec302811203101$export$9b816377c2ca1f1f)
});
const $cf1b91c76ed3232d$export$195d1cf7c59f3ef = {
    kernelName: (0, $507890e4aa8e1463$export$fde18c826dda6b1b),
    backendName: 'webgl',
    kernelFunc: $cf1b91c76ed3232d$export$3b295495ca3cad7c
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

// Sign does not propagate NANs.
const $7dcbf4341e9b312c$var$SIGN = `
  if (isnan(x)) { return 0.0; }
  return sign(x);
`;
const $7dcbf4341e9b312c$export$c5552dfdbc7cec71 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $7dcbf4341e9b312c$var$SIGN
});
const $7dcbf4341e9b312c$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $507890e4aa8e1463$export$1db683ad541682f6),
    backendName: 'webgl',
    kernelFunc: $7dcbf4341e9b312c$export$c5552dfdbc7cec71
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $5e3733a6494c4bc5$var$SIN = (0, $d770bb96fbeee88f$export$bf39b1cb254b6187) + `
  return sin(x);
`;
const $5e3733a6494c4bc5$var$SIN_PACKED = `
  vec4 result = sin(x);
  bvec4 isNaN = isnan(x);
  ${(0, $845a6b9d98d1f900$export$2b4d5cee4bd7b2dd)}
  return result;
`;
const $5e3733a6494c4bc5$export$5de3937cb4b592ed = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $5e3733a6494c4bc5$var$SIN,
    packedOpSnippet: $5e3733a6494c4bc5$var$SIN_PACKED
});
const $5e3733a6494c4bc5$export$d993ec4e5c253b66 = {
    kernelName: (0, $507890e4aa8e1463$export$75be1b631f7687),
    backendName: 'webgl',
    kernelFunc: $5e3733a6494c4bc5$export$5de3937cb4b592ed
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $d0ec2fe58cd48847$var$SINH = `
  float e2x = exp(x);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const $d0ec2fe58cd48847$export$545004b505d7c555 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $d0ec2fe58cd48847$var$SINH
});
const $d0ec2fe58cd48847$export$b92766b47f18ac85 = {
    kernelName: (0, $507890e4aa8e1463$export$b8c187376329d79b),
    backendName: 'webgl',
    kernelFunc: $d0ec2fe58cd48847$export$545004b505d7c555
};




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $17137acf1aa41712$var$SOFTPLUS = `
  float epsilon = 1.1920928955078125e-7;
  float threshold = log(epsilon) + 2.0;

  bool too_large = x > -threshold;
  bool too_small = x < threshold;

  float result;
  float exp_x = exp(x);

  if (too_large){
    result = x;
  }
  else if (too_small){
    result = exp_x;
  }
  else{
    result = log(exp_x + 1.0);
  }
  return result;
`;
const $17137acf1aa41712$export$76aa560a8c2b0055 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $17137acf1aa41712$var$SOFTPLUS
});
const $17137acf1aa41712$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $507890e4aa8e1463$export$c5af433747f1fd0a),
    backendName: 'webgl',
    kernelFunc: $17137acf1aa41712$export$76aa560a8c2b0055
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



const $1178e43a59082d75$export$effb9d7cae92012f = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $0775da5e684c8c0d$exports).assert(x.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const toDispose = [];
    const paddedX = (0, $29f8dda7be82fac6$export$f676d6ad4f38bb89)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $f35e0c1a651337db$exports).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $f35e0c1a651337db$exports).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $f35e0c1a651337db$exports).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapedPaddedX = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: paddedX
        },
        backend: backend,
        attrs: {
            shape: reshapedPaddedShape
        }
    });
    const paddedXT = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
        inputs: {
            x: reshapedPaddedX
        },
        backend: backend,
        attrs: {
            perm: permutedReshapedPaddedPermutation
        }
    });
    const result = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: paddedXT
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    toDispose.push(paddedX);
    toDispose.push(reshapedPaddedX);
    toDispose.push(paddedXT);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
};
const $1178e43a59082d75$export$2f85417863d2050b = {
    kernelName: (0, $507890e4aa8e1463$export$f63ac5409312707c),
    backendName: 'webgl',
    kernelFunc: $1178e43a59082d75$export$effb9d7cae92012f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $90ca5f66c670e293$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
         ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
         ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
         ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.readSync(indices.dataId);
    const $values = backend.readSync(values.dataId);
    const $denseShape = backend.readSync(denseShape.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId)[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $1cec302811203101$export$6cee5fb970d08428)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $90ca5f66c670e293$export$818286c593224d1a = {
    kernelName: (0, $507890e4aa8e1463$export$8f1933853a5c8cca),
    backendName: 'webgl',
    kernelFunc: $90ca5f66c670e293$export$c82a1904a15b5028
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $71fbeb8b16429ad2$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.readSync(inputShape.dataId));
    const $inputIndices = backend.readSync(inputIndices.dataId);
    const targetShape = Array.from(backend.readSync(newShape.dataId));
    const [newIndices, indicesShape, outputShape] = (0, $1cec302811203101$export$d17b3360054ff370)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $71fbeb8b16429ad2$export$eb106efc10374803 = {
    kernelName: (0, $507890e4aa8e1463$export$f08f0dca44fa542),
    backendName: 'webgl',
    kernelFunc: $71fbeb8b16429ad2$export$1408c45865e11fc6
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $cca9f9a521faa473$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
              ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
              ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $1cec302811203101$export$a503222c03b33888)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $cca9f9a521faa473$export$51e7224ae14d7f78 = {
    kernelName: (0, $507890e4aa8e1463$export$610b077aecc2447b),
    backendName: 'webgl',
    kernelFunc: $cca9f9a521faa473$export$dbc0c9096869d04e
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $961b5ab4695f82ac$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
             ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
             ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $1cec302811203101$export$a503222c03b33888)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $961b5ab4695f82ac$export$73fa0270f28b9555 = {
    kernelName: (0, $507890e4aa8e1463$export$68351c28d7116b56),
    backendName: 'webgl',
    kernelFunc: $961b5ab4695f82ac$export$2255ce53fc777865
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $99dc15742d8269d4$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $f35e0c1a651337db$exports).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    if (sparseValues.dtype === 'string') {
        const indicesBuf = backend.bufferSync(sparseIndices);
        const updatesBuf = backend.bufferSync(sparseValues);
        const $defaultValue = (0, $0775da5e684c8c0d$exports).decodeString(backend.readSync(defaultValue.dataId)[0]);
        const outBuf = (0, $1cec302811203101$export$2295c910080b5ca7)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
        return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $f0725c2e7dbebe9a$export$8d0317f5c5cbc1ac)(numUpdates, sliceRank, sparseIndices.shape.length, sparseValues.shape.length, strides, [
        outputSize,
        1
    ], sumDupeIndices);
    const res = backend.runWebGLProgram(program, [
        sparseValues,
        sparseIndices,
        defaultValue
    ], sparseValues.dtype);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outputShape
        }
    });
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $99dc15742d8269d4$export$7bc088f8ad44ef99 = {
    kernelName: (0, $507890e4aa8e1463$export$2c426709a9332421),
    backendName: 'webgl',
    kernelFunc: $99dc15742d8269d4$export$1be4b823dd1a3080
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $144ba33e7d405c89$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $0775da5e684c8c0d$exports).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $f35e0c1a651337db$exports).prepareSplitSize(x, numOrSizeSplits, $axis);
    const xRank = x.shape.length;
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $c77e6e12689cfb9b$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $144ba33e7d405c89$export$317be24be3af9ea0 = {
    kernelName: (0, $507890e4aa8e1463$export$8dffabb4071f05aa),
    backendName: 'webgl',
    kernelFunc: $144ba33e7d405c89$export$c0085d48b0a75d8f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $44b4bd83bb1fd1af$var$SQRT = `return sqrt(x);`;
const $44b4bd83bb1fd1af$export$eba8049fb5020b81 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $44b4bd83bb1fd1af$var$SQRT,
    packedOpSnippet: $44b4bd83bb1fd1af$var$SQRT,
    cpuKernelImpl: (0, $1cec302811203101$export$548a22b20eeaf85b)
});
const $44b4bd83bb1fd1af$export$a592ba9268f10eeb = {
    kernelName: (0, $507890e4aa8e1463$export$21ab404ab9d512a6),
    backendName: 'webgl',
    kernelFunc: $44b4bd83bb1fd1af$export$eba8049fb5020b81
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $c15372ca2ef76b94$var$SQUARE = `return x * x;`;
const $c15372ca2ef76b94$export$dd4f28cef696bc7d = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $c15372ca2ef76b94$var$SQUARE
});
const $c15372ca2ef76b94$export$7c77bece4d51efc4 = {
    kernelName: (0, $507890e4aa8e1463$export$b09fb900337259de),
    backendName: 'webgl',
    kernelFunc: $c15372ca2ef76b94$export$dd4f28cef696bc7d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $0ce61a34fc1979b4$var$SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
const $0ce61a34fc1979b4$export$b178697fb6d0b37f = (0, $d770bb96fbeee88f$export$29353c66e70e3e16)({
    opSnippet: $0ce61a34fc1979b4$var$SQUARED_DIFFERENCE,
    packedOpSnippet: $0ce61a34fc1979b4$var$SQUARED_DIFFERENCE
});
const $0ce61a34fc1979b4$export$9ed4691d69db8a43 = {
    kernelName: (0, $507890e4aa8e1463$export$2f922d20d66089c6),
    backendName: 'webgl',
    kernelFunc: $0ce61a34fc1979b4$export$b178697fb6d0b37f
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $9170413a6dea298e$export$2bdfdc7ae087914d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    if (x.dtype !== 'string') throw new Error('Input must be of datatype string');
    const $x = backend.readSync(x.dataId);
    const stringInput = (0, $f35e0c1a651337db$exports).fromUint8ToStringArray($x);
    const output = (0, $1cec302811203101$export$b3e893e48b8d1e39)(stringInput, 'string', attrs);
    return backend.makeTensorInfo(x.shape, 'string', output);
}
const $9170413a6dea298e$export$1069b2f6977254f4 = {
    kernelName: (0, $507890e4aa8e1463$export$2fbaa77553edaeff),
    backendName: 'webgl',
    kernelFunc: $9170413a6dea298e$export$2bdfdc7ae087914d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $212b12d10fc39763$export$35d34bc0ed591a92({ inputs: inputs, attrs: attrs, backend: backend }) {
    const { x: x } = inputs;
    const opSnippet = (0, $b1c981bb7af6249a$export$39f0cca2b63399f6) + `
    return x > 0.0 ? 1.0 : float(${attrs.alpha});
  `;
    const program = new (0, $b1c981bb7af6249a$export$f93811a5a466fd42)(x.shape, opSnippet);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $212b12d10fc39763$export$c42ffaf52eb2647 = {
    kernelName: (0, $507890e4aa8e1463$export$fd55ce593607084a),
    backendName: 'webgl',
    kernelFunc: $212b12d10fc39763$export$35d34bc0ed591a92
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $0624a323a3442955$export$335c52ce94f359f6 {
    constructor(begin, strides, size){
        this.variableNames = [
            'x'
        ];
        this.outputShape = size;
        const rank = size.length;
        const inputDtype = (0, $a18658cdba53b459$export$859efd105c10c755)(size.length);
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(size.length);
        let newCoords = '';
        if (rank === 1) newCoords = 'coords * strides + begin';
        else {
            let outputAxis = 0;
            newCoords = size.map((_, i)=>{
                outputAxis++;
                return size.length === 1 ? `coords * strides[${i}] + begin[${i}]` : `coords[${outputAxis - 1}] * strides[${i}] + begin[${i}]`;
            }).join(',');
        }
        this.userCode = `
      ${inputDtype} begin = ${inputDtype}(${begin});
      ${inputDtype} strides = ${inputDtype}(${strides});

      void main() {
        ${dtype} coords = getOutputCoords();
        setOutput(getX(${newCoords}));
      }
    `;
    }
}




function $e442bb3e1e48f6a7$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $f147fd057118a602$exports).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $0775da5e684c8c0d$exports).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $f147fd057118a602$exports).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $c77e6e12689cfb9b$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
            x
        ]);
        if (shouldExecuteOnCPU) {
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const values = backend.readSync(x.dataId);
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const xBuf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(x.shape, x.dtype, values);
            const resultValues = (0, $1cec302811203101$export$efd4e188e5de0188)(finalShapeSparse, xBuf, $strides, $begin);
            result = backend.makeTensorInfo(finalShape, x.dtype, resultValues.values);
        } else {
            const program = new (0, $0624a323a3442955$export$335c52ce94f359f6)($begin, $strides, finalShapeSparse);
            result = backend.runWebGLProgram(program, [
                x
            ], x.dtype);
        }
    }
    const resultReshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $e442bb3e1e48f6a7$export$81773633114187bd = {
    kernelName: (0, $507890e4aa8e1463$export$60c7f9ac271417a9),
    backendName: 'webgl',
    kernelFunc: $e442bb3e1e48f6a7$export$4ae57224f3b0605c
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $ad58606189a7a15d$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.readSync(data.dataId);
    const $dataSplits = backend.readSync(dataSplits.dataId);
    const [nGrams, nGramsSplits] = (0, $1cec302811203101$export$bb9e83cb65884ef3)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $ad58606189a7a15d$export$35e13284eed34c22 = {
    kernelName: (0, $507890e4aa8e1463$export$11a7f4af7d96ad41),
    backendName: 'webgl',
    kernelFunc: $ad58606189a7a15d$export$3490514dcc63b044
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $38a7f591c27026a3$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.readSync(input.dataId);
    const $delimiter = backend.readSync(delimiter.dataId)[0];
    const [indices, values, shape] = (0, $1cec302811203101$export$bb4b4a9a1db97dea)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $38a7f591c27026a3$export$c51cbbd627a96532 = {
    kernelName: (0, $507890e4aa8e1463$export$7e266f7223b9d396),
    backendName: 'webgl',
    kernelFunc: $38a7f591c27026a3$export$aa7f8babb17e7672
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $0df64a52a5990dc4$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.readSync(input.dataId);
    const output = (0, $1cec302811203101$export$d7d8a9bba3df6e63)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $0df64a52a5990dc4$export$a88a78b2b233f507 = {
    kernelName: (0, $507890e4aa8e1463$export$a5639899909bc8ae),
    backendName: 'webgl',
    kernelFunc: $0df64a52a5990dc4$export$6195616d6fd0c848
};




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $356399372f8b34b5$var$TAN = `return tan(x);`;
const $356399372f8b34b5$export$fcdd3b0b3246a325 = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $356399372f8b34b5$var$TAN
});
const $356399372f8b34b5$export$97648844df7611f3 = {
    kernelName: (0, $507890e4aa8e1463$export$115b2d5263ba5985),
    backendName: 'webgl',
    kernelFunc: $356399372f8b34b5$export$fcdd3b0b3246a325
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $18a62a9a05e0e760$var$TANH = `
  float e2x = exp(-2.0 * abs(x));
  return sign(x) * (1.0 - e2x) / (1.0 + e2x);
`;
const $18a62a9a05e0e760$export$7128670e45beef9a = (0, $d770bb96fbeee88f$export$ba4daf5748026fba)({
    opSnippet: $18a62a9a05e0e760$var$TANH
});
const $18a62a9a05e0e760$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $507890e4aa8e1463$export$893b6e865e352c83),
    backendName: 'webgl',
    kernelFunc: $18a62a9a05e0e760$export$7128670e45beef9a
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $069e526a547ec40b$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const {} = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $f35e0c1a651337db$exports).calculateShapes(updates, indices, tensor.shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(tensor.shape, indices.dtype);
    const flattenIndices = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const flattenTensor = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: tensor
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    const program = new (0, $f0725c2e7dbebe9a$export$8d0317f5c5cbc1ac)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, false, true);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        flattenTensor
    ], flattenTensor.dtype);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: tensor.shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(flattenTensor);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $069e526a547ec40b$export$2819813ce8339b64 = {
    kernelName: (0, $507890e4aa8e1463$export$20050a140fd1de77),
    backendName: 'webgl',
    kernelFunc: $069e526a547ec40b$export$d3ac02769385eb36
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $229a718a87467439$export$215140f0ab19f420 {
    constructor(aShape, reps){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[i] * reps[i];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $a18658cdba53b459$export$859efd105c10c755)(this.rank);
        const sourceCoords = $229a718a87467439$var$getSourceCoords(aShape);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        setOutput(getA(${sourceCoords}));
      }
    `;
    }
}
function $229a718a87467439$var$getSourceCoords(aShape) {
    const rank = aShape.length;
    if (rank > 5) throw Error(`Tile for rank ${rank} is not yet supported`);
    if (rank === 1) return `imod(resRC, ${aShape[0]})`;
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)sourceCoords.push(`imod(${currentCoords[i]}, ${aShape[i]})`);
    return sourceCoords.join();
}


function $496afae4e2f256b7$export$3c17558da18e4d75(params) {
    const { inputs: inputs, backend: backend, attrs: attrs } = params;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    // tile gpu program cannot handle rank > 5 case.
    if (x.dtype === 'string' || x.shape.length > 5) {
        // Even thought string tensor is always on CPU, just to be consistent on how
        // to access tensor data.
        const data = backend.readSync(x.dataId);
        const value = x.dtype === 'string' ? data.map((d)=>(0, $0775da5e684c8c0d$exports).decodeString(d)) : data;
        const buf = (0, $e54e5fd6b4dd8457$export$ab1029bcae9ddb4a)(x.shape, x.dtype, value);
        const outBuf = (0, $1cec302811203101$export$349e02a266ab3131)(buf, reps);
        return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $229a718a87467439$export$215140f0ab19f420)(x.shape, reps);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
}
const $496afae4e2f256b7$export$a5a9f8050ba7f41e = {
    kernelName: (0, $507890e4aa8e1463$export$235cb65c20ad2b7),
    backendName: 'webgl',
    kernelFunc: $496afae4e2f256b7$export$3c17558da18e4d75
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

// Based on Algorithm 2 of Bitonic Top K, ref:
// https://anilshanbhag.in/static/papers/gputopk_sigmod18.pdf
// The original algorithm is based on computing the top K only, however
// since for TFJS we require the indices of the top K values as well then the
// algorithm found here is a bit modified. Rather than producing the values
// at each step, the indices containing the top K are generated instead.
// The output values are not generated to reduce the number of outputs in the
// GPU, the values can easily be retrieved from the indices using a gather
// op.
class $dc204cfb301b1148$export$5ee54e3c81d6f6e7 {
    /**
     * @param shape desired output shape (can be larger than input shape, output
     *                                    will be padded with -Infinity)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK.
        // |firstPass|indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |inc| Swaps pairs of indices (0, inc), (1, inc + 1), (2, inc + 2) ...
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'negativeInf',
                type: 'float'
            },
            {
                name: 'dir',
                type: 'int'
            },
            {
                name: 'inc',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // We compare elements pair-wise within a group of size 2 * inc.
         // The comparing rule for each group alternates between ascending
         // and descending. Within each group, we compare each pair at
         // positions i and i+inc. To decide whether an element at position i
         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
         // inc, it is in the first half of the group, we denote it as x0,
         // otherwise we denote it as x1.
         // For example, as shown in the Bitonic top K paper referenced above,
         // Figure5(a) shows that element[1] is in the
         // second half of the group when group size is 2, but it is in the
         // first half of the group when group size is 4.

         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;
         int i = isFirstInPair ? elemIdx : elemIdx - inc;

         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));
         float x0 = i0 < n ? getX(batch, i0) : negativeInf;
         float x1 = i1 < n ? getX(batch, i1) : negativeInf;

         // Denotes which direction indices are in (ascending or descending).
         bool reverse = imod(elemIdx, 2 * dir) >= dir;
         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
         if (reverse == isGreater) { // Elements in opposite order of direction
           int iTemp = i0;
           i0 = i1;
           i1 = iTemp;
         }
         if (isFirstInPair) {
            setOutput(float(i0));
         } else {
            setOutput(float(i1));
         }
       }
     `;
    }
}
class $dc204cfb301b1148$export$c3fbf8b38d821ac9 {
    /**
     * @param shape desired output shape (must be half of the input size)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK
        // |firstPass| indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |k| Top k elements desired
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'k',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
    void main() {
         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // The output size is half of the previous size.
         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),
         // we only need to output the indices at positions |, the indices at
         // positions _ can be thrown away, see Figure5(b) After Phase 2
         // (Merge phase) in the Bitonic Top K paper referenced above.
         // For example, the paper shows we only need to output the orange bars.
         // The output sequence should look like this | | | | | | | |.
         // Because the sequence is halved, to map the output index back
         // to the previous sequence to find the corresponding value,
         // we need to double the index. When we double the index,
         // we basically interpolate a position, so 2i looks like
         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position
         // of each 2k positions by - elemIdx % k. E.g. for output at
         // index 4,5,6,7, we want to get the corresponding element at
         // original index 8,9,10,11, for output at index 8,9,10,11,
         // we want to get the corresponding element at original index
         // 16,17,18,19, so on and so forth.

         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));
         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));

         float x0 = getX(batch, i0);
         float x1 = i1 < n ? getX(batch, i1) : x0;

         setOutput(x0 >= x1 ? float(i0) : float(i1));
       }
     `;
    }
}






function $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, tensorInfo) {
    if (tensorInfo !== null) backend.disposeIntermediateTensorInfo(tensorInfo);
}
function $f76aab861e64522a$var$roundUpToPow2(num) {
    let pow2 = 1;
    while(pow2 < num)pow2 *= 2;
    return pow2;
}
function $f76aab861e64522a$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    // Empirically determined constant used to determine last dim threshold for
    // handing off execution to the CPU.
    const TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD');
    // Empirically determined constant used to determine k threshold for handing
    // off execution to the CPU.
    const TOPK_K_CPU_HANDOFF_THRESHOLD = (0, $339e95daf833709b$export$a7b6bc01c63cdfc3)().getNumber('TOPK_K_CPU_HANDOFF_THRESHOLD');
    const xShape = x.shape;
    const lastDim = xShape[xShape.length - 1];
    if (backend.shouldExecuteOnCPU([
        x
    ]) || lastDim < TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD || k > TOPK_K_CPU_HANDOFF_THRESHOLD) {
        const xVals = backend.readSync(x.dataId);
        const [allTopKVals, allTopKIndices] = (0, $1cec302811203101$export$cc4aa6851cf96e2b)(xVals, xShape, x.dtype, k, sorted);
        return [
            backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
            backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
        ];
    }
    if (k === 0) {
        xShape[xShape.length - 1] = 0;
        return [
            backend.makeTensorInfo(xShape, x.dtype, []),
            backend.makeTensorInfo(xShape, 'int32', [])
        ];
    }
    if (lastDim === 1 /* firstPass */ ) return [
        x,
        (0, $d717ecf39741148f$export$9563e054e6f787fb)({
            attrs: {
                shape: xShape,
                dtype: 'int32',
                value: 0
            },
            backend: backend
        })
    ];
    // Eagerly unpack x input since it is passed in to all the shaders which
    // require unpacked inputs.
    const xtexData = backend.texData.get(x.dataId);
    const xIsPacked = xtexData !== null && xtexData.isPacked;
    const xUnPacked = xIsPacked ? backend.unpackTensor(x) : x;
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const xSize = (0, $0775da5e684c8c0d$exports).sizeFromShape(xShape);
    const batch = xSize / lastDim;
    const x2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: xUnPacked
        },
        attrs: {
            shape: [
                batch,
                lastDim
            ]
        },
        backend: backend
    });
    if (xIsPacked) $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, xUnPacked);
    const kPow2 = $f76aab861e64522a$var$roundUpToPow2(k);
    const lastDimPow2 = $f76aab861e64522a$var$roundUpToPow2(lastDim);
    // Only the indices containing the top K are kept at every step to reduce
    // number of outputs in the GPU algorithms, so once the final set of indices
    // is computed then gather is used to grab the corresponding values
    // from the original input.
    let indices = null;
    // GPU algorithm always takes in an indices input but this input is not used
    // on the first run of a GPU algorithm, therefore if indices is null we simply
    // pass in x2D instead of it but the value will not actually be used
    const getInputs = ()=>indices === null ? [
            x2D,
            x2D
        ] : [
            x2D,
            indices
        ];
    const runSwap = (dir, inc, shape)=>{
        const inputs = getInputs();
        const program = new (0, $dc204cfb301b1148$export$5ee54e3c81d6f6e7)(shape);
        const fistPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                fistPass
            ],
            [
                Number.NEGATIVE_INFINITY
            ],
            [
                dir
            ],
            [
                inc
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(program, inputs, 'int32', customValues);
        $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    };
    // Step 1: local sort
    for(let len = 1; len < kPow2; len *= 2){
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, [
            batch,
            lastDimPow2
        ]);
    }
    // Step 2: merge
    for(let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2){
        const inputs = getInputs();
        const mergeProgram = new (0, $dc204cfb301b1148$export$c3fbf8b38d821ac9)([
            batch,
            indicesSize / 2
        ]);
        const firstPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                firstPass
            ],
            [
                kPow2
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(mergeProgram, inputs, 'int32', customValues);
        $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
        // Step 3: rebuild
        const len = kPow2 / 2;
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, indices.shape);
    }
    // Keep only the requested top K results instead of kPow2
    let prevIndices = indices;
    indices = (0, $c77e6e12689cfb9b$export$58adb3bec8346d0f)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            begin: 0,
            size: [
                batch,
                k
            ]
        }
    });
    $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    // Gather values on last dimension
    let values = (0, $0c5a2f4de81ea707$export$3d75b4295ded9925)({
        inputs: {
            x: x2D,
            indices: indices
        },
        backend: backend,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, x2D);
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const newShape = xShape.slice(0, -1);
    newShape.push(k);
    prevIndices = indices;
    indices = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    const prevValues = values;
    values = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: values
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $f76aab861e64522a$var$disposeIntermediateTensorInfoOrNull(backend, prevValues);
    return [
        values,
        indices
    ];
}
const $f76aab861e64522a$export$cffaee31213314ce = {
    kernelName: (0, $507890e4aa8e1463$export$c593cd1ea0d02ebd),
    backendName: 'webgl',
    kernelFunc: $f76aab861e64522a$export$7e641efc73a2d81
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $0cefb709677084f3$export$c83a293baf8f269d {
    constructor(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape){
        this.variableNames = [
            'Image',
            'Transforms'
        ];
        this.outputShape = outShape;
        const interpolationModeId = interpolation === 'nearest' ? 1 : 2;
        let fillModeId;
        switch(fillMode){
            case 'constant':
                fillModeId = 1;
                break;
            case 'reflect':
                fillModeId = 2;
                break;
            case 'wrap':
                fillModeId = 3;
                break;
            case 'nearest':
                fillModeId = 4;
                break;
            default:
                fillModeId = 1;
                break;
        }
        this.userCode = `
            float mapCoord(float outCoord, float len) {
              float inCoord = outCoord;
              if(${fillModeId} == 2) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    if (inCoord < sz2) {
                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +
                      inCoord;
                    }
                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    inCoord -= sz2 * float(int(float(inCoord / sz2)));
                    if (inCoord >= len) {
                      inCoord = sz2 - inCoord - 1.0;
                    }
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 3) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord -= len * float(int(float(inCoord / sz)));
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 4) {
                return clamp(outCoord, 0.0, len - 1.0);
              } else {
                return outCoord;
              }
            }

            float readWithFillValue(int batch, int coordY, int coordX,
              int channel) {
              float outputValue;
              if (0 <= coordY && coordY < ${imageHeight} && 0 <= coordX && coordX < ${imageWidth}) {
                  outputValue = getImage(batch, coordY, coordX, channel);
              } else {
                outputValue = float(${fillValue});
              }
              return outputValue;
            }

            void main() {
              ivec4 coords = getOutputCoords();
              float outputValue;
              int batch = coords[0];
              int x = coords[2];
              int y = coords[1];
              int channel = coords[3];
              float xf = float(x);
              float yf = float(y);
              float a1 = getTransforms(batch, 0);
              float a2 = getTransforms(batch, 1);
              float a3 = getTransforms(batch, 2);
              float b1 = getTransforms(batch, 3);
              float b2 = getTransforms(batch, 4);
              float b3 = getTransforms(batch, 5);
              float c1 = getTransforms(batch, 6);
              float c2 = getTransforms(batch, 7);
              float projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = float(${fillValue});
              } else {
                float inX = (a1 * xf + a2 * yf + a3) / projection;
                float inY = (b1 * xf + b2 * yf + b3) / projection;
                float mapX = mapCoord(inX, float(${imageWidth}));
                float mapY = mapCoord(inY, float(${imageHeight}));

                if (${interpolationModeId} == 1) {
                  int coordY = int(round(mapY));
                  int coordX = int(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  float yFloor = floor(mapY);
                  float xFloor = floor(mapX);
                  float yCeil = yFloor + 1.0;
                  float xCeil = xFloor + 1.0;
                  float valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);
                  float valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutput(outputValue);
            }
        `;
    }
}


function $c1408bd32215e347$export$51186ad6e864892a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const program = new (0, $0cefb709677084f3$export$c83a293baf8f269d)(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape);
    return backend.runWebGLProgram(program, [
        image,
        transforms
    ], 'float32');
}
const $c1408bd32215e347$export$1c7a3de6335954ed = {
    kernelName: (0, $507890e4aa8e1463$export$563a914cafbdc389),
    backendName: 'webgl',
    kernelFunc: $c1408bd32215e347$export$51186ad6e864892a
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $5658f602e9ebed5d$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $f6f0bdab98aa0468$export$1412c17b2531581a)(x, 'unique');
    // For now, always forward calculation to the CPU backend.
    console.warn('WARNING: ', 'UI might be locked temporarily as data is being downloaded');
    const values = backend.readSync(x.dataId);
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $1cec302811203101$export$c417de669ad2e148)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $5658f602e9ebed5d$export$78cd70dcd092910e = {
    kernelName: (0, $507890e4aa8e1463$export$8e3adf126971a183),
    backendName: 'webgl',
    kernelFunc: $5658f602e9ebed5d$export$7a5d5c156e7dc406
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $c6e010d1ac55e9fc$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const x = value;
    const xRank = x.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(xRank - 1);
    let outIndex = 0;
    for(let i = 0; i < xRank; i++)if (i !== axis) outShape[outIndex++] = x.shape[i];
    const toDispose = [];
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const sliced = (0, $c77e6e12689cfb9b$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        res[i] = reshaped;
        toDispose.push(sliced);
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $c6e010d1ac55e9fc$export$d06292128cae50d6 = {
    kernelName: (0, $507890e4aa8e1463$export$441ad6bfc5db8ab4),
    backendName: 'webgl',
    kernelFunc: $c6e010d1ac55e9fc$export$417857010dc9287f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $27b7c333c349d634$export$543f739d986d05c3 {
    constructor(segOpInfo, segOpType){
        this.variableNames = [
            'x',
            'segmentIds'
        ];
        const windowSize = segOpInfo.windowSize;
        const batchSize = segOpInfo.batchSize;
        const inSize = segOpInfo.inSize;
        const numSegments = segOpInfo.numSegments;
        const outSize = numSegments * Math.ceil(inSize / windowSize);
        this.outputShape = [
            batchSize,
            outSize
        ];
        const initializationValue = '0.0';
        const returnValue = `sumValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        const updateSnippet = `
        sumValue += dot(values, segFilter);
    `;
        let checkValueOutOfBounds = '';
        if (inSize % windowSize > 0) checkValueOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        let checkSegmentIdOutOfBounds = '';
        if (inSize % windowSize > 0) checkSegmentIdOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return -1.0;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};

      float getValue(int batch, int inIdx) {
        ${checkValueOutOfBounds}
        return getX(batch, inIdx);
      }

      float getSegmentIdAtIndex(int inIdx) {
        ${checkSegmentIdOutOfBounds}
        return getSegmentIds(inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = int(floor(float(outIdx) / float(
          ${numSegments})) * float(${windowSize}));
        int currentSeg = int(mod(float(outIdx), float(${numSegments})));

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            0,
            0,
            0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
              0,
              0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            0
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}






function $1db510320962263d$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    let axis = 0;
    const permutation = (0, $f35e0c1a651337db$exports).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) {
        permutedX = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        toDispose.push(permutedX);
        axis = (0, $f35e0c1a651337db$exports).getInnerMostAxes(1, xRank)[0];
    }
    const outShape = (0, $f35e0c1a651337db$exports).segment_util.computeOutShape(permutedX.shape, axis, numSegments);
    const inSize = (0, $0775da5e684c8c0d$exports).sizeFromShape([
        permutedX.shape[axis]
    ]);
    const a2D = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    toDispose.push(a2D);
    const outputDType = (0, $4ccb7c1368387e67$export$3479b4fbed3c0d8d)(x.dtype);
    const segOpCompute = (x, segOpType, segmentIds, dtype, numSegments)=>{
        const batchSize = x.shape[0];
        const inSize = x.shape[1];
        const windowSize = (0, $f35e0c1a651337db$exports).segment_util.segOpComputeOptimalWindowSize(inSize, numSegments);
        const segOpInfo = {
            windowSize: windowSize,
            inSize: inSize,
            batchSize: batchSize,
            numSegments: numSegments
        };
        const program = new (0, $27b7c333c349d634$export$543f739d986d05c3)(segOpInfo, segOpType);
        const output = backend.compileAndRun(program, [
            x,
            segmentIds
        ], dtype);
        toDispose.push(output);
        // No need to run another GPGPU program.
        if (output.shape[1] === numSegments) return output;
        const rangeInfo = (0, $ad18f707db942307$export$d02631cccf789723)({
            backend: backend,
            attrs: {
                start: 0,
                stop: numSegments,
                step: 1,
                dtype: 'float32'
            }
        });
        const tileInfo = (0, $496afae4e2f256b7$export$3c17558da18e4d75)({
            inputs: {
                x: rangeInfo
            },
            backend: backend,
            attrs: {
                reps: [
                    inSize / windowSize
                ]
            }
        });
        toDispose.push(rangeInfo);
        toDispose.push(tileInfo);
        const result = segOpCompute(output, segOpType, tileInfo, dtype, numSegments);
        return result;
    };
    const segOpResult = segOpCompute(a2D, 'unsortedSegmentSum', segmentIds, outputDType, numSegments);
    const reshaped = (0, $fa3edc728a2e320c$export$9eaad88cf88cee2b)({
        inputs: {
            x: segOpResult
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    let result = reshaped;
    if (permutation != null) {
        toDispose.push(reshaped);
        const perm = (0, $f35e0c1a651337db$exports).getUndoAxesPermutation(permutation);
        result = (0, $1c4657c4bdbc3da9$export$9cb09a71b7d66923)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: perm
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $1db510320962263d$export$71e3626a4ca29968 = {
    kernelName: (0, $507890e4aa8e1463$export$af810663cded5fe2),
    backendName: 'webgl',
    kernelFunc: $1db510320962263d$export$ba7c4d144d85a309
};



// List all kernel configs here
const $f0ddc9f53c6fc928$var$kernelConfigs = [
    (0, $ee939c71e5790a4a$export$f70d36da1c218f84),
    (0, $699ad679f487e1fb$export$d66f48648b9d5ec7),
    (0, $c2bd9f32ffd620c4$export$255826ca70737275),
    (0, $20f0d10500127df9$export$3f520b71a56c9e70),
    (0, $1b609dcf1a546aff$export$b1f3a580afb68e4c),
    (0, $f993bb4c35385a7d$export$ff8000bc6f0313e1),
    (0, $c5d671667fdd4ddd$export$4e3f081eb1a330fa),
    (0, $3882cc1fb3f31d51$export$1a8ff634f2df3da6),
    (0, $14aaa2183f9a3bf0$export$ec7419fc9ad0069e),
    (0, $ac8a2391b7d02edd$export$21836a5e5fa09eb4),
    (0, $f68e15c4e27b742c$export$de5cb0ef95dd6700),
    (0, $ad77828faadec38a$export$20d424616c76166),
    (0, $bd86350724669de1$export$159d632e3ff13624),
    (0, $cabac374ecd3048e$export$c53c7ab019edb8a0),
    (0, $5b4556489d3f8cd9$export$e9ce1ba75fc9b746),
    (0, $25e74c1a889062ec$export$6c901824a23e6150),
    (0, $4d3565df9ada271b$export$5a9c81d240244392),
    (0, $e09821a54384de8c$export$1eeb8780807d0508),
    (0, $2536508d1a2a33db$export$ac3f8709351ab225),
    (0, $441717a786130602$export$d0dd993198185538),
    (0, $72072ccb62d79264$export$df2dc5c7a755e418),
    (0, $5f87b77034830ff7$export$44e08e19f97e5513),
    (0, $9a8f6dde2b526303$export$af9f0093738840fb),
    (0, $1a06e0c150dbdb81$export$6d53927dafa38bf9),
    (0, $7b77d3241d159562$export$8f7b2ec0c6f08fb2),
    (0, $9c293e2e2e5c8de5$export$ac4d0f0f3927a8f3),
    (0, $0fef2d9cfa1a3f46$export$df387212b1898306),
    (0, $eee2af9d0117e73a$export$f7ee8f07ce0ff4e1),
    (0, $a1426942a1186ebb$export$67917f7910d27fd8),
    (0, $263a6d991c175c2d$export$a4817d2978acc054),
    (0, $96cfa83cf7469b29$export$c8cf96dae25282e5),
    (0, $37873063552b1d98$export$4a39bf13b4378042),
    (0, $fdae7f50dc117069$export$7a95f55d2d2e7d24),
    (0, $e62aaa60a192be5b$export$19bbc19fff1ed26f),
    (0, $8bc7a4aa68e84b12$export$1fe590fda0829040),
    (0, $af1a1036d6ff5a5b$export$6dce9169640850fa),
    (0, $1e452c2c789ec117$export$cdcac766a3ef1744),
    (0, $ae16523bd100b6ad$export$ff099a1da5235a7e),
    (0, $e219df4d24afa34b$export$c5824052b09ba0ed),
    (0, $730670272b7fca20$export$f7086edcf0050c7f),
    (0, $1986a8584298489b$export$db50d81ed60c5a35),
    (0, $4592fa10e21b38aa$export$2f6196f3316e7ed2),
    (0, $dbfad14251be08d2$export$88ba267b84334692),
    (0, $809947e6cef82232$export$9c5b88dcb1d2008b),
    (0, $c27a68ca8c416df2$export$240667804b7c390e),
    (0, $205df477dfbf9a46$export$30bc0ac3775583fc),
    (0, $f4b20c9bea72245e$export$55d12409e744bebe),
    (0, $b43cd568e2967973$export$56dc5d812a22748f),
    (0, $74c153cef2074155$export$36d3c11f61a8891a),
    (0, $c7b47b0fcf5efe3c$export$40bbf341885a23b7),
    (0, $e67e670418ba0ac4$export$b990686634ee3cce),
    (0, $b7cec932ff04e96c$export$59bb07dd04647a1d),
    (0, $d2569824a1e7c5de$export$3c8bc3d8ee318217),
    (0, $c69f458d2b03591c$export$d044ffef16079bd),
    (0, $be243d168303c1ee$export$2fd7ea0fcf021f34),
    (0, $3e4008b896c924ea$export$86341ba0ce5d8e60),
    (0, $652f720f0d7ea8db$export$16db8a08b36f938),
    (0, $b42bd72b22df700c$export$a4d564e380763c78),
    (0, $d717ecf39741148f$export$c953bf474b2bde62),
    (0, $9139e23ca1b31b0f$export$c9ec83cb23304466),
    (0, $82457195349a997e$export$7e9a0f96fa6bd01c),
    (0, $340be0d6c1d2ebc5$export$7eac933a0c7fd37f),
    (0, $33f199f68eb498a4$export$b22e14d614fc7178),
    (0, $682f2e112362089c$export$5b64efa829ddf94e),
    (0, $2d2e6fbf41af95a2$export$58481cc3409b412c),
    (0, $48996d80d58aef83$export$d9700eb1c7f5c969),
    (0, $0c5a2f4de81ea707$export$b1bd3139c91d8765),
    (0, $4f66b7828c9623b6$export$8c4f7e92d92310f8),
    (0, $66397ffc843f3402$export$7a6926f9fcac24ca),
    (0, $4565c1320ebddb8a$export$c426d3942537ad84),
    (0, $ae59ba4b2df78447$export$dc267425bf21b465),
    (0, $217ea7e271ca5f11$export$ddfc128c2801add7),
    (0, $bdb077694402852d$export$4d45c8f7b9ffdaf1),
    (0, $6d6163a26e43f0d4$export$bc383b82282e9b5a),
    (0, $96d61689af2c5138$export$d58ff790c765c1f0),
    (0, $61a07a9369feffc0$export$aa04ab963fdf437f),
    (0, $e1ad69f7f2932036$export$8d4530ce8b6ffc3c),
    (0, $287f091a50eac9b7$export$9f26bd257393dd8),
    (0, $729197add8ee611f$export$46b96f742c70959b),
    (0, $12444958de76b521$export$a4ae1f00643ddd14),
    (0, $14f27cac6505d0dd$export$c458b9e5ba980198),
    (0, $df613d0358d5aed0$export$257f1e82e69113fb),
    (0, $6a4c6684daa7041f$export$68e2dd0840056271),
    (0, $6ccef36c3249ec61$export$ce04b6546987ef43),
    (0, $9dc39364e74cd2aa$export$6fb124d5a6994734),
    (0, $492a61514ad5bd05$export$99a62fc039d7aca0),
    (0, $8b051c53b11bfa55$export$7d79147246e312bb),
    (0, $70e6af5f4c85c3fe$export$45b97bdc342e72a2),
    (0, $3b138df01d90fc23$export$45c8263b38f19e33),
    (0, $a5d40d22c7b0e3fc$export$91a8fc5da39ec855),
    (0, $0d6ad0c8d309f708$export$5201426bb10bd5eb),
    (0, $0e485e09200039d8$export$e01a7f8dbee29127),
    (0, $d6c80cf7151f0eb3$export$a069ee2247a7d1ce),
    (0, $98a58188dd8f469e$export$b934af0ccd0cdbe1),
    (0, $d483c194e7539669$export$3cd9f9a31b38cf18),
    (0, $e03817dbaa06bbb0$export$ea24ffbbbce8d546),
    (0, $307ad2c13084635b$export$2cfd6c6c7daeb5fc),
    (0, $d6d08aca45d9c2a1$export$9037685a81180a9c),
    (0, $364860dd6df456d8$export$ad960e364767f0e2),
    (0, $951ae52c1905ecdf$export$745576778aafee88),
    (0, $d75a61973198b844$export$cc7b18b8229c3db),
    (0, $7432013e4e671179$export$549561cd158f260a),
    (0, $5762aa7cfc8d977b$export$906b8fb32c570e9d),
    (0, $77cf1115ce0e228c$export$4c00b682f309701d),
    (0, $0257d1a223ca6ecf$export$d003d4d7e1500775),
    (0, $da13844c5e01268f$export$dde5645b472b80b2),
    (0, $92eba13024379b38$export$d8d7015eb6ab37d0),
    (0, $d37d72bc93114742$export$1645fa8803aa1f86),
    (0, $29f8dda7be82fac6$export$b0317e720bfd61fc),
    (0, $8b0c36d89bf8109f$export$b823d49786719761),
    (0, $23ae834e36b40056$export$a5c4a9b694579636),
    (0, $d440bca714405b58$export$d556aa935cef5c0c),
    (0, $ad9bcf16f925db13$export$cebb8a7d5932c7e8),
    (0, $6704d5cf1ff66c2b$export$91ddd62a193b9401),
    (0, $5aa331d918940d77$export$792f441e33dcdf26),
    (0, $ad18f707db942307$export$361c4075706e31c2),
    (0, $d01fae68c7267ce6$export$4b7bce57557ae68b),
    (0, $62c8e00f7845e3a1$export$15c5d6176b30b9a6),
    (0, $76ec15aa63e8617d$export$412a6b66203fdf72),
    (0, $469401a94c8169b1$export$731f9199bde068eb),
    (0, $cbdfdb156dd6be21$export$92c30890ad649d53),
    (0, $fa3edc728a2e320c$export$cfa02e698602aca2),
    (0, $13b60e18f1cd3799$export$a37a56137abc1357),
    (0, $10acce583c51b114$export$51f84ca614e84763),
    (0, $0e546ad21d1eeac4$export$2b6a92caba113b89),
    (0, $3d2c6d572ac5702d$export$2b08d810b5090fe1),
    (0, $f02bb32dfb2c0a4e$export$cab6a4e8d2ed8e8d),
    (0, $52594bbca9813153$export$44ba8c83417ab668),
    (0, $c113d89fd901a82b$export$6c09e3291f636503),
    (0, $c9618968bcc47ea4$export$941104b789956ef6),
    (0, $6effc6492e20302a$export$573371744f044f5),
    (0, $26e7863cfdd57514$export$4b437b1a1aa6472f),
    (0, $4bc7e78284177998$export$7ff911e710ee72fc),
    (0, $82b816405898321f$export$8afc8558705c1a39),
    (0, $cf1b91c76ed3232d$export$195d1cf7c59f3ef),
    (0, $7dcbf4341e9b312c$export$9c0fb3eb2124ceb7),
    (0, $5e3733a6494c4bc5$export$d993ec4e5c253b66),
    (0, $d0ec2fe58cd48847$export$b92766b47f18ac85),
    (0, $c77e6e12689cfb9b$export$8d8a1e11dd2cc6c4),
    (0, $08be6664f17d4ed7$export$c022691f23e2ee69),
    (0, $17137acf1aa41712$export$d9bcfe553d12d9e3),
    (0, $1178e43a59082d75$export$2f85417863d2050b),
    (0, $90ca5f66c670e293$export$818286c593224d1a),
    (0, $71fbeb8b16429ad2$export$eb106efc10374803),
    (0, $cca9f9a521faa473$export$51e7224ae14d7f78),
    (0, $961b5ab4695f82ac$export$73fa0270f28b9555),
    (0, $99dc15742d8269d4$export$7bc088f8ad44ef99),
    (0, $144ba33e7d405c89$export$317be24be3af9ea0),
    (0, $44b4bd83bb1fd1af$export$a592ba9268f10eeb),
    (0, $c15372ca2ef76b94$export$7c77bece4d51efc4),
    (0, $0ce61a34fc1979b4$export$9ed4691d69db8a43),
    (0, $9170413a6dea298e$export$1069b2f6977254f4),
    (0, $212b12d10fc39763$export$c42ffaf52eb2647),
    (0, $e442bb3e1e48f6a7$export$81773633114187bd),
    (0, $ad58606189a7a15d$export$35e13284eed34c22),
    (0, $38a7f591c27026a3$export$c51cbbd627a96532),
    (0, $0df64a52a5990dc4$export$a88a78b2b233f507),
    (0, $28dc108b32441d03$export$5d068476dad60c4d),
    (0, $0082ed6af416fef1$export$47edea402251c258),
    (0, $356399372f8b34b5$export$97648844df7611f3),
    (0, $18a62a9a05e0e760$export$a2fc7de1a1e4eee0),
    (0, $069e526a547ec40b$export$2819813ce8339b64),
    (0, $496afae4e2f256b7$export$a5a9f8050ba7f41e),
    (0, $f76aab861e64522a$export$cffaee31213314ce),
    (0, $c1408bd32215e347$export$1c7a3de6335954ed),
    (0, $1c4657c4bdbc3da9$export$895a002a39b774be),
    (0, $5658f602e9ebed5d$export$78cd70dcd092910e),
    (0, $c6e010d1ac55e9fc$export$d06292128cae50d6),
    (0, $1db510320962263d$export$71e3626a4ca29968),
    (0, $079df9c4a2d91c76$export$15368df05c479e41)
];
for (const kernelConfig of $f0ddc9f53c6fc928$var$kernelConfigs)(0, $071cf1fd9dc2117e$export$f3f7c443f3a606e6)(kernelConfig);




/**
 * Extends a line formed by 2 points.
 * @param {number} x1 The x coordinate of the first point.
 * @param {number} y1 The y coordinate of the first point.
 * @param {number} x2 The x coordinate of the second point.
 * @param {number} y2 The y coordinate of the second point.
 * @param {number} distance The distance to extend the line to.
 * @returns {[number, number]} The coordinate of the extended line from the first point.
 */ function $c3c280a1a9197b81$export$728e9f9f95bdf3be(x2, y2, x1, y1, distance) {
    return [
        x1 + distance * (x2 - x1),
        y1 + distance * (y2 - y1)
    ];
}



var $hSilF = parcelRequire("hSilF");

var $eg79f = parcelRequire("eg79f");

var $eaQG2 = parcelRequire("eaQG2");
//Global Vars & Functions
let $705e64c36f7be633$var$currentLang = window.localStorage.getItem('lang') == 'en' ? 'en' : 'jp';
let $705e64c36f7be633$var$mirror = true;
let $705e64c36f7be633$var$showFPS = window.localStorage.getItem('showFPS') !== undefined ? Boolean(window.localStorage.getItem('showFPS') == 'true') : true;
let $705e64c36f7be633$var$activePageEventLoop = null;
let $705e64c36f7be633$var$activeCamStream = null;
let $705e64c36f7be633$var$selectedWebcam = null;
let $705e64c36f7be633$var$predictionActive = false;
let $705e64c36f7be633$var$mediapipeInitialised = false;
let $705e64c36f7be633$var$newPoseModel, $705e64c36f7be633$var$newPoseModelMode;
/** @type {import("./js/game/main")} */ let $705e64c36f7be633$var$Game;
function $705e64c36f7be633$var$closeNotifi(elm) {
    console.dir(elm);
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).parent().parent().animate({
        opacity: 0,
        height: 0,
        margin: 0,
        padding: 0
    }, 1000, ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).parent().parent().remove();
    });
}
function $705e64c36f7be633$var$notifi(status, title, text) {
    let notifi = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("<article>", {
        class: "notifi message " + status
    });
    let header = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("<div>", {
        class: "message-header"
    });
    header.text(title);
    header.append((0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("<button>", {
        class: "delete",
        click: (e)=>{
            $705e64c36f7be633$var$closeNotifi(e.target);
        }
    }));
    let body = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("<div>", {
        class: "message-body"
    });
    body.html(text);
    notifi.append(header, body);
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#notifications').append(notifi);
}
function $705e64c36f7be633$var$closeModalAuto(modalId) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modalId + " .modal-background").animate({
        opacity: 0
    }, 1000);
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modalId + " .modal-card").animate({
        right: "100%"
    }, 1000, ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modalId).removeClass('is-active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modalId + " .modal-background").css("opacity", "1");
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modalId + " .modal-card").css("right", "0%");
    });
}
function $705e64c36f7be633$var$closeModal(elm, stopLoad, stopStream) {
    let modal = elm.parentElement.parentElement.parentElement;
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modal).addClass("is-closing");
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modal).find(".modal-background").animate({
        opacity: 0
    }, 1000, ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modal).removeClass('is-active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modal).removeClass("is-closing");
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(modal).find(".modal-background").css("opacity", "1");
    });
    if (stopLoad) (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#startBtn").removeClass('is-loading');
    if (stopStream) $705e64c36f7be633$var$stopCamStream();
}
function $705e64c36f7be633$var$updateLang() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(`[data-${$705e64c36f7be633$var$currentLang}]`).each((_, elm)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).text((0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).attr(`data-${$705e64c36f7be633$var$currentLang}`));
    });
    if ($705e64c36f7be633$var$Game) $705e64c36f7be633$var$Game.lang = $705e64c36f7be633$var$currentLang;
    window.localStorage.setItem('lang', $705e64c36f7be633$var$currentLang);
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(".lang-btn").removeClass("is-active");
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(".lang-btn-2").removeClass("is-active");
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(`#lang-${$705e64c36f7be633$var$currentLang}-btn`).addClass("is-active");
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(`#lang-${$705e64c36f7be633$var$currentLang}-btn-2`).addClass("is-active");
    document.documentElement.setAttribute('lang', [
        'en',
        'jp'
    ].includes($705e64c36f7be633$var$currentLang) ? $705e64c36f7be633$var$currentLang : 'jp');
}
function $705e64c36f7be633$var$stopCamStream() {
    if ($705e64c36f7be633$var$activeCamStream) $705e64c36f7be633$var$activeCamStream.getTracks().forEach(function(track) {
        track.stop();
    });
}
//MediaPose Utilities
let $705e64c36f7be633$var$vision;
/** @type {import("@tensorflow-models/pose-detection").PoseDetector} */ let $705e64c36f7be633$var$poseLandmarker;
let $705e64c36f7be633$var$poseModel = window.localStorage.getItem('poseModel') || 'blazepose';
let $705e64c36f7be633$var$poseModelMode = window.localStorage.getItem('poseModelMode') || 'full';
if (!($705e64c36f7be633$var$poseModel === 'blazepose' && [
    'lite',
    'full',
    'heavy'
].includes($705e64c36f7be633$var$poseModelMode) || $705e64c36f7be633$var$poseModel === 'movenet' && [
    'thunder',
    'lightning'
].includes($705e64c36f7be633$var$poseModelMode))) {
    $705e64c36f7be633$var$poseModel = 'blazepose';
    $705e64c36f7be633$var$poseModelMode = 'full';
    window.localStorage.setItem('poseModel', $705e64c36f7be633$var$poseModel);
    window.localStorage.setItem('poseModelMode', $705e64c36f7be633$var$poseModelMode);
}
async function $705e64c36f7be633$var$initUtils() {
    try {
        await Promise.all([
            new Promise(async (resolve, reject)=>{
                try {
                    try {
                        await $8a461ef06e070cc9$export$7953970fabc9c2('webgpu');
                        if ($705e64c36f7be633$var$poseModel === 'movenet') $705e64c36f7be633$var$poseLandmarker = await $a54e498d8d862fdc$export$5221435586e5381b($a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet, {
                            modelType: $705e64c36f7be633$var$poseModelMode == 'thunder' ? $a54e498d8d862fdc$export$86beb49ae50c5d8b.modelType.SINGLEPOSE_THUNDER : $a54e498d8d862fdc$export$86beb49ae50c5d8b.modelType.SINGLEPOSE_LIGHTNING,
                            enableSmoothing: true
                        });
                        else if ($705e64c36f7be633$var$poseModel === 'blazepose') $705e64c36f7be633$var$poseLandmarker = await $a54e498d8d862fdc$export$5221435586e5381b($a54e498d8d862fdc$export$2f09812b4c450c2b.BlazePose, {
                            runtime: 'mediapipe',
                            solutionPath: './mediapipeAssets',
                            modelType: $705e64c36f7be633$var$poseModelMode,
                            enableSmoothing: true,
                            enableSegmentation: true,
                            smoothSegmentation: true
                        });
                    } catch (e) {
                        console.warn(e);
                        console.log("WebGPU Initialiasation Failed, falling back to WebGL...");
                        await $8a461ef06e070cc9$export$7953970fabc9c2('webgl');
                        if ($705e64c36f7be633$var$poseModel === 'movenet') $705e64c36f7be633$var$poseLandmarker = await $a54e498d8d862fdc$export$5221435586e5381b($a54e498d8d862fdc$export$2f09812b4c450c2b.MoveNet, {
                            modelType: $705e64c36f7be633$var$poseModelMode == 'thunder' ? $a54e498d8d862fdc$export$86beb49ae50c5d8b.modelType.SINGLEPOSE_THUNDER : $a54e498d8d862fdc$export$86beb49ae50c5d8b.modelType.SINGLEPOSE_LIGHTNING,
                            enableSmoothing: true
                        });
                        else if ($705e64c36f7be633$var$poseModel === 'blazepose') $705e64c36f7be633$var$poseLandmarker = await $a54e498d8d862fdc$export$5221435586e5381b($a54e498d8d862fdc$export$2f09812b4c450c2b.BlazePose, {
                            runtime: 'mediapipe',
                            solutionPath: './mediapipeAssets',
                            modelType: $705e64c36f7be633$var$poseModelMode,
                            enableSmoothing: true,
                            enableSegmentation: true,
                            smoothSegmentation: true
                        });
                    }
                    resolve();
                } catch (e) {
                    reject(e);
                }
            }),
            new Promise(async (resolve, reject)=>{
                try {
                    // FONT MAY RANDOMLY FAIL TO LOAD DURING TESTING, SEE https://stackoverflow.com/a/58689370/18573662
                    await fetch('./assets/fonts/Yusei Magic/YuseiMagic-Regular.ttf');
                    let attemptCount = 0;
                    let fontLoaded = false;
                    while(!fontLoaded && attemptCount <= 5)try {
                        const font = await new FontFace('Yusei Magic', 'url(\'./assets/fonts/Yusei Magic/YuseiMagic-Regular.ttf\')', {
                            style: 'normal',
                            weight: 400
                        }).load();
                        document.fonts.add(font);
                        fontLoaded = true;
                    } catch (e) {
                        if (attemptCount >= 5) throw e;
                        else {
                            console.error(e);
                            console.warn("Font failed to load, retrying...");
                            attemptCount++;
                            continue;
                        }
                    }
                    console.info("GAME FONT LOADED");
                    document.fonts.ready.then(()=>resolve()).catch((e)=>{
                        reject(e);
                    });
                } catch (e) {
                    reject(e);
                }
            }),
            new Promise(async (resolve, reject)=>{
                try {
                    $705e64c36f7be633$var$canvasElement = document.getElementById("canvas");
                    $705e64c36f7be633$var$canvasCtx = $705e64c36f7be633$var$canvasElement.getContext("2d");
                    $705e64c36f7be633$var$Game = new (0, $hSilF.default)($705e64c36f7be633$var$canvasCtx, window.innerWidth, window.innerHeight, 0, 0, 'webcam', $705e64c36f7be633$var$currentLang); // Initialise game first, later then resize when webcam is ready.
                    await $705e64c36f7be633$var$Game.load();
                    console.info("GAME ICONS & IMAGES LOADED");
                    resolve();
                } catch (e) {
                    reject(e);
                }
            })
        ]);
        $705e64c36f7be633$var$mediapipeInitialised = true;
        console.info("MEDIAPIPE UTILS READY");
    } catch (e) {
        $705e64c36f7be633$var$notifi('is-danger', "Error", `\u{30B2}\u{30FC}\u{30E0}\u{306E}\u{521D}\u{671F}\u{5316}\u{306B}\u{5931}\u{6557}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30DA}\u{30FC}\u{30B8}\u{3092}\u{518D}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{3057}\u{3066}\u{307F}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}<br>The game has failed to initialise. Please try to refresh the page.<br>${e}`);
        console.error(e);
    }
}
//Page 1
function $705e64c36f7be633$var$getDevices() {
    return navigator.mediaDevices.enumerateDevices().then((devices)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('select#videoSource').empty();
        let deviceCount = 0;
        for(var i = 0; i < devices.length; i++){
            let device = devices[i];
            if (device.kind === 'videoinput') {
                deviceCount++;
                let opt = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("<option>", {
                    value: device.deviceId,
                    text: device.label || 'Camera ' + deviceCount
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('select#videoSource').append(opt);
            }
        }
        if (deviceCount >= 1) return $705e64c36f7be633$var$webcamStart();
    });
}
function $705e64c36f7be633$var$webcamStart() {
    let useWebcam = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('select#videoSource').val();
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamConfirmBtn").addClass("is-loading");
    $705e64c36f7be633$var$stopCamStream();
    return navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
            deviceId: useWebcam
        }
    }).then((stream)=>{
        const videoTracks = stream.getVideoTracks();
        $705e64c36f7be633$var$selectedWebcam = videoTracks[0].getSettings().deviceId;
        // if (useWebcam != selectedWebcam){
        //   $('select#videoSource').val(selectedWebcam)
        //   notifi("is-danger","Error","The selected webcam is not compatible and cannot be used.")
        // }
        //console.log("Got stream with constraints:", constraints);
        console.log(`Using video device: ${videoTracks[0].label}`);
        $705e64c36f7be633$var$activeCamStream = stream;
        stream.onremovetrack = ()=>{
            console.log("Stream ended");
        };
        document.getElementById('webcamIn').srcObject = stream;
        document.getElementById('webcamIn').play();
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamConfirmBtn").attr("disabled", false);
    }).catch((error)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamConfirmBtn").attr("disabled", true);
        if (error.name === "NotAllowedError") //Should not happen
        alert("You need to grant this page permission to access your webcam.");
        else console.error(`getUserMedia error: ${error.name}`, error);
    }).finally(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamConfirmBtn").removeClass("is-loading");
    });
}
function $705e64c36f7be633$var$webcamPermitRequest(elm) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).addClass('is-loading');
    navigator.mediaDevices.getUserMedia({
        audio: false,
        video: true
    }).then((stream)=>{
        stream.getTracks().forEach(function(track) {
            track.stop();
        });
        return $705e64c36f7be633$var$getDevices().then(()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamSelectModal").addClass('is-active');
        });
    }).catch((error)=>{
        if (error.name === "NotAllowedError") (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamBlockedModal").addClass('is-active');
        else console.error(`getUserMedia error: ${error.name}`, error);
    }).finally(()=>{
        $705e64c36f7be633$var$closeModalAuto("#webcamPermitReqModal");
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).removeClass('is-loading');
    });
}
function $705e64c36f7be633$var$setUp(elm) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).addClass('is-loading');
    // BUG: Firefox no support navigator.permissions.query with 'camera'
    navigator.permissions.query({
        name: "camera"
    }).then((res)=>{
        if (res.state == "granted") $705e64c36f7be633$var$getDevices().then(()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamSelectModal").addClass('is-active');
        });
        else if (res.state === "prompt") (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamPermitReqModal").addClass('is-active');
        else (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamBlockedModal").addClass('is-active');
    }).catch((err)=>{
        if (err.message == "Permissions.query: 'camera' (value of 'name' member of PermissionDescriptor) is not a valid value for enumeration PermissionName.") (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamPermitReqModal").addClass('is-active');
    }).finally(()=>{
        $705e64c36f7be633$var$closeModalAuto('#selectGameModeModal');
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).removeClass('is-loading');
    });
}
function $705e64c36f7be633$var$gameInit(elm) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).addClass('is-loading');
    if (!$705e64c36f7be633$var$mediapipeInitialised) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#takingSomeTimeModal').addClass('is-active');
        return setTimeout(()=>{
            $705e64c36f7be633$var$gameInit(elm);
        }, 1000);
    }
    return $705e64c36f7be633$var$page2Init().then(()=>{
        $705e64c36f7be633$var$closeModal(elm.parentElement);
        $705e64c36f7be633$var$closeModal(document.getElementById('takingSomeTimeModalTitle'));
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#pg2").removeClass("hidden");
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#pg1").animate({
            right: "100%"
        }, 1000, ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#pg1").addClass("hidden").css("right", "0%");
            (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(elm).removeClass('is-loading');
        });
    });
}
function $705e64c36f7be633$var$page1Init() {
    // $("#pg1 #startBtn").on('click', (event) => { setUp(event.target) })
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamSelectModal button.delete").on('click', (event)=>{
        $705e64c36f7be633$var$closeModal(event.target, true, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamSelectModal .select").on('change', $705e64c36f7be633$var$webcamStart);
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamSelectModal #webcamConfirmBtn").on('click', (event)=>{
        $705e64c36f7be633$var$gameInit(event.target);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamPermitReqModal button.delete").on('click', (event)=>{
        $705e64c36f7be633$var$closeModal(event.target, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamPermitReqModal #webcamReqBtn").on('click', (event)=>{
        $705e64c36f7be633$var$webcamPermitRequest(event.target);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#webcamBlockedModal button.delete").on('click', (event)=>{
        $705e64c36f7be633$var$closeModal(event.target, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#settingsModal button.delete").on('click', (event)=>{
        $705e64c36f7be633$var$closeModal(event.target, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#settingsBtn").on('click', (event)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#settingsModal').addClass('is-active');
    });
    // $('#gameLangSelect').on('change', (event) => {
    //   currentLang = event.currentTarget.value;
    //   updateLang();
    // });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(".lang-btn, .lang-btn-2").on('click', (event)=>{
        $705e64c36f7be633$var$currentLang = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(event.currentTarget).attr('data-lang');
        $705e64c36f7be633$var$updateLang();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('.gameModeOption').on('click', (event)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('.gameModeOption').each((_, elm)=>elm.classList.remove('selected'));
        event.currentTarget.classList.add('selected');
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#gameModeBtn').attr('disabled', false);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#pg1 #startBtn").on('click', (event)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#selectGameModeModal').addClass('is-active');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#selectGameModeModal button.delete").on('click', (event)=>{
        $705e64c36f7be633$var$closeModal(event.target);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#selectGameModeModal #gameModeBtn").on('click', (event)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#selectGameModeModal #webcamGameOption').hasClass('selected')) $705e64c36f7be633$var$setUp(event.target);
        else {
            event.target.classList.add('is-loading');
            window.location.href = `./cursor.html?lang=${$705e64c36f7be633$var$currentLang}`;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))("#useTouchCursorModeLink").on("click", ()=>{
        window.location.href = `./cursor.html?lang=${$705e64c36f7be633$var$currentLang}`;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#FPSCheckbox').on("change", ()=>{
        $705e64c36f7be633$var$showFPS = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#FPSCheckbox').prop('checked');
        localStorage.setItem('showFPS', $705e64c36f7be633$var$showFPS);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#poseModelSelect').on("change", ()=>{
        [$705e64c36f7be633$var$newPoseModel, $705e64c36f7be633$var$newPoseModelMode] = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#poseModelSelect').val().split('-');
        if ($705e64c36f7be633$var$newPoseModel != $705e64c36f7be633$var$poseModel || $705e64c36f7be633$var$newPoseModelMode != $705e64c36f7be633$var$poseModelMode) (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#modelChangeSaveBtn').attr('disabled', false);
        else (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#modelChangeSaveBtn').attr('disabled', true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#modelChangeSaveBtn').on('click', ()=>{
        if ($705e64c36f7be633$var$newPoseModel != $705e64c36f7be633$var$poseModel || $705e64c36f7be633$var$newPoseModelMode != $705e64c36f7be633$var$poseModelMode) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#modelChangeSaveBtn').addClass('is-loading');
            window.localStorage.setItem('poseModel', $705e64c36f7be633$var$newPoseModel);
            window.localStorage.setItem('poseModelMode', $705e64c36f7be633$var$newPoseModelMode);
            window.location.reload();
        }
    });
}
//Page 2
let $705e64c36f7be633$var$video;
let $705e64c36f7be633$var$canvasElement;
/** @type {CanvasRenderingContext2D} */ let $705e64c36f7be633$var$canvasCtx;
let $705e64c36f7be633$var$videoScalling;
let $705e64c36f7be633$var$prevTimeMs;
let $705e64c36f7be633$var$prevRightCursor, $705e64c36f7be633$var$prevRightCursorTime;
let $705e64c36f7be633$var$prevLeftCursor, $705e64c36f7be633$var$prevLeftCursorTime;
let $705e64c36f7be633$var$cursorSize = 50;
let $705e64c36f7be633$var$fullscreenToggled = false;
// let drawingUtils;
// let cursor_hover_elm = [null, null];
async function $705e64c36f7be633$var$page2Init() {
    document.addEventListener("dblclick", ()=>{
        if (!$705e64c36f7be633$var$fullscreenToggled && document.documentElement.requestFullscreen) document.documentElement.requestFullscreen({
            navigationUI: "hide"
        }).finally(()=>{
            $705e64c36f7be633$var$fullscreenToggled = true;
        });
        else if (document.exitFullscreen) document.exitFullscreen().then(()=>{
            $705e64c36f7be633$var$fullscreenToggled = false;
        }).catch(()=>{
            if (document.documentElement.requestFullscreen) document.documentElement.requestFullscreen({
                navigationUI: "hide"
            }).finally(()=>{
                $705e64c36f7be633$var$fullscreenToggled = true;
            });
        });
    });
    document.documentElement.requestFullscreen({
        navigationUI: "hide"
    }).then(()=>{
        $705e64c36f7be633$var$fullscreenToggled = true;
    });
    document.getElementById("cursor-container").classList.add("is-active");
    $705e64c36f7be633$var$video = document.getElementById("baseCameraIn");
    $705e64c36f7be633$var$canvasElement = document.getElementById("canvas");
    $705e64c36f7be633$var$canvasCtx = $705e64c36f7be633$var$canvasElement.getContext("2d");
    // drawingUtils = new DrawingUtils(canvasCtx);
    //poseLandmarker.setOptions({canvas: canvasCtx});
    // console.dir(drawingUtils);
    document.getElementById('baseCameraIn').srcObject = $705e64c36f7be633$var$activeCamStream;
    document.getElementById('baseCameraIn').play();
    await $705e64c36f7be633$var$waitForVidInit();
    $705e64c36f7be633$var$Game.setActiveScreen("intro");
    $705e64c36f7be633$var$setVideoDimensions();
    window.onresize = $705e64c36f7be633$var$setVideoDimensions;
    $705e64c36f7be633$var$predictionActive = true;
    try {
        await $705e64c36f7be633$var$predictWebcam();
    } catch (e) {
        $705e64c36f7be633$var$notifi('is-danger', 'Error', `\u{91CD}\u{5927}\u{306A}\u{30A8}\u{30E9}\u{30FC}\u{304C}\u{767A}\u{751F}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30DA}\u{30FC}\u{30B8}\u{3092}\u{518D}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{FF01}<br>A fatal error has occured. Please refresh the page!<br>${e}`);
        throw e;
    }
    $705e64c36f7be633$var$activePageEventLoop = (landmarks)=>{
        landmarks;
    };
//setVideoDimensionsLoop();
}
async function $705e64c36f7be633$var$waitForVidInit() {
    while($705e64c36f7be633$var$video.videoWidth == 0)await new Promise((r)=>setTimeout(r, 100));
    while(!$705e64c36f7be633$var$mediapipeInitialised)await new Promise((r)=>setTimeout(r, 100));
}
function $705e64c36f7be633$var$setVideoDimensions() {
    let scalingWidth = document.documentElement.clientWidth / $705e64c36f7be633$var$video.videoWidth;
    let scalingHeight = document.documentElement.clientHeight / $705e64c36f7be633$var$video.videoHeight;
    let scaling = Math.max(scalingWidth, scalingHeight);
    $705e64c36f7be633$var$canvasElement.width = $705e64c36f7be633$var$video.videoWidth * scaling;
    $705e64c36f7be633$var$canvasElement.style.width = $705e64c36f7be633$var$video.videoWidth * scaling + "px";
    $705e64c36f7be633$var$canvasElement.height = $705e64c36f7be633$var$video.videoHeight * scaling;
    $705e64c36f7be633$var$canvasElement.style.height = $705e64c36f7be633$var$video.videoHeight * scaling + "px";
    $705e64c36f7be633$var$video.style.width = $705e64c36f7be633$var$video.videoWidth * scaling + "px";
    $705e64c36f7be633$var$video.style.height = $705e64c36f7be633$var$video.videoHeight * scaling + "px";
    $705e64c36f7be633$var$videoScalling = scaling;
    $705e64c36f7be633$var$Game.updateScreenRes(window.innerWidth, window.innerHeight, (canvas.width - window.innerWidth) / 2, (canvas.height - window.innerHeight) / 2);
}
function $705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, index, noFlip) {
    // Need to flip coordinates and resize
    if (noFlip) return [
        landmarks[index].x * $705e64c36f7be633$var$videoScalling,
        landmarks[index].y * $705e64c36f7be633$var$videoScalling
    ];
    else return [
        $705e64c36f7be633$var$canvasElement.width - landmarks[index].x * $705e64c36f7be633$var$videoScalling,
        landmarks[index].y * $705e64c36f7be633$var$videoScalling
    ];
}
function $705e64c36f7be633$var$getCorodinatesForBlazepose(landmarks, wrist_index, pinky_index, index_finger_index) {
    const averageX = new Array();
    const averageY = new Array();
    const hand_landmarks = [
        wrist_index,
        pinky_index,
        index_finger_index
    ];
    for(let i = 0; i < hand_landmarks.length; i++){
        const landmark = landmarks[hand_landmarks[i]];
        if (landmark.score >= 0.15) {
            averageX.push(landmark.x);
            averageY.push(landmark.y);
        }
    }
    if (averageX.length > 0 && averageY.length > 0) return [
        averageX.reduce((a, c)=>a + c, 0) / averageX.length * $705e64c36f7be633$var$videoScalling,
        averageY.reduce((a, c)=>a + c, 0) / averageY.length * $705e64c36f7be633$var$videoScalling
    ];
}
function $705e64c36f7be633$var$smoothCursor(newCursor, animationStep, isLeft) {
    if (!animationStep) return newCursor;
    if (isLeft) {
        // if (!prevLeftCursor || Math.sqrt((newCursor[1] - prevLeftCursor[1])**2 + (newCursor[0] - prevLeftCursor[0])**2) > 50){
        //   prevLeftCursor = newCursor;
        //   return newCursor;
        // }
        // else{
        //   return prevLeftCursor;
        // }
        const cursorDiffTiming = animationStep - ($705e64c36f7be633$var$prevLeftCursorTime || animationStep);
        $705e64c36f7be633$var$prevLeftCursorTime = animationStep;
        if (!$705e64c36f7be633$var$prevLeftCursor || cursorDiffTiming <= 0) return newCursor;
        const diffY = newCursor[1] - $705e64c36f7be633$var$prevLeftCursor[1];
        const diffX = newCursor[0] - $705e64c36f7be633$var$prevLeftCursor[0];
        const cursorSpeed = Math.sqrt(diffY ** 2 + diffX ** 2) / cursorDiffTiming;
        const cursorDiffAmount = Math.min(1, cursorSpeed / 500);
        return [
            newCursor[0] + diffX * cursorDiffAmount,
            newCursor[1] + diffY * cursorDiffAmount
        ];
    } else {
        // if (!prevRightCursor || Math.sqrt((newCursor[1] - prevRightCursor[1])**2 + (newCursor[0] - prevRightCursor[0])**2) > 50){
        //   prevRightCursor = newCursor;
        //   return newCursor;
        // }
        // else{
        //   return prevRightCursor;
        // }
        const cursorDiffTiming = animationStep - ($705e64c36f7be633$var$prevRightCursorTime || animationStep);
        $705e64c36f7be633$var$prevRightCursorTime = animationStep;
        if (!$705e64c36f7be633$var$prevRightCursor || cursorDiffTiming <= 0) return newCursor;
        const diffY = newCursor[1] - $705e64c36f7be633$var$prevRightCursor[1];
        const diffX = newCursor[0] - $705e64c36f7be633$var$prevRightCursor[0];
        const cursorSpeed = Math.sqrt(diffY ** 2 + diffX ** 2) / cursorDiffTiming;
        const cursorDiffAmount = Math.min(1, cursorSpeed / 500);
        return [
            newCursor[0] + diffX * cursorDiffAmount,
            newCursor[1] + diffY * cursorDiffAmount
        ];
    }
}
async function $705e64c36f7be633$var$predictWebcam(animationStep) {
    // WARNING: EXPECT EXTREMELY SLOW PERFORMANCE ON FIREFOX
    let cursors = /** @type {Cursor[]} */ new Array();
    const startTimeMs = performance.now();
    if ($705e64c36f7be633$var$Game.activeScreens[0]) $705e64c36f7be633$var$cursorSize = $705e64c36f7be633$var$Game.activeScreens[0].screenState.S(50);
    const results = $705e64c36f7be633$var$poseModel === 'blazepose' ? (await $705e64c36f7be633$var$poseLandmarker.estimatePoses($705e64c36f7be633$var$video, {
        maxPoses: 1,
        flipHorizontal: true
    }, startTimeMs))[0] : (await $705e64c36f7be633$var$poseLandmarker.estimatePoses($705e64c36f7be633$var$video, undefined, startTimeMs))[0];
    const landmarks = results ? results.keypoints : undefined;
    $705e64c36f7be633$var$canvasCtx.save();
    $705e64c36f7be633$var$canvasCtx.clearRect(0, 0, $705e64c36f7be633$var$canvasElement.width, $705e64c36f7be633$var$canvasElement.height);
    if (landmarks) {
        document.getElementById("cursor-msg").classList.remove('is-active');
        if ($705e64c36f7be633$var$poseModel === 'movenet') {
            if (landmarks[9]) {
                // 1.309 because golden ratio = 1.618, thus (1.618-1)/2 + 1 = 1.309
                // (distance from elbow to wrist)*1.309 = distance from elbow to center of palm 
                const left_cursor = $705e64c36f7be633$var$smoothCursor(landmarks[7] ? (0, $c3c280a1a9197b81$export$728e9f9f95bdf3be)(...$705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, 9), ...$705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, 7), 1.309) : $705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, 9), animationStep, true);
                // canvasCtx.beginPath();
                // canvasCtx.arc(...left_cursor, 50, 0,2*Math.PI);
                // canvasCtx.fillStyle = "red"
                // canvasCtx.fill();
                cursors.push(new (0, $eg79f.default)(...left_cursor, "left", 50));
            } else {
                [$705e64c36f7be633$var$prevLeftCursor, $705e64c36f7be633$var$prevLeftCursorTime] = [
                    undefined,
                    undefined
                ];
                cursors.push(new (0, $eg79f.default)(0, 0, "left", 0));
            }
            if (landmarks[10]) {
                const right_cursor = $705e64c36f7be633$var$smoothCursor(landmarks[8] ? (0, $c3c280a1a9197b81$export$728e9f9f95bdf3be)(...$705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, 10), ...$705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, 8), 1.309) : $705e64c36f7be633$var$getCorodinatesForMovenet(landmarks, 10), animationStep, false);
                // canvasCtx.beginPath();
                // canvasCtx.arc(...right_cursor, 50, 0,2*Math.PI);
                // canvasCtx.fillStyle = "blue"
                // canvasCtx.fill()
                cursors.push(new (0, $eg79f.default)(...right_cursor, "right", 50));
            } else {
                [$705e64c36f7be633$var$prevRightCursor, $705e64c36f7be633$var$prevRightCursorTime] = [
                    undefined,
                    undefined
                ];
                cursors.push(new (0, $eg79f.default)(0, 0, "right", 0));
            }
        } else if ($705e64c36f7be633$var$poseModel === 'blazepose') {
            const left_coordinates = $705e64c36f7be633$var$getCorodinatesForBlazepose(landmarks, 15, 17, 19);
            if (left_coordinates) cursors.push(new (0, $eg79f.default)(...left_coordinates, "left", 50));
            else cursors.push(new (0, $eg79f.default)(0, 0, "left", 0));
            const right_coordinates = $705e64c36f7be633$var$getCorodinatesForBlazepose(landmarks, 16, 18, 20);
            if (right_coordinates) cursors.push(new (0, $eg79f.default)(...right_coordinates, "right", 50));
            else cursors.push(new (0, $eg79f.default)(0, 0, "right", 0));
        }
    // document.getElementById("left-hand-cursor").style.setProperty("--cursor-x", landmarks[9].x);
    // document.getElementById("left-hand-cursor").style.setProperty("--cursor-y", landmarks[9].y);
    // document.getElementById("right-hand-cursor").style.setProperty("--cursor-x", landmarks[10].x);
    // document.getElementById("right-hand-cursor").style.setProperty("--cursor-y", landmarks[10].y);
    } else {
        cursors = [
            new (0, $eg79f.default)(0, 0, "left", 0),
            new (0, $eg79f.default)(0, 0, "right", 0)
        ];
        // document.getElementById("cursor-msg").innerHTML = "Please Stand in the view of the camera!"
        document.getElementById("cursor-msg").classList.add('is-active');
    // document.getElementById("left-hand-cursor").classList.add('is-gone');
    // document.getElementById("right-hand-cursor").classList.add('is-gone');
    }
    if (animationStep) $705e64c36f7be633$var$Game.renderScreen(animationStep, cursors, results && results.segmentation ? new (0, $eaQG2.default)(await results.segmentation.mask.toImageData(), $705e64c36f7be633$var$videoScalling) : undefined);
    $705e64c36f7be633$var$canvasCtx.font = '48px Yusei Magic';
    $705e64c36f7be633$var$canvasCtx.textAlign = 'left';
    $705e64c36f7be633$var$canvasCtx.textBaseline = 'bottom';
    $705e64c36f7be633$var$canvasCtx.globalAlpha = 1;
    if ($705e64c36f7be633$var$showFPS && $705e64c36f7be633$var$prevTimeMs) {
        const infer_speed = startTimeMs - $705e64c36f7be633$var$prevTimeMs;
        if (infer_speed >= 60) $705e64c36f7be633$var$canvasCtx.fillStyle = "red";
        else if (infer_speed >= 35) $705e64c36f7be633$var$canvasCtx.fillStyle = "yellow";
        else $705e64c36f7be633$var$canvasCtx.fillStyle = "limegreen";
        $705e64c36f7be633$var$canvasCtx.fillText(`FPS: ${Math.floor(1000 / infer_speed)}`, 0, window.innerHeight + ($705e64c36f7be633$var$canvasElement.height - window.innerHeight) / 2);
    }
    $705e64c36f7be633$var$canvasCtx.globalAlpha = 0.5;
    $705e64c36f7be633$var$canvasCtx.fillStyle = "#EB5E55";
    if (cursors[0].radius > 0) {
        $705e64c36f7be633$var$canvasCtx.beginPath();
        $705e64c36f7be633$var$canvasCtx.arc(cursors[0].x, cursors[0].y, $705e64c36f7be633$var$cursorSize, 0, 2 * Math.PI);
        $705e64c36f7be633$var$canvasCtx.fill();
    }
    if (cursors[1].radius > 0) {
        $705e64c36f7be633$var$canvasCtx.beginPath();
        $705e64c36f7be633$var$canvasCtx.arc(cursors[1].x, cursors[1].y, $705e64c36f7be633$var$cursorSize, 0, 2 * Math.PI);
        $705e64c36f7be633$var$canvasCtx.fill();
    }
    $705e64c36f7be633$var$canvasCtx.globalAlpha = 1;
    $705e64c36f7be633$var$canvasCtx.restore();
    if ($705e64c36f7be633$var$activePageEventLoop) $705e64c36f7be633$var$activePageEventLoop(landmarks);
    $705e64c36f7be633$var$prevTimeMs = startTimeMs;
    // Call this function again to keep predicting when the browser is ready.
    if ($705e64c36f7be633$var$predictionActive) window.requestAnimationFrame($705e64c36f7be633$var$predictWebcam);
}
(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#FPSCheckbox').prop('checked', $705e64c36f7be633$var$showFPS);
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#poseModelSelect').val(`${$705e64c36f7be633$var$poseModel}-${$705e64c36f7be633$var$poseModelMode}`);
    $705e64c36f7be633$var$updateLang();
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('html').addClass('load-finish');
    $705e64c36f7be633$var$initUtils();
    $705e64c36f7be633$var$page1Init();
});


//# sourceMappingURL=mirai.e6c78599.js.map
